
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("b7P4C", function(module, exports) {
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return (parcelRequire("k6PTJ")).AnchorPageRelayQuery; });
$parcel$export(module.exports, "getAnchorPageRelayQueryVars", function () { return (parcelRequire("k6PTJ")).getAnchorPageRelayQueryVars; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return (parcelRequire("k6PTJ")).shapeAnchorContentfulResponse; });
$parcel$export(module.exports, "getPricingPageRelayQueryVars", function () { return (parcelRequire("5UKqd")).getPricingPageRelayQueryVars; });
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return (parcelRequire("5UKqd")).PricingPageRelayQuery; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return (parcelRequire("5UKqd")).shapePricingContentfulResponse; });
parcelRequire("k6PTJ");
parcelRequire("5UKqd");

});
parcelRegister("k6PTJ", function(module, exports) {
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return $7906bd495d425fea$export$102ea97ffff273aa; });
$parcel$export(module.exports, "getAnchorPageRelayQueryVars", function () { return $7906bd495d425fea$export$9db61a55a3e7ac2d; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return $7906bd495d425fea$export$ee86e87edca54d71; });

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");

var $gVC4y = parcelRequire("gVC4y");
var $7906bd495d425fea$var$_anchorPageRelayQuery;

const $7906bd495d425fea$export$102ea97ffff273aa = $7906bd495d425fea$var$_anchorPageRelayQuery !== void 0 ? $7906bd495d425fea$var$_anchorPageRelayQuery : ($7906bd495d425fea$var$_anchorPageRelayQuery = (parcelRequire("gpiLA")), $7906bd495d425fea$var$_anchorPageRelayQuery.hash && $7906bd495d425fea$var$_anchorPageRelayQuery.hash !== "b5acdf742944624a0b58eb80313c25b1" && console.error("The definition of 'anchorPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $7906bd495d425fea$var$_anchorPageRelayQuery);
const $7906bd495d425fea$export$9db61a55a3e7ac2d = (cmsPageVariant, location)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        paidVariant: cmsPageVariant,
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US"
    };
};
function $7906bd495d425fea$export$ee86e87edca54d71(data) {
    var _data_anchorCollection;
    // eslint-disable-next-line complexity
    return (_data_anchorCollection = data.anchorCollection) === null || _data_anchorCollection === void 0 ? void 0 : _data_anchorCollection.items.map((anchor)=>{
        var _anchor_personaCollection, _anchor_productCollection, _anchor_headlineCollection, _anchor_primaryMessageCollection, // eslint-disable-next-line complexity
        _anchor_bannerCollection, // eslint-disable-next-line complexity
        _anchor_resultsCollection, _anchor_socialProofCollection, _anchor_callToActionCollection;
        return {
            node: {
                name: (anchor === null || anchor === void 0 ? void 0 : anchor.anchorTitleExternal) || "",
                pageVariant: (anchor === null || anchor === void 0 ? void 0 : anchor.paidVariant) || "paid-lp-jsw-features",
                persona: (anchor === null || anchor === void 0 ? void 0 : (_anchor_personaCollection = anchor.personaCollection) === null || _anchor_personaCollection === void 0 ? void 0 : _anchor_personaCollection.items.map((persona)=>({
                        name: (persona === null || persona === void 0 ? void 0 : persona.personaNameExternal) || "",
                        id: (persona === null || persona === void 0 ? void 0 : persona.personaNameExternal) || ""
                    }))) || [],
                product: (anchor === null || anchor === void 0 ? void 0 : (_anchor_productCollection = anchor.productCollection) === null || _anchor_productCollection === void 0 ? void 0 : _anchor_productCollection.items.map((product)=>{
                    var _product_productNameReference;
                    return {
                        productNameId: (product === null || product === void 0 ? void 0 : (_product_productNameReference = product.productNameReference) === null || _product_productNameReference === void 0 ? void 0 : _product_productNameReference.productNameId) || ""
                    };
                })) || [],
                headline: (anchor === null || anchor === void 0 ? void 0 : (_anchor_headlineCollection = anchor.headlineCollection) === null || _anchor_headlineCollection === void 0 ? void 0 : _anchor_headlineCollection.items.map((headline)=>{
                    var _headline_planBenefitsCollection;
                    return {
                        name: (headline === null || headline === void 0 ? void 0 : headline.headlineTitleExternal) || null,
                        subheading: (headline === null || headline === void 0 ? void 0 : headline.headlineSubheading) || null,
                        planBenefits: (headline === null || headline === void 0 ? void 0 : (_headline_planBenefitsCollection = headline.planBenefitsCollection) === null || _headline_planBenefitsCollection === void 0 ? void 0 : _headline_planBenefitsCollection.items.map((planBenefit)=>{
                            var _planBenefit_planBenefits, _planBenefit_supportingAsset, _planBenefit_supportingAsset1, _planBenefit_planFeaturesCollection;
                            return {
                                description: (0, $gVC4y.richTextToHTML)(planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_planBenefits = planBenefit.planBenefits) === null || _planBenefit_planBenefits === void 0 ? void 0 : _planBenefit_planBenefits.json),
                                supportingAsset: {
                                    url: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_supportingAsset = planBenefit.supportingAsset) === null || _planBenefit_supportingAsset === void 0 ? void 0 : _planBenefit_supportingAsset.url) || "",
                                    description: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_supportingAsset1 = planBenefit.supportingAsset) === null || _planBenefit_supportingAsset1 === void 0 ? void 0 : _planBenefit_supportingAsset1.description) || ""
                                },
                                planFeatures: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_planFeaturesCollection = planBenefit.planFeaturesCollection) === null || _planBenefit_planFeaturesCollection === void 0 ? void 0 : _planBenefit_planFeaturesCollection.items.map((planFeature)=>{
                                    var _planFeature_description;
                                    return {
                                        description: (0, $gVC4y.richTextToHTML)(planFeature === null || planFeature === void 0 ? void 0 : (_planFeature_description = planFeature.description) === null || _planFeature_description === void 0 ? void 0 : _planFeature_description.json)
                                    };
                                })) || null
                            };
                        })) || []
                    };
                })) || [],
                primaryMessage: (anchor === null || anchor === void 0 ? void 0 : (_anchor_primaryMessageCollection = anchor.primaryMessageCollection) === null || _anchor_primaryMessageCollection === void 0 ? void 0 : _anchor_primaryMessageCollection.items.map((primaryMessage)=>{
                    var _primaryMessage_supportingExampleCollection;
                    return {
                        name: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primaryMessageTitleExternal) || "",
                        supportingExample: (primaryMessage === null || primaryMessage === void 0 ? void 0 : (_primaryMessage_supportingExampleCollection = primaryMessage.supportingExampleCollection) === null || _primaryMessage_supportingExampleCollection === void 0 ? void 0 : _primaryMessage_supportingExampleCollection.items.map(// eslint-disable-next-line complexity
                        (supportingExample)=>{
                            var _supportingExample_proofpoint, _supportingExample_supportingAsset, _supportingExample_supportingAsset1, _supportingExample_advocateQuote_advocateHeadshot, _supportingExample_advocateQuote, _supportingExample_advocateQuote_advocateHeadshot1, _supportingExample_advocateQuote1, _supportingExample_advocateQuote2, _supportingExample_advocateQuote3, _supportingExample_advocateQuote4;
                            return {
                                proofpoint: (0, $gVC4y.richTextToHTML)(supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_proofpoint = supportingExample.proofpoint) === null || _supportingExample_proofpoint === void 0 ? void 0 : _supportingExample_proofpoint.json),
                                supportingAsset: {
                                    url: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_supportingAsset = supportingExample.supportingAsset) === null || _supportingExample_supportingAsset === void 0 ? void 0 : _supportingExample_supportingAsset.url) || "",
                                    description: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_supportingAsset1 = supportingExample.supportingAsset) === null || _supportingExample_supportingAsset1 === void 0 ? void 0 : _supportingExample_supportingAsset1.description) || ""
                                },
                                heading: (supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.supportingExampleHeading) || null,
                                name: (supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.supportingExampleTitleExternal) || "",
                                advocateQuote: !!(supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.advocateQuote) ? {
                                    advocateHeadshot: {
                                        url: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote === void 0 ? void 0 : (_supportingExample_advocateQuote_advocateHeadshot = _supportingExample_advocateQuote.advocateHeadshot) === null || _supportingExample_advocateQuote_advocateHeadshot === void 0 ? void 0 : _supportingExample_advocateQuote_advocateHeadshot.url) || null,
                                        description: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote1 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote1 === void 0 ? void 0 : (_supportingExample_advocateQuote_advocateHeadshot1 = _supportingExample_advocateQuote1.advocateHeadshot) === null || _supportingExample_advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _supportingExample_advocateQuote_advocateHeadshot1.description) || null
                                    },
                                    advocateName: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote2 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote2 === void 0 ? void 0 : _supportingExample_advocateQuote2.advocateName) || null,
                                    advocateQuote: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote3 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote3 === void 0 ? void 0 : _supportingExample_advocateQuote3.advocateQuote) || null,
                                    advocateJobTitle: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote4 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote4 === void 0 ? void 0 : _supportingExample_advocateQuote4.advocateJobTitle) || null
                                } : null
                            };
                        })) || []
                    };
                })) || [],
                banner: (anchor === null || anchor === void 0 ? void 0 : (_anchor_bannerCollection = anchor.bannerCollection) === null || _anchor_bannerCollection === void 0 ? void 0 : _anchor_bannerCollection.items.map((banner)=>{
                    var _banner_bannerImage, _banner_bannerImage1, _banner_bannerBackground, _banner_bannerText;
                    return {
                        bannerImage: {
                            description: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage = banner.bannerImage) === null || _banner_bannerImage === void 0 ? void 0 : _banner_bannerImage.description) || null,
                            url: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage1 = banner.bannerImage) === null || _banner_bannerImage1 === void 0 ? void 0 : _banner_bannerImage1.url) || null
                        },
                        backgroundImage: {
                            url: (banner === null || banner === void 0 ? void 0 : (_banner_bannerBackground = banner.bannerBackground) === null || _banner_bannerBackground === void 0 ? void 0 : _banner_bannerBackground.url) || null
                        },
                        text: (0, $gVC4y.richTextToHTML)(banner === null || banner === void 0 ? void 0 : (_banner_bannerText = banner.bannerText) === null || _banner_bannerText === void 0 ? void 0 : _banner_bannerText.json) || "",
                        url: (banner === null || banner === void 0 ? void 0 : banner.bannerUrl) || "",
                        urlText: (banner === null || banner === void 0 ? void 0 : banner.bannerUrlText) || ""
                    };
                })) || null,
                results: (anchor === null || anchor === void 0 ? void 0 : (_anchor_resultsCollection = anchor.resultsCollection) === null || _anchor_resultsCollection === void 0 ? void 0 : _anchor_resultsCollection.items.map((result)=>{
                    var _result_sys, _result_newResultSubheading, _result_resultAsset, _result_resultAsset1, _result_resultAsset2, _result_resultAsset3, _result_resultAsset4;
                    return {
                        id: (result === null || result === void 0 ? void 0 : (_result_sys = result.sys) === null || _result_sys === void 0 ? void 0 : _result_sys.id) || "",
                        name: (result === null || result === void 0 ? void 0 : result.resultTitleExternal) || "",
                        lozenge: (result === null || result === void 0 ? void 0 : result.lozenge) || null,
                        subheading: (0, $gVC4y.richTextToHTML)(result === null || result === void 0 ? void 0 : (_result_newResultSubheading = result.newResultSubheading) === null || _result_newResultSubheading === void 0 ? void 0 : _result_newResultSubheading.json),
                        asset: {
                            url: (result === null || result === void 0 ? void 0 : (_result_resultAsset = result.resultAsset) === null || _result_resultAsset === void 0 ? void 0 : _result_resultAsset.url) || "",
                            description: (result === null || result === void 0 ? void 0 : (_result_resultAsset1 = result.resultAsset) === null || _result_resultAsset1 === void 0 ? void 0 : _result_resultAsset1.description) || "",
                            fileName: (result === null || result === void 0 ? void 0 : (_result_resultAsset2 = result.resultAsset) === null || _result_resultAsset2 === void 0 ? void 0 : _result_resultAsset2.fileName) || "",
                            title: (result === null || result === void 0 ? void 0 : (_result_resultAsset3 = result.resultAsset) === null || _result_resultAsset3 === void 0 ? void 0 : _result_resultAsset3.title) || "",
                            details: null,
                            contentType: (result === null || result === void 0 ? void 0 : (_result_resultAsset4 = result.resultAsset) === null || _result_resultAsset4 === void 0 ? void 0 : _result_resultAsset4.contentType) || ""
                        }
                    };
                })) || [],
                socialProof: (anchor === null || anchor === void 0 ? void 0 : (_anchor_socialProofCollection = anchor.socialProofCollection) === null || _anchor_socialProofCollection === void 0 ? void 0 : _anchor_socialProofCollection.items.map((proof)=>{
                    var _proof_customersCollection;
                    return {
                        name: (proof === null || proof === void 0 ? void 0 : proof.socialProofTitleExternal) || "",
                        customers: (proof === null || proof === void 0 ? void 0 : (_proof_customersCollection = proof.customersCollection) === null || _proof_customersCollection === void 0 ? void 0 : _proof_customersCollection.items.map((customer)=>{
                            var _customer_logoCollection, _customer_altDarkLogoCollection;
                            return {
                                logo: (customer === null || customer === void 0 ? void 0 : (_customer_logoCollection = customer.logoCollection) === null || _customer_logoCollection === void 0 ? void 0 : _customer_logoCollection.items.map((logo)=>({
                                        url: (logo === null || logo === void 0 ? void 0 : logo.url) || "",
                                        description: (logo === null || logo === void 0 ? void 0 : logo.description) || ""
                                    }))) || [],
                                altDarkLogo: (customer === null || customer === void 0 ? void 0 : (_customer_altDarkLogoCollection = customer.altDarkLogoCollection) === null || _customer_altDarkLogoCollection === void 0 ? void 0 : _customer_altDarkLogoCollection.items.map((darkLogo)=>({
                                        url: (darkLogo === null || darkLogo === void 0 ? void 0 : darkLogo.url) || "",
                                        description: (darkLogo === null || darkLogo === void 0 ? void 0 : darkLogo.description) || ""
                                    }))) || []
                            };
                        })) || []
                    };
                })) || [],
                callToAction: (anchor === null || anchor === void 0 ? void 0 : (_anchor_callToActionCollection = anchor.callToActionCollection) === null || _anchor_callToActionCollection === void 0 ? void 0 : _anchor_callToActionCollection.items.map((cta)=>({
                        valueProposition: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
                        text: (cta === null || cta === void 0 ? void 0 : cta.ctaText) || "",
                        url: (cta === null || cta === void 0 ? void 0 : cta.ctaUrl) || ""
                    }))) || []
            }
        };
    });
}

});
parcelRegister("gpiLA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $95c4c2ff867336d4$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<3210dc1da59269531585a698c5b79a75>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95c4c2ff867336d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "paidVariant"
        }
    ], v1 = {
        "kind": "Literal",
        "name": "limit",
        "value": 1
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "kind": "Literal",
            "name": "skip",
            "value": 0
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "paidVariant",
                    "variableName": "paidVariant"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorTitleExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidVariant",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": [
            v1 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "where",
                "value": {
                    "personaNameExternal": "unknown"
                }
            }
        ],
        "concreteType": "AnchorPersonaCollection",
        "kind": "LinkedField",
        "name": "personaCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyPersona",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personaNameExternal",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "personaCollection(limit:1,where:{\"personaNameExternal\":\"unknown\"})"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorProductCollection",
        "kind": "LinkedField",
        "name": "productCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductListing",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductName",
                        "kind": "LinkedField",
                        "name": "productNameReference",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productNameId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "productCollection(limit:1)"
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineTitleExternal",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineSubheading",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v12 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v15 = [
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ], v16 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "supportingAsset",
        "plural": false,
        "selections": v15 /*: any*/ ,
        "storageKey": null
    }, v17 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 6
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v19 = [
        v10 /*: any*/ 
    ], v20 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorPrimaryMessageCollection",
        "kind": "LinkedField",
        "name": "primaryMessageCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PrimaryMessage",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryMessageTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": v18 /*: any*/ ,
                        "concreteType": "PrimaryMessageSupportingExampleCollection",
                        "kind": "LinkedField",
                        "name": "supportingExampleCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SupportingExample",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SupportingExampleProofpoint",
                                        "kind": "LinkedField",
                                        "name": "proofpoint",
                                        "plural": false,
                                        "selections": v19 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    v16 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleHeading",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleTitleExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AdvocateQuote",
                                        "kind": "LinkedField",
                                        "name": "advocateQuote",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Asset",
                                                "kind": "LinkedField",
                                                "name": "advocateHeadshot",
                                                "plural": false,
                                                "selections": v15 /*: any*/ ,
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateQuote",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateJobTitle",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "supportingExampleCollection(limit:10)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "primaryMessageCollection(limit:1)"
    }, v21 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 3
            }
        ],
        "concreteType": "AnchorBannerCollection",
        "kind": "LinkedField",
        "name": "bannerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Banner",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrl",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerImage",
                        "plural": false,
                        "selections": v15 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerBackground",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ 
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "BannerBannerText",
                        "kind": "LinkedField",
                        "name": "bannerText",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrlText",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "bannerCollection(limit:3)"
    }, v22 = {
        "alias": null,
        "args": v18 /*: any*/ ,
        "concreteType": "AnchorResultsCollection",
        "kind": "LinkedField",
        "name": "resultsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Result",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v11 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resultTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lozenge",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResultNewResultSubheading",
                        "kind": "LinkedField",
                        "name": "newResultSubheading",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "resultAsset",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileName",
                                "storageKey": null
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentType",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "resultsCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorCallToActionCollection",
        "kind": "LinkedField",
        "name": "callToActionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CallToAction",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueProposition",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "callToActionCollection(limit:1)"
    }, v24 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": v15 /*: any*/ ,
            "storageKey": null
        }
    ], v25 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorSocialProofCollection",
        "kind": "LinkedField",
        "name": "socialProofCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SocialProof",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "socialProofTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 16
                            }
                        ],
                        "concreteType": "SocialProofCustomersCollection",
                        "kind": "LinkedField",
                        "name": "customersCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternal",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "logoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "logoCollection(limit:1)"
                                    },
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "altDarkLogoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "altDarkLogoCollection(limit:1)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "customersCollection(limit:16)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "socialProofCollection(limit:1)"
    }, v26 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v12 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v26 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c0e29d89a263bf14d5f310fa9fca5b2c",
            "id": null,
            "metadata": {},
            "name": "anchorPageRelayQuery",
            "operationKind": "query",
            "text": "query anchorPageRelayQuery(\n  $locale: String!\n  $paidVariant: String!\n) {\n  anchorCollection(locale: $locale, where: {paidVariant: $paidVariant}, limit: 1, skip: 0) {\n    items {\n      anchorTitleExternal\n      paidVariant\n      personaCollection(limit: 1, where: {personaNameExternal: \"unknown\"}) {\n        items {\n          personaNameExternal\n        }\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      headlineCollection(limit: 1) {\n        items {\n          headlineTitleExternal\n          headlineSubheading\n          planBenefitsCollection(limit: 1) {\n            items {\n              planBenefits {\n                json\n                links {\n                  entries {\n                    inline {\n                      __typename\n                      sys {\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              supportingAsset {\n                url\n                description\n              }\n              planFeaturesCollection(limit: 6) {\n                items {\n                  description {\n                    json\n                    links {\n                      entries {\n                        inline {\n                          __typename\n                          sys {\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      primaryMessageCollection(limit: 1) {\n        items {\n          primaryMessageTitleExternal\n          supportingExampleCollection(limit: 10) {\n            items {\n              proofpoint {\n                json\n              }\n              supportingAsset {\n                url\n                description\n              }\n              supportingExampleHeading\n              supportingExampleTitleExternal\n              advocateQuote {\n                advocateHeadshot {\n                  url\n                  description\n                }\n                advocateName\n                advocateQuote\n                advocateJobTitle\n              }\n            }\n          }\n        }\n      }\n      bannerCollection(limit: 3) {\n        items {\n          bannerUrl\n          bannerImage {\n            url\n            description\n          }\n          bannerBackground {\n            url\n          }\n          bannerText {\n            json\n          }\n          bannerUrlText\n        }\n      }\n      resultsCollection(limit: 10) {\n        items {\n          sys {\n            id\n          }\n          resultTitleExternal\n          lozenge\n          newResultSubheading {\n            json\n          }\n          resultAsset {\n            title\n            fileName\n            url\n            description\n            contentType\n          }\n        }\n      }\n      callToActionCollection(limit: 1) {\n        items {\n          valueProposition\n          ctaText\n          ctaUrl\n        }\n      }\n      socialProofCollection(limit: 1) {\n        items {\n          socialProofTitleExternal\n          customersCollection(limit: 16) {\n            items {\n              logoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n              altDarkLogoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$95c4c2ff867336d4$var$node.hash = "b5acdf742944624a0b58eb80313c25b1";
var $95c4c2ff867336d4$export$2e2bcd8739ae039 = $95c4c2ff867336d4$var$node;

});


parcelRegister("5UKqd", function(module, exports) {
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return $b9b8849a1260f275$export$1a50c94ee129d160; });
$parcel$export(module.exports, "getPricingPageRelayQueryVars", function () { return $b9b8849a1260f275$export$73d4337b94775e7c; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return $b9b8849a1260f275$export$7d2aff0545f03f9e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");

var $gVC4y = parcelRequire("gVC4y");

var $anFUN = parcelRequire("anFUN");
var $b9b8849a1260f275$var$_pricingPageRelayQuery;

const $b9b8849a1260f275$export$1a50c94ee129d160 = $b9b8849a1260f275$var$_pricingPageRelayQuery !== void 0 ? $b9b8849a1260f275$var$_pricingPageRelayQuery : ($b9b8849a1260f275$var$_pricingPageRelayQuery = (parcelRequire("i9aaD")), $b9b8849a1260f275$var$_pricingPageRelayQuery.hash && $b9b8849a1260f275$var$_pricingPageRelayQuery.hash !== "f0b024f23898a201517a855bfe7f282e" && console.error("The definition of 'pricingPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b9b8849a1260f275$var$_pricingPageRelayQuery);
const $b9b8849a1260f275$export$73d4337b94775e7c = (productNameId, location, pricingTitleInternal = null)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        productNameId: productNameId,
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US",
        pricingTitleInternal: pricingTitleInternal,
        skipSeoFields: (0, $anFUN.getIsGwp10385)()
    };
};
const $b9b8849a1260f275$export$7d2aff0545f03f9e = (data)=>{
    // Extract pricingCollection from data if it's nested
    const pricingCollection = data.pricingCollection;
    if (!pricingCollection || !pricingCollection.items) return {
        pricings: {
            edges: []
        }
    };
    return {
        pricings: {
            // @ts-ignore
            edges: pricingCollection.items.filter(Boolean).map((item)=>{
                var _item_headline, _item_comparePlansCollection_items, _item_comparePlansCollection, _item_compareFeaturesCollection_items, _item_compareFeaturesCollection, _item_additionalDetailsCollection_items, _item_additionalDetailsCollection, _item_relatedProductCollection_items, _item_relatedProductCollection, _item_callToActionContainerCollection_items, _item_callToActionContainerCollection, _item_datacenterPlansCollection_items, _item_datacenterPlansCollection;
                var _item_pricingTitleInternal, _item_pricingTitleExternal, _item_pageDescription, _item_compareFeaturesTitle, _item_getMoreDetailsTitle;
                return {
                    __typename: "ContentPlatformPricingResultEdge",
                    node: (0, $dPABA._)((0, $6ogO3._)({
                        __typename: "ContentPlatformPricing",
                        pricingTitleInternal: (_item_pricingTitleInternal = item === null || item === void 0 ? void 0 : item.pricingTitleInternal) !== null && _item_pricingTitleInternal !== void 0 ? _item_pricingTitleInternal : ""
                    }, (0, $anFUN.getIsGwp10385)() ? {} : {
                        pricingTitleExternal: (_item_pricingTitleExternal = item === null || item === void 0 ? void 0 : item.pricingTitleExternal) !== null && _item_pricingTitleExternal !== void 0 ? _item_pricingTitleExternal : "",
                        pageDescription: (_item_pageDescription = item === null || item === void 0 ? void 0 : item.pageDescription) !== null && _item_pageDescription !== void 0 ? _item_pageDescription : ""
                    }), {
                        headline: (item === null || item === void 0 ? void 0 : (_item_headline = item.headline) === null || _item_headline === void 0 ? void 0 : _item_headline.json) ? (0, $gVC4y.richTextToHTML)(item.headline.json) : null,
                        comparePlans: (item === null || item === void 0 ? void 0 : (_item_comparePlansCollection = item.comparePlansCollection) === null || _item_comparePlansCollection === void 0 ? void 0 : (_item_comparePlansCollection_items = _item_comparePlansCollection.items) === null || _item_comparePlansCollection_items === void 0 ? void 0 : _item_comparePlansCollection_items.filter(Boolean).map((plan)=>{
                            var _plan_microCtaCollection_items, _plan_microCtaCollection, _plan_highlightedFeaturesContainerCollection_items, _plan_highlightedFeaturesContainerCollection;
                            var _plan_planTitleExternal, _plan_planOneLiner, _plan_highlightedFeaturesTitle;
                            return {
                                __typename: "ContentPlatformPlan",
                                planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null,
                                planOneLiner: (_plan_planOneLiner = plan === null || plan === void 0 ? void 0 : plan.planOneLiner) !== null && _plan_planOneLiner !== void 0 ? _plan_planOneLiner : null,
                                highlightedFeaturesTitle: (_plan_highlightedFeaturesTitle = plan === null || plan === void 0 ? void 0 : plan.highlightedFeaturesTitle) !== null && _plan_highlightedFeaturesTitle !== void 0 ? _plan_highlightedFeaturesTitle : null,
                                microCta: (plan === null || plan === void 0 ? void 0 : (_plan_microCtaCollection = plan.microCtaCollection) === null || _plan_microCtaCollection === void 0 ? void 0 : (_plan_microCtaCollection_items = _plan_microCtaCollection.items) === null || _plan_microCtaCollection_items === void 0 ? void 0 : _plan_microCtaCollection_items.filter(Boolean).map((cta)=>{
                                    var _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl;
                                    return {
                                        __typename: "ContentPlatformCallToActionMicrocopy",
                                        ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta === null || cta === void 0 ? void 0 : cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                        ctaButtonText: (_cta_ctaButtonText = cta === null || cta === void 0 ? void 0 : cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                        ctaUrl: (_cta_ctaUrl = cta === null || cta === void 0 ? void 0 : cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null
                                    };
                                })) || [],
                                highlightedFeaturesContainer: (plan === null || plan === void 0 ? void 0 : (_plan_highlightedFeaturesContainerCollection = plan.highlightedFeaturesContainerCollection) === null || _plan_highlightedFeaturesContainerCollection === void 0 ? void 0 : (_plan_highlightedFeaturesContainerCollection_items = _plan_highlightedFeaturesContainerCollection.items) === null || _plan_highlightedFeaturesContainerCollection_items === void 0 ? void 0 : _plan_highlightedFeaturesContainerCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_highlightedFeatureDetails;
                                    var _feature_highlightedFeatureTitleExternal, _feature_callOut;
                                    return {
                                        __typename: "ContentPlatformHighlightedFeature",
                                        highlightedFeatureDetails: (feature === null || feature === void 0 ? void 0 : (_feature_highlightedFeatureDetails = feature.highlightedFeatureDetails) === null || _feature_highlightedFeatureDetails === void 0 ? void 0 : _feature_highlightedFeatureDetails.json) ? (0, $gVC4y.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: (_feature_highlightedFeatureTitleExternal = feature === null || feature === void 0 ? void 0 : feature.highlightedFeatureTitleExternal) !== null && _feature_highlightedFeatureTitleExternal !== void 0 ? _feature_highlightedFeatureTitleExternal : null,
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null
                                    };
                                })) || []
                            };
                        })) || [],
                        compareFeaturesTitle: (_item_compareFeaturesTitle = item === null || item === void 0 ? void 0 : item.compareFeaturesTitle) !== null && _item_compareFeaturesTitle !== void 0 ? _item_compareFeaturesTitle : null,
                        compareFeatures: (item === null || item === void 0 ? void 0 : (_item_compareFeaturesCollection = item.compareFeaturesCollection) === null || _item_compareFeaturesCollection === void 0 ? void 0 : (_item_compareFeaturesCollection_items = _item_compareFeaturesCollection.items) === null || _item_compareFeaturesCollection_items === void 0 ? void 0 : _item_compareFeaturesCollection_items.filter(Boolean).map((featureGroup)=>{
                            var _featureGroup_featuresCollection_items, _featureGroup_featuresCollection;
                            var _featureGroup_featureGroupTitleExternal;
                            return {
                                __typename: "ContentPlatformFeatureGroup",
                                featureGroupTitleExternal: (_featureGroup_featureGroupTitleExternal = featureGroup === null || featureGroup === void 0 ? void 0 : featureGroup.featureGroupTitleExternal) !== null && _featureGroup_featureGroupTitleExternal !== void 0 ? _featureGroup_featureGroupTitleExternal : null,
                                features: (featureGroup === null || featureGroup === void 0 ? void 0 : (_featureGroup_featuresCollection = featureGroup.featuresCollection) === null || _featureGroup_featuresCollection === void 0 ? void 0 : (_featureGroup_featuresCollection_items = _featureGroup_featuresCollection.items) === null || _featureGroup_featuresCollection_items === void 0 ? void 0 : _featureGroup_featuresCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_description, _feature_relevantPlanCollection_items, _feature_relevantPlanCollection, _feature_featureAdditionalInformationCollection_items, _feature_featureAdditionalInformationCollection;
                                    var _feature_callOut, _feature_featureNameExternal, _feature_relevantUrl;
                                    return {
                                        __typename: "ContentPlatformFeature",
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null,
                                        featureNameExternal: (_feature_featureNameExternal = feature === null || feature === void 0 ? void 0 : feature.featureNameExternal) !== null && _feature_featureNameExternal !== void 0 ? _feature_featureNameExternal : null,
                                        description: (feature === null || feature === void 0 ? void 0 : (_feature_description = feature.description) === null || _feature_description === void 0 ? void 0 : _feature_description.json) ? (0, $gVC4y.richTextToHTML)(feature.description.json) : null,
                                        relevantPlan: (feature === null || feature === void 0 ? void 0 : (_feature_relevantPlanCollection = feature.relevantPlanCollection) === null || _feature_relevantPlanCollection === void 0 ? void 0 : (_feature_relevantPlanCollection_items = _feature_relevantPlanCollection.items) === null || _feature_relevantPlanCollection_items === void 0 ? void 0 : _feature_relevantPlanCollection_items.filter(Boolean).map((plan)=>{
                                            var _plan_planTitleExternal;
                                            return {
                                                __typename: "ContentPlatformPlan",
                                                planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null
                                            };
                                        })) || [],
                                        relevantUrl: (_feature_relevantUrl = feature === null || feature === void 0 ? void 0 : feature.relevantUrl) !== null && _feature_relevantUrl !== void 0 ? _feature_relevantUrl : null,
                                        featureAdditionalInformation: (feature === null || feature === void 0 ? void 0 : (_feature_featureAdditionalInformationCollection = feature.featureAdditionalInformationCollection) === null || _feature_featureAdditionalInformationCollection === void 0 ? void 0 : (_feature_featureAdditionalInformationCollection_items = _feature_featureAdditionalInformationCollection.items) === null || _feature_featureAdditionalInformationCollection_items === void 0 ? void 0 : _feature_featureAdditionalInformationCollection_items.filter(Boolean).map((info)=>{
                                            var _info_relevantPlanCollection_items, _info_relevantPlanCollection;
                                            var _info_featureAdditionalInformation;
                                            return {
                                                __typename: "ContentPlatformFeatureAdditionalInformation",
                                                featureAdditionalInformation: (_info_featureAdditionalInformation = info === null || info === void 0 ? void 0 : info.featureAdditionalInformation) !== null && _info_featureAdditionalInformation !== void 0 ? _info_featureAdditionalInformation : null,
                                                relevantPlan: (info === null || info === void 0 ? void 0 : (_info_relevantPlanCollection = info.relevantPlanCollection) === null || _info_relevantPlanCollection === void 0 ? void 0 : (_info_relevantPlanCollection_items = _info_relevantPlanCollection.items) === null || _info_relevantPlanCollection_items === void 0 ? void 0 : _info_relevantPlanCollection_items.filter(Boolean).map((plan)=>{
                                                    var _plan_planTitleExternal;
                                                    return {
                                                        __typename: "ContentPlatformPlan",
                                                        planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null
                                                    };
                                                })) || []
                                            };
                                        })) || []
                                    };
                                })) || []
                            };
                        })) || [],
                        getMoreDetailsTitle: (_item_getMoreDetailsTitle = item === null || item === void 0 ? void 0 : item.getMoreDetailsTitle) !== null && _item_getMoreDetailsTitle !== void 0 ? _item_getMoreDetailsTitle : null,
                        additionalDetails: (item === null || item === void 0 ? void 0 : (_item_additionalDetailsCollection = item.additionalDetailsCollection) === null || _item_additionalDetailsCollection === void 0 ? void 0 : (_item_additionalDetailsCollection_items = _item_additionalDetailsCollection.items) === null || _item_additionalDetailsCollection_items === void 0 ? void 0 : _item_additionalDetailsCollection_items.filter(Boolean).map((detail)=>{
                            var _detail_planAdditionalDetails;
                            var _detail_planAdditionalDetailsTitleExternal;
                            return {
                                __typename: "ContentPlatformPlanDetails",
                                planAdditionalDetailsTitleExternal: (_detail_planAdditionalDetailsTitleExternal = detail === null || detail === void 0 ? void 0 : detail.planAdditionalDetailsTitleExternal) !== null && _detail_planAdditionalDetailsTitleExternal !== void 0 ? _detail_planAdditionalDetailsTitleExternal : null,
                                planAdditionalDetails: (detail === null || detail === void 0 ? void 0 : (_detail_planAdditionalDetails = detail.planAdditionalDetails) === null || _detail_planAdditionalDetails === void 0 ? void 0 : _detail_planAdditionalDetails.json) ? (0, $gVC4y.richTextToHTML)(detail.planAdditionalDetails.json) : null
                            };
                        })) || [],
                        relatedProduct: (item === null || item === void 0 ? void 0 : (_item_relatedProductCollection = item.relatedProductCollection) === null || _item_relatedProductCollection === void 0 ? void 0 : (_item_relatedProductCollection_items = _item_relatedProductCollection.items) === null || _item_relatedProductCollection_items === void 0 ? void 0 : _item_relatedProductCollection_items.filter(Boolean).map((product)=>{
                            var _product_productName, _product_productNameId;
                            return {
                                __typename: "ContentPlatformPricingProductName",
                                productName: (_product_productName = product === null || product === void 0 ? void 0 : product.productName) !== null && _product_productName !== void 0 ? _product_productName : "",
                                productNameId: (_product_productNameId = product === null || product === void 0 ? void 0 : product.productNameId) !== null && _product_productNameId !== void 0 ? _product_productNameId : ""
                            };
                        })) || [],
                        callToActionContainer: (item === null || item === void 0 ? void 0 : (_item_callToActionContainerCollection = item.callToActionContainerCollection) === null || _item_callToActionContainerCollection === void 0 ? void 0 : (_item_callToActionContainerCollection_items = _item_callToActionContainerCollection.items) === null || _item_callToActionContainerCollection_items === void 0 ? void 0 : _item_callToActionContainerCollection_items.filter(Boolean).map((cta)=>{
                            var _cta_ctaTitleExternal, _cta_valueProposition, _cta_ctaText, _cta_ctaUrl, _cta_ctaAsset_title, _cta_ctaAsset_description, _cta_ctaAsset_url, _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl1;
                            if (cta && ("ctaTitleExternal" in cta || "valueProposition" in cta || "ctaText" in cta || "ctaAsset" in cta)) // ContentPlatformCallToAction
                            return {
                                __typename: "ContentPlatformCallToAction",
                                title: (_cta_ctaTitleExternal = cta.ctaTitleExternal) !== null && _cta_ctaTitleExternal !== void 0 ? _cta_ctaTitleExternal : null,
                                valueProposition: (_cta_valueProposition = cta.valueProposition) !== null && _cta_valueProposition !== void 0 ? _cta_valueProposition : null,
                                text: (_cta_ctaText = cta.ctaText) !== null && _cta_ctaText !== void 0 ? _cta_ctaText : null,
                                url: (_cta_ctaUrl = cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null,
                                asset: cta.ctaAsset ? {
                                    __typename: "ContentPlatformTemplateImageAsset",
                                    title: (_cta_ctaAsset_title = cta.ctaAsset.title) !== null && _cta_ctaAsset_title !== void 0 ? _cta_ctaAsset_title : null,
                                    description: (_cta_ctaAsset_description = cta.ctaAsset.description) !== null && _cta_ctaAsset_description !== void 0 ? _cta_ctaAsset_description : null,
                                    url: (_cta_ctaAsset_url = cta.ctaAsset.url) !== null && _cta_ctaAsset_url !== void 0 ? _cta_ctaAsset_url : ""
                                } : null
                            };
                            else if (cta && ("ctaMicrocopyTitleExternal" in cta || "ctaButtonText" in cta)) // ContentPlatformCallToActionMicrocopy
                            return {
                                __typename: "ContentPlatformCallToActionMicrocopy",
                                ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                ctaButtonText: (_cta_ctaButtonText = cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                ctaUrl: (_cta_ctaUrl1 = cta.ctaUrl) !== null && _cta_ctaUrl1 !== void 0 ? _cta_ctaUrl1 : null
                            };
                            // Filter null values at the map level
                            return null;
                        }).filter(Boolean)) || [],
                        datacenterPlans: (item === null || item === void 0 ? void 0 : (_item_datacenterPlansCollection = item.datacenterPlansCollection) === null || _item_datacenterPlansCollection === void 0 ? void 0 : (_item_datacenterPlansCollection_items = _item_datacenterPlansCollection.items) === null || _item_datacenterPlansCollection_items === void 0 ? void 0 : _item_datacenterPlansCollection_items.filter(Boolean).map((datacenterPlan)=>{
                            var _datacenterPlan_microCtaCollection_items, _datacenterPlan_microCtaCollection, _datacenterPlan_highlightedFeaturesContainerCollection_items, _datacenterPlan_highlightedFeaturesContainerCollection;
                            var _datacenterPlan_planTitleExternal, _datacenterPlan_planOneLiner, _datacenterPlan_highlightedFeaturesTitle;
                            return {
                                __typename: "ContentPlatformPlan",
                                planTitleExternal: (_datacenterPlan_planTitleExternal = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.planTitleExternal) !== null && _datacenterPlan_planTitleExternal !== void 0 ? _datacenterPlan_planTitleExternal : null,
                                planOneLiner: (_datacenterPlan_planOneLiner = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.planOneLiner) !== null && _datacenterPlan_planOneLiner !== void 0 ? _datacenterPlan_planOneLiner : null,
                                microCta: (datacenterPlan === null || datacenterPlan === void 0 ? void 0 : (_datacenterPlan_microCtaCollection = datacenterPlan.microCtaCollection) === null || _datacenterPlan_microCtaCollection === void 0 ? void 0 : (_datacenterPlan_microCtaCollection_items = _datacenterPlan_microCtaCollection.items) === null || _datacenterPlan_microCtaCollection_items === void 0 ? void 0 : _datacenterPlan_microCtaCollection_items.filter(Boolean).map((cta)=>{
                                    var _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl;
                                    return {
                                        __typename: "ContentPlatformCallToActionMicrocopy",
                                        ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta === null || cta === void 0 ? void 0 : cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                        ctaButtonText: (_cta_ctaButtonText = cta === null || cta === void 0 ? void 0 : cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                        ctaUrl: (_cta_ctaUrl = cta === null || cta === void 0 ? void 0 : cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null
                                    };
                                })) || [],
                                highlightedFeaturesTitle: (_datacenterPlan_highlightedFeaturesTitle = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.highlightedFeaturesTitle) !== null && _datacenterPlan_highlightedFeaturesTitle !== void 0 ? _datacenterPlan_highlightedFeaturesTitle : null,
                                highlightedFeaturesContainer: (datacenterPlan === null || datacenterPlan === void 0 ? void 0 : (_datacenterPlan_highlightedFeaturesContainerCollection = datacenterPlan.highlightedFeaturesContainerCollection) === null || _datacenterPlan_highlightedFeaturesContainerCollection === void 0 ? void 0 : (_datacenterPlan_highlightedFeaturesContainerCollection_items = _datacenterPlan_highlightedFeaturesContainerCollection.items) === null || _datacenterPlan_highlightedFeaturesContainerCollection_items === void 0 ? void 0 : _datacenterPlan_highlightedFeaturesContainerCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_highlightedFeatureDetails;
                                    var _feature_highlightedFeatureTitleExternal, _feature_callOut;
                                    return {
                                        __typename: "ContentPlatformHighlightedFeature",
                                        highlightedFeatureDetails: (feature === null || feature === void 0 ? void 0 : (_feature_highlightedFeatureDetails = feature.highlightedFeatureDetails) === null || _feature_highlightedFeatureDetails === void 0 ? void 0 : _feature_highlightedFeatureDetails.json) ? (0, $gVC4y.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: (_feature_highlightedFeatureTitleExternal = feature === null || feature === void 0 ? void 0 : feature.highlightedFeatureTitleExternal) !== null && _feature_highlightedFeatureTitleExternal !== void 0 ? _feature_highlightedFeatureTitleExternal : null,
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null
                                    };
                                })) || []
                            };
                        })) || []
                    })
                };
            })
        }
    };
};

});
parcelRegister("anFUN", function(module, exports) {
$parcel$export(module.exports, "getIsGwp10385", function () { return $99e85e1c3199b393$export$132b230cffb28f63; });

var $32ng3 = parcelRequire("32ng3");
const $99e85e1c3199b393$export$132b230cffb28f63 = ()=>(0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp10385PricingSeoDetailsCleanup);

});

parcelRegister("i9aaD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $7365710ab12be4cd$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<8a6750eba89f00791d37df4819357191>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7365710ab12be4cd$var$node = function() {
    var v0 = {
        "defaultValue": 1,
        "kind": "LocalArgument",
        "name": "limit"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pricingTitleInternal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productNameId"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "skipSeoFields"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "pricingTitleInternal_contains",
                    "variableName": "pricingTitleInternal"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "productNameId_contains",
                            "variableName": "productNameId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "relatedProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingTitleInternal",
        "storageKey": null
    }, v7 = {
        "condition": "skipSeoFields",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricingTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageDescription",
                "storageKey": null
            }
        ]
    }, v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "concreteType": "PricingHeadline",
        "kind": "LinkedField",
        "name": "headline",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": null
    }, v10 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planTitleExternal",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planOneLiner",
        "storageKey": null
    }, v13 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 15
        }
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ctaUrl",
        "storageKey": null
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaMicrocopyTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaButtonText",
                "storageKey": null
            },
            v14 /*: any*/ 
        ],
        "type": "CallToActionMicrocopy",
        "abstractKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "highlightedFeaturesTitle",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callOut",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PlanHighlightedFeaturesContainerCollection",
        "kind": "LinkedField",
        "name": "highlightedFeaturesContainerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "HighlightedFeature",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "HighlightedFeatureHighlightedFeatureDetails",
                        "kind": "LinkedField",
                        "name": "highlightedFeatureDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "highlightedFeatureTitleExternal",
                        "storageKey": null
                    },
                    v17 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "highlightedFeaturesContainerCollection(limit:15)"
    }, v19 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "compareFeaturesTitle",
        "storageKey": null
    }, v21 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v22 = {
        "alias": null,
        "args": v10 /*: any*/ ,
        "concreteType": "PricingCompareFeaturesCollection",
        "kind": "LinkedField",
        "name": "compareFeaturesCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FeatureGroup",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featureGroupTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 20
                            }
                        ],
                        "concreteType": "FeatureGroupFeaturesCollection",
                        "kind": "LinkedField",
                        "name": "featuresCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Feature",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "featureNameExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureDescription",
                                        "kind": "LinkedField",
                                        "name": "description",
                                        "plural": false,
                                        "selections": v8 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureRelevantPlanCollection",
                                        "kind": "LinkedField",
                                        "name": "relevantPlanCollection",
                                        "plural": false,
                                        "selections": v21 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "relevantUrl",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": v13 /*: any*/ ,
                                        "concreteType": "FeatureFeatureAdditionalInformationCollection",
                                        "kind": "LinkedField",
                                        "name": "featureAdditionalInformationCollection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FeatureAdditionalInformation",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "featureAdditionalInformation",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": v13 /*: any*/ ,
                                                        "concreteType": "FeatureAdditionalInformationRelevantPlanCollection",
                                                        "kind": "LinkedField",
                                                        "name": "relevantPlanCollection",
                                                        "plural": false,
                                                        "selections": v21 /*: any*/ ,
                                                        "storageKey": "relevantPlanCollection(limit:15)"
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": "featureAdditionalInformationCollection(limit:15)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "featuresCollection(limit:20)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "compareFeaturesCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "getMoreDetailsTitle",
        "storageKey": null
    }, v24 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PricingAdditionalDetailsCollection",
        "kind": "LinkedField",
        "name": "additionalDetailsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PlanDetails",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "planAdditionalDetailsTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PlanDetailsPlanAdditionalDetails",
                        "kind": "LinkedField",
                        "name": "planAdditionalDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "additionalDetailsCollection(limit:15)"
    }, v25 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 1
            }
        ],
        "concreteType": "PricingRelatedProductCollection",
        "kind": "LinkedField",
        "name": "relatedProductCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productNameId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "relatedProductCollection(limit:1)"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "valueProposition",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaText",
                "storageKey": null
            },
            v14 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "ctaAsset",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "CallToAction",
        "abstractKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v28 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v27 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v5 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v5 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "93590f1d3eb68265fc67bf3fd6183c1f",
            "id": null,
            "metadata": {},
            "name": "pricingPageRelayQuery",
            "operationKind": "query",
            "text": "query pricingPageRelayQuery(\n  $limit: Int = 1\n  $productNameId: String!\n  $locale: String!\n  $pricingTitleInternal: String = null\n  $skipSeoFields: Boolean = false\n) {\n  pricingCollection(limit: $limit, where: {relatedProduct: {productNameId_contains: $productNameId}, pricingTitleInternal_contains: $pricingTitleInternal}, locale: $locale) {\n    items {\n      pricingTitleInternal\n      pricingTitleExternal @skip(if: $skipSeoFields)\n      pageDescription @skip(if: $skipSeoFields)\n      headline {\n        json\n      }\n      comparePlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n      compareFeaturesTitle\n      compareFeaturesCollection(limit: 10) {\n        items {\n          featureGroupTitleExternal\n          featuresCollection(limit: 20) {\n            items {\n              callOut\n              featureNameExternal\n              description {\n                json\n              }\n              relevantPlanCollection {\n                items {\n                  planTitleExternal\n                }\n              }\n              relevantUrl\n              featureAdditionalInformationCollection(limit: 15) {\n                items {\n                  featureAdditionalInformation\n                  relevantPlanCollection(limit: 15) {\n                    items {\n                      planTitleExternal\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      getMoreDetailsTitle\n      additionalDetailsCollection(limit: 15) {\n        items {\n          planAdditionalDetailsTitleExternal\n          planAdditionalDetails {\n            json\n          }\n        }\n      }\n      relatedProductCollection(limit: 1) {\n        items {\n          productName\n          productNameId\n        }\n      }\n      callToActionContainerCollection(limit: 10) {\n        items {\n          __typename\n          ... on CallToAction {\n            ctaTitleExternal\n            valueProposition\n            ctaText\n            ctaUrl\n            ctaAsset {\n              title\n              description\n              url\n            }\n          }\n          ... on CallToActionMicrocopy {\n            ctaMicrocopyTitleExternal\n            ctaButtonText\n            ctaUrl\n          }\n        }\n      }\n      datacenterPlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$7365710ab12be4cd$var$node.hash = "f0b024f23898a201517a855bfe7f282e";
var $7365710ab12be4cd$export$2e2bcd8739ae039 = $7365710ab12be4cd$var$node;

});



parcelRegister("iwpqF", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPage", function () { return $c6b186384bdc45c6$export$20dde44a04c91eb6; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $7WM7y = parcelRequire("7WM7y");
const $c6b186384bdc45c6$export$20dde44a04c91eb6 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {});

});
parcelRegister("7WM7y", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $b3e0454f7f1f85f3$export$580adf4c24c28053; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $9GLx2 = parcelRequire("9GLx2");

var $bv77X = parcelRequire("bv77X");

var $doAVE = parcelRequire("doAVE");

var $PE2DD = parcelRequire("PE2DD");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $1ka2O = parcelRequire("1ka2O");

var $4d61Q = parcelRequire("4d61Q");
const $b3e0454f7f1f85f3$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9GLx2.default), {
        locale: "en",
        messages: {},
        defaultLocale: "en",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $PE2DD.BxpWebStargateClientProvider), {
            baseUrl: (0, $PE2DD.getStargateBaseUrl)(),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $doAVE.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "404-page",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1ka2O.LocationProvider), {
                            location: typeof window !== "undefined" ? window.location : {
                                pathname: "/",
                                href: "/"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                                        isShowTryNowLink: true,
                                        tryNowLinkCtaButtonColor: "light_grey",
                                        productKey: "404"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
                            ]
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("lsYgE", function(module, exports) {
$parcel$export(module.exports, "BuyCloudOrgSetupPage", function () { return $263c5b0e055ff0bd$export$4e76f99368941eb8; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("je62f");
var $8DbQq = parcelRequire("8DbQq");
const $263c5b0e055ff0bd$export$4e76f99368941eb8 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8DbQq.BuyCloudOrgSetupPageTemplate), {});

});
parcelRegister("je62f", function(module, exports) {
$parcel$export(module.exports, "BuyCloudOrgSetupPageTemplate", function () { return (parcelRequire("8DbQq")).BuyCloudOrgSetupPageTemplate; });

var $8DbQq = parcelRequire("8DbQq");

});
parcelRegister("8DbQq", function(module, exports) {
$parcel$export(module.exports, "BuyCloudOrgSetupPageTemplate", function () { return $1dcf28602161449e$export$61ed6150ce1cf26a; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $j2b52 = parcelRequire("j2b52");

const $1dcf28602161449e$var$DirectBuyOrgSetupContainer = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-ignore
    Promise.resolve((parcelRequire("4wClq"))));
const $1dcf28602161449e$export$61ed6150ce1cf26a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($1dcf28602161449e$var$DirectBuyOrgSetupContainer, {})
    });
};

});



parcelRegister("2ABij", function(module, exports) {
$parcel$export(module.exports, "BuyCloudPostOrderProvisioningPage", function () { return $4e5168b65a5948ac$export$a5f8b599017bd5cd; });

var $7VQPk = parcelRequire("7VQPk");

var $k7GoD = parcelRequire("k7GoD");
const $4e5168b65a5948ac$export$a5f8b599017bd5cd = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $k7GoD.BuyCloudPostOrderProvisioningPageTemplate), {});

});

parcelRegister("2kCSN", function(module, exports) {
$parcel$export(module.exports, "BuyCloudSiteSetupPage", function () { return $0cf966eca9574fc8$export$4febe9f853354faf; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("b0jru");
var $7YWV2 = parcelRequire("7YWV2");
const $0cf966eca9574fc8$export$4febe9f853354faf = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7YWV2.BuyCloudSiteSetupPageTemplate), {});

});
parcelRegister("b0jru", function(module, exports) {
$parcel$export(module.exports, "BuyCloudSiteSetupPageTemplate", function () { return (parcelRequire("7YWV2")).BuyCloudSiteSetupPageTemplate; });

var $7YWV2 = parcelRequire("7YWV2");

});
parcelRegister("7YWV2", function(module, exports) {
$parcel$export(module.exports, "BuyCloudSiteSetupPageTemplate", function () { return $675a97dee15650d0$export$17d9bc116915a14; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $j2b52 = parcelRequire("j2b52");

const $675a97dee15650d0$var$DirectBuySiteSetupContainer = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-ignore
    (parcelRequire("fvJHu")));
const $675a97dee15650d0$export$17d9bc116915a14 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($675a97dee15650d0$var$DirectBuySiteSetupContainer, {})
    });
};

});
parcelRegister("fvJHu", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("b69he")).then(()=>parcelRequire('1Mst4'));

});




parcelRegister("83Z9w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e00e0b56977ce279$export$2e2bcd8739ae039; });
/* cdn-library.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jMhSx = parcelRequire("jMhSx");

var $gaU6N = parcelRequire("gaU6N");
const $e00e0b56977ce279$var$CDNLibrary = ()=>{
    var _window;
    const [bgColor, setBgColor] = (0, $1oC0p.useState)("#f0f0f0");
    // Redirect to the homepage if the page is accessed from atlassian.com
    if (((_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname) === "atlassian.com") window.location.href = "/";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0q1wto _u5f3idpf _n3td1wto _19bvidpf _1tke1kxc _bfhkbs0x"
        ]),
        style: {
            "--_1w9snyi": (0, $6ZVlx.default)(bgColor)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqsw1n9t _152tidpf _1e0c1txw _1bah1yb4 _zulp1wto _ca0qviql _u5f3viql _n3tdviql _19bvviql _1bsb1osq _16qsd8sd _bfhkbs0x"
                    ]),
                    style: {
                        "--_1w9snyi": (0, $6ZVlx.default)(bgColor)
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                            type: "color",
                            value: bgColor,
                            onChange: (e)=>setBgColor(e.target.value),
                            title: "Change background color of the page"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("b", {
                                        children: "Last updated:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: new Date((0, $gaU6N.lastUpdated)).toLocaleString()
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: $e00e0b56977ce279$var$calculateHowLongAgo(new Date((0, $gaU6N.lastUpdated)))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1q51webb _rzby1wto _8k2z1wug _nd4uidpf _9u9n1wug _iowe1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                children: "WAC-WEB CDN Library"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1ogm _y3gn1h6o"
                                ]),
                                children: "These are the asset files uploaded to the WAC CDN. Search, filter, and copy the URL of the asset you are looking for quick and easy."
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _zulpviql _19pk1wto _2hwxidpf _otyr1wto _18u0idpf"
                                ]),
                                children: (0, $gaU6N.cdnLibraryData).map((section)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e00e0b56977ce279$var$DirectorySection, {
                                        directory: section.directory,
                                        files: section.files
                                    }, section.directory))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $e00e0b56977ce279$var$DirectorySection = ({ directory: directory, files: files })=>{
    const [showFiles, setShowFiles] = (0, $1oC0p.useState)(false);
    const [filter, setFilter] = (0, $1oC0p.useState)("");
    const filteredFiles = files.filter((file)=>file.includes(filter));
    if (files.length === 0) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _4cvr1h6o _6a6z1e5h _yv0ek13l _zulpviql _1n461j6v _if5y1j6v _1gnp1j6v _7e5b1j6v _cq5utlke"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: directory
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                        htmlFor: directory + "show",
                        className: (0, $2jatx.default)([
                            "_80omtlke"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: directory + "show",
                                type: "checkbox",
                                checked: showFiles,
                                onChange: ()=>setShowFiles((prev)=>!prev)
                            }),
                            "Show ",
                            files.length === 1 ? "file" : "files",
                            " (",
                            filteredFiles.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                        htmlFor: directory + "filter",
                        children: [
                            "Filter:",
                            " ",
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                id: directory + "filter",
                                type: "text",
                                value: filter,
                                onChange: (e)=>setFilter(e.target.value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1vyd _2lx21bp4 _zulpviql"
                ]),
                style: {
                    "--_1dd9cxe": (0, $6ZVlx.default)(showFiles ? "flex" : "none")
                },
                children: filteredFiles.map((file)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e00e0b56977ce279$var$FilePreview, {
                        file: file
                    }, file))
            })
        ]
    });
};
const $e00e0b56977ce279$var$FilePreview = ({ file: file })=>{
    const copyToClipboard = ()=>{
        navigator.clipboard.writeText(file);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvrv2br _6a6zv2br _zulp1j6v _19pkidpf _2hwxviql _otyridpf _18u0viql _bozg1j6v _191w1qv1 _43ds13q2"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulpviql"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                onClick: copyToClipboard,
                                title: "Save to clipboard",
                                children: "COPY URL"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: file,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "OPEN IN NEW TAB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: file
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _mezj1osq _1y2k1osq _rtys1osq _26rc1osq _19l31osq _1ghp1osq"
                ]),
                children: [
                    $e00e0b56977ce279$var$isVideo(file) && // Tech debt: Adding this disable to unblock commits for GWP-2646
                    // eslint-disable-next-line jsx-a11y/media-has-caption
                    /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        src: file,
                        controls: true
                    }),
                    $e00e0b56977ce279$var$isImage(file) && /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: file,
                        alt: file,
                        loading: "lazy"
                    })
                ]
            })
        ]
    });
};
const $e00e0b56977ce279$var$isVideo = (file)=>{
    return file.endsWith(".mp4") || file.endsWith(".webm");
};
const $e00e0b56977ce279$var$isImage = (file)=>{
    return file.endsWith(".svg") || file.endsWith(".webp") || file.endsWith(".png") || file.endsWith(".jpg") || file.endsWith(".jpeg") || file.endsWith(".gif");
};
const $e00e0b56977ce279$var$calculateHowLongAgo = (datePast)=>{
    // Calculate the difference between now and the datePast
    const difference = new Date().getTime() - datePast.getTime();
    // Convert difference into days, hours, and minutes
    const daysDifference = Math.floor(difference / 86400000);
    const hoursDifference = Math.floor(difference % 86400000 / 3600000);
    const minutesDifference = Math.floor(difference % 3600000 / 60000);
    // Construct the output string
    let result = "";
    if (daysDifference > 0) result += daysDifference + " day" + (daysDifference > 1 ? "s" : "");
    if (daysDifference > 0 && hoursDifference > 0) result += ", ";
    if (hoursDifference > 0) result += hoursDifference + " hour" + (hoursDifference > 1 ? "s" : "");
    if (hoursDifference > 0 && minutesDifference > 0) result += ", and ";
    if (minutesDifference > 0) result += minutesDifference + " minute" + (minutesDifference > 1 ? "s" : "");
    return result + " ago";
};
var $e00e0b56977ce279$export$2e2bcd8739ae039 = $e00e0b56977ce279$var$CDNLibrary;

});
parcelRegister("gaU6N", function(module, exports) {
$parcel$export(module.exports, "lastUpdated", function () { return $18aac2c07ff756bf$export$c60d1a715a48771d; });
$parcel$export(module.exports, "cdnLibraryData", function () { return $18aac2c07ff756bf$export$48209f5fd1d7ca21; });
// This file is auto-generated by the script generate-cdn-library-data.mjs
const $18aac2c07ff756bf$export$c60d1a715a48771d = "2024-04-20T06:39:46.627Z";
const $18aac2c07ff756bf$export$48209f5fd1d7ca21 = [
    {
        directory: "download/",
        files: []
    },
    {
        directory: "keynote/",
        files: []
    },
    {
        directory: "keyword-cluster/",
        files: []
    },
    {
        directory: "mp4-animations/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/mp4-animations/jira-hero-wac-animation.mp4"
        ]
    },
    {
        directory: "optimizely/",
        files: []
    },
    {
        directory: "pdfs/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/pdfs/CSD-10312_France_Gender_Equity_Disclosure-FY24_Q3.pdf"
        ]
    },
    {
        directory: "svgs/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/svgs/audi-n50.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/avocado.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/beacon-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/bitbucket-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/blue-wave-background.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/canva-n50.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/code-aws-devops.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/code-aws-jsw.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/compass-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-whiteboards-logo-lockup-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence-whiteboards-logo-lockup.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/crowd.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/devops-background.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/devops-v2-left-optimized.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/envelope-n2n.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/figma.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-core-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-ops-blue-rgb.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-product-discovery-logo-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-service-management-logo-gradient-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-software-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-software-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira-work-management-logo-gradient-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jira.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jpd-firstimpression-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jpd-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsd-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsd-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsm-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jsw-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/jwm-social-proof-reel.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/logo-gradient-blue-compass.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/loom.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/loom_beam_color.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/menu.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/microsoft-teams.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/ms-teams.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/opsgenie-blue-rgb.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/slack.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/ss-atlassian-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/ss-jsw-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/statuspage-blue.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/statuspage-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/success-n2e.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-beta-color.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-beta-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/team-central-hero.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/tempo-logo-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/tempo-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/trello-icon-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/svgs/trello-logo.svg"
        ]
    },
    {
        directory: "test-svgs/",
        files: []
    },
    {
        directory: "testreplica/",
        files: []
    },
    {
        directory: "videos/",
        files: []
    },
    {
        directory: "webp-images/",
        files: [
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/001 Plan-1878220112.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/002 Track-61709455.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/003 Collab-1370881390.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/004 Launch-3779179643.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/005 Report-161454665.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/10C-Logo-Nextiva1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/10C-Logo-Nextiva@2x 1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/5_New%20Mobile@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/9D-Logo-Lufthansa-Systems.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/9D-Logo-Lufthansa-Systems_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ADD_DARK_MODE@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/AUTO_LOAD_BALANCE@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Air_Canada-logo-n0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Announcement_Banner.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Archived_Page.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Arvato Systems-4222291387.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian-Intelligence-icon.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian-intelligence.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_DHCS_Ryan_Alpha-1206744447.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Atlassian_Presents_Unleash_logo_banner.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation_Triggers.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Automation_Triggers.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY-SUPPORT@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BANC.LY_SUPPORT@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-1440-left.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-1440-right.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-Hero-768-right.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/BG-dot_filled_circle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Backlog.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blog_360x265@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Best%20Practices@4x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Demo%20Video@4x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Blue%20Use%20Cases@4x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Board-with-nav-collapsed.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Board.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Bulk_archiving.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Macros__@1x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Page_versioning__@1x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Unlimited_spaces__@1x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ AI-3298633667.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ AI_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Confluence-2040505915.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Confluence_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JPD-286968629.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JPD_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JSM-3020245023.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ JSM_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Loom-791474346.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_ Loom_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_HD (0-00-00-00)-4060786602.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_A_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_HD (0-00-09-24)-1969559334.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_B_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_HD (0-00-16-35)-1443600009.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_C_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_FULL_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Hero_FULL_LowBR.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Jira-4003614779.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10721_WAC_Jira_LowBR.mp4",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204 project north star plan@2x.webp-2125193628.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-Templates-screen@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-cta-left.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-cta-right.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-hero-left-side.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204-hero-right-side.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Break_down_information_silos@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Employee_Resource_hub@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Get_on_the_same_page@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Templates_screen@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Weekly_status@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_Your_entire_team_on_one_platform@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_project_north_star_plan@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-6204_project_overview@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-8431-FY24-Team-24-Animated-Website-Hero_v03.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ClearwaterAnalytics-823945256.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Community@2x-3332122863.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Community@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CommunityMobile_360x235@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueBestPractices.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueDemoVideo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_BlueUseCases.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Conf_ProductTour_Thumbnail.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence%20PT%20thumbnail@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence@2x-blue.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Collaboration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_SourceOfTruth.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_BusinessPlan_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Marketing_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProductJA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProductPT.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Product_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revisedJA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revisedPT.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Productivity-revised_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProjectJA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_ProjectPT.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Templates_Project_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced%20search%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced_search.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Advanced_search_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Integration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_KnowledgeMangement.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real%20time%20Editing%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real_time_Editing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Real_time_Editing_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki-961320203.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_frFR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Word_Wiki_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence_AI.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Copy_Space_Permissions-optimized.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DESIGN_TEAMS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DHCS-1703508494.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Dektop_TL@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Dependency-management.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_BL-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_BR-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Desktop_TR-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Doodle-3562754075.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/DropBox-4186472046.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Endenred-734004069.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Engineering_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Ent%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FLO_logo_horizontal_white%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/FUN@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Frame 1010105996-1698270861.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GW-1212_ds_jsm_bancly_help_center2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg2.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-dark-sectionbg3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-footerbg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-mobile-workflow-diagram.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tab-bg3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1150-tablet-footerbg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212-unlock-collaboration-2790x1554.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_Incident_issue_view_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_it_ops_tab.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_jsm_bancly_help_center2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/GWP-1212_service_management_screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273011-2525946013.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273205-1701574714.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273206-2473828409.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273207-554690744.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Guest_markers_in_product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HERO_ROADMAPS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/HR_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/IP_allowlist.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ITSM-1400.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image-@2X%202.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image-smile.webp-647850140.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Impossible-Alone-Video-Header-Image.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Inspect_Perms-optimized.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JA sign-responsive.webp-1988963931.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JA%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JPD_screen_framed.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM + topics.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSMJiraprovisioning.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_AI.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_BG%20Graphics.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_CTA Background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_CTA%20Background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DeliverFast_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_DevOps_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Automation_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_ITIL_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_Knowledge_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_FeaturesTicketing_SLA_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Change_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Configuration_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_DynamicForms_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Incident_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Integrations_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Problem_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_Request_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_SelfService_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_Features_ServiceDesk_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_ja_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSM_MakeVisible_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW%20free-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_AI.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Automation_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2%202.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2_pt-de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Backlog_x2_2pt-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Blue_Grid.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Boards_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bug_Tracking.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Bye_Bye_Spreadseets_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Capacity_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Forecast_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Goals_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Kanban.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_BugTracking_Spot.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Wave.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_DarkModeIllustration_Workflow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ProductTour_PromoBannerGeo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_ReportsInsights_2_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Reports_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Roadmaps_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Roadmaps_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_SingleSource_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_deDE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSW_Visualization_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JWM.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Board-Software-3233077719.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Calendar-Marketing-4146978900.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-List-Design-1069502226.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-On-call-IT-3030871761.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Product Management-3301759489.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Jira-Timeline-Project Management-2679766879.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraConfluenceprovisioning.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraJSMProvisioning.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Joe Cotant Roblox-2296603445.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kiva-1702957319.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Lang_support@1x-from-@harry.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo-wall-left-2221824116.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo-wall-right-3214451279.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Lumen-381040365.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MARKETING_CALENDAR@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Marketing_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MehmetSari-4103257443.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MercedesBenz-357676847.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Microsoft-teams-logo-1526817987.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Microsoft_Teams_Logo_2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Miro-logo-3117227469.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/MissionControl.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Mobile_B-2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Mobile_T@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Networking_people_spot@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN-INCIDENTS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPEN_INCIDENTS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/OPERATIONS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Octicons-cloud-download.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Overview_issue_hiearchy.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-11.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-11.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-01.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-02.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-03.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-04.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-07.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-11.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-13.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/POS-system.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/PRODUCT_TEAMS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Pasted Graphic-2395339363.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Prem%20sign-responsive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Premium_feature_-_site_analytics-2X_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Product_Management.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Product_team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/QMetry-logo-978966706.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/RTR_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Releases.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Roblox Interview Joe Cotant + Alpha-1942757731.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Roblox-3121607094.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/RobloxJoeCotant-1985850389.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Round 5.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/RoyalCaribbean-2310931816.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Rule-builder-component_list-2x_.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SERVICE_CENTER@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SOFTWARE_TEAMS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SUBTASKS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen%20Shot%202023-01-05%20at%203.48%201.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights%20JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-kanban_board@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-scrum_board@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Social%20Unleash%20193x122.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Software AG-2524322619.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/SonyMusic-3191867672.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Spotify_Logo-N0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Stars.webp-347416437.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/StephanieLeue_CPO_Doodle-2892442182.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Structured_page_tree__@1x_(2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEAM_ANALYTICS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_de-DE@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_fr-FR@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_ja-JP@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TEMPLATES_pt-BR@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TOOLS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x-ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TRACK_PROGRESS@2x_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team%20Playbook_360x265@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-24-Animated-Website-Hero_Mobile_329x253.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-Calendars.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team-Logo-1786577449.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo only_1200_628.webp-2037705328.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo-1729653467.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo.webp-1729653467.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo_-977956.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Team_Logo_only_1200_628.webp-3936184367.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/TheVeryGroup-1520026636.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Ticket_created@2x_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/Timeline.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/WaisRoyalCaribbean-4173208448.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/add-dark-mode.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/admin-insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/admin-key.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/advanced-roadmaps-timeline.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/agile-reporting.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-atlassian-intelligence-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background-tablet.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-deeplink-banner-background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/air-table-3638621307.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-add-people-modal.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-automation-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-customer-service-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-customer-support-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-iress-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-open-cases-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-silverline-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-support-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor-jsm-trouble-ticket-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_HR_support_screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_JSM_topics.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_automation_rule_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_automation_screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_business_team_support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_change_details_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_facilities.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_facilities2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_incident_issue_view_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_cs.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_cs2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_jsm_features_dynamic_forms.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_project_templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_team_analytics_dashboard.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/anchor_topics_jsm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-hand.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/artboard-stars.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/arvato-johannes-siebzehnrubl-2519619866.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/asana-363871342.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/aset-selection.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/assign-and-prioritize_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/astronaut.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/atlassian-unleash.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/audi-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/audit-logs.cdnVersion1351.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-rules_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2_1_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation2xpng.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/automationscreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/backing4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/balsamiq-1570513082.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l_.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_l_with_lines.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_r.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_bg_r_.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bannerAlert_team24_logo_.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg_atl_cloud_hero_small.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bitbucketscreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bitbucketscreen2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-angle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-closing-angle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bonobos-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/breakdownInfoSilos.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bring-visibility.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bucket_test.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/bucket_test_2.png",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-363018985.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/canvalogo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/capacity-management.1354.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/cec1c0b14a8ceca297df71534fae13dd-481890245.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/check-green.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/check-green.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/checkmark-paper-plane-illustration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/choose_your_own_adventure_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/clearwater-analytics-erica-larson-783154932.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/closing-banner-graphic.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate_4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-invite.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-collaboration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-default.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-knowledge-base.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-product-question-trying-out.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/con-onboard-template-background-2765676952.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-create-a-page.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-organize-your-work.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence-share-it-with-your-team.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-collaboration.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-documentation.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-feature-templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-businessplan.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-marketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluencelp-templates-product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/construction.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/content_gif_v1.0.2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/create_issue_2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ctaLeft.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ctaRight.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/curved-arrow-icon-3497580723.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer service screen.webp-3113962215.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-company-placeholder-mercedes-benz-3039099905.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-company-placeholder-roblox-4173828533.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-filter-icon-3367749555.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-hero-asset-placeholder-mercedes-benz-1758178859.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customer-story-person-placeholder-roblox-2783909767.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/customers-team24-hero-background.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dark-shape.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/demo-deeny-fullcard1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/department-of-defense-n50.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/deploymentscreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/desc.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-1-3753095941.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-2-1415836422.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-3-3083932167.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-main-2975787526.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devOps_template_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devops-diagram-compressed.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/devops-diagram-compressed.webp-1760218363.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcs-ryan-mosley-4192898571.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcs2-419927292.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcsfigma-846763754.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dhcsfigma2-303950232.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dominos-n0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/doodle-stephanie-leue-1192382875.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/doodle2-1344893385.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/doodlefigma-3413596895.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/dropbox-damien-davis-3638188557.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earf-high-res.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earf.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earf2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/earth-noise.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/edenred-razvan-nechifor-1301495753.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-campaign-management.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-content-management.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-customer-journey-mapping.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-go-to-market.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-kanban.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-roadmap.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/emp-screen-scrum.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/employeeResourcehub.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower-employees.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/empower5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-bars.webp-2356904232.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-graph.webp-3089236614.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-grid.webp-3189788274.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-quarter-circle.webp-2345858369.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprisetabContentImage-978864670.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/esm_templates.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/explore-apps-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fabric-sign-up-hero-rev@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/feature-code-image-three.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-one.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-three.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-two.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-363833302.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-logo-4073520400.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/file.webp-1703115956.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ford-n0.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterfigma-3996254026.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/fullcard4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartnerfigma-4234034927.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartnerpeerinsightsfigma-3794251448.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/gestural-line.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/getOnTheSamePage.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/git-lab-204839338.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/github-3505995671.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/github-logo-1518537873.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-analytics-3286988256.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-2740153165.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-logo-950929547.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-2276762714.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-logo-2396662236.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-play-280x86.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-sheets-1718541418.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/header-line.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-illustration%20.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-illustration.webp-1789985659.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-screenshot-main.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hero-screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardDesign.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardIt.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardMarketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardOps.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardSoftwareDev.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroLeftSide.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroRightSide.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/high-velocity.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hot-jar-1014134517.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/how-to-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspot-3684386805.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspotLogo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/icongithub.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/iconsalesforce.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image-368080789.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image.webp-368080789.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image0_1822_82735.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image1-1147150532.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image2-951482151.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/image3-917086086.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/img-arrow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/incident-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/infobip-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/iss-logo-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/iss-logo-white_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-1-197982346.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-2-3557245065.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-3-1450489864.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-main-2485041033.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/itsm-market-event-wac-homepage-nov16-thumbnail.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jenkins-214038284.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-board-sparkle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-family-hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-cta.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-homepage-full.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-homepage-res.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ticket-loop-de-loop.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-impact_assessment.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-improve_discoverability.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jpd-pt-performance.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-competitors-service-desk.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-engie-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-explore-apps-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-incident-issue-view-shadow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-incident-issue-view.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-logo-ginkgo-bioworks.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-nextiva-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-request-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-saint-gobain-logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-anchor-subtasks.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-deliverfast.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-devops.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-hero-portal.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsm-makevisible.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin insights screenshot with sidebar.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin%20insights%20screenshot%20with%20sidebar.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-admin_insights_screenshot_with_sidebar.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jsw-project-archiving.1353.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jwm-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/jwm.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/kanban-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/kanban.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/kiva-brit-heiring-2670154364.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-darkly-198811051.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/load-balance-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/logged-in-states.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/login-flyout.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/logo-angle.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/logo-canva-80x80.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lucid_motors_logo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lucid_motors_logo_l.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lumen-mai-lian-scarlett-2328968069.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/lumenfigma-2189149097.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mailchimp-1767865028.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-1-2762112147.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-2-1921074928.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-3-2388914769.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-main-3970751984.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/maximize-efficiency_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mbenz-357294988.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedes-benz-mehmet-sari-366365367.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedesbenz2-2811812509.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mercedesbenzfigma-1447440523.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-365-3971673211.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-office-1075029899.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-teams-500184357.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/miro.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/mobile-dark-shape.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardDesign.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardIt.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardMarketing.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardOps.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardSoftwareDev.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/monday-3089500834.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/ms-teams.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/nasa-logo-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/nav-expanded-products.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/nextiva-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/notifications_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/object lightning 1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/page-insights.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/page-space-permissions.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/paid-hero.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/pendo-379684898.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/placeholder-video-1920x1080.webm",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/power-of-teamwork-stroke.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/pre-approved-change.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-1-4088370720.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-2-3111339843.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-card-3-4125726562.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prod-management-main-2176065091.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/prodbutton.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-1-4087893998.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-2-3111006349.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-card-3-4125393068.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/proj-management-main-2175731597.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/projectNorthStarPlan.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/projectOverview@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/public_links_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/quote.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/redfinfigma-3508974692.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/reports_and_insights_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-agile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-community.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-devops.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/resource-playbook.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/roadmaps_1462x860_en.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/roblox-joe-cotant-466070325.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/roblox2-2160814116.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/robloxfigma-3257924658.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/rocket-icon.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/royal-caribbean-wais-mojaddidi-3806226212.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/royalcaribbean2-1165951194.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/royalcaribbeanfigma-286749900.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-2848088583.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-logo-1329625985.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scottf-usericon.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev%20status%20in%20issue.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ES.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_JA.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_RU.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ptBR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-roadmaps_(1848x1062.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-scrum-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/script-runner-1229978336.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-accent-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-brand-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-portrait-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scroll-teams-screenshot-5.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/scrum_template_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2_1_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/seamless-integration2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-center.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-desk-screen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-map.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-now-3403321428.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sickkids_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/signal.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-375335524.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-logo-4089617954.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/smartsheet-2509293444.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-1-2014673720.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-2-1837920251.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-card-3-2211238458.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-main-4112590587.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/softwareag-tim-brutscher-149530773.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sony-music-publishing-alison-wood-1422956484.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sony_music_publishing_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sophosLogo.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sprints-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sprints.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/star.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/statsig-4214018365.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_br.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_de.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_fr.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/stay-on-track-re-export_ja.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sunlifefigma-451494296.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sydney.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/sydney.webp-3093752750.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab2image-29451184.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab3image-29484945.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab4image-29379446.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab5image-29413207.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-logo-desktop.webp-1192641009.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-right-hand-image-desktop.webp-3380811166.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-ad-banner-confluence-right-hand-image-tablet.webp-2937812902.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-anu-desktop.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-anu-tablet.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-logo-confluence-ad-banner-desktop.webp-1441519569.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-poster.webp-1047714346.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-desktop.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-mobile.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-promotion-header-static-tablet.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24-right-hand-image-confluence-desktop.webp-4272371151.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24_attribution-logo-above-center_full-color_RGB.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-24_attribution-logo-above-left_full-color_RGB.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team-tour_government_attribution-logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-card-test.webp-4063272267.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-color-lockup-desktop-3939666149.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-left-desktop-1497436778.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-left-tablet-3665178386.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-right-desktop-2027904593.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-liftedbar-right-tablet-1999618345.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-panel.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-audi.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-hubspot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24-testimonial-kiva.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24_card.webp-3094176962.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promo.webp-432199718.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promobanner.webp-3262748562.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promobannerwithdates.webp-3177688311.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24promowithdates.webp-3515396547.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team24widerpromobanner.webp-2328022111.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team_24_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/team_anywear_illo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-blogpost.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-brainwriting-theme-white-v2.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-brainwriting-theme-white.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-business-card-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-kanban-card-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header-update.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-confluence-chart.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/template_library-2X.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/templates-screenshot.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/templatesScreen@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/test_png.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-roblox.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial2.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial3.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial4.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline-view-de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline-view-fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline_view_(1.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/timeline_view_updated.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/toast_logo_n70_1.svg",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_de-DE.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_fr-FR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_ja-JP.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-bugs_pt-BR.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/trophy.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/trophy.webp-3079354842.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/trust-center-cloud-icon-3087608378.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/underline-header.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/unified-service-view.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/unitedfigma-3439270545.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/upgradescreen.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/user-icon-scottf.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-customer-service.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-employee-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-engineering-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-it-management-tab.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-1-hero-it-operations.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-customer-service.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-employee-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-engineering-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-it-operations.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/variant-2-hero-it-support.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/very-group-rob-crompton-1788084465.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/video-play-light.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_banner_background_11_14_23.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_bg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_bg_lu.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_tablet_bg.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/weeklyStatus@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/welcome-login-product.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/whiteboards.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/workflow-diagram.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/workflow.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/wrike-368502576.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/yale_school_mgmt_logo.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/yellow-gestural-lines-2995366884.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/yourEntireTeamOnOnePlatform@2x.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zendesk-97087002.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-1703389861.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-logo-3117034915.webp",
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom.webp"
        ]
    }
];

});


parcelRegister("4DBV5", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionPricingPage", function () { return $4a26ac1f20e86f75$export$8a26b3769c1320bc; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $dNCJN = parcelRequire("dNCJN");
const $4a26ac1f20e86f75$export$8a26b3769c1320bc = (props)=>{
    const { pricingContent: pricingContent, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "strategy-collection",
        pricingContent: pricingContent,
        // @ts-ignore
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNCJN.StrategyCollectionPricingPageTemplate), {})
    });
};

});
parcelRegister("dl2JF", function(module, exports) {
$parcel$export(module.exports, "usePricingContentContext", function () { return $f009a0814995d12d$export$5c4a541176bccda; });
$parcel$export(module.exports, "PricingContentContextProvider", function () { return $f009a0814995d12d$export$72e02a396b6ef938; });
$parcel$export(module.exports, "PricingContentContextProviderRelay", function () { return $f009a0814995d12d$export$4e54691009c7ed4c; });
$parcel$export(module.exports, "usePricingPlanComparison", function () { return $f009a0814995d12d$export$6ef9aee1b558c2a5; });
$parcel$export(module.exports, "useGetComparePlanCta", function () { return $f009a0814995d12d$export$8c0343b0c8323d5e; });
$parcel$export(module.exports, "useDatacenterPlans", function () { return $f009a0814995d12d$export$317f41c6296bda84; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $5UKqd = parcelRequire("5UKqd");

var $eY3N6 = parcelRequire("eY3N6");

var $4EfnG = parcelRequire("4EfnG");

var $kooLp = parcelRequire("kooLp");

var $eEYrI = parcelRequire("eEYrI");
const $f009a0814995d12d$var$PricingContentContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $f009a0814995d12d$export$5c4a541176bccda = ()=>{
    return (0, $1oC0p.useContext)($f009a0814995d12d$var$PricingContentContext);
};
const $f009a0814995d12d$var$stripPTags = (htmlString)=>{
    return htmlString.replace(/<\/?p>/g, "");
};
const $f009a0814995d12d$export$72e02a396b6ef938 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContextProviderInternal, (0, $6ogO3._)({}, props))
    });
};
const $f009a0814995d12d$var$PricingContentContextProviderInternal = (props)=>{
    const { productId: productId, pricingContent: initialPricingContent, pricingTitleInternal: pricingTitleInternal } = props;
    const locale = (0, $kooLp.useLocale)();
    const [pricingContent, setPricingContent] = (0, $1oC0p.useState)(initialPricingContent);
    const [loading, setLoading] = (0, $1oC0p.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        async function fetchPricingContent() {
            try {
                const fetchedContent = await (0, $eEYrI.getPricingContent)(productId, {
                    locale: locale,
                    pricingTitleInternal: pricingTitleInternal
                });
                setPricingContent(fetchedContent);
            } catch (error) {
                createAnalyticsEvent({
                    eventType: "track",
                    action: "failed",
                    actionSubject: "getPricingContent",
                    attributes: {
                        productId: productId,
                        locale: locale,
                        pricingTitleInternal: pricingTitleInternal,
                        // @ts-ignore
                        error: error.message
                    },
                    source: window.location.pathname
                }).fire();
                setPricingContent({
                    hasError: true
                });
            } finally{
                setLoading(false);
            }
        }
        if (!initialPricingContent) fetchPricingContent();
        else setLoading(false);
    }, [
        initialPricingContent,
        productId,
        locale
    ]);
    const cleanedValue = pricingContent ? (0, $dPABA._)((0, $6ogO3._)({}, pricingContent), {
        headline: (pricingContent === null || pricingContent === void 0 ? void 0 : pricingContent.headline) ? $f009a0814995d12d$var$stripPTags(pricingContent.headline) : ""
    }) : undefined;
    if (loading) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContext.Provider, {
        value: cleanedValue,
        children: props.children
    });
};
const $f009a0814995d12d$export$4e54691009c7ed4c = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContextProviderInternalRelay, (0, $6ogO3._)({}, props))
    });
};
const $f009a0814995d12d$var$PricingContentContextProviderInternalRelay = (props)=>{
    let { pricingContent: pricingContent } = props;
    const [loading, setLoading] = (0, $1oC0p.useState)(true);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $5UKqd.PricingPageRelayQuery), props.queryRef || null);
    if (!pricingContent) {
        var _shapedResponse_pricings_edges_, _shapedResponse_pricings_edges, _shapedResponse_pricings;
        const shapedResponse = (0, $5UKqd.shapePricingContentfulResponse)(data);
        pricingContent = shapedResponse === null || shapedResponse === void 0 ? void 0 : (_shapedResponse_pricings = shapedResponse.pricings) === null || _shapedResponse_pricings === void 0 ? void 0 : (_shapedResponse_pricings_edges = _shapedResponse_pricings.edges) === null || _shapedResponse_pricings_edges === void 0 ? void 0 : (_shapedResponse_pricings_edges_ = _shapedResponse_pricings_edges[0]) === null || _shapedResponse_pricings_edges_ === void 0 ? void 0 : _shapedResponse_pricings_edges_.node;
    }
    (0, $1oC0p.useEffect)(()=>{
        if (!!pricingContent) setLoading(false);
    }, [
        pricingContent
    ]);
    const cleanedValue = pricingContent ? (0, $dPABA._)((0, $6ogO3._)({}, pricingContent), {
        headline: (pricingContent === null || pricingContent === void 0 ? void 0 : pricingContent.headline) ? $f009a0814995d12d$var$stripPTags(pricingContent.headline) : ""
    }) : undefined;
    if (loading) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f009a0814995d12d$var$PricingContentContext.Provider, {
        value: cleanedValue,
        children: props.children
    });
};
function $f009a0814995d12d$export$6ef9aee1b558c2a5(title) {
    var _context_comparePlans;
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    return context === null || context === void 0 ? void 0 : (_context_comparePlans = context.comparePlans) === null || _context_comparePlans === void 0 ? void 0 : _context_comparePlans.find((p)=>p.planTitleExternal === title);
}
function $f009a0814995d12d$export$8c0343b0c8323d5e() {
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    return function getComparePlanCta(params) {
        var _context_comparePlans_params_comparePlanIdx_microCta, _context_comparePlans_params_comparePlanIdx, _context_comparePlans;
        var _params_microCtaIdx;
        return context === null || context === void 0 ? void 0 : (_context_comparePlans = context.comparePlans) === null || _context_comparePlans === void 0 ? void 0 : (_context_comparePlans_params_comparePlanIdx = _context_comparePlans[params.comparePlanIdx]) === null || _context_comparePlans_params_comparePlanIdx === void 0 ? void 0 : (_context_comparePlans_params_comparePlanIdx_microCta = _context_comparePlans_params_comparePlanIdx.microCta) === null || _context_comparePlans_params_comparePlanIdx_microCta === void 0 ? void 0 : _context_comparePlans_params_comparePlanIdx_microCta[(_params_microCtaIdx = params.microCtaIdx) !== null && _params_microCtaIdx !== void 0 ? _params_microCtaIdx : 0];
    };
}
function $f009a0814995d12d$export$e5b23f1c4d669bad() {
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    return function getPricingPlanCta(params) {
        var _context_comparePlans_find_microCta, _context_comparePlans_find, _context_comparePlans;
        return context === null || context === void 0 ? void 0 : (_context_comparePlans = context.comparePlans) === null || _context_comparePlans === void 0 ? void 0 : (_context_comparePlans_find = _context_comparePlans.find((p)=>p.planTitleExternal === params.planName)) === null || _context_comparePlans_find === void 0 ? void 0 : (_context_comparePlans_find_microCta = _context_comparePlans_find.microCta) === null || _context_comparePlans_find_microCta === void 0 ? void 0 : _context_comparePlans_find_microCta[0];
    };
}
function $f009a0814995d12d$export$317f41c6296bda84(btnText, linkText) {
    var _context_datacenterPlans, _datacenterContent_microCta, _datacenterContent_microCta1;
    const context = $f009a0814995d12d$export$5c4a541176bccda();
    const datacenterContent = context === null || context === void 0 ? void 0 : (_context_datacenterPlans = context.datacenterPlans) === null || _context_datacenterPlans === void 0 ? void 0 : _context_datacenterPlans[0];
    const btnCtaObject = datacenterContent === null || datacenterContent === void 0 ? void 0 : (_datacenterContent_microCta = datacenterContent.microCta) === null || _datacenterContent_microCta === void 0 ? void 0 : _datacenterContent_microCta.find((btnCta)=>"ctaButtonText" in btnCta && btnText === btnCta.ctaButtonText);
    const linkCtaObject = datacenterContent === null || datacenterContent === void 0 ? void 0 : (_datacenterContent_microCta1 = datacenterContent.microCta) === null || _datacenterContent_microCta1 === void 0 ? void 0 : _datacenterContent_microCta1.find((linkCta)=>"ctaButtonText" in linkCta && linkText === linkCta.ctaButtonText);
    var _datacenterContent_planTitleExternal, _datacenterContent_planOneLiner;
    return {
        title: (_datacenterContent_planTitleExternal = datacenterContent === null || datacenterContent === void 0 ? void 0 : datacenterContent.planTitleExternal) !== null && _datacenterContent_planTitleExternal !== void 0 ? _datacenterContent_planTitleExternal : "",
        description: (_datacenterContent_planOneLiner = datacenterContent === null || datacenterContent === void 0 ? void 0 : datacenterContent.planOneLiner) !== null && _datacenterContent_planOneLiner !== void 0 ? _datacenterContent_planOneLiner : "",
        buttonCta: btnCtaObject && "ctaUrl" in btnCtaObject ? {
            label: btnCtaObject.ctaButtonText || undefined,
            href: btnCtaObject.ctaUrl || undefined
        } : undefined,
        linkCta: linkCtaObject && "ctaUrl" in linkCtaObject ? {
            label: linkCtaObject.ctaButtonText || undefined,
            href: linkCtaObject.ctaUrl || undefined
        } : undefined
    };
}

});
parcelRegister("d9N42", function(module, exports) {
$parcel$export(module.exports, "useCCPPriceFinderData", function () { return (parcelRequire("dkcYJ")).useCCPPriceFinderData; });
$parcel$export(module.exports, "useHAMSPriceData", function () { return (parcelRequire("dkcYJ")).useHAMSPriceData; });
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return (parcelRequire("k6PTJ")).AnchorPageRelayQuery; });
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return (parcelRequire("5UKqd")).PricingPageRelayQuery; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return (parcelRequire("k6PTJ")).shapeAnchorContentfulResponse; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return (parcelRequire("5UKqd")).shapePricingContentfulResponse; });
parcelRequire("dkcYJ");
parcelRequire("b7P4C");

});

parcelRegister("eEYrI", function(module, exports) {
$parcel$export(module.exports, "getPricingContent", function () { return $ddf64ed950a8ce67$export$331f740a8830d0ce; });

var $f3gS9 = parcelRequire("f3gS9");

var $gRpMo = parcelRequire("gRpMo");

var $5UKqd = parcelRequire("5UKqd");
const $ddf64ed950a8ce67$export$331f740a8830d0ce = async (productId, opts = {})=>{
    var _pricingDataRelay_pricings_edges_, _pricingDataRelay_pricings_edges, _pricingDataRelay_pricings;
    const { pricingTitleInternal: pricingTitleInternal } = opts;
    const fetchGraphQL = async (request, variables)=>{
        const resp = await fetch("https://graphql.contentful.com/content/v1/spaces/xjcz23wx147q/environments/staging", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer WFETdoDDbFH844w-0KwS2F0SFzgYf5EtZPE5isAYUhY"
            },
            body: JSON.stringify({
                query: request.text,
                variables: variables
            })
        });
        if (!resp.ok) throw new Error("Response failed.");
        return await resp.json();
    };
    const environment = new (0, $gRpMo.Environment)({
        store: new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)({})),
        network: (0, $gRpMo.Network).create(fetchGraphQL)
    });
    const pricingDataRaw = await (0, $f3gS9.fetchQuery)(environment, (0, $5UKqd.PricingPageRelayQuery), (0, $5UKqd.getPricingPageRelayQueryVars)(productId, window.location, pricingTitleInternal)).toPromise().then((data)=>data).catch((error)=>{
        console.log(error);
    });
    const pricingDataRelay = (0, $5UKqd.shapePricingContentfulResponse)(pricingDataRaw);
    return pricingDataRelay === null || pricingDataRelay === void 0 ? void 0 : (_pricingDataRelay_pricings = pricingDataRelay.pricings) === null || _pricingDataRelay_pricings === void 0 ? void 0 : (_pricingDataRelay_pricings_edges = _pricingDataRelay_pricings.edges) === null || _pricingDataRelay_pricings_edges === void 0 ? void 0 : (_pricingDataRelay_pricings_edges_ = _pricingDataRelay_pricings_edges[0]) === null || _pricingDataRelay_pricings_edges_ === void 0 ? void 0 : _pricingDataRelay_pricings_edges_.node;
};

});


parcelRegister("dNCJN", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionPricingPageTemplate", function () { return $b5a17977904a47a3$export$22ea4bdc4834ca4; });
/* strategy-collection-pricing-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $bE8d4 = parcelRequire("bE8d4");
var $2zOxm = parcelRequire("2zOxm");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $7yPHr = parcelRequire("7yPHr");

var $f2RFx = parcelRequire("f2RFx");

var $btixQ = parcelRequire("btixQ");
const $b5a17977904a47a3$export$22ea4bdc4834ca4 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1;
    // @ts-ignore
    const intl = (0, $8e22h.default)();
    const content = (0, $dl2JF.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1];
    // @ts-ignore
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f2RFx.StrategyCollectionNavbar), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "strategy-collection-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulp7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7yPHr.Hero), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                            children: content === null || content === void 0 ? void 0 : content.headline
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $btixQ.StrategyCollectionPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "strategyCollection"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                })
            ]
        })
    });
};
const $b5a17977904a47a3$var$headingContainerCss = null;

});
parcelRegister("h9b6O", function(module, exports) {
$parcel$export(module.exports, "PricingFeatureTable", function () { return (parcelRequire("7aKDf")).PricingFeatureTable; });
parcelRequire("7aKDf");

});
parcelRegister("7aKDf", function(module, exports) {
$parcel$export(module.exports, "PricingFeatureTable", function () { return $84231b70db855011$export$49da9cb6ddf668ee; });
/* features-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20Gca = parcelRequire("20Gca");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("9K6CO");
var $6tSTn = parcelRequire("6tSTn");

var $hrGO1 = parcelRequire("hrGO1");
parcelRequire("i0PNA");
var $l4Rl8 = parcelRequire("l4Rl8");

var $6o9v8 = parcelRequire("6o9v8");
const $84231b70db855011$var$tdStyles = null;
const $84231b70db855011$var$advanceHeadingStyles = null;
const $84231b70db855011$var$advanceTitleStyles = null;
const $84231b70db855011$var$advanceButtontyles = null;
const $84231b70db855011$var$advanceSoftStyles = null;
const $84231b70db855011$var$featureTableSubHeader = null;
const $84231b70db855011$var$featuresTableHeadIdPrefix = "featTableHead_";
const $84231b70db855011$export$5a7d94d7c691844a = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _b8yq1git _n09v1ylp _1txjidpf _y4duvbgk _u19lidpf _jpg4bfng"
        ])
    }));
};
const $84231b70db855011$export$de898cfe2ca10ff8 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: props.children
    });
};
const $84231b70db855011$export$f052fee91dc6777a = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("h2", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_syaz1hlo _k48p1fw0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb14no _1cqszwfg _3p1c1ylp _py5ockbl"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        }
    }));
};
const $84231b70db855011$export$a433b7aa5ad7fd61 = ({ linkText: linkText, linkHref: linkHref })=>{
    const intl = (0, $8e22h.default)();
    const defaultLinkText = intl.formatMessage({
        id: "PricingPages.featureTable.subHeader",
        defaultMessage: "Learn about features"
    });
    const defaultLinkHref = `https://www.atlassian.com${(0, $kooLp.useLocalizedHref)("/software/jira/features")}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1wyb7vkz _vwz4gktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
            href: linkHref !== null && linkHref !== void 0 ? linkHref : defaultLinkHref,
            className: "link-class",
            type: "primary"
        })
    });
};
const $84231b70db855011$var$FeaturesTableContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext({
    planTiers: []
});
const $84231b70db855011$export$e2b8eb038115bae6 = (props)=>{
    const intl = (0, $8e22h.default)();
    const localizedSignupURL = (0, $kooLp.useLocalizedHref)((0, $hrGO1.SIGNUP_CTA_URL));
    const localizedContactURL = (0, $kooLp.useLocalizedHref)((0, $hrGO1.CONTACT_CTA_URL));
    return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$var$FeaturesTableContext.Provider, {
        value: {
            planTiers: props.planTiers
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
            className: (0, $2jatx.default)([
                "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _476d1tcg _1e0c5mfb _1pfhzwfg _1mt1ckbl"
            ]),
            children: [
                props.captionText && /*#__PURE__*/ (0, $7VQPk.jsx)("caption", {
                    className: (0, $2jatx.default)([
                        "_y3gnv2br _ca0qzwfg _u5f3dlk8 _n3tddlk8 _19bvdlk8 _ect41pz4 _1wyb1k92 _1kmx1tcg _1ggmdlk8 _1ykzdlk8 _1maedlk8"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                    },
                    children: props.captionText
                }),
                props.subCaptionText && /*#__PURE__*/ (0, $7VQPk.jsx)("caption", {
                    className: (0, $2jatx.default)([
                        "_y3gnv2br _ca0qidpf _u5f3dlk8 _n3tddlk8 _19bvdlk8 _ect41pz4 _1wyb1j6v"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                    },
                    children: props.subCaptionText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                    className: (0, $2jatx.default)([
                        "_179ru1j4 _sugaglyw _1pbykb7n _154i88uy _kqsw1if8 _11q7cd5j"
                    ]),
                    style: {
                        "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
                        className: (0, $2jatx.default)([
                            "_17gvangw _7dd6v2br"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$var$FeaturesTableHeadCell, {
                                index: 0
                            }),
                            props.planTiers.map((tierContent, index)=>{
                                let edition, ctaBtnText = "", ctaBtnUrl = "", dataEventPropsLabel = "start-trial";
                                if (props.stickyCtasEnabled && props.dataProductKey) {
                                    const startFreeTrialText = intl.formatMessage({
                                        id: "Pricing.CompareFeatures.StartFreeTrial",
                                        defaultMessage: (0, $hrGO1.CtaBtnText).START_FREE_TRIAL
                                    });
                                    const getItNowText = intl.formatMessage({
                                        id: "Pricing.CompareFeatures.GetItNow",
                                        defaultMessage: (0, $hrGO1.CtaBtnText).GET_IT_NOW
                                    });
                                    const contactSalesText = intl.formatMessage({
                                        id: "Pricing.CompareFeatures.ContactSales",
                                        defaultMessage: (0, $hrGO1.CtaBtnText).CONTACT_SALES
                                    });
                                    ctaBtnText = startFreeTrialText;
                                    dataEventPropsLabel = dataEventPropsLabel = `${tierContent}-start-trial-compare-features`;
                                    // tech-debt: get cta text and urls from contentful
                                    // ticket: https://hello.jira.atlassian.cloud/browse/PRICING-1542
                                    switch(tierContent){
                                        case (0, $hrGO1.SpecialPlanNames).FREE:
                                            edition = (0, $hrGO1.Edition).FREE;
                                            ctaBtnText = getItNowText;
                                            ctaBtnUrl = localizedSignupURL + "?bundle=jira-software&edition=free";
                                            dataEventPropsLabel = `${tierContent}-get-it-now-compare-features`;
                                            break;
                                        case (0, $hrGO1.SpecialPlanNames).STANDARD:
                                            edition = (0, $hrGO1.Edition).STANDARD;
                                            ctaBtnUrl = localizedSignupURL + "?bundle=jira-software&edition=standard";
                                            break;
                                        case (0, $hrGO1.SpecialPlanNames).PREMIUM:
                                            edition = (0, $hrGO1.Edition).PREMIUM;
                                            ctaBtnUrl = localizedSignupURL + "?bundle=jira-software&edition=premium";
                                            break;
                                        case (0, $hrGO1.SpecialPlanNames).ENTERPRISE:
                                            edition = (0, $hrGO1.Edition).ENTERPRISE;
                                            ctaBtnText = contactSalesText;
                                            ctaBtnUrl = localizedContactURL;
                                            dataEventPropsLabel = `${tierContent}-contact-sales-compare-features`;
                                            break;
                                    }
                                }
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$var$FeaturesTableHeadCell, {
                                    index: index,
                                    children: typeof tierContent === "string" ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        id: `${$84231b70db855011$var$featuresTableHeadIdPrefix}${index}`,
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1hlo _k48p1fw0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                },
                                                children: tierContent
                                            }),
                                            props.stickyCtasEnabled && props.dataProductKey && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6o9v8.StickyCTAContextProvider), {
                                                isSticky: undefined,
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4Rl8.CtaButton), {
                                                    edition: edition,
                                                    dataProductKey: props.dataProductKey,
                                                    type: "secondary",
                                                    text: ctaBtnText,
                                                    dataEventPropsLabel: dataEventPropsLabel,
                                                    url: ctaBtnUrl,
                                                    isDisabled: false,
                                                    containerId: (0, $hrGO1.COMPARE_FEATURES_CONTAINER)
                                                })
                                            })
                                        ]
                                    }) : tierContent ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_y3gn1e5h"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1hlo _k48p1fw0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                },
                                                children: tierContent.title
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_syaz1hlo _k48p1fw0"
                                                        ]),
                                                        style: {
                                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                        },
                                                        children: tierContent.price
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                        className: (0, $2jatx.default)([
                                                            "_syaznqye _ahbqi2wt"
                                                        ]),
                                                        style: {
                                                            "--_1a8xanm": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light600"))
                                                        },
                                                        children: "per user"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                                size: "small",
                                                variant: "secondary",
                                                color: "black",
                                                colorAgainst: "other",
                                                href: "https://www.atlassian.com/enterprise/contact?formType=product-features",
                                                className: (0, $2jatx.default)([
                                                    "_1pfhw1gv"
                                                ]),
                                                children: tierContent.button
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: "Invalid Data"
                                    })
                                }, index);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                    children: props.children
                })
            ]
        })
    });
};
const $84231b70db855011$var$FeaturesTableHeadCell = (_param)=>{
    var { advance: advance } = _param, props = (0, $aPnCa._)(_param, [
        "advance"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("th", (0, $dPABA._)((0, $6ogO3._)({
        scope: "col"
    }, props), {
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        }
    }));
};
const $84231b70db855011$var$lozengeContainerCss = null;
const $84231b70db855011$export$4a48add4d33bb5cb = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        className: (0, $2jatx.default)([
            "_syaz1hlo _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1rga _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41q9y _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw",
                    "_y3gnv2br"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_syaz1hlo _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: props.headerTitle
                })
            }),
            props.tierCellsContent.map((content, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                    className: (0, $2jatx.default)([
                        "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                        "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                    },
                    children: content
                }, index))
        ]
    });
};
const $84231b70db855011$export$8d6c1dc4bc4e86f2 = (props)=>{
    let lozenge = null;
    const { text: text, expanderContent: expanderContent, href: href } = props.featureCellContent;
    if (props.lozengeText) lozenge = /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_ahbq1y44"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
            children: props.lozengeText
        })
    });
    const rowDescId = `rowDesc_${props.id}`;
    let featureCellContent;
    if (href) featureCellContent = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                id: rowDescId,
                text: text,
                href: href,
                type: "primary",
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _ahbq1y44"
                ])
            }),
            lozenge
        ]
    });
    else {
        const children = expanderContent ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: expanderContent
            },
            className: (0, $2jatx.default)([
                "_1wybdlk8 _syazr2ho _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            }
        }) : undefined;
        featureCellContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6tSTn.ExpandableContent), {
            eventDataName: text,
            label: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                id: rowDescId,
                children: [
                    text,
                    lozenge
                ]
            }),
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        className: (0, $2jatx.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkcd5j _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41q9y _y3gn1h6o _1ckvidpf _irr31rga _1o4gu1j4 _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw",
                    "_y3gnv2br _16nmgktf _1w6hgktf _gtp7150w _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1reo15vq"
                    ]),
                    children: featureCellContent
                })
            }),
            props.tierCellsContent.map((content, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$17906fe86bec07d9, {
                    index: index,
                    cellContent: content,
                    rowDescId: rowDescId
                }, index))
        ]
    });
};
const $84231b70db855011$export$17906fe86bec07d9 = ({ cellContent: cellContent, index: index, rowDescId: rowDescId })=>{
    const { planTiers: planTiers } = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext($84231b70db855011$var$FeaturesTableContext);
    const tierContent = planTiers[index];
    const cellContentStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("td", {
        className: (0, $2jatx.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _s7n41q9y _t51zyzqy _10msglyw",
            "_s7n4jp4b"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_suga1txw _1e0cglyw"
                ]),
                children: typeof tierContent === "string" ? tierContent : tierContent && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: tierContent.title
                })
            }),
            cellContent && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulpu2gc"
                ]),
                children: [
                    cellContent.checkmark && /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$4f481e0a96cfbed6, {
                        containerProps: {
                            "aria-labelledby": `${$84231b70db855011$var$featuresTableHeadIdPrefix}${index} ${rowDescId}`,
                            "tabIndex": 0,
                            "style": {
                                marginBlockStart: "-6px"
                            }
                        }
                    }),
                    cellContent.textContent && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: cellContent.textContent
                        },
                        className: (0, $2jatx.default)([
                            "_y3gnv2br _1wybdlk8 _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                        ])
                    })
                ]
            })
        ]
    });
};
const $84231b70db855011$export$4f481e0a96cfbed6 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, props.containerProps), {
        className: (0, $2jatx.default)([
            "_1a1x1ssb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            "data-testid": "checkmark",
            className: (0, $2jatx.default)([
                "_bfhkl30o _2rko1ssb _syazcd5j _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _19pk1y44 _2hwx1y44 _otyr1y44 _18u01y44 _y3gn1h6o _4t3i1tcg _1bsb1tcg"
            ]),
            style: {
                "--_1x006p6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime700")),
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Icon), {
                name: "featurecheckmark",
                size: "xs",
                color: (0, $kbpa7.wacToken)("color.neutral.light0")
            })
        })
    }));
};
const $84231b70db855011$export$49da9cb6ddf668ee = ({ title: title, comparePlans: comparePlans, compareFeatures: compareFeatures, linkValues: linkValues, dataProductKey: dataProductKey, stickyCtasEnabled: stickyCtasEnabled })=>{
    const intl = (0, $8e22h.default)();
    if (!comparePlans || !compareFeatures) return null;
    var _comparePlans_map;
    // maintain a list to keep track of the plans in the contentful order
    const orderedPlanTiers = (_comparePlans_map = comparePlans === null || comparePlans === void 0 ? void 0 : comparePlans.map((plan)=>{
        var _plan_planTitleExternal;
        return (_plan_planTitleExternal = plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : "";
    })) !== null && _comparePlans_map !== void 0 ? _comparePlans_map : [];
    const fallbackTitle = intl.formatMessage({
        id: "PricingFeatureTable.fallbackTitle",
        defaultMessage: "Compare Features"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)($84231b70db855011$export$5a7d94d7c691844a, {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)($84231b70db855011$export$de898cfe2ca10ff8, {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$f052fee91dc6777a, {
                        children: title !== null && title !== void 0 ? title : fallbackTitle
                    }),
                    (linkValues === null || linkValues === void 0 ? void 0 : linkValues.linkHref) && (linkValues === null || linkValues === void 0 ? void 0 : linkValues.linkText) ? /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$a433b7aa5ad7fd61, (0, $6ogO3._)({}, linkValues)) : null
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$e2b8eb038115bae6, {
                captionText: "",
                planTiers: orderedPlanTiers,
                dataProductKey: dataProductKey,
                stickyCtasEnabled: stickyCtasEnabled,
                children: compareFeatures === null || compareFeatures === void 0 ? void 0 : compareFeatures.map((featureGroup, index)=>{
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$4612d2a76503b8a4, {
                        featureGroup: featureGroup,
                        orderedPlanTiers: orderedPlanTiers,
                        groupIndex: index
                    }, featureGroup.featureGroupTitleExternal);
                })
            })
        ]
    });
};
const $84231b70db855011$export$4612d2a76503b8a4 = ({ featureGroup: featureGroup, orderedPlanTiers: orderedPlanTiers, groupIndex: groupIndex })=>{
    const { featureGroupTitleExternal: featureGroupTitleExternal, features: features } = featureGroup;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$4a48add4d33bb5cb, {
                headerTitle: featureGroupTitleExternal !== null && featureGroupTitleExternal !== void 0 ? featureGroupTitleExternal : "",
                tierCellsContent: Array(Object.keys(orderedPlanTiers).length).fill("")
            }),
            features === null || features === void 0 ? void 0 : features.map((feature, index)=>{
                const { featureNameExternal: featureNameExternal, description: description, relevantUrl: relevantUrl, callOut: callOut, featureAdditionalInformation: featureAdditionalInformation, relevantPlan: relevantPlan } = feature;
                // Initialize an object to store feature cell information for each plan.
                // The keys will be the plan names, and the values will be initially set to exmpty objects.
                const featureCellInfo = orderedPlanTiers.reduce((obj, plan)=>{
                    obj[plan] = {};
                    return obj;
                }, {});
                if (featureAdditionalInformation) // Iterate over each addtional information and update the appropiriate featureCellInfo with corresponding messages
                featureAdditionalInformation === null || featureAdditionalInformation === void 0 ? void 0 : featureAdditionalInformation.forEach((info)=>{
                    const { featureAdditionalInformation: message, relevantPlan: featureRelevantPlans } = info;
                    featureRelevantPlans === null || featureRelevantPlans === void 0 ? void 0 : featureRelevantPlans.forEach((plan)=>{
                        const planTitleExternal = plan.planTitleExternal;
                        if (featureCellInfo[planTitleExternal]) featureCellInfo[planTitleExternal].textContent = message !== null && message !== void 0 ? message : "";
                    });
                });
                // hanlding boolean values
                if (relevantPlan) relevantPlan === null || relevantPlan === void 0 ? void 0 : relevantPlan.forEach((plan)=>{
                    // Mark this plan as true in featureCellInfo
                    const planTitleExternal = plan.planTitleExternal;
                    if (featureCellInfo[planTitleExternal]) featureCellInfo[planTitleExternal].checkmark = true;
                });
                // Generate the ordered values for tierCellsContent
                const orderedValues = orderedPlanTiers.map((key)=>featureCellInfo[key]).filter((value)=>value !== undefined);
                return /*#__PURE__*/ (0, $7VQPk.jsx)($84231b70db855011$export$8d6c1dc4bc4e86f2, {
                    featureCellContent: {
                        text: featureNameExternal !== null && featureNameExternal !== void 0 ? featureNameExternal : "",
                        expanderContent: description !== null && description !== void 0 ? description : null,
                        href: relevantUrl !== null && relevantUrl !== void 0 ? relevantUrl : null
                    },
                    lozengeText: callOut,
                    tierCellsContent: orderedValues,
                    id: `${groupIndex}_${index}`
                }, featureNameExternal);
            })
        ]
    });
};

});
parcelRegister("9K6CO", function(module, exports) {
$parcel$export(module.exports, "ExpandableContent", function () { return (parcelRequire("6tSTn")).ExpandableContent; });
parcelRequire("eapmz");

});
parcelRegister("eapmz", function(module, exports) {
$parcel$export(module.exports, "ExpandableContent", function () { return (parcelRequire("6tSTn")).ExpandableContent; });
parcelRequire("6tSTn");

});
parcelRegister("6tSTn", function(module, exports) {
$parcel$export(module.exports, "ExpandableContent", function () { return $71a3008b09c61d64$export$9ffd278d9b1d2f4b; });
/* expandable-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $9BG80 = parcelRequire("9BG80");

var $kbpa7 = parcelRequire("kbpa7");
const $71a3008b09c61d64$var$buttonCss = null;
const $71a3008b09c61d64$var$labelContentsCss = null;
const $71a3008b09c61d64$var$buttonContentCss = null;
const $71a3008b09c61d64$export$9ffd278d9b1d2f4b = (props)=>{
    const [expanded, setExpanded] = (0, $1oC0p.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    // contentRef controls the content element height upon expansion change
    const contentRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (!contentRef.current) return;
        if (expanded) contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
        else contentRef.current.style.maxHeight = "0";
    }, [
        expanded
    ]);
    const handleButtonClick = ()=>{
        if (props.eventDataName) {
            const data = {
                name: props.eventDataName,
                direction: expanded ? "close" : "open"
            };
            createAnalyticsEvent({
                eventName: "expandableContentClicked",
                eventType: "ui",
                eventComponent: "button",
                event: "clicked",
                actionSubject: "expandableContent",
                action: "clicked",
                attributes: data,
                data: data
            }).fire();
        }
        setExpanded((prev)=>!prev);
    };
    const labelContents = /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _1e0c1txw _zulp1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_4t3i1tcg _1bsb1tcg _t9ec1pp8 _v564f4ca"
                ]),
                style: {
                    "--_1drzqs5": (0, $6ZVlx.default)(expanded ? "rotate(90deg)" : "rotate(0deg)")
                },
                children: props.children && /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                    label: "",
                    spacing: "spacious"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                style: props.labelCss,
                className: (0, $2jatx.default)([
                    "_85i5yh40 _1bsb1osq"
                ]),
                children: expanded && props.expandedLabelText ? props.expandedLabelText : props.label
            })
        ]
    });
    const expandedStyles = null;
    const collapsedStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            props.children ? /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                "aria-expanded": expanded,
                onClick: handleButtonClick,
                className: (0, $2jatx.default)([
                    "_kkk218uv _mizuoelr _ra3x1wug _128mt94y",
                    "_ect41bgz _1wyboxwj _vwz44jg8 _syazr2ho _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
                ]),
                style: {
                    cursor: "pointer",
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: labelContents
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect41bgz _1wyboxwj _vwz44jg8 _syazr2ho _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: labelContents
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentRef,
                "aria-hidden": !expanded,
                role: expanded ? "region" : undefined,
                className: (0, $2jatx.default)([
                    "_1e0ctcjq _1reo15vq _18m915vq _v56413gs _bozg1f4h"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        expanded && "_1e0c1ule",
                        !expanded && "_1e0cglyw"
                    ]),
                    children: props.children
                })
            })
        ]
    });
};

});



parcelRegister("i0PNA", function(module, exports) {
$parcel$export(module.exports, "PriceCard", function () { return (parcelRequire("f1eZF")).PriceCard; });
$parcel$export(module.exports, "CtaButton", function () { return (parcelRequire("l4Rl8")).CtaButton; });
parcelRequire("f1eZF");
parcelRequire("l4Rl8");

});
parcelRegister("f1eZF", function(module, exports) {
$parcel$export(module.exports, "PriceCard", function () { return $9cd0991b9ed771f1$export$24997073811e6afa; });
/* price-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $20Gca = parcelRequire("20Gca");
parcelRequire("5579Q");
var $j75fB = parcelRequire("j75fB");
var $f7LGP = parcelRequire("f7LGP");
var $k6638 = parcelRequire("k6638");
var $jgk8M = parcelRequire("jgk8M");
var $6RfM0 = parcelRequire("6RfM0");
var $6oL3t = parcelRequire("6oL3t");

var $hrGO1 = parcelRequire("hrGO1");

var $jcRJT = parcelRequire("jcRJT");

var $eYlij = parcelRequire("eYlij");

var $kbpa7 = parcelRequire("kbpa7");

var $9Rl14 = parcelRequire("9Rl14");

var $6o9v8 = parcelRequire("6o9v8");
const $9cd0991b9ed771f1$var$planFeatureMessageContainerStyles = null;
const $9cd0991b9ed771f1$var$planFeatureMessagesStyles = null;
// @ts-ignore
const $9cd0991b9ed771f1$var$stickyCtaContainerStyles = null;
const $9cd0991b9ed771f1$export$24997073811e6afa = (props)=>{
    var _props_planFeatureMessages;
    const { enableRecommendation: enableRecommendation = true } = props;
    const { recommendationElement: recommendationElement } = (0, $eYlij.usePriceFinderContext)();
    let highlightedFeaturesTitle = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "Pricing.PriceCard.featureMessageTitleFree",
        defaultMessage: "Includes:"
    });
    if (props.adjacentLowerTierPlanName) highlightedFeaturesTitle = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "Pricing.PriceCard.featureMessageTitle",
        defaultMessage: "Everything from {featureMessagePlanName}, plus:",
        values: {
            featureMessagePlanName: props.adjacentLowerTierPlanName
        }
    });
    const planTitleId = `planTitle_${props.priceCalcIdx}`;
    const defaultRecommendationElement = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "Pricing.PriceCard.recommended",
        defaultMessage: "Recommended"
    });
    /* eslint-disable jsx-a11y/no-redundant-roles */ /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6RfM0.PriceCard), (0, $dPABA._)((0, $6ogO3._)({}, (0, $6RfM0.getPriceCardProps)(props)), {
        outlined: props.highlighted,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6oL3t.PriceCardSection), {
                children: [
                    enableRecommendation && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j75fB.Banner), {
                        shown: props.highlighted,
                        children: recommendationElement ? recommendationElement : defaultRecommendationElement
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f7LGP.ContentStack), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                                        id: planTitleId,
                                        variant: "lg",
                                        as: "h2",
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($9cd0991b9ed771f1$var$PriceCardTitle, {
                                            planName: props.planName,
                                            planTitleComponent: props.planTitleComponent
                                        })
                                    }),
                                    props.description && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                                        variant: "md",
                                        id: `pricing-plan-description-${props.planName}`,
                                        children: props.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh1wug _1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_4t3i88uy"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Rl14.Price), (0, $6ogO3._)({}, props))
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            props.billingCycle === "ANNUAL" && !(props.offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo && props.billingCycle === "ANNUAL" && props.unitCount > 1000) && "_1pfh1tcg"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6o9v8.StickyCTAContextProvider), {
                                            isSticky: false,
                                            children: props.ctaButton
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!((_props_planFeatureMessages = props.planFeatureMessages) === null || _props_planFeatureMessages === void 0 ? void 0 : _props_planFeatureMessages.length) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6oL3t.PriceCardSection), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgk8M.ExpanderStack), {
                    heading: highlightedFeaturesTitle,
                    lozenge: props.dataProductKey === "loom" && props.planName === "Business + AI" && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1pfhmyb0 _x10q1wr3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                            style: {
                                color: (0, $kbpa7.wacToken)("color.neutral.light0")
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "Pricing.PriceCard.LoomAiLozenge",
                                defaultMessage: "Powered by Loom AI",
                                description: "Loom AI should not be translated"
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        role: "list",
                        className: (0, $2jatx.default)([
                            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfhidpf _2mzuglyw"
                        ]),
                        children: props.planFeatureMessages.map((planFeatureMessage, idx)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_1pfh7vkz _1d6jidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jcRJT.PlanFeature), (0, $dPABA._)((0, $6ogO3._)({}, planFeatureMessage), {
                                    padded: false
                                }))
                            }, idx);
                        })
                    })
                })
            })
        ]
    }));
};
const $9cd0991b9ed771f1$var$PriceCardTitle = (props)=>{
    const { planName: planName, planTitleComponent: PlanTitle } = props;
    return PlanTitle ? /*#__PURE__*/ (0, $7VQPk.jsx)(PlanTitle, {
        planName: planName
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        id: `pricing-plan-title-${planName}`,
        children: planName
    });
};

});
parcelRegister("5579Q", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return (parcelRequire("j75fB")).Banner; });
$parcel$export(module.exports, "ContentStack", function () { return (parcelRequire("f7LGP")).ContentStack; });
$parcel$export(module.exports, "ContentText", function () { return (parcelRequire("k6638")).ContentText; });
$parcel$export(module.exports, "ExpanderStack", function () { return (parcelRequire("jgk8M")).ExpanderStack; });
$parcel$export(module.exports, "getPriceCardProps", function () { return (parcelRequire("6RfM0")).getPriceCardProps; });
$parcel$export(module.exports, "PriceCard", function () { return (parcelRequire("6RfM0")).PriceCard; });
$parcel$export(module.exports, "PriceCardSection", function () { return (parcelRequire("6oL3t")).PriceCardSection; });
$parcel$export(module.exports, "PriceCardsStack", function () { return (parcelRequire("luVdE")).PriceCardsStack; });
$parcel$export(module.exports, "Button", function () { return (parcelRequire("5qUgh")).Adg4Button; });
parcelRequire("eapmz");
var $6tSTn = parcelRequire("6tSTn");

var $5qUgh = parcelRequire("5qUgh");
parcelRequire("j75fB");
parcelRequire("4HVo5");
parcelRequire("f7LGP");
parcelRequire("k6638");
parcelRequire("jgk8M");
parcelRequire("6RfM0");
parcelRequire("6oL3t");
parcelRequire("luVdE");

});
parcelRegister("j75fB", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return $29230037a2fbb88e$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $29230037a2fbb88e$export$3b4e64e77073e307 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq",
            props.shown && "_11q71hlo _2rko1kw7"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: props.shown && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_syazcd5j _1wyb1crf _ect48q0o _k48pni7l _1p1dangw _vwz4f6fq _1dyzt94y _slp31hna _y3gn1h6o"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: props.children
        })
    });
};
const $29230037a2fbb88e$var$bannerCss = null;
const $29230037a2fbb88e$var$bannerContent = null;

});

parcelRegister("4HVo5", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_SECTIONS_COUNT", function () { return $0d9e6c5b89c5e20f$export$366b07c70d10dc4d; });
const $0d9e6c5b89c5e20f$export$366b07c70d10dc4d = 2;

});

parcelRegister("f7LGP", function(module, exports) {
$parcel$export(module.exports, "ContentStack", function () { return $3df91ce6dd04ff8b$export$346989ded957d179; });
/* content-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $3df91ce6dd04ff8b$export$346989ded957d179 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1tcg _4t3i1osq _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg"
        ]),
        children: props.children
    });
};
const $3df91ce6dd04ff8b$var$contentStackCss = null;

});

parcelRegister("k6638", function(module, exports) {
$parcel$export(module.exports, "ContentText", function () { return $f542c6588c759f80$export$646b80a994b34028; });
/* content-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $f542c6588c759f80$export$646b80a994b34028 = (props)=>{
    const { as: Component = "span", variant: variant = "md" } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)(Component, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_ect48q0o _syazqlpt _y3gn1h6o _1e0c1ule _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            variant === "xl" && "_1wyb1ylp _vwz4ckbl _k48p1fw0",
            variant === "lg" && "_1wyb1tcg _vwz41ul9 _k48p1fw0",
            variant === "md" && "_1wybdlk8 _vwz4gktf"
        ]),
        children: props.children
    }));
};
const $f542c6588c759f80$var$xlCss = null;
const $f542c6588c759f80$var$lgCss = null;
const $f542c6588c759f80$var$mdCss = null;
const $f542c6588c759f80$var$contentTextCss = null;

});

parcelRegister("jgk8M", function(module, exports) {
$parcel$export(module.exports, "ExpanderStack", function () { return $d03c0397d251a4ea$export$b2da8816cb6c8b9e; });
/* expander-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $d03c0397d251a4ea$var$expanderStackCss = null;
const $d03c0397d251a4ea$var$expanderStackHeadingCss = null;
const $d03c0397d251a4ea$export$b2da8816cb6c8b9e = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _1bsb1osq"
        ]),
        children: [
            props.lozenge,
            props.heading && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48pni7l _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: props.heading
            }),
            props.children
        ]
    });
};

});

parcelRegister("6RfM0", function(module, exports) {
$parcel$export(module.exports, "PriceCard", function () { return $733cb585185a6f15$export$24997073811e6afa; });
$parcel$export(module.exports, "getPriceCardProps", function () { return $733cb585185a6f15$export$3a1eade60b680c85; });
/* price-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $luVdE = parcelRequire("luVdE");
const $733cb585185a6f15$export$24997073811e6afa = (props)=>{
    const { isInsideCardStack: isInsideCardStack } = (0, $luVdE.useIsInsideCardStack)();
    const validChildren = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).isValidElement(child)) validChildren.push(child);
    });
    const children = validChildren.map((child, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(child, {
            key: index,
            first: index === 0,
            last: index === (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.count(validChildren) - 1,
            firstCard: props.first,
            lastCard: props.last,
            outlined: props.outlined
        });
    });
    if (isInsideCardStack) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1s4p1osq"
        ]),
        children: children
    });
};
const $733cb585185a6f15$var$priceCardCss = null;
const $733cb585185a6f15$export$3a1eade60b680c85 = ({ first: first, last: last, outlined: outlined })=>({
        first: first,
        last: last,
        outlined: outlined
    });

});
parcelRegister("luVdE", function(module, exports) {
$parcel$export(module.exports, "PriceCardsStack", function () { return $60c6fc47d6443243$export$4379d187fb91b2c6; });
$parcel$export(module.exports, "useIsInsideCardStack", function () { return $60c6fc47d6443243$export$41df4605c6d99494; });
/* price-cards-stack.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $4HVo5 = parcelRequire("4HVo5");
const $60c6fc47d6443243$export$4379d187fb91b2c6 = (props)=>{
    const { sections: sectionsCount = (0, $4HVo5.DEFAULT_SECTIONS_COUNT) } = props;
    const cardsCount = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.count(props.children);
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.map(props.children, (child, index)=>{
        const childElement = child;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(childElement, {
            first: index === 0,
            last: index === cardsCount - 1
        });
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)($60c6fc47d6443243$var$PriceCardStackContext.Provider, {
        value: {
            isInsideCardStack: true
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _wij21bp4 _1bsb1ns9 _glte1ns9 _1mjb1txw _na0i1bp4 _1s4p1osq",
                "_2z051xin _yv0e1iwh"
            ]),
            style: {
                "--_1u0qyx2": (0, $6ZVlx.default)(sectionsCount),
                "--_uofz2v": (0, $6ZVlx.default)(cardsCount)
            },
            children: children
        })
    });
};
const $60c6fc47d6443243$var$priceCardsStackCss = null;
const $60c6fc47d6443243$var$PriceCardStackContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    isInsideCardStack: false
});
const $60c6fc47d6443243$export$41df4605c6d99494 = ()=>{
    return (0, $1oC0p.useContext)($60c6fc47d6443243$var$PriceCardStackContext);
};

});


parcelRegister("6oL3t", function(module, exports) {
$parcel$export(module.exports, "PriceCardSection", function () { return $d647f0efe2b4519d$export$bead6418a4510dba; });
/* price-card-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $luVdE = parcelRequire("luVdE");
const $d647f0efe2b4519d$export$bead6418a4510dba = (props)=>{
    const { first: first, last: last, firstCard: firstCard, lastCard: lastCard, outlined: outlined, children: children } = props, divProps = (0, $aPnCa._)(props, [
        "first",
        "last",
        "firstCard",
        "lastCard",
        "outlined",
        "children"
    ]);
    const { isInsideCardStack: isInsideCardStack } = (0, $luVdE.useIsInsideCardStack)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, divProps), {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1h6o _glte1osq _11q7cd5j",
            "_mqm2u1j4 _191wu1j4 _16qsglyw",
            !isInsideCardStack && first && "_1s1ggktf _5fbcgktf",
            !isInsideCardStack && "_t51zu1j4",
            !isInsideCardStack && last && "_179ru1j4 _1yxngktf _1eingktf",
            !isInsideCardStack && outlined && "_191wn4na _t51zn4na",
            !isInsideCardStack && outlined && first && "_mqm2n4na",
            !isInsideCardStack && outlined && last && "_179rn4na _1yxngktf _1eingktf",
            isInsideCardStack && "_1tk6u1j4",
            isInsideCardStack && first && "_1e0kgktf _tg79gktf",
            isInsideCardStack && last && "_179ru1j4 _1egl1tcg _6q09idpf",
            isInsideCardStack && lastCard && "_p5clu1j4",
            isInsideCardStack && firstCard && first && "_1orwgktf",
            isInsideCardStack && lastCard && first && "_yo7bgktf",
            isInsideCardStack && lastCard && last && "_1f8wgktf",
            isInsideCardStack && firstCard && last && "_3ynegktf",
            isInsideCardStack && outlined && first && "_mqm2n4na",
            isInsideCardStack && outlined && "_xvbnn4na _1tk6n4na _1w6en4na _p5cln4na",
            isInsideCardStack && outlined && last && "_179rn4na"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: children
    }));
};
const $d647f0efe2b4519d$var$priceCardSectionCss = null;

});


parcelRegister("jcRJT", function(module, exports) {
$parcel$export(module.exports, "PlanFeature", function () { return $4dfd82fed4675488$export$eba92f5ed965ecf9; });
/* price-card-plan-feature.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $20Gca = parcelRequire("20Gca");
parcelRequire("9K6CO");
var $6tSTn = parcelRequire("6tSTn");
const $4dfd82fed4675488$var$planFeatureMessageContainerCss = null;
const $4dfd82fed4675488$var$contentContainerCss = null;
const $4dfd82fed4675488$var$lozengeContainerCss = null;
const $4dfd82fed4675488$var$featureContentContainerCss = null;
const $4dfd82fed4675488$export$eba92f5ed965ecf9 = ({ featureMessage: featureMessage, lozengeText: lozengeText, padded: padded = true })=>{
    const featureMessageHasContent = !(typeof featureMessage === "string");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _szfsglyw _stfgglyw _d32voelr _4rtxtlke _1sg88q0o _1o7poxwj _1q9t1nn1 _11lv1y44 _ficf1e5h _4pkpu7gi",
            padded && "_1q517vkz _bozg19bv"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_syaz1mpp _1bsb1osq"
            ]),
            children: featureMessageHasContent ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6tSTn.ExpandableContent), {
                eventDataName: featureMessage.text,
                label: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    children: [
                        featureMessage.text,
                        lozengeText && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_ahbq1y44"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                children: lozengeText
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wyboxwj _syazqlpt _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                    ]),
                    children: featureMessage.content("100%")
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6tSTn.ExpandableContent), {
                eventDataName: featureMessage,
                label: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    children: [
                        featureMessage,
                        lozengeText && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_ahbq1y44"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                children: lozengeText
                            })
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("eYlij", function(module, exports) {
$parcel$export(module.exports, "usePriceFinderContext", function () { return $d1b3d524711863c2$export$179afbf02f71f9f; });
$parcel$export(module.exports, "PriceFinderContextProvider", function () { return $d1b3d524711863c2$export$520d8e05995e73b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $d1b3d524711863c2$var$PriceFinderContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $d1b3d524711863c2$export$179afbf02f71f9f = ()=>{
    const context = (0, $1oC0p.useContext)($d1b3d524711863c2$var$PriceFinderContext);
    if (!context) throw new Error("usePriceFinderContext must be used within a PriceFinderContextProvider");
    return context;
};
const $d1b3d524711863c2$export$520d8e05995e73b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d1b3d524711863c2$var$PriceFinderContext.Provider, {
        value: props,
        children: props.children
    });
};

});

parcelRegister("9Rl14", function(module, exports) {
$parcel$export(module.exports, "Price", function () { return $c39a07724f817c70$export$3f58fdce283c1f4c; });
/* price.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ /* Will be refactored once we have redesign goes live */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
parcelRequire("5579Q");
var $k6638 = parcelRequire("k6638");

var $hrGO1 = parcelRequire("hrGO1");

var $kooLp = parcelRequire("kooLp");

var $eYlij = parcelRequire("eYlij");

var $3F38X = parcelRequire("3F38X");

var $kOGAE = parcelRequire("kOGAE");

var $cdVVX = parcelRequire("cdVVX");
const $c39a07724f817c70$var$fontCharlieDisplay = '"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';
const $c39a07724f817c70$var$priceSpanStyles = null;
const $c39a07724f817c70$export$3f58fdce283c1f4c = (props)=>{
    var _messages_cardOverSignupLimit;
    const { billingCycle: billingCycle, overSignupLimit: overSignupLimit, planName: planName, currencyISOCode: currencyISOCode, unitCount: unitCount, productKey: productKey, priceCalcIdx: priceCalcIdx, contactURL: contactURL, offeringSku: offeringSku, shouldAddDiscount: shouldAddDiscount } = props;
    const [{ priceCalcs: priceCalcs, messages: messages }, actions] = (0, $3F38X.usePriceFinderStore)();
    const { enterpriseMinimumCount: enterpriseMinimumCount = (0, $hrGO1.DefaultPlanLimits).UNIT_MIN_ENTERPRISE } = (0, $eYlij.usePriceFinderContext)();
    const priceCalc = priceCalcs[priceCalcIdx];
    if (!priceCalc) throw new Error(`Price calculation was not found for index ${priceCalcIdx}`);
    let planMessage = billingCycle === "MONTHLY" ? /*#__PURE__*/ (0, $7VQPk.jsx)($c39a07724f817c70$var$MonthlyPrice, {
        formattedPrice: priceCalc.formattedAvgPerUnitPrice,
        formattedAvgPerUnitPriceWithDiscount: priceCalc.formattedAvgPerUnitPriceWithDiscount,
        planName: planName,
        shouldAddDiscount: shouldAddDiscount
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($c39a07724f817c70$export$8e077f62bcf5008c, {
        formattedPrice: priceCalc.formattedTotalPrice,
        formattedTotalPriceWithDiscount: priceCalc.formattedTotalPriceWithDiscount,
        planName: planName,
        priceCalc: priceCalc,
        priceDisplaySize: currencyISOCode === "JPY" ? "small" : "normal",
        shouldAddDiscount: shouldAddDiscount
    });
    var _messages_cardOverSignupLimit_defaultMessage;
    if (overSignupLimit && productKey === (0, $hrGO1.SpecialProductKeys).BITBUCKET) planMessage = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $k6638.ContentText), {
        variant: "md",
        "data-testid": "bitbucket-signup-limit",
        children: [
            "For teams of more than 35,000,",
            " ",
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: contactURL,
                children: "contact our sales team."
            })
        ]
    });
    else if (overSignupLimit) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "md",
        "data-testid": "signup-limit",
        children: (_messages_cardOverSignupLimit_defaultMessage = messages === null || messages === void 0 ? void 0 : (_messages_cardOverSignupLimit = messages.cardOverSignupLimit) === null || _messages_cardOverSignupLimit === void 0 ? void 0 : _messages_cardOverSignupLimit.defaultMessage) !== null && _messages_cardOverSignupLimit_defaultMessage !== void 0 ? _messages_cardOverSignupLimit_defaultMessage : ""
    });
    if (offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo && unitCount > 1000) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "md",
        "data-testid": "rovo-annual-message",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "Pricing.card.body.rovo.annual.message",
            defaultMessage: "Start your free 30-day trial or contact your Atlassian sales representative for more information."
        })
    });
    switch(planName){
        case (0, $hrGO1.SpecialPlanNames).STARTER:
        case (0, $hrGO1.SpecialPlanNames).FREE:
            planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)($c39a07724f817c70$var$FreePrice, {
                formattedPrice: priceCalc.formattedTotalPrice,
                planName: planName
            });
            break;
        case (0, $hrGO1.SpecialPlanNames).ENTERPRISE:
            if (messages.cardEnterpriseBodyOverride) planMessage = messages.cardEnterpriseBodyOverride;
            else if (billingCycle === "MONTHLY") planMessage = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-monthly",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kOGAE.BilledAnnuallyButton), {
                        onClick: ()=>actions.updateBillingCycle("ANNUAL")
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "PricingTeam24.card.body.enterprise.monthly",
                        defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
                    })
                ]
            });
            else if (currencyISOCode === "JPY") planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-jpy",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Pricing.card.body.enterprise.jpy",
                    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
                })
            });
            else if (overSignupLimit) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-signup-limit",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Pricing.card.body.enterprise.overSignupLimit",
                    defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
                })
            });
            else if (unitCount < enterpriseMinimumCount) planMessage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                "data-testid": "enterprise-min-limit",
                children: messages.cardEnterpriseMinimumCount && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: messages.cardEnterpriseMinimumCount.id,
                    defaultMessage: messages.cardEnterpriseMinimumCount.defaultMessage,
                    values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                        enterpriseMinimumCount: enterpriseMinimumCount
                    })
                })
            });
            break;
    }
    return planMessage;
};
const $c39a07724f817c70$var$FREE_PRICE_TEST_ID = "free-price";
const $c39a07724f817c70$var$FreePrice = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "xl",
        "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
        "data-testid": $c39a07724f817c70$var$FREE_PRICE_TEST_ID,
        children: props.formattedPrice
    });
};
const $c39a07724f817c70$var$MONTHLY_PRICE_TEST_ID = "monthly-price";
const $c39a07724f817c70$var$MonthlyPrice = (props)=>{
    const [{ messages: messages }] = (0, $3F38X.usePriceFinderStore)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "xl",
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                "data-testid": $c39a07724f817c70$var$MONTHLY_PRICE_TEST_ID,
                children: props.formattedAvgPerUnitPriceWithDiscount
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "xl",
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                "data-testid": $c39a07724f817c70$var$MONTHLY_PRICE_TEST_ID,
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "md",
                children: (messages === null || messages === void 0 ? void 0 : messages.cardMonthlyPerUnitCount) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: messages.cardMonthlyPerUnitCount.id,
                    defaultMessage: messages.cardMonthlyPerUnitCount.defaultMessage
                })
            })
        ]
    });
};
const $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID = "annual-price";
const $c39a07724f817c70$export$1db406331b1cb6e4 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === "small" ? "35px" : undefined
                },
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedTotalPriceWithDiscount
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wybckbl _k48pbfng _ect41lim _kqswh2mm"
                ]),
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                className: (0, $2jatx.default)([
                    "_1pfh1h22"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "Pricing.PriceCard.Annual.Description",
                    defaultMessage: "per year"
                })
            }),
            props.formattedUnitTierNode
        ]
    });
};
const $c39a07724f817c70$export$8e077f62bcf5008c = (props)=>{
    const [{ unitCount: unitCount }] = (0, $3F38X.usePriceFinderStore)();
    const { annualUserTierDisplayThreshold: annualUserTierDisplayThreshold } = (0, $eYlij.usePriceFinderContext)();
    const shouldDisplayPriceTier = annualUserTierDisplayThreshold === undefined || unitCount >= annualUserTierDisplayThreshold;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            props.shouldAddDiscount ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === "small" ? "35px" : undefined
                },
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedTotalPriceWithDiscount
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                variant: "xl",
                style: {
                    fontSize: props.priceDisplaySize === "small" ? "35px" : undefined
                },
                "data-cy": `plan-card-price-${props.planName.toLowerCase()}`,
                children: props.formattedPrice
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $k6638.ContentText), {
                "data-testid": $c39a07724f817c70$var$ANNUAL_PRICE_TEST_ID,
                variant: "md",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "Pricing.PriceCard.Annual.Description",
                        defaultMessage: "per year"
                    }),
                    shouldDisplayPriceTier && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cdVVX.UserTier), {
                        priceCalc: props.priceCalc
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("3F38X", function(module, exports) {
$parcel$export(module.exports, "PriceFinderContainer", function () { return $ca9b5fbc269af845$export$d217816b05791954; });
$parcel$export(module.exports, "usePriceFinderStore", function () { return $ca9b5fbc269af845$export$f4b6caeda40bfc57; });

var $6ogO3 = parcelRequire("6ogO3");

var $6FQb9 = parcelRequire("6FQb9");
var $cVxfO = parcelRequire("cVxfO");
var $dv8pz = parcelRequire("dv8pz");

var $g2S82 = parcelRequire("g2S82");
const $ca9b5fbc269af845$export$d4c72bab9d6cc13a = {
    unitCount: 0,
    billingCycle: "MONTHLY",
    priceCalcs: [],
    currencyISOCode: "USD",
    messages: {
        // These messages always be overridden by the consumer on init
        unitCountInputText: {},
        unitCountInputTooltip: {},
        cardOverSignupLimit: {},
        cardEnterpriseMinimumCount: {},
        cardUnitCountTierRange: {},
        cardMonthlyPerUnitCount: {},
        cardFreeDescription: {}
    }
};
const $ca9b5fbc269af845$export$d217816b05791954 = (0, $6FQb9.createContainer)();
const $ca9b5fbc269af845$var$store = (0, $dv8pz.createStore)({
    containedBy: $ca9b5fbc269af845$export$d217816b05791954,
    name: "price-finder",
    initialState: $ca9b5fbc269af845$export$d4c72bab9d6cc13a,
    actions: $g2S82,
    handlers: {
        onInit: ()=>({ setState: setState }, state)=>{
                setState((0, $6ogO3._)({}, state));
            }
    }
});
const $ca9b5fbc269af845$export$f4b6caeda40bfc57 = (0, $cVxfO.createHook)($ca9b5fbc269af845$var$store);

});
parcelRegister("6FQb9", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $4dbf0c115974ff4b$export$26ae5ca175b4ec5a; });

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $djHSy = parcelRequire("djHSy");

var $19KTt = parcelRequire("19KTt");
var $iLhGt = parcelRequire("iLhGt");

var $iEBLg = parcelRequire("iEBLg");
const $4dbf0c115974ff4b$var$_excluded = [
    "children"
], $4dbf0c115974ff4b$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $4dbf0c115974ff4b$var$noop = ()=>()=>{};
function $4dbf0c115974ff4b$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $4dbf0c115974ff4b$var$noop, onUpdate: onUpdate = $4dbf0c115974ff4b$var$noop, onCleanup: onCleanup = $4dbf0c115974ff4b$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $4dbf0c115974ff4b$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $4dbf0c115974ff4b$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $4dbf0c115974ff4b$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $4dbf0c115974ff4b$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $4dbf0c115974ff4b$var$createFunctionContainer(StoreOrOptions);
}
function $4dbf0c115974ff4b$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $1oC0p.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $iLhGt.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $4dbf0c115974ff4b$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $1oC0p.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $1oC0p.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $19KTt.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $19KTt.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: storeState.subscribe(()=>handlers.onUpdate == null ? void 0 : handlers.onUpdate())
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $4dbf0c115974ff4b$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $1oC0p.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $1oC0p.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $4dbf0c115974ff4b$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(props, $4dbf0c115974ff4b$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(restProps, $4dbf0c115974ff4b$var$_excluded2);
        const ctx = (0, $1oC0p.useContext)((0, $djHSy.Context));
        const registry = $4dbf0c115974ff4b$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $1oC0p.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $4dbf0c115974ff4b$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $4dbf0c115974ff4b$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $iEBLg.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $1oC0p.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (scope) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $djHSy.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).bool
    };
    return FunctionContainer;
}

});
parcelRegister("djHSy", function(module, exports) {
$parcel$export(module.exports, "Context", function () { return $9b1f1627d56ad4e6$export$841858b892ce1f4c; });

var $1oC0p = parcelRequire("1oC0p");

var $iLhGt = parcelRequire("iLhGt");
const $9b1f1627d56ad4e6$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext({
    globalRegistry: (0, $iLhGt.defaultRegistry),
    retrieveStore: (Store)=>(0, $iLhGt.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("iLhGt", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", function () { return $da8a557b4bf7f386$export$acb47f32da33501e; });
$parcel$export(module.exports, "defaultRegistry", function () { return $da8a557b4bf7f386$export$9d726ae4880b1060; });

var $5SdS7 = parcelRequire("5SdS7");

var $19KTt = parcelRequire("19KTt");

var $4h8Lm = parcelRequire("4h8Lm");
const $da8a557b4bf7f386$export$e4d628ba0054221b = '__global__';
class $da8a557b4bf7f386$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $da8a557b4bf7f386$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $5SdS7.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $4h8Lm.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $19KTt.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $da8a557b4bf7f386$export$9d726ae4880b1060 = new $da8a557b4bf7f386$export$acb47f32da33501e();

});
parcelRegister("5SdS7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $446cc194a1624a36$export$2e2bcd8739ae039; });
const $446cc194a1624a36$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $446cc194a1624a36$export$2e2bcd8739ae039 = $446cc194a1624a36$var$supports;

});

parcelRegister("19KTt", function(module, exports) {
$parcel$export(module.exports, "bindActions", function () { return $0d7b01ce9c6a9ee9$export$5ee1d46cd0883a22; });

var $7EDZa = parcelRequire("7EDZa");
const $0d7b01ce9c6a9ee9$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $0d7b01ce9c6a9ee9$var$warnings = new WeakMap();
const $0d7b01ce9c6a9ee9$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $7EDZa.default).devtools ? $0d7b01ce9c6a9ee9$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$0d7b01ce9c6a9ee9$var$warnings.has(actionFn)) $0d7b01ce9c6a9ee9$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $0d7b01ce9c6a9ee9$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $0d7b01ce9c6a9ee9$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});
parcelRegister("7EDZa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $592b492760646f40$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
const $592b492760646f40$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $592b492760646f40$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))),
    devtools: false,
    middlewares: new Set(),
    mutator: $592b492760646f40$var$defaultMutator
};
var $592b492760646f40$export$2e2bcd8739ae039 = $592b492760646f40$var$defaults;

});


parcelRegister("4h8Lm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31cf8c17d087a0dd$export$2e2bcd8739ae039; });

var $l7oft = parcelRequire("l7oft");

var $iltul = parcelRequire("iltul");

var $7EDZa = parcelRequire("7EDZa");

var $beVz1 = parcelRequire("beVz1");
function $31cf8c17d087a0dd$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $beVz1.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $l7oft.default)(storeState, (0, $7EDZa.default).middlewares);
    return storeState;
}
var $31cf8c17d087a0dd$export$2e2bcd8739ae039 = (0, $iltul.default)($31cf8c17d087a0dd$var$createStoreState);

});
parcelRegister("l7oft", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f5fd0fb4f3f37e08$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");

var $8p4Wo = parcelRequire("8p4Wo");
const $f5fd0fb4f3f37e08$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $8p4Wo.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $7EDZa.default).mutator);
var $f5fd0fb4f3f37e08$export$2e2bcd8739ae039 = $f5fd0fb4f3f37e08$var$applyMiddleware;

});
parcelRegister("8p4Wo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $61e47da7d6a27804$export$2e2bcd8739ae039; });

var $iEBLg = parcelRequire("iEBLg");
const $61e47da7d6a27804$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $iEBLg.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $61e47da7d6a27804$export$2e2bcd8739ae039 = $61e47da7d6a27804$var$updateMiddleware;

});
parcelRegister("iEBLg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9494103866cad1b$export$2e2bcd8739ae039; });
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $d9494103866cad1b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $d9494103866cad1b$var$CACHE = new WeakMap();
function $d9494103866cad1b$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($d9494103866cad1b$var$CACHE.has(objA)) keysA = $d9494103866cad1b$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $d9494103866cad1b$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($d9494103866cad1b$var$CACHE.has(objB)) keysB = $d9494103866cad1b$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $d9494103866cad1b$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$d9494103866cad1b$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("iltul", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5b10ff816f52ca9$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");
const $d5b10ff816f52ca9$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $d5b10ff816f52ca9$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $7EDZa.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $7EDZa.default).devtools === 'function' ? (0, $7EDZa.default).devtools(storeState) : {};
                        devTools = $d5b10ff816f52ca9$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $d5b10ff816f52ca9$export$2e2bcd8739ae039 = $d5b10ff816f52ca9$var$withDevtools;

});

parcelRegister("beVz1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82eda785b72bac58$export$2e2bcd8739ae039; });

var $7EDZa = parcelRequire("7EDZa");

var $9PrlP = parcelRequire("9PrlP");

var $5SdS7 = parcelRequire("5SdS7");
const $82eda785b72bac58$var$QUEUE = [];
let $82eda785b72bac58$var$scheduled;
function $82eda785b72bac58$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $7EDZa.default).batchUpdates || !(0, $5SdS7.default).scheduling()) return (0, $9PrlP.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$82eda785b72bac58$var$QUEUE.includes(fn)) $82eda785b72bac58$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($82eda785b72bac58$var$scheduled) return;
    $82eda785b72bac58$var$scheduled = (0, $9PrlP.batch)(()=>{
        let queueFn;
        while(queueFn = $82eda785b72bac58$var$QUEUE.shift())queueFn();
        $82eda785b72bac58$var$scheduled = null;
    });
}

});
parcelRegister("9PrlP", function(module, exports) {
$parcel$export(module.exports, "batch", function () { return $727e17d26f80e91e$export$712ea50be43a7858; });
/* eslint-disable import/no-unresolved */ 
var $gUjjH = parcelRequire("gUjjH");

var $jEVVm = parcelRequire("jEVVm");

var $7EDZa = parcelRequire("7EDZa");

var $5SdS7 = parcelRequire("5SdS7");
let $727e17d26f80e91e$var$isInsideBatchedSchedule = false;
function $727e17d26f80e91e$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $7EDZa.default).batchUpdates || !(0, $5SdS7.default).scheduling() || $727e17d26f80e91e$var$isInsideBatchedSchedule) return (0, $gUjjH.unstable_batchedUpdates)(fn);
    $727e17d26f80e91e$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $jEVVm.unstable_scheduleCallback)((0, $jEVVm.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $gUjjH.unstable_batchedUpdates)(fn);
        $727e17d26f80e91e$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("jEVVm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9BZqy"));

});
parcelRegister("9BZqy", function(module, exports) {
$parcel$export(module.exports, "unstable_now", function () { return $6ff737efae05bc89$export$c4744153514ff05d; }, function (v) { return $6ff737efae05bc89$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7; }, function (v) { return $6ff737efae05bc89$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6ff737efae05bc89$export$e26fe2ed2fa76875; }, function (v) { return $6ff737efae05bc89$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6ff737efae05bc89$export$502329bbf4b505b1; }, function (v) { return $6ff737efae05bc89$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6ff737efae05bc89$export$6e3807111c4874c4; }, function (v) { return $6ff737efae05bc89$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6ff737efae05bc89$export$c27134553091fb3a; }, function (v) { return $6ff737efae05bc89$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6ff737efae05bc89$export$33ee1acdc04fd2a2; }, function (v) { return $6ff737efae05bc89$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6ff737efae05bc89$export$b00a404bbd5edef2; }, function (v) { return $6ff737efae05bc89$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6ff737efae05bc89$export$d66a1c1c77bd778b; }, function (v) { return $6ff737efae05bc89$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6ff737efae05bc89$export$d3dfb8e4810cb555; }, function (v) { return $6ff737efae05bc89$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6ff737efae05bc89$export$72fdf0e06517287b; }, function (v) { return $6ff737efae05bc89$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6ff737efae05bc89$export$816d2913ae6b83b1; }, function (v) { return $6ff737efae05bc89$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6ff737efae05bc89$export$61bcfe829111a1d0; }, function (v) { return $6ff737efae05bc89$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6ff737efae05bc89$export$7ee8c9beb337bc3f; }, function (v) { return $6ff737efae05bc89$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6ff737efae05bc89$export$b5836b71941fa3ed; }, function (v) { return $6ff737efae05bc89$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6ff737efae05bc89$export$cf845f2c119da08a; }, function (v) { return $6ff737efae05bc89$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ff737efae05bc89$export$c4744153514ff05d;
var $6ff737efae05bc89$export$3e506c1ccc9cc1a7;
var $6ff737efae05bc89$export$e26fe2ed2fa76875;
var $6ff737efae05bc89$export$502329bbf4b505b1;
var $6ff737efae05bc89$export$6e3807111c4874c4;
var $6ff737efae05bc89$export$c27134553091fb3a;
var $6ff737efae05bc89$export$33ee1acdc04fd2a2;
var $6ff737efae05bc89$export$b00a404bbd5edef2;
var $6ff737efae05bc89$export$d66a1c1c77bd778b;
var $6ff737efae05bc89$export$d3dfb8e4810cb555;
var $6ff737efae05bc89$export$72fdf0e06517287b;
var $6ff737efae05bc89$export$816d2913ae6b83b1;
var $6ff737efae05bc89$export$61bcfe829111a1d0;
var $6ff737efae05bc89$export$7ee8c9beb337bc3f;
var $6ff737efae05bc89$export$b5836b71941fa3ed;
var $6ff737efae05bc89$export$cf845f2c119da08a;
"use strict";
function $6ff737efae05bc89$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $6ff737efae05bc89$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $6ff737efae05bc89$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $6ff737efae05bc89$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $6ff737efae05bc89$var$compare(left, last)) rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $6ff737efae05bc89$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $6ff737efae05bc89$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$6ff737efae05bc89$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ff737efae05bc89$var$localPerformance = performance;
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localPerformance.now();
    };
} else {
    var $6ff737efae05bc89$var$localDate = Date, $6ff737efae05bc89$var$initialTime = $6ff737efae05bc89$var$localDate.now();
    $6ff737efae05bc89$export$c4744153514ff05d = function() {
        return $6ff737efae05bc89$var$localDate.now() - $6ff737efae05bc89$var$initialTime;
    };
}
var $6ff737efae05bc89$var$taskQueue = [], $6ff737efae05bc89$var$timerQueue = [], $6ff737efae05bc89$var$taskIdCounter = 1, $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = 3, $6ff737efae05bc89$var$isPerformingWork = !1, $6ff737efae05bc89$var$isHostCallbackScheduled = !1, $6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$needsPaint = !1, $6ff737efae05bc89$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $6ff737efae05bc89$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $6ff737efae05bc89$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $6ff737efae05bc89$var$advanceTimers(currentTime) {
    for(var timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue); null !== timer;){
        if (null === timer.callback) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue);
        else if (timer.startTime <= currentTime) $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$timerQueue), timer.sortIndex = timer.expirationTime, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, timer);
        else break;
        timer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
    }
}
function $6ff737efae05bc89$var$handleTimeout(currentTime) {
    $6ff737efae05bc89$var$isHostTimeoutScheduled = !1;
    $6ff737efae05bc89$var$advanceTimers(currentTime);
    if (!$6ff737efae05bc89$var$isHostCallbackScheduled) {
        if (null !== $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue)) $6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $6ff737efae05bc89$var$isMessageLoopRunning = !1, $6ff737efae05bc89$var$taskTimeoutID = -1, $6ff737efae05bc89$var$frameInterval = 5, $6ff737efae05bc89$var$startTime = -1;
function $6ff737efae05bc89$var$shouldYieldToHost() {
    return $6ff737efae05bc89$var$needsPaint ? !0 : $6ff737efae05bc89$export$c4744153514ff05d() - $6ff737efae05bc89$var$startTime < $6ff737efae05bc89$var$frameInterval ? !1 : !0;
}
function $6ff737efae05bc89$var$performWorkUntilDeadline() {
    $6ff737efae05bc89$var$needsPaint = !1;
    if ($6ff737efae05bc89$var$isMessageLoopRunning) {
        var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
        $6ff737efae05bc89$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $6ff737efae05bc89$var$isHostCallbackScheduled = !1;
                $6ff737efae05bc89$var$isHostTimeoutScheduled && ($6ff737efae05bc89$var$isHostTimeoutScheduled = !1, $6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1);
                $6ff737efae05bc89$var$isPerformingWork = !0;
                var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
                try {
                    b: {
                        $6ff737efae05bc89$var$advanceTimers(currentTime);
                        for($6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue); null !== $6ff737efae05bc89$var$currentTask && !($6ff737efae05bc89$var$currentTask.expirationTime > currentTime && $6ff737efae05bc89$var$shouldYieldToHost());){
                            var callback = $6ff737efae05bc89$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $6ff737efae05bc89$var$currentTask.callback = null;
                                $6ff737efae05bc89$var$currentPriorityLevel = $6ff737efae05bc89$var$currentTask.priorityLevel;
                                var continuationCallback = callback($6ff737efae05bc89$var$currentTask.expirationTime <= currentTime);
                                currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $6ff737efae05bc89$var$currentTask.callback = continuationCallback;
                                    $6ff737efae05bc89$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $6ff737efae05bc89$var$currentTask === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                                $6ff737efae05bc89$var$advanceTimers(currentTime);
                            } else $6ff737efae05bc89$var$pop($6ff737efae05bc89$var$taskQueue);
                            $6ff737efae05bc89$var$currentTask = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue);
                        }
                        if (null !== $6ff737efae05bc89$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue);
                            null !== firstTimer && $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $6ff737efae05bc89$var$currentTask = null, $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel, $6ff737efae05bc89$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline() : $6ff737efae05bc89$var$isMessageLoopRunning = !1;
        }
    }
}
var $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $6ff737efae05bc89$var$localSetImmediate) $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetImmediate($6ff737efae05bc89$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6ff737efae05bc89$var$channel = new MessageChannel(), $6ff737efae05bc89$var$port = $6ff737efae05bc89$var$channel.port2;
    $6ff737efae05bc89$var$channel.port1.onmessage = $6ff737efae05bc89$var$performWorkUntilDeadline;
    $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
        $6ff737efae05bc89$var$port.postMessage(null);
    };
} else $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline = function() {
    $6ff737efae05bc89$var$localSetTimeout($6ff737efae05bc89$var$performWorkUntilDeadline, 0);
};
function $6ff737efae05bc89$var$requestHostTimeout(callback, ms) {
    $6ff737efae05bc89$var$taskTimeoutID = $6ff737efae05bc89$var$localSetTimeout(function() {
        callback($6ff737efae05bc89$export$c4744153514ff05d());
    }, ms);
}
$6ff737efae05bc89$export$3e506c1ccc9cc1a7 = 5;
$6ff737efae05bc89$export$e26fe2ed2fa76875 = 1;
$6ff737efae05bc89$export$502329bbf4b505b1 = 4;
$6ff737efae05bc89$export$6e3807111c4874c4 = 3;
$6ff737efae05bc89$export$c27134553091fb3a = null;
$6ff737efae05bc89$export$33ee1acdc04fd2a2 = 2;
$6ff737efae05bc89$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$6ff737efae05bc89$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6ff737efae05bc89$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$6ff737efae05bc89$export$d3dfb8e4810cb555 = function() {
    return $6ff737efae05bc89$var$currentPriorityLevel;
};
$6ff737efae05bc89$export$72fdf0e06517287b = function(eventHandler) {
    switch($6ff737efae05bc89$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$816d2913ae6b83b1 = function() {
    $6ff737efae05bc89$var$needsPaint = !0;
};
$6ff737efae05bc89$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    $6ff737efae05bc89$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$6ff737efae05bc89$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $6ff737efae05bc89$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $6ff737efae05bc89$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$timerQueue, priorityLevel), null === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$taskQueue) && priorityLevel === $6ff737efae05bc89$var$peek($6ff737efae05bc89$var$timerQueue) && ($6ff737efae05bc89$var$isHostTimeoutScheduled ? ($6ff737efae05bc89$var$localClearTimeout($6ff737efae05bc89$var$taskTimeoutID), $6ff737efae05bc89$var$taskTimeoutID = -1) : $6ff737efae05bc89$var$isHostTimeoutScheduled = !0, $6ff737efae05bc89$var$requestHostTimeout($6ff737efae05bc89$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $6ff737efae05bc89$var$push($6ff737efae05bc89$var$taskQueue, priorityLevel), $6ff737efae05bc89$var$isHostCallbackScheduled || $6ff737efae05bc89$var$isPerformingWork || ($6ff737efae05bc89$var$isHostCallbackScheduled = !0, $6ff737efae05bc89$var$isMessageLoopRunning || ($6ff737efae05bc89$var$isMessageLoopRunning = !0, $6ff737efae05bc89$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$6ff737efae05bc89$export$b5836b71941fa3ed = $6ff737efae05bc89$var$shouldYieldToHost;
$6ff737efae05bc89$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $6ff737efae05bc89$var$currentPriorityLevel;
        $6ff737efae05bc89$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $6ff737efae05bc89$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});








parcelRegister("cVxfO", function(module, exports) {
$parcel$export(module.exports, "createHook", function () { return $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24; });

var $1oC0p = parcelRequire("1oC0p");

var $ixLXc = parcelRequire("ixLXc");

var $djHSy = parcelRequire("djHSy");

var $82g7P = parcelRequire("82g7P");
const $96949a7b8ed8e0eb$var$EMPTY_SELECTOR = ()=>undefined;
const $96949a7b8ed8e0eb$var$DEFAULT_SELECTOR = (state)=>state;
function $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $1oC0p.useContext)((0, $djHSy.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $1oC0p.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $1oC0p.useMemo)(()=>selector ? (0, $82g7P.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $96949a7b8ed8e0eb$var$EMPTY_SELECTOR : $96949a7b8ed8e0eb$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $1oC0p.useState)({})[1];
        const getSnapshot = (0, $1oC0p.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $ixLXc.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $96949a7b8ed8e0eb$export$7c643e1d6648e418(Store) {
    const useHook = $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $96949a7b8ed8e0eb$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $96949a7b8ed8e0eb$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("ixLXc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bOBs2"));

});
parcelRegister("bOBs2", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", function () { return $89a16a416bb12add$export$306c0aa65ff9ec16; }, function (v) { return $89a16a416bb12add$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89a16a416bb12add$export$306c0aa65ff9ec16;
'use strict';

var $1oC0p = parcelRequire("1oC0p");
function $89a16a416bb12add$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $89a16a416bb12add$var$k = "function" === typeof Object.is ? Object.is : $89a16a416bb12add$var$h, $89a16a416bb12add$var$l = $1oC0p.useState, $89a16a416bb12add$var$m = $1oC0p.useEffect, $89a16a416bb12add$var$n = $1oC0p.useLayoutEffect, $89a16a416bb12add$var$p = $1oC0p.useDebugValue;
function $89a16a416bb12add$var$q(a, b) {
    var d = b(), f = $89a16a416bb12add$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $89a16a416bb12add$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $89a16a416bb12add$var$m(function() {
        $89a16a416bb12add$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $89a16a416bb12add$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $89a16a416bb12add$var$p(d);
    return d;
}
function $89a16a416bb12add$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$89a16a416bb12add$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $89a16a416bb12add$var$t(a, b) {
    return b();
}
var $89a16a416bb12add$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $89a16a416bb12add$var$t : $89a16a416bb12add$var$q;
$89a16a416bb12add$export$306c0aa65ff9ec16 = void 0 !== $1oC0p.useSyncExternalStore ? $1oC0p.useSyncExternalStore : $89a16a416bb12add$var$u;

});


parcelRegister("82g7P", function(module, exports) {
$parcel$export(module.exports, "getSelectorInstance", function () { return $5d9b04c7903768eb$export$38d24f3c60944dd5; });

var $lrKV1 = parcelRequire("lrKV1");
function $5d9b04c7903768eb$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $lrKV1.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $lrKV1.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $5d9b04c7903768eb$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $5d9b04c7903768eb$var$cache = new WeakMap();
function $5d9b04c7903768eb$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$5d9b04c7903768eb$var$cache.has(storeState)) $5d9b04c7903768eb$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $5d9b04c7903768eb$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $5d9b04c7903768eb$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("lrKV1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9d083a877bb8b60$export$2e2bcd8739ae039; });

var $iEBLg = parcelRequire("iEBLg");
function $f9d083a877bb8b60$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $f9d083a877bb8b60$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $iEBLg.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$f9d083a877bb8b60$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $f9d083a877bb8b60$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $f9d083a877bb8b60$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $iEBLg.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("dv8pz", function(module, exports) {
$parcel$export(module.exports, "createStore", function () { return $9d44b1f8bf314c4a$export$f51a9068ac82ea43; });

var $ekT4F = parcelRequire("ekT4F");
function $9d44b1f8bf314c4a$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $ekT4F.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $9d44b1f8bf314c4a$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $9d44b1f8bf314c4a$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("ekT4F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6fda7907ddc7134$export$2e2bcd8739ae039; });
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a6fda7907ddc7134$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("g2S82", function(module, exports) {
$parcel$export(module.exports, "updateUnitCount", function () { return $281be3e92bc01f76$export$753383981d56a121; });
$parcel$export(module.exports, "updateBillingCycle", function () { return $281be3e92bc01f76$export$ea0e718cff6511cb; });
$parcel$export(module.exports, "updatePriceCalcs", function () { return $281be3e92bc01f76$export$55173bfd96ab1f01; });
$parcel$export(module.exports, "updateCurrencyISOCode", function () { return $281be3e92bc01f76$export$c376e0e2eb868782; });
const $281be3e92bc01f76$export$753383981d56a121 = (unitCount)=>({ setState: setState })=>{
        setState({
            unitCount: unitCount
        });
    };
const $281be3e92bc01f76$export$ea0e718cff6511cb = (billingCycle)=>({ setState: setState })=>{
        setState({
            billingCycle: billingCycle
        });
    };
const $281be3e92bc01f76$export$55173bfd96ab1f01 = (priceCalcs)=>({ setState: setState })=>{
        setState({
            priceCalcs: priceCalcs
        });
    };
const $281be3e92bc01f76$export$c376e0e2eb868782 = (currencyISOCode)=>({ setState: setState })=>{
        setState({
            currencyISOCode: currencyISOCode
        });
    };

});


parcelRegister("kOGAE", function(module, exports) {
$parcel$export(module.exports, "BilledAnnuallyButton", function () { return $6a8c318d6d78f834$export$ae3c75f0e47b71cc; });
/* billed-annually-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $6a8c318d6d78f834$export$ae3c75f0e47b71cc = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        onClick: props.onClick,
        tabIndex: 0,
        "data-event-component": "linkButton",
        "data-event": "clicked",
        className: (0, $2jatx.default)([
            "_bfhk1j28 _19itidpf _80omtlke _syazoelr _ect41kw7 _1wyb1kw7 _vwz4idpf _19pkidpf _2hwxyh40 _otyridpf _18u0yh40 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l3u7gi"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "Pricing.card.body.enterprise.billedAnnually",
            defaultMessage: "Billed annually."
        })
    });
};

});

parcelRegister("cdVVX", function(module, exports) {
$parcel$export(module.exports, "UserTier", function () { return $0cbf75546d5654ce$export$cd4f9ca719669f8d; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2Yrzq = parcelRequire("2Yrzq");

var $kooLp = parcelRequire("kooLp");

var $3F38X = parcelRequire("3F38X");
const $0cbf75546d5654ce$var$userTierContainerStyles = null;
const $0cbf75546d5654ce$var$userTierMessageStyles = null;
const $0cbf75546d5654ce$var$toolTipContainerStyles = null;
const $0cbf75546d5654ce$export$cd4f9ca719669f8d = ({ priceCalc: priceCalc })=>{
    const { formattedBreakdown: formattedBreakdown } = priceCalc;
    const [{ messages: messages }] = (0, $3F38X.usePriceFinderStore)();
    const fmtBreakdownTier = formattedBreakdown[formattedBreakdown.length - 1];
    if (!fmtBreakdownTier) throw new Error("No breakdown provided for user tier.");
    const { formattedUnitLimitLower: formattedUnitLimitLower, formattedUnitLimitUpper: formattedUnitLimitUpper, formattedUnitsInTier: formattedUnitsInTier, formattedUnitsAvailableInTier: formattedUnitsAvailableInTier } = fmtBreakdownTier;
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const tooltipAriaLabel = formatMessage({
        id: "Pricing.PriceCard.UserTier.MoreInformationAboutTier",
        defaultMessage: "More information about tier"
    });
    const filledSeatsMessage = formatMessage({
        id: "Pricing.PriceCard.UserTier.Details",
        defaultMessage: "Filled seats"
    });
    const availableSeatsMessage = formatMessage({
        id: "Pricing.PriceCard.UserTier.AvailableSeats",
        defaultMessage: "Available seats"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _zulp1y44"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, messages.cardUnitCountTierRange), {
                        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                            lowerLimit: formattedUnitLimitLower,
                            upperLimit: formattedUnitLimitUpper
                        })
                    }))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Yrzq.Tooltip), {
                ariaLabel: tooltipAriaLabel,
                buttonSize: "small",
                content: `Tier:
                    ${formattedUnitLimitLower} -${" "}${formattedUnitLimitUpper}

                    ${filledSeatsMessage}:
                    ${formattedUnitsInTier}

                    ${availableSeatsMessage}:
                    ${formattedUnitsAvailableInTier}`
            })
        ]
    });
};

});


parcelRegister("6o9v8", function(module, exports) {
$parcel$export(module.exports, "StickyCTAContextProvider", function () { return $52fdcbddbb22aba0$export$6177378b3c0dfa99; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $52fdcbddbb22aba0$var$StickyCtaContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $52fdcbddbb22aba0$export$d07c74b192781870 = ()=>{
    const context = (0, $1oC0p.useContext)($52fdcbddbb22aba0$var$StickyCtaContext);
    if (!context) return {
        isSticky: false
    };
    return context;
};
const $52fdcbddbb22aba0$export$6177378b3c0dfa99 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($52fdcbddbb22aba0$var$StickyCtaContext.Provider, {
        value: props,
        children: props.children
    });
};

});


parcelRegister("l4Rl8", function(module, exports) {
$parcel$export(module.exports, "CtaButton", function () { return $8627522070c75517$export$87cbfb14b50d331c; });
/* cta-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("5579Q");
var $5qUgh = parcelRequire("5qUgh");
parcelRequire("jmley");
var $gfjAv = parcelRequire("gfjAv");

var $lOlsU = parcelRequire("lOlsU");

var $4IlVP = parcelRequire("4IlVP");
const $8627522070c75517$var$ctaButtonStyles = null;
const $8627522070c75517$export$87cbfb14b50d331c = (_param)=>{
    var { edition: edition, dataProductKey: dataProductKey, text: text, type: type, url: url, dataEventPropsLabel: dataEventPropsLabel, containerId: containerId, isDisabled: isDisabled } = _param, props = (0, $aPnCa._)(_param, [
        "edition",
        "dataProductKey",
        "text",
        "type",
        "url",
        "dataEventPropsLabel",
        "containerId",
        "isDisabled"
    ]);
    const fireCtaEvent = (0, $lOlsU.useFirePricingPlanCtaEvent)({
        edition: edition,
        containerId: containerId,
        productKey: dataProductKey
    });
    const envSpecificURL = (0, $4IlVP.getEnvironment)(true) === "staging" ? url.replace(/https:\/\/(www.)?atlassian.com/, "https://wac.stg.internal.atlassian.com") : url;
    const handleClick = ()=>{
        var // @ts-ignore
        _props_onClick;
        fireCtaEvent();
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
        intentType: "button",
        containerId: containerId,
        productKey: dataProductKey,
        edition: edition,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), (0, $dPABA._)((0, $6ogO3._)({
            isDisabled: isDisabled,
            variant: type,
            color: "black",
            href: envSpecificURL,
            dataEventProps: {
                "data-product-key": dataProductKey,
                "data-event-component": "linkButton",
                "data-event-container": "priceBlock",
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        }, props), {
            onClick: handleClick,
            className: (0, $2jatx.default)([
                "_11c88q0o _1wyb7vkz _k48p1nn1 _vwz4gktf _4t3i1wug _4bfu1r31 _1hmsglyw _ajmmnqa1 _1bsb1ns9 _o5724jg8 _1q51ftgi _85i5ftgi"
            ]),
            children: text
        }))
    });
};

});
parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});

parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            containerId: containerId,
            actionSubjectId: "pricingPlanCta",
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});





parcelRegister("bCS4H", function(module, exports) {
$parcel$export(module.exports, "PricingFaq", function () { return (parcelRequire("bE8d4")).PricingFaq; });
$parcel$export(module.exports, "QuotationsAdornment", function () { return (parcelRequire("2zOxm")).QuotationsAdornment; });
parcelRequire("bE8d4");
parcelRequire("2zOxm");

});
parcelRegister("bE8d4", function(module, exports) {
$parcel$export(module.exports, "PricingFaq", function () { return $858340cf4dc38f41$export$3c5f68183e9d00f8; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $iAA1N = parcelRequire("iAA1N");

var $e1ZWr = parcelRequire("e1ZWr");
const $858340cf4dc38f41$export$3c5f68183e9d00f8 = ({ header: header, planDetails: planDetails })=>{
    const intl = (0, $8e22h.default)();
    if (!planDetails) return null;
    const fallbackHeader = intl.formatMessage({
        id: "pricing.faq.header",
        defaultMessage: "Get more info"
    });
    const faqAccordionsFeatures = planDetails.map((item)=>{
        var _item_planAdditionalDetailsTitleExternal, _item_planAdditionalDetails;
        return {
            header: (_item_planAdditionalDetailsTitleExternal = item.planAdditionalDetailsTitleExternal) !== null && _item_planAdditionalDetailsTitleExternal !== void 0 ? _item_planAdditionalDetailsTitleExternal : "",
            content: (0, $e1ZWr.parseHtmlString)((_item_planAdditionalDetails = item.planAdditionalDetails) !== null && _item_planAdditionalDetails !== void 0 ? _item_planAdditionalDetails : undefined)
        };
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iAA1N.default), {
        header: header !== null && header !== void 0 ? header : fallbackHeader,
        features: faqAccordionsFeatures
    });
};
$858340cf4dc38f41$export$3c5f68183e9d00f8.displayName = "PricingFaq";

});
parcelRegister("iAA1N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6090491cfa4b9136$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $6090491cfa4b9136$var$rowCss = null;
const $6090491cfa4b9136$var$containerCss = null;
const $6090491cfa4b9136$var$headerCss = null;
const $6090491cfa4b9136$var$featureContainerCss = null;
const $6090491cfa4b9136$var$fadeInAnimation = null;
const $6090491cfa4b9136$var$featureContentCss = null;
const $6090491cfa4b9136$var$showContentCss = null;
const $6090491cfa4b9136$var$featureHeaderCss = null;
const $6090491cfa4b9136$var$toggleIconCss = null;
/**
 * @deprecated - Please use @/libraries/design/components/accordion instead
 */ const $6090491cfa4b9136$var$FaqAccordions = ({ header: header, features: features })=>{
    const [expanded, setExpanded] = (0, $1oC0p.useState)({});
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: "faq",
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _1bsb1osq _j4or1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _n3tdvbgk _1bsbf2ck _8fz61c5i _1hwcidpf _1s4p1osq _q5bceo28 _jjfo1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_n7zld48f _syazqlpt _1wyb1ylp _k48p1fw0 _vwz4ckbl _1dyzidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f37vkz _n3td1tcg _19bv7vkz _y3gn1h6o _so7d14no _19q1or1b _1v4mzwfg _1bl410mc"
                    ]),
                    children: header
                }),
                features.map((feature)=>{
                    var _expanded_feature_header;
                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_n7zld48f _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _xlob1h6o _cy6oglyw _szfsglyw _stfgidpf _d32vrbzz _4rtxtlke _dpd31txw _1jmq1tcg _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _14hp1osq _1d421ul9 _k6cg1ul9"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                "aria-expanded": (_expanded_feature_header = expanded[feature.header]) !== null && _expanded_feature_header !== void 0 ? _expanded_feature_header : false,
                                onClick: ()=>setExpanded((0, $dPABA._)((0, $6ogO3._)({}, expanded), {
                                        [feature.header]: !expanded[feature.header]
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1bqd _16jlkb7n _1o9zkb7n _i0dlf1ug _1wyb1tcg _k48pbfng _1dyznl7k _vwz410nf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _y3gn1e5h _1xrxrbzz _so7dqslr _gwdjgktf"
                                        ]),
                                        children: feature.header
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_bfhkrbzz _2rko1ssb _4t3i1tcg _v56488n5 _1bsb1tcg _wtqc14w8 _pmf41sub _ts4v19bv _49x519bv _1mf219bv _12h0b3bt _s971b3bt _229db3bt _1st5stnw _vuffstnw _kd02stnw _189bidpf _1owaidpf _1ypnidpf _umq4idpf _1d08idpf _3rqzidpf _3uxpidpf _pl8lidpf _2x6gidpf _1lzuidpf _e2u3idpf _1u95idpf _tmcvu67f _1696u67f _15g2u67f _aze81wug _8u7c1wug _19dq1wug _144j14y2 _iui614y2 _6v8s14y2 _1faz1wug _1ew01wug _3r7i1wug _1oz314y2 _18xc14y2 _u63c14y2 _1xlyyh40 _kotoyh40 _6zj4yh40 _6zj41wug _ornayh40 _19dq14y2 _6v8s1wug _3r7i14y2 _u63c1wug",
                                            expanded[feature.header] ? "minus" : "plus"
                                        ])
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_y44v1dy6 _1e0cglyw _2hwxvbgk _n3td1tcg _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _clfdidpf _11pqidpf _q0a51tcg _c3k8idpf",
                                    expanded[feature.header] && "_1e0c1ule"
                                ]),
                                children: feature.content
                            })
                        ]
                    }, feature.header);
                })
            ]
        })
    });
};
var $6090491cfa4b9136$export$2e2bcd8739ae039 = $6090491cfa4b9136$var$FaqAccordions;

});

parcelRegister("e1ZWr", function(module, exports) {
$parcel$export(module.exports, "parseHtmlString", function () { return $3d89aad90cf98a04$export$85d98c827c7edf42; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $3d89aad90cf98a04$var$sharedRichtextValues = {
    p: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: chunks
        }, key),
    strong: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
            children: chunks
        }, key),
    ul: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            children: chunks
        }, key),
    li: (chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
            children: chunks
        }, key),
    a: (chunks, key, href)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: href,
            children: chunks
        }, key),
    br: (_chunks, key)=>/*#__PURE__*/ (0, $7VQPk.jsx)("br", {}, key)
};
const $3d89aad90cf98a04$var$convertToReact = (node, key)=>{
    if (node.nodeType === Node.TEXT_NODE) return node.textContent;
    if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node;
        const tagName = element.tagName.toLowerCase();
        const children = Array.from(element.childNodes).map((child, index)=>$3d89aad90cf98a04$var$convertToReact(child, `${key}-${index}`));
        const renderFunction = $3d89aad90cf98a04$var$sharedRichtextValues[tagName];
        if (renderFunction) return renderFunction(children, key, element.getAttribute("href") || undefined);
        else return /*#__PURE__*/ (0, $1oC0p.createElement)(tagName, {
            key: key
        }, children);
    }
    return null;
};
const $3d89aad90cf98a04$export$85d98c827c7edf42 = (htmlString)=>{
    if (!htmlString) return null;
    if (typeof document === "undefined") return null;
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return $3d89aad90cf98a04$var$convertToReact(tempDiv, "root");
};

});


parcelRegister("2zOxm", function(module, exports) {
$parcel$export(module.exports, "QuotationsAdornment", function () { return $a59da8f7af8cdcb0$export$41c85da8b12966cf; });
/* quotations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");
const $a59da8f7af8cdcb0$export$41c85da8b12966cf = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152t3sup _1e021c6i _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($a59da8f7af8cdcb0$var$LeftQuotation, {})
            }),
            props.children,
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _rjxpu4aj _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($a59da8f7af8cdcb0$var$RightQuotation, {})
            })
        ]
    });
};
const $a59da8f7af8cdcb0$var$LeftQuotation = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/02m24o230o077mu3rxv7gm30nj77wqii.svg",
            alt: "Quotation left"
        }
    });
const $a59da8f7af8cdcb0$var$RightQuotation = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/50x33lwtmm1hnd8x717wk316dthyw741.svg",
            alt: "Quotation right"
        }
    });

});


parcelRegister("1YZW1", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return (parcelRequire("grcEk")).PricingPageLayout; });
$parcel$export(module.exports, "PageHeading", function () { return (parcelRequire("6Px6U")).PageHeading; });
parcelRequire("grcEk");
parcelRequire("6Px6U");

});
parcelRegister("grcEk", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return $229e6cc32b6909b5$export$179602f42864b2b8; });
/* pricing-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8LaTa = parcelRequire("8LaTa");

var $jvvcS = parcelRequire("jvvcS");
const $229e6cc32b6909b5$export$179602f42864b2b8 = ({ nav: nav, banner: banner, hero: hero, bgColor: bgColor, hasGlobalFooter: hasGlobalFooter = true, showFallback: showFallback = false, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            nav && nav,
            !showFallback && banner,
            !showFallback && hero,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    background: bgColor
                },
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1q51vbgk _85i5vbgk _xc2ickbl _1u2qzwfg"
                ]),
                children: [
                    showFallback && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jvvcS.PricingPageFallback), {}),
                    !showFallback && children && /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                        id: "content",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulpvbgk _p12ftfvk _1bsbaq80 _vqct1h22 _1wfq1ul9 _15vt1ul9 _v7361wqb _chtu1wqb _8164ckbl _63vr1vh9 _1tbz1ul9 _68811ul9"
                        ]),
                        children: children
                    })
                ]
            }),
            hasGlobalFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhvbgk _476dckbl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            })
        ]
    });
};
const $229e6cc32b6909b5$var$footerCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutOuterCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutInnerCss = null;

});
parcelRegister("jvvcS", function(module, exports) {
$parcel$export(module.exports, "PricingPageFallback", function () { return $a5f2023cdede46a1$export$54fc8f6b9874893e; });
/* pricing-page-fallback.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $a5f2023cdede46a1$export$54fc8f6b9874893e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3idtre _1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "PageFallback.message",
            defaultMessage: "An unexpected error occurred. Please try again later."
        })
    });
};

});


parcelRegister("6Px6U", function(module, exports) {
$parcel$export(module.exports, "PageHeading", function () { return $9310efba541b4555$export$9716a88f5535df7c; });
/* page-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");
const $9310efba541b4555$export$9716a88f5535df7c = (props)=>{
    const { as: Component = "h1", children: children } = props, rest = (0, $aPnCa._)(props, [
        "as",
        "children"
    ]);
    const headingStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi"
        ]),
        children: [
            typeof children === "string" ? /*#__PURE__*/ (0, $7VQPk.jsx)("h1", (0, $dPABA._)((0, $6ogO3._)({}, rest), {
                dangerouslySetInnerHTML: {
                    __html: children
                },
                className: (0, $2jatx.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ])
            })) : /*#__PURE__*/ (0, $7VQPk.jsx)("h1", (0, $dPABA._)((0, $6ogO3._)({}, rest), {
                className: (0, $2jatx.default)([
                    "_k48p1fw0 _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1s18ckbl _1cqs1ady _1qjn1ylp _syazqlpt"
                ]),
                children: children
            })),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ox5132cg4k77h80v02063670d5th386i.svg",
                    alt: ""
                }
            })
        ]
    });
};

});


parcelRegister("j6FQw", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("je135")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("je135")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("je135")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("5S2vX")).ParentScrollTracking; });
parcelRequire("je135");
parcelRequire("5S2vX");

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)((0, $dPABA._)((0, $6ogO3._)({
        threshold: 0.5,
        triggerOnce: true
    }, observerOptions), {
        skip: (observerOptions === null || observerOptions === void 0 ? void 0 : observerOptions.skip) || !scrollTrackingEnabled
    }));
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6ogO3._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6ogO3._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            if (analyticsClient) {
                createAnalyticsEvent((0, $6ogO3._)({}, scrollTrackAnalyticsPayload)).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent((0, $6ogO3._)({}, dwellTimeTrackAnalyticsPayload)).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, (0, $dPABA._)((0, $6ogO3._)({
            section: section
        }, options), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, (0, $6ogO3._)({}, props))
        }));
    };
}

});
parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("j6FQw");
var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    var _props_pageId;
    const pageId = (_props_pageId = props.pageId) !== null && _props_pageId !== void 0 ? _props_pageId : parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});



parcelRegister("7yPHr", function(module, exports) {
$parcel$export(module.exports, "Hero", function () { return $3a7aabd8c31916de$export$887967f05dc521ae; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $imIsw = parcelRequire("imIsw");
const $3a7aabd8c31916de$export$887967f05dc521ae = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
            alt: intl.formatMessage({
                id: "StrategyCollectionPricingPageTemplate.headingLogoAlt",
                defaultMessage: "Strategy Collection logo"
            })
        }
    });
};

});

parcelRegister("f2RFx", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionNavbar", function () { return $75474cece0afe122$export$8f1cb1d63697797a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $l2QYX = parcelRequire("l2QYX");

var $lVpxp = parcelRequire("lVpxp");

var $bNHK1 = parcelRequire("bNHK1");
const $75474cece0afe122$export$8f1cb1d63697797a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $dPABA._)((0, $6ogO3._)({}, (0, $lVpxp.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $bNHK1.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("lVpxp", function(module, exports) {
$parcel$export(module.exports, "CollectionsCompoundSubNavProps", function () { return $41aac9f09a5b294b$export$7390cb3961621991; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $cR2Ov = parcelRequire("cR2Ov");

var $5yuBp = parcelRequire("5yuBp");
const $41aac9f09a5b294b$export$7390cb3961621991 = ()=>{
    const intl = (0, $8e22h.default)();
    const teamworkOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork");
    const teamworkFeaturesHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/features");
    const teamworkEnterpriseHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/enterprise");
    const teamworkPricingHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/pricing");
    const teamworkResourcesHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/resources");
    const strategyOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/strategy");
    const strategyDemoCenterHref = (0, $kooLp.useLocalizedHref)("/collections/strategy/demo-center");
    const strategyPricingHref = (0, $kooLp.useLocalizedHref)("/collections/strategy/pricing");
    const serviceOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/service");
    const servicePricingHref = (0, $kooLp.useLocalizedHref)("/collections/service/pricing");
    const softwareHref = (0, $kooLp.useLocalizedHref)("/collections/software");
    const collectionsHref = (0, $kooLp.useLocalizedHref)("/collections");
    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = (0, $5yuBp.useIsMobile)(1024);
    const hasSubnav = !isMobile;
    const props = {
        optionalClassName: "collections-nav",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.features",
                                        defaultMessage: "Features"
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: teamworkEnterpriseHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: teamworkPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.resources",
                                        defaultMessage: "Resources"
                                    }),
                                    href: teamworkResourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.demoCenter",
                                        defaultMessage: "Demo Center"
                                    }),
                                    href: strategyDemoCenterHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: strategyPricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "service",
                linkText: "Service",
                href: serviceOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: serviceOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: servicePricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "software",
                linkText: "Software",
                hasSubnav: false,
                href: softwareHref
            }
        ],
        isShowCta: false,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    return props;
};

});

parcelRegister("bNHK1", function(module, exports) {
$parcel$export(module.exports, "CTA_URL_PATH", function () { return $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc; });
const $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc = "/collections/strategy#contact";

});


parcelRegister("btixQ", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionPriceFinder", function () { return $d750d64597cdb634$export$2faf81ba1ab86dc7; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $hrGO1 = parcelRequire("hrGO1");

var $eYlij = parcelRequire("eYlij");

var $gIRO7 = parcelRequire("gIRO7");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $bNHK1 = parcelRequire("bNHK1");

var $dj6Rw = parcelRequire("dj6Rw");
const $d750d64597cdb634$export$2faf81ba1ab86dc7 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    // @ts-ignore
    const intl = (0, $8e22h.default)();
    const content = {
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Strategy Collection") // please ensure this matches the plan-comparison entry in Contentful
    };
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    const productPlans = [
        {
            planName: (0, $hrGO1.SpecialPlanNames).ENTERPRISE,
            planTitleComponent: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: "Strategy Collection"
                }),
            offeringSku: "strategy-collection-enterprise-sku",
            recommendationLimit: 2000,
            signupLimit: 2000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            signupURLInfo: {
                urlDomain: window.location.origin,
                urlPath: (0, $bNHK1.CTA_URL_PATH),
                shouldLocalize: true
            }
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "StrategyCollectionPriceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size"
        },
        unitCountInputTerm: {
            id: "StrategyCollectionPriceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardUnitCountTierRange: {
            id: "StrategyCollectionPriceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardEnterpriseMinimumCount: {
            id: "StrategyCollectionPriceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "strategyCollection",
            productPlans: productPlans,
            defaultUnitCount: 50,
            isAnnualBillingOnly: true,
            enterpriseMinimumCount: 50,
            contactURL: (0, $bNHK1.CTA_URL_PATH),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                        messages: messages,
                        serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.strategyCollection,
                        countryCode: props.countryCode
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dj6Rw.Disclaimer), {})
                ]
            })
        })
    });
};

});
parcelRegister("gIRO7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8b32bb2e3a52fb0a$export$2e2bcd8739ae039; });
/* price-finder.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $g9ZvA = parcelRequire("g9ZvA");

var $eYlij = parcelRequire("eYlij");
parcelRequire("d9N42");
var $dkcYJ = parcelRequire("dkcYJ");

var $hu3Tl = parcelRequire("hu3Tl");

var $hrGO1 = parcelRequire("hrGO1");

var $daYeb = parcelRequire("daYeb");

var $4XErw = parcelRequire("4XErw");

var $3F38X = parcelRequire("3F38X");

var $1RK9J = parcelRequire("1RK9J");

var $7t0tI = parcelRequire("7t0tI");
const $8b32bb2e3a52fb0a$export$2b19a4f5a8b03e05 = ({ hamsProductKey: hamsProductKey = "", signupURL: signupURL = (0, $hrGO1.SIGNUP_CTA_URL), ccpPricingData: ccpPricingData, hamsPricingData: hamsPricingData, countryCode: countryCode = (0, $hrGO1.DEFAULT_COUNTRY_ISO_CODE), localeISOCode: localeISOCode = "en-US", messages: messages })=>{
    const { productPlans: productPlans, defaultUnitCount: defaultUnitCount, enterpriseMinimumCount: enterpriseMinimumCount = (0, $hrGO1.DefaultPlanLimits).UNIT_MIN_ENTERPRISE, contactURL: contactURL = (0, $hrGO1.CONTACT_CTA_URL) } = (0, $eYlij.usePriceFinderContext)();
    const currencyISOCode = (0, $hu3Tl.COUNTRY_CODE_TO_CURRENCY)[countryCode] || (0, $hrGO1.DEFAULT_CURRENCY_ISO_CODE);
    const initialFetchPriceCalcs = (0, $1RK9J.usePriceFinderRequests)(hamsProductKey, productPlans, enterpriseMinimumCount, defaultUnitCount, "MONTHLY");
    const initialPriceCalcs = (0, $1RK9J.usePricing)(ccpPricingData, hamsPricingData, initialFetchPriceCalcs, currencyISOCode, localeISOCode);
    const initialState = {
        unitCount: defaultUnitCount,
        billingCycle: "MONTHLY",
        priceCalcs: initialPriceCalcs,
        currencyISOCode: currencyISOCode,
        messages: messages
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3F38X.PriceFinderContainer), (0, $dPABA._)((0, $6ogO3._)({}, initialState), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4XErw.PriceFinderInputsRedesign), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $daYeb.PriceCardsContainer), {
                    productKey: hamsProductKey,
                    signupURL: signupURL,
                    contactURL: contactURL,
                    hamsProductKey: hamsProductKey,
                    hamsPricingData: hamsPricingData,
                    ccpPricingData: ccpPricingData,
                    localeISOCode: localeISOCode
                })
            ]
        })
    }));
};
const $8b32bb2e3a52fb0a$var$PriceFinderWithFetch = ({ envSource: envSource, hamsProductKey: hamsProductKey = "", messages: messages, contentfulEnvironment: contentfulEnvironment })=>{
    const { dataProductKey: dataProductKey, productPlans: productPlans } = (0, $eYlij.usePriceFinderContext)();
    const offeringSkus = productPlans.map((plan)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return plan.offeringSku;
    }).filter(Boolean);
    const { prices: prices, status: status, fetchData: fetchData } = (0, $dkcYJ.useCCPPriceFinderData)(offeringSkus, envSource["PRODUCT_CATALOG_DELIVERY_KEY"], envSource["PRODUCT_CATALOG_SPACE"], contentfulEnvironment);
    (0, $1oC0p.useEffect)(()=>{
        fetchData();
    }, []);
    const { prices: hamsPrices, status: hamsStatus } = (0, $dkcYJ.useHAMSPriceData)(hamsProductKey, envSource["PRODUCT_CATALOG_DELIVERY_KEY"], envSource["PRODUCT_CATALOG_SPACE"], contentfulEnvironment);
    const { countryCode: countryCode, status: locationStatus } = (0, $hu3Tl.useGeoLocation)(envSource["PRODUCT_CATALOG_LOCATION_BASE_URL"]);
    let forceCountryCode = countryCode;
    if (dataProductKey === "bitbucket") forceCountryCode = (0, $hrGO1.DEFAULT_COUNTRY_ISO_CODE);
    if (locationStatus == "complete" && status == "complete" && hamsStatus == "complete" && prices && hamsPrices && forceCountryCode) return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$export$2b19a4f5a8b03e05, {
        ccpPricingData: prices,
        hamsPricingData: hamsPrices,
        hamsProductKey: hamsProductKey,
        messages: messages,
        countryCode: forceCountryCode
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i5o3v _4cvr1h6o"
        ]),
        children: (0, $g9ZvA.LoadingSpinner)
    });
};
const $8b32bb2e3a52fb0a$var$PriceFinderSection = ({ hamsProductKey: hamsProductKey, serverSideCCPPricing: serverSideCCPPricing, serverSideHAMSPricing: serverSideHAMSPricing, countryCode: countryCode, messages: messages, contentfulEnvironment: contentfulEnvironment })=>{
    if (serverSideCCPPricing && serverSideHAMSPricing && countryCode) return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$export$2b19a4f5a8b03e05, {
        ccpPricingData: serverSideCCPPricing,
        hamsPricingData: serverSideHAMSPricing,
        hamsProductKey: hamsProductKey,
        countryCode: countryCode,
        messages: messages
    });
    // server-side request failed
    if (typeof window !== "undefined") // client side render
    return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$var$PriceFinderWithFetch, {
        hamsProductKey: hamsProductKey,
        messages: messages,
        envSource: window,
        contentfulEnvironment: contentfulEnvironment
    });
    // server side render
    return /*#__PURE__*/ (0, $7VQPk.jsx)($8b32bb2e3a52fb0a$var$PriceFinderWithFetch, {
        hamsProductKey: hamsProductKey,
        envSource: $7t0tI.env,
        messages: messages,
        contentfulEnvironment: contentfulEnvironment
    });
};
var $8b32bb2e3a52fb0a$export$2e2bcd8739ae039 = $8b32bb2e3a52fb0a$var$PriceFinderSection;

});
parcelRegister("daYeb", function(module, exports) {
$parcel$export(module.exports, "PriceCardsContainer", function () { return $beb84d554eee0045$export$631362d6f0b0bcb9; });
/* card-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("5579Q");
var $luVdE = parcelRequire("luVdE");

var $dl2JF = parcelRequire("dl2JF");

var $kooLp = parcelRequire("kooLp");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $hrGO1 = parcelRequire("hrGO1");

var $eYlij = parcelRequire("eYlij");

var $3F38X = parcelRequire("3F38X");

var $1RK9J = parcelRequire("1RK9J");
parcelRequire("i0PNA");
var $l4Rl8 = parcelRequire("l4Rl8");
var $f1eZF = parcelRequire("f1eZF");
const $beb84d554eee0045$export$6d3386d43155b5be = {
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
    justifyContent: "center",
    lineHeight: "24px"
};
const $beb84d554eee0045$export$631362d6f0b0bcb9 = ({ productKey: productKey, signupURL: signupURL, contactURL: contactURL, hamsProductKey: hamsProductKey, hamsPricingData: hamsPricingData, ccpPricingData: ccpPricingData, localeISOCode: localeISOCode })=>{
    var _productPlans__planFeatureMessages, _productPlans_;
    const intl = (0, $8e22h.default)();
    let forcedUsdPricing = undefined;
    const { dataProductKey: dataProductKey, productPlans: productPlans, enterpriseMinimumCount: enterpriseMinimumCount = (0, $hrGO1.DefaultPlanLimits).UNIT_MIN_ENTERPRISE } = (0, $eYlij.usePriceFinderContext)();
    const [{ unitCount: unitCount, billingCycle: billingCycle, currencyISOCode: currencyISOCode }, actions] = (0, $3F38X.usePriceFinderStore)();
    const recommendedPlanName = $beb84d554eee0045$export$623a082ce2e33ce1(unitCount, productPlans);
    const fetchPriceCalcs = (0, $1RK9J.usePriceFinderRequests)(hamsProductKey, productPlans, enterpriseMinimumCount, unitCount, billingCycle);
    if (dataProductKey === "trello") forcedUsdPricing = "USD";
    const finalPriceCalcs = (0, $1RK9J.usePricing)(ccpPricingData, hamsPricingData, fetchPriceCalcs, forcedUsdPricing || currencyISOCode, localeISOCode);
    (0, $1oC0p.useEffect)(()=>{
        actions.updatePriceCalcs(finalPriceCalcs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unitCount,
        billingCycle,
        currencyISOCode
    ]);
    const localizedSignupURL = (0, $kooLp.useLocalizedHref)(signupURL);
    const localizedContactURL = (0, $kooLp.useLocalizedHref)(contactURL);
    const ctaButtonText = intl.formatMessage({
        id: "Pricing.PriceCard.StartFreeTrial",
        defaultMessage: (0, $hrGO1.CtaBtnText).START_FREE_TRIAL
    });
    const getProductPlanProps = (params)=>({
            idx: params.idx,
            productPlan: params.productPlan,
            dataProductKey: dataProductKey,
            recommendedPlanName: recommendedPlanName,
            unitCount: unitCount,
            ctaButtonText: ctaButtonText,
            localizedSignupURL: localizedSignupURL,
            localizedContactURL: localizedContactURL,
            billingCycle: billingCycle,
            currencyISOCode: currencyISOCode,
            productKey: productKey
        });
    const hasFeatures = (_productPlans_ = productPlans[0]) === null || _productPlans_ === void 0 ? void 0 : (_productPlans__planFeatureMessages = _productPlans_.planFeatureMessages) === null || _productPlans__planFeatureMessages === void 0 ? void 0 : _productPlans__planFeatureMessages.length;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $luVdE.PriceCardsStack), {
            sections: hasFeatures ? 2 : 1,
            children: productPlans.map((productPlan, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)($beb84d554eee0045$var$ProductPlanPriceCard, (0, $6ogO3._)({}, getProductPlanProps({
                    idx: idx,
                    productPlan: productPlan
                })), productPlan.planName))
        })
    });
};
// eslint-disable-next-line complexity
const $beb84d554eee0045$var$ProductPlanPriceCard = (props)=>{
    var _offeringSku_toLowerCase_match, _productPlan_signupURLInfo, _productPlans_;
    const intl = (0, $8e22h.default)();
    const contactSalesText = intl.formatMessage({
        id: "Pricing.PriceCard.ContactSales",
        defaultMessage: (0, $hrGO1.CtaBtnText).CONTACT_SALES
    });
    const { productPlan: productPlan, idx: idx, dataProductKey: dataProductKey, recommendedPlanName: recommendedPlanName, unitCount: unitCount, ctaButtonText: ctaButtonText, localizedSignupURL: localizedSignupURL, localizedContactURL: localizedContactURL, billingCycle: billingCycle, currencyISOCode: currencyISOCode, productKey: productKey } = props;
    const { productPlans: productPlans, shouldAddDiscount: shouldAddDiscount, ctaUrlSource: ctaUrlSource } = (0, $eYlij.usePriceFinderContext)();
    const getComparePlanCta = (0, $dl2JF.useGetComparePlanCta)();
    const { signupURLSuffix: signupURLSuffix, planFeatureMessages: planFeatureMessages, description: description, signupLimit: signupLimit, offeringSku: offeringSku } = productPlan;
    const { planTitleComponent: planTitleComponent } = productPlan;
    let { planName: planName } = productPlan;
    let edition = offeringSku === null || offeringSku === void 0 ? void 0 : (_offeringSku_toLowerCase_match = offeringSku.toLowerCase().match(/free|standard|premium|enterprise/)) === null || _offeringSku_toLowerCase_match === void 0 ? void 0 : _offeringSku_toLowerCase_match[0];
    const isHighlighted = planName === recommendedPlanName || productPlans.length === 1;
    let dataEventPropsLabel = `${planName}-start-trial`;
    let ctaBtnText = ctaButtonText;
    let ctaBtnUrl = "";
    let rovoStartTrialUrl = "";
    var _productPlan_signupURLInfo_urlPath;
    const localizedUrlPath = (0, $kooLp.useLocalizedHref)((_productPlan_signupURLInfo_urlPath = (_productPlan_signupURLInfo = productPlan.signupURLInfo) === null || _productPlan_signupURLInfo === void 0 ? void 0 : _productPlan_signupURLInfo.urlPath) !== null && _productPlan_signupURLInfo_urlPath !== void 0 ? _productPlan_signupURLInfo_urlPath : "");
    if (productPlan.signupURLInfo) {
        const { shouldLocalize: shouldLocalize, urlDomain: urlDomain, urlPath: urlPath } = productPlan.signupURLInfo;
        if (shouldLocalize) {
            ctaBtnUrl = `${urlDomain}${localizedUrlPath}`;
            rovoStartTrialUrl = `${urlDomain}${localizedUrlPath}`;
        } else {
            ctaBtnUrl = `${urlDomain}${urlPath}`;
            rovoStartTrialUrl = `${urlDomain}${urlPath}`;
        }
    } else ctaBtnUrl = localizedSignupURL + (signupURLSuffix || "");
    const overSignupLimit = unitCount > (signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT);
    if (offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo || dataProductKey === "rovo") {
        planName = "Rovo";
        if (unitCount > 1000) {
            ctaBtnUrl = localizedContactURL;
            ctaBtnText = contactSalesText;
        }
    }
    const pricingPlanId = "";
    const jpdPremiumUrl = `https://www.atlassian.com/software/jira/product-discovery/premium`;
    if (offeringSku === "jira-product-discovery-premium-sku" && !(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraProductDiscoveryPremiumWacUpdates)) {
        ctaBtnUrl = jpdPremiumUrl;
        ctaBtnText = (0, $hrGO1.CtaBtnText).JOIN_WAITLIST;
    }
    if (dataProductKey === "trello") ctaBtnUrl = (0, $hrGO1.TRELLO_CTA_URL);
    switch(planName){
        case (0, $hrGO1.SpecialPlanNames).STARTER:
        case (0, $hrGO1.SpecialPlanNames).FREE:
            edition = (0, $hrGO1.Edition).FREE;
            dataEventPropsLabel = `${planName}-get-it-now`;
            ctaBtnText = intl.formatMessage({
                id: "Pricing.PriceCard.GetItNow",
                defaultMessage: (0, $hrGO1.CtaBtnText).GET_IT_NOW
            });
            break;
        case (0, $hrGO1.SpecialPlanNames).ENTERPRISE:
            edition = (0, $hrGO1.Edition).ENTERPRISE;
            dataEventPropsLabel = `${planName}-contact-sales`;
            ctaBtnText = contactSalesText;
            ctaBtnUrl = productPlan.signupURLInfo ? ctaBtnUrl : localizedContactURL;
            break;
    }
    const shouldDisableCta = overSignupLimit && planName !== (0, $hrGO1.SpecialPlanNames).FREE && planName !== (0, $hrGO1.SpecialPlanNames).ENTERPRISE;
    const planTitleId = `planTitle_${idx}`;
    const planDescriptionId = `planDesc_${idx}`;
    const ctaId = `planCta_${idx}`;
    const ctaAriaLabelledBy = `${planTitleId} ${planDescriptionId} ${ctaId}`;
    const contentfulCta = getComparePlanCta({
        comparePlanIdx: idx
    });
    let ctaButtonUrl = ctaBtnUrl;
    if ((contentfulCta === null || contentfulCta === void 0 ? void 0 : contentfulCta.ctaUrl) && ctaUrlSource !== "productPlans") ctaButtonUrl = contentfulCta.ctaUrl;
    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage)) {
        const urlWithSignupSource = new URL(ctaButtonUrl, window.location.origin);
        urlWithSignupSource.searchParams.set("signupSource", "pricing");
        ctaButtonUrl = urlWithSignupSource.toString();
    }
    var _contentfulCta_ctaButtonText;
    let ctaButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4Rl8.CtaButton), {
        id: ctaId,
        edition: edition,
        dataProductKey: dataProductKey,
        type: isHighlighted ? "primary" : "secondary",
        text: (_contentfulCta_ctaButtonText = contentfulCta === null || contentfulCta === void 0 ? void 0 : contentfulCta.ctaButtonText) !== null && _contentfulCta_ctaButtonText !== void 0 ? _contentfulCta_ctaButtonText : ctaBtnText,
        dataEventPropsLabel: dataEventPropsLabel,
        url: ctaButtonUrl,
        isDisabled: shouldDisableCta,
        containerId: (0, $hrGO1.PRICE_FINDER_CONTAINER),
        "aria-labelledby": ctaAriaLabelledBy
    });
    if (offeringSku === (0, $hrGO1.CloudOfferingsWithSkus).rovo && unitCount > 1000) ctaButton = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "rovo-double-cta",
        className: (0, $2jatx.default)([
            "_1e0c1txw _zulp14y2"
        ]),
        children: [
            ctaButton,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4Rl8.CtaButton), {
                id: ctaId,
                edition: edition,
                dataProductKey: dataProductKey,
                type: "secondary",
                text: ctaButtonText,
                dataEventPropsLabel: dataEventPropsLabel,
                url: rovoStartTrialUrl,
                isDisabled: overSignupLimit,
                target: "_self",
                "aria-labelledby": ctaAriaLabelledBy,
                containerId: (0, $hrGO1.PRICE_FINDER_CONTAINER)
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f1eZF.PriceCard), {
        planName: planName,
        planTitleComponent: planTitleComponent,
        description: description,
        highlighted: isHighlighted,
        ctaButton: ctaButton,
        planFeatureMessages: planFeatureMessages,
        adjacentLowerTierPlanName: (_productPlans_ = productPlans[idx - 1]) === null || _productPlans_ === void 0 ? void 0 : _productPlans_.planName,
        first: idx === 0,
        last: idx === productPlans.length - 1,
        billingCycle: billingCycle,
        overSignupLimit: overSignupLimit,
        currencyISOCode: currencyISOCode,
        unitCount: unitCount,
        productKey: productKey,
        priceCalcIdx: idx,
        contactURL: localizedContactURL,
        offeringSku: offeringSku,
        enableRecommendation: productPlans.length > 1,
        shouldAddDiscount: shouldAddDiscount,
        pricingPlanId: pricingPlanId,
        edition: edition,
        dataProductKey: dataProductKey
    }, idx);
};
const $beb84d554eee0045$var$getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
    const len = minUnitCounts.length - 1;
    return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
};
const $beb84d554eee0045$export$623a082ce2e33ce1 = (unitCount, productPlans)=>{
    var _productPlans_recommendedPlanIdx;
    const recommendedPlanIdx = $beb84d554eee0045$var$getRecommendedPlanIdx(unitCount, productPlans.map((productPlan)=>productPlan.recommendationLimit));
    var _productPlans_recommendedPlanIdx_planName;
    return (_productPlans_recommendedPlanIdx_planName = (_productPlans_recommendedPlanIdx = productPlans[recommendedPlanIdx]) === null || _productPlans_recommendedPlanIdx === void 0 ? void 0 : _productPlans_recommendedPlanIdx.planName) !== null && _productPlans_recommendedPlanIdx_planName !== void 0 ? _productPlans_recommendedPlanIdx_planName : "";
};

});
parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: "0",
                formattedUnitsAvailableInTier: "0",
                formattedUnitLimitLower: "0",
                formattedUnitLimitUpper: "0",
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? "" : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering === null || offering === void 0 ? void 0 : offering.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === "MONTHLY" && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === "ANNUAL" && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === "MONTHLY" && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === "ANNUAL" && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === "USD" && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        "MONTH",
        "YEAR"
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === "COMMERCIAL" && pricingPlan.activatedWithReason === "DEFAULT_PRICING" && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = "en-US") {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        var _a_unitLimitLower, _b_unitLimitLower;
        return ((_a_unitLimitLower = a.unitLimitLower) !== null && _a_unitLimitLower !== void 0 ? _a_unitLimitLower : 0) - ((_b_unitLimitLower = b.unitLimitLower) !== null && _b_unitLimitLower !== void 0 ? _b_unitLimitLower : 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === "MONTHLY" || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = (finalTier === null || finalTier === void 0 ? void 0 : finalTier.unitLimitUpper) || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>{
    var _prices_find;
    return ((_prices_find = prices.find(({ currency: currency })=>currency === currencyISOCode)) === null || _prices_find === void 0 ? void 0 : _prices_find.unitPrice) || 0;
};

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    var _tiers_;
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: ((_tiers_ = tiers[0]) === null || _tiers_ === void 0 ? void 0 : _tiers_.pricingStrategy) === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});




parcelRegister("4XErw", function(module, exports) {
$parcel$export(module.exports, "PriceFinderInputsRedesign", function () { return $50a9f17dfaed6430$export$f72c1ba1733c641a; });
/* price-finder-inputs-redesign.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $20Gca = parcelRequire("20Gca");

var $eYlij = parcelRequire("eYlij");

var $kbpa7 = parcelRequire("kbpa7");

var $hrGO1 = parcelRequire("hrGO1");

var $3F38X = parcelRequire("3F38X");
const $50a9f17dfaed6430$var$labelStyles = null;
const $50a9f17dfaed6430$var$legendStyles = null;
const $50a9f17dfaed6430$var$inputTermStyle = null;
const $50a9f17dfaed6430$var$radioLabelStyles = null;
const $50a9f17dfaed6430$var$radioStyles = null;
const $50a9f17dfaed6430$var$discountLozengeStyles = null;
const $50a9f17dfaed6430$var$billMeStyles = null;
const $50a9f17dfaed6430$export$f72c1ba1733c641a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [{ unitCount: unitCount, billingCycle: billingCycle, messages: messages }, actions] = (0, $3F38X.usePriceFinderStore)();
    const { isMonthlyBillingOnly: isMonthlyBillingOnly, isAnnualBillingOnly: isAnnualBillingOnly, dataProductKey: dataProductKey } = (0, $eYlij.usePriceFinderContext)();
    (0, $1oC0p.useEffect)(()=>{
        if (isAnnualBillingOnly) actions.updateBillingCycle("ANNUAL");
    }, []);
    const [visualUnitCount, setVisualUnitCount] = (0, $1oC0p.useState)(unitCount);
    (0, $1oC0p.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) actions.updateUnitCount(visualUnitCount);
    }, [
        visualUnitCount,
        actions
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount("");
        // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (e)=>{
        const data = {
            billingCycle: e.target.id,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        actions.updateBillingCycle(e.target.id);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, messages.unitCountInputTextRedesign))
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $2jatx.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $2jatx.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, messages.unitCountInputTerm))
                            })
                        ]
                    }),
                    !isMonthlyBillingOnly && !isAnnualBillingOnly && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("fieldset", {
                            "data-testid": "billing-inputs",
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1n261g80 _zulp7vkz _19itglyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                                    className: (0, $2jatx.default)([
                                        "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                        "_1aax1e5h"
                                    ]),
                                    style: {
                                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.priceFinderInputs.billMeText",
                                        defaultMessage: "Bill me:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                    className: (0, $2jatx.default)([
                                        "_4t3i1osq _1e0c1txw _zulp7vkz _wnej1g80"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                            htmlFor: "MONTHLY",
                                            className: (0, $2jatx.default)([
                                                "_80omtlke _zulpftgi _1e0c1txw _4cvr1h6o"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                    type: "radio",
                                                    id: "MONTHLY",
                                                    "data-testid": "billing-radio-monthly",
                                                    name: "billing",
                                                    checked: billingCycle === "MONTHLY",
                                                    onChange: handleRadioChange,
                                                    className: (0, $2jatx.default)([
                                                        "_bfhki0pe _19it1pkj _2rko1ssb _80omtlke _1e0c1txw _1bsb1tcg _4t3i1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _t9ec1s1q _v564lstf _s7n4jp4b _r06hglyw _858ub0wy _1di64m1f _irr34m1f _z0ai1cbz _1qdg1cbz _18postnw _1hfki0pe _14mj1ssb _aetrb3bt _1peqidpf _qc5o16qv _h0k6rbzz _9e6urbzz _1q44oelr _dhyqkb7n _1jb3u67f _xqvjrbzz _ga64yh40 _sfejglyw _128ydlk8 _1199dlk8 _12gnrbzz _kl6cu67f _1htqn7od _1e7g1m1a"
                                                    ])
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "Pricing.priceFinderInputs.monthly",
                                                    defaultMessage: "Monthly"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _1n261q9c"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("label", {
                                                    htmlFor: "ANNUAL",
                                                    className: (0, $2jatx.default)([
                                                        "_80omtlke _zulpftgi _1e0c1txw _4cvr1h6o"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                                            type: "radio",
                                                            id: "ANNUAL",
                                                            "data-testid": "billing-radio-annual",
                                                            name: "billing",
                                                            checked: billingCycle === "ANNUAL",
                                                            onChange: handleRadioChange,
                                                            className: (0, $2jatx.default)([
                                                                "_bfhki0pe _19it1pkj _2rko1ssb _80omtlke _1e0c1txw _1bsb1tcg _4t3i1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _t9ec1s1q _v564lstf _s7n4jp4b _r06hglyw _858ub0wy _1di64m1f _irr34m1f _z0ai1cbz _1qdg1cbz _18postnw _1hfki0pe _14mj1ssb _aetrb3bt _1peqidpf _qc5o16qv _h0k6rbzz _9e6urbzz _1q44oelr _dhyqkb7n _1jb3u67f _xqvjrbzz _ga64yh40 _sfejglyw _128ydlk8 _1199dlk8 _12gnrbzz _kl6cu67f _1htqn7od _1e7g1m1a"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                            id: "Pricing.priceFinderInputs.anually",
                                                            defaultMessage: "Annually"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_1bsb1ns9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozg1y44 _1p1dangw _1rkb1wdt _1rfm1osq _q5ugidpf _7tldidpf _14adidpf _4uroidpf _11cg1y44 _xsmrusic"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                                        appearance: "inprogress",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                            id: "Pricing.priceFinderInputs.saveUpTo",
                                                            defaultMessage: "SAVE UP TO 17%"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

});


parcelRegister("1qGP5", function(module, exports) {
$parcel$export(module.exports, "createPlanFeatureMessages", function () { return $9f8554c0837366fe$export$8fd76139fda318d8; });

var $7VQPk = parcelRequire("7VQPk");
const $9f8554c0837366fe$export$68568ac1e2cced1f = (highlightedFeatures)=>{
    return highlightedFeatures.map((highlight)=>({
            featureMessage: highlight.highlightedFeatureDetails ? {
                text: highlight.highlightedFeatureTitleExternal,
                content: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: highlight.highlightedFeatureDetails
                        }
                    })
            } : highlight.highlightedFeatureTitleExternal,
            lozengeText: highlight.callOut
        }));
};
const $9f8554c0837366fe$export$8fd76139fda318d8 = (content, planKey)=>{
    const plan = content === null || content === void 0 ? void 0 : content[planKey];
    return (plan === null || plan === void 0 ? void 0 : plan.highlightedFeaturesContainer) ? $9f8554c0837366fe$export$68568ac1e2cced1f(plan.highlightedFeaturesContainer) : [];
};

});

parcelRegister("dj6Rw", function(module, exports) {
$parcel$export(module.exports, "Disclaimer", function () { return $0e39fb2c1741a607$export$74f29a5c5ac28ae1; });
/* disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
const $0e39fb2c1741a607$export$74f29a5c5ac28ae1 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_b961rdnh"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            className: (0, $2jatx.default)([
                "_k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            },
            children: intl.formatMessage({
                id: "StrategyCollectionPriceFinder.disclaimer",
                defaultMessage: "This estimate isn\u2019t binding for either you or Atlassian. Figures shown here are intended to show an estimation of the final price, not the cost after taxes and other potential changes."
            })
        })
    });
};
const $0e39fb2c1741a607$var$containerCss = null;
const $0e39fb2c1741a607$var$textCss = null;

});




parcelRegister("8bbjU", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingPage", function () { return $422294758afc6222$export$ed5df383947f6344; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $cfD82 = parcelRequire("cfD82");
const $422294758afc6222$export$ed5df383947f6344 = (props)=>{
    const { pricingContent: pricingContent, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "teamwork-collection",
        pricingContent: pricingContent,
        // @ts-ignore
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cfD82.TeamworkCollectionPricingPageTemplate), {})
    });
};

});
parcelRegister("cfD82", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingPageTemplate", function () { return $21994d508e20de79$export$dc72c095d5764aad; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");
parcelRequire("g1ccm");
var $djE2J = parcelRequire("djE2J");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $bE8d4 = parcelRequire("bE8d4");
var $2zOxm = parcelRequire("2zOxm");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $jfojT = parcelRequire("jfojT");

var $kooLp = parcelRequire("kooLp");

var $5S2vX = parcelRequire("5S2vX");

var $h1dGc = parcelRequire("h1dGc");

var $dwgHH = parcelRequire("dwgHH");
const $21994d508e20de79$export$dc72c095d5764aad = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const intl = (0, $8e22h.default)();
    const content = (0, $dl2JF.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1];
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h1dGc.TeamworkCollectionNavbar), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "teamwork-collection-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jfojT.TeamworkCollectionPricingHero), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dwgHH.TeamworkCollectionPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "teamworkCollection"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $djE2J.AtlassianGuardAddOnShared), {
                    headingText: intl.formatMessage({
                        id: "TeamworkCollection.pricing.atlassianGuard.heading",
                        defaultMessage: "Teamwork Collection Premium and Enterprise include Atlassian Guard Standard"
                    }),
                    bodyText: "",
                    ctaHref: (0, $kooLp.useLocalizedHref)("/software/guard")
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: "Teamwork Collection",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("g1ccm", function(module, exports) {
$parcel$export(module.exports, "PricingTabs", function () { return (parcelRequire("9RHgs")).PricingTabs; });
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("baTp3")).DataCenterSection; });
$parcel$export(module.exports, "QuestionsCta", function () { return (parcelRequire("frz5c")).QuestionsCta; });
$parcel$export(module.exports, "DemoAddOn", function () { return (parcelRequire("1jOvc")).DemoAddOn; });
$parcel$export(module.exports, "AtlassianGuardAddOnShared", function () { return (parcelRequire("djE2J")).AtlassianGuardAddOnShared; });

var $kYeRR = parcelRequire("kYeRR");
parcelRequire("h9b6O");
parcelRequire("9RHgs");
parcelRequire("21Gmw");
parcelRequire("gqa4z");
parcelRequire("8Bcrk");
parcelRequire("jQCkx");
parcelRequire("frz5c");
parcelRequire("1jOvc");
parcelRequire("djE2J");

});
parcelRegister("kYeRR", function(module, exports) {
/* pricing-tiers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $1341a3436472bd20$var$sectionCss = null;
const $1341a3436472bd20$var$headerCss = null;
const $1341a3436472bd20$var$cardsWrapperCss = null;
const $1341a3436472bd20$var$cardWrapperCss = null;
const $1341a3436472bd20$var$costCss = null;
const $1341a3436472bd20$var$costAndQuantityColor = "#172b4d";
const $1341a3436472bd20$var$costLabelCss = null;
const $1341a3436472bd20$var$quantityCss = null;
const $1341a3436472bd20$var$footerWrapperCss = null;
const $1341a3436472bd20$var$PricingCard = ({ ctaEmphasis: ctaEmphasis, tier: tier, cost: cost, costLabel: costLabel, quantity: quantity, cta: cta, ctaUrl: ctaUrl, description1: description1, description2: description2, linkText: linkText, linkUrl: linkUrl })=>{
    const cardHeaderCss = [
        ctaEmphasis && null,
        !ctaEmphasis && null
    ];
    const ctaCss = [
        ctaEmphasis && null,
        !ctaEmphasis && null
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhkcd5j _1h6d1hxd _16qso5yx _2rko1y44 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _vwz411nn _y3gn1h6o _ca0qidpf _u5f3idpf _n3td1l27 _19bvidpf"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    ctaEmphasis && "_bfhk1hxd _1wyb1k8s _k48pbfng _1dyznl7k _vwz411ph _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f31crf _n3td1tcg _19bv1crf _1bsb1osq",
                    !ctaEmphasis && "_11q7glyw _1wyb1k8s _k48pbfng _1dyznl7k _vwz411ph _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1tcg _u5f31crf _n3td1tcg _19bv1crf _1bsb1osq"
                ]),
                children: tier
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ect41pz4 _1wyb1ady _k48pni7l _vwz4kb7n _6rth1crf _1pfh1ylp"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: cost
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syazalr3 _1wyb1k92 _vwz4cjiy"
                ]),
                children: costLabel
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syazalr3 _1wyboxwj _vwz411nn"
                ]),
                children: quantity
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: ctaUrl,
                className: (0, $2jatx.default)([
                    ctaEmphasis && "_bfhkrbzz _syaz12cp _k48pbfng _irr31cml _4cvx1cml _19it36id _2rko1l7b _1e0c1ule _1wyb7vkz _vwz4bs82 _6rth1tcg _1pfhzwfg _ca0qh72c _u5f37vkz _n3tdh72c _19bv7vkz _4bfu1snc _1hmsagmp _ajmmvv82 _v564p9y3",
                    !ctaEmphasis && "_bfhk1j28 _syaz1pd3 _k48p1nn1 _irr34m1f _4cvx1cml _19it36id _2rko1l7b _1e0c1ule _1wyb7vkz _vwz4bs82 _6rth1tcg _1pfhzwfg _ca0qh72c _u5f37vkz _n3tdh72c _19bv7vkz _4bfu1snc _1hmsagmp _ajmmvv82 _v564p9y3"
                ]),
                children: cta
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: description1
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: description2
            }),
            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: linkUrl,
                children: linkText
            })
        ]
    });
};
const $1341a3436472bd20$export$8db7662682d3869a = ({ header: header, cards: cards, footer: footer })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1yd3vbgk _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _1q51vbgk _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _xlt1idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1s18ahaf _14b5f2ck _syaz1bqd _ect41pz4 _k48pbfng _vwz411ph _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qzwfg _u5f37vkz _n3tdckbl _19bv7vkz _y3gn1h6o _1cqs1k8s _1u2qzwfg _1rfm1osq"
                ]),
                style: {
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1fhb _1e0c1txw _zulpzwfg _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _1gde1bp4 _q5ugidpf _7tld1wug _14adidpf _4uro1wug _1rfmf2ck _bna31osq"
                ]),
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($1341a3436472bd20$var$PricingCard, (0, $6ogO3._)({}, card), `PricingCard-${index}`))
            }),
            footer && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _bfhkcd5j _1h6d1hxd _16qso5yx _2rko1y44 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _vwz411nn _y3gn1h6o _ca0qidpf _u5f3idpf _n3td1l27 _19bvidpf",
                    "_19pkzwfg _2hwx7vkz _otyrzwfg _18u07vkz _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _25gb1ylp _u9mw1ylp _13e01ylp _182g1ylp"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: footer
            })
        ]
    });
};
var $1341a3436472bd20$export$2e2bcd8739ae039 = $1341a3436472bd20$export$8db7662682d3869a;

});

parcelRegister("9RHgs", function(module, exports) {
$parcel$export(module.exports, "PricingTabs", function () { return $85217f2010396a88$export$72a589327a08c3da; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $a9CD6 = parcelRequire("a9CD6");

var $1OyVz = parcelRequire("1OyVz");

var $hK1eD = parcelRequire("hK1eD");

var $98rQm = parcelRequire("98rQm");

var $iyxHK = parcelRequire("iyxHK");
parcelRequire("7g1ev");
var $gGOh9 = parcelRequire("gGOh9");
const $85217f2010396a88$var$tabStyles = null;
const $85217f2010396a88$export$72a589327a08c3da = ({ jiraCalculatorComponent: jiraCalculatorComponent, confluenceCalculatorComponent: confluenceCalculatorComponent, trelloCalculatorComponent: trelloCalculatorComponent, loomCalculatorComponent: loomCalculatorComponent, teamworkCollectionComponent: teamworkCollectionComponent, dataProductKey: dataProductKey, banner: banner })=>{
    const intl = (0, $8e22h.default)();
    const defaultProductKey = "nonProfitCalculator";
    const defaultJiraCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Jira Component"
        });
    const defaultConfluenceCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Confluence Component"
        });
    const defaultTrelloCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Trello Component"
        });
    const defaultLoomCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const defaultTeamworkCollectionCalculatorComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: "Default Loom Component"
        });
    const JiraComponent = jiraCalculatorComponent !== null && jiraCalculatorComponent !== void 0 ? jiraCalculatorComponent : defaultJiraCalculatorComponent;
    const ConfluenceComponent = confluenceCalculatorComponent !== null && confluenceCalculatorComponent !== void 0 ? confluenceCalculatorComponent : defaultConfluenceCalculatorComponent;
    const TrelloComponent = trelloCalculatorComponent !== null && trelloCalculatorComponent !== void 0 ? trelloCalculatorComponent : defaultTrelloCalculatorComponent;
    const LoomComponent = loomCalculatorComponent !== null && loomCalculatorComponent !== void 0 ? loomCalculatorComponent : defaultLoomCalculatorComponent;
    const TeamworkCollectionComponent = teamworkCollectionComponent !== null && teamworkCollectionComponent !== void 0 ? teamworkCollectionComponent : defaultTeamworkCollectionCalculatorComponent;
    const possibleTabs = [
        {
            id: "jira",
            textLabel: intl.formatMessage({
                id: "PricingTabs.jira",
                defaultMessage: "Jira"
            }),
            component: typeof JiraComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(JiraComponent, {}) : JiraComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(jiraCalculatorComponent)
        },
        {
            id: "confluence",
            textLabel: intl.formatMessage({
                id: "PricingTabs.confluence",
                defaultMessage: "Confluence"
            }),
            component: typeof ConfluenceComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(ConfluenceComponent, {}) : ConfluenceComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9CD6.ConfluenceMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(confluenceCalculatorComponent)
        },
        {
            id: "loom",
            textLabel: intl.formatMessage({
                id: "PricingTabs.loom",
                defaultMessage: "Loom"
            }),
            component: typeof LoomComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(LoomComponent, {}) : LoomComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hK1eD.LoomMarkBrandV2), {
                className: "logoSize"
            }),
            isAvailable: Boolean(loomCalculatorComponent)
        },
        {
            id: "trello",
            textLabel: intl.formatMessage({
                id: "PricingTabs.trello",
                defaultMessage: "Trello"
            }),
            component: typeof TrelloComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(TrelloComponent, {}) : TrelloComponent,
            iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $98rQm.TrelloMarkBrand), {
                className: "logoSize"
            }),
            isAvailable: Boolean(trelloCalculatorComponent)
        },
        {
            id: "teamwork-collection",
            elementLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_161tnagk _1lve1osq _1m8i1w81 _1pww1wug _eaz5idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyxHK.CollectionTeamworkLogoBrandV3), {})
            }),
            textLabel: intl.formatMessage({
                id: "PricingTabs.teamworkCollection",
                defaultMessage: "Teamwork Collection"
            }),
            component: typeof TeamworkCollectionComponent === "function" ? /*#__PURE__*/ (0, $7VQPk.jsx)(TeamworkCollectionComponent, {}) : TeamworkCollectionComponent,
            isAvailable: Boolean(teamworkCollectionComponent)
        }
    ];
    const tabs = possibleTabs.filter((tab)=>tab.isAvailable);
    const defaultBanner = intl.formatMessage({
        id: "tabGroup.banner",
        defaultMessage: "showing 75% off"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq _1kde1ule _5pbc1f4h _mp6aglyw _1v4zidpf _1n3n1osq _si4cgrf3 _1p4fgrf3 _r7togrf3 _17a1grf3 _1ypridpf _n8lpka7h _9ss6idpf _cy2pka7h _11cq1txw _1b5s1h6o _1rvg1h6o _jmjjr3uz _inr21rga _u4d1idpf _1v9nh2mm _7l98t94y _1bvkvle5 _1gvk1x1l _150515x9 _1afqkb7n _1b7v1crf _pu7u1crf _kqje1crf _16vm1crf _rclkls4b _12lk189y _f40hcd5j _wx5ocd5j _1lxt1hdd _xaq61hdd _qr3omwu3 _1xrymwu3 _1lx01r31 _xx3h1r31 _1lleglyw _dqzjglyw _u4pp1o36 _12t91o36 _1s6ccs5v _1jp7cs5v _1lp7bsef _2g4515iw _dt8dglyw _929l14y2 _15uvglyw _1schglyw _1qmzglyw _1fv4glyw _a47gglyw _fp1f7vkz _ipo11crf _mzrv1git _1plp1osq _1ckkidpf _o6gx1wug _1bmhidpf _196a1wug _mzhvidpf _113widpf _12kyidpf _1vg7idpf _w4c110yn _9kzd10yn _1qsfglyw _fe4v7vkz _1x987vkz _1pqlidpf _1lp010j7"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_sse8eq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark900")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gGOh9.TabsCustom), {
            id: "pricingtabs",
            label: "pricing tabs",
            headerText: "",
            bodyText: "",
            className: "pricing-tabs",
            tabs: tabs,
            dataProductKey: dataProductKey !== null && dataProductKey !== void 0 ? dataProductKey : defaultProductKey,
            banner: banner !== null && banner !== void 0 ? banner : defaultBanner
        })
    });
};
$85217f2010396a88$export$72a589327a08c3da.displayName = "TabbedCalculatorSection";

});
parcelRegister("hK1eD", function(module, exports) {
$parcel$export(module.exports, "LoomMarkBrandV2", function () { return $f58adaea274070d6$export$e783a4d8175ce805; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");
const $f58adaea274070d6$export$e783a4d8175ce805 = (_param)=>{
    var { width: width = "100%", height: height = "100%", className: className } = _param, rest = (0, $aPnCa._)(_param, [
        "width",
        "height",
        "className"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", (0, $dPABA._)((0, $6ogO3._)({
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M41 22.1094H31.0579L39.6682 17.1383L37.7774 13.8622L29.167 18.8334L34.1371 10.2237L30.861 8.33173L25.891 16.9414V7H22.109V16.9423L17.137 8.33173L13.862 10.2228L18.833 18.8324L10.2227 13.8622L8.33169 17.1373L16.942 22.1085H7V25.8906H16.9411L8.33169 30.8617L10.2227 34.1378L18.8321 29.1676L13.8611 37.7772L17.137 39.6682L22.1081 31.0577V41H25.8901V31.0586L30.8601 39.6682L34.136 37.7772L29.1651 29.1667L37.7754 34.1378L39.6664 30.8617L31.057 25.8915H40.998V22.1094H41ZM24 29.1437C21.1483 29.1437 18.8368 26.8324 18.8368 23.9805C18.8368 21.1287 21.1483 18.8172 24 18.8172C26.8517 18.8172 29.1631 21.1287 29.1631 23.9805C29.1631 26.8324 26.8517 29.1437 24 29.1437Z",
            fill: "#625DF5"
        })
    }));
};
$f58adaea274070d6$export$e783a4d8175ce805.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).number
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string
};

});

parcelRegister("7g1ev", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gGOh9")).TabsCustom; });

var $gGOh9 = parcelRequire("gGOh9");

});
parcelRegister("gGOh9", function(module, exports) {
$parcel$export(module.exports, "TabsCustom", function () { return $e3221c0f304a7ad7$export$da3a983bae6b9d3a; });
/* tabs-custom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");
parcelRequire("kaZQn");
var $2CA9S = parcelRequire("2CA9S");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
const $e3221c0f304a7ad7$var$CustomTabsStyle = null;
const $e3221c0f304a7ad7$export$da3a983bae6b9d3a = ({ id: id, label: label, headerText: headerText, bodyText: bodyText, tabs: tabs, dataProductKey: dataProductKey, colors: colors, ctaProps: ctaProps, linkPosition: linkPosition = "bottom", backgroundProperties: backgroundProperties, className: className, banner: banner })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.StyledBackground), (0, $dPABA._)((0, $6ogO3._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1yt41d5t _13zni5hb _15tx1jx0",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2CA9S.TabGroup), {
                        colors: colors,
                        tabContentType: "custom",
                        tabs: tabs,
                        id: id,
                        label: label,
                        dataProductKey: dataProductKey,
                        banner: banner
                    })
                }),
                linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $dPABA._)((0, $6ogO3._)({}, ctaProps.primaryLinkProps), {
                            text: ctaProps.primaryLinkProps.text,
                            "aria-label": ctaProps.primaryLinkProps.text
                        }))
                    })
                }) : null
            ]
        })
    }));
};

});
parcelRegister("2tb46", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return (parcelRequire("2ivuE")).ContentBlock; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("2ivuE")).ContentBlock; });

var $2ivuE = parcelRequire("2ivuE");

});
parcelRegister("2ivuE", function(module, exports) {
$parcel$export(module.exports, "ContentBlock", function () { return $20f7f25677f4cd05$export$eb38b3b9c7f5f31b; });
/* content-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $20Gca = parcelRequire("20Gca");

var $5qUgh = parcelRequire("5qUgh");

var $6SdoX = parcelRequire("6SdoX");

var $7y4Rg = parcelRequire("7y4Rg");
parcelRequire("jmley");
var $gfjAv = parcelRequire("gfjAv");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $fJP6M = parcelRequire("fJP6M");

var $imIsw = parcelRequire("imIsw");
function $20f7f25677f4cd05$var$getHeaderTag(text, header, lozenge, lozengeAppearance) {
    const headerTag = header ? header : "h3";
    const headerText = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            text,
            lozenge && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_ahbqftgi _1e0c1o8l"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _s7n4nkob"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                        appearance: lozengeAppearance,
                        children: lozenge
                    })
                })
            })
        ]
    });
    const style = lozenge ? {
        style: {
            display: "inline-block"
        }
    } : null;
    return /*#__PURE__*/ (0, $1oC0p.createElement)(headerTag, style, headerText);
}
/* Gives p tag  so that page structure follows HTML semantic ordering */ function $20f7f25677f4cd05$var$getEyebrowTag(// @ts-ignore
headerType, eyebrowText) {
    return /*#__PURE__*/ (0, $1oC0p.createElement)(`p`, {
        className: "contentBlock-eyebrow"
    }, eyebrowText);
}
function $20f7f25677f4cd05$var$renderLinks({ ctaProps: ctaProps, product: product, edition: edition }) {
    if (!ctaProps) return null;
    let firstLink;
    if ("buttonProps" in ctaProps && "text" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), (0, $6ogO3._)({}, ctaProps.buttonProps));
    else if ("buttonProps" in ctaProps && "variant" in ctaProps.buttonProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), (0, $6ogO3._)({}, ctaProps.buttonProps));
    else if ("primaryLinkProps" in ctaProps && ctaProps.primaryLinkProps) firstLink = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $6ogO3._)({}, ctaProps.primaryLinkProps));
    const secondaryLink = "secondaryLinkProps" in ctaProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $6ogO3._)({}, ctaProps.secondaryLinkProps)) : null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
        intentType: "button",
        containerId: "ctaSection",
        edition: edition,
        productKey: product === null || product === void 0 ? void 0 : product.key,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: "contentBlock-linkFlex",
            children: [
                firstLink,
                secondaryLink
            ]
        })
    });
}
/**
 * This method retrieves either the eyebrow or icon decoration. If both are present, the icon is returned.
 * @param headerType
 */ const $20f7f25677f4cd05$var$getDecoration = (headerType, eyebrowText, iconName, iconColor, iconSize)=>{
    if (iconName) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Icon), {
        name: iconName,
        color: iconColor,
        size: iconSize
    });
    else if (eyebrowText) return $20f7f25677f4cd05$var$getEyebrowTag(headerType, eyebrowText);
    return null;
};
const $20f7f25677f4cd05$var$getImage = (pictureProps, imageLink, imageAltText, aspectRatio)=>{
    if (pictureProps) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), (0, $6ogO3._)({}, pictureProps))
    });
    else if (imageLink && imageAltText) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: "img-section",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Image), {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        })
    });
    else return null;
};
const $20f7f25677f4cd05$var$isHtml = (text)=>{
    return text.startsWith("<") && text.endsWith(">") && text.includes("</");
};
const $20f7f25677f4cd05$export$eb38b3b9c7f5f31b = ({ headerText: headerText, isBannerRichText: isBannerRichText = false, lozenge: lozenge, lozengeAppearance: lozengeAppearance = "inprogress", bodyText: bodyText, bodyComponent: bodyComponent, headerType: headerType = "h3", eyebrowText: eyebrowText, className: className = "", imageLink: imageLink, imageAltText: imageAltText, pictureProps: pictureProps, iconName: iconName, iconColor: iconColor, iconSize: iconSize, ctaProps: ctaProps, aspectRatio: aspectRatio = "1/1", orientation: orientation, cardStyle: cardStyle, isCentered: isCentered = false, horizontalRule: horizontalRule })=>{
    const { product: product, edition: edition } = (0, $7y4Rg.useProductIntent)();
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            isBannerRichText && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType === "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _a5ip1osq _1ma11kwk _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation === "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c11p5 _yv0e1ewx _zulp1j6v _1s8mi47z _1wm0idpf _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType === "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _q7gq1k92 _ecfq8ypw _1csa1pz4 _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1h6o _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1h6o _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _z5ukgktf _1boagktf _16itgktf _ad5cgktf _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            !isBannerRichText && !isCentered && orientation !== "horizontal" && !cardStyle && headerType !== "h1" && "_1e0c1txw _2lx21bp4 _1br3idpf _1xqk1ule _1wmp1osq _1ma11kwk _1xqd1e5h _1l641txw _h8su1bp4 _eapqidpf _9r7vidpf _q4m21tcg _9n8yidpf _1twlbfng _l5k1bfng _r8ntbfng _1a7kbfng _5gkfbfng _1kwrbfng _1xd23ei5 _17z43ei5 _1axi3ei5 _1euy3ei5 _c9nz3ei5 _1lbi3ei5 _1vfh1wto _1av5yn4p _1ivkahaf _11ebyn4p _1x1p8pqr _1kllahaf _ggmh1k8s _8kc91k92 _zcqx19ii _1ysr1kwk _1blq1kwk _ujmh1ns9 _14hp1ns9 _bpspbfng _1q9tbfng _1uu11nn1 _1qefoqnp _1adhni7l _15jf17lu _crcvangw _wd3k1mrw _q2dt1pz4 _1ctm1mrw _1sci1txw _1wrb1g80 _10sm9by0 _13mw1y6m _6o9b1h6o",
            `content-block ${className}`
        ]),
        style: {
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
        },
        children: [
            $20f7f25677f4cd05$var$getImage(pictureProps, imageLink, imageAltText, aspectRatio),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "text-section",
                children: [
                    headerText && $20f7f25677f4cd05$var$getHeaderTag(headerText, headerType, lozenge, lozengeAppearance),
                    $20f7f25677f4cd05$var$getDecoration(headerType, eyebrowText, iconName, iconColor, iconSize),
                    horizontalRule && /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                        className: (0, $2jatx.default)([
                            "_4t3iyh40 _p12f1fra"
                        ])
                    }),
                    bodyText ? typeof bodyText === "string" && $20f7f25677f4cd05$var$isHtml(bodyText) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6SdoX.SanitizedRichText), {
                        innerHTML: bodyText
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "contentBlock-body",
                        children: bodyText
                    }) : null,
                    !bodyText && bodyComponent && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "contentBlock-body",
                        children: bodyComponent
                    }),
                    $20f7f25677f4cd05$var$renderLinks({
                        ctaProps: ctaProps,
                        product: product,
                        edition: edition
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("kaZQn", function(module, exports) {
$parcel$export(module.exports, "TabGroup", function () { return (parcelRequire("2CA9S")).TabGroup; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("2CA9S")).TabGroup; });

var $2CA9S = parcelRequire("2CA9S");

});
parcelRegister("2CA9S", function(module, exports) {
$parcel$export(module.exports, "TabGroup", function () { return $0e9f48a434f4cddf$export$85fd4ed3b8ca1010; });
/* tab-group.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $1ka2O = parcelRequire("1ka2O");
parcelRequire("fl7Kz");
var $92jF6 = parcelRequire("92jF6");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $imIsw = parcelRequire("imIsw");
parcelRequire("8EEDU");
var $hBYvx = parcelRequire("hBYvx");
const $0e9f48a434f4cddf$var$bannerStyle = null;
const $0e9f48a434f4cddf$var$TabGroupStyle = null;
const $0e9f48a434f4cddf$var$quoteSidebar = null;
const $0e9f48a434f4cddf$var$tabPanel = null;
const $0e9f48a434f4cddf$var$contentBlockStyle = null;
const $0e9f48a434f4cddf$var$cardRules = {
    6: 1,
    5: 2,
    4: 2,
    3: 3,
    2: 4
};
const $0e9f48a434f4cddf$var$CardStyleDisplay = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        children: tab.cards.map((card, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), (0, $dPABA._)((0, $6ogO3._)({}, card), {
                aspectRatio: tab.cards.length < 3 ? "16/9" : "3/2"
            }), index);
        })
    });
};
const $0e9f48a434f4cddf$export$625d95e4189a6523 = (props)=>{
    var _tabDisplay_videoProps_videoLink, _tabDisplay_imageProps_src, _tabDisplay_imageProps_alt;
    const tabDisplay = props.tab.display;
    let elementToDisplay = null;
    if ("videoProps" in tabDisplay && ((_tabDisplay_videoProps_videoLink = tabDisplay.videoProps.videoLink) === null || _tabDisplay_videoProps_videoLink === void 0 ? void 0 : _tabDisplay_videoProps_videoLink.length)) elementToDisplay = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), (0, $6ogO3._)({}, tabDisplay.videoProps));
    else if ("imageProps" in tabDisplay && ((_tabDisplay_imageProps_src = tabDisplay.imageProps.src) === null || _tabDisplay_imageProps_src === void 0 ? void 0 : _tabDisplay_imageProps_src.length) && ((_tabDisplay_imageProps_alt = tabDisplay.imageProps.alt) === null || _tabDisplay_imageProps_alt === void 0 ? void 0 : _tabDisplay_imageProps_alt.length)) elementToDisplay = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Image), (0, $dPABA._)((0, $6ogO3._)({}, tabDisplay.imageProps), {
        alt: tabDisplay.imageProps.alt
    }));
    else if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(tabDisplay)) elementToDisplay = tabDisplay;
    return elementToDisplay;
};
const $0e9f48a434f4cddf$export$82b8d343c504672 = (props)=>{
    var _props_colors;
    const backgroundImageColor = ((_props_colors = props.colors) === null || _props_colors === void 0 ? void 0 : _props_colors.quoteColor) ? `linear-gradient(90deg, transparent, ${props.colors.quoteColor})` : "transparent";
    const quoteWrapperClass = props.isDisplayInSmScreen ? "quote-wrapper isDisplayInSmScreen" : "quote-wrapper";
    const quoteStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_y3gn1e5h _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _ca0q1ul9 _u5f312am _n3td1ul9 _19bvidpf _2rko1ygb _1itk1mlj _urbdidpf _bh33qgp8 _z1c11pz4 _1r1x8n31 _sjb1gktf _1pntidpf _1pugidpf _s3jyidpf _177hangw _1i5midpf _utopidpf _rggridpf _1ie3idpf _14sxoxwj _1uc8angw _sugaglyw _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _p0bo1ule",
            quoteWrapperClass
        ]),
        style: {
            "--_xnxqej": (0, $6ZVlx.default)(backgroundImageColor),
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
        },
        children: [
            props.image ? props.image : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-blurb",
                children: props.quote
            }),
            props.name ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-name",
                children: props.name
            }) : null,
            props.company ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: "quote-company",
                children: props.company
            }) : null
        ]
    });
};
const $0e9f48a434f4cddf$var$QuoteTextImage = (tab, colors)=>{
    var _tab_headerTextType;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
        layout: "4-8",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1e5h"
                ]),
                children: [
                    tab.headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: (_tab_headerTextType = tab.headerTextType) !== null && _tab_headerTextType !== void 0 ? _tab_headerTextType : "h3",
                        iconName: tab.iconName,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3"
                        ])
                    }) : null,
                    tab.quote ? /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$export$82b8d343c504672, {
                        image: tab.quoteImageProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Image), (0, $dPABA._)((0, $6ogO3._)({}, tab.quoteImageProps), {
                            alt: tab.quoteImageProps.alt
                        })),
                        quote: tab.quote,
                        name: tab.name,
                        company: tab.company,
                        isDisplayInSmScreen: tab.isDisplayQuoteInSmScreen || false,
                        colors: colors
                    }) : null,
                    tab.ctaProps && tab.ctaProps.primaryLinkProps ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $6ogO3._)({
                        "aria-label": tab.ctaProps.primaryLinkProps.ariaLabel
                    }, tab.ctaProps.primaryLinkProps)) : null
                ]
            }),
            $0e9f48a434f4cddf$export$625d95e4189a6523({
                tab: tab
            })
        ]
    });
};
const $0e9f48a434f4cddf$var$TextImageFullWidth = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            children: [
                tab.headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_p12f1osq _19pkidpf _2hwx1wug _otyr1tcg _18u01wug _gltebxu3",
                        "content-block"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: tab.headerText,
                        bodyText: tab.bodyText,
                        headerType: "h2",
                        isCentered: true
                    })
                }) : null,
                $0e9f48a434f4cddf$export$625d95e4189a6523({
                    tab: tab
                })
            ]
        })
    });
};
const $0e9f48a434f4cddf$var$TabContent = (tabContentType, tab, tabsLength, colors)=>{
    const cardRule = $0e9f48a434f4cddf$var$cardRules[tabsLength];
    switch(tabContentType){
        case "custom":
            if (!("component" in tab)) throw new Error("Must provide a `customComponent` JSX node");
            return tab.component;
        case "cards":
            if (!("cards" in tab)) throw new Error("Must provide an array of card values in the `cards` tab prop");
            else if (tab.cards.length > cardRule) throw new Error(`For a group of ${tabsLength} tabs, no more than ${cardRule} cards per tab`);
            return $0e9f48a434f4cddf$var$CardStyleDisplay(tab);
        case "quoteTextImage":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $0e9f48a434f4cddf$var$QuoteTextImage(tab, colors);
        case "textImageFullWidth":
            if (!("display" in tab)) throw new Error("Please provide image or video props");
            return $0e9f48a434f4cddf$var$TextImageFullWidth(tab);
        default:
            return null;
    }
};
const $0e9f48a434f4cddf$var$updateURL = (tabId)=>{
    const newParams = new URLSearchParams(window.location.search);
    if (tabId) {
        newParams.set("tab", tabId);
        window.history.pushState({}, "", `?${newParams.toString()}`);
    }
};
const $0e9f48a434f4cddf$var$getTabStyle = (colors, isActive)=>{
    if (isActive) return {
        backgroundColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || (0, $kbpa7.wacToken)("color.extended.blue200"),
        color: (colors === null || colors === void 0 ? void 0 : colors.activeText) || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        borderColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverBG: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverText: (colors === null || colors === void 0 ? void 0 : colors.activeText) || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        activeBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || (0, $kbpa7.wacToken)("color.extended.blue200")
    };
    return {
        backgroundColor: (colors === null || colors === void 0 ? void 0 : colors.defaultBG) || (0, $kbpa7.wacToken)("color.neutral.light100"),
        color: (colors === null || colors === void 0 ? void 0 : colors.defaultText) || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        borderColor: "transparent",
        hoverBG: (colors === null || colors === void 0 ? void 0 : colors.hoverBG) || (0, $kbpa7.wacToken)("color.neutral.light200"),
        hoverText: (colors === null || colors === void 0 ? void 0 : colors.hoverText) || (0, $kbpa7.wacToken)("color.extended.blue1000"),
        activeBGColor: (colors === null || colors === void 0 ? void 0 : colors.activeBG) || (0, $kbpa7.wacToken)("color.extended.blue200"),
        hoverBGColor: (colors === null || colors === void 0 ? void 0 : colors.hoverBG) || (0, $kbpa7.wacToken)("color.neutral.light200")
    };
};
const $0e9f48a434f4cddf$var$TabGroupInner = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, setCurrentTab: setCurrentTab })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    var _tab_iconBefore;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        role: "tab",
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-controls": tab.id,
        id: tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-label-english": tab.dataLabelEnglish,
        "data-product-key": dataProductKey,
        onClick: (event)=>{
            setCurrentTab(index);
            $0e9f48a434f4cddf$var$updateURL(tab.id);
            if (onDesktopClickHandler) onDesktopClickHandler(event);
        },
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: [
            (_tab_iconBefore = tab.iconBefore) !== null && _tab_iconBefore !== void 0 ? _tab_iconBefore : tab.iconBefore,
            tab.isForceDisplayTextLabelOnPill ? tab.textLabel : tab.elementLabel ? tab.elementLabel : "headerText" in tab ? tab.headerText : tab.textLabel
        ]
    }, `tab-${index}-${tab.id}`);
};
const $0e9f48a434f4cddf$var$TabOption = ({ index: index, currentTab: currentTab, tab: tab, colors: colors, dataProductKey: dataProductKey })=>{
    const isActive = index === currentTab;
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
        "data-index": index,
        "data-id": tab.id,
        "data-event-component": "linkButton",
        "data-event-container": "tabContent",
        "data-event": "clicked",
        "data-label": tab.textLabel,
        "data-product-key": dataProductKey,
        value: tab.textLabel,
        "aria-selected": index === currentTab,
        "aria-describedby": `tab-${tab.id}`,
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn"
        ]),
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: tab.isForceDisplayTextLabelOnPill ? tab.textLabel : tab.elementLabel ? tab.elementLabel : "headerText" in tab ? tab.headerText : tab.textLabel
    }, `option-${index}-${tab.id}`);
};
const $0e9f48a434f4cddf$var$TabSelect = ({ id: id, currentTab: currentTab, tabs: tabs, colors: colors, updateURL: updateURL, onMobileChangeHandler: onMobileChangeHandler, setCurrentTab: setCurrentTab, dataProductKey: dataProductKey })=>{
    var _tabs_currentTab, _tabs_;
    const isActive = true; // Always active for TabSelect
    const { activeBGColor: activeBGColor, hoverBGColor: hoverBGColor, backgroundColor: backgroundColor, color: color, borderColor: borderColor, hoverBG: hoverBG, hoverText: hoverText } = $0e9f48a434f4cddf$var$getTabStyle(colors, isActive);
    const tabStyle = null;
    const handleChange = (event)=>{
        var _event_target_selectedOptions_, _event_target, _event_target_selectedOptions_1, _event_target1;
        const selectedIndex = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : (_event_target_selectedOptions_ = _event_target.selectedOptions[0]) === null || _event_target_selectedOptions_ === void 0 ? void 0 : _event_target_selectedOptions_.dataset["index"];
        const selectedId = event === null || event === void 0 ? void 0 : (_event_target1 = event.target) === null || _event_target1 === void 0 ? void 0 : (_event_target_selectedOptions_1 = _event_target1.selectedOptions[0]) === null || _event_target_selectedOptions_1 === void 0 ? void 0 : _event_target_selectedOptions_1.dataset["id"];
        setCurrentTab(Number(selectedIndex));
        updateURL(selectedId);
        if (onMobileChangeHandler) onMobileChangeHandler(event);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("select", {
        id: id,
        className: (0, $2jatx.default)([
            "_80omtlke _2rko12am _vchhusvi _1y1m1u8q _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _r06hglyw _1dqonqa1 _189eyh40 _1h6d1j28 _ect41td8 _1dyz1d98 _1seqidpf _zecv1wug _1uldidpf _1pp41wug _3zq41ule _1blx1osq _3p1c1k92 _so7d1qy7 _bfhkaxbu _syaz1aj3 _jomr10a2 _irr310a2 _f8pj7ny5 _30l37ny5 _858u1srq _4cvx1srq _mizu1r31 _ra3xglyw _128midpf _pojj1w4s _q4ztj7jn",
            "select"
        ]),
        value: ((_tabs_currentTab = tabs[currentTab]) === null || _tabs_currentTab === void 0 ? void 0 : _tabs_currentTab.textLabel) || ((_tabs_ = tabs[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.textLabel),
        onChange: handleChange,
        style: {
            "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
            "--_1ylxx6h": (0, $6ZVlx.default)(color),
            "--_mf9og": (0, $6ZVlx.default)(hoverBG),
            "--_3siqzd": (0, $6ZVlx.default)(hoverText),
            "--_37cwmb": (0, $6ZVlx.default)(borderColor),
            "--_1kkre8f": (0, $6ZVlx.default)(activeBGColor),
            "--_h2utlw": (0, $6ZVlx.default)(hoverBGColor)
        },
        children: tabs.map((tab, index)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabOption, {
                index: index,
                tab: tab,
                colors: colors,
                dataProductKey: dataProductKey,
                currentTab: currentTab
            }, `option-${index}-${tab.id}`);
        })
    });
};
const $0e9f48a434f4cddf$export$85fd4ed3b8ca1010 = (props)=>{
    var _tabsMap_currentTab, _tabsMap_currentTab1;
    const { tabContentType: tabContentType, tabs: tabs, colors: colors, id: id, label: label, dataProductKey: dataProductKey, onDesktopClickHandler: onDesktopClickHandler, onMobileChangeHandler: onMobileChangeHandler, banner: banner } = props;
    const location = (0, $1ka2O.useLocation)();
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(()=>{
        var _location_search;
        const params = new URLSearchParams((_location_search = location.search) !== null && _location_search !== void 0 ? _location_search : window.location.search);
        const paramID = params.get("tab");
        const matchingTab = tabs.findIndex((tab)=>{
            return tab.id === paramID;
        });
        if (matchingTab >= 0) return matchingTab;
        return 0;
    });
    if (!id || !label) throw new Error('"id" and "label" props are required for accessibility!');
    if (tabs.length > 6 || tabs.length < 1) throw new Error("Must have a minimum of 1 and a maximum of 6 tabs per group!");
    const tabsMap = tabs.reduce(function(map, obj, index) {
        map[index] = obj;
        return map;
    }, {});
    // eslint-disable-next-line react/no-unstable-nested-components
    const MobileSelect = ()=>{
        const selectContainerColor = (colors === null || colors === void 0 ? void 0 : colors.activeText) ? colors.activeText : (0, $kbpa7.wacToken)("color.extended.blue1000");
        const selectContainerStyles = null;
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bah1h6o _suga1txw _181nglyw _12xhh2mm _d7qx1osq _c2wd1pna _qj6jstnw _14z6gktf _7x8didpf _jm44idpf _wppf1wug _6mc91wug _1yyz1wug _c8mx1wug _1vd7171q",
                "select-container"
            ]),
            style: {
                "--_1uth3n3": (0, $6ZVlx.default)(selectContainerColor)
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "select-container-inner",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: id,
                        "aria-label": label,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabSelect, {
                            id: id,
                            currentTab: currentTab,
                            tabs: tabs,
                            colors: colors,
                            updateURL: $0e9f48a434f4cddf$var$updateURL,
                            setCurrentTab: setCurrentTab,
                            dataProductKey: dataProductKey,
                            onMobileChangeHandler: onMobileChangeHandler
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "15",
                        height: "8",
                        viewBox: "0 0 15 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M1.5 1L7.5 7L13.5 1",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_p12f1osq",
            "tab-group"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_sugaglyw _1cj31txw _196r1h6o _270t1g80 _wmdl7vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: "tab-group-inner",
                        children: [
                            tabs.map((tab, index)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)($0e9f48a434f4cddf$var$TabGroupInner, {
                                    tab: tab,
                                    index: index,
                                    colors: colors,
                                    dataProductKey: dataProductKey,
                                    onDesktopClickHandler: onDesktopClickHandler,
                                    setCurrentTab: setCurrentTab,
                                    currentTab: currentTab
                                }, `tab-${index}-${tab.id}`);
                            }),
                            banner && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1crf _syazcd5j _11q717la _y3gn1h6o _1bsb1osq _1dyzt94y _k48pni7l _vwz4f6fq _ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _1p1dangw"
                                ]),
                                style: {
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                },
                                children: banner
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)(MobileSelect, {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "tab-panels",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkgktf _2hwx1wug _otyridpf _18u01wug _mderglyw",
                        "tab-panel"
                    ]),
                    "aria-hidden": false,
                    id: `tab-${(_tabsMap_currentTab = tabsMap[currentTab]) === null || _tabsMap_currentTab === void 0 ? void 0 : _tabsMap_currentTab.id}`,
                    children: $0e9f48a434f4cddf$var$TabContent(tabContentType, tabsMap[currentTab], tabs.length, colors)
                }, `tabpanel-${currentTab}-${(_tabsMap_currentTab1 = tabsMap[currentTab]) === null || _tabsMap_currentTab1 === void 0 ? void 0 : _tabsMap_currentTab1.id}`)
            })
        ]
    });
};

});
parcelRegister("fl7Kz", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return (parcelRequire("92jF6")).Card; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("92jF6")).Card; });

var $92jF6 = parcelRequire("92jF6");

});
parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffffff";
    const cardBackTextColor = textColor !== null && textColor !== void 0 ? textColor : "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_8vvi5m": (0, $6ZVlx.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("8EEDU", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("hBYvx")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hBYvx")).Video; });

var $hBYvx = parcelRequire("hBYvx");

});
parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $6ogO3._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});







parcelRegister("21Gmw", function(module, exports) {
parcelRequire("gIRO7");

});

parcelRegister("gqa4z", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("baTp3")).DataCenterSection; });
parcelRequire("baTp3");

});
parcelRegister("baTp3", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return $beae9ace14d19c79$export$3e74b76dd9e071d6; });
/* data-center-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
const $beae9ace14d19c79$var$ctaButtonStyles = null;
const $beae9ace14d19c79$var$dataCenterSectionContainer = null;
const $beae9ace14d19c79$var$headingStyle = null;
const $beae9ace14d19c79$var$descriptionStyle = null;
const $beae9ace14d19c79$var$rightSection = null;
const $beae9ace14d19c79$var$ctaWrapper = null;
const $beae9ace14d19c79$var$svgStyles = null;
const $beae9ace14d19c79$export$64adec1d96f4a7a4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: `https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg`,
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb112f _4t3i1jj5 _1s4pawd2 _1kne10uk"
        ])
    });
};
const $beae9ace14d19c79$export$3e74b76dd9e071d6 = (props)=>{
    var _props_buttonCta, _props_buttonCta1, _props_linkCta, _props_linkCta1;
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "Pricing.DataCenterSection.title",
        defaultMessage: "Data Center Products"
    });
    const description = intl.formatMessage({
        id: "Pricing.DataCenterSection.description",
        defaultMessage: "Data Center is our self-managed product offering for customers with strict regulatory or security requirements. To learn more about this offering, please contact us."
    });
    const buttonCtaLabel = intl.formatMessage({
        id: "Pricing.DataCenterSection.buttonCta",
        defaultMessage: "Contact Us"
    });
    const linkCtaLabel = intl.formatMessage({
        id: "Pricing.DataCenterSection.linkCta",
        defaultMessage: "Learn more"
    });
    const buttonCtaHref = `https://www.atlassian.com${(0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features")}`;
    const linkCtaHref = `https://www.atlassian.com${(0, $kooLp.useLocalizedHref)("/enterprise/data-center")}`;
    var _props_title, _props_description, _props_buttonCta_href, _props_buttonCta_label, _props_linkCta_label, _props_linkCta_href;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhk17la _mkrz1ohv _1e0c1txw _4cvr1y6m _1bah1h6o _zulpvbgk _ca0q1et3 _u5f313rr _n3td88uy _19bv13rr _2osnqslr _8fz61fdn _tl281et3 _axwi1l27 _1hwcvbgk _sp8t1l27 _1s4p1osq _1gde1bp4"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($beae9ace14d19c79$export$64adec1d96f4a7a4, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syazcd5j _p12fukw8 _8fz61im0"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        id: "data-center-section-heading",
                        className: (0, $2jatx.default)([
                            "_1wybzwfg _vwz410mc _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9"
                        ]),
                        children: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1wyb7vkz _vwz41tcg _6rth1tcg"
                        ]),
                        children: (_props_description = props.description) !== null && _props_description !== void 0 ? _props_description : description
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _zulp7vkz _1gde1bp4 _1rfmwz92"
                        ]),
                        children: [
                            props.buttonCta !== null && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                size: "small",
                                variant: "secondary",
                                color: "white",
                                colorAgainst: "other",
                                href: (_props_buttonCta_href = (_props_buttonCta = props.buttonCta) === null || _props_buttonCta === void 0 ? void 0 : _props_buttonCta.href) !== null && _props_buttonCta_href !== void 0 ? _props_buttonCta_href : buttonCtaHref,
                                className: (0, $2jatx.default)([
                                    "_4t3i1ylp _1bsbwz92 _o5721q9c"
                                ]),
                                children: (_props_buttonCta_label = (_props_buttonCta1 = props.buttonCta) === null || _props_buttonCta1 === void 0 ? void 0 : _props_buttonCta1.label) !== null && _props_buttonCta_label !== void 0 ? _props_buttonCta_label : buttonCtaLabel
                            }),
                            props.linkCta !== null && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                bgColor: "bgBlackBlue",
                                text: (_props_linkCta_label = (_props_linkCta = props.linkCta) === null || _props_linkCta === void 0 ? void 0 : _props_linkCta.label) !== null && _props_linkCta_label !== void 0 ? _props_linkCta_label : linkCtaLabel,
                                href: (_props_linkCta_href = (_props_linkCta1 = props.linkCta) === null || _props_linkCta1 === void 0 ? void 0 : _props_linkCta1.href) !== null && _props_linkCta_href !== void 0 ? _props_linkCta_href : linkCtaHref,
                                id: "data-center-section-link",
                                ariaLabelledby: "data-center-section-link data-center-section-heading"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$beae9ace14d19c79$export$3e74b76dd9e071d6.displayName = "DataCenterSection";

});


parcelRegister("8Bcrk", function(module, exports) {
/* addon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $aSr2F = parcelRequire("aSr2F");

var $2fk4i = parcelRequire("2fk4i");
const $addc509816787790$var$addonContainerCss = null;
const $addc509816787790$var$sectionLeftCss = null;
const $addc509816787790$var$sectionRightCss = null;
const $addc509816787790$var$headingTextCss = null;
const $addc509816787790$var$bodyTextCss = null;
const $addc509816787790$var$featureListCss = null;
const $addc509816787790$var$featureListItemCss = null;
const $addc509816787790$export$b4fbd0ed3ac70e71 = ({ logo: logo, heading: heading, subheading: subheading, features: features, learnMore: learnMore, imgSrc: imgSrc, imgAlt: imgAlt })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _2rkogktf _bfhku67f _16qsdtw3 _zulpftgi _1bsb1osq _p12f16yw _9959vrvc _a64kzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: logo
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybqslr _k48p1nn1 _vwz41f4h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q51183y _kqswh2mm"
                        ]),
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q511y44"
                        ]),
                        children: subheading
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1pfh183y _6rth1tcg"
                        ]),
                        children: features.map((feature, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvrv2br _zulpftgi _1q511y44"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aSr2F))), {
                                        label: "",
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: feature
                                    })
                                ]
                            }, index))
                    }),
                    learnMore && /* eslint-disable-next-line @atlassian/a11y/anchor-has-content,@atlassian/a11y/link-name */ /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: learnMore.text,
                        type: "primary",
                        href: learnMore.href,
                        onClick: learnMore.onClick
                    })
                ]
            }),
            imgSrc && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _je3o1txw _vu061h6o _1i7q10sk"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: imgSrc,
                    alt: imgAlt,
                    height: 268,
                    width: 504
                })
            })
        ]
    });
};
const $addc509816787790$export$e80698ec11357cbb = {
    eventName: "pricingAddonLearnMoreClicked",
    eventType: "ui",
    eventComponent: "linkButton",
    event: "clicked",
    actionSubject: "linkButton",
    actionSubjectId: "pricingAddonLearnMore",
    action: "clicked"
};

});
parcelRegister("aSr2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7eb3ec80aea1436f$var$_react = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7eb3ec80aea1436f$var$_baseNew = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $7eb3ec80aea1436f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7eb3ec80aea1436f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7eb3ec80aea1436f$var$_react.default.createElement($7eb3ec80aea1436f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$7eb3ec80aea1436f$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $7eb3ec80aea1436f$var$_default = module.exports.default = $7eb3ec80aea1436f$var$CheckMarkIcon;

});


parcelRegister("jQCkx", function(module, exports) {
/* addons-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $0a61eed25b4a5849$var$rootCss = null;
const $0a61eed25b4a5849$var$angledEdgeCss = null;
const $0a61eed25b4a5849$var$headingCss = null;
const $0a61eed25b4a5849$var$childrenCss = null;
const $0a61eed25b4a5849$export$ef9150b23047bebe = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_19pkvbgk _2hwx1wug _otyrvbgk _18u01wug _bfhkdoyu _kqswh2mm _p12f194r"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_syazu67f _1wybzwfg _k48p1fw0 _vwz410mc _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1wqb _u5f31tcg _n3tdidpf _19bv1tcg _1s1814no _17gqor1b _1akofhn8 _c7s71tcg _4puvidpf _1r3v1tcg _fz891ylp _1ol9ckbl _h1401wqb"
                ]),
                children: props.heading
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1pbykb7n _p12f194r _1bsb1osq _u7coidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($0a61eed25b4a5849$var$AngledEdgeBackground, {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbycs5v _152tckbl _1e02idpf _rjxpidpf _ahbq1wug _12l21wug _bozgzwfg _y4tizwfg _1e0c1txw _1bah1h6o _4cvr1fhb _2lx2vrvc _zulpzwfg _na0i1bp4 _dh1a1h6o _2osnckbl"
                ]),
                children: props.children
            })
        ]
    });
};
const $0a61eed25b4a5849$var$AngledEdgeBackground = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1312 180",
        fill: "none",
        width: "100%",
        height: "100%",
        className: (0, $2jatx.default)([
            "_kqswh2mm _u7co1bs0"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M0 180L1312 180L1312 0.000114699L5.65586e-06 115.305L0 180Z",
            fill: "white"
        })
    });
};

});

parcelRegister("frz5c", function(module, exports) {
$parcel$export(module.exports, "QuestionsCta", function () { return $a5fd4efc00df1131$export$7874bf850b18c607; });
/* questions-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $imIsw = parcelRequire("imIsw");
const $a5fd4efc00df1131$var$containerCss = null;
const $a5fd4efc00df1131$var$sectionLeftCss = null;
const $a5fd4efc00df1131$var$sectionLeftTextCss = null;
const $a5fd4efc00df1131$var$headingCss = null;
const $a5fd4efc00df1131$var$svgStyles = null;
const $a5fd4efc00df1131$export$7874bf850b18c607 = ({ questionsHeader: questionsHeader, questionsBody: questionsBody, priceAndLicensingLinkText: priceAndLicensingLinkText, ctaHref: ctaHref, imageHref: imageHref = "https://dam-cdn.atl.orangelogic.com/AssetLink/0s31nt386q2lt662011182pvct037sp1.svg", product: product })=>{
    const intl = (0, $8e22h.default)();
    if (!ctaHref || !product && !questionsBody) return null;
    const fallbackQuestionsHeader = intl.formatMessage({
        id: "PricingPage.QuestionsCta.questionsHeader",
        defaultMessage: "Questions?"
    });
    const fallbackQuestionsBody = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingPage.QuestionsCta.questionsBody",
        defaultMessage: "We got answers. Read our full list of common questions and answers for general cloud pricing and licensing or specific {product} pricing and licensing.",
        values: {
            product: product
        }
    });
    const text = intl.formatMessage({
        id: "PricingPage.QuestionsCta.priceAndLicensingLinkText",
        defaultMessage: "See price and licensing page"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1y6m _1bah1h6o _bfhkr3uz _1e0c1txw _syazu67f _1reoewfl _18m9ewfl _ca0qvbgk _u5f31uvc _n3tdvbgk _19bvd3xy _2osnqslr _8fz61fdn _tl28vbgk _axwi1l27 _1hwc1et3 _sp8t1l27 _1gde1sxn _1vth1hhm _mkrz22xr _zulpt9kd"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1y6m _y3gn1e5h _zulp7vkz _85i519bv _xlt110yn"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        "data-testid": "questions-cta-header",
                        className: (0, $2jatx.default)([
                            "_1wybzwfg _vwz410mc _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9",
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsHeader !== null && questionsHeader !== void 0 ? questionsHeader : fallbackQuestionsHeader
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        "data-testid": "questions-cta-body",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsBody !== null && questionsBody !== void 0 ? questionsBody : fallbackQuestionsBody
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: priceAndLicensingLinkText !== null && priceAndLicensingLinkText !== void 0 ? priceAndLicensingLinkText : text,
                        href: ctaHref,
                        anchorProps: {
                            "data-testid": "questions-cta-link"
                        },
                        bgColor: "bgBlackBlue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: imageHref,
                    alt: ""
                },
                className: (0, $2jatx.default)([
                    "_1bsb7l9q _4t3irb92 _1s4pnxnw _1kne1yvi"
                ])
            })
        ]
    });
};
$a5fd4efc00df1131$export$7874bf850b18c607.displayName = "QuestionsCTASection";

});

parcelRegister("1jOvc", function(module, exports) {
$parcel$export(module.exports, "DemoAddOn", function () { return $5702e44d4b94ef8e$export$b100dca757cd91d; });
/* demo-add-on.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $imIsw = parcelRequire("imIsw");
const $5702e44d4b94ef8e$var$containerCss = null;
const $5702e44d4b94ef8e$var$sectionRightCss = null;
const $5702e44d4b94ef8e$var$headingTextCss = null;
const $5702e44d4b94ef8e$var$bodyTextCss = null;
const $5702e44d4b94ef8e$var$svgStyles = null;
const $5702e44d4b94ef8e$export$98641d5fe71eada5 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/rl8k3b0oo518e2ag657731kn07r84m04.svg",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb1qi6 _4t3ii8ts _1s4pvrzy _1kne11yp"
        ])
    });
};
const $5702e44d4b94ef8e$export$b100dca757cd91d = ({ headingText: headingText, bodyText: bodyText, linkText: linkText, ctaHref: ctaHref })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const defaultHeadingText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.heading",
        defaultMessage: "See what Atlassian Guard can do for you"
    });
    const defaultBodyText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.body",
        defaultMessage: "Join our live monthly demo to gain practical guidance for implementing security best practices and controls across Atlassian cloud."
    });
    const defaultLinkText = formatMessage({
        id: "PricingPages.atlassianGuard.demoAddOn.cta",
        defaultMessage: "Register for the demo"
    });
    const handleClick = ()=>{
        if (ctaHref) window.location.href = ctaHref;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        tabIndex: 0,
        onClick: handleClick,
        role: "link",
        onKeyDown: (e)=>{
            if (e.code == "Enter" || e.code == "Space") {
                e.preventDefault();
                handleClick();
            }
        },
        className: (0, $2jatx.default)([
            "_p12f1qhy _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4oahv _1e0c1txw _1bahv2br _2rkovwyg _1gde1bp4 _ag851h6o _8164183y _133ixy5q _s51s1ejb _16qszucj _v56416gf _1dbz1cd0 _zulpoahv",
            "_80om2v03"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
            "--_1ivi1ch": (0, $6ZVlx.default)(ctaHref ? "pointer" : "default")
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($5702e44d4b94ef8e$export$98641d5fe71eada5, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        id: "atlassian-guard-add-on-heading",
                        className: (0, $2jatx.default)([
                            "_1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: headingText !== null && headingText !== void 0 ? headingText : defaultHeadingText
                    }),
                    bodyText !== "" && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: bodyText !== null && bodyText !== void 0 ? bodyText : defaultBodyText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
                        type: "primary",
                        href: ctaHref,
                        id: "atlassian-guard-add-on-cta",
                        ariaLabelledby: "atlassian-guard-addon-cta atlassian-guard-add-on-heading"
                    })
                ]
            })
        ]
    });
};
$5702e44d4b94ef8e$export$b100dca757cd91d.displayName = "DemoAddOnSection";

});

parcelRegister("djE2J", function(module, exports) {
$parcel$export(module.exports, "AtlassianGuardAddOnShared", function () { return $f4f37fc7b98c337e$export$fcf33b8d632fa1db; });
/* atlassian-guard-add-on-shared.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $fz5gy = parcelRequire("fz5gy");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $imIsw = parcelRequire("imIsw");
const $f4f37fc7b98c337e$var$containerCss = null;
const $f4f37fc7b98c337e$var$sectionRightCss = null;
const $f4f37fc7b98c337e$var$atlassianGuardLogoContainerCss = null;
const $f4f37fc7b98c337e$var$headingTextCss = null;
const $f4f37fc7b98c337e$var$bodyTextCss = null;
const $f4f37fc7b98c337e$var$svgStyles = null;
const $f4f37fc7b98c337e$export$5cd54d97896804b4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xxlo4l61p3fn223u1nahuu4r6r3ug1a2.svg",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsbvrzy _4t3i11yp _glte1qi6 _165ti8ts"
        ])
    });
};
const $f4f37fc7b98c337e$export$fcf33b8d632fa1db = ({ headingText: headingText, bodyText: bodyText, linkText: linkText, ctaHref: ctaHref })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const defaultHeadingText = formatMessage({
        id: "PricingPagesTeam.atlassianGuard.heading",
        defaultMessage: "Safeguard your mission-critical data"
    });
    const defaultBodyText = formatMessage({
        id: "PricingPagesTeam.atlassianGuard.body",
        defaultMessage: "Add Atlassian Guard for enhanced security and visibility across your Atlassian cloud products. Set proactive security policies, quickly detect suspicious behavior, and take action with suggested remediation steps to protect your most valuable work. Additionally, with a Cloud Enterprise plan, you get support for multiple identity providers (IdPs) and Atlassian Guard Standard."
    });
    const defaultLinkText = formatMessage({
        id: "PricingPages.atlassianGuard.cta",
        defaultMessage: "Learn more"
    });
    const handleClick = ()=>{
        if (ctaHref) window.location.href = ctaHref;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "atlassianGuardAddOnShared",
        tabIndex: 0,
        onClick: handleClick,
        role: "link",
        onKeyDown: (e)=>{
            if (e.code == "Enter" || e.code == "Space") {
                e.preventDefault();
                handleClick();
            }
        },
        className: (0, $2jatx.default)([
            "_p12f1qhy _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4oahv _1e0c1txw _2rkovwyg _4cvr1h6o _1gde1bp4 _8164183y _133ixy5q _s51s1ejb _16qszucj _v56416gf _1dbz1cd0 _zulpoahv _80omtlke"
        ]),
        style: {
            "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($f4f37fc7b98c337e$export$5cd54d97896804b4, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3ixy5q _1752xy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fz5gy.GuardLogo), {
                            appearance: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        id: "atlassian-guard-add-on-heading",
                        className: (0, $2jatx.default)([
                            "_1wyb1tcg _k48p1fw0 _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: headingText !== null && headingText !== void 0 ? headingText : defaultHeadingText
                    }),
                    bodyText !== "" && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1io3"
                        ]),
                        style: {
                            "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                        },
                        children: bodyText !== null && bodyText !== void 0 ? bodyText : defaultBodyText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: linkText !== null && linkText !== void 0 ? linkText : defaultLinkText,
                        type: "primary",
                        href: ctaHref,
                        id: "atlassian-guard-add-on-cta",
                        ariaLabelledby: "atlassian-guard-add-on-cta atlassian-guard-add-on-heading"
                    })
                ]
            })
        ]
    });
};
$f4f37fc7b98c337e$export$fcf33b8d632fa1db.displayName = "AtlassianGuardAddOn";

});
parcelRegister("fz5gy", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", function () { return $b54e359ca5207dcd$export$a4a891d202775deb; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $b54e359ca5207dcd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $b54e359ca5207dcd$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b54e359ca5207dcd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});



parcelRegister("jfojT", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingHero", function () { return $e2d3685819b80935$export$11d510446f2a0235; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $e2d3685819b80935$export$11d510446f2a0235 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg",
            alt: "Teamwork Collection"
        },
        products: [
            {
                name: "Jira",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg",
                    alt: "Jira"
                }
            },
            {
                name: "Confluence",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg",
                    alt: "Confluence"
                }
            },
            {
                name: "Loom",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg",
                    alt: "Loom"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});
parcelRegister("e0LCf", function(module, exports) {
$parcel$export(module.exports, "CollectionPricingHero", function () { return $2a773e3b9098f7a0$export$8065869e82d5a4c7; });
/* collection-pricing-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $8A3gV = parcelRequire("8A3gV");
const $2a773e3b9098f7a0$var$horizontalOrientationCss = null;
const $2a773e3b9098f7a0$var$verticalOrientationCss = null;
const $2a773e3b9098f7a0$var$logoCss = null;
const $2a773e3b9098f7a0$var$verticalLogoCss = null;
const $2a773e3b9098f7a0$export$8065869e82d5a4c7 = (props)=>{
    const orientation = props.orientation || "horizontal";
    const messages = (0, $8A3gV.useCollectionPricingHeroMessages)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1f2ygktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1ns9 _p12fuoas"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1yt417la _1lp7vrvc _19wgxy5q _6yttgfpe"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: props.collectionImage.src,
                                    alt: props.collectionImage.alt,
                                    height: props.collectionImage.height,
                                    width: props.collectionImage.width
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1crf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect4bzd7 _1wyb19bv _k48p1nn1 _1p1dangw _syaz1yg0 _vwz47vkz _y3gn1h6o _uj6k18uv"
                                    ]),
                                    style: {
                                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                                    },
                                    children: messages.includes
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        orientation === "horizontal" ? "_1e0c11p5 _yv0efsjm _2z05im57 _zulpxy5q _gy1pxy5q _1p57pxbi _ect41pz4 _k48p1nn1 _1wyb1wbj" : "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                    },
                                    children: props.products.map((product, key)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                orientation === "horizontal" ? "_1e0c1txw _4cvr1h6o _zulp12x7 _1bsb1n5l" : "_1e0c1txw _4cvr1h6o _4t3igktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                    image: {
                                                        src: product.image.src,
                                                        alt: product.image.alt
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_y4ti9pc2"
                                                    ]),
                                                    style: {
                                                        height: "20px",
                                                        "--_s4yu5j": (0, $6ZVlx.default)(orientation === "vertical" ? "var(--ds-space-075, 6px)" : 0)
                                                    }
                                                }),
                                                product.name
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _mqm21djo"
                    ]),
                    style: {
                        "--_w9vrer": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1100"))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1hlo _1e0c1ule _y3gn1h6o _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1fw0 _vwz41ou6 _1yt4zu5n"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: messages.heading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _zulpu2gc _19wgpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k383m26br4w8fu6i68s0qbnym881f0wb.svg",
                                        name: messages.home,
                                        alt: messages.home
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7k15161ensv07cht48h87c31ueh7sh3.svg",
                                        name: messages.goals,
                                        alt: messages.goals
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/51ht267g50ve2d3051aw8nrgs0k11ad6.svg",
                                        name: messages.teams,
                                        alt: messages.teams
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2pqaabre17cu7mx66ydvhplnbt4hh3ub.svg",
                                        name: messages.studio,
                                        alt: messages.studio
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/to7s6r4xr4564x6jhc134qhgevi13wo3.svg",
                                        name: messages.search,
                                        alt: messages.search
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe661ex05dvkmxul5nf4fi1e20hq8063.svg",
                                        name: messages.chat,
                                        alt: messages.chat
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8f6ta76fw1d04u40k8fp622i67154764.svg",
                                        name: messages.analytics,
                                        alt: messages.analytics
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/dv817l8n01hct543cmd030ksu3hfj0k6.svg",
                                        name: messages.admin,
                                        alt: messages.admin
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $2a773e3b9098f7a0$var$Subproduct = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: props.src,
                            alt: props.alt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf"
                ]),
                style: {
                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                },
                children: props.name
            })
        ]
    });
};

});
parcelRegister("8A3gV", function(module, exports) {
$parcel$export(module.exports, "useCollectionPricingHeroMessages", function () { return $6e2ac6bb4e232ff3$export$7c226aa081048b2; });

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");
function $6e2ac6bb4e232ff3$export$7c226aa081048b2() {
    const intl = (0, $8e22h.default)();
    const hardcoded = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8279CollectionHeroIntl);
    if (hardcoded) return $6e2ac6bb4e232ff3$export$22298271baa6ded9(intl.locale);
    return {
        heading: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.platformAppsHeading",
            defaultMessage: "Plus all Atlassian Platform Apps"
        }),
        includes: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.includes",
            defaultMessage: "Includes"
        }),
        home: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.home.alt",
            defaultMessage: "Home"
        }),
        goals: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.goals",
            defaultMessage: "Goals"
        }),
        teams: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.teams",
            defaultMessage: "Teams"
        }),
        studio: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.studio",
            defaultMessage: "Studio"
        }),
        search: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.search",
            defaultMessage: "Search"
        }),
        chat: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.chat",
            defaultMessage: "Chat"
        }),
        analytics: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.analytics",
            defaultMessage: "Analytics"
        }),
        admin: intl.formatMessage({
            id: "TeamworkCollectionPricingPageHero.app.admin",
            defaultMessage: "Admin"
        })
    };
}
function $6e2ac6bb4e232ff3$export$22298271baa6ded9(locale) {
    var _MESSAGES_locale;
    return (_MESSAGES_locale = $6e2ac6bb4e232ff3$var$MESSAGES[locale]) !== null && _MESSAGES_locale !== void 0 ? _MESSAGES_locale : $6e2ac6bb4e232ff3$var$enMessages;
}
const $6e2ac6bb4e232ff3$var$enMessages = {
    home: "Home",
    heading: "Plus all Atlassian Platform Apps",
    includes: "Includes",
    goals: "Goals",
    teams: "Teams",
    studio: "Studio",
    search: "Search",
    chat: "Chat",
    analytics: "Analytics",
    admin: "Admin"
};
const $6e2ac6bb4e232ff3$var$MESSAGES = {
    en: $6e2ac6bb4e232ff3$var$enMessages,
    nl: {
        home: "Home",
        heading: "Plus alle Atlassian Platform-apps",
        includes: "Omvat",
        goals: "Doelstellingen",
        teams: "Teams",
        studio: "Studio",
        search: "Zoeken",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Beheerder"
    },
    es: {
        home: "Inicio",
        heading: "Adem\xe1s de todas las aplicaciones de la plataforma de Atlassian",
        includes: "Incluye",
        goals: "Objetivos",
        teams: "Equipos",
        studio: "Studio",
        search: "Buscar",
        chat: "Chat",
        analytics: "An\xe1lisis",
        admin: "Administrativo"
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        heading: "\u0410 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B Atlassian",
        includes: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442",
        goals: "\u0426\u0435\u043B\u0438",
        teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
        studio: "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
        search: "\u041F\u043E\u0438\u0441\u043A",
        chat: "\u0427\u0430\u0442",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    fr: {
        home: "Accueil",
        heading: "Et toutes les apps de la plateforme Atlassian",
        includes: "Fonctionnalit\xe9s incluses",
        goals: "Objectifs",
        teams: "\xc9quipes",
        studio: "Studio",
        search: "Recherche",
        chat: "Chat",
        analytics: "Analyses",
        admin: "Administrateur"
    },
    ko: {
        home: "\uD648",
        heading: "\uBC0F \uBAA8\uB4E0 Atlassian \uD50C\uB7AB\uD3FC \uC571",
        includes: "\uD3EC\uD568 \uC0AC\uD56D",
        goals: "\uBAA9\uD45C",
        teams: "\uD300",
        studio: "\uC2A4\uD29C\uB514\uC624",
        search: "\uAC80\uC0C9",
        chat: "\uCC44\uD305",
        analytics: "\uBD84\uC11D",
        admin: "\uAD00\uB9AC\uC790"
    },
    br: {
        home: "In\xedcio",
        heading: "Al\xe9m de todos os apps da plataforma Atlassian",
        includes: "Inclui",
        goals: "Metas",
        teams: "Equipes",
        studio: "Studio",
        search: "Pesquisar",
        chat: "Bate-papo",
        analytics: "Dados de An\xe1lise",
        admin: "Admin"
    },
    pl: {
        home: "Strona g\u0142\xf3wna",
        heading: "Plus wszystkie aplikacje platformy Atlassian",
        includes: "Obejmuje",
        goals: "Cele",
        teams: "Zespo\u0142y",
        studio: "Studio",
        search: "Wyszukiwanie",
        chat: "Czat",
        analytics: "Analizy",
        admin: "Administrator"
    },
    de: {
        home: "Home",
        heading: "Plus alle Apps der Atlassian-Plattform",
        includes: "Beinhaltet",
        goals: "Ziele",
        teams: "Teams",
        studio: "Studio",
        search: "Suchen",
        chat: "Chat",
        analytics: "Analysen",
        admin: "Administrator"
    },
    zh: {
        home: "\u9996\u9875",
        heading: "\u4EE5\u53CA\u6240\u6709 Atlassian \u5E73\u53F0\u5E94\u7528",
        includes: "\u5305\u62EC",
        goals: "\u76EE\u6807",
        teams: "\u56E2\u961F",
        studio: "\u5DE5\u4F5C\u5BA4",
        search: "\u641C\u7D22",
        chat: "\u804A\u5929",
        analytics: "\u5206\u6790",
        admin: "\u7BA1\u7406\u5458"
    },
    it: {
        home: "Pagina iniziale",
        heading: "E tutte le app della piattaforma di Atlassian",
        includes: "Include",
        goals: "Obiettivi",
        teams: "Team",
        studio: "Studio",
        search: "Cerca",
        chat: "Chat",
        analytics: "Analisi",
        admin: "Amministratore"
    },
    ja: {
        home: "\u30DB\u30FC\u30E0",
        heading: "\u3055\u3089\u306B\u3059\u3079\u3066\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 \u30A2\u30D7\u30EA",
        includes: "\u30A4\u30F3\u30AF\u30EB\u30FC\u30C9",
        goals: "\u76EE\u6A19",
        teams: "\u30C1\u30FC\u30E0",
        studio: "\u30B9\u30BF\u30B8\u30AA",
        search: "\u691C\u7D22",
        chat: "\u30C1\u30E3\u30C3\u30C8",
        analytics: "\u5206\u6790\u6A5F\u80FD",
        admin: "\u7BA1\u7406\u8005"
    }
};

});



parcelRegister("h1dGc", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionNavbar", function () { return $b27b8dfab4fc1019$export$693b523fb4eb0711; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $l2QYX = parcelRequire("l2QYX");

var $lVpxp = parcelRequire("lVpxp");
const $b27b8dfab4fc1019$export$693b523fb4eb0711 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $dPABA._)((0, $6ogO3._)({}, (0, $lVpxp.CollectionsCompoundSubNavProps)()), {
            ctaUrl: "/collections/teamwork#contact"
        })
    });
};

});

parcelRegister("dwgHH", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPriceFinder", function () { return $21e2f995b3010408$export$9c2caa4596f790ac; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");

var $eYlij = parcelRequire("eYlij");

var $gIRO7 = parcelRequire("gIRO7");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $7aFr7 = parcelRequire("7aFr7");
const $21e2f995b3010408$export$9c2caa4596f790ac = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    // planNames should not be translated
    const productPlans = [
        {
            planName: "Free",
            offeringSku: (0, $7aFr7.offeringSkus).free,
            // @ts-ignore
            description: content.free.planOneLiner,
            recommendationLimit: 0,
            signupLimit: 10,
            planFeatureMessages: freePlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        },
        {
            planName: "Standard",
            offeringSku: (0, $7aFr7.offeringSkus).standard,
            // @ts-ignore
            description: content.standard.planOneLiner,
            recommendationLimit: 0,
            signupLimit: 100000,
            planFeatureMessages: standardPlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        },
        {
            planName: "Premium",
            offeringSku: (0, $7aFr7.offeringSkus).premium,
            // @ts-ignore
            description: content.premium.planOneLiner,
            recommendationLimit: 0,
            signupLimit: 100000,
            planFeatureMessages: premiumPlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        },
        {
            planName: "Enterprise",
            offeringSku: (0, $7aFr7.offeringSkus).enterprise,
            // @ts-ignore
            description: content.enterprise.planOneLiner,
            recommendationLimit: 5000,
            signupLimit: 100000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            signupURLInfo: {
                shouldLocalize: true,
                urlDomain: window.location.origin,
                urlPath: "/collections/teamwork#contact"
            }
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "TeamworkCollectionPriceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "TeamworkCollectionPriceFinder.unitCountInputText",
            defaultMessage: "users"
        },
        cardEnterpriseMinimumCount: {
            id: "TeamworkCollectionPriceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "TeamworkCollectionPriceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardUnitCountTierRange: {
            id: "TeamworkCollectionPriceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "TeamworkCollectionPriceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user/month"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "teamworkCollection",
            productPlans: productPlans,
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.teamworkCollection,
                countryCode: props.countryCode
            })
        })
    });
};

});
parcelRegister("7aFr7", function(module, exports) {
$parcel$export(module.exports, "offeringSkus", function () { return $b5b897d4f7b95ee2$export$b2421372229fc1c9; });
const $b5b897d4f7b95ee2$export$b2421372229fc1c9 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};

});




parcelRegister("806Eh", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactThanksPage", function () { return $6afe4a8234fd5e3b$export$66942264c1afdb2a; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("ghVq4");
var $1vmBr = parcelRequire("1vmBr");
const $6afe4a8234fd5e3b$export$66942264c1afdb2a = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1vmBr.EnterpriseContactThanksPageTemplate), {});

});
parcelRegister("ghVq4", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactThanksPageTemplate", function () { return (parcelRequire("1vmBr")).EnterpriseContactThanksPageTemplate; });

var $1vmBr = parcelRequire("1vmBr");

});
parcelRegister("1vmBr", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactThanksPageTemplate", function () { return $7232d4740c8ebf7f$export$cb652a9a98cba1b2; });
/* enterprise-contact-thanks.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8f0Vj = parcelRequire("8f0Vj");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $eBWBi = parcelRequire("eBWBi");

var $8xKNU = parcelRequire("8xKNU");
const $7232d4740c8ebf7f$var$wrapperStyle = null;
const $7232d4740c8ebf7f$export$cb652a9a98cba1b2 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_vchhusvi _11rm1hrf _1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                            isShowTryNowLink: false,
                            tryNowLinkCtaButtonColor: "light_grey",
                            productKey: "enterpriseContactThanks"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8f0Vj.ContactSalesNav), {
                        showContactSales: true
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eBWBi.default), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8xKNU.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("8f0Vj", function(module, exports) {
$parcel$export(module.exports, "ContactSalesNav", function () { return $cbfc951804659d8d$export$98b85ca48705081; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");
parcelRequire("lzfAX");
var $9D78w = parcelRequire("9D78w");
var $5xvRI = parcelRequire("5xvRI");

var $kooLp = parcelRequire("kooLp");
const $cbfc951804659d8d$export$98b85ca48705081 = ({ showContactSales: showContactSales })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9D78w.ProductNavBar), {
        productHref: (0, $kooLp.useLocalizedHref)("/enterprise"),
        productName: "enterprise",
        showFreeHrefButton: false,
        showTextWithoutLogo: true,
        showContactSalesHrefButton: showContactSales,
        freeHref: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
        ariaLabel: intl.formatMessage({
            id: "contact-sales-thanks.logo-label",
            defaultMessage: "Enterprise"
        }),
        dataProductKey: "enterpriseContactSales",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.overview",
                    defaultMessage: "Overview"
                }),
                href: (0, $kooLp.useLocalizedHref)("/enterprise")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.cloud",
                    defaultMessage: "Cloud"
                }),
                href: (0, $kooLp.useLocalizedHref)("/enterprise/cloud")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.data-center",
                    defaultMessage: "Data Center"
                }),
                href: (0, $kooLp.useLocalizedHref)("/enterprise/data-center")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.services",
                    defaultMessage: "Services"
                }),
                href: (0, $kooLp.useLocalizedHref)("/enterprise/services")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5xvRI.ProductNavLink), {
                label: intl.formatMessage({
                    id: "contact-sales.navbar.resources",
                    defaultMessage: "Resources"
                }),
                href: (0, $kooLp.useLocalizedHref)("/enterprise/resources")
            })
        ]
    });
};
$cbfc951804659d8d$export$98b85ca48705081.displayName = "ContactSalesNav";

});
parcelRegister("lzfAX", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return (parcelRequire("9D78w")).ProductNavBar; });
$parcel$export(module.exports, "ProductNavLink", function () { return (parcelRequire("5xvRI")).ProductNavLink; });

var $9D78w = parcelRequire("9D78w");

var $5xvRI = parcelRequire("5xvRI");

var $7z8Jg = parcelRequire("7z8Jg");

});
parcelRegister("9D78w", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return $b545d9db2ee66805$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $5RBBI = parcelRequire("5RBBI");

var $kbpa7 = parcelRequire("kbpa7");

var $aHkxS = parcelRequire("aHkxS");

var $jMhSx = parcelRequire("jMhSx");

var $2ve7k = parcelRequire("2ve7k");

var $fJP6M = parcelRequire("fJP6M");
const $b545d9db2ee66805$var$navigationWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarCss = null;
const $b545d9db2ee66805$var$logoAndLinksCss = null;
const $b545d9db2ee66805$var$keyframeChevron = null;
const $b545d9db2ee66805$var$removeKeyframeChevron = null;
const $b545d9db2ee66805$var$dropdownSlideInAnimation = null;
const $b545d9db2ee66805$var$dropdownSlideOutAnimation = null;
const $b545d9db2ee66805$var$listItemCss = null;
const $b545d9db2ee66805$var$buttonWrapper = null;
const $b545d9db2ee66805$var$linkAndButtonWrapper = null;
const $b545d9db2ee66805$var$buttonStyle = null;
const $b545d9db2ee66805$var$contactSalesButtonStyle = null;
const $b545d9db2ee66805$var$logoDimensions = {
    confluence: 157,
    jiraservicemanagement: 280,
    jira: 80,
    jirasoftware: 80
};
const $b545d9db2ee66805$export$6bfdc568e00f9e3d = (props)=>{
    const intl = (0, $8e22h.default)();
    var _props_showFreeHrefButton;
    const isShowFreeHrefButton = (_props_showFreeHrefButton = props.showFreeHrefButton) !== null && _props_showFreeHrefButton !== void 0 ? _props_showFreeHrefButton : true;
    var _props_showContactSalesHrefButton;
    const isShowContactSalesHrefButton = (_props_showContactSalesHrefButton = props.showContactSalesHrefButton) !== null && _props_showContactSalesHrefButton !== void 0 ? _props_showContactSalesHrefButton : false;
    var _props_showTextWithoutLogo;
    const showTextWithoutLogo = (_props_showTextWithoutLogo = props.showTextWithoutLogo) !== null && _props_showTextWithoutLogo !== void 0 ? _props_showTextWithoutLogo : false;
    const [activeDropdown, setActive] = (0, $1oC0p.useState)(null);
    const [buttonType, setButtonType] = (0, $1oC0p.useState)("secondary");
    const location = (0, $2ve7k.useLocation)();
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    const handleScroll = ()=>{
        setButtonType(window.scrollY > 56 ? "primary" : "secondary");
    };
    const getItFreeText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    const getContactSalesText = intl.formatMessage({
        id: "productNavBar.contact-sales-button",
        defaultMessage: "Contact sales"
    });
    const dropdownCss = [
        null,
        !activeDropdown && null,
        activeDropdown && null
    ];
    const mobileCategoriesWrapperCss = [
        null,
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const renderSelectionItems = (isMobile)=>{
        const categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8119w _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $1oC0p.Children).map(props.children, (child, index)=>child ? /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                        isSelected: child.props.isSelected || (0, $2ve7k.isEqualUnlocalizedPathname)(child.props.href, location.pathname),
                        isMobile: isMobile
                    })
                }, index) : null)
        });
    };
    const renderDropdownButton = ()=>{
        if (props.children) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: ()=>setActive(!activeDropdown),
            className: (0, $2jatx.default)([
                "_1e0cglyw _80omtlke _bfhk1j28 _19itglyw _syaz1ep1 _1q5112x7 _1752xy5q _w8l5xy5q _48hmq7pw _1mjb1ule",
                !activeDropdown && "",
                !activeDropdown && "_1px1k4ed",
                activeDropdown && "",
                activeDropdown && "_1px1qbue"
            ]),
            style: {
                "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                label: ""
            })
        });
        return null;
    };
    const logoWrapperCss = [
        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth == "" && null,
        null
    ];
    const textWrapperCss = null;
    const textCss = null;
    const boxShadowCss = props.productName !== "confluence" && props.productName !== "jira" && null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1bsb1osq _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1y6m _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o",
                    props.productName !== "confluence" && props.productName !== "jira" && "_16qsg1bn"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yag119w _1vkh8vuz _13zno7np _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15tx119w",
                        "productNavBar"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                showTextWithoutLogo ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        "_4t3i12am _syazvejh _4cvr1h6o _1e0c1txw _2lx2vrvc"
                                    ]),
                                    style: {
                                        "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb166g _k48pbfng"
                                        ]),
                                        children: props.ariaLabel
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth == "" && "_1bsb2lms",
                                        "_4cvr1h6o _1e0c1txw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand",
                                        height: "48",
                                        width: $b545d9db2ee66805$var$logoDimensions[props.productName]
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                isShowFreeHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                        "showFreeHrefButton"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                                        text: getItFreeText,
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getItFreeText,
                                            "data-label-english": "Get it free",
                                            "data-product-key": props.dataProductKey,
                                            "data-track-event": `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                }),
                                isShowContactSalesHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "showContactSalesHrefButton",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                                        text: getContactSalesText,
                                        color: "yellow",
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getContactSalesText,
                                        dataEventProps: {
                                            "data-event-container": "navbar",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-label": getContactSalesText,
                                            "data-product-key": props.dataProductKey
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _11q711ib _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ]),
                                        style: {
                                            "--_1f8eaoq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.yellow400"))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _bfhk1rga _179r1k0a _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown === null && "_1h6du4vp _mqm21k0a",
                    activeDropdown && "",
                    activeDropdown && "_c71l8stt _y44v18yz _1h6dvejh _mqm2yzqy",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1eb4 _1h6du4vp _mqm2yzqy",
                    "mobileCategoriesWrapper"
                ]),
                style: {
                    "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
                    "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000")),
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                },
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $b545d9db2ee66805$export$2e2bcd8739ae039 = $b545d9db2ee66805$export$6bfdc568e00f9e3d;

});
parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $444f1300adfdb621$var$_baseNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});


parcelRegister("5xvRI", function(module, exports) {
$parcel$export(module.exports, "ProductNavLink", function () { return $3331e0af5dabfddc$export$df4f9873dfab197b; });
/* product-navlink.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $3331e0af5dabfddc$var$linkStyle = null;
const $3331e0af5dabfddc$export$df4f9873dfab197b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_18ywh2mm _9c4j1l7b _1hw71ule _19tb1j6v _1la1kb7n _8bvm119w _i7kgzu5n _5i9qrbzz _1x5rusvi _1qxa59zy _1unt1r31 _jsn2glyw _1b4hnqa1 _1mcc10vn _1ry4oelr _906b1osq _1nzh1xjh _1euc119w _3uyxrbzz _1u7j19bv _c12j1r31 _1udz8stv _4ba5nqa1 _1u6y1r31 _14ifglyw _f3mxnqa1 _1sinoelr _jhsausvi _c3hm4m1f _1ohxni7l _4mi7nclz _b4f8nclz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", (0, $dPABA._)((0, $6ogO3._)({
            className: props.isSelected ? "selected" : "",
            href: props.href
        }, props.dataEventProps), {
            "data-label": props.label,
            children: props.label
        }))
    });
};
var $3331e0af5dabfddc$export$2e2bcd8739ae039 = $3331e0af5dabfddc$export$df4f9873dfab197b;

});

parcelRegister("7z8Jg", function(module, exports) {
/* product-navdropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $92PV0 = parcelRequire("92PV0");

var $gw3Bt = parcelRequire("gw3Bt");
const $96f8f1342a672b0a$var$parentItemStyle = null;
const $96f8f1342a672b0a$var$dropdownStyle = null;
const $96f8f1342a672b0a$var$listStyle = null;
const $96f8f1342a672b0a$var$headerStyle = null;
const $96f8f1342a672b0a$var$listItemStyle = null;
const $96f8f1342a672b0a$var$linkStyle = null;
const $96f8f1342a672b0a$var$mobileDropdownStyle = null;
const $96f8f1342a672b0a$export$39cc2d4a9bc14e7d = ({ label: label, isMobile: isMobile = false, groups: groups, dataProductKey: dataProductKey = "jiraSoftware" })=>{
    const [isDropdownVisible, setDropdownVisible] = (0, $1oC0p.useState)(false);
    const [isMobileDropdownVisible, setMobileDropdownVisible] = (0, $1oC0p.useState)(false);
    const dropdownRef = (0, $1oC0p.useRef)(null);
    (0, $gw3Bt.useOutsideEvent)(dropdownRef, "click", ()=>setDropdownVisible(false));
    (0, $gw3Bt.useOutsideEvent)(dropdownRef, "focusin", ()=>setDropdownVisible(false));
    const innerRef = (0, $1oC0p.useRef)(null);
    (0, $gw3Bt.useOutsideEvent)(innerRef, "click", ()=>setDropdownVisible(false));
    (0, $gw3Bt.useOutsideEvent)(innerRef, "focusin", ()=>setDropdownVisible(false));
    const handleTouchEnd = (event)=>{
        event.preventDefault();
        setMobileDropdownVisible((state)=>!state);
    };
    const handleClick = ()=>setMobileDropdownVisible((state)=>!state);
    const handleMouseEnter = ()=>setDropdownVisible(true);
    const handleMouseLeave = ()=>setDropdownVisible(false);
    const handleKeyUp = (event)=>{
        if (event.key === "Enter") setDropdownVisible((state)=>!state);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (isDropdownVisible || isMobileDropdownVisible) (0, $92PV0.Tracking).autoTrackLinks(true);
    }, [
        isDropdownVisible,
        isMobileDropdownVisible
    ]);
    const renderGroups = (dataProductKey)=>groups === null || groups === void 0 ? void 0 : groups.map(({ header: header, items: items, hideHeader: hideHeader }, groupIndex)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h5", {
                            className: (0, $2jatx.default)([
                                "_1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _1wyb1j6v _syaz1bqd _19pk1crf _2hwxidpf _otyridpf _18u0idpf _1p1dangw _k48p1fw0 _vwz410nf _1dyzt94y"
                            ]),
                            children: header
                        })
                    }),
                    items.map(({ label: itemLabel, labelEnglish: itemLabelEnglish, href: href, isSelected: isSelected }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1pfh1crf _6rth1crf _1ohxni7l _ym7n1bqd _zgzju67f"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1j6v _vwz4851k _1e0c1ule _ca0q1y44 _u5f31ul9 _n3td1y44 _19bv1ul9 _o5721q9c _4bfu1r31 _1hmsglyw _ajmmnqa1 _syazrbzz _1l4er3uz _irr3rbzz _30l3u67f",
                                    isSelected ? "selected" : ""
                                ]),
                                href: href,
                                id: `dropdown-${label.toLowerCase()}-${index}`,
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "navbarDropdownLink",
                                "data-product-key": dataProductKey,
                                "data-label": itemLabel,
                                "data-label-english": itemLabelEnglish,
                                children: itemLabel
                            })
                        }, `${itemLabel}-${index}`))
                ]
            }, `${header}-${groupIndex}`));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: dropdownRef,
                onTouchEnd: handleTouchEnd,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onClick: handleClick,
                onFocus: handleMouseEnter,
                onKeyUp: handleKeyUp,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        id: `dropdown-${label.toLowerCase()}`,
                        href: "#",
                        "data-event": "clicked",
                        "data-label": label,
                        "data-event-component": "linkButton",
                        "data-event-container": "navbarDropdown",
                        "data-product-key": dataProductKey,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _152t1l7b _1e0c1txw _4cvr1h6o _1wyb1j6v _vwz4kb7n _syazrbzz _30l3oelr _1b75y6p2 _rtay4h09 _16m51fys _1nbi1f51 _1l3vb3bt _1m5l1o8l _1t6ii2wt _1k6s1crf _1dqh1crf _d6wu1vv5 _1j5e4h09 _1y3ib3bt _1mhxi2wt _1nwwi2wt _fl6h1axk _l23r1axk _u5pl1kw7 _ytugq07a _gs6s19bv _1t7gbf4l _7wutjyd4 _k11laqso _1vie3iz4 _ue5g119w _1yagzu5n _1gs5usvi _v9tz59zy _1s4p1osq _6ssj1xjh _17p3119w _1a5h19bv",
                            isMobileDropdownVisible ? "open" : ""
                        ]),
                        children: label
                    }),
                    !isMobile && isDropdownVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: innerRef,
                        className: (0, $2jatx.default)([
                            "_bfhku67f _19itulfz _2rko1y44 _16qsg1bn _kqswstnw _152t1osq _1e021ssb _t9ec1e6q _1pbyzo7u"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_qtt8glyw _bozgidpf _1q5114y2 _85i514y2 _kqswh2mm _1pbykb7n _1rusu67f _iajmidpf _1g0vidpf _1fkr1osq _z5wt1ssb _14h81fby _1kt9f705 _kfgtidpf _1mp4idpf _1cs8stnw _dsq4glyw _7dwzzr6s _15l21hqi _1bqq1mrw _1guf1osq _g0nf1ssb _eq43105i _aetrf705 _1qdgidpf _z0aiidpf _18postnw _11fnglyw _1cteu67f _clh3zr6s"
                            ]),
                            children: renderGroups(dataProductKey)
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: isMobile && isMobileDropdownVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: innerRef,
                    className: (0, $2jatx.default)([
                        "_1hziidpf _3n4midpf _ltofidpf _k7zyidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        children: renderGroups(dataProductKey)
                    })
                }) : null
            })
        ]
    });
};
var $96f8f1342a672b0a$export$2e2bcd8739ae039 = $96f8f1342a672b0a$export$39cc2d4a9bc14e7d;

});



parcelRegister("eBWBi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edc225729fd9b967$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $edc225729fd9b967$var$outerWrapperStyle = null;
const $edc225729fd9b967$var$rowWrapperStyle = null;
const $edc225729fd9b967$var$columnStyle = null;
const $edc225729fd9b967$var$headerTextStyle = null;
const $edc225729fd9b967$var$descriptionTextSytle = null;
const $edc225729fd9b967$var$imageStyle = null;
const $edc225729fd9b967$export$6e76f8357f41ff9b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Ticket_created@2x_1.webp",
        alt: "Ticket",
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1nu9 _y3gn1h6o _4t3i1qnl _6rth7vkz _p12f1osq _1reozryt _18m9zryt _1bsb1178 _1b3h1ntv _wii51fhb _1rx61osq"
        ])
    });
};
const $edc225729fd9b967$var$Hero = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "enterpriseContactThanksPage.message-recieved",
        defaultMessage: "Message received"
    });
    const descriptionTicketText = intl.formatMessage({
        id: "enterpriseContactThanksPage.creating-ticket",
        defaultMessage: "Our sales team is creating a ticket and will email you within 2 business days."
    });
    const descriptionResourcesText = intl.formatMessage({
        id: "enterpriseContactThanksPage.resources-to-start",
        defaultMessage: "In the meantime, here are some resources to get you started."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _11rm1hrf _1e0c1ule _12qx1osq _85i5zwfg _1q5116xz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vchhusvi _1e0c1txw _1n261g80 _12l21wug _ahbq1wug _p12f1git"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _vchhusvi _1e0c1ule _2lx21bp4 _1aax1e5h _1tket94y _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _y3gn1h6o _1bsbf2ck _1rfm1osq _1fqp1jgg _1ywm1jgg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($edc225729fd9b967$export$6e76f8357f41ff9b, {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1e0c1ule _6rth1tcg _ect41jfk _1wyb1wto _k48pbfng _1dyz4jg8 _vwz41k7u _y3gn1h6o _s7n41q9y _syaz1bqd _flz0yn4p _280zzz36 _1po47vkz _1lzoyn4p _119zzz36 _qtem7vkz _1cqsviql _1bys10nf _srwzdlk8"
                        ]),
                        children: headerText
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1e0c1ule _ect41jfk _1wyb1k92 _k48p1nn1 _1dyznl7k _vwz419ii _y3gn1h6o _s7n41q9y _syazvwuj"
                        ]),
                        children: [
                            descriptionTicketText,
                            /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                            descriptionResourcesText
                        ]
                    })
                ]
            })
        })
    });
};
var $edc225729fd9b967$export$2e2bcd8739ae039 = $edc225729fd9b967$var$Hero;

});

parcelRegister("8xKNU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc961ec8943d3af9$export$2e2bcd8739ae039; });
/* resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $7iXNu = parcelRequire("7iXNu");
const $bc961ec8943d3af9$var$wrapperCardStyle = null;
const $bc961ec8943d3af9$var$resourceCardsStyling = null;
const $bc961ec8943d3af9$var$ResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const roadMapsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.ViewRoadmaps",
        defaultMessage: "View roadmaps"
    });
    const advancedFeaturesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.AdvancedFeatures",
        defaultMessage: "See advanced features"
    });
    const browseResourcesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.BrowseResources",
        defaultMessage: "Browse resources"
    });
    const resourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps",
                defaultMessage: "Feature Roadmaps"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps.dsc",
                defaultMessage: "See what's in our pipeline for Cloud and Data Center products."
            }),
            buttonText: roadMapsText,
            url: (0, $kooLp.useLocalizedHref)("/roadmap/cloud")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium",
                defaultMessage: "Cloud Premium products"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium.dsc",
                defaultMessage: "Learn about advanced product features for enterprises."
            }),
            buttonText: advancedFeaturesText,
            url: (0, $kooLp.useLocalizedHref)("/software/premium")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources",
                defaultMessage: "More enterprise resources"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources.dsc",
                defaultMessage: "View resources, filtered by Cloud and Data Center product features."
            }),
            buttonText: browseResourcesText,
            url: (0, $kooLp.useLocalizedHref)("/enterprise/resources?format=&topic=product-features&platform=")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _11rm1hrf _1e0c1ule _1ul91osq _85i57vkz _1q517vkz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vchhusvi _1e0c1txw _2lx2vrvc _ahbq1wug _12l21wug _p12f1fra _1gde1bp4"
            ]),
            children: resourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), (0, $dPABA._)((0, $6ogO3._)({}, cardProps), {
                    key: cardProps.header,
                    type: "primary",
                    color: "grey"
                })))
        })
    });
};
var $bc961ec8943d3af9$export$2e2bcd8739ae039 = $bc961ec8943d3af9$var$ResourceCards;

});
parcelRegister("7iXNu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $633ccda817580805$export$2e2bcd8739ae039; });
/* resource-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fJP6M = parcelRequire("fJP6M");
const $633ccda817580805$var$resourceCardStyles = {
    primary: {
        white: {
            padding: "24px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "10px",
            borderColor: "#c1c7d0",
            width: "310px"
        },
        grey: {
            height: "100%",
            padding: "40px",
            backgroundColor: "#fafbfc",
            borderRadius: "3px"
        }
    },
    secondary: {}
};
const $633ccda817580805$var$wrapperStyle = null;
const $633ccda817580805$var$headerStyle = null;
const $633ccda817580805$var$descriptionStyle = null;
const $633ccda817580805$var$buttonStyle = null;
const $633ccda817580805$var$ResourceCard = ({ header: header, description: description, buttonText: buttonText, url: url, type: type, color: color })=>{
    const formattedType = type === null || type === void 0 ? void 0 : type.toLowerCase();
    const resourceCardType = formattedType === "secondary" ? "secondary" : "primary";
    const formattedColor = color === null || color === void 0 ? void 0 : color.toLowerCase();
    const resourceCardColor = formattedColor === "grey" ? "grey" : "white";
    const styles = $633ccda817580805$var$resourceCardStyles[resourceCardType][resourceCardColor];
    /* eslint-disable @typescript-eslint/no-non-null-assertion */ const { padding: padding, width: width, height: height, borderStyle: borderStyle, borderRadius: borderRadius, borderWidth: borderWidth, borderColor: borderColor, backgroundColor: backgroundColor } = styles ? styles : $633ccda817580805$var$resourceCardStyles.primary.white;
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ const backgroundStyle = null;
    const templatesTabCardDataEventProps = {
        "data-product-key": "enterpriseContactSales",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked"
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _1e0c1ule _1aax1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1tket94y _ect4czdy _1wyb7vkz _vwz47vkz _s7n41q9y _14b527ks"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_vchhusvi _1e0c1ule _2lx21bp4 _1yt418y6 _1bsb9tg7 _4t3imry4 _1dqo1yif _2rko1qt3 _189e1ywc _bfhkaxbu _1h6d1srq"
            ]),
            style: {
                "--_1xumd0e": (0, $6ZVlx.default)(padding),
                "--_1ea5ebz": (0, $6ZVlx.default)(width),
                "--_roksyz": (0, $6ZVlx.default)(height),
                "--_ahoyl5": (0, $6ZVlx.default)(borderStyle),
                "--_1lnby5": (0, $6ZVlx.default)(borderRadius),
                "--_g1hsiq": (0, $6ZVlx.default)(borderWidth),
                "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                "--_37cwmb": (0, $6ZVlx.default)(borderColor)
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect418zh _1wyb1k92 _k48pbfng _1dyz165v _vwz4cjiy _s7n41q9y _syaz1bqd _qtemdlk8 _1cqs1j6v _srwzdlk8 _1bys10nf"
                    ]),
                    children: header
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect4czdy _1wyb7vkz _k48p1nn1 _vwz4bs82 _syazvwuj _s7n41q9y"
                    ]),
                    children: description
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                        text: buttonText,
                        "aria-label": buttonText,
                        url: url,
                        type: "secondary",
                        color: "whiteblue",
                        dataEventProps: templatesTabCardDataEventProps,
                        className: (0, $2jatx.default)([
                            "_bfhku67f _syazrbzz _vchhusvi _1e0c1o8l _4t3in7od _1tkel07h _85i56mu8 _bozg19bv _y4ti19bv _1q516mu8 _ect418gv _1wyboxwj _k48pbfng _vwz4nqt0 _y3gn1h6o _1hmsglyw _ajmmnqa1 _1keg1wug _3fcw1g80 _s7n41q9y _d5ymcfaq _1dqonqa1 _189et94y _80omtlke _2rko1l7b _qmxj15zi _1y1musvi _qjkj1u8q _1lrw1wug"
                        ])
                    })
                })
            ]
        })
    });
};
var $633ccda817580805$export$2e2bcd8739ae039 = $633ccda817580805$var$ResourceCard;

});





parcelRegister("cv1g1", function(module, exports) {
$parcel$export(module.exports, "EnterpriseLandingPage", function () { return $6815b466a41cc44d$export$da7e1b175932c7dc; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("jMfH8");
var $dbnlr = parcelRequire("dbnlr");
const $6815b466a41cc44d$export$da7e1b175932c7dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dbnlr.EnterpriseLandingPageTemplate), {});
};

});
parcelRegister("jMfH8", function(module, exports) {
$parcel$export(module.exports, "EnterpriseLandingPageTemplate", function () { return (parcelRequire("dbnlr")).EnterpriseLandingPageTemplate; });

var $dbnlr = parcelRequire("dbnlr");

});
parcelRegister("dbnlr", function(module, exports) {
$parcel$export(module.exports, "EnterpriseLandingPageTemplate", function () { return $e09cbf2e00feadf9$export$8cba5fe34aed322c; });

var $7VQPk = parcelRequire("7VQPk");

var $3L8ZR = parcelRequire("3L8ZR");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("k1xqL");
var $a8Jhy = parcelRequire("a8Jhy");

var $jMhSx = parcelRequire("jMhSx");

var $8LaTa = parcelRequire("8LaTa");
parcelRequire("6E42A");
var $evuYk = parcelRequire("evuYk");
var $lZygM = parcelRequire("lZygM");
var $7IS0o = parcelRequire("7IS0o");
var $lYqKy = parcelRequire("lYqKy");
var $6VSBC = parcelRequire("6VSBC");
var $jwbFO = parcelRequire("jwbFO");
var $iDNJX = parcelRequire("iDNJX");
var $1vLxv = parcelRequire("1vLxv");
var $EJqLv = parcelRequire("EJqLv");
var $fuhhv = parcelRequire("fuhhv");
var $6cCqM = parcelRequire("6cCqM");
var $lk2q3 = parcelRequire("lk2q3");
var $u4tJt = parcelRequire("u4tJt");
var $97gok = parcelRequire("97gok");
const $e09cbf2e00feadf9$export$8cba5fe34aed322c = ()=>{
    const shouldShowHeroV2 = (0, $3L8ZR.default).getExperimentValue("wac-enterprise-hero-v2", "value", false);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "enterprise-page",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.TypographyStyles), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6VSBC.EnterprisePageProductNav), {
                        isActive: "overview"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iDNJX.HeroEnterpriseTakeoverTurbo), {}),
                    shouldShowHeroV2 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $EJqLv.HeroV2Section), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1vLxv.HeroSection), {}),
                    shouldShowHeroV2 ? null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $evuYk.BadgesSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $97gok.TabsSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lZygM.CarouselSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fuhhv.PlatformSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lk2q3.StatsSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6cCqM.ResourcesSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a8Jhy.Adg4SectionDivider), {
                        bgColor: "#F0F1F2"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $u4tJt.SupportSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lYqKy.DataCenterSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7IS0o.CtaSection), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwbFO.GartnerDisclaimer), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("k1xqL", function(module, exports) {
$parcel$export(module.exports, "Adg4SectionDivider", function () { return (parcelRequire("a8Jhy")).Adg4SectionDivider; });
$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return (parcelRequire("a8Jhy")).SECTION_DIVIDER_VARIATION; });
parcelRequire("a8Jhy");

});
parcelRegister("a8Jhy", function(module, exports) {
$parcel$export(module.exports, "SECTION_DIVIDER_VARIATION", function () { return $15488782d37e40da$export$89ad02e8b5e6fb05; });
$parcel$export(module.exports, "Adg4SectionDivider", function () { return $15488782d37e40da$export$2446497a3d298a13; });
/* section-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
var $15488782d37e40da$export$89ad02e8b5e6fb05 = /*#__PURE__*/ function(SECTION_DIVIDER_VARIATION) {
    SECTION_DIVIDER_VARIATION["NORMAL"] = "normal";
    SECTION_DIVIDER_VARIATION["REVERSE"] = "reverse";
    SECTION_DIVIDER_VARIATION["FLIP"] = "flip";
    SECTION_DIVIDER_VARIATION["REVERSE_FLIP"] = "reverse-flip";
    return SECTION_DIVIDER_VARIATION;
}({});
const $15488782d37e40da$export$2446497a3d298a13 = ({ bgColor: bgColor = "#1868DB", colorAgainst: colorAgainst = "#FFF", desktopHeight: desktopHeight = 120, tabletHeight: tabletHeight = 80, mobileHeight: mobileHeight = 60, variation: variation })=>{
    const sectionDividerStyles = null;
    const colorBehindDividerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk1tls"
        ]),
        style: {
            "--_1gwlqo7": (0, $6ZVlx.default)(colorAgainst)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_mkrzsrs8 _11q7bs0x _4t3iepwt _1vkh1mjl _tnruenus",
                variation === "reverse" && "_mkrz1fra",
                variation === "flip" && "_mkrz1n6g",
                variation === "reverse-flip" && "_mkrz1vud"
            ]),
            style: {
                "--_1w9snyi": (0, $6ZVlx.default)(bgColor),
                "--_qqqbix": (0, $6ZVlx.default)(desktopHeight, "px"),
                "--_1ly4yra": (0, $6ZVlx.default)(tabletHeight, "px"),
                "--_klg1fm": (0, $6ZVlx.default)(mobileHeight, "px")
            }
        })
    });
};

});


parcelRegister("6E42A", function(module, exports) {
$parcel$export(module.exports, "CtaSection", function () { return (parcelRequire("7IS0o")).CtaSection; });
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("lYqKy")).DataCenterSection; });
$parcel$export(module.exports, "GartnerDisclaimer", function () { return (parcelRequire("jwbFO")).GartnerDisclaimer; });
$parcel$export(module.exports, "HeroSection", function () { return (parcelRequire("1vLxv")).HeroSection; });
$parcel$export(module.exports, "HeroEnterpriseTakeoverTurbo", function () { return (parcelRequire("iDNJX")).HeroEnterpriseTakeoverTurbo; });
$parcel$export(module.exports, "PlatformSection", function () { return (parcelRequire("fuhhv")).PlatformSection; });
$parcel$export(module.exports, "ResourcesSection", function () { return (parcelRequire("6cCqM")).ResourcesSection; });
$parcel$export(module.exports, "StatsSection", function () { return (parcelRequire("lk2q3")).StatsSection; });
$parcel$export(module.exports, "SupportSection", function () { return (parcelRequire("u4tJt")).SupportSection; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("97gok")).TabsSection; });
$parcel$export(module.exports, "CarouselSection", function () { return (parcelRequire("lZygM")).CarouselSection; });
$parcel$export(module.exports, "BadgesSection", function () { return (parcelRequire("evuYk")).BadgesSection; });
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return (parcelRequire("6VSBC")).EnterprisePageProductNav; });
$parcel$export(module.exports, "HeroV2Section", function () { return (parcelRequire("EJqLv")).HeroV2Section; });
parcelRequire("7IS0o");
parcelRequire("lYqKy");
parcelRequire("jwbFO");
parcelRequire("1vLxv");
parcelRequire("iDNJX");
parcelRequire("fuhhv");
parcelRequire("6cCqM");
parcelRequire("lk2q3");
parcelRequire("u4tJt");
parcelRequire("97gok");
parcelRequire("lZygM");
parcelRequire("evuYk");
parcelRequire("6VSBC");
parcelRequire("EJqLv");

});
parcelRegister("7IS0o", function(module, exports) {
$parcel$export(module.exports, "CtaSection", function () { return $11580cc2f6e77cb1$export$a241c84f183c05c2; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $4Jdkw = parcelRequire("4Jdkw");
const $11580cc2f6e77cb1$export$a241c84f183c05c2 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-cta",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1itk11ql _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _vd3yidpf _mla21wug _kubfidpf _3x9r1wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Jdkw.ADG4CtaWithPolygonBackground), {
                header: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.header",
                    defaultMessage: "Build your system of work with Atlassian"
                }),
                ctaText: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.buttonText",
                    defaultMessage: "Contact sales"
                }),
                ctaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                ctaLabel: "Contact sales",
                productKey: "enterprise"
            })
        })
    });
};
const $11580cc2f6e77cb1$var$ctaSectionContainerStyle = null;

});
parcelRegister("4Jdkw", function(module, exports) {
$parcel$export(module.exports, "ADG4CtaWithPolygonBackground", function () { return $07707e85aaf85d14$export$eacf4ba154ffd9bb; });
/* cta-with-polygon-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $5qUgh = parcelRequire("5qUgh");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $07707e85aaf85d14$var$ctaStyles = null;
const $07707e85aaf85d14$var$h3Styles = null;
const $07707e85aaf85d14$var$typographyOverrides = null;
const $07707e85aaf85d14$var$polygonStyles = null;
const $07707e85aaf85d14$export$eacf4ba154ffd9bb = ({ header: header, paragraph: paragraph, ctaText: ctaText, ctaUrl: ctaUrl, ctaLabel: ctaLabel, productKey: productKey, backgroundColor: backgroundColor = "#101214", buttonVariant: buttonVariant = "secondary", buttonColor: buttonColor = "white" })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_p12f1git _18s84p42 _y3gn1h6o",
                "_syaz121t _6rth4cqu",
                sectionIsVisible ? "is-visible" : ""
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    "--background-color": backgroundColor
                },
                className: (0, $2jatx.default)([
                    "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci",
                    "polygon"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1fu0 _vwz41da2 _1cqs1h67 _1jw853lb _1bys1fu0",
                                    "_syaz121t _6rth4cqu",
                                    "header h3"
                                ]),
                                style: {
                                    marginBottom: noParagraphSpacing,
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_syaz121t _6rth4cqu",
                                        ".body-lg"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                    },
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                variant: buttonVariant,
                                color: buttonColor,
                                colorAgainst: backgroundColor == "#101214" ? "black" : "other",
                                href: ctaUrl,
                                dataEventProps: {
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "ctaSection",
                                    "data-label-english": ctaLabel
                                },
                                className: (0, $2jatx.default)([
                                    "_6rthzwfg"
                                ]),
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        })
    });
};

});


parcelRegister("lYqKy", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return $2140f2fe8e065770$export$3e74b76dd9e071d6; });
/* data-center.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $2140f2fe8e065770$export$3e74b76dd9e071d6 = ()=>{
    const intl = (0, $8e22h.default)();
    const dataCenterSectionContent = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.headerText",
            defaultMessage: "Not ready to move to cloud?"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.bodyText",
            defaultMessage: "Atlassian Data Center is our self-managed, enterprise-grade offering designed for organizations with strict security and compliance requirements."
        }),
        linkText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.linkText",
            defaultMessage: "Learn about Data Center"
        }),
        href: (0, $kooLp.useLocalizedHref)("/enterprise/data-center")
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-dataCenter",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_bfhk17fj _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _quu713sl _3int1tcg _4fugzwfg _1ynq1tcg _1j3nzwfg _4sdyiec4 _12ce3739 _1tsvgktf _fd8v1txw _1bwb1q9c _1iievrvc _68jdvle5 _9u9rnxnw _19q81txw _12dhx19p _19pe1h6o _lmm31y6m _1yusvle5 _1hkovle5 _30721txw _y1mj1g80 _4vzb1w8u _m5gb1y6m _12vwzwfg _1crqcv93 _leujidpf _14zaidpf _1il1idpf _fs5uidpf _p5u7ftgi _bpkv1ul9 _1r27idpf _2lgdidpf _6wouidpf _1c7pidpf _1ppp1ogm _1lywftgi _5k731txw _1c2n1osq _5hes1j6v _qc6e1k8s _gvxubfng _nd0zzwfg _1mmnzwfg _awmxzwfg _1xi6zwfg _l7qw1g80 _ar0r1h6o _1p7u1osq _1ubi1h6o _18q6esu3 _1vumzwfg _fls593m8 _2uu193m8 _zbwo1txw _o3yo1g80 _i5yc1osq _13ku1h6o _dbaqidpf _1qoridpf _1a5bidpf _1rafidpf _1f1p1h6o _1j211tcg _1wfzidpf _212widpf _15d21crf _vh6pidpf _1nr81wug _1h01idpf _cc93idpf _e7z31crf _1u52idpf _14hs1osq _pd60glyw _fnxl1txw _rc231h6o _1ogs1osq"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: "data-center-container",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: "img-container",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
                                    alt: ""
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "text-container",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                    children: dataCenterSectionContent.headerText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: dataCenterSectionContent.bodyText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    href: dataCenterSectionContent.href,
                                    text: dataCenterSectionContent.linkText,
                                    type: "primary",
                                    dataEventProps: {
                                        "data-label": dataCenterSectionContent.linkText,
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "dataCenterSection",
                                        "data-event": "clicked",
                                        "data-label-english": "Learn about Data Center"
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $2140f2fe8e065770$var$dataCenterSectionContainerStyle = null;

});

parcelRegister("jwbFO", function(module, exports) {
$parcel$export(module.exports, "GartnerDisclaimer", function () { return $5b60474b1056b2e6$export$46ba377055e90871; });
/* gartner-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $5b60474b1056b2e6$var$finePrintStyles = null;
const $5b60474b1056b2e6$export$46ba377055e90871 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-disclaimer",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syazfesn _18s81jx0",
                    "fine-print"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.gartnerDisclaimer",
                    defaultMessage: "* Gartner, Magic Quadrant for DevOps Platforms, Manjunath Bhat, Thomas Murphy, Joachim Herschmann, Daniel Betts, Chris Saunderson, Hassan Ennaciri, Bill Holz, Peter Hyde, 5 June 2023.  {br}{br} Gartner, Magic Quadrant for Enterprise Agile Planning Tools, Bill Blosen, Mike West, Keith Mann, Deacon D.K Wan, Akis Sklavounakis, Hassan Ennaciri, Sarah Davies, 25 April 2022.  {br}{br} Gartner, Voice of the Customer for Enterprise Agile Planning Tools, By Peer Contributors, 13 December 2023.  {br}{br} Gartner does not endorse any vendor, product or service depicted in its research publications, and does not advise technology users to select only those vendors with the highest ratings or other designation. Gartner research publications consist of the opinions of Gartner\u2019s research organization and should not be construed as statements of fact. Gartner disclaims all warranties, expressed or implied, with respect to this research, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} Gartner Peer Insights content consists of the opinions of individual end users based on their own experiences with the vendors listed on the platform, should not be construed as statements of fact, nor do they represent the views of Gartner or its affiliates. Gartner does not endorse any vendor, product or service depicted in this content nor makes any warranties, expressed or implied, with respect to this content, about its accuracy or completeness, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} GARTNER is a registered trademark and service mark, and the GARTNER PEER INSIGHTS CUSTOMERS\u2019 CHOICE badge, MAGIC QUADRANT and PEER INSIGHTS are trademarks and service marks, of Gartner, Inc. and/or its affiliates in the U.S. and internationally and are used herein with permission. All rights reserved.",
                    values: (0, $kooLp.DEFAULT_VALUES)
                })
            })
        })
    });

});

parcelRegister("1vLxv", function(module, exports) {
$parcel$export(module.exports, "HeroSection", function () { return $d426652f1eda45bf$export$4489c2ed11909944; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $d426652f1eda45bf$export$4489c2ed11909944 = ()=>{
    const intl = (0, $8e22h.default)();
    const heroSectionHeaderText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "EnterpriseLandingPage.Hero.Title",
        defaultMessage: "Transform <span>teamwork at scale</span> with Atlassian",
        values: (0, $kooLp.DEFAULT_VALUES)
    });
    const heroSectionButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.Hero.ContactSales",
        defaultMessage: "Contact sales"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-hero",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1xusidpf _pdfi1ul9 _hfczidpf _t0uc1ul9 _1humidpf _vxqx1wqb _m3vkidpf _l2as1wqb _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                alignItems: "center",
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1j444cyy _10j0ubw4 _1cbbgktf _l9wpidpf _f4o91wqb _14dmidpf _xgqm1zx8 _2h35g6j5 _bzzima1m _18jm1wqb _qji6idpf _ms0l1wqb _v5weidpf _1bl41w8u _b2g01l0k _13hpuihq _1isq1ikj _y3gn1h6o _kqswh2mm _19it1i89 _2rkogktf _19pk1wqb _2hwxidpf _otyr1wqb _18u0idpf _1reo15vq _18m915vq _1tke1edt _1itk105u _ouxlvvtf _12vemgnk _1lrw9efu _1e8sbxu3 _psnd1osr _q4ef6276 _18tn1fw0 _dkzuidpf _17f71wug _at0e1ul9 _1nx01wug _bpsp1nn1"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: "superhero-contrast",
                            children: heroSectionHeaderText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                            variant: "primary",
                            href: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                            dataEventProps: {
                                "data-product-key": "enterprise",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-event": "clicked",
                                "data-label": heroSectionButtonText,
                                "data-label-english": "Contact sales"
                            },
                            children: heroSectionButtonText
                        })
                    ]
                })
            })
        })
    });
};
const $d426652f1eda45bf$var$heroStyle = null;
const $d426652f1eda45bf$var$heroSectionBoxStyle = null;

});

parcelRegister("iDNJX", function(module, exports) {
$parcel$export(module.exports, "HeroEnterpriseTakeoverTurbo", function () { return $774d158b0a94a674$export$5f34b2edc97abcd5; });
/* hero-takeover-turbo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $774d158b0a94a674$export$5f34b2edc97abcd5 = ()=>{
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $kooLp.useLocalizedHref)("/enterprise/atlassian-williams-racing");
    const turboBodyText = intl.formatMessage({
        id: "HomePage.hero-turbo.body-text",
        defaultMessage: "Introducing Atlassian Williams Racing. Two teamwork powerhouses join forces to usher in a new era of Formula 1 racing."
    });
    const turboFeatureGate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp5046TurboBannerEnterprise);
    if (turboFeatureGate) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-turbo",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _11q7jk2v _18s8zucw _mkrz95kk"
            ]),
            style: {
                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _4cvr1h6o _zulptudo _1bsb1fra _p12f1osq _1yt415v9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _na0i1bp4 _gu181h6o _dh1a1h6o _2osnpxbi _o5kc1h6o _6ssjnl7l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e0c1txw _zulp1ejb _2lx21bp4 _4cvr1y6m _1bsb9tyk _acte1nn1 _qpk8yn4p _dd34idpf _l0uhidpf _ldjiidpf _g49yidpf _mihdcjiy _m78dcd5j _1tc71693 _1qf11ule _1hzvviql _vubcviql _125xcd5j _q7gqoxwj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _txws1k92 _1kt119ii _19qkdgin _ov511osq _1s4p1wug _8fz6dgin _6ssj1e2i _gu181h6o _dh1a1h6o _o5kc1h6o"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: "hero hero-turbo",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "HomePage.hero-turbo.heading",
                                    defaultMessage: "Unleash the <strong>power of teamwork</strong>",
                                    values: (0, $kooLp.DEFAULT_VALUES)
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: "turbo",
                                children: turboBodyText
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                variant: "primary",
                                color: "yellow",
                                size: "large",
                                href: ctaLink,
                                dataEventProps: {
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    // @ts-ignore
                                    "data-event-container": "turboHero",
                                    "data-product-key": "home",
                                    "data-label-english": "Find out more"
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "HomePage.hero-turbo.cta-link-livery",
                                    defaultMessage: "Find out more"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1yt41jx0 _1bsb16tw _mezj1osq _bna71wug _18zx1kb5 _1s4p1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                alt: "",
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4l06vv7x28fd2whw3f1i721165ooydn4.webp"
                            }
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};
const $774d158b0a94a674$var$heroTurboCSS = null;
const $774d158b0a94a674$var$containingWidth = null;
const $774d158b0a94a674$var$leftHero = null;
const $774d158b0a94a674$var$rightHero = null;
$774d158b0a94a674$export$5f34b2edc97abcd5.displayName = "HeroEnterpriseTakeoverTurbo";

});

parcelRegister("fuhhv", function(module, exports) {
$parcel$export(module.exports, "PlatformSection", function () { return $f2e85d00bdce9b0b$export$156caa82c28797f7; });
/* platform.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("fl7Kz");
var $92jF6 = parcelRequire("92jF6");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $f2e85d00bdce9b0b$export$156caa82c28797f7 = ()=>{
    const intl = (0, $8e22h.default)();
    const platformCardsCrossProductExperience = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.headerText",
                defaultMessage: "Collaboration"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.bodyText",
                defaultMessage: "Keep work flowing across teams and tools."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/collaboration"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.headerText",
                defaultMessage: "Intelligence"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.bodyText",
                defaultMessage: "Transform teamwork with the power of AI-human collaboration."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/artificial-intelligence"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.headerText",
                defaultMessage: "Automation"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.bodyText",
                defaultMessage: "Replace manual, time-consuming work with modern workflows."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/automation"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.headerText",
                defaultMessage: "Analytics"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.bodyText",
                defaultMessage: "Make faster decisions with accessible data-informed insights."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/analytics"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.headerText",
                defaultMessage: "Extensibility"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.bodyText",
                defaultMessage: "Customize your tools to meet the unique needs of each team."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: "https://marketplace.atlassian.com/",
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    const platformCardsEnterpriseGradeCapabilities = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.headerText",
                defaultMessage: "Resilience at scale"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.bodyText",
                defaultMessage: "Adapt to any challenge with software designed to dynamically scale to meet the needs of any team, regardless of size or complexity."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/trust/resilience"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.headerText",
                defaultMessage: "Security and compliance"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.bodyText",
                defaultMessage: "Meet regulatory requirements and effectively manage your organization's data using comprehensive controls."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/trust/data-protection"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-platformSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _1sc1zwfg _1o2nzwfg _16zdidpf _jvlqidpf _1j3nzwfg _4fugzwfg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _q7gqgktf _w77horz4 _clfdftgi _11pq1wug _q0a5ftgi _c3k81wug"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: intl.formatMessage({
                                id: "EnterpriseLandingPage.Platform.headerText",
                                defaultMessage: "Unify your teams on one powerful platform"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk1t97 _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.crossProductExperince.headerText",
                                        defaultMessage: "Experiences built to help work flow"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _ohma7vkz _iz1bzlre _1seo1wug _ox5hglyw _1f7i1osq _1r6y7vkz _1d9j7vkz _tuj67vkz _1cae7vkz _1m5l7vkz _bapsidpf _24o4idpf _ru7pidpf _1pqjidpf _1oan1fw0 _ax17ftgi _2axr1osq _1swwidpf _bzvvidpf _1dr6idpf _1o9tidpf _7dyf1j6v _scyo1k8s _1xaw1g80 _1rrc1tcg _1sgw17i6 _161z1osq"
                                    ]),
                                    children: platformCardsCrossProductExperience.map((cardProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), (0, $6ogO3._)({
                                            className: "platform-row-one-card"
                                        }, cardProps), index))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhkcs0v _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf _clfd7vkz _11pq1wug _q0a57vkz _c3k81wug _w77horz4 _kckd1w8u _19tb1j6v _1la11k8s _bpspbfng"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.headerText",
                                        defaultMessage: "A common data model designed to unlock key insights"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.bodyText",
                                        defaultMessage: "Unify Atlassian and third-party data to connect teams, deepen collaboration, and drive results."
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    type: "primary",
                                    href: (0, $kooLp.useLocalizedHref)("/platform"),
                                    text: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.linkText",
                                        defaultMessage: "Learn about our platform"
                                    }),
                                    dataEventProps: {
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "platformSection",
                                        "data-event": "clicked",
                                        "data-label": intl.formatMessage({
                                            id: "EnterpriseLandingPage.Platform.commonDataModel.dataLabel",
                                            defaultMessage: "Learn about our platform"
                                        }),
                                        "data-label-english": "Learn about our platform"
                                    }
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk1ymo _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilites.headerText",
                                        defaultMessage: "All built on enterprise-grade foundations"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1w8u _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _1wa17vkz _1ull1ssb _10ql1wug _tlbsglyw _lz7x1osq _knw07vkz _w3mz7vkz _14877vkz _6mwl7vkz _xc0a7vkz _19elidpf _wsnuidpf _1lioidpf _rkcxidpf _14uv1fw0 _x8poftgi _2fdk1osq _6qlpidpf _7m8oidpf _196hidpf _47ltidpf _1b8g1j6v _1xzh1k8s _1qza1osq _11901g80 _17duzwfg _kyxpidpf _3x14zwfg _p8qcidpf _rvvr1osq"
                                    ]),
                                    children: platformCardsEnterpriseGradeCapabilities.map((cardProps, index)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), (0, $6ogO3._)({
                                            className: "platform-row-three-card"
                                        }, cardProps), index);
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
const $f2e85d00bdce9b0b$var$platformSectionBoxContainer = null;
const $f2e85d00bdce9b0b$var$platformBoxContainer = null;
const $f2e85d00bdce9b0b$var$platformSectionHeaderContainerStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowOneStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionRowOneCardContainerStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowTwoStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowThreeStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionRowThreeCardContainerStyle = null;

});

parcelRegister("6cCqM", function(module, exports) {
$parcel$export(module.exports, "ResourcesSection", function () { return $a415d9d03629612e$export$3f0336208d56829f; });
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $a415d9d03629612e$export$3f0336208d56829f = ()=>{
    const intl = (0, $8e22h.default)();
    const tileList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.headerText",
                defaultMessage: "Trust Center"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.bodyText",
                defaultMessage: "Keep your organization\u2019s data secure, maintain compliance, and achieve resilience at scale."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/trust-center-cloud-icon-3087608378.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.trustCenter.linkText",
                    defaultMessage: "Visit our Trust Center"
                }),
                href: (0, $kooLp.useLocalizedHref)("/trust"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.trustCenter.dataLabel",
                        defaultMessage: "Visit our Trust Center"
                    }),
                    "data-label-english": "Visit our Trust Center"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.headerText",
                defaultMessage: "Public Roadmap"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.bodyText",
                defaultMessage: "Discover the latest features in the Atlassian cloud and see what we\u2019re working on next."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/curved-arrow-icon-3497580723.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.publicRoadmap.linkText",
                    defaultMessage: "Check out the Cloud Roadmap"
                }),
                href: (0, $kooLp.useLocalizedHref)("/roadmap/cloud"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.publicRoadmap.dataLabel",
                        defaultMessage: "Check out the Cloud Roadmap"
                    }),
                    "data-label-english": "Check out the Cloud Roadmap"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.headerText",
                defaultMessage: "Enterprise Community"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.bodyText",
                defaultMessage: "Ask questions and learn best practices for our products at scale from Atlassian advocates."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.community.linkText",
                    defaultMessage: "Join the Enterprise Community"
                }),
                href: "https://community.atlassian.com/t5/Enterprise/gh-p/Enterprise",
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.community.dataLabel",
                        defaultMessage: "Join the Enterprise Community"
                    }),
                    "data-label-english": "Join the Enterprise Community"
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-resourcesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_ca0qzwfg _u5f3idpf _n3tdidpf _19bvidpf _1afj1h6o _l5k11fw0 _16qeidpf _3ontidpf _19szidpf _i5bbidpf _cw8vusvi _hycy1txw _pg7i1bp4 _ezjiidpf _n5mbidpf _ypkd1tcg _1a0jidpf _14tm1ule _ix4uidpf _1gb7mhvn _64bp1osq _41c21txw _1iyj1osq _1kkgftgi _zkiw1e5h _fhnp1bp4 _1jxlzwfg _uuujidpf _1tu71fw0 _wft81crf _1jklidpf _1l021osq _178z1tcg _zlemidpf _ibgk1ul9 _o6yp1j6v _1syj1k8s _1chlbfng _wsbmf6fq _irte1j6v _w2lm1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Resources.sectionHeader",
                            defaultMessage: "Teamwork starts with trust"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "4-4-4",
                    children: tileList.map((content, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "resources-section-container",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "img-section",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                        src: content.imageProps.src,
                                        alt: content.imageProps.alt,
                                        className: (0, $2jatx.default)([
                                            "_1h1t1fut _5ral1f51",
                                            "enterprise-resources-card-image"
                                        ])
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: "text-section",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                            children: content.headerText
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: "contentBlock-body",
                                            children: content.bodyText
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: "contentBlock-linkFlex",
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                text: content.linkProps.text,
                                                href: content.linkProps.href,
                                                dataEventProps: content.linkProps.dataEventProps,
                                                type: "primary"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
const $a415d9d03629612e$var$resourcesSectionContainerStyle = null;

});

parcelRegister("lk2q3", function(module, exports) {
$parcel$export(module.exports, "StatsSection", function () { return $34a1992600616f27$export$49e22b3583223277; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");

var $32ng3 = parcelRequire("32ng3");
const $34a1992600616f27$export$49e22b3583223277 = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.stats.header",
            defaultMessage: "High-performing enterprises run on Atlassian"
        }),
        bigStat: {
            stat: "200",
            statText: intl.formatMessage({
                id: "EnterpriseLandingPage.stats.bigText",
                defaultMessage: "countries around the world where Atlassian software helps power enterprise"
            }),
            statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "44",
                statText: intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText1",
                    defaultMessage: "of enterprise customers are able to make faster data-driven decisions after moving to the cloud"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            },
            {
                stat: "79",
                statText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2-gwp-7518",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud apps"
                }) : intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud products"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-stats",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.Stats), (0, $6ogO3._)({}, statsProps))
        })
    });
};

});
parcelRegister("4Fnxt", function(module, exports) {
$parcel$export(module.exports, "Stats", function () { return $cac0a62c179e6d20$export$3cdec2bba15e3523; });
/* stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $6iKF0 = parcelRequire("6iKF0");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $cac0a62c179e6d20$var$earthStyles = null;
const $cac0a62c179e6d20$export$cc52242338d2406f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1e02idpf _152txard _bna71wug _rtys1osq _t9ec1u9r _1h1t1ekt _tnru1wug _1rfm12eq _xaejlc6t _1eg616tw _95u51a2f"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/435e558616x6e3c2jvth65jiq2vusf20.webp",
                alt: "",
                width: 700,
                height: 700
            }
        })
    });
};
const $cac0a62c179e6d20$var$easeOutQuad = (t)=>t * (2 - t);
const $cac0a62c179e6d20$var$frameDuration = 1000 / 60;
const $cac0a62c179e6d20$var$AnimateCount = ({ children: children = "0", duration: duration = 2000 })=>{
    const countTo = parseInt(children, 10);
    const [count, setCount] = (0, $1oC0p.useState)(0);
    (0, $1oC0p.useEffect)(()=>{
        let frame = 0;
        const totalFrames = Math.round(duration / $cac0a62c179e6d20$var$frameDuration);
        const counter = setInterval(()=>{
            frame++;
            const progress = $cac0a62c179e6d20$var$easeOutQuad(frame / totalFrames);
            setCount(countTo * progress);
            if (frame === totalFrames) clearInterval(counter);
        }, $cac0a62c179e6d20$var$frameDuration);
        return ()=>clearInterval(counter);
    }, [
        countTo,
        duration
    ]);
    return Math.floor(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const $cac0a62c179e6d20$export$3cdec2bba15e3523 = (statsProps)=>{
    var _statsProps_bigStat_statSymbol, _statsProps_bigStat_statSymbol1;
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_p12f1git _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1pbykb7n _ca0qymf6 _u5f3idpf _n3td53f4 _19bvidpf _1reo15vq _18m915vq _11q71rga _mkrz13pj _1vth1g58 _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _srwz1ylp"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1q51gktf _85i5gktf _1gde1bp4",
                    "wrapper"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1q511ul9 _p12f1osq _1e0c1txw _4cvr1y6m _zulp1ylp _kqswh2mm _1t19idpf _p7vbidpf _1rhg1w8u _19wggktf _1gde1bp4 _1u2q1wqb",
                            "text-wrapper"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1ssb _1fe7kb7n _12ihkb7n _1a1xf1ug _1rfm1osq",
                                    "fifty"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb8pqr _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.headerText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                            "_1wyb1qf2 _g4miqd8k _1lzo1bc9",
                                            "big-stat"
                                        ]),
                                        style: {
                                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1bjw",
                                                    "big-stat"
                                                ]),
                                                style: {
                                                    "--_1shjtka": (0, $6ZVlx.default)(statsProps.bigStat.statColor ? statsProps.bigStat.statColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                        fallback: null,
                                                        children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$var$AnimateCount, {
                                                            children: statsProps.bigStat.stat
                                                        }) : statsProps.bigStat.stat
                                                    })
                                                ]
                                            }),
                                            statsProps.bigStat.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1y4s"
                                                ]),
                                                style: {
                                                    "--_1bnfnau": (0, $6ZVlx.default)(((_statsProps_bigStat_statSymbol = statsProps.bigStat.statSymbol) === null || _statsProps_bigStat_statSymbol === void 0 ? void 0 : _statsProps_bigStat_statSymbol.symbolCharacterColor) ? statsProps.bigStat.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                },
                                                children: (_statsProps_bigStat_statSymbol1 = statsProps.bigStat.statSymbol) === null || _statsProps_bigStat_statSymbol1 === void 0 ? void 0 : _statsProps_bigStat_statSymbol1.symbolCharacter
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.bigStat.statText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1r5k _1e0c1txw _zulpgktf _2lx21bp4 _y4ti1ylp _1fe7kb7n _12ihkb7n _1a1xf1ug _chtuidpf",
                                    "thirty"
                                ]),
                                children: statsProps.littleStats.map((statObj, index)=>{
                                    var _statObj_statSymbol, _statObj_statSymbol1;
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _bozggktf",
                                            "stat-wrapper"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _4t3i1osq _11q71hlo _1bsbyh40 _1e02idpf"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_ect4qlpn _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz17la",
                                                    "_1wybxxch",
                                                    "little-stat"
                                                ]),
                                                style: {
                                                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_syazoodi"
                                                    ]),
                                                    style: {
                                                        "--_11wxpl2": (0, $6ZVlx.default)(statObj.statColor ? statObj.statColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                            fallback: null,
                                                            children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$var$AnimateCount, {
                                                                children: statObj.stat
                                                            }) : statObj.stat
                                                        }),
                                                        statObj.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_syaz16k1"
                                                            ]),
                                                            style: {
                                                                "--_1nxvphm": (0, $6ZVlx.default)(((_statObj_statSymbol = statObj.statSymbol) === null || _statObj_statSymbol === void 0 ? void 0 : _statObj_statSymbol.symbolCharacterColor) ? statObj.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)("color.primary.black"))
                                                            },
                                                            children: (_statObj_statSymbol1 = statObj.statSymbol) === null || _statObj_statSymbol1 === void 0 ? void 0 : _statObj_statSymbol1.symbolCharacter
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: statObj.statText
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1h1tgbua _kqswh2mm _rjxpidpf _u7coidpf _152tidpf _4t3i1osq _1e0c1txw _1bah1h6o _mmgkgktf _1rfm1osq _tnru68cl _srwzidpf _476d1ylp _1t06idpf _1jc21gwv _10jx1gwv",
                            "earth-contents"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$cc52242338d2406f, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _1o2w1n0t _rjxp3ll0 _p5ce1x96 _1l7d176h _xaej15qf _1rfm68cl _tnru1wug",
                                    "blob"
                                ]),
                                width: "102",
                                height: "95",
                                "aria-hidden": "true",
                                viewBox: "0 0 102 95",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M97.6377 58.2134C98.2297 54.8868 98.5329 51.356 98.5329 47.6063C98.5329 43.8566 98.2152 40.2236 97.6233 36.8533C94.057 16.8063 80.2829 4.44834 60.9645 1.28226C57.6726 0.742421 54.2074 0.46521 50.6123 0.46521C47.0172 0.46521 43.2632 0.771614 39.8414 1.34063C20.5085 4.60885 6.74887 16.923 3.18262 36.8533C2.57621 40.2236 2.27301 43.7982 2.27301 47.6063C2.27301 51.4143 2.57621 54.8868 3.16818 58.2134C6.70555 78.1144 20.4797 90.4578 39.8414 93.726C43.2632 94.3096 46.8728 94.6014 50.6123 94.6014C54.3518 94.6014 57.6726 94.3242 60.9645 93.7844C80.3118 90.6037 94.1148 78.2312 97.6521 58.2134H97.6377Z",
                                        fill: "#FCA700"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                                className: (0, $2jatx.default)([
                                    "_1bsbutna _4t3i1wug _kqswstnw _1e021nh5 _u7co1228 _sugaglyw",
                                    "lightning"
                                ]),
                                width: "131",
                                height: "139",
                                "aria-hidden": "true",
                                viewBox: "0 0 131 139",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M20.4793 61.2896C11.5228 63.9778 10.6462 63.8696 8.14861 74.6224C5.48565 77.7767 3.98043 82.2375 2.50009 87.7471C1.52422 89.9276 8.05758 89.112 4.36913 89.8361C6.75918 90.66 13.6813 90.2023 14.4338 91.2343C10.9604 99.0243 8.42147 107.638 6.13066 115.911C6.18028 130.151 27.1036 98.5582 29.5102 96.5941C30.7176 93.1152 44.2806 78.484 38.1442 78.1761C29.196 76.6947 23.4234 81.4636 30.1387 69.8369C30.2793 69.3875 33.3061 62.3049 32.6197 60.1909C28.0133 62.1883 27.0788 70.1864 24.2752 74.5474C19.5778 80.881 28.6253 81.9463 32.6114 81.3554C32.5618 82.2875 36.1345 80.7562 35.2909 82.7037C30.1718 90.2606 12.9866 112.723 13.028 112.765C11.7296 115.611 9.81084 116.752 9.33117 115.861C9.04172 115.328 18.2546 92.6159 19.5117 89.6947C20.5289 86.1243 14.2436 86.9482 14.2436 86.9482C14.2436 86.9482 14.897 87.2727 16.7578 87.3226C14.8143 87.8969 9.87707 87.1396 6.51115 86.8733C7.08179 81.7382 13.7061 65.3676 13.7061 65.3676C13.7061 65.3676 27.7817 64.2191 31.3378 59.9662C28.7245 59.7415 24.3001 61.0649 20.471 61.2979L20.4793 61.2896Z",
                                        fill: "#101214"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M128.71 53.5661L129.636 51.8599C129.934 51.294 130.314 50.7031 130.413 50.1954C130.537 49.6877 130.521 49.2633 130.488 48.9138C130.48 48.8139 130.488 48.7556 130.438 48.6391C130.397 48.5225 130.306 48.3894 130.248 48.3395C130.116 48.2313 129.983 48.1147 129.818 47.9982C129.487 47.7735 129.065 47.5322 128.47 47.424C127.858 47.3408 127.205 47.2908 126.576 47.2159C123.392 46.8913 120.216 46.5667 117.082 46.2505C114.138 45.9425 111.227 45.6346 108.341 45.335C105.76 45.052 103.205 44.7774 100.691 44.5027C100.492 44.4528 100.178 44.5193 100.137 44.253C100.153 44.0283 100.31 43.8369 100.393 43.6455C100.972 42.3971 101.543 41.1571 102.113 39.9336C103.395 37.1955 104.644 34.5239 105.86 31.9189C108.316 26.7256 110.689 21.8236 112.972 17.2878L112.699 17.5541C112.889 17.2295 113.303 16.1393 113.576 15.9479C113.923 14.9075 114.436 13.4843 115.039 11.9113C115.345 11.129 115.66 10.3051 115.982 9.47285L116.47 8.22446C116.76 7.53368 117.041 6.85116 117.322 6.17702C117.653 5.36141 117.702 4.6707 117.653 4.06315C117.587 3.43063 117.347 2.78144 116.958 2.27376C116.189 1.21679 114.948 0.800607 114.088 0.867188C113.063 1.14183 112.219 1.35825 111.632 1.51638C111.326 1.63289 111.086 1.7245 110.913 1.78276C110.789 1.82437 110.731 1.8493 110.731 1.8493C106.794 3.33905 102.626 4.49591 98.4578 5.61114C98.4578 5.61114 97.0768 5.87744 94.8769 6.31021C93.7687 6.5266 92.462 6.78464 91.0065 7.07593C90.2787 7.22574 89.5096 7.39216 88.7157 7.55861C88.3187 7.64184 87.9052 7.74169 87.4834 7.84988C87.0865 7.94975 86.6896 8.05795 86.2843 8.16614C83.0673 8.99008 79.4202 9.78077 76.1535 11.1124C74.5243 11.7699 73.0026 12.5771 71.729 13.4843C70.4472 14.3915 69.4216 15.4152 68.6939 16.3473C66.6181 18.4696 65.0798 21.008 63.8228 23.613C62.5575 26.2263 61.5733 28.9228 60.5974 31.5943C59.6464 34.2826 58.6292 36.8626 57.5458 39.5008L54.3536 47.3907C54.3536 47.3907 49.4163 60.7236 48.4156 64.9348C48.0931 66.2831 47.8864 67.4066 47.7871 68.2472C48.1841 68.2139 48.7382 68.1889 49.4328 68.1806C50.6899 65.9085 52.6582 61.3311 55.4452 53.7408C55.5527 53.5993 55.8008 53.1084 55.8918 53.0668C57.0744 49.6378 58.3315 46.2838 59.6465 42.9547C60.3163 41.2985 60.9862 39.6424 61.656 37.9862C62.3507 36.2967 62.9958 34.5821 63.6243 32.9176C64.8896 29.5886 66.1467 26.3178 67.7842 23.4132C68.6029 21.9651 69.5126 20.6085 70.5546 19.4267C71.5967 18.2365 72.7297 17.2711 74.086 16.4389C73.8213 16.3224 74.086 15.9145 74.4995 15.8479L74.5243 16.1808C76.3189 14.999 78.2789 14.2666 80.181 13.6924C82.0914 13.1181 83.9853 12.7103 85.8874 12.2609L87.3181 11.9113L88.7157 11.5452C89.6254 11.3205 90.5352 11.0957 91.4697 10.871C93.3801 10.3966 95.3814 9.84733 97.5233 9.11493C97.5068 9.12326 96.6053 9.71416 96.5888 9.7308C100.037 8.97344 103.627 8.15785 107.398 7.15081C108.341 6.88448 109.292 6.62649 110.259 6.32688C110.739 6.18539 111.227 6.03554 111.715 5.86909L112.145 5.72767L112.236 5.69435C112.352 5.64441 112.509 5.57783 112.616 5.69435C112.732 5.80254 112.658 5.96065 112.6 6.08549C109.813 12.3025 106.877 18.869 103.883 25.5521C102.32 29.0476 100.74 32.5681 99.1691 36.0969C98.3834 37.8613 97.5978 39.6257 96.8121 41.3818L95.8527 43.5206C95.6625 43.9284 95.4971 44.3446 95.431 44.7275C95.3648 45.1103 95.3649 45.4515 95.3897 45.7595C95.4145 46.3587 95.828 47.1993 96.3408 47.6321C96.5806 47.8484 96.837 47.9983 97.1595 48.1647C97.4903 48.3145 97.879 48.4394 98.3173 48.4893C105.239 49.1801 111.988 49.8542 118.521 50.5117C120.068 50.6615 121.598 50.8113 123.119 50.9528L124.252 51.061L124.74 51.1026H124.839L125.269 51.1275C125.327 51.1442 125.451 51.0943 125.46 51.1858L125.377 51.3689L125.195 51.76C124.906 52.3177 124.608 52.867 124.318 53.4246C123.979 54.0654 123.648 54.7063 123.293 55.3305L123.417 55.2056V55.2888C123.649 54.9726 123.963 54.5066 124.327 53.9073C124.674 53.3497 125.087 52.6838 125.534 51.9515C125.724 51.6851 125.956 51.3606 126.212 50.9778C126.262 50.8779 126.378 50.7947 126.378 50.6782C126.328 50.5866 126.204 50.6199 126.121 50.5783C125.915 50.5367 125.716 50.4951 125.517 50.4618C125.294 50.4202 125.071 50.3785 124.864 50.3369C124.393 50.2703 123.938 50.2038 123.5 50.1455C122.59 50.0207 121.763 49.9041 121.052 49.8126C119.638 49.6212 118.72 49.4963 118.72 49.4963C120.109 49.4547 121.523 49.463 122.946 49.5046C123.64 49.5379 124.343 49.5629 125.046 49.5962C125.592 49.6212 126.163 49.6544 126.742 49.6961L127.618 49.7709C127.693 49.7792 127.767 49.771 127.833 49.7959C127.899 49.8209 127.949 49.8958 127.932 49.9707C127.874 50.1038 127.8 50.2287 127.734 50.3536C127.453 50.8613 127.172 51.3772 126.882 51.8932C126.551 52.4758 126.212 53.0667 125.873 53.6493C125.501 54.2985 125.129 54.9476 124.732 55.5884C123.136 58.1352 121.564 60.7152 119.886 63.212C119.067 64.477 118.248 65.7338 117.438 66.9822C116.611 68.2222 115.8 69.4623 115.023 70.7107L114.742 70.4277C117.512 66.1749 119.629 62.1717 120.44 60.5571C115.593 68.2639 108.068 79.6908 99.8224 90.4602C95.7453 95.8783 91.4531 101.105 87.5 105.816C85.5069 108.154 83.6213 110.393 81.8185 112.399C80.9253 113.414 80.0735 114.388 79.263 115.312C78.4443 116.227 77.6669 117.093 76.9391 117.9C77.2037 117.842 78.1548 116.718 79.2382 115.578C80.3133 114.429 81.4959 113.223 82.3229 113.056C81.5786 113.888 80.8261 114.721 80.0818 115.545C79.3292 116.36 78.5684 117.176 77.8241 117.983C77.0715 118.79 76.3271 119.589 75.5911 120.38C74.8468 121.162 74.086 121.92 73.3416 122.661C72.8951 122.211 74.7641 120.646 75.0205 120.222C74.3093 120.788 72.1094 122.952 68.7187 126.114C67.0151 127.687 65.055 129.552 62.789 131.541C62.5161 131.782 62.2432 132.024 61.9703 132.273L61.7718 132.44C61.6312 132.531 61.532 132.681 61.3666 132.714C61.2012 132.739 61.0275 132.631 60.9614 132.465C60.8869 132.29 60.9944 132.115 61.0358 131.948C61.6395 129.901 62.268 127.754 62.9131 125.54C63.6822 122.96 64.4927 120.305 65.3446 117.6C67.0482 112.191 68.9006 106.573 70.8606 100.963C72.8124 95.3539 74.8716 89.7445 76.9474 84.3348C77.9811 81.63 79.0232 78.975 80.0569 76.395L80.4374 75.4296L80.6276 74.9469C80.6607 74.8636 80.6938 74.8054 80.7186 74.6889L80.8013 74.3227C81.0246 73.3406 81.2479 72.3668 81.4712 71.4014C81.5787 70.9187 81.6944 70.436 81.8019 69.9616L81.9674 69.2459L82.0501 68.8881C82.0583 68.8298 82.0914 68.7632 82.0832 68.7216C82.0584 68.6633 82.0087 68.6633 81.9591 68.6384C81.2313 68.3471 80.5036 68.0557 79.7841 67.7644C77.7 67.8477 75.6656 67.9226 73.6807 67.9975C72.2418 68.0391 70.8359 68.0724 69.4796 68.1057C66.767 68.1639 64.2198 68.1889 61.8959 68.1889C57.2398 68.1723 53.4522 68.164 50.8719 68.1557C50.3426 68.1557 49.8794 68.1557 49.4494 68.1557C49.2757 68.4719 49.1186 68.7382 48.9698 68.9629C49.8216 69.1128 50.9545 69.2792 52.4266 69.4789L51.5086 69.7619C56.082 70.0698 60.2584 70.253 64.501 70.4194C66.6181 70.4943 68.7517 70.5692 70.9516 70.6525C72.0515 70.6858 73.168 70.7274 74.3093 70.769C74.8799 70.7856 75.4588 70.8106 76.0377 70.8272C76.4512 70.8522 76.8647 70.8771 77.2865 70.9021C77.394 70.8938 77.4932 70.8855 77.5759 70.8772C78.2706 70.8189 78.3451 70.8355 78.6759 70.5276C79.0067 70.461 79.6517 70.3445 79.7261 70.203C79.8502 70.1031 79.9991 70.0116 80.1645 69.9367C80.2141 69.9201 80.3299 69.8785 80.3299 69.9367C80.3299 69.97 80.3299 70.0199 80.3216 70.0781C80.2803 70.3029 80.1645 70.6857 80.0074 71.1268C79.6931 72.0173 79.2217 73.0743 78.9819 73.7235C78.1549 72.5416 75.2273 79.3828 72.5809 87.1395C69.8931 94.8712 67.5443 103.469 66.8331 105.433C65.452 105.832 64.2198 113.214 63.0289 115.461C63.0372 115.278 63.1116 114.13 63.1281 113.98C62.7891 114.463 61.9538 117.026 60.9945 120.48C60.5148 122.203 59.9937 124.15 59.4727 126.156C58.9352 128.295 58.3811 130.5 57.8518 132.606C57.703 133.255 57.6368 133.821 57.6202 134.346C57.612 134.878 57.8105 135.427 58.1744 135.844C58.8773 136.709 60.1427 136.925 60.9779 136.501C61.7553 136.06 62.4582 135.394 63.0867 134.795C63.6491 134.271 64.1453 133.813 64.5588 133.438C66.0971 132.048 66.4692 131.907 64.7408 133.987C71.4147 128.528 78.742 121.678 86.1437 113.705C93.5702 105.757 100.972 96.6024 108.035 86.79C115.081 76.961 121.688 66.3996 127.61 55.6551L128.743 53.5661H128.71Z",
                                        fill: "#101214"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $cac0a62c179e6d20$var$wrapperStyle = null;
const $cac0a62c179e6d20$var$earthContents = null;
const $cac0a62c179e6d20$var$blobStyles = null;
const $cac0a62c179e6d20$var$lightningStyles = null;
const $cac0a62c179e6d20$var$TextWrapperStyles = null;
const $cac0a62c179e6d20$var$fiftyStyles = null;
const $cac0a62c179e6d20$var$h2Styles = null;
const $cac0a62c179e6d20$var$statStyles = null;
const $cac0a62c179e6d20$var$bigStatStyles = null;
const $cac0a62c179e6d20$var$littleStatStyles = null;
const $cac0a62c179e6d20$var$statTextStyles = null;
const $cac0a62c179e6d20$var$thirtyStyles = null;
const $cac0a62c179e6d20$var$statWrapperStyles = null;
const $cac0a62c179e6d20$var$dividerStyles = null;
const $cac0a62c179e6d20$var$statsStyles = null;

});


parcelRegister("u4tJt", function(module, exports) {
$parcel$export(module.exports, "SupportSection", function () { return $906e979b456f42a3$export$17b1756ef4d0cdd6; });
/* support.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("fl7Kz");
var $92jF6 = parcelRequire("92jF6");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $906e979b456f42a3$export$17b1756ef4d0cdd6 = ()=>{
    const intl = (0, $8e22h.default)();
    const cardList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.advisoryServices",
                defaultMessage: "Advisory Services"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.advisoryServices",
                defaultMessage: "Maximize your Atlassian investment and achieve your goals with strategic, technical, and practice guidance from Atlassian\u2019s in-house experts."
            }),
            iconName: "lightning",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/services/advisory-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/services/advisory-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.enterprisePartners",
                defaultMessage: "Enterprise Partners"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.enterprisePartners",
                defaultMessage: "Consulting, hands-on technical implementation, and best practices to optimize your Atlassian portfolio and ensure your success."
            }),
            iconName: "partners",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/enterprise-partners"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/enterprise-partners"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.customerSupport",
                defaultMessage: "Customer Support"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.customerSupport",
                defaultMessage: "Get 24/7 support with 30-minute response times for critical issues included with Cloud Enterprise and Data Center subscriptions."
            }),
            iconName: "sparkle",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/support-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/support-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-supportSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_bfhk17fj _85i51ylp _94n51n1a _1afj1h6o _l5k11fw0 _1eavgktf _7qsbtlke _4mdwglyw _nmva14mp _8mry16gf _ajae1tcg _17s71tcg _1uza1tcg _18bc1tcg _bo1n1osq _1gm71fw0 _5hjp1osq _1xi9idpf _1yay1j6v _1k931k8s _cwu5jojz _9rk41fp4 _wxo81jeb _1qj31yy8"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.headerText",
                            defaultMessage: "Support designed for every enterprise"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "4-4-4",
                    children: cardList.map((CardProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), (0, $6ogO3._)({
                            className: `support-section-card support-section-card-${index}`,
                            headerType: "h4"
                        }, CardProps), index))
                })
            ]
        })
    });
};
const $906e979b456f42a3$var$SupportSectionContainerStyles = null;
var $906e979b456f42a3$export$2e2bcd8739ae039 = $906e979b456f42a3$export$17b1756ef4d0cdd6;

});

parcelRegister("97gok", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $aefc41f18298c8bf$export$502de1d4d55224c1; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("6hzTZ");
var $c0p5s = parcelRequire("c0p5s");
parcelRequire("jy5WX");
var $l4cHn = parcelRequire("l4cHn");
var $2EsR9 = parcelRequire("2EsR9");
var $8uEmY = parcelRequire("8uEmY");
var $3Fv2O = parcelRequire("3Fv2O");
const $aefc41f18298c8bf$export$502de1d4d55224c1 = ()=>{
    const intl = (0, $8e22h.default)();
    const tabs = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.softwareDevelopment",
                defaultMessage: "Software development"
            }),
            englishLabel: "Software development",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2EsR9.EnterpriseSoftwareDevelopment), {})
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.Service management",
                defaultMessage: "Service management"
            }),
            englishLabel: "Service management",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4cHn.EnterpriseServiceManagement), {})
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterpriseStrategyAndPlanning",
                defaultMessage: "Enterprise strategy & planning"
            }),
            englishLabel: "Enterprise strategy & planning",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8uEmY.EnterpriseStrategyAndPlanning), {})
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.workManagement",
                defaultMessage: "Work management"
            }),
            englishLabel: "Work management",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Fv2O.EnterpriseWorkManagement), {})
        }
    ];
    const solutionsHeader = intl.formatMessage({
        id: "EnterpriseLandingPage.solutions.header",
        defaultMessage: "Industry-leading solutions to accelerate your business"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-tabs",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c0p5s.TabsWithCards), {
            h2Text: solutionsHeader,
            tabsData: tabs
        })
    });
};

});
parcelRegister("6hzTZ", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return (parcelRequire("c0p5s")).TabsWithCards; });
parcelRequire("c0p5s");

});
parcelRegister("c0p5s", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return $d6274292653c0a3a$export$3c855d4d211f5f7e; });
/* tabs-with-cards.pattern.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $a9lfn = parcelRequire("a9lfn");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $d6274292653c0a3a$var$Tab = ({ title: title, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", (0, $dPABA._)((0, $6ogO3._)({}, dataEventProps), {
        className: (0, $2jatx.default)([
            "_1ul9ymf6 _bfhk17fj _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i12am _2rko1f4h _y4ti1ul9 _bozg1ul9 _80omtlke _19it1hmt _ect4lnmy _k48p1nn1 _1wybgktf _1dbzzucj _1bg41b66 _nt751hlo",
            isSelected && "_19it8djs _bfhk1ybm"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: title
    }));
};
const $d6274292653c0a3a$export$3c855d4d211f5f7e = ({ h2Text: h2Text, tabsData: tabsData })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _y3gn1h6o _6rthidpf"
                        ]),
                        children: h2Text
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                    rowGap: "12px",
                    className: (0, $2jatx.default)([
                        "_ca0q1ylp _u5f31wqb _n3td1qjk _19bv1wqb _1kmx1ylp _1ggmzwfg _1ykz1ul9 _1maezwfg",
                        "tab-list"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                            tabIndex: index,
                            className: "round-tab",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($d6274292653c0a3a$var$Tab, {
                                title: tab.title,
                                dataEventProps: {
                                    "data-product-key": "home",
                                    "data-event": "clicked",
                                    "data-event-component": "button",
                                    "data-event-container": "tabsMenu",
                                    "data-label": tab.title,
                                    "data-label-english": tab.englishLabel
                                }
                            })
                        }, index))
                }),
                tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                        panelIndex: index,
                        id: tab.id,
                        children: tab.tabComponent
                    }, index))
            ]
        })
    });
};
const $d6274292653c0a3a$var$sectionStyles = null;
const $d6274292653c0a3a$var$h2Styles = null;
const $d6274292653c0a3a$var$tabList = null;
const $d6274292653c0a3a$var$tabStyles = null;
const $d6274292653c0a3a$var$currentStyle = null;

});


parcelRegister("jy5WX", function(module, exports) {
$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return (parcelRequire("8uEmY")).EnterpriseStrategyAndPlanning; });
$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return (parcelRequire("l4cHn")).EnterpriseServiceManagement; });
$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return (parcelRequire("2EsR9")).EnterpriseSoftwareDevelopment; });
$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return (parcelRequire("3Fv2O")).EnterpriseWorkManagement; });

var $8uEmY = parcelRequire("8uEmY");

var $l4cHn = parcelRequire("l4cHn");

var $2EsR9 = parcelRequire("2EsR9");

var $3Fv2O = parcelRequire("3Fv2O");

});
parcelRegister("8uEmY", function(module, exports) {
$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return $bf6dd4cff04406bb$export$b230c8e7621aa6c7; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $hcrIp = parcelRequire("hcrIp");
const $bf6dd4cff04406bb$export$b230c8e7621aa6c7 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible",
                    defaultMessage: "Make all work visible in real-time"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible.bodytext",
                    defaultMessage: "Spot and solve blockers faster with visibility into all work from teams across your enterprise."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam",
                    defaultMessage: "Align every team to strategy"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam.bodyText",
                    defaultMessage: "Get everyone on the same page so you can solve for dependencies, scope, and roadmaps across teams and portfolios."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue",
                    defaultMessage: "Stay focused on customer value"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue.bodyText",
                    defaultMessage: "Map investments to customer value creation so you can make confident decisions at make-or-break moments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.StrategyAndPlanning.learnMore",
                defaultMessage: "Learn about enterprise strategy & planning"
            }),
            link: (0, $kooLp.useLocalizedHref)("/software/jira/align"),
            linkLabel: "Learn about enterprise strategy & planning",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1tu5g7e71x67ptt70udllxtw5705vl17.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.StrategyAndPlanning.resources",
            defaultMessage: "Enterprise strategy & planning resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.headerText",
                    defaultMessage: 'Gartner<sup>\xae</sup> Predicts 2024: Strategic Portfolio Leaders Must Plan for the "Never Normal"',
                    values: (0, $hcrIp.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("software/jira/align/resources/gartner-strategic-portfolio-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kx4vls2kbgf442m7wq2p88a182k0sy20.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar",
                    defaultMessage: "Demo center"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.headerText",
                    defaultMessage: "Learn how to boost Enterprise Strategy & Planning with Jira Align"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.linkText",
                        defaultMessage: "Explore demos"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/jira/align/demo"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore demos"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-02-demo@2x-3880751788.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide",
                    defaultMessage: "Webinar"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.headerText",
                    defaultMessage: "Transformations Across Hybrid Environments"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.linkText",
                        defaultMessage: "Watch webinar"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/webinars/agile-at-scale/transformations-across-hybrid-environments"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch webinar"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kv2eo50o020nn5amk6ahukj52h35405s.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});
parcelRegister("682Ua", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $89f20ef110b77061$export$2e2bcd8739ae039; });
/* tabs-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $ggSCt = parcelRequire("ggSCt");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $5yuBp = parcelRequire("5yuBp");
const $89f20ef110b77061$var$settings = {
    arrows: false,
    centerMode: true,
    dots: true,
    infinite: false,
    swipeToSlide: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
// FIXME: Nested selectors are used here to target dynamically inserted child elements
const $89f20ef110b77061$var$slickStyle = null;
const $89f20ef110b77061$var$TabsContent = (tabsContentProps)=>{
    var _tabsContentProps_contentLink, _tabsContentProps_contentLink1, _tabsContentProps_contentLink2;
    const isMobile = (0, $5yuBp.useIsMobile)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_y44v951u",
                tabsContentProps.className || ""
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_dm2511p5 _1rqtaigu _pdlmzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_uhi5kb7n _eao7qfx8"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kzvi1txw _1gzvzwfg",
                                            "content-list"
                                        ]),
                                        children: tabsContentProps.contentList.map((content, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_xlt17vkz _40tuftgi _1tnt1tcg _v9tzum4z _p6svglyw",
                                                    "content-text"
                                                ]),
                                                style: {
                                                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                                        className: (0, $2jatx.default)([
                                                            "_6rthidpf _1pfhidpf",
                                                            content === null || content === void 0 ? void 0 : content.headerType
                                                        ]),
                                                        children: content.headerText
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        className: (0, $2jatx.default)([
                                                            "_476dftgi"
                                                        ]),
                                                        children: content.bodyText
                                                    })
                                                ]
                                            }, "content-" + index))
                                    }),
                                    tabsContentProps.contentLink && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_gq9a1h6o",
                                            "link-content-container"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            href: tabsContentProps.contentLink.link,
                                            text: (_tabsContentProps_contentLink = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink === void 0 ? void 0 : _tabsContentProps_contentLink.linkText,
                                            type: "primary",
                                            dataEventProps: {
                                                "data-product-key": (_tabsContentProps_contentLink1 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink1 === void 0 ? void 0 : _tabsContentProps_contentLink1.productKey,
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "tabsSection",
                                                "data-label-english": (_tabsContentProps_contentLink2 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink2 === void 0 ? void 0 : _tabsContentProps_contentLink2.linkLabel
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1reo15vq _18m915vq _uhi5qfx8 _eao71mrw _1iyegktf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), (0, $dPABA._)((0, $6ogO3._)({}, tabsContentProps.pictureProps), {
                                    className: (0, $2jatx.default)([
                                        "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _m369951u _ovn1i2wt"
                                    ])
                                }))
                            })
                        ]
                    })
                }),
                tabsContentProps.tabContentEyebrowText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "tab-content-header-wrapper",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _1pfhidpf _6rth1tcg",
                                "eyebrow-md"
                            ]),
                            children: tabsContentProps.tabContentEyebrowText
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "tabs-content-cards",
                    children: isMobile ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _11wpftgi _ehjsftgi _13e4ftgi _12l3ftgi _gzcot94y _1xnx1ule _6rj8idpf _k58e13la _qmn3idpf _bjmnidpf _6qh814y2 _1qzl14y2 _1dx414y2 _1n6c14y2 _1mfj1h6o _12bq1o8l _nog6tlke _1njogktf _1ssvgktf _110yidpf _1glb14y2 _1a57idpf _c30z14y2 _1yjcidpf _qop8idpf _63deidpf _l4aeidpf _1jkiidpf _1xco1ule _je42idpf _176uidpf _rtji14y2 _1jth14y2 _9af414y2 _9uha14y2 _11votlke _omsfgktf _6fzegktf _5l3c1j28 _iygb1j28 _c2ls1r31 _6ejeglyw _1e79idpf _54up1hlo _1gdw1osq _cshx1hlo _2g951ssb _1f1o1mp2 _z3otldb6 _w1ixgktf _1kauidpf _fcd11h6o _slqlidpf _4if1gktf _vcsd13la _1wxl1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), (0, $dPABA._)((0, $6ogO3._)({}, $89f20ef110b77061$var$settings), {
                            children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($89f20ef110b77061$var$TabCard, (0, $6ogO3._)({}, cardContent))
                                }, "card-" + index))
                        }))
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "4-4-4",
                        containerType: "ul",
                        children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($89f20ef110b77061$var$TabCard, (0, $dPABA._)((0, $6ogO3._)({}, cardContent), {
                                    containerType: "li"
                                }))
                            }, "card-" + index))
                    })
                })
            ]
        })
    });
};
const $89f20ef110b77061$var$slidein = null;
const $89f20ef110b77061$var$wrapperStyles = null;
const $89f20ef110b77061$var$bigImgWrapperStyles = null;
const $89f20ef110b77061$var$contentListWrapperStyle = null;
const $89f20ef110b77061$var$contentListTextWrapperStyle = null;
const $89f20ef110b77061$var$contentListStyles = null;
const $89f20ef110b77061$var$contentImageStyle = null;
const $89f20ef110b77061$var$eyebrowStyle = null;
const $89f20ef110b77061$var$ContentTextStyles = null;
const $89f20ef110b77061$var$ContentTextPStyle = null;
const $89f20ef110b77061$var$contentListHeaderStyle = null;
const $89f20ef110b77061$var$linkContainerStyle = null;
const $89f20ef110b77061$var$TabCard = (cardContentProps)=>{
    const { eyebrowText: eyebrowText, headerText: headerText, bodyText: bodyText, ctaProps: ctaProps, pictureProps: pictureProps, containerType: containerType } = cardContentProps;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Card), {
        title: headerText,
        titleAs: "h3",
        image: pictureProps,
        body: bodyText,
        eyebrow: eyebrowText,
        callToAction: ctaProps,
        containerType: containerType
    });
};
var $89f20ef110b77061$export$2e2bcd8739ae039 = $89f20ef110b77061$var$TabsContent;

});

parcelRegister("hcrIp", function(module, exports) {
$parcel$export(module.exports, "formatRegisteredSymbol", function () { return $0b8f8eb27e7a388e$export$7c6a07146a40a24d; });
/* utils.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $0b8f8eb27e7a388e$export$7c6a07146a40a24d = {
    sup: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("sup", {
            className: (0, $2jatx.default)([
                "_vwz4idpf"
            ]),
            children: chunks
        })
};

});


parcelRegister("l4cHn", function(module, exports) {
$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return $acbe78da1a3d03fc$export$851060687c9906bd; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");
const $acbe78da1a3d03fc$export$851060687c9906bd = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue",
                    defaultMessage: "Deliver value fast"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue.bodytext",
                    defaultMessage: "Replace costly legacy tools and deploy faster with a powerful, easy-to-use platform that has transparent pricing."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps",
                    defaultMessage: "Accelerate dev and ops"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps.bodyText",
                    defaultMessage: "Instead of siloed tools, increase visibility and the flow of work by connecting Development and IT Operations teams on a single platform."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll",
                    defaultMessage: "Empower service for all"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll.bodyText",
                    defaultMessage: "Help every team take ownership of their service experience and scale practices - without costly add-ons or confusing deployments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.serviceManagement.learnMore",
                defaultMessage: "Learn about service management"
            }),
            link: (0, $kooLp.useLocalizedHref)("/solutions/itsm"),
            linkLabel: "Learn about service management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/x2s3unwoyy1xp3222df5pu0j23fx7lki.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.serviceManagement.resources",
            defaultMessage: "Service management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport",
                    defaultMessage: "Forrester report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.headerText",
                    defaultMessage: "Atlassian is a Leader in Enterprise Service Management, Q4 2023"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterWave-3356930698.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar",
                    defaultMessage: "ROI resources"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.headerText",
                    defaultMessage: "The Total Economic Impact of Jira Service Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.linkText",
                        defaultMessage: "Explore resources"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/jira/service-management/total-economic-impact-hub"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore resources"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/totEconomicImpact-1137923345.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.headerText",
                    defaultMessage: "ITSM for high-velocity teams"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Download guide"
                    }),
                    href: "https://wac-cdn.atlassian.com/it/dam/jcr:4ec50253-90f1-4d6c-98e2-2ff994cf94db/Jira-Service-Management-Overview-Datasheet.pdf?cdnVersion=1275#:~:text=Jira%20Service%20Management%20offers%20business,approach%20of%20legacy%20ITSM%20solutions.&text=Empower%20all%20teams%20across%20IT,business%20with%20intuitive%2C%20flexible%20workflows.&text=Make%20work%20visible%20through%20the%20open%20and%20collaborative%20Jira%20platform.",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Download guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/itServiceMngmt-1552092334.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("2EsR9", function(module, exports) {
$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return $94aadbde708c2ed9$export$24da22834a2c8907; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $hcrIp = parcelRequire("hcrIp");
const $94aadbde708c2ed9$export$24da22834a2c8907 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge",
                    defaultMessage: "Supercharge dev productivity"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge.bodytext",
                    defaultMessage: "Reduce bottlenecks and keep your software teams in the flow with everything you need to discover, plan, build, and operate world-class software."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos",
                    defaultMessage: "Eliminate knowledge silos"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos.bodyText",
                    defaultMessage: "Create better harmony between software and business teams by keeping work visible across your entire organization."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes",
                    defaultMessage: "Drive better business outcomes"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes.bodyText",
                    defaultMessage: "Connect and visualize data from all of your Atlassian and third-party tools to make faster and more informed decisions."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.softwareDevelopment.learnMore",
                defaultMessage: "Learn about software development"
            }),
            link: (0, $kooLp.useLocalizedHref)("/teams/software-development"),
            linkLabel: "Learn about software development",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5kq1t5b8yd8rfi6b617314esnw1mt5ra.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.softwareDevelopment.resources",
            defaultMessage: "Software development resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.headerText",
                    defaultMessage: "Open DevOps: Keep your tools, ditch the setup"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/solutions/devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-01-solutions@2x-310314428.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.headerText",
                    defaultMessage: "Atlassian named a Leader in the 2024 Gartner<sup>\xae</sup> Magic Quadrant\u2122 for DevOps Platforms",
                    values: (0, $hcrIp.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/gartner/magic-quadrant-devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-01-report@2x-1971220130.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo",
                    defaultMessage: "Demo"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.headerText",
                    defaultMessage: "Maximize Developer Experience Demo"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.linkText",
                        defaultMessage: "Watch on-demand"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/webinars/enterprise-cloud/Maximize-Developer-Experience-with-Atlassian"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch on-demand"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-03-demo@2x-531224759.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("3Fv2O", function(module, exports) {
$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return $70db6bec80cf2dea$export$26da8c8cc9d60467; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");
const $70db6bec80cf2dea$export$26da8c8cc9d60467 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess",
                    defaultMessage: "Plan for success"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess.bodytext",
                    defaultMessage: "Create, communicate, and organize your plans and content to make it easier for all teams to discover your org\u2019s most important work."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals",
                    defaultMessage: "Collaborate on shared goals"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals.bodyText",
                    defaultMessage: "Track and communicate your goals by sharing project status to keep everyone across your organization has visibility into work being done."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays",
                    defaultMessage: "Flex your ways of working"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays.bodyText",
                    defaultMessage: "Let your teams work the way they prefer, using their own process, language, and views while still staying connected to other team\u2019s projects."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.WorkManagement.learnMore",
                defaultMessage: "Learn about work management"
            }),
            link: (0, $kooLp.useLocalizedHref)("/solutions/work-management"),
            linkLabel: "Learn about work management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/65p0f3lsvwv2tt0v473y166n7i4147ad.webp",
                alt: "",
                width: 1519,
                height: 1093
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.WorkManagement.resources",
            defaultMessage: "Work management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.headerText",
                    defaultMessage: "Atlassian Work Management solutions and tools"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/solutions/work-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-01-solutions@2x-3900037778.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.headerText",
                    defaultMessage: "A Comprehensive Guide to Work Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.linkText",
                        defaultMessage: "Get the guide"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/blog/work-management/guide-to-work-management-2024"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Get the guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-02-guide@2x-511342337.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide",
                    defaultMessage: "Report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.headerText",
                    defaultMessage: "The economic benefits of improving work management with Atlassian"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/whitepapers/esg-work-management-report"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-03-report@2x-1528241620.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});



parcelRegister("lZygM", function(module, exports) {
$parcel$export(module.exports, "CarouselSection", function () { return $98754143592a1482$export$5edf3752a9da9c72; });
/* carousel-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");
parcelRequire("7rz8I");
var $h8tN9 = parcelRequire("h8tN9");

var $dweoU = parcelRequire("dweoU");
const $98754143592a1482$export$5edf3752a9da9c72 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4nbubfng"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
            name: "enterprise-page-testimonials",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h8tN9.ADG4CustomerTestimonials), {
                bgColor: "black",
                heading: intl.formatMessage({
                    id: "EnterpriseLandingPage.carousel.heading",
                    defaultMessage: "Trusted by over 80% of the Fortune 500"
                }),
                cta: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.carousel.heading.cta",
                        defaultMessage: "Explore all customers stories"
                    }),
                    url: (0, $kooLp.useLocalizedHref)("/customers?filterByEnterprise=true"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "customersSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.carousel.heading.ctaDataLabel",
                            defaultMessage: "Explore all customers stories"
                        }),
                        "data-label-english": "Explore all customers stories"
                    }
                },
                testimonials: $98754143592a1482$var$Testimonials(),
                className: "customer-stories-carousel"
            })
        })
    });
};
const $98754143592a1482$var$Testimonials = ()=>{
    const intl = (0, $8e22h.default)();
    const testimonials = [
        {
            name: "Sun Life Employee",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialSunLife), {}),
            title: "",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 SunLife on Black 2x 1-2143605095.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial1.quote",
                defaultMessage: "Jira Cloud and Confluence Cloud are a big step in the right direction from the previous tools we were using. All the new functionality really improved my day to day."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial1.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/sunlife"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial1.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Sun Life"
        },
        {
            name: "Mehmet Sari",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialMercedesBenz), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.title",
                defaultMessage: "Modern Collaboration Platform Team, Mercedes-Benz"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Mercedes-Benz on Black 2x 1-2641411897.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.quote",
                defaultMessage: "Atlassian cloud is the solution for high performance, high security, high availability, and the newest features."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial2.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/mercedes-benz"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial2.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Mercedes Benz"
        },
        {
            name: "Ryan Mosley",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialDHCS), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.title",
                defaultMessage: "Chief of Factory & Engineering Modernization, DHCS"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 DHCS on Black 2x 1-2317410165.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.quote",
                defaultMessage: "By tracking everything in Jira and all of our developer tools, we reduced the cost to get the team set up and deliver the product from $2.8 million to $600,000."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial3.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/dhcs"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial3.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "DHCS California Department of Health Care Services"
        },
        {
            name: "Mai Lian Scarlett",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialLumen), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.title",
                defaultMessage: "Former Senior Director, Agile Transformation Office, Lumen"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Lumen on Black 2x 1-2939378294.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.quote",
                defaultMessage: "Our partnership with Atlassian has really been an accelerator and an enabler to our digital transformation\u2026We\u2019re excited to see Atlassian\u2019s commitment to the cloud platform."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial4.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/lumen"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial4.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Lumen"
        },
        {
            name: "Oxana Trotsenko",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialUnited), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.title",
                defaultMessage: "Chief of Staff of Digital Technology, United Airlines"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 United on Black 2x 1-995190318.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.quote",
                defaultMessage: "Atlassian cloud provides you flexibility, cost savings over time, and efficiency\u2026When I think about technology in the modern world, we would not consider anything else."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial5.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/united-airlines"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial5.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "United Airlines"
        },
        {
            name: "Evan Lerer",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialRedfin), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.title",
                defaultMessage: "Director of Engineering, Redfin"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Redfin on Black 2x 1-8548123.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.quote",
                defaultMessage: "We trust Atlassian to help our team deliver world-class products that redefine real estate in the customer\u2019s favor."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial6.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/redfin"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial6.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Redfin"
        }
    ];
    return testimonials;
};
const $98754143592a1482$var$carouselSectionStyles = null;

});
parcelRegister("7rz8I", function(module, exports) {
$parcel$export(module.exports, "ADG4CustomerTestimonials", function () { return (parcelRequire("h8tN9")).ADG4CustomerTestimonials; });

var $h8tN9 = parcelRequire("h8tN9");

});
parcelRegister("h8tN9", function(module, exports) {
$parcel$export(module.exports, "ADG4CustomerTestimonials", function () { return $46cab561f3e1a3ae$export$d0511cb0623812b3; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $a9lfn = parcelRequire("a9lfn");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
// @ts-ignore
const $46cab561f3e1a3ae$var$AUTO_TRANSITION_INTERVAL = 8000;
/* eslint-disable local/ensure-wac-token-usage */ // Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $46cab561f3e1a3ae$var$backgroundColorStyleMap = {
    blue: "_bfhkdoyu",
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $46cab561f3e1a3ae$var$backgroundShapeStyleMap = {
    "image-left": "_mkrz75ra _1vthq8qa",
    "image-right": "_mkrz1ofp _1vth1ofp"
};
const $46cab561f3e1a3ae$var$customerImagesSectionStyleMap = {
    "image-left": "_1461n7od",
    "image-right": "_uhi5cs5v"
};
const $46cab561f3e1a3ae$var$customerQuotesSectionStyleMap = {
    "image-left": "_1461n7od",
    "image-right": "_uhi5kb7n _1fltkb7n"
};
const $46cab561f3e1a3ae$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $46cab561f3e1a3ae$var$topLineStyleMap = {
    blue: "_bfhk1nof",
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $46cab561f3e1a3ae$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f",
    "white-bg": "_d4ksr3uz _i862r3uz"
};
const $46cab561f3e1a3ae$export$d0511cb0623812b3 = ({ bgColor: bgColor = "blue", heading: heading, subheading: subheading, cta: cta, testimonials: testimonials, productKey: productKey, className: className, imagePosition: imagePosition = "left", testimonialCta: testimonialCta })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const logosContainerStyles = null;
    const bgTheme = bgColor === "blue" || bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                ref: scrollRef,
                className: sectionIsVisible ? "is-visible" : "",
                children: [
                    !heading && !subheading && !cta ? null : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _6rth1ylp"
                            ]),
                            children: [
                                heading && /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_1mouqlbw",
                                        ""
                                    ]),
                                    children: heading
                                }),
                                subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1mou1kvp",
                                        "body-lg"
                                    ]),
                                    children: subheading
                                }),
                                cta && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    text: cta.text,
                                    href: cta.url,
                                    dataEventProps: cta.dataEventProps,
                                    type: "primary"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: scrollRef,
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1pbykb7n _6rth1jfw",
                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                            `${className} ${sectionIsVisible ? "is-visible" : ""} image-${imagePosition} ${bgColor}-background`
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                            $46cab561f3e1a3ae$var$backgroundColorStyleMap[bgColor],
                                            $46cab561f3e1a3ae$var$backgroundShapeStyleMap[`image-${imagePosition}`],
                                            "bgshape"
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                        ]),
                                        children: testimonials.map((testimonial, index)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                                                id: `${index}`,
                                                panelIndex: index,
                                                forceRender: true,
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($46cab561f3e1a3ae$var$TopRowContent, {
                                                    testimonial: testimonial,
                                                    imagePosition: imagePosition,
                                                    index: index,
                                                    bgTheme: bgTheme,
                                                    bgColor: bgColor
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
                                            "row-width"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf",
                                                "_1e0clk1h _1jz9dz2r",
                                                "logos-container"
                                            ]),
                                            style: {
                                                "--_k8hunf": (0, $6ZVlx.default)(testimonialCta ? "flex" : "block"),
                                                "--_1t0o0zy": (0, $6ZVlx.default)(testimonialCta ? "0" : "auto")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4DraggableTabList), {
                                                    className: (0, $2jatx.default)([
                                                        "_6rth1fu0 _1q511aa3 _qtt8agmp",
                                                        "logos"
                                                    ]),
                                                    rowGap: "32px",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                                $46cab561f3e1a3ae$var$topLineStyleMap[bgColor],
                                                                "top-line"
                                                            ])
                                                        }),
                                                        testimonials.map((testimonial, index)=>{
                                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                                                as: "button",
                                                                className: (0, $2jatx.default)([
                                                                    $46cab561f3e1a3ae$var$logoOptionStyleMap[bgTheme],
                                                                    "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf",
                                                                    "logo-option"
                                                                ]),
                                                                tabIndex: index,
                                                                dataEventProps: {
                                                                    "data-product-key": productKey,
                                                                    "data-event-component": "tab",
                                                                    "data-event-container": "testimonialsSection",
                                                                    "data-event": "clicked",
                                                                    "data-label-english": testimonial.label
                                                                },
                                                                label: testimonial.label,
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($46cab561f3e1a3ae$var$LogoTabContent, {
                                                                    testimonialLogo: testimonial.logo
                                                                })
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                testimonialCta && testimonialCta
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
const $46cab561f3e1a3ae$var$TopRowContent = ({ testimonial: testimonial, imagePosition: imagePosition, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    var _testimonial_link_type;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v",
            "row-width top-row"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug",
                    $46cab561f3e1a3ae$var$customerImagesSectionStyleMap[`image-${imagePosition}`],
                    "customer-images-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: testimonial.title
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb",
                    $46cab561f3e1a3ae$var$customerQuotesSectionStyleMap[`image-${imagePosition}`],
                    "customer-quotes-section"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _1bahh9n0 _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        "testimonial-quotes-section"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6",
                            "quote-container"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $46cab561f3e1a3ae$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: (_testimonial_link_type = testimonial.link.type) !== null && _testimonial_link_type !== void 0 ? _testimonial_link_type : "primary",
                                bgColor: bgColor === "blue" || bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                dataEventProps: testimonial.link.dataEventProps
                            })
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $46cab561f3e1a3ae$var$topRowActiveStyle = null;
const $46cab561f3e1a3ae$var$customerImagesImgActiveStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerActiveStyle = null;
const $46cab561f3e1a3ae$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    isSelected && "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n",
                        "logo-img-container"
                    ]),
                    children: testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $46cab561f3e1a3ae$var$logoImgStyle = null;
const $46cab561f3e1a3ae$var$logoImgSelectedStyle = null;
const $46cab561f3e1a3ae$var$logoButtonStyle = null;
const $46cab561f3e1a3ae$var$topMarkerStyle = null;
const $46cab561f3e1a3ae$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $46cab561f3e1a3ae$var$headerStyles = null;
const $46cab561f3e1a3ae$var$h2Styles = null;
const $46cab561f3e1a3ae$var$pStyles = null;
const $46cab561f3e1a3ae$var$topLineStyles = null;
const $46cab561f3e1a3ae$var$testimonialKeyframeStyles = null;
const $46cab561f3e1a3ae$var$rowWidthStyle = null;
const $46cab561f3e1a3ae$var$topRowStyle = null;
const $46cab561f3e1a3ae$var$bgShapeStyle = null;
const $46cab561f3e1a3ae$var$customerImagesSectionStyles = null;
const $46cab561f3e1a3ae$var$customerImagesSectionImageStyles = null;
const $46cab561f3e1a3ae$var$customerQuotesSectionStyle = null;
const $46cab561f3e1a3ae$var$testimonialQuotesSectionStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerStyle = null;
const $46cab561f3e1a3ae$var$quoteContainerPStyle = null;
const $46cab561f3e1a3ae$var$logosContainerBaseStyle = null;
const $46cab561f3e1a3ae$var$logosStyle = null;
const $46cab561f3e1a3ae$var$logoOptionStyle = null;
const $46cab561f3e1a3ae$var$testimonialStyles = null;
const $46cab561f3e1a3ae$var$tabPanelWrapperStyles = null;

});


parcelRegister("dweoU", function(module, exports) {
$parcel$export(module.exports, "TestimonialRedfin", function () { return $ba4696cf403c7502$export$faa4c35a40f54c9f; });
$parcel$export(module.exports, "TestimonialDHCS", function () { return $ba4696cf403c7502$export$559c708bf478ce1; });
$parcel$export(module.exports, "TestimonialDropbox", function () { return $ba4696cf403c7502$export$3944c61ebd3bc79e; });
$parcel$export(module.exports, "TestimonialRoblox", function () { return $ba4696cf403c7502$export$d76e3d65f440a2bb; });
$parcel$export(module.exports, "TestimonialLumen", function () { return $ba4696cf403c7502$export$2d5c2c6aa86b2349; });
$parcel$export(module.exports, "TestimonialDoodle", function () { return $ba4696cf403c7502$export$72c6ec790fc33a37; });
$parcel$export(module.exports, "TestimonialRoyalCaribbean", function () { return $ba4696cf403c7502$export$ea2a07b098c3c428; });
$parcel$export(module.exports, "TestimonialMercedesBenz", function () { return $ba4696cf403c7502$export$3192ac60f265126c; });
$parcel$export(module.exports, "TestimonialSunLife", function () { return $ba4696cf403c7502$export$53d258996873a1e3; });
$parcel$export(module.exports, "TestimonialUnited", function () { return $ba4696cf403c7502$export$6a1b58616eb8f4e3; });
/* testimonial-logos.tsx generated by @compiled/babel-plugin v0.28.8 */ /* testimonial logos */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");
const $ba4696cf403c7502$export$c237744daee40794 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "25",
        viewBox: "0 0 69 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M56.6992 0.810686C54.0412 0.806395 51.4603 1.7031 49.3776 3.35447C47.295 1.70299 44.714 0.806273 42.056 0.810686C39.3982 0.806573 36.8175 1.70327 34.7348 3.35447C32.6524 1.70291 30.0715 0.806178 27.4136 0.810686C24.7558 0.806573 22.1751 1.70327 20.0924 3.35447C18.0098 1.70321 15.429 0.806512 12.7712 0.810686C6.24899 0.810686 0.963501 6.09579 0.963501 12.6184C0.963501 19.1402 6.2486 24.4261 12.7712 24.4261C15.429 24.4302 18.0097 23.5335 20.0924 21.8823C22.175 23.5336 24.7558 24.4303 27.4136 24.4261C30.0715 24.4305 32.6523 23.5338 34.7348 21.8823C36.8175 23.5335 39.3982 24.4302 42.056 24.4261C44.714 24.4305 47.2949 23.5338 49.3776 21.8823C51.4603 23.5338 54.0412 24.4305 56.6992 24.4261C63.2214 24.4261 68.5065 19.1406 68.5065 12.6184C68.5065 6.09617 63.2214 0.810686 56.6992 0.810686ZM18.1605 19.9534C16.6559 21.051 14.7762 21.7209 12.7712 21.7209C7.73975 21.7209 3.66831 17.6498 3.66831 12.6184C3.66831 7.58693 7.73975 3.5155 12.7712 3.5155C14.7762 3.5155 16.6547 4.18574 18.1605 5.28373C16.5015 7.36796 15.6007 9.95451 15.6063 12.6184C15.6075 15.2812 16.5075 17.8657 18.1605 19.9534ZM20.0928 18.0269C18.9324 16.4627 18.3077 14.5659 18.3115 12.6184C18.3066 10.6707 18.9314 8.77353 20.0928 7.20992C21.2539 8.77365 21.8787 10.6707 21.8741 12.6184C21.8777 14.5659 21.253 16.4627 20.0928 18.0269ZM32.8032 19.9534C31.24 21.1043 29.3486 21.7229 27.4075 21.7182C25.4703 21.7221 23.5832 21.1035 22.0244 19.9534C23.6775 17.866 24.5775 15.2815 24.5785 12.6188C24.5841 9.95489 23.6834 7.36835 22.0244 5.28412C23.583 4.13374 25.4702 3.51491 27.4075 3.51896C29.427 3.51896 31.2929 4.17229 32.8032 5.28412C31.1443 7.36835 30.2435 9.95489 30.2491 12.6188C30.2502 15.2815 31.1502 17.8659 32.8032 19.9534ZM34.7348 18.0269C33.5744 16.4627 32.9497 14.5659 32.9535 12.6184C32.9488 10.6707 33.5736 8.77362 34.7348 7.20992C35.8962 8.77352 36.5212 10.6706 36.5165 12.6184C36.5202 14.566 35.8953 16.4628 34.7348 18.0269ZM47.4457 19.9534C45.9353 21.0656 44.0694 21.7182 42.0503 21.7182C40.0311 21.7182 38.1771 21.0645 36.6668 19.9534C38.32 17.8661 39.22 15.2816 39.2209 12.6188C39.2265 9.95489 38.3258 7.36835 36.6668 5.28412C38.1771 4.17268 40.0311 3.51896 42.0503 3.51896C44.0694 3.51896 45.9353 4.17229 47.4457 5.28412C45.7869 7.36845 44.8862 9.95493 44.8915 12.6188C44.8928 15.2815 45.7928 17.8658 47.4457 19.9534ZM49.378 18.0269C48.2176 16.4627 47.5929 14.5659 47.5967 12.6184C47.5916 10.6706 48.2165 8.77346 49.378 7.20992C50.5391 8.77365 51.1639 10.6707 51.1593 12.6184C51.1628 14.5659 50.5381 16.4626 49.378 18.0269ZM56.6992 21.7209C54.6935 21.7209 52.8142 21.051 51.3099 19.9534C52.9629 17.8659 53.8629 15.2815 53.8641 12.6188C53.8694 9.95493 52.9687 7.36845 51.3099 5.28412C52.8157 4.18651 54.6938 3.51588 56.6992 3.51588C61.7299 3.51588 65.8021 7.58732 65.8021 12.6188C65.8021 17.6495 61.7299 21.7209 56.6992 21.7209Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$export$7952818aa3b430a7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$export$53457fb076dd0473 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "71",
        height: "30",
        viewBox: "0 0 71 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M6.19961 0H0.302734V29.4403H6.19961V0ZM21.6954 29.4381H27.5923V9.42706H21.6954V29.4381ZM36.7814 29.4381H43.5707L50.36 9.42706H44.4632C44.4632 9.42706 41.3098 20.2777 40.349 23.7307H40.2807C39.3199 20.2777 36.0982 9.42706 36.0982 9.42706H29.8576L36.7814 29.4381ZM70.9264 9.42706H65.2344V12.175C64.2736 10.0617 62.0127 8.86294 59.3375 8.86294C54.5381 8.86294 50.6972 12.8801 50.6972 19.4315C50.6972 25.9828 54.3993 30 59.0621 30C62.3543 30 64.2736 28.3803 65.3027 26.5469V29.4359H70.9925L70.9264 9.42706ZM65.1 19.9273C65.1 23.5919 62.9052 25.3526 60.7104 25.3526C58.3107 25.3526 56.7329 22.8162 56.7329 19.4337C56.7329 16.0511 58.379 13.5148 60.9153 13.5148C62.9713 13.5148 65.0978 15.2755 65.0978 18.9401V19.9273H65.1ZM7.70688 18.9401C17.1692 18.9401 19.364 10.8374 19.364 9.42706H18.542C9.07973 9.42706 6.88493 17.5297 6.88493 18.9401H7.70688ZM6.88493 19.6452C6.88493 21.1238 8.53103 29.3676 18.6787 29.3676H19.5006C19.5006 27.8889 17.8545 19.6452 7.70688 19.6452H6.88493ZM28.2093 3.93125C28.2093 2.02953 26.7703 0.407668 24.9171 0.407668C24.8488 0.407668 24.7805 0.407668 24.7122 0.407668C22.8611 0.337153 21.2833 1.81578 21.215 3.7197C21.215 3.79022 21.215 3.86073 21.215 3.93125C21.215 5.83297 22.654 7.45483 24.5072 7.45483C24.5755 7.45483 24.6439 7.45483 24.7122 7.45483C26.5632 7.52534 28.141 6.04672 28.2093 4.1428C28.2093 4.07228 28.2093 4.00176 28.2093 3.93125Z",
            fill: "white"
        })
    });
};
const $ba4696cf403c7502$export$17670a653fa957a4 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "102",
        height: "31",
        viewBox: "0 0 102 31",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 6.34607H3.55597V14.2464H11.0557V6.34607H14.6163V25.739H11.0557V17.6727H3.55597V25.739H0V6.34607ZM25.8816 19.4224C25.8816 21.0458 24.559 22.3669 22.936 22.3669C21.3123 22.3669 19.9905 21.0458 19.9905 19.4224V11.0731H16.6182V19.4224C16.6182 22.9057 19.4525 25.739 22.936 25.739C26.4186 25.739 29.2527 22.9057 29.2527 19.4224V11.0731H25.8816V19.4224ZM38.6669 11.1709C36.9941 11.1709 35.8265 11.6563 34.6988 12.7632V6.34607H31.3156V18.2388C31.3156 22.6904 34.5341 25.739 38.15 25.739C42.1699 25.739 45.692 22.636 45.692 18.4551C45.692 14.3273 42.4442 11.1709 38.6669 11.1709ZM38.751 22.6091C36.4585 22.6091 34.7054 20.6945 34.7054 18.4551C34.7054 16.2154 36.4585 14.3002 38.751 14.3002C40.6935 14.3002 42.4476 16.2154 42.4476 18.4551C42.4476 20.6945 40.6935 22.6091 38.751 22.6091ZM51.3744 12.0232C51.3744 10.3225 52.5076 9.78333 53.7482 9.78333C54.7469 9.78333 56.0685 10.5387 56.931 11.4561L59.1427 8.86645C58.0373 7.38286 55.7986 6.35742 53.9641 6.35742C50.2948 6.35742 47.6509 8.48878 47.6509 12.0232C47.6509 18.5786 55.7176 16.5007 55.7176 20.1706C55.7176 21.3024 54.6118 22.3015 53.3446 22.3015C51.3475 22.3015 50.6997 21.3303 49.7828 20.3048L47.3274 22.8404C48.8931 24.756 50.8348 25.7276 53.1552 25.7276C56.635 25.7276 59.4409 23.5694 59.4409 20.1967C59.4409 12.913 51.3744 15.1794 51.3744 12.0232ZM68.3475 10.9809C64.732 10.9809 61.5131 14.0277 61.5131 18.4802V30.4037H64.8961V23.956C66.0239 25.0621 67.191 25.5484 68.8644 25.5484C72.6415 25.5484 75.8897 22.3924 75.8897 18.2645C75.8897 14.0831 72.3666 10.9809 68.3475 10.9809ZM68.9487 22.4195C66.6564 22.4195 64.9031 20.5022 64.9031 18.2645C64.9031 16.0248 66.6564 14.1096 68.9487 14.1096C70.8908 14.1096 72.6451 16.0248 72.6451 18.2645C72.6451 20.5022 70.8908 22.4195 68.9487 22.4195ZM100.793 22.6091C98.7974 22.6091 98.2309 21.7462 98.2309 20.4238V14.5699H101.333V11.6027H98.2309V7.69061L94.8058 9.22798V21.1522C94.8058 24.201 96.9093 25.739 99.7946 25.739C100.226 25.739 100.82 25.7111 101.144 25.6312L101.981 22.5561C101.603 22.5822 101.172 22.6091 100.793 22.6091Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M91.8684 14.7425C91.2198 13.6266 90.3075 12.7321 89.1669 12.0586C88.3146 11.5624 87.4308 11.2475 86.4348 11.1122V7.56661C87.4308 7.14373 88.0489 6.20773 88.0489 5.11576C88.0489 3.62739 86.8553 2.42129 85.3681 2.42129C83.8798 2.42129 82.6653 3.62739 82.6653 5.11576C82.6653 6.20773 83.2477 7.14373 84.2437 7.56661V11.1138C83.4469 11.229 82.6207 11.4774 81.8662 11.859C80.325 10.6885 75.2715 6.84873 72.3153 4.60602C72.3854 4.35325 72.4394 4.09271 72.4394 3.81782C72.4394 2.16931 71.1044 0.83313 69.4553 0.83313C67.8062 0.83313 66.4718 2.16931 66.4718 3.81782C66.4718 5.46614 67.8076 6.80271 69.4567 6.80271C70.0192 6.80271 70.5395 6.63818 70.9885 6.36768L71.6123 6.84096L80.1848 13.0175C79.7316 13.4336 79.3095 13.9069 78.9719 14.4379C78.2877 15.5205 77.8696 16.7117 77.8696 18.011V18.2821C77.8696 19.1942 78.0429 20.0554 78.3381 20.8643C78.598 21.5706 78.9781 22.2128 79.4488 22.7934L76.6037 25.6455C76.1914 25.492 75.7436 25.4605 75.3139 25.5548C74.8841 25.649 74.4906 25.865 74.1803 26.1769C73.9655 26.3907 73.7953 26.6449 73.6794 26.925C73.5636 27.205 73.5044 27.5053 73.5055 27.8083C73.5057 28.4244 73.7457 29.0035 74.1815 29.4391C74.3951 29.6541 74.6493 29.8245 74.9293 29.9406C75.2092 30.0566 75.5094 30.1159 75.8125 30.1151C76.1157 30.1159 76.416 30.0566 76.696 29.9405C76.9761 29.8245 77.2303 29.654 77.4441 29.4391C77.6588 29.2253 77.829 28.9712 77.9449 28.6913C78.0608 28.4113 78.1201 28.1113 78.1194 27.8083C78.1194 27.5699 78.0825 27.3372 78.0132 27.1161L80.9539 24.175C81.357 24.4535 81.7925 24.688 82.2606 24.8901C83.1838 25.2893 84.2029 25.5325 85.3182 25.5325H85.5225C86.7555 25.5325 87.9186 25.2429 89.012 24.6505C90.1641 24.0245 91.0658 23.1683 91.7471 22.0754C92.4319 20.9794 92.809 19.7685 92.809 18.4363V18.3698C92.809 17.0593 92.5056 15.8502 91.8684 14.7425ZM88.2754 20.9121C87.4772 21.7991 86.5597 22.3455 85.5225 22.3455H85.3516C84.7592 22.3455 84.1798 22.1817 83.6125 21.8839C82.9731 21.5561 82.487 21.0884 82.0892 20.4962C81.6781 19.9149 81.455 19.2803 81.455 18.6074V18.4031C81.455 17.7415 81.5819 17.1143 81.9018 16.5219C82.2438 15.8743 82.7057 15.3708 83.3201 14.9704C83.9232 14.5728 84.5674 14.3778 85.2849 14.3778H85.3516C86.0022 14.3778 86.6181 14.5061 87.1993 14.8035C87.7915 15.1206 88.2754 15.5538 88.6504 16.1237C89.0148 16.6938 89.2315 17.3087 89.3012 17.9786C89.3122 18.1178 89.3177 18.2604 89.3177 18.3967C89.3177 19.3058 88.9703 20.1478 88.2754 20.9121Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$faa4c35a40f54c9f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "74",
        height: "21",
        viewBox: "0 0 74 21",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.2467 4.39989C36.9006 3.47215 35.0814 3.13135 32.662 3.13135H28.0898V18.8903H32.759C34.4205 18.8903 35.8515 18.6694 37.0461 18.1708C38.2467 17.6596 39.1866 16.8518 39.8233 15.6842C40.46 14.5166 40.7935 13.002 40.7935 11.0708C40.7935 9.40462 40.5934 8.0351 40.175 6.93696C39.7506 5.83883 39.1139 5.00576 38.2467 4.39989ZM37.0218 13.7972C36.7975 14.5861 36.4337 15.1856 35.8758 15.6022C35.2573 16.0566 34.3295 16.3027 33.1835 16.3027H31.5462V5.72523H32.9227C34.2749 5.73154 35.2755 5.95243 35.9486 6.46994C36.4397 6.85492 36.7854 7.38506 37.0097 8.11084C37.2341 8.84293 37.3311 9.75804 37.3311 10.9004C37.3311 12.0427 37.2462 13.0146 37.0218 13.7972Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M42.9609 18.8903H46.4234V12.1752H50.4194V9.60658H46.4234V5.72523H52.5963V3.13135H42.9609V18.8903Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M54.7842 18.8912H58.2467V3.13232H54.7842C54.7842 3.13232 54.76 18.8912 54.7842 18.8912Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M73.4648 3.13135H69.9902V12.1752L63.5505 3.13135H60.7793V18.8903H64.2599V9.60658L70.6269 18.8903H73.4648V3.13135Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.0294 19.4902C14.7384 19.3703 14.4473 19.1368 13.6651 17.7673L12.1006 15.0787L10.2633 11.9042L10.1056 11.6329C10.1966 11.6076 10.2815 11.576 10.3724 11.5445C12.4826 10.7935 13.7136 8.78021 13.7136 5.91496C13.7136 4.49495 13.1618 3.18855 12.1127 2.21032C11.9611 2.07778 11.8035 1.94525 11.6337 1.82534C10.233 0.859735 8.34105 0.5 5.8185 0.5H1.05841H0.985639C0.676384 0.5 0.646065 0.683023 0.767342 0.853424C0.87649 0.99858 1.00383 1.20054 1.05234 1.70543V17.5275C0.997767 18.1712 0.870427 18.3795 0.767342 18.5246C0.646065 18.695 0.70064 18.8843 1.00989 18.878H4.53904V12.1756H6.13988L7.26775 14.1699L8.68669 16.6755L9.37796 17.8935C10.2512 19.4271 11.0152 20.2728 12.5433 20.4558C12.7494 20.4874 12.9738 20.5 13.2103 20.5C13.2285 20.5 13.4286 20.5 13.4468 20.5C13.9925 20.5 14.5322 20.2728 14.8597 20.1213C14.9021 20.1024 14.9506 20.0835 14.9931 20.0645C15.3872 19.8752 15.272 19.5912 15.0294 19.4902ZM6.77659 9.60697H4.65425H4.53297V3.13174H6.77659C7.88626 3.13174 8.72913 3.28321 9.36584 3.88277C9.60232 4.11628 9.77817 4.39397 9.91158 4.72846C10.0692 5.13869 10.1481 5.62465 10.1481 6.21789C10.142 7.07621 10.0632 9.60697 6.77659 9.60697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M19.5662 12.1752H23.5683V9.60658H19.5662V5.71891H25.7391V3.13135H16.0977V18.8903H25.7391V16.2774H19.5662V12.1752Z",
                fill: "white"
            })
        ]
    });
};
const $ba4696cf403c7502$var$testimonialDHCSStyle = null;
const $ba4696cf403c7502$export$559c708bf478ce1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dhcs-2416114995.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb10e3 _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$export$2e83fbbf538f5ae7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "57",
        height: "34",
        viewBox: "0 0 57 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_7035_3621)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M38.2791 29.91C38.2336 29.8512 38.1835 29.8059 38.1153 29.7698C38.047 29.7336 37.9742 29.7109 37.8878 29.7109C37.8104 29.7109 37.7376 29.72 37.6694 29.7562C37.6012 29.7833 37.5466 29.8331 37.4965 29.8874C37.4465 29.9417 37.4192 30.0095 37.3919 30.0865C37.3646 30.1634 37.3555 30.2358 37.3555 30.3217V30.3308H38.4019C38.4019 30.2539 38.3928 30.1815 38.3746 30.1046C38.3564 30.0276 38.3291 29.9643 38.2791 29.9055V29.91Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M1.32617 26.4219V34.0001H55.8044V26.4219H1.32617ZM14.3065 31.7741L13.9744 30.9145H12.6959L12.382 31.7741H11.9361L13.2009 28.4578H13.4876L14.7751 31.7741H14.3065ZM16.4767 29.8241C16.3994 29.7879 16.3266 29.7653 16.2401 29.7653C16.1628 29.7653 16.0763 29.7834 16.0035 29.8332C15.9171 29.8694 15.8307 29.9372 15.7351 30.0323V31.7651H15.2983V29.3989H15.6623L15.7215 29.6658C15.7988 29.5979 15.8625 29.5436 15.9217 29.4939C15.9808 29.4577 16.0354 29.417 16.0945 29.3989C16.14 29.3808 16.1992 29.3627 16.2356 29.3536C16.2811 29.3446 16.322 29.3446 16.3675 29.3446C16.4267 29.3446 16.4813 29.3536 16.5313 29.3627C16.5768 29.3808 16.6178 29.3989 16.6542 29.4215L16.4813 29.8287L16.4767 29.8241ZM18.0509 31.7741H17.7188L16.7952 29.3989H17.2411L17.878 31.1995H17.8871L18.6014 29.3989H19.0291L18.0464 31.7741H18.0509ZM20.8217 31.756L20.7261 31.5298C20.6988 31.566 20.6488 31.5977 20.6033 31.6338C20.5578 31.661 20.4987 31.6927 20.4395 31.7198C20.3804 31.7379 20.3167 31.756 20.2484 31.7786C20.1802 31.7877 20.1074 31.7967 20.0209 31.7967C19.9163 31.7967 19.8208 31.7877 19.7343 31.7515C19.6388 31.7243 19.5614 31.6746 19.4977 31.6112C19.4295 31.5524 19.3749 31.48 19.3339 31.385C19.2975 31.2991 19.2748 31.195 19.2748 31.0819C19.2748 30.8466 19.3612 30.6566 19.5205 30.5209C19.6843 30.3897 19.9208 30.3128 20.2348 30.3037L20.6897 30.2856V30.1997C20.6897 30.1137 20.6806 30.0368 20.6534 29.9734C20.6261 29.9101 20.5942 29.8603 20.5487 29.8241C20.5123 29.7879 20.4532 29.7563 20.3986 29.7382C20.344 29.7201 20.2757 29.711 20.2075 29.711C20.1301 29.711 20.0664 29.7201 20.0073 29.7291C19.939 29.7382 19.8844 29.7563 19.8344 29.7744C19.7889 29.7925 19.7389 29.8106 19.7025 29.8422C19.6661 29.8739 19.6251 29.8875 19.5887 29.9191L19.4249 29.616C19.5023 29.5572 19.5751 29.521 19.6433 29.4848C19.7116 29.4486 19.7844 29.417 19.8526 29.3989C19.9208 29.3717 19.9845 29.3627 20.0619 29.3536C20.1301 29.3446 20.2029 29.3446 20.2803 29.3446C20.4031 29.3446 20.5169 29.3627 20.6215 29.3898C20.7261 29.417 20.8126 29.4667 20.8899 29.5301C20.9673 29.5979 21.0219 29.6794 21.0719 29.7879C21.1174 29.892 21.1402 30.0232 21.1402 30.177V31.3217C21.1402 31.4167 21.1493 31.5026 21.1493 31.5569C21.1584 31.6158 21.1675 31.6429 21.1675 31.6791C21.1675 31.7153 21.1766 31.747 21.1857 31.7651H20.8126L20.8217 31.756ZM22.9555 31.747C22.8327 31.7922 22.7189 31.8148 22.6143 31.8148C22.5187 31.8148 22.4414 31.8058 22.3777 31.7786C22.314 31.7515 22.2549 31.7198 22.2139 31.6746C22.1684 31.6293 22.1366 31.5705 22.1184 31.5117C22.1002 31.4438 22.0911 31.3805 22.0911 31.3036V29.7698H21.6998V29.3989H22.0911V28.8695L22.5369 28.7293V29.4034H23.2603L23.1193 29.7653H22.5369V31.1588C22.5369 31.2538 22.5551 31.3307 22.5961 31.376C22.637 31.4212 22.6916 31.4438 22.769 31.4438C22.8054 31.4438 22.8463 31.4348 22.8827 31.4257C22.9191 31.4167 22.9601 31.4076 22.9965 31.3895C23.0329 31.3714 23.0647 31.3624 23.092 31.3443C23.1102 31.3171 23.1375 31.3081 23.1602 31.2855L23.2922 31.5886C23.1875 31.6655 23.0829 31.7198 22.9601 31.7605L22.9555 31.747ZM25.8218 31.0909C25.7627 31.2538 25.6808 31.385 25.5761 31.4981C25.4806 31.5931 25.3669 31.67 25.2349 31.7243C25.103 31.7696 24.9574 31.8012 24.7981 31.8012C24.4842 31.8012 24.234 31.7062 24.0383 31.5162C23.9337 31.4031 23.8472 31.2719 23.7927 31.109C23.7335 30.9462 23.7062 30.7697 23.7062 30.5797C23.7062 30.3897 23.7335 30.2178 23.7927 30.0594C23.8518 29.8965 23.9337 29.7653 24.0383 29.6522C24.1339 29.5482 24.2476 29.4712 24.3796 29.4169C24.5024 29.3581 24.648 29.331 24.8072 29.331C24.9801 29.331 25.1212 29.3581 25.2531 29.4169C25.3851 29.4758 25.4988 29.5482 25.5943 29.6522C25.699 29.7653 25.7854 29.8965 25.8218 30.0503C25.881 30.1997 25.9083 30.3806 25.9083 30.5706C25.9083 30.7607 25.881 30.9326 25.8218 31.0909ZM29.7755 31.281C29.7164 31.3941 29.6436 31.48 29.548 31.5569C29.4525 31.6339 29.3388 31.6881 29.2068 31.7379C29.0749 31.7741 28.9293 31.8058 28.7791 31.8058C28.6654 31.8058 28.5699 31.7967 28.4743 31.7786C28.3788 31.7605 28.2923 31.7424 28.215 31.7108C28.1376 31.6836 28.0739 31.6519 28.0057 31.6248C27.9374 31.5977 27.8919 31.5569 27.8328 31.5298L28.033 31.1905C28.0694 31.2176 28.1103 31.2493 28.1558 31.2764C28.2013 31.3036 28.2605 31.3352 28.3287 31.3533C28.3879 31.3714 28.4607 31.3895 28.5289 31.4122C28.6062 31.4303 28.679 31.4303 28.7564 31.4303C28.8246 31.4303 28.8974 31.4212 28.9748 31.4031C29.0521 31.385 29.1158 31.3579 29.175 31.3172C29.2341 31.2764 29.2796 31.2312 29.316 31.1769C29.3524 31.1181 29.3751 31.0457 29.3751 30.9688C29.3751 30.8828 29.357 30.7969 29.316 30.7335C29.2751 30.6702 29.2205 30.6023 29.1522 30.5435C29.084 30.4847 29.0112 30.4394 28.9247 30.3806C28.8383 30.3354 28.7518 30.2856 28.6654 30.2313C28.579 30.1861 28.4925 30.1273 28.4061 30.0684C28.3196 30.0096 28.2423 29.9463 28.1786 29.8694C28.1103 29.7925 28.0557 29.7065 28.0057 29.6115C27.9693 29.5165 27.9374 29.4034 27.9374 29.2722C27.9374 29.1591 27.9556 29.046 28.0057 28.9419C28.0512 28.8378 28.1103 28.7519 28.1968 28.675C28.2832 28.5981 28.3879 28.5438 28.5107 28.494C28.6335 28.4488 28.7791 28.4261 28.9293 28.4261C29.1022 28.4261 29.2523 28.4442 29.3751 28.4849C29.498 28.5257 29.6026 28.5619 29.68 28.5981L29.6709 29.0324C29.5662 28.9645 29.4616 28.9193 29.3297 28.8831C29.2068 28.8469 29.0703 28.8152 28.9384 28.8152C28.861 28.8152 28.7882 28.8243 28.72 28.8424C28.6517 28.8605 28.5971 28.8786 28.538 28.9193C28.4925 28.9555 28.4425 28.9962 28.4152 29.0505C28.3879 29.0957 28.3697 29.1636 28.3697 29.2405C28.3697 29.3265 28.3879 29.4034 28.4379 29.4667C28.4743 29.5346 28.5335 29.5979 28.6017 29.6477C28.6699 29.7065 28.7427 29.7608 28.8292 29.8106C28.9156 29.8603 29.0021 29.9146 29.0976 29.9599C29.1932 30.0051 29.2796 30.0639 29.3661 30.1318C29.4525 30.1906 29.5298 30.2539 29.5935 30.3309C29.6982 30.4168 29.7573 30.5028 29.7937 30.5978C29.8301 30.6928 29.862 30.8059 29.862 30.9281C29.862 31.0593 29.8347 31.1859 29.7755 31.29V31.281ZM31.5818 31.946C31.5044 32.1632 31.4316 32.3351 31.3452 32.4663C31.2587 32.5975 31.1723 32.7016 31.0858 32.7694C30.9994 32.8464 30.9039 32.8916 30.8083 32.9097C30.7128 32.9278 30.6172 32.9459 30.5126 32.9459C30.4079 32.9459 30.3215 32.9368 30.2441 32.9187C30.1668 32.9007 30.1031 32.8826 30.0349 32.8509L30.1486 32.5116C30.1941 32.5387 30.2532 32.5568 30.3124 32.5704C30.3715 32.5794 30.4352 32.5885 30.5035 32.5885C30.5717 32.5885 30.6354 32.5704 30.7037 32.5432C30.7719 32.5161 30.8356 32.4663 30.8948 32.403C30.9539 32.3396 31.0085 32.2537 31.0676 32.1451C31.1268 32.041 31.1723 31.9189 31.2087 31.7651L30.1304 29.3989H30.599L31.4089 31.2448H31.4271L32.0458 29.3989H32.4826L31.5772 31.946H31.5818ZM34.3935 31.4257C34.348 31.5117 34.2797 31.5886 34.1933 31.6429C34.1068 31.7017 34.0113 31.7379 33.8976 31.7651C33.7838 31.7922 33.6701 31.8012 33.5336 31.8012C33.4471 31.8012 33.3607 31.7922 33.297 31.7832C33.2197 31.7741 33.156 31.756 33.0968 31.7379C33.0377 31.7198 32.9831 31.7017 32.9239 31.67C32.8784 31.6519 32.8284 31.6248 32.792 31.5931L32.9421 31.2538C32.9785 31.2719 33.0195 31.2991 33.0559 31.3217C33.1014 31.3398 33.1423 31.3579 33.1969 31.3805C33.2561 31.3986 33.3015 31.4076 33.3607 31.4257C33.4198 31.4348 33.4744 31.4438 33.5427 31.4438C33.6109 31.4438 33.6746 31.4348 33.7338 31.4257C33.7929 31.4076 33.8384 31.3895 33.8839 31.3579C33.9203 31.3307 33.9613 31.2991 33.9795 31.2538C33.9977 31.2176 34.0159 31.1678 34.0159 31.1226C34.0159 31.0547 33.9977 31.0005 33.9704 30.9507C33.9431 30.9009 33.9021 30.8647 33.8475 30.8285C33.802 30.7923 33.7429 30.7607 33.6746 30.7335C33.6064 30.7064 33.5427 30.6747 33.4744 30.6476C33.4062 30.6204 33.3425 30.5797 33.2743 30.5435C33.206 30.5073 33.1514 30.4575 33.1014 30.4123C33.0559 30.3535 33.0058 30.2992 32.9785 30.2223C32.9512 30.1454 32.933 30.0594 32.933 29.9553C32.933 29.8694 32.9512 29.7834 32.9785 29.6975C33.0149 29.6205 33.065 29.5482 33.1287 29.4893C33.1924 29.4305 33.2788 29.3853 33.388 29.3491C33.4926 29.3129 33.6064 29.3038 33.752 29.3038C33.8839 29.3038 33.9977 29.3129 34.1023 29.34C34.2069 29.3581 34.2934 29.3989 34.3798 29.426V29.806C34.3343 29.7879 34.2843 29.7698 34.2479 29.7472C34.2024 29.7291 34.1523 29.7201 34.1068 29.702C34.0614 29.6929 34.0022 29.6748 33.9567 29.6748C33.8976 29.6658 33.843 29.6658 33.7838 29.6658C33.7247 29.6658 33.6701 29.6748 33.62 29.6839C33.57 29.6929 33.5245 29.711 33.4881 29.7291C33.4517 29.7472 33.4198 29.7744 33.4016 29.8151C33.3834 29.8558 33.3743 29.892 33.3743 29.9372C33.3743 29.9961 33.3925 30.0504 33.4198 30.0865C33.4471 30.1227 33.4972 30.1635 33.5427 30.1997C33.5882 30.2358 33.6473 30.2675 33.7156 30.2947C33.7838 30.3218 33.8475 30.3535 33.9158 30.3897C33.984 30.4168 34.0477 30.4575 34.116 30.4937C34.1842 30.5299 34.2388 30.5797 34.2888 30.634C34.3571 30.7109 34.3935 30.7652 34.4208 30.8421C34.4481 30.919 34.4663 31.005 34.4663 31.1C34.4663 31.2221 34.439 31.3352 34.3889 31.4212L34.3935 31.4257ZM36.1542 31.747C36.0314 31.7922 35.9176 31.8148 35.813 31.8148C35.7174 31.8148 35.6401 31.8058 35.5764 31.7786C35.5127 31.7515 35.4536 31.7198 35.4126 31.6746C35.3671 31.6293 35.3353 31.5705 35.3171 31.5117C35.2989 31.4438 35.2898 31.3805 35.2898 31.3036V29.7698H34.8985V29.3989H35.2898V28.8695L35.7356 28.7293V29.4034H36.459L36.318 29.7653H35.7356V31.1588C35.7356 31.2538 35.7538 31.3307 35.7948 31.376C35.8357 31.4212 35.8903 31.4438 35.9677 31.4438C36.0041 31.4438 36.045 31.4348 36.0814 31.4257C36.1178 31.4167 36.1588 31.4076 36.1952 31.3895C36.2316 31.3714 36.2634 31.3624 36.2907 31.3443C36.3089 31.3171 36.3362 31.3081 36.359 31.2855L36.4909 31.5886C36.3863 31.6655 36.2816 31.7198 36.1588 31.7605L36.1542 31.747ZM38.9068 30.6566H37.3917C37.3917 30.7697 37.4008 30.8647 37.4372 30.9597C37.4645 31.0547 37.5146 31.1407 37.5783 31.204C37.6374 31.281 37.7102 31.3352 37.8058 31.376C37.9013 31.4167 38.006 31.4348 38.1197 31.4348C38.2243 31.4348 38.329 31.4167 38.4245 31.376C38.5292 31.3398 38.6156 31.2991 38.7021 31.2538L38.8249 31.5569C38.7112 31.6429 38.5974 31.6972 38.4518 31.7379C38.3199 31.7741 38.1743 31.7967 38.0424 31.7967C37.8422 31.7967 37.6784 31.7605 37.5373 31.6927C37.3963 31.6248 37.278 31.5298 37.187 31.4167C37.096 31.3036 37.0232 31.1724 36.9777 31.0185C36.9322 30.8692 36.9095 30.7154 36.9095 30.5435C36.9095 30.3716 36.9277 30.2223 36.9777 30.0684C37.0232 29.9282 37.0915 29.7925 37.1779 29.6884C37.2644 29.5844 37.369 29.4984 37.4918 29.4305C37.6147 29.3627 37.7512 29.3355 37.9013 29.3355C38.0515 29.3355 38.197 29.3627 38.3108 29.4215C38.4245 29.4803 38.5292 29.5617 38.6156 29.6658C38.693 29.7698 38.7567 29.901 38.834 30.0368C38.8795 30.1861 38.9022 30.358 38.9022 30.539V30.6521L38.9068 30.6566ZM42.9651 31.7651H42.5193V30.2404C42.5193 30.1635 42.5102 30.1001 42.5011 30.0323C42.492 29.9644 42.4738 29.9191 42.4419 29.8694C42.4146 29.8241 42.3737 29.7834 42.3282 29.7563C42.2827 29.7291 42.2235 29.7201 42.1371 29.7201C42.0597 29.7201 41.996 29.7291 41.9369 29.7472C41.8687 29.7653 41.8141 29.7925 41.7549 29.8241C41.6958 29.8513 41.6412 29.892 41.5911 29.9282L41.4501 30.0413C41.4501 30.0413 41.4592 30.0775 41.4592 30.1001V31.7651H41.0133V30.2494C41.0133 30.1725 41.0042 30.1092 40.9951 30.0413C40.986 29.9734 40.9678 29.9191 40.936 29.8694C40.9041 29.8196 40.8677 29.7834 40.8222 29.7563C40.7767 29.7291 40.7085 29.7201 40.6311 29.7201C40.5538 29.7201 40.4901 29.7291 40.431 29.7472C40.3627 29.7653 40.3081 29.7925 40.249 29.8241C40.1898 29.8558 40.1352 29.892 40.0852 29.9282L39.9441 30.0413V31.747H39.4983V29.3808H39.8713L39.9305 29.6567C40.0806 29.5436 40.2262 29.4577 40.3582 29.3989C40.4901 29.34 40.6357 29.3129 40.7585 29.3129C40.8996 29.3129 41.027 29.3491 41.1316 29.4169C41.2362 29.4848 41.3136 29.5798 41.35 29.6929C41.4182 29.6341 41.4819 29.5798 41.5593 29.5301C41.6366 29.4803 41.7003 29.4441 41.7777 29.4079C41.855 29.3808 41.9187 29.3491 41.9961 29.331C42.0734 29.3129 42.1371 29.3038 42.2053 29.3038C42.3009 29.3038 42.3964 29.3129 42.4829 29.34C42.5693 29.3672 42.6467 29.4079 42.7195 29.4622C42.815 29.5572 42.8696 29.6432 42.9105 29.7382C42.9469 29.8332 42.9697 29.9553 42.9697 30.1092V31.7651H42.9651ZM45.1081 31.4303C45.0626 31.5117 44.9943 31.5886 44.9079 31.6429C44.8214 31.6972 44.7259 31.7379 44.6121 31.7651C44.4984 31.7922 44.3847 31.8012 44.2482 31.8012C44.1617 31.8012 44.0753 31.7922 44.0116 31.7832C43.9342 31.7741 43.8705 31.756 43.8114 31.7379C43.7522 31.7198 43.6976 31.7017 43.6385 31.6746C43.593 31.6565 43.543 31.6293 43.5066 31.6022L43.6567 31.2674C43.6931 31.2855 43.734 31.3126 43.7704 31.3307C43.8159 31.3488 43.8569 31.3669 43.9115 31.385C43.9706 31.4031 44.0161 31.4122 44.0753 31.4303C44.1344 31.4393 44.189 31.4484 44.2573 31.4484C44.3255 31.4484 44.3892 31.4393 44.4483 31.4303C44.5075 31.4122 44.553 31.3941 44.5985 31.3669C44.6349 31.3398 44.6758 31.3126 44.694 31.2629C44.7122 31.2267 44.7304 31.1814 44.7304 31.1317C44.7304 31.0683 44.7122 31.0095 44.6849 30.9643C44.6576 30.919 44.6167 30.8828 44.5621 30.8421C44.5166 30.8059 44.4574 30.7788 44.3892 30.7471C44.321 30.7199 44.2573 30.6928 44.189 30.6657C44.1208 30.6385 44.0571 30.6023 43.9888 30.5616C43.9206 30.5254 43.866 30.4802 43.8159 30.4304C43.7704 30.3761 43.7204 30.3173 43.6931 30.2449C43.6658 30.1725 43.6476 30.0865 43.6476 29.9825C43.6476 29.901 43.6658 29.8151 43.6931 29.7337C43.7295 29.6613 43.7795 29.5843 43.8432 29.5301C43.9069 29.4758 43.9934 29.426 44.1026 29.3898C44.2072 29.3536 44.321 29.3446 44.4665 29.3446C44.5985 29.3446 44.7122 29.3536 44.8169 29.3808C44.9215 29.3989 45.008 29.435 45.0944 29.4622V29.8332C45.0489 29.8151 44.9989 29.797 44.9625 29.7789C44.917 29.7608 44.8669 29.7517 44.8214 29.7337C44.7759 29.7156 44.7168 29.7065 44.6713 29.7065C44.6121 29.6975 44.5575 29.6975 44.4984 29.6975C44.4392 29.6975 44.3847 29.7065 44.3346 29.7156C44.2891 29.7246 44.2391 29.7427 44.2027 29.7608C44.1663 29.7789 44.1344 29.806 44.1162 29.8422C44.098 29.8784 44.0889 29.9146 44.0889 29.9644C44.0889 30.0187 44.1071 30.0775 44.1344 30.1137C44.1617 30.1499 44.2118 30.1861 44.2573 30.2268C44.3028 30.2675 44.3619 30.2901 44.4301 30.3218C44.4984 30.349 44.5621 30.3761 44.6303 30.4168C44.6986 30.444 44.7623 30.4802 44.8305 30.5209C44.8988 30.5616 44.9534 30.6023 45.0034 30.6611C45.0489 30.7154 45.099 30.7742 45.1263 30.8466C45.1627 30.9281 45.1854 31.014 45.1854 31.1181C45.1854 31.2402 45.1581 31.3488 45.1081 31.4348V31.4303Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M20.6989 30.6386L20.2712 30.6567C20.0801 30.6657 19.9391 30.7019 19.8526 30.7698C19.7662 30.8376 19.7207 30.9191 19.7207 31.0457C19.7207 31.1046 19.7298 31.1589 19.748 31.2086C19.7662 31.2539 19.7935 31.2946 19.8344 31.3308C19.8754 31.367 19.9118 31.3986 19.9664 31.4167C20.0255 31.4348 20.0892 31.4439 20.1575 31.4439C20.2348 31.4439 20.2894 31.4439 20.3486 31.4258C20.4077 31.4077 20.4532 31.3896 20.4987 31.367C20.5442 31.3443 20.5851 31.3217 20.6215 31.2901C20.6488 31.2629 20.6807 31.2448 20.708 31.2131H20.6989V30.634V30.6386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M13.4011 29.2857C13.3829 29.2178 13.3647 29.1636 13.3556 29.1047H13.3465C13.3283 29.1726 13.3101 29.2269 13.2874 29.2948C13.2646 29.3626 13.2419 29.435 13.21 29.5119L12.8506 30.5073H13.8197L13.4784 29.5119C13.4511 29.426 13.4193 29.349 13.4011 29.2857Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M25.2891 29.9373C25.23 29.8604 25.1663 29.7971 25.0798 29.7563C24.9934 29.7111 24.8979 29.6885 24.7932 29.6885C24.6886 29.6885 24.6021 29.7156 24.5157 29.7563C24.4383 29.8016 24.3746 29.8604 24.3155 29.9373C24.2563 30.0142 24.2199 30.1092 24.1926 30.2133C24.1653 30.3174 24.1562 30.4305 24.1562 30.5617C24.1562 30.6929 24.1744 30.8195 24.2017 30.9236C24.229 31.0277 24.2791 31.1227 24.3337 31.1996C24.3928 31.2765 24.4565 31.3398 24.543 31.3806C24.6203 31.4258 24.7159 31.4484 24.8205 31.4484C24.9252 31.4484 25.0207 31.4213 25.098 31.3806C25.1754 31.3353 25.2391 31.2765 25.2982 31.1996C25.3437 31.1227 25.3938 31.0277 25.4211 30.9236C25.4484 30.8195 25.4666 30.7064 25.4666 30.5752C25.4666 30.444 25.4484 30.3174 25.4211 30.2133C25.3847 30.1092 25.3437 30.0142 25.2891 29.9373Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M49.0617 17.776H49.8989V23.4585H49.2892L46.3183 19.3957V23.4585H45.4811V17.776H46.1863L49.0617 21.7076V17.776ZM42.401 17.7308L44.6394 23.4585H43.6794L43.1835 22.1058H40.9633L40.4673 23.4585H39.5438L41.8095 17.7308H42.401ZM42.906 21.3774L42.0688 19.0835L41.2317 21.3774H42.906ZM37.4008 17.776L35.7447 21.3457L34.0295 17.776H33.256L32.6555 23.4585H33.5609L33.9249 19.4636L35.5446 22.8342H35.8949L37.4964 19.3776L37.8786 23.4676H38.7657L38.1652 17.7851H37.4054V17.776H37.4008ZM29.0612 19.0926C29.0612 18.6175 29.4525 18.3551 30.0804 18.3551C30.6036 18.3551 31.1177 18.613 31.327 18.7442L31.6318 18.0611C31.4589 17.9479 30.822 17.6177 30.0622 17.6177C28.902 17.6177 28.1558 18.2239 28.1558 19.1605C28.1558 21.1602 30.9948 20.4001 30.9948 21.8524C30.9948 22.4406 30.4898 22.7256 29.7482 22.7256H28.6836L28.3424 23.4721H29.771C31.1313 23.4721 31.9048 22.7618 31.9048 21.7936C31.923 19.6536 29.0658 20.3142 29.0658 19.0926H29.0612ZM25.7354 17.776H24.8573V23.4585H27.6554L27.9966 22.712H25.7308V17.776H25.7354ZM21.3358 20.8435H23.3559V20.106H21.3358V18.5044H23.6789V17.767H20.4714V23.4495H23.7654V22.712H21.3358V20.848V20.8435ZM15.403 18.5135H17.0045V23.4585H17.8826V18.5135H19.4841V17.767H15.4075V18.5135H15.403ZM14.5931 19.4636C14.5931 18.5813 14.0699 17.776 12.7914 17.776H10.9989V23.4585H11.8542V18.4501H12.5776C13.2828 18.4501 13.6923 18.8845 13.6923 19.4455C13.6923 20.3051 13.0735 20.6082 12.2364 20.6082H12.1226L13.9698 23.4585H15.0345L13.4148 21.0426C14.0608 20.8254 14.584 20.3051 14.584 19.4591L14.5931 19.4636ZM7.28629 20.8435H9.31547V20.106H7.29539V18.5044H9.6385V17.767H6.43095V23.4495H9.72494V22.712H7.29539L7.28629 20.848V20.8435ZM5.30717 21.7845C5.30717 22.6758 4.68841 23.4902 3.15516 23.4902H1.32617V17.7489H3.17335C4.51552 17.7489 5.03874 18.4139 5.03874 19.1695C5.03874 19.7577 4.65656 20.1468 4.28803 20.3458C4.74301 20.5177 5.30717 20.8933 5.30717 21.7845ZM4.41998 21.8388C4.41998 21.0607 3.75117 20.7485 2.90492 20.7485H2.63649L2.94132 20.0744C3.38719 20.0744 4.16064 19.9974 4.16064 19.1921C4.16064 18.8121 3.91496 18.4366 3.08236 18.4366H2.16787V22.7935H3.12786C3.87856 22.7844 4.41543 22.4451 4.41543 21.8388H4.41998ZM54.9536 17.776V21.7076L52.0782 17.776H51.373V23.4585H52.2101V19.3957L55.1811 23.4585H55.7908V17.776H54.9536Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M43.0972 3.15343H45.5177V5.27532H43.0972V9.92628C43.0972 10.8945 43.4612 11.3288 44.3939 11.3288H45.2037V13.4416H43.3474C41.3274 13.4416 40.4811 12.288 40.4811 10.7135V5.27532H38.9479V3.15343H40.4811V0.787226L43.1018 0V3.15343H43.0972ZM37.3054 10.7226C37.3054 12.202 37.3509 12.9576 37.5056 13.4416H35.0761L34.8577 12.5323C34.1798 13.1385 33.238 13.6588 31.8685 13.6588C29.9622 13.6588 28.479 12.3151 28.479 10.2973C28.479 8.16633 30.1669 6.95383 32.8012 6.86786L34.6666 6.8V6.57379C34.6666 5.33413 33.7612 5.031 32.6647 5.031C31.732 5.031 29.7484 5.12601 29.7484 5.12601V3.167C29.7484 3.167 31.5955 3.07199 33.1879 3.07199C35.7403 3.07199 37.2918 4.04019 37.2918 6.73666V10.7226H37.3009H37.3054ZM34.6711 8.60067L33.1561 8.64591C31.7366 8.6821 31.0996 9.23407 31.0996 10.0937C31.0996 10.9533 31.6911 11.5912 32.7876 11.5912C33.7021 11.5912 34.3299 11.2428 34.6711 10.9397V8.60067ZM23.0011 9.83127L20.5898 3.15343H17.6871L21.8956 13.4281H23.8883L28.1833 3.15343H25.4898L23.0057 9.83127H23.0011ZM13.5332 3.15343H11.2947V13.4281H13.9518V6.26613C14.5614 5.69607 15.2939 5.59202 15.9127 5.59202C16.122 5.59202 16.3813 5.61916 16.6543 5.70512V3.13985C15.6715 3.13985 14.8526 3.28011 13.8244 4.23021L13.5286 3.1489L13.5332 3.15343ZM9.06082 10.7226C9.06082 12.202 9.10631 12.9576 9.261 13.4416H6.83146L6.61307 12.5323C5.93516 13.1385 4.99337 13.6588 3.62391 13.6588C1.71758 13.6588 0.234375 12.3151 0.234375 10.2973C0.234375 8.16633 1.92232 6.95383 4.5566 6.86786L6.42198 6.8V6.57379C6.42198 5.33413 5.51659 5.031 4.42011 5.031C3.48742 5.031 1.50374 5.12601 1.50374 5.12601V3.167C1.50374 3.167 3.35093 3.07199 4.94333 3.07199C7.49571 3.07199 9.04717 4.04019 9.04717 6.73666V10.7226H9.05627H9.06082ZM6.42198 8.60067L4.90693 8.64591C3.48742 8.6821 2.85046 9.23407 2.85046 10.0937C2.85046 10.9533 3.44192 11.5912 4.5384 11.5912C5.45289 11.5912 6.08075 11.2428 6.42198 10.9397V8.60067ZM56.8965 8.27944C56.8965 11.3876 54.8855 13.7629 51.6962 13.7629C48.5068 13.7629 46.5322 11.3967 46.5322 8.3654C46.5322 4.85003 48.9026 2.8322 51.7144 2.8322C54.5261 2.8322 56.8965 4.78217 56.8965 8.27944ZM54.2031 8.29754C54.2031 6.3159 53.2886 4.88623 51.6689 4.88623C50.0492 4.88623 49.2029 6.38377 49.2029 8.29754C49.2029 10.2113 50.1447 11.745 51.7371 11.745C53.3295 11.745 54.2031 10.2294 54.2031 8.29754Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_7035_3621",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "56.6667",
                        height: "34",
                        fill: "white",
                        transform: "translate(0.229492)"
                    })
                })
            })
        ]
    });
};
const $ba4696cf403c7502$var$testimonialDropboxStyle = null;
const $ba4696cf403c7502$export$3944c61ebd3bc79e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-dropbox-2272682323.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsbs0l4 _4t3izwfg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialRobloxStyle = null;
const $ba4696cf403c7502$export$d76e3d65f440a2bb = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-roblox-1428046955.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb1j4a _4t3i1tcg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialLumenStyle = null;
const $ba4696cf403c7502$export$2d5c2c6aa86b2349 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-lumen-3277500912.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb1j4a _4t3if6fq"
        ])
    });
};
const $ba4696cf403c7502$export$5ea2342df8447e77 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "89",
        height: "23",
        viewBox: "0 0 89 23",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.9993 21.1745C29.5465 21.1745 28.2194 19.926 28.2194 17.5961V10.7638H27.3641C26.9562 10.7589 26.5629 10.5918 26.2779 10.3018C25.9928 10.0118 25.8355 9.62348 25.8453 9.22042C25.865 8.40939 26.5384 7.76057 27.3641 7.75566H28.2194V5.72071C28.2931 4.81629 29.0599 4.1134 29.984 4.1134C30.9081 4.1134 31.6798 4.81138 31.7486 5.72071V7.75566H33.1249C33.5179 7.76704 33.8913 7.92991 34.1671 8.21022C34.4428 8.49053 34.5995 8.86658 34.6044 9.25974C34.5995 9.65291 34.4428 10.029 34.1671 10.3093C33.8913 10.5896 33.5179 10.7524 33.1249 10.7638H31.7486V16.672C31.7486 17.7043 32.4122 18.1073 32.9627 18.1073H33.2674C34.2603 18.1073 34.8158 18.7561 34.8158 19.6016C34.8158 20.447 34.2898 21.1745 31.9993 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M43.035 21.1744C38.6505 21.1744 36.0012 18.0286 36.0012 14.2881C36.0012 10.577 38.6555 7.43119 43.035 7.43119C47.449 7.43119 50.0983 10.577 50.0983 14.2881C50.1278 15.2155 49.9639 16.1389 49.617 16.9996C49.2701 17.8602 48.7478 18.6392 48.0834 19.287C47.419 19.9347 46.627 20.4371 45.7579 20.762C44.8887 21.087 43.9614 21.2274 43.035 21.1744ZM43.035 10.4934C40.8526 10.4934 39.6434 12.2531 39.6434 14.2881C39.6434 16.323 40.8575 18.1171 43.035 18.1171C45.2125 18.1171 46.4561 16.3574 46.4561 14.2881C46.4561 12.2531 45.2125 10.4934 43.035 10.4934ZM62.48 21.0122H62.2048C61.9295 21.0122 60.6859 20.7959 60.6859 19.4934C59.7766 20.5502 58.2086 21.1744 56.4686 21.1744C54.3452 21.1744 51.8334 19.7637 51.8334 16.8342C51.8334 13.7719 54.3452 12.607 56.4686 12.607C58.2381 12.607 59.8061 13.1772 60.6859 14.2045V12.4399C60.6859 11.1128 59.5259 10.2427 57.7613 10.2427C56.707 10.2208 55.67 10.5134 54.7826 11.0833C54.5909 11.1997 54.3727 11.2657 54.1486 11.275C53.4113 11.2651 52.8214 10.6704 52.8214 9.94783C52.8253 9.70892 52.8914 9.47515 53.0131 9.26951C53.8389 7.96695 56.8176 7.42627 58.361 7.42627C61.3937 7.42627 64.1807 8.62069 64.1807 12.3858V19.3017C64.1856 20.2356 63.4238 21.0024 62.4702 21.0073L62.48 21.0122ZM60.6859 16.0772C60.1059 15.3203 59.0049 14.9369 57.8744 14.9369C56.4932 14.9369 55.3626 15.6349 55.3626 16.9178C55.3626 18.1368 56.4932 18.8446 57.8744 18.8446C59.0049 18.8446 60.1059 18.4661 60.6859 17.7042V16.0772Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M72.4687 21.1745C70.7336 21.1745 67.9466 20.6043 67.1209 19.4345C66.9587 19.2231 66.8702 18.9675 66.8751 18.7021C66.8853 18.3204 67.0431 17.9575 67.3154 17.6898C67.5876 17.4221 67.9531 17.2705 68.335 17.2668C68.5905 17.2668 68.8363 17.3356 69.0526 17.4683C70.0996 18.0631 71.4808 18.5251 72.6359 18.5251C74.1547 18.5251 74.8723 17.9304 74.8723 17.1144C74.8723 14.9468 66.9537 16.7065 66.9537 11.5552C66.9537 9.35805 68.915 7.43616 72.4147 7.43616C74.1498 7.43616 76.5239 7.98176 77.271 9.03364C77.414 9.22724 77.4915 9.46143 77.4922 9.70213C77.4676 10.4296 76.8581 11.0096 76.1159 11.0047C75.8848 11.0052 75.6571 10.9495 75.4523 10.8425C74.5313 10.328 73.4942 10.0573 72.4392 10.056C71.1711 10.056 70.3453 10.6262 70.3453 11.3586C70.3453 13.31 78.2344 11.683 78.2344 16.967C78.2344 19.3558 76.1651 21.1745 72.4687 21.1745ZM85.2928 21.1745C82.8401 21.1745 81.5129 19.926 81.5129 17.5961V10.7638H80.6577C80.2497 10.7589 79.8565 10.5918 79.5714 10.3018C79.2863 10.0118 79.129 9.62348 79.1388 9.22042C79.1585 8.4094 79.8319 7.76057 80.6577 7.75566H81.5129V5.72071C81.5534 5.28091 81.7569 4.87215 82.0834 4.57474C82.4099 4.27733 82.8359 4.11277 83.2775 4.11341C84.2016 4.11341 84.9733 4.81138 85.0421 5.72071V7.75566H86.4233C86.8164 7.76704 87.1898 7.92992 87.4655 8.21023C87.7412 8.49054 87.8979 8.86658 87.9028 9.25975C87.8979 9.65291 87.7412 10.029 87.4655 10.3093C87.1898 10.5896 86.8164 10.7524 86.4233 10.7638H85.0421V16.672C85.0421 17.7043 85.7057 18.1073 86.2562 18.1073H86.561C87.5539 18.1073 88.1044 18.7561 88.1044 19.6016C88.1044 20.447 87.5883 21.1745 85.2928 21.1745Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.5989 15.7873C23.6186 14.3373 23.5547 12.8872 23.4072 11.4471C23.2991 10.4738 22.9698 9.22533 21.913 8.96974C22.0492 9.00427 22.1924 8.99915 22.3259 8.95499C23.5498 8.316 23.4564 6.73818 23.0238 5.59783C22.4537 4.10357 21.1019 3.04186 19.7601 2.33897C17.2714 1.09804 14.5118 0.499666 11.7327 0.598398C8.95364 0.69713 6.24345 1.48982 3.84917 2.90423C2.63509 3.65136 1.23914 5.11121 1.85355 6.73818C2.02012 7.14309 2.26576 7.51071 2.5761 7.81955L3.03814 8.30125C2.4139 9.14669 1.95677 9.91348 1.66185 10.9408C0.777095 14.0374 0.924555 16.0281 1.16541 18.5153C1.31778 20.0538 1.82406 22.3443 3.59849 22.5999C5.04359 22.8015 6.61158 22.3247 8.05668 22.1526C9.64925 21.9658 11.2566 21.6709 12.8688 21.7152C15.1397 21.7741 17.3909 22.3099 19.6667 22.3345C20.866 22.3443 22.8616 22.4623 23.2204 20.8796C23.5596 19.3755 23.5744 17.8124 23.5744 16.2788C23.594 16.1166 23.594 15.9495 23.594 15.7922L23.5989 15.7873ZM21.0036 18.3875C20.4384 19.6606 18.8409 19.518 17.7251 19.4246L12.7361 18.8299C11.2516 18.7856 9.78196 19.0658 8.33686 19.3853C7.25549 19.6212 5.74648 20.2455 4.76834 19.4148C3.68205 18.4956 3.49035 16.9276 3.47561 15.6054C3.49602 14.4115 3.61438 13.2213 3.82951 12.0467C3.96222 11.3193 4.1785 10.6115 4.46359 9.93314C4.8519 8.95008 5.42699 8.35532 5.45648 8.38481C5.16648 8.08498 4.81749 7.92277 4.62088 7.5148C3.87866 5.96648 5.73174 4.65409 6.74429 4.20679C10.2882 2.62406 15.2429 2.78135 18.5902 4.81138C19.6323 5.44545 21.6574 7.62294 19.765 8.70922C20.9299 9.25974 21.2297 10.9211 21.3575 12.1008C21.562 13.9955 21.5024 15.9095 21.1806 17.7878C21.1458 17.9947 21.0896 18.1962 21.0036 18.3875Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$13c02cb17fc407de = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "29",
        viewBox: "0 0 103 29",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M29.4863 0.270996L29.6308 22.1619H32.9144V0.270996H29.4863ZM70.1289 0.270996V22.1706H74.0802C74.0802 22.1706 74.113 14.268 74.1568 14.2768C74.2006 14.2768 80.0476 22.4705 80.1002 22.4421C80.1593 22.4267 83.6049 21.1877 83.6049 21.1527C83.6049 21.1264 77.7316 13.62 77.7316 13.6113C77.7316 13.5938 82.657 8.11231 82.6132 8.06852C82.4775 7.94156 79.809 6.78791 79.7324 6.8295C79.6974 6.85577 74.0802 12.9524 74.0802 12.9524V0.270996H70.1289ZM4.6708 6.94771C3.25009 7.24761 1.91693 8.15609 1.36966 9.20685C1.1214 9.71444 0.993808 10.2725 0.996846 10.8376C0.999884 11.4026 1.13347 11.9593 1.38717 12.4642C1.73743 13.1406 2.75535 14.0819 4.33587 15.1918C6.04774 16.4068 6.69571 17.0131 6.85989 17.5867C7.10726 18.4338 6.73073 19.2285 5.90983 19.6225C5.50047 19.8195 5.31877 19.8436 4.592 19.8108C3.64412 19.767 2.99396 19.5262 2.02858 18.8344C1.71992 18.6221 1.43752 18.4667 1.4025 18.5017C1.36966 18.5367 1.061 18.9986 0.719503 19.5284L0.10437 20.4763L0.334224 20.6558C0.472137 20.7499 0.881496 20.9995 1.25802 21.2118C3.85865 22.6566 7.70488 22.4267 9.65535 20.7083C10.1652 20.2713 10.5541 19.7106 10.7849 19.08C11.0156 18.4494 11.0805 17.7701 10.9732 17.1073C10.7849 15.8332 10.0822 14.997 7.87563 13.3968C6.14187 12.1402 5.32096 11.4485 5.1327 11.0807C4.76494 10.3605 5.02106 9.66874 5.79818 9.26595C6.19222 9.06237 6.35421 9.04486 7.13353 9.07769C7.89314 9.10396 8.12518 9.16525 8.75783 9.46297L9.49336 9.82198L10.0647 8.92445C10.3821 8.42972 10.612 7.9919 10.5879 7.95031C10.485 7.79707 9.27883 7.2914 8.52579 7.09657C7.52537 6.8295 5.59241 6.75288 4.6708 6.9499V6.94771ZM22.0368 8.88286C23.7662 9.69283 24.6878 12.2322 24.3135 15.1239C24.1821 16.1506 23.8166 17.3897 23.4751 17.9632C23.1314 18.5542 22.4659 19.1956 21.9339 19.443C20.9598 19.9027 19.515 19.7254 18.6 19.0315C17.3347 18.0661 16.6407 15.6975 16.9056 13.2348C17.1552 10.9778 17.9673 9.54835 19.3858 8.88943C20.1214 8.54793 21.3122 8.54793 22.0368 8.88286ZM20.4629 6.3676C19.4296 6.59965 18.6087 7.06154 17.7199 7.90653L16.9144 8.67709V6.83826H13.2126V28.7291H16.9144V19.802L17.6258 20.4938C18.9239 21.7678 20.4475 22.2823 22.2251 22.0327C23.3875 21.8707 24.2084 21.573 25.0731 20.9907C27.503 19.3664 28.8449 16.1244 28.4771 12.7378C28.1269 9.52426 26.4763 7.30016 23.8144 6.45517C23.1314 6.23188 21.2663 6.1881 20.4629 6.3676ZM35.6683 6.83826C35.6683 6.83826 35.7887 18.4076 35.8653 18.7425C36.163 20.0166 37.0189 21.2293 37.9778 21.7525C38.8578 22.2297 39.567 22.3764 40.8936 22.3764C42.7828 22.3676 43.9277 21.9145 45.3309 20.6229L46.0489 19.9728V22.1619H49.8623L49.812 6.83826H46.0489C46.0489 6.83826 46.0993 16.3564 46.0489 16.6891C45.8256 18.0245 44.7924 19.119 43.7394 19.4693C43.1155 19.6816 42.021 19.8524 41.3621 19.7495C40.6878 19.64 39.5495 18.8957 39.4817 17.7837V6.88861L35.6683 6.83826ZM67.375 22.1619C67.375 22.1619 67.2546 10.5925 67.178 10.2576C66.8803 8.98356 66.0243 7.77081 65.0655 7.24762C64.1855 6.7704 63.4762 6.62373 62.1496 6.62373C60.2605 6.63248 59.1156 7.08562 57.7124 8.37718L56.9944 9.02734V6.83826H53.181L53.2313 22.1619H56.9944C56.9944 22.1619 56.944 12.6437 56.9944 12.311C57.2176 10.9756 58.2509 9.88109 59.3038 9.53083C59.9277 9.31849 60.7486 9.1565 61.6812 9.25063C62.6115 9.35133 63.6295 10.1985 63.5616 11.2164V22.1115L67.375 22.1619Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.6399 5.74365V9.02728L100.774 13.4055L87.6399 19.1015V22.1618L102.963 15.5945V11.2164L87.6399 5.74365Z",
                fill: "#101214"
            })
        ]
    });
};
const $ba4696cf403c7502$export$9deaa7e38ca0abdf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "85",
        height: "25",
        viewBox: "0 0 85 25",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.0486 23.7095H56.5358C58.2522 23.7095 59.6608 23.0052 60.805 21.5961C61.9053 20.2318 62.4776 18.6035 62.4776 16.7555C62.4776 13.0143 57.6804 10.3735 55.831 10.3735H49.5375C49.0534 10.3735 48.6565 10.1533 48.3491 9.8016C48.0408 9.40515 47.8649 8.9653 47.8649 8.43685C47.8649 7.8207 48.0408 7.2927 48.3491 6.85241C48.7012 6.41255 49.1411 6.14856 49.6695 6.14856H61.465V1.43862H49.4489C47.2922 1.43862 45.6191 2.09907 44.4307 3.37521C43.3751 4.56366 42.8462 6.14811 42.8462 8.04086C42.8462 9.8893 43.3751 11.518 44.4307 12.8376C45.6191 14.29 47.0282 15.0391 48.7446 15.0391H56.0073C56.4467 15.0391 56.7993 15.1711 57.0629 15.5223C57.3712 15.8745 57.5032 16.3148 57.5032 16.7994C57.5032 17.3717 57.283 17.8997 56.9309 18.34C56.5349 18.736 56.0946 18.9561 55.5232 18.9561H43.9036L43.7277 18.6478L39.3704 4.65181L39.1502 4.21151C38.0938 2.05477 36.3335 0.998769 33.9128 0.998769C32.5923 0.998769 31.4039 1.30662 30.3474 1.96706C29.2471 2.62706 28.5428 3.59536 28.1468 4.82811L22.2927 23.6652L27.6184 23.7099L32.9879 6.941C33.1199 6.41256 33.4282 6.14856 33.8242 6.14856C34.0443 6.14856 34.2202 6.23626 34.3522 6.36871C34.4842 6.54456 34.5723 6.72086 34.6162 6.941L40.0295 23.7099L45.0486 23.7095ZM5.43611 8.30485V23.6652H0.50647V6.63226C0.50647 4.43166 1.03492 2.89106 2.17907 1.96706C3.05922 1.30662 4.37966 0.954468 6.22811 0.954468C7.72441 0.954468 9.001 1.39477 10.1452 2.23107C11.2893 3.06736 12.0375 4.21151 12.4339 5.62011L15.6466 16.9314L16.1751 18.472C16.2189 18.7798 16.3952 19 16.5711 19.1754C16.7912 19.3521 17.0109 19.4403 17.2754 19.3521C17.7157 19.3083 17.9358 19.0438 17.9358 18.6478V1.48292H22.9975V18.4277C22.9975 20.3204 22.5576 21.7295 21.6332 22.7416C20.753 23.7538 19.4326 24.2822 17.6718 24.2822C16.1312 24.2822 14.8546 23.9739 13.8425 23.4459C12.6102 22.8298 11.8177 21.8615 11.4656 20.5844L7.76871 7.68871L7.50471 6.85241C7.41656 6.54455 7.24071 6.32441 7.02056 6.10426C6.80041 5.92796 6.53641 5.88411 6.27241 5.92796C6.00841 5.97226 5.83256 6.10426 5.65626 6.36826C5.51155 6.60704 5.43538 6.88105 5.43611 7.16026V8.30485ZM84.2204 23.7095L78.4988 4.65181L78.2786 4.21151C77.2222 2.05477 75.4619 0.998769 73.0411 0.998769C71.7207 0.998769 70.5322 1.30662 69.4762 1.96706C68.375 2.62706 67.6716 3.59536 67.2747 4.82811L61.4211 23.6652L66.7467 23.7099L72.1162 6.941C72.2482 6.41256 72.5565 6.14856 72.9525 6.14856C73.1727 6.14856 73.3485 6.23626 73.4805 6.36871C73.6134 6.54456 73.7007 6.72086 73.7454 6.941L79.1588 23.7099L84.2204 23.7095Z",
            fill: "#101214"
        })
    });
};
const $ba4696cf403c7502$var$testimonialDoodleStyle = null;
const $ba4696cf403c7502$export$72c6ec790fc33a37 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-doodle-1380981062.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb1qr7 _4t3i1tcg"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialRoyalCaribbeanStyle = null;
const $ba4696cf403c7502$export$ea2a07b098c3c428 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-royal-caribbean-3438806072.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsbhcro _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialMercedesBenzStyle = null;
const $ba4696cf403c7502$export$3192ac60f265126c = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonial-mercedes-benz-2937659039.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsbwz92 _4t3i1u1b"
        ])
    });
};
const $ba4696cf403c7502$var$testimonialSunLifeStyle = null;
const $ba4696cf403c7502$export$53d258996873a1e3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-sun-life-resize-2840009056.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb18cf _4t3i1u1b"
        ])
    });
const $ba4696cf403c7502$var$testimonialUnitedStyle = null;
const $ba4696cf403c7502$export$6a1b58616eb8f4e3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/testimonials-united-resize-2634290916.webp",
            alt: ""
        },
        className: (0, $2jatx.default)([
            "_1bsb1qr7 _4t3i1u1b"
        ])
    });

});


parcelRegister("evuYk", function(module, exports) {
$parcel$export(module.exports, "BadgesSection", function () { return $7cbd5ae14e10bec6$export$a81af8b662eb2b7; });
/* badges.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $7cbd5ae14e10bec6$export$a81af8b662eb2b7 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-badges",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_6rth8ved"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _6rth19bv",
                        "eyebrow-md"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "EnterpriseLandingPage.badges.eyebrow",
                        defaultMessage: "Recognized by world-class analysts"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "3-3-3-3",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            href: (0, $kooLp.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forrester_wave_leader_2023-3286669196.webp",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge1",
                                defaultMessage: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                            }),
                            badgeLabel: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge2",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for DevOps Platforms*"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge3",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for Enterprise Agile Planning Tools*"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Peer-Insights-Customers-Choice-2023.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge4",
                                defaultMessage: "A Gartner\xae Peer Insights\u2122 Customers' Choice for Enterprise Agile Planning Tools."
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $7cbd5ae14e10bec6$var$badgeSectionStyles = null;
const $7cbd5ae14e10bec6$var$divStyles = null;
const $7cbd5ae14e10bec6$var$Badge = ({ href: href, imageUrl: imageUrl, imageAlt: imageAlt, badgeText: badgeText, badgeLabel: badgeLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1ml653f4 _kmx4ys9h _q1391ule _1cac1wug _14fh1wug _gdebo7ao _qgibo7ao _1bsa1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            href: href,
            "data-product-key": "enterprise",
            "data-event-component": "link",
            "data-event-container": "badgesSection",
            "data-event": "clicked",
            "data-label": badgeText,
            "data-label-english": badgeLabel,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "image-container",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: imageUrl,
                        alt: imageAlt
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "badge-text body-sm",
                    children: badgeText
                })
            ]
        })
    });
};
const $7cbd5ae14e10bec6$var$BadgeStyles = null;

});

parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");
const $3872cd7d84b2ef7a$var$logoWrapperStyles = null;
const $3872cd7d84b2ef7a$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive == "success",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: (0, $kooLp.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("EJqLv", function(module, exports) {
$parcel$export(module.exports, "HeroV2Section", function () { return $ca865e303881e7c7$export$cd8aff68574ce209; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $i0Jom = parcelRequire("i0Jom");

var $4Im8f = parcelRequire("4Im8f");

var $8hNiC = parcelRequire("8hNiC");

var $liM7f = parcelRequire("liM7f");
const $ca865e303881e7c7$export$11abae89ba61f3a8 = 8000;
const $ca865e303881e7c7$export$cd8aff68574ce209 = ()=>{
    const intl = (0, $8e22h.default)();
    const tabs = [
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8hNiC.EnterpriseTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise",
                defaultMessage: "Enterprise"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise.caption",
                defaultMessage: "Atlassian\u2019s System of Work"
            }),
            englishLabel: "enterprise",
            id: "enterprise"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $liM7f.ProductTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product",
                defaultMessage: "Product"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product.caption",
                defaultMessage: "Atlassian\u2019s latest AI innovation"
            }),
            englishLabel: "product",
            id: "product"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Im8f.AnalystsTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts",
                defaultMessage: "Analysts"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts.caption",
                defaultMessage: "Gartner Magic Quadrant Leader"
            }),
            englishLabel: "analysts",
            id: "analysts"
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i0Jom.EnterpriseTabsWithCards), {
        tabsData: tabs,
        tabSwitchInterval: $ca865e303881e7c7$export$11abae89ba61f3a8
    });
};

});
parcelRegister("i0Jom", function(module, exports) {
$parcel$export(module.exports, "EnterpriseTabsWithCards", function () { return $81937f6de4338711$export$255fc2fb2ce9d4ee; });
/* enterprise-tabs-with-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $a9lfn = parcelRequire("a9lfn");
const $81937f6de4338711$var$Tab = ({ title: title, caption: caption, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    const eyebrowStyle = null;
    const captionStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", (0, $dPABA._)((0, $6ogO3._)({}, dataEventProps), {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1ns9 _4t3i1osq _1tkekz1e _p12f5jys _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _4cvr1y6m _80omtlke _16jlkb7n _2rkogktf _19itglyw _11q7u66n _16qss1rx _ect4lnmy _k48p1nn1 _1wybgktf _syaz1iem _152tr8pp _v5641gvb _1mdbkz1e _uhd05jys _1j96zwfg _jvmrzwfg _k0mszwfg _1b7pzwfg _1x6l13rr _j6qupd6w _xut117n1 _ceho8wlv _jx4017n1 _1i7q122r _1dbzyicz",
            isSelected && "_19it1oen _16qsyicz _syazr3uz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect48q0o _1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4f6fq _1p1dangw _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4kipj _1wybf6fq _zg8l4jg8 _k48p1fw0 _vwz41tcg _y3gn1e5h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1fhb _1bsb1osq"
                ]),
                children: caption
            })
        ]
    }));
};
const $81937f6de4338711$export$255fc2fb2ce9d4ee = ({ tabsData: tabsData, tabSwitchInterval: tabSwitchInterval })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4Tabs), {
            tabSwitchInterval: tabSwitchInterval,
            loop: true,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                            panelIndex: index,
                            id: tab.id,
                            children: tab.tabComponent
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule _1pbycs5v _152tr8pp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                        rowGap: "12px",
                        className: (0, $2jatx.default)([
                            "_ca0qidpf _u5f31wqb _n3td1qjk _19bv1wqb _1e0c1txw _4cvr1fhb _zulpzwfg _1kmxidpf _1ggmzwfg _1ykz1ul9 _1maezwfg",
                            "tab-list"
                        ]),
                        children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                tabIndex: index,
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($81937f6de4338711$var$Tab, {
                                    title: tab.title,
                                    caption: tab.caption,
                                    dataEventProps: {
                                        "data-product-key": "home",
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "tabsMenu",
                                        "data-label": tab.title,
                                        "data-label-english": tab.englishLabel
                                    }
                                })
                            }, index))
                    })
                })
            ]
        })
    });
};
const $81937f6de4338711$var$topSectionStyles = null;
const $81937f6de4338711$var$bottomSectionStyles = null;
const $81937f6de4338711$var$sectionStyles = null;
const $81937f6de4338711$var$tabList = null;
const $81937f6de4338711$var$tabStyles = null;
const $81937f6de4338711$var$currentStyle = null;

});

parcelRegister("4Im8f", function(module, exports) {
$parcel$export(module.exports, "AnalystsTabContent", function () { return $a799074227eeb47f$export$bfe5f81b459a55ca; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");

var $kooLp = parcelRequire("kooLp");
const $a799074227eeb47f$export$bfe5f81b459a55ca = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.header",
            defaultMessage: "Atlassian named a Leader in DevOps Platforms by Gartner"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.body",
            defaultMessage: "Learn about our unified DevOps platform that connects engineering, IT Ops, and business teams"
        }),
        textAlign: "right",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.analysts.cta",
                defaultMessage: "Read the report"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-analysts-cta",
                "data-label-english": "Read the report"
            },
            href: (0, $kooLp.useLocalizedHref)("/gartner/magic-quadrant-devops")
        },
        ctaType: "button",
        color: "light",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-xs.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-sm.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-md.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-lg.webp"
        }
    });
};

});
parcelRegister("flDFL", function(module, exports) {
$parcel$export(module.exports, "EnterpriseHero", function () { return $69fdc043b04a07d0$export$9d702f5b43ea4715; });
/* enterprise-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $69fdc043b04a07d0$var$contentMaxWidth = {
    center: {
        xs: "378px",
        sm: "534px",
        md: "568px",
        lg: "568px"
    },
    left: {
        xs: "378px",
        sm: "421px",
        md: "514px",
        lg: "568px"
    },
    right: {
        xs: "378px",
        sm: "365px",
        md: "514px",
        lg: "668px"
    }
};
const $69fdc043b04a07d0$export$9d702f5b43ea4715 = ({ headerText: headerText, bodyText: bodyText, textAlign: textAlign = "center", color: color = "light", cta: cta, ctaType: ctaType, backgroundImgSrc: backgroundImgSrc })=>{
    const textColor = color === "light" ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.primary.black");
    const inlineStart = textAlign === "left" ? "199.5px" : textAlign === "right" ? "-140px" : "0";
    const alignItems = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const justifyContent = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const containerStyle = null;
    const { md: md, lg: lg } = $69fdc043b04a07d0$var$contentMaxWidth[textAlign];
    const contentStyle = null;
    const headerStyle = null;
    const bodyStyle = null;
    const ctaStyle = null;
    const CallToAction = ()=>{
        if (!cta) return null;
        if (ctaType === "button") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "yellow",
                href: href,
                dataEventProps: dataEventProps,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1wpzn3xj _es5ofn2t _1gwbyfnk"
                ]),
                style: {
                    "--_k2wmiu": (0, $6ZVlx.default)(alignItems),
                    "--_2idk6s": (0, $6ZVlx.default)(textAlign === "center" ? "center" : "flex-start"),
                    "--_1t1mgkw": (0, $6ZVlx.default)(textAlign === "right" ? "center" : alignItems)
                },
                children: text
            });
        } else if (ctaType === "link") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                type: "external",
                href: href,
                text: text,
                dataEventProps: dataEventProps
            });
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: cta
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_y44v19jp _11q7xprm _p12fklux _4t3i1c5i _1o9zidpf _kqswh2mm _19pk1wqb _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3zwfg _n3tdidpf _19bvzwfg _1e0c1txw _1bahjlb8 _4cvr1h6o _yj3y1b9g _1d4udzi4 _1j96idpf _jvmr1wqb _k0msidpf _1b7p1wqb _ibctnzkm _v8ts8nql _2ysd8nql"
        ]),
        style: {
            "--_n0tana": (0, $6ZVlx.default)(backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.xs, ")", "url("),
            "--_1ecqhzh": (0, $6ZVlx.default)(justifyContent),
            "--_188fmqn": (0, $6ZVlx.default)(textAlign === "right" ? "center" : justifyContent),
            "--_c4618e": (0, $6ZVlx.default)(textAlign === "right" ? `url(${backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.xs}) 50% / 100% 100% no-repeat` : `url(${backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.sm}) 50% / cover no-repeat`),
            "--_450zrg": (0, $6ZVlx.default)(backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.md, ")", "url("),
            "--_11tlo2t": (0, $6ZVlx.default)(backgroundImgSrc === null || backgroundImgSrc === void 0 ? void 0 : backgroundImgSrc.lg, ")", "url(")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _1bahkeqs _4cvrn3xj _18s81any _y3gn2i2r _p12f1oh5 _7bccng7t _b14zybpo _sfxvybpo _10vrkeqs _yir31oh5 _1rsv1oh5 _1190gb00 _ytj9ydnc"
            ]),
            style: {
                "--_ux0pmw": (0, $6ZVlx.default)(textAlign),
                "--_k2wmiu": (0, $6ZVlx.default)(alignItems),
                "--_1x9bz3": (0, $6ZVlx.default)(textAlign === "center" ? "0 auto" : "0"),
                "--_xk83tk": (0, $6ZVlx.default)(textAlign === "center" ? "center" : "left"),
                "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign),
                "--_1itq52x": (0, $6ZVlx.default)(inlineStart),
                "--_1ndsstv": (0, $6ZVlx.default)(textAlign === "right" ? "668px" : "568px")
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_ect41pz4 _1wybigbc _zg8l4jg8 _k48p9y44 _vwz4v9r7 _18s81khp _syaz1u00 _50pk12am _167l1ady _1sg4idpf _maxsidpf _1jvh1f4h _1ucaidpf _b14zybpo _17gq8vuz _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf",
                        "enterprise-hero-header-text"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                        "--_j86zen": (0, $6ZVlx.default)(textAlign === "right" ? "10vw" : "44px"),
                        "--_1l1q5sn": (0, $6ZVlx.default)(textAlign === "right" ? "12vw" : "50px"),
                        "--_192zam2": (0, $6ZVlx.default)(textAlign === "right" ? "0 0 5vw 0" : "0 0 28px 0"),
                        "--_srel9g": (0, $6ZVlx.default)(textColor),
                        "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: headerText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _4t3i1ns9 _c71lt9kd _1bsb1ns9 _19pkidpf _2hwxidpf _otyr1f4h _18u0idpf _syaz1u00 _b14zybpo _1dxp1yu0 _1sg4idpf _maxsidpf _1jvhzwfg _1ucaidpf _b8yq1ns9 _1s18gktf _17gq1f4h"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                        "--_srel9g": (0, $6ZVlx.default)(textColor),
                        "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: bodyText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)(CallToAction, {})
            ]
        })
    });
};

});


parcelRegister("8hNiC", function(module, exports) {
$parcel$export(module.exports, "EnterpriseTabContent", function () { return $4e88cce0cf69ea64$export$6b3a3100e0e8582e; });
/* eslint-disable local/no-non-orangelogic-images-eslint */ 
var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");
const $4e88cce0cf69ea64$export$6b3a3100e0e8582e = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.headerText",
            defaultMessage: "Forward Together"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.bodyText",
            defaultMessage: "Discover how Atlassian Williams Racing is accelerating teamwork transformation on the grid using the Atlassian Cloud Platform."
        }),
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise.cta",
                defaultMessage: "Watch video"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-enterprise-cta",
                "data-label-english": "Watch video"
            },
            href: "https://www.youtube.com/watch?v=sSKY7pNdlvI"
        },
        ctaType: "link",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-sm-107626183.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-md-2984500272.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-lg-2107118674.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-1621379571.webp"
        }
    });
};

});

parcelRegister("liM7f", function(module, exports) {
$parcel$export(module.exports, "ProductTabContent", function () { return $f4ffa76e12bb7992$export$36e1444062b1b431; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");

var $kooLp = parcelRequire("kooLp");
const $f4ffa76e12bb7992$export$36e1444062b1b431 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.header",
            defaultMessage: "Say Hello to Rovo"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.body",
            defaultMessage: "Atlassian's AI-powered solution that makes teamwork easier and faster."
        }),
        textAlign: "center",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.product.cta",
                defaultMessage: "Learn more"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-product-cta",
                "data-label-english": "Learn more"
            },
            href: (0, $kooLp.useLocalizedHref)("/software/rovo")
        },
        ctaType: "button",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-mobile@2x-1408243573.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-tablet@2x-1411287807.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-S@2x-1748573145.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-L@2x-2396412742.webp"
        }
    });
};

});






parcelRegister("bWWTF", function(module, exports) {
$parcel$export(module.exports, "CheckemailPage", function () { return $83469c2406e9f5ec$export$137de9ee4cfd53f4; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");
parcelRequire("i90Tr");
var $33d71 = parcelRequire("33d71");
const $83469c2406e9f5ec$export$137de9ee4cfd53f4 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $33d71.CheckemailPageTemplate), {});

});
parcelRegister("i90Tr", function(module, exports) {
$parcel$export(module.exports, "CheckemailPageTemplate", function () { return (parcelRequire("33d71")).CheckemailPageTemplate; });

var $33d71 = parcelRequire("33d71");

});
parcelRegister("33d71", function(module, exports) {
$parcel$export(module.exports, "CheckemailPageTemplate", function () { return $933e21ecde646934$export$81cea22471256edf; });
/* checkemail-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $78ld5 = parcelRequire("78ld5");

var $h7dMy = parcelRequire("h7dMy");

var $j6OMz = parcelRequire("j6OMz");
const $933e21ecde646934$var$ContainerStyle = null;
const $933e21ecde646934$var$InnerStyle = null;
const $933e21ecde646934$export$81cea22471256edf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_4cvr1fhb _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _ca0q1wto _u5f31wto _n3td1wto _19bv1wto _k48p4jg8 _ect4bzd7 _xlob1h6o _szfsglyw _stfgidpf _d32voelr _dpd3116y _1o7p1osq _1r4aidpf _125m1tcg _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _ficf1h6o _397o1r31 _108nglyw _uulsnqa1 _1eo0tlke _4pkprbzz _1pnjrbzz _1k4x1ltp _wlf1oelr _k58frbzz _8t1xrbzz _knlz1ltp"
            ]),
            style: {
                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Logo), {
                        type: "logo",
                        appearance: "brand",
                        brand: "atlassian"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j6OMz.EmailedYou), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h7dMy.EmailButtons), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $78ld5.ContactSupport), {})
            ]
        })
    });
};

});
parcelRegister("78ld5", function(module, exports) {
$parcel$export(module.exports, "ContactSupport", function () { return $dfa248c26cf11756$export$d65ea6ee8960e96a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $dfa248c26cf11756$export$d65ea6ee8960e96a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                style: {
                    display: "inline-block",
                    width: "22rem"
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "checkemail.didNotReceive",
                    defaultMessage: "<strong>{question}</strong> Check your spam folder.",
                    values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                        question: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "checkemail.question",
                            defaultMessage: "Didn't receive an email?"
                        })
                    })
                })
            })
        })
    });
};

});

parcelRegister("h7dMy", function(module, exports) {
$parcel$export(module.exports, "EmailButtons", function () { return $73f96e1cee655e97$export$78d42fa1f0d70d0; });
/* email-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $ddxTX = parcelRequire("ddxTX");

var $aAezZ = parcelRequire("aAezZ");
const $73f96e1cee655e97$var$overallContainerStyle = null;
const $73f96e1cee655e97$var$socialButtonStyles = null;
const $73f96e1cee655e97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES = {
    OPEN_GMAIL_CLICKED: "check_email_page_open_gmail_clicked",
    OPEN_OUTLOOK_CLICKED: "check_email_page_open_outlook_clicked"
};
const $73f96e1cee655e97$export$78d42fa1f0d70d0 = ()=>{
    const intl = (0, $8e22h.default)();
    const openGmail = intl.formatMessage({
        id: "checkemail.openGmail",
        defaultMessage: "Open Gmail"
    });
    const openOutlook = intl.formatMessage({
        id: "checkemail.openOutlook",
        defaultMessage: "Open Outlook"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c116y _zulp1j6v"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _bfhku67f _19it1s07 _2rko1l7b _vchhusvi _1e0c116y _zulpoark _1bah1h6o _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _jomr1qgq _f8pj1nct _irr31qgq _30l31nct _1ah3t94y _1ii71ule _w8l51k8s _17521k8s _12s31kwk _37z21h6o _incy116y _1sjq4jg8"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                        appearance: "link",
                        "data-event-component": "linkButton",
                        "data-event-container": "gmailButton",
                        "data-event": "clicked",
                        "data-product-key": "checkEmail",
                        "data-name": $73f96e1cee655e97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_GMAIL_CLICKED,
                        href: "https://mail.google.com/mail/u/0/#search/atlassian+from%3A(%40atlassian.com)+in%3Aanywhere",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "buttonText",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aAezZ.GmailLogo), {}),
                                openGmail
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _bfhku67f _19it1s07 _2rko1l7b _vchhusvi _1e0c116y _zulpoark _1bah1h6o _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _jomr1qgq _f8pj1nct _irr31qgq _30l31nct _1ah3t94y _1ii71ule _w8l51k8s _17521k8s _12s31kwk _37z21h6o _incy116y _1sjq4jg8"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                        appearance: "link",
                        href: "https://outlook.live.com/mail/0/inbox",
                        "data-event-component": "linkButton",
                        "data-event-container": "outlookButton",
                        "data-event": "clicked",
                        "data-product-key": "checkEmail",
                        "data-name": $73f96e1cee655e97$var$CHECK_EMAIL_PAGE_TRACKING_EVENT_NAMES.OPEN_OUTLOOK_CLICKED,
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "buttonText",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aAezZ.OutlookLogo), {}),
                                openOutlook
                            ]
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("aAezZ", function(module, exports) {
$parcel$export(module.exports, "GmailLogo", function () { return $6744d74c5b31606c$export$e0989a788da1a704; });
$parcel$export(module.exports, "OutlookLogo", function () { return $6744d74c5b31606c$export$2926c6045834af46; });
$parcel$export(module.exports, "EmailLetterIcon", function () { return $6744d74c5b31606c$export$8ead1903281b785a; });

var $7VQPk = parcelRequire("7VQPk");
const $6744d74c5b31606c$export$e0989a788da1a704 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "52 42 88 66",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
const $6744d74c5b31606c$export$2926c6045834af46 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "-0.12979372698077785 0 33.25199671942124 32",
        xmlns: "http://www.w3.org/2000/svg",
        width: "2500",
        height: "2397",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.596 2H11.404A1.404 1.404 0 0 0 10 3.404V5l9.69 3L30 5V3.404A1.404 1.404 0 0 0 28.596 2z",
                fill: "#0364b8"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.65 17.405A11.341 11.341 0 0 0 32 16a.666.666 0 0 0-.333-.576l-.013-.008-.004-.002L20.812 9.24a1.499 1.499 0 0 0-.145-.083 1.5 1.5 0 0 0-1.334 0 1.49 1.49 0 0 0-.145.082L8.35 15.415l-.004.002-.012.007A.666.666 0 0 0 8 16a11.344 11.344 0 0 0 .35 1.405l11.492 8.405z",
                fill: "#0a2767"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 5h-7l-2.021 3L17 11l7 6h6v-6z",
                fill: "#28a8ea"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10 5h7v6h-7z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 5h6v6h-6z",
                fill: "#50d9ff"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 17l-7-6h-7v6l7 6 10.832 1.768z",
                fill: "#0364b8"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.031 5H30",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17 11h7v6h-7z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10 17h7v6h-7z",
                fill: "#064a8c"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 17h6v6h-6z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M20.19 25.218l-11.793-8.6.495-.87s10.745 6.12 10.909 6.212a.528.528 0 0 0 .42-.012l10.933-6.23.496.869z",
                fill: "#0a2767",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.667 16.577l-.014.008-.003.002-10.838 6.174a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5V16a.666.666 0 0 1-.333.577z",
                fill: "#1490df"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32 28.5v-.738l-9.983-5.688-1.205.687a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5z",
                opacity: ".05"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.95 28.883L21.007 22.65l-.195.11a1.497 1.497 0 0 1-1.46.092l3.774 5.061 8.254 1.797v.004a1.501 1.501 0 0 0 .57-.83z",
                opacity: ".1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.35 16.59v-.01h-.01l-.03-.02A.65.65 0 0 1 8 16v12.5A1.498 1.498 0 0 0 9.5 30h21a1.503 1.503 0 0 0 .37-.05.637.637 0 0 0 .18-.06.142.142 0 0 0 .06-.02 1.048 1.048 0 0 0 .23-.13c.02-.01.03-.01.04-.03z",
                fill: "#28a8ea"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M18 24.667V8.333A1.337 1.337 0 0 0 16.667 7H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 26h8.667A1.337 1.337 0 0 0 18 24.667z",
                opacity: ".1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17 25.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 27h7.667A1.337 1.337 0 0 0 17 25.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17 23.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h7.667A1.337 1.337 0 0 0 17 23.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M16 23.667V9.333A1.337 1.337 0 0 0 14.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h6.667A1.337 1.337 0 0 0 16 23.667z",
                opacity: ".2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8z",
                fill: "#0078d4"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M3.867 13.468a4.181 4.181 0 0 1 1.642-1.814A4.965 4.965 0 0 1 8.119 11a4.617 4.617 0 0 1 2.413.62 4.14 4.14 0 0 1 1.598 1.733 5.597 5.597 0 0 1 .56 2.55 5.901 5.901 0 0 1-.577 2.666 4.239 4.239 0 0 1-1.645 1.794A4.8 4.8 0 0 1 7.963 21a4.729 4.729 0 0 1-2.468-.627 4.204 4.204 0 0 1-1.618-1.736 5.459 5.459 0 0 1-.567-2.519 6.055 6.055 0 0 1 .557-2.65zm1.75 4.258a2.716 2.716 0 0 0 .923 1.194 2.411 2.411 0 0 0 1.443.435 2.533 2.533 0 0 0 1.541-.449 2.603 2.603 0 0 0 .897-1.197 4.626 4.626 0 0 0 .286-1.665 5.063 5.063 0 0 0-.27-1.686 2.669 2.669 0 0 0-.866-1.24 2.387 2.387 0 0 0-1.527-.473 2.493 2.493 0 0 0-1.477.439 2.741 2.741 0 0 0-.944 1.203 4.776 4.776 0 0 0-.007 3.44z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 0h32v32H0z",
                fill: "none"
            })
        ]
    });
const $6744d74c5b31606c$export$8ead1903281b785a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "150",
        height: "128",
        viewBox: "0 0 150 128",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "150",
                        height: "127.685",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M149.861 52.5802L91.7015 5.85771C86.9468 2.06703 81.046 0.00274658 74.9651 0.00274658C68.8843 0.00274658 62.9835 2.06703 58.2287 5.85771L0.13947 52.5802H0V127.615H150V52.5802H149.861Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M131.241 15.6206H17.7126V107.545H131.241V15.6206Z",
                        fill: "#FAFBFC"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 39.8884H30.6136V41.2831H118.271V39.8884Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M131.241 13.5983H17.7126V22.0711H131.241V13.5983Z",
                        fill: "#1DB9D4"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M76.4295 46.5829H30.6136V47.9776H76.4295V46.5829Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 33.1938H30.6136V34.5885H118.271V33.1938Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 59.9023H30.6136V61.297H118.271V59.9023Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M118.271 66.5969H30.6136V67.9916H118.271V66.5969Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M81.0321 73.2914H30.6136V74.6861H81.0321V73.2914Z",
                        fill: "#3384FF"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M150 127.685C124.547 127.685 108.368 123.57 98.2566 117.782C74.8954 104.254 71.9665 84.7977 47.5593 68.5495C30.265 57.0432 12.2734 53.7656 0 52.7196V127.685H150Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0 127.685C25.5927 127.685 41.6318 123.57 51.7434 117.782C75.1046 104.254 77.9637 84.7977 102.441 68.5495C119.665 57.0432 137.727 53.7656 150 52.7196V127.685H0Z",
                        fill: "#6BD5E5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "74.993",
                        y1: "127.699",
                        x2: "74.993",
                        y2: "52.7057",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#1DB9D4"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.12",
                                stopColor: "#38C3DA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.26",
                                stopColor: "#4FCBDF"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.41",
                                stopColor: "#5FD1E2"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.59",
                                stopColor: "#68D4E4"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.82",
                                stopColor: "#6BD5E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "150",
                            height: "127.685",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});


parcelRegister("j6OMz", function(module, exports) {
$parcel$export(module.exports, "EmailedYou", function () { return $2afbb9e36d5769b0$export$3f894db345e46fe7; });
/* emailed-you.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $aAezZ = parcelRequire("aAezZ");
const $2afbb9e36d5769b0$var$h1Style = null;
const $2afbb9e36d5769b0$var$pStyle = null;
const $2afbb9e36d5769b0$export$3f894db345e46fe7 = ()=>{
    const intl = (0, $8e22h.default)();
    const headerMessage = {
        identifier: "checkemail.header",
        text: intl.formatMessage({
            id: "checkemail.header.text",
            defaultMessage: "Verify and activate your account"
        })
    };
    const weveEmailedYou = {
        identifier: "checkemail.emailedYou",
        text: intl.formatMessage({
            id: "checkemail.emailedYou.text",
            defaultMessage: "We've emailed your verification link. Verify your account to create your site"
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_1wybahaf _k48pbfng _syazl4fm _ect41485"
                ]),
                children: headerMessage.text
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aAezZ.EmailLetterIcon), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syazl4fm _y3gn1h6o _1bsbiolt _1e0c116y _ect41485 _ca0qviql _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v"
                ]),
                children: weveEmailedYou.text
            })
        ]
    });
};

});




parcelRegister("2fKIG", function(module, exports) {
$parcel$export(module.exports, "SoftwareBitbucketPricingPage", function () { return $4feeaa56577cf171$export$a036524a443241f4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("iOanG");
var $ijSTy = parcelRequire("ijSTy");
const $4feeaa56577cf171$export$a036524a443241f4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "bitbucket",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "bitbucket-pricing-page",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ijSTy.SoftwareBitbucketPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("iOanG", function(module, exports) {
$parcel$export(module.exports, "SoftwareBitbucketPricingPageTemplate", function () { return (parcelRequire("ijSTy")).SoftwareBitbucketPricingPageTemplate; });

var $ijSTy = parcelRequire("ijSTy");

});
parcelRegister("ijSTy", function(module, exports) {
$parcel$export(module.exports, "SoftwareBitbucketPricingPageTemplate", function () { return $102ffae1b997ffb4$export$d089087e1703e7f4; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");
parcelRequire("g1ccm");
var $baTp3 = parcelRequire("baTp3");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $bE8d4 = parcelRequire("bE8d4");
var $2zOxm = parcelRequire("2zOxm");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");
parcelRequire("9b72g");
var $atyps = parcelRequire("atyps");

var $5S2vX = parcelRequire("5S2vX");

var $7Rs16 = parcelRequire("7Rs16");
const $102ffae1b997ffb4$export$d089087e1703e7f4 = ({ pricing: pricing, countryCode: countryCode })=>{
    var _content_callToActionContainer, _pricing_hamsPricingData, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)("Contact Us", "Learn more");
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $atyps.BitbucketNav), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "bitbucket-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Rs16.BitbucketPriceFinder), {
                    serverSideHAMSPricing: pricing === null || pricing === void 0 ? void 0 : (_pricing_hamsPricingData = pricing.hamsPricingData) === null || _pricing_hamsPricingData === void 0 ? void 0 : _pricing_hamsPricingData.bitbucket,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $baTp3.DataCenterSection), (0, $6ogO3._)({}, dataCenterContent)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: "Bitbucket",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("9b72g", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return (parcelRequire("atyps")).BitbucketNav; });
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return (parcelRequire("fv5hW")).WhyBitbucketSubnav; });
parcelRequire("atyps");
parcelRequire("fv5hW");

});
parcelRegister("atyps", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return $46b40aa87e150696$export$374e7235418bdbdb; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $33ot9 = parcelRequire("33ot9");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9b72g");
var $fv5hW = parcelRequire("fv5hW");
const $46b40aa87e150696$var$BitbucketLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33ot9.BitbucketLogo), {
        appearance: "brand"
    });
};
const $46b40aa87e150696$export$374e7235418bdbdb = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=bitbucket&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).BITBUCKET,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $kooLp.useLocalizedHref)("/software/bitbucket/enterprise/data-center");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/bitbucket/pricing");
    const links = [
        {
            globalLinksKey: "whyBitbucket",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.whyBitbucket",
                defaultMessage: "Why Bitbucket"
            }),
            productKey: "bitbucket",
            hasSubnav: true,
            dropdownType: "why-bitbucket"
        },
        {
            globalLinksKey: "self-hosted",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.selfhosted",
                defaultMessage: "Self-Hosted"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: dataCenterHref
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productKey: "bitbucket",
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.bitbucket-logo",
                defaultMessage: "Bitbucket logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "whyBitbucket",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.whyBitbucket",
                        defaultMessage: "Why Bitbucket"
                    }),
                    containerStyles: {
                        width: "fit-content",
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fv5hW.WhyBitbucketSubnav), {
                        productKey: "bitbucket"
                    })
                },
                {
                    globalLinksKey: "self-hosted",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.selfhosted",
                        defaultMessage: "Self-Hosted"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: dataCenterHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-bitbucket",
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("33ot9", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", function () { return $2394a1fec8c53679$export$bd40525f5333524b; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $2394a1fec8c53679$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $2394a1fec8c53679$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2394a1fec8c53679$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("fv5hW", function(module, exports) {
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $e0ef30a4e223c9fa$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $e0ef30a4e223c9fa$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: "solution",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.solution",
                defaultMessage: "Solution"
            }),
            items: [
                {
                    id: "ci-cd",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.work-management",
                        defaultMessage: "CI/CD"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/pipelines")
                },
                {
                    id: "cloud-security",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.cloud-security",
                        defaultMessage: "Cloud Security"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                },
                {
                    id: "dev-sec-ops",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.dev-sec-ops",
                        defaultMessage: "DevSecOps"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/devsecops")
                },
                {
                    id: "code-review",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.it-service-management",
                        defaultMessage: "Code Review"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/code-review")
                },
                {
                    id: "jira-integrations",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.agile-devops",
                        defaultMessage: "Jira Integrations"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/jira/bitbucket-integration")
                }
            ]
        },
        plans: {
            id: "plans",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.plans",
                defaultMessage: "Plans"
            }),
            items: [
                {
                    id: "bitbucket-cloud-premium",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium",
                        defaultMessage: "Bitbucket Cloud Premium"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/premium")
                }
            ]
        }
    };
}
const $e0ef30a4e223c9fa$export$7b115720fff1fb0d = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $8e22h.default)();
    const bitbucketLinks = $e0ef30a4e223c9fa$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1rga"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("7Rs16", function(module, exports) {
$parcel$export(module.exports, "BitbucketPriceFinder", function () { return $cd0a3f920b6b151d$export$3f1971038752fd47; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $dl2JF = parcelRequire("dl2JF");
const $cd0a3f920b6b151d$export$3f1971038752fd47 = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium")
    };
    var _content_free_planTitleExternal, _content_free_planOneLiner, _content_standard_planTitleExternal, _content_standard_planOneLiner, _content_premium_planTitleExternal, _content_premium_planOneLiner;
    const bitbucketProductPlans = [
        {
            planName: (_content_free_planTitleExternal = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) !== null && _content_free_planTitleExternal !== void 0 ? _content_free_planTitleExternal : "Free",
            description: (_content_free_planOneLiner = (_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            recommendationLimit: 0,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=bitbucket&edition=free",
            planFeatureMessages: []
        },
        {
            planName: (_content_standard_planTitleExternal = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) !== null && _content_standard_planTitleExternal !== void 0 ? _content_standard_planTitleExternal : "Standard",
            description: (_content_standard_planOneLiner = (_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            recommendationLimit: 5,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=bitbucket&edition=standard",
            planFeatureMessages: []
        },
        {
            planName: (_content_premium_planTitleExternal = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) !== null && _content_premium_planTitleExternal !== void 0 ? _content_premium_planTitleExternal : "Premium",
            description: (_content_premium_planOneLiner = (_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            recommendationLimit: 100,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=bitbucket&edition=premium",
            planFeatureMessages: []
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "BitbucketSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Bitbucket Software user is any user who can log in to Bitbucket Software, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "BitbucketSoftwarePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "BitbucketSoftwarePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "BitbucketSoftwarePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "BitbucketSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "bitbucket",
            productPlans: bitbucketProductPlans,
            defaultUnitCount: 5,
            isMonthlyBillingOnly: true,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), (0, $6ogO3._)({
                messages: messages,
                hamsProductKey: "com.atlassian.bitbucket.manual"
            }, props))
        })
    });
};
$cd0a3f920b6b151d$export$3f1971038752fd47.displayName = "BitbucketPriceFinderSection";

});




parcelRegister("boM8U", function(module, exports) {
$parcel$export(module.exports, "SoftwareCompassPricingPage", function () { return $07ef5f80d51b18e6$export$a2e7512bef730a43; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $epXDi = parcelRequire("epXDi");
const $07ef5f80d51b18e6$export$a2e7512bef730a43 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "compass",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "compass-pricing-page",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $epXDi.SoftwareCompassPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("epXDi", function(module, exports) {
$parcel$export(module.exports, "SoftwareCompassPricingPageTemplate", function () { return $c9089bdccbd910b3$export$45aaac790ab82a3a; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");
parcelRequire("g1ccm");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $2zOxm = parcelRequire("2zOxm");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $bE8d4 = parcelRequire("bE8d4");

var $lgKym = parcelRequire("lgKym");

var $kKzVb = parcelRequire("kKzVb");
const $c9089bdccbd910b3$export$45aaac790ab82a3a = ({ pricing: pricing, countryCode: countryCode })=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lgKym.CompassNav), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "compass-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKzVb.SoftwareCompassPriceFinder), {
                    pricing: pricing,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: "Compass",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("lgKym", function(module, exports) {
$parcel$export(module.exports, "CompassNav", function () { return $73340f47439b5afe$export$78e93448314ae49; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jwykx = parcelRequire("jwykx");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $73340f47439b5afe$var$CompassLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwykx.CompassLogo), {
        appearance: "brand"
    });
};
const $73340f47439b5afe$export$78e93448314ae49 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=compass&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).COMPASS,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/compass/pricing");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "CompassPageTemplate.navbar.compass-logo",
                defaultMessage: "Compass logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: (0, $kooLp.useLocalizedHref)("/software/compass/features")
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-compass",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: (0, $kooLp.useLocalizedHref)("/software/compass/features")
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: pricingHref
                        }
                    ]
                }
            ]
        })
    });
};

});
parcelRegister("jwykx", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", function () { return $e36ba2bb4efdeb40$export$eb7d748e4f9c9676; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $e36ba2bb4efdeb40$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $e36ba2bb4efdeb40$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e36ba2bb4efdeb40$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("kKzVb", function(module, exports) {
$parcel$export(module.exports, "SoftwareCompassPriceFinder", function () { return $3a3a3d312451d671$export$5a248d92074c4b1b; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");
const $3a3a3d312451d671$export$5a248d92074c4b1b = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const SoftwareCompassPricingProductPlans = [
        {
            planName: ((_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) || "Free",
            offeringSku: "compass-free",
            description: ((_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) || "",
            recommendationLimit: 0,
            signupLimit: 3,
            signupURLSuffix: "?bundle=compass&edition=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: ((_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) || "Standard",
            offeringSku: "compass-standard",
            description: ((_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) || "",
            recommendationLimit: 3,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=compass&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: ((_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) || "Premium",
            offeringSku: "compass-premium-sku",
            description: ((_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) || "",
            recommendationLimit: 250,
            signupLimit: 35000,
            signupURLSuffix: "?bundle=compass&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "CompassPricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        cardOverSignupLimit: {
            id: "CompassPricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        unitCountInputTerm: {
            id: "CompassPricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardEnterpriseMinimumCount: {
            id: "CompassPricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "CompassPricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "CompassPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "compass",
            productPlans: SoftwareCompassPricingProductPlans,
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), (0, $6ogO3._)({
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.compass,
                countryCode: props.countryCode
            }, props))
        })
    });
};
$3a3a3d312451d671$export$5a248d92074c4b1b.displayName = "SoftwareCompassPriceFinderSection";

});



parcelRegister("8IsVQ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorAutomation", function () { return $ca484168b962bf16$export$7f9d44dab84ab3fb; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $ca484168b962bf16$export$7f9d44dab84ab3fb = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.start-with-page.title",
                defaultMessage: "Start with a page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.start-with-page.body",
                defaultMessage: "Plan projects, share knowledge, and automate workflows, all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.supercharge-productivity.title",
                defaultMessage: "Supercharge productivity"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.supercharge-productivity.body",
                defaultMessage: "Save time by automating repetitive, manual tasks."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/qrpd4w43508d10hq328mq05417ilsc7y.webp",
            imgAltText: "Confluence automating emails"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.connect-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Automation.connect-work.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-automation-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-automation";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConfAnchorAutomation",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});
parcelRegister("cR8Gg", function(module, exports) {
$parcel$export(module.exports, "useLogMeInD0to6", function () { return $83b6c6a3b1991cc3$export$dc29ba926b713c7f; });

var $6gVNd = parcelRequire("6gVNd");

var $doAVE = parcelRequire("doAVE");
const $83b6c6a3b1991cc3$export$dc29ba926b713c7f = ({ availableProducts: availableProducts, userProfile: userProfile })=>{
    const confluenceD0to6 = (0, $doAVE.useConfluenceD0to6)();
    const useLogMeInOriginalResponse = (0, $6gVNd.useLogMeIn)({
        availableProducts: availableProducts,
        userProfile: userProfile,
        siteType: (0, $6gVNd.AtlSiteType).CONFLUENCE
    });
    const shouldShowLogMeIn = !!confluenceD0to6 && useLogMeInOriginalResponse.shouldShowLogMeIn;
    return {
        userProfileName: useLogMeInOriginalResponse.userProfileName,
        recentSites: useLogMeInOriginalResponse.recentSites,
        shouldShowLogMeIn: shouldShowLogMeIn
    };
};

});
parcelRegister("6gVNd", function(module, exports) {
$parcel$export(module.exports, "AtlSiteType", function () { return $eb6f3bd622284567$export$25e165f6cdbb7fba; });
$parcel$export(module.exports, "useLogMeIn", function () { return $eb6f3bd622284567$export$3b3e141b692cc8f3; });

var $3riD8 = parcelRequire("3riD8");
var $eb6f3bd622284567$export$25e165f6cdbb7fba = /*#__PURE__*/ function(AtlSiteType) {
    AtlSiteType["CONFLUENCE"] = "confluence.ondemand";
    AtlSiteType["JIRA"] = "jira-software.ondemand";
    return AtlSiteType;
}({});
const $eb6f3bd622284567$var$filterAvailableSites = (availableProducts, siteType)=>{
    if (availableProducts) {
        const filteredSites = availableProducts.sites.filter((site)=>{
            return site.products.includes(siteType);
        }) || [];
        return filteredSites;
    } else return [];
};
const $eb6f3bd622284567$export$3b3e141b692cc8f3 = ({ availableProducts: availableProducts, userProfile: userProfile, siteType: siteType = "confluence.ondemand" })=>{
    const filteredSites = $eb6f3bd622284567$var$filterAvailableSites(availableProducts, siteType);
    const loggedInUserName = (0, $3riD8.useLoggedInUser)().name;
    const userProfileName = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.name) || loggedInUserName;
    return {
        userProfileName: userProfileName,
        recentSites: filteredSites,
        shouldShowLogMeIn: !!userProfileName && filteredSites.length > 0
    };
};

});


parcelRegister("bspxF", function(module, exports) {
$parcel$export(module.exports, "PaidHeroCarousel", function () { return $3b471d0a49843259$export$f092ba03447984fe; });
/* paid-hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kc6xi = parcelRequire("kc6xi");

var $3LcIp = parcelRequire("3LcIp");

var $2emUn = parcelRequire("2emUn");

var $cudmb = parcelRequire("cudmb");
const $3b471d0a49843259$var$paidHeroContainerStyles = null;
const $3b471d0a49843259$var$backgroundGradient = null;
const $3b471d0a49843259$var$paidHeroContentStyles = null;
const $3b471d0a49843259$var$blockStartPadding = null;
const $3b471d0a49843259$var$signUpFormContainerStyles = null;
const $3b471d0a49843259$var$carouselContainerStyles = null;
const $3b471d0a49843259$var$rebrandBackground = null;
const $3b471d0a49843259$export$f092ba03447984fe = ({ pageId: pageId, carouselSlides: carouselSlides, shouldUseTransparentBackground: shouldUseTransparentBackground, shouldUseBlockStartPadding: shouldUseBlockStartPadding = true, shouldUseNewBrandBackground: shouldUseNewBrandBackground, usePlainContainer: usePlainContainer })=>{
    const intl = (0, $8e22h.default)();
    const isLiftAndShiftExposure = pageId === "paid-lp-conf-features" || pageId === "confluence-default";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: isLiftAndShiftExposure ? "cfind-1466-lift-and-shift" : "wac-conf-anchors-lift-and-shift",
        group: isLiftAndShiftExposure ? "treatmentA" : "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            id: "start-trial",
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bah1h6o",
                !shouldUseTransparentBackground && "_11q7i1wq",
                shouldUseNewBrandBackground && "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1tke1fbq _p12fzqdx _gy1pckbl _1p571tcg _1bsb1osq _1bah1h6o",
                    shouldUseBlockStartPadding && "_1q511wqb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n _1o9zkb7n _i0dl1osq _p12f1usy"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
                            name: isLiftAndShiftExposure ? "conf-lift-and-shift-features-signup-module" : "conf-lift-and-shift-signup-module",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cudmb.EmbeddedSignupForm), {
                                pageId: pageId
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _1bah1h6o _1ul91178 _16jlkb7n _1o9zkb7n _i0dl1osq _y4tizwfg _sugaglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsAssetWrapper), {
                            product: "confluence",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
                                name: isLiftAndShiftExposure ? "cfind-1466-carousel" : "conf-lift-and-shift-carousel",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kc6xi.Carousel), {
                                    "aria-label": intl.formatMessage({
                                        id: "ConfluenceSoftwarePage.v4.CarouselHero.AriaLabel",
                                        defaultMessage: "A display of various confluence features",
                                        description: "Aria label for the carousel section"
                                    }),
                                    slides: carouselSlides,
                                    id: "confluence-features-carousel",
                                    usePlainContainer: usePlainContainer
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("cudmb", function(module, exports) {
$parcel$export(module.exports, "EmbeddedSignupForm", function () { return $4568c23a144289c5$export$7572837522fb3c8b; });

var $7VQPk = parcelRequire("7VQPk");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");
parcelRequire("hJZgm");
var $dx6hU = parcelRequire("dx6hU");
var $7Izt2 = parcelRequire("7Izt2");
var $b9dfy = parcelRequire("b9dfy");
var $2UACm = parcelRequire("2UACm");
const $4568c23a144289c5$export$2f0084313b87d4cc = {
    "paid-lp-conf-features": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-conf-features"
    }),
    "paid-lp-confl-projectmgmt": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-projectmgmt"
    }),
    "paid-lp-confl-documentation": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-documentation"
    }),
    "paid-lp-confl-template": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-template"
    }),
    "anchor-lp-conf-automation": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-automation"
    }),
    "anchor-lp-conf-collaboration": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-collaboration"
    }),
    "anchor-lp-conf-teamwork": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-teamwork"
    }),
    "anchor-lp-conf-work-management": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-work-management"
    }),
    "anchor-lp-conf-competitors": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Izt2.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-competitors"
    }),
    "default": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b9dfy.DefaultEmbeddedSignupForm), {}),
    "confluence-default": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dx6hU.CFindEmbeddedSignupForm), {})
};
const $4568c23a144289c5$export$7572837522fb3c8b = ({ pageId: pageId })=>{
    const { product: product, user: user } = (0, $doAVE.useUserContext)();
    if (user.isUserLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2UACm.LoggedInForm), {});
    let variantName = "default";
    if ((product === null || product === void 0 ? void 0 : product.key) === (0, $7VwhR.ProductKey).CONFLUENCE) variantName = "confluence-default";
    if (pageId in $4568c23a144289c5$export$2f0084313b87d4cc) variantName = pageId;
    return $4568c23a144289c5$export$2f0084313b87d4cc[variantName];
};

});
parcelRegister("hJZgm", function(module, exports) {
$parcel$export(module.exports, "CFindEmbeddedSignupForm", function () { return (parcelRequire("dx6hU")).CFindEmbeddedSignupForm; });
$parcel$export(module.exports, "ConfluenceFeaturesPageEmbeddedSignupForm", function () { return (parcelRequire("7Izt2")).ConfluenceFeaturesPageEmbeddedSignupForm; });
$parcel$export(module.exports, "DefaultEmbeddedSignupForm", function () { return (parcelRequire("b9dfy")).DefaultEmbeddedSignupForm; });
$parcel$export(module.exports, "LoggedInForm", function () { return (parcelRequire("2UACm")).LoggedInForm; });
parcelRequire("dx6hU");
parcelRequire("7Izt2");
parcelRequire("b9dfy");
parcelRequire("2UACm");

});
parcelRegister("dx6hU", function(module, exports) {
$parcel$export(module.exports, "CFindEmbeddedSignupForm", function () { return $0f104ab1090b0a33$export$30d022a977c0a6db; });
/* cfind-embedded-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $jVa6Y = parcelRequire("jVa6Y");

var $3LcIp = parcelRequire("3LcIp");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("3XETN");
var $8GyVU = parcelRequire("8GyVU");
var $Mhvf3 = parcelRequire("Mhvf3");
var $4MWzW = parcelRequire("4MWzW");
const $0f104ab1090b0a33$var$confluenceEmbeddedExistingText = (0, $fnHPc.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $0f104ab1090b0a33$export$30d022a977c0a6db = ()=>{
    const gwp9286ConfluenceAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const defaultHeader = gwp9286ConfluenceAnchorUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "GWP9286ConfluenceAnchorUpdates.header.confluence.features",
        defaultMessage: "Meet your new AI-powered workspace"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features.gwp9286",
        defaultMessage: "Goodbye silos, hello teamwork with Confluence"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8GyVU.EmbeddedSignupFormWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $2jatx.default)([
                "_4cvr1fhb _bfhku67f _16qsoopq _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "header",
                        children: defaultHeader
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "subheader",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpUiSignup.SignupForm.subheader.1",
                            defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.default), {
                    Login: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4MWzW.SocialEndorsement), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Mhvf3.ExistingProductText), {
                    messageOverride: $0f104ab1090b0a33$var$confluenceEmbeddedExistingText
                })
            ]
        })
    });
};
const $0f104ab1090b0a33$var$containerStyle = null;
const $0f104ab1090b0a33$var$headerStyle = null;
const $0f104ab1090b0a33$var$subheaderStyle = null;

});
parcelRegister("jVa6Y", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("1WLWt")).Separator; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("cGEBM")).useAccountCreationContext; });
$parcel$export(module.exports, "default", function () { return $4e0aa450913abeb5$export$2e2bcd8739ae039; });

var $6KUQg = parcelRequire("6KUQg");
parcelRequire("1FWHc");
parcelRequire("9ktVo");
var $4e0aa450913abeb5$export$2e2bcd8739ae039 = (0, $6KUQg.AccountCreation);

});
parcelRegister("6KUQg", function(module, exports) {
$parcel$export(module.exports, "AccountCreation", function () { return $42aa4ee4b4afed63$export$b841b541bc741e79; });

var $6ogO3 = parcelRequire("6ogO3");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1FWHc");
var $7u4F3 = parcelRequire("7u4F3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $42aa4ee4b4afed63$export$b841b541bc741e79 = (_param)=>{
    var { getContinueUrl: getContinueUrl, identityCobranding: identityCobranding, templateId: templateId } = _param, props = (0, $aPnCa._)(_param, [
        "getContinueUrl",
        "identityCobranding",
        "templateId"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cGEBM.AccountCreationContextProvider), {
        getContinueUrl: getContinueUrl,
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7u4F3.Content), (0, $6ogO3._)({}, props))
    });
};

});
parcelRegister("1FWHc", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("7u4F3")).Content; });
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("1WLWt")).Separator; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
parcelRequire("MNUwH");
parcelRequire("f5lYY");
parcelRequire("7PpcD");
parcelRequire("1p00m");
parcelRequire("bncEF");
parcelRequire("1WLWt");
parcelRequire("k0W5w");
parcelRequire("kHTHh");

});
parcelRegister("MNUwH", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("7u4F3")).Content; });
parcelRequire("7u4F3");

});
parcelRegister("7u4F3", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $6cc2293976038b02$export$7c6e2c02157bb7d2; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $lX14w = parcelRequire("lX14w");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
parcelRequire("f5lYY");
var $mG5bv = parcelRequire("mG5bv");
parcelRequire("7PpcD");
var $irRyj = parcelRequire("irRyj");
parcelRequire("bncEF");
var $lJMiD = parcelRequire("lJMiD");

var $1WLWt = parcelRequire("1WLWt");
parcelRequire("k0W5w");
var $32ARy = parcelRequire("32ARy");
parcelRequire("kHTHh");
var $l7G9R = parcelRequire("l7G9R");
const $6cc2293976038b02$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {}), Input: Input = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {}), Social: Social = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1WLWt.Separator), {}), Error: Error = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $mG5bv.Error), {}), Login: Login = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {}) })=>{
    const { onSubmit: onSubmit } = (0, $cGEBM.useAccountCreationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                onSubmit: onSubmit,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            Submit
                        ]
                    }))
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("9ktVo", function(module, exports) {
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return (parcelRequire("cGEBM")).AccountCreationContextProvider; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("cGEBM")).useAccountCreationContext; });
parcelRequire("cGEBM");

});
parcelRegister("cGEBM", function(module, exports) {
$parcel$export(module.exports, "useAccountCreationContext", function () { return $835e146085c3a79b$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $835e146085c3a79b$export$b0a1b3550379fc78; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7VwhR = parcelRequire("7VwhR");
parcelRequire("jmley");
var $gfjAv = parcelRequire("gfjAv");

var $doAVE = parcelRequire("doAVE");

var $1ka2O = parcelRequire("1ka2O");

var $iSeHD = parcelRequire("iSeHD");
const $835e146085c3a79b$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $835e146085c3a79b$export$30b295205cfae694 = ()=>{
    const context = (0, $1oC0p.useContext)($835e146085c3a79b$export$52bc2238e0ff8657);
    if (!context) throw new Error("useAccountCreationContext must be used within a AccountCreationContextProvider");
    return context;
};
const $835e146085c3a79b$export$b0a1b3550379fc78 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding = "wac", templateId: templateId, children: children })=>{
    const location = (0, $1ka2O.useLocation)();
    const isEmbedded = !location.pathname.endsWith("/try/cloud/signup");
    const { product: product, edition: edition } = (0, $doAVE.useUserContext)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const [isEmailValid, setIsEmailValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [formError, setFormError] = (0, $1oC0p.useState)(false);
    const [typeAheadEmail, setTypeAheadEmail] = (0, $1oC0p.useState)("");
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $1oC0p.useState)(false);
    const localePath = (0, $7VwhR.getLocalePath)(intl.locale);
    const continueParam = (0, $7VwhR.getContinueParam)(location);
    const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
    // default experiment params
    if (product && identityCobranding === "wac") {
        if (product.name === "confluence") identityCobranding = "wac--otp-confluence";
        else if (product.name === "jira") identityCobranding = "wac--otp-jira";
        else if (product.name === "loom") identityCobranding = "wac--loom";
        else if (product.name === "jira-product-discovery") identityCobranding = "wac--jpd";
        else if (product.name === "jira-servicedesk") identityCobranding = "wac--jsm";
        else if (product.name === "service-collection") identityCobranding = "wac--service-collection";
        else if (product.name === "teamwork-collection") identityCobranding = "wac--teamwork-collection";
    }
    const defaultContinueUrl = (0, $1oC0p.useCallback)(()=>continueParam ? continueParam : (0, $7VwhR.getNameYourSiteRedirectUrl)({
            bundle: product === null || product === void 0 ? void 0 : product.bundle,
            edition: edition,
            localePath: localePath,
            templateId: templateId,
            application: identityCobranding
        }), [
        continueParam,
        product,
        edition,
        localePath,
        templateId,
        identityCobranding
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $7VwhR.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product === null || product === void 0 ? void 0 : product.key,
            edition: edition
        });
        (0, $7VwhR.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
        (0, $7VwhR.trackSignFormLoad)(createAnalyticsEvent);
        (0, $7VwhR.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product === null || product === void 0 ? void 0 : product.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmit = (0, $1oC0p.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $7VwhR.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        (0, $7VwhR.trackFormSubmit)(createAnalyticsEvent, product === null || product === void 0 ? void 0 : product.key, edition);
        setIsSubmitting(true);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        try {
            // check identity interstitial redirect experiments for enrollment
            const url = (0, $7VwhR.getIdentityInterstitialUrl)(email, continueUrl, identityCobranding);
            createAnalyticsEvent({
                eventType: "ui",
                action: "succeeded",
                actionSubject: "accountCreationInterstitialRedirect",
                containerId: "bxp-ui-signup",
                attributes: {
                    productKey: product === null || product === void 0 ? void 0 : product.key,
                    edition: edition
                }
            }).fire();
            window.location.assign(url);
            return;
        } catch (error) {
            setHasSubmitted(true);
            setFormError(true);
            setIsSubmitting(false);
            createAnalyticsEvent({
                eventType: "ui",
                action: "errored",
                actionSubject: "accountCreationInterstitialRedirect",
                containerId: "bxp-ui-signup",
                attributes: {
                    productKey: product === null || product === void 0 ? void 0 : product.key,
                    edition: edition
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        defaultContinueUrl,
        edition,
        getContinueUrl,
        identityCobranding,
        isEmailValid,
        product
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $7VwhR.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product === null || product === void 0 ? void 0 : product.key, edition);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        const socialRedirectUrl = (0, $7VwhR.getSocialButtonUrl)({
            redirectTo: continueUrl,
            identityCobranding: identityCobranding,
            provider: provider
        });
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $7VwhR.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($835e146085c3a79b$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmit: onSubmit,
            product: product,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
            edition: edition,
            intentType: "form",
            productKey: product === null || product === void 0 ? void 0 : product.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});


parcelRegister("f5lYY", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return (parcelRequire("mG5bv")).Error; });
parcelRequire("mG5bv");

});
parcelRegister("mG5bv", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return $d2f561c370fddce6$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $d2f561c370fddce6$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const { formError: formError } = (0, $cGEBM.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === "en" // temporary fix until translation is available
     ? formatMessage({
        id: "AccountCreation.userSignupError",
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    }) : formatMessage({
        id: "BxpUiSignup.SignupForm.formError",
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "alert",
        className: (0, $2jatx.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $d2f561c370fddce6$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $d2f561c370fddce6$var$errorCss = null;

});


parcelRegister("7PpcD", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
parcelRequire("irRyj");

});
parcelRegister("irRyj", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $5190fd2e8a96a930$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
parcelRequire("1p00m");
var $6nMZs = parcelRequire("6nMZs");
const $5190fd2e8a96a930$var$HELP_TEXT_ID = "account_creation_email_help_text";
const $5190fd2e8a96a930$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperText",
        defaultMessage: "Using a work email helps find teammates and boost collaboration."
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $7VwhR.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth7vkz _1rwq121t _1heubzd7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rnbzd7 _1q9pbfng _d78pglyw",
            modalVisualUpdates && "_17rnjdj5 _1heujdj5"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_zbay183y",
                        isValid === true && "_1lo6qn1y",
                        isValid === false && "_1lo61wfy"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                            autoComplete: "email",
                            "aria-describedby": $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        })),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $2jatx.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            className: (0, $2jatx.default)([
                                "_1wybepq8 _vwz4bs82 _tzy4txnc _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $5190fd2e8a96a930$var$errorMessageCss = null;
const $5190fd2e8a96a930$var$helpTextCss = null;
const $5190fd2e8a96a930$var$fieldCss = null;
// todo remove !important when we productionize gate and merge properties with fieldCss
const $5190fd2e8a96a930$var$fieldV2Css = null;
const $5190fd2e8a96a930$var$inputCss = null;
const $5190fd2e8a96a930$var$inputInvalidCss = null;
const $5190fd2e8a96a930$var$inputValidCss = null;

});
parcelRegister("1p00m", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
parcelRequire("6nMZs");

});
parcelRegister("6nMZs", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return $f28bd5fc1ae39550$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kCGk7 = parcelRequire("kCGk7");

var $78jg9 = parcelRequire("78jg9");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");
const $f28bd5fc1ae39550$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const validMessage = formatMessage({
        id: "signupForm.accountCreation.validEmailIcon",
        defaultMessage: "Success"
    });
    const invalidMessage = formatMessage({
        id: "signupForm.accountCreation.invalidEmailIcon",
        defaultMessage: "Warning"
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1ua5"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78jg9))), {
            label: validMessage
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1bqt"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kCGk7))), {
            label: invalidMessage
        })
    });
};
const $f28bd5fc1ae39550$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $kbpa7.wacToken)("color.neutral.light0"),
    fontSize: (0, $7VwhR.fontSize).md,
    paddingInlineEnd: 8
};
const $f28bd5fc1ae39550$var$iconValidCss = null;
const $f28bd5fc1ae39550$var$iconInvalidCss = null;

});




parcelRegister("bncEF", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
parcelRequire("lJMiD");

});
parcelRegister("lJMiD", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return $50db90a6da99c80d$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $7VwhR = parcelRequire("7VwhR");

var $2fk4i = parcelRequire("2fk4i");

var $1ka2O = parcelRequire("1ka2O");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $50db90a6da99c80d$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const { product: product } = (0, $cGEBM.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct",
        defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
    }, {
        product: product === null || product === void 0 ? void 0 : product.description,
        logInLink: (text)=>$50db90a6da99c80d$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
        },
        children: loginText
    });
};
const $50db90a6da99c80d$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $7VwhR.getLoginUrl)(location)
    });
const $50db90a6da99c80d$var$existingProductCss = null;

});


parcelRegister("k0W5w", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
parcelRequire("iTWJZ");
parcelRequire("32ARy");

});
parcelRegister("32ARy", function(module, exports) {
$parcel$export(module.exports, "Social", function () { return $4e2e5c1067955974$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");

var $iTWJZ = parcelRequire("iTWJZ");
const $4e2e5c1067955974$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    // when there are 3 buttons, we display in a single row and visually hide the text labels
    const rowStyle = buttons.length === 3;
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && !rowStyle && "_1e0c11p5 _zulp7vkz _yv0efsjm",
            rowStyle && "_1e0c11p5 _zulp7vkz _wij21bp4"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iTWJZ.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iTWJZ.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                rowStyle && "_kqswstnw _1e021cib _152t1wug _1bsbt94y _4t3it94y _1reo15vq _18m915vq _ogtohxbz _o5721q9c"
                            ]),
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};
const $4e2e5c1067955974$var$buttonGridCss = null;
const $4e2e5c1067955974$var$buttonListCss = null;
const $4e2e5c1067955974$var$buttonRowCss = null;
const $4e2e5c1067955974$var$srOnlyCss = null;

});


parcelRegister("kHTHh", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
parcelRequire("l7G9R");

});
parcelRegister("l7G9R", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c; });
/* submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    if (modalVisualUpdates) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: buttonText
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        children: buttonText
    });
};
const $9e3c42c7c44204a7$var$buttonCss = null;

});







parcelRegister("3XETN", function(module, exports) {
$parcel$export(module.exports, "EmbeddedSignupFormWrapper", function () { return (parcelRequire("8GyVU")).EmbeddedSignupFormWrapper; });
$parcel$export(module.exports, "ExistingProductText", function () { return (parcelRequire("Mhvf3")).ExistingProductText; });
$parcel$export(module.exports, "SocialEndorsement", function () { return (parcelRequire("4MWzW")).SocialEndorsement; });
parcelRequire("8GyVU");
parcelRequire("Mhvf3");
parcelRequire("4MWzW");

});
parcelRegister("8GyVU", function(module, exports) {
$parcel$export(module.exports, "EmbeddedSignupFormWrapper", function () { return $15727279b34dd3f9$export$feb4e6597ee7cf21; });
/* embedded-signup-form-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jVaD0 = parcelRequire("jVaD0");

var $7VwhR = parcelRequire("7VwhR");
const $15727279b34dd3f9$var$signupModule = null;
const $15727279b34dd3f9$var$container = null;
const $15727279b34dd3f9$var$footer = null;
const $15727279b34dd3f9$export$feb4e6597ee7cf21 = ({ hideFooter: hideFooter, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx21bp4 _ect41qje _1wyb8oy7 _ca0qviql _u5f3viql _n3tdviql _19bvviql _1kmxviql _1ggm1kwk _1ykzviql _1mae1kwk _ie1cviql _78i21j6v _1db0viql _dpmd1j6v _i6jxviql _1lh71j6v _z3ncviql _wpai1j6v"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_p12fnl1e _1bsb1osq _cadt1qje _8v2f1qje _iowe1h6o _1afj1h6o _1vfhqwb1 _1twlni7l _1xd21btq _rzbyidpf _8k2zidpf _nd4uidpf _9u9nidpf _11eb1kw7 _l5k14jg8 _1n461kwk _if5yidpf _1gnp1kwk _7e5bidpf _1g0f1k8s _cg41alr3 _1t2qalr3 _125xalr3 _doqyalr3 _zcqxbs82 _clfd1j6v _11pqidpf _q0a51j6v _c3k8idpf _1sgrepq8 _kminepq8 _59381r31 _yha2glyw _1nmznqa1 _43dsoelr _1cayoelr _9m7f1r31 _rfqo1r31 _w7sw8stv _1bgk8stv _15a9nqa1 _1t0pnqa1"
                ]),
                style: {
                    "--_1n7yiy6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xl),
                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                },
                children: children
            }),
            !hideFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_19pk1k8s _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVaD0.AtlassianLogo), {
                    appearance: "brand",
                    size: "small",
                    testId: "atlassian-logo",
                    label: "Atlassian logo"
                })
            })
        ]
    });
};

});

parcelRegister("Mhvf3", function(module, exports) {
$parcel$export(module.exports, "ExistingProductText", function () { return $b146f38ea128bebe$export$2421ab9e56e71ee7; });
/* existing-product-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $2fk4i = parcelRequire("2fk4i");

var $1ka2O = parcelRequire("1ka2O");
const $b146f38ea128bebe$var$existingText = (0, $fnHPc.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct",
    defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
});
const $b146f38ea128bebe$export$2421ab9e56e71ee7 = ({ messageOverride: messageOverride, bgColor: bgColor = "bgWhite" })=>{
    const { product: product } = (0, $doAVE.useUserContext)();
    const location = (0, $1ka2O.useLocation)();
    const loginUrl = new URL("/login", (0, $7VwhR.getIdentityBaseUrl)());
    const continueParam = (0, $7VwhR.getContinueParam)(location);
    if (continueParam) loginUrl.searchParams.append("continue", continueParam);
    else {
        const defaultContinueUrl = new URL("/gateway/api/start/authredirect", (0, $7VwhR.getWacIntegrationUrl)()).toString();
        loginUrl.searchParams.append("continue", defaultContinueUrl);
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, messageOverride !== null && messageOverride !== void 0 ? messageOverride : $b146f38ea128bebe$var$existingText), {
            values: {
                product: product === null || product === void 0 ? void 0 : product.name,
                logInLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: text,
                        "aria-label": text,
                        type: "inline",
                        href: loginUrl.toString(),
                        bgColor: bgColor,
                        className: "linkText"
                    })
            }
        }))
    });
};
const $b146f38ea128bebe$var$existingProductCss = null;

});

parcelRegister("4MWzW", function(module, exports) {
$parcel$export(module.exports, "SocialEndorsement", function () { return $c94a1620ecd53dba$export$782656e60c9cecfd; });
/* social-endorsement.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2emUn = parcelRequire("2emUn");
const $c94a1620ecd53dba$var$carouselStyle = null;
const $c94a1620ecd53dba$var$trackStyle = null;
const $c94a1620ecd53dba$var$logoStyle = null;
const $c94a1620ecd53dba$var$SocialEndorsementComponent = ()=>{
    const logos = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg",
            alt: "Canva",
            width: 95
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg",
            alt: "Nasa",
            width: 60
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg",
            alt: "Illumina",
            width: 103
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg",
            alt: "Docker",
            width: 108
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg",
            alt: "The New York Times",
            width: 165
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg",
            alt: "Audi",
            width: 68
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "cfind-2675-social-proof",
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _4t3i14no _kqswh2mm _1q511tcg _1bsb1osq _vchh1ntv"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_y44v9j94 _1e0c1txw _zulpzwfg _kqswstnw"
            ]),
            children: [
                ...logos,
                ...logos
            ].map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: logo.src,
                        alt: logo.alt,
                        loading: "lazy",
                        width: logo.width,
                        className: (0, $2jatx.default)([
                            "_lcxvglyw _kdamllbs _4t3i14no _16bullbs"
                        ])
                    })
                }, index))
        })
    });
};
const $c94a1620ecd53dba$export$782656e60c9cecfd = (0, $2emUn.withFeatureExposed)("cfind-2675-social-proof-paid", "true", $c94a1620ecd53dba$var$SocialEndorsementComponent);

});



parcelRegister("7Izt2", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFeaturesPageEmbeddedSignupForm", function () { return $00a39583d443db7b$export$2394908a1a97673f; });
/* confluence-features-page-embedded.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");

var $jVa6Y = parcelRequire("jVa6Y");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("3XETN");
var $8GyVU = parcelRequire("8GyVU");
var $Mhvf3 = parcelRequire("Mhvf3");
const $00a39583d443db7b$var$confluenceEmbeddedExistingText = (0, $fnHPc.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $00a39583d443db7b$export$2394908a1a97673f = ({ variant: variant })=>{
    const gwp9286ConfluenceAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const headers = {
        "paid-lp-conf-features": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features",
            defaultMessage: "Goodbye silos, hello teamwork with Confluence"
        }),
        "anchor-lp-conf-competitors": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.competitors",
            defaultMessage: "Confluence is the #1 collaboration tool for productive teams"
        }),
        "anchor-lp-conf-work-management": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.work.management",
            defaultMessage: "Bring your team\u2019s work together with Confluence"
        }),
        "anchor-lp-conf-teamwork": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.teamwork",
            defaultMessage: "Accelerate teamwork and productivity with Confluence"
        }),
        "anchor-lp-conf-collaboration": gwp9286ConfluenceAnchorUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "GWP9286ConfluenceAnchorUpdates.header.confluence.collaboration",
            defaultMessage: "AI-driven project collaboration for modern teams"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.collaboration",
            defaultMessage: "Turn ideas into action with Confluence"
        }),
        "anchor-lp-conf-automation": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.automation",
            defaultMessage: "Collaborate better with Confluence"
        }),
        "paid-lp-confl-template": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.template",
            defaultMessage: "There\u2019s a Confluence template for that"
        }),
        "paid-lp-confl-documentation": gwp9286ConfluenceAnchorUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "GWP9286ConfluenceAnchorUpdates.header.confluence.documentation",
            defaultMessage: "Turn team knowledge into lasting documentation everyone can use"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.documentation",
            defaultMessage: "Technically superior documentation starts with Confluence"
        }),
        "paid-lp-confl-projectmgmt": /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.project.management",
            defaultMessage: "Confluence makes project management easy"
        })
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8GyVU.EmbeddedSignupFormWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $2jatx.default)([
                "_4cvr1fhb _bfhku67f _16qs1cd0 _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: headers[variant]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: (0, $2jatx.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.SignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.default), {
                    Login: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Mhvf3.ExistingProductText), {
                    messageOverride: $00a39583d443db7b$var$confluenceEmbeddedExistingText
                })
            ]
        })
    });
};
const $00a39583d443db7b$var$containerStyle = null;
const $00a39583d443db7b$var$headerStyle = null;
const $00a39583d443db7b$var$subheaderStyle = null;

});

parcelRegister("b9dfy", function(module, exports) {
$parcel$export(module.exports, "DefaultEmbeddedSignupForm", function () { return $c1b1a124c7e97ca9$export$ec3bbe4365c4cdfa; });
/* default-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $jVa6Y = parcelRequire("jVa6Y");

var $doAVE = parcelRequire("doAVE");
parcelRequire("3XETN");
var $8GyVU = parcelRequire("8GyVU");
var $Mhvf3 = parcelRequire("Mhvf3");
const $c1b1a124c7e97ca9$export$ec3bbe4365c4cdfa = ()=>{
    const { product: product } = (0, $doAVE.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8GyVU.EmbeddedSignupFormWrapper), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $2jatx.default)([
                "_4cvr1fhb _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.header",
                        defaultMessage: "Get started with {product}",
                        values: {
                            product: product === null || product === void 0 ? void 0 : product.name
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.default), {
                    Login: null
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Mhvf3.ExistingProductText), {})
            ]
        })
    });
};
const $c1b1a124c7e97ca9$var$containerStyle = null;

});

parcelRegister("2UACm", function(module, exports) {
$parcel$export(module.exports, "LoggedInForm", function () { return $0eca7a5f583e0e14$export$c5d014cdd7dc976f; });
/* logged-in-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iuew3 = parcelRequire("iuew3");
var $bGrkd = parcelRequire("bGrkd");
var $bs458 = parcelRequire("bs458");

var $doAVE = parcelRequire("doAVE");

var $ea4mV = parcelRequire("ea4mV");
const $0eca7a5f583e0e14$export$c5d014cdd7dc976f = ()=>{
    const intl = (0, $8e22h.default)();
    const firstName = (0, $doAVE.useFirstName)();
    const experiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).confluenceContactAndCompanyExpandSiteActivation);
    const useContactExpandCohortLogic = experiment.type === "enrolled" && experiment.value;
    if (useContactExpandCohortLogic) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhku67f _2rkogktf _ca0q1ylp _u5f312am _n3td8vuz _19bv12am _1bsb1erl"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_k48pbfng",
                    "_19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpUiSignup.nameSite.header",
                    defaultMessage: "Welcome back, {name}",
                    values: {
                        name: firstName
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuew3.default), {
                useContactExpandCohortLogic: true,
                CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {})
            })
        ]
    });
    const headerText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.header",
        defaultMessage: "Welcome back, {name}"
    }, {
        name: firstName
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhku67f _2rkogktf _ca0q1ylp _u5f312am _n3td8vuz _19bv12am _1bsb1erl"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_k48pbfng"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuew3.default), {
                WeekOneUser: null
            })
        ]
    });
};
const $0eca7a5f583e0e14$var$containerStyles = null;
const $0eca7a5f583e0e14$var$headerStyles = null;
const $0eca7a5f583e0e14$var$headerContactExpandCss = null;

});
parcelRegister("iuew3", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("fMbfG")).Dropdown; });
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("jgBbG")).ExistingUser; });
$parcel$export(module.exports, "JoinableSites", function () { return (parcelRequire("bGrkd")).JoinableSites; });
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lBvZp")).NewUser; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("bs458")).ReturnToProduct; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("33py5")).SitePicker; });
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return (parcelRequire("2HR6E")).UpgradeEligibleUser; });
$parcel$export(module.exports, "useSiteActivationContext", function () { return (parcelRequire("ff4S3")).useSiteActivationContext; });
$parcel$export(module.exports, "default", function () { return $90cafc496d86b407$export$2e2bcd8739ae039; });

var $ka4Xu = parcelRequire("ka4Xu");
parcelRequire("a7UN5");
parcelRequire("hQLiM");
var $90cafc496d86b407$export$2e2bcd8739ae039 = (0, $ka4Xu.SiteActivation);

});
parcelRegister("ka4Xu", function(module, exports) {
$parcel$export(module.exports, "SiteActivation", function () { return $9dd5cc04ed0b1948$export$5f19f51fdf3d70; });
/* site-activation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $doAVE = parcelRequire("doAVE");
parcelRequire("hQLiM");
var $ff4S3 = parcelRequire("ff4S3");

var $3fEYe = parcelRequire("3fEYe");
const $9dd5cc04ed0b1948$export$5f19f51fdf3d70 = (props)=>{
    const cohort = (0, $doAVE.useCohort)(props.useContactExpandCohortLogic);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "site-activation",
        "data-cohort": cohort,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff4S3.SiteActivationContextProvider), {
            existingSites: props.existingSites,
            useContactExpandCohortLogic: props.useContactExpandCohortLogic,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3fEYe.SiteActivationSwitcher), (0, $6ogO3._)({}, props))
        })
    });
};
// fill the available space in the parent container
const $9dd5cc04ed0b1948$var$siteActivationCss = null;

});
parcelRegister("hQLiM", function(module, exports) {
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return (parcelRequire("ff4S3")).SiteActivationContextProvider; });
$parcel$export(module.exports, "useSiteActivationContext", function () { return (parcelRequire("ff4S3")).useSiteActivationContext; });
parcelRequire("lbA31");
parcelRequire("ff4S3");

});
parcelRegister("lbA31", function(module, exports) {
$parcel$export(module.exports, "useRecommendedSiteName", function () { return $8bbeebdbf54863c8$export$c2aa7c9492b42e56; });

var $1oC0p = parcelRequire("1oC0p");

var $at5jC = parcelRequire("at5jC");

var $3riD8 = parcelRequire("3riD8");

var $ff4S3 = parcelRequire("ff4S3");
function $8bbeebdbf54863c8$export$c2aa7c9492b42e56(props = {}) {
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, recommendedSiteName: recommendedSiteName } = (0, $ff4S3.useSiteActivationContext)();
    const [siteNamePopulated, setSiteNamePopulated] = (0, $1oC0p.useState)();
    const client = (0, $at5jC.useBxpWebStargateClient)();
    const user = (0, $3riD8.useLoggedInUser)();
    const email = user === null || user === void 0 ? void 0 : user.email;
    (0, $1oC0p.useEffect)(()=>{
        if (email) client.getRecommendedSiteName({
            email: email
        }).then((result)=>setSiteNameValue(result.recommendedName)).catch(props.onError);
    }, [
        client,
        email,
        props.onError,
        setSiteNameValue
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (siteNamePopulated) // take no action because site name was already changed via either user interaction or site-name recommendation
        return;
        if (siteName) // user has already started typing, let's not overwrite their input with a recommended site name
        setSiteNamePopulated(true);
        else if (recommendedSiteName) {
            setSiteNameValue(recommendedSiteName);
            setSiteNamePopulated(true);
        }
    }, [
        siteNamePopulated,
        recommendedSiteName,
        siteName,
        setSiteNameValue
    ]);
}

});
parcelRegister("ff4S3", function(module, exports) {
$parcel$export(module.exports, "useSiteActivationContext", function () { return $d9523cfc95d5074c$export$48473054405e7add; });
$parcel$export(module.exports, "SiteActivationContextProvider", function () { return $d9523cfc95d5074c$export$e1087d57f38afae1; });
//TO DO: in the next PR refactor and test this context

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $8e22h = parcelRequire("8e22h");

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");

var $k9ZIM = parcelRequire("k9ZIM");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $hgaI1 = parcelRequire("hgaI1");

var $at5jC = parcelRequire("at5jC");

var $kooLp = parcelRequire("kooLp");

var $gx3aw = parcelRequire("gx3aw");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $1ka2O = parcelRequire("1ka2O");

var $6E8lZ = parcelRequire("6E8lZ");

var $amfpH = parcelRequire("amfpH");
const { ABORTED: $d9523cfc95d5074c$var$ABORTED, SUCCEEDED: $d9523cfc95d5074c$var$SUCCEEDED } = (0, $7VwhR.UfoExperienceStatus);
const { PRESS: $d9523cfc95d5074c$var$PRESS, TRANSITION: $d9523cfc95d5074c$var$TRANSITION } = (0, $7VwhR.UfoInteractionType);
const $d9523cfc95d5074c$var$ufoBaseLogs = [
    {
        name: "pkg:site-activation"
    },
    {
        name: "component:siteActivationContextProvider"
    }
];
const $d9523cfc95d5074c$export$fe5d808150ab3415 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $d9523cfc95d5074c$export$48473054405e7add = ()=>{
    const context = (0, $1oC0p.useContext)($d9523cfc95d5074c$export$fe5d808150ab3415);
    if (!context) throw new Error("useSiteActivationContext must be used within a SiteActivationContextProvider");
    return context;
};
async function $d9523cfc95d5074c$var$getHasHighestEditionStrategyWithPaidTargetEdition({ cloudId: cloudId, productKey: productKey, stargateClient: stargateClient, signupSource: signupSource, createAnalyticsEvent: createAnalyticsEvent }) {
    if (!cloudId || !productKey || signupSource === "pricing" || ![
        (0, $7VwhR.ProductKey).CONFLUENCE,
        (0, $7VwhR.ProductKey).JIRA_SOFTWARE,
        (0, $7VwhR.ProductKey).JIRA_PRODUCT_DISCOVERY,
        (0, $7VwhR.ProductKey).JIRA_SERVICE_DESK,
        (0, $7VwhR.ProductKey).SERVICE_COLLECTION
    ].includes(productKey) || !(0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacRedirectEditionParityKillSwitch)) return false;
    try {
        var _activateProductCrossflowPlanResult_tasks_find, _activateProductCrossflowPlanResult_tasks, _activatePlanTaskContext_edition;
        (0, $7VwhR.trackCrossFlowActivationPlanFetched)({
            createAnalyticsEvent: createAnalyticsEvent,
            cloudId: cloudId,
            productKey: productKey
        });
        const activateProductCrossflowPlanResult = await stargateClient.activateProductCrossflowPlan({
            cloudId: cloudId,
            productKey: productKey,
            jobName: (0, $at5jC.JobName).WAC_SIGNUP,
            context: {
                sourceComponent: "redirect",
                sourceContext: "start",
                originProduct: "wac"
            }
        });
        const activatePlanTaskContext = activateProductCrossflowPlanResult === null || activateProductCrossflowPlanResult === void 0 ? void 0 : (_activateProductCrossflowPlanResult_tasks = activateProductCrossflowPlanResult.tasks) === null || _activateProductCrossflowPlanResult_tasks === void 0 ? void 0 : (_activateProductCrossflowPlanResult_tasks_find = _activateProductCrossflowPlanResult_tasks.find((task)=>(task === null || task === void 0 ? void 0 : task.name) === "activate")) === null || _activateProductCrossflowPlanResult_tasks_find === void 0 ? void 0 : _activateProductCrossflowPlanResult_tasks_find.context;
        return (activatePlanTaskContext === null || activatePlanTaskContext === void 0 ? void 0 : activatePlanTaskContext["editionStrategy"]) === "highest" && (activatePlanTaskContext === null || activatePlanTaskContext === void 0 ? void 0 : (_activatePlanTaskContext_edition = activatePlanTaskContext["edition"]) === null || _activatePlanTaskContext_edition === void 0 ? void 0 : _activatePlanTaskContext_edition["id"]) !== "free";
    } catch (error) {
        (0, $7VwhR.trackCrossFlowActivationPlanFailed)({
            createAnalyticsEvent: createAnalyticsEvent,
            cloudId: cloudId,
            productKey: productKey,
            error: error
        });
        return false;
    }
}
async function $d9523cfc95d5074c$var$onUpdateDropdownSelection({ cloudId: cloudId, updateStatsigClientWithTenantId: updateStatsigClientWithTenantId }) {
    if (!cloudId || !(0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacRedirectEditionParityKillSwitch)) return;
    await updateStatsigClientWithTenantId({
        cloudId: cloudId
    });
}
const $d9523cfc95d5074c$export$e1087d57f38afae1 = ({ children: children, existingSites: existingSites, useContactExpandCohortLogic: useContactExpandCohortLogic })=>{
    var _transactionAccounts_, _profile_cohorts, _location_pathname;
    //HOOKS
    const intl = (0, $8e22h.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const { profile: profile, user: user, product: product, edition: originalEdition = "free", transactionAccounts: transactionAccounts } = (0, $doAVE.useUserContext)();
    /**
   * Rovo Dev (aka DEVAI) is a special case, it only has a single
   * edition, standard. There is an outstanding DACI:
   * https://hello.atlassian.net/wiki/spaces/uts/pages/5807772710/Rovo+Dev+Everywhere+SKU+DACI
   * If/when this DACI is resolved and Rovo Dev supports the free
   * edition, this special case can then be removed.
   */ let edition = originalEdition;
    if ((product === null || product === void 0 ? void 0 : product.key) === (0, $7VwhR.ProductKey).DEVAI) edition = "standard";
    const { companyType: companyType, domainType: domainType, userType: userType } = (profile === null || profile === void 0 ? void 0 : profile.cohorts) || {};
    const cohort = (0, $doAVE.useCohort)(useContactExpandCohortLogic);
    const expandableSites = (0, $doAVE.useCrossflowEligibleSites)();
    const upgradableSites = (0, $doAVE.useUpgradableSites)();
    const stargateClient = (0, $at5jC.useBxpWebStargateClient)();
    const updateStatsigClientWithTenantId = (0, $hgaI1.useUpdateFeatureGatesClientWithTenantId)();
    const location = (0, $1ka2O.useLocation)();
    const sites = (0, $1oC0p.useMemo)(()=>{
        var _ref;
        return (_ref = existingSites !== null && existingSites !== void 0 ? existingSites : cohort === (0, $doAVE.COHORTS).UPGRADE_ELIGIBLE_USER ? upgradableSites : expandableSites) !== null && _ref !== void 0 ? _ref : [];
    }, [
        cohort,
        expandableSites,
        upgradableSites,
        existingSites
    ]);
    const isWorkspaceProduct = (0, $1oC0p.useMemo)(()=>!!(product === null || product === void 0 ? void 0 : product.key) && [
            (0, $7VwhR.ProductKey).CONFLUENCE,
            (0, $7VwhR.ProductKey).TEAMWORK_COLLECTION,
            (0, $7VwhR.ProductKey).SERVICE_COLLECTION
        ].includes(product === null || product === void 0 ? void 0 : product.key), [
        product === null || product === void 0 ? void 0 : product.key
    ]);
    //STATE
    const [showSitePicker, setShowSitePicker] = (0, $1oC0p.useState)(sites.length > 0);
    const [siteNameValid, setSiteNameValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [sitePickerValue, setSitePickerValue] = (0, $1oC0p.useState)(sites[0]);
    const onUpdateDropdownSelectionPromise = (0, $1oC0p.useRef)($d9523cfc95d5074c$var$onUpdateDropdownSelection({
        cloudId: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.cloudId,
        updateStatsigClientWithTenantId: updateStatsigClientWithTenantId
    }));
    const setSitePickerValueWithAdditionalCall = (0, $1oC0p.useCallback)((value)=>{
        onUpdateDropdownSelectionPromise.current = $d9523cfc95d5074c$var$onUpdateDropdownSelection({
            cloudId: value === null || value === void 0 ? void 0 : value.cloudId,
            updateStatsigClientWithTenantId: updateStatsigClientWithTenantId
        });
        setSitePickerValue(value);
    }, [
        updateStatsigClientWithTenantId
    ]);
    const [siteName, setSiteNameValue] = (0, $1oC0p.useState)("");
    const [recommendedSiteName] = (0, $1oC0p.useState)("");
    var _transactionAccounts__id;
    const [selectedTransactionAccountId, setSelectedTransactionAccountId] = (0, $1oC0p.useState)((_transactionAccounts__id = (_transactionAccounts_ = transactionAccounts[0]) === null || _transactionAccounts_ === void 0 ? void 0 : _transactionAccounts_.id) !== null && _transactionAccounts__id !== void 0 ? _transactionAccounts__id : "");
    const [recaptchaFailedToLoad, setRecaptchFailedToLoad] = (0, $1oC0p.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $1oC0p.useState)(60);
    const [validatationMessage, setValidationMessage] = (0, $1oC0p.useState)();
    const [paymentDetailsView, setPaymentDetailsView] = (0, $1oC0p.useState)({
        view: "site-setup"
    });
    //VARIABLES
    const searchParameters = new URLSearchParams(location.search);
    var _searchParameters_get;
    const platform = (_searchParameters_get = searchParameters.get("platform")) !== null && _searchParameters_get !== void 0 ? _searchParameters_get : "routing";
    const primaryCollectionProduct = searchParameters.get("primaryCollectionProduct");
    const localizedContactUrl = (0, $kooLp.useLocalizedHref)("/company/contact");
    const isNewUser = ((_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.userType) === "new-user";
    const productKey = product === null || product === void 0 ? void 0 : product.key;
    const { isValid: isValid, isValidating: isValidating, error: error } = (0, $6E8lZ.useSiteNameValidation)(siteName, setSiteNameValid);
    const isEmbedded = !((_location_pathname = location.pathname) === null || _location_pathname === void 0 ? void 0 : _location_pathname.endsWith("/try/cloud/signup"));
    const dataFoundationsActionSubjectId = isEmbedded ? "embedded" : "standalone";
    const showRecaptchaFormError = (0, $1oC0p.useCallback)(()=>{
        const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "n/a");
        setValidationMessage((0, $dPABA._)((0, $6ogO3._)({}, (0, $amfpH.messages).timeout), {
            values: {
                // eslint-disable-next-line react/no-unstable-nested-components
                "href-support": (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        href: localizedContactUrl,
                        children: node
                    }),
                "error_id": `Anonymous ID: ${anonymousId}`
            }
        }));
        // Reset form to allow re-submit
        setIsSubmitting(false);
        setHasSubmitted(false);
    }, [
        localizedContactUrl
    ]);
    const activateSiteHandler = (0, $1oC0p.useCallback)(async (signupId, privacyPolicy)=>{
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setRecaptchFailedToLoad(true);
            return;
        }
        setRecaptchFailedToLoad(false);
        const localeData = await stargateClient.getConsentConfig();
        const testingPurposes = (0, $7VwhR.isTestTenantByName)(siteName);
        const signupContext = (0, $7VwhR.getSignupContext)({
            productKey: productKey,
            testingPurposes: testingPurposes,
            signupId: signupId,
            search: location.search
        });
        const MAX_SIGNUP_CONTEXT_LENGTH = 8192;
        let signupContextString = JSON.stringify(signupContext);
        if (signupContextString.length > MAX_SIGNUP_CONTEXT_LENGTH) signupContextString = "{}";
        const ccpProducts = (0, $7VwhR.mapProductKeyAndEditionToCcpProduct)({
            productKey: productKey,
            edition: edition
        });
        // service collections with a primaryCollectionProduct prioritize that product first
        const childProductsForPriorityActivation = productKey === (0, $7VwhR.ProductKey).SERVICE_COLLECTION && primaryCollectionProduct ? [
            primaryCollectionProduct
        ] : [];
        const gRecaptchaResponse = await (0, $7VwhR.getRecaptcha)(user.email || "", executeRecaptcha);
        (0, $7VwhR.ufoEventNewSiteN2NSubmit).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "SiteActivationProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $7VwhR.trackRecaptchaFailure)(createAnalyticsEvent, "site-activation");
            showRecaptchaFormError();
            return;
        }
        // Set experiment metadata before starting UFO event for GraphQL webhook setup
        (0, $7VwhR.ufoEventGraphQLWebhookSetup).setCustomData({
            webPlatform: "site-activation"
        });
        var _localeData_locale;
        // get consents
        const consent = (0, $7VwhR.getConsents)((_localeData_locale = localeData.locale) !== null && _localeData_locale !== void 0 ? _localeData_locale : "US-VA", localeData.localeRequiresMarketingCommunicationOptIn, privacyPolicy);
        const response = await stargateClient.activateProduct({
            displayName: user.name,
            email: user.email || "",
            ccpProducts: [
                ccpProducts
            ],
            childProductsForPriorityActivation: childProductsForPriorityActivation,
            siteName: siteName,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            useCcpPlatform: platform === "ccp",
            consent: consent,
            platform: platform,
            signupContext: signupContextString,
            isNewUser: productKey === (0, $7VwhR.ProductKey).JIRA_SOFTWARE || isNewUser,
            gRecaptchaResponse: gRecaptchaResponse,
            testingPurposes: testingPurposes,
            signupId: signupId,
            transactionAccountId: selectedTransactionAccountId
        });
        const redirectUrl = (0, $7VwhR.getConfirmationPageUrl)({
            locale: intl.locale,
            productKey: productKey,
            response: response,
            siteName: siteName,
            signupId: signupId,
            edition: edition,
            primaryCollectionProduct: primaryCollectionProduct
        });
        window.location.assign(redirectUrl);
    }, [
        executeRecaptcha,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        stargateClient,
        siteName,
        primaryCollectionProduct,
        location.search,
        productKey,
        edition,
        user,
        platform,
        isNewUser,
        intl.locale,
        createAnalyticsEvent,
        selectedTransactionAccountId
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (profile.requestInProgress || !analyticsClient) return;
        (0, $7VwhR.trackSiteActivationViewed)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            cohort: cohort,
            productKey: productKey,
            edition: edition,
            userType: userType,
            domainType: domainType,
            companyType: companyType,
            numTxas: transactionAccounts.length
        });
    }, [
        analyticsClient,
        cohort,
        createAnalyticsEvent,
        companyType,
        dataFoundationsActionSubjectId,
        domainType,
        edition,
        productKey,
        profile.requestInProgress,
        userType,
        transactionAccounts.length
    ]);
    (0, $1oC0p.useEffect)(()=>{
        const ufoSubmitEvent = showSitePicker ? (0, $7VwhR.ufoEventExistingSiteN2ESubmit) : (0, $7VwhR.ufoEventNewSiteN2NSubmit);
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) ufoSubmitEvent.failure({
            customData: {
                reactComponent: "SiteActivationContextProvider",
                analyticsEvent: "errored",
                recaptchaRetryTimeRemainingSecond: 0,
                siteType: showSitePicker ? "existing-site" : "new-site"
            },
            error: new Error("Recaptcha retry failed")
        });
        if (recaptchaFailedToLoad) activateSiteHandler().then(()=>{
            ufoSubmitEvent.success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            showRecaptchaFormError();
            ufoSubmitEvent.failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: showSitePicker ? "existing-site" : "new-site",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        });
    }, [
        activateSiteHandler,
        executeRecaptcha,
        localizedContactUrl,
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond,
        showRecaptchaFormError,
        showSitePicker
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const activateSite = async ({ privacyPolicy: privacyPolicy })=>{
        var _profile_cohorts;
        setHasSubmitted(true);
        sessionStorage.setItem("provisioningStartTime", `${Date.now()}`);
        // Start UFOs to begin duration metrics for signup submit
        (0, $7VwhR.ufoEventNewSiteN2NSubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        (0, $7VwhR.ufoEventExistingSiteN2ESubmit).start({
            productKey: productKey,
            webPlatform: "site-activation"
        });
        const ufoLogs = [
            ...$d9523cfc95d5074c$var$ufoBaseLogs,
            {
                name: "method:activateSite"
            }
        ];
        // user must be logged in
        if (!user.isUserLoggedIn) return;
        // Generate a signup ID and add it to all the events in this flow.
        // This id is used to stitch together a view of the end-to-end
        // provisioning experience, all the way to landing in product.
        const signupId = (0, $fuLgT.default)();
        const isN2N = !showSitePicker && !sitePickerValue;
        const domainType = profile === null || profile === void 0 ? void 0 : (_profile_cohorts = profile.cohorts) === null || _profile_cohorts === void 0 ? void 0 : _profile_cohorts.domainType;
        (0, $7VwhR.trackSignupStarted)(createAnalyticsEvent, signupId, productKey, edition, isN2N, domainType);
        // handle site picker submit
        if (showSitePicker) {
            if (sitePickerValue) {
                const upgradableProduct = sitePickerValue.products.find((product)=>[
                        product.productKey,
                        product.partOfCollection
                    ].includes(productKey) && product.productEdition === "free");
                // checking the same eligibility cohort as `twcg907Astro540WacUpgradeS2p` experiment
                const hasUpgradableStandardProduct = edition === "premium" && [
                    (0, $7VwhR.ProductKey).JIRA_SOFTWARE,
                    (0, $7VwhR.ProductKey).CONFLUENCE,
                    (0, $7VwhR.ProductKey).JIRA_PRODUCT_DISCOVERY
                ].includes(productKey) && sitePickerValue.products.some((product)=>[
                        product.productKey
                    ].includes(productKey) && product.productEdition === "standard");
                if (upgradableProduct || hasUpgradableStandardProduct) {
                    var _sitePickerValue_products_;
                    // send to adminhub
                    const redirectUrl = await (0, $7VwhR.getAdminHubUpgradeProductUrl)(sitePickerValue, productKey, edition);
                    createAnalyticsEvent({
                        eventName: "signupUpgrade",
                        eventComponent: "button",
                        billingSystem: (_sitePickerValue_products_ = sitePickerValue.products[0]) === null || _sitePickerValue_products_ === void 0 ? void 0 : _sitePickerValue_products_.billingSourceSystem,
                        cloudId: sitePickerValue.cloudId,
                        event: "clicked",
                        eventType: "ui",
                        action: "upgrade"
                    }).fire("signup");
                    window.location.assign(redirectUrl);
                    return;
                }
                try {
                    // Check for Shadow IT authorization.
                    await stargateClient.getActivationAuthorization({
                        productKeys: [
                            productKey
                        ],
                        productEdition: edition,
                        cloudId: sitePickerValue.cloudId,
                        siteName: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.displayName
                    });
                    // ensure that the tenantId has been added to statsig client by this point
                    await onUpdateDropdownSelectionPromise.current;
                    const searchParameters = new URLSearchParams(window.location.search);
                    const signupSource = searchParameters.get("signupSource");
                    // fetch /plans endpoint once user has clicked
                    const hasHighestEditionStrategyWithPaidTargetEdition = await $d9523cfc95d5074c$var$getHasHighestEditionStrategyWithPaidTargetEdition({
                        cloudId: sitePickerValue.cloudId,
                        productKey: productKey,
                        stargateClient: stargateClient,
                        signupSource: signupSource,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                    const crossFlowActivationUrl = (0, $7VwhR.getCrossFlowActivationUrl)({
                        cloudId: sitePickerValue.cloudId,
                        edition: edition,
                        productKey: primaryCollectionProduct !== null && primaryCollectionProduct !== void 0 ? primaryCollectionProduct : productKey,
                        siteName: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.displayName,
                        hasHighestEditionStrategyWithPaidTargetEdition: hasHighestEditionStrategyWithPaidTargetEdition,
                        shouldApplyWacRedirectEditionParityExperiment: ()=>{
                            // get experiment and fire statsig exposure
                            const experiment = (0, $ea4mV.getExperimentWithExposures)((0, $ea4mV.experiments).wacRedirectEditionParityAB);
                            if (experiment.type === "enrolled") // fire GasV3 exposure if enrolled
                            (0, $ea4mV.fireTrackingEvents)((0, $ea4mV.experiments).wacRedirectEditionParityAB.experimentName, analyticsClient, createAnalyticsEvent, {
                                cloudId: sitePickerValue === null || sitePickerValue === void 0 ? void 0 : sitePickerValue.cloudId
                            }, experiment.value);
                            return experiment.type === "enrolled" && experiment.value === "variation";
                        }
                    });
                    (0, $7VwhR.ufoEventExistingSiteN2ESubmit).success({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "succeeded",
                            siteType: "existing-site"
                        }
                    });
                    (0, $7VwhR.trackSitePickerSubmit)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        targetCloudId: sitePickerValue.cloudId,
                        provisionedProducts: [
                            {
                                product: productKey,
                                edition: edition
                            }
                        ],
                        signupUrl: crossFlowActivationUrl,
                        aaid: user.accountId,
                        signupSource: signupSource,
                        componentSource: "SiteActivationContextProvider",
                        hasHighestEditionStrategyWithPaidTargetEdition: hasHighestEditionStrategyWithPaidTargetEdition
                    });
                    window.location.assign(crossFlowActivationUrl);
                } catch (error) {
                    (0, $7VwhR.ufoEventExistingSiteN2ESubmit).failure({
                        customData: {
                            reactComponent: "SiteActivationContextProvider",
                            analyticsEvent: "errored",
                            siteType: "existing-site"
                        },
                        error: error
                    });
                    (0, $7VwhR.redirectToAdminHubForShadowIt)(error);
                }
            }
            return;
        }
        if (isValidating) {
            const { availability: availability } = await stargateClient.checkCloudNameAvailability({
                cloudName: siteName
            });
            if (availability !== "AVAILABLE") {
                setHasSubmitted(false); // reset to allow re-submit
                return;
            }
            setSiteNameValid(true);
        }
        if (!siteNameValid && !isValidating || !siteName) {
            setHasSubmitted(false); // reset to allow re-submit
            return;
        }
        (0, $7VwhR.trackSubmitSuccess)(createAnalyticsEvent);
        if (siteName !== recommendedSiteName) (0, $7VwhR.trackSiteNameChangedFromRecommendedSiteName)(createAnalyticsEvent, siteName, recommendedSiteName);
        let setTimeoutId;
        const interactionId = (0, $fuLgT.default)();
        (0, $7VwhR.operateWithSignupUFOLogging)({
            interactionId: interactionId,
            interactionName: "try-cloud-signup_form-submit",
            type: "press",
            timeout: 120000,
            labelStack: [
                {
                    name: "uip"
                }
            ],
            errorContext: "error occured on signup form submit button"
        }, async ()=>Promise.race([
                new Promise((_resolve, reject)=>{
                    setTimeoutId = setTimeout(()=>{
                        reject((0, $7VwhR.SignupUFOLoggingActionTimeoutError));
                    }, 60000);
                }),
                activateSiteHandler(signupId, privacyPolicy).finally(()=>{
                    if (setTimeoutId) clearTimeout(setTimeoutId);
                })
            ])).then(()=>{
            // SLO "good event" for N2N signup submit
            (0, $7VwhR.ufoEventNewSiteN2NSubmit).success({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "succeeded",
                    siteType: "new-site"
                }
            });
            (0, $7VwhR.trackAndCompleteUFOEvent)({
                experienceName: (0, $7VwhR.UfoEventName).ACTIVATE_PRODUCT_API_SUCCESS,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$TRANSITION,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured on bxp-ui only
            (0, $7VwhR.trackAndCompleteUFOEvent)({
                experienceName: (0, $7VwhR.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "good event" for signup submit captured across bxp-ui and bxpkit
            (0, $7VwhR.trackAndCompleteUFOEvent)({
                experienceName: (0, $7VwhR.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED,
                experienceStatus: $d9523cfc95d5074c$var$SUCCEEDED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                ufoLogger: ufoLogs
            });
        }).catch((error)=>{
            var _error_response, _error_response_headers, _error_response1;
            // Show add-payment-method page if Rovo Dev 403 (user clicks "Open payment methods" to open in new tab)
            if (productKey === (0, $7VwhR.ProductKey).DEVAI && (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 403) {
                const adminPaymentLink = (0, $7VwhR.getAdminPaymentLink)(error);
                if (adminPaymentLink) {
                    setIsSubmitting(false);
                    setHasSubmitted(false);
                    setPaymentDetailsView({
                        view: "payment-required",
                        adminPaymentLink: adminPaymentLink
                    });
                    return;
                }
            }
            // SLO "bad event" for N2N signup submit
            (0, $7VwhR.ufoEventNewSiteN2NSubmit).failure({
                customData: {
                    reactComponent: "SiteActivationContextProvider",
                    analyticsEvent: "errored",
                    siteType: "new-site"
                },
                error: error
            });
            (0, $7VwhR.redirectToAdminHubForShadowIt)(error);
            const traceId = error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_headers = _error_response1.headers) === null || _error_response_headers === void 0 ? void 0 : _error_response_headers.get("atl-traceid");
            setValidationMessage((0, $dPABA._)((0, $6ogO3._)({}, (0, $amfpH.messages).timeout), {
                values: {
                    // eslint-disable-next-line react/no-unstable-nested-components
                    "href-support": (node)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: localizedContactUrl,
                            children: node
                        }),
                    "error_id": traceId ? `Trace ID: ${traceId}` : `Interaction ID: ${interactionId}`
                }
            }));
            // don't re-enable the form when there is an HTTP exception. this helps with rate-limiting
            const errorType = (0, $7VwhR.SignupGetUFOErrorType)(error);
            if (errorType !== "http_exception") {
                // Reset form to allow re-submit
                setIsSubmitting(false);
                setHasSubmitted(false);
            }
            (0, $7VwhR.trackAndCompleteUFOEvent)({
                experienceName: (0, $7VwhR.UfoEventName).ACTIVATE_PRODUCT_API_ERROR,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$TRANSITION,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured on bxp-ui only
            (0, $7VwhR.trackAndCompleteUFOEvent)({
                experienceName: (0, $7VwhR.UfoEventName).BXPUI_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
            // Reliabiltiy SLO "bad event" for signup submit captured across bxp-ui and bxpkit
            (0, $7VwhR.trackAndCompleteUFOEvent)({
                experienceName: (0, $7VwhR.UfoEventName).DEFAULT_SIGNUP_SUBMIT_SLO_FAILED,
                experienceStatus: $d9523cfc95d5074c$var$ABORTED,
                interactionType: $d9523cfc95d5074c$var$PRESS,
                error: error,
                errorName: "ActivateProductError",
                errorMessage: "error occured on activateProduct",
                ufoLogger: ufoLogs
            });
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d9523cfc95d5074c$export$fe5d808150ab3415.Provider, {
        value: {
            isSubmitting: isSubmitting,
            activateSite: activateSite,
            showSitePicker: showSitePicker,
            sites: sites,
            isRequestInProgress: profile.requestInProgress,
            email: user.email,
            sitePickerValue: sitePickerValue,
            setSitePickerValue: setSitePickerValueWithAdditionalCall,
            setSiteNameValid: setSiteNameValid,
            siteName: siteName,
            setSiteNameValue: setSiteNameValue,
            setShowSitePicker: setShowSitePicker,
            recommendedSiteName: recommendedSiteName,
            hasSubmitted: hasSubmitted,
            setHasSubmitted: setHasSubmitted,
            validationMessageState: [
                validatationMessage,
                setValidationMessage
            ],
            isValid: isValid,
            isValidating: isValidating,
            error: error,
            isWorkspaceProduct: isWorkspaceProduct,
            selectedTransactionAccountId: selectedTransactionAccountId,
            setSelectedTransactionAccountId: setSelectedTransactionAccountId,
            primaryCollectionProduct: primaryCollectionProduct,
            paymentDetailsView: paymentDetailsView,
            setPaymentDetailsView: setPaymentDetailsView
        },
        children: children
    });
};

});
parcelRegister("amfpH", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $e768825b373a6c77$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $e768825b373a6c77$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    timeout: {
        id: "siteActivation.nameSite.error.timeout",
        defaultMessage: "Something went wrong on our end. Please try again. If this keeps happening, <href-support>contact support</href-support>. (Issue ID for Atlassian use: {error_id})"
    },
    invalidName: {
        id: "siteActivation.nameSite.error.invalidName",
        defaultMessage: "Your site name must be at least 3 characters long. Use only lowercase letters and numbers."
    },
    maxLength: {
        id: "siteActivation.nameSite.error.maxLength",
        defaultMessage: "That's a bit too long \u2014 try something 50 characters or less."
    },
    unavailable: {
        id: "siteActivation.nameSite.error.unavailable",
        defaultMessage: "This site is already taken."
    },
    networkError: {
        id: "siteActivation.nameSite.error.networkError",
        defaultMessage: "Something went wrong. Please try again later."
    }
});

});




parcelRegister("3fEYe", function(module, exports) {
$parcel$export(module.exports, "SiteActivationSwitcher", function () { return $aeae241f769fd6ee$export$336514a242c2c5c0; });

var $7VQPk = parcelRequire("7VQPk");

var $doAVE = parcelRequire("doAVE");
parcelRequire("a7UN5");
var $jgBbG = parcelRequire("jgBbG");
var $jGkoX = parcelRequire("jGkoX");
var $lBvZp = parcelRequire("lBvZp");
var $2HR6E = parcelRequire("2HR6E");
var $3ptXA = parcelRequire("3ptXA");
const $aeae241f769fd6ee$export$336514a242c2c5c0 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}), ManagedUser: ManagedUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jGkoX.ManagedUser), {}), NewUser: NewUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lBvZp.NewUser), {}), WeekOneUser: WeekOneUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3ptXA.WeekOneUser), {}), UpgradeEligibleUser: UpgradeEligibleUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2HR6E.UpgradeEligibleUser), {}), CurrentProductJoinableUser: CurrentProductJoinableUser, CurrentProductUser: CurrentProductUser, UpliftEligibleUser: UpliftEligibleUser, CrossflowEligibleUser: CrossflowEligibleUser, useContactExpandCohortLogic: useContactExpandCohortLogic })=>{
    const cohort = (0, $doAVE.useCohort)(useContactExpandCohortLogic);
    if (cohort === (0, $doAVE.COHORTS).MANAGED_USER && ManagedUser) return ManagedUser;
    if (cohort === (0, $doAVE.COHORTS).WEEK_ONE_USER && WeekOneUser) return WeekOneUser;
    if (cohort === (0, $doAVE.COHORTS).CURRENT_PRODUCT_JOINABLE_USER && CurrentProductJoinableUser) return CurrentProductJoinableUser;
    if (cohort === (0, $doAVE.COHORTS).CURRENT_PRODUCT_USER && CurrentProductUser) return CurrentProductUser;
    if (cohort === (0, $doAVE.COHORTS).NEW_USER && NewUser) return NewUser;
    if (cohort === (0, $doAVE.COHORTS).UPGRADE_ELIGIBLE_USER && UpgradeEligibleUser) return UpgradeEligibleUser;
    if (cohort === (0, $doAVE.COHORTS).UPLIFT_ELIGIBLE_USER && UpliftEligibleUser) return UpliftEligibleUser;
    if (cohort === (0, $doAVE.COHORTS).CROSSFLOW_ELIGIBLE_USER && CrossflowEligibleUser) return CrossflowEligibleUser;
    return ExistingUser;
};

});
parcelRegister("a7UN5", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("fMbfG")).Dropdown; });
$parcel$export(module.exports, "JoinableSites", function () { return (parcelRequire("bGrkd")).JoinableSites; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("bs458")).ReturnToProduct; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("33py5")).SitePicker; });
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("jgBbG")).ExistingUser; });
$parcel$export(module.exports, "ManagedUser", function () { return (parcelRequire("jGkoX")).ManagedUser; });
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lBvZp")).NewUser; });
$parcel$export(module.exports, "WeekOneUser", function () { return (parcelRequire("3ptXA")).WeekOneUser; });
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return (parcelRequire("2HR6E")).UpgradeEligibleUser; });
parcelRequire("biSAQ");
parcelRequire("9fMVX");
parcelRequire("hLU4E");
parcelRequire("bGUHK");
parcelRequire("6RRFZ");
parcelRequire("bmxFk");

});
parcelRegister("biSAQ", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return (parcelRequire("fMbfG")).Dropdown; });
$parcel$export(module.exports, "JoinableSites", function () { return (parcelRequire("bGrkd")).JoinableSites; });
$parcel$export(module.exports, "Label", function () { return (parcelRequire("54KVk")).Label; });
$parcel$export(module.exports, "ReturnToProduct", function () { return (parcelRequire("bs458")).ReturnToProduct; });
$parcel$export(module.exports, "SiteNameInput", function () { return (parcelRequire("eWKFr")).SiteNameInput; });
$parcel$export(module.exports, "SitePicker", function () { return (parcelRequire("33py5")).SitePicker; });
$parcel$export(module.exports, "SiteToggleButton", function () { return (parcelRequire("aw05g")).SiteToggleButton; });
$parcel$export(module.exports, "TermsAndConditions", function () { return (parcelRequire("8PRMc")).TermsAndConditions; });
parcelRequire("fMbfG");
parcelRequire("lJoGY");
parcelRequire("bGrkd");
parcelRequire("54KVk");
parcelRequire("bs458");
parcelRequire("eWKFr");
parcelRequire("33py5");
parcelRequire("aw05g");
parcelRequire("8Mruz");
parcelRequire("8PRMc");

});
parcelRegister("fMbfG", function(module, exports) {
$parcel$export(module.exports, "Dropdown", function () { return $c66d8b790d64bccd$export$931cbfb6bfb85fc; });
/* dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $lAVaU = parcelRequire("lAVaU");

var $7VwhR = parcelRequire("7VwhR");

var $ff4S3 = parcelRequire("ff4S3");
const $c66d8b790d64bccd$export$931cbfb6bfb85fc = ({ sites: sites })=>{
    const { sitePickerValue: sitePickerValue, setSitePickerValue: setSitePickerValue, isSubmitting: isSubmitting, isRequestInProgress: isRequestInProgress, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "adg4-site-picker",
        className: (0, $2jatx.default)([
            "_125x1syg _62vcmccc _17rn1kw7 _1mmsglyw _pqyq183y _84yz183y _tnizyh40 _101oyh40 _9fwgmccc _1700grf3 _156ugrf3 _16z5grf3 _iazigrf3 _1ybr1crf _uy3o19bv"
        ]),
        style: {
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            defaultValue: sites[0],
            isDisabled: isSubmitting,
            id: "site-picker-field",
            name: "site-picker-field",
            testId: "site-picker-field",
            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48p4jg8 _vwz4gktf"
                ]),
                children: isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "siteActivation.yourWorkspace",
                    defaultMessage: "Your workspace"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "WacSignupForm.siteNameN2ELabel",
                    defaultMessage: "Your site"
                })
            }),
            children: (_param)=>{
                var { fieldProps: { id: id } } = _param, rest = (0, $aPnCa._)(_param.fieldProps, [
                    "id"
                ]);
                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lAVaU.default), (0, $dPABA._)((0, $6ogO3._)({}, rest), {
                    inputId: id,
                    options: sites,
                    getOptionLabel: (option)=>option.url.replace("https://", ""),
                    getOptionValue: (option)=>option.cloudId,
                    value: sitePickerValue,
                    onChange: (newValue)=>setSitePickerValue(newValue !== null && newValue !== void 0 ? newValue : sites[0]),
                    isLoading: isRequestInProgress,
                    isSearchable: false,
                    styles: {
                        menu: (base)=>(0, $dPABA._)((0, $6ogO3._)({}, base), {
                                fontSize: (0, $7VwhR.fontSize).md
                            }),
                        container: (base)=>(0, $dPABA._)((0, $6ogO3._)({}, base), {
                                fontFamily: "inherit"
                            }),
                        valueContainer: (base)=>(0, $dPABA._)((0, $6ogO3._)({}, base), {
                                fontSize: (0, $7VwhR.fontSize).md,
                                minHeight: "40px",
                                paddingTop: "8px",
                                paddingRight: "6px",
                                paddingBottom: "8px",
                                paddingLeft: "6px"
                            }),
                        singleValue: (base)=>(0, $dPABA._)((0, $6ogO3._)({}, base), {
                                margin: 0
                            })
                    }
                }));
            }
        })
    });
};
const $c66d8b790d64bccd$var$labelCss = null;
const $c66d8b790d64bccd$var$inputAndLabelStyles = null;

});

parcelRegister("lJoGY", function(module, exports) {
$parcel$export(module.exports, "IsValidOrLoading", function () { return $b4fede7ff554c6cb$export$71ec10810b978f7e; });

var $7VQPk = parcelRequire("7VQPk");

var $78jg9 = parcelRequire("78jg9");

var $iUVnd = parcelRequire("iUVnd");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");
const $b4fede7ff554c6cb$export$71ec10810b978f7e = ({ isValidating: isValidating, siteNameValue: siteNameValue, validationMessage: validationMessage })=>{
    if (siteNameValue === "") return null;
    if (isValidating) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
        size: "small",
        testId: "spinner"
    });
    if (validationMessage) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUVnd))), {
        label: "warning",
        color: (0, $lP7A9.default)("color.icon.danger")
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78jg9))), {
        label: "success",
        color: (0, $lP7A9.default)("color.icon.success")
    });
};

});

parcelRegister("bGrkd", function(module, exports) {
$parcel$export(module.exports, "JoinableSites", function () { return $701300cad08ca63f$export$fa96b097075fdf52; });
/* joinable-sites.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $PE2DD = parcelRequire("PE2DD");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("hQLiM");
var $ff4S3 = parcelRequire("ff4S3");
parcelRequire("9fMVX");
var $jgBbG = parcelRequire("jgBbG");
const $701300cad08ca63f$export$fa96b097075fdf52 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}) })=>{
    var _profile_attributes;
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(false);
    const { product: product, edition: edition, profile: profile } = (0, $doAVE.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const { user: { email: email } } = (0, $doAVE.useUserContext)();
    const { productName: productName } = (0, $7VwhR.getProductData)(product === null || product === void 0 ? void 0 : product.key);
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    let sites = ((_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingProductsFromOrg.filter(({ accessType: accessType })=>[
            (0, $PE2DD.AccessRequestCapability).DIRECT_ACCESS,
            (0, $PE2DD.AccessRequestCapability).REQUEST_ACCESS
        ].includes(accessType)).sort((a, b)=>a.accessType !== b.accessType && a.accessType === (0, $PE2DD.AccessRequestCapability).DIRECT_ACCESS ? -1 : 1)) || [];
    // make sure sites are unique by cloudId (userProfile can return duplicates)
    sites = Array.from(sites.reduce((acc, currentItem)=>{
        if (!acc.has(currentItem.cloudId)) acc.set(currentItem.cloudId, currentItem);
        return acc;
    }, new Map()).values());
    const requestAccess = intl.formatMessage({
        id: "signup.siteActivation.requestAccess",
        defaultMessage: "Request access"
    });
    const join = intl.formatMessage({
        id: "signup.siteActivation.join",
        defaultMessage: "Join"
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$701300cad08ca63f$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "joinableSitesGoToSiteNamingScreen",
                    attributes: {
                        productName: product === null || product === void 0 ? void 0 : product.name,
                        productKey: product === null || product === void 0 ? void 0 : product.key,
                        edition: edition
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "joinableSitesGoToReturnToProductScreen",
            attributes: {
                productName: product === null || product === void 0 ? void 0 : product.name,
                productKey: product === null || product === void 0 ? void 0 : product.key,
                edition: edition
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$701300cad08ca63f$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $701300cad08ca63f$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "return-to-product",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp7vkz _1jop70sv _1bv01wug"
                ]),
                children: sites === null || sites === void 0 ? void 0 : sites.map((site, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                        href: $701300cad08ca63f$var$getProductUrl(site),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: site.accessType === (0, $PE2DD.AccessRequestCapability).REQUEST_ACCESS ? "joinableSitesClickRequestAccessButton" : "joinableSitesClickJoinSiteButton",
                                attributes: {
                                    productName: productName,
                                    productKey: site.productKey,
                                    edition: site.productEdition
                                }
                            }).fire();
                            window.location.assign($701300cad08ca63f$var$getProductUrl(site));
                        },
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                        ]),
                        style: {
                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb7vkz _1reo15vq _18m915vq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: productName
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_syaz1hap _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                        },
                                        children: site.displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_187zmgvx",
                                    modalVisualUpdates && "_1sg8jdj5 _1o7pdlk8 _1wtnftgi"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: site.accessType === (0, $PE2DD.AccessRequestCapability).REQUEST_ACCESS ? requestAccess : join
                                })
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $701300cad08ca63f$var$getProductUrl = ({ productKey: productKey, productUrl: productUrl })=>{
    // jira links should be myjira.atlassian.net/welcome/software
    if (productKey === (0, $7VwhR.ProductKey).JIRA_SOFTWARE) {
        const { origin: origin } = new URL(productUrl);
        productUrl = `${origin}/welcome/software`;
    }
    //send to identity login with continue param
    const joinUrl = new URL("/login", (0, $7VwhR.getIdentityBaseUrl)());
    joinUrl.searchParams.append("continue", productUrl);
    return joinUrl.toString();
};
const $701300cad08ca63f$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l33gnd"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $701300cad08ca63f$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: exitView,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $701300cad08ca63f$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $7VwhR.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $701300cad08ca63f$var$containerCss = null;
const $701300cad08ca63f$var$goToExistingWorkspaceLinkCss = null;
const $701300cad08ca63f$var$goToExistingWorkspaceMessageCss = null;
const $701300cad08ca63f$var$switchAccountSubheader = null;
const $701300cad08ca63f$var$createNewWorkspaceMessageCss = null;
const $701300cad08ca63f$var$createNewWorkspaceLinkCss = null;
const $701300cad08ca63f$var$boxContainerCss = null;
const $701300cad08ca63f$var$siteBoxCss = null;
const $701300cad08ca63f$var$goToProductButtonCss = null;
const $701300cad08ca63f$var$goToProductButtonUpdatedCss = null;
const $701300cad08ca63f$var$bold = null;
const $701300cad08ca63f$var$siteCss = null;
const $701300cad08ca63f$var$siteNameCss = null;
const $701300cad08ca63f$var$emailCss = null;
const $701300cad08ca63f$var$switchAccountLinkCss = null;

});
parcelRegister("9fMVX", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return (parcelRequire("jgBbG")).ExistingUser; });
parcelRequire("jgBbG");

});
parcelRegister("jgBbG", function(module, exports) {
$parcel$export(module.exports, "ExistingUser", function () { return $94f60ca190cbbbec$export$706672462bf25099; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $95d7u = parcelRequire("95d7u");
const $94f60ca190cbbbec$export$706672462bf25099 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $95d7u.Content), (0, $6ogO3._)({}, props));

});
parcelRegister("95d7u", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $636317ea5e3d75f8$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lX14w = parcelRequire("lX14w");

var $2WL8B = parcelRequire("2WL8B");

var $32ng3 = parcelRequire("32ng3");

var $ff4S3 = parcelRequire("ff4S3");
parcelRequire("biSAQ");
var $eWKFr = parcelRequire("eWKFr");
var $33py5 = parcelRequire("33py5");
var $aw05g = parcelRequire("aw05g");
var $8PRMc = parcelRequire("8PRMc");

var $aMZEL = parcelRequire("aMZEL");

var $k3fT0 = parcelRequire("k3fT0");
const $636317ea5e3d75f8$export$7c6e2c02157bb7d2 = ({ SitePicker: SitePicker = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {}), SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aw05g.SiteToggleButton), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy })=>{
    const { showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker, activateSite: activateSite, sites: sites } = (0, $ff4S3.useSiteActivationContext)();
    const transactionSelectorEligible = (0, $2WL8B.useSignupTransactionSelectorCohort)();
    const sitePickerEnabled = sites.length > 0 && SitePicker && SiteToggleButton;
    const defaultTermsAndConditions = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).signupSiteActivationTermsAndConditions);
    if (typeof PrivacyPolicy === "undefined" && defaultTermsAndConditions) PrivacyPolicy = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8PRMc.TermsAndConditions), {});
    // if the site picker is not enabled, let context know it is not showing
    (0, $1oC0p.useEffect)(()=>{
        if (!sitePickerEnabled && showSitePicker) setShowSitePicker(false);
    }, [
        sitePickerEnabled
    ]);
    const activateSiteWithPrivacyPolicy = ()=>{
        var _document_getElementById;
        const privacyPolicy = ((_document_getElementById = document.getElementById("privacy-policy-text")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.innerHTML) || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k3fT0.ExistingSitesSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    // Only show if user is in signup transaction selector cohort and creating a new site
    const showTxaSelector = !showSitePicker && transactionSelectorEligible;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "existing-sites-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            showSitePicker && sitePickerEnabled ? SitePicker : SiteNameInput,
                            sitePickerEnabled && SiteToggleButton
                        ]
                    }),
                    showTxaSelector && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aMZEL.TransactionAccountSelector), {}),
                    SubmitButton,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            }))
    });
};
const $636317ea5e3d75f8$var$containerCss = null;

});
parcelRegister("aMZEL", function(module, exports) {
$parcel$export(module.exports, "TransactionAccountSelector", function () { return $cf45f2a2372e480a$export$24b383d12e62d81f; });
/* transaction-account-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $aTd7T = parcelRequire("aTd7T");

var $lAVaU = parcelRequire("lAVaU");

var $doAVE = parcelRequire("doAVE");

var $kbpa7 = parcelRequire("kbpa7");

var $ff4S3 = parcelRequire("ff4S3");
parcelRequire("biSAQ");
var $54KVk = parcelRequire("54KVk");
const $cf45f2a2372e480a$var$container = null;
const $cf45f2a2372e480a$export$24b383d12e62d81f = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $doAVE.useUserContext)();
    const { isSubmitting: isSubmitting, selectedTransactionAccountId: selectedTransactionAccountId, setSelectedTransactionAccountId: setSelectedTransactionAccountId } = (0, $ff4S3.useSiteActivationContext)();
    const handleSelectionChange = (value)=>{
        if (value) setSelectedTransactionAccountId(value.value);
    };
    const selectedValue = transactionAccounts.find((account)=>account.id === selectedTransactionAccountId);
    const transactionAccountLabel = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "siteActivation.transactionAccountSelectorLabel",
        defaultMessage: "Billing Account"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "transaction-account-select-container",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpyh40"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTd7T.Label), {
                htmlFor: "transaction-account-select",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
                    children: transactionAccountLabel
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lAVaU.default), {
                inputId: "transaction-account-select",
                options: transactionAccounts.map((transactionAccount)=>({
                        label: transactionAccount.number,
                        value: transactionAccount.id
                    })),
                value: selectedValue ? {
                    label: selectedValue.number,
                    value: selectedValue.id
                } : null,
                onChange: handleSelectionChange,
                isDisabled: isSubmitting,
                isRequired: true,
                styles: {
                    control: (rest)=>(0, $dPABA._)((0, $6ogO3._)({}, rest), {
                            borderRadius: "21px",
                            fontFamily: (0, $kbpa7.wacToken)("font.charlie.text"),
                            fontSize: "1rem",
                            padding: "0px 6px"
                        })
                }
            })
        ]
    });
};

});

parcelRegister("k3fT0", function(module, exports) {
$parcel$export(module.exports, "ExistingSitesSubmitButton", function () { return $01476f5b75cbd817$export$795867072991ebfa; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $01476f5b75cbd817$export$795867072991ebfa = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});
parcelRegister("8Mruz", function(module, exports) {
$parcel$export(module.exports, "SubmitButton", function () { return $b3ffdc0cbf384296$export$8b7b7cdfb85d78c5; });
/* submit-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $32ng3 = parcelRequire("32ng3");

var $ff4S3 = parcelRequire("ff4S3");
const $b3ffdc0cbf384296$export$8b7b7cdfb85d78c5 = ({ submitMessage: submitMessage })=>{
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted } = (0, $ff4S3.useSiteActivationContext)();
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    if (modalVisualUpdates) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted,
        isLoading: isSubmitting || hasSubmitted,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: submitMessage
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_14hp1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
            isDisabled: isSubmitting || hasSubmitted,
            isLoading: isSubmitting || hasSubmitted,
            type: "submit",
            dataEventProps: {
                "data-product-key": "jira",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "siteName",
                "data-label": "continue-or-agree",
                "data-label-english": submitMessage,
                "data-track-event": "jira-site-name.site-name-form.atlas-66195.site-name"
            },
            children: submitMessage
        })
    });
};
const $b3ffdc0cbf384296$var$buttonCss = null;
const $b3ffdc0cbf384296$var$buttonStyles = null;

});






parcelRegister("54KVk", function(module, exports) {
$parcel$export(module.exports, "Label", function () { return $08e560f13c474cc2$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $08e560f13c474cc2$var$labelCss = null;
const $08e560f13c474cc2$export$b04be29aa201d4f5 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _k48p4jg8 _vwz4gktf"
        ]),
        children: children
    });
};

});

parcelRegister("bs458", function(module, exports) {
$parcel$export(module.exports, "ReturnToProduct", function () { return $7a9446a5ace995a8$export$1cac7f8e3baae627; });
/* return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $1ka2O = parcelRequire("1ka2O");
parcelRequire("hQLiM");
var $ff4S3 = parcelRequire("ff4S3");
parcelRequire("9fMVX");
var $jgBbG = parcelRequire("jgBbG");
const $7a9446a5ace995a8$export$1cac7f8e3baae627 = ({ ExistingUser: ExistingUser = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}), sites: sites })=>{
    const location = (0, $1ka2O.useLocation)();
    const createNewWorkspace = (0, $1oC0p.useMemo)(()=>{
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("createNew") === "true";
    }, [
        location.search
    ]);
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(createNewWorkspace);
    const { product: product } = (0, $doAVE.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const sitesWithCurrentProduct = (0, $doAVE.useSitesWithCurrentProduct)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const { user: { email: email } } = (0, $doAVE.useUserContext)();
    const { productName: productName } = (0, $7VwhR.getProductData)(product === null || product === void 0 ? void 0 : product.key);
    if (sites === undefined) sites = sitesWithCurrentProduct;
    const goToProductButtonText = isWorkspaceProduct ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>$7a9446a5ace995a8$var$createNewWorkspaceMessageLink(str, ()=>{
                setShowSiteNaming(true);
                createAnalyticsEvent({
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "contactExpandGoToSiteNamingScreen",
                    attributes: {
                        productName: product === null || product === void 0 ? void 0 : product.name
                    }
                }).fire();
            })
    };
    const createNewWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$7a9446a5ace995a8$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = isWorkspaceProduct ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            ExistingUser,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulpzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $7a9446a5ace995a8$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "return-to-product",
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulp7vkz _1jop70sv _1bv01wug"
                        ]),
                        children: sites === null || sites === void 0 ? void 0 : sites.map((site, index)=>{
                            var _product_key;
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                href: $7a9446a5ace995a8$var$getProductUrl({
                                    url: site.url,
                                    productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                }),
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for event to fire
                                    createAnalyticsEvent({
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "contactExpandClickReturnToProductButton",
                                        attributes: {
                                            productName: productName
                                        }
                                    }).fire();
                                    var _product_key;
                                    window.location.assign($7a9446a5ace995a8$var$getProductUrl({
                                        url: site.url,
                                        productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                    }));
                                },
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _zulp19bv _yv0e1ghl _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                                ]),
                                style: {
                                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb7vkz _1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: productName
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz1hap _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                                ]),
                                                style: {
                                                    "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                                },
                                                children: site.displayName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_p12fmgvx"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                            variant: "primary",
                                            size: "small",
                                            color: "blue",
                                            children: goToProductButtonText
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $7a9446a5ace995a8$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l33gnd"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $7a9446a5ace995a8$var$createNewWorkspaceMessageLink = (str, exitView)=>/*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: exitView,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wybjdj5 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $7a9446a5ace995a8$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $7VwhR.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $7a9446a5ace995a8$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $7VwhR.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $7VwhR.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $7a9446a5ace995a8$var$containerCss = null;
const $7a9446a5ace995a8$var$goToExistingWorkspaceLinkCss = null;
const $7a9446a5ace995a8$var$goToExistingWorkspaceMessageCss = null;
const $7a9446a5ace995a8$var$switchAccountSubheader = null;
const $7a9446a5ace995a8$var$contentCss = null;
const $7a9446a5ace995a8$var$createNewWorkspaceMessageCss = null;
const $7a9446a5ace995a8$var$createNewWorkspaceLinkCss = null;
const $7a9446a5ace995a8$var$boxContainerCss = null;
const $7a9446a5ace995a8$var$siteBoxCss = null;
const $7a9446a5ace995a8$var$goToProductButtonCss = null;
const $7a9446a5ace995a8$var$bold = null;
const $7a9446a5ace995a8$var$siteCss = null;
const $7a9446a5ace995a8$var$siteNameCss = null;
const $7a9446a5ace995a8$var$emailCss = null;
const $7a9446a5ace995a8$var$switchAccountLinkCss = null;

});

parcelRegister("eWKFr", function(module, exports) {
$parcel$export(module.exports, "SiteNameInput", function () { return $69669b99c9d478dc$export$42a3d109cf521241; });
/* site-name-input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $6E8lZ = parcelRequire("6E8lZ");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");

var $lbA31 = parcelRequire("lbA31");

var $ff4S3 = parcelRequire("ff4S3");

var $amfpH = parcelRequire("amfpH");

var $lJoGY = parcelRequire("lJoGY");

var $54KVk = parcelRequire("54KVk");
const $69669b99c9d478dc$export$42a3d109cf521241 = ({ inputLabel: inputLabel })=>{
    (0, $lbA31.useRecommendedSiteName)({
        onError: console.error
    }); // onError catches errors from endpoint
    const { siteName: siteName, setSiteNameValue: setSiteNameValue, isSubmitting: isSubmitting, validationMessageState: [validationMessage, setValidationMessage], isValid: isValid, isValidating: isValidating, error: error, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const siteNameAddressSuffix = (0, $7VwhR.isProduction)() ? ".atlassian.net" : ".jira-dev.com";
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    (0, $1oC0p.useEffect)(()=>{
        switch(error){
            case (0, $6E8lZ.ErrorType).NO_ERROR:
                setValidationMessage(undefined);
                break;
            case (0, $6E8lZ.ErrorType).INVALID_NAME:
                setValidationMessage((0, $amfpH.messages).invalidName);
                break;
            case (0, $6E8lZ.ErrorType).MAXIMUM_LENGTH:
                setValidationMessage((0, $amfpH.messages).maxLength);
                break;
            case (0, $6E8lZ.ErrorType).UNAVAILABLE:
                setValidationMessage((0, $amfpH.messages).unavailable);
                break;
            case (0, $6E8lZ.ErrorType).NETWORK_ERROR:
                setValidationMessage((0, $amfpH.messages).networkError);
                break;
        }
    }, [
        error,
        setValidationMessage
    ]);
    const label = (inputLabel !== null && inputLabel !== void 0 ? inputLabel : isWorkspaceProduct) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "siteActivation.yourWorkspace",
        defaultMessage: "Your workspace"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "accountActivation.nameSite.inputSiteNameLabel",
        defaultMessage: "Your site"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "adg4-site-name-input",
        className: (0, $2jatx.default)([
            "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _17rn1kw7 _lsdidlk8 _1ilx1nn1 _lonvgktf",
            !modalVisualUpdates && "_mo2i1hlo"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_8xzq121t _1rwq121t _r64ckb7n _1ljbkb7n _17eaf1ug _1heu1kw7 _125x1j6v _5hv91wug _1d6jidpf _1mmsglyw"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                "aria-required": true,
                isDisabled: isSubmitting,
                name: "site-name",
                label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
                    children: label
                }),
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            isValid && "_1lo6qn1y",
                            validationMessage !== undefined && "_1lo61wfy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({
                                type: "text",
                                autoComplete: "on",
                                testId: "site-name-input"
                            }, fieldProps), {
                                value: siteName,
                                onChange: (e)=>{
                                    setSiteNameValue(e.currentTarget.value);
                                    fieldProps.onChange(e);
                                },
                                "aria-describedby": validationMessage ? "site-name-error" : undefined,
                                elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_4cvr1h6o _syaztqnc _1e0c1txw _1wyb1j6v _k48p1nn1 _1bahesu3 _y4tiftgi _1bsb1wug"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                            className: (0, $2jatx.default)([
                                                "_bfhku67f _1wyb8oy7 _y4tiftgi _o5721q9c"
                                            ]),
                                            style: {
                                                "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
                                            },
                                            children: siteNameAddressSuffix
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJoGY.IsValidOrLoading), {
                                            isValidating: isValidating,
                                            siteNameValue: siteName,
                                            validationMessage: validationMessage
                                        })
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                id: "site-name-error",
                                role: "alert",
                                className: (0, $2jatx.default)([
                                    "_syaz1tmw _1wyboqnp _43ds17la _59381r31 _yha28stv _1nmznqa1",
                                    validationMessage && "_1pfhi2wt"
                                ]),
                                style: {
                                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                },
                                children: validationMessage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, validationMessage))
                            })
                        ]
                    })
            })
        })
    });
};
const $69669b99c9d478dc$var$inputInvalidCss = null;
const $69669b99c9d478dc$var$inputValidCss = null;
const $69669b99c9d478dc$var$fieldWrapperCss = null;
const $69669b99c9d478dc$var$siteNameAfterLabelCss = null;
const $69669b99c9d478dc$var$siteNameAfterCss = null;
const $69669b99c9d478dc$var$siteNameErrorCss = null;
const $69669b99c9d478dc$var$siteNameErrorVisibleCss = null;
const $69669b99c9d478dc$var$inputAndLabelStyles = null;
const $69669b99c9d478dc$var$blackLabelCss = null;

});

parcelRegister("33py5", function(module, exports) {
$parcel$export(module.exports, "SitePicker", function () { return $b5507a35ec5b9046$export$7793ee10ee71ac54; });
/* site-picker.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("hQLiM");
var $ff4S3 = parcelRequire("ff4S3");
parcelRequire("biSAQ");
var $fMbfG = parcelRequire("fMbfG");
var $54KVk = parcelRequire("54KVk");
const $b5507a35ec5b9046$export$7793ee10ee71ac54 = ()=>{
    var _sites_;
    const { sites: sites, isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const label = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $54KVk.Label), {
        children: isWorkspaceProduct ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "siteActivation.yourWorkspace",
            defaultMessage: "Your workspace"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "siteActivation.siteNameSitePickerLabel",
            defaultMessage: "Your site"
        })
    });
    if (sites.length === 1) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1mmsglyw _11ur183y _1rys1rga _a5o8xv17 _1tgt1kw7 _1cgv7vkz _1b7z1nn1 _jxt41kw7 _1f3hi2wt _nrq3ftgi _1npwi2wt _aszr7vkz"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            isDisabled: true,
            name: "site-picker-field",
            id: "site-picker-field",
            testId: "site-picker-field",
            label: label,
            defaultValue: (_sites_ = sites[0]) === null || _sites_ === void 0 ? void 0 : _sites_.url.replace("https://", ""),
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $6ogO3._)({}, fieldProps))
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fMbfG.Dropdown), {
        sites: sites
    });
};
const $b5507a35ec5b9046$var$inputCss = null;

});

parcelRegister("aw05g", function(module, exports) {
$parcel$export(module.exports, "SiteToggleButton", function () { return $b5b9071c4b1e6573$export$3bfd0ee4a8c5295a; });
/* site-toggle-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $ddxTX = parcelRequire("ddxTX");

var $7VwhR = parcelRequire("7VwhR");

var $ff4S3 = parcelRequire("ff4S3");
const $b5b9071c4b1e6573$export$3bfd0ee4a8c5295a = ()=>{
    const intl = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct, showSitePicker: showSitePicker, setShowSitePicker: setShowSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    const toggleYourSiteButtonText = showSitePicker ? isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.startNewWorkspaceButton",
        defaultMessage: "Start a new workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.startNewSiteButton",
        defaultMessage: "Start a new site"
    }) : isWorkspaceProduct ? intl.formatMessage({
        id: "siteActivation.nameSite.useExistingWorkspaceButton",
        defaultMessage: "Use an existing workspace"
    }) : intl.formatMessage({
        id: "siteActivation.nameSite.useExistingSiteButton",
        defaultMessage: "Use an existing site"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
        appearance: "link",
        onClick: ()=>setShowSitePicker(!showSitePicker),
        className: (0, $2jatx.default)([
            "_18zrgrf3"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _1e0c1txw _1wyb8oy7 _zulp1y44 _syazrbzz"
            ]),
            style: {
                "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
            },
            children: [
                toggleYourSiteButtonText,
                /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                    "aria-hidden": true,
                    fill: "currentColor",
                    height: "8",
                    width: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "m7.908 0-1.08 1.202 1.75 1.948H1.264C.842 3.15.5 3.53.5 4c0 .469.342.85.763.85H8.58l-1.75 1.948L7.907 8 11.5 4 7.908 0Z"
                    })
                })
            ]
        })
    });
};
const $b5b9071c4b1e6573$var$buttonCss = null;
const $b5b9071c4b1e6573$var$buttonInnerCss = null;

});

parcelRegister("8PRMc", function(module, exports) {
$parcel$export(module.exports, "TermsAndConditions", function () { return $6708a90e0f1be576$export$71c56c718a357b5; });
/* terms-and-conditions.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");
const $6708a90e0f1be576$export$71c56c718a357b5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        "data-testid": "terms-and-conditions",
        className: (0, $2jatx.default)([
            "_1wyboxwj _vwz41k92 _6rth1j6v _1pfhidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.SignupForm.termsAndConditions",
            defaultMessage: "I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
            values: {
                termsOfServiceLink: $6708a90e0f1be576$var$TermsOfServiceLink,
                aiTermsLink: $6708a90e0f1be576$var$AiTermsLink,
                privacyPolicyLink: $6708a90e0f1be576$var$PrivacyPolicyLink
            }
        })
    });
const $6708a90e0f1be576$var$AiTermsLink = (text)=>{
    const aiTermsLinkHref = (0, $kooLp.useLocalizedHref)("/legal/product-specific-terms#atlassian-intelligence-specific-terms");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        "aria-label": text,
        href: aiTermsLinkHref,
        text: text,
        type: "inline"
    });
};
const $6708a90e0f1be576$var$PrivacyPolicyLink = (text)=>{
    const privacyPolicyLinkHref = (0, $kooLp.useLocalizedHref)("/legal/privacy-policy#what-this-policy-covers");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        "aria-label": text,
        href: privacyPolicyLinkHref,
        text: text,
        type: "inline"
    });
};
const $6708a90e0f1be576$var$TermsOfServiceLink = (text)=>{
    const termsOfServiceLinkHref = (0, $kooLp.useLocalizedHref)("/legal/cloud-terms-of-service");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        "aria-label": text,
        href: termsOfServiceLinkHref,
        text: text,
        type: "inline"
    });
};
const $6708a90e0f1be576$var$termsAndConditionsCss = null;

});


parcelRegister("hLU4E", function(module, exports) {
$parcel$export(module.exports, "ManagedUser", function () { return (parcelRequire("jGkoX")).ManagedUser; });
parcelRequire("jGkoX");

});
parcelRegister("jGkoX", function(module, exports) {
$parcel$export(module.exports, "ManagedUser", function () { return $0ef791acb9b8931b$export$fcb76302df2c072d; });
/* managed-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $doAVE = parcelRequire("doAVE");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $2emUn = parcelRequire("2emUn");
parcelRequire("9fMVX");
var $jgBbG = parcelRequire("jgBbG");

var $3D1CY = parcelRequire("3D1CY");
const $0ef791acb9b8931b$export$fcb76302df2c072d = ()=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const sites = (0, $doAVE.useManagingOrgUserSites)();
    const { profile: profile, product: product } = (0, $doAVE.useUserContext)();
    const orgId = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    const clickGoToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToReturnToProductScreen",
            attributes: {
                orgId: orgId,
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$0ef791acb9b8931b$var$goToExistingWorkspace(str, clickGoToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    const clickGoToSiteNamingScreen = ()=>{
        setShowSiteNaming(true);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToSiteNamingScreen",
            attributes: {
                orgId: orgId,
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToSiteNamingMessageValues = {
        link: (str)=>$0ef791acb9b8931b$var$goToSiteNaming(str, clickGoToSiteNamingScreen)
    };
    const goToSiteNamingMessage = formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, goToSiteNamingMessageValues);
    return (sites === null || sites === void 0 ? void 0 : sites.length) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "signup-guard-return-to-product",
        group: "treatment",
        metadata: {
            orgId: orgId
        },
        children: showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToExistingWorkspaceMessage
                })
            ]
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1yb4 _1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz _1bah1yb4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3D1CY.SitesList), {
                    sites: sites
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybdlk8 _k48pbfng _y3gn1h6o"
                    ]),
                    children: goToSiteNamingMessage
                })
            ]
        })
    }) : null;
};
const $0ef791acb9b8931b$var$goToSiteNaming = (str, clickGoToSiteNamingScreen)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
        onClick: clickGoToSiteNamingScreen,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $0ef791acb9b8931b$var$goToExistingWorkspace = (str, clickGoToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
        onClick: clickGoToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: str
    });
const $0ef791acb9b8931b$var$containerCss = null;
const $0ef791acb9b8931b$var$goToLinkCss = null;
const $0ef791acb9b8931b$var$goToMessageCss = null;

});
parcelRegister("3D1CY", function(module, exports) {
$parcel$export(module.exports, "SitesList", function () { return $fa618feefe0aa5d1$export$e2789664959efdd3; });
/* sites-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
const $fa618feefe0aa5d1$export$e2789664959efdd3 = ({ sites: sites })=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { profile: profile, product: product, user: { email: email } } = (0, $doAVE.useUserContext)();
    const orgId = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $fa618feefe0aa5d1$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c11p5 _1bsb1osq _1jc21k1x _1mbp1wug"
                ]),
                children: sites.map(({ displayName: displayName, url: url })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                        href: $fa618feefe0aa5d1$var$getIdentityUrl({
                            url: url,
                            productKey: product === null || product === void 0 ? void 0 : product.key
                        }),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "guardClickReturnToProductButton",
                                attributes: {
                                    orgId: orgId,
                                    productName: product === null || product === void 0 ? void 0 : product.name
                                }
                            }).fire();
                            window.location.href = $fa618feefe0aa5d1$var$getIdentityUrl({
                                url: url,
                                productKey: product === null || product === void 0 ? void 0 : product.key
                            });
                        },
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _179rzgxb _1e0c11p5 _zulp1y44 _yv0e9sye _1bah1yb4 _ca0q7vkz _u5f3ftgi _n3td7vkz _19bvftgi _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82 _8gg5glyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1syg"
                                ]),
                                style: {
                                    "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: product === null || product === void 0 ? void 0 : product.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_syaz131l _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wybdlk8"
                                        ]),
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_p12f13i4 _1e0c1txw _1bahesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                    variant: "secondary",
                                    size: "small",
                                    color: "black",
                                    className: (0, $2jatx.default)([
                                        modalVisualUpdates && "_ect41kw7 _1wybdlk8 _1rjcftgi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "bxpSignup.siteExpansion.goToProduct",
                                        defaultMessage: "Go to {productName}",
                                        values: {
                                            productName: product === null || product === void 0 ? void 0 : product.description
                                        }
                                    })
                                })
                            })
                        ]
                    }, url))
            })
        ]
    });
};
const $fa618feefe0aa5d1$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $7VwhR.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $fa618feefe0aa5d1$var$getIdentityUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $7VwhR.ProductKey).JIRA_SOFTWARE:
            return `${(0, $7VwhR.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/jira`,
                application: "jira"
            })}`;
        case (0, $7VwhR.ProductKey).CONFLUENCE:
            return `${(0, $7VwhR.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/wiki`,
                application: "confluence"
            })}`;
        case (0, $7VwhR.ProductKey).DEVAI:
            return `${(0, $7VwhR.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/rovodev`,
                application: "devai"
            })}`;
        default:
            return url;
    }
};
const $fa618feefe0aa5d1$var$containerCss = null;
const $fa618feefe0aa5d1$var$switchAccountSubheader = null;
const $fa618feefe0aa5d1$var$sitesListCss = null;
const $fa618feefe0aa5d1$var$siteBoxCss = null;
const $fa618feefe0aa5d1$var$productNameCss = null;
const $fa618feefe0aa5d1$var$siteCss = null;
const $fa618feefe0aa5d1$var$siteNameCss = null;
const $fa618feefe0aa5d1$var$goToSiteButtonContainerCss = null;
const $fa618feefe0aa5d1$var$goToSiteButtonCss = null;
const $fa618feefe0aa5d1$var$emailCss = null;
const $fa618feefe0aa5d1$var$switchAccountLinkCss = null;

});



parcelRegister("bGUHK", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return (parcelRequire("lBvZp")).NewUser; });
parcelRequire("lBvZp");

});
parcelRegister("lBvZp", function(module, exports) {
$parcel$export(module.exports, "NewUser", function () { return $642e4e985a9cdc5c$export$17cbb676e2e98676; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $3kezV = parcelRequire("3kezV");
const $642e4e985a9cdc5c$export$17cbb676e2e98676 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3kezV.Content), (0, $6ogO3._)({}, props));

});
parcelRegister("3kezV", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $3dbd49b2429de188$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lX14w = parcelRequire("lX14w");

var $ff4S3 = parcelRequire("ff4S3");

var $eWKFr = parcelRequire("eWKFr");

var $3naW4 = parcelRequire("3naW4");

var $8SDzo = parcelRequire("8SDzo");
const $3dbd49b2429de188$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), HelperText: HelperText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3naW4.HelperText), {}), SubmitButton: SubmitButton, PrivacyPolicy: PrivacyPolicy = null })=>{
    const { activateSite: activateSite } = (0, $ff4S3.useSiteActivationContext)();
    const activateSiteWithPrivacyPolicy = ()=>{
        var _document_getElementById;
        const privacyPolicy = ((_document_getElementById = document.getElementById("privacy-policy-text")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.innerHTML) || "";
        activateSite({
            privacyPolicy: privacyPolicy
        });
    };
    if (SubmitButton === undefined) SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8SDzo.NewUserSubmitButton), {
        hasPrivacyPolicy: !!PrivacyPolicy
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSiteWithPrivacyPolicy,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "new-user-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            SiteNameInput,
                            HelperText
                        ]
                    }),
                    SubmitButton,
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        id: "privacy-policy-text",
                        children: PrivacyPolicy
                    })
                ]
            }))
    });
};
const $3dbd49b2429de188$var$containerCss = null;

});
parcelRegister("3naW4", function(module, exports) {
$parcel$export(module.exports, "HelperText", function () { return $b38a10467ddc3e98$export$7bc3de131d90901c; });
/* helper-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("hQLiM");
var $ff4S3 = parcelRequire("ff4S3");
const $b38a10467ddc3e98$export$7bc3de131d90901c = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { isWorkspaceProduct: isWorkspaceProduct } = (0, $ff4S3.useSiteActivationContext)();
    const text = isWorkspaceProduct ? formatMessage({
        id: "siteActivation.nameSite.inputWorkspaceNameHelperText",
        defaultMessage: "This workspace name is just a suggestion. Feel free to change to something your team will recognize."
    }) : formatMessage({
        id: "siteActivation.nameSite.inputSiteNameHelperText",
        defaultMessage: "This site name is just a suggestion. Feel free to change to something your team will recognize."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_syazalr3 _1wyboqnp _vwz4bs82 _19pk1kwk _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: text
    });
};
const $b38a10467ddc3e98$var$helperTextCss = null;

});

parcelRegister("8SDzo", function(module, exports) {
$parcel$export(module.exports, "NewUserSubmitButton", function () { return $95b46875f4877d38$export$f05369598c89e38f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $8Mruz = parcelRequire("8Mruz");
const $95b46875f4877d38$export$f05369598c89e38f = ({ hasPrivacyPolicy: hasPrivacyPolicy = false })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const submitMessage = hasPrivacyPolicy ? formatMessage({
        id: "siteActivation.nameSite.agreeButton",
        defaultMessage: "Agree and start now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});




parcelRegister("6RRFZ", function(module, exports) {
$parcel$export(module.exports, "WeekOneUser", function () { return (parcelRequire("3ptXA")).WeekOneUser; });
parcelRequire("3ptXA");

});
parcelRegister("3ptXA", function(module, exports) {
$parcel$export(module.exports, "WeekOneUser", function () { return $0d9840caf41bd814$export$16be3dbbc731576d; });
/* week-one-user.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $5qUgh = parcelRequire("5qUgh");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("9fMVX");
var $jgBbG = parcelRequire("jgBbG");
parcelRequire("k2D5f");
var $g4osg = parcelRequire("g4osg");
const $0d9840caf41bd814$export$16be3dbbc731576d = ()=>{
    const createNewWorkspace = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === "undefined") return false;
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get("createNew") === "true";
    }, []);
    const [showSiteNaming, setShowSiteNaming] = (0, $1oC0p.useState)(createNewWorkspace);
    const { product: product } = (0, $doAVE.useUserContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: product === null || product === void 0 ? void 0 : product.name
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>$0d9840caf41bd814$var$link(str, clickReturnToExistingWorkspace)
    };
    const goToExistingWorkspaceMessage = (product === null || product === void 0 ? void 0 : product.key) === (0, $7VwhR.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgBbG.ExistingUser), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g4osg.ReturnToExistingProduct), {
        productKeyForExpand: (product === null || product === void 0 ? void 0 : product.key) || (0, $7VwhR.ProductKey).JIRA_SOFTWARE,
        exitView: ()=>{
            setShowSiteNaming(true);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "contactExpandGoToSiteNamingScreen",
                attributes: {
                    productName: product === null || product === void 0 ? void 0 : product.name
                }
            }).fire();
        }
    });
};
const $0d9840caf41bd814$var$containerCss = null;
const $0d9840caf41bd814$var$goToExistingWorkspaceLinkCss = null;
const $0d9840caf41bd814$var$goToExistingWorkspaceMessageCss = null;
const $0d9840caf41bd814$var$link = (str, clickReturnToExistingWorkspace)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
        onClick: clickReturnToExistingWorkspace,
        className: (0, $2jatx.default)([
            "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3l3k2"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: str
    });

});
parcelRegister("k2D5f", function(module, exports) {
$parcel$export(module.exports, "ReturnToExistingProduct", function () { return (parcelRequire("g4osg")).ReturnToExistingProduct; });
parcelRequire("g4osg");

});
parcelRegister("g4osg", function(module, exports) {
$parcel$export(module.exports, "ReturnToExistingProduct", function () { return $a961e78bb1453a70$export$ba7c22a9ce02f49f; });
/* return-to-existing-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $5qUgh = parcelRequire("5qUgh");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
const $a961e78bb1453a70$export$ba7c22a9ce02f49f = ({ exitView: exitView, productKeyForExpand: productKeyForExpand })=>{
    const d0to6JiraSite = (0, $doAVE.useProductD0to6Site)({
        productKey: productKeyForExpand
    });
    const { product: product } = (0, $doAVE.useUserContext)();
    const { user: { email: email } } = (0, $doAVE.useUserContext)();
    const { productName: productName } = (0, $7VwhR.getProductData)(product === null || product === void 0 ? void 0 : product.key);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    const goToProductButtonText = productKeyForExpand === (0, $7VwhR.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                onClick: exitView,
                className: (0, $2jatx.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _ect41kw7 _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const createNewWorkspaceMessage = productKeyForExpand === (0, $7VwhR.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    var _product_key;
    return !d0to6JiraSite ? null : /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ae4v1yb4 _1e0c11p5 _16jlkb7n _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulpzwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect41kw7 _1wybdlk8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                                    className: (0, $2jatx.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $a961e78bb1453a70$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "return-to-existing-product",
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _19ityzqy _2rkoftgi _1e0c11p5 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq"
                        ]),
                        style: {
                            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                            href: $a961e78bb1453a70$var$getProductUrl({
                                url: d0to6JiraSite.url,
                                productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                            }),
                            onClick: (e)=>{
                                e.preventDefault(); // wait for event to fire
                                createAnalyticsEvent({
                                    eventType: "ui",
                                    action: "clicked",
                                    actionSubject: "button",
                                    actionSubjectId: "contactExpandClickReturnToProductButton",
                                    attributes: {
                                        productName: productName
                                    }
                                }).fire();
                                var _product_key;
                                window.location.href = $a961e78bb1453a70$var$getProductUrl({
                                    url: d0to6JiraSite.url,
                                    productKey: (_product_key = product === null || product === void 0 ? void 0 : product.key) !== null && _product_key !== void 0 ? _product_key : ""
                                });
                            },
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1yb4 _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1wyb1syg _1reo15vq _18m915vq"
                                    ]),
                                    style: {
                                        "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                            ]),
                                            children: productName
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_syaz1hap _1wybdlk8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                            ]),
                                            style: {
                                                "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                            },
                                            children: d0to6JiraSite.displayName
                                        })
                                    ]
                                }),
                                modalVisualUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    className: (0, $2jatx.default)([
                                        "_ect41kw7 _1wyb7vkz _1rjcftgi"
                                    ]),
                                    children: goToProductButtonText
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: goToProductButtonText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $a961e78bb1453a70$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $7VwhR.getSwitchAccountUrl)(),
        className: (0, $2jatx.default)([
            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $a961e78bb1453a70$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $7VwhR.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $7VwhR.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $a961e78bb1453a70$var$switchAccountSubheader = null;
const $a961e78bb1453a70$var$containerCss = null;
const $a961e78bb1453a70$var$contentCss = null;
const $a961e78bb1453a70$var$createNewWorkspaceMessageCss = null;
const $a961e78bb1453a70$var$createNewWorkspaceLinkCss = null;
const $a961e78bb1453a70$var$boxContainerCss = null;
const $a961e78bb1453a70$var$siteBoxCss = null;
const $a961e78bb1453a70$var$bold = null;
const $a961e78bb1453a70$var$siteCss = null;
const $a961e78bb1453a70$var$siteNameCss = null;
const $a961e78bb1453a70$var$emailCss = null;
const $a961e78bb1453a70$var$switchAccountLinkCss = null;
const $a961e78bb1453a70$var$goToProductButtonCss = null;

});




parcelRegister("bmxFk", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return (parcelRequire("2HR6E")).UpgradeEligibleUser; });
parcelRequire("2HR6E");

});
parcelRegister("2HR6E", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleUser", function () { return $ce270ebdae685cc4$export$31213096ab10a3ce; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $b72iB = parcelRequire("b72iB");
const $ce270ebdae685cc4$export$31213096ab10a3ce = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $b72iB.Content), (0, $6ogO3._)({}, props));

});
parcelRegister("b72iB", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $455b4be8f401193e$export$7c6e2c02157bb7d2; });
/* content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lX14w = parcelRequire("lX14w");

var $ff4S3 = parcelRequire("ff4S3");
parcelRequire("biSAQ");
var $eWKFr = parcelRequire("eWKFr");
var $33py5 = parcelRequire("33py5");
var $aw05g = parcelRequire("aw05g");

var $ejUcs = parcelRequire("ejUcs");
const $455b4be8f401193e$export$7c6e2c02157bb7d2 = ({ SiteNameInput: SiteNameInput = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eWKFr.SiteNameInput), {}), SitePicker: SitePicker = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33py5.SitePicker), {}), SiteToggleButton: SiteToggleButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aw05g.SiteToggleButton), {}), SubmitButton: SubmitButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ejUcs.UpgradeEligibleSubmitButton), {}) })=>{
    const { activateSite: activateSite, showSitePicker: showSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
        onSubmit: activateSite,
        isDisabled: false,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", (0, $dPABA._)((0, $6ogO3._)({}, formProps), {
                autoComplete: "off",
                "data-testid": "upgrade-eligible-site-activation",
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _zulp1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            showSitePicker ? SitePicker : SiteNameInput,
                            SiteToggleButton
                        ]
                    }),
                    SubmitButton
                ]
            }))
    });
};
const $455b4be8f401193e$var$containerCss = null;

});
parcelRegister("ejUcs", function(module, exports) {
$parcel$export(module.exports, "UpgradeEligibleSubmitButton", function () { return $ec48f630e3d05de6$export$9143452c910a3be3; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");
parcelRequire("hQLiM");
var $ff4S3 = parcelRequire("ff4S3");

var $8Mruz = parcelRequire("8Mruz");
const $ec48f630e3d05de6$export$9143452c910a3be3 = ()=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const { showSitePicker: showSitePicker } = (0, $ff4S3.useSiteActivationContext)();
    const submitMessage = showSitePicker ? formatMessage({
        id: "WacSignupForm.upgradeButtonText",
        defaultMessage: "Upgrade now"
    }) : formatMessage({
        id: "siteActivation.nameSiteNewUser.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Mruz.SubmitButton), {
        submitMessage: submitMessage
    });
};

});












parcelRegister("hswtB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f8728e2e52e85e74$export$2e2bcd8739ae039; });

var $7wIVU = parcelRequire("7wIVU");

var $6M1ku = parcelRequire("6M1ku");

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jMhSx = parcelRequire("jMhSx");

var $aRkc9 = parcelRequire("aRkc9");

var $7DnXU = parcelRequire("7DnXU");
const $f8728e2e52e85e74$export$4489c2ed11909944 = (_param)=>{
    var props = (0, $7wIVU._)({}, (0, $6M1ku._)(_param));
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            props.loggedInPaid ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7DnXU.default), (0, $6ogO3._)({}, props))
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7DnXU.default), (0, $6ogO3._)({}, props)),
            !props.hideExploreMore && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aRkc9.default), {})
        ]
    });
};
var $f8728e2e52e85e74$export$2e2bcd8739ae039 = $f8728e2e52e85e74$export$4489c2ed11909944;

});
parcelRegister("aRkc9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2dcff6f910a7097$export$2e2bcd8739ae039; });
/* explore-more-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
parcelRequire("dqEYQ");
var $7Sp5f = parcelRequire("7Sp5f");
var $bDAxQ = parcelRequire("bDAxQ");

var $02dyT = parcelRequire("02dyT");
const $f2dcff6f910a7097$var$exploreStyle = null;
const $f2dcff6f910a7097$var$largeSparklesIconContainerStyles = null;
const $f2dcff6f910a7097$var$mediumSparklesIconContainerStyles = null;
const $f2dcff6f910a7097$var$smallSparklesIconContainerStyles = null;
const $f2dcff6f910a7097$export$ce05c083d6af8c49 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $02dyT.default), {
        header: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1rkb1kdj"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluenceSoftwarePageTemplate.heroHeaderExploreMoreOfConfluence",
                    defaultMessage: "Explore more of Confluence"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _11wmh2mm _fc2710yn _1kyz14y2 _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sp5f.SparklesIcon), {
                        width: "120",
                        height: "80"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _11wmh2mm _fc271crf _1kyz14y2 _dm25glyw _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sp5f.SparklesIcon), {
                        width: "90",
                        height: "60"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _11wmh2mm _fc27ftgi _1kyz1l7b _181nglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bDAxQ.ThickSparklesIcon), {
                        width: "60",
                        height: "40"
                    })
                })
            ]
        }),
        subHeader: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePage.heroHeaderExploreMoreOfConfluence.subHeading",
            defaultMessage: "Create, collaborate, and connect your team's knowledge, all in one place"
        })
    });
};
var $f2dcff6f910a7097$export$2e2bcd8739ae039 = $f2dcff6f910a7097$export$ce05c083d6af8c49;

});
parcelRegister("dqEYQ", function(module, exports) {
$parcel$export(module.exports, "OfficeBuildingIcon", function () { return (parcelRequire("4eAXW")).OfficeBuildingIcon; });
$parcel$export(module.exports, "PlayIcon", function () { return (parcelRequire("b5WBX")).PlayIcon; });
$parcel$export(module.exports, "DocumentsIcon", function () { return (parcelRequire("1nOTC")).DocumentsIcon; });
$parcel$export(module.exports, "SparklesIcon", function () { return (parcelRequire("7Sp5f")).SparklesIcon; });
$parcel$export(module.exports, "ThickSparklesIcon", function () { return (parcelRequire("bDAxQ")).ThickSparklesIcon; });
$parcel$export(module.exports, "GroupsIcon", function () { return (parcelRequire("f2Lca")).GroupsIcon; });
parcelRequire("8c0f7");
parcelRequire("4eAXW");
parcelRequire("6Hcux");
parcelRequire("b5WBX");
parcelRequire("1nOTC");
parcelRequire("7Sp5f");
parcelRequire("bDAxQ");
parcelRequire("f2Lca");

});
parcelRegister("8c0f7", function(module, exports) {

var $7VQPk = parcelRequire("7VQPk");
const $d8f03402331e15d3$export$a3543c9c8473fb3d = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Brand Icons/Comment",
                clipPath: "url(#clip0_5565_6276)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.9995 34.4994L37.9995 34.499V10.499L9.99951 10.4994V40.499L19.9995 34.4994ZM31.999 20.5H15.999V16.5H31.999V20.5ZM24.999 28.5H15.999V24.5H24.999V28.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6276",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("4eAXW", function(module, exports) {
$parcel$export(module.exports, "OfficeBuildingIcon", function () { return $a44e9e73e8ce2395$export$2a7e5122c4e1fda; });

var $7VQPk = parcelRequire("7VQPk");
const $a44e9e73e8ce2395$export$2a7e5122c4e1fda = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Brand Icons/Office Building",
                clipPath: "url(#clip0_5565_6283)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.999 40.5V8.5H35.999V40.5H26.9995V33.5H20.9995V40.5H11.999ZM17.999 15.5H21.999V12.5H17.999V15.5ZM25.999 15.5H29.999V12.5H25.999V15.5ZM21.999 22.5H17.999V19.5H21.999V22.5ZM17.999 29.5H21.999V26.5H17.999V29.5ZM29.999 22.5H25.999V19.5H29.999V22.5ZM25.999 29.5H29.999V26.5H25.999V29.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6283",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("6Hcux", function(module, exports) {

var $7VQPk = parcelRequire("7VQPk");
const $20971915af41dbb0$export$fec93b5f1e2bccb4 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 11 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            id: "arrow",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40698 0.5L6.32733 1.7021L8.07756 3.6497H0.762206C0.340929 3.6497 -0.000976562 4.03038 -0.000976562 4.49943C-0.000976562 4.96849 0.340929 5.34917 0.762206 5.34917H8.07756L6.32733 7.2979L7.40698 8.5L10.999 4.49943L7.40698 0.5Z",
            fill: "#0065FF"
        })
    });
};

});

parcelRegister("b5WBX", function(module, exports) {
$parcel$export(module.exports, "PlayIcon", function () { return $c98fe34d56285e32$export$a6630b90defda83f; });

var $7VQPk = parcelRequire("7VQPk");
const $c98fe34d56285e32$export$a6630b90defda83f = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_5565_6290)",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M37.999 10.5H9.99902V38.5H37.999V10.5ZM17.0027 16C15.8981 16 15.0027 16.8954 15.0027 18C15.0027 19.1046 15.8981 20 17.0027 20C18.1073 20 19.0027 19.1046 19.0027 18C19.0027 16.8954 18.1073 16 17.0027 16ZM17.0027 29C15.8981 29 15.0027 29.8954 15.0027 31C15.0027 32.1046 15.8981 33 17.0027 33C18.1073 33 19.0027 32.1046 19.0027 31C19.0027 29.8954 18.1073 29 17.0027 29ZM15.0027 24.5C15.0027 23.3954 15.8981 22.5 17.0027 22.5C18.1073 22.5 19.0027 23.3954 19.0027 24.5C19.0027 25.6046 18.1073 26.5 17.0027 26.5C15.8981 26.5 15.0027 25.6046 15.0027 24.5ZM31.999 19.5139L21.999 19.5139V16.5139L31.999 16.5139V19.5139ZM31.999 26L21.999 26V23L31.999 23V26ZM21.999 32.5H31.999V29.5H21.999V32.5Z",
                    fill: "#101214"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "11.999",
                y: "12.5",
                width: "24",
                height: "24",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.999 24L19.749 30.4952L19.749 17.5048L30.999 24Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6290",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("1nOTC", function(module, exports) {
$parcel$export(module.exports, "DocumentsIcon", function () { return $846a54b40753b380$export$f4d1f69b1f255ce3; });

var $7VQPk = parcelRequire("7VQPk");
const $846a54b40753b380$export$f4d1f69b1f255ce3 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                id: "Brand Icons/Documents",
                clipPath: "url(#clip0_5565_6299)",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Vector",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.9993 8.5H20.9993L29.9993 17.5V33.5H10.9993V8.5ZM18.9993 19.5V11.5L26.9993 19.5H18.9993Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M32.9991 18.5V36.5H16.9991V40.5H36.9991V18.5H32.9991Z",
                            fill: "#101214"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_5565_6299",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white",
                        transform: "translate(-0.000976562 0.5)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("7Sp5f", function(module, exports) {
$parcel$export(module.exports, "SparklesIcon", function () { return $4e81f00723f31458$export$a05b22346a85e647; });

var $7VQPk = parcelRequire("7VQPk");
const $4e81f00723f31458$export$a05b22346a85e647 = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 122 82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            id: "Gestural Line/star 7",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector",
                    d: "M27.8084 18.2872C24.4456 16.7937 16.6276 20.7744 17.5199 14.5683C16.7065 16.9365 20.2695 2.56069 17.3317 4.61946C17.101 4.3398 16.1662 6.63659 16.4758 6.708C16.8339 9.13569 14.497 14.1696 14.2663 18.0253C14.2481 17.8944 -6.35927 17.6029 2.88523 20.0484C4.59695 20.2507 17.6656 18.9298 13.0342 26.3259C14.2543 43.7363 17.1678 31.3836 17.01 20.8815C18.9463 21.2801 32.9193 21.0719 27.8023 18.2872H27.8084Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector_2",
                    d: "M120.32 39.0772C115.701 38.2025 110.116 40.8504 108.89 36.4056C110.371 35.644 109.431 22.3749 107.543 29.4676C107.871 29.6164 108.308 29.4914 108.119 29.8009C106.22 29.8842 108.332 32.3237 107.488 32.77C106.311 32.1809 108.338 35.3941 107.154 34.5849C106.426 35.763 106.353 37.3279 106.426 38.9761C107.106 39.4878 88.4408 37.8098 96.447 41.2312C97.0115 39.4521 96.5381 42.3915 99.1906 40.6719C101.679 41.6954 103.33 42.1 106.584 42.0881C105.261 45.807 108.866 60.9205 109.631 49.7817C110.189 47.5206 107.561 39.4521 113.437 42.5224C114.748 40.9694 124.921 41.9452 120.308 39.0713L120.32 39.0772Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector_3",
                    d: "M82.6317 11.6885C78.0125 10.8138 72.4282 13.4617 71.2021 9.01685C72.6832 8.25522 71.7423 -5.01372 69.8546 2.07894C70.1824 2.2277 70.6194 2.10271 70.4312 2.41212C68.5313 2.49542 70.6437 4.93501 69.8 5.38127C68.6224 4.7922 70.6497 8.00535 69.4661 7.19612C68.7377 8.37426 68.6649 9.93917 68.7377 11.5874C69.4176 12.0991 50.7464 10.4211 58.7587 13.8425C59.3233 12.0634 58.8498 15.0028 61.5024 13.2832C63.991 14.3066 65.642 14.7112 68.8955 14.6993C67.7908 18.2754 70.7226 33.2462 72.1733 22.4406C72.064 20.6555 70.1216 11.9444 75.7545 15.1337C77.0656 13.5807 87.2388 14.5566 82.6257 11.6826L82.6317 11.6885Z",
                    fill: "#101214"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    id: "Vector_4",
                    d: "M71.3178 67.2696C66.6986 66.3949 61.1143 69.0428 59.8881 64.598C61.3692 63.8363 60.4284 50.5673 58.5406 57.66C58.8684 57.8087 59.3054 57.6838 59.1172 57.9932C57.2174 58.0765 59.3297 60.5161 58.486 60.9624C57.3084 60.3733 59.3358 63.5865 58.1521 62.7772C57.4237 63.9554 57.3509 65.5203 57.4238 67.1685C58.1036 67.6802 39.4325 66.0022 47.4448 69.4236C48.0093 67.6445 47.5358 70.5839 50.1884 68.8643C52.6771 69.8877 54.3281 70.2924 57.5816 70.2805C56.2584 73.9993 59.8638 89.1129 60.6286 77.9741C61.1871 75.713 58.5588 67.6445 64.4345 70.7148C65.7456 69.1618 75.9188 70.1376 71.3057 67.2637L71.3178 67.2696Z",
                    fill: "#101214"
                })
            ]
        })
    });
};

});

parcelRegister("bDAxQ", function(module, exports) {
$parcel$export(module.exports, "ThickSparklesIcon", function () { return $3181594c1a3e5352$export$8016ce75dc94b90d; });

var $7VQPk = parcelRequire("7VQPk");
const $3181594c1a3e5352$export$8016ce75dc94b90d = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 62 43",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M14.0609 10.1436C12.3934 9.39683 8.51669 11.3872 8.95914 8.28414C8.55582 9.46824 10.3226 2.28034 8.86582 3.30973C8.75144 3.1699 8.28791 4.3183 8.44142 4.354C8.619 5.56784 7.46019 8.08479 7.34581 10.0127C7.33678 9.94721 -2.88176 9.80144 1.70229 11.0242C2.55108 11.1254 9.03138 10.4649 6.73484 14.163C7.33982 22.8681 8.78454 16.6918 8.70629 11.4407C9.66644 11.6401 16.5952 11.5359 14.0579 10.1436H14.0609Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.9349 20.5386C57.6444 20.1013 54.8753 21.4252 54.2673 19.2028C55.0017 18.822 54.5352 12.1875 53.5991 15.7338C53.7617 15.8082 53.9784 15.7457 53.8851 15.9004C52.943 15.9421 53.9904 17.1619 53.5721 17.385C52.9881 17.0905 53.9934 18.697 53.4065 18.2924C53.0453 18.8815 53.0092 19.664 53.0453 20.4881C53.3824 20.7439 44.127 19.9049 48.0971 21.6156C48.377 20.726 48.1422 22.1958 49.4575 21.336C50.6916 21.8477 51.5103 22.05 53.1236 22.044C52.4674 23.9035 54.2553 31.4602 54.6346 25.8908C54.9115 24.7603 53.6082 20.7261 56.5217 22.2612C57.1719 21.4847 62.2164 21.9726 59.9289 20.5356L59.9349 20.5386Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.2465 6.84425C38.956 6.4069 36.1869 7.73083 35.579 5.50842C36.3134 5.12761 35.8468 -1.50686 34.9108 2.03947C35.0733 2.11385 35.29 2.05135 35.1967 2.20606C34.2546 2.24771 35.3021 3.4675 34.8837 3.69064C34.2998 3.3961 35.3051 5.00267 34.7181 4.59806C34.3569 5.18713 34.3208 5.96959 34.357 6.79369C34.6941 7.04955 25.4357 6.21055 29.4087 7.92123C29.6886 7.03168 29.4539 8.5014 30.7692 7.64159C32.0032 8.15331 32.8219 8.35562 34.4352 8.34967C33.8874 10.1377 35.3412 17.6231 36.0605 12.2203C36.0063 11.3278 35.0432 6.97219 37.8364 8.56685C38.4865 7.79034 43.531 8.27828 41.2435 6.8413L41.2465 6.84425Z",
                fill: "#101214",
                stroke: "black"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.6353 34.6348C33.3447 34.1975 30.5756 35.5214 29.9676 33.299C30.702 32.9182 30.2355 26.2837 29.2994 29.83C29.462 29.9044 29.6787 29.8419 29.5854 29.9966C28.6433 30.0383 29.6907 31.2581 29.2724 31.4812C28.6884 31.1867 29.6937 32.7932 29.1068 32.3886C28.7456 32.9777 28.7095 33.7601 28.7456 34.5843C29.0827 34.8401 19.8243 34.0011 23.7974 35.7118C24.0773 34.8222 23.8425 36.292 25.1578 35.4322C26.3919 35.9439 27.2106 36.1462 28.8239 36.1402C28.1677 37.9997 29.9556 45.5564 30.3348 39.987C30.6117 38.8565 29.3085 34.8222 32.222 36.3574C32.8722 35.5809 37.9167 36.0688 35.6292 34.6318L35.6353 34.6348Z",
                fill: "#101214",
                stroke: "black"
            })
        ]
    });
};

});

parcelRegister("f2Lca", function(module, exports) {
$parcel$export(module.exports, "GroupsIcon", function () { return $8ce456a773f2e7b4$export$6b0e36037a267557; });

var $7VQPk = parcelRequire("7VQPk");
const $8ce456a773f2e7b4$export$6b0e36037a267557 = ({ size: size })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 49 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            id: "Brand Icons/Groups",
            clipPath: "url(#clip0_6876_13409)",
            filter: "url(#filter0_d_6876_13409)",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.4463 31.5C17.4463 27.634 20.5803 24.5 24.4463 24.5C28.3123 24.5 31.4463 27.634 31.4463 31.5V40.5H17.4463V31.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M30.4463 15.5C30.4463 18.8137 27.76 21.5 24.4463 21.5C21.1326 21.5 18.4463 18.8137 18.4463 15.5C18.4463 12.1863 21.1326 9.5 24.4463 9.5C27.76 9.5 30.4463 12.1863 30.4463 15.5Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M31.2581 21.3824C31.6422 21.4595 32.0395 21.5 32.4463 21.5C35.76 21.5 38.4463 18.8137 38.4463 15.5C38.4463 12.1863 35.76 9.5 32.4463 9.5C32.0395 9.5 31.6422 9.54048 31.2581 9.61764C32.6216 11.1952 33.4463 13.2513 33.4463 15.5C33.4463 17.7487 32.6216 19.8048 31.2581 21.3824Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.6345 9.61764C16.271 11.1952 15.4463 13.2513 15.4463 15.5C15.4463 17.7487 16.271 19.8048 17.6345 21.3824C17.2504 21.4595 16.8531 21.5 16.4463 21.5C13.1326 21.5 10.4463 18.8137 10.4463 15.5C10.4463 12.1863 13.1326 9.5 16.4463 9.5C16.8531 9.5 17.2504 9.54048 17.6345 9.61764Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M17.3049 24.5C15.5366 26.3037 14.4463 28.7745 14.4463 31.5V40.5H10.4463V29.5C10.4463 26.7386 12.6849 24.5 15.4463 24.5H17.3049Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M34.4463 40.5V31.5C34.4463 28.7745 33.356 26.3037 31.5877 24.5H33.4463C36.2077 24.5 38.4463 26.7386 38.4463 29.5V40.5H34.4463Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });
};

});


parcelRegister("02dyT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a314bdb44da51be$export$2e2bcd8739ae039; });
/* header-text-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $8a314bdb44da51be$var$headerTextBlock = null;
const $8a314bdb44da51be$var$headerText = null;
const $8a314bdb44da51be$var$headerSubText = null;
const $8a314bdb44da51be$var$leftAlignedStyle = null;
const $8a314bdb44da51be$var$button = null;
const $8a314bdb44da51be$export$b0d75561f67a4b0d = ({ header: header, subHeader: subHeader, leftAligned: leftAligned, cta: cta })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1bah1h6o _1q51oahv _85i5xncg _ag851h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3td7vkz _19bvidpf",
                    leftAligned && "_y3gn1e5h",
                    "superhero-contrast"
                ]),
                children: header
            }),
            subHeader && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3td7vkz _19bvidpf",
                    leftAligned && "_y3gn1e5h",
                    "body-lg"
                ]),
                children: subHeader
            }),
            cta && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _bpsp1nn1 _43dscd5j"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: cta
            })
        ]
    });
};
var $8a314bdb44da51be$export$2e2bcd8739ae039 = $8a314bdb44da51be$export$b0d75561f67a4b0d;

});


parcelRegister("7DnXU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0dd858399beccd45$export$2e2bcd8739ae039; });
/* log-me-in.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $dEFIL = parcelRequire("dEFIL");

var $ea4mV = parcelRequire("ea4mV");

var $iSeHD = parcelRequire("iSeHD");

var $eXdK6 = parcelRequire("eXdK6");
const $0dd858399beccd45$var$START_URL = "https://start.atlassian.com";
const $0dd858399beccd45$var$SIGNUP_URL = "https://atlassian.com/try/cloud/signup?bundle=confluence&edition=free";
const $0dd858399beccd45$var$sectionCSS = null;
const $0dd858399beccd45$var$wrapLogMeSecAndLines = null;
// Adjustments for fixed top nav.
// The logged in paid pages have a position:fixed top nav.
const $0dd858399beccd45$var$wrapLogMeSecAndLinesLoggedInPaid = null;
const $0dd858399beccd45$var$logMeBackInSectionStyle = null;
const $0dd858399beccd45$var$headingStyle = null;
const $0dd858399beccd45$var$subHeadingStyle = null;
const $0dd858399beccd45$var$confluenceSiteBoxContainerStyle = null;
const $0dd858399beccd45$var$flareContainerCss = null;
const $0dd858399beccd45$var$confluenceSiteBoxUnderlayStyle = null;
const $0dd858399beccd45$var$confluenceSiteBoxStyle = null;
const $0dd858399beccd45$var$logoAndSiteNameStyle = null;
const $0dd858399beccd45$var$logoStyle = null;
const $0dd858399beccd45$var$siteStyle = null;
const $0dd858399beccd45$var$productStyle = null;
const $0dd858399beccd45$var$siteNameStyle = null;
const $0dd858399beccd45$var$otherSiteLinkStyle = null;
const $0dd858399beccd45$var$buttonStyle = null;
const $0dd858399beccd45$var$imgWrapperStyle = null;
const $0dd858399beccd45$var$imgStyle = null;
var $0dd858399beccd45$var$TRACKING_EVENT_NAMES = /*#__PURE__*/ function(TRACKING_EVENT_NAMES) {
    TRACKING_EVENT_NAMES["loggedInHeroProductCtaClicked"] = "loggedInHeroProductCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroAnotherSiteCtaClicked"] = "loggedInHeroAnotherSiteCtaClicked";
    TRACKING_EVENT_NAMES["loggedInHeroNewSiteCtaClicked"] = "loggedInHeroNewSiteCtaClicked";
    return TRACKING_EVENT_NAMES;
}($0dd858399beccd45$var$TRACKING_EVENT_NAMES || {});
const $0dd858399beccd45$export$48ece50d13cfbebc = ({ confluenceSites: confluenceSites, userProfileName: userProfileName, imgSrc: // eslint-disable-next-line local/no-non-orangelogic-images-eslint
imgSrc = "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero Image B-1884788674.webp", loggedInPaid: loggedInPaid })=>{
    var _confluenceSites_, _confluenceSites_1;
    const createConfluenceUrl = (url)=>{
        try {
            const tempUrl = new URL(url);
            tempUrl.pathname = "/wiki";
            tempUrl.search = "";
            return tempUrl.toString();
        } catch (e) {
            return url;
        }
    };
    const getSitenameFromUrl = (url)=>{
        try {
            const tempUrl = new URL(url);
            return tempUrl.hostname.split(".")[0] || "";
        } catch (e) {
            return "";
        }
    };
    const firstName = userProfileName === null || userProfileName === void 0 ? void 0 : userProfileName.split(" ")[0];
    const siteUrl = createConfluenceUrl(((_confluenceSites_ = confluenceSites[0]) === null || _confluenceSites_ === void 0 ? void 0 : _confluenceSites_.url) || "") || $0dd858399beccd45$var$START_URL;
    const siteName = getSitenameFromUrl(((_confluenceSites_1 = confluenceSites[0]) === null || _confluenceSites_1 === void 0 ? void 0 : _confluenceSites_1.url) || "");
    const hasMultipleConfluences = confluenceSites.length > 1;
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== "undefined") createAnalyticsEvent({
            eventType: "ui",
            action: "loaded",
            actionSubject: "page",
            actionSubjectId: "loggedInHero",
            source: "/software/confluence",
            attributes: {
                url: window.location.href
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "loggedInHero",
            source: "/software/confluence",
            attributes: {
                eventName: eventName,
                url: window.location.href
            }
        }).fire();
    };
    const intl = (0, $8e22h.default)();
    const linkUrl = loggedInPaid ? $0dd858399beccd45$var$SIGNUP_URL : $0dd858399beccd45$var$START_URL;
    const signupHref = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=confluence&edition=free&createNew=true");
    const gwp5090BannerExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsLiftedBanner = gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "lifted";
    const gwp5090Team25Config = {
        identifier: "GWP5090.confluence-product-tour.lifted",
        customCSS: {
            position: "absolute",
            margin: "auto",
            inset: "auto 0 90px"
        },
        bannerType: "lifted",
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from the world\u2019s leading product experts on how to boost team performance at Team \u201925!",
                values: (0, $kooLp.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "team25-banners-and-butterbars.confluence.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from leading product experts!",
                values: (0, $kooLp.DEFAULT_VALUES)
            })
        }),
        productKey: "home",
        backgroundPreset: "gwp-5090-banners",
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/gf1wkse40oux4nf58b103kknvb18p4yc.webp",
            alt: "Team25",
            //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: "team25-banners-and-butterbars.confluence.cta",
            defaultMessage: "Get your pass"
        }),
        linkUrl: "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=confluence_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=lifted-bar_WEBTEAM-17396&event_id=216653",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "team25-banners-and-butterbars.confluence.cta",
                defaultMessage: "Get your pass"
            }),
            "data-label-english": "Get your pass"
        }
    };
    const classWrapperName = gwp5090IsLiftedBanner ? "lifted" : "standard";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_1yeuh2mm",
                classWrapperName
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1itk1m1u _1lrw1dfr _1e0c1txw _4cvr1h6o _1bah1h6o _zulp1a0z _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q1wto _u5f31lev _n3td1fqw _19bv1lev _165t1kc5 _na0i1bp4 _2osnckbl _13lo7rrr",
                        loggedInPaid && "_165t1wug _5br81et3 _rvh8ys9h _17y2ys9h _2936ys9h _jk7n16xz _la4x1tcg _d8uxys9h _1vw11tcg",
                        classWrapperName
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_ca0q1tcg _u5f3idpf _n3td1tcg _19bvidpf _1lp7vrvc _10jx1erl _1s4p1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                    className: (0, $2jatx.default)([
                                        "_1wybckbl _vwz48vuz _k48pbfng _1pfhidpf _6rthftgi"
                                    ]),
                                    children: firstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                                        defaultMessage: `Welcome back, {name}.`,
                                        values: {
                                            name: firstName
                                        }
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.welcomeBack",
                                        defaultMessage: "Welcome back"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1wybgktf _6rth1tcg _1pfhidpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff",
                                        defaultMessage: "Pick up where you left off in Confluence."
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_kqswstnw _1e02k4tm _1pbycs5v _14qqglyw"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eXdK6.FlareSvg), {})
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_kqswh2mm _1pbykb7n _1bsb1wug _4t3it9kd _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1puz _2rko1y44 _ca0q7vkz _u5f31tcg _n3td7vkz _19bv7vkz _bfhku67f _yhmu1bp4 _9pnu1wug _te6cv2br _jk7n1v6z _la4x7vkz _d8ux7vkz _1vw17vkz"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _1ul9idpf"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_12l219bv _1pfhrdoj"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Logo), {
                                                                brand: "confluence",
                                                                type: "mark",
                                                                appearance: "brand"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_vwz4qslr _1wyb7vkz _1reo15vq _18m915vq"
                                                            ]),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_k48pbfng _4t3iqslr _1wybl52n _y3gnv2br"
                                                                    ]),
                                                                    children: "Confluence"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_k48powjs _1bto1l2s _1reo15vq _18m915vq _o5721q9c _4t3iqslr"
                                                                    ]),
                                                                    children: siteName
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                                    id: "confluence-button",
                                                    variant: "primary",
                                                    size: "small",
                                                    color: "blue",
                                                    href: siteUrl,
                                                    onClick: ()=>clickHandler("loggedInHeroProductCtaClicked"),
                                                    className: (0, $2jatx.default)([
                                                        "_o5721q9c _ahbqo7ao _19tjidpf _1qza1osq _5m7p1osq"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.goToConfluence",
                                                        defaultMessage: "Go to Confluence"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1bsb1w8u _kqswstnw _u7conicn _rjxpd439 _bfhkh727 _4t3i1wqb _9pnu1l8a"
                                            ])
                                        })
                                    ]
                                }),
                                hasMultipleConfluences && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    href: linkUrl,
                                    text: intl.formatMessage({
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite",
                                        defaultMessage: "Looking for a different site?"
                                    }),
                                    onClick: ()=>clickHandler("loggedInHeroAnotherSiteCtaClicked"),
                                    className: (0, $2jatx.default)([
                                        "_1pfhckbl"
                                    ])
                                }),
                                loggedInPaid && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    href: signupHref,
                                    text: intl.formatMessage({
                                        id: "ConfluenceSoftwarePageTemplate.loggedInHero.orCreateANewWorkspace",
                                        defaultMessage: "Or create a new workspace"
                                    }),
                                    onClick: ()=>clickHandler("loggedInHeroNewSiteCtaClicked"),
                                    className: (0, $2jatx.default)([
                                        "_1pfhckbl"
                                    ])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_10jxstmo _1s4p1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                alt: "",
                                src: imgSrc,
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq"
                                ])
                            })
                        })
                    ]
                }),
                gwp5090IsLiftedBanner && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEFIL.EnhancedBannerAlert), (0, $6ogO3._)({}, gwp5090Team25Config))
            ]
        })
    });
};
var $0dd858399beccd45$export$2e2bcd8739ae039 = $0dd858399beccd45$export$48ece50d13cfbebc;

});
parcelRegister("dEFIL", function(module, exports) {
$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $2gCne = parcelRequire("2gCne");
const $41ab4e6d9e0b9eaf$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        "data-product-key": bannerInfo.productKey,
        "data-event-component": "button",
        "data-event-container": "announcementBanner",
        "data-event": "clicked",
        "data-label": "Close",
        "data-label-english": "Close"
    };
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? "three-screen" : "two-screen";
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    let mobileProps = bannerInfo.imageProps;
    if (bannerInfo.imageMobileProps && bannerInfo.imageMobileProps.src) mobileProps = bannerInfo.imageMobileProps;
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : "banner-type-default";
    const bgLinkColor = bannerInfo.backgroundPreset == "gwp-5090-banners" ? "bgBlackBlue" : "bgWhite";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhk1ybm _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pio2icb _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bjk2v _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w1cd5j _5vmz1ejb _3kek1ejb _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1hlo _sqps1ybm _iawm1hlo _abydglyw _6c4acd5j _udn3glyw _2fl2idpf _1kn8cd5j _1vxmcd5j _1mafcd5j _waepcd5j _1y8xcd5j _1ur0cd5j _ojfccd5j _1yaacd5j _11zscd5j _1s05cd5j _6rr71ybm _fsy11ybm _sx881ybm _1s7h1ybm _1gudcd5j _1m8acd5j _1lcvcd5j _v05mcd5j _lkhdni7l _pu49ni7l _162fni7l _19ycni7l _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4fcd5j _xfs2idpf _17es1rga _lfur1dgx _1t0kmgnk _ejrwidpf _1m4lanty _7ax8uuw1 _1ww71tcg _cfnoftgi _ogm61et3 _ve7k1ule _1mt7kfja _76j711ux _1dxgidpf _1i4jt1wm _ne8lqiko _1it7ys9h _umq2mgvx _16471dnu _1uhmmr2s _6cysidpf _yo8p1tcg _17pqqslr _ti1kp3fh _onmtn7od",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? "true" : undefined,
            "data-testid": "banner-alert-container",
            style: (0, $dPABA._)((0, $6ogO3._)({}, bannerInfo.customCSS), {
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
                "--_e0fbx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple500")),
                "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900")),
                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700")),
                "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                "--_1vwzriw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.yellow")),
                "--_b9m2cq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.green")),
                "--_1lpv4ka": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.lime")),
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
            }),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                            image: (0, $6ogO3._)({
                                                width: 209
                                            }, bannerInfo.imageProps),
                                            style: {
                                                maxWidth: "100%",
                                                height: "auto"
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_191w1xtt _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw",
                                    "mobile-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                        image: (0, $6ogO3._)({
                                                            width: 180
                                                        }, mobileProps),
                                                        style: {
                                                            maxWidth: "100%",
                                                            height: "auto"
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType != "lifted" && /*#__PURE__*/ (0, $7VQPk.jsx)("button", (0, $dPABA._)((0, $6ogO3._)({
                    className: (0, $2jatx.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                    }
                }, closeIconDataEventProps), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Cross), {
                        size: "24"
                    })
                }))
            ]
        })
    });
};
const $41ab4e6d9e0b9eaf$var$scrollUpTwoScreens = null;
const $41ab4e6d9e0b9eaf$var$scrollUpThreeScreens = null;
const $41ab4e6d9e0b9eaf$var$desktopContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$mobileContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$desktopLogoStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeContainerStyles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItemStyle = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem1Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem2Styles = null;
const $41ab4e6d9e0b9eaf$var$marqueeItem3Styles = null;
const $41ab4e6d9e0b9eaf$var$containerStyles = null;
const $41ab4e6d9e0b9eaf$var$contentStyles = null;
const $41ab4e6d9e0b9eaf$var$pStyle = null;
const $41ab4e6d9e0b9eaf$var$lineStyle = null;
const $41ab4e6d9e0b9eaf$var$closeStyles = null;

});

parcelRegister("eXdK6", function(module, exports) {
$parcel$export(module.exports, "FlareSvg", function () { return $7baa2276e93da712$export$7b83271ab79d7cd2; });

var $7VQPk = parcelRequire("7VQPk");

var $imIsw = parcelRequire("imIsw");
const $7baa2276e93da712$export$7b83271ab79d7cd2 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8ra1mh2pbsd5j7i3kc5rdw2h5815w1i1.svg",
            alt: "",
            width: 77,
            height: 81
        }
    });

});



parcelRegister("3sDDl", function(module, exports) {
$parcel$export(module.exports, "ConfluencePagePaidLpConflAnchor", function () { return $7e46c16dbeed31a5$export$66f40902ad8b3dc6; });
/* eslint-disable complexity */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gHIMV = parcelRequire("gHIMV");

var $8e22h = parcelRequire("8e22h");

var $a8Jhy = parcelRequire("a8Jhy");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $a5uC7 = parcelRequire("a5uC7");

var $kZQhV = parcelRequire("kZQhV");

var $28AH4 = parcelRequire("28AH4");

var $cqCPq = parcelRequire("cqCPq");

var $ik40B = parcelRequire("ik40B");
const $7e46c16dbeed31a5$var$LANDING_TYPE = "confluence-rebranded-anchor";
const $7e46c16dbeed31a5$export$66f40902ad8b3dc6 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps, dataProductKey: dataProductKey, carouselHeroProps: carouselHeroProps, keyword: keyword, subAnchor: subAnchor, customHeroSection: customHeroSection, customTabsProps: customTabsProps })=>{
    const intl = (0, $8e22h.default)();
    const productHref = (0, $kooLp.useLocalizedHref)("/software/confluence");
    const [content, setContent] = (0, $1oC0p.useState)(undefined);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        const anchorLocalStorageData = {
            persona: persona,
            team: "",
            teamTypeInferredMl: teamType
        };
        if (!!keyword) anchorLocalStorageData.keyword = keyword;
        if (!!subAnchor) anchorLocalStorageData.subAnchor = subAnchor;
        setAnchorLocalStorage(anchorLocalStorageData);
        setContent(anchorContents);
    // We only want to run this useEffect once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const props = {
        hideNavigationBar: false,
        landingType: $7e46c16dbeed31a5$var$LANDING_TYPE,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: false,
        productNavProps: {
            productHref: productHref,
            productName: "confluence",
            ariaLabel: intl.formatMessage({
                id: "wacConfluenceNavigation.logo-label",
                defaultMessage: "Confluence logo"
            }),
            dataProductKey: "confluence",
            showFreeHrefButton: false
        },
        heroProps: $7e46c16dbeed31a5$var$getHeroProps({
            resp: content,
            pageVariant: pageVariant,
            keyword: keyword,
            subAnchor: subAnchor
        }),
        carouselHeroProps: carouselHeroProps,
        tabsProps: customTabsProps || $7e46c16dbeed31a5$var$getTabProps(content, dataProductKey, pageVariant, keyword, subAnchor),
        ctaWithPolyGonProps: $7e46c16dbeed31a5$var$getCtaWithPolygonProps(content, pageId, dataProductKey),
        testimonialProps: $7e46c16dbeed31a5$var$getTestimonialProps(content),
        alternatingTextAndImageProps: $7e46c16dbeed31a5$var$getAlternatingTextAndImageProps(content),
        resultSectionDivider: {
            color: (0, $kbpa7.wacToken)("color.neutral.light100"),
            variation: (0, $a8Jhy.SECTION_DIVIDER_VARIATION).NORMAL
        },
        hasRebrandedSignupFormStyles: true,
        heroBgColor: "bgWhite",
        customHeroSection: customHeroSection
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), (0, $6ogO3._)({}, props));
};
const $7e46c16dbeed31a5$var$heroFeatureMatrix = {
    engineering: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    featuresCerebro: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    keywords: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: false
    },
    subAnchor: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: false
    },
    marketing: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: true,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    },
    brandUpdate: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false,
        showScribble: true,
        showEyeLash: true,
        showFourSocialButtons: true
    }
};
const $7e46c16dbeed31a5$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false,
        showScribble: false,
        showEyeLash: false,
        showFourSocialButtons: false
    };
    return $7e46c16dbeed31a5$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
const $7e46c16dbeed31a5$var$getAnimation = ({ pageVariant: pageVariant, keyword: keyword, subAnchor: subAnchor })=>{
    if (pageVariant === "keywords") return (0, $cqCPq.getAnimationByKeyword)((keyword === null || keyword === void 0 ? void 0 : keyword.trim()) || "");
    else if (pageVariant === "subAnchor") return (0, $ik40B.getAnimationBySubAnchor)((subAnchor === null || subAnchor === void 0 ? void 0 : subAnchor.trim()) || "");
    return undefined;
};
const $7e46c16dbeed31a5$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, keyword: keyword, subAnchor: subAnchor })=>{
    const defaultProps = {
        theme: "dark-on-light",
        headerText: "",
        secondaryText: "",
        signup: {
            bundle: "confluence",
            edition: "free",
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0]) return defaultProps;
    const { headline: headline } = resp[0].node;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = (data === null || data === void 0 ? void 0 : data.planBenefits) && (data === null || data === void 0 ? void 0 : data.planBenefits[0]) ? data === null || data === void 0 ? void 0 : data.planBenefits[0] : null;
    const supportingAsset = planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.supportingAsset;
    const features = $7e46c16dbeed31a5$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : "",
            alt: description || ""
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || "" : "";
    const animation = $7e46c16dbeed31a5$var$getAnimation({
        pageVariant: pageVariant,
        keyword: keyword,
        subAnchor: subAnchor
    });
    return (0, $dPABA._)((0, $6ogO3._)({}, defaultProps, features), {
        headerText: (data === null || data === void 0 ? void 0 : data.name) || "",
        secondaryText: (data === null || data === void 0 ? void 0 : data.subheading) || "",
        image: getImage(supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url, supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: (planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.description) || "",
        animation: animation
    });
};
const $7e46c16dbeed31a5$var$getTabProps = (resp, dataProductKey, pageVariant, keyword, subAnchor)=>{
    const defaultProps = {
        dataProductKey: dataProductKey,
        headerText: "",
        tabStyles: {
            defaultBG: (0, $kbpa7.wacToken)("color.neutral.light200"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultText: "#172B4D",
            hoverBG: (0, $kbpa7.wacToken)("color.neutral.light200"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverText: "#172B4D",
            activeBG: (0, $kbpa7.wacToken)("color.extended.blue100"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeText: "#172B4D"
        },
        styles: {
            "--lp-tabs-hover": "#0C66E4",
            "--lp-tabs-unselected": "#172B4D"
        },
        tabs: undefined
    };
    if (!resp || !resp[0]) return defaultProps;
    const tabs = $7e46c16dbeed31a5$var$getTabs(resp, pageVariant, keyword, subAnchor);
    const primaryMessage = $7e46c16dbeed31a5$var$getPrimaryMessage(resp);
    return (0, $dPABA._)((0, $6ogO3._)({}, defaultProps), {
        landingType: $7e46c16dbeed31a5$var$LANDING_TYPE,
        headerText: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
        tabs: tabs
    });
};
const $7e46c16dbeed31a5$var$getCtaWithPolygonProps = (resp, pageId, dataProductKey)=>{
    const cta = $7e46c16dbeed31a5$var$getCta(resp);
    return {
        header: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
        ctaText: (cta === null || cta === void 0 ? void 0 : cta.text) || "",
        ctaUrl: (cta === null || cta === void 0 ? void 0 : cta.url) || "",
        ctaLabel: pageId,
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue700"),
        productKey: dataProductKey,
        buttonVariant: "primary",
        buttonColor: "yellow"
    };
};
const $7e46c16dbeed31a5$var$getTestimonialProps = (resp)=>{
    var _data_customers;
    if (!resp || !resp[0]) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data === null || data === void 0 ? void 0 : data.name,
        logos: data === null || data === void 0 ? void 0 : (_data_customers = data.customers) === null || _data_customers === void 0 ? void 0 : _data_customers.map((customer)=>{
            return {
                src: customer && customer.altDarkLogo && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0]) && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].url) ? customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].url : "",
                alt: customer && customer.altDarkLogo && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0]) && (customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].description) ? customer === null || customer === void 0 ? void 0 : customer.altDarkLogo[0].description : "",
                lazy: true
            };
        })
    };
};
const $7e46c16dbeed31a5$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $7e46c16dbeed31a5$var$getResults(resp);
    function generateProps(result, index) {
        var _result_asset, _result_asset1;
        // this shouldn't go past
        const countMap = [
            "one",
            "two",
            "three",
            "four"
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($gHIMV)))(`${countMap[index]}`);
        const position = index % 2 === 1 ? "left" : "right";
        return {
            backgroundColor: (0, $kbpa7.wacToken)("color.neutral.light100"),
            [`row${count}Header`]: (result === null || result === void 0 ? void 0 : result.name) || "",
            [`row${count}Lozenge`]: (result === null || result === void 0 ? void 0 : result.lozenge) || "",
            [`row${count}Body`]: (result === null || result === void 0 ? void 0 : result.subheading) || "",
            [`row${count}ImageLink`]: result === null || result === void 0 ? void 0 : (_result_asset = result.asset) === null || _result_asset === void 0 ? void 0 : _result_asset.url,
            [`row${count}ImageAltText`]: (result === null || result === void 0 ? void 0 : (_result_asset1 = result.asset) === null || _result_asset1 === void 0 ? void 0 : _result_asset1.description) || "",
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results === null || results === void 0 ? void 0 : results.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return (0, $6ogO3._)({}, acc, curr);
    });
    return (0, $6ogO3._)({
        imageWidth: "100%",
        imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
        imageTextSideRowTwoPadding: "16px 0",
        imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px"
    }, contentBlocks);
};
const $7e46c16dbeed31a5$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $7e46c16dbeed31a5$var$getTabs = (resp, pageVariant, keyword, subAnchor)=>{
    const primaryMessage = $7e46c16dbeed31a5$var$getPrimaryMessage(resp);
    if (!primaryMessage || !(primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.supportingExample)) return undefined;
    if (pageVariant === "keywords") return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>({
            textLabel: "",
            id: "",
            component: (0, $cqCPq.generateTabComponent)(keyword, {
                title: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
                description: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
                content: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || ""
            })
        }));
    if (pageVariant === "subAnchor") return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>({
            textLabel: "",
            id: "",
            component: (0, $ik40B.generateTabComponentSubAnchor)(subAnchor, {
                title: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
                description: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
                content: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || ""
            })
        }));
    return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>{
        var _advocateQuote_advocateHeadshot, _advocateQuote_advocateHeadshot1;
        const supportingAsset = tab === null || tab === void 0 ? void 0 : tab.supportingAsset;
        const advocateQuote = tab === null || tab === void 0 ? void 0 : tab.advocateQuote;
        return {
            textLabel: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            id: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            component: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
                isShowTestimonyBorder: false,
                isIncludeTestimony: !!(tab === null || tab === void 0 ? void 0 : tab.advocateQuote),
                testimonyIsUsingTextQuotationMarks: true,
                title: (tab === null || tab === void 0 ? void 0 : tab.heading) || "",
                rawHtmlContent: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || "",
                imageSrc: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url) || "",
                imageAlt: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description) || "",
                quoteBlurb: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateQuote) || "",
                quoteName: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateName) || "",
                quoteCompany: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateJobTitle) || "",
                testimonyImageSrc: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url) || "",
                testimonyImageAlt: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.description) || ""
            }, tab === null || tab === void 0 ? void 0 : tab.name)
        };
    });
};
const $7e46c16dbeed31a5$var$getResults = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $7e46c16dbeed31a5$var$getCta = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};

});
parcelRegister("gHIMV", function(module, exports) {

var $24uwp = parcelRequire("24uwp");

var $7RbbL = parcelRequire("7RbbL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c2936778f0bf11fd$var$capitalize(string) {
    return $7RbbL($24uwp(string).toLowerCase());
}
module.exports = $c2936778f0bf11fd$var$capitalize;

});
parcelRegister("7RbbL", function(module, exports) {

var $iBcGo = parcelRequire("iBcGo");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5b86297e1fc1db25$var$upperFirst = $iBcGo('toUpperCase');
module.exports = $5b86297e1fc1db25$var$upperFirst;

});
parcelRegister("iBcGo", function(module, exports) {

var $ehULU = parcelRequire("ehULU");

var $ePM67 = parcelRequire("ePM67");

var $1GITV = parcelRequire("1GITV");

var $24uwp = parcelRequire("24uwp");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8a585375440fb5a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $24uwp(string);
        var strSymbols = $ePM67(string) ? $1GITV(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ehULU(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $d8a585375440fb5a$var$createCaseFirst;

});
parcelRegister("ehULU", function(module, exports) {

var $ezuzU = parcelRequire("ezuzU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a66eb0e6cce6b4e5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ezuzU(array, start, end);
}
module.exports = $a66eb0e6cce6b4e5$var$castSlice;

});
parcelRegister("ezuzU", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a9bc0dc53628b88a$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a9bc0dc53628b88a$var$baseSlice;

});


parcelRegister("ePM67", function(module, exports) {
/** Used to compose unicode character classes. */ var $accb234eacd9a37f$var$rsAstralRange = '\\ud800-\\udfff', $accb234eacd9a37f$var$rsComboMarksRange = '\\u0300-\\u036f', $accb234eacd9a37f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $accb234eacd9a37f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $accb234eacd9a37f$var$rsComboRange = $accb234eacd9a37f$var$rsComboMarksRange + $accb234eacd9a37f$var$reComboHalfMarksRange + $accb234eacd9a37f$var$rsComboSymbolsRange, $accb234eacd9a37f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $accb234eacd9a37f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $accb234eacd9a37f$var$reHasUnicode = RegExp('[' + $accb234eacd9a37f$var$rsZWJ + $accb234eacd9a37f$var$rsAstralRange + $accb234eacd9a37f$var$rsComboRange + $accb234eacd9a37f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $accb234eacd9a37f$var$hasUnicode(string) {
    return $accb234eacd9a37f$var$reHasUnicode.test(string);
}
module.exports = $accb234eacd9a37f$var$hasUnicode;

});

parcelRegister("1GITV", function(module, exports) {

var $3VH6A = parcelRequire("3VH6A");

var $ePM67 = parcelRequire("ePM67");

var $aYfG6 = parcelRequire("aYfG6");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $13ac8b161df780fb$var$stringToArray(string) {
    return $ePM67(string) ? $aYfG6(string) : $3VH6A(string);
}
module.exports = $13ac8b161df780fb$var$stringToArray;

});
parcelRegister("3VH6A", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2dc821c7632c8518$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $2dc821c7632c8518$var$asciiToArray;

});

parcelRegister("aYfG6", function(module, exports) {
/** Used to compose unicode character classes. */ var $7fcbab4f0bbb188c$var$rsAstralRange = '\\ud800-\\udfff', $7fcbab4f0bbb188c$var$rsComboMarksRange = '\\u0300-\\u036f', $7fcbab4f0bbb188c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7fcbab4f0bbb188c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7fcbab4f0bbb188c$var$rsComboRange = $7fcbab4f0bbb188c$var$rsComboMarksRange + $7fcbab4f0bbb188c$var$reComboHalfMarksRange + $7fcbab4f0bbb188c$var$rsComboSymbolsRange, $7fcbab4f0bbb188c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7fcbab4f0bbb188c$var$rsAstral = '[' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsCombo = '[' + $7fcbab4f0bbb188c$var$rsComboRange + ']', $7fcbab4f0bbb188c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7fcbab4f0bbb188c$var$rsModifier = '(?:' + $7fcbab4f0bbb188c$var$rsCombo + '|' + $7fcbab4f0bbb188c$var$rsFitz + ')', $7fcbab4f0bbb188c$var$rsNonAstral = '[^' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7fcbab4f0bbb188c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7fcbab4f0bbb188c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7fcbab4f0bbb188c$var$reOptMod = $7fcbab4f0bbb188c$var$rsModifier + '?', $7fcbab4f0bbb188c$var$rsOptVar = '[' + $7fcbab4f0bbb188c$var$rsVarRange + ']?', $7fcbab4f0bbb188c$var$rsOptJoin = '(?:' + $7fcbab4f0bbb188c$var$rsZWJ + '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair
].join('|') + ')' + $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + ')*', $7fcbab4f0bbb188c$var$rsSeq = $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + $7fcbab4f0bbb188c$var$rsOptJoin, $7fcbab4f0bbb188c$var$rsSymbol = '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral + $7fcbab4f0bbb188c$var$rsCombo + '?',
    $7fcbab4f0bbb188c$var$rsCombo,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair,
    $7fcbab4f0bbb188c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7fcbab4f0bbb188c$var$reUnicode = RegExp($7fcbab4f0bbb188c$var$rsFitz + '(?=' + $7fcbab4f0bbb188c$var$rsFitz + ')|' + $7fcbab4f0bbb188c$var$rsSymbol + $7fcbab4f0bbb188c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7fcbab4f0bbb188c$var$unicodeToArray(string) {
    return string.match($7fcbab4f0bbb188c$var$reUnicode) || [];
}
module.exports = $7fcbab4f0bbb188c$var$unicodeToArray;

});





parcelRegister("cqCPq", function(module, exports) {
$parcel$export(module.exports, "isTargetedKeyword", function () { return $44122322e18142b4$export$cb97405e1165a712; });
$parcel$export(module.exports, "getPageId", function () { return $44122322e18142b4$export$2ce6e339a89daf7a; });
$parcel$export(module.exports, "generateTabComponent", function () { return $44122322e18142b4$export$58cc84c10393e7c7; });
$parcel$export(module.exports, "getAnimationByKeyword", function () { return $44122322e18142b4$export$91b39788ec2acd40; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $a9lfn = parcelRequire("a9lfn");

var $2Y4QO = parcelRequire("2Y4QO");

var $a2Szx = parcelRequire("a2Szx");

var $4HcEI = parcelRequire("4HcEI");

var $cLuPb = parcelRequire("cLuPb");
const $44122322e18142b4$export$cb97405e1165a712 = (keyword = "")=>[
        "document editor",
        "documento editor",
        "document sharing",
        "doc editing",
        "editar um documento",
        "editar documentos online",
        "doc editing online",
        "doc editor online",
        "text editor online",
        "word",
        "notion",
        "google docs",
        "microsoft word",
        "microsoft word en l\xednea",
        "word gratis",
        "word editor",
        "word online",
        "microsoft word gratis descargar",
        "microsoft office",
        "spreadsheets",
        "google sheets",
        "project plan",
        "project management tool",
        "project management platform",
        "software project management tools",
        "project management template",
        "plan del proyecto",
        "task list",
        "digital diagram",
        "diagrama digital",
        "diagrama de flujo",
        "online flow chart",
        "creador de diagramas de flujo",
        "diagramas de flujo online",
        "hacer un diagrama de flujo",
        "diagrama de flujo online",
        "programas para hacer diagramas de flujo",
        "fluxograma online",
        "diagrama de flujo online gratis",
        "flowchart",
        "criar mapas mentais"
    ].includes(keyword);
const $44122322e18142b4$export$2ce6e339a89daf7a = (keyword = "")=>{
    return ({
        "document editor": "paid-lp-conf-keywords-documentation",
        "documento editor": "paid-lp-conf-keywords-documentation",
        "document sharing": "paid-lp-conf-keywords-documentation",
        "doc editing": "paid-lp-conf-keywords-documentation",
        "editar um documento": "paid-lp-conf-keywords-documentation",
        "editar documentos online": "paid-lp-conf-keywords-documentation",
        "doc editing online": "paid-lp-conf-keywords-documentation",
        "doc editor online": "paid-lp-conf-keywords-documentation",
        "text editor online": "paid-lp-conf-keywords-documentation",
        "word": "paid-lp-conf-keywords-competitors",
        "notion": "paid-lp-conf-keywords-competitors",
        "google docs": "paid-lp-conf-keywords-competitors",
        "microsoft word": "paid-lp-conf-keywords-competitors",
        "microsoft word en l\xednea": "paid-lp-conf-keywords-competitors",
        "word gratis": "paid-lp-conf-keywords-competitors",
        "word editor": "paid-lp-conf-keywords-competitors",
        "word online": "paid-lp-conf-keywords-competitors",
        "microsoft word gratis descargar": "paid-lp-conf-keywords-competitors",
        "microsoft office": "paid-lp-conf-keywords-competitors",
        "spreadsheets": "paid-lp-conf-keywords-spreadsheets",
        "google sheets": "paid-lp-conf-keywords-spreadsheets",
        "project plan": "paid-lp-conf-keywords-project-plan",
        "project management tool": "paid-lp-conf-keywords-project-plan",
        "project management platform": "paid-lp-conf-keywords-project-plan",
        "software project management tools": "paid-lp-conf-keywords-project-plan",
        "project management template": "paid-lp-conf-keywords-project-plan",
        "plan del proyecto": "paid-lp-conf-keywords-project-plan",
        "task list": "paid-lp-conf-keywords-task-list",
        "digital diagram": "paid-lp-conf-keywords-digital-diagram",
        "diagrama digital": "paid-lp-conf-keywords-digital-diagram",
        "diagrama de flujo": "paid-lp-conf-keywords-digital-diagram",
        "online flow chart": "paid-lp-conf-keywords-digital-diagram",
        "creador de diagramas de flujo": "paid-lp-conf-keywords-digital-diagram",
        "diagramas de flujo online": "paid-lp-conf-keywords-digital-diagram",
        "hacer un diagrama de flujo": "paid-lp-conf-keywords-digital-diagram",
        "diagrama de flujo online": "paid-lp-conf-keywords-digital-diagram",
        "programas para hacer diagramas de flujo": "paid-lp-conf-keywords-digital-diagram",
        "fluxograma online": "paid-lp-conf-keywords-digital-diagram",
        "diagrama de flujo online gratis": "paid-lp-conf-keywords-digital-diagram",
        "flowchart": "paid-lp-conf-keywords-digital-diagram",
        "criar mapas mentais": "paid-lp-conf-keywords-mental-map"
    })[keyword] || "paid-lp-conf-keywords-documentation";
};
const $44122322e18142b4$export$58cc84c10393e7c7 = (keyword = "", tab)=>{
    let videoProps;
    if ([
        "spreadsheets",
        "google sheets"
    ].includes(keyword)) videoProps = {
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
    };
    else if ([
        "digital diagram",
        "diagrama digital",
        "diagrama de flujo",
        "criar mapas mentais",
        "online flow chart",
        "creador de diagramas de flujo",
        "diagramas de flujo online",
        "hacer un diagrama de flujo",
        "diagrama de flujo online",
        "programas para hacer diagramas de flujo",
        "fluxograma online",
        "diagrama de flujo online gratis",
        "flowchart"
    ].includes(keyword)) videoProps = {
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
    };
    else videoProps = {
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4Tabs), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), (0, $dPABA._)((0, $6ogO3._)({}, videoProps), {
            showBackground: true,
            active: true,
            showAsterisks: true,
            hideSeparator: true,
            title: tab.title,
            description: tab.description,
            iconCollection: Array.from(new DOMParser().parseFromString(tab.content, "text/html").querySelectorAll("p")).slice(0, 3).map((p, i)=>({
                    description: p.textContent || "",
                    icon: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4HcEI.Rocket), {
                            size: "small"
                        }, "Rocket"),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Y4QO.Megaphone), {
                            size: "small"
                        }, "Megaphone"),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a2Szx.Notepad), {
                            size: "small"
                        }, "Notepad")
                    ][i]
                }))
        }))
    });
};





const $44122322e18142b4$export$91b39788ec2acd40 = (keyword)=>{
    let animation;
    if ([
        "spreadsheets",
        "google sheets"
    ].includes(keyword)) animation = (parcelRequire("it4Xd"));
    else if ([
        "digital diagram",
        "diagrama digital",
        "diagrama de flujo",
        "criar mapas mentais",
        "online flow chart",
        "creador de diagramas de flujo",
        "diagramas de flujo online",
        "hacer un diagrama de flujo",
        "diagrama de flujo online",
        "programas para hacer diagramas de flujo",
        "fluxograma online",
        "diagrama de flujo online gratis",
        "flowchart"
    ].includes(keyword)) animation = (parcelRequire("eHjoD"));
    else if ([
        "project plan",
        "project management tool",
        "project management platform",
        "software project management tools",
        "project management template",
        "plan del proyecto"
    ].includes(keyword)) animation = (parcelRequire("6RSzT"));
    else if ([
        "task list"
    ].includes(keyword)) animation = (parcelRequire("bc9ce"));
    else animation = (parcelRequire("aljB9"));
    return animation ? {
        lottieAnimationPromise: animation
    } : undefined;
};

});
parcelRegister("it4Xd", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gjPKD")).then(()=>parcelRequire('djZoW'));

});

parcelRegister("eHjoD", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("2Ev8p")).then(()=>parcelRequire('jczec'));

});

parcelRegister("6RSzT", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("32L2j")).then(()=>parcelRequire('68Qcz'));

});

parcelRegister("bc9ce", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("67ATO")).then(()=>parcelRequire('77xjy'));

});

parcelRegister("aljB9", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("h4RwC")).then(()=>parcelRequire('aZedk'));

});




parcelRegister("9Ws6n", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantAnchorLpConfCollaboration", function () { return $7df99e51aa0e7f7e$export$bef8c54fab70371e; });
// @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $7df99e51aa0e7f7e$export$bef8c54fab70371e = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const gwp9286ConfluenceAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const carouselSlidesOriginal = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.get-on-the-same-page.title",
                defaultMessage: "Get on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.get-on-the-same-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm \u2013 all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.collaborate-live-across-time-zones.title",
                defaultMessage: "Collaborate live across time zones"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.collaborate-live-across-time-zones.body",
                defaultMessage: "Move work forward with real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.find-what-you-need.title",
                defaultMessage: "Find what you need"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Collaboration.find-what-you-need.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselSlidesGwp9286Updates = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.turn-ideas-into-action.title",
                defaultMessage: "Turn ideas into action"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.turn-ideas-into-action.body",
                defaultMessage: "Help your team think bigger, move faster, and capture ever spark."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/2p1rm3keie5h48ed6w7kag6u7m418264.webp",
            imgAltText: "Marketing brainstorming whiteboard"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.from-prompt-to-draft.title",
                defaultMessage: "From prompt to draft, in seconds"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.from-prompt-to-draft.body",
                defaultMessage: "Spend less time starting from scratch and more time refining ideas with AI."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/37xpd5m0sv6yf55n24701d48q5uf2ut7.webp",
            imgAltText: "Screenshot of using AI to create a project plan document"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.stay-in-sync.title",
                defaultMessage: "Stay in sync"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CollaborationGwp9286Updates.stay-in-sync.body",
                defaultMessage: "Keep your team aligned from project kickoff to project completion."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/8v31m8aisl4ty5cg1xf0nuhjdfnqmk37.webp",
            imgAltText: "Screenshot of Rovo providing a summary of what changed on the page"
        }
    ];
    const carouselSlides = gwp9286ConfluenceAnchorUpdates ? carouselSlidesGwp9286Updates : carouselSlidesOriginal;
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-collaboration-carousel",
        "slides": carouselSlides,
        "usePlainContainer": gwp9286ConfluenceAnchorUpdates
    };
    const pageId = "anchor-lp-conf-collaboration";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true,
            usePlainContainer: gwp9286ConfluenceAnchorUpdates
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-AnchorLpConfCollaboration",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});
parcelRegister("eRc0B", function(module, exports) {
$parcel$export(module.exports, "carouselHeroMessages", function () { return (parcelRequire("jxpLG")).carouselHeroMessages; });
parcelRequire("jxpLG");

});
parcelRegister("jxpLG", function(module, exports) {
$parcel$export(module.exports, "carouselHeroMessages", function () { return $5c8eb521db6c66c7$export$556302becf693fc2; });

var $fnHPc = parcelRequire("fnHPc");
const $5c8eb521db6c66c7$export$556302becf693fc2 = (0, $fnHPc.defineMessages)({
    ariaLabel: {
        id: "ConfluenceSoftwarePage.v4.CarouselHero.AriaLabel",
        defaultMessage: "A display of various confluence features",
        description: "Aria label for the carousel section"
    }
});

});



parcelRegister("kufmD", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorCompetitors", function () { return $b9f721f682896de7$export$97018adfbdd04630; });
// @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $b9f721f682896de7$export$97018adfbdd04630 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.achieve-team-goals-together.title",
                defaultMessage: "Achieve team goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.achieve-team-goals-together.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.get-everyone-on-the-same-page.body",
                defaultMessage: "Collaborate with your teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.connect-teams-content-context.title",
                defaultMessage: "Connect teams, content, and context"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Competitors.connect-teams-content-context.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-competitors-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-competitors";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConflCompetitors",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});

parcelRegister("gKC0O", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorCustomerService", function () { return $00e2e8c4b076dd53$export$dee2b0bf0794eecf; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $00e2e8c4b076dd53$export$dee2b0bf0794eecf = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    // TODO: add missing images
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.dynamic-documentation.body",
                defaultMessage: "Brainstorm ideas and workflows, document best practices, and share knowledge\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.scale-practices.title",
                defaultMessage: "Scale best practices across your org"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.scale-practices.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/k2it51f6l70x62mw505kfe305m744wnv.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.connect-your-work.title",
                defaultMessage: "Centralize and connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.CustomerService.connect-your-work.body",
                defaultMessage: "Keep FAQs and commonly referenced documentation organized and easily findable in dedicated workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/23124865qxudxy6cj8rl3g6my5h472d7.webp",
            imgAltText: "Organized Customer Success Hub in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-customer-service-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-customerservice";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "customerService",
        dataProductKey: "confluence-AnchorLpConfCustomerService",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("fTqPM", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorDesign", function () { return $218b189f0b6f91ef$export$e823aa878f5ce57e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $218b189f0b6f91ef$export$e823aa878f5ce57e = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.dynamic-documentation.body",
                defaultMessage: "Brainstorm ideas, document design guidelines, and take notes\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.same-page.body",
                defaultMessage: "Collaborate with cross-functional teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.context-designers-need.title",
                defaultMessage: "The context designers need"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Design.context-designers-need.body",
                defaultMessage: "Stay organized with dedicated team workspaces, all equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-design-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-design";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "design",
        dataProductKey: "confluence-AnchorLpConfDesign",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("e18uw", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorEngineering", function () { return $f16f31b365271cf4$export$e45207782b7349c7; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $f16f31b365271cf4$export$e45207782b7349c7 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const pageId = "anchor-lp-conf-team-engineering";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.dynamic-documentation.body",
                defaultMessage: "Brainstorm workflows, plan sprints, and take release notes\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0du4h6u1u85gdfw51btwg1w486m05ehy.webp",
            imgAltText: "A Confluence page with advanced roadmap integration"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.get-everyone-on-the-same-page.body",
                defaultMessage: "Collaborate with cross-functional teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/b2d5d0n6c3585bx8t07l0kmlsd36648q.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.the-context-software-developers-need.title",
                defaultMessage: "The context software developers need"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Engineering.the-context-software-developers-need.body",
                defaultMessage: "Stay organized with dedicated team workspaces, all equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/21k4hektb512gekkj3ibm325ahan4vrh.webp",
            imgAltText: "A Confluence page titled Project Hub"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-engineering-carousel",
        "slides": carouselSlides
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "engineering",
        dataProductKey: "confluence-PaidLpConflEngineering",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection,
        teamType: ""
    }));
};

});

parcelRegister("ccCRD", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorHr", function () { return $8f53ed6e7f86da34$export$d807d62fc3dbe5f7; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $8f53ed6e7f86da34$export$d807d62fc3dbe5f7 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.source-of-truth.title",
                defaultMessage: "A single source of truth"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.source-of-truth.body",
                defaultMessage: "Confluence brings together recruiting, onboarding, and employee development\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ow1y2k84sc71x364sfir34k2fu2k4o8.webp",
            imgAltText: "Organized HR Hub in Confluence"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.scale-practices.title",
                defaultMessage: "Scale best practices across your org"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.scale-practices.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1d4ro6h610bxw33m1v70c0ik55110tmg.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.simplify-workflows.title",
                defaultMessage: "Simplify HR workflows"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Hr.simplify-workflows.body",
                defaultMessage: "Brainstorm ideas for employee engagement, coordinate training, and share announcements with the entire org."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/g46gcy7jab7kyu00487ys6bkiv0e7a1f.webp",
            imgAltText: "Ideas on Confluence Sticky Notes"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-hr-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-hr";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "hr",
        dataProductKey: "confluence-AnchorLpConfHr",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("kqZTJ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorLegal", function () { return $2afaed4f728ce6ce$export$b53560d6986ee58d; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $2afaed4f728ce6ce$export$b53560d6986ee58d = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.dynamic-documentation.title",
                defaultMessage: "Dynamic Documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.dynamic-documentation.body",
                defaultMessage: "Brainstorm on whiteboards, draft pages, and record video messages. Customize documentation to suit your clients' and team's needs."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.same-page.title",
                defaultMessage: "Get on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.same-page.body",
                defaultMessage: "Collaborate with your team using real-time editing and inline comments. Easily manage permissions so only the right people have access to information."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.centralize-work.title",
                defaultMessage: "Centralize and connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Legal.centralize-work.body",
                defaultMessage: "Keep commonly used legal forms, decision registers, and meeting notes organized in dedicated workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/prhqp320pa2f46636madbq6hv2kuff62.webp",
            imgAltText: "Organized Legal Hub in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-legal-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-legal";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "legal",
        dataProductKey: "confluence-AnchorLpConfLegal",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("kShM7", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorMarketing", function () { return $7668325f98bd6281$export$11286c25bf03cb0c; });
// @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $7668325f98bd6281$export$11286c25bf03cb0c = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-goals.title",
                defaultMessage: "Achieve marketing goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-goals.body",
                defaultMessage: "Plan campaigns, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.same-page.body",
                defaultMessage: "Collaborate with cross-functional teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-deadlines.title",
                defaultMessage: "Hit marketing launch deadlines"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.marketing-deadlines.body",
                defaultMessage: "Stay organized with dedicated marketing workspaces equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-marketing-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-marketing";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        // TODO: replace with pageProps.persona when all personas are added
        persona: "unknown",
        pageVariant: "marketing",
        dataProductKey: "confluence-AnchorLpConfMarketing",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("4f5AO", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorOperations", function () { return $dac1d4b98d26b348$export$75eaa13c52290701; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $dac1d4b98d26b348$export$75eaa13c52290701 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.dynamic-documentation.body",
                defaultMessage: "Brainstorm more efficient workflows, manage resources, and share knowledge\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.streamline-processes.title",
                defaultMessage: "Streamline processes and team efficiency"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.streamline-processes.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/n5g67a5u6744u0183v1em5q6rjc4oer5.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Operations.same-page.body",
                defaultMessage: "Keep teams organized with dedicated workspaces, all equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-operations-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-operations";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "operations",
        dataProductKey: "confluence-AnchorLpConfOperations",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("SJn7F", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorProgramMgmt", function () { return $4c7606deb194f802$export$7f35a3c71359f12a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $hswtB = parcelRequire("hswtB");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $4c7606deb194f802$export$7f35a3c71359f12a = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    // TODO: add missing images
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-goals.title",
                defaultMessage: "Achieve project goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-goals.body",
                defaultMessage: "Brainstorm ideas, plan projects, take notes, and share knowledge\u2014all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.team-efficiency.title",
                defaultMessage: "Streamline processes and team efficiency"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.team-efficiency.body",
                defaultMessage: "Boost productivity by using Automation to coordinate workflows, prompting next steps when a dependency is completed."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/3rpsu66gd78285buk60k1t08w568ds37.webp",
            imgAltText: "A Confluence automation rule"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-deadlines.title",
                defaultMessage: "Hit project deadlines"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.ProgramMgmt.project-deadlines.body",
                defaultMessage: "Keep teams organized with dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-program-management-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-team-programmgmt";
    let customHeroSection = null;
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: pageId,
        persona: "unknown",
        pageVariant: "programMgmt",
        dataProductKey: "confluence-AnchorLpConfProgramMgmt",
        carouselHeroProps: carouselHeroProps,
        keyword: pageProps.keyword,
        customHeroSection: customHeroSection
    }));
};

});

parcelRegister("8vTdi", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorTeamwork", function () { return $4ea0580cfd773d5e$export$c24154344f2ebeeb; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");
parcelRequire("eRc0B");
var $jxpLG = parcelRequire("jxpLG");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $4ea0580cfd773d5e$export$c24154344f2ebeeb = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.get-everyone-on-the-same-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.bring-teams-together.title",
                defaultMessage: "Bring teams together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.bring-teams-together.body",
                defaultMessage: "Invite your teams to collaborate using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.centralize-the-teams-work.title",
                defaultMessage: "Centralize the team\u2019s work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Teamwork.centralize-the-teams-work.body",
                defaultMessage: "Stay organized and up-to-date with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": intl.formatMessage((0, $jxpLG.carouselHeroMessages).ariaLabel),
        "id": "confluence-teamwork-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-teamwork";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-AnchorLpConfTeamwork",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});

parcelRegister("drgFv", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageAnchorWorkManagement", function () { return $e31d55af448a7f73$export$9fca2d06de428e79; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $e31d55af448a7f73$export$9fca2d06de428e79 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.move-work-forward.title",
                defaultMessage: "Move work forward"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.move-work-forward.body",
                defaultMessage: "Plan projects, take notes, and brainstorm \u2014 all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.work-better-together.title",
                defaultMessage: "Work better, together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.work-better-together.body",
                defaultMessage: "Collaborate with your teams with real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.connect-all-your-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.WorkManagement.connect-all-your-work.body",
                defaultMessage: "Stay organized and up-to-date with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-work-management-carousel",
        "slides": carouselSlides
    };
    const pageId = "anchor-lp-conf-work-management";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConfWorkManagementAutomation",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});

parcelRegister("WuRB2", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfFeatures", function () { return $02f5ad054c73b27b$export$8f2e6fd6be55a708; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $cR8Gg = parcelRequire("cR8Gg");

var $doAVE = parcelRequire("doAVE");

var $kbpa7 = parcelRequire("kbpa7");

var $5fw4P = parcelRequire("5fw4P");

var $a5uC7 = parcelRequire("a5uC7");

var $bspxF = parcelRequire("bspxF");

var $9H2hw = parcelRequire("9H2hw");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $32ng3 = parcelRequire("32ng3");

var $1ka2O = parcelRequire("1ka2O");

var $6gQvZ = parcelRequire("6gQvZ");

var $ik40B = parcelRequire("ik40B");
const $02f5ad054c73b27b$export$8f2e6fd6be55a708 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    // Evaluate condition for Conf BPS with Bandits
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    const isEnglishLocale = (0, $6gQvZ.useEnglishLocale)();
    const locationSearch = (0, $1ka2O.useLocation)().search;
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure,
        pageProps.subAnchor
    ]);
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const gwp9286ConfluenceAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const carouselLiftAndShift = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.title",
                defaultMessage: "Start with a page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.start-with-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/cs8c8dbwh841g64nad3y8o63fo6peqkv.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.title",
                defaultMessage: "Share with your teams"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.share-with-teams.body",
                defaultMessage: "Invite your teams to collaborate using real-time editing and inline comments."
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/63i2v45spmjd7q66mqefep624mf6y20h.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSection.connect-work.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            // will fix in separate ticket GWP-4659
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/o47q33qpw6cp3211df81a3noi34e41ib.webp",
            imgAltText: "A Confluence page with a summary being generated by Atlassian Intelligence"
        }
    ];
    const carouselSlidesGwp9286Updates = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.create-more-together.title",
                defaultMessage: "Create more together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.create-more-together.body",
                defaultMessage: "Instantly draft and brainstorm with Rovo AI and plan for any project"
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/l8pf65qmp34as5x0u4d57k7x7hq82k45/Anchor_Journey_Confluence_Brand_Carousel_1.webp",
            imgAltText: "Create more together"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.collaborate-across-teams.title",
                defaultMessage: "Collaborate across teams"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.collaborate-across-teams.body",
                defaultMessage: "Move projects forward faster with human-AI collaboration"
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/sfr1x0ctcr3k8w56256gb5787tta8s8t/Anchor_Journey_Confluence_Brand_Carousel_2.webp",
            imgAltText: "Collaborate across teams"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.connect-knowledge-from-anywhere.title",
                defaultMessage: "Connect knowledge from anywhere"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.FeaturesSectionGwp9286Updates.connect-knowledge-from-anywhere.body",
                defaultMessage: "Get relevant answers across all your tools with AI-powered search"
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/krl10r0n7l1x62114173sia1ws136md4/Anchor_Journey_Confluence_Brand_Carousel_3.webp",
            imgAltText: "Connect knowledge from anywhere"
        }
    ];
    const carouselSlides = gwp9286ConfluenceAnchorUpdates ? carouselSlidesGwp9286Updates : carouselLiftAndShift;
    const showDefault = !shouldShowLogMeIn;
    let customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
        pageId: showDefault ? "confluence-default" : "paid-lp-conf-features",
        embeddedSignup: {
            bundle: "confluence"
        },
        carouselSlides: carouselSlides,
        keyword: pageProps.keyword,
        usePlainContainer: gwp9286ConfluenceAnchorUpdates
    });
    if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2801-get-paid-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
            confluenceSites: recentSites,
            userProfileName: userProfileName,
            hideExploreMore: true,
            loggedInPaid: true
        })
    });
    const props = {
        customHeroSection: customHeroSection,
        heroProps: {
            headerText: intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroHeader",
                defaultMessage: "Accomplish more together with Confluence"
            }),
            secondaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroBody",
                defaultMessage: "So many features, so little time \u2014 all built to meet your team\u2019s needs"
            }),
            featuresLabel: intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListHeading",
                defaultMessage: "What you get on the free plan:"
            }),
            featuresList: [
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem1",
                    defaultMessage: "Supports up to 10 users or 3 agents"
                }),
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem2",
                    defaultMessage: "Includes 2 GB of storage"
                }),
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem3",
                    defaultMessage: "Offers Community support"
                }),
                intl.formatMessage({
                    id: "ConfluenceSoftwarePagePaidLpConfFeatures.heroListItem4",
                    defaultMessage: "Is always free, no credit card needed"
                })
            ],
            signup: {
                bundle: "confluence",
                edition: "free"
            }
        },
        tabsProps: {
            dataProductKey: "confluence-PaidLpConflFeatures",
            headerText: gwp9286ConfluenceAnchorUpdates ? intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsHeader",
                defaultMessage: "Power every stage of work with Confluence"
            }) : intl.formatMessage({
                id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader",
                defaultMessage: "Jump start company-wide collaboration with fewer tools by using Confluence."
            }),
            tabStyles: {
                // eslint-disable-next-line local/ensure-wac-token-usage
                defaultBG: "#ebecf0",
                // eslint-disable-next-line local/ensure-wac-token-usage
                defaultText: "#42526e",
                // eslint-disable-next-line local/ensure-wac-token-usage
                activeBG: "#0747a6",
                activeText: (0, $kbpa7.wacToken)("color.neutral.light0"),
                // eslint-disable-next-line local/ensure-wac-token-usage
                hoverBG: "#ebecf0",
                // eslint-disable-next-line local/ensure-wac-token-usage
                hoverText: "#42526e"
            },
            styles: {
                "--lp-tabs-hover": "#c1c7d0",
                "--lp-tabs-unselected": "#6b778c"
            },
            tabs: gwp9286ConfluenceAnchorUpdates ? [
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.create",
                        defaultMessage: "Create"
                    }),
                    id: "tab-create",
                    component: $02f5ad054c73b27b$var$CreateGwp9286()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.transform-work",
                        defaultMessage: "Transform work"
                    }),
                    id: "tab-transform-work",
                    component: $02f5ad054c73b27b$var$TransformWorkGwp9286()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.stay-up-to-date",
                        defaultMessage: "Stay up to date"
                    }),
                    id: "tab-stay-up-to-date",
                    component: $02f5ad054c73b27b$var$StayUpToDateGwp9286()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.pill.get-answers",
                        defaultMessage: "Get answers"
                    }),
                    id: "tab-get-answers",
                    component: $02f5ad054c73b27b$var$GetAnswersGwp9286()
                }
            ] : [
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.documentation",
                        defaultMessage: "Documentation"
                    }),
                    id: "tab-documentation",
                    component: $02f5ad054c73b27b$var$Documentation()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.collaboration",
                        defaultMessage: "Collaboration"
                    }),
                    id: "tab-collaboration",
                    component: $02f5ad054c73b27b$var$Collaboration()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.truth",
                        defaultMessage: "Single source of truth"
                    }),
                    id: "tab-truth",
                    component: $02f5ad054c73b27b$var$Truth()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.pill.templates",
                        defaultMessage: "Templates"
                    }),
                    id: "tab-templates",
                    component: $02f5ad054c73b27b$var$Templates()
                }
            ]
        },
        keyword: pageProps.keyword,
        subAnchor: pageProps.subAnchor
    };
    if (showDefault) props.testimonialProps = undefined;
    const isBanditsEnabled = isLoggedOut && isEnglishLocale && locationSearch.includes("keyword");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        isExperimentEnabled: isBanditsEnabled,
        keyword: pageProps.keyword,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9H2hw.PaidLandingConfTemplate), (0, $6ogO3._)({}, props))
    });
};
/* GWP-9286 Updated Tabs */ const $02f5ad054c73b27b$var$CreateGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.heading",
        defaultMessage: "Put pen to paper without the heavy lifting"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.listItem1",
            defaultMessage: "Beat the blank page with AI-powered creation that brings your ideas to life in seconds."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.listItem2",
            defaultMessage: "Start fast with pre-built templates for meeting notes, project plans, retros, and more."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.create.listItem3",
            defaultMessage: "Articulate your ideas in a variety of content types such as pages, whiteboards, and databases."
        }, "listItem3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/k71m1n07jgo4dqk526dw11nhw4ia441p/Anchor_Journey_Confluence_Brand_Tab_1.webp";
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.create",
        defaultMessage: "Create"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$TransformWorkGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.heading",
        defaultMessage: "Transform ideas into action"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.listItem1",
            defaultMessage: "Turn brainstorms into structured plans with AI that organizes thoughts for you."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.listItem2",
            defaultMessage: "Push work forward with seamlessly integrations with tools like Jira and other 3rd party apps"
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.transform-work.listItem3",
            defaultMessage: "Collaborate with teammates in real-time on flexible content types like whiteboards, pages, and databases."
        }, "listItem3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/12kbaa12oil2751c30185853j6413vb2/Anchor_Journey_Confluence_Brand_Tab_2.webp";
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.transform-work",
        defaultMessage: "Transform work"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$StayUpToDateGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.heading",
        defaultMessage: "Stay in the know, your way"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.listItem1",
            defaultMessage: "AI summaries and audio briefings make it quick and easy to stay caught up on all things work."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.listItem2",
            defaultMessage: "Get notified when content gets updated or when teammates share new information."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.stay-up-to-date.listItem3",
            defaultMessage: "Stay up to date on work happening across your org with personalized feeds."
        }, "listItem3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/3u2u80i2k4wnm266fqmtgnemy6d1ljt3/Anchor_Journey_Confluence_Brand_Tab_3.webp";
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.stay-up-to-date",
        defaultMessage: "Stay up to date"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$GetAnswersGwp9286 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.heading",
        defaultMessage: "Get context and answers in seconds"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.listItem1",
            defaultMessage: "Find exactly what you need with AI-powered search that understands context and company jargon."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.listItem2",
            defaultMessage: "Organize work into workspaces that centralize key information and break down siloes."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.get-answers.listItem3",
            defaultMessage: "Spend less time digging and more time doing with connected knowledge across teams."
        }, "listItem3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/4648h612p8824q33utwoa73nr08717n5/Anchor_Journey_Confluence_Brand_Tab_4.webp";
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeaturesGwp9286Updates.tabSection.tabsImageAltText.get-answers",
        defaultMessage: "Get answers"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
/* Tabs */ const $02f5ad054c73b27b$var$Documentation = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.documentation",
        defaultMessage: "Create better documentation for your teams"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem1",
            defaultMessage: "Organize pages, attachments, and even spaces with keyword labels \u2014 such as meeting type or project name."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem2",
            defaultMessage: "Use the advanced search & page tree to quickly find and label key docs in a well-organized page tree."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.documentation.listItem3",
            defaultMessage: "Use the Table of Contents macro to help colleagues quickly locate information."
        }, "listItem3")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)("documentation", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.documentation",
        defaultMessage: "Documentation"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$Collaboration = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.collaboration",
        defaultMessage: "Collaborate with teams in real-time"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem1",
            defaultMessage: "Co-edit together in real time and publish updates that highlight changes."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem2",
            defaultMessage: "Make it a \u201Cteam effort\u201D with in-line and page comments, likes, and visual elements, such as images, GIFs, and emojis."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.collaboration.listItem3",
            defaultMessage: "Alert your teammates when you tag them or assign a task so everyone stays on top of progress."
        }, "listItem3")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)("collaboration", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.collaboration",
        defaultMessage: "Project collaboration"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$Truth = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.truth",
        defaultMessage: "Share information between teams"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.truth.listItem1",
            defaultMessage: "Keep employees informed with open access to information they need, but share and protect sensitive content with permission settings."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.truth.listItem2",
            defaultMessage: "Easily get back to recent spaces, in-progress work, and drafts, and stay updated with activity and popular feeds on your personal \u201Chomepage.\u201D"
        }, "listItem2")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)("truth", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.truth",
        defaultMessage: "Program manager hub"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $02f5ad054c73b27b$var$Templates = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsHeader.templates",
        defaultMessage: "There\u2019s a template for that"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem1",
            defaultMessage: "Use best-practices templates, from product roadmaps to marketing plans so you can quickly jump right in."
        }, "listItem1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem2",
            defaultMessage: "Kickstart the creation stage by spending less time formatting pages and more time getting sh*t done."
        }, "listItem2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.templates.listItem3",
            defaultMessage: "Start with a blank page or choose from over 75 customizable templates for every team\u2013from strategy and planning docs to reports."
        }, "listItem3")
    ];
    const imageSrc = (0, $5fw4P.getLocalizedImage)("templates", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "ConfluenceSoftwarePagePaidLpConfFeatures.tabSection.tabsImageAltText.templates",
        defaultMessage: "Confluence templates"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};

});
parcelRegister("5fw4P", function(module, exports) {
$parcel$export(module.exports, "getLocalizedImage", function () { return $169ced6c547859d9$export$df12673c228208c7; });
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionCollaborationImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-02.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-02.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-02.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Collaboration.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-02.webp"
};
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionDocumentationImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Documentation_ja-JP.webp"
};
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionTemplatesImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-13.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-13.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-13.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_Templates.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp"
};
// no localized image for es, ru
const $169ced6c547859d9$var$tabsSectionTruthImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_de-DE-11.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_fr-FR-11.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_pt-BR-11.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Feature_SourceOfTruth.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/PFMX-359_Landing_Page_Playbook-V3_ja-JP-13.webp"
};
// no localized image for es, ru
const $169ced6c547859d9$var$rowOneImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Onboarding-graphic@2x_ja-JP.webp"
};
// no localized image for es, ru
const $169ced6c547859d9$var$rowTwoImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Development-graphic@2x_ja-JP.webp"
};
// no localized image for es, ru
const $169ced6c547859d9$var$rowThreeImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_deDE.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_frFR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ConfluenceLP_Core_Recent-graphic@2x_ja-JP.webp"
};
const $169ced6c547859d9$var$getCorrespondingImageMap = (descriptor)=>{
    switch(descriptor){
        case "collaboration":
            return $169ced6c547859d9$var$tabsSectionCollaborationImageMap;
        case "documentation":
            return $169ced6c547859d9$var$tabsSectionDocumentationImageMap;
        case "row one":
            return $169ced6c547859d9$var$rowOneImageMap;
        case "row two":
            return $169ced6c547859d9$var$rowTwoImageMap;
        case "row three":
            return $169ced6c547859d9$var$rowThreeImageMap;
        case "templates":
            return $169ced6c547859d9$var$tabsSectionTemplatesImageMap;
        case "truth":
            return $169ced6c547859d9$var$tabsSectionTruthImageMap;
        default:
            throw new Error(`Unknown descriptor: ${descriptor}`);
    }
};
const $169ced6c547859d9$export$df12673c228208c7 = (descriptor, locale)=>{
    const map = $169ced6c547859d9$var$getCorrespondingImageMap(descriptor);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return map[locale] || map["en"];
};

});

parcelRegister("9H2hw", function(module, exports) {
$parcel$export(module.exports, "PaidLandingConfTemplate", function () { return $297747c88b640aa1$export$5c32e5cc9dc425db; });
/* eslint-disable local/ensure-wac-token-usage */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $2emUn = parcelRequire("2emUn");

var $28AH4 = parcelRequire("28AH4");

var $5fw4P = parcelRequire("5fw4P");

var $2ve7k = parcelRequire("2ve7k");

var $kZQhV = parcelRequire("kZQhV");
const $297747c88b640aa1$export$5c32e5cc9dc425db = (props)=>{
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $2ve7k.useLoggedInUser)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        const { keyword: keyword, subAnchor: subAnchor } = props;
        const anchorLocalStorage = {};
        if (!!keyword) anchorLocalStorage.keyword = keyword;
        if (!!subAnchor) anchorLocalStorage.subAnchor = subAnchor;
        if (Object.keys(anchorLocalStorage).length > 0) setAnchorLocalStorage(anchorLocalStorage);
    }, [
        props.keyword
    ]);
    const embeddedSignup = !userInfo.isUserLoggedIn && !userInfo.requestInProgress ? {
        bundle: "confluence",
        edition: "free",
        useCurrentRedirect: true
    } : undefined;
    (0, $2emUn.useFeatureExposed)("cfind-1254-paid-embedded-signup-form", "Test", {
        conditions: [
            !!embeddedSignup
        ]
    });
    const finalProps = (0, $dPABA._)((0, $6ogO3._)({
        landingType: "confluence-paid",
        productNavProps: {
            productHref: (0, $kooLp.useLocalizedHref)("/software/confluence"),
            productName: "confluence",
            ariaLabel: intl.formatMessage({
                id: "wacConfluenceNavigation.logo-label",
                defaultMessage: "Confluence logo"
            }),
            dataProductKey: "confluence",
            showFreeHrefButton: false
        },
        alternatingTextAndImageProps: {
            backgroundColor: "#e6fcff",
            horizontalRuleColor: "#dfe1e5",
            //Row 1
            rowOneHeader: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneHeader",
                defaultMessage: "Move work forward"
            }),
            rowOneBody: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneBody",
                defaultMessage: "Kickstart collaboration with a flexible workspace \u2014 from actionable meeting notes to inspiring project plans."
            }),
            rowOneImageLink: (0, $5fw4P.getLocalizedImage)("row one", intl.locale),
            rowOneImageAltText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowOneImageAltText",
                defaultMessage: "Screenshot of IT template"
            }),
            //Row 2
            rowTwoHeader: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoHeader",
                defaultMessage: "Capture all the knowledge"
            }),
            rowTwoBody: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoBody",
                defaultMessage: "Save everyone time by harnessing your teams' collective knowledge into easy-to-find information."
            }),
            rowTwoImageLink: (0, $5fw4P.getLocalizedImage)("row two", intl.locale),
            rowTwoImageAltText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowTwoImageAltText",
                defaultMessage: "Screenshot of strategic template in use"
            }),
            //Row 3
            rowThreeHeader: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeHeader",
                defaultMessage: "Inspire conversation & connection"
            }),
            rowThreeBody: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeBody",
                defaultMessage: "Motivate teams company-wide to share announcements, comment, and provide feedback."
            }),
            rowThreeImageLink: (0, $5fw4P.getLocalizedImage)("row three", intl.locale),
            rowThreeImageAltText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.alternatingTextAndImage.rowThreeImageAltText",
                defaultMessage: "Screenshot of IT template"
            })
        },
        ctaProps: {
            headerText: intl.formatMessage({
                id: "ConfluenceSoftwarePage.paidLpConfDefault.ctaSection.title",
                defaultMessage: "Make quick decisions, gain alignment, and transform how your team works together."
            }),
            ctaProps: {
                buttonProps: {
                    color: "yellow",
                    url: "#start-trial",
                    text: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.ctaSection.button",
                        defaultMessage: "Get it free"
                    }),
                    dataEventProps: {
                        "data-event": "clicked",
                        "data-event-container": "ctaSection",
                        "data-event-component": "linkButton",
                        "data-product-key": "confluence"
                    }
                }
            }
        },
        testimonialProps: {
            headerText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.paidLpConfDefault.customerSection.customersUseConfluenceToMoveWorkForward",
                defaultMessage: "75,000+ customers use Confluence to move work forward."
            }),
            logoSize: "large",
            logos: [
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:b12e4075-84f4-467e-9acf-f062c8fdaece/twilio-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.twilio",
                        defaultMessage: "Twilio logo"
                    }),
                    width: "107px",
                    height: "32px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:35c6a74c-a259-4dac-8df8-ea8c5b12f44d/nasa-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.nasa",
                        defaultMessage: "NASA logo"
                    }),
                    width: "71px",
                    height: "60px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:5a1e47e3-be98-4279-a3a2-c626164dbd5d/illumina-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.illumina",
                        defaultMessage: "Illumina logo"
                    }),
                    width: "100px",
                    height: "24px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:731482d9-54c4-48e7-a10b-ab601ca4fbd6/docker-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.docker",
                        defaultMessage: "Docker logo"
                    }),
                    width: "126px",
                    height: "33px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:7343b372-8a2a-4156-8755-bcf38735ca6b/morningstar-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.morningStart",
                        defaultMessage: "MorningStart logo"
                    }),
                    width: "134px",
                    height: "30px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:c67f93d6-d8be-4970-b4f5-addf24c13e4e/rtr-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.rtr",
                        defaultMessage: "RTR logo"
                    }),
                    width: "43.71px",
                    height: "60px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:b62031f5-0770-46cb-a1c2-50cdacb8a0b0/anz-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.anz",
                        defaultMessage: "ANZ logo"
                    }),
                    width: "102px",
                    height: "32px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:475f41d8-45f4-48c9-a9b2-d78215ae4b16/nyt-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.theNewYorkTimes",
                        defaultMessage: "The New York Times logo"
                    }),
                    width: "223px",
                    height: "32px",
                    loading: "lazy"
                },
                {
                    src: "https://wac-cdn.atlassian.com/dam/jcr:6841df63-0c84-4075-9ac5-1ed0f8ddea17/gopro-n50.svg",
                    alt: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.paidLpConfDefault.customerSection.imgAltText.goPro",
                        defaultMessage: "GoPro logo"
                    }),
                    width: "110px",
                    height: "35px",
                    loading: "lazy"
                }
            ]
        }
    }, props), {
        heroProps: (0, $dPABA._)((0, $6ogO3._)({}, props.heroProps), {
            embeddedSignup: embeddedSignup
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), (0, $6ogO3._)({}, finalProps));
};

});


parcelRegister("8KaV5", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfKeywords", function () { return $7f70b95c93835cc1$export$bdb004359ea2e77b; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $cqCPq = parcelRequire("cqCPq");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $7f70b95c93835cc1$export$bdb004359ea2e77b = (pageProps)=>{
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "cfind-2260-nbps-paid-anchor-journey",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
            pageId: (0, $cqCPq.getPageId)(pageProps.keyword),
            persona: "unknown",
            pageVariant: "keywords",
            dataProductKey: "confluence-PaidLpConflKeywords"
        }))
    });
};

});

parcelRegister("jToCF", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConfSubAnchors", function () { return $17e66f2f4b4e1fa2$export$5bd0bf292ae6f984; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $ea4mV = parcelRequire("ea4mV");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $17e66f2f4b4e1fa2$export$5bd0bf292ae6f984 = (pageProps)=>{
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if (!exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        pageId: (0, $ik40B.getPageId)(pageProps.subAnchor),
        persona: "unknown",
        pageVariant: "subAnchor",
        dataProductKey: "confluence-PaidLpConflSubAnchor"
    }));
};

});

parcelRegister("4FLZc", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflDocumentation", function () { return $679cd8dcae2a792a$export$2a2456203daa2a03; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $32ng3 = parcelRequire("32ng3");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $679cd8dcae2a792a$export$2a2456203daa2a03 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure,
        pageProps.subAnchor
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const gwp9286ConfluenceAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9286ConfluenceAnchorUpdates);
    const carouselSlidesLiftAndShift = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.dynamic-documentation.title",
                defaultMessage: "Dynamic documentation"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.dynamic-documentation.body",
                defaultMessage: "Plan projects, take notes, and keep track of changes \u2013 all in one place."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.save-time-repeat-less.title",
                defaultMessage: "Save time, repeat less"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.save-time-repeat-less.body",
                defaultMessage: "Scale the production of documentation for faster project delivery."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/033m853kq4f084xpcj7g6l0u2da8thu4.webp",
            imgAltText: "Start a Page with a Confluence Template"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.centralize-knowledge.title",
                defaultMessage: "Centralize knowledge"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Documentation.centralize-knowledge.body",
                defaultMessage: "Stay organized and find what you need with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselSlidesGwp9286Updates = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.create-faster.title",
                defaultMessage: "Create faster"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.create-faster.body",
                defaultMessage: "Turns ideas, notes, or outlines into clear documentation in seconds with AI."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/px480pk16cki2886ch46saty0405glgc/Anchor_Journey_Confluence_Documentation_Carousel_1.webp",
            imgAltText: "Screenshots of messy notes turned into a Formatted page"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.centralize-knowledge.title",
                defaultMessage: "Centralize knowledge"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.centralize-knowledge.body",
                defaultMessage: "Build a single source of truth with team workspaces that keep documentation organized and accessible."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/rrukx4q7x2olk6o6w5e577pxf2bha32q/Anchor_Journey_Confluence_Documentation_Carousel_2.webp",
            imgAltText: "Team space overview page with content tree visible"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.stay-up-to-date.title",
                defaultMessage: "Stay up to date"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.DocumentationGwp9286Updates.stay-up-to-date.body",
                defaultMessage: "Get AI summaries of changes, comments, and updates to keep everyone aligned on the latest."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/31iyaw5g2v083bs67h44un3pswa35o3i/Anchor_Journey_Confluence_Documentation_Carousel_3.webp",
            imgAltText: "Screenshot showing AI Summary of a page"
        }
    ];
    const carouselSlides = gwp9286ConfluenceAnchorUpdates ? carouselSlidesGwp9286Updates : carouselSlidesLiftAndShift;
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-documentation-carousel",
        "slides": carouselSlides,
        "usePlainContainer": gwp9286ConfluenceAnchorUpdates
    };
    const pageId = "paid-lp-confl-documentation";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true,
            usePlainContainer: gwp9286ConfluenceAnchorUpdates
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConflDocumentation",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});

parcelRegister("45Tk8", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflProjectMgmt", function () { return $86c0ed3f454d0484$export$d2c906712b67f2f1; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $86c0ed3f454d0484$export$d2c906712b67f2f1 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.achieve-project-goals-together.title",
                defaultMessage: "Achieve project goals together"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.achieve-project-goals-together.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Let AI write your first draft."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1e81unagi717g13fj44qtgpk0h8r0537.webp",
            imgAltText: "A Confluence page being edited"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.get-everyone-on-the-same-page.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.get-everyone-on-the-same-page.body",
                defaultMessage: "Collaborate with your teams using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.hit-project-deadlines.title",
                defaultMessage: "Hit project deadlines"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Projectmgmt.hit-project-deadlines.body",
                defaultMessage: "Stay organized in dedicated workspaces, equipped with AI-powered search."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-projectmgmt-carousel",
        "slides": carouselSlides
    };
    const pageId = "paid-lp-confl-projectmgmt";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConflProjectMgmt",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});

parcelRegister("imhoT", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageVariantPaidLpConflTemplate", function () { return $ee2fe640b2b64bb2$export$e1067e28e1b2acea; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $cR8Gg = parcelRequire("cR8Gg");

var $bspxF = parcelRequire("bspxF");

var $hswtB = parcelRequire("hswtB");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $3sDDl = parcelRequire("3sDDl");

var $ik40B = parcelRequire("ik40B");
const $ee2fe640b2b64bb2$export$e1067e28e1b2acea = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $1oC0p.useEffect)(()=>{
        if ((0, $ik40B.isTargetedSubAnchor)(pageProps.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const gwpAJContextualBanditsConfluenceSubAnchor = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsConfluenceSubAnchor);
    const isCBSubAnchorExperimentEnabled = gwpAJContextualBanditsConfluenceSubAnchor.type === "enrolled" && gwpAJContextualBanditsConfluenceSubAnchor.value;
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data)
    });
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $cR8Gg.useLogMeInD0to6)({
        availableProducts: pageProps.availableProducts,
        userProfile: pageProps.userProfile
    });
    const carouselSlides = [
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.start-with-a-page.title",
                defaultMessage: "Start with a page"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.start-with-a-page.body",
                defaultMessage: "Plan projects, take notes, and brainstorm. Get started with a template."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/033m853kq4f084xpcj7g6l0u2da8thu4.webp",
            imgAltText: "Start a Page with a Confluence Template"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.share-with-your-teams.title",
                defaultMessage: "Share with your teams"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.share-with-your-teams.body",
                defaultMessage: "Invite your teams to collaborate using real-time editing and inline comments."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/i0011ky0775062fk18784clr4dcxd5wg.webp",
            imgAltText: "A Confluence page with multiple teammates editing and leaving comments"
        },
        {
            primaryText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.connect-all-your-work.title",
                defaultMessage: "Connect all your work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.Template.connect-all-your-work.body",
                defaultMessage: "Stay organized and find what you need with dedicated team workspaces."
            }),
            imgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/fpd20037c363n21cfmh45nc5m50co161.webp",
            imgAltText: "Organized workspace in Confluence"
        }
    ];
    const carouselHeroProps = {
        "aria-label": "A display of various confluence features",
        "id": "confluence-template-carousel",
        "slides": carouselSlides
    };
    const pageId = "paid-lp-confl-template";
    const isLoggedIn = !!userProfileName;
    let customHeroSection;
    const getLiftShiftHeroSectionBrandUpdate = ()=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bspxF.PaidHeroCarousel), {
            pageId: pageId,
            embeddedSignup: {
                bundle: "confluence"
            },
            carouselSlides: carouselSlides,
            shouldUseNewBrandBackground: true,
            shouldUseTransparentBackground: true
        });
    };
    if (isLoggedIn) {
        if (shouldShowLogMeIn) customHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-2801-get-paid-users-back-to-product",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hswtB.default), {
                confluenceSites: recentSites,
                userProfileName: userProfileName,
                hideExploreMore: true,
                loggedInPaid: true
            })
        });
        else customHeroSection = getLiftShiftHeroSectionBrandUpdate();
    } else // Logged out user
    customHeroSection = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).CONFLUENCE,
        keyword: pageProps.keyword,
        isExperimentEnabled: isCBSubAnchorExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_SUB_ANCHOR,
        subAnchor: pageProps.subAnchor || "",
        channel: pageProps.utmMedium || "paid-search",
        utmContent: pageProps.utmContent || "",
        utmCampaign: pageProps.utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "cfind-3090-paid-confluence-product-tour",
            group: "Test",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3sDDl.ConfluencePagePaidLpConflAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
                pageId: pageId,
                persona: "unknown",
                pageVariant: "brandUpdate",
                dataProductKey: "confluence-PaidLpConflTemplate",
                keyword: pageProps.keyword,
                carouselHeroProps: carouselHeroProps,
                customHeroSection: customHeroSection
            }))
        })
    });
};

});

parcelRegister("jYywI", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFreePage", function () { return $3e100e14641888aa$export$5c727b1e47c0f85c; });

var $kooLp = parcelRequire("kooLp");
const $3e100e14641888aa$export$5c727b1e47c0f85c = ()=>{
    const signupPath = (0, $kooLp.useLocalizedHref)("/try/cloud/signup");
    location.href = `${signupPath}?bundle=confluence&edition=free`;
    return null;
};

});

parcelRegister("30s1N", function(module, exports) {
$parcel$export(module.exports, "ConfluencePricingPage", function () { return $de7d821157dc63ae$export$6bdd18cae91b5a8; });

var $7VQPk = parcelRequire("7VQPk");

var $3L8ZR = parcelRequire("3L8ZR");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("l8kCZ");
var $bTseT = parcelRequire("bTseT");
parcelRequire("i6fBc");
var $8geYQ = parcelRequire("8geYQ");
const $de7d821157dc63ae$export$6bdd18cae91b5a8 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate("gwp-737-enable-intercom-chat-confluence");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
            productKeys: [
                (0, $20OkY.ProductKeys).CONFLUENCE
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
                productId: "confluence",
                pricingContent: pricingContent,
                queryRef: queryRef,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8geYQ.ConfluencePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("l8kCZ", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("bTseT")).IntercomProvider; });
parcelRequire("bTseT");
parcelRequire("25OgP");

});
parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $PE2DD = parcelRequire("PE2DD");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== "undefined";
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $6ogO3._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("25OgP", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("i6fBc", function(module, exports) {
$parcel$export(module.exports, "ConfluencePricingPageV2Template", function () { return (parcelRequire("8geYQ")).ConfluencePricingPageV2Template; });
parcelRequire("8geYQ");

});
parcelRegister("8geYQ", function(module, exports) {
$parcel$export(module.exports, "ConfluencePricingPageV2Template", function () { return $1a10b84a25e4b863$export$d4dd4cff5718a25c; });

var $7VQPk = parcelRequire("7VQPk");

var $in5fb = parcelRequire("in5fb");

var $kIC93 = parcelRequire("kIC93");
parcelRequire("g1ccm");
var $frz5c = parcelRequire("frz5c");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $bE8d4 = parcelRequire("bE8d4");
var $2zOxm = parcelRequire("2zOxm");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $hCHU3 = parcelRequire("hCHU3");

var $5S2vX = parcelRequire("5S2vX");

var $cxuID = parcelRequire("cxuID");
const $1a10b84a25e4b863$export$d4dd4cff5718a25c = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)("Contact Us", "Learn more");
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCHU3.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "confluence-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cxuID.default), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "confluence"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in5fb.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                    product: "confluence"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: "Confluence",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("in5fb", function(module, exports) {
$parcel$export(module.exports, "DataCenterPromoCard", function () { return $a35fac25401ec131$export$3e66a33f1e68491c; });
/* data-center-promo-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
const $a35fac25401ec131$export$3e66a33f1e68491c = ({ dataCenterContent: dataCenterContent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1pfh1ejb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Card), {
            orientation: "horizontal",
            columns: 10,
            title: dataCenterContent.title,
            body: dataCenterContent.description,
            callToAction: {
                text: "Learn more",
                href: "/enterprise/data-center"
            },
            // eslint-disable-next-line local/no-non-orangelogic-images-eslint
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg"
        })
    });
};

});

parcelRegister("kIC93", function(module, exports) {
$parcel$export(module.exports, "TwcPromo", function () { return $3b570c8d1312e036$export$f72cba571c49850d; });
/* twc-promo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $3b570c8d1312e036$export$f72cba571c49850d = ({ product: product })=>{
    const intl = (0, $8e22h.default)();
    let text = intl.formatMessage({
        id: "TeamworkCollection.promo.jira.body",
        defaultMessage: "Get Jira, Confluence, Loom, and Rovo in one collection to bring together projects, knowledge, video communication, and AI-powered insights."
    });
    if (product === "confluence") text = intl.formatMessage({
        id: "TeamworkCollection.promo.confluence.body",
        defaultMessage: "Get Confluence, Jira, Loom, and Rovo in one collection to bring together knowledge, projects, video communication, and AI-powered insights."
    });
    if (product === "loom") text = intl.formatMessage({
        id: "TeamworkCollection.promo.loom.body",
        defaultMessage: "Get Loom, Jira, Confluence, and Rovo in one collection to bring together video communication, projects, knowledge, and AI-powered insights."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1mouxy5q"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
            logo: "teamworkCollection",
            title: intl.formatMessage({
                id: "TeamworkCollection.promo.title",
                defaultMessage: "All your tools, one collection"
            }),
            text: text,
            callToActionProps: {
                link: {
                    text: intl.formatMessage({
                        id: "TeamworkCollection.promo.body",
                        defaultMessage: "Explore Teamwork Collection"
                    }),
                    href: "/collections/teamwork"
                }
            },
            pictureProps: {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1q83t675w16167510pu524e7ccp6n551.png",
                    alt: ""
                }
            },
            orientation: "horizontal-reverse",
            columns: 12,
            backgroundColor: `${(0, $kbpa7.wacToken)("color.extended.blue200")}`,
            hat: "high-right"
        })
    });
};

});

parcelRegister("cxuID", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ef1f3c8e12499aa$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $32ng3 = parcelRequire("32ng3");
const $3ef1f3c8e12499aa$var$ConfluencePriceFinder = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    const intl = (0, $8e22h.default)();
    const addSignupSourceToUrlsOnPricingPageEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).addSignupSourceToUrlsOnPricingPage);
    const signupUrlSourceQueryParam = addSignupSourceToUrlsOnPricingPageEnabled ? "&signupSource=pricing" : "";
    // planNames should not be translated
    const confluenceProductPlans = [
        {
            planName: "Free",
            offeringSku: "confluence-free",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=free&signupSource=pricing&editionIntent=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "confluence-standard",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: 150000,
            signupURLSuffix: `?bundle=confluence&edition=standard${signupUrlSourceQueryParam}`,
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "confluence-premium",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.premiumDescription",
                defaultMessage: "Connect work across teams"
            }),
            recommendationLimit: 250,
            signupLimit: 150000,
            signupURLSuffix: `?bundle=confluence&edition=premium${signupUrlSourceQueryParam}`,
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: "Enterprise",
            offeringSku: "confluence-enterprise-sku",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.enterpriseDescription",
                defaultMessage: "Advanced analytics, scale and security for enterprises"
            }),
            recommendationLimit: 5000,
            signupLimit: 150000,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "ConfluencePricingPageTeam24.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "ConfluencePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    const sourceFromProductPlans = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7546ConfluencePricingCtaCtaUrlSource);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "confluence",
            ctaUrlSource: sourceFromProductPlans ? "productPlans" : undefined,
            productPlans: confluenceProductPlans,
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.confluence,
                countryCode: props.countryCode
            })
        })
    });
};
$3ef1f3c8e12499aa$var$ConfluencePriceFinder.displayName = "ConfluencePriceFinderTeam24";
var $3ef1f3c8e12499aa$export$2e2bcd8739ae039 = $3ef1f3c8e12499aa$var$ConfluencePriceFinder;

});




parcelRegister("fenhY", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $16a2671b05b4487c$export$933c1404a4ee79b; });
const $16a2671b05b4487c$export$933c1404a4ee79b = ()=>{
    return "Confluence Pricing Page";
};

});

parcelRegister("kPZ6t", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateCategoryRelayPage", function () { return $7acae86b58c469af$export$edf498f6a1736180; });

var $7VQPk = parcelRequire("7VQPk");

var $1YXN8 = parcelRequire("1YXN8");
const $7acae86b58c469af$export$edf498f6a1736180 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("c33x4", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPage", function () { return $78d507c9edcebec4$export$bc0513752517fd32; });

var $7VQPk = parcelRequire("7VQPk");

var $gbUpX = parcelRequire("gbUpX");
const $78d507c9edcebec4$export$bc0513752517fd32 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gbUpX.ConfluenceTemplateCollectionDetailsRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("8ItDm", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplatesRelayPage", function () { return $7bccba45c9347f8e$export$931ec4cf658dfdff; });

var $7VQPk = parcelRequire("7VQPk");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $1YXN8 = parcelRequire("1YXN8");
const $7bccba45c9347f8e$export$931ec4cf658dfdff = ({ queryRef: queryRef, mlTemplateIds: // @ts-ignore
mlTemplateIds })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
        productKeys: [
            (0, $20OkY.ProductKeys).CONFLUENCE
        ],
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageTemplate), {
            queryRef: queryRef
        })
    });
};

});

parcelRegister("6mr2B", function(module, exports) {
$parcel$export(module.exports, "ConfluenceTemplateSearchRelayPage", function () { return $4ca03bd75694ef27$export$b1405e79a5b8deb2; });

var $7VQPk = parcelRequire("7VQPk");

var $1YXN8 = parcelRequire("1YXN8");
const $4ca03bd75694ef27$export$b1405e79a5b8deb2 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});

parcelRegister("kUDf6", function(module, exports) {
$parcel$export(module.exports, "SoftwareGuardPricingPage", function () { return $6e7e458098ca5aac$export$4d5b8f19509ba187; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("1Q9Zw");
var $aiOMy = parcelRequire("aiOMy");
const $6e7e458098ca5aac$export$4d5b8f19509ba187 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "atlassian-access",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "guard-pricing-page",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aiOMy.SoftwareGuardPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("1Q9Zw", function(module, exports) {
$parcel$export(module.exports, "SoftwareGuardPricingPageTemplate", function () { return (parcelRequire("aiOMy")).SoftwareGuardPricingPageTemplate; });

var $aiOMy = parcelRequire("aiOMy");

});
parcelRegister("aiOMy", function(module, exports) {
$parcel$export(module.exports, "SoftwareGuardPricingPageTemplate", function () { return $459e8e9292ffd88f$export$633a765a05118a91; });
/* software-guard-pricing-page.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $jVACb = parcelRequire("jVACb");
parcelRequire("g1ccm");
var $1jOvc = parcelRequire("1jOvc");
var $frz5c = parcelRequire("frz5c");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $g2lQR = parcelRequire("g2lQR");

var $7No1H = parcelRequire("7No1H");
const $459e8e9292ffd88f$var$inlineLink = null;
const $459e8e9292ffd88f$var$WebinarLink = ({ href: href, children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-product-key": "guard",
        "data-track-event": "GuardPricingPage.webinar.banner",
        "data-event-container": "GuardPricingPageWebinar",
        "data-label-english": "Ask the Experts: Guard Premium AMA",
        href: href,
        className: (0, $2jatx.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _9oik1r31 _1bnxglyw _jf4cnqa1"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: children
    });
const $459e8e9292ffd88f$var$createWebinarLinkRenderer = (href)=>(textstring)=>/*#__PURE__*/ (0, $7VQPk.jsx)($459e8e9292ffd88f$var$WebinarLink, {
            href: href,
            children: textstring
        });
const $459e8e9292ffd88f$export$633a765a05118a91 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const addonCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[1];
    const intl = (0, $8e22h.default)();
    const localizedHref = (0, $kooLp.useLocalizedHref)("/webinars/enterprise-cloud/defend-your-cloud-level-up-security-with-guard-premium");
    const workshopHref = (0, $kooLp.useLocalizedHref)("/webinars/enterprise-cloud/getting-started-with-guard-a-practical-walkthrough-of-security-best-practices");
    const webinarLinkRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useMemo(()=>$459e8e9292ffd88f$var$createWebinarLinkRenderer(localizedHref), [
        localizedHref
    ]);
    const guardBannerProps = {
        identifier: "GuardPricingPage.banner-alert.premium-edition",
        productKey: "atlassianGuard",
        text: intl.formatMessage({
            id: "GuardPricingPage.banner-alert.text",
            defaultMessage: "Atlassian Guard Premium is generally available!"
        }),
        linkText: intl.formatMessage({
            id: "GuardPricingPage.banner-alert.link-text",
            defaultMessage: "Read the blog."
        }),
        linkUrl: (0, $kooLp.useLocalizedHref)("/blog/announcements/guard-premium"),
        dataEventProps: {
            "data-product-key": "atlassianGuard",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Read the blog",
            "data-label-english": "Read the blog"
        }
    };
    const webinarBannerProps = {
        identifier: "GuardPricingPage.banner-alert.webinar-september-4-2025",
        productKey: "atlassianGuard",
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "GuardPricingPage.banner-alert.text.webinar-september-4-2025",
            defaultMessage: "<a>Ask the Experts: Guard Premium AMA</a> | Live Q&A | Sept 3rd & 4th",
            values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                a: webinarLinkRenderer
            })
        }),
        linkText: "",
        linkUrl: (0, $kooLp.useLocalizedHref)("/blog/announcements/guard-premium")
    };
    const workshopBannerProps = {
        identifier: "GuardPricingPage.banner-alert.guard-workshop",
        productKey: "atlassianGuard",
        text: intl.formatMessage({
            id: "GuardPricingPage.banner-alert.text.guard-workshop",
            defaultMessage: "Get actionable tips to maximize Guard."
        }),
        linkText: intl.formatMessage({
            id: "GuardPricingPage.banner-alert.link-text.guard-workshop",
            defaultMessage: "Register for the workshop now"
        }),
        linkUrl: workshopHref,
        dataEventProps: {
            "data-product-key": "atlassianGuard",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Register for the workshop now",
            "data-label-english": "Register for the workshop now"
        }
    };
    const displayWorkshopBanner = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8240ButterbarGuard);
    const displayWebinarBanner = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7735GuardWebinar);
    const displayedBannerProps = displayWorkshopBanner ? workshopBannerProps : displayWebinarBanner ? webinarBannerProps : guardBannerProps;
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _addonCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
            nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g2lQR.GuardNav), {}),
            banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), (0, $6ogO3._)({}, displayedBannerProps)),
            showFallback: content === null || content === void 0 ? void 0 : content.hasError,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "guard-pricing-page",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                        children: content === null || content === void 0 ? void 0 : content.headline
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7No1H.default), {
                        pricing: props.pricing,
                        countryCode: props.countryCode
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                        title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                        comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                        compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1jOvc.DemoAddOn), {
                        headingText: addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.title,
                        bodyText: addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.valueProposition,
                        linkText: addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.text,
                        ctaHref: (_addonCtaContent_url = addonCtaContent === null || addonCtaContent === void 0 ? void 0 : addonCtaContent.url) !== null && _addonCtaContent_url !== void 0 ? _addonCtaContent_url : ""
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                                planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                        product: "Guard",
                        ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                        questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                        priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                        questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                        imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                    })
                ]
            })
        })
    });
};

});
parcelRegister("jVACb", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return $8326461e03189c88$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $2gCne = parcelRequire("2gCne");
const $8326461e03189c88$var$containerStyles = null;
const $8326461e03189c88$var$contentStyles = null;
const $8326461e03189c88$var$closeIconStyles = null;
const $8326461e03189c88$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $8e22h.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $2jatx.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $2jatx.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});

parcelRegister("g2lQR", function(module, exports) {
$parcel$export(module.exports, "GuardNav", function () { return $97dc5fc3d3238142$export$941339143e9f5522; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $fz5gy = parcelRequire("fz5gy");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $97dc5fc3d3238142$var$GuardLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fz5gy.GuardLogo), {
        appearance: "brand"
    });
};
const $97dc5fc3d3238142$export$941339143e9f5522 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $kooLp.useLocalizedHref)("/software/guard/capabilities");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/guard/pricing");
    const guideHref = (0, $kooLp.useLocalizedHref)("/software/guard/guide#getting-started");
    const demoHref = (0, $kooLp.useLocalizedHref)("/software/guard/demo");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "GuardPageTemplate.navbar.guard-logo",
                defaultMessage: "Guard logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "capabilities",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.capabilities",
                        defaultMessage: "Capabilities"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: capabilitiesHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: pricingHref
                },
                {
                    globalLinksKey: "guide",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.guide",
                        defaultMessage: "Guide"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: guideHref
                },
                {
                    globalLinksKey: "demo",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.demo",
                        defaultMessage: "Demo"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: demoHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-guard",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "capabilities",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.capabilities",
                                defaultMessage: "Capabilities"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: capabilitiesHref
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: pricingHref
                        },
                        {
                            globalLinksKey: "guide",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.guide",
                                defaultMessage: "Guide"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: guideHref
                        },
                        {
                            globalLinksKey: "demo",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.demo",
                                defaultMessage: "Demo"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: demoHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("7No1H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5301f31b52bb5c42$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");
const $5301f31b52bb5c42$var$GuardPriceFinder = (props)=>{
    var _content_standard, _content_standard1, _content_premium, _content_premium1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium")
    };
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const guardProductPlans = [
        {
            planName: ((_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) || "Standard",
            offeringSku: "atlassian-access-standard-sku",
            description: ((_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) || "",
            recommendationLimit: 0,
            signupLimit: 50000,
            signupURLInfo: {
                shouldLocalize: false,
                urlDomain: "https://admin.atlassian.com",
                urlPath: "/atlassian-guard"
            },
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: ((_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) || "Premium",
            offeringSku: "atlassian-guard-premium-addon-sku",
            description: ((_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) || "",
            recommendationLimit: 99,
            signupLimit: 50000,
            signupURLInfo: {
                shouldLocalize: false,
                urlDomain: "https://admin.atlassian.com",
                urlPath: "/atlassian-guard-premium"
            },
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "GuardPriceFinder.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "GuardPriceFinder.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardOverSignupLimit: {
            id: "GuardPriceFinder.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "GuardPriceFinder.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "GuardPriceFinder.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "GuardPriceFinder.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "atlassianGuard",
            productPlans: guardProductPlans,
            defaultUnitCount: 100,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), (0, $6ogO3._)({
                countryCode: props.countryCode,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.guard,
                messages: messages
            }, props))
        })
    });
};
$5301f31b52bb5c42$var$GuardPriceFinder.displayName = "GuardPriceFinderSection";
var $5301f31b52bb5c42$export$2e2bcd8739ae039 = $5301f31b52bb5c42$var$GuardPriceFinder;

});




parcelRegister("5v5zT", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswDesign", function () { return $ca2938185376ac8a$export$911cc88a5f759c10; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $ca2938185376ac8a$export$911cc88a5f759c10 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-design",
        persona: "unknown",
        pageVariant: "design"
    }));
};

});
parcelRegister("17vRh", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAnchor", function () { return $28e1a916c0aa04c8$export$5bd099500f106950; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gHIMV = parcelRequire("gHIMV");

var $8e22h = parcelRequire("8e22h");

var $doAVE = parcelRequire("doAVE");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $a5uC7 = parcelRequire("a5uC7");

var $kZQhV = parcelRequire("kZQhV");

var $3oD33 = parcelRequire("3oD33");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $28AH4 = parcelRequire("28AH4");

var $eq4XL = parcelRequire("eq4XL");
const $28e1a916c0aa04c8$export$5bd099500f106950 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps })=>{
    const intl = (0, $8e22h.default)();
    const productHref = (0, $kooLp.useLocalizedHref)("/software/jira");
    const [content, setContent] = (0, $1oC0p.useState)(undefined);
    const loggedInHasJira = (0, $doAVE.useLoggedInHasJira)();
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    // Jira FFl experiment check start
    const jiraFflExperimentCheck = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).cfind4666JiraFfl);
    const isJiraFflVariant = jiraFflExperimentCheck.type === (0, $ea4mV.EnrollmentType).ENROLLED && jiraFflExperimentCheck.value;
    // Jira FFl experiment check end
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    (0, $1oC0p.useEffect)(()=>{
        setAnchorLocalStorage({
            persona: persona,
            teamTypeInferredMl: teamType,
            team: ""
        });
        setContent(anchorContents);
    // We only want to run this useEffect once.
    }, []);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const landingType = pageVariant === "features" || $28e1a916c0aa04c8$var$isTeamAnchor(pageVariant) ? "jira-software-rebranded-anchor" : "jira-software-anchor";
    const theme = pageVariant === "features" || $28e1a916c0aa04c8$var$isTeamAnchor(pageVariant) ? "dark-on-light" : "light-on-dark";
    const props = {
        hideNavigationBar: false,
        customHeroSection: undefined,
        landingType: landingType,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: true,
        productNavProps: {
            productHref: productHref,
            productName: "jira",
            ariaLabel: intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            }),
            dataProductKey: "jiraSoftware",
            showFreeHrefButton: false
        },
        heroProps: $28e1a916c0aa04c8$var$getHeroProps({
            resp: content,
            pageVariant: pageVariant,
            theme: theme
        }),
        tabsProps: $28e1a916c0aa04c8$var$getTabProps(content, landingType),
        ctaProps: $28e1a916c0aa04c8$var$getCtaProps(content),
        testimonialProps: $28e1a916c0aa04c8$var$getTestimonialProps(content),
        alternatingTextAndImageProps: $28e1a916c0aa04c8$var$getAlternatingTextAndImageProps(content),
        hasRebrandedSignupFormStyles: true,
        heroBgColor: theme == "dark-on-light" ? "bgWhite" : "bgBlackBlue"
    };
    return loggedInHasJira ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "jfind-1504-after-d7-get-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "jfind-get-d1to6-users-back-to-product-for-paid",
            group: "variant",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
                experimentKey: "jfind-981-paid-jpto-logged-in-redesign",
                group: "Test",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3oD33.PaidLoggedInJiraProductTourOverview), {})
            })
        })
    }) : isLoggedOut && isJiraFflVariant ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eq4XL.PaidLandingJiraAiTemplate), (0, $6ogO3._)({}, props)) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), (0, $6ogO3._)({}, props));
};
const $28e1a916c0aa04c8$var$heroFeatureMatrix = {
    features: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    pm: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: true
    },
    template: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: true
    },
    project_collaboration: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    automation: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    teamwork: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    agile: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    competitors: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    roadmaps: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    tracker: {
        useNewHero: true,
        showAnimatedHero: true,
        animatedSocialBanner: true,
        darkSolidTheme: true,
        showStaticImage: false
    },
    engineering: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    marketing: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    hr: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    legal: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    operations: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    design: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    programmgmt: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    },
    sales: {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: true,
        darkSolidTheme: false,
        showStaticImage: false
    }
};
const $28e1a916c0aa04c8$var$isTeamAnchor = (pageVariant)=>{
    const teamAnchors = [
        "engineering",
        "marketing",
        "hr",
        "legal",
        "operations",
        "design",
        "programmgmt",
        "sales"
    ];
    return teamAnchors.includes(pageVariant);
};
const $28e1a916c0aa04c8$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false
    };
    return $28e1a916c0aa04c8$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
const $28e1a916c0aa04c8$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, theme: theme })=>{
    const defaultProps = {
        theme: theme,
        headerText: "",
        secondaryText: "",
        signup: {
            bundle: "jira-software",
            edition: "free",
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0] || !resp[0].node) return defaultProps;
    const { headline: headline } = resp[0].node;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = (data === null || data === void 0 ? void 0 : data.planBenefits) && (data === null || data === void 0 ? void 0 : data.planBenefits[0]) ? data === null || data === void 0 ? void 0 : data.planBenefits[0] : null;
    const supportingAsset = planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.supportingAsset;
    const features = $28e1a916c0aa04c8$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : "",
            alt: description || ""
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || "" : "";
    return (0, $dPABA._)((0, $6ogO3._)({}, defaultProps, features), {
        headerText: (data === null || data === void 0 ? void 0 : data.name) || "",
        secondaryText: (data === null || data === void 0 ? void 0 : data.subheading) || "",
        image: getImage(supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url, supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: (planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.description) || ""
    });
};
const $28e1a916c0aa04c8$var$getTabProps = (resp, landingType)=>{
    const defaultProps = {
        dataProductKey: "jiraSoftware-PaidLpJiraPm",
        headerText: "",
        tabStyles: {
            defaultBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultText: "#091e42",
            hoverBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverText: "#091e42",
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeBG: "#deebff",
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeText: "#091e42"
        },
        styles: {
            "--lp-tabs-hover": "#deebff",
            "--lp-tabs-unselected": "#6b778c"
        },
        tabs: undefined
    };
    if (!resp || !resp[0] || !resp[0].node) return defaultProps;
    const tabs = $28e1a916c0aa04c8$var$getTabs(resp);
    const primaryMessage = $28e1a916c0aa04c8$var$getPrimaryMessage(resp);
    return (0, $dPABA._)((0, $6ogO3._)({}, defaultProps), {
        landingType: landingType,
        headerText: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
        tabs: tabs
    });
};
const $28e1a916c0aa04c8$var$getCtaProps = (resp)=>{
    const cta = $28e1a916c0aa04c8$var$getCta(resp);
    return {
        headerText: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
        ctaProps: {
            buttonProps: {
                color: "yellow",
                url: (cta === null || cta === void 0 ? void 0 : cta.url) || "",
                text: (cta === null || cta === void 0 ? void 0 : cta.text) || "",
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-container": "ctaSection",
                    "data-event-component": "linkButton",
                    "data-product-key": "jiraSoftware"
                }
            }
        },
        backgroundProperties: {
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        }
    };
};
const $28e1a916c0aa04c8$var$getTestimonialProps = (resp)=>{
    var _data_customers;
    if (!resp || !resp[0] || !resp[0].node) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data === null || data === void 0 ? void 0 : data.name,
        logos: data === null || data === void 0 ? void 0 : (_data_customers = data.customers) === null || _data_customers === void 0 ? void 0 : _data_customers.map((customer)=>{
            return {
                src: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].url) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].url : "",
                alt: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].description) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].description : "",
                lazy: true
            };
        })
    };
};
const $28e1a916c0aa04c8$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $28e1a916c0aa04c8$var$getResults(resp);
    function generateProps(result, index) {
        var _result_asset, _result_asset1;
        // this shouldn't go past
        const countMap = [
            "one",
            "two",
            "three",
            "four"
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($gHIMV)))(`${countMap[index]}`);
        const position = index % 2 === 0 ? "left" : "right";
        return {
            [`row${count}Header`]: (result === null || result === void 0 ? void 0 : result.name) || "",
            [`row${count}Body`]: (result === null || result === void 0 ? void 0 : result.subheading) || "",
            [`row${count}ImageLink`]: result === null || result === void 0 ? void 0 : (_result_asset = result.asset) === null || _result_asset === void 0 ? void 0 : _result_asset.url,
            [`row${count}ImageAltText`]: (result === null || result === void 0 ? void 0 : (_result_asset1 = result.asset) === null || _result_asset1 === void 0 ? void 0 : _result_asset1.description) || "",
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results === null || results === void 0 ? void 0 : results.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return (0, $6ogO3._)({}, acc, curr);
    });
    return (0, $6ogO3._)({
        imageWidth: "100%",
        imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
        imageTextSideRowTwoPadding: "16px 0",
        imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px"
    }, contentBlocks);
};
const $28e1a916c0aa04c8$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $28e1a916c0aa04c8$var$getTabs = (resp)=>{
    const primaryMessage = $28e1a916c0aa04c8$var$getPrimaryMessage(resp);
    if (!primaryMessage || !(primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.supportingExample)) return undefined;
    return primaryMessage.supportingExample.filter((tab)=>tab !== null).map((tab)=>{
        var _advocateQuote_advocateHeadshot, _advocateQuote_advocateHeadshot1;
        const supportingAsset = tab === null || tab === void 0 ? void 0 : tab.supportingAsset;
        const advocateQuote = tab === null || tab === void 0 ? void 0 : tab.advocateQuote;
        return {
            textLabel: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            id: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            component: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
                isShowTestimonyBorder: false,
                isIncludeTestimony: !!(tab === null || tab === void 0 ? void 0 : tab.advocateQuote),
                testimonyIsUsingTextQuotationMarks: true,
                title: (tab === null || tab === void 0 ? void 0 : tab.heading) || "",
                rawHtmlContent: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || "",
                imageSrc: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url) || "",
                imageAlt: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description) || "",
                quoteBlurb: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateQuote) || "",
                quoteName: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateName) || "",
                quoteCompany: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateJobTitle) || "",
                testimonyImageSrc: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url) || "",
                testimonyImageAlt: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.description) || ""
            }, tab === null || tab === void 0 ? void 0 : tab.name)
        };
    });
};
const $28e1a916c0aa04c8$var$getResults = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $28e1a916c0aa04c8$var$getCta = (resp)=>{
    if (!resp || !resp[0] || !resp[0].node) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};

});
parcelRegister("eq4XL", function(module, exports) {
$parcel$export(module.exports, "PaidLandingJiraAiTemplate", function () { return $41d2acb981c5bf8f$export$46443c2e6bf22513; });
/* cfind-4666-paid-landing-jira-ai.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $k9ZIM = parcelRequire("k9ZIM");

var $8IN8s = parcelRequire("8IN8s");
parcelRequire("k1xqL");
var $a8Jhy = parcelRequire("a8Jhy");

var $4Jdkw = parcelRequire("4Jdkw");

var $8LaTa = parcelRequire("8LaTa");

var $jkEFt = parcelRequire("jkEFt");
parcelRequire("cDJ3u");
var $50aZ0 = parcelRequire("50aZ0");

var $ea4mV = parcelRequire("ea4mV");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $dSJSp = parcelRequire("dSJSp");

var $jYNiT = parcelRequire("jYNiT");

var $4Dg8Z = parcelRequire("4Dg8Z");

var $6HCeC = parcelRequire("6HCeC");

var $33kEK = parcelRequire("33kEK");

var $icTHu = parcelRequire("icTHu");

var $5IbWH = parcelRequire("5IbWH");

var $1SFKa = parcelRequire("1SFKa");

var $cf7Ff = parcelRequire("cf7Ff");

var $jUBSR = parcelRequire("jUBSR");

var $kZQhV = parcelRequire("kZQhV");
const $41d2acb981c5bf8f$var$promptContainerCss = null;
const $41d2acb981c5bf8f$export$d9e9f182c157d2bc = ({ landingType: landingType, showHorizontalRule: showHorizontalRule, heroProps: heroProps, bannerProps: bannerProps, tabsProps: tabsProps, customSection: customSection, alternatingTextAndImageProps: alternatingTextAndImageProps, ctaProps: ctaProps, ctaWithPolyGonProps: ctaWithPolyGonProps, testimonialProps: testimonialProps, resultSectionDivider: resultSectionDivider })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const { cgsDataLoading: cgsDataLoading } = (0, $jUBSR.useJiraAiFFL)();
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4666JiraFfl);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = (0, $1oC0p.useState)(false);
    const showStaticTestimonials = !heroProps.animatedSocialBanner;
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (cgsDataLoading) setIsPreviewModalOpen(true);
    }, [
        cgsDataLoading
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return; // be sure analyticsClient is available before firing event
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "PaidLandingJiraAiTemplate",
            attributes: {
                flow: "paidLandingJiraAi"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "paid-lp-jsw-ffl",
            scrollTrackingEnabled: true,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dSJSp.PaidJiraAiBackground), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Dg8Z.PaidJiraAiHeader), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhckbl _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb _y3gn1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33kEK.PaidJiraAiTeamTypeMadLibPrompt), {})
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jYNiT.PaidJiraAiDisclaimer), {}),
                isPreviewModalOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6HCeC.PaidJiraAiPreviewModal), {
                    onClose: ()=>setIsPreviewModalOpen(false)
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cf7Ff.PaidTabsSection), (0, $6ogO3._)({}, tabsProps)),
                customSection && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1SFKa.PaidCustomSection), {
                    customSection: customSection
                }),
                showHorizontalRule && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.HorizontalRule), {}),
                bannerProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $50aZ0.SimpleImageTextSide), (0, $6ogO3._)({}, bannerProps)),
                resultSectionDivider && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_6rth1cg9"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a8Jhy.Adg4SectionDivider), {
                        bgColor: resultSectionDivider.color,
                        variation: resultSectionDivider.variation
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $icTHu.PaidAlternatingImageText), {
                    landingType: landingType,
                    alternatingImageTextProps: alternatingTextAndImageProps
                }),
                ctaProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5IbWH.PaidCtaSection), {
                    ctaProps: ctaProps,
                    landingType: landingType
                }),
                ctaWithPolyGonProps && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                resultSectionDivider && "_bfhkyt3g _1pfh1cg9 _4t3iuuw1"
                            ]),
                            style: {
                                "--_1he1i5": (0, $6ZVlx.default)(resultSectionDivider === null || resultSectionDivider === void 0 ? void 0 : resultSectionDivider.color)
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                resultSectionDivider && "_1pfh1snh"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Jdkw.ADG4CtaWithPolygonBackground), (0, $6ogO3._)({}, ctaWithPolyGonProps))
                        })
                    ]
                }),
                showStaticTestimonials && testimonialProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jkEFt.default), (0, $6ogO3._)({}, testimonialProps)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            ]
        })
    });
};
const $41d2acb981c5bf8f$export$46443c2e6bf22513 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUBSR.JiraAiFFLProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($41d2acb981c5bf8f$export$d9e9f182c157d2bc, (0, $6ogO3._)({}, props))
    });

});
parcelRegister("8IN8s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f81b8289a3c24944$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $cjWBX = parcelRequire("cjWBX");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $cR2Ov = parcelRequire("cR2Ov");

var $9KOR3 = parcelRequire("9KOR3");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("2yMfA");
var $cB958 = parcelRequire("cB958");
parcelRequire("dQMjB");
var $1jBLM = parcelRequire("1jBLM");
const $f81b8289a3c24944$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $f81b8289a3c24944$var$JiraSoftwareNav = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    var _newLinks_find, _newLinks_find1;
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const productNavGoToAppCta = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).productNavGoToAppCta);
    const isExperimentEnabled = productNavGoToAppCta.type === "enrolled" && productNavGoToAppCta.value === true;
    const ctaText = isExperimentEnabled ? intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.navbar.openJira",
        defaultMessage: "Open Jira"
    }) : intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.navbar.getItFree",
        defaultMessage: "Get it free"
    });
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SOFTWARE,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, [
        openCrossFlow,
        productNavCtaCTAClickFunction,
        isUseOpenCrossFlow
    ]);
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    // Teams Hrefs
    const marketingHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/marketing");
    const engineeringHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/engineering");
    const designHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/design");
    const operationsHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/operations");
    const itHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/it");
    // Use Cases Hrefs
    const gettingStartedHref = (0, $kooLp.useLocalizedHref)("https://community.atlassian.com/learning/hub/jira");
    const planningHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/planning");
    const campaignManagementHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/campaign-management");
    const agileProjectManagementHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/agile-project-management");
    const programManagementHref = (0, $kooLp.useLocalizedHref)("/jira/solutions/program-management");
    //Company Size Hrefs
    const enterpriseHref = (0, $kooLp.useLocalizedHref)("/software/jira/enterprise");
    const solutionsDropdown = (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
            contentSections: [
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.teams.header",
                        defaultMessage: "Teams"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.marketing",
                                defaultMessage: "Marketing"
                            }),
                            href: marketingHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.engineering",
                                defaultMessage: "Engineering"
                            }),
                            href: engineeringHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.design",
                                defaultMessage: "Design"
                            }),
                            href: designHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.operations",
                                defaultMessage: "Operations"
                            }),
                            href: operationsHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.teams.it",
                                defaultMessage: "IT"
                            }),
                            href: itHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.useCases.header",
                        defaultMessage: "Use Cases"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.getting-started",
                                defaultMessage: "Getting started"
                            }),
                            href: gettingStartedHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.planning",
                                defaultMessage: "Planning"
                            }),
                            href: planningHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.campaign-management",
                                defaultMessage: "Campaign Management"
                            }),
                            href: campaignManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.agile-project-management",
                                defaultMessage: "Agile Project Management"
                            }),
                            href: agileProjectManagementHref
                        },
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.useCases.program-management",
                                defaultMessage: "Program Management"
                            }),
                            href: programManagementHref
                        }
                    ]
                },
                {
                    header: intl.formatMessage({
                        id: "software-jira.navbar.solutions.companySize.header",
                        defaultMessage: "Company Size"
                    }),
                    links: [
                        {
                            text: intl.formatMessage({
                                id: "software-jira.navbar.solutions.companySize.enterprise",
                                defaultMessage: "Enterprise"
                            }),
                            href: enterpriseHref
                        }
                    ]
                }
            ]
        }), [
        intl,
        gettingStartedHref,
        marketingHref,
        engineeringHref,
        designHref,
        operationsHref,
        itHref,
        planningHref,
        campaignManagementHref,
        agileProjectManagementHref,
        programManagementHref,
        enterpriseHref
    ]);
    const featuresHref = (0, $kooLp.useLocalizedHref)("/software/jira/features");
    const productGuideHref = (0, $kooLp.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/jira/pricing");
    const productLogoHref = (0, $kooLp.useLocalizedHref)("/software/jira");
    const featuresDropdownShown = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jiraFeaturesSubNav);
    const templatesLinkContent = (0, $1oC0p.useMemo)(()=>{
        return {
            globalLinksKey: "templates",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.templates",
                defaultMessage: "Templates"
            }),
            productKey: "jira",
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1jBLM.TemplateCategoriesDropdown), {}),
            dropdownType: "templates",
            containerPosition: "relative"
        };
    }, [
        intl
    ]);
    const featuresLinkContent = (0, $1oC0p.useMemo)(()=>{
        const common = {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.features",
                defaultMessage: "Features"
            }),
            productKey: "jira"
        };
        return featuresDropdownShown ? (0, $dPABA._)((0, $6ogO3._)({}, common), {
            hasSubnav: true,
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cB958.FeaturesDropdown), {}),
            dropdownType: "features",
            containerPosition: "relative"
        }) : (0, $dPABA._)((0, $6ogO3._)({}, common), {
            hasSubnav: false,
            href: featuresHref
        });
    }, [
        intl,
        featuresHref,
        featuresDropdownShown
    ]);
    const newLinks = (0, $1oC0p.useMemo)(()=>[
            featuresLinkContent,
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                productKey: "jira",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                dropdownType: "solutions",
                content: solutionsDropdown
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            }
        ], [
        intl,
        featuresLinkContent,
        templatesLinkContent,
        gwp7518NavIconUpdates,
        solutionsDropdown,
        solutionsDropdownStyles,
        productGuideHref,
        pricingHref
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: featuresHref
            },
            {
                globalLinksKey: "productGuide",
                linkText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "software-jira.navbar.product-guide-gwp-7518",
                    defaultMessage: "Guide"
                }) : intl.formatMessage({
                    id: "software-jira.navbar.product-guide",
                    defaultMessage: "Product guide"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: productGuideHref
            },
            templatesLinkContent,
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: pricingHref
            },
            {
                globalLinksKey: "enterprise",
                linkText: intl.formatMessage({
                    id: "software-jira.navbar.enterprise",
                    defaultMessage: "Enterprise"
                }),
                hasSubnav: false,
                productKey: "jira",
                href: enterpriseHref
            }
        ], [
        enterpriseHref,
        featuresHref,
        intl,
        pricingHref,
        productGuideHref,
        templatesLinkContent,
        gwp7518NavIconUpdates
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cjWBX.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
                globalNavItemKeys: globalNavItemKeys,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
                    productLogoUrl: productLogoHref,
                    productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($f81b8289a3c24944$var$JiraLogo, {}),
                    productLogoAriaLabel: intl.formatMessage({
                        id: "wacJiraSoftwareNavigation.logo-label",
                        defaultMessage: "Jira Software logo"
                    }),
                    mobileCtaText: intl.formatMessage({
                        id: "JiraeSoftwarePageTemplate.navbar.getitfree",
                        defaultMessage: "Get it free"
                    }),
                    mobileCtaUrl: signupLink,
                    mobileCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($f81b8289a3c24944$var$JiraLogo, {}),
                    navigationTrynowCtaText: ctaText,
                    navigationTrynowCtaUrl: signupLink,
                    navigationTrynowCtaOnClick: (e)=>{
                        if (productNavOnClick) productNavOnClick(e);
                    },
                    productPageNavLinks: newLinks,
                    mobileLinksSections: [
                        {
                            mobileLinkKey: "mobile-jira",
                            mobileLinksProps: newLinks
                        }
                    ],
                    additionalMenuPageObjectsArray: [
                        {
                            menuPageKey: "solutions",
                            menuPageObjects: (_newLinks_find = newLinks.find((link)=>link.globalLinksKey === "solutions")) === null || _newLinks_find === void 0 ? void 0 : _newLinks_find.content
                        },
                        {
                            menuPageKey: "templates",
                            menuPageObjects: (_newLinks_find1 = newLinks.find((link)=>link.globalLinksKey === "templates")) === null || _newLinks_find1 === void 0 ? void 0 : _newLinks_find1.content
                        }
                    ]
                })
            })
        ]
    });
};
$f81b8289a3c24944$var$JiraSoftwareNav.displayName = "JiraSoftwareNav";
var $f81b8289a3c24944$export$2e2bcd8739ae039 = $f81b8289a3c24944$var$JiraSoftwareNav;

});
parcelRegister("2yMfA", function(module, exports) {
$parcel$export(module.exports, "FeaturesDropdown", function () { return (parcelRequire("cB958")).FeaturesDropdown; });
parcelRequire("cB958");

});
parcelRegister("cB958", function(module, exports) {
$parcel$export(module.exports, "FeaturesDropdown", function () { return $ea82a2d484c53cd9$export$ad0d22100914784b; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $cR2Ov = parcelRequire("cR2Ov");
const $ea82a2d484c53cd9$export$ad0d22100914784b = ()=>{
    const locale = (0, $kooLp.useLocale)();
    const intl = (0, $8e22h.default)();
    const allFeaturesLink = {
        text: intl.formatMessage({
            id: "jira.FeaturesDropdown.allFeatures",
            defaultMessage: "All Features"
        }),
        href: (0, $kooLp.getLocalizedHref)({
            href: "/software/jira/features",
            locale: locale
        })
    };
    const featureLinks = [
        {
            text: intl.formatMessage({
                id: "jira.FeaturesDropdown.rovo",
                defaultMessage: "Rovo in Jira"
            }),
            href: (0, $kooLp.getLocalizedHref)({
                href: "/software/jira/ai",
                locale: locale
            })
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allFeaturesLink,
                    ...featureLinks
                ]
            }
        ]
    });
};

});


parcelRegister("dQMjB", function(module, exports) {
$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return (parcelRequire("1jBLM")).TemplateCategoriesDropdown; });
parcelRequire("1jBLM");

});
parcelRegister("1jBLM", function(module, exports) {
$parcel$export(module.exports, "TemplateCategoriesDropdown", function () { return $6235f0ca21d73c59$export$8bb7e16f8f8a7ba6; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $cR2Ov = parcelRequire("cR2Ov");
parcelRequire("1EuOE");
var $bhzuC = parcelRequire("bhzuC");
const $6235f0ca21d73c59$export$8bb7e16f8f8a7ba6 = ()=>{
    const locale = (0, $kooLp.useLocale)();
    const intl = (0, $8e22h.default)();
    const { data: data } = (0, $bhzuC.useJiraTemplateCategories)();
    const allTemplateLink = {
        text: intl.formatMessage({
            id: "ira.TemplateCategoriesDropdown.allTemplates",
            defaultMessage: "All templates"
        }),
        href: (0, $kooLp.getLocalizedHref)({
            href: "/software/jira/templates",
            locale: locale
        })
    };
    const templateLinks = data.map((category)=>({
            text: category.categoryNameExternal,
            href: (0, $kooLp.getLocalizedHref)({
                href: `/software/jira/templates/${category.urlSlug}`,
                locale: locale
            })
        }));
    const jsmTemplatesLink = {
        text: intl.formatMessage({
            id: "Jira.TemplateCategoriesDropdown.JiraServiceManagementTemplates",
            defaultMessage: "Jira Service Management templates"
        }),
        href: (0, $kooLp.getLocalizedHref)({
            href: "/software/jira/templates/service-management",
            locale: locale
        }),
        anchorProps: {
            target: "_blank"
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
        orientation: "column",
        contentSections: [
            {
                links: [
                    allTemplateLink,
                    ...templateLinks
                ]
            },
            {
                links: [
                    jsmTemplatesLink
                ]
            }
        ]
    });
};

});
parcelRegister("1EuOE", function(module, exports) {
$parcel$export(module.exports, "useJiraTemplateCategories", function () { return (parcelRequire("bhzuC")).useJiraTemplateCategories; });
parcelRequire("614MQ");
parcelRequire("bhzuC");

});
parcelRegister("614MQ", function(module, exports) {
$parcel$export(module.exports, "getTemplateCategories", function () { return $8003fdfd77cf038c$export$819167f3de5f32cb; });

var $kXfPT = parcelRequire("kXfPT");

var $eRzlV = parcelRequire("eRzlV");
let $8003fdfd77cf038c$var$_ = (t)=>t, $8003fdfd77cf038c$var$t;
const $8003fdfd77cf038c$var$JIRA_PRODUCT_INTERNAL_TITLE = "Jira Cloud Product";
const $8003fdfd77cf038c$export$52bf0b65d881440d = (0, $kXfPT.gql)($8003fdfd77cf038c$var$t || ($8003fdfd77cf038c$var$t = $8003fdfd77cf038c$var$_`
query ($locale: String) {
  taxonomyTemplateCategoryCollection(
    locale: $locale
    limit: 100,
    where: {
      product: {
        internalTitle: "${0}"
      }
    }
    # for the short-term, sort-ordering is done via the internal-name
    # todo: GWP-6125 implement a long term sort-ordering solution
    order: categoryNameInternal_ASC
  ) {
    items {
      sys {
        id
      }
      categoryNameInternal
      categoryNameExternal
      urlSlug
    }
  }
}
`), $8003fdfd77cf038c$var$JIRA_PRODUCT_INTERNAL_TITLE);
const $8003fdfd77cf038c$export$819167f3de5f32cb = (args)=>{
    const { locale: locale } = args;
    return (0, $kXfPT.request)({
        url: (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL),
        document: $8003fdfd77cf038c$export$52bf0b65d881440d,
        variables: {
            locale: locale
        },
        requestHeaders: {
            Authorization: `Bearer ${window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES}`
        }
    });
};

});
parcelRegister("kXfPT", function(module, exports) {
$parcel$export(module.exports, "request", function () { return $f4159a034cc4c190$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "gql", function () { return $f4159a034cc4c190$export$72e4926bf8358653; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $eLb04 = parcelRequire("eLb04");

var $haH5f = parcelRequire("haH5f");

var $fSIns = parcelRequire("fSIns");

var $Xz7Q6 = parcelRequire("Xz7Q6");

var $1iZL3 = parcelRequire("1iZL3");

var $6FOC8 = parcelRequire("6FOC8");

var $fuprL = parcelRequire("fuprL");
/**
 * Convert the given headers configuration into a plain object.
 */ const $f4159a034cc4c190$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $6FOC8 && $6FOC8.Headers && headers instanceof $6FOC8.Headers) oHeaders = (0, $haH5f.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $f4159a034cc4c190$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $f4159a034cc4c190$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($f4159a034cc4c190$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $f4159a034cc4c190$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $f4159a034cc4c190$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = (0, $6ogO3._)({}, params.headers);
        let queryParams = ``;
        let body = undefined;
        var _fetchOptions_jsonSerializer;
        if (method === `POST`) {
            body = $f4159a034cc4c190$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $f4159a034cc4c190$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: (_fetchOptions_jsonSerializer = fetchOptions.jsonSerializer) !== null && _fetchOptions_jsonSerializer !== void 0 ? _fetchOptions_jsonSerializer : (0, $eLb04.defaultJsonSerializer)
        });
        const init = (0, $6ogO3._)({
            method: method,
            headers: headers,
            body: body
        }, fetchOptions);
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware((0, $dPABA._)((0, $6ogO3._)({}, init), {
                url: url,
                operationName: operationName,
                variables: variables
            })));
            const { url: urlNew } = result, initNew = (0, $aPnCa._)(result, [
                "url"
            ]);
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $f4159a034cc4c190$export$b0f268a6eae2cdf1 {
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $fSIns.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const _this_requestConfig = this.requestConfig, { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware } = _this_requestConfig, fetchOptions = (0, $aPnCa._)(_this_requestConfig, [
            "headers",
            "fetch",
            "method",
            "requestMiddleware",
            "responseMiddleware"
        ]);
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(requestOptions.document);
        return $f4159a034cc4c190$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: (0, $6ogO3._)({}, $f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)), $f4159a034cc4c190$var$resolveHeaders(requestOptions.requestHeaders)),
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $fSIns.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const _this_requestConfig = this.requestConfig, { headers: headers } = _this_requestConfig, fetchOptions = (0, $aPnCa._)(_this_requestConfig, [
            "headers"
        ]);
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $Xz7Q6.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        var _this_requestConfig_fetch;
        return $f4159a034cc4c190$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: (0, $6ogO3._)({}, $f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)), $f4159a034cc4c190$var$resolveHeaders(batchRequestOptions.requestHeaders)),
            operationName: undefined,
            fetch: (_this_requestConfig_fetch = this.requestConfig.fetch) !== null && _this_requestConfig_fetch !== void 0 ? _this_requestConfig_fetch : (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))),
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $fSIns.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const _this_requestConfig = this.requestConfig, { headers: headers, fetch: fetch = (0, (/*@__PURE__*/$parcel$interopDefault($6FOC8))), method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware } = _this_requestConfig, fetchOptions = (0, $aPnCa._)(_this_requestConfig, [
                "headers",
                "fetch",
                "method",
                "requestMiddleware",
                "responseMiddleware"
            ]);
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(rawRequestOptions.query);
            return $f4159a034cc4c190$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: (0, $6ogO3._)({}, $f4159a034cc4c190$var$resolveHeaders($f4159a034cc4c190$var$callOrIdentity(headers)), $f4159a034cc4c190$var$resolveHeaders(rawRequestOptions.requestHeaders)),
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
}
const $f4159a034cc4c190$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    var _params_method;
    const fetcher = $f4159a034cc4c190$var$createHttpMethodFetcher((0, $haH5f.uppercase)((_params_method = params.method) !== null && _params_method !== void 0 ? _params_method : `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    var _fetchOptions_jsonSerializer;
    const result = await $f4159a034cc4c190$var$getResult(response, (_fetchOptions_jsonSerializer = fetchOptions.jsonSerializer) !== null && _fetchOptions_jsonSerializer !== void 0 ? _fetchOptions_jsonSerializer : (0, $eLb04.defaultJsonSerializer));
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const _ref = Array.isArray(result) ? result : result, { errors: _ } = _ref, rest = (0, $aPnCa._)(_ref, [
            "errors"
        ]);
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return (0, $dPABA._)((0, $6ogO3._)({}, dataEnvelope), {
            headers: response.headers,
            status: response.status
        });
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new (0, $1iZL3.ClientError)(// @ts-expect-error TODO
        (0, $dPABA._)((0, $6ogO3._)({}, errorResult), {
            status: response.status,
            headers: response.headers
        }), {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $f4159a034cc4c190$export$3052fa16c23a17ef = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $fSIns.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.rawRequest((0, $6ogO3._)({}, requestOptions));
};
// prettier-ignore
// eslint-disable-next-line
async function $f4159a034cc4c190$export$b5fe3f66a567bec0(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $fSIns.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(requestOptions.url);
    return client.request((0, $6ogO3._)({}, requestOptions));
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $f4159a034cc4c190$export$72420c3222c11ca1 = async (...args)=>{
    const params = $f4159a034cc4c190$var$parseBatchRequestsArgsExtended(args);
    const client = new $f4159a034cc4c190$export$b0f268a6eae2cdf1(params.url);
    return client.batchRequests(params);
};
const $f4159a034cc4c190$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $f4159a034cc4c190$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer !== null && jsonSerializer !== void 0 ? jsonSerializer : (0, $eLb04.defaultJsonSerializer);
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $f4159a034cc4c190$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $f4159a034cc4c190$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
const $f4159a034cc4c190$export$72e4926bf8358653 = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
var $f4159a034cc4c190$export$2e2bcd8739ae039 = $f4159a034cc4c190$export$b5fe3f66a567bec0;

});
parcelRegister("eLb04", function(module, exports) {
$parcel$export(module.exports, "defaultJsonSerializer", function () { return $abedfcdcad7ec23a$export$94978876ea00418f; });
const $abedfcdcad7ec23a$export$94978876ea00418f = JSON;

});

parcelRegister("haH5f", function(module, exports) {
$parcel$export(module.exports, "uppercase", function () { return $c804ca5df265e067$export$6cfe151e6b925e83; });
$parcel$export(module.exports, "HeadersInstanceToPlainObject", function () { return $c804ca5df265e067$export$8cbbf7c85c69d7bd; });
const $c804ca5df265e067$export$6cfe151e6b925e83 = (str)=>str.toUpperCase();
const $c804ca5df265e067$export$8cbbf7c85c69d7bd = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};

});

parcelRegister("fSIns", function(module, exports) {
$parcel$export(module.exports, "parseRequestArgs", function () { return $02fbd80aa1deaafb$export$23fbebc38045fef1; });
$parcel$export(module.exports, "parseRawRequestArgs", function () { return $02fbd80aa1deaafb$export$915c311301d24138; });
$parcel$export(module.exports, "parseBatchRequestArgs", function () { return $02fbd80aa1deaafb$export$db48f1a2d994371; });
$parcel$export(module.exports, "parseRequestExtendedArgs", function () { return $02fbd80aa1deaafb$export$77a1c1c6dd0fc83d; });
$parcel$export(module.exports, "parseRawRequestExtendedArgs", function () { return $02fbd80aa1deaafb$export$7dbb6e4001743509; });
const $02fbd80aa1deaafb$export$23fbebc38045fef1 = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$915c311301d24138 = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$db48f1a2d994371 = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$77a1c1c6dd0fc83d = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
const $02fbd80aa1deaafb$export$7dbb6e4001743509 = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};

});

parcelRegister("Xz7Q6", function(module, exports) {
$parcel$export(module.exports, "resolveRequestDocument", function () { return $0b30c1fbc38efde2$export$8a71244cbc138170; });

var $bUPIt = parcelRequire("bUPIt");
var $hj3p7 = parcelRequire("hj3p7");
/**
 * helpers
 */ const $0b30c1fbc38efde2$var$extractOperationName = (document)=>{
    var _operationDefinitions__name, _operationDefinitions_;
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = (_operationDefinitions_ = operationDefinitions[0]) === null || _operationDefinitions_ === void 0 ? void 0 : (_operationDefinitions__name = _operationDefinitions_.name) === null || _operationDefinitions__name === void 0 ? void 0 : _operationDefinitions__name.value;
    return operationName;
};
const $0b30c1fbc38efde2$export$8a71244cbc138170 = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $bUPIt.parse)(document);
            operationName = $0b30c1fbc38efde2$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $0b30c1fbc38efde2$var$extractOperationName(document);
    return {
        query: (0, $hj3p7.print)(document),
        operationName: operationName
    };
};

});

parcelRegister("1iZL3", function(module, exports) {
$parcel$export(module.exports, "ClientError", function () { return $0f3760bf22470851$export$bb8c263ad32caa8; });
class $0f3760bf22470851$export$bb8c263ad32caa8 extends Error {
    static extractMessage(response) {
        var _response_errors_, _response_errors;
        var _response_errors__message;
        return (_response_errors__message = (_response_errors = response.errors) === null || _response_errors === void 0 ? void 0 : (_response_errors_ = _response_errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.message) !== null && _response_errors__message !== void 0 ? _response_errors__message : `GraphQL Error (Code: ${response.status})`;
    }
    constructor(response, request){
        const message = `${$0f3760bf22470851$export$bb8c263ad32caa8.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $0f3760bf22470851$export$bb8c263ad32caa8.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $0f3760bf22470851$export$bb8c263ad32caa8);
    }
}

});

parcelRegister("6FOC8", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("fuprL", function(module, exports) {
/* eslint-disable */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $Xz7Q6 = parcelRequire("Xz7Q6");

var $1iZL3 = parcelRequire("1iZL3");
// import type WebSocket from 'ws'
const $b46d659564fbec9f$var$CONNECTION_INIT = `connection_init`;
const $b46d659564fbec9f$var$CONNECTION_ACK = `connection_ack`;
const $b46d659564fbec9f$var$PING = `ping`;
const $b46d659564fbec9f$var$PONG = `pong`;
const $b46d659564fbec9f$var$SUBSCRIBE = `subscribe`;
const $b46d659564fbec9f$var$NEXT = `next`;
const $b46d659564fbec9f$var$ERROR = `error`;
const $b46d659564fbec9f$var$COMPLETE = `complete`;
class $b46d659564fbec9f$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $b46d659564fbec9f$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
}
class $b46d659564fbec9f$export$5eb90cb6288c26cf {
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($b46d659564fbec9f$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($b46d659564fbec9f$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $Xz7Q6.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($b46d659564fbec9f$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($b46d659564fbec9f$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $b46d659564fbec9f$var$parseMessage(e.data);
                switch(message.type){
                    case $b46d659564fbec9f$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $b46d659564fbec9f$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($b46d659564fbec9f$var$Pong(r).text));
                        else socket.send($b46d659564fbec9f$var$Pong(null).text);
                        return;
                    case $b46d659564fbec9f$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $b46d659564fbec9f$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new (0, $1iZL3.ClientError)((0, $dPABA._)((0, $6ogO3._)({}, message.payload), {
                            status: 200
                        }), {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b46d659564fbec9f$var$ERROR:
                        subscriber.error && subscriber.error(new (0, $1iZL3.ClientError)({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b46d659564fbec9f$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
}
$b46d659564fbec9f$export$5eb90cb6288c26cf.PROTOCOL = `graphql-transport-ws`;
// Helper functions
function $b46d659564fbec9f$var$parseMessage(data, f = (a)=>a) {
    const m = $b46d659564fbec9f$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $b46d659564fbec9f$var$ConnectionInit(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$CONNECTION_INIT, payload);
}
function $b46d659564fbec9f$var$Ping(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$PING, payload, undefined);
}
function $b46d659564fbec9f$var$Pong(payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$PONG, payload, undefined);
}
function $b46d659564fbec9f$var$Subscribe(id, payload) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$SUBSCRIBE, payload, id);
}
function $b46d659564fbec9f$var$Complete(id) {
    return new $b46d659564fbec9f$var$GraphQLWebSocketMessage($b46d659564fbec9f$var$COMPLETE, undefined, id);
}

});



parcelRegister("bhzuC", function(module, exports) {
$parcel$export(module.exports, "useJiraTemplateCategories", function () { return $d5e332dcdb267cf7$export$ef1e726410cc2d37; });

var $1oC0p = parcelRequire("1oC0p");

var $kooLp = parcelRequire("kooLp");

var $kf4PU = parcelRequire("kf4PU");

var $614MQ = parcelRequire("614MQ");
// cache data per locale to optimize duplicate queries
const $d5e332dcdb267cf7$var$cache = new Map();
const $d5e332dcdb267cf7$export$d2adf65b87e47523 = ()=>{
    $d5e332dcdb267cf7$var$cache.clear();
};
const $d5e332dcdb267cf7$export$ef1e726410cc2d37 = ()=>{
    const locale = (0, $kooLp.useLocale)();
    const mappedLocale = (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale];
    // initialize state from cache if available
    const cacheEntry = mappedLocale ? $d5e332dcdb267cf7$var$cache.get(mappedLocale) : undefined;
    var _cacheEntry_data;
    const [data, setData] = (0, $1oC0p.useState)((_cacheEntry_data = cacheEntry === null || cacheEntry === void 0 ? void 0 : cacheEntry.data) !== null && _cacheEntry_data !== void 0 ? _cacheEntry_data : []);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        // if we don't have a mapped locale, do nothing
        if (!mappedLocale) return;
        const existingCache = $d5e332dcdb267cf7$var$cache.get(mappedLocale);
        // if we already have cached data, use it
        if ((existingCache === null || existingCache === void 0 ? void 0 : existingCache.data) && !existingCache.promise) {
            setData(existingCache.data);
            return;
        }
        // if a fetch is already in progress, wait for it
        if (existingCache === null || existingCache === void 0 ? void 0 : existingCache.promise) {
            setLoading(true);
            existingCache.promise.then((items)=>{
                setData(items);
                setLoading(false);
            }).catch((err)=>{
                setError(err);
                setLoading(false);
            });
            return;
        }
        // start a new fetch
        setLoading(true);
        setError(null);
        const fetchPromise = (0, $614MQ.getTemplateCategories)({
            // @ts-ignore
            locale: mappedLocale
        }).then((response)=>{
            var _response_taxonomyTemplateCategoryCollection_items;
            const items = (_response_taxonomyTemplateCategoryCollection_items = response.taxonomyTemplateCategoryCollection.items) !== null && _response_taxonomyTemplateCategoryCollection_items !== void 0 ? _response_taxonomyTemplateCategoryCollection_items : [];
            // update cache with data and clear promise
            $d5e332dcdb267cf7$var$cache.set(mappedLocale, {
                data: items,
                promise: null
            });
            setData(items);
            setLoading(false);
            return items;
        }).catch((err)=>{
            // clear promise on error
            const entry = $d5e332dcdb267cf7$var$cache.get(mappedLocale);
            if (entry) entry.promise = null;
            setError(err);
            setLoading(false);
            throw err;
        });
        var _existingCache_data;
        // store the in-flight promise
        $d5e332dcdb267cf7$var$cache.set(mappedLocale, {
            data: (_existingCache_data = existingCache === null || existingCache === void 0 ? void 0 : existingCache.data) !== null && _existingCache_data !== void 0 ? _existingCache_data : [],
            promise: fetchPromise
        });
    }, [
        locale,
        mappedLocale
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};

});





parcelRegister("cDJ3u", function(module, exports) {
$parcel$export(module.exports, "SimpleImageTextSide", function () { return (parcelRequire("50aZ0")).SimpleImageTextSide; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("50aZ0")).SimpleImageTextSide; });

var $50aZ0 = parcelRequire("50aZ0");

});
parcelRegister("50aZ0", function(module, exports) {
$parcel$export(module.exports, "SimpleImageTextSide", function () { return $52a85b4e5fd4de41$export$c449191a6146bc15; });
/* simple-image-text-side.tsx generated by @compiled/babel-plugin v0.28.8 */ //@ts-nocheck

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
const $52a85b4e5fd4de41$var$simpleImageTextSideStyle = null;
const $52a85b4e5fd4de41$var$RenderImage = ({ imageLink: imageLink, imageAltText: imageAltText, aspectRatio: aspectRatio })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: imageLink,
            alt: imageAltText,
            aspectRatio: aspectRatio
        },
        className: (0, $2jatx.default)([
            "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _688gkb7n"
        ])
    });
const $52a85b4e5fd4de41$var$RenderContent = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText, headerType: headerType, lozenge: lozenge, bodyText: bodyText, ctaProps: ctaProps, horizontalRule: horizontalRule, linkText: linkText, linkUrl: linkUrl })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                eyebrowText: eyebrowText,
                headerText: headerText,
                isBannerRichText: isBannerRichText,
                headerType: headerType,
                lozenge: lozenge,
                bodyText: bodyText,
                ctaProps: ctaProps,
                horizontalRule: horizontalRule
            }),
            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                text: linkText,
                href: linkUrl,
                type: "primary"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1jab1ylp _3fdxglyw _5jnq1ylp _uknx7vkz _b9s91ylp"
                ])
            })
        ]
    });
const $52a85b4e5fd4de41$export$c449191a6146bc15 = ({ eyebrowText: eyebrowText, headerText: headerText, isBannerRichText: isBannerRichText = false, headerType: headerType = "h2", lozenge: lozenge, bodyText: bodyText, linkText: linkText, linkUrl: linkUrl, imageLink: imageLink, imageAltText: imageAltText, imagePosition: imagePosition, className: className = "", ctaProps: ctaProps, aspectRatio: aspectRatio, horizontalRule: horizontalRule = false, alignItems: alignItems = "center", rowProps: rowProps = "6-6", backgroundColor: backgroundColor = "transparent", margin: margin = "80px 0" })=>{
    const renderImageProps = {
        imageLink: imageLink,
        imageAltText: imageAltText,
        aspectRatio: aspectRatio
    };
    const renderContentProps = {
        eyebrowText: eyebrowText,
        headerText: headerText,
        isBannerRichText: isBannerRichText,
        headerType: headerType,
        lozenge: lozenge,
        bodyText: bodyText,
        ctaProps: ctaProps,
        horizontalRule: horizontalRule,
        linkText: linkText,
        linkUrl: linkUrl
    };
    const first = imagePosition === "left" ? /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderImage, (0, $6ogO3._)({}, renderImageProps)) : /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderContent, (0, $6ogO3._)({}, renderContentProps));
    const second = imagePosition === "left" ? /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderContent, (0, $6ogO3._)({}, renderContentProps)) : /*#__PURE__*/ (0, $7VQPk.jsx)($52a85b4e5fd4de41$var$RenderImage, (0, $6ogO3._)({}, renderImageProps));
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _1kmx7vkz _1ggmidpf _1ykz7vkz _1maeidpf _i6jx1wqb _1lh7idpf _z3nc1wqb _wpaiidpf",
            className
        ]),
        style: {
            "--bkgd-color": backgroundColor,
            "--margin": margin,
            "backgroundColor": "var(--bkgd-color, transparent)",
            "margin": "var(--margin, 0)"
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
            layout: rowProps,
            alignItems: alignItems,
            children: [
                first,
                second
            ]
        })
    });
};

});


parcelRegister("dSJSp", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiBackground", function () { return $9260c7e6a9a0f7d6$export$89e553d210168ba3; });
/* paid-jira-ai-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $9260c7e6a9a0f7d6$var$containerStyle = null;
const $9260c7e6a9a0f7d6$var$backgroundBlurStyle = null;
const $9260c7e6a9a0f7d6$var$leftVectorStyle = null;
const $9260c7e6a9a0f7d6$var$leftTicketsStyle = null;
const $9260c7e6a9a0f7d6$var$rightVectorStyle = null;
const $9260c7e6a9a0f7d6$var$rightGoalsStyle = null;
const $9260c7e6a9a0f7d6$export$89e553d210168ba3 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "paid-jira-ai-background",
        className: (0, $2jatx.default)([
            "_1pby1mrw _kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1kxc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1r6p _p12f1osq _4t3i4d55 _kqswstnw _1e021ssb _t9eczr6s _152t1lze _11q7ob6u _kdam1tg5 _tzy41ou4"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf _152t1wdt _spvdglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "278",
                        height: "346",
                        viewBox: "0 0 278 346",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M126.304 216.886C141.869 233.09 165.768 229.102 199.031 197.151C202.628 193.696 205.438 189.284 209.035 185.829L277.314 256.912C271.899 263.892 263.781 271.69 252.99 282.056C170.191 361.588 93.474 360.919 42.4374 307.786C4.43138 268.22 0.727808 230.217 3.22073 191.465C3.82247 163.224 5.10354 142.958 -8.71683 128.57C-24.2812 112.367 -48.1115 116.288 -81.4433 148.306L-93.0907 159.494L-160.514 89.3015C-154.209 81.4664 -146.09 73.6677 -136.19 64.1579C-52.5348 -16.1976 23.3597 -16.3841 75.219 37.6046C113.258 77.2054 116.038 116.03 114.333 154.025C113.8 182.2 112.45 202.531 126.27 216.919L126.304 216.886Z",
                            fill: "#FCA700"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e02idpf _152t1ame _1itk1wg8 _1lrw1dfr _12vemgnk _1bsb1l5f _4t3i1g4h _1pbycs5v"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _rjxpidpf _152tcae7 _spvdglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "259",
                        height: "422",
                        viewBox: "0 0 259 422",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M387.189 211.854L214.396 384.134L111.034 351.343L69.1056 110.944L261.572 55.9512L387.189 211.854Z",
                            fill: "#BF63F3",
                            stroke: "#BF63F3",
                            strokeWidth: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _rjxpidpf _152tautk _1itk1t7m _1lrw1dfr _12vemgnk _1bsb3sup _4t3io25y _1pbycs5v"
                        ])
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("jYNiT", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiDisclaimer", function () { return $ae803050897374c7$export$360a68ea5c3472a9; });
/* paid-jira-ai-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $kYjgt = parcelRequire("kYjgt");
const $ae803050897374c7$var$containerCss = null;
const $ae803050897374c7$export$360a68ea5c3472a9 = ()=>{
    const acceptableUsePolicyLinkHref = (0, $kooLp.useLocalizedHref)("/legal/acceptable-use-policy");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ect418aq _1wyboqnp _vwz41cby _syazr3uz _1pfh1j6v _y3gn1h6o _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $kYjgt.messages).acceptableUsePolicyDisclaimer), {
            values: {
                acceptableUsePolicyLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        type: "inline",
                        text: text,
                        "aria-label": text,
                        href: acceptableUsePolicyLinkHref
                    })
            }
        }))
    });
};

});

parcelRegister("4Dg8Z", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiHeader", function () { return $849bf4e102b0673b$export$82f38f5bb421b213; });
/* paid-jira-ai-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $kYjgt = parcelRequire("kYjgt");
const $849bf4e102b0673b$var$containerCss = null;
const $849bf4e102b0673b$var$headerCss = null;
const $849bf4e102b0673b$var$subHeaderCss = null;
const $849bf4e102b0673b$export$82f38f5bb421b213 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_ect41roz _k48p9y44 _1wybckbl _vwz48vuz _y3gn1h6o _syazr3uz _1pfh1h39"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).getToDoneFaster))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_ect418aq _k48p1nn1 _1wyb7vkz _vwz41tcg _y3gn1h6o _syazr3uz _19pkftgi _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).aiPoweredProjectManagement))
            })
        ]
    });
};

});

parcelRegister("6HCeC", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiPreviewModal", function () { return $aa8e2f30f553fcbf$export$10f9150bed23074; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react-hooks/exhaustive-deps */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $4WS03 = parcelRequire("4WS03");

var $h6Fsc = parcelRequire("h6Fsc");

var $63bv7 = parcelRequire("63bv7");

var $ljrfG = parcelRequire("ljrfG");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");

var $jUBSR = parcelRequire("jUBSR");

var $33kEK = parcelRequire("33kEK");

var $6qT9Y = parcelRequire("6qT9Y");

var $6G35q = parcelRequire("6G35q");

var $aBUAq = parcelRequire("aBUAq");
const $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS = 250;
const $aa8e2f30f553fcbf$var$backgroundCss = null;
const $aa8e2f30f553fcbf$var$mainContainerCss = null;
const $aa8e2f30f553fcbf$var$headerContainerCss = null;
const $aa8e2f30f553fcbf$var$headerContainerShowCss = null;
const $aa8e2f30f553fcbf$var$bodyContainerCss = null;
const $aa8e2f30f553fcbf$var$promptSlideOutKeyframes = null;
const $aa8e2f30f553fcbf$var$promptSlideInKeyframes = null;
const $aa8e2f30f553fcbf$var$promptContainerCss = null;
const $aa8e2f30f553fcbf$var$promptContainerShowAnimationCss = null;
const $aa8e2f30f553fcbf$var$promptContainerHideAnimationCss = null;
const $aa8e2f30f553fcbf$export$10f9150bed23074 = ({ onClose: onClose })=>{
    const intl = (0, $8e22h.default)();
    const { cgsDataLoading: cgsDataLoading, formattedCgsData: formattedCgsData, rawCgsData: rawCgsData, firePaidJiraAi: firePaidJiraAi, promptAttemptIndex: promptAttemptIndex, isErrorFromCgs: isErrorFromCgs } = (0, $jUBSR.useJiraAiFFL)();
    const [showJiraSpaceReady, setShowJiraSpaceReady] = (0, $1oC0p.useState)(false);
    const [jiraSpaceShownAtLeastOnce, setJiraSpaceShownAtLeastOnce] = (0, $1oC0p.useState)(false);
    const [progressiveRows, setProgressiveRows] = (0, $1oC0p.useState)(undefined);
    const revealTimeoutsRef = (0, $1oC0p.useRef)([]);
    const modalOpenedAtRef = (0, $1oC0p.useRef)(null);
    const revealStartedAtRef = (0, $1oC0p.useRef)(null);
    const rowsRevealedCountRef = (0, $1oC0p.useRef)(0);
    const revealPlannedMsRef = (0, $1oC0p.useRef)(null);
    const firePaidJiraAiRef = (0, $1oC0p.useRef)(firePaidJiraAi);
    const promptAttemptIndexRef = (0, $1oC0p.useRef)(promptAttemptIndex);
    const headerContainerRef = (0, $1oC0p.useRef)(null);
    const [showLoadingState, setShowLoadingState] = (0, $1oC0p.useState)(false);
    const [bodyContainerPositionY, setBodyContainerPositionY] = (0, $1oC0p.useState)(0);
    const clearRevealTimeouts = (0, $1oC0p.useCallback)(()=>{
        revealTimeoutsRef.current.forEach((t)=>window.clearTimeout(t));
        revealTimeoutsRef.current = [];
    }, []);
    // Disable scrolling in body
    (0, $1oC0p.useEffect)(()=>{
        window.document.body.style.overflow = "hidden";
        return ()=>{
            window.document.body.style.overflow = "";
        };
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        firePaidJiraAiRef.current = firePaidJiraAi;
    }, [
        firePaidJiraAi
    ]);
    (0, $1oC0p.useEffect)(()=>{
        promptAttemptIndexRef.current = promptAttemptIndex;
    }, [
        promptAttemptIndex
    ]);
    (0, $1oC0p.useEffect)(()=>{
        modalOpenedAtRef.current = performance.now();
        firePaidJiraAiRef.current("PreviewModalOpened", "viewed", {
            promptAttemptIndex: promptAttemptIndexRef.current
        });
        // Cleanup on unmount.
        return ()=>clearRevealTimeouts();
    }, []);
    // Show loading UI while loading
    (0, $1oC0p.useEffect)(()=>{
        if (cgsDataLoading) {
            clearRevealTimeouts();
            setShowJiraSpaceReady(false);
            setProgressiveRows(undefined);
        }
    }, [
        cgsDataLoading
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (cgsDataLoading) setShowLoadingState(true);
    }, [
        cgsDataLoading
    ]);
    // Progressive reveal: append rows one-by-one so customers see "AI generating" behavior.
    // Note: this is a UI effect; the API response still arrives as a single payload.
    (0, $1oC0p.useEffect)(()=>{
        if (!formattedCgsData || formattedCgsData.length === 0) return;
        clearRevealTimeouts();
        setShowJiraSpaceReady(false);
        rowsRevealedCountRef.current = 0;
        revealStartedAtRef.current = performance.now();
        revealPlannedMsRef.current = formattedCgsData.length * $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS;
        firePaidJiraAiRef.current("PreviewRevealStarted", "started", {
            promptAttemptIndex: promptAttemptIndexRef.current,
            rowCount: formattedCgsData.length,
            revealPlannedMs: revealPlannedMsRef.current
        });
        // Keep a fixed height while revealing (shows placeholder rows).
        const minRowCount = 6;
        const targetLen = Math.max(minRowCount, formattedCgsData.length);
        setProgressiveRows(Array.from({
            length: targetLen
        }));
        formattedCgsData.forEach((row, idx)=>{
            const t = window.setTimeout(()=>{
                setProgressiveRows((prev)=>{
                    if (!prev) return prev;
                    const next = [
                        ...prev
                    ];
                    next[idx] = row;
                    rowsRevealedCountRef.current = Math.max(rowsRevealedCountRef.current, idx + 1);
                    return next;
                });
            }, idx * $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS);
            revealTimeoutsRef.current.push(t);
        });
        // Mark workspace ready only after the table finishes populating.
        const done = window.setTimeout(()=>{
            setProgressiveRows(formattedCgsData);
            setShowJiraSpaceReady(true);
            setJiraSpaceShownAtLeastOnce(true);
            setShowLoadingState(false);
            const now = performance.now();
            const revealDurationMs = revealStartedAtRef.current ? Math.max(0, now - revealStartedAtRef.current) : undefined;
            const dwellMs = modalOpenedAtRef.current ? Math.max(0, now - modalOpenedAtRef.current) : undefined;
            var _revealPlannedMsRef_current;
            firePaidJiraAiRef.current("PreviewReady", "succeeded", {
                promptAttemptIndex: promptAttemptIndexRef.current,
                rowCount: formattedCgsData.length,
                revealDurationMs: revealDurationMs,
                revealPlannedMs: (_revealPlannedMsRef_current = revealPlannedMsRef.current) !== null && _revealPlannedMsRef_current !== void 0 ? _revealPlannedMsRef_current : undefined,
                dwellMs: dwellMs
            });
        }, formattedCgsData.length * $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS + 50);
        revealTimeoutsRef.current.push(done);
    }, [
        formattedCgsData
    ]);
    // Close modal on esc press
    (0, $1oC0p.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            // If user is focused on the contentEditable span input, then don't close the modal on esc
            const active = document.activeElement;
            if ((active === null || active === void 0 ? void 0 : active.isContentEditable) || active instanceof HTMLInputElement) return;
            if (event.key === "Escape") onClose === null || onClose === void 0 ? void 0 : onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        // Cleanup
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, []);
    const handleClose = (0, $1oC0p.useCallback)(()=>{
        const now = performance.now();
        const dwellMs = modalOpenedAtRef.current ? Math.max(0, now - modalOpenedAtRef.current) : undefined;
        firePaidJiraAiRef.current("PreviewModalClosed", "closed", {
            promptAttemptIndex: promptAttemptIndexRef.current,
            closeReason: "xButton",
            dwellMs: dwellMs,
            rowsRevealedCount: rowsRevealedCountRef.current
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        onClose
    ]);
    // Position adjustment for sliding animation
    // Adjust y position for body element when header height changes
    (0, $1oC0p.useEffect)(()=>{
        if (!showJiraSpaceReady) {
            setBodyContainerPositionY(0);
            return;
        }
        const updatePosition = ()=>{
            var _headerContainerRef_current;
            const headerHeight = ((_headerContainerRef_current = headerContainerRef.current) === null || _headerContainerRef_current === void 0 ? void 0 : _headerContainerRef_current.offsetHeight) || 0;
            setBodyContainerPositionY(headerHeight + 16);
        };
        const timer = setTimeout(updatePosition);
        window.addEventListener("resize", updatePosition);
        // Cleanup
        return ()=>{
            clearTimeout(timer);
            window.removeEventListener("resize", updatePosition);
        };
    }, [
        isErrorFromCgs,
        showJiraSpaceReady
    ]); // Keep isErrorFromCgs, ref height changes on error
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqsw1n9t _1pbyb4wl _1bsbauwl _4t3i1kxc _1ltvidpf _154iidpf _11q7cd5j"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6qT9Y.Background), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqsw1n9t _1e02idpf _152tidpf _1bsbauwl _4t3i1kxc _1pbyjwwv _ca0qgktf _u5f31f4h _n3tdgktf _19bv1f4h _1reo15zi _18m915zi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ljrfG.default), {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraIcon), {
                                appearance: "brand",
                                shouldUseNewLogoDesign: true
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                                shape: "circle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))),
                                label: intl.formatMessage((0, $kYjgt.messages).close),
                                appearance: "default",
                                onClick: handleClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: headerContainerRef,
                        className: (0, $2jatx.default)([
                            "_m6k41rjc _kqswstnw _1bsbkest _t9ec13ve _tzy4idpf _v5646wc9",
                            showJiraSpaceReady && "_t9ec1kli _tzy4kb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6G35q.Header), {
                            onRetryClick: ()=>{
                                firePaidJiraAi("PreviewRetryClicked", "clicked", {
                                    promptAttemptIndex: promptAttemptIndex,
                                    rowsRevealedCount: rowsRevealedCountRef.current
                                });
                                clearRevealTimeouts();
                                setShowJiraSpaceReady(false);
                                setProgressiveRows(undefined);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: {
                            transform: `translateY(${bodyContainerPositionY}px)`
                        },
                        className: (0, $2jatx.default)([
                            "_m6k41e03 _kqswh2mm _v564o8wx _1pfhviql"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aBUAq.PreviewTable), {
                                rows: progressiveRows !== null && progressiveRows !== void 0 ? progressiveRows : formattedCgsData,
                                spaceName: cgsDataLoading ? undefined : rawCgsData === null || rawCgsData === void 0 ? void 0 : rawCgsData.sampleIssues.spaceName
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfhckbl _y3gn1h6o _m6k41rjc _kqswh2mm",
                                    showJiraSpaceReady && "",
                                    showJiraSpaceReady && "_y44v15q7",
                                    !showJiraSpaceReady && jiraSpaceShownAtLeastOnce && "",
                                    !showJiraSpaceReady && jiraSpaceShownAtLeastOnce && "_y44vayar"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33kEK.PaidJiraAiTeamTypeMadLibPrompt), {
                                    isRerun: true,
                                    showLoadingState: showLoadingState
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("4WS03", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39a67771810b537d$export$2e2bcd8739ae039; });

var $8Ad6U = parcelRequire("8Ad6U");

var $2rbPH = parcelRequire("2rbPH");

var $1oC0p = parcelRequire("1oC0p");

var $kPutE = parcelRequire("kPutE");

var $ilIaa = parcelRequire("ilIaa");

var $awhiQ = parcelRequire("awhiQ");

var $lCzCA = parcelRequire("lCzCA");

var $jBgJs = parcelRequire("jBgJs");

var $7kLyP = parcelRequire("7kLyP");
var $39a67771810b537d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $39a67771810b537d$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $39a67771810b537d$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $2rbPH.default)(_ref, $39a67771810b537d$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $2rbPH.default)(unsafeRest, $39a67771810b537d$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lCzCA.default), (0, $8Ad6U.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jBgJs.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7kLyP.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $awhiQ.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $ilIaa.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $lCzCA.default), (0, $8Ad6U.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $kPutE.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $jBgJs.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7kLyP.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $awhiQ.default), null, label)));
    });
}));
$39a67771810b537d$var$IconButton.displayName = 'IconButton';
var $39a67771810b537d$export$2e2bcd8739ae039 = $39a67771810b537d$var$IconButton;

});
parcelRegister("lCzCA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fbd8c73b8607da45$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8Ad6U = parcelRequire("8Ad6U");

var $2rbPH = parcelRequire("2rbPH");

var $axrVF = parcelRequire("axrVF");

var $1oC0p = parcelRequire("1oC0p");

var $72iRh = parcelRequire("72iRh");

var $kPutE = parcelRequire("kPutE");

var $gyCsW = parcelRequire("gyCsW");

var $4UF4U = parcelRequire("4UF4U");

var $39c3M = parcelRequire("39c3M");

var $6Ipjw = parcelRequire("6Ipjw");

var $awhiQ = parcelRequire("awhiQ");

var $9z2pQ = parcelRequire("9z2pQ");

var $fhMPB = parcelRequire("fhMPB");

var $2ylX1 = parcelRequire("2ylX1");
var $fbd8c73b8607da45$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $fbd8c73b8607da45$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $fbd8c73b8607da45$var$LOADING_LABEL = ', Loading';
var $fbd8c73b8607da45$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $fbd8c73b8607da45$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $fbd8c73b8607da45$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $fbd8c73b8607da45$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $fbd8c73b8607da45$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $fbd8c73b8607da45$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $fbd8c73b8607da45$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $fbd8c73b8607da45$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $fbd8c73b8607da45$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $2rbPH.default)(_ref, $fbd8c73b8607da45$var$_excluded);
    var localRef = (0, $1oC0p.useRef)(null);
    var splitButtonContext = (0, $9z2pQ.useSplitButtonContext)();
    var loadingLabelId = (0, $4UF4U.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $39c3M.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gyCsW.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $2rbPH.default)(unsafeRest, $fbd8c73b8607da45$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $6Ipjw.default), (0, $8Ad6U.default)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $kPutE.default)([
            localRef,
            ref
        ]),
        xcss: (0, $72iRh.cx)($fbd8c73b8607da45$var$styles.base, appearance === 'default' && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$defaultStyles.rootRefreshed : $fbd8c73b8607da45$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$defaultStyles.interactiveRefreshed : $fbd8c73b8607da45$var$defaultStyles.interactive), appearance === 'primary' && $fbd8c73b8607da45$var$primaryStyles.root, appearance === 'primary' && isInteractive && $fbd8c73b8607da45$var$primaryStyles.interactive, appearance === 'warning' && $fbd8c73b8607da45$var$warningStyles.root, appearance === 'warning' && isInteractive && $fbd8c73b8607da45$var$warningStyles.interactive, appearance === 'danger' && $fbd8c73b8607da45$var$dangerStyles.root, appearance === 'danger' && isInteractive && $fbd8c73b8607da45$var$dangerStyles.interactive, appearance === 'discovery' && $fbd8c73b8607da45$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $fbd8c73b8607da45$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$subtleStyles.rootRefreshed : $fbd8c73b8607da45$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$subtleStyles.interactiveRefreshed : $fbd8c73b8607da45$var$subtleStyles.interactive), $fbd8c73b8607da45$var$styles.linkDecorationUnset, isSelected && ((0, $39c3M.fg)('platform-component-visual-refresh') ? $fbd8c73b8607da45$var$selectedStyles.rootRefreshed : $fbd8c73b8607da45$var$selectedStyles.root), isSelected && isSplitButton && $fbd8c73b8607da45$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $fbd8c73b8607da45$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $fbd8c73b8607da45$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $fbd8c73b8607da45$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $fbd8c73b8607da45$var$selectedStyles.discovery, isDisabled && $fbd8c73b8607da45$var$styles.disabled, isCircle && !isSplitButton && $fbd8c73b8607da45$var$styles.circle, spacing === 'compact' && $fbd8c73b8607da45$var$styles.spacingCompact, hasIconBefore && $fbd8c73b8607da45$var$styles.buttonIconBefore, shouldFitContainer && $fbd8c73b8607da45$var$styles.fullWidth, hasIconAfter && $fbd8c73b8607da45$var$styles.buttonIconAfter, isIconButton && $fbd8c73b8607da45$var$styles.iconButton, isIconButton && spacing === 'compact' && $fbd8c73b8607da45$var$styles.iconButtonCompact, isLoading && $fbd8c73b8607da45$var$styles.loading, isSplitButton && $fbd8c73b8607da45$var$styles.splitButton, isNavigationSplitButton && $fbd8c73b8607da45$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($fbd8c73b8607da45$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $fhMPB.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9z2pQ.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        className: (0, $axrVF.default)([
            $fbd8c73b8607da45$var$styles.loadingOverlay
        ])
    }, (0, $2ylX1.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $awhiQ.default), {
        id: loadingLabelId
    }, $fbd8c73b8607da45$var$LOADING_LABEL)));
});
var $fbd8c73b8607da45$export$2e2bcd8739ae039 = $fbd8c73b8607da45$var$ButtonBase;

});
parcelRegister("6Ipjw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e3a7cf7f3c74217$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8Ad6U = parcelRequire("8Ad6U");

var $2rbPH = parcelRequire("2rbPH");

var $1oC0p = parcelRequire("1oC0p");


var $7iPpc = parcelRequire("7iPpc");

var $8dNux = parcelRequire("8dNux");

var $ef3YL = parcelRequire("ef3YL");

var $7uNuF = parcelRequire("7uNuF");

var $etBkE = parcelRequire("etBkE");

var $auuFw = parcelRequire("auuFw");
var $4e3a7cf7f3c74217$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $4e3a7cf7f3c74217$var$_excluded2 = [
    "className"
];
var $4e3a7cf7f3c74217$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $4e3a7cf7f3c74217$var$Pressable = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $7uNuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $2rbPH.default)(_ref, $4e3a7cf7f3c74217$var$_excluded);
    var interactionContext = (0, $1oC0p.useContext)((0, $etBkE.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $8dNux.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.0",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $2rbPH.default)(htmlAttributes, $4e3a7cf7f3c74217$var$_excluded2);
    return /*#__PURE__*/ $1oC0p.createElement((0, $auuFw.default), (0, $8Ad6U.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $ef3YL.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $7iPpc.cx)($4e3a7cf7f3c74217$var$styles.root, isDisabled && $4e3a7cf7f3c74217$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $4e3a7cf7f3c74217$export$2e2bcd8739ae039 = $4e3a7cf7f3c74217$var$Pressable;

});
parcelRegister("ef3YL", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $a5e58d8d2836fb88$export$95df08bae54cb4df; });
function $a5e58d8d2836fb88$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $a5e58d8d2836fb88$var$isIPhone() {
    return $a5e58d8d2836fb88$var$testPlatform(/^iPhone/i);
}
function $a5e58d8d2836fb88$var$isMac() {
    return $a5e58d8d2836fb88$var$testPlatform(/^Mac/i);
}
function $a5e58d8d2836fb88$var$isIPad() {
    return $a5e58d8d2836fb88$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $a5e58d8d2836fb88$var$isMac() && navigator.maxTouchPoints > 1;
}
function $a5e58d8d2836fb88$var$isIOS() {
    return $a5e58d8d2836fb88$var$isIPhone() || $a5e58d8d2836fb88$var$isIPad();
}
function $a5e58d8d2836fb88$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $a5e58d8d2836fb88$export$e1865c3bedcd822b() {
    return $a5e58d8d2836fb88$var$isMac() || $a5e58d8d2836fb88$var$isIOS();
}

});


parcelRegister("9z2pQ", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", function () { return $6f6941b27a08e699$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $6f6941b27a08e699$export$47e2c6fdb142d947; });

var $1oC0p = parcelRequire("1oC0p");
var $6f6941b27a08e699$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
var $6f6941b27a08e699$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $1oC0p.useContext)($6f6941b27a08e699$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("fhMPB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b20e5271e86cf2bc$export$2e2bcd8739ae039; });
function $b20e5271e86cf2bc$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $b20e5271e86cf2bc$var$tabKeyCode = 9;
function $b20e5271e86cf2bc$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b20e5271e86cf2bc$var$tabKeyCode) return;
    $b20e5271e86cf2bc$var$abort(event);
}
function $b20e5271e86cf2bc$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $b20e5271e86cf2bc$var$abort,
        onMouseUpCapture: $b20e5271e86cf2bc$var$abort,
        onKeyDownCapture: $b20e5271e86cf2bc$var$onKey,
        onKeyUpCapture: $b20e5271e86cf2bc$var$onKey,
        onTouchStartCapture: $b20e5271e86cf2bc$var$abort,
        onTouchEndCapture: $b20e5271e86cf2bc$var$abort,
        onPointerDownCapture: $b20e5271e86cf2bc$var$abort,
        onPointerUpCapture: $b20e5271e86cf2bc$var$abort,
        onClickCapture: $b20e5271e86cf2bc$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $b20e5271e86cf2bc$var$abort
    } : events;
}

});

parcelRegister("2ylX1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1dbfc8c62de116d0$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $k7Rwn = parcelRequire("k7Rwn");
function $1dbfc8c62de116d0$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $1dbfc8c62de116d0$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $1dbfc8c62de116d0$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $k7Rwn.default), {
        size: $1dbfc8c62de116d0$var$getIconSpacing(spacing),
        appearance: $1dbfc8c62de116d0$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("k7Rwn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea6dfa4dd66dc7b5$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $49jjD = parcelRequire("49jjD");

var $1oC0p = parcelRequire("1oC0p");

var $etBkE = parcelRequire("etBkE");

var $DdsbK = parcelRequire("DdsbK");

var $jllqM = parcelRequire("jllqM");
/**
 * Returns the appropriate circle stroke color.
 */ function $ea6dfa4dd66dc7b5$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $DdsbK.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $DdsbK.N0), ")");
}
var $ea6dfa4dd66dc7b5$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $ea6dfa4dd66dc7b5$var$loadIn = null;
var $ea6dfa4dd66dc7b5$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $ea6dfa4dd66dc7b5$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $ea6dfa4dd66dc7b5$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $jllqM.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $ea6dfa4dd66dc7b5$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $etBkE.default));
    $ea6dfa4dd66dc7b5$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $49jjD.default)([
            $ea6dfa4dd66dc7b5$var$styles.wrapperStyles,
            $ea6dfa4dd66dc7b5$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $49jjD.default)([
            $ea6dfa4dd66dc7b5$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $49jjD.default)([
            $ea6dfa4dd66dc7b5$var$styles.circleStyles
        ])
    })));
}));
var $ea6dfa4dd66dc7b5$export$2e2bcd8739ae039 = $ea6dfa4dd66dc7b5$var$Spinner;

});
parcelRegister("49jjD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3056fc6010fcc978$export$2e2bcd8739ae039; });
const $3056fc6010fcc978$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $3056fc6010fcc978$var$ATOMIC_GROUP_LENGTH = 5;
function $3056fc6010fcc978$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $3056fc6010fcc978$var$UNDERSCORE_UNICODE ? $3056fc6010fcc978$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("DdsbK", function(module, exports) {
$parcel$export(module.exports, "N0", function () { return $075e143f94feb311$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $075e143f94feb311$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $075e143f94feb311$export$4b84fd0e2c617bd = '#FFEBE6';
var $075e143f94feb311$export$b34b069eff244586 = '#FFBDAD';
var $075e143f94feb311$export$be802dd0d8b57f35 = '#FF8F73';
var $075e143f94feb311$export$60847d42f9da92a6 = '#FF7452';
var $075e143f94feb311$export$4a7404f376229999 = '#FF5630';
var $075e143f94feb311$export$2010d0fb4295b346 = '#DE350B';
var $075e143f94feb311$export$2837b5a1a71d5c02 = '#BF2600';
var $075e143f94feb311$export$8d9596b529bbb9cf = '#FFFAE6';
var $075e143f94feb311$export$41060a744ab0b7ae = '#FFF0B3';
var $075e143f94feb311$export$1cc05bbbf340e559 = '#FFE380';
var $075e143f94feb311$export$5aae31392d72caaa = '#FFC400';
var $075e143f94feb311$export$c6930421db9fa514 = '#FFAB00';
var $075e143f94feb311$export$59619663aa6500fb = '#FF991F';
var $075e143f94feb311$export$874739ea9e379ab6 = '#FF8B00';
var $075e143f94feb311$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $075e143f94feb311$export$69a3bf21b9686c2b = '#ABF5D1';
var $075e143f94feb311$export$afbce1382ec95f73 = '#79F2C0';
var $075e143f94feb311$export$747d86715d4175de = '#57D9A3';
var $075e143f94feb311$export$940e1f69e873f202 = '#36B37E';
var $075e143f94feb311$export$a49394138f7b8e85 = '#00875A';
var $075e143f94feb311$export$6fa04827ac68a4fb = '#006644';
var $075e143f94feb311$export$226de0355ed012f8 = '#DEEBFF';
var $075e143f94feb311$export$8c13c2ee36917869 = '#B3D4FF';
var $075e143f94feb311$export$ecfc1dff386a3e7a = '#4C9AFF';
var $075e143f94feb311$export$215b7063051591f1 = '#2684FF';
var $075e143f94feb311$export$e62e8919cca44969 = '#0065FF';
var $075e143f94feb311$export$b3de0ae08da2ce64 = '#0052CC';
var $075e143f94feb311$export$a6ee3d71bc067634 = '#0747A6';
var $075e143f94feb311$export$67f15409e87642a1 = '#669DF1';
var $075e143f94feb311$export$f0539dbc42dbb067 = '#8FB8F6';
var $075e143f94feb311$export$363e4475840015bb = '#EAE6FF';
var $075e143f94feb311$export$4b0a4417ed59760f = '#C0B6F2';
var $075e143f94feb311$export$6011520a64d9a187 = '#998DD9';
var $075e143f94feb311$export$a7175d4e9206bc80 = '#8777D9';
var $075e143f94feb311$export$b48405b95304b5a1 = '#6554C0';
var $075e143f94feb311$export$c71e4279dd54a18d = '#5243AA';
var $075e143f94feb311$export$147899de772240ec = '#403294';
var $075e143f94feb311$export$2cf711fe14c66f06 = '#E6FCFF';
var $075e143f94feb311$export$7a8f4d33f6f9772c = '#B3F5FF';
var $075e143f94feb311$export$776c9c497ef08533 = '#79E2F2';
var $075e143f94feb311$export$69cb3ca10c1e330e = '#00C7E6';
var $075e143f94feb311$export$9dc1ef0f3f48059b = '#00B8D9';
var $075e143f94feb311$export$7c835c78b6fcdef8 = '#00A3BF';
var $075e143f94feb311$export$6036577f95c3877e = '#008DA6';
var $075e143f94feb311$export$29a4f05edc054374 = '#FFFFFF';
var $075e143f94feb311$export$e655ef011c4aa1a2 = '#FAFBFC';
var $075e143f94feb311$export$9fdfb749e33cdf97 = '#F4F5F7';
var $075e143f94feb311$export$3e51e8f1440314ba = '#EBECF0';
var $075e143f94feb311$export$1ce2d1575d444ceb = '#DFE1E6';
var $075e143f94feb311$export$8754fc7e6d8b3000 = '#C1C7D0';
var $075e143f94feb311$export$c2e91cbeada39b8b = '#B3BAC5';
var $075e143f94feb311$export$5f71e19f3a7ad9de = '#A5ADBA';
var $075e143f94feb311$export$eaa8c8a70ac22806 = '#97A0AF';
var $075e143f94feb311$export$7c87d337fb91a97d = '#8993A4';
var $075e143f94feb311$export$d6447c357493214f = '#7A869A';
var $075e143f94feb311$export$f563ee71e9ee74cd = '#6B778C';
var $075e143f94feb311$export$e2ef2124cf4024b1 = '#5E6C84';
var $075e143f94feb311$export$eece5f492e429f08 = '#505F79';
var $075e143f94feb311$export$c39c0fe0f26207ae = '#42526E';
var $075e143f94feb311$export$7090862dc3038a9f = '#344563';
var $075e143f94feb311$export$ad0bacf983b7ddaa = '#253858';
var $075e143f94feb311$export$7d61b15e0da132af = '#172B4D';
var $075e143f94feb311$export$fbda843f0a27fe96 = '#091E42';
var $075e143f94feb311$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $075e143f94feb311$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $075e143f94feb311$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $075e143f94feb311$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $075e143f94feb311$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $075e143f94feb311$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $075e143f94feb311$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $075e143f94feb311$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $075e143f94feb311$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $075e143f94feb311$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $075e143f94feb311$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $075e143f94feb311$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $075e143f94feb311$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $075e143f94feb311$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $075e143f94feb311$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $075e143f94feb311$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $075e143f94feb311$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $075e143f94feb311$export$2f6319cf7d736c2a = '#E6EDFA';
var $075e143f94feb311$export$95126bc8884d6634 = '#DCE5F5';
var $075e143f94feb311$export$8338d8c35d44ff1 = '#CED9EB';
var $075e143f94feb311$export$5368d76ae4fbbda7 = '#B8C7E0';
var $075e143f94feb311$export$9f0a771d16ec8d36 = '#ABBBD6';
var $075e143f94feb311$export$abcf8c38338b4aa5 = '#9FB0CC';
var $075e143f94feb311$export$97e81faa16a182c7 = '#8C9CB8';
var $075e143f94feb311$export$bfe21c59123ecf33 = '#7988A3';
var $075e143f94feb311$export$ee82aa2ea6a1558 = '#67758F';
var $075e143f94feb311$export$682927c6ed76be02 = '#56637A';
var $075e143f94feb311$export$91fd9994c5be9757 = '#455166';
var $075e143f94feb311$export$d281fbfe3cff2df6 = '#3B475C';
var $075e143f94feb311$export$3902c91d8b98a753 = '#313D52';
var $075e143f94feb311$export$8e8133c1ba5845b5 = '#283447';
var $075e143f94feb311$export$33ff357f6620b39 = '#202B3D';
var $075e143f94feb311$export$633847cf062b69e0 = '#1B2638';
var $075e143f94feb311$export$9776a6e503bdbf76 = '#121A29';
var $075e143f94feb311$export$6c813d5160dff5db = '#0E1624';
var $075e143f94feb311$export$3d4f271a500072a = '#0D1424';
var $075e143f94feb311$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $075e143f94feb311$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $075e143f94feb311$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $075e143f94feb311$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $075e143f94feb311$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $075e143f94feb311$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $075e143f94feb311$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $075e143f94feb311$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $075e143f94feb311$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $075e143f94feb311$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $075e143f94feb311$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $075e143f94feb311$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $075e143f94feb311$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $075e143f94feb311$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $075e143f94feb311$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $075e143f94feb311$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $075e143f94feb311$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $075e143f94feb311$export$d2adc5dedf09fced = '#292A2E';
var $075e143f94feb311$export$f51762073d2bb381 = '#94C748';
var $075e143f94feb311$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("jllqM", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $e1509a39136a530d$export$4e9f1640bbe7a1a8; });
var $e1509a39136a530d$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});





parcelRegister("ljrfG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f84082fe6c13430b$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3HaTX = parcelRequire("3HaTX");
var $f84082fe6c13430b$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $f84082fe6c13430b$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $f84082fe6c13430b$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $f84082fe6c13430b$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $f84082fe6c13430b$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $f84082fe6c13430b$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $f84082fe6c13430b$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $f84082fe6c13430b$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    return /*#__PURE__*/ $1oC0p.createElement(Component, {
        role: role,
        className: (0, $3HaTX.default)([
            $f84082fe6c13430b$var$styles.root,
            gap && $f84082fe6c13430b$var$columnGapMap[gap],
            columnGap && $f84082fe6c13430b$var$columnGapMap[columnGap],
            gap && $f84082fe6c13430b$var$rowGapMap[gap],
            rowGap && $f84082fe6c13430b$var$rowGapMap[rowGap],
            alignItems && $f84082fe6c13430b$var$alignItemsMap[alignItems],
            direction && $f84082fe6c13430b$var$flexDirectionMap[direction],
            justifyContent && $f84082fe6c13430b$var$justifyContentMap[justifyContent],
            wrap && $f84082fe6c13430b$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f84082fe6c13430b$var$Flex.displayName = 'Flex';
var $f84082fe6c13430b$export$2e2bcd8739ae039 = $f84082fe6c13430b$var$Flex;

});
parcelRegister("3HaTX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2b0dd80d67d56afd$export$2e2bcd8739ae039; });
const $2b0dd80d67d56afd$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $2b0dd80d67d56afd$var$ATOMIC_GROUP_LENGTH = 5;
function $2b0dd80d67d56afd$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $2b0dd80d67d56afd$var$UNDERSCORE_UNICODE ? $2b0dd80d67d56afd$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});


parcelRegister("jUBSR", function(module, exports) {
$parcel$export(module.exports, "JiraAiFFLProvider", function () { return $0fa7666158234ad7$export$cb2adc27ad575a30; });
$parcel$export(module.exports, "useJiraAiFFL", function () { return $0fa7666158234ad7$export$2741bae471e27db6; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7XYQW = parcelRequire("7XYQW");

var $427NR = parcelRequire("427NR");

var $bqpaF = parcelRequire("bqpaF");

var $PE2DD = parcelRequire("PE2DD");

var $6qhMT = parcelRequire("6qhMT");

var $fx9D8 = parcelRequire("fx9D8");
const $0fa7666158234ad7$var$noop = ()=>{
/* empty */ };
const $0fa7666158234ad7$var$defaultContext = {
    submit: $0fa7666158234ad7$var$noop,
    selectedTeamType: (0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE),
    setSelectedTeamType: $0fa7666158234ad7$var$noop,
    workingOnSuggestion: "",
    goalSuggestion: "",
    workingOnValue: "",
    goalValue: "",
    setWorkingOnValue: $0fa7666158234ad7$var$noop,
    setGoalValue: $0fa7666158234ad7$var$noop,
    hasUserSelectedTeamType: false,
    setHasUserSelectedTeamType: $0fa7666158234ad7$var$noop,
    hasSubmittedDefaultValues: false,
    shuffle: $0fa7666158234ad7$var$noop,
    suggestMadLib: $0fa7666158234ad7$var$noop,
    promptAttemptIndex: 0,
    commonAnalyticsAttributes: {
        flow: (0, $6qhMT.PAID_JIRA_AI_FLOW),
        experimentKey: (0, $6qhMT.PAID_JIRA_AI_EXPERIMENT_KEY)
    },
    firePaidJiraAi: $0fa7666158234ad7$var$noop,
    markPromptChangedField: $0fa7666158234ad7$var$noop,
    cgsDataLoading: false,
    isErrorFromCgs: false,
    rawCgsData: undefined,
    formattedCgsData: undefined,
    setIsErrorFromCgs: $0fa7666158234ad7$var$noop
};
const $0fa7666158234ad7$var$JiraAiFFLContext = /*#__PURE__*/ (0, $1oC0p.createContext)($0fa7666158234ad7$var$defaultContext);
const $0fa7666158234ad7$export$cb2adc27ad575a30 = ({ children: children })=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    // Analytics state
    const [promptAttemptIndex, setPromptAttemptIndex] = (0, $1oC0p.useState)(0);
    const promptAttemptIndexRef = (0, $1oC0p.useRef)(0);
    const changedFieldsRef = (0, $1oC0p.useRef)(new Set());
    const [changedFieldsVersion, setChangedFieldsVersion] = (0, $1oC0p.useState)(0);
    const engagedAtRef = (0, $1oC0p.useRef)(null);
    const hasSubmittedThisAttemptRef = (0, $1oC0p.useRef)(false);
    const hasFiredViewedRef = (0, $1oC0p.useRef)(false);
    const hasFiredEngagedRef = (0, $1oC0p.useRef)(false);
    const hasFiredAbandonedRef = (0, $1oC0p.useRef)(false);
    // Shared Madlib UI state
    const [selectedTeamType, setSelectedTeamType] = (0, $1oC0p.useState)($0fa7666158234ad7$var$defaultContext.selectedTeamType);
    const [workingOnSuggestion, setWorkingOnSuggestion] = (0, $1oC0p.useState)("");
    const [goalSuggestion, setGoalSuggestion] = (0, $1oC0p.useState)("");
    const [workingOnValue, setWorkingOnValue] = (0, $1oC0p.useState)("");
    const [goalValue, setGoalValue] = (0, $1oC0p.useState)("");
    const [hasUserSelectedTeamType, setHasUserSelectedTeamType] = (0, $1oC0p.useState)(false);
    const [hasSubmittedDefaultValues, setHasSubmittedDefaultValues] = (0, $1oC0p.useState)(false);
    const initialSuggestion = (0, $1oC0p.useRef)();
    const suggestionsIndex = (0, $1oC0p.useRef)({
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT)]: 0
    });
    // CGS state
    const [cgsDataLoading, setCgsDataLoading] = (0, $1oC0p.useState)(false);
    const [isErrorFromCgs, setIsErrorFromCgs] = (0, $1oC0p.useState)(false);
    const [cgsData, setCgsData] = (0, $1oC0p.useState)(undefined);
    (0, $1oC0p.useEffect)(()=>{
        promptAttemptIndexRef.current = promptAttemptIndex;
    }, [
        promptAttemptIndex
    ]);
    const getChangedFields = ()=>Array.from(changedFieldsRef.current);
    const workingOnLength = (0, $1oC0p.useMemo)(()=>workingOnValue.trim().length, [
        workingOnValue
    ]);
    const goalLength = (0, $1oC0p.useMemo)(()=>goalValue.trim().length, [
        goalValue
    ]);
    const promptType = (0, $1oC0p.useMemo)(()=>(0, $6qhMT.derivePromptType)({
            workingOnValue: workingOnValue,
            goalValue: goalValue,
            workingOnSuggestion: workingOnSuggestion,
            goalSuggestion: goalSuggestion
        }), [
        workingOnValue,
        goalValue,
        workingOnSuggestion,
        goalSuggestion
    ]);
    const teamTypeCategory = (0, $1oC0p.useMemo)(()=>(0, $6qhMT.categorizeTeamType)(selectedTeamType), [
        selectedTeamType
    ]);
    const commonAnalyticsAttributes = (0, $1oC0p.useMemo)(()=>{
        const changedFields = getChangedFields();
        const cgsKey = typeof window !== "undefined" ? (0, $6qhMT.getCgsKeyFromLocationHref)(window.location.href) : undefined;
        return {
            flow: (0, $6qhMT.PAID_JIRA_AI_FLOW),
            experimentKey: (0, $6qhMT.PAID_JIRA_AI_EXPERIMENT_KEY),
            teamType: selectedTeamType,
            teamTypeCategory: teamTypeCategory,
            promptAttemptIndex: promptAttemptIndex,
            isRetry: promptAttemptIndex > 1,
            promptType: promptType,
            didChangeAnything: changedFields.length > 0,
            changedFields: changedFields,
            workingOnLength: workingOnLength,
            goalLength: goalLength,
            cgsKey: cgsKey
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedTeamType,
        teamTypeCategory,
        promptAttemptIndex,
        promptType,
        workingOnLength,
        goalLength,
        changedFieldsVersion
    ]);
    const firePaidJiraAi = (0, $1oC0p.useCallback)((step, action, attributes = {})=>{
        (0, $6qhMT.firePaidJiraAiEvent)(createAnalyticsEvent, {
            step: step,
            action: action,
            attributes: (0, $6ogO3._)({}, commonAnalyticsAttributes, attributes)
        });
    }, [
        createAnalyticsEvent,
        commonAnalyticsAttributes
    ]);
    const markPromptEngaged = (0, $1oC0p.useCallback)(()=>{
        if (!engagedAtRef.current) engagedAtRef.current = performance.now();
        if (!hasFiredEngagedRef.current) {
            hasFiredEngagedRef.current = true;
            firePaidJiraAi("PromptEngaged", "started");
        }
    }, [
        firePaidJiraAi
    ]);
    const markPromptChangedField = (0, $1oC0p.useCallback)((field)=>{
        markPromptEngaged();
        if (!changedFieldsRef.current.has(field)) {
            changedFieldsRef.current.add(field);
            setChangedFieldsVersion((v)=>v + 1);
        }
    }, [
        markPromptEngaged
    ]);
    // Prompt view + abandonment tracking
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFiredViewedRef.current) {
            hasFiredViewedRef.current = true;
            firePaidJiraAi("PromptViewed", "viewed");
        }
        const maybeFireAbandoned = ()=>{
            if (hasFiredAbandonedRef.current) return;
            if (!engagedAtRef.current || hasSubmittedThisAttemptRef.current) return;
            hasFiredAbandonedRef.current = true;
            firePaidJiraAi("PromptAbandoned", "closed", {
                dwellMs: Math.max(0, performance.now() - engagedAtRef.current)
            });
        };
        window.addEventListener("pagehide", maybeFireAbandoned);
        const onVisibilityChange = ()=>{
            if (document.visibilityState === "hidden") maybeFireAbandoned();
        };
        document.addEventListener("visibilitychange", onVisibilityChange);
        return ()=>{
            window.removeEventListener("pagehide", maybeFireAbandoned);
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, [
        firePaidJiraAi
    ]);
    const suggestMadLib = (teamType)=>{
        const t = teamType || selectedTeamType;
        const suggestions = (0, $bqpaF.getSuggestionsForTeamType)(t);
        suggestionsIndex.current[t] = (suggestionsIndex.current[t] || 0) + 1;
        if (!suggestions[suggestionsIndex.current[t]]) suggestionsIndex.current[t] = 0;
        const suggestion = suggestions[suggestionsIndex.current[t]];
        const workingOnSuggestion = intl.formatMessage(suggestion === null || suggestion === void 0 ? void 0 : suggestion.task);
        const goalSuggestion = intl.formatMessage(suggestion === null || suggestion === void 0 ? void 0 : suggestion.goal);
        setWorkingOnSuggestion(workingOnSuggestion);
        setGoalSuggestion(goalSuggestion);
        if (!initialSuggestion.current) initialSuggestion.current = {
            workingOn: workingOnSuggestion,
            goal: goalSuggestion
        };
        setWorkingOnValue("");
        setGoalValue("");
    };
    // Ensure initial suggestion is populated on first mount
    // We intentionally omit dependencies to only run on first mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1oC0p.useEffect)(()=>suggestMadLib(), []);
    const shuffle = ()=>{
        markPromptChangedField("shuffle");
        firePaidJiraAi("PromptShuffleClicked", "clicked");
        if (!hasUserSelectedTeamType) {
            const teamTypes = Object.keys((0, $fx9D8.teamTypesMap));
            const randomTeamType = teamTypes[Math.floor(Math.random() * teamTypes.length)];
            setSelectedTeamType(randomTeamType);
            suggestMadLib(randomTeamType);
        } else suggestMadLib();
    };
    const formattedCgsData = (0, $1oC0p.useMemo)(()=>{
        if (cgsDataLoading || !cgsData) return undefined;
        return (0, $fx9D8.formatCgsData)(cgsData);
    }, [
        cgsData,
        cgsDataLoading
    ]);
    const getRecaptchaOutcome = async ()=>{
        const recaptchaStart = performance.now();
        let token;
        let recaptchaError;
        try {
            token = await (0, $427NR.getRecaptcha)("", // paid landing is anonymous; token still binds to browser context
            executeRecaptcha);
        } catch (e) {
            recaptchaError = e;
            token = undefined;
        }
        const recaptchaTimeMs = Math.max(0, performance.now() - recaptchaStart);
        const result = token ? "token" : recaptchaError ? "error" : "empty";
        if (token) firePaidJiraAi("RecaptchaTokenSucceeded", "succeeded", {
            recaptchaTimeMs: recaptchaTimeMs
        });
        else firePaidJiraAi("RecaptchaTokenFailed", "failed", (0, $6ogO3._)({
            recaptchaTimeMs: recaptchaTimeMs,
            failureReason: recaptchaError ? "error" : "empty"
        }, (0, $6qhMT.safeErrorContext)(recaptchaError)));
        return {
            token: token !== null && token !== void 0 ? token : "",
            recaptchaTimeMs: recaptchaTimeMs,
            result: result
        };
    };
    const setCgsKeyInUrl = (cgsKey)=>{
        // Persist cgsKey in the URL so downstream flows (e.g. account creation)
        // can pick it up without depending on this context provider.
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("cgsKey", cgsKey);
        window.history.replaceState(null, "", nextUrl.toString());
    };
    const submit = async (update)=>{
        const { teamType: teamType, workingOn: workingOn, goal: goal } = update;
        const attemptIndex = promptAttemptIndexRef.current + 1;
        const submitStart = performance.now();
        hasSubmittedThisAttemptRef.current = true;
        hasFiredAbandonedRef.current = false;
        const derived = {
            promptAttemptIndex: attemptIndex,
            isRetry: attemptIndex > 1,
            promptType: promptType,
            didChangeAnything: getChangedFields().length > 0,
            changedFields: getChangedFields(),
            workingOnLength: workingOnLength,
            goalLength: goalLength
        };
        setPromptAttemptIndex(attemptIndex);
        setCgsDataLoading(true);
        setIsErrorFromCgs(false);
        let recaptchaOutcome;
        try {
            var _initialSuggestion_current, _initialSuggestion_current1, _formatCgsData;
            // Explicit lifecycle start (click is tracked separately in the prompt component).
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_STARTED),
                eventType: "track",
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: (0, $6ogO3._)({
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW)
                }, derived)
            }).fire();
            firePaidJiraAi("ContentGenStarted", "started", derived);
            // Be resilient: even if reCAPTCHA is empty/errored, proceed and let the API
            // decide whether it's required.
            recaptchaOutcome = await getRecaptchaOutcome();
            setHasSubmittedDefaultValues(teamType === $0fa7666158234ad7$var$defaultContext.selectedTeamType && workingOn === ((_initialSuggestion_current = initialSuggestion.current) === null || _initialSuggestion_current === void 0 ? void 0 : _initialSuggestion_current.workingOn) && goal === ((_initialSuggestion_current1 = initialSuggestion.current) === null || _initialSuggestion_current1 === void 0 ? void 0 : _initialSuggestion_current1.goal));
            const response = await stargateClient.postContentGenerationForJiraFfl({
                teamType: teamType,
                workingOnSummary: workingOn,
                goal: goal,
                gRecaptchaResponse: recaptchaOutcome.token
            });
            setCgsData(response);
            setCgsKeyInUrl(response.cacheKey);
            setCgsDataLoading(false);
            var _formatCgsData_length;
            const rowCount = (_formatCgsData_length = (_formatCgsData = (0, $fx9D8.formatCgsData)(response)) === null || _formatCgsData === void 0 ? void 0 : _formatCgsData.length) !== null && _formatCgsData_length !== void 0 ? _formatCgsData_length : 0;
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_SUCCEEDED),
                eventType: "track",
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: (0, $6ogO3._)({
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW),
                    timeToCgsMs: Math.max(0, performance.now() - submitStart),
                    rowCount: rowCount,
                    recaptchaTimeMs: recaptchaOutcome.recaptchaTimeMs,
                    recaptchaResult: recaptchaOutcome.result
                }, derived)
            }).fire();
            firePaidJiraAi("ContentGenSucceeded", "succeeded", (0, $6ogO3._)({
                timeToCgsMs: Math.max(0, performance.now() - submitStart),
                rowCount: rowCount,
                recaptchaTimeMs: recaptchaOutcome.recaptchaTimeMs,
                recaptchaResult: recaptchaOutcome.result
            }, derived));
        } catch (error) {
            setCgsDataLoading(false);
            setIsErrorFromCgs(true);
            setCgsData((0, $fx9D8.fallbackCgsData));
            setCgsKeyInUrl((0, $fx9D8.fallbackCgsData).cacheKey);
            const safe = (0, $6qhMT.safeErrorContext)(error);
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_FAILED),
                eventType: "track",
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: (0, $6ogO3._)({
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW),
                    error: error.message,
                    timeToCgsMs: Math.max(0, performance.now() - submitStart),
                    recaptchaTimeMs: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.recaptchaTimeMs,
                    recaptchaResult: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.result
                }, derived, safe)
            }).fire();
            firePaidJiraAi("ContentGenFailed", "failed", (0, $6ogO3._)({
                timeToCgsMs: Math.max(0, performance.now() - submitStart),
                recaptchaTimeMs: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.recaptchaTimeMs,
                recaptchaResult: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.result
            }, derived, safe));
        } finally{
            // Reset engagement tracking for the next attempt.
            engagedAtRef.current = null;
            hasSubmittedThisAttemptRef.current = false;
            hasFiredEngagedRef.current = false;
            changedFieldsRef.current = new Set();
            setChangedFieldsVersion((v)=>v + 1);
        }
    };
    const value = (0, $1oC0p.useMemo)(()=>({
            submit: submit,
            // Madlib UI state
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            selectedTeamType: selectedTeamType,
            setSelectedTeamType: setSelectedTeamType,
            workingOnSuggestion: workingOnSuggestion,
            goalSuggestion: goalSuggestion,
            workingOnValue: workingOnValue,
            goalValue: goalValue,
            setWorkingOnValue: setWorkingOnValue,
            setGoalValue: setGoalValue,
            hasUserSelectedTeamType: hasUserSelectedTeamType,
            setHasUserSelectedTeamType: setHasUserSelectedTeamType,
            hasSubmittedDefaultValues: hasSubmittedDefaultValues,
            shuffle: shuffle,
            suggestMadLib: suggestMadLib,
            promptAttemptIndex: promptAttemptIndex,
            commonAnalyticsAttributes: commonAnalyticsAttributes,
            firePaidJiraAi: firePaidJiraAi,
            markPromptChangedField: markPromptChangedField,
            cgsDataLoading: // CGS
            cgsDataLoading,
            isErrorFromCgs: isErrorFromCgs,
            rawCgsData: cgsData,
            formattedCgsData: formattedCgsData,
            setIsErrorFromCgs: setIsErrorFromCgs
        }), [
        submit,
        selectedTeamType,
        workingOnSuggestion,
        goalSuggestion,
        workingOnValue,
        goalValue,
        hasUserSelectedTeamType,
        hasSubmittedDefaultValues,
        shuffle,
        suggestMadLib,
        promptAttemptIndex,
        commonAnalyticsAttributes,
        firePaidJiraAi,
        markPromptChangedField,
        cgsDataLoading,
        isErrorFromCgs,
        cgsData,
        formattedCgsData,
        setIsErrorFromCgs
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0fa7666158234ad7$var$JiraAiFFLContext.Provider, {
        value: value,
        children: children
    });
};
const $0fa7666158234ad7$export$2741bae471e27db6 = ()=>(0, $1oC0p.useContext)($0fa7666158234ad7$var$JiraAiFFLContext);

});
parcelRegister("bqpaF", function(module, exports) {
$parcel$export(module.exports, "stepMessages", function () { return $7688d9a9c22b6469$export$cca2c966ff5753ee; });
$parcel$export(module.exports, "getSuggestionsForTeamType", function () { return $7688d9a9c22b6469$export$1699afe393f55639; });

var $fnHPc = parcelRequire("fnHPc");

var $7XYQW = parcelRequire("7XYQW");
const $7688d9a9c22b6469$export$cca2c966ff5753ee = (0, $fnHPc.defineMessages)({
    header: {
        id: "step.madlib.header",
        defaultMessage: "What are you working on?"
    },
    subheader: {
        id: "step.madlib.subheader",
        defaultMessage: "Share what you\u2019re working on, and we\u2019ll turn it into actionable tasks so your team can get started faster."
    },
    submitButton: {
        id: "step.madlib.submitButton",
        defaultMessage: "Create space"
    },
    skipButton: {
        id: "step.madlib.skipButton",
        defaultMessage: "Skip"
    },
    aiDisclaimer: {
        id: "step.madlib.aiDisclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    aiDisclaimerLabel: {
        id: "step.madlib.aiDisclaimerLabel",
        defaultMessage: "AI Disclaimer Information Icon"
    },
    aiDisclaimerLinkNewWindowLabel: {
        id: "step.madlib.aiDisclaimerLinkNewWindowLabel",
        defaultMessage: "Opens a new window to view AI information"
    }
});
const $7688d9a9c22b6469$export$3e3e8e3ace2d7f0e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.1.madlib.content",
        defaultMessage: "Feature release with the goal of meeting a key user need",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.1.madlib.task",
        defaultMessage: "feature release",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.1.madlib.goal",
        defaultMessage: "meeting a key user need",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$4083d838b33ee248 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.2.madlib.content",
        defaultMessage: "Platform migration with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.2.madlib.task",
        defaultMessage: "platform migration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.2.madlib.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$238954bdf622c599 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.3.madlib.content",
        defaultMessage: "Backend revamp with the goal of improving system performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.3.madlib.task",
        defaultMessage: "backend revamp",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.3.madlib.goal",
        defaultMessage: "improving system performance",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$e67cd156d6d6f2ae = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.4.madlib.content",
        defaultMessage: "Design system update with the goal of unifying components",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.4.madlib.task",
        defaultMessage: "design system update",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.4.madlib.goal",
        defaultMessage: "unifying components",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$c859d4b806b7c319 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.5.madlib.content",
        defaultMessage: "API integration project with the goal of connecting new services",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.5.madlib.task",
        defaultMessage: "api integration project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.5.madlib.goal",
        defaultMessage: "connecting new services",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$aa93c7dd62258c4c = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.6.madlib.content",
        defaultMessage: "Mobile app launch with the goal of delivering a responsive design",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.6.madlib.task",
        defaultMessage: "mobile app launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.6.madlib.goal",
        defaultMessage: "delivering a responsive design",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$5eb899ea0abf885b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.7.madlib.content",
        defaultMessage: "Security fix with the goal of resolving vulnerabilities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.7.madlib.task",
        defaultMessage: "security fix",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.7.madlib.goal",
        defaultMessage: "resolving vulnerabilities",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$fffcfc2b88cf5096 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.8.madlib.content",
        defaultMessage: "Performance optimization with the goal of speeding up the app",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.8.madlib.task",
        defaultMessage: "performance optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.8.madlib.goal",
        defaultMessage: "speeding up the app",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$d946a96bae566935 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.9.madlib.content",
        defaultMessage: "Product launch with the goal of shipping a new service to market",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.9.madlib.task",
        defaultMessage: "product launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.9.madlib.goal",
        defaultMessage: "shipping a new service to market",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$7c01f95ee53b1178 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.10.madlib.content",
        defaultMessage: "Feature launch with the goal of delivering value to users",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.10.madlib.task",
        defaultMessage: "feature launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.10.madlib.goal",
        defaultMessage: "delivering value to users",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$2f763ba3e5452cc1 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.11.madlib.content",
        defaultMessage: "Strategic plan with the goal of creating a clear roadmap",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.11.madlib.task",
        defaultMessage: "strategic plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.11.madlib.goal",
        defaultMessage: "creating a clear roadmap",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$1397ef1e776ed951 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.12.madlib.content",
        defaultMessage: "Customer research study with the goal of gathering insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.12.madlib.task",
        defaultMessage: "customer research study",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.12.madlib.goal",
        defaultMessage: "gathering insights",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$8cad710146c3f103 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.13.madlib.content",
        defaultMessage: "Platform upgrade with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.13.madlib.task",
        defaultMessage: "platform upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.13.madlib.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$51ac07ea9a8753b7 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.14.madlib.content",
        defaultMessage: "Analytics project with the goal of tracking key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.14.madlib.task",
        defaultMessage: "analytics project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.14.madlib.goal",
        defaultMessage: "tracking key metrics",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$aa3333d2f7d341a9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.15.madlib.content",
        defaultMessage: "Quarterly product plan with the goal of creating a strong backlog",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.15.madlib.task",
        defaultMessage: "quarterly product plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.15.madlib.goal",
        defaultMessage: "creating a strong backlog",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$ba89ed94fac4b472 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.16.madlib.content",
        defaultMessage: "A/B experiment with the goal of optimizing an experience",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.16.madlib.task",
        defaultMessage: "a/b experiment",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.16.madlib.goal",
        defaultMessage: "optimizing an experience",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$700e64e0f0dceb08 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.17.madlib.content",
        defaultMessage: "Campaign launch with the goal of driving brand awareness",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.17.madlib.task",
        defaultMessage: "campaign launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.17.madlib.goal",
        defaultMessage: "driving brand awareness",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$50293e2ec360ad90 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.18.madlib.content",
        defaultMessage: "Content strategy with the goal of improving SEO",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.18.madlib.task",
        defaultMessage: "content strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.18.madlib.goal",
        defaultMessage: "improving SEO",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$2c612aa5d867d94d = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.19.madlib.content",
        defaultMessage: "Referral program with the goal of growing customers via referrals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.19.madlib.task",
        defaultMessage: "referral program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.19.madlib.goal",
        defaultMessage: "growing customers via referrals",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$75d56ecc14891dc1 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.20.madlib.content",
        defaultMessage: "Social media campaign with the goal of increasing engagement",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.20.madlib.task",
        defaultMessage: "social media campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.20.madlib.goal",
        defaultMessage: "increasing engagement",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$10d5913842e26806 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.21.madlib.content",
        defaultMessage: "Influencer partnership with the goal of reaching new audiences",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.21.madlib.task",
        defaultMessage: "influencer partnership",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.21.madlib.goal",
        defaultMessage: "reaching new audiences",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$e32f3ee079464889 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.22.madlib.content",
        defaultMessage: "Promotional event with the goal of driving brand awareness",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.22.madlib.task",
        defaultMessage: "promotional event",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.22.madlib.goal",
        defaultMessage: "driving brand awareness",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$3c2846799041acd1 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.23.madlib.content",
        defaultMessage: "Email campaign with the goal of generating leads",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.23.madlib.task",
        defaultMessage: "email campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.23.madlib.goal",
        defaultMessage: "generating leads",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$28f387abcb0b61c2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.24.madlib.content",
        defaultMessage: "Paid advertising with the goal of reaching new customers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.24.madlib.task",
        defaultMessage: "paid advertising",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.24.madlib.goal",
        defaultMessage: "reaching new customers",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$217ea0fee69755b2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.25.madlib.content",
        defaultMessage: "Cross-team launch with the goal of delivering a new service",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.25.madlib.task",
        defaultMessage: "cross-team launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.25.madlib.goal",
        defaultMessage: "delivering a new service",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$ba7d0398d02cd9c0 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.26.madlib.content",
        defaultMessage: "System upgrade with the goal of improving performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.26.madlib.task",
        defaultMessage: "system upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.26.madlib.goal",
        defaultMessage: "improving performance",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$510943abc3818b56 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.27.madlib.content",
        defaultMessage: "Training program with the goal of upskilling team members",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.27.madlib.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.27.madlib.goal",
        defaultMessage: "upskilling team members",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$eb28136e581b59a2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.28.madlib.content",
        defaultMessage: "Communication strategy with the goal of aligning stakeholders",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.28.madlib.task",
        defaultMessage: "communication strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.28.madlib.goal",
        defaultMessage: "aligning stakeholders",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$fb13f40a79e19ca5 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.29.madlib.content",
        defaultMessage: "Event planning initiative with the goal of engaging participants",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.29.madlib.task",
        defaultMessage: "event planning initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.29.madlib.goal",
        defaultMessage: "engaging participants",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$443d3648968f7329 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.30.madlib.content",
        defaultMessage: "Process optimization project with the goal of increasing efficiency",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.30.madlib.task",
        defaultMessage: "process optimization project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.30.madlib.goal",
        defaultMessage: "increasing efficiency",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$b47a1b25f95c27f7 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.31.madlib.content",
        defaultMessage: "Company-wide initiative with the goal of improving collaboration",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.31.madlib.task",
        defaultMessage: "company-wide initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.31.madlib.goal",
        defaultMessage: "improving collaboration",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$ff468a2badd833da = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.32.madlib.content",
        defaultMessage: "Technology upgrade with the goal of modernizing our tools",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.32.madlib.task",
        defaultMessage: "technology upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.32.madlib.goal",
        defaultMessage: "modernizing our tools",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$5a07aeb3f31820fd = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.33.madlib.content",
        defaultMessage: "Dashboard with the goal of tracking performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.33.madlib.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.33.madlib.goal",
        defaultMessage: "tracking performance",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$dfd30a31c0976d81 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.34.madlib.content",
        defaultMessage: "Segmentation model with the goal of driving personalization",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.34.madlib.task",
        defaultMessage: "segmentation model",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.34.madlib.goal",
        defaultMessage: "driving personalization",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$95dbb3526f288923 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.35.madlib.content",
        defaultMessage: "Predictive model with the goal of forecasting demand",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.35.madlib.task",
        defaultMessage: "predictive model",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.35.madlib.goal",
        defaultMessage: "forecasting demand",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$70448386f1965d8f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.36.madlib.content",
        defaultMessage: "A/B test analysis with the goal of measuring experiment impact",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.36.madlib.task",
        defaultMessage: "a/b test analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.36.madlib.goal",
        defaultMessage: "measuring experiment impact",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$9b985ff42826fe70 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.37.madlib.content",
        defaultMessage: "Churn analysis with the goal of reducing customer loss",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.37.madlib.task",
        defaultMessage: "churn analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.37.madlib.goal",
        defaultMessage: "reducing customer loss",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$90db3bc5ac7e2675 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.38.madlib.content",
        defaultMessage: "Data pipeline with the goal of improving data quality",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.38.madlib.task",
        defaultMessage: "data pipeline",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.38.madlib.goal",
        defaultMessage: "improving data quality",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$cacf7e1270784764 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.39.madlib.content",
        defaultMessage: "Data lake migration with the goal of centralizing datasets",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.39.madlib.task",
        defaultMessage: "data lake migration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.39.madlib.goal",
        defaultMessage: "centralizing datasets",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$73dab2578d6196e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.40.madlib.content",
        defaultMessage: "Funnel analysis with the goal of identifying new opportunities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.40.madlib.task",
        defaultMessage: "funnel analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.40.madlib.goal",
        defaultMessage: "identifying new opportunities",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$e89b21d7e4f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.41.madlib.content",
        defaultMessage: "Lead generation project with the goal of finding new customers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.41.madlib.task",
        defaultMessage: "lead generation project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.41.madlib.goal",
        defaultMessage: "finding new customers",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$7552cab841864320 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.42.madlib.content",
        defaultMessage: "Sales campaign with the goal of increasing revenue",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.42.madlib.task",
        defaultMessage: "sales campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.42.madlib.goal",
        defaultMessage: "increasing revenue",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$7a24837b79d45438 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.43.madlib.content",
        defaultMessage: "Account plan with the goal of growing client relationships",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.43.madlib.task",
        defaultMessage: "account plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.43.madlib.goal",
        defaultMessage: "growing client relationships",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$8b9f0dc25b70b492 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.44.madlib.content",
        defaultMessage: "Sales kickoff plan with the goal of driving sales growth",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.44.madlib.task",
        defaultMessage: "sales kickoff plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.44.madlib.goal",
        defaultMessage: "driving sales growth",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$6aaa62a0350d7e26 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.45.madlib.content",
        defaultMessage: "Pipeline optimization with the goal of increasing deal flow",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.45.madlib.task",
        defaultMessage: "pipeline optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.45.madlib.goal",
        defaultMessage: "increasing deal flow",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$2998d96008544a57 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.46.madlib.content",
        defaultMessage: "Sales training program with the goal of improving team skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.46.madlib.task",
        defaultMessage: "sales training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.46.madlib.goal",
        defaultMessage: "improving team skills",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$9f50b52f7978030 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.47.madlib.content",
        defaultMessage: "Market analysis with the goal of identifying new opportunities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.47.madlib.task",
        defaultMessage: "market analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.47.madlib.goal",
        defaultMessage: "identifying new opportunities",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$233be78d085cc677 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.48.madlib.content",
        defaultMessage: "Customer retention initiative with the goal of reducing churn",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.48.madlib.task",
        defaultMessage: "customer retention initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.48.madlib.goal",
        defaultMessage: "reducing churn",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$9a70a449effffd31 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.49.madlib.content",
        defaultMessage: "Annual budget plan with the goal of optimizing resource allocation",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.49.madlib.task",
        defaultMessage: "annual budget plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.49.madlib.goal",
        defaultMessage: "optimizing resource allocation",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$b42e1c0dd11c43a8 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.50.madlib.content",
        defaultMessage: "Financial dashboard with the goal of surfacing key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.50.madlib.task",
        defaultMessage: "financial dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.50.madlib.goal",
        defaultMessage: "surfacing key metrics",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$c75ce3d04975da18 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.51.madlib.content",
        defaultMessage: "Financial audit preparation with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.51.madlib.task",
        defaultMessage: "financial audit preparation",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.51.madlib.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$7d4e88dfaf5cfbf2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.52.madlib.content",
        defaultMessage: "Cost reduction project with the goal of improving profitability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.52.madlib.task",
        defaultMessage: "cost reduction project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.52.madlib.goal",
        defaultMessage: "improving profitability",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$edc324362fedbd80 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.53.madlib.content",
        defaultMessage: "Forecasting project with the goal of predicting revenue",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.53.madlib.task",
        defaultMessage: "forecasting project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.53.madlib.goal",
        defaultMessage: "predicting revenue",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$fe3389126f5cb0d8 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.54.madlib.content",
        defaultMessage: "Automation project with the goal of streamlining operations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.54.madlib.task",
        defaultMessage: "automation project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.54.madlib.goal",
        defaultMessage: "streamlining operations",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$dd6b1ebf96801fbc = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.55.madlib.content",
        defaultMessage: "Technology upgrade with the goal of modernizing our systems",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.55.madlib.task",
        defaultMessage: "technology upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.55.madlib.goal",
        defaultMessage: "modernizing our systems",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$4d5e8549a481dc8f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.56.madlib.content",
        defaultMessage: "Tax planning initiative with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.56.madlib.task",
        defaultMessage: "tax planning initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.56.madlib.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$93f014d48a475135 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.57.madlib.content",
        defaultMessage: "Contract review project with the goal of faster approvals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.57.madlib.task",
        defaultMessage: "contract review project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.57.madlib.goal",
        defaultMessage: "faster approvals",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$d11bd1cb56453b28 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.58.madlib.content",
        defaultMessage: "Compliance rollout with the goal of meeting regulatory standards",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.58.madlib.task",
        defaultMessage: "compliance rollout",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.58.madlib.goal",
        defaultMessage: "meeting regulatory standards",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$4c3a6919fce6fd40 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.59.madlib.content",
        defaultMessage: "Property transaction with the goal of finalizing a deal",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.59.madlib.task",
        defaultMessage: "property transaction",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.59.madlib.goal",
        defaultMessage: "finalizing a deal",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$c439b80ed7353230 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.60.madlib.content",
        defaultMessage: "IP litigation case with the goal of protecting intellectual property",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.60.madlib.task",
        defaultMessage: "ip litigation case",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.60.madlib.goal",
        defaultMessage: "protecting intellectual property",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$ea984107697503fc = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.61.madlib.content",
        defaultMessage: "Legal intake portal with the goal of streamlining request handling",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.61.madlib.task",
        defaultMessage: "legal intake portal",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.61.madlib.goal",
        defaultMessage: "streamlining request handling",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$28e7793f76656931 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.62.madlib.content",
        defaultMessage: "Data privacy project with the goal of protecting customer data",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.62.madlib.task",
        defaultMessage: "data privacy project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.62.madlib.goal",
        defaultMessage: "protecting customer data",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$1da97b56a73dc2b2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.63.madlib.content",
        defaultMessage: "Employee policy review with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.63.madlib.task",
        defaultMessage: "employee policy review",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.63.madlib.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$ced6c8fb350e76bb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.64.madlib.content",
        defaultMessage: "Legal tech adoption plan with the goal of improving team efficiency",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.64.madlib.task",
        defaultMessage: "legal tech adoption plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.64.madlib.goal",
        defaultMessage: "improving team efficiency",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a4bf996d2c840321 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.65.madlib.content",
        defaultMessage: "Support project with the goal of monitoring requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.65.madlib.task",
        defaultMessage: "support project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.65.madlib.goal",
        defaultMessage: "monitoring requests",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$673f161eccda0fd2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.66.madlib.content",
        defaultMessage: "Knowledge base redesign with the goal of simplifying resources",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.66.madlib.task",
        defaultMessage: "knowledge base redesign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.66.madlib.goal",
        defaultMessage: "simplifying resources",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$16b6eaa2913019eb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.67.madlib.content",
        defaultMessage: "AI chat tool with the goal of automating responses",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.67.madlib.task",
        defaultMessage: "ai chat tool",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.67.madlib.goal",
        defaultMessage: "automating responses",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$747e538403f25754 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.68.madlib.content",
        defaultMessage: "Customer feedback survey with the goal of gathering insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.68.madlib.task",
        defaultMessage: "customer feedback survey",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.68.madlib.goal",
        defaultMessage: "gathering insights",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$131cdd783f6832db = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.69.madlib.content",
        defaultMessage: "Process optimization with the goal of reducing bottlenecks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.69.madlib.task",
        defaultMessage: "process optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.69.madlib.goal",
        defaultMessage: "reducing bottlenecks",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$b39996d55eda2c57 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.70.madlib.content",
        defaultMessage: "Multi-channel integration with the goal of centralizing interactions",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.70.madlib.task",
        defaultMessage: "multi-channel integration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.70.madlib.goal",
        defaultMessage: "centralizing interactions",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$db220d81a1a51dbb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.71.madlib.content",
        defaultMessage: "Support dashboard with the goal of tracking key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.71.madlib.task",
        defaultMessage: "support dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.71.madlib.goal",
        defaultMessage: "tracking key metrics",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$22b3d354cda23d40 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.72.madlib.content",
        defaultMessage: "Training program with the goal of improving team skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.72.madlib.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.72.madlib.goal",
        defaultMessage: "improving team skills",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$116ac96c94b3d638 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.73.madlib.content",
        defaultMessage: "New hire onboarding with the goal of ramping up employees",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.73.madlib.task",
        defaultMessage: "new hire onboarding",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.73.madlib.goal",
        defaultMessage: "ramping up employees",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a2ffbc021439bdbd = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.74.madlib.content",
        defaultMessage: "Employee training with the goal of building skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.74.madlib.task",
        defaultMessage: "employee training",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.74.madlib.goal",
        defaultMessage: "building skills",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$de23ac620cd66202 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.75.madlib.content",
        defaultMessage: "Performance review process with the goal of evaluating growth",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.75.madlib.task",
        defaultMessage: "performance review process",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.75.madlib.goal",
        defaultMessage: "evaluating growth",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$22b19d3e0decb8c0 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.76.madlib.content",
        defaultMessage: "Benefits rollout with the goal of improving employee satisfaction",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.76.madlib.task",
        defaultMessage: "benefits rollout",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.76.madlib.goal",
        defaultMessage: "improving employee satisfaction",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$78bb6bf9117c9ba8 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.77.madlib.content",
        defaultMessage: "Recruitment campaign with the goal of hiring top talent",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.77.madlib.task",
        defaultMessage: "recruitment campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.77.madlib.goal",
        defaultMessage: "hiring top talent",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$35ab0ba9aa19c048 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.78.madlib.content",
        defaultMessage: "Employee survey with the goal of gathering feedback",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.78.madlib.task",
        defaultMessage: "employee survey",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.78.madlib.goal",
        defaultMessage: "gathering feedback",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a2510dd93efe31ef = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.79.madlib.content",
        defaultMessage: "Compliance audit with the goal of meeting regulations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.79.madlib.task",
        defaultMessage: "compliance audit",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.79.madlib.goal",
        defaultMessage: "meeting regulations",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$35ae46aa9cb3c54f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.80.madlib.content",
        defaultMessage: "Campus hiring program with the goal of recruiting new graduates",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.80.madlib.task",
        defaultMessage: "campus hiring program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.80.madlib.goal",
        defaultMessage: "recruiting new graduates",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$d873cca220ce6032 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.81.madlib.content",
        defaultMessage: "Knowledge base with the goal of speeding up troubleshooting",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.81.madlib.task",
        defaultMessage: "knowledge base",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.81.madlib.goal",
        defaultMessage: "speeding up troubleshooting",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$c3408d7adaa661b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.82.madlib.content",
        defaultMessage: "Support workflow with the goal of managing requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.82.madlib.task",
        defaultMessage: "support workflow",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.82.madlib.goal",
        defaultMessage: "managing requests",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$8376003f433cab7a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.83.madlib.content",
        defaultMessage: "Asset management project with the goal of tracking hardware",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.83.madlib.task",
        defaultMessage: "asset management project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.83.madlib.goal",
        defaultMessage: "tracking hardware",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$e8c57044a32c12dd = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.84.madlib.content",
        defaultMessage: "Backup and recovery plan with the goal of protecting data",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.84.madlib.task",
        defaultMessage: "backup and recovery plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.84.madlib.goal",
        defaultMessage: "protecting data",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$219354e66633cab9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.85.madlib.content",
        defaultMessage: "Training program with the goal of reducing support requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.85.madlib.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.85.madlib.goal",
        defaultMessage: "reducing support requests",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$2e05d8d366fc16ef = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.86.madlib.content",
        defaultMessage: "Vendor procurement project with the goal of managing suppliers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.86.madlib.task",
        defaultMessage: "vendor procurement project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.86.madlib.goal",
        defaultMessage: "managing suppliers",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$f82da0359a5d86b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.87.madlib.content",
        defaultMessage: "System upgrade with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.87.madlib.task",
        defaultMessage: "system upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.87.madlib.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$ac718d2313dc759b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.88.madlib.content",
        defaultMessage: "Dashboard with the goal of tracking system performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.88.madlib.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.88.madlib.goal",
        defaultMessage: "tracking system performance",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$df6110169c836468 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.89.madlib.content",
        defaultMessage: "Process update initiative with the goal of optimizing workflows",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.89.madlib.task",
        defaultMessage: "process update initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.89.madlib.goal",
        defaultMessage: "optimizing workflows",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a7287c8dd13a5aea = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.90.madlib.content",
        defaultMessage: "Dashboard with the goal of providing actionable insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.90.madlib.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.90.madlib.goal",
        defaultMessage: "providing actionable insights",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a611f3e4d87fb273 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.91.madlib.content",
        defaultMessage: "Inventory overhaul with the goal of improving stock management",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.91.madlib.task",
        defaultMessage: "inventory overhaul",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.91.madlib.goal",
        defaultMessage: "improving stock management",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$8334b28c2d4fc9d9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.92.madlib.content",
        defaultMessage: "Workflow update with the goal of improving team collaboration",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.92.madlib.task",
        defaultMessage: "workflow update",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.92.madlib.goal",
        defaultMessage: "improving team collaboration",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$24a7a9835dd5371e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.93.madlib.content",
        defaultMessage: "Vendor onboarding program with the goal of streamlining suppliers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.93.madlib.task",
        defaultMessage: "vendor onboarding program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.93.madlib.goal",
        defaultMessage: "streamlining suppliers",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$e9aed7ccbc11b019 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.94.madlib.content",
        defaultMessage: "Logistics plan with the goal of ensuring smooth operations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.94.madlib.task",
        defaultMessage: "logistics plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.94.madlib.goal",
        defaultMessage: "ensuring smooth operations",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$314e0f69ccc1d38a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.95.madlib.content",
        defaultMessage: "Budget plan with the goal of controlling costs",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.95.madlib.task",
        defaultMessage: "budget plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.95.madlib.goal",
        defaultMessage: "controlling costs",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$1e537e1670815d80 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.96.madlib.content",
        defaultMessage: "Process optimization project with the goal of reducing bottlenecks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.96.madlib.task",
        defaultMessage: "process optimization project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.96.madlib.goal",
        defaultMessage: "reducing bottlenecks",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$bda370311792820b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.97.madlib.content",
        defaultMessage: "Product feature with the goal of improving the user experience",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.97.madlib.task",
        defaultMessage: "product feature",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.97.madlib.goal",
        defaultMessage: "improving the user experience",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$9e431b0aa66e8252 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.98.madlib.content",
        defaultMessage: "Design system with the goal of scaling consistent components",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.98.madlib.task",
        defaultMessage: "design system",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.98.madlib.goal",
        defaultMessage: "scaling consistent components",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$4b2bd99114944c59 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.99.madlib.content",
        defaultMessage: "Website redesign with the goal of simplifying navigation",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.99.madlib.task",
        defaultMessage: "website redesign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.99.madlib.goal",
        defaultMessage: "simplifying navigation",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a41c7817b9e4797e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.100.madlib.content",
        defaultMessage: "Brand refresh with the goal of unifying visuals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.100.madlib.task",
        defaultMessage: "brand refresh",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.100.madlib.goal",
        defaultMessage: "unifying visuals",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$c8d0d05503dbe79a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.101.madlib.content",
        defaultMessage: "Interactive prototype with the goal of testing new concepts",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.101.madlib.task",
        defaultMessage: "interactive prototype",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.101.madlib.goal",
        defaultMessage: "testing new concepts",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a240bee4318a7275 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.102.madlib.content",
        defaultMessage: "Research study with the goal of validating design decisions",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.102.madlib.task",
        defaultMessage: "research study",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.102.madlib.goal",
        defaultMessage: "validating design decisions",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$21a95300c10295cb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.103.madlib.content",
        defaultMessage: "Content strategy with the goal of creating a consistent voice",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.103.madlib.task",
        defaultMessage: "content strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.103.madlib.goal",
        defaultMessage: "creating a consistent voice",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$cfa4185509d4a774 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.104.madlib.content",
        defaultMessage: "Mobile app design with the goal of streamlining core user flows",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.104.madlib.task",
        defaultMessage: "mobile app design",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.104.madlib.goal",
        defaultMessage: "streamlining core user flows",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$ed7df379a72deca9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.105.madlib.content",
        defaultMessage: "Product release with the goal of keeping teams aligned",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.105.madlib.task",
        defaultMessage: "product release",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.105.madlib.goal",
        defaultMessage: "keeping teams aligned",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$a238aef13a297f47 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.106.madlib.content",
        defaultMessage: "Project kickoff with the goal of aligning stakeholders",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.106.madlib.task",
        defaultMessage: "project kickoff",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.106.madlib.goal",
        defaultMessage: "aligning stakeholders",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$4c943dbf592d3daf = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.107.madlib.content",
        defaultMessage: "Marketing launch with the goal of ensuring on-time delivery",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.107.madlib.task",
        defaultMessage: "marketing launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.107.madlib.goal",
        defaultMessage: "ensuring on-time delivery",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$8ea24421c21eb989 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.108.madlib.content",
        defaultMessage: "Resource plan with the goal of balancing workloads",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.108.madlib.task",
        defaultMessage: "resource plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.108.madlib.goal",
        defaultMessage: "balancing workloads",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$9060f613b4033371 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.109.madlib.content",
        defaultMessage: "Status report with the goal of keeping leadership informed",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.109.madlib.task",
        defaultMessage: "status report",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.109.madlib.goal",
        defaultMessage: "keeping leadership informed",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$3b9fc7e351d5a0da = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.110.madlib.content",
        defaultMessage: "Timeline plan with the goal of meeting deadlines",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.110.madlib.task",
        defaultMessage: "timeline plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.110.madlib.goal",
        defaultMessage: "meeting deadlines",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$8558a67dfa2e822a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.111.madlib.content",
        defaultMessage: "Risk assessment with the goal of reducing project blockers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.111.madlib.task",
        defaultMessage: "risk assessment",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.111.madlib.goal",
        defaultMessage: "reducing project blockers",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$91724e490013331 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.112.madlib.content",
        defaultMessage: "Cross-functional project with the goal of coordinating team tasks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.112.madlib.task",
        defaultMessage: "cross-functional project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.112.madlib.goal",
        defaultMessage: "coordinating team tasks",
        description: "The goal for the suggestion"
    }
});
const $7688d9a9c22b6469$export$1699afe393f55639 = (teamType)=>{
    switch(teamType){
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE:
            return [
                $7688d9a9c22b6469$export$3e3e8e3ace2d7f0e,
                $7688d9a9c22b6469$export$4083d838b33ee248,
                $7688d9a9c22b6469$export$238954bdf622c599,
                $7688d9a9c22b6469$export$e67cd156d6d6f2ae,
                $7688d9a9c22b6469$export$c859d4b806b7c319,
                $7688d9a9c22b6469$export$aa93c7dd62258c4c,
                $7688d9a9c22b6469$export$5eb899ea0abf885b,
                $7688d9a9c22b6469$export$fffcfc2b88cf5096
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT:
            return [
                $7688d9a9c22b6469$export$d946a96bae566935,
                $7688d9a9c22b6469$export$7c01f95ee53b1178,
                $7688d9a9c22b6469$export$2f763ba3e5452cc1,
                $7688d9a9c22b6469$export$1397ef1e776ed951,
                $7688d9a9c22b6469$export$8cad710146c3f103,
                $7688d9a9c22b6469$export$51ac07ea9a8753b7,
                $7688d9a9c22b6469$export$aa3333d2f7d341a9,
                $7688d9a9c22b6469$export$ba89ed94fac4b472
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING:
            return [
                $7688d9a9c22b6469$export$700e64e0f0dceb08,
                $7688d9a9c22b6469$export$50293e2ec360ad90,
                $7688d9a9c22b6469$export$2c612aa5d867d94d,
                $7688d9a9c22b6469$export$75d56ecc14891dc1,
                $7688d9a9c22b6469$export$10d5913842e26806,
                $7688d9a9c22b6469$export$e32f3ee079464889,
                $7688d9a9c22b6469$export$3c2846799041acd1,
                $7688d9a9c22b6469$export$28f387abcb0b61c2
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL:
            return [
                $7688d9a9c22b6469$export$217ea0fee69755b2,
                $7688d9a9c22b6469$export$ba7d0398d02cd9c0,
                $7688d9a9c22b6469$export$510943abc3818b56,
                $7688d9a9c22b6469$export$eb28136e581b59a2,
                $7688d9a9c22b6469$export$fb13f40a79e19ca5,
                $7688d9a9c22b6469$export$443d3648968f7329,
                $7688d9a9c22b6469$export$b47a1b25f95c27f7,
                $7688d9a9c22b6469$export$ff468a2badd833da
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE:
            return [
                $7688d9a9c22b6469$export$5a07aeb3f31820fd,
                $7688d9a9c22b6469$export$dfd30a31c0976d81,
                $7688d9a9c22b6469$export$95dbb3526f288923,
                $7688d9a9c22b6469$export$70448386f1965d8f,
                $7688d9a9c22b6469$export$9b985ff42826fe70,
                $7688d9a9c22b6469$export$90db3bc5ac7e2675,
                $7688d9a9c22b6469$export$cacf7e1270784764,
                $7688d9a9c22b6469$export$73dab2578d6196e
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SALES:
            return [
                $7688d9a9c22b6469$export$e89b21d7e4f,
                $7688d9a9c22b6469$export$7552cab841864320,
                $7688d9a9c22b6469$export$7a24837b79d45438,
                $7688d9a9c22b6469$export$8b9f0dc25b70b492,
                $7688d9a9c22b6469$export$6aaa62a0350d7e26,
                $7688d9a9c22b6469$export$2998d96008544a57,
                $7688d9a9c22b6469$export$9f50b52f7978030,
                $7688d9a9c22b6469$export$233be78d085cc677
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_FINANCE:
            return [
                $7688d9a9c22b6469$export$9a70a449effffd31,
                $7688d9a9c22b6469$export$b42e1c0dd11c43a8,
                $7688d9a9c22b6469$export$c75ce3d04975da18,
                $7688d9a9c22b6469$export$7d4e88dfaf5cfbf2,
                $7688d9a9c22b6469$export$edc324362fedbd80,
                $7688d9a9c22b6469$export$fe3389126f5cb0d8,
                $7688d9a9c22b6469$export$dd6b1ebf96801fbc,
                $7688d9a9c22b6469$export$4d5e8549a481dc8f
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_LEGAL:
            return [
                $7688d9a9c22b6469$export$93f014d48a475135,
                $7688d9a9c22b6469$export$d11bd1cb56453b28,
                $7688d9a9c22b6469$export$4c3a6919fce6fd40,
                $7688d9a9c22b6469$export$c439b80ed7353230,
                $7688d9a9c22b6469$export$ea984107697503fc,
                $7688d9a9c22b6469$export$28e7793f76656931,
                $7688d9a9c22b6469$export$1da97b56a73dc2b2,
                $7688d9a9c22b6469$export$ced6c8fb350e76bb
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE:
            return [
                $7688d9a9c22b6469$export$a4bf996d2c840321,
                $7688d9a9c22b6469$export$673f161eccda0fd2,
                $7688d9a9c22b6469$export$16b6eaa2913019eb,
                $7688d9a9c22b6469$export$747e538403f25754,
                $7688d9a9c22b6469$export$131cdd783f6832db,
                $7688d9a9c22b6469$export$b39996d55eda2c57,
                $7688d9a9c22b6469$export$db220d81a1a51dbb,
                $7688d9a9c22b6469$export$22b3d354cda23d40
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_HR:
            return [
                $7688d9a9c22b6469$export$116ac96c94b3d638,
                $7688d9a9c22b6469$export$a2ffbc021439bdbd,
                $7688d9a9c22b6469$export$de23ac620cd66202,
                $7688d9a9c22b6469$export$22b19d3e0decb8c0,
                $7688d9a9c22b6469$export$78bb6bf9117c9ba8,
                $7688d9a9c22b6469$export$35ab0ba9aa19c048,
                $7688d9a9c22b6469$export$a2510dd93efe31ef,
                $7688d9a9c22b6469$export$35ae46aa9cb3c54f
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT:
            return [
                $7688d9a9c22b6469$export$d873cca220ce6032,
                $7688d9a9c22b6469$export$c3408d7adaa661b,
                $7688d9a9c22b6469$export$8376003f433cab7a,
                $7688d9a9c22b6469$export$e8c57044a32c12dd,
                $7688d9a9c22b6469$export$219354e66633cab9,
                $7688d9a9c22b6469$export$2e05d8d366fc16ef,
                $7688d9a9c22b6469$export$f82da0359a5d86b,
                $7688d9a9c22b6469$export$ac718d2313dc759b
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS:
            return [
                $7688d9a9c22b6469$export$df6110169c836468,
                $7688d9a9c22b6469$export$a7287c8dd13a5aea,
                $7688d9a9c22b6469$export$a611f3e4d87fb273,
                $7688d9a9c22b6469$export$8334b28c2d4fc9d9,
                $7688d9a9c22b6469$export$24a7a9835dd5371e,
                $7688d9a9c22b6469$export$e9aed7ccbc11b019,
                $7688d9a9c22b6469$export$314e0f69ccc1d38a,
                $7688d9a9c22b6469$export$1e537e1670815d80
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN:
            return [
                $7688d9a9c22b6469$export$bda370311792820b,
                $7688d9a9c22b6469$export$9e431b0aa66e8252,
                $7688d9a9c22b6469$export$4b2bd99114944c59,
                $7688d9a9c22b6469$export$a41c7817b9e4797e,
                $7688d9a9c22b6469$export$c8d0d05503dbe79a,
                $7688d9a9c22b6469$export$a240bee4318a7275,
                $7688d9a9c22b6469$export$21a95300c10295cb,
                $7688d9a9c22b6469$export$cfa4185509d4a774
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT:
            return [
                $7688d9a9c22b6469$export$ed7df379a72deca9,
                $7688d9a9c22b6469$export$a238aef13a297f47,
                $7688d9a9c22b6469$export$4c943dbf592d3daf,
                $7688d9a9c22b6469$export$8ea24421c21eb989,
                $7688d9a9c22b6469$export$9060f613b4033371,
                $7688d9a9c22b6469$export$3b9fc7e351d5a0da,
                $7688d9a9c22b6469$export$8558a67dfa2e822a,
                $7688d9a9c22b6469$export$91724e490013331
            ];
        default:
            return [];
    }
};

});

parcelRegister("6qhMT", function(module, exports) {
$parcel$export(module.exports, "PAID_JIRA_AI_FLOW", function () { return $f5661b1f1d377ec0$export$15580d5934f13398; });
$parcel$export(module.exports, "PAID_JIRA_AI_EXPERIMENT_KEY", function () { return $f5661b1f1d377ec0$export$cece5c76676ec0b; });
$parcel$export(module.exports, "categorizeTeamType", function () { return $f5661b1f1d377ec0$export$1029d82c7dcd7984; });
$parcel$export(module.exports, "getCgsKeyFromLocationHref", function () { return $f5661b1f1d377ec0$export$22103f8d80cc8961; });
$parcel$export(module.exports, "derivePromptType", function () { return $f5661b1f1d377ec0$export$c37691d1fa2eace6; });
$parcel$export(module.exports, "firePaidJiraAiEvent", function () { return $f5661b1f1d377ec0$export$9a72bee4029287c2; });
$parcel$export(module.exports, "safeErrorContext", function () { return $f5661b1f1d377ec0$export$b800576c577b2197; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");
const $f5661b1f1d377ec0$export$15580d5934f13398 = "paidLandingJiraAi";
const $f5661b1f1d377ec0$export$cece5c76676ec0b = "cfind4666JiraFfl";
function $f5661b1f1d377ec0$export$1029d82c7dcd7984(teamType) {
    // Keep this stable and explicit so analysis is consistent.
    switch(teamType){
        case "software-development":
        case "it-support":
            return "tech";
        case "product-management":
        case "marketing":
        case "project-management":
        case "design":
            return "biz";
        default:
            return "unknown";
    }
}
function $f5661b1f1d377ec0$export$22103f8d80cc8961(href) {
    try {
        const url = new URL(href);
        var _url_searchParams_get;
        return (_url_searchParams_get = url.searchParams.get("cgsKey")) !== null && _url_searchParams_get !== void 0 ? _url_searchParams_get : undefined;
    } catch (e) {
        return undefined;
    }
}
function $f5661b1f1d377ec0$export$c37691d1fa2eace6(args) {
    var _args_workingOnValue, _args_goalValue;
    const workingOnIsCustom = Boolean((_args_workingOnValue = args.workingOnValue) === null || _args_workingOnValue === void 0 ? void 0 : _args_workingOnValue.trim());
    const goalIsCustom = Boolean((_args_goalValue = args.goalValue) === null || _args_goalValue === void 0 ? void 0 : _args_goalValue.trim());
    if (workingOnIsCustom && goalIsCustom) return "custom";
    if (!workingOnIsCustom && !goalIsCustom) return "template";
    return "mixed";
}
function $f5661b1f1d377ec0$export$9a72bee4029287c2(createAnalyticsEvent, payload) {
    var _payload_eventType;
    createAnalyticsEvent({
        eventType: (_payload_eventType = payload.eventType) !== null && _payload_eventType !== void 0 ? _payload_eventType : "track",
        action: payload.action,
        actionSubject: "paidLandingJiraAiExperiment",
        attributes: (0, $dPABA._)((0, $6ogO3._)({}, payload.attributes), {
            step: payload.step
        })
    }).fire();
}
function $f5661b1f1d377ec0$export$b800576c577b2197(error) {
    if (error instanceof Error) {
        var _error_response;
        const msg = error.message || "";
        if (msg.includes("Missing reCAPTCHA")) return {
            errorType: "recaptcha_missing",
            errorName: error.name,
            message: msg
        };
        return {
            errorType: "unknown",
            errorName: error.name,
            message: msg,
            status: error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status
        };
    }
    // Support UnsuccessfulFetchError-like shapes without importing cross-package types.
    if (error && typeof error === "object") {
        const maybeStatus = error.status;
        if (typeof maybeStatus === "number") return {
            errorType: "http_error",
            status: maybeStatus
        };
    }
    return {
        errorType: "unknown"
    };
}

});


parcelRegister("33kEK", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiTeamTypeMadLibPrompt", function () { return $cd6c6dd32e2ad127$export$df93ffe29d467f53; });
/* paid-jira-ai-team-type-mad-lib-prompt.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $7Sqn0 = parcelRequire("7Sqn0");
var $ddxTX = parcelRequire("ddxTX");

var $4se1R = parcelRequire("4se1R");

var $ahmPu = parcelRequire("ahmPu");

var $9yC2v = parcelRequire("9yC2v");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");

var $jUBSR = parcelRequire("jUBSR");

var $fx9D8 = parcelRequire("fx9D8");

var $l7lZe = parcelRequire("l7lZe");
const $cd6c6dd32e2ad127$var$modalCss = null;
const $cd6c6dd32e2ad127$var$teamTypeContainerCss = null;
const $cd6c6dd32e2ad127$var$teamTypeButtonsGroupCss = null;
const $cd6c6dd32e2ad127$var$teamTypeButtonStyles = {
    fontWeight: 400,
    borderRadius: 8,
    marginInlineStart: 4,
    marginBlockEnd: 4
};
const $cd6c6dd32e2ad127$var$footerCss = null;
const $cd6c6dd32e2ad127$var$disclaimerCss = null;
const $cd6c6dd32e2ad127$var$poweredByAiCss = null;
const $cd6c6dd32e2ad127$var$footerButtonStyles = {
    borderRadius: "40px",
    paddingLeft: "24px",
    paddingRight: "24px"
};
const $cd6c6dd32e2ad127$export$df93ffe29d467f53 = ({ isRerun: isRerun, showLoadingState: showLoadingState })=>{
    const { submit: submit, cgsDataLoading: cgsDataLoading, selectedTeamType: selectedTeamType, setSelectedTeamType: setSelectedTeamType, workingOnSuggestion: workingOnSuggestion, goalSuggestion: goalSuggestion, workingOnValue: workingOnValue, goalValue: goalValue, setWorkingOnValue: setWorkingOnValue, setGoalValue: setGoalValue, setHasUserSelectedTeamType: setHasUserSelectedTeamType, hasUserSelectedTeamType: hasUserSelectedTeamType, shuffle: shuffle, suggestMadLib: suggestMadLib, setIsErrorFromCgs: setIsErrorFromCgs, firePaidJiraAi: firePaidJiraAi, markPromptChangedField: markPromptChangedField, commonAnalyticsAttributes: commonAnalyticsAttributes, promptAttemptIndex: promptAttemptIndex } = (0, $jUBSR.useJiraAiFFL)();
    const [isFormValid, setIsFormValid] = (0, $1oC0p.useState)(true);
    const handleOnSubmit = async ()=>{
        if (!isFormValid) return;
        // Track click intent separately from the async lifecycle events in the context.
        firePaidJiraAi("BuildWithAIClicked", "clicked", {
            cta: isRerun ? "rerunPrompt" : "getStarted",
            promptAttemptIndex: promptAttemptIndex + 1
        });
        const params = {
            teamType: selectedTeamType,
            workingOnValue: workingOnValue || workingOnSuggestion,
            goalValue: goalValue || goalSuggestion
        };
        await submit({
            teamType: params.teamType,
            workingOn: params.workingOnValue,
            goal: params.goalValue
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1o8l _1bsbn0dd _p12f1osq _16qs1kzk _2rko7vkz _11q7cd5j _ca0q1tcg _u5f3gktf _n3td1tcg _19bvgktf _y3gn1e5h"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            !isRerun ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth7vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ahbqmyb0 _6rthmyb0"
                    ]),
                    children: Object.entries((0, $fx9D8.teamTypesMap)).map(([teamType, { messageKey: messageKey }])=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            appearance: selectedTeamType === teamType ? "subtle" : "default",
                            isSelected: selectedTeamType === teamType,
                            style: $cd6c6dd32e2ad127$var$teamTypeButtonStyles,
                            onClick: ()=>{
                                markPromptChangedField("teamType");
                                firePaidJiraAi("PromptTeamTypeSelected", "clicked", {
                                    previousTeamType: selectedTeamType,
                                    newTeamType: teamType,
                                    isFirstSelection: !hasUserSelectedTeamType
                                });
                                setHasUserSelectedTeamType(true);
                                setSelectedTeamType(teamType);
                                suggestMadLib(teamType);
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages)[messageKey]))
                        }, teamType))
                })
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7lZe.PaidJiraAiMadLib), {
                focusInput: !isRerun,
                workingOnSuggestion: workingOnSuggestion,
                goalSuggestion: goalSuggestion,
                workingOnValue: workingOnValue,
                goalValue: goalValue,
                onEnter: handleOnSubmit,
                onChange: ({ workingOnValue: newWorkingOnValue, goalValue: newGoalValue })=>{
                    if (newWorkingOnValue !== workingOnValue) {
                        var _commonAnalyticsAttributes_changedFields;
                        setIsErrorFromCgs(false);
                        setWorkingOnValue(newWorkingOnValue);
                        if (!((_commonAnalyticsAttributes_changedFields = commonAnalyticsAttributes.changedFields) === null || _commonAnalyticsAttributes_changedFields === void 0 ? void 0 : _commonAnalyticsAttributes_changedFields.includes("workingOn"))) firePaidJiraAi("PromptFieldChanged", "clicked", {
                            field: "workingOn",
                            valueLength: newWorkingOnValue.trim().length,
                            isCustom: Boolean(newWorkingOnValue.trim())
                        });
                        markPromptChangedField("workingOn");
                    }
                    if (newGoalValue !== goalValue) {
                        var _commonAnalyticsAttributes_changedFields1;
                        setIsErrorFromCgs(false);
                        setGoalValue(newGoalValue);
                        if (!((_commonAnalyticsAttributes_changedFields1 = commonAnalyticsAttributes.changedFields) === null || _commonAnalyticsAttributes_changedFields1 === void 0 ? void 0 : _commonAnalyticsAttributes_changedFields1.includes("goal"))) firePaidJiraAi("PromptFieldChanged", "clicked", {
                            field: "goal",
                            valueLength: newGoalValue.trim().length,
                            isCustom: Boolean(newGoalValue.trim())
                        });
                        markPromptChangedField("goal");
                    }
                },
                setAreInputsValid: setIsFormValid
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh7vkz _1e0c1txw _1bah1yb4 _4cvr1q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ect4b1j9 _1wyb1crf _vwz47vkz _syaz1ggn"
                        ]),
                        children: !isRerun ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulp1y44"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).poweredByAi)),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4se1R))), {
                                    label: "Status info"
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sqn0.default), {
                        children: cgsDataLoading || showLoadingState ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            isDisabled: true,
                            appearance: "subtle",
                            style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).working))
                        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    appearance: "subtle",
                                    iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9yC2v))), {
                                        label: ""
                                    }),
                                    style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                                    onClick: shuffle,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).shuffle))
                                }),
                                isRerun ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    isDisabled: !isFormValid,
                                    appearance: "subtle",
                                    iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                        label: ""
                                    }),
                                    style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                                    onClick: handleOnSubmit,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).rerunPrompt))
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    isDisabled: !isFormValid,
                                    appearance: "primary",
                                    style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                                    onClick: handleOnSubmit,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).getStarted))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7Sqn0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5bc20816e4beb8e1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $5bc20816e4beb8e1$var$buttonGroupStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> *': {
        flex: '1 0 auto'
    }
});
function $5bc20816e4beb8e1$export$2e2bcd8739ae039(_ref) {
    var appearance = _ref.appearance, children = _ref.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $5bc20816e4beb8e1$var$buttonGroupStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("4se1R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0749aecb688ec01c0962b8f7fb609ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e4a8d142e55a34$var$_react = $33e4a8d142e55a34$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33e4a8d142e55a34$var$_baseNew = $33e4a8d142e55a34$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $33e4a8d142e55a34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e4a8d142e55a34$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $33e4a8d142e55a34$var$_react.default.createElement($33e4a8d142e55a34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$33e4a8d142e55a34$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $33e4a8d142e55a34$var$_default = module.exports.default = $33e4a8d142e55a34$var$StatusInformationIcon;

});

parcelRegister("9yC2v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79393cf52935af5d2ce7204817b33e1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f54cbdf12a460b8$var$_react = $6f54cbdf12a460b8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6f54cbdf12a460b8$var$_baseNew = $6f54cbdf12a460b8$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6f54cbdf12a460b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Randomize".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for randomizing or shuffling functionality.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f54cbdf12a460b8$var$RandomizeIcon = (props)=>/*#__PURE__*/ $6f54cbdf12a460b8$var$_react.default.createElement($6f54cbdf12a460b8$var$_baseNew.default, Object.assign({
        name: "RandomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 .052 1.004l-.052.056-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="m15.78 3.72.05.06a.75.75 0 0 1-.05 1l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM2.91 3a2 2 0 0 1 1.55.74l1.53 1.88-.97 1.19-1.73-2.13a.5.5 0 0 0-.39-.18H0V3z"/>`
    }, props));
$6f54cbdf12a460b8$var$RandomizeIcon.displayName = 'RandomizeIcon';
var $6f54cbdf12a460b8$var$_default = module.exports.default = $6f54cbdf12a460b8$var$RandomizeIcon;

});

parcelRegister("l7lZe", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiMadLib", function () { return $d5f42ac48b84f3d9$export$c896215e2accffb4; });
/* paid-jira-ai-mad-lib.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $grHEz = parcelRequire("grHEz");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");
const $d5f42ac48b84f3d9$var$containerStyle = null;
const $d5f42ac48b84f3d9$var$inlineInputStyle = null;
const $d5f42ac48b84f3d9$var$MadLibLabel = ({ id: id, str: str, forSelector: forSelector })=>{
    const focusInput = ()=>{
        const element = window.document.querySelector(forSelector);
        element === null || element === void 0 ? void 0 : element.focus();
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            focusInput();
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        id: id,
        onClick: focusInput,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "button",
        children: str
    });
};
const $d5f42ac48b84f3d9$export$c896215e2accffb4 = ({ workingOnSuggestion: workingOnSuggestion, goalSuggestion: goalSuggestion, workingOnValue: workingOnValue, goalValue: goalValue, onChange: onChange, onEnter: onEnter, focusInput: focusInput, setAreInputsValid: setAreInputsValid })=>{
    const [isWorkingOnInputValid, setIsWorkingOnInputValid] = (0, $1oC0p.useState)(true);
    const [isGoalInputValid, setIsGoalInputValid] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        setAreInputsValid === null || setAreInputsValid === void 0 ? void 0 : setAreInputsValid(isWorkingOnInputValid && isGoalInputValid);
    }, [
        setAreInputsValid,
        isWorkingOnInputValid,
        isGoalInputValid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ect41pz4 _1wyb1tcg _vwz41ylp _1dyznl7k _syazpmk4 _1tke1lev"
        ]),
        style: {
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $kYjgt.messages).madLib), {
            values: {
                workingOn: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d5f42ac48b84f3d9$var$MadLibLabel, {
                        id: "workingOnLabel",
                        str: str,
                        forSelector: "#working-on-input span[contenteditable]"
                    }),
                goal: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d5f42ac48b84f3d9$var$MadLibLabel, {
                        id: "goalLabel",
                        str: str,
                        forSelector: "#goal-input span[contenteditable]"
                    }),
                workingOnInput: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    id: "working-on-input",
                    className: (0, $2jatx.default)([
                        "_syaz17la _179r1p8s _5pio1be1 _y3gn1h6o _1ul953f4 _1e0c1nu9 _1tke1u1b _vwz4d6z3 _s7n4z0dk _1kt9f705 _9tn1qvpr _aetrf705 _1qjlqvpr"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                        "--_1fb7i9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.purple"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grHEz.InlineInput), {
                        value: workingOnValue,
                        placeholder: workingOnSuggestion,
                        ariaLabelledBy: "workingOnLabel",
                        animatePlaceholder: true,
                        focus: focusInput,
                        onEnter: onEnter,
                        onChange: (value)=>{
                            if (onChange) onChange({
                                workingOnValue: value,
                                goalValue: goalValue
                            });
                        },
                        setIsInputValid: setIsWorkingOnInputValid
                    })
                }),
                goalInput: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    id: "goal-input",
                    className: (0, $2jatx.default)([
                        "_syaz17la _179r1p8s _5pio1be1 _y3gn1h6o _1ul953f4 _1e0c1nu9 _1tke1u1b _vwz4d6z3 _s7n4z0dk _1kt9f705 _9tn1qvpr _aetrf705 _1qjlqvpr"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                        "--_1fb7i9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.purple"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grHEz.InlineInput), {
                        value: goalValue,
                        placeholder: goalSuggestion,
                        ariaLabelledBy: "goalLabel",
                        animatePlaceholder: true,
                        onEnter: onEnter,
                        onChange: (value)=>{
                            if (onChange) onChange({
                                workingOnValue: workingOnValue,
                                goalValue: value
                            });
                        },
                        setIsInputValid: setIsGoalInputValid
                    })
                })
            }
        }))
    });
};

});
parcelRegister("grHEz", function(module, exports) {
$parcel$export(module.exports, "InlineInput", function () { return $264a45a5b6f2823d$export$36d3e0619bb09209; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $264a45a5b6f2823d$var$inlineInputStyle = null;
const $264a45a5b6f2823d$export$36d3e0619bb09209 = ({ value: value, placeholder: placeholder, animatePlaceholder: animatePlaceholder = false, onChange: onChange, onEnter: onEnter, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, focus: focus, setIsInputValid: setIsInputValid })=>{
    const [isClient, setIsClient] = (0, $1oC0p.useState)(false);
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const [doesInputContainPlaceholder, setDoesInputContainPlaceholder] = (0, $1oC0p.useState)(true);
    const [initFocused, setInitFocused] = (0, $1oC0p.useState)(false);
    const inputRef = (0, $1oC0p.useRef)(null);
    const intervalRef = (0, $1oC0p.useRef)(0);
    const previousOnChangeVal = (0, $1oC0p.useRef)(undefined);
    const previousIsInputValidVal = (0, $1oC0p.useRef)(undefined);
    const previousPlaceholder = (0, $1oC0p.useRef)("");
    const previousValue = (0, $1oC0p.useRef)(undefined);
    const handleOnChange = (doesInputContainPlaceholder)=>{
        if (!isClient || !inputRef.current) return;
        // Call onChange if value changed (user is typing)
        const value = doesInputContainPlaceholder ? "" : inputRef.current.innerText;
        if (onChange && previousOnChangeVal.current !== value) {
            previousOnChangeVal.current = value;
            onChange(value);
        }
        // Call setIsInputValid when input changes between valid/invalid (empty = invalid)
        const isValid = !!(doesInputContainPlaceholder || inputRef.current.innerText);
        if (setIsInputValid && previousIsInputValidVal.current !== isValid) {
            previousIsInputValidVal.current = isValid;
            setIsInputValid(isValid);
        }
        // Focus on input on component load
        if (focus && !initFocused) {
            inputRef.current.focus();
            // Move cursor to the end
            const range = document.createRange();
            range.selectNodeContents(inputRef.current);
            range.collapse(false); // false = to end of node
            const sel = window.getSelection();
            sel === null || sel === void 0 ? void 0 : sel.removeAllRanges();
            sel === null || sel === void 0 ? void 0 : sel.addRange(range);
            setInitFocused(true);
        }
    };
    // Handle blur: restore placeholder if empty
    const handleOnBlur = (0, $1oC0p.useCallback)(()=>{
        if (!isClient || !inputRef.current) return;
        setIsFocused(false);
        if (inputRef.current.innerText === "") {
            // Replace empty input with the placeholder text
            inputRef.current.innerText = placeholder;
            setDoesInputContainPlaceholder(true);
            handleOnChange(true);
        } else handleOnChange(doesInputContainPlaceholder);
    }, [
        isClient,
        placeholder,
        handleOnChange
    ]);
    // Handle input: replace placeholder on input
    const handleOnInput = (0, $1oC0p.useCallback)((e)=>{
        if (!isClient || !inputRef.current) return;
        if (doesInputContainPlaceholder) {
            var _nativeEvent_dataTransfer;
            const nativeEvent = e.nativeEvent;
            // Replace placeholder text with whatever the user typed
            inputRef.current.innerText = nativeEvent.data || ((_nativeEvent_dataTransfer = nativeEvent.dataTransfer) === null || _nativeEvent_dataTransfer === void 0 ? void 0 : _nativeEvent_dataTransfer.getData("text/plain")) || "";
            // Set cursor to the end
            inputRef.current.focus();
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(inputRef.current);
            range.collapse(false);
            selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
            selection === null || selection === void 0 ? void 0 : selection.addRange(range);
            setDoesInputContainPlaceholder(false);
        }
        handleOnChange(false);
    }, [
        isClient,
        doesInputContainPlaceholder,
        handleOnChange
    ]);
    // Set client flag
    (0, $1oC0p.useEffect)(()=>setIsClient(true), []);
    // Animate or set placeholder
    (0, $1oC0p.useEffect)(()=>{
        if (!isClient || !inputRef.current || value) return;
        if (previousPlaceholder.current === placeholder) return;
        previousPlaceholder.current = placeholder;
        // Set placeholder without animation
        if (!animatePlaceholder) {
            inputRef.current.innerText = placeholder;
            setDoesInputContainPlaceholder(true);
            handleOnChange(true);
            return;
        }
        // Animate placeholder
        window.clearInterval(intervalRef.current);
        inputRef.current.innerText = "";
        intervalRef.current = window.setInterval(()=>{
            if (!inputRef.current) {
                window.clearInterval(intervalRef.current);
                return;
            }
            const currentNumChars = inputRef.current.innerText.length;
            const renderNumChars = currentNumChars + (placeholder[currentNumChars] === " " ? 2 : 1);
            inputRef.current.innerText = placeholder.substring(0, renderNumChars);
            if (renderNumChars >= placeholder.length) {
                window.clearInterval(intervalRef.current);
                setDoesInputContainPlaceholder(true);
                handleOnChange(true);
            }
        }, 35);
    }, [
        isClient,
        value,
        placeholder,
        animatePlaceholder,
        handleOnChange
    ]);
    // Sync value with input text
    (0, $1oC0p.useEffect)(()=>{
        if (!isClient || !inputRef.current) return;
        if (previousValue.current === value) return;
        previousValue.current = value;
        if (typeof value !== "string") return;
        if (inputRef.current.innerText !== value) {
            if (value === "" && !isFocused) {
                inputRef.current.innerText = placeholder;
                setDoesInputContainPlaceholder(true);
                handleOnChange(true);
            } else {
                inputRef.current.innerText = value;
                setDoesInputContainPlaceholder(false);
                handleOnChange(false);
            }
        }
    }, [
        isClient,
        value,
        isFocused,
        placeholder,
        handleOnChange
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            !isClient && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_12ji1r31 _1qu2glyw _12y3idpf"
                ]),
                children: placeholder
            }),
            isClient && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                contentEditable: "plaintext-only",
                role: "textbox",
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-placeholder": placeholder,
                tabIndex: 0,
                onInput: handleOnInput,
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        e.preventDefault();
                        onEnter === null || onEnter === void 0 ? void 0 : onEnter();
                    }
                },
                onFocus: ()=>setIsFocused(true),
                onBlur: ()=>handleOnBlur(),
                ref: inputRef,
                suppressContentEditableWarning: true,
                className: (0, $2jatx.default)([
                    "_12ji1r31 _1qu2glyw _12y3idpf"
                ])
            })
        ]
    });
};

});



parcelRegister("6G35q", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return $a782b39b8df6e4f9$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $a1X32 = parcelRequire("a1X32");

var $iUVnd = parcelRequire("iUVnd");

var $jVa6Y = parcelRequire("jVa6Y");
var $32ARy = parcelRequire("32ARy");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");

var $jUBSR = parcelRequire("jUBSR");

var $iuNYi = parcelRequire("iuNYi");
const $a782b39b8df6e4f9$var$containerCss = null;
const $a782b39b8df6e4f9$var$paragraphCss = null;
const $a782b39b8df6e4f9$var$messageCss = null;
const $a782b39b8df6e4f9$var$messageHeaderCss = null;
const $a782b39b8df6e4f9$var$messageBodyCss = null;
const $a782b39b8df6e4f9$var$errorCss = null;
const $a782b39b8df6e4f9$var$messageCtaCss = null;
const $a782b39b8df6e4f9$var$accountCreationCss = null;
const $a782b39b8df6e4f9$var$separatorBorderCss = null;
const $a782b39b8df6e4f9$var$separatorCss = null;
const $a782b39b8df6e4f9$export$8b251419efc915eb = ({ onRetryClick: onRetryClick })=>{
    const { firePaidJiraAi: firePaidJiraAi, promptAttemptIndex: promptAttemptIndex, isErrorFromCgs: isErrorFromCgs, hasSubmittedDefaultValues: hasSubmittedDefaultValues } = (0, $jUBSR.useJiraAiFFL)();
    const messages = {
        yourJiraSpaceIsReady: "Your Jira space is ready",
        getStartedNow: "Get started now to keep editing, save your progress, and make it your own.",
        tryAnotherPrompt: "Try another prompt"
    };
    (0, $1oC0p.useEffect)(()=>{
        firePaidJiraAi("AccountCreationViewed", "viewed", {
            promptAttemptIndex: promptAttemptIndex
        });
    }, [
        firePaidJiraAi,
        promptAttemptIndex
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _zulpzwfg _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _p12fiafe"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1aom"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_ect41roz _k48p1fw0 _1wybviql _vwz411uf _1dyznmab _syazpmk4"
                        ]),
                        style: {
                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
                        },
                        children: messages.yourJiraSpaceIsReady
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect418aq _1wyb1k92 _vwz41m1q _syazpmk4",
                            "_1pfhoqnp _6rthoqnp"
                        ]),
                        style: {
                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
                        },
                        children: messages.getStartedNow
                    }),
                    isErrorFromCgs && !hasSubmittedDefaultValues && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_19it3dcd _bfhklnmr _ect418aq _1wyboxwj _vwz410nf _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _syaz1hlo _1e0c1txw _zulp1j6v _4cvr1h6o _2rko1kwk"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUVnd))), {
                                label: "error",
                                color: "var(--ds-icon-warning, #E56910)"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: "We couldn't build the project the way you asked for it. So we have built out a project that showcases what Rovo and Jira are capable of."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1pfhoqnp _6rthoqnp"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            onClick: ()=>onRetryClick === null || onRetryClick === void 0 ? void 0 : onRetryClick(),
                            tabIndex: 0,
                            role: "button",
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    onRetryClick === null || onRetryClick === void 0 ? void 0 : onRetryClick();
                                }
                            },
                            "aria-label": messages.tryAnotherPrompt,
                            className: (0, $2jatx.default)([
                                "_ect418aq _k48pni7l _1wyb1j6v _vwz41k92 _syazjk2v _80omtlke"
                            ]),
                            style: {
                                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                            },
                            children: [
                                messages.tryAnotherPrompt,
                                " ",
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1X32))), {
                                    label: messages.tryAnotherPrompt,
                                    size: "small"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1os5 _1ul91dxr"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.default), {
                    templateId: "cfind-4666-jira-ai-preview",
                    Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuNYi.InputSubmitButton), {}),
                    Submit: null,
                    Login: null,
                    Separator: /*#__PURE__*/ (0, $7VQPk.jsx)($a782b39b8df6e4f9$var$Separator, {}),
                    Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                        providers: {
                            google: "Google"
                        }
                    })
                })
            })
        ]
    });
};
const $a782b39b8df6e4f9$var$Separator = ()=>{
    const intl = (0, $8e22h.default)();
    const separatorText = intl.formatMessage({
        id: "WacSignupForm.socialSignUpOrSignUpWith",
        defaultMessage: "Or sign up with"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _1e0c1txw _vwz4400g _19pkviql _2hwxidpf _otyrviql _18u0idpf _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1h6d1kw7 _1dqonqa1 _189esoed _1e0c1ule _16jlkb7n _4t3iidpf _19pkidpf _2hwx1j6v _otyridpf _18u01j6v _tzy41acx"
                ])
            }),
            separatorText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1h6d1kw7 _1dqonqa1 _189esoed _1e0c1ule _16jlkb7n _4t3iidpf _19pkidpf _2hwx1j6v _otyridpf _18u01j6v _tzy41acx"
                ])
            })
        ]
    });
};

});
parcelRegister("a1X32", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74d7cd19eb40d689$var$_react = $74d7cd19eb40d689$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $74d7cd19eb40d689$var$_baseNew = $74d7cd19eb40d689$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $74d7cd19eb40d689$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74d7cd19eb40d689$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $74d7cd19eb40d689$var$_react.default.createElement($74d7cd19eb40d689$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$74d7cd19eb40d689$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $74d7cd19eb40d689$var$_default = module.exports.default = $74d7cd19eb40d689$var$ArrowRightIcon;

});

parcelRegister("iuNYi", function(module, exports) {
$parcel$export(module.exports, "InputSubmitButton", function () { return $69f3df6730317c8b$export$8a1669598804b0aa; });
/* input-submit-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $ddxTX = parcelRequire("ddxTX");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");
parcelRequire("jVa6Y");
var $6nMZs = parcelRequire("6nMZs");
var $cGEBM = parcelRequire("cGEBM");

var $7VwhR = parcelRequire("7VwhR");

var $jUBSR = parcelRequire("jUBSR");
const $69f3df6730317c8b$export$8a1669598804b0aa = ()=>{
    const intl = (0, $8e22h.default)();
    const { formError: formError, hasSubmitted: hasSubmitted, isReadyForInvalid: isReadyForInvalid, isSubmitting: isSubmitting, onClickSubmitButton: onClickSubmitButton, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const { firePaidJiraAi: firePaidJiraAi, promptAttemptIndex: promptAttemptIndex } = (0, $jUBSR.useJiraAiFFL)();
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $7VwhR.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    const buttonText = intl.formatMessage({
        id: "signupForm.accountCreation.signupButton",
        defaultMessage: "Sign up"
    });
    const placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    const errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    const labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvresu3 _1bah1yb4 _zulp1kwk _6rthkan1 _1e3j1bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _zzqj1vbe _vq65e4h9 _62vcoqnp _1heu1kw7 _1rwqvuon _125x1syg _17rn1kw7 _1t2q1kw7 _1q9pbfng _12vqewfl _1vyiewfl _1p1fidpf _d78pglyw"
                        ]),
                        style: {
                            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                            "aria-required": true,
                            isRequired: true,
                            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1o8l _1bsbr0r7"
                                ]),
                                children: labelText
                            }),
                            name: "email",
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        isValid === true && "_1lo6qn1y",
                                        isValid === false && "_1lo61wfy"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                        autoComplete: "email",
                                        "aria-describedby": "account_creation_email_help_text",
                                        elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                            valid: isValid
                                        }),
                                        onBlur: ()=>setIsReadyForInvalid(true),
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                            setTypeAheadEmail(e.target.value);
                                            fieldProps.onChange(e);
                                        },
                                        placeholder: placeholderText,
                                        testId: "email_field",
                                        type: "email",
                                        value: email,
                                        style: $69f3df6730317c8b$var$textFieldStyles
                                    }))
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e991osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            type: "submit",
                            appearance: "primary",
                            style: $69f3df6730317c8b$var$buttonStyles,
                            isDisabled: isSubmitting || hasSubmitted && !formError,
                            onClick: ()=>{
                                onClickSubmitButton();
                                firePaidJiraAi("AccountCreationSubmitClicked", "clicked", {
                                    source: "paidLandingPreview",
                                    method: "email",
                                    promptAttemptIndex: promptAttemptIndex
                                });
                            },
                            children: buttonText
                        })
                    })
                ]
            }),
            isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: "account_creation_email_help_text",
                role: "alert",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1wybepq8 _vwz4bs82 _syaznbxb"
                ]),
                style: {
                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                },
                children: errorMessageText
            }) : null
        ]
    });
};
const $69f3df6730317c8b$var$containerCss = null;
const $69f3df6730317c8b$var$inputCss = null;
const $69f3df6730317c8b$var$labelChildCss = null;
const $69f3df6730317c8b$var$textFieldStyles = {
    height: "2.286rem",
    paddingInlineStart: "1.125rem",
    paddingInlineEnd: "1.125rem"
};
const $69f3df6730317c8b$var$buttonContainerCss = null;
const $69f3df6730317c8b$var$buttonStyles = {
    borderRadius: "2.5rem",
    paddingInlineStart: "1.5rem",
    paddingInlineEnd: "1.5rem",
    width: "100%"
};
const $69f3df6730317c8b$var$errorMessageCss = null;
const $69f3df6730317c8b$var$inputInvalidCss = null;
const $69f3df6730317c8b$var$inputValidCss = null;

});






parcelRegister("9h3ui", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswEngineering", function () { return $5f64ecbd83542af8$export$21c206b8ba9eb903; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $5f64ecbd83542af8$export$21c206b8ba9eb903 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-engineering",
        persona: "unknown",
        pageVariant: "engineering"
    }));
};

});

parcelRegister("8v2ki", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswHr", function () { return $d9e299dc383c47ee$export$ad7cb727602fa346; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $d9e299dc383c47ee$export$ad7cb727602fa346 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-hr",
        persona: "unknown",
        pageVariant: "hr"
    }));
};

});

parcelRegister("2LTjU", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswLegal", function () { return $51fd46f684ec8cbe$export$a54419ba9ddd4e32; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $51fd46f684ec8cbe$export$a54419ba9ddd4e32 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-legal",
        persona: "unknown",
        pageVariant: "legal"
    }));
};

});

parcelRegister("idul7", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswMarketing", function () { return $c9117ca4233aaf70$export$560daf6a01ddd7ea; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $c9117ca4233aaf70$export$560daf6a01ddd7ea = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-marketing",
        persona: "unknown",
        pageVariant: "marketing"
    }));
};

});

parcelRegister("iEYMn", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswOperations", function () { return $96b8a703ecbb65ad$export$e2ac21102c7fc08d; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $96b8a703ecbb65ad$export$e2ac21102c7fc08d = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-operations",
        persona: "unknown",
        pageVariant: "operations"
    }));
};

});

parcelRegister("1MAo5", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswProgramMgmt", function () { return $6104242eaac5f9c8$export$474595b11c2cc21b; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $6104242eaac5f9c8$export$474595b11c2cc21b = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-programmgmt",
        persona: "unknown",
        pageVariant: "programmgmt"
    }));
};

});

parcelRegister("dQR2M", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePageAnchorLpJswSales", function () { return $e85ae7222d917129$export$bd9265ca82ed6224; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $e85ae7222d917129$export$bd9265ca82ed6224 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsw-team-sales",
        persona: "unknown",
        pageVariant: "sales"
    }));
};

});

parcelRegister("dXL3R", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePage", function () { return $9d047481379b0727$export$a6be62ed06c967ea; });

var $7VQPk = parcelRequire("7VQPk");

var $67UrT = parcelRequire("67UrT");

var $9rnwe = parcelRequire("9rnwe");

var $3L8ZR = parcelRequire("3L8ZR");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");
parcelRequire("l8kCZ");
var $bTseT = parcelRequire("bTseT");

var $5JA6e = parcelRequire("5JA6e");

var $2V8Su = parcelRequire("2V8Su");

var $bxwDC = parcelRequire("bxwDC");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $hFl3j = parcelRequire("hFl3j");
const $9d047481379b0727$export$a6be62ed06c967ea = ({ utmCampaign: utmCampaign })=>{
    const loggedInHasJira = (0, $doAVE.useLoggedInHasJira)();
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    const isWae = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).dxpMigrationJiraProductTourGate);
    const loggedInSkeletonEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jfindLoggedInJiraProductTourSkeleton);
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate("gwp-737-enable-intercom-chat-jsw");
    const hasImcKey = (0, $7VwhR.hasJiraImcCampaignKey)(utmCampaign);
    // Jira FFl experiment check start
    const jiraFflExperimentCheck = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).cfind4666JiraFfl);
    const isJiraFflVariant = jiraFflExperimentCheck.type === (0, $ea4mV.EnrollmentType).ENROLLED && jiraFflExperimentCheck.value;
    // Jira FFl experiment check end
    let template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bxwDC.LoggedOutOrNoJiraProductTourOverview), {});
    //For logged in, we will either show a "Has Jira" experience, otherwise the Uniform "logged out" page
    if (loggedInHasJira) template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2V8Su.OrganicLoggedInJiraProductTourOverview), {});
    else {
        if (hasImcKey && isJiraFflVariant && isLoggedOut) template = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hFl3j.JiraProductTourAiTemplate), {});
        else if (isWae) template = /*#__PURE__*/ (0, $7VQPk.jsx)($9d047481379b0727$var$WaeJiraPage, {});
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "jira-product-tour-overview",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
            appId: "p0ww63i2",
            triggerBoot: isBootIntercom,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $20OkY.ProductKeys).JIRA_SOFTWARE
                ],
                screenName: "wacJswProductTourPage",
                children: loggedInSkeletonEnabled ? //Feature Gate checks for logged in users
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5JA6e.LoggedInHeroContainer), {
                    children: template
                }) : template
            })
        })
    });
};
const $9d047481379b0727$var$WaeJiraPage = ()=>{
    const { composition: composition } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), {
        composition: composition
    });
};

});
parcelRegister("67UrT", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPage", function () { return $567142e6bd5e85f1$export$f0d4a992b207ed41; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iSeHD = parcelRequire("iSeHD");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");
parcelRequire("1RvSu");
var $ipRTK = parcelRequire("ipRTK");

var $ea4mV = parcelRequire("ea4mV");

var $doAVE = parcelRequire("doAVE");
const $567142e6bd5e85f1$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4666JiraFfl);
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    const [dxpMigrationJsmAnchorJourneyExposureFired, fireDxpMigrationJsmAnchorJourneyExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationJsmAnchorJourneyExposureFired && isDxpMigrationJsmAnchorJourney.type === (0, $ea4mV.EnrollmentType).ENROLLED && isLoggedOut && [
            `paid-lp-jsm-itsm`,
            `paid-lp-jsm-features`,
            `paid-lp-jsm-service-desk`,
            `paid-lp-jsm-ticketing`
        ].includes(window.cmsPageVariant || "")) fireDxpMigrationJsmAnchorJourneyExposure();
    }, [
        dxpMigrationJsmAnchorJourneyExposureFired,
        fireDxpMigrationJsmAnchorJourneyExposure,
        isDxpMigrationJsmAnchorJourney,
        isLoggedOut
    ]);
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $1oC0p.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRTK.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("1RvSu", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return (parcelRequire("ipRTK")).UniformEntryPageTemplate; });

var $ipRTK = parcelRequire("ipRTK");

});
parcelRegister("ipRTK", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $9b881e462c85fa95$export$8328465fb6b6a7d2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $9b881e462c85fa95$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});



parcelRegister("5JA6e", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroContainer", function () { return $7dd9a4cf5c1be356$export$c91dc4c235bd2e79; });

var $7VQPk = parcelRequire("7VQPk");

var $doAVE = parcelRequire("doAVE");

var $ZCSXq = parcelRequire("ZCSXq");
const $7dd9a4cf5c1be356$export$c91dc4c235bd2e79 = ({ children: children })=>{
    const { profile: { requestInProgress: profileRequestInProgress }, user: { requestInProgress: userRequestInProgress } } = (0, $doAVE.useUserContext)();
    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (userRequestInProgress || profileRequestInProgress) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ZCSXq.LoggedInHeroSkeleton), {});
    return children;
};

});
parcelRegister("ZCSXq", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSkeleton", function () { return $136a2b90265c9861$export$84abebbf129cccbc; });
/* logged-in-hero-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $136a2b90265c9861$var$headingSectionGap = null;
const $136a2b90265c9861$var$sectionGap = null;
const $136a2b90265c9861$var$contianerStyles = null;
const $136a2b90265c9861$var$mobileDisplay = null;
const $136a2b90265c9861$var$desktopDisplay = null;
const $136a2b90265c9861$export$84abebbf129cccbc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "logged-in-jira-pt-skeleton",
        className: (0, $2jatx.default)([
            "_1pfh1ejb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1152px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1140px",
                                height: "1140px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _1mjb1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rth1epz"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "48px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthxncg _1eglxncg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "480px",
                                height: "480px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("eUwCn", function(module, exports) {
$parcel$export(module.exports, "Adg4Skeleton", function () { return $a7f43d28d2add36d$export$e754784845e8828d; });

var $6ogO3 = parcelRequire("6ogO3");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $4jcRW = parcelRequire("4jcRW");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");
const $a7f43d28d2add36d$export$e754784845e8828d = (_param)=>{
    var { width: width, height: height, groupName: groupName, testId: testId } = _param, props = (0, $aPnCa._)(_param, [
        "width",
        "height",
        "groupName",
        "testId"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), (0, $6ogO3._)({
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $lP7A9.default)("space.100"),
        color: (0, $kbpa7.wacToken)("color.neutral.light200"),
        ShimmeringEndColor: (0, $kbpa7.wacToken)("color.neutral.light300")
    }, props));
};

});



parcelRegister("2V8Su", function(module, exports) {
$parcel$export(module.exports, "OrganicLoggedInJiraProductTourOverview", function () { return $416013fb4d6c28df$export$49bc6fac881dd811; });

var $7VQPk = parcelRequire("7VQPk");

var $8LaTa = parcelRequire("8LaTa");

var $l4vdU = parcelRequire("l4vdU");

var $2emUn = parcelRequire("2emUn");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $4afjM = parcelRequire("4afjM");

var $ly0rU = parcelRequire("ly0rU");

var $lTaG1 = parcelRequire("lTaG1");

var $jmYmp = parcelRequire("jmYmp");
const $416013fb4d6c28df$export$49bc6fac881dd811 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "jfind-1506-after-d7-gubtp-organic",
        group: "jfind-1506-after-d7-gubtp-organic",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "jfind-organic-jpt-logged-in-redesign",
            group: "jfind-organic-jpt-logged-in-redesign",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ly0rU.JiraSitesProvider), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4vdU.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmYmp.default), {})
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        scrollTrackingEnabled: true,
                        pageId: "jsw",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4afjM.ReturningUserBanner), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lTaG1.LoggedInHeroSection), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
                        ]
                    })
                ]
            })
        })
    });
};

});
parcelRegister("l4vdU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73f92d32d2fa0cb0$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $32ng3 = parcelRequire("32ng3");
const $73f92d32d2fa0cb0$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $2jatx.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $73f92d32d2fa0cb0$var$sticky = null;
var $73f92d32d2fa0cb0$export$2e2bcd8739ae039 = $73f92d32d2fa0cb0$var$StickyContainer;

});

parcelRegister("4afjM", function(module, exports) {
$parcel$export(module.exports, "ReturningUserBanner", function () { return $51537c7de9d5df83$export$14e4a778e9c76f32; });
/* returning-user-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
const $51537c7de9d5df83$export$14e4a778e9c76f32 = ()=>{
    const isBannerEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jiraProductTourReturningUserBanner);
    if (!isBannerEnabled) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "returning-user-banner",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _bfhk6kkz _1e0c1txw _1n261g80 _zulp1kwk _1bah1h6o _vwz410nf _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v"
        ]),
        style: {
            "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: "\uD83D\uDCE3"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraProductTourReturningUserBanner.message",
                defaultMessage: "Introducing agents in Jira <link>Learn more</link>",
                values: {
                    link: $51537c7de9d5df83$var$LearnMoreLink
                }
            })
        ]
    });
};
const $51537c7de9d5df83$var$LearnMoreLink = (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: "https://www.atlassian.com/blog/announcements/ai-agents-in-jira",
        className: (0, $2jatx.default)([
            "_syazjk2v _4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1"
        ]),
        style: {
            "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
        },
        children: chunks
    });
const $51537c7de9d5df83$var$bannerCss = null;
const $51537c7de9d5df83$var$linkCss = null;

});

parcelRegister("ly0rU", function(module, exports) {
$parcel$export(module.exports, "useJiraSitesContext", function () { return $007cd6e9556fb39d$export$8095836340dcdac5; });
$parcel$export(module.exports, "JiraSitesProvider", function () { return $007cd6e9556fb39d$export$e5844423e4215335; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $doAVE = parcelRequire("doAVE");

var $lmmDf = parcelRequire("lmmDf");
const $007cd6e9556fb39d$var$JiraSitesContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $007cd6e9556fb39d$export$8095836340dcdac5 = ()=>{
    const context = (0, $1oC0p.useContext)($007cd6e9556fb39d$var$JiraSitesContext);
    if (!context) throw new Error("useJiraSitesContext must be used within a JiraSitesProvider");
    return context;
};
const $007cd6e9556fb39d$export$e5844423e4215335 = ({ children: children })=>{
    var _profile_attributes;
    const [jiraSitesFromAgg, setJiraSitesFromAgg] = (0, $1oC0p.useState)(undefined);
    const { profile: profile } = (0, $doAVE.useUserContext)();
    const aggClient = (0, $1oC0p.useMemo)(()=>new (0, $lmmDf.LoggedInUserJiraSitesClient)(), []);
    (0, $1oC0p.useEffect)(()=>{
        var _profile_attributes;
        if (!((_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites) || profile.attributes.existingSites.length !== 1) return;
        const site = profile.attributes.existingSites[0];
        var _site_cloudId;
        aggClient.getJiraSites((_site_cloudId = site === null || site === void 0 ? void 0 : site.cloudId) !== null && _site_cloudId !== void 0 ? _site_cloudId : "").then((data)=>{
            setJiraSitesFromAgg(data);
        });
    }, [
        aggClient,
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($007cd6e9556fb39d$var$JiraSitesContext.Provider, {
        value: {
            jiraSitesFromAgg: jiraSitesFromAgg
        },
        children: children
    });
};

});

parcelRegister("lTaG1", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroSection", function () { return $27cf35ec8a7f1f0a$export$49c6370202c57ed1; });
/* logged-in-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iSeHD = parcelRequire("iSeHD");

var $lqyi6 = parcelRequire("lqyi6");

var $eY3N6 = parcelRequire("eY3N6");

var $hLJF4 = parcelRequire("hLJF4");

var $doAVE = parcelRequire("doAVE");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $1OyVz = parcelRequire("1OyVz");

var $aTTHV = parcelRequire("aTTHV");

var $kP8Dm = parcelRequire("kP8Dm");

var $3riD8 = parcelRequire("3riD8");

var $jUgJp = parcelRequire("jUgJp");

var $1YSly = parcelRequire("1YSly");

var $ly0rU = parcelRequire("ly0rU");
const $27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES = {
    loggedInHeroProductCtaClicked: "loggedInHeroProductCtaClicked",
    loggedInHeroAnotherSiteCtaClicked: "loggedInHeroAnotherSiteCtaClicked",
    loggedInHeroExploreFeaturesClicked: "loggedInHeroExploreFeaturesClicked",
    loggedInHeroCreateNewSiteClicked: "loggedInHeroCreateNewSiteClicked"
};
const $27cf35ec8a7f1f0a$var$START_URL = "https://start.atlassian.com";
const $27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3 = {
    eventType: "ui",
    action: "clicked",
    actionSubject: "button",
    actionSubjectId: "loggedInHero",
    source: "/software/jira"
};
const $27cf35ec8a7f1f0a$var$jswLoggedInCss = null;
const $27cf35ec8a7f1f0a$var$heroSectionCss = null;
const $27cf35ec8a7f1f0a$var$anchorContainer = null;
const $27cf35ec8a7f1f0a$var$jiraSiteBoxCss = null;
const $27cf35ec8a7f1f0a$var$headingCss = null;
const $27cf35ec8a7f1f0a$var$starCss = null;
const $27cf35ec8a7f1f0a$var$differentSiteCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingContainerCss = null;
const $27cf35ec8a7f1f0a$var$createNewSiteAnchorCss = null;
const $27cf35ec8a7f1f0a$var$subHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesContainerCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesHeadingCss = null;
const $27cf35ec8a7f1f0a$var$exploreFeaturesCtaCss = null;
const $27cf35ec8a7f1f0a$var$nameUnderlineCss = null;
const $27cf35ec8a7f1f0a$var$inlineJiraLogoCss = null;
const $27cf35ec8a7f1f0a$var$siteInfoContainerCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconCss = null;
const $27cf35ec8a7f1f0a$var$sitenameIconTextCss = null;
const $27cf35ec8a7f1f0a$var$sitenameAndAvatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$siteNameSpanCss = null;
const $27cf35ec8a7f1f0a$var$tooltipWrapperCss = null;
const $27cf35ec8a7f1f0a$var$avatarContainerCss = null;
const $27cf35ec8a7f1f0a$var$linkPlaceholderCss = null;
const $27cf35ec8a7f1f0a$export$49c6370202c57ed1 = ()=>{
    var _user_name, _loggedInUserProfile_name, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira, _jiraSitesFromAgg_jira1, _jiraSitesFromAgg_jira2;
    const loggedInUserProfile = (0, $3riD8.useLoggedInUser)();
    const { user: user } = (0, $doAVE.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [teammateAvatars, setTeammateAvatars] = (0, $1oC0p.useState)([]);
    const [totalUserCount, setTotalUserCount] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    // GWP-10447: Check if the user is an SMB sales lead to adjust the hero CTA button variant
    const { isEligible: isSMBSalesLead } = (0, $aTTHV.useContactSalesCtaEligibility)();
    var _user_name_split_;
    // Try to get name from props, and fallback to hook if needed
    const userFirstName = (_user_name_split_ = (_user_name = user.name) === null || _user_name === void 0 ? void 0 : _user_name.split(" ")[0]) !== null && _user_name_split_ !== void 0 ? _user_name_split_ : (_loggedInUserProfile_name = loggedInUserProfile.name) === null || _loggedInUserProfile_name === void 0 ? void 0 : _loggedInUserProfile_name.split(" ")[0];
    var _user_picture;
    // Try to get picture from props, and fallback to hook if needed
    const userPicture = (_user_picture = user === null || user === void 0 ? void 0 : user.picture) !== null && _user_picture !== void 0 ? _user_picture : loggedInUserProfile.picture;
    const avatars = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.edges;
    (0, $1oC0p.useEffect)(()=>{
        var _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira;
        var _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map;
        setTeammateAvatars((_jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.edges.filter((assignableUser)=>assignableUser.node.picture != userPicture && assignableUser.node.accountStatus === "active").map((assignableUser)=>{
            var _assignableUser_node_picture;
            return (_assignableUser_node_picture = assignableUser.node.picture) !== null && _assignableUser_node_picture !== void 0 ? _assignableUser_node_picture : "";
        })) !== null && _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map !== void 0 ? _jiraSitesFromAgg_jira_allJiraProjects_edges__node_assignableUsers_edges_filter_map : []);
    }, [
        avatars,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira1 = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira1 === void 0 ? void 0 : _jiraSitesFromAgg_jira1.allJiraProjects.edges,
        userPicture
    ]);
    (0, $1oC0p.useEffect)(()=>{
        var _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira;
        return setTotalUserCount(jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira.allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges_.node.assignableUsers.totalCount);
    }, [
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira2 = jiraSitesFromAgg.jira) === null || _jiraSitesFromAgg_jira2 === void 0 ? void 0 : _jiraSitesFromAgg_jira2.allJiraProjects.edges
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedTryLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&createNew=true");
    const localizedProductGuideLink = (0, $kooLp.useLocalizedHref)("/software/jira/guides/getting-started/introduction");
    const [hasMultipleJiras, setHasMultipleJiras] = (0, $1oC0p.useState)(false);
    const [siteName, setSiteName] = (0, $1oC0p.useState)("");
    const [siteInitials, setSiteInitials] = (0, $1oC0p.useState)("");
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)("");
    const { hasMultipleJiras: mostRecentHasMultipleJiras, siteName: mostRecentSiteName, siteUrl: mostRecentSiteUrl, siteInitials: mostRecentSiteInitials } = (0, $kP8Dm.useRecentJiraSite)();
    (0, $1oC0p.useEffect)(()=>{
        setHasMultipleJiras(mostRecentHasMultipleJiras);
        setSiteName(mostRecentSiteName);
        setSiteUrl(mostRecentSiteUrl);
        setSiteInitials(mostRecentSiteInitials);
    }, [
        mostRecentHasMultipleJiras,
        mostRecentSiteInitials,
        mostRecentSiteName,
        mostRecentSiteUrl
    ]);
    const loggedInHeroLoadedAnalyticsPayload = {
        eventType: "ui",
        action: "loaded",
        actionSubject: "component",
        actionSubjectId: "loggedInHero",
        source: "/software/jira",
        attributes: {
            atlasId: "ATLAS-76385, ATLAS-93656"
        }
    };
    (0, $1oC0p.useEffect)(()=>{
        //if client side, fire analytics event
        if (typeof window !== "undefined") createAnalyticsEvent((0, $6ogO3._)({}, loggedInHeroLoadedAnalyticsPayload)).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const clickHandler = (eventName)=>{
        createAnalyticsEvent((0, $dPABA._)((0, $6ogO3._)({}, $27cf35ec8a7f1f0a$export$cbc42fadf8b93ea3), {
            attributes: {
                eventName: eventName,
                url: window.location.href,
                atlasId: "ATLAS-76385, ATLAS-93656"
            }
        })).fire();
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _11q71ybm _12vemgnk _1lrw1dfr _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _18zr53f4 _1q5110yn _85i512am _1bsb1osq _1bhl10yn"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _syaz1hlo _1bsb1osq _p12fk3xj _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _s51sidpf"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_t9ecuuzf _kqswstnw _1e0c1o8l _u7co1w81 _1e021vgi _1mjbglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            width: 88,
                            height: 70,
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g06k378gucflnfse7s88i0365h14j40v.webp",
                            alt: ""
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wybckbl _vwz48vuz _k48p9y44 _ect41pz4 _6rtho7ao _bozgidpf _so7dldb6 _19q11ylp"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                    },
                    children: userFirstName ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBackWithName",
                        defaultMessage: `Welcome back, {name}.`,
                        values: {
                            name: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_zg8l4jg8 _kqswh2mm _3p6m1sr6 _1v5vmgnk _14rnhyuj _19h91f51 _aetrb3bt _1qdggktf _1gufd439 _1czd12gs _g0nfmyb0 _18postnw _14tt14id _1ruvyjp0"
                                ]),
                                style: {
                                    "--_1f8eaoq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.yellow400"))
                                },
                                children: userFirstName
                            })
                        }
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                        defaultMessage: "Welcome back"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _gy1p53f4 _1bah1yb4 _4cvr1q9y"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOffInProduct",
                                defaultMessage: "Pick up where you left off in <span>{product}</span>",
                                values: {
                                    product: "Jira",
                                    // eslint-disable-next-line react/no-unstable-nested-components
                                    span: (text)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1e0c1o8l _t9ec1jia _kqswh2mm _152tdlk8 _195g14id"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1OyVz.JiraMarkBrand), {})
                                                }),
                                                text
                                            ]
                                        })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "createNewSiteAnchor",
                            href: localizedTryLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroCreateNewSiteClicked),
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wyb7vkz _k48pni7l _vwz41f4h _syazjk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "WacSignupForm.createNewSite",
                                defaultMessage: "Create a new site"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _16jlkb7n _1wpz1fhb"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhkcd5j _2rko1y44 _1bsb1osq _1ul91mjv _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _19it1wcj _1rjc7vkz _18zr7vkz _1mougktf _kqswh2mm"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jUgJp.JiraSiteContainer), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _4t3ivbgk _zulppxbi"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_11q7ihgv _2rko1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ivbgk _1bsbvbgk _1ul9vbgk"
                                            ]),
                                            style: {
                                                "--_1efrnav": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime300"))
                                            },
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz5wis _ect41pz4 _1wyb1ejb _k48pni7l _vwz41f4h _1dyznl7k _y3gn1h6o"
                                                ]),
                                                style: {
                                                    "--_1yoj5ey": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime800")),
                                                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                                },
                                                children: siteInitials
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _2lx21bp4 _1bah1h6o _zulp19bv _kqswh2mm _4t3ivbgk"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3igktf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                                                        content: siteName,
                                                        position: "top-end",
                                                        mousePosition: "top",
                                                        tag: "span",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_ect4bzd7 _1wybgktf _k48p1fw0 _4t3igktf _vwz41j6v _y3gn1e5h _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1o8l _s7n4jp4b _uhd0uuw1 _1tssl1r9"
                                                            ]),
                                                            style: {
                                                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                                            },
                                                            children: siteName
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_4t3i1tcg _uhd0uuw1 _1tssl1r9"
                                                    ]),
                                                    children: userPicture && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1YSly.LoggedInProductTourAvatarFacepile), {
                                                        max: 4,
                                                        iconSize: 24,
                                                        icons: [
                                                            userPicture,
                                                            ...teammateAvatars
                                                        ],
                                                        totalUserCount: totalUserCount !== null && totalUserCount !== void 0 ? totalUserCount : 0
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                                    "data-testid": "goToJiraButton",
                                    variant: isSMBSalesLead ? "primary" : "primary_alt",
                                    href: siteUrl,
                                    size: "small",
                                    onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroProductCtaClicked),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "JiraSoftwarePageTemplate.loggedInHero.goToJira",
                                        defaultMessage: "Go to Jira"
                                    })
                                })
                            ]
                        })
                    })
                }),
                hasMultipleJiras ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ect4bzd7 _1pfho7ao _1wybdlk8 _k48p1nn1 _gu181h6o"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: intl.formatMessage({
                            id: "ConfluenceSoftwarePageTemplate.loggedInHero.lookingForDifferentSite",
                            defaultMessage: "Looking for a different site?"
                        }),
                        href: $27cf35ec8a7f1f0a$var$START_URL,
                        type: "primary",
                        onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroAnotherSiteCtaClicked)
                    })
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3iqslr"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfhvbgk _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ect4bzd7 _1wybgktf _vwz41f4h _k48p1nn1 _6rth7vkz"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraSoftwarePageTemplate.loggedInHero.findOutMore",
                                defaultMessage: "Want to find out more about Jira?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-testid": "exploreFeaturesAnchor",
                            href: localizedProductGuideLink,
                            onClick: ()=>clickHandler($27cf35ec8a7f1f0a$var$TRACKING_EVENT_NAMES.loggedInHeroExploreFeaturesClicked),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb7vkz _k48pni7l _11q7glyw _r06hglyw _2rko1ul9 _ca0q19bv _u5f31ul9 _n3td19bv _19bv1ul9 _19it1axk _80omtlke"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jira-product-tour.staggered-double-feature-section.first-feature-link-text",
                                    defaultMessage: "Explore features"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$27cf35ec8a7f1f0a$export$49c6370202c57ed1.displayName = "LoggedInHeroSection";
var $27cf35ec8a7f1f0a$export$2e2bcd8739ae039 = $27cf35ec8a7f1f0a$export$49c6370202c57ed1;

});

parcelRegister("jmYmp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $32c81aeeb0653afd$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $cjWBX = parcelRequire("cjWBX");

var $doAVE = parcelRequire("doAVE");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");

var $ly0rU = parcelRequire("ly0rU");
const $32c81aeeb0653afd$var$JiraLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
};
const $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar = ()=>{
    var _profile_attributes, _profile_attributes1;
    const intl = (0, $8e22h.default)();
    const logoUrl = (0, $kooLp.useLocalizedHref)("/software/jira");
    const { profile: profile } = (0, $doAVE.useUserContext)();
    const { jiraSitesFromAgg: jiraSitesFromAgg } = (0, $ly0rU.useJiraSitesContext)();
    const [siteUrl, setSiteUrl] = (0, $1oC0p.useState)("");
    (0, $1oC0p.useEffect)(()=>{
        var _profile_attributes, _jiraSitesFromAgg_jira_allJiraProjects_edges__node, _jiraSitesFromAgg_jira_allJiraProjects_edges_, _jiraSitesFromAgg_jira_allJiraProjects;
        const site = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites[0];
        let tempSiteUrl = site === null || site === void 0 ? void 0 : site.url;
        if ((jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges.length) === 1) tempSiteUrl = jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects = jiraSitesFromAgg.jira.allJiraProjects) === null || _jiraSitesFromAgg_jira_allJiraProjects === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges_ = _jiraSitesFromAgg_jira_allJiraProjects.edges[0]) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges_ === void 0 ? void 0 : (_jiraSitesFromAgg_jira_allJiraProjects_edges__node = _jiraSitesFromAgg_jira_allJiraProjects_edges_.node) === null || _jiraSitesFromAgg_jira_allJiraProjects_edges__node === void 0 ? void 0 : _jiraSitesFromAgg_jira_allJiraProjects_edges__node.webUrl;
        setSiteUrl(tempSiteUrl !== null && tempSiteUrl !== void 0 ? tempSiteUrl : "");
    }, [
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges,
        jiraSitesFromAgg === null || jiraSitesFromAgg === void 0 ? void 0 : jiraSitesFromAgg.jira.allJiraProjects.edges.length,
        profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        profile === null || profile === void 0 ? void 0 : (_profile_attributes1 = profile.attributes) === null || _profile_attributes1 === void 0 ? void 0 : _profile_attributes1.existingSites.length
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cjWBX.JiraSmartBanner), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
                productLogoUrl: logoUrl,
                productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                productLogoAriaLabel: intl.formatMessage({
                    id: "wacJiraSoftwareNavigation.logo-label",
                    defaultMessage: "Jira Software logo"
                }),
                mobileCtaText: intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.navbar.goToJira",
                    defaultMessage: "Go to Jira"
                }),
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                mobileCtaOnClick: ()=>{},
                mobileCtaUrl: siteUrl,
                mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($32c81aeeb0653afd$var$JiraLogo, {}),
                navigationTrynowCtaText: intl.formatMessage({
                    id: "JiraFeatureSoftwarePageTemplate.navbar.goToJira",
                    defaultMessage: "Go to Jira"
                }),
                navigationTrynowCtaUrl: siteUrl,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                navigationTrynowCtaOnClick: ()=>{},
                productPageNavLinks: [],
                mobileLinksSections: [],
                isShowSearchButton: false,
                isShowAppSwitcher: false,
                isShowTabletDropdown: false
            })
        ]
    });
};
var $32c81aeeb0653afd$export$2e2bcd8739ae039 = $32c81aeeb0653afd$var$SoftwareJiraLoggedInNavbar;

});


parcelRegister("hFl3j", function(module, exports) {
$parcel$export(module.exports, "JiraProductTourAiTemplate", function () { return $35d304dc3dd67c9d$export$2464f9fe3647b767; });
/* cfind-4666-jira-product-tour-ai.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eY3N6 = parcelRequire("eY3N6");

var $k9ZIM = parcelRequire("k9ZIM");

var $8IN8s = parcelRequire("8IN8s");

var $ea4mV = parcelRequire("ea4mV");

var $dSJSp = parcelRequire("dSJSp");

var $4E3yC = parcelRequire("4E3yC");

var $jYNiT = parcelRequire("jYNiT");

var $4Dg8Z = parcelRequire("4Dg8Z");

var $6HCeC = parcelRequire("6HCeC");

var $33kEK = parcelRequire("33kEK");

var $jUBSR = parcelRequire("jUBSR");
const $35d304dc3dd67c9d$var$promptContainerCss = null;
const $35d304dc3dd67c9d$export$2bf0755ba7240c46 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const { cgsDataLoading: cgsDataLoading } = (0, $jUBSR.useJiraAiFFL)();
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4666JiraFfl);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (cgsDataLoading) setIsPreviewModalOpen(true);
    }, [
        cgsDataLoading
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return; // be sure analyticsClient is available before firing event
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "PaidLandingJiraAiTemplate",
            attributes: {
                flow: "paidLandingJiraAi"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dSJSp.PaidJiraAiBackground), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Dg8Z.PaidJiraAiHeader), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhckbl _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33kEK.PaidJiraAiTeamTypeMadLibPrompt), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jYNiT.PaidJiraAiDisclaimer), {}),
            isPreviewModalOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6HCeC.PaidJiraAiPreviewModal), {
                onClose: ()=>setIsPreviewModalOpen(false)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4E3yC.PaidJiraAiBody), {})
        ]
    });
};
const $35d304dc3dd67c9d$export$2464f9fe3647b767 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUBSR.JiraAiFFLProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($35d304dc3dd67c9d$export$2bf0755ba7240c46, {})
    });

});
parcelRegister("4E3yC", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiBody", function () { return $48ae735f31d53976$export$ed242b92311bcd7d; });
/* paid-jira-ai-body.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $8LaTa = parcelRequire("8LaTa");

var $jkEFt = parcelRequire("jkEFt");
parcelRequire("aoV5a");
var $bSwKq = parcelRequire("bSwKq");

var $5IbWH = parcelRequire("5IbWH");

var $cf7Ff = parcelRequire("cf7Ff");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $7btsq = parcelRequire("7btsq");
const $48ae735f31d53976$var$jiraAiBodyStyles = null;
const $48ae735f31d53976$var$threeAlternatingImageTextCss = null;
const $48ae735f31d53976$var$paidCtaSectionCss = null;
const $48ae735f31d53976$export$ed242b92311bcd7d = ()=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonPropsHref = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const landingType = "jira-software-paid-ai";
    const tabsProps = {
        dataProductKey: "jiraSoftware-PaidLpJiraFfl",
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.heading",
            defaultMessage: "Discover AI features that power your teams"
        }),
        tabStyles: {
            defaultBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
            defaultText: (0, $kbpa7.wacToken)("color.extended.blue1000"),
            hoverBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
            hoverText: (0, $kbpa7.wacToken)("color.extended.blue1000"),
            activeBG: (0, $kbpa7.wacToken)("color.extended.blue200"),
            activeText: (0, $kbpa7.wacToken)("color.extended.blue1000")
        },
        styles: {
            "--lp-tabs-hover": (0, $kbpa7.wacToken)("color.extended.blue200"),
            "--lp-tabs-unselected": (0, $kbpa7.wacToken)("color.neutral.light700")
        },
        tabs: [
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.textLabel",
                    defaultMessage: "Plan"
                }),
                id: "plan",
                component: (0, $7btsq.Plan)()
            },
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.textLabel",
                    defaultMessage: "Track"
                }),
                id: "track",
                component: (0, $7btsq.Track)()
            },
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.textLabel",
                    defaultMessage: "Collaborate"
                }),
                id: "collaborate",
                component: (0, $7btsq.Collaborate)()
            },
            {
                textLabel: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.textLabel",
                    defaultMessage: "Report"
                }),
                id: "report",
                component: (0, $7btsq.Report)()
            }
        ]
    };
    const alternatingTextAndImageProps = {
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue100"),
        imageWidth: "100%",
        imageTextSideRowOnePadding: "7.5rem 0 1rem",
        imageTextSideRowOnePaddingBelowLargeScreen: "7.5rem 0 1rem",
        imageTextSideRowTwoPadding: "1rem 0",
        imageTextSideRowThreePadding: "1rem 0 7.5rem",
        imageTextSideRowThreePaddingBelowLargeScreen: "1rem 0 7.5rem",
        rowPropsOdd: "7-5",
        rowPropsEven: "5-7",
        //Row 1
        rowOneHeader: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneHeader",
            defaultMessage: "Customize how your team\u2019s work flows"
        }),
        rowOneBody: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneBody",
            defaultMessage: "Set up, clean up, and automate even the most complicated project workflows."
        }),
        rowOneImageLink: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EZD9.webp",
        rowOneImageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneImageAltText",
            defaultMessage: "Jira boards"
        }),
        //Row 2
        rowTwoHeader: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextHeader",
            defaultMessage: "Stay on track \u2013 even when the track changes"
        }),
        rowTwoBody: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextBody",
            defaultMessage: "Use the timeline view to map out the big picture, communicate updates to stakeholders, and ensure your team stays on the same page."
        }),
        rowTwoImageLink: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EZD7.webp",
        rowTwoImageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowTwoImageAltText",
            defaultMessage: "Jira timeline view."
        }),
        //Row 3
        rowThreeHeader: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeHeader",
            defaultMessage: "Bye-bye, spreadsheets"
        }),
        rowThreeBody: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeBody",
            defaultMessage: "Keep every detail of a project centralized in real time so up-to-date info can flow freely across people, teams, and tools."
        }),
        rowThreeImageLink: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EZD8.webp",
        rowThreeImageAltText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeImageAltText",
            defaultMessage: "Spreadsheets"
        })
    };
    const ctaProps = {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.header",
            defaultMessage: "Move fast, stay aligned, and build better - together"
        }),
        ctaProps: {
            buttonProps: {
                color: "blueprimary700",
                url: ctaButtonPropsHref,
                text: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.button",
                    defaultMessage: "Get it free"
                }),
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-container": "ctaSection",
                    "data-event-component": "linkButton",
                    "data-product-key": "jiraSoftware-PaidLpJiraFeatures"
                },
                size: "small"
            }
        },
        backgroundProperties: {
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        }
    };
    const testimonialProps = {
        headerText: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.heading",
            defaultMessage: "Trusted by over 100,000 customers world-wide"
        }),
        logos: [
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5382nib232306760cxko3fu33yr03hc6.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.squareAlt",
                    defaultMessage: "Square logo"
                }),
                loading: "lazy",
                width: 162,
                height: 40
            },
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8sh6x4kh58c7576am3gc70215abr77gu.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ebayAlt",
                    defaultMessage: "eBay logo"
                }),
                loading: "lazy",
                width: 99,
                height: 41
            },
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7l40fo7ky3ck1752eh0ti31556343388.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.spotifyAlt",
                    defaultMessage: "Spotify logo"
                }),
                loading: "lazy",
                width: 163,
                height: 49
            },
            {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/0atd5rxku6yg42wfhx0b1jdrsusm532i.svg",
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ciscoAlt",
                    defaultMessage: "Cisco logo"
                }),
                loading: "lazy",
                width: 92,
                height: 49
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q5153f4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "paid-lp-jsw-ffl",
            scrollTrackingEnabled: true,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cf7Ff.PaidTabsSection), (0, $6ogO3._)({}, tabsProps)),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1nh073xg _1b6r1fw0 _vuss8pqr _18m21wto _17xw1hlo _p1061k92 _13031m1q _1of01hlo"
                    ]),
                    style: {
                        "--_1fssbon": (0, $6ZVlx.default)((1168 + (0, $jMhSx.GRID_FIXED_PADDING) * 2) / 16, "rem"),
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSwKq.ThreeAlternatingImageText), (0, $6ogO3._)({}, alternatingTextAndImageProps))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1pal2qcg _14c7idpf _6vxh1wug _1rmzidpf _1igu1wug _17xwr3uz _1b6r8n31 _17e21k92 _10sl1k8s _1wty8pqr _zms51kwk _qpb11k8s _9kaf1kwk _1art1k8s _73hz8pqr _cokwidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5IbWH.PaidCtaSection), {
                        ctaProps: ctaProps,
                        landingType: landingType
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jkEFt.default), (0, $6ogO3._)({}, testimonialProps)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            ]
        })
    });
};

});
parcelRegister("aoV5a", function(module, exports) {
$parcel$export(module.exports, "ThreeAlternatingImageText", function () { return (parcelRequire("bSwKq")).ThreeAlternatingImageText; });

var $bSwKq = parcelRequire("bSwKq");

});

parcelRegister("7btsq", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswFeatures", function () { return $d1221b05e912c95d$export$6ab6d2db3208c01b; });
$parcel$export(module.exports, "Plan", function () { return $d1221b05e912c95d$export$814cc77def5a44df; });
$parcel$export(module.exports, "Track", function () { return $d1221b05e912c95d$export$13921ac0cc260818; });
$parcel$export(module.exports, "Collaborate", function () { return $d1221b05e912c95d$export$3141e70acdd1cdb7; });
$parcel$export(module.exports, "Report", function () { return $d1221b05e912c95d$export$33aa3110c4070c17; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $doAVE = parcelRequire("doAVE");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $k16ze = parcelRequire("k16ze");

var $a5uC7 = parcelRequire("a5uC7");

var $I9wqw = parcelRequire("I9wqw");

var $kZQhV = parcelRequire("kZQhV");

var $3oD33 = parcelRequire("3oD33");

var $3LcIp = parcelRequire("3LcIp");

var $l7lLR = parcelRequire("l7lLR");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $32ng3 = parcelRequire("32ng3");
const $d1221b05e912c95d$export$6ab6d2db3208c01b = ({ keyword: keyword, subAnchor: subAnchor, utmMedium: utmMedium, utmContent: utmContent, utmCampaign: utmCampaign })=>{
    const intl = (0, $8e22h.default)();
    const productHref = (0, $kooLp.useLocalizedHref)("/software/jira");
    const loggedInHasJira = (0, $doAVE.useLoggedInHasJira)();
    const ctaButtonPropsHref = (0, $kooLp.useLocalizedHref)("#start-trial");
    const pageId = "paid-lp-jsw-features";
    const paidLoggedOutHeroSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $I9wqw.PaidTeamSelectionHeroSection), {
        keyword: keyword
    });
    const gwpAJContextualBanditsJiraExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwpAJContextualBanditsJiraBPS);
    const isgwpAJContextualBanditsJiraExperimentEnabled = gwpAJContextualBanditsJiraExperiment.type === "enrolled" && gwpAJContextualBanditsJiraExperiment.value;
    const gwp9473JSWAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9473JSWAnchorUpdates);
    const props = {
        hideNavigationBar: false,
        customHeroSection: paidLoggedOutHeroSection,
        landingType: "jira-software",
        pageId: pageId,
        productNavProps: {
            productHref: productHref,
            productName: "jira",
            ariaLabel: intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            }),
            dataProductKey: "jiraSoftware",
            showFreeHrefButton: false,
            logoLinkWrapperWidth: "auto"
        },
        heroProps: {
            headerText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.hero.header",
                defaultMessage: "Connect every team, task, and project together with Jira"
            }),
            secondaryText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.hero.body",
                defaultMessage: "Trusted by 100K+ teams that plan, track, release, and manage world-class software."
            }),
            tertiaryText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.heroListHeading",
                defaultMessage: "INCLUDED IN YOUR FREE PLAN: Forever free for up to 10 users"
            }),
            image: {
                src: (0, $k16ze.getLocalizedImage)("hero", intl.locale),
                alt: intl.formatMessage({
                    id: "JiraSoftwarePagePaidLpJswFeatures.heroImageAlt",
                    defaultMessage: "Screen capture of a Jira backlog"
                }),
                width: 1134,
                height: 620
            },
            signup: {
                bundle: "jira-software",
                edition: "free",
                featureFlags: {
                    enableDefaultExpandedEmail: false,
                    enableDeferredFullName: true
                }
            }
        },
        tabsProps: {
            dataProductKey: "jiraSoftware-PaidLpJiraFeatures",
            headerText: gwp9473JSWAnchorUpdates ? intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.heading",
                defaultMessage: "Discover AI features that power your teams"
            }) : intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.tabs.heading",
                defaultMessage: "Discover the features that make Jira so easy to use"
            }),
            tabStyles: {
                defaultBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
                defaultText: (0, $kbpa7.wacToken)("color.extended.blue1000"),
                hoverBG: (0, $kbpa7.wacToken)("color.neutral.light0"),
                hoverText: (0, $kbpa7.wacToken)("color.extended.blue1000"),
                activeBG: (0, $kbpa7.wacToken)("color.extended.blue200"),
                activeText: (0, $kbpa7.wacToken)("color.extended.blue1000")
            },
            styles: {
                "--lp-tabs-hover": (0, $kbpa7.wacToken)("color.extended.blue200"),
                "--lp-tabs-unselected": (0, $kbpa7.wacToken)("color.neutral.light700")
            },
            tabs: gwp9473JSWAnchorUpdates ? [
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.textLabel",
                        defaultMessage: "Plan"
                    }),
                    id: "plan",
                    component: $d1221b05e912c95d$export$814cc77def5a44df()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.textLabel",
                        defaultMessage: "Track"
                    }),
                    id: "track",
                    component: $d1221b05e912c95d$export$13921ac0cc260818()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.textLabel",
                        defaultMessage: "Collaborate"
                    }),
                    id: "collaborate",
                    component: $d1221b05e912c95d$export$3141e70acdd1cdb7()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.textLabel",
                        defaultMessage: "Report"
                    }),
                    id: "report",
                    component: $d1221b05e912c95d$export$33aa3110c4070c17()
                }
            ] : [
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.textLabel",
                        defaultMessage: "Boards"
                    }),
                    id: "boards",
                    component: $d1221b05e912c95d$var$Boards()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.textLabel",
                        defaultMessage: "Timeline"
                    }),
                    id: "timeline",
                    component: $d1221b05e912c95d$var$Timeline()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.textLabel",
                        defaultMessage: "Reports"
                    }),
                    id: "reports",
                    component: $d1221b05e912c95d$var$Reports()
                },
                {
                    textLabel: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.textLabel",
                        defaultMessage: "Automation"
                    }),
                    id: "automation",
                    component: $d1221b05e912c95d$var$Automation()
                }
            ]
        },
        ctaProps: {
            headerText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.header",
                defaultMessage: "Move fast, stay aligned, and build better - together"
            }),
            ctaProps: {
                buttonProps: {
                    color: "yellow",
                    url: ctaButtonPropsHref,
                    text: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.ctaSection.button",
                        defaultMessage: "Get it free"
                    }),
                    dataEventProps: {
                        "data-event": "clicked",
                        "data-event-container": "ctaSection",
                        "data-event-component": "linkButton",
                        "data-product-key": "jiraSoftware-PaidLpJiraFeatures"
                    }
                }
            },
            backgroundProperties: {
                textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
            }
        },
        testimonialProps: {
            headerText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.heading",
                defaultMessage: "Trusted by over 100,000 customers world-wide"
            }),
            logos: [
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5382nib232306760cxko3fu33yr03hc6.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.squareAlt",
                        defaultMessage: "Square logo"
                    }),
                    loading: "lazy",
                    width: 162,
                    height: 40
                },
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8sh6x4kh58c7576am3gc70215abr77gu.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ebayAlt",
                        defaultMessage: "eBay logo"
                    }),
                    loading: "lazy",
                    width: 99,
                    height: 41
                },
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7l40fo7ky3ck1752eh0ti31556343388.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.spotifyAlt",
                        defaultMessage: "Spotify logo"
                    }),
                    loading: "lazy",
                    width: 163,
                    height: 49
                },
                {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/0atd5rxku6yg42wfhx0b1jdrsusm532i.svg",
                    alt: intl.formatMessage({
                        id: "JiraSoftwarePagePaidLpJswFeatures.socialProof.ciscoAlt",
                        defaultMessage: "Cisco logo"
                    }),
                    loading: "lazy",
                    width: 92,
                    height: 49
                }
            ]
        },
        alternatingTextAndImageProps: {
            backgroundImage: `linear-gradient(225deg, ${(0, $kbpa7.wacToken)("color.extended.blue200")} 0%, ${(0, $kbpa7.wacToken)("color.neutral.light0")} 100%)`,
            horizontalRuleColor: (0, $kbpa7.wacToken)("color.extended.blue200"),
            imageWidth: "100%",
            imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
            imageTextSideRowTwoPadding: "16px 0",
            imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px",
            //Row 1
            rowOneHeader: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneHeader",
                defaultMessage: "Customize how your team\u2019s work flows"
            }),
            rowOneBody: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneBody",
                defaultMessage: "Set up, clean up, and automate even the most complicated project workflows."
            }),
            rowOneImageLink: (0, $k16ze.getLocalizedImage)("row one", intl.locale),
            rowOneImageAltText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowOneImageAltText",
                defaultMessage: "Jira boards"
            }),
            //Row 2
            rowTwoHeader: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextHeader",
                defaultMessage: "Stay on track \u2013 even when the track changes"
            }),
            rowTwoBody: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.secondTextBody",
                defaultMessage: "Use the timeline view to map out the big picture, communicate updates to stakeholders, and ensure your team stays on the same page."
            }),
            rowTwoImageLink: (0, $k16ze.getLocalizedImage)("row two", intl.locale),
            rowTwoImageAltText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowTwoImageAltText",
                defaultMessage: "Jira timeline view."
            }),
            //Row 3
            rowThreeHeader: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeHeader",
                defaultMessage: "Bye-bye, spreadsheets"
            }),
            rowThreeBody: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeBody",
                defaultMessage: "Keep every detail of a project centralized in real time so up-to-date info can flow freely across people, teams, and tools."
            }),
            rowThreeImageLink: (0, $k16ze.getLocalizedImage)("row three", intl.locale),
            rowThreeImageAltText: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.alternatingTextAndImage.rowThreeImageAltText",
                defaultMessage: "Spreadsheets"
            })
        }
    };
    return loggedInHasJira ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
        experimentKey: "jfind-1504-after-d7-get-users-back-to-product",
        group: "Test",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
            experimentKey: "jfind-get-d1to6-users-back-to-product-for-paid",
            group: "variant",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
                experimentKey: "jfind-981-paid-jpto-logged-in-redesign",
                group: "Test",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3oD33.PaidLoggedInJiraProductTourOverview), {})
            })
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsProvider), {
        product: (0, $l7lLR.BANDITS_PRODUCT).JIRA,
        isExperimentEnabled: isgwpAJContextualBanditsJiraExperimentEnabled,
        useCase: (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY_JIRA_BPS,
        keyword: keyword,
        subAnchor: subAnchor || "",
        channel: utmMedium || "paid-search",
        utmContent: utmContent || "",
        utmCampaign: utmCampaign || "",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), (0, $6ogO3._)({}, props))
    });
};
/* Tabs */ const $d1221b05e912c95d$var$Boards = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.heading",
        defaultMessage: "Powerful agile boards"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Scrum boards:</strong> Scrum boards help agile teams break large, complex projects into manageable pieces of work so focused teams ship faster."
        }, "tabs.tab1.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Kanban boards:</strong> Agile and DevOps teams can use flexible kanban boards to visualize workflows, limit work-in-progress, and maximize efficiency as a team. Templates make it easy to get started quickly and customize as you go."
        }, "tabs.tab1.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Choose your own adventure:</strong> Jira is flexible enough to mold to your team\u2019s own unique way of working, whether it is Scrum, Kanban, or something in between."
        }, "tabs.tab1.item3")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)("boards", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab1.imageAlt",
        defaultMessage: "Jira boards"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$var$Timeline = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.heading",
        defaultMessage: "Timeline"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Keep teams aligned:</strong> Give your team the visibility they need to make fast and informed decisions while staying aligned with the bigger goals."
        }, "tabs.tab2.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Track the big picture:</strong> Plan and track how you\u2019re making progress on the big picture for a single team."
        }, "tabs.tab2.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Get ahead of dependencies:</strong> Visualize dependencies within your team to account for them when making plans."
        }, "tabs.tab2.item3"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.item4",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Plan with team capacity in mind (Premium only):</strong> Ensure your teams have bandwidth to complete the work they\u2019ve scoped. See multiple teams' capacity on a sprint-by-sprint basis."
        }, "tabs.tab2.item4")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)("timeline", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab2.imageAlt",
        defaultMessage: "Jira timeline"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$var$Reports = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.heading",
        defaultMessage: "Reports and insights"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Ready to go reporting:</strong> Out-of-the-box reports and dashboards in Jira offer critical insights within the context of your work to ensure your teams are always up to date and set up for success."
        }, "tabs.tab3.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Sprint reporting:</strong> Determine where your team is overcommitted to reduce excessive scope creep and better understand completed work in each sprint."
        }, "tabs.tab3.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Burndown chart:</strong> Track work towards sprint goals to manage progress and respond accordingly."
        }, "tabs.tab3.item3"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.item4",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Release Burndown:</strong> Track and monitor the projected release date for versions and take action if work is falling behind schedule."
        }, "tabs.tab3.item4")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)("reports", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab3.imageAlt",
        defaultMessage: "Jira reports"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$var$Automation = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.heading",
        defaultMessage: "Automation"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Drag and drop automation:</strong> Focus on the important things. Let automation do the rest. Powerful, yet simple - Jira automation is actually fun to use."
        }, "tabs.tab4.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Auto-assign issues:</strong> When an issue is raised without an assignee, auto-assign to whoever created it so nothing falls through the cracks."
        }, "tabs.tab4.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Sync work:</strong> When an epic is marked as 'done' move all of its stories to 'done' also."
        }, "tabs.tab4.item3"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item4",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Daily Slack summary:</strong> Send a daily Slack message with a list of issues still open in the Sprint."
        }, "tabs.tab4.item4"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.item5",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Auto-close old support issues:</strong> If a customer has not responded to an issue in 5 days, close the issue and leave a comment."
        }, "tabs.tab4.item5")
    ];
    const imageSrc = (0, $k16ze.getLocalizedImage)("automation", intl.locale);
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeatures.tabs.tab4.imageAlt",
        defaultMessage: "Jira automation"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$814cc77def5a44df = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.heading",
        defaultMessage: "Kick off with clarity"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Align work to goals:</strong> Connect work to company impact and collaborate with cross-functional partners."
        }, "tabs.gwp9473.tab1.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Break down projects:</strong> Go from big picture to automatically assigned tasks with Rovo AI."
        }, "tabs.gwp9473.tab1.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Get the context you need:</strong> Use Rovo to find relevant resources and rich data from across your apps."
        }, "tabs.gwp9473.tab1.item3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/y43424xo5d312uq63es504lre561n4hf.webp";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab1.imageAlt",
        defaultMessage: "Jira plan view"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$13921ac0cc260818 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.heading",
        defaultMessage: "Stay up to date"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Track your work, your way:</strong> See projects in a board, list, timeline, or calendar view."
        }, "tabs.gwp9473.tab2.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Manage risks and dependencies:</strong> Get status updates and any blockers from AI agents."
        }, "tabs.gwp9473.tab2.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Remove work around work:</strong> Use Rovo AI to automate tedious tasks."
        }, "tabs.gwp9473.tab2.item3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/33884gu02a10x77i0282w08okk31o4c3.webp";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab2.imageAlt",
        defaultMessage: "Jira track view"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$3141e70acdd1cdb7 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.heading",
        defaultMessage: "Bring teams together"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Automate workflows:</strong> Use Rovo AI and everyday language to build any workflow."
        }, "tabs.gwp9473.tab3.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Streamline requests:</strong> Get all the details you need and share your progress with forms."
        }, "tabs.gwp9473.tab3.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Keep everyone aligned:</strong> Provide real-time status updates and use Rovo to identify risks."
        }, "tabs.gwp9473.tab3.item3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/py7ek04olrn273137jbptehj24b21d5p.webp";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab3.imageAlt",
        defaultMessage: "Jira collaborate view"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};
const $d1221b05e912c95d$export$33aa3110c4070c17 = ()=>{
    const intl = (0, $8e22h.default)();
    const title = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.heading",
        defaultMessage: "Inform your decisions"
    });
    const listItems = [
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.item1",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Track progress against goals:</strong> Get visibility into how your team's work contributes to company goals and progress."
        }, "tabs.gwp9473.tab4.item1"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.item2",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>See performance insights:</strong> Understand your teams with cycle time reports, burn down charts, and capacity plans."
        }, "tabs.gwp9473.tab4.item2"),
        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.item3",
            values: (0, $kooLp.DEFAULT_VALUES),
            defaultMessage: "<strong>Iterate with AI:</strong> Use Rovo's insights to identify recurring themes and priorities."
        }, "tabs.gwp9473.tab4.item3")
    ];
    const imageSrc = "https://dam-cdn.atl.orangelogic.com/AssetLink/0d4wi87lq61r3551o21ij30mm5l03buq.webp";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.tabs.tab4.imageAlt",
        defaultMessage: "Jira report view"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
        title: title,
        listItems: listItems,
        imageSrc: imageSrc,
        imageAlt: imageAlt
    });
};

});
parcelRegister("k16ze", function(module, exports) {
$parcel$export(module.exports, "getLocalizedImage", function () { return $d7f99bd9e65d2fb0$export$df12673c228208c7; });
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$heroSectionImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/t1hdrv58771uc7a1caq48j2vup58nuxq.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/i138n0173hw3vplo38724k74w12fhljw.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/7x1v3q2bn02e0r18p1c3p220orkcaa53.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/a6exiwjuxdt5yt737r34jm8r0qwgx5a1.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/4krne7la727rr2uo447m5y6dcutb5468.webp"
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionAutomationImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/nhaj8o1l28kge001xo7746ov4nc72005.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/aw3e6hgl68r6v7mk0u4yw40xrk18kln0.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/j4dl52d0b2e8yn2s8tl0b34f2d0vwi1l.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/wf5834oq338l44v8yfrhf0s1q27g7kho.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/4ak0a2801n26ls3f2kr37x6s7di8g435.webp"
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionBoardsImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/vsxtbk6nixxgyw7s86d2422h33183666.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/8qyaj2s5n36ouwe8sw77d040776w2un2.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ei3ltwf7858ltw6l48670u8j6ews56bw.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/737g80fw6ml20lr326ccpphj50d7xex2.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/1y3cs512486c3a2t7u112yui0nl1l6a1.webp"
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionReportsImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/670r88uhf63s523y62bq4p6r27cwo21h.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hf8r6r78ma46c3tkah540710e506k0g.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/c341bo7s5q43xhtyeosj20utoa62j4gf.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/t7du15rcv88p3epa4n0r63n1733rb7oe.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/07cpm5tqamy4s567700fk6qyu1w1f3q8.webp"
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$tabsSectionTimelineImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/6i83t23511sqleh83338b6c3qdw3u5hy.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/78h0t1uh08qm08j78kyq1832060nsi2q.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/6nr6005kc5m6a0b5cu54862y667s561b.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/081fa55814t01f42l608c6v4rd4706yb.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/42f2e8u6c3g3fyq20k1lg6n6i08y3cr6.webp"
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$rowOneImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/vsxtbk6nixxgyw7s86d2422h33183666.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/8qyaj2s5n36ouwe8sw77d040776w2un2.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ei3ltwf7858ltw6l48670u8j6ews56bw.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/737g80fw6ml20lr326ccpphj50d7xex2.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/1y3cs512486c3a2t7u112yui0nl1l6a1.webp"
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$rowTwoImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/1y066woqlgoe2430346q7c2r3pry10tb.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/l3yqms82gf6nyi141b7868v547mtk755.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/74u3u60n631kp01p67wlg211ml0ue676.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/03ww8q35s1o815s41383u0eye53o18ib.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/1wo8sdr62p0we8736414nximtscv142r.webp"
};
// no localized image for es, ru
const $d7f99bd9e65d2fb0$var$rowThreeImageMap = {
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/7o3775x22n2c5yxfb7l5g0v3ye568v0s.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/5wp1j5x50y0ppby1t1r16qsy54231h15.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/46o4s1jbv7733e4qv2723p4n0m274g84.webp",
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/2oh1ay3ar5u0q28ey78w3e7iqsj5i5r1.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/0k071g3m4h17ng7s54bw0vm37qxf3g7f.webp"
};
const $d7f99bd9e65d2fb0$var$getCorrespondingImageMap = (descriptor)=>{
    switch(descriptor){
        case "automation":
            return $d7f99bd9e65d2fb0$var$tabsSectionAutomationImageMap;
        case "boards":
            return $d7f99bd9e65d2fb0$var$tabsSectionBoardsImageMap;
        case "hero":
            return $d7f99bd9e65d2fb0$var$heroSectionImageMap;
        case "reports":
            return $d7f99bd9e65d2fb0$var$tabsSectionReportsImageMap;
        case "timeline":
            return $d7f99bd9e65d2fb0$var$tabsSectionTimelineImageMap;
        case "row one":
            return $d7f99bd9e65d2fb0$var$rowOneImageMap;
        case "row two":
            return $d7f99bd9e65d2fb0$var$rowTwoImageMap;
        case "row three":
            return $d7f99bd9e65d2fb0$var$rowThreeImageMap;
        default:
            throw new Error(`Unknown descriptor: ${descriptor}`);
    }
};
const $d7f99bd9e65d2fb0$export$df12673c228208c7 = (descriptor, locale)=>{
    const map = $d7f99bd9e65d2fb0$var$getCorrespondingImageMap(descriptor);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return map[locale] || map["en"];
};

});

parcelRegister("I9wqw", function(module, exports) {
$parcel$export(module.exports, "PaidTeamSelectionHeroSection", function () { return $55c23fe1cad42cf8$export$dbb9d3849f125826; });
/* paid-hero-section-team-selection-variant.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $a9lfn = parcelRequire("a9lfn");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $28AH4 = parcelRequire("28AH4");

var $gCwEn = parcelRequire("gCwEn");
const $55c23fe1cad42cf8$var$iconWrapperStyle = null;
const $55c23fe1cad42cf8$var$buttonDefaultStyles = null;
const $55c23fe1cad42cf8$var$iconHoverStyles = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $55c23fe1cad42cf8$var$buttonStyles = {
    sm: "_1bsb16xz",
    md: "_1bsb1et3",
    lg: "_1bsb68cl",
    xl: "_1bsb68cl"
};
const $55c23fe1cad42cf8$var$selectedStyles = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $55c23fe1cad42cf8$var$iconWrapperStyleMap = {
    sm: "_4t3i10mc _1bsb10mc _ca0q19bv _u5f319bv _n3td19bv _19bv19bv",
    md: "_4t3iajfg _1bsbajfg _ca0q1skh _u5f31skh _n3td1skh _19bv1skh",
    lg: "_4t3ickbl _1bsbckbl _ca0q1skh _u5f31skh _n3td1skh _19bv1skh",
    xl: "_4t3i1wqb _1bsb1wqb _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8"
};
const $55c23fe1cad42cf8$var$Tab = ({ teamTypeId: teamTypeId, index: index, title: title, iconSrc: iconSrc, iconSrcSelected: iconSrcSelected, setSelectedTeamType: setSelectedTeamType })=>{
    const { isCurrentTab: isCurrentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const isSelected = isCurrentTab(index);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    // analytics for "team expansion box" experiment GWP-4223
    const handleTeamTabClick = (clickedTeamType)=>{
        setSelectedTeamType(clickedTeamType);
        if (clickedTeamType) createAnalyticsEvent({
            eventName: "clickTeamSelectorTab",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "teamSelectorTab",
            source: "teamExpansionSelector",
            attributes: {
                product: "wac",
                pageUrl: window.location.href,
                pagePath: window.location.pathname,
                teamType: clickedTeamType
            }
        }).fire();
    };
    let buttonSize;
    switch(index){
        case 0:
        case 6:
            buttonSize = "sm";
            break;
        case 1:
        case 5:
            buttonSize = "md";
            break;
        case 2:
        case 4:
            buttonSize = "lg";
            break;
        case 3:
            buttonSize = "xl";
            break;
        default:
            buttonSize = "sm";
    }
    const buttonSizingStyles = $55c23fe1cad42cf8$var$buttonStyles[buttonSize];
    const iconWrapperSizingStyles = $55c23fe1cad42cf8$var$iconWrapperStyleMap[buttonSize];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        onClick: (e)=>{
            e.preventDefault();
            handleTeamTabClick(teamTypeId);
        },
        className: (0, $2jatx.default)([
            "_11q7glyw _19itglyw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke _ect4bzd7 _k48p1nn1 _1e0c1txw _2lx21bp4 _4cvr1h6o",
            $55c23fe1cad42cf8$var$buttonStyles[buttonSize],
            "_z5z6jojz"
        ]),
        style: {
            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1wqb _4t3i1wqb _2rko14q1 _bfhk1kix _1e0c1txw _4cvr1h6o _1bah1h6o",
                    $55c23fe1cad42cf8$var$iconWrapperStyleMap[buttonSize],
                    isSelected && "_bfhk1ep1",
                    "icon-wrapper"
                ]),
                style: {
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: isSelected && iconSrcSelected ? iconSrcSelected : iconSrc,
                        alt: "",
                        width: 100
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: title
            })
        ]
    });
};
const $55c23fe1cad42cf8$export$dbb9d3849f125826 = ({ keyword: keyword })=>{
    const intl = (0, $8e22h.default)();
    const whiteBackgroundStyle = null;
    const containerStyle = null;
    const teamData = (0, $gCwEn.JSW_FEATURES_TEAM_DATA);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const [selectedTeamType, setSelectedTeamType] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        setAnchorLocalStorage({
            team: selectedTeamType
        });
    }, [
        setAnchorLocalStorage,
        selectedTeamType
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "hero-team-selection-variant",
        id: "start-trial",
        className: (0, $2jatx.default)([
            "_bfhkuzct"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q5153f4 _85i5ymf6"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4Tabs), {
                initialTab: 3,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                        children: teamData.map((team, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                tabIndex: index,
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($55c23fe1cad42cf8$var$Tab, {
                                    index: index,
                                    title: intl.formatMessage(team.title),
                                    iconSrc: team.icon,
                                    iconSrcSelected: team.iconSrcSelected,
                                    setSelectedTeamType: setSelectedTeamType,
                                    teamTypeId: team.teamTypeId
                                })
                            }, index))
                    }),
                    teamData.map((team, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                            panelIndex: index,
                            id: team.teamTypeId,
                            children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(team.tabComponent, {
                                keyword: keyword
                            })
                        }, index))
                ]
            })
        })
    });
};
$55c23fe1cad42cf8$export$dbb9d3849f125826.displayName = "PaidTeamSelectionHeroSection";

});
parcelRegister("gCwEn", function(module, exports) {
$parcel$export(module.exports, "JSW_FEATURES_TEAM_DATA", function () { return $ec246ec752747b53$export$cab6cf085c064769; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $9JSU2 = parcelRequire("9JSU2");

var $7RVa7 = parcelRequire("7RVa7");

var $8hXXn = parcelRequire("8hXXn");

var $4pIA3 = parcelRequire("4pIA3");

var $gRuVN = parcelRequire("gRuVN");

var $gYFKy = parcelRequire("gYFKy");

var $hYavq = parcelRequire("hYavq");
const $ec246ec752747b53$export$cab6cf085c064769 = [
    {
        teamTypeId: "Software Engineering",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/575h0o4d5531rcso8b6or7m5ljj5yf77.svg",
        title: (0, $fnHPc.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab1",
            defaultMessage: "Software"
        }),
        englishLabel: "Software",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hYavq.default), {})
    },
    {
        teamTypeId: "Operations",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/yl01ea2raydqsbpq411uu2jb4x1o5k16.svg",
        title: (0, $fnHPc.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab2",
            defaultMessage: "Operations"
        }),
        englishLabel: "Operations",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gRuVN.default), {})
    },
    {
        teamTypeId: "HR",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/c85anlqa4vbx8kgn1y41t10q44q0325l.svg",
        title: (0, $fnHPc.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab3",
            defaultMessage: "HR"
        }),
        englishLabel: "HR",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8hXXn.default), {})
    },
    {
        teamTypeId: undefined,
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/7300dt61p6o2c340nk53534647755fep.svg",
        iconSrcSelected: "https://dam-cdn.atl.orangelogic.com/AssetLink/72lkaojcq61b111eyg28t62gv1002f22.svg",
        title: (0, $fnHPc.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab4",
            defaultMessage: "All Teams"
        }),
        englishLabel: "All Teams",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9JSU2.default), {})
    },
    {
        teamTypeId: "Marketing",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/6648s271ra1efk47v7r40xslp7630o4w.svg",
        title: (0, $fnHPc.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab5",
            defaultMessage: "Marketing"
        }),
        englishLabel: "Marketing",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4pIA3.default), {})
    },
    {
        teamTypeId: "Design",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/x82hxxkp01k3f20y83q86a0r0bvm55p4.svg",
        title: (0, $fnHPc.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab6",
            defaultMessage: "Design"
        }),
        englishLabel: "Design",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7RVa7.default), {})
    },
    {
        teamTypeId: "Sales",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/6101e5o3r21du53012037egepyolhibt.svg",
        title: (0, $fnHPc.defineMessage)({
            id: "PaidLandingPage.teamSelectionHero.label.tab7",
            defaultMessage: "Sales"
        }),
        englishLabel: "Sales",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gYFKy.default), {})
    }
];

});
parcelRegister("9JSU2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f47a62d22e6c98d$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");

var $iN2W6 = parcelRequire("iN2W6");
const $9f47a62d22e6c98d$var$AllTeamsTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9473JSWAnchorUpdates);
    const allTeamsHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.header",
            defaultMessage: "Connect every team, task, and project together with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/t501oo65h16scx35qe60q32dj6a4782t.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.default.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        },
        showAnimatedHero: true
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.header",
            defaultMessage: "Where your teams and AI come together"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wdmncs35471g5521yr5462w3ku0t834b.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.default.heroImageAlt",
                defaultMessage: "Screen capture of a Jira list view"
            })
        },
        showAnimatedHero: false
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), (0, $dPABA._)((0, $6ogO3._)({}, gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : allTeamsHeroProps), {
        isAllTeamsTab: true
    }));
};
var $9f47a62d22e6c98d$export$2e2bcd8739ae039 = $9f47a62d22e6c98d$var$AllTeamsTabContent;

});
parcelRegister("iN2W6", function(module, exports) {
$parcel$export(module.exports, "PaidHeroTabPanelTemplate", function () { return $6500b1ce48d546a6$export$b11df6f0d1a6642c; });
/* hero-tab-panel-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kc6xi = parcelRequire("kc6xi");

var $7kIQK = parcelRequire("7kIQK");

var $iuew3 = parcelRequire("iuew3");
var $bGrkd = parcelRequire("bGrkd");
var $bs458 = parcelRequire("bs458");

var $doAVE = parcelRequire("doAVE");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $1Q6XY = parcelRequire("1Q6XY");

var $2opLs = parcelRequire("2opLs");

var $3LcIp = parcelRequire("3LcIp");

var $ea4mV = parcelRequire("ea4mV");

var $2gCne = parcelRequire("2gCne");
const $6500b1ce48d546a6$var$contentStyle = null;
const $6500b1ce48d546a6$var$formColumn = null;
const $6500b1ce48d546a6$var$signupFormContainer = null;
const $6500b1ce48d546a6$var$headerStyle = null;
const $6500b1ce48d546a6$var$imgContainer = null;
const $6500b1ce48d546a6$var$carouselContainerStyles = null;
const $6500b1ce48d546a6$var$subHeaderStyles = null;
const $6500b1ce48d546a6$var$animationHeroContainer = null;
const $6500b1ce48d546a6$var$staticImageContainer = null;
const $6500b1ce48d546a6$export$b11df6f0d1a6642c = ({ header: header, subHeader: subHeader, image: image, showAnimatedHero: showAnimatedHero = false, carouselHeroProps: carouselHeroProps, isAllTeamsTab: isAllTeamsTab = false })=>{
    (0, $1oC0p.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $2gCne.getLocalStorage)((0, $1Q6XY.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $1Q6XY.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    const { user: { isUserLoggedIn: isUserLoggedIn } } = (0, $doAVE.useUserContext)();
    const contactExpandExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).jiraContactAndCompanyExpandSiteActivation);
    const useContactExpandCohortLogic = contactExpandExperiment.type === "enrolled" && contactExpandExperiment.value;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-testid": "hero-tab-panel",
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx2vrvc _zulpzwfg _4cvr1h6o _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _na0i1bp4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _10jxdgin _gltexe31 _1945stmo _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_ect41pz4 _1wyb1wto _vwz41k7u _k48pbfng _1pfh12am _6rth1tcg _gu181h6o"
                                ]),
                                style: {
                                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                                    product: "jira",
                                    type: "header",
                                    children: header
                                })
                            })
                        }),
                        subHeader && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_6rth7vkz _y3gn1h6o _uj6k1e5h"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                                product: "jira",
                                type: "subheader",
                                children: subHeader
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            "data-testid": "signup-form",
                            className: (0, $2jatx.default)([
                                "_p12f1feq _1bsb1osq"
                            ]),
                            children: isUserLoggedIn ? useContactExpandCohortLogic ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuew3.default), {
                                CurrentProductUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bs458.ReturnToProduct), {}),
                                CurrentProductJoinableUser: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bGrkd.JoinableSites), {}),
                                useContactExpandCohortLogic: true
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuew3.default), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2opLs.PaidAccountCreation), {
                                pageId: "paid-lp-jsw-features"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $3LcIp.BanditsAssetWrapper), {
                    product: "jira",
                    showChildren: !isAllTeamsTab,
                    children: [
                        showAnimatedHero && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_p12fstmo _glte1kpv _1mjb1txw _o5kc1h6o _na0i1bp4"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1h1th1c8 _4t3i1wug _1tket94y _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _1y8o1osq _1mjbglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kIQK.AnimatedJiraTour), {})
                            })
                        }),
                        carouselHeroProps ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kc6xi.Carousel), (0, $6ogO3._)({}, carouselHeroProps))
                        }) : null,
                        image && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                showAnimatedHero ? "_1e0cglyw _1mjb1txw _o5kc1h6o _na0i1bp4" : "_p12fstmo _glte1kpv _1mjb1txw _o5kc1h6o _na0i1bp4"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: image,
                                style: {
                                    maxWidth: "100%"
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$6500b1ce48d546a6$export$b11df6f0d1a6642c.displayName = "PaidHeroTemplate";

});


parcelRegister("7RVa7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bd21a0ad00f4afb2$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");

var $iN2W6 = parcelRequire("iN2W6");
const $bd21a0ad00f4afb2$var$DesignTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9473JSWAnchorUpdates);
    const designHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.design.header",
            defaultMessage: "Unleash innovative design work with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/stwkq56nns422b0684fodlf0074s3b6e.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.design.heroImageAlt",
                defaultMessage: "Screen capture of a Jira design ticket"
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.design.header",
            defaultMessage: "Design with all the right context"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2s7dw8mxw65kwtjh2npm8x55200kcnu3.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.design.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board view"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), (0, $6ogO3._)({}, gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : designHeroProps));
};
var $bd21a0ad00f4afb2$export$2e2bcd8739ae039 = $bd21a0ad00f4afb2$var$DesignTabContent;

});

parcelRegister("8hXXn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2fde524a0049ee3$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $iN2W6 = parcelRequire("iN2W6");
const $f2fde524a0049ee3$var$HRTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const hrHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.hr.header",
            defaultMessage: "Build teamwork and productivity across your organization with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/o3vf21711xl7j3k661enul0050252c02.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.hr.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), (0, $6ogO3._)({}, hrHeroProps));
};
var $f2fde524a0049ee3$export$2e2bcd8739ae039 = $f2fde524a0049ee3$var$HRTabContent;

});

parcelRegister("4pIA3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $500f5c9b451db8a6$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");

var $iN2W6 = parcelRequire("iN2W6");
const $500f5c9b451db8a6$var$MarketingTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9473JSWAnchorUpdates);
    const marketingHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.marketing.header",
            defaultMessage: "Unleash the power of marketing teams with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/62xi2h6p73mrb7t2ib163ss3qeh22c5f.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.marketing.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board tracking a marketing launch"
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.marketing.header",
            defaultMessage: "Go from big idea to an even bigger launch"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ox58yay38c0ps0rm5xeg0e2765128to3.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.marketing.heroImageAlt",
                defaultMessage: "Screen capture of a Jira list view"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), (0, $6ogO3._)({}, gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : marketingHeroProps));
};
var $500f5c9b451db8a6$export$2e2bcd8739ae039 = $500f5c9b451db8a6$var$MarketingTabContent;

});

parcelRegister("gRuVN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b5fbde38ddff7678$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");

var $iN2W6 = parcelRequire("iN2W6");
const $b5fbde38ddff7678$var$OperationsTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9473JSWAnchorUpdates);
    const operationsHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.operations.header",
            defaultMessage: "Operations processes made easy with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w4g3m6wrfl232cm6kx12p83t1sg1odlm.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.operations.header",
            defaultMessage: "Conquer complex workflows"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8mbx11md7br33n86667to5e4q87x8dfl.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board view"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), (0, $6ogO3._)({}, gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : operationsHeroProps));
};
var $b5fbde38ddff7678$export$2e2bcd8739ae039 = $b5fbde38ddff7678$var$OperationsTabContent;

});

parcelRegister("gYFKy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c34b5c3337693845$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $iN2W6 = parcelRequire("iN2W6");
const $c34b5c3337693845$var$SalesTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const salesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.sales.header",
            defaultMessage: "Hit sales team targets with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/87h6hy3p184v1kyn202mov58b5y6q82d.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.sales.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board for a product launch"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), (0, $6ogO3._)({}, salesHeroProps));
};
var $c34b5c3337693845$export$2e2bcd8739ae039 = $c34b5c3337693845$var$SalesTabContent;

});

parcelRegister("hYavq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b0af393b30f2063$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $32ng3 = parcelRequire("32ng3");

var $iN2W6 = parcelRequire("iN2W6");
const $4b0af393b30f2063$var$SoftwareTabContent = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp9473JSWAnchorUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9473JSWAnchorUpdates);
    const softwareHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.software.header",
            defaultMessage: "Jira is the #1 software development tool used by agile teams"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/fya3j34w81idu648i580m4mutc60guo0.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.software.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board"
            })
        }
    };
    const gwp9473JSWAnchorUpdatesHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.software.header",
            defaultMessage: "Focus on outcomes, not admin"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3m35263c8gy137p68p2v33ijxb0703p5.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.software.heroImageAlt",
                defaultMessage: "Screenshot of Jira list view"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iN2W6.PaidHeroTabPanelTemplate), (0, $6ogO3._)({}, gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : softwareHeroProps));
};
var $4b0af393b30f2063$export$2e2bcd8739ae039 = $4b0af393b30f2063$var$SoftwareTabContent;

});







parcelRegister("3jSW5", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAgile", function () { return $1069cb10173098de$export$914726d7f0b742d9; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $1069cb10173098de$export$914726d7f0b742d9 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-agile",
        persona: "unknown",
        pageVariant: "agile"
    }));
};

});

parcelRegister("2LlD0", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswAutomation", function () { return $3ca8e0bedf5416b4$export$ed27212f6342eeed; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $3ca8e0bedf5416b4$export$ed27212f6342eeed = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-automation",
        persona: "unknown",
        pageVariant: "automation"
    }));
};

});

parcelRegister("faUzl", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswCompetitors", function () { return $09acfa39dba39643$export$68f655f873e2ac04; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $09acfa39dba39643$export$68f655f873e2ac04 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-competitors",
        persona: "unknown",
        pageVariant: "competitors"
    }));
};

});

parcelRegister("eNeuM", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswPm", function () { return $736d9d54c77de04a$export$3940e8f9b3d490c4; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $736d9d54c77de04a$export$3940e8f9b3d490c4 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-pm",
        persona: "unknown",
        pageVariant: "pm"
    }));
};

});

parcelRegister("lTIGz", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswProjCollab", function () { return $2774693f9dbda9e5$export$f9651956eec158e0; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $2774693f9dbda9e5$export$f9651956eec158e0 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-project_collaboration",
        persona: "unknown",
        pageVariant: "project_collaboration"
    }));
};

});

parcelRegister("eIZwM", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswRoadmaps", function () { return $0eb5ea83f1f296e3$export$3507bd3b8f9604d1; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $0eb5ea83f1f296e3$export$3507bd3b8f9604d1 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-roadmaps",
        persona: "unknown",
        pageVariant: "roadmaps"
    }));
};

});

parcelRegister("bcBwv", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTeamwork", function () { return $86c08eafed9bc805$export$3577f38e8e4e34f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $86c08eafed9bc805$export$3577f38e8e4e34f = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-teamwork",
        persona: "unknown",
        pageVariant: "teamwork"
    }));
};

});

parcelRegister("gfnSo", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTemplate", function () { return $a648ed5db03ba6a2$export$4206a0db856d7544; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $a648ed5db03ba6a2$export$4206a0db856d7544 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-template",
        persona: "unknown",
        pageVariant: "template"
    }));
};

});

parcelRegister("lFb3d", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJswTracker", function () { return $baf81d2127141d55$export$5d7d37f42bf228bb; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $17vRh = parcelRequire("17vRh");
const $baf81d2127141d55$export$5d7d37f42bf228bb = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $17vRh.JiraSoftwarePagePaidLpJswAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsw-tracker",
        persona: "unknown",
        pageVariant: "tracker"
    }));
};

});

parcelRegister("02cSL", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareFreePage", function () { return $a6d720ca803f2dba$export$a1727845ccb60c5c; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1hDfS");
var $2ymPl = parcelRequire("2ymPl");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $kooLp = parcelRequire("kooLp");

var $ea4mV = parcelRequire("ea4mV");

var $1ka2O = parcelRequire("1ka2O");
const $a6d720ca803f2dba$export$a1727845ccb60c5c = ()=>{
    const isLoggedIn = (0, $doAVE.useLoggedIn)();
    const jiraPlusExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).twcg1444JiraPlusOptIn);
    const jiraPlusExperimentPaid = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).twcg1444JiraPlusOptInPaid);
    const signupPath = (0, $kooLp.useLocalizedHref)("/try/cloud/signup");
    const location = (0, $1ka2O.useLocation)();
    const isPaidExperience = (0, $7VwhR.hasJiraPlusPaidParam)(location);
    const experiment = isPaidExperience ? jiraPlusExperimentPaid : jiraPlusExperiment;
    if (isLoggedIn && experiment.type === (0, $ea4mV.EnrollmentType).ENROLLED) {
        experiment.fireExposure();
        if (experiment.value) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ymPl.JiraPlus), {});
    }
    // ATLAS-55799 - JSW Find Team
    const queryParameters = new URLSearchParams(location.search);
    var _queryParameters_get;
    const templateId = (_queryParameters_get = queryParameters.get("templateId")) !== null && _queryParameters_get !== void 0 ? _queryParameters_get : "";
    var _queryParameters_get1;
    const jiraProductTourSignupType = (_queryParameters_get1 = queryParameters.get("jiraProductTourSignupType")) !== null && _queryParameters_get1 !== void 0 ? _queryParameters_get1 : "";
    const signupParameters = new URLSearchParams({
        bundle: "jira-software",
        edition: "free",
        skipBundles: "true"
    });
    if (templateId) signupParameters.append("templateId", templateId);
    if (jiraProductTourSignupType) signupParameters.append("jiraProductTourSignupType", jiraProductTourSignupType);
    if (typeof window !== "undefined") window.location.assign(`${signupPath}?${signupParameters}`);
    return null;
};

});
parcelRegister("1hDfS", function(module, exports) {
$parcel$export(module.exports, "JiraPlus", function () { return (parcelRequire("2ymPl")).JiraPlus; });
parcelRequire("2ymPl");

});
parcelRegister("2ymPl", function(module, exports) {
$parcel$export(module.exports, "JiraPlus", function () { return $73cea66d8ab3b938$export$cd61a514420a0945; });
/* jira-plus.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $46Ma8 = parcelRequire("46Ma8");

var $55Jan = parcelRequire("55Jan");

var $9Cyyz = parcelRequire("9Cyyz");

var $a9Umc = parcelRequire("a9Umc");

var $63bv7 = parcelRequire("63bv7");

var $kvjl7 = parcelRequire("kvjl7");

var $k9ZIM = parcelRequire("k9ZIM");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $1ka2O = parcelRequire("1ka2O");

var $k18Zl = parcelRequire("k18Zl");
const $73cea66d8ab3b938$export$cd61a514420a0945 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return; // be sure analyticsClient is available before firing event
        createAnalyticsEvent({
            action: "viewed",
            actionSubject: "component",
            actionSubjectId: "jiraPlusModal",
            attributes: {
                source: "jiraPlusModal"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const location = (0, $1ka2O.useLocation)();
    const searchParams = new URLSearchParams(location.search);
    const editionIntent = searchParams.get("editionIntent");
    const jiraSignupHref = (0, $kooLp.useLocalizedHref)(`/try/cloud/signup${editionIntent ? `?editionIntent=${editionIntent}` : ""}`);
    const twcSignupHref = (0, $kooLp.useLocalizedHref)(`/try/cloud/signup?bundle=teamwork-collection&edition=premium&touchpoint=jira-plus`);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvjl7.JiraBackground), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k18Zl.Modal), {
            version: (0, $k18Zl.LayoutVersion).V3,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                className: (0, $2jatx.default)([
                    "_ect4b1j9 _181n1txw _b8yqiafe _15y11ccs _14b51osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("article", {
                        className: (0, $2jatx.default)([
                            "_4cvrv2br _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _ca0qviql _u5f3viql _n3tdviql _19bvviql",
                            "_bfhku67f _syaz1kw7 _15vtoqnp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _1e0c1txw _zulp1j6v _6rth1j6v"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraLogo), {
                                    size: "medium",
                                    appearance: "brand",
                                    shouldUseNewLogoDesign: true
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_vwz41j7w"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.jiraHeading",
                                    defaultMessage: "Get started with Jira only"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.jiraDescription",
                                    defaultMessage: "Get AI-powered project management for all teams."
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                                className: (0, $2jatx.default)([
                                    "_2mzuglyw _6rth1k8s _1pfhidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k",
                                            "_1nj1doyu"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a9Umc))), {
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "jiraPlus.planAndTrack",
                                                defaultMessage: "Plan and track your work"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k",
                                            "_1nj1doyu"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($55Jan))), {
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "jiraPlus.aiPoweredProjectsAndInsights",
                                                defaultMessage: "Get AI-powered projects and insights"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k",
                                            "_1nj1doyu"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Cyyz))), {
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "jiraPlus.automateTasks",
                                                defaultMessage: "Automate tasks to keep work moving smoothly"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                href: jiraSignupHref,
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for analytics event to fire before navigating
                                    createAnalyticsEvent({
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "getJiraOnly",
                                        attributes: {
                                            source: "jiraPlusModal"
                                        }
                                    }).fire();
                                    window.location.assign(jiraSignupHref);
                                },
                                className: (0, $2jatx.default)([
                                    "_ect41kw7 _1wyboxwj _k48pbfng _1pfh1wug _p12f1wug _1rjc1kwk _1bsb1osq",
                                    "_bfhk1j28 _19it1jxq _syaz1kw7 _irr31fkg"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.jiraButtonText",
                                    defaultMessage: "Get Jira only"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _1jb36tgj _kxohy1ik _181n1ule _14b58pqr"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("article", {
                        className: (0, $2jatx.default)([
                            "_4cvrv2br _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _ca0qviql _u5f3viql _n3tdviql _19bvviql",
                            "_bfhk6tgj _syazu67f _1wfqoqnp"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_4cvr1h6o _1e0c1txw _zulp1j6v _6rth1j6v",
                                    "_h47hu67f"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraLogo), {
                                        size: "medium",
                                        appearance: "brand",
                                        shouldUseNewLogoDesign: true
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ma8))), {
                                        label: ""
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1kwk"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.LoomIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.RovoIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_vwz41j7w"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcHeading",
                                    defaultMessage: "Or work <em>3x faster</em> with teamwork apps",
                                    values: {
                                        em: $73cea66d8ab3b938$var$headingEmphasis
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcDescription",
                                    defaultMessage: "Boost productivity by adding apps that supercharge teamwork."
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_k48pbfng _6rthidpf _1pfh1k8s"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcListIntro",
                                    defaultMessage: "Get everything from Jira, plus:"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                                className: (0, $2jatx.default)([
                                    "_2mzuglyw _6rth1k8s _1pfhidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.ConfluenceIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true,
                                                size: "xxsmall"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "jiraPlus.bundleJiraWithConfluence",
                                                    defaultMessage: "Bundle Jira with <em>Confluence</em>, so all your work stays in one place",
                                                    values: {
                                                        em: $73cea66d8ab3b938$var$listEmphasis
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.LoomIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true,
                                                size: "xxsmall"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "jiraPlus.saveTimeWithLoom",
                                                    defaultMessage: "Save time with <em>Loom\u2019s</em> AI-generated meeting notes",
                                                    values: {
                                                        em: $73cea66d8ab3b938$var$listEmphasis
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        className: (0, $2jatx.default)([
                                            "_4cvrv2br _1e0c1txw _zulpoqnp _1pfh1k8s _ny56133k"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.RovoIcon), {
                                                appearance: "brand",
                                                shouldUseNewLogoDesign: true,
                                                size: "xxsmall"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                    id: "jiraPlus.createAndSearchWithRovo",
                                                    defaultMessage: "Easily create and search for knowledge with <em>Rovo</em>",
                                                    values: {
                                                        em: $73cea66d8ab3b938$var$listEmphasis
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                href: twcSignupHref,
                                onClick: (e)=>{
                                    e.preventDefault(); // wait for analytics event to fire before navigating
                                    createAnalyticsEvent({
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: "getTwc",
                                        attributes: {
                                            source: "jiraPlusModal"
                                        }
                                    }).fire();
                                    window.location.assign(twcSignupHref);
                                },
                                className: (0, $2jatx.default)([
                                    "_ect41kw7 _1wyboxwj _k48pbfng _1pfh1wug _p12f1wug _1rjc1kwk _1bsb1osq",
                                    "_irr31q0g"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "jiraPlus.twcButtonText",
                                    defaultMessage: "Try them for free"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $73cea66d8ab3b938$var$headingEmphasis = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _o5721q9c _1pbyidpf _1kt9b3bt _1cs8stnw _1rus1yy8 _1rhx1o5r _144l133k _1mp41pfy _kfgtkh0n _7dwzxjsu _1g0v1mrw"
        ]),
        children: children
    });
const $73cea66d8ab3b938$var$listEmphasis = (children)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_k48p1fw0"
        ]),
        children: children
    });
const $73cea66d8ab3b938$var$COLORS = {
    // eslint-disable-next-line local/ensure-wac-token-usage
    B700: "#1868DB",
    // eslint-disable-next-line local/ensure-wac-token-usage
    B800: "#1558BC",
    // eslint-disable-next-line local/ensure-wac-token-usage
    B900: "#123263",
    // eslint-disable-next-line local/ensure-wac-token-usage
    N300: "#DDDEE1",
    // eslint-disable-next-line local/ensure-wac-token-usage
    N300A: "#0B120E24",
    // eslint-disable-next-line local/ensure-wac-token-usage
    P500: "#BF63F3"
};
const $73cea66d8ab3b938$var$buttonCss = null;
const $73cea66d8ab3b938$var$choiceCss = null;
const $73cea66d8ab3b938$var$descriptionCss = null;
const $73cea66d8ab3b938$var$headingCss = null;
const $73cea66d8ab3b938$var$headingEmphasisCss = null;
const $73cea66d8ab3b938$var$iconsCss = null;
const $73cea66d8ab3b938$var$jiraButtonCss = null;
const $73cea66d8ab3b938$var$jiraChoiceCss = null;
const $73cea66d8ab3b938$var$listEmphasisCss = null;
const $73cea66d8ab3b938$var$jiraListItemCss = null;
const $73cea66d8ab3b938$var$listCss = null;
const $73cea66d8ab3b938$var$listIntroCss = null;
const $73cea66d8ab3b938$var$listItemCss = null;
const $73cea66d8ab3b938$var$logosCss = null;
const $73cea66d8ab3b938$var$modalContentCss = null;
const $73cea66d8ab3b938$var$separatorCss = null;
const $73cea66d8ab3b938$var$twcButtonCss = null;
const $73cea66d8ab3b938$var$twcChoiceCss = null;
const $73cea66d8ab3b938$var$twcLogosCss = null;

});
parcelRegister("46Ma8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fdd15086956a812$var$_react = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2fdd15086956a812$var$_baseNew = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2fdd15086956a812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fdd15086956a812$var$AddIcon = (props)=>/*#__PURE__*/ $2fdd15086956a812$var$_react.default.createElement($2fdd15086956a812$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$2fdd15086956a812$var$AddIcon.displayName = 'AddIcon';
var $2fdd15086956a812$var$_default = module.exports.default = $2fdd15086956a812$var$AddIcon;

});

parcelRegister("55Jan", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b5074773e8f1916$var$_react = $3b5074773e8f1916$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3b5074773e8f1916$var$_baseNew = $3b5074773e8f1916$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $3b5074773e8f1916$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b5074773e8f1916$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $3b5074773e8f1916$var$_react.default.createElement($3b5074773e8f1916$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$3b5074773e8f1916$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $3b5074773e8f1916$var$_default = module.exports.default = $3b5074773e8f1916$var$AtlassianIntelligenceIcon;

});

parcelRegister("9Cyyz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $701277dc6e7898a3$var$_react = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $701277dc6e7898a3$var$_baseNew = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $701277dc6e7898a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $701277dc6e7898a3$var$AutomationIcon = (props)=>/*#__PURE__*/ $701277dc6e7898a3$var$_react.default.createElement($701277dc6e7898a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$701277dc6e7898a3$var$AutomationIcon.displayName = 'AutomationIcon';
var $701277dc6e7898a3$var$_default = module.exports.default = $701277dc6e7898a3$var$AutomationIcon;

});




parcelRegister("koI83", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $31a5684656309797$export$933c1404a4ee79b; });
const $31a5684656309797$export$933c1404a4ee79b = ()=>{
    return "Jira Pricing Page";
};

});

parcelRegister("Q2S5p", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPage", function () { return $3f3699cf5f70cbd9$export$743fd6231b24dcf9; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $3L8ZR = parcelRequire("3L8ZR");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("l8kCZ");
var $bTseT = parcelRequire("bTseT");
parcelRequire("f0U7g");
var $5yFib = parcelRequire("5yFib");

var $ea4mV = parcelRequire("ea4mV");
const $3f3699cf5f70cbd9$export$743fd6231b24dcf9 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate("gwp-737-enable-intercom-chat-jsw");
    const [hasFired, fireExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).jiraPricingWaeMigrationExperimentRerunExp);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProvider), {
            productId: "jira-software",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5yFib.JiraSoftwarePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("f0U7g", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return (parcelRequire("5yFib")).JiraSoftwarePricingPageV2Template; });
parcelRequire("5yFib");

});
parcelRegister("5yFib", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return $cdf4d25a3c43b2b5$export$413c805c73a21678; });

var $7VQPk = parcelRequire("7VQPk");

var $in5fb = parcelRequire("in5fb");

var $kIC93 = parcelRequire("kIC93");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");
parcelRequire("g1ccm");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $2zOxm = parcelRequire("2zOxm");

var $bE8d4 = parcelRequire("bE8d4");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $5S2vX = parcelRequire("5S2vX");

var $8IN8s = parcelRequire("8IN8s");

var $b7CnU = parcelRequire("b7CnU");
const $cdf4d25a3c43b2b5$export$413c805c73a21678 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)("Contact Us", "Learn more");
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[1];
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jira-software-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CnU.JiraPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "jiraSoftware",
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in5fb.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                    product: "jira"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: "Jira",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("b7CnU", function(module, exports) {
$parcel$export(module.exports, "JiraPriceFinder", function () { return $be32cafd3b047742$export$1bf486cdabb14f4d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $be32cafd3b047742$export$1bf486cdabb14f4d = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _content_enterprise, _content_enterprise1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    const signupLimit = 100000;
    const addSignupSourceToUrlsOnPricingPageEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage);
    const signupUrlSourceQueryParam = addSignupSourceToUrlsOnPricingPageEnabled ? "&signupSource=pricing" : "";
    var _content_free_planTitleExternal, _content_free_planOneLiner, _content_standard_planTitleExternal, _content_standard_planOneLiner, _content_premium_planTitleExternal, _content_premium_planOneLiner, _content_enterprise_planTitleExternal, _content_enterprise_planOneLiner;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: (_content_free_planTitleExternal = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) !== null && _content_free_planTitleExternal !== void 0 ? _content_free_planTitleExternal : "Free",
            offeringSku: "jira-software-free",
            description: (_content_free_planOneLiner = (_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: `?bundle=jira-software&edition=free&editionIntent=free${signupUrlSourceQueryParam}`,
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: (_content_standard_planTitleExternal = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) !== null && _content_standard_planTitleExternal !== void 0 ? _content_standard_planTitleExternal : "Standard",
            offeringSku: "jira-software-standard",
            description: (_content_standard_planOneLiner = (_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: `?bundle=jira-software&edition=standard${signupUrlSourceQueryParam}`,
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: (_content_premium_planTitleExternal = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) !== null && _content_premium_planTitleExternal !== void 0 ? _content_premium_planTitleExternal : "Premium",
            offeringSku: "jira-software-premium",
            description: (_content_premium_planOneLiner = (_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: `?bundle=jira-software&edition=premium${signupUrlSourceQueryParam}`,
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: (_content_enterprise_planTitleExternal = (_content_enterprise = content.enterprise) === null || _content_enterprise === void 0 ? void 0 : _content_enterprise.planTitleExternal) !== null && _content_enterprise_planTitleExternal !== void 0 ? _content_enterprise_planTitleExternal : "Enterprise",
            offeringSku: "jira-software-enterprise-sku",
            recommendationLimit: 5000,
            description: (_content_enterprise_planOneLiner = (_content_enterprise1 = content.enterprise) === null || _content_enterprise1 === void 0 ? void 0 : _content_enterprise1.planOneLiner) !== null && _content_enterprise_planOneLiner !== void 0 ? _content_enterprise_planOneLiner : "",
            signupLimit: signupLimit,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "JiraSoftwarePricingPageV2.priceFinder.header",
            defaultMessage: "<blue>Simple, transparent pricing</blue> for every team."
        },
        unitCountInputText: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "JiraSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Jira Software user is any user who can log in to Jira Software, and who exists in User Management"
        },
        cardOverSignupLimit: {
            id: "JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "JiraSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$be32cafd3b047742$export$1bf486cdabb14f4d.displayName = "JiraPriceFinder";

});




parcelRegister("2S6eY", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPage", function () { return $bd56f592d97598be$export$d8efa57f95a0eae9; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");
parcelRequire("l8kCZ");
var $bTseT = parcelRequire("bTseT");

var $32ng3 = parcelRequire("32ng3");

var $9xKEy = parcelRequire("9xKEy");
parcelRequire("hKTyA");
var $gZJ17 = parcelRequire("gZJ17");
const $bd56f592d97598be$export$d8efa57f95a0eae9 = ()=>{
    const intl = (0, $8e22h.default)();
    const isBootIntercom = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp1304AddIntercomToJpdProductTour);
    (0, $1oC0p.useEffect)(()=>{
        (0, $3L8ZR.default).getLayer("wac-edge-track-routing-layer").get("track", "main");
    }, []);
    const intercomAppId = intl.locale === "ja" ? "p0ww63i2" : "";
    const isSalesWidgetBxpWebPlatform = intercomAppId !== "" && (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).salesWidgetBxpWebPlatform);
    const isSalesWidgetBxpWebPlatformDeveloper = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).salesWidgetBxpWebPlatformDeveloper);
    if (isSalesWidgetBxpWebPlatformDeveloper) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZJ17.JiraProductDiscoveryTemplate), {})
        })
    });
    else if (isSalesWidgetBxpWebPlatform) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZJ17.JiraProductDiscoveryTemplate), {})
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
            screenName: "wacJpdProductTourPage",
            productKeys: [
                (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY
            ],
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gZJ17.JiraProductDiscoveryTemplate), {})
        })
    });
};

});
parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $9dCmO = parcelRequire("9dCmO");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("lNX8N")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("asSV5")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, "");
        if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, "");
    } catch (e) {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match === null || match === void 0 ? void 0 : match[1]) {
            let pathname = match[1].replace(/\/+$/, "");
            if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, "");
        }
        return "";
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    "software/jira/product-discovery": {
        contactFlowId: "4cdb6e29-9088-4404-bbfe-dfdba35bd3d6",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/jira": {
        contactFlowId: "7e776619-ede4-4975-a194-38c6b182fa0c",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom": {
        contactFlowId: "42cee94e-c0db-43d2-bd45-3cca9d7adb61",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-confluence": {
        contactFlowId: "9f1756b6-8607-43b4-97b6-32f888713bf0",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-jira": {
        contactFlowId: "863e7f31-092a-45c6-affa-02db50c7ef72",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/resources": {
        contactFlowId: "4b5e7c93-5e16-4479-8030-fcad737249a3",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/ai-meeting": {
        contactFlowId: "f1956561-00b8-4ee0-a6c2-2100d07feb5f",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/editing": {
        contactFlowId: "bc21d930-ac0d-4eec-9158-d2dde2097029",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/company/contact/japan": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/pricing": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence/pricing": {
        contactFlowId: "af93bfc1-9e6f-481b-bc07-834e30832ba6",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management/pricing": {
        contactFlowId: "c5be7db2-a892-4f58-a4ab-c79a04c59159",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    var _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath;
    return (_CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath]) !== null && _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath !== void 0 ? _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath : {
        contactFlowId: ""
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ""
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === "object" && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return "{}";
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    return normalizedPath === "ja" || normalizedPath.startsWith("ja/");
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join("_");
    } catch (error) {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
            return pathParts.join("_");
        }
        return "";
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === "attachments") return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === "object" && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse === null || chatConnectionConfigResponse === void 0 ? void 0 : chatConnectionConfigResponse.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    var _contact_value;
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    return contact === null || contact === void 0 ? void 0 : (_contact_value = contact.value) === null || _contact_value === void 0 ? void 0 : _contact_value.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    const value = contact === null || contact === void 0 ? void 0 : contact.value;
    return {
        contactId: value === null || value === void 0 ? void 0 : value.contactId,
        participantId: value === null || value === void 0 ? void 0 : value.participantId,
        region: value === null || value === void 0 ? void 0 : value.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ""
        ],
        authenticated: isUserLoggedIn ? null : [
            "No"
        ],
        email: [
            isUserLoggedIn ? userEmail : ""
        ],
        customer_status: [
            "Customer"
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            "GMT+6"
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            "en"
        ],
        is_partner_dc_exception: [
            "Customer not in SFDC"
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split("_").join(" ")
        ],
        support_channel: [
            "chat"
        ],
        inquiry_category: [
            "access_issues"
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                "Chat Transcript for <email removed for privacy>"
            ],
            details: "",
            contactEmail: isUserLoggedIn ? userEmail !== null && userEmail !== void 0 ? userEmail : "" : "",
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    var _response_channelPlatform_getCustomerConversations_conversations, _response_channelPlatform_getCustomerConversations;
    var _response_channelPlatform_getCustomerConversations_conversations_length;
    const count = (_response_channelPlatform_getCustomerConversations_conversations_length = response === null || response === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations = response.channelPlatform_getCustomerConversations) === null || _response_channelPlatform_getCustomerConversations === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations_conversations = _response_channelPlatform_getCustomerConversations.conversations) === null || _response_channelPlatform_getCustomerConversations_conversations === void 0 ? void 0 : _response_channelPlatform_getCustomerConversations_conversations.length) !== null && _response_channelPlatform_getCustomerConversations_conversations_length !== void 0 ? _response_channelPlatform_getCustomerConversations_conversations_length : 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? "Loading chat" : "Open chat widget",
        style: {
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1000,
            cursor: isLoading ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            backgroundColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            color: "white",
            boxShadow: (0, $lP7A9.default)("elevation.shadow.raised")
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};
function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: (0, $dPABA._)((0, $6ogO3._)({}, headers), {
                        "Content-Type": "application/json",
                        "X-Client-Hash": channelsIdentityHash
                    })
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "";
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            var _response_data;
            setCustomerConversationsResponse((_response_data = response === null || response === void 0 ? void 0 : response.data) !== null && _response_data !== void 0 ? _response_data : null);
        }).catch((err)=>{
            console.warn("Error fetching customer conversations:", err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) {
            console.warn("Client with token not available yet");
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail !== null && userEmail !== void 0 ? userEmail : "", isUserLoggedIn);
        var _JSON_parse;
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: "CHAT",
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: $c6548387155117f6$export$a40d7197cc58cf92($c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn)),
                attributes: (_JSON_parse = JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)))) !== null && _JSON_parse !== void 0 ? _JSON_parse : {},
                anonymousId: (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || ""
            }
        }).then((response)=>{
            setChatConnectionConfig(response === null || response === void 0 ? void 0 : response.data);
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching chat connection config:", err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: "sales"
            }
        }).then((response)=>{
            var _response_data;
            const token = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching channel platform token:", err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: "80%",
        height: 500
    };
    const omniChannelEnv = "staging";
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                children,
                chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                            conversationId: conversationId
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                            contactId: connectionConfigAttributes.contactId,
                            participantId: connectionConfigAttributes.participantId,
                            region: connectionConfigAttributes.region
                        })
                    ]
                }),
                channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                        clientToken: clientToken,
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                    isLoading: viewState.isButtonLoading,
                    onClick: handleChatButtonClick,
                    onKeyDown: handleChatButtonKeyDown
                }),
                showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                        env: omniChannelEnv,
                        clientIdentityHash: clientToken || "",
                        chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                        accountId: aaid || "",
                        isRefreshed: isRefreshed,
                        customerConversations: customerConversationsResponse,
                        loading: loading,
                        error: error,
                        isUserLoggedIn: isUserLoggedIn,
                        surveyModalAttributes: surveyModalAttributes,
                        onLoaded: ()=>setIsCustomerComponentLoaded(true)
                    })
                })
            ]
        })
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("9dCmO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b6316d01b13082f$var$_react = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6b6316d01b13082f$var$_baseNew = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6b6316d01b13082f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b6316d01b13082f$var$CommentIcon = (props)=>/*#__PURE__*/ $6b6316d01b13082f$var$_react.default.createElement($6b6316d01b13082f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$6b6316d01b13082f$var$CommentIcon.displayName = 'CommentIcon';
var $6b6316d01b13082f$var$_default = module.exports.default = $6b6316d01b13082f$var$CommentIcon;

});

parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });
// @ts-expect-error - @apollo/client is ESM but this file is treated as CommonJS by TypeScript

var $4Wqet = parcelRequire("4Wqet");
let $59b9792633dffc77$var$_ = (t)=>t, $59b9792633dffc77$var$t, $59b9792633dffc77$var$t1, $59b9792633dffc77$var$t2, $59b9792633dffc77$var$t3, $59b9792633dffc77$var$t4;
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)($59b9792633dffc77$var$t || ($59b9792633dffc77$var$t = $59b9792633dffc77$var$_`
    query channelPlatformTokenGeneration {
        supportInquiry_channelsIdentityHash
    }
`));
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)($59b9792633dffc77$var$t1 || ($59b9792633dffc77$var$t1 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
        $anonymousId: String
        $attributes: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: {
                payload: $payload
                metadata: $metadata
                attributes: $attributes
            }
            anonymousId: $anonymousId
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)($59b9792633dffc77$var$t2 || ($59b9792633dffc77$var$t2 = $59b9792633dffc77$var$_`
    query CustomerConversations($anonymousId: String) {
        channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
            conversations
        }
    }
`));
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)($59b9792633dffc77$var$t3 || ($59b9792633dffc77$var$t3 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: { payload: $payload, metadata: $metadata }
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)($59b9792633dffc77$var$t4 || ($59b9792633dffc77$var$t4 = $59b9792633dffc77$var$_`
    query channelPlatformTokenGenerationByClientName($clientName: String) {
        supportInquiry_channelsIdentityHashByClientName(
            request: { clientName: $clientName }
        )
    }
`));

});

parcelRegister("lNX8N", function(module, exports) {


























module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("iWCiw")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("eDmkW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gjBTD")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("2TJ5h")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("fpTAo")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("j2nJQ")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("6zKN2")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("HRjDP")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("9WEDO")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gFcxC")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7Q4ht")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("76kmj"))
]).then(()=>parcelRequire('8Cs4z'));

});

parcelRegister("asSV5", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("iWCiw")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hx68B"))
]).then(()=>parcelRequire('cJIcN'));

});


parcelRegister("hKTyA", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryTemplate", function () { return (parcelRequire("gZJ17")).JiraProductDiscoveryTemplate; });
parcelRequire("gZJ17");

});
parcelRegister("gZJ17", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryTemplate", function () { return $6656f5e31aa2d995$export$55460b563be26bbf; });

var $7VQPk = parcelRequire("7VQPk");

var $jMhSx = parcelRequire("jMhSx");

var $8LaTa = parcelRequire("8LaTa");

var $fhttR = parcelRequire("fhttR");

var $aYwTu = parcelRequire("aYwTu");

var $cwVvH = parcelRequire("cwVvH");

var $ceI23 = parcelRequire("ceI23");

var $lY5mc = parcelRequire("lY5mc");

var $hBk6f = parcelRequire("hBk6f");

var $haaSq = parcelRequire("haaSq");

var $lLZy5 = parcelRequire("lLZy5");

var $tce8m = parcelRequire("tce8m");

var $dMCHr = parcelRequire("dMCHr");

var $5OLfs = parcelRequire("5OLfs");

var $8yYDi = parcelRequire("8yYDi");
const $6656f5e31aa2d995$export$55460b563be26bbf = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYwTu.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("main", {
                    id: "content",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhttR.JPDBanner), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lLZy5.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5OLfs.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBk6f.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $haaSq.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dMCHr.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cwVvH.AtlassianIntelligence), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $tce8m.HowItWorks), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yYDi.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ceI23.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lY5mc.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("fhttR", function(module, exports) {
$parcel$export(module.exports, "JPDBanner", function () { return $ffacf727c21fa555$export$637e7e5d1efd26e9; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");
parcelRequire("53RJr");
var $jVACb = parcelRequire("jVACb");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $ffacf727c21fa555$export$637e7e5d1efd26e9 = ()=>{
    const intl = (0, $8e22h.default)();
    const gwp6473JpdPremiumBanner = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp6473JpdPremiumBanner);
    const gwp7456JpdStateOfProductBanner = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7456JpdStateOfProductBanner);
    const gwp8038JpdBannerWebinar = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8038JpdBannerWebinar);
    const gwp9038JdpAIWebinarBanner = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9038JdpAIWebinarBanner);
    const jpdBannerMessagesWebinar = {
        identifier: "JPDPageTemplate.webinar-announcement",
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Register for the webinar to hear the surprising findings!",
            values: (0, $kooLp.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement.link-text",
            defaultMessage: "Register now \u2192"
        }),
        linkUrl: (0, $kooLp.useLocalizedHref)("/webinars/software/state-of-product-2026"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Register now",
            "data-label-english": "Register now",
            "data-track-event": "jpdPageTemplate.bannerAlert.stateOfProductWebinarAnnouncement.registerNow"
        }
    };
    const jpdBannerMessagesStateOfProduct = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement",
            defaultMessage: "<strong>State of Product 2026:</strong> Find out what 1000+ product teams think in our newest research report.",
            values: (0, $kooLp.DEFAULT_VALUES)
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement.link-text",
            defaultMessage: "Read now \u2192"
        }),
        linkUrl: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/resources/state-of-product-2026"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Read now",
            "data-label-english": "Read now",
            "data-track-event": "jpdPageTemplate.bannerAlert.stateOfProductAnnouncement.readNow"
        }
    };
    const jpdBannerMessagesAIWebinar = {
        identifier: "JPDPageTemplate.ai-webinar-annnouncement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.ai-webinar-annnouncement",
            defaultMessage: "AI product strategy: How to build & win today."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Get the Details \u2192"
        }),
        linkUrl: (0, $kooLp.useLocalizedHref)("/webinars/software/jira-product-discovery-ai-webinar"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Get the Details",
            "data-label-english": "Get the Details",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };
    const jpdBannerMessagesPremium = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.premium-announcement",
            defaultMessage: "Jira Product Discovery Premium is now available! Get more visibility, control, and support to build products at scale."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Learn more \u2192"
        }),
        linkUrl: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/premium"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };
    if (gwp9038JdpAIWebinarBanner) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), (0, $6ogO3._)({}, jpdBannerMessagesAIWebinar));
    if (gwp8038JpdBannerWebinar) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), (0, $6ogO3._)({}, jpdBannerMessagesWebinar));
    if (gwp7456JpdStateOfProductBanner) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), (0, $6ogO3._)({}, jpdBannerMessagesStateOfProduct));
    if (gwp6473JpdPremiumBanner) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVACb.BannerAlert), (0, $6ogO3._)({}, jpdBannerMessagesPremium));
    return null;
};

});
parcelRegister("53RJr", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("jVACb")).BannerAlert; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("jVACb")).BannerAlert; });

var $jVACb = parcelRequire("jVACb");

});


parcelRegister("aYwTu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a060b684c4f472c9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $a060b684c4f472c9$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $a060b684c4f472c9$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
        productLogoUrl: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$a060b684c4f472c9$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $a060b684c4f472c9$export$2e2bcd8739ae039 = $a060b684c4f472c9$var$JiraProductDiscoveryNavV2;

});

parcelRegister("cwVvH", function(module, exports) {
$parcel$export(module.exports, "AtlassianIntelligence", function () { return $49ae067eb8751f37$export$eec9700d5a261698; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $49ae067eb8751f37$var$ArrowPencilPointRight = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fill: "currentColor",
            d: "M59.938 15.4c-.92-.48-1.816-.597-2.7-.75a7.975 7.975 0 0 0-2.872.044c-.848.163-1.709.062-2.511-.19-1.5-.473-3.039-.55-4.597-.555-.973-.005-1.959-.054-2.916-.202-.663-.104-1.292-.416-1.965-.642-.392.625-.992.599-1.612.367-1.278-.481-2.594-.57-3.947-.543-.736.014-1.463-.158-2.068-.635-.077-.056-.175-.084-.267-.117-.61.602-1.323.564-2.063.397-1.19-.262-2.387-.5-3.577-.762-.804-.18-1.606-.377-2.409-.569-.797-.196-1.56-.48-2.43-.276-1.08.253-2.16-.009-3.235-.18-1.226-.2-2.439-.518-3.666-.604-2.097-.152-4.158-.522-6.235-.81-.993-.14-1.991-.243-2.975-.423a42.808 42.808 0 0 1-2.978-.664c-1.046-.264-2.085-.582-3.121-.882C1.122 7.214.74 6.67.444 6.112.36 5.953.59 5.534.78 5.337c.594-.621 1.35-.92 2.211-.987 1.934-.153 3.86-.06 5.774.12 1.72.162 3.425.459 5.124.761 1.963.342 3.938.566 5.928.725 1.551.12 3.096.346 4.645.495 1.447.144 2.9.241 4.353.38 1.607.156 3.215.305 4.824.502 2.28.273 4.55.593 6.831.872 1.62.199 3.241.391 4.895.293.938-.058 1.897.126 2.828.295 1.34.24 2.692.28 4.046.348 1.651.082 3.303.158 4.96.246.474.026.944.098 1.42.124.13.013.267-.05.401-.072-.052-.126-.069-.295-.162-.37-.553-.454-1.127-.874-1.68-1.327-1.467-1.208-2.934-2.416-4.394-3.635-.563-.473-.885-1.124-1.227-1.76-.208-.387-.023-.71.165-1.002.18-.28.301-.676.723-.71.29-.024.579-.048.87-.041 1.45.024 2.74.566 4.009 1.184.906.442 1.796.925 2.718 1.344.386.178.62.43.782.807.114.264.204.591.615.274.182-.137.404-.09.571.125.246.314.537.602.782.921.167.222.358.277.63.3 1.026.064 1.83.574 2.406 1.407.371.537.868.9 1.432 1.15.655.29 1.24.663 1.702 1.185.85.958 1.653 1.953 2.45 2.954.341.43.245 1.248-.147 1.657-.703.737-1.431 1.44-2.117 2.191-.368.406-.66.885-1 1.323-.14.178-.285.415-.478.478-.75.258-1.239.837-1.802 1.342-.233.21-.48.442-.76.557-.915.379-1.838.732-2.774 1.043-.273.091-.606-.027-.91-.023-.139.004-.345.03-.402.12-.507.805-1.262 1.2-2.163 1.25-1.377.08-2.673.52-4.003.82-1.53.344-3.061.683-4.589 1.052a13.66 13.66 0 0 1-3.57.36c-.512-.011-.884-.266-1.065-.674-.39-.899-.488-.879.139-1.69.118-.155.253-.297.35-.466.372-.67 1.031-.793 1.682-1.007 1.115-.364 2.208-.796 3.296-1.234 1.425-.578 2.831-1.193 4.246-1.784.764-.322 1.542-.601 2.29-.949.75-.348 1.47-.753 2.287-1.178l.016-.034z"
        })
    });
};
const $49ae067eb8751f37$var$ArrowPencilPointLeft = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fill: "currentColor",
            d: "M11.923 9.891c.933.429 1.83.508 2.72.622a8.268 8.268 0 0 0 2.87-.149c.843-.189 1.706-.123 2.515.09 1.513.401 3.053.417 4.61.365.973-.031 1.96-.021 2.921.086.666.076 1.303.353 1.983.546.374-.617.975-.614 1.6-.413 1.292.416 2.61.453 3.962.376.735-.04 1.467.098 2.084.536.08.051.178.075.271.104.594-.604 1.307-.594 2.051-.46 1.197.208 2.4.393 3.597.601.809.144 1.616.304 2.424.46.802.16 1.572.404 2.437.176 1.072-.285 2.16-.072 3.24.053 1.23.147 2.452.409 3.68.446 2.102.069 4.172.35 6.256.55.997.097 1.998.16 2.986.297 1.006.139 2.007.323 2.995.53 1.053.216 2.101.484 3.145.735.677.158 1.073.668 1.385 1.196.088.15-.132.564-.316.76-.577.622-1.325.94-2.184 1.035-1.93.22-3.856.202-5.776.099-1.724-.091-3.436-.315-5.143-.543a66.397 66.397 0 0 0-5.946-.479c-1.554-.057-3.105-.218-4.657-.304-1.451-.086-2.906-.126-4.363-.206-1.611-.09-3.223-.174-4.836-.304-2.288-.179-4.566-.403-6.853-.588-1.626-.13-3.252-.256-4.902-.1-.936.091-1.9-.05-2.835-.179-1.348-.183-2.7-.17-4.055-.186-1.653-.017-3.307-.029-4.965-.052-.476-.007-.947-.06-1.423-.067-.13-.008-.267.059-.4.085.055.119.077.282.172.351.565.417 1.151.8 1.716 1.218 1.5 1.11 2.999 2.222 4.491 3.344.576.435.915 1.051 1.274 1.651.218.367.042.685-.137.974-.173.278-.284.664-.705.712-.288.034-.577.068-.869.072-1.449.03-2.753-.444-4.039-.993-.918-.393-1.821-.825-2.753-1.196a1.417 1.417 0 0 1-.805-.75c-.12-.25-.219-.562-.621-.24-.18.138-.402.1-.575-.1-.255-.294-.553-.561-.807-.86-.172-.207-.365-.254-.638-.266-1.027-.024-1.844-.485-2.444-1.268-.385-.504-.892-.836-1.462-1.057-.662-.256-1.258-.593-1.734-1.08a69.905 69.905 0 0 1-2.53-2.758c-.352-.404-.277-1.196.103-1.606.683-.737 1.392-1.443 2.058-2.192.356-.405.635-.879.964-1.314.135-.177.274-.41.464-.48.744-.276 1.217-.853 1.766-1.361.227-.211.467-.445.745-.566.904-.4 1.817-.775 2.745-1.11.27-.098.606.004.911-.011.138-.01.343-.042.398-.131.486-.796 1.23-1.205 2.129-1.287 1.374-.128 2.659-.601 3.98-.94 1.52-.39 3.042-.773 4.56-1.186C22.527.86 23.711.715 24.915.7c.513-.009.892.223 1.084.61.415.853.512.83-.093 1.635-.115.155-.246.297-.338.464-.354.66-1.01.803-1.654 1.034-1.105.393-2.186.85-3.262 1.314-1.41.61-2.798 1.257-4.197 1.879-.755.34-1.525.638-2.265 1.001-.74.364-1.448.781-2.254 1.222l-.014.033z"
        })
    });
};
const $49ae067eb8751f37$export$eec9700d5a261698 = ()=>{
    const intl = (0, $8e22h.default)();
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "jpd-atlassianIntelligence",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            id: "atlassian-intelligence",
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_85i51wqb _1reo15vq _18m915vq",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _1e021ssb _t9eczr6s _1bsbtfvk _p12fauwl _bfhkqlpt _1pby1mrw _4t3i1w8u _mkrz1wiv _165t1mqo _1cfr1y69",
                                "background"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _2lx21bp4 _kqswh2mm",
                                "content-wrapper"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _2lx21bp4 _zulp4bvh _p12f32xz _1q511k4y _kqswh2mm _y3gn1h6o _81641tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _srwzi2wt"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1crf _6rthzwfg",
                                                    "branding"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                    image: {
                                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/228i1sr1dfw1gwf6gej5q22wij418525.svg",
                                                        alt: "Atlassian Intelligence",
                                                        width: 32,
                                                        height: 32
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                                className: (0, $2jatx.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz12cp _1pby11wp",
                                                    "_1rkb1w8u"
                                                ]),
                                                children: intl.formatMessage({
                                                    id: "JiraProductDiscoveryPage.atlassianIntelligence.header",
                                                    defaultMessage: "Transform teamwork with human-AI collaboration"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                        text: intl.formatMessage({
                                            id: "JiraProductDiscoveryPage.atlassianIntelligence.ctaText",
                                            defaultMessage: "Explore Atlassian Intelligence"
                                        }),
                                        href: (0, $kooLp.useLocalizedHref)("/software/artificial-intelligence"),
                                        type: "primary",
                                        bgColor: "bgBlackBlue",
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "ctaSection",
                                            "data-product-key": "jiraProductDiscovery",
                                            "data-label-english": "Explore Atlassian Intelligence"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1h1tcq2i _1bsb1osq _lcxvglyw"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$LeftArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$RightArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                image: {
                                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w5a2w16s762570j03psv36nc66c7bpuk.webp",
                                                    alt: "",
                                                    width: 1920,
                                                    height: 1080
                                                },
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "auto"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $49ae067eb8751f37$var$LeftArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152tubeo _1e02tidb _1vxpvqxi _mmgkvkhr _jj7e1xgq _zsl9vkhr _17s11xgq _dqt7vkhr"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqu7fg"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#1868DB",
                    rotate: 200
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1j6v"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#BC5DF2",
                    rotate: 222
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqb8yl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#fff",
                    rotate: 219
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1gop"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#101214",
                    rotate: 196
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1r2e"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointLeft, {
                    color: "#B9D58D",
                    rotate: 199
                })
            })
        ]
    });
};
const $49ae067eb8751f37$var$RightArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _1pbycs5v",
            "_152t11oi _1e02sisq _1vxp1ebb _mmgk189v _jj7etpnp _zsl9189v _17s1tpnp _dqt7189v"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqwpsi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#1868DB",
                    rotate: 139
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1xrr"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#fff",
                    rotate: 127
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq59wa"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#82B536",
                    rotate: 114
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqmgyd"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($49ae067eb8751f37$var$ArrowPencilPointRight, {
                    color: "#101214",
                    rotate: 138
                })
            })
        ]
    });
};
const $49ae067eb8751f37$var$sectionStyles = null;
const $49ae067eb8751f37$var$arrowStyles = null;
const $49ae067eb8751f37$var$wrapperStyles = null;
const $49ae067eb8751f37$var$leftAndRightArrowsStyles = null;
const $49ae067eb8751f37$var$svgStyles = null;
const $49ae067eb8751f37$var$leftArrowsStyles = null;
const $49ae067eb8751f37$var$rightArrowsStyles = null;
const $49ae067eb8751f37$var$headerStyles = null;
const $49ae067eb8751f37$var$containerStyles = null;
const $49ae067eb8751f37$var$backgroundStyles = null;
const $49ae067eb8751f37$var$textWrapperStyles = null;
const $49ae067eb8751f37$var$textStyles = null;
const $49ae067eb8751f37$var$brandingStyles = null;
const $49ae067eb8751f37$var$imageWrapperStyles = null;
const $49ae067eb8751f37$var$fadeIn = null;
const $49ae067eb8751f37$var$fadeInAnimation = null;
const $49ae067eb8751f37$var$arrowLeft1 = null;
const $49ae067eb8751f37$var$arrowLeft1Animation = null;
const $49ae067eb8751f37$var$arrowLeft2 = null;
const $49ae067eb8751f37$var$arrowLeft2Animation = null;
const $49ae067eb8751f37$var$arrowLeft3 = null;
const $49ae067eb8751f37$var$arrowLeft3Animation = null;
const $49ae067eb8751f37$var$arrowLeft4 = null;
const $49ae067eb8751f37$var$arrowLeft4Animation = null;
const $49ae067eb8751f37$var$arrowLeft5 = null;
const $49ae067eb8751f37$var$arrowLeft5Animation = null;
const $49ae067eb8751f37$var$arrowRight1 = null;
const $49ae067eb8751f37$var$arrowRight1Animation = null;
const $49ae067eb8751f37$var$arrowRight2 = null;
const $49ae067eb8751f37$var$arrowRight2Animation = null;
const $49ae067eb8751f37$var$arrowRight3 = null;
const $49ae067eb8751f37$var$arrowRight3Animation = null;
const $49ae067eb8751f37$var$arrowRight4 = null;
const $49ae067eb8751f37$var$arrowRight4Animation = null;

});

parcelRegister("ceI23", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b574d965bf0dad0e$export$2e2bcd8739ae039; });
/* community.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
const $b574d965bf0dad0e$var$Community = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1mou1epz"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/tj67uy2v6dlh816537m17ay3p0qwy6y2.webp",
                        alt: ""
                    },
                    className: (0, $2jatx.default)([
                        "_rtys1osq _bna71wug _1vr0xy5q"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: "h4",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.community.heading",
                                defaultMessage: "Join us in the Atlassian Community"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.community.subheading",
                                defaultMessage: "Ask questions, give app feedback, and connect with our team and other users to learn best practices."
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                            text: intl.formatMessage({
                                id: "JiraProductDiscoveryPage.community.ctaText",
                                defaultMessage: "Join the discussion"
                            }),
                            href: "https://community.atlassian.com/t5/Jira-Product-Discovery/ct-p/jpd",
                            type: "primary",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                "data-event-container": "pronouncedCtaSection",
                                "data-event": "clicked",
                                "data-product-key": "jiraProductDiscovery"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
var $b574d965bf0dad0e$export$2e2bcd8739ae039 = $b574d965bf0dad0e$var$Community;
const $b574d965bf0dad0e$var$section = null;
const $b574d965bf0dad0e$var$img = null;

});

parcelRegister("lY5mc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d8c7e3342f7badfc$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $20OkY = parcelRequire("20OkY");

var $5qUgh = parcelRequire("5qUgh");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $d8c7e3342f7badfc$var$CtaSection = ()=>{
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _y3gn1h6o _6rthxncg _1q51xncg _85i5xy5q _1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1cs8stnw _1g0v1mrw _1kt9b3bt _1812ukr8 _gs7s10v4 _1rusbq5w _7dwz6xro _1kwxdcea _jbut1ssa _5t3m1oci _m2uvwt5r _18postnw _1bqq1mrw _aetrb3bt _13w1ukr8 _16gxmgjw _1hfkb29m _3p6m1cq2 _1v5vmgnk _z0bc1h14 _19h9d943 _1oj4kh7c _otsx1cpx _wi3iz9ld _tzs91clp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "_1cs8stnw _1mp410mc _kfgt10mc _1kt9b3bt _1s6k11z8 _1ank5vt7 _cfu11o8l _7dwz4djf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraProductDiscoveryPage.cta.section.heading",
                            defaultMessage: "<span>Build</span> better features, not more features.",
                            values: {
                                span: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_syaz1gfe _1mouidpf _14b51n8h _1m0r1wug",
                            "body-lg"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraProductDiscoveryPage.cta.section.subheading",
                            defaultMessage: "Leave the guess work behind and build products your customers love."
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                        color: "yellow",
                        variant: "primary",
                        size: "small",
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraProductDiscovery",
                            "data-label-english": "Get it free",
                            "data-track-event": "jiraProductDiscovery.get-it-free-button-clicked"
                        },
                        href: signupLink,
                        onClick: openCrossFlow,
                        className: (0, $2jatx.default)([
                            "_1pfhpxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "JiraProductDiscoveryPage.cta.section.cta.text",
                            defaultMessage: "Get it free"
                        })
                    })
                ]
            })
        })
    });
};
var $d8c7e3342f7badfc$export$2e2bcd8739ae039 = $d8c7e3342f7badfc$var$CtaSection;
const $d8c7e3342f7badfc$var$container = null;
const $d8c7e3342f7badfc$var$sectionStyle = null;
const $d8c7e3342f7badfc$var$textStyle = null;
const $d8c7e3342f7badfc$var$accent = null;
const $d8c7e3342f7badfc$var$button = null;

});

parcelRegister("hBk6f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b532b44e72bdf1eb$export$2e2bcd8739ae039; });
/* customers.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $b532b44e72bdf1eb$var$sectionStyle = null;
const $b532b44e72bdf1eb$var$logosGridStyle = null;
const $b532b44e72bdf1eb$var$liStyle = null;
const $b532b44e72bdf1eb$var$Customers = ()=>{
    const logos = [
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/260w4830ha12g7838ik7j5rq3ex31h8h.svg",
            alt: "Canva",
            width: 136,
            height: 43
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4ojx82fmj7q6l0354r1qfe572un65j0m.svg",
            alt: "Coupa",
            width: 158
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g76770b7kmwx457yu43qbo42h874ann8.svg",
            alt: "Docker",
            width: 158
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7ivn8866tpd7e4155176u71d4syycwc8.webp",
            alt: "The Economist",
            width: 112
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4x7bp61gn38200m4omcfxsx0cm75w71i.svg",
            alt: "Deliveroo",
            width: 148
        },
        {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/mmi427i07l27j8ul2aj32h25144vb65u.svg",
            alt: "Decathlon",
            width: 156
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_6rth12bs _y3gn1h6o _syazvejh"
        ]),
        style: {
            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: "h5",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "JiraProductDiscoveryPage.customers.heading",
                        defaultMessage: "Join the 10,000+ customers who build products with Jira Product Discovery"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _zulpviql _yv0e14qi _4cvr1h6o _6a6z1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bsb1osq _rtys1osq _1da7nl51 _1rqt1g7m"
                    ]),
                    children: logos.map((logo)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: (0, $6ogO3._)({}, logo)
                            })
                        }, logo.src))
                })
            })
        ]
    });
};
var $b532b44e72bdf1eb$export$2e2bcd8739ae039 = $b532b44e72bdf1eb$var$Customers;

});

parcelRegister("haaSq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3e07b8657bc59969$export$2e2bcd8739ae039; });
/* demo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $3e07b8657bc59969$var$bannerStyle = null;
const $3e07b8657bc59969$var$imgStyle = null;
const $3e07b8657bc59969$var$buttonStyle = null;
const $3e07b8657bc59969$var$DemoBanner = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_11q7owgw _2rkovwyg _1e0c11p5 _yv0ehkll _4cvr1h6o _6a6z1h6o _zulp1ejb _1bsb1osq _1q51xy5q _18zrpxbi _6rthxy5q _y3gn1h6o _12e81fhb _uj6kv2br _1j8b7y8c _16imze3t _su07xy5q _jplc1xh7 _bj231xh7"
            ]),
            style: {
                "--_1lpv4ka": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.lime")),
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "h3",
                    children: intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.body.text",
                        defaultMessage: "Join our demo with live chat Q&A"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                    variant: "secondary",
                    color: "black",
                    href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/demo"),
                    dataEventProps: {
                        "data-event": "clicked",
                        "data-event-container": "banner-link-button",
                        "data-event-component": "linkButton",
                        "data-product-key": "jiraProductDiscovery"
                    },
                    className: (0, $2jatx.default)([
                        "_10fp1h6o"
                    ]),
                    children: intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.cta.text",
                        defaultMessage: "Register now"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ua18axib18162bej4n515osj7675wepi.webp",
                        alt: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.demo.screenshot.alt",
                            defaultMessage: "Screenshot of Jira Product Discovery"
                        }),
                        width: 368,
                        height: 154
                    },
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1wpzesu3 _p12f1osq _1kr6kb7n _dz5jcs5v _rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $3e07b8657bc59969$export$2e2bcd8739ae039 = $3e07b8657bc59969$var$DemoBanner;

});

parcelRegister("lLZy5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a50f29d88e694ae6$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5qUgh = parcelRequire("5qUgh");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $a50f29d88e694ae6$var$Hero = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            layout: "8",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _1rjc1lhf _26vxxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1g0v1mrw _1cs8stnw _1kt9b3bt _1tes18wq _18crxkqj _f6gemgnk _wkf1wsfl _1nrl42os _1gg83zxr",
                            "superhero"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.heading.super",
                            defaultMessage: "From ideas to <em>impact</em>, build what matters"
                        }, (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                            em: (text)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _1cs8stnw _1kt9b3bt _1tesidpf _18crnqtd _f6gemgnk _wkf1174u _7dwz1vci _5z7wyan6 _1kwx1wlv _5t3mz98b"
                                    ]),
                                    children: text
                                });
                            }
                        }))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "body-lg",
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.subtitle",
                            defaultMessage: "Capture insights, prioritize ideas, and build roadmaps - all in Jira"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                        href: signupLink,
                        onClick: openCrossFlow,
                        variant: "primary",
                        dataEventProps: {
                            "data-event": "clicked",
                            "data-event-container": "heroSection",
                            "data-event-component": "linkButton",
                            "data-product-key": "jiraProductDiscovery",
                            "data-label-english": "Get it free",
                            "data-track-event": "jiraProductDiscovery.get-it-free-button-clicked"
                        },
                        className: (0, $2jatx.default)([
                            "_1pfhpxbi"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.hero.cta.label",
                            defaultMessage: "Get it free"
                        })
                    })
                ]
            })
        })
    });
};
var $a50f29d88e694ae6$export$2e2bcd8739ae039 = $a50f29d88e694ae6$var$Hero;
const $a50f29d88e694ae6$var$container = null;
const $a50f29d88e694ae6$var$heroContainer = null;
const $a50f29d88e694ae6$var$heading = null;
const $a50f29d88e694ae6$var$impact = null;
const $a50f29d88e694ae6$var$button = null;

});

parcelRegister("tce8m", function(module, exports) {
$parcel$export(module.exports, "HowItWorks", function () { return $4affc59986e2abbe$export$409faa00494a55a; });
/* how-it-works.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $a9lfn = parcelRequire("a9lfn");
parcelRequire("l22jm");
var $8IYGL = parcelRequire("8IYGL");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $l4UnR = parcelRequire("l4UnR");

var $iWL9l = parcelRequire("iWL9l");
const $4affc59986e2abbe$export$409faa00494a55a = ()=>{
    const intl = (0, $8e22h.default)();
    const cardRef = (0, $1oC0p.useRef)(null);
    const [activeTeamIndex, setActiveTeamIndex] = (0, $1oC0p.useState)(0);
    const [activeTeamData, setActiveTeamData] = (0, $1oC0p.useState)((0, $l4UnR.TEAM_DATA)[0]);
    (0, $1oC0p.useEffect)(()=>{
        setActiveTeamData((0, $l4UnR.TEAM_DATA)[activeTeamIndex]);
    }, [
        activeTeamIndex
    ]);
    const renderActiveMedia = ()=>{
        const { heroImage: heroImage, contentTitle: contentTitle, contentText: contentText, quoteColor: quoteColor, quoteText: quoteText, customerName: customerName, customerTitle: customerTitle } = activeTeamData;
        const quoteProps = {
            quoteColor: quoteColor,
            quoteText: intl.formatMessage(quoteText),
            customerName: intl.formatMessage(customerName),
            customerTitle: intl.formatMessage(customerTitle)
        };
        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "4-8",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage(contentTitle)
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: intl.formatMessage(contentText)
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kzviglyw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iWL9l.default), (0, $6ogO3._)({}, quoteProps))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_mezj1osq _bna71wug"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: heroImage,
                                    alt: ""
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_dm25glyw _sugaglyw"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iWL9l.default), (0, $6ogO3._)({}, quoteProps))
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-hero",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            id: "hero-jira-cta",
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _6rth1ylp"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_ect41pz4 _1wyb1ylp _k48p1fw0 _vwz4ckbl _y3gn1h6o"
                            ]),
                            style: {
                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _18postnw _z0ai1qo0 _1qdg1qjk _1guf1lpd _1czd17hu _aetrb3bt _3p6m1s0j _1mhxca9o _1nww1ul9 _1y2q17rr _sjmw1lpd _1efb101a"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "JiraProductDiscoveryPage.howItWorks.header",
                                    defaultMessage: "How it works",
                                    values: {
                                        teams: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IYGL.Adg4TextUnderline), {
                                                underline: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                                    width: "100%",
                                                    height: "30",
                                                    viewBox: "0 0 306 42",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                                        d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
                                                        fill: "#FFA900"
                                                    })
                                                }),
                                                children: str
                                            }),
                                        br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            ref: cardRef,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4Tabs), {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _1bah1yb4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rth12am _zulpckbl"
                                        ]),
                                        children: (0, $l4UnR.TEAM_DATA).map(({ title: title, id: id, icon: icon, englishLabel: englishLabel }, index)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                                onClick: ()=>{
                                                    setActiveTeamIndex(index);
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                                    "data-product-key": "home",
                                                    "data-event-component": "button",
                                                    "data-event-container": "heroSection",
                                                    "data-event": "clicked",
                                                    "data-label-english": englishLabel,
                                                    "aria-label": intl.formatMessage(title),
                                                    className: (0, $2jatx.default)([
                                                        "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _d0altlke"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                        className: (0, $2jatx.default)([
                                                            "_vchhusvi _1e0c1txw _2lx21bp4 _1bsbh2q2 _4cvr1h6o _ca0qi2wt _u5f3i2wt _n3tdi2wt _19bvi2wt _zulpidpf _2rkoi2wt _19itt94y _11q7m7j4 _1j55glyw _19lc15ej _kbawglyw _1x381ule",
                                                            activeTeamIndex === index && "_19it1dfy _2rkoi2wt _1kd31fw0"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                className: (0, $2jatx.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "default-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                                    image: {
                                                                        src: `${icon}`,
                                                                        alt: "",
                                                                        draggable: "false"
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                className: (0, $2jatx.default)([
                                                                    "_4t3i3okq _1bsb3okq _mezj3okq _bna73okq",
                                                                    "hover-icon"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                                    image: {
                                                                        src: icon,
                                                                        alt: "",
                                                                        draggable: "false"
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                className: (0, $2jatx.default)([
                                                                    "_ect41pz4 _k48p1nn1 _1wyb1j6v _vwz41k8s _syazqlpt"
                                                                ]),
                                                                style: {
                                                                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                                                                },
                                                                children: intl.formatMessage(title)
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, id);
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                            children: renderActiveMedia()
                        })
                    ]
                })
            })
        })
    });
};
const $4affc59986e2abbe$var$jiraHeroStyles = null;
const $4affc59986e2abbe$var$heroTitleStyles = null;
const $4affc59986e2abbe$var$heroTitleSpanStyles = null;
const $4affc59986e2abbe$var$buttonResetStyle = null;
const $4affc59986e2abbe$var$tabsStyle = null;
const $4affc59986e2abbe$var$teamCardStyles = null;
const $4affc59986e2abbe$var$iconContainerStyles = null;
const $4affc59986e2abbe$var$teamCardTextStyles = null;
const $4affc59986e2abbe$var$teamCardActiveStyles = null;
const $4affc59986e2abbe$var$imageOverrideStyles = null;
const $4affc59986e2abbe$var$quoteStyles = null;
const $4affc59986e2abbe$var$tabletQuoteStyles = null;

});
parcelRegister("l22jm", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return (parcelRequire("8IYGL")).Adg4TextUnderline; });
parcelRequire("8IYGL");

});
parcelRegister("8IYGL", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return $37a3584e5be26d24$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");
const $37a3584e5be26d24$var$textStyle = null;
const $37a3584e5be26d24$var$inViewTextStyle = null;
const $37a3584e5be26d24$var$underlineStyle = null;
const $37a3584e5be26d24$var$inViewUnderlineStyle = null;
const $37a3584e5be26d24$var$hiddenText = null;
const $37a3584e5be26d24$var$visibleText = null;
const $37a3584e5be26d24$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $6ZVlx.default)(fontWeight.from),
            "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
                },
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $6ZVlx.default)(underlineInset),
                    "--_p0j3r4": (0, $6ZVlx.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("l4UnR", function(module, exports) {
$parcel$export(module.exports, "TEAM_DATA", function () { return $bc2f4f4043a65c9d$export$860b41270ca4de2e; });

var $fnHPc = parcelRequire("fnHPc");
const $bc2f4f4043a65c9d$export$860b41270ca4de2e = [
    {
        id: "software",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/0tktsadc6a0h85663hv4lb34mml07y0g.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/1l8b1267j66mc1b334eua3gyam2nggrx.webp",
        title: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab1",
            defaultMessage: "Capture"
        }),
        englishLabel: "Capture",
        contentTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab1",
            defaultMessage: "Capture ideas and insights"
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab1",
            defaultMessage: "There\u2019s now a home for all the unstructured work that happens before you start building software. Gather and organize your product opportunities, user feedback, and feature requests all in one place."
        }),
        quoteColor: "blue",
        quoteText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab1",
            defaultMessage: "Jira Product Discovery is helping us do the right things, in the right order, and at the right time, focusing on work that will deliver on benefits."
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab1",
            defaultMessage: "John Sayers"
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab1",
            defaultMessage: "PMO Lead, Renaissancere"
        })
    },
    {
        id: "product-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/kha7lb4n41e6nqbfm6uu8jwym0dumt36.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ohh610p3j7iv5hyda53yqh0006v40258.webp",
        title: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab2",
            defaultMessage: "Prioritize"
        }),
        englishLabel: "Prioritize",
        contentTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab2",
            defaultMessage: "Prioritize \u2013 your way"
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab2",
            defaultMessage: "Flexible views and granular fields let you compare ideas against one another using the prioritization method that works best for you."
        }),
        quoteColor: "lime",
        quoteText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab2",
            defaultMessage: "Up until Jira Product Discovery, even with other roadmapping tools, we\u2019ve had to use shared spreadsheets and slide presentations to coordinate prioritization in an accessible way. However, within a week of \u201Ctrying\u201D out Jira Product Discovery, it became clear it was the tool to invest in going forward."
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab2",
            defaultMessage: "John Daily Jr."
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab2",
            defaultMessage: "Head of Product, Karhoo"
        })
    },
    {
        id: "marketing",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/36m76eu4oo0e46hvd21s744fn11i35q5.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/2fh1741j5vly80365ofehwwe0qes6b4a.webp",
        title: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab3",
            defaultMessage: "Engage"
        }),
        englishLabel: "Engage",
        contentTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab3",
            defaultMessage: "Engage and align your teams"
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab3",
            defaultMessage: "Create and share roadmaps tailored to individual stakeholders \u2013 even ones outside your organization \u2013 and let them provide feedback via comments, votes, or simple reactions."
        }),
        quoteColor: "purple",
        quoteText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab3",
            defaultMessage: "Jira Product Discovery has revitalized how we think about roadmaps."
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab3",
            defaultMessage: "Adam Chapman"
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab3",
            defaultMessage: "Full Stack Developer, Apex Networks"
        })
    },
    {
        id: "project-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/3e2ln2b76w2544cn5633031qjtn2fobe.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/r1elfv055406ty7x72u4000npq20n46m.webp",
        title: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.label.tab4",
            defaultMessage: "Connect"
        }),
        englishLabel: "Connect",
        contentTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.title.tab4",
            defaultMessage: "Connect teams, all in Jira"
        }),
        contentText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.text.tab4",
            defaultMessage: "Seamlessly connect your ideas to delivery work in Jira so your teams have full context and visibility from discovery to delivery."
        }),
        quoteColor: "yellow",
        quoteText: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.text.tab4",
            defaultMessage: "Jira Product Discovery combines everything I was doing in spreadsheets and Powerpoints into one easy-to-navigate tool. Plus everything is added straight into Jira, instead of requiring some third-party tool to integrate."
        }),
        customerName: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.name.tab4",
            defaultMessage: "Abby Kiesling"
        }),
        customerTitle: (0, $fnHPc.defineMessage)({
            id: "JiraProductDiscoveryPage.howItWorks.tabs.quote.title.tab4",
            defaultMessage: "Product Manager, EZ Texting"
        })
    }
];

});

parcelRegister("iWL9l", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edb29ea8e109e6d3$export$2e2bcd8739ae039; });
/* testimonial-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("k1xqL");
var $a8Jhy = parcelRequire("a8Jhy");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");
const $edb29ea8e109e6d3$var$quoteStyles = null;
const $edb29ea8e109e6d3$var$quotePStyles = null;
const $edb29ea8e109e6d3$var$portraitStyles = null;
const $edb29ea8e109e6d3$var$nameStyles = null;
const $edb29ea8e109e6d3$var$titleStyles = null;
const $edb29ea8e109e6d3$var$quoteSrcMap = {
    yellow: "https://dam-cdn.atl.orangelogic.com/AssetLink/3ixqjd5540sdn251h25h55i82occ48sa.svg",
    purple: "https://dam-cdn.atl.orangelogic.com/AssetLink/0ho3162460jba51mgj0a16k3cpvy074s.svg",
    lime: "https://dam-cdn.atl.orangelogic.com/AssetLink/q6j1k002cmxpvr2145m8q3u70gfrm2qt.svg",
    blue: "https://dam-cdn.atl.orangelogic.com/AssetLink/504175ycu5d01061dg4evte5l0m72pea.svg",
    none: ""
};
const $edb29ea8e109e6d3$var$TestimonialQuote = ({ quoteText: quoteText, customerName: customerName, customerTitle: customerTitle, quoteColor: quoteColor, colorAgainst: colorAgainst })=>{
    const quoteImage = {
        src: $edb29ea8e109e6d3$var$quoteSrcMap[quoteColor],
        alt: customerTitle
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_11q7qbzx _ca0q1ul9 _u5f3gktf _n3td1ul9 _19bv53f4 _kqswh2mm _1pfhzwfg _14dk1fw0"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyr1j6v _18u0idpf _ect4bzd7 _1wybdlk8 _k48p1nn1 _vwz4gktf _y3gn1e5h",
                            "body-sm"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: quoteText
                    }),
                    quoteColor !== "none" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1bsb88uy _1e02gktf _152tgktf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: quoteImage
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1mt11ul9",
                            "body-sm name"
                        ]),
                        children: customerName
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1p1dangw",
                            "fine-print"
                        ]),
                        children: customerTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a8Jhy.Adg4SectionDivider), {
                variation: (0, $a8Jhy.SECTION_DIVIDER_VARIATION).FLIP,
                desktopHeight: 15,
                tabletHeight: 15,
                mobileHeight: 15,
                bgColor: "var(--ds-surface-sunken, #F7F8F9)",
                colorAgainst: colorAgainst
            })
        ]
    });
};
var $edb29ea8e109e6d3$export$2e2bcd8739ae039 = $edb29ea8e109e6d3$var$TestimonialQuote;

});


parcelRegister("dMCHr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1835431f38c452b$export$2e2bcd8739ae039; });
/* side-by-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $imIsw = parcelRequire("imIsw");
parcelRequire("5kb8q");
var $4hIcA = parcelRequire("4hIcA");
const $d1835431f38c452b$var$SideBySide = ()=>{
    const intl = (0, $8e22h.default)();
    const items = [
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.1.title",
                defaultMessage: "Bring structure to chaos"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.1.description",
                defaultMessage: "Leverage data and customer insights to help your team prioritize ideas that will make the biggest impact."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8i4ut65m3p28wvyedk7505mtqm5kiqr3.webp",
                alt: "",
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.2.title",
                defaultMessage: "Get everyone on the same page"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.2.description",
                defaultMessage: "Spend less time updating and persuading with custom roadmaps that give your stakeholders the information they need."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g5xp0826vanhei54fi3437v7nr227cn7.webp",
                alt: "",
                width: 768,
                height: 512
            }
        },
        {
            title: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.3.title",
                defaultMessage: "Connect discovery and delivery in Jira"
            }),
            description: intl.formatMessage({
                id: "JiraProductDiscoveryPage.scroller.3.description",
                defaultMessage: "Reduce context switching, add visibility, and move faster by seamlessly connecting your ideas to the delivery work happening in Jira."
            }),
            img: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/767r1t8n744265g8k4550obw1udklx2f.webp",
                alt: "",
                width: 768,
                height: 512
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1reozryt"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4hIcA.Scroller), {
                items: items,
                renderText: (item)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d1835431f38c452b$var$ScrollerContent, {
                        item: item
                    }),
                renderGraphic: (item)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: item.img,
                        className: (0, $2jatx.default)([
                            "_p12f1osq _rtys1osq _bna71wug"
                        ])
                    }),
                layout: "right",
                mobileGraphicLayout: "above",
                backgroundColor: "#fff",
                inScrollBackgroundColor: "#fff",
                heading: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _1bsb1osq _1e0c11p5 _85i5xy5q"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_6rthidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.scroller.heading.text",
                                defaultMessage: "Discover your next great product idea"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.scroller.subheading.text",
                                defaultMessage: "Better product decisions are made as a team"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $d1835431f38c452b$export$2e2bcd8739ae039 = $d1835431f38c452b$var$SideBySide;
const $d1835431f38c452b$var$ScrollerContent = ({ item: item })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                children: item.title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: item.description
            })
        ]
    });
};
const $d1835431f38c452b$var$sectionStyle = null;
const $d1835431f38c452b$var$scrollerHeading = null;
const $d1835431f38c452b$var$heading = null;
const $d1835431f38c452b$var$imgStyle = null;

});
parcelRegister("5kb8q", function(module, exports) {
$parcel$export(module.exports, "Scroller", function () { return (parcelRequire("4hIcA")).Scroller; });
parcelRequire("4hIcA");

});
parcelRegister("4hIcA", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", function () { return $7dccf64997c912da$export$dece24112a937f92; });
$parcel$export(module.exports, "Scroller", function () { return $7dccf64997c912da$export$76d6749d1cf8513c; });
/* scroller.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $Yd0go = parcelRequire("Yd0go");
const $7dccf64997c912da$export$dece24112a937f92 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    activeIndex: 0,
    setActiveIndex: ()=>{
        return;
    },
    graphicHeight: 100,
    graphicTopBottom: {
        top: 188,
        bottom: 288
    }
});
const $7dccf64997c912da$export$76d6749d1cf8513c = ({ items: items, renderText: renderText, renderGraphic: renderGraphic, heading: heading, layout: layout = "left", mobileGraphicLayout: mobileGraphicLayout = "above", backgroundColor: backgroundColor = "#fff", inScrollBackgroundColor: inScrollBackgroundColor, scrollerInViewOptions: scrollerInViewOptions, navHeight: navHeight = 68 })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)((0, $6ogO3._)({
        threshold: 0.2
    }, scrollerInViewOptions));
    const containerRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const graphicRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const headingRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(0);
    /**
   * The calculated top position to use for the graphic
   */ const [graphicTop, setGraphicTop] = (0, $1oC0p.useState)(navHeight + 100);
    /**
   * The height of the graphic, used to set min height on the text column
   */ const [graphicHeight, setGraphicHeight] = (0, $1oC0p.useState)(null);
    /**
   * The calculated top and bottom positions
   * to use for determining if an item is aligned with the graphic
   */ const [graphicTopBottom, setGraphicTopBottom] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (!containerRef.current || !graphicRef.current || !headingRef.current || !window) return;
        // Where the magic happens
        const calculateSizes = ()=>{
            var _graphicRef_current, _headingRef_current;
            var _graphicRef_current_clientHeight;
            // Vertically center the graphic +navHeight for the sticky nav
            const currentGraphicHeight = (_graphicRef_current_clientHeight = (_graphicRef_current = graphicRef.current) === null || _graphicRef_current === void 0 ? void 0 : _graphicRef_current.clientHeight) !== null && _graphicRef_current_clientHeight !== void 0 ? _graphicRef_current_clientHeight : 100;
            var _headingRef_current_clientHeight;
            const currentHeaderHeight = (_headingRef_current_clientHeight = (_headingRef_current = headingRef.current) === null || _headingRef_current === void 0 ? void 0 : _headingRef_current.clientHeight) !== null && _headingRef_current_clientHeight !== void 0 ? _headingRef_current_clientHeight : 100;
            const viewHeight = window.innerHeight;
            const minGraphicY = navHeight + currentHeaderHeight;
            const top = (viewHeight - navHeight - currentGraphicHeight) / 2 + navHeight;
            const newTop = Math.max(minGraphicY, top);
            const newBottom = Math.min(viewHeight, newTop + currentGraphicHeight);
            setGraphicTop(Math.max(minGraphicY, top));
            setGraphicHeight(currentGraphicHeight);
            setGraphicTopBottom({
                top: newTop,
                bottom: newBottom
            });
        };
        const observer = new ResizeObserver(()=>{
            // Use requestAnimationFrame to defer DOM updates and prevent ResizeObserver loop limit errors
            // This helps prevent the "ResizeObserver loop limit exceeded" warning by deferring DOM updates
            requestAnimationFrame(()=>{
                calculateSizes();
            });
        });
        observer.observe(containerRef.current);
        return ()=>{
            // Cleanup the observer by unobserving all elements
            observer.disconnect();
        };
    }, [
        containerRef,
        graphicRef,
        headingRef,
        navHeight
    ]);
    const backgroundStyle = null;
    const inViewBackgroundStyle = null;
    const dynamicHeadingStyle = null;
    const inViewHeaderBackgroundStyle = null;
    var _items_activeIndex;
    const currentItem = (_items_activeIndex = items[activeIndex]) !== null && _items_activeIndex !== void 0 ? _items_activeIndex : items[0];
    return /*#__PURE__*/ (0, $7VQPk.jsx)($7dccf64997c912da$export$dece24112a937f92.Provider, {
        value: {
            activeIndex: activeIndex,
            setActiveIndex: setActiveIndex,
            graphicHeight: graphicHeight,
            graphicTopBottom: graphicTopBottom
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_bfhkaxbu",
                sectionIsVisible && "_bfhk1tlu"
            ]),
            style: {
                "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                "--_1p67x28": (0, $6ZVlx.default)(inScrollBackgroundColor)
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                ref: containerRef,
                className: (0, $2jatx.default)([
                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                    "_85i568cl _1q51mgvx _4cvr1y6m _zulp1wqb _10l5idpf _1w2i1bp4",
                    layout === "right" && "_2lx21sbv"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: {
                            insetBlockEnd: graphicHeight ? graphicHeight + $7dccf64997c912da$var$contentBlockEnd + "px" : "auto"
                        },
                        className: (0, $2jatx.default)([
                            "_kqswstnw _152tidpf _1e02idpf _rjxpidpf _1e0c1txw _1bah1h6o _rolbh2mm"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_16jlkb7n _1o9zkb7n _i0dl1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                ref: headingRef,
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _1e0c1txw _2lx2vrvc _18zrzwfg _umua1wqb _owpu1wqb _gltezqdx",
                                    "_152t1gys",
                                    "_1pbykb7n _kqsw1if8 _rolbh2mm _14ucidpf",
                                    sectionIsVisible && "_1itk1qvr"
                                ]),
                                style: {
                                    "--_l57dfm": (0, $6ZVlx.default)(navHeight ? navHeight + "px" : 0),
                                    "--_1p67x28": (0, $6ZVlx.default)(inScrollBackgroundColor)
                                },
                                children: heading
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_i0dlhwvj _311g1kc5 _c7541h6o"
                        ]),
                        children: items.map((item, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $Yd0go.ScrollerItem), {
                                index: i,
                                children: [
                                    mobileGraphicLayout === "above" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    }),
                                    renderText(item),
                                    mobileGraphicLayout === "below" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0cglyw _1yba1ule"
                                        ]),
                                        children: renderGraphic(item, activeIndex, true)
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: graphicRef,
                        style: {
                            insetBlockStart: graphicTop + "px"
                        },
                        className: (0, $2jatx.default)([
                            "_4cvresu3 _1e0c1txw _2lx21bp4 _1bah1h6o _i0dl1nrf _kqsw1if8 _1ybaglyw"
                        ]),
                        children: renderGraphic(currentItem, activeIndex, false)
                    })
                ]
            })
        })
    });
};
const $7dccf64997c912da$var$mediaQuery = "@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)";
const $7dccf64997c912da$var$contentBlockEnd = 120;
const $7dccf64997c912da$var$rowStyles = null;
const $7dccf64997c912da$var$contentStyle = null;
const $7dccf64997c912da$var$headingContainer = null;
const $7dccf64997c912da$var$headingColumnContainer = null;
const $7dccf64997c912da$var$headingStyle = null;
const $7dccf64997c912da$var$rtlRowStyles = null;
const $7dccf64997c912da$var$textColumn = null;
const $7dccf64997c912da$var$mobileItemStyle = null;
const $7dccf64997c912da$var$graphicColumn = null;

});
parcelRegister("Yd0go", function(module, exports) {
$parcel$export(module.exports, "ScrollerItem", function () { return $4fd71dbca21309e3$export$11692ab46144d76c; });
/* scroller-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $4hIcA = parcelRequire("4hIcA");
const $4fd71dbca21309e3$export$11692ab46144d76c = ({ children: children, index: index })=>{
    const { ref: scrollRef, inView: sectionInView } = (0, $jKShK.useInView)({
        threshold: 0.25
    });
    const itemRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const { setActiveIndex: setActiveIndex, graphicHeight: graphicHeight, graphicTopBottom: graphicTopBottom } = (0, $1oC0p.useContext)((0, $4hIcA.ScrollContext));
    (0, $1oC0p.useEffect)(()=>{
        if (!document) return;
        const checkElementPosition = ()=>{
            if (!itemRef.current || !graphicTopBottom || !sectionInView) return;
            const rect = itemRef.current.getBoundingClientRect();
            const top = rect.top;
            const bottom = rect.bottom;
            // check if this element overlaps with the top or bottom of the graphic
            if (top >= graphicTopBottom.top && top <= graphicTopBottom.bottom || bottom >= graphicTopBottom.top && bottom <= graphicTopBottom.bottom) setActiveIndex(index);
        };
        document.addEventListener("scroll", checkElementPosition);
        return ()=>{
            document.removeEventListener("scroll", checkElementPosition);
        };
    }, [
        setActiveIndex,
        index,
        itemRef,
        graphicTopBottom,
        sectionInView
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: scrollRef,
        style: {
            minHeight: graphicHeight ? graphicHeight + "px" : "auto"
        },
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1osq _c71l1a8x _1e0c1txw _2lx21bp4 _1bah1h6o _37sk1kxc _19yo1h90 _14q01wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: itemRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _tzy4kb7n _zulp12am _2lx21bp4"
            ]),
            children: children
        })
    });
};
const $4fd71dbca21309e3$var$mediaQuery = "@media (max-height: 49.99vw) and (max-width: 1271.99px), (max-height: 635.99px) and (min-width: 1272px), not all and (min-width: 48rem)";
const $4fd71dbca21309e3$var$itemWrapperStyle = null;
const $4fd71dbca21309e3$var$itemStyle = null;

});




parcelRegister("5OLfs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $545a9ce8cb3bf6be$export$2e2bcd8739ae039; });
/* video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");
parcelRequire("8EEDU");
var $hBYvx = parcelRequire("hBYvx");

var $jMhSx = parcelRequire("jMhSx");
const $545a9ce8cb3bf6be$var$HeroVideo = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _4cvr1h6o _6a6z1h6o _1pfhmgjw _6rthxy5q _1ob9xncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        alt: "",
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/eskxgojb0g32x168w8yg8g7g2586005n.svg"
                    },
                    className: (0, $2jatx.default)([
                        "_t9ec120f _yyhyrgcp _1ii7rgcp _1bsbj6kd"
                    ])
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), {
                    loop: true,
                    muted: true,
                    // existing video that is low priority to move over to brandfolder
                    // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                    videoLink: "https://wac-cdn.atlassian.com/misc-assets/videos/jira-product-discovery/JPD_product-tour_hero.mp4",
                    className: (0, $2jatx.default)([
                        "_1reozryt _18m9zryt _1h1tcq2i _2rko1kwk _kdam1319 _yyhyrgcp _1ii7rgcp _t9eck9uq _14dmvqnv _sfej3ovx"
                    ])
                })
            ]
        })
    });
};
var $545a9ce8cb3bf6be$export$2e2bcd8739ae039 = $545a9ce8cb3bf6be$var$HeroVideo;
const $545a9ce8cb3bf6be$var$container = null;
const $545a9ce8cb3bf6be$var$video = null;
const $545a9ce8cb3bf6be$var$bgImage = null;

});

parcelRegister("8yYDi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $98f22cdf3b645268$export$2e2bcd8739ae039; });
/* workflow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $imIsw = parcelRequire("imIsw");

var $jMhSx = parcelRequire("jMhSx");
const $98f22cdf3b645268$var$Workflow = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _11q7m7j4 _195g1wug _1rjcoahv _2oz41k92 _1hr2kd3c _ecdxxy5q _6ru51ris"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_1mouidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.workflow.heading",
                                defaultMessage: "Connect your entire workflow with Jira"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "JiraProductDiscoveryPage.workflow.body.text",
                                defaultMessage: "From strategy and ideation through planning and delivery, bring your entire software lifecycle together in Jira"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1036e8r078n724ru6bb24rdl38bot0iu.webp",
                        alt: ""
                    },
                    className: (0, $2jatx.default)([
                        "_rtys1osq _bna71wug"
                    ])
                })
            ]
        })
    });
};
var $98f22cdf3b645268$export$2e2bcd8739ae039 = $98f22cdf3b645268$var$Workflow;
const $98f22cdf3b645268$var$section = null;
const $98f22cdf3b645268$var$img = null;
const $98f22cdf3b645268$var$bodyContent = null;

});




parcelRegister("6PSGm", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $9d1bf4b2a97507ae$export$933c1404a4ee79b; });

var $32ng3 = parcelRequire("32ng3");
const $9d1bf4b2a97507ae$export$933c1404a4ee79b = ()=>{
    const checkGate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jiraProductDiscoveryPremiumWacUpdates);
    return checkGate ? "Jira Product Discovery Pricing Page (GWP-5783)" : "Jira Product Discovery Pricing Page";
};

});

parcelRegister("04Umd", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPricingPage", function () { return $de4035e7cb1b46bd$export$4771e0906f773aa4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $kCFWz = parcelRequire("kCFWz");
const $de4035e7cb1b46bd$export$4771e0906f773aa4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "jira-product-discovery",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "jpd-pricing-page",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kCFWz.JiraProductDiscoveryPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("kCFWz", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPricingPageTemplate", function () { return $c0b6d853aac0ee5e$export$6c2556bd70f89142; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $2zOxm = parcelRequire("2zOxm");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $bE8d4 = parcelRequire("bE8d4");

var $fhttR = parcelRequire("fhttR");

var $aYwTu = parcelRequire("aYwTu");

var $aRBTI = parcelRequire("aRBTI");

var $dEsrl = parcelRequire("dEsrl");
const $c0b6d853aac0ee5e$export$6c2556bd70f89142 = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
            nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYwTu.default), {}),
            banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fhttR.JPDBanner), {}),
            showFallback: content === null || content === void 0 ? void 0 : content.hasError,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                scrollTrackingEnabled: true,
                pageId: "jpd-pricing-page",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                        children: content === null || content === void 0 ? void 0 : content.headline
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aRBTI.JiraProductDiscoveryPriceFinder), {
                        pricing: props.pricing,
                        countryCode: props.countryCode
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                        title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                        comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                        compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                                planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dEsrl.JpdQuestionsCta), {})
                ]
            })
        })
    });
};

});
parcelRegister("aRBTI", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryPriceFinder", function () { return $3fd601000846fcbe$export$b36576908b6a3c15; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $dl2JF = parcelRequire("dl2JF");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $3fd601000846fcbe$export$b36576908b6a3c15 = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium")
    };
    const addSignupSourceToUrlsOnPricingPageEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage);
    const signupUrlSourceQueryParam = addSignupSourceToUrlsOnPricingPageEnabled ? "&signupSource=pricing" : "";
    var _content_free_planTitleExternal, _content_free_planOneLiner, _content_standard_planTitleExternal, _content_standard_planOneLiner, _content_premium_planTitleExternal, _content_premium_planOneLiner;
    const jiraProductDiscoveryProductPlans = [
        {
            planName: (_content_free_planTitleExternal = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) !== null && _content_free_planTitleExternal !== void 0 ? _content_free_planTitleExternal : "Free",
            offeringSku: "jira-servicedesk-free",
            description: (_content_free_planOneLiner = (_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            recommendationLimit: 0,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-product-discovery&edition=free&signupSource=pricing"
        },
        {
            planName: (_content_standard_planTitleExternal = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) !== null && _content_standard_planTitleExternal !== void 0 ? _content_standard_planTitleExternal : "Standard",
            offeringSku: "jira-product-discovery-standard",
            description: (_content_standard_planOneLiner = (_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            recommendationLimit: 3,
            signupLimit: 20000,
            signupURLSuffix: `?bundle=jira-product-discovery&edition=standard${signupUrlSourceQueryParam}`
        },
        {
            planName: (_content_premium_planTitleExternal = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) !== null && _content_premium_planTitleExternal !== void 0 ? _content_premium_planTitleExternal : "Premium",
            offeringSku: "jira-product-discovery-premium-sku",
            description: (_content_premium_planOneLiner = (_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            recommendationLimit: 50,
            signupLimit: 20000,
            signupURLSuffix: `?bundle=jira-product-discovery&edition=premium${signupUrlSourceQueryParam}`
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "creators"
        },
        unitCountInputText: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many agents are on your team?"
        },
        cardOverSignupLimit: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your agent count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more agents above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraProductDiscoveryPricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "Creator tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraProductDiscoveryPricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per creator / month"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
        dataProductKey: "jiraProductDiscovery",
        productPlans: jiraProductDiscoveryProductPlans,
        defaultUnitCount: 10,
        enterpriseMinimumCount: 201,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
            messages: messages,
            serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraProductDiscovery,
            countryCode: props.countryCode
        })
    });
};
$3fd601000846fcbe$export$b36576908b6a3c15.displayName = "JiraProductDiscoveryPriceFinder";

});

parcelRegister("dEsrl", function(module, exports) {
$parcel$export(module.exports, "JpdQuestionsCta", function () { return $062ddb31541d908d$export$5481e63b06ebf9c4; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("g1ccm");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");

var $kooLp = parcelRequire("kooLp");
const $062ddb31541d908d$export$5481e63b06ebf9c4 = ()=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const questionsCtaHref = `https://www.atlassian.com${(0, $kooLp.useLocalizedHref)("/licensing/jira-product-discovery#jira-product-discovery")}`;
    var _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
        product: "Jira Product Discovery",
        ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : questionsCtaHref,
        questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
        priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
        questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
        imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
    });
};

});



parcelRegister("fTJHm", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorLpJsmAsset", function () { return $c44799f5234bc6cd$export$fd3c22504cf8dc2a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $c44799f5234bc6cd$export$fd3c22504cf8dc2a = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-asset",
        persona: "unknown",
        pageVariant: "asset",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});
parcelRegister("1DjVm", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePagePaidLpJsmAnchor", function () { return $5f86d0cde7cf45ec$export$c1457b2e098e9b28; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $gHIMV = parcelRequire("gHIMV");

var $8e22h = parcelRequire("8e22h");

var $a0utR = parcelRequire("a0utR");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $a5uC7 = parcelRequire("a5uC7");

var $kZQhV = parcelRequire("kZQhV");

var $gx3aw = parcelRequire("gx3aw");

var $32ng3 = parcelRequire("32ng3");

var $28AH4 = parcelRequire("28AH4");

var $ig7Vf = parcelRequire("ig7Vf");

var $gSzjE = parcelRequire("gSzjE");
const $5f86d0cde7cf45ec$var$LANDING_TYPE = "jira-service-management-anchor";
const $5f86d0cde7cf45ec$export$c1457b2e098e9b28 = ({ anchorContents: anchorContents, persona: persona, teamType: teamType, pageId: pageId, pageVariant: pageVariant, animatedJiraTourProps: animatedJiraTourProps, bannerAlertProps: bannerAlertProps, signupEdition: signupEdition, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $8e22h.default)();
    const enableCustomerServiceManagementLogo = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).enableCsmAjLogo) && pageId === "anchor-lp-jsm-csm";
    const productHref = (0, $kooLp.useLocalizedHref)(enableCustomerServiceManagementLogo ? "/software/customer-service-management" : "/software/jira/service-management");
    const [content, setContent] = (0, $1oC0p.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const customHeadline = intl.formatMessage({
        id: "jira.servicemanagement.anchor.paidlpjsmitsm.variantb",
        defaultMessage: "End bad service management"
    });
    const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
    if ((0, $ig7Vf.isAuxiaServedPage)(auxiaResponse)) createAnalyticsEvent({
        name: "getAuxiaJsmPaidLpTreatmentSuccess",
        action: "getAuxiaJsmPaidLpTreatmentSuccess",
        actionSubject: "auxiaPage",
        eventType: "operational",
        source: window.location.pathname,
        attributes: {
            pageUrl: window.location.href,
            anonymousId: anonymousId,
            auxiaResponse: auxiaResponse
        }
    }).fire();
    else if ((0, $ig7Vf.isAuxiaResponseMalformed)(auxiaResponse)) createAnalyticsEvent({
        name: "getAuxiaJsmPaidLpTreatmentFailure",
        action: "getAuxiaJsmPaidLpTreatmentFailure",
        actionSubject: "auxiaPage",
        eventType: "operational",
        source: window.location.pathname,
        attributes: {
            pageUrl: window.location.href,
            anonymousId: anonymousId,
            auxiaResponse: auxiaResponse
        }
    }).fire();
    (0, $1oC0p.useEffect)(()=>{
        setAnchorLocalStorage({
            persona: persona,
            teamTypeInferredMl: teamType,
            team: ""
        });
        if ((0, $ig7Vf.isAuxiaServedPage)(auxiaResponse)) {
            setContent(auxiaResponse.auxiaTreatment);
            (0, $gSzjE.sendAnalyticsToAuxia)({
                anonymousId: anonymousId,
                treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                treatmentId: auxiaResponse.treatmentId,
                interactionType: "VIEWED",
                interactionTimeMicros: (0, $gSzjE.convertDateTimeToInteractionTimeMicros)(Date.now())
            });
        } else setContent(anchorContents);
    // We only want to run this useEffect once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!content) // TODO: loading UI for static renders
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const tabsProps = $5f86d0cde7cf45ec$var$getTabProps(content);
    const tabsHasTestimonials = tabsProps && tabsProps.tabs && tabsProps.tabs[0] ? tabsProps.tabs[0].isIncludeTestimony : null;
    const heroProps = $5f86d0cde7cf45ec$var$getHeroProps({
        resp: content,
        pageVariant: pageVariant,
        customHeadline: customHeadline,
        isAuxiaServedPage: !!(0, $ig7Vf.isAuxiaServedPage)(auxiaResponse)
    });
    const heroImageSubheader = heroProps.tertiaryText;
    const servCoBanner = {
        identifier: "jira-service-management.banner-alert.service-collection",
        text: intl.formatMessage({
            id: "jira-service-management.banner-alert.service-collection.text",
            defaultMessage: "Jira Service Management is now more powerful than ever as part of Service Collection. Unlock exceptional service experiences with Rovo, Assets, and our new Customer Service Management app."
        }),
        linkText: intl.formatMessage({
            id: "jira-service-management.banner-alert.service-collection.cta",
            defaultMessage: "Try it now"
        }),
        linkUrl: "/try/cloud/signup?bundle=service-collection&edition=premium",
        hasProductNavBar: true
    };
    const paidJSMBannerAlertProps = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8577ServiceCollectionBanners) ? servCoBanner : bannerAlertProps;
    const logoProductName = enableCustomerServiceManagementLogo ? "customerservicemanagement" : "jiraservicemanagement";
    const logoAriaLabel = enableCustomerServiceManagementLogo ? intl.formatMessage({
        id: "wacCustomerServiceManagementNavigation.logo-label",
        defaultMessage: "Customer Service Management logo"
    }) : intl.formatMessage({
        id: "wacJiraServiceManagementNavigation.logo-label",
        defaultMessage: "Jira Service Management logo"
    });
    const props = {
        landingType: $5f86d0cde7cf45ec$var$LANDING_TYPE,
        pageId: pageId,
        animatedJiraTourProps: animatedJiraTourProps,
        showHorizontalRule: !tabsHasTestimonials,
        productNavProps: {
            productHref: productHref,
            productName: logoProductName,
            ariaLabel: logoAriaLabel,
            dataProductKey: "jiraServiceManagement",
            showFreeHrefButton: false,
            logoLinkWrapperWidth: "279px"
        },
        heroProps: (0, $dPABA._)((0, $6ogO3._)({}, heroProps), {
            signup: (0, $dPABA._)((0, $6ogO3._)({}, heroProps.signup), {
                edition: signupEdition
            })
        }),
        tabsProps: tabsProps,
        bannerAlertProps: paidJSMBannerAlertProps,
        bannerProps: $5f86d0cde7cf45ec$var$getBannerProps(content),
        ctaProps: $5f86d0cde7cf45ec$var$getCtaProps(content),
        testimonialProps: $5f86d0cde7cf45ec$export$aa9a7bf59732070a(content),
        alternatingTextAndImageProps: $5f86d0cde7cf45ec$var$getAlternatingTextAndImageProps(content),
        heroImageSubheader: heroImageSubheader,
        heroBgColor: "bgBlackBlue",
        hasRebrandedSignupFormStyles: true,
        auxiaResponse: auxiaResponse
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kZQhV.PaidLandingTemplate), (0, $6ogO3._)({}, props));
};
const $5f86d0cde7cf45ec$var$heroFeatureMatrix = {
    "asset": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "automation": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "competitors": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "csm": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "devops": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "esm": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "features": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "features-cerebro": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "incidentchangemgmt": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "incident-changemgmt": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "itsm": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "service-desk": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "ticketing": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "marketing": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "engineering": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "hr": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "legal": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "operations": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "design": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    },
    "customerservice": {
        useNewHero: true,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: true,
        showStaticImage: false
    }
};
const $5f86d0cde7cf45ec$var$getHeroFeatures = (pageVariant)=>{
    const defaultFeatures = {
        useNewHero: false,
        showAnimatedHero: false,
        animatedSocialBanner: false,
        darkSolidTheme: false,
        showStaticImage: false
    };
    return $5f86d0cde7cf45ec$var$heroFeatureMatrix[pageVariant] || defaultFeatures;
};
const $5f86d0cde7cf45ec$var$getHeroProps = ({ resp: resp, pageVariant: pageVariant, customHeadline: customHeadline })=>{
    const defaultProps = {
        theme: "light-on-dark",
        headerText: "",
        secondaryText: "",
        signup: {
            bundle: "jira-service-management",
            edition: "free",
            featureFlags: {
                enableDefaultExpandedEmail: false,
                enableDeferredFullName: true
            }
        }
    };
    if (!resp || !resp[0]) return defaultProps;
    const { headline: headline } = resp[0].node;
    const nodeName = resp[0].node.name;
    const data = headline && headline[0] ? headline[0] : null;
    const planBenefits = (data === null || data === void 0 ? void 0 : data.planBenefits) && (data === null || data === void 0 ? void 0 : data.planBenefits[0]) ? data === null || data === void 0 ? void 0 : data.planBenefits[0] : null;
    const supportingAsset = planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.supportingAsset;
    const features = $5f86d0cde7cf45ec$var$getHeroFeatures(pageVariant);
    const getImage = (url, description)=>url && description ? {
            src: url ? url : "",
            alt: description || ""
        } : undefined;
    const getFeaturesRawHtml = ()=>planBenefits && planBenefits.planFeatures && planBenefits.planFeatures[0] ? planBenefits.planFeatures[0].description || "" : "";
    return (0, $dPABA._)((0, $6ogO3._)({}, defaultProps, features), {
        headerText: customHeadline && customHeadline.length > 0 && nodeName == "paid-lp-jsm-itsm" && !(0, $ig7Vf.isAuxiaServedPage) ? customHeadline : (data === null || data === void 0 ? void 0 : data.name) || "",
        secondaryText: (data === null || data === void 0 ? void 0 : data.subheading) || "",
        image: getImage(supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url, supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description),
        featuresRawHtml: getFeaturesRawHtml(),
        tertiaryText: (planBenefits === null || planBenefits === void 0 ? void 0 : planBenefits.description) || ""
    });
};
const $5f86d0cde7cf45ec$var$getTabProps = (resp)=>{
    const defaultProps = {
        dataProductKey: "jiraSoftware-PaidLpJiraPm",
        headerText: "",
        tabStyles: {
            defaultBG: (0, $kbpa7.wacToken)("color.neutral.light200"),
            defaultText: (0, $kbpa7.wacToken)("color.extended.blue900"),
            hoverBG: (0, $kbpa7.wacToken)("color.neutral.light200"),
            hoverText: (0, $kbpa7.wacToken)("color.extended.blue900"),
            activeBG: (0, $kbpa7.wacToken)("color.extended.blue100"),
            activeText: (0, $kbpa7.wacToken)("color.extended.blue900")
        },
        styles: {
            "--lp-tabs-hover": (0, $kbpa7.wacToken)("color.extended.blue700"),
            "--lp-tabs-unselected": (0, $kbpa7.wacToken)("color.extended.blue900")
        },
        tabs: undefined
    };
    if (!resp || !resp[0]) return defaultProps;
    const tabs = $5f86d0cde7cf45ec$var$getTabs(resp);
    const primaryMessage = $5f86d0cde7cf45ec$var$getPrimaryMessage(resp);
    return (0, $dPABA._)((0, $6ogO3._)({}, defaultProps), {
        landingType: $5f86d0cde7cf45ec$var$LANDING_TYPE,
        headerText: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.name) || "",
        tabs: tabs
    });
};
const $5f86d0cde7cf45ec$var$getBannerProps = (resp)=>{
    var _banner_bannerImage, _banner_bannerImage1;
    const banner = $5f86d0cde7cf45ec$var$getBanner(resp);
    if (!banner) return undefined;
    return {
        headerText: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))((banner === null || banner === void 0 ? void 0 : banner.text) || "")
            }
        }),
        isBannerRichText: true,
        imageLink: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage = banner.bannerImage) === null || _banner_bannerImage === void 0 ? void 0 : _banner_bannerImage.url) || "",
        imageAltText: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage1 = banner.bannerImage) === null || _banner_bannerImage1 === void 0 ? void 0 : _banner_bannerImage1.description) || "imageAltText",
        imagePosition: "left",
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue200"),
        ctaProps: {
            buttonProps: {
                text: (banner === null || banner === void 0 ? void 0 : banner.urlText) || "",
                url: (banner === null || banner === void 0 ? void 0 : banner.url) || "",
                color: "darkblue",
                type: "secondary"
            }
        },
        margin: "60px 0"
    };
};
const $5f86d0cde7cf45ec$var$getCtaProps = (resp)=>{
    const cta = $5f86d0cde7cf45ec$var$getCta(resp);
    return {
        headerText: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
        ctaProps: {
            buttonProps: {
                color: "yellow",
                url: (cta === null || cta === void 0 ? void 0 : cta.url) || "",
                text: (cta === null || cta === void 0 ? void 0 : cta.text) || "",
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-container": "ctaSection",
                    "data-event-component": "linkButton",
                    "data-product-key": "jiraSoftware"
                }
            }
        },
        backgroundProperties: {
            textColor: (0, $kbpa7.wacToken)("color.neutral.light0")
        }
    };
};
const $5f86d0cde7cf45ec$export$aa9a7bf59732070a = (resp)=>{
    var _data_customers;
    if (!resp || !resp[0]) return undefined;
    const { socialProof: socialProof } = resp[0].node;
    const data = socialProof && socialProof[0] ? socialProof[0] : null;
    if (!data) return undefined;
    return {
        headerText: data === null || data === void 0 ? void 0 : data.name,
        logos: (data === null || data === void 0 ? void 0 : (_data_customers = data.customers) === null || _data_customers === void 0 ? void 0 : _data_customers.map((customer)=>{
            return {
                src: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].url) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].url : "",
                alt: customer && customer.logo && (customer === null || customer === void 0 ? void 0 : customer.logo[0]) && (customer === null || customer === void 0 ? void 0 : customer.logo[0].description) ? customer === null || customer === void 0 ? void 0 : customer.logo[0].description : "",
                lazy: true
            };
        })) || []
    };
};
const $5f86d0cde7cf45ec$var$getAlternatingTextAndImageProps = (resp)=>{
    const results = $5f86d0cde7cf45ec$var$getResults(resp);
    function generateProps(result, index) {
        var _result_asset, _result_asset1;
        // this shouldn't go past
        const countMap = [
            "one",
            "two",
            "three",
            "four"
        ];
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($gHIMV)))(`${countMap[index]}`);
        const position = index % 2 === 0 ? "left" : "right";
        return {
            [`row${count}Header`]: (result === null || result === void 0 ? void 0 : result.name) || "",
            [`row${count}Body`]: (result === null || result === void 0 ? void 0 : result.subheading) || "",
            [`row${count}ImageLink`]: result === null || result === void 0 ? void 0 : (_result_asset = result.asset) === null || _result_asset === void 0 ? void 0 : _result_asset.url,
            //getLocalizedImage("row one", intl.locale),
            [`row${count}ImageAltText`]: (result === null || result === void 0 ? void 0 : (_result_asset1 = result.asset) === null || _result_asset1 === void 0 ? void 0 : _result_asset1.description) || "",
            [`row${count}ImagePosition`]: position
        };
    }
    const contentBlocks = results === null || results === void 0 ? void 0 : results.map((result, index)=>generateProps(result, index)).slice(0, 4) // ensure max of 4 results so we don't break the pattern
    .filter((result)=>!!result).reduce((acc, curr)=>{
        return (0, $6ogO3._)({}, acc, curr);
    });
    return (0, $6ogO3._)({
        imageWidth: "100%",
        imageTextSideRowOnePaddingBelowLargeScreen: "32px 0 16px",
        imageTextSideRowTwoPadding: "16px 0",
        imageTextSideRowThreePaddingBelowLargeScreen: "16px 0 32px"
    }, contentBlocks);
};
const $5f86d0cde7cf45ec$var$getPrimaryMessage = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { primaryMessage: primaryMessage } = resp[0].node;
    const data = primaryMessage && primaryMessage[0] ? primaryMessage[0] : null;
    return data;
};
const $5f86d0cde7cf45ec$var$getTabs = (resp)=>{
    const primaryMessage = $5f86d0cde7cf45ec$var$getPrimaryMessage(resp);
    if (!primaryMessage || !(primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.supportingExample)) return undefined;
    return primaryMessage.supportingExample.filter((tab)=>tab !== null)// eslint-disable-next-line complexity
    .map((tab)=>{
        var _advocateQuote_advocateHeadshot, _advocateQuote_advocateHeadshot1;
        const supportingAsset = tab === null || tab === void 0 ? void 0 : tab.supportingAsset;
        const advocateQuote = tab === null || tab === void 0 ? void 0 : tab.advocateQuote;
        const isIncludeTestimony = !!(tab === null || tab === void 0 ? void 0 : tab.advocateQuote);
        return {
            textLabel: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            id: (tab === null || tab === void 0 ? void 0 : tab.name) || "",
            isIncludeTestimony: isIncludeTestimony,
            component: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a5uC7.default), {
                isShowTestimonyBorder: isIncludeTestimony,
                isIncludeTestimony: isIncludeTestimony,
                testimonyIsUsingTextQuotationMarks: false,
                title: (tab === null || tab === void 0 ? void 0 : tab.heading) || "",
                rawHtmlContent: (tab === null || tab === void 0 ? void 0 : tab.proofpoint) || "",
                imageSrc: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.url) || "",
                imageAlt: (supportingAsset === null || supportingAsset === void 0 ? void 0 : supportingAsset.description) || "",
                quoteBlurb: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateQuote) || "",
                quoteName: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateName) || "",
                quoteCompany: (advocateQuote === null || advocateQuote === void 0 ? void 0 : advocateQuote.advocateJobTitle) || "",
                testimonyImageSrc: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot === void 0 ? void 0 : _advocateQuote_advocateHeadshot.url) || "",
                testimonyImageAlt: (advocateQuote === null || advocateQuote === void 0 ? void 0 : (_advocateQuote_advocateHeadshot1 = advocateQuote.advocateHeadshot) === null || _advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _advocateQuote_advocateHeadshot1.description) || "",
                isSmallQuote: true,
                isIncludeHorizontalMobileRule: false
            }, tab === null || tab === void 0 ? void 0 : tab.name)
        };
    });
};
const $5f86d0cde7cf45ec$var$getResults = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { results: results } = resp[0].node;
    const data = results && results.length ? results : null;
    return data;
};
const $5f86d0cde7cf45ec$var$getCta = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { callToAction: callToAction } = resp[0].node;
    const data = callToAction && callToAction[0] ? callToAction[0] : null;
    return data;
};
const $5f86d0cde7cf45ec$var$getBanner = (resp)=>{
    if (!resp || !resp[0]) return null;
    const { banner: banner } = resp[0].node;
    const data = banner && banner[0] ? banner[0] : null;
    return data;
};

});


parcelRegister("hgMlo", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorAutomation", function () { return $2df687868f98fb02$export$fe028e87ba31b736; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $2df687868f98fb02$export$fe028e87ba31b736 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-automation",
        persona: "unknown",
        pageVariant: "automation",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("dbZp9", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorCompetitors", function () { return $df033c2fd81a6dcb$export$9e7550d57c83d484; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $df033c2fd81a6dcb$export$9e7550d57c83d484 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-competitors",
        persona: "unknown",
        pageVariant: "competitors",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("7xaX2", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorCsm", function () { return $a510ba3bf7657859$export$1b2806c3b1e704cc; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $a510ba3bf7657859$export$1b2806c3b1e704cc = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-csm",
        persona: "unknown",
        pageVariant: "csm",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("kuBeN", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorLpJsmDevops", function () { return $35e00c8619ae53e4$export$cbbd19ee24db230d; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $35e00c8619ae53e4$export$cbbd19ee24db230d = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-devops",
        persona: "unknown",
        pageVariant: "devops",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("gsiI9", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorEsm", function () { return $e295f7021ed6d93e$export$f88fd6b582bc38b8; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $e295f7021ed6d93e$export$f88fd6b582bc38b8 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-esm",
        persona: "unknown",
        pageVariant: "esm",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("5NnUP", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorCustomerService", function () { return $61ce207f9d3cfa1a$export$b02149e5ebf276fb; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $61ce207f9d3cfa1a$export$b02149e5ebf276fb = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-customerservice",
        persona: "unknown",
        pageVariant: "customerservice",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("k1ORe", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorDesign", function () { return $92ca5dc072a2b436$export$c306ba868bad369c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $92ca5dc072a2b436$export$c306ba868bad369c = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-design",
        persona: "unknown",
        pageVariant: "design",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("8xrM0", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorEngineering", function () { return $f6c1d0fc39bf26b7$export$a4c1bc231ccdbe60; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $f6c1d0fc39bf26b7$export$a4c1bc231ccdbe60 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-engineering",
        persona: "unknown",
        pageVariant: "engineering",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("l8sJe", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorHr", function () { return $8934bbad1a0b6ce6$export$7c87531041f697c3; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $8934bbad1a0b6ce6$export$7c87531041f697c3 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-hr",
        persona: "unknown",
        pageVariant: "hr",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("dsoMC", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorLegal", function () { return $3b480f9a7623a2c5$export$c020747f2adc0733; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $3b480f9a7623a2c5$export$c020747f2adc0733 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-legal",
        persona: "unknown",
        pageVariant: "legal",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("23HrX", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorMarketing", function () { return $f893badf6e8c2b95$export$d4eeb7a08f7b5c72; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $f893badf6e8c2b95$export$d4eeb7a08f7b5c72 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-marketing",
        persona: "unknown",
        pageVariant: "marketing",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("gy1vX", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePageAnchorOperations", function () { return $ebe6fcd725a023a3$export$4674d3807e1d8c79; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $1DjVm = parcelRequire("1DjVm");
const $ebe6fcd725a023a3$export$4674d3807e1d8c79 = (pageProps)=>{
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "anchor-lp-jsm-team-operations",
        persona: "unknown",
        pageVariant: "operations",
        signupEdition: "premium",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("lhmFt", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmFeatures", function () { return $2df70fe2b21f595a$export$be845ee60820b39e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $kooLp = parcelRequire("kooLp");

var $8uLTu = parcelRequire("8uLTu");

var $ea4mV = parcelRequire("ea4mV");

var $doAVE = parcelRequire("doAVE");

var $1DjVm = parcelRequire("1DjVm");
const $2df70fe2b21f595a$export$be845ee60820b39e = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const linkUrl = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/comparison");
    const [dxpMigrationJsmAnchorJourneyExposureFired, fireDxpMigrationJsmAnchorJourneyExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationJsmAnchorJourneyExposureFired && isDxpMigrationJsmAnchorJourney.type === "enrolled" && isLoggedOut) fireDxpMigrationJsmAnchorJourneyExposure();
    }, [
        dxpMigrationJsmAnchorJourneyExposureFired,
        fireDxpMigrationJsmAnchorJourneyExposure,
        isDxpMigrationJsmAnchorJourney,
        isLoggedOut
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $8uLTu.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-features",
        persona: "unknown",
        pageVariant: "features",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});
parcelRegister("8uLTu", function(module, exports) {
$parcel$export(module.exports, "getBannerConfig", function () { return $38568df923be2c2a$export$aad1aaa28842aab3; });

var $7VQPk = parcelRequire("7VQPk");

var $3L8ZR = parcelRequire("3L8ZR");

var $2fk4i = parcelRequire("2fk4i");
const $38568df923be2c2a$export$aad1aaa28842aab3 = ({ intl: intl, linkUrl: linkUrl })=>{
    const isBannerEnabled = (0, $3L8ZR.default).checkGate("gwp-2022-jsm-paid-lp-banner");
    return isBannerEnabled ? {
        identifier: "jira-service-management.banner-alert.itsm-leader",
        text: intl.formatMessage({
            id: "jira-service-management.banner-alert.itsm-leader.text",
            defaultMessage: "There\u2019s a new leader in ITSM software. <a>See why companies are switching</a> to Jira Service Management."
        }, {
            a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                    text: (chunks || "").toString(),
                    href: linkUrl,
                    type: "inline"
                })
        })
    } : undefined;
};

});


parcelRegister("e7uW8", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebro", function () { return $0a1966a2b0d303f8$export$ab92522b7cf27ff; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $kooLp = parcelRequire("kooLp");

var $8uLTu = parcelRequire("8uLTu");

var $1DjVm = parcelRequire("1DjVm");
const $0a1966a2b0d303f8$export$ab92522b7cf27ff = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const linkUrl = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $8uLTu.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-features-cerebro",
        persona: "unknown",
        pageVariant: "features-cerebro"
    }));
};

});

parcelRegister("1H2ve", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmt", function () { return $f4fc7d5df99a6cf1$export$329b00bf88efc8dd; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $kooLp = parcelRequire("kooLp");

var $8uLTu = parcelRequire("8uLTu");

var $1DjVm = parcelRequire("1DjVm");
const $f4fc7d5df99a6cf1$export$329b00bf88efc8dd = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const linkUrl = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/comparison");
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $8uLTu.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-incidentchangemgmt",
        persona: "unknown",
        pageVariant: "incidentchangemgmt",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("aZQ1N", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmItsm", function () { return $7e50abcbc6c248e8$export$3d1982be409f777c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $kooLp = parcelRequire("kooLp");

var $8uLTu = parcelRequire("8uLTu");

var $ea4mV = parcelRequire("ea4mV");

var $doAVE = parcelRequire("doAVE");

var $1DjVm = parcelRequire("1DjVm");
const $7e50abcbc6c248e8$export$3d1982be409f777c = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const linkUrl = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/comparison");
    const [dxpMigrationJsmAnchorJourneyExposureFired, fireDxpMigrationJsmAnchorJourneyExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationJsmAnchorJourneyExposureFired && isDxpMigrationJsmAnchorJourney.type === "enrolled" && isLoggedOut) fireDxpMigrationJsmAnchorJourneyExposure();
    }, [
        dxpMigrationJsmAnchorJourneyExposureFired,
        fireDxpMigrationJsmAnchorJourneyExposure,
        isDxpMigrationJsmAnchorJourney,
        isLoggedOut
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $8uLTu.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-itsm",
        persona: "unknown",
        pageVariant: "itsm",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("aWYhK", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmServiceDesk", function () { return $3a9918899fa10910$export$595fa6be9e31a4b2; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $kooLp = parcelRequire("kooLp");

var $8uLTu = parcelRequire("8uLTu");

var $ea4mV = parcelRequire("ea4mV");

var $doAVE = parcelRequire("doAVE");

var $1DjVm = parcelRequire("1DjVm");
const $3a9918899fa10910$export$595fa6be9e31a4b2 = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const linkUrl = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/comparison");
    const [dxpMigrationJsmAnchorJourneyExposureFired, fireDxpMigrationJsmAnchorJourneyExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationJsmAnchorJourneyExposureFired && isDxpMigrationJsmAnchorJourney.type === "enrolled" && isLoggedOut) fireDxpMigrationJsmAnchorJourneyExposure();
    }, [
        dxpMigrationJsmAnchorJourneyExposureFired,
        fireDxpMigrationJsmAnchorJourneyExposure,
        isDxpMigrationJsmAnchorJourney,
        isLoggedOut
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $8uLTu.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-service-desk",
        persona: "unknown",
        pageVariant: "service-desk",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("iDsYU", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementSoftwarePagePaidLpJsmTicketing", function () { return $58cffe0da0a4c992$export$a288ad63561bc60a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $f3gS9 = parcelRequire("f3gS9");
parcelRequire("d9N42");
var $k6PTJ = parcelRequire("k6PTJ");

var $kooLp = parcelRequire("kooLp");

var $8uLTu = parcelRequire("8uLTu");

var $ea4mV = parcelRequire("ea4mV");

var $doAVE = parcelRequire("doAVE");

var $1DjVm = parcelRequire("1DjVm");
const $58cffe0da0a4c992$export$a288ad63561bc60a = (pageProps)=>{
    const intl = (0, $8e22h.default)();
    const linkUrl = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/comparison");
    const [dxpMigrationJsmAnchorJourneyExposureFired, fireDxpMigrationJsmAnchorJourneyExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationJsmAnchorJourneyExposureFired && isDxpMigrationJsmAnchorJourney.type === "enrolled" && isLoggedOut) fireDxpMigrationJsmAnchorJourneyExposure();
    }, [
        dxpMigrationJsmAnchorJourneyExposureFired,
        fireDxpMigrationJsmAnchorJourneyExposure,
        isDxpMigrationJsmAnchorJourney,
        isLoggedOut
    ]);
    const data = (0, $f3gS9.usePreloadedQuery)((0, $k6PTJ.AnchorPageRelayQuery), pageProps.queryRef || null);
    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: (0, $8uLTu.getBannerConfig)({
            intl: intl,
            linkUrl: linkUrl
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1DjVm.JiraSoftwarePagePaidLpJsmAnchor), (0, $dPABA._)((0, $6ogO3._)({}, pageProps), {
        anchorContents: (0, $k6PTJ.shapeAnchorContentfulResponse)(data),
        pageId: "paid-lp-jsm-ticketing",
        persona: "unknown",
        pageVariant: "ticketing",
        auxiaResponse: pageProps.auxiaResponse
    }));
};

});

parcelRegister("31J3d", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $4d8708b285ba0671$export$933c1404a4ee79b; });
const $4d8708b285ba0671$export$933c1404a4ee79b = ()=>{
    return "Jira Service Management Pricing Page";
};

});

parcelRegister("6QgX2", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementPricingPage", function () { return $ef6f08b787170088$export$2a3104cce6671f76; });

var $7VQPk = parcelRequire("7VQPk");

var $3L8ZR = parcelRequire("3L8ZR");

var $9xKEy = parcelRequire("9xKEy");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("l8kCZ");
var $bTseT = parcelRequire("bTseT");
parcelRequire("9LW9x");
var $94Mty = parcelRequire("94Mty");

var $32ng3 = parcelRequire("32ng3");
const $ef6f08b787170088$export$2a3104cce6671f76 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $3L8ZR.default).checkGate("gwp-737-enable-intercom-chat-jsm");
    const isSalesWidgetBxpWebPlatform = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).salesWidgetBxpWebPlatform);
    const isSalesWidgetBxpWebPlatformDeveloper = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).salesWidgetBxpWebPlatformDeveloper);
    if (isSalesWidgetBxpWebPlatformDeveloper) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
            productId: "jira-service-management",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "jsm-pricing-page",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $94Mty.JiraServiceManagementPricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
    else if (isSalesWidgetBxpWebPlatform) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
            productId: "jira-service-management",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "data-testid": "jsm-pricing-page",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $94Mty.JiraServiceManagementPricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9xKEy.ChatWidgetProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
                productId: "jira-service-management",
                pricingContent: pricingContent,
                queryRef: queryRef,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    "data-testid": "jsm-pricing-page",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $94Mty.JiraServiceManagementPricingPageV2Template), {
                        pricing: pricing,
                        countryCode: countryCode
                    })
                })
            })
        })
    });
};

});
parcelRegister("9LW9x", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementPricingPageV2Template", function () { return (parcelRequire("94Mty")).JiraServiceManagementPricingPageV2Template; });
parcelRequire("94Mty");

});
parcelRegister("94Mty", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementPricingPageV2Template", function () { return $2728f1090ab6b090$export$ac87b8d354f2d1fd; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");
parcelRequire("g1ccm");
var $djE2J = parcelRequire("djE2J");
var $baTp3 = parcelRequire("baTp3");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $2zOxm = parcelRequire("2zOxm");

var $bE8d4 = parcelRequire("bE8d4");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $kooLp = parcelRequire("kooLp");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $aYVVm = parcelRequire("aYVVm");

var $CxZAa = parcelRequire("CxZAa");
const $2728f1090ab6b090$export$ac87b8d354f2d1fd = (props)=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)("Contact Us", "Learn more");
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jsm-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $CxZAa.JsmPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $djE2J.AtlassianGuardAddOnShared), {
                    ctaHref: (0, $kooLp.useLocalizedHref)("/software/guard")
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $baTp3.DataCenterSection), (0, $6ogO3._)({}, dataCenterContent)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: "JSM",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : undefined,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("aYVVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $133256a5190381b7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $b31tm = parcelRequire("b31tm");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $cR2Ov = parcelRequire("cR2Ov");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $iSeHD = parcelRequire("iSeHD");

var $9KOR3 = parcelRequire("9KOR3");
const $133256a5190381b7$var$JiraServiceManagementLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
};
const $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    var _links_find, _links_find1;
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const featuresHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/features");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/pricing");
    const itSupportHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/itsm-software");
    const itOperationsHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/it-operations");
    const enterpriseServiceManagementHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/features/enterprise-service-management");
    const customerServiceHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/customer-service-software");
    const hrHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/hr");
    const smallTeamsHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/help-desk-software-small-business-software");
    const premiumHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/premium");
    const enterpriseHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/enterprise");
    const technologyTelecomHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/technology-telecommunications");
    const financialServicesHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/financial-services");
    const retailHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/retail-ecommerce");
    const manufacturingHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/manufacturing");
    const itsmHref = (0, $kooLp.useLocalizedHref)("/itsm");
    const productGuideHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/product-guide");
    const resourcesHref = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/resources");
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            transform: "translateX(-40%)"
        };
    }, []);
    const templatesUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/service-management");
    const { fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)();
    const viewedUIEvent = (0, $1oC0p.useRef)(false);
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: "viewed",
                actionSubject: "jiraServiceManagementSoftwareNavV2"
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: "features",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.features",
                    defaultMessage: "Features"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: featuresHref
            },
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "jira-servicedesk.ondemand",
                href: pricingHref
            },
            {
                globalLinksKey: "solutions",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.solutions",
                    defaultMessage: "Solutions"
                }),
                hasSubnav: true,
                dropdownType: "solutions",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.useCases.header",
                                defaultMessage: "By use case"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itSupport",
                                        defaultMessage: "IT Support"
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.itOperations",
                                        defaultMessage: "IT Operations"
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.businessTeams",
                                        defaultMessage: "Business Teams"
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.customerService",
                                        defaultMessage: "Customer Service"
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.humanResources",
                                        defaultMessage: "Human Resources"
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.capability.header",
                                defaultMessage: "By capability"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.smallTeams",
                                        defaultMessage: "Small Teams"
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.premium",
                                        defaultMessage: "Premium"
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.capability.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.solutions.industry.customerService",
                                defaultMessage: "By industry"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.technologyTelecom",
                                        defaultMessage: "Technology & Telecom"
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.financialServices",
                                        defaultMessage: "Financial Services"
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.industry.retail",
                                        defaultMessage: "Retail"
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.solutions.useCases.manufacturing",
                                        defaultMessage: "Manufacturing"
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "resources",
                linkText: intl.formatMessage({
                    id: "software-jira-service-management.navbar.resources",
                    defaultMessage: "Resources"
                }),
                hasSubnav: true,
                dropdownType: "resources",
                productKey: "jira-servicedesk.ondemand",
                containerPosition: "relative",
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: "software-jira-service-management.navbar.resources.type.header",
                                defaultMessage: "By type"
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.itsm",
                                        defaultMessage: "ITSM"
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: gwp7518NavIconUpdates ? intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide-gwp-7518",
                                        defaultMessage: "Guide"
                                    }) : intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.productGuide",
                                        defaultMessage: "Product Guide"
                                    }),
                                    href: productGuideHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.templates",
                                        defaultMessage: "Templates"
                                    }),
                                    href: templatesUrl
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "software-jira-service-management.navbar.resources.type.additionalResources",
                                        defaultMessage: "Additional Resources"
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        productGuideHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const signupLink = (0, $kooLp.useLocalizedHref)("/software/jira/service-management/free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    // Check if JSM back-to-product hero experiment is active
    // If so, hide the "Get it free" button in the global nav
    const jsmHeroExperiment = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).gwp9973JSMBackToProductHero);
    const isJsmHeroExperimentActive = jsmHeroExperiment.type === "enrolled" && jsmHeroExperiment.value === true;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $kooLp.useLocalizedHref)("/software/jira/service-management"),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            isShowTryNowLink: isJsmHeroExperimentActive ? false : undefined,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-jira-service-management",
                    mobileLinksProps: links
                }
            ],
            isIncludeMobileCTA: !isJsmHeroExperimentActive,
            mobileCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: intl.formatMessage({
                id: "productNavBar.get-it-free-button",
                defaultMessage: "Get it free"
            }),
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: "solutions",
                    menuPageObjects: (_links_find = links.find((link)=>link.globalLinksKey === "solutions")) === null || _links_find === void 0 ? void 0 : _links_find.content
                },
                {
                    menuPageKey: "resources",
                    menuPageObjects: (_links_find1 = links.find((link)=>link.globalLinksKey === "resources")) === null || _links_find1 === void 0 ? void 0 : _links_find1.content
                }
            ]
        })
    });
};
var $133256a5190381b7$export$2e2bcd8739ae039 = $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2;

});

parcelRegister("CxZAa", function(module, exports) {
$parcel$export(module.exports, "JsmPriceFinder", function () { return $863743dd4076071d$export$27bafd5c0a9a3fce; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $aA1TB = parcelRequire("aA1TB");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $863743dd4076071d$export$27bafd5c0a9a3fce = (props)=>{
    var _content_free, _content_free1, _content_standard, _content_standard1, _content_premium, _content_premium1, _content_enterprise, _content_enterprise1, _props_pricing_ccpPricingData, _props_pricing;
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "JsmPricingPageV2.priceFinder.headerText",
            defaultMessage: "Service management <blue>that scales</blue>"
        },
        unitCountInputTextRedesign: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputTerm",
            defaultMessage: "agents"
        },
        billingCycleText: {
            id: "JsmPricingPageV2.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputText",
            defaultMessage: "How many agents are on your team?"
        },
        unitCountInputTooltip: {
            id: "JsmPricingPageV2.priceFinder.unitCountInputTooltip",
            defaultMessage: "Agents work on tickets and communicate directly with your customers."
        },
        cardOverSignupLimit: {
            id: "JsmPricingPageV2.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your agent count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JsmPricingPageV2.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more agents above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JsmPricingPageV2.priceFinder.cardUnitCountTierRange",
            defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JsmPricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per agent / month"
        },
        cardFreeDescription: {
            id: "JsmPricingPageV2.priceFinder.cardFreeDescription",
            defaultMessage: "always free for 3 agents,"
        }
    });
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Free"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Standard"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Premium"),
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    const addSignupSourceToUrlsOnPricingPageEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage);
    const signupUrlSourceQueryParam = addSignupSourceToUrlsOnPricingPageEnabled ? "&signupSource=pricing" : "";
    // Note: We need to use the jiraServiceDesk plan name instead of a new jiraServiceManagement key because of how the pricing data is stored in CCP/HAMS. jiraServiceManagement is used as the dataProductKey in all other components on the JSM pricing page.
    const jiraServiceManagementProductPlans = [
        {
            planName: ((_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planTitleExternal) || "Free",
            offeringSku: "jira-servicedesk-free",
            description: ((_content_free1 = content.free) === null || _content_free1 === void 0 ? void 0 : _content_free1.planOneLiner) || "",
            recommendationLimit: 0,
            signupLimit: 20000,
            signupURLSuffix: "?bundle=jira-service-management&edition=free&signupSource=pricing",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: ((_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planTitleExternal) || "Standard",
            offeringSku: "jira-servicedesk-standard-repack-sku",
            description: ((_content_standard1 = content.standard) === null || _content_standard1 === void 0 ? void 0 : _content_standard1.planOneLiner) || "",
            recommendationLimit: 3,
            signupLimit: 20000,
            signupURLSuffix: `?bundle=jira-service-management&edition=standard${signupUrlSourceQueryParam}`,
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: ((_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planTitleExternal) || "Premium",
            offeringSku: "jira-servicedesk-premium",
            description: ((_content_premium1 = content.premium) === null || _content_premium1 === void 0 ? void 0 : _content_premium1.planOneLiner) || "",
            recommendationLimit: 50,
            signupLimit: 20000,
            signupURLSuffix: `?bundle=jira-service-management&edition=premium${signupUrlSourceQueryParam}`,
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: ((_content_enterprise = content.enterprise) === null || _content_enterprise === void 0 ? void 0 : _content_enterprise.planTitleExternal) || "Enterprise",
            offeringSku: "jira-servicedesk-enterprise-sku",
            recommendationLimit: 250,
            description: ((_content_enterprise1 = content.enterprise) === null || _content_enterprise1 === void 0 ? void 0 : _content_enterprise1.planOneLiner) || "",
            signupLimit: 20000,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $eYlij.PriceFinderContextProvider), {
        dataProductKey: "jiraServiceDesk",
        productPlans: jiraServiceManagementProductPlans,
        defaultUnitCount: 75,
        enterpriseMinimumCount: 201,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraServiceDesk,
                countryCode: props.countryCode
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aA1TB.default), {})
        ]
    });
};
$863743dd4076071d$export$27bafd5c0a9a3fce.displayName = "JsmPriceFinderSection";

});
parcelRegister("aA1TB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18b90e3e981074f6$export$2e2bcd8739ae039; });
/* disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $18b90e3e981074f6$var$disclaimerTextStyles = null;
const $18b90e3e981074f6$var$Disclaimer = ({ disclaimerText: disclaimerText })=>{
    const intl = (0, $8e22h.default)();
    const text = disclaimerText !== null && disclaimerText !== void 0 ? disclaimerText : intl.formatMessage({
        id: "pricing.disclaimer.text",
        defaultMessage: "The prices shown are estimates and aren't binding for either you or Atlassian. The amount you are billed may be different if you change your scope of use, including by updating your agent count or exceeding your base plan usage of Assets or Virtual Service Agent."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_k48p1kdj _vwz4gktf _1wybdlk8 _syazr3uz _1q511tcg"
        ]),
        children: text
    });
};
$18b90e3e981074f6$var$Disclaimer.displayName = "disclaimer";
var $18b90e3e981074f6$export$2e2bcd8739ae039 = $18b90e3e981074f6$var$Disclaimer;

});





parcelRegister("keOu4", function(module, exports) {
$parcel$export(module.exports, "JiraTemplateCategoryPage", function () { return $35f22ae28293b9db$export$52bd3b9163994b81; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("jZxYd");
var $5eEVK = parcelRequire("5eEVK");
const $35f22ae28293b9db$export$52bd3b9163994b81 = ({ templates: templates })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5eEVK.JiraTemplateCategoryPageTemplate), {
        templates: templates
    });

});
parcelRegister("jZxYd", function(module, exports) {
$parcel$export(module.exports, "JiraTemplateCategoryPageTemplate", function () { return (parcelRequire("5eEVK")).JiraTemplateCategoryPageTemplate; });

var $5eEVK = parcelRequire("5eEVK");

});
parcelRegister("5eEVK", function(module, exports) {
$parcel$export(module.exports, "JiraTemplateCategoryPageTemplate", function () { return $53c56b844af24133$export$8ae757bfa7e42dde; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $20OkY = parcelRequire("20OkY");

var $9kQRf = parcelRequire("9kQRf");

var $5kPBa = parcelRequire("5kPBa");

var $6iKF0 = parcelRequire("6iKF0");

var $jMhSx = parcelRequire("jMhSx");

var $7ASVM = parcelRequire("7ASVM");

var $8Sr8q = parcelRequire("8Sr8q");

var $8AvPJ = parcelRequire("8AvPJ");

var $2fCHu = parcelRequire("2fCHu");
const $53c56b844af24133$var$PageContent = ({ templates: templates })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AvPJ.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fCHu.TemplatesGrid), {
                        templates: templates !== null && templates !== void 0 ? templates : (0, $7ASVM.JSM_TEMPLATES_CONTENT)
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Sr8q.Resources), {})
            ]
        })
    });
};
const $53c56b844af24133$export$8ae757bfa7e42dde = ({ templates: templates })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fireSLOErrorEvent = (0, $1oC0p.useCallback)((error)=>{
        createAnalyticsEvent({
            product: "marketing",
            eventType: "operational",
            actionSubject: "wacJsmTemplateScreenFailed",
            action: "failed",
            attributes: {
                errorMessage: (error === null || error === void 0 ? void 0 : error.message) || error
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)($53c56b844af24133$var$PageContent, {
            templates: templates
        }),
        onError: (e)=>fireSLOErrorEvent(e),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9kQRf.CrossFlowProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kPBa.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK
                ],
                screenName: "wacJsmTemplateScreen",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($53c56b844af24133$var$PageContent, {
                    templates: templates
                })
            })
        })
    });
};

});
parcelRegister("7ASVM", function(module, exports) {
$parcel$export(module.exports, "JSM_TEMPLATES_CONTENT", function () { return $44530ce77f7794c2$export$a582b1f9bb954226; });
const $44530ce77f7794c2$export$a582b1f9bb954226 = [
    {
        templateId: "it-service-management",
        name: "IT service management",
        oneLinerHeadline: "Intake requests, set up alerts, raise incidents, and fix issues quickly.",
        urlSlug: "it-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/ug362u6qv3ywnwcca17012vsdfpwcu1j.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Alerts and on-call schedules",
                iconRef: "alert-icon"
            },
            {
                name: "Multi-channel support",
                iconRef: "headphone-icon"
            }
        ]
    },
    {
        templateId: "advanced-it-service-management",
        name: "Advanced IT service management",
        oneLinerHeadline: "Incident, change, and problem management with ITSM best practices.",
        urlSlug: "advanced-it-service-management",
        templateIcon: {
            name: "Help Center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/3fte56b800hsu0n8r76727ht510v7808.svg",
            description: "Help Center screenshot"
        },
        keyFeatures: [
            {
                name: "Automated change requests",
                iconRef: "check-task-icon"
            },
            {
                name: "Alerts and on-call schedules",
                iconRef: "alert-icon"
            }
        ]
    },
    {
        templateId: "hr-service-management",
        name: "HR service management",
        oneLinerHeadline: "Manage onboarding and offboarding and respond to HR requests.",
        urlSlug: "hr-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/cre6xx6lyq1hcp327v813e1t38k241sx.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customizable request forms",
                iconRef: "mail-icon"
            }
        ]
    },
    {
        templateId: "customer-service-management",
        name: "Customer service management",
        oneLinerHeadline: "Deliver great service experiences for your external customers.",
        urlSlug: "customer-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/2b83vv62ssm4g2km1m7638d126w2e1u3.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Developer escalations",
                iconRef: "flag-icon"
            },
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            }
        ]
    },
    {
        templateId: "marketing-service-management",
        name: "Marketing service management",
        oneLinerHeadline: "Manage and track all your marketing requests.",
        urlSlug: "marketing-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/g13dr33528x350811shfr52mr5y5hr72.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Forms for Marketing requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reports",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "design-service-management",
        name: "Design service management",
        oneLinerHeadline: "Manage and track all your design requests.",
        urlSlug: "design-service-management",
        templateIcon: {
            name: "Help Center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/e4tgp6i7841gcfb7wf43k0j6a2576264.svg",
            description: "Help Center screenshot"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Automated design workflows",
                iconRef: "workflow-icon"
            }
        ]
    },
    {
        templateId: "finance-service-management",
        name: "Finance service management",
        oneLinerHeadline: "Manage and track budget, spend, and other finance requests.",
        urlSlug: "finance-service-management",
        templateIcon: {
            name: "Form view",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/401876mvht4ti1a070a3s3o3t3i6s51u.svg",
            description: "Form view"
        },
        keyFeatures: [
            {
                name: "Forms for Finance requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reporting and tracking",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "analytics-service-management",
        name: "Analytics service management",
        oneLinerHeadline: "Manage employee requests for the data and insights they need.",
        urlSlug: "analytics-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/hqvjo4k71u4x3y6e2nkden08471f4e47.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Automated Analytics workflows",
                iconRef: "robot-icon"
            }
        ]
    },
    {
        templateId: "facilities-service-management",
        name: "Facilities service management",
        oneLinerHeadline: "Manage requests for maintenance, moving, and event planning.",
        urlSlug: "facilities-service-management",
        templateIcon: {
            name: "Help center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/18xqw35pw8do7ru0wp3d8oscs2fmw1mf.svg",
            description: "Help center screenshot"
        },
        keyFeatures: [
            {
                name: "Forms for Facilities requests",
                iconRef: "mail-icon"
            },
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            }
        ]
    },
    {
        templateId: "sales-service-management",
        name: "Sales service management",
        oneLinerHeadline: "Manage, track, and report on all your sales requests.",
        urlSlug: "sales-service-management",
        templateIcon: {
            name: "Kanban board",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/1k3k7o8j66265rdk5e6vj0o23g611j04.svg",
            description: "Kanban board"
        },
        keyFeatures: [
            {
                name: "Forms designed for Sales requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reporting and tracking",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "legal-service-management",
        name: "Legal service management",
        oneLinerHeadline: "Manage and track all your contracts and legal requests.",
        urlSlug: "legal-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/47k1ynn8f0024m4tg2vd6omf3jr60h7u.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customer portal to take requests",
                iconRef: "mail-icon"
            }
        ]
    },
    {
        templateId: "general-service-management",
        name: "General service management",
        oneLinerHeadline: "Collect, prioritize, and manage requests for any business teams.",
        urlSlug: "general-service-management",
        templateIcon: {
            name: "Queues view",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/2x43564ibsn386dk7g764353rk2341n2.svg",
            description: "Queues view"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customer portal to take requests",
                iconRef: "mail-icon"
            }
        ]
    }
];

});

parcelRegister("8Sr8q", function(module, exports) {
$parcel$export(module.exports, "Resources", function () { return $cfe011856ec0428b$export$e9a269813a6315a4; });
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $cfe011856ec0428b$var$backgroundStyles = null;
const $cfe011856ec0428b$var$h2Styles = null;
const $cfe011856ec0428b$var$h4Styles = null;
const $cfe011856ec0428b$var$pStyles = null;
const $cfe011856ec0428b$var$linkStyles = null;
const $cfe011856ec0428b$export$e9a269813a6315a4 = ()=>{
    const intl = (0, $8e22h.default)();
    const resources = [
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.gettingStartedGuide",
                defaultMessage: "Getting started guide"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.gettingStartedGuideDescription",
                defaultMessage: "Everything you need to know about getting started with Jira Service Management."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.gettingStartedGuideLink",
                    defaultMessage: "Go to guide"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/service-management/product-guide/getting-started/quick-start-guide"),
                type: "primary"
            }
        },
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.productGuide",
                defaultMessage: "Jira Service Management product guides"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.productGuideDescription",
                defaultMessage: "How to use Jira Service Management: guides, tutorials, and demos."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.productGuideLink",
                    defaultMessage: "Review the guide"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/service-management/product-guide"),
                type: "primary"
            }
        },
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.demo",
                defaultMessage: "Jira Service Management demo"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.demoDescription",
                defaultMessage: "Choose specific features you\u2019re interested in and we\u2019ll personalize a demo for you."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.demoLink",
                    defaultMessage: "Watch the demo"
                }),
                href: (0, $kooLp.useLocalizedHref)("/software/jira/service-management/demo"),
                type: "primary"
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1itk1ejp _12vemgnk _1lrw1wug _1bsb1osq _ca0qgktf _u5f37vkz _n3tdckbl _19bv7vkz _1akockbl _c7s77vkz _4puvvbgk _1r3v7vkz _3int1h90 _4fuggrf3 _1ynq1h90 _1j3ngrf3 _ip651h90 _g8ou1h90 _1opi1h90 _1x951h90"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syazmcao _1wybk299 _k48p124r _vwz42a8g _y3gn1qpp _19pkgrf3 _2hwx1h90 _otyrgrf3 _18u01h90 _ca0q7vkz _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ako1crf _c7s77vkz _4puv1crf _1r3v7vkz _1s18r6mz _uj6k1s23"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "resources.heading",
                    defaultMessage: "Service management resources"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "4-4-4",
                children: resources.map((resource, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_syazmcao _k48p124r _vwz4cjiy _6rth1usy _1wyb19as _1dyzzyni _1s18n2z8"
                                ]),
                                children: resource.heading
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_syazt5hr _1wyb1j6v _k48pl8b6 _vwz41k8s _6rth1x4e"
                                ]),
                                children: resource.description
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $dPABA._)((0, $6ogO3._)({}, resource.link), {
                                className: (0, $2jatx.default)([
                                    "_v56412xp"
                                ])
                            }))
                        ]
                    }, index))
            })
        ]
    });
};

});

parcelRegister("8AvPJ", function(module, exports) {
$parcel$export(module.exports, "SharedHeaderFooterContainer", function () { return $37d8fa01f56156a9$export$93790172861f3d8b; });

var $7VQPk = parcelRequire("7VQPk");

var $20OkY = parcelRequire("20OkY");

var $lFwc0 = parcelRequire("lFwc0");

var $8LaTa = parcelRequire("8LaTa");

var $aYVVm = parcelRequire("aYVVm");
const $37d8fa01f56156a9$export$93790172861f3d8b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lFwc0.SiteSelectorContextProvider), {
                productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
                analyticsPrefix: "wac.showroom",
                internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                children: children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});

parcelRegister("2fCHu", function(module, exports) {
$parcel$export(module.exports, "TemplatesGrid", function () { return $fc0f390a3f68e4b0$export$e845b3e887ad68a4; });
/* templates-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $5LkDU = parcelRequire("5LkDU");

var $jMhSx = parcelRequire("jMhSx");
const $fc0f390a3f68e4b0$var$fontCharlieDisplay = `"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $fc0f390a3f68e4b0$var$fontCharlieText = `"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $fc0f390a3f68e4b0$var$backgroundStyles = null;
const $fc0f390a3f68e4b0$var$containerStyles = null;
const $fc0f390a3f68e4b0$var$titleStyles = null;
const $fc0f390a3f68e4b0$var$h1Styles = null;
const $fc0f390a3f68e4b0$var$pStyles = null;
const $fc0f390a3f68e4b0$var$gridContainerStyles = null;
const $fc0f390a3f68e4b0$export$e845b3e887ad68a4 = ({ templates: templates })=>{
    const templateGridRows = ()=>{
        const rows = [];
        for(let i = 0; i < templates.length; i += 3)rows.push(templates.slice(i, i + 3));
        return rows;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1itk12hr _12vemgnk _1reoidpf _18m9idpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ahbq1wug _12l21wug _85i57vkz _1q517vkz _p12f1fra _1yd316xz _1waf16xz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ahbq1wug _12l21wug _1bsb1osq _bozg7vkz _y4ti7vkz _85i5zwfg _14b5m8w4 _uj6k1h6o _1yd3vbgk _glte2c62 _40tuvbgk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: (0, $2jatx.default)([
                                "_syazmcao _vwz4zz36 _ect41bwv _k48p53lb _1pfhidpf _6rth7vkz _1wyb14b4 _1s181a5d _3p1cxxch"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "jsm.templates.page.title",
                                defaultMessage: "Service management templates"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_syaz1fxt _ect41fn2"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "jsm.templates.page.subtitle",
                                defaultMessage: "Empower any team to get started with a service experience in Jira Service Management with pre-configured request types, workflows, and automations."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    "data-testid": "templates-grid",
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _bozg1gpt _y4ti1gpt _9bbqgrf3 _1qqcgrf3"
                    ]),
                    children: templateGridRows().map((row, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                            layout: "4-4-4",
                            children: row.map((template)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5LkDU.TemplateCard), {
                                    template: template
                                }, template.urlSlug))
                        }, `template-grid-row-${index}`))
                })
            ]
        })
    });
};

});
parcelRegister("5LkDU", function(module, exports) {
$parcel$export(module.exports, "TemplateCard", function () { return $5795f296170cd462$export$ba340e850b866867; });
/* template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("fl7Kz");
var $92jF6 = parcelRequire("92jF6");

var $kbpa7 = parcelRequire("kbpa7");

var $jSj3N = parcelRequire("jSj3N");
const $5795f296170cd462$var$colorN700 = "#253858";
const $5795f296170cd462$var$containerStyles = null;
const $5795f296170cd462$export$ba340e850b866867 = ({ template: template })=>{
    var _template_templateIcon;
    const intl = (0, $8e22h.default)();
    const url = template.urlSlug ? `/software/jira/templates/${template.urlSlug}` : "";
    const messages = // @ts-ignore
    (0, $jSj3N.JiraServiceManagementTemplateMessageMap)[template.templateId];
    var _template_templateIcon_url, _intl_formatMessage;
    if (messages) return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: url !== null && url !== void 0 ? url : "",
        className: (0, $2jatx.default)([
            "_z5uk1h67 _1boa1h67 _16it1h67 _ad5c1h67 _1rhqmcao _8kc9n2z8 _1euyw0jn _k6x01gpt _125xmcao _q7gq19as _zcqxk299 _1ayngrf3 _16qsl45a _v564mihd _1dbz1x6p _858u8ben _2rko1wa3 _1reo15vq _18m915vq _1ilwgrf3"
        ]),
        style: {
            "--_w9vrer": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1100")),
            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), {
            className: "template-card",
            "data-testid": "template-card",
            headerText: intl.formatMessage(messages.name),
            headerType: "h4",
            bodyText: intl.formatMessage(messages.oneLinerHeadline),
            backgroundColor: (0, $kbpa7.wacToken)("color.neutral.light100"),
            textColor: $5795f296170cd462$var$colorN700,
            clickableCardUrl: url !== null && url !== void 0 ? url : "",
            pictureProps: {
                image: {
                    src: (_template_templateIcon_url = (_template_templateIcon = template.templateIcon) === null || _template_templateIcon === void 0 ? void 0 : _template_templateIcon.url) !== null && _template_templateIcon_url !== void 0 ? _template_templateIcon_url : "",
                    alt: (_intl_formatMessage = intl.formatMessage(messages.iconDescription)) !== null && _intl_formatMessage !== void 0 ? _intl_formatMessage : ""
                }
            }
        })
    });
    return null;
};

});
parcelRegister("jSj3N", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementTemplateMessageMap", function () { return $5cab63bd7c1076be$export$7eb612acc27aff49; });

var $fnHPc = parcelRequire("fnHPc");
const $5cab63bd7c1076be$export$7d34f3deca703e17 = (0, $fnHPc.defineMessages)({
    "it-service-managementName": {
        id: "jsm.templates.it-service-management.name",
        defaultMessage: "IT service management"
    },
    "it-service-managementOneLinerHeadline": {
        id: "jsm.templates.it-service-management.oneLinerHeadline",
        defaultMessage: "Intake requests, set up alerts, raise incidents, and fix issues quickly."
    },
    "it-service-managementIconName": {
        id: "jsm.templates.it-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "it-service-managementIconDescription": {
        id: "jsm.templates.it-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "it-service-managementFeature-1": {
        id: "jsm.templates.it-service-management.feature-1",
        defaultMessage: "Alerts and on-call schedules"
    },
    "it-service-managementFeature-2": {
        id: "jsm.templates.it-service-management.feature-2",
        defaultMessage: "Multi-channel support"
    },
    "advanced-it-service-managementName": {
        id: "jsm.templates.advanced-it-service-management.name",
        defaultMessage: "Advanced IT service management"
    },
    "advanced-it-service-managementOneLinerHeadline": {
        id: "jsm.templates.advanced-it-service-management.oneLinerHeadline",
        defaultMessage: "Incident, change, and problem management with ITSM best practices."
    },
    "advanced-it-service-managementIconName": {
        id: "jsm.templates.advanced-it-service-management.templateIcon.name",
        defaultMessage: "Help Center screenshot"
    },
    "advanced-it-service-managementIconDescription": {
        id: "jsm.templates.advanced-it-service-management.templateIcon.description",
        defaultMessage: "Help Center screenshot"
    },
    "advanced-it-service-managementFeature-1": {
        id: "jsm.templates.advanced-it-service-management.feature-1",
        defaultMessage: "Automated change requests"
    },
    "advanced-it-service-managementFeature-2": {
        id: "jsm.templates.advanced-it-service-management.feature-2",
        defaultMessage: "Alerts and on-call schedules"
    },
    "hr-service-managementName": {
        id: "jsm.templates.hr-service-management.name",
        defaultMessage: "HR service management"
    },
    "hr-service-managementOneLinerHeadline": {
        id: "jsm.templates.hr-service-management.oneLinerHeadline",
        defaultMessage: "Manage onboarding and offboarding and respond to HR requests."
    },
    "hr-service-managementIconName": {
        id: "jsm.templates.hr-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "hr-service-managementIconDescription": {
        id: "jsm.templates.hr-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "hr-service-managementFeature-1": {
        id: "jsm.templates.hr-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "hr-service-managementFeature-2": {
        id: "jsm.templates.hr-service-management.feature-2",
        defaultMessage: "Customizable request forms"
    },
    "customer-service-managementName": {
        id: "jsm.templates.customer-service-management.name",
        defaultMessage: "Customer service management"
    },
    "customer-service-managementOneLinerHeadline": {
        id: "jsm.templates.customer-service-management.oneLinerHeadline",
        defaultMessage: "Deliver great service experiences for your external customers."
    },
    "customer-service-managementIconName": {
        id: "jsm.templates.customer-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "customer-service-managementIconDescription": {
        id: "jsm.templates.customer-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "customer-service-managementFeature-1": {
        id: "jsm.templates.customer-service-management.feature-1",
        defaultMessage: "Developer escalations"
    },
    "customer-service-managementFeature-2": {
        id: "jsm.templates.customer-service-management.feature-2",
        defaultMessage: "Self-service and FAQ help center"
    },
    "marketing-service-managementName": {
        id: "jsm.templates.marketing-service-management.name",
        defaultMessage: "Marketing service management"
    },
    "marketing-service-managementOneLinerHeadline": {
        id: "jsm.templates.marketing-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your marketing requests."
    },
    "marketing-service-managementIconName": {
        id: "jsm.templates.marketing-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "marketing-service-managementIconDescription": {
        id: "jsm.templates.marketing-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "marketing-service-managementFeature-1": {
        id: "jsm.templates.marketing-service-management.feature-1",
        defaultMessage: "Forms for Marketing requests"
    },
    "marketing-service-managementFeature-2": {
        id: "jsm.templates.marketing-service-management.feature-2",
        defaultMessage: "Reports"
    },
    "design-service-managementName": {
        id: "jsm.templates.design-service-management.name",
        defaultMessage: "Design service management"
    },
    "design-service-managementOneLinerHeadline": {
        id: "jsm.templates.design-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your design requests."
    },
    "design-service-managementIconName": {
        id: "jsm.templates.design-service-management.templateIcon.name",
        defaultMessage: "Help Center screenshot"
    },
    "design-service-managementIconDescription": {
        id: "jsm.templates.design-service-management.templateIcon.description",
        defaultMessage: "Help Center screenshot"
    },
    "design-service-managementFeature-1": {
        id: "jsm.templates.design-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "design-service-managementFeature-2": {
        id: "jsm.templates.design-service-management.feature-2",
        defaultMessage: "Automated design workflows"
    },
    "finance-service-managementName": {
        id: "jsm.templates.finance-service-management.name",
        defaultMessage: "Finance service management"
    },
    "finance-service-managementOneLinerHeadline": {
        id: "jsm.templates.finance-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track budget, spend, and other finance requests."
    },
    "finance-service-managementIconName": {
        id: "jsm.templates.finance-service-management.templateIcon.name",
        defaultMessage: "Form view"
    },
    "finance-service-managementIconDescription": {
        id: "jsm.templates.finance-service-management.templateIcon.description",
        defaultMessage: "Form view"
    },
    "finance-service-managementFeature-1": {
        id: "jsm.templates.finance-service-management.feature-1",
        defaultMessage: "Forms for Finance requests"
    },
    "finance-service-managementFeature-2": {
        id: "jsm.templates.finance-service-management.feature-2",
        defaultMessage: "Reporting and tracking"
    },
    "analytics-service-managementName": {
        id: "jsm.templates.analytics-service-management.name",
        defaultMessage: "Analytics service management"
    },
    "analytics-service-managementOneLinerHeadline": {
        id: "jsm.templates.analytics-service-management.oneLinerHeadline",
        defaultMessage: "Manage employee requests for the data and insights they need."
    },
    "analytics-service-managementIconName": {
        id: "jsm.templates.analytics-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "analytics-service-managementIconDescription": {
        id: "jsm.templates.analytics-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "analytics-service-managementFeature-1": {
        id: "jsm.templates.analytics-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "analytics-service-managementFeature-2": {
        id: "jsm.templates.analytics-service-management.feature-2",
        defaultMessage: "Automated Analytics workflows"
    },
    "facilities-service-managementName": {
        id: "jsm.templates.facilities-service-management.name",
        defaultMessage: "Facilities service management"
    },
    "facilities-service-managementOneLinerHeadline": {
        id: "jsm.templates.facilities-service-management.oneLinerHeadline",
        defaultMessage: "Manage requests for maintenance, moving, and event planning."
    },
    "facilities-service-managementIconName": {
        id: "jsm.templates.facilities-service-management.templateIcon.name",
        defaultMessage: "Help center screenshot"
    },
    "facilities-service-managementIconDescription": {
        id: "jsm.templates.facilities-service-management.templateIcon.description",
        defaultMessage: "Help center screenshot"
    },
    "facilities-service-managementFeature-1": {
        id: "jsm.templates.facilities-service-management.feature-1",
        defaultMessage: "Forms for Facilities requests"
    },
    "facilities-service-managementFeature-2": {
        id: "jsm.templates.facilities-service-management.feature-2",
        defaultMessage: "Self-service and FAQ help center"
    },
    "sales-service-managementName": {
        id: "jsm.templates.sales-service-management.name",
        defaultMessage: "Sales service management"
    },
    "sales-service-managementOneLinerHeadline": {
        id: "jsm.templates.sales-service-management.oneLinerHeadline",
        defaultMessage: "Manage, track, and report on all your sales requests."
    },
    "sales-service-managementIconName": {
        id: "jsm.templates.sales-service-management.templateIcon.name",
        defaultMessage: "Kanban board"
    },
    "sales-service-managementIconDescription": {
        id: "jsm.templates.sales-service-management.template    .Icon.description",
        defaultMessage: "Kanban board"
    },
    "sales-service-managementFeature-1": {
        id: "jsm.templates.sales-service-management.feature-1",
        defaultMessage: "Forms designed for Sales requests"
    },
    "sales-service-managementFeature-2": {
        id: "jsm.templates.sales-service-management.feature-2",
        defaultMessage: "Reporting and tracking"
    },
    "legal-service-managementName": {
        id: "jsm.templates.legal-service-management.name",
        defaultMessage: "Legal service management"
    },
    "legal-service-managementOneLinerHeadline": {
        id: "jsm.templates.legal-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your contracts and legal requests."
    },
    "legal-service-managementIconName": {
        id: "jsm.templates.legal-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "legal-service-managementIconDescription": {
        id: "jsm.templates.legal-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "legal-service-managementFeature-1": {
        id: "jsm.templates.legal-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "legal-service-managementFeature-2": {
        id: "jsm.templates.legal-service-management.feature-2",
        defaultMessage: "Customer portal to take requests"
    },
    "general-service-managementName": {
        id: "jsm.templates.general-service-management.name",
        defaultMessage: "General service management"
    },
    "general-service-managementOneLinerHeadline": {
        id: "jsm.templates.general-service-management.oneLinerHeadline",
        defaultMessage: "Collect, prioritize, and manage requests for any business teams."
    },
    "general-service-managementIconName": {
        id: "jsm.templates.general-service-management.templateIcon.name",
        defaultMessage: "Queues view"
    },
    "general-service-managementIconDescription": {
        id: "jsm.templates.general-service-management.templateIcon.description",
        defaultMessage: "Queues view"
    },
    "general-service-managementFeature-1": {
        id: "jsm.templates.general-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "general-service-managementFeature-2": {
        id: "jsm.templates.general-service-management.feature-2",
        defaultMessage: "Customer portal to take requests"
    }
});
const $5cab63bd7c1076be$export$7eb612acc27aff49 = {
    "it-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementFeature-2"]
        ]
    },
    "advanced-it-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementFeature-2"]
        ]
    },
    "hr-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementFeature-2"]
        ]
    },
    "customer-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementFeature-2"]
        ]
    },
    "marketing-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementFeature-2"]
        ]
    },
    "design-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementFeature-2"]
        ]
    },
    "finance-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementFeature-2"]
        ]
    },
    "analytics-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementFeature-2"]
        ]
    },
    "facilities-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementFeature-2"]
        ]
    },
    "sales-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementFeature-2"]
        ]
    },
    "legal-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementFeature-2"]
        ]
    },
    "general-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementFeature-2"]
        ]
    }
};

});






parcelRegister("cbLEA", function(module, exports) {
$parcel$export(module.exports, "LoomPricingPage", function () { return $129471080e200af5$export$1c056246c70ea895; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");

var $2hXb7 = parcelRequire("2hXb7");
const $129471080e200af5$export$1c056246c70ea895 = (props)=>{
    const { pricingContent: pricingContent, queryRef: queryRef } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "loom",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2hXb7.LoomPricingPage), {})
    });
};

});
parcelRegister("2hXb7", function(module, exports) {
$parcel$export(module.exports, "LoomPricingPage", function () { return $7badbe18ec94dee9$export$1c056246c70ea895; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kIC93 = parcelRequire("kIC93");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");
parcelRequire("g1ccm");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $2zOxm = parcelRequire("2zOxm");

var $bE8d4 = parcelRequire("bE8d4");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $1K6kz = parcelRequire("1K6kz");

var $5S2vX = parcelRequire("5S2vX");

var $4ui88 = parcelRequire("4ui88");

var $9Url8 = parcelRequire("9Url8");

var $dQswK = parcelRequire("dQswK");
const $7badbe18ec94dee9$export$1c056246c70ea895 = (props)=>{
    var _content_callToActionContainer, _content_callToActionContainer1, _questionsCtaContent_asset;
    const { pricing: pricing, countryCode: countryCode } = props;
    const content = (0, $dl2JF.usePricingContentContext)();
    const featuresCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[1];
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer1 = content.callToActionContainer) === null || _content_callToActionContainer1 === void 0 ? void 0 : _content_callToActionContainer1[0];
    const intl = (0, $8e22h.default)();
    const defaultQuestionsCtaHrefPath = (0, $dQswK.usePremiumSignupUrl)();
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _featuresCtaContent_text, _featuresCtaContent_url, _content_getMoreDetailsTitle, _content_additionalDetails, _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1K6kz.default), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "loom-pricing-page",
            as: "main",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content === null || content === void 0 ? void 0 : content.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Url8.LoomPriceFinder), {
                    pricing: pricing,
                    countryCode: countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4ui88.LoomAiSection), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined,
                    linkValues: {
                        linkText: (_featuresCtaContent_text = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.text) !== null && _featuresCtaContent_text !== void 0 ? _featuresCtaContent_text : undefined,
                        linkHref: (_featuresCtaContent_url = featuresCtaContent === null || featuresCtaContent === void 0 ? void 0 : featuresCtaContent.url) !== null && _featuresCtaContent_url !== void 0 ? _featuresCtaContent_url : undefined
                    },
                    dataProductKey: "loom",
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                    href: (0, $kooLp.useLocalizedHref)("/teams/nonprofits/discount-pricing?tab=loom"),
                    text: intl.formatMessage({
                        id: "LoomPricingPage.educationDiscount",
                        defaultMessage: "Are you a teacher or a student? Take advantage of our Education discount"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                        product: "loom"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: "Loom",
                    ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : defaultQuestionsCtaHrefPath,
                    questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
                    priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
                    questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
                    imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
                })
            ]
        })
    });
};

});
parcelRegister("1K6kz", function(module, exports) {
$parcel$export(module.exports, "LoomNav", function () { return $b0045c9e2971c8ff$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $b0045c9e2971c8ff$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kH7QU = parcelRequire("kH7QU");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");

var $32ng3 = parcelRequire("32ng3");

var $gWusH = parcelRequire("gWusH");

var $635dy = parcelRequire("635dy");
const $b0045c9e2971c8ff$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $b0045c9e2971c8ff$var$LoomLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "loomcircular",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kH7QU.LoomAttributionLogo), {
        appearance: "brand"
    });
};
const $b0045c9e2971c8ff$export$e9541932877c1f74 = ()=>{
    const intl = (0, $8e22h.default)();
    const dropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: "fit-content !important",
            margin: 0,
            insetBlockStart: "4.25rem",
            transform: "translateX(-25%)"
        };
    }, []);
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium");
    const resourcesHref = (0, $kooLp.useLocalizedHref)("/software/loom/resources");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/loom/pricing");
    const desktopLinks = [
        {
            globalLinksKey: "features",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: true,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "solutions",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.resources",
                defaultMessage: "Solutions"
            }),
            hasSubnav: true,
            containerStyles: dropdownStyles,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})),
            containerPosition: "relative"
        },
        {
            globalLinksKey: "resources",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.useCases",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            href: resourcesHref
        },
        {
            globalLinksKey: "pricing",
            productKey: "loom",
            linkText: intl.formatMessage({
                id: "LoomPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            href: pricingHref
        }
    ];
    const mobileLinks = [
        ...desktopLinks.map((link)=>({
                globalLinksKey: link.globalLinksKey,
                productKey: link.productKey,
                linkText: link.linkText,
                hasSubnav: link.hasSubnav,
                href: link.href,
                dropdownType: link.globalLinksKey
            }))
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
        productKey: "loom",
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "LoomPageTemplate.navbar.loom-logo",
            defaultMessage: "Loom logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "LoomPageTemplate.navbar.getitfree",
            defaultMessage: "Get it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productPageNavLinks: desktopLinks,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-loom",
                mobileLinksProps: mobileLinks
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: "features",
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})
            },
            {
                menuPageKey: "solutions",
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})
            }
        ]
    });
};
var $b0045c9e2971c8ff$export$2e2bcd8739ae039 = $b0045c9e2971c8ff$export$e9541932877c1f74;

});
parcelRegister("kH7QU", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", function () { return $f10dea1b0839dfd3$export$6e87ce8d41eda665; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $f10dea1b0839dfd3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $f10dea1b0839dfd3$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f10dea1b0839dfd3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gWusH", function(module, exports) {
$parcel$export(module.exports, "LoomFeaturesSubnav", function () { return $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8; });
/* features-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $dfBhn = parcelRequire("dfBhn");
const $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8 = ()=>{
    const intl = (0, $8e22h.default)();
    const productKey = "loom";
    const loomLinks = {
        features: {
            id: "features",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.loomFeatures.links.features",
                defaultMessage: "Explore Features"
            }),
            items: [
                {
                    id: "meeting-notes",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.meeting-notes",
                        defaultMessage: "Meeting Notes"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/ai-meeting")
                },
                {
                    id: "screen-recorder",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screen-recorder",
                        defaultMessage: "Screen Recorder"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/screen-recorder")
                },
                {
                    id: "screenshots",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.screenshots",
                        defaultMessage: "Screenshots"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/screenshot")
                },
                {
                    id: "loom-ai",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.loom-ai",
                        defaultMessage: "Loom AI"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/ai")
                },
                {
                    id: "editing",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.loomFeatures.links.editing",
                        defaultMessage: "Editing"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/editing")
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1p1dangw _syazmt5y _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0")),
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bpsp1nn1 _19tboxwj _43dsmt5y _qfs11r31 _s41oglyw _1k6pnqa1 _1caymt5y _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_1ex89o1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark0"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "globalNavSubnav",
                                        "data-product-key": productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("635dy", function(module, exports) {
$parcel$export(module.exports, "LoomSolutionsSubnav", function () { return $7ae29eaf01c2e45b$export$e7b21fd28cd3f276; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $7ae29eaf01c2e45b$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: "teams",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.solution",
                defaultMessage: "Teams"
            }),
            items: [
                {
                    id: "sales",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.sales",
                        defaultMessage: "Sales"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/sales")
                },
                {
                    id: "marketing",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.marketing",
                        defaultMessage: "Marketing"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/marketing")
                },
                {
                    id: "design",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.design",
                        defaultMessage: "Design"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/design")
                },
                {
                    id: "support",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.support",
                        defaultMessage: "Support"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/support")
                },
                {
                    id: "productmanagement",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.product-management",
                        defaultMessage: "Product Management"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/product-management")
                },
                {
                    id: "engineering",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.engineering",
                        defaultMessage: "Engineering"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/use-case/engineering")
                }
            ]
        },
        usecases: {
            id: "usecases",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.use-cases",
                defaultMessage: "Use cases"
            }),
            items: [
                {
                    id: "loom-jira",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-jira",
                        defaultMessage: "Loom + Jira"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/loom-jira")
                },
                {
                    id: "loom-confluence",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.loom-confluence",
                        defaultMessage: "Loom + Confluence"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/loom-confluence")
                }
            ]
        },
        companysize: {
            id: "companysize",
            title: (0, $fnHPc.defineMessage)({
                id: "loom-product-nav.solutions.links.company-size",
                defaultMessage: "Company Size"
            }),
            items: [
                {
                    id: "enterprise",
                    text: (0, $fnHPc.defineMessage)({
                        id: "loom-product-nav.solutions.links.enterprise",
                        defaultMessage: "Enterprise"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/loom/enterprise")
                }
            ]
        }
    };
}
const $7ae29eaf01c2e45b$export$e7b21fd28cd3f276 = ({ productKey: productKey = "loom" })=>{
    const intl = (0, $8e22h.default)();
    const loomSolutionLinks = $7ae29eaf01c2e45b$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkcd5j _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("4ui88", function(module, exports) {
$parcel$export(module.exports, "LoomAiSection", function () { return $71efe2429e06e754$export$7b95013d8cafda1; });
/* loom-ai-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $20Gca = parcelRequire("20Gca");

var $imIsw = parcelRequire("imIsw");

var $dl2JF = parcelRequire("dl2JF");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $dQswK = parcelRequire("dQswK");
const $71efe2429e06e754$export$7b95013d8cafda1 = ()=>{
    var _context_datacenterPlans, _loomAiContent_microCta_, _loomAiContent_microCta, _loomAiContent_highlightedFeaturesContainer;
    const context = (0, $dl2JF.usePricingContentContext)();
    const loomAiContent = context === null || context === void 0 ? void 0 : (_context_datacenterPlans = context.datacenterPlans) === null || _context_datacenterPlans === void 0 ? void 0 : _context_datacenterPlans[0];
    const ctaContent = (loomAiContent === null || loomAiContent === void 0 ? void 0 : (_loomAiContent_microCta = loomAiContent.microCta) === null || _loomAiContent_microCta === void 0 ? void 0 : (_loomAiContent_microCta_ = _loomAiContent_microCta[0]) === null || _loomAiContent_microCta_ === void 0 ? void 0 : _loomAiContent_microCta_.__typename) === "ContentPlatformCallToActionMicrocopy" ? loomAiContent.microCta[0] : undefined;
    var _loomAiContent_planOneLiner;
    const textParagraph = (_loomAiContent_planOneLiner = loomAiContent === null || loomAiContent === void 0 ? void 0 : loomAiContent.planOneLiner) !== null && _loomAiContent_planOneLiner !== void 0 ? _loomAiContent_planOneLiner : "";
    const textBullets = loomAiContent === null || loomAiContent === void 0 ? void 0 : (_loomAiContent_highlightedFeaturesContainer = loomAiContent.highlightedFeaturesContainer) === null || _loomAiContent_highlightedFeaturesContainer === void 0 ? void 0 : _loomAiContent_highlightedFeaturesContainer.map((highlightedFeature)=>{
        return {
            text: highlightedFeature === null || highlightedFeature === void 0 ? void 0 : highlightedFeature.highlightedFeatureTitleExternal,
            callOut: highlightedFeature === null || highlightedFeature === void 0 ? void 0 : highlightedFeature.callOut
        };
    });
    const zeroMarginCss = null;
    const defaultPremiumSignupUrl = (0, $dQswK.usePremiumSignupUrl)();
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/07v5f6mik43gk4jga0367a2x5qn64vbp.webp",
                        alt: intl.formatMessage({
                            id: "LoomPricingPage.LoomAiSection.meetingGraphicAltText",
                            defaultMessage: "Example graphic of using Loom AI for meetings"
                        })
                    },
                    style: {
                        width: "100%",
                        height: "auto"
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx2vrvc _4cvr1y6m _zulp1b66"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: loomAiContent === null || loomAiContent === void 0 ? void 0 : loomAiContent.planTitleExternal
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                    image: {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp",
                                        alt: ""
                                    },
                                    style: {
                                        width: "100%",
                                        height: "27px",
                                        position: "relative",
                                        insetBlockStart: "var(--ds-space-050, 4px)"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: textParagraph
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_6rthpxbi"
                            ]),
                            children: textBullets === null || textBullets === void 0 ? void 0 : textBullets.map((bullet)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                                        children: [
                                            bullet.text,
                                            bullet.callOut && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_ahbq1b66"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                                                    children: bullet.callOut
                                                })
                                            })
                                        ]
                                    })
                                }, bullet.text);
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                            href: (ctaContent === null || ctaContent === void 0 ? void 0 : ctaContent.ctaUrl) || defaultPremiumSignupUrl,
                            size: "small",
                            children: (ctaContent === null || ctaContent === void 0 ? void 0 : ctaContent.ctaButtonText) || intl.formatMessage({
                                id: "LoomAiSection.ctaButtonText",
                                defaultMessage: "Try for free"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("dQswK", function(module, exports) {
$parcel$export(module.exports, "SIGNUP_URL_QUERY_PREMIUM", function () { return $8f236d094af265c8$export$ff7054db20c33aeb; });
$parcel$export(module.exports, "usePremiumSignupUrl", function () { return $8f236d094af265c8$export$aa185ad968f4b15f; });

var $kooLp = parcelRequire("kooLp");
const $8f236d094af265c8$export$ff7054db20c33aeb = "?bundle=loom&edition=premium";
const $8f236d094af265c8$export$aa185ad968f4b15f = ()=>(0, $kooLp.useLocalizedHref)(`/try/cloud/signup${$8f236d094af265c8$export$ff7054db20c33aeb}`);

});


parcelRegister("9Url8", function(module, exports) {
$parcel$export(module.exports, "LoomPriceFinder", function () { return $44da10c9bd623a4e$export$4377a557bebc94dd; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
parcelRequire("5579Q");
var $k6638 = parcelRequire("k6638");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");

var $kooLp = parcelRequire("kooLp");

var $crD7r = parcelRequire("crD7r");

var $dQswK = parcelRequire("dQswK");
const $44da10c9bd623a4e$export$4377a557bebc94dd = (props)=>{
    var _content_free, _content_standard, _content_premium, _content_enterprise, _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)("Starter"),
        standard: (0, $dl2JF.usePricingPlanComparison)("Business"),
        premium: (0, $dl2JF.usePricingPlanComparison)("Business + AI"),
        enterprise: (0, $dl2JF.usePricingPlanComparison)("Enterprise")
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "free");
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "premium");
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "enterprise");
    var _content_free_planOneLiner, _content_standard_planOneLiner, _content_premium_planOneLiner, _content_enterprise_planOneLiner;
    const loomProductPlans = [
        {
            planName: "Starter",
            offeringSku: "loom-free-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: freePlanFeatureMessages,
            description: (_content_free_planOneLiner = (_content_free = content.free) === null || _content_free === void 0 ? void 0 : _content_free.planOneLiner) !== null && _content_free_planOneLiner !== void 0 ? _content_free_planOneLiner : "",
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Business",
            offeringSku: "loom-business-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: standardPlanFeatureMessages,
            description: (_content_standard_planOneLiner = (_content_standard = content.standard) === null || _content_standard === void 0 ? void 0 : _content_standard.planOneLiner) !== null && _content_standard_planOneLiner !== void 0 ? _content_standard_planOneLiner : "",
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Business + AI",
            planTitleComponent: (0, $crD7r.LoomAiTitle),
            offeringSku: "loom-business-ai-sku",
            recommendationLimit: 0,
            signupLimit: 50000,
            planFeatureMessages: premiumPlanFeatureMessages,
            description: (_content_premium_planOneLiner = (_content_premium = content.premium) === null || _content_premium === void 0 ? void 0 : _content_premium.planOneLiner) !== null && _content_premium_planOneLiner !== void 0 ? _content_premium_planOneLiner : "",
            signupURLSuffix: (0, $dQswK.SIGNUP_URL_QUERY_PREMIUM)
        },
        {
            planName: "Enterprise",
            offeringSku: "loom-enterprise-sku",
            recommendationLimit: Infinity,
            signupLimit: 50000,
            planFeatureMessages: enterprisePlanFeatureMessages,
            description: (_content_enterprise_planOneLiner = (_content_enterprise = content.enterprise) === null || _content_enterprise === void 0 ? void 0 : _content_enterprise.planOneLiner) !== null && _content_enterprise_planOneLiner !== void 0 ? _content_enterprise_planOneLiner : ""
        }
    ];
    let cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {});
    const locale = (0, $kooLp.useLocale)();
    if (locale === "en") cardEnterpriseBodyOverride = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k6638.ContentText), {
        variant: "xl",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "LoomPriceFinderTeam25.cardEnterpriseBodyOverride",
            defaultMessage: "Let's talk"
        })
    });
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "LoomPriceFinderTeam25.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "LoomPriceFinderTeam25.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "LoomPriceFinderTeam25.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        cardOverSignupLimit: {
            id: "LoomPriceFinderTeam25.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "LoomPriceFinderTeam25.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "LoomPriceFinderTeam25.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "LoomPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardEnterpriseBodyOverride: // @ts-ignore
        cardEnterpriseBodyOverride
    });
    const recommendationElement = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "LoomPriceFinderTeam25.recommendationElement",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "loom",
            productPlans: loomProductPlans,
            defaultUnitCount: 100,
            shouldAddDiscount: props.shouldAddDiscount,
            annualUserTierDisplayThreshold: 26,
            recommendationElement: recommendationElement,
            ctaUrlSource: props.ctaUrlSource,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.loom,
                countryCode: props.countryCode
            })
        })
    });
};
$44da10c9bd623a4e$export$4377a557bebc94dd.displayName = "LoomPriceFinder";

});
parcelRegister("crD7r", function(module, exports) {
$parcel$export(module.exports, "LoomAiTitle", function () { return $981d3821a6ea456e$export$930d845fa234c9bc; });

var $7VQPk = parcelRequire("7VQPk");

var $lP7A9 = parcelRequire("lP7A9");

var $imIsw = parcelRequire("imIsw");
const $981d3821a6ea456e$export$930d845fa234c9bc = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        id: `pricing-plan-title-${props.planName}`,
        children: [
            props.planName,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/y42547423ap63hd11cr1832n3n455pt5.webp",
                    alt: ""
                },
                style: {
                    height: "17px",
                    width: "17px",
                    position: "relative",
                    insetInlineStart: (0, $lP7A9.default)("space.025"),
                    insetBlockEnd: (0, $lP7A9.default)("space.050")
                }
            })
        ]
    });
};

});




parcelRegister("ioPgw", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoPricingPage", function () { return $e13c4f74aaa45a69$export$28b640e1f1ca7dbf; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("6ulAx");
var $hN6aG = parcelRequire("hN6aG");
const $e13c4f74aaa45a69$export$28b640e1f1ca7dbf = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "rovo-pricing-page",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
            productId: "rovo",
            pricingContent: props.pricingContent,
            queryRef: props.queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hN6aG.SoftwareRovoPricingPageTemplate), (0, $6ogO3._)({}, props))
        })
    });
};

});
parcelRegister("6ulAx", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoPricingPageTemplate", function () { return (parcelRequire("hN6aG")).SoftwareRovoPricingPageTemplate; });

var $hN6aG = parcelRequire("hN6aG");

});
parcelRegister("hN6aG", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoPricingPageTemplate", function () { return $5fb67fb458372cd2$export$b59f422a2cd6b675; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");
parcelRequire("h9b6O");
var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $2zOxm = parcelRequire("2zOxm");

var $bE8d4 = parcelRequire("bE8d4");
parcelRequire("1YZW1");
var $6Px6U = parcelRequire("6Px6U");
var $grcEk = parcelRequire("grcEk");

var $3wzIU = parcelRequire("3wzIU");

var $5S2vX = parcelRequire("5S2vX");

var $gTzEq = parcelRequire("gTzEq");

var $9uWXx = parcelRequire("9uWXx");
const $5fb67fb458372cd2$export$b59f422a2cd6b675 = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    var _content_compareFeaturesTitle, _content_comparePlans, _content_compareFeatures, _content_getMoreDetailsTitle, _content_additionalDetails;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3wzIU.RovoNav), {}),
        showFallback: content === null || content === void 0 ? void 0 : content.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "rovo-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        id: "rovo",
                        children: content === null || content === void 0 ? void 0 : content.headline
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gTzEq.RovoPriceFinder), (0, $6ogO3._)({}, props)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: (_content_compareFeaturesTitle = content === null || content === void 0 ? void 0 : content.compareFeaturesTitle) !== null && _content_compareFeaturesTitle !== void 0 ? _content_compareFeaturesTitle : undefined,
                    comparePlans: (_content_comparePlans = content === null || content === void 0 ? void 0 : content.comparePlans) !== null && _content_comparePlans !== void 0 ? _content_comparePlans : undefined,
                    compareFeatures: (_content_compareFeatures = content === null || content === void 0 ? void 0 : content.compareFeatures) !== null && _content_compareFeatures !== void 0 ? _content_compareFeatures : undefined
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: (_content_getMoreDetailsTitle = content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle) !== null && _content_getMoreDetailsTitle !== void 0 ? _content_getMoreDetailsTitle : undefined,
                            planDetails: (_content_additionalDetails = content === null || content === void 0 ? void 0 : content.additionalDetails) !== null && _content_additionalDetails !== void 0 ? _content_additionalDetails : undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9uWXx.RovoQuestionsCta), {})
            ]
        })
    });
};

});
parcelRegister("3wzIU", function(module, exports) {
$parcel$export(module.exports, "RovoNav", function () { return $d94e8e579fb0c00d$export$f7b51e35c95f667c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3o1l4 = parcelRequire("3o1l4");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $cR2Ov = parcelRequire("cR2Ov");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $3riD8 = parcelRequire("3riD8");
const $d94e8e579fb0c00d$export$f7b51e35c95f667c = ()=>{
    var _userSegments_UserSegmentTypes_OWNED_PRODUCTS;
    const intl = (0, $8e22h.default)();
    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/features")
        },
        {
            globalLinksKey: "connectors",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.connectors",
                defaultMessage: "Connectors"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/connectors")
        },
        {
            globalLinksKey: "use-cases",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.use-cases",
                defaultMessage: "Use cases"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/use-cases")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            productKey: "rovo",
            containerPosition: "relative",
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                orientation: "column",
                contentSections: [
                    {
                        links: [
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.ai-adoption-resources",
                                    defaultMessage: "AI adoption resources"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("http://community.atlassian.com/learning/hub/rovo")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.admin-onboarding",
                                    defaultMessage: "Admin onboarding"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("/software/rovo/guides/admin-guide")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.end-user-onboarding",
                                    defaultMessage: "End-user onboarding"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("/software/rovo/guides/end-user-guide")
                            }
                        ]
                    }
                ]
            })
        },
        {
            globalLinksKey: "licensing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.licensing",
                defaultMessage: "Licensing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/licensing/rovo")
        }
    ];
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const isRovoCtasEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8011RovoProductTour);
    const gwp8979RovoOnWacButtonEG = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwp8979RovoChatOnWac);
    const gwp8979RovoOnWacButtonFG = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8979RovoOnWacButton);
    const { data: userSegments } = (0, $3o1l4.useUserSegments)();
    const isRovoInPlanList = userSegments === null || userSegments === void 0 ? void 0 : (_userSegments_UserSegmentTypes_OWNED_PRODUCTS = userSegments[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]) === null || _userSegments_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _userSegments_UserSegmentTypes_OWNED_PRODUCTS.includes("rovo.ondemand");
    const defaultCTAUrl = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium");
    const isUserLoggedInAndCtasEnabledAndInPlan = isUserLoggedIn && isRovoCtasEnabled && isRovoInPlanList;
    const isRovoEnabled = isUserLoggedInAndCtasEnabledAndInPlan || gwp8979RovoOnWacButtonEG.type === "enrolled" && gwp8979RovoOnWacButtonEG.value;
    const ctaText = isRovoEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.try-rovo",
        defaultMessage: "Try Rovo"
    }) : isRovoCtasEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.get-rovo",
        defaultMessage: "Get Rovo"
    }) : undefined;
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? "https://home.atlassian.com/chat" : isRovoCtasEnabled ? defaultCTAUrl : undefined;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const shouldShowCTAButtonVariant = gwp8979RovoOnWacButtonEG.type === "enrolled" && gwp8979RovoOnWacButtonEG.value && gwp8979RovoOnWacButtonFG;
    const buttonVariant = shouldShowCTAButtonVariant ? "secondary" : "primary";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            productLogoAriaLabel: intl.formatMessage({
                id: "RovoPageTemplate.navbar.rovo-logo",
                defaultMessage: "Rovo logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaButtonVariant: buttonVariant,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-rovo",
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("gTzEq", function(module, exports) {
$parcel$export(module.exports, "RovoPriceFinder", function () { return $c856a897304fd7ef$export$dc441f522034d071; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");
const $c856a897304fd7ef$export$dc441f522034d071 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const content = {
        standard: (0, $dl2JF.usePricingPlanComparison)("Rovo")
    };
    const planFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, "standard");
    const rovoProductPlans = [
        {
            planName: "Standard",
            offeringSku: "rovo-org-purchase-sku",
            recommendationLimit: 100000,
            signupLimit: 35000,
            signupURLInfo: {
                urlDomain: window.location.origin,
                urlPath: "/software/rovo/start",
                shouldLocalize: true
            },
            planFeatureMessages: planFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        unitCountInputTextRedesign: {
            id: "RovoSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "RovoSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        cardOverSignupLimit: {
            id: "RovoSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "RovoSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "RovoSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "RovoSoftwarePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "rovo",
            productPlans: rovoProductPlans,
            defaultUnitCount: 375,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), (0, $6ogO3._)({
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.rovo,
                countryCode: props.countryCode
            }, props))
        })
    });
};
$c856a897304fd7ef$export$dc441f522034d071.displayName = "RovoPriceFinderSection";

});

parcelRegister("9uWXx", function(module, exports) {
$parcel$export(module.exports, "RovoQuestionsCta", function () { return $d2a25cde4c4631f2$export$c1392586038e7a93; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("g1ccm");
var $frz5c = parcelRequire("frz5c");

var $dl2JF = parcelRequire("dl2JF");

var $kooLp = parcelRequire("kooLp");
const $d2a25cde4c4631f2$export$c1392586038e7a93 = ()=>{
    var _content_callToActionContainer, _questionsCtaContent_asset;
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content === null || content === void 0 ? void 0 : (_content_callToActionContainer = content.callToActionContainer) === null || _content_callToActionContainer === void 0 ? void 0 : _content_callToActionContainer[0];
    const locale = (0, $kooLp.useLocale)();
    const questionsCtaHref = `https://support.atlassian.com${(0, $kooLp.getLocalizedHref)({
        locale: locale,
        href: "/subscriptions-and-billing/docs/managing-your-bill-for-rovo/",
        supportedLocales: (0, $kooLp.ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES)
    })}`;
    var _questionsCtaContent_url, _questionsCtaContent_title, _questionsCtaContent_text, _questionsCtaContent_valueProposition;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
        product: "Rovo",
        ctaHref: (_questionsCtaContent_url = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.url) !== null && _questionsCtaContent_url !== void 0 ? _questionsCtaContent_url : questionsCtaHref,
        questionsHeader: (_questionsCtaContent_title = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.title) !== null && _questionsCtaContent_title !== void 0 ? _questionsCtaContent_title : undefined,
        priceAndLicensingLinkText: (_questionsCtaContent_text = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.text) !== null && _questionsCtaContent_text !== void 0 ? _questionsCtaContent_text : undefined,
        questionsBody: (_questionsCtaContent_valueProposition = questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : questionsCtaContent.valueProposition) !== null && _questionsCtaContent_valueProposition !== void 0 ? _questionsCtaContent_valueProposition : undefined,
        imageHref: questionsCtaContent === null || questionsCtaContent === void 0 ? void 0 : (_questionsCtaContent_asset = questionsCtaContent.asset) === null || _questionsCtaContent_asset === void 0 ? void 0 : _questionsCtaContent_asset.url
    });
};
$d2a25cde4c4631f2$export$c1392586038e7a93.displayName = "RovoQuestionsCtaSection";

});




parcelRegister("hI6CC", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPage", function () { return $af65b479e9aa4397$export$7b3d03c2fa269586; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $6iKF0 = parcelRequire("6iKF0");
parcelRequire("gKZds");
var $72aQB = parcelRequire("72aQB");

var $gsqLc = parcelRequire("gsqLc");
const $af65b479e9aa4397$export$7b3d03c2fa269586 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleOnError = (0, $1oC0p.useCallback)((error)=>{
        createAnalyticsEvent({
            action: "failed",
            eventType: "track",
            actionSubject: "SoftwareRovoStartPage",
            source: "SoftwareRovoStartPage",
            attributes: {
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gsqLc.ErrorScreen), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $72aQB.SoftwareRovoStartPageTemplate), {})
    });
};

});
parcelRegister("gKZds", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return (parcelRequire("72aQB")).SoftwareRovoStartPageTemplate; });

var $72aQB = parcelRequire("72aQB");

});
parcelRegister("72aQB", function(module, exports) {
$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return $154413073beb82d2$export$89c9d15d38180eeb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $PE2DD = parcelRequire("PE2DD");

var $6Z2mc = parcelRequire("6Z2mc");

var $3riD8 = parcelRequire("3riD8");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $4weTV = parcelRequire("4weTV");

var $6VYIX = parcelRequire("6VYIX");
const $154413073beb82d2$export$89c9d15d38180eeb = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const [redirectUrl, setRedirectUrl] = (0, $1oC0p.useState)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/contact");
    const adminBaseUrl = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === "undefined") return "https://admin.atlassian.com";
        return (0, $6Z2mc.isProduction)() ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        redirectUrl && setTimeout(()=>window.location.href = redirectUrl, 300);
    }, [
        redirectUrl
    ]);
    const fireViewAnalytics = (0, $1oC0p.useCallback)((attributes = {})=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPage",
            source: "softwareRovoStartPage",
            attributes: attributes
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const getIsOrgAdmin = (0, $1oC0p.useCallback)(async ()=>{
        const { success: success, accountOrgs: accountOrgs } = await stargateClient.getAccountOrgs({});
        if (!success) throw new Error("Get account/orgs call failed");
        const isOrgAdmin = !!(accountOrgs && accountOrgs.length > 0);
        fireViewAnalytics({
            isOrgAdmin: isOrgAdmin
        });
        isOrgAdmin ? setRedirectUrl(`${adminBaseUrl}/rovo`) : setRedirectUrl(localizedContactHref);
    }, [
        fireViewAnalytics,
        stargateClient,
        setRedirectUrl,
        localizedContactHref,
        adminBaseUrl
    ]);
    const checkIfRovoProductExists = (0, $1oC0p.useCallback)(async ()=>{
        const productsUrl = (0, $6Z2mc.isProduction)() ? "https://rovo.atlassian.com" : "https://home.stg.atlassian.com/rovo";
        const { accountProducts: accountProducts, success: success } = await stargateClient.getAccountProducts({});
        if (!success) throw new Error("Get account/products call failed");
        if (accountProducts && accountProducts.length > 0) {
            const siteWithRovo = accountProducts.find((site)=>site.products.includes("rovo.ondemand"));
            if (siteWithRovo) {
                fireViewAnalytics({
                    hasRovo: true
                });
                const cloudId = siteWithRovo.cloudId;
                setRedirectUrl(`${productsUrl}?cloudId=${cloudId}`);
                return;
            }
        }
        getIsOrgAdmin();
    }, [
        stargateClient,
        fireViewAnalytics,
        getIsOrgAdmin,
        setRedirectUrl
    ]);
    (0, $1oC0p.useEffect)(()=>{
        switch(requestInProgress){
            case false:
                switch(isUserLoggedIn){
                    case true:
                        checkIfRovoProductExists();
                        break;
                    case false:
                        fireViewAnalytics();
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }, [
        fireViewAnalytics,
        checkIfRovoProductExists,
        isUserLoggedIn,
        requestInProgress
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: !requestInProgress && !isUserLoggedIn ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4weTV.LoginContactSales), {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6VYIX.LoadingSpinner), {})
    });
};

});
parcelRegister("4weTV", function(module, exports) {
$parcel$export(module.exports, "LoginContactSales", function () { return $00bb124a426bfcbf$export$6a33a815ad7360e9; });
/* login-contact-sales.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $5yMx4 = parcelRequire("5yMx4");

var $99VqK = parcelRequire("99VqK");
var $7OBrw = parcelRequire("7OBrw");
var $9HSUa = parcelRequire("9HSUa");
var $bHlSp = parcelRequire("bHlSp");
var $4HBPY = parcelRequire("4HBPY");

var $5qUgh = parcelRequire("5qUgh");
parcelRequire("l22jm");
var $8IYGL = parcelRequire("8IYGL");

var $k18Zl = parcelRequire("k18Zl");

var $2fk4i = parcelRequire("2fk4i");

var $6Z2mc = parcelRequire("6Z2mc");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $cxI2Y = parcelRequire("cxI2Y");
const $00bb124a426bfcbf$var$elevatedContainerInnerStyles = (0, $4HBPY.xcss)({
    textAlign: "center",
    paddingBlockStart: "space.500"
});
const $00bb124a426bfcbf$var$bodyTextStyles = (0, $4HBPY.xcss)({
    paddingBlockStart: "space.100"
});
const $00bb124a426bfcbf$var$loginButtonStyles = (0, $4HBPY.xcss)({
    paddingBlockStart: "space.400",
    paddingBlockEnd: "space.400",
    paddingInlineStart: "space.800",
    paddingInlineEnd: "space.800"
});
const $00bb124a426bfcbf$var$contactAtlassianStyles = (0, $4HBPY.xcss)({
    justifyContent: "center"
});
const $00bb124a426bfcbf$var$relative = null;
const $00bb124a426bfcbf$var$whiteBackground = null;
const $00bb124a426bfcbf$export$6a33a815ad7360e9 = ()=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/contact");
    const fireButtonAnalytics = (0, $1oC0p.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "loginContactSalesScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const loginButtonHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics("loginButton"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    const loginUrl = (0, $1oC0p.useMemo)(()=>{
        if (typeof window === "undefined") return "id.atlassian.com/";
        return (0, $6Z2mc.isProduction)() ? "https://id.atlassian.com/" : "https://id.stg.internal.atlassian.com/";
    }, []);
    const LinktoContactAtlassian = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: localizedContactHref,
            type: "primary",
            ariaLabel: "Contact Atlassian Page",
            "aria-label": "Contact Atlassian Page",
            text: props.children,
            onClick: contactSalesLinkHandler
        });
    const allItemsContactAtlassian = intl.formatMessage((0, $8AQXb.messages).contactAtlassianText, {
        a: (contactAtlassian)=>/*#__PURE__*/ (0, $7VQPk.jsx)(LinktoContactAtlassian, {
                children: contactAtlassian
            })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k18Zl.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5yMx4.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9HSUa.default), {
            xcss: $00bb124a426bfcbf$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1pbyidpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _u7coidpf _1e02idpf _rjxpidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1mrw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $8AQXb.messages).rovoGetStarted), {
                                values: {
                                    started: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IYGL.Adg4TextUnderline), {
                                            underline: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cxI2Y.ScribbleImage), {}),
                                            fontWeight: {
                                                from: 600,
                                                to: 600
                                            },
                                            children: str
                                        })
                                }
                            }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $99VqK.default), {
                    xcss: $00bb124a426bfcbf$var$bodyTextStyles,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bHlSp.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $8AQXb.messages).rovoBodyText))
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $99VqK.default), {
                    xcss: $00bb124a426bfcbf$var$loginButtonStyles,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                        size: "small",
                        isFullWidth: true,
                        "aria-label": "Login Button",
                        href: `${loginUrl}login?continue=${encodeURIComponent(window.location.href)}`,
                        onClick: loginButtonHandler,
                        target: "",
                        children: intl.formatMessage((0, $8AQXb.messages).loginButtonRovo)
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7OBrw.default), {
                    space: "space.100",
                    xcss: $00bb124a426bfcbf$var$contactAtlassianStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $8AQXb.messages).dontHaveAccountText)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $99VqK.default), {
                            children: allItemsContactAtlassian
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("5yMx4", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", function () { return $40c5c63fd8f4fd26$export$a0f6cb8061290bbb; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $40c5c63fd8f4fd26$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $40c5c63fd8f4fd26$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $40c5c63fd8f4fd26$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7OBrw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b0a3f47ca61ccb4$export$2e2bcd8739ae039; });

var $halAH = parcelRequire("halAH");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $4HBPY = parcelRequire("4HBPY");

var $2FlEO = parcelRequire("2FlEO");
var $5b0a3f47ca61ccb4$var$flexGrowMap = {
    hug: (0, $4HBPY.xcss)({
        flexGrow: 0
    }),
    fill: (0, $4HBPY.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $5b0a3f47ca61ccb4$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $5b0a3f47ca61ccb4$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $5b0a3f47ca61ccb4$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5b0a3f47ca61ccb4$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($5b0a3f47ca61ccb4$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $3dJ4i.jsx)((0, $2FlEO.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: grow ? [
            $5b0a3f47ca61ccb4$var$flexGrowMap[grow]
        ].concat((0, $halAH.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$5b0a3f47ca61ccb4$var$Inline.displayName = 'Inline';
var $5b0a3f47ca61ccb4$export$2e2bcd8739ae039 = $5b0a3f47ca61ccb4$var$Inline;

});

parcelRegister("8AQXb", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $8fa89a103bc738eb$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $8fa89a103bc738eb$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    loading: {
        id: "SoftwareRovoStart.Page.loading",
        defaultMessage: "Loading"
    },
    login: {
        id: "SoftwareRovoStart.Page.login",
        defaultMessage: "Login"
    },
    contactSales: {
        id: "SoftwareRovoStart.Page.contactSales",
        defaultMessage: "Contact Sales"
    },
    rovoGetStarted: {
        defaultMessage: "Get <started>started</started> with Rovo",
        description: "Title text for WAC Rovo Start_logged out page",
        id: "SoftwareRovoStart.Page.rovoGetStarted"
    },
    loginButtonRovo: {
        defaultMessage: "Log in",
        id: "SoftwareRovoStart.Page.loginButtonRovo"
    },
    rovoBodyText: {
        defaultMessage: "Log in to add it to your organization",
        id: "SoftwareRovoStart.Page.rovoBodyText"
    },
    dontHaveAccountText: {
        defaultMessage: "Don\u2019t have an account?",
        id: "SoftwareRovoStart.Page.dontHaveAccountText"
    },
    contactAtlassianText: {
        defaultMessage: "<a>Contact Atlassian</a>",
        id: "SoftwareRovoStart.Page.contactAtlassianText"
    },
    errorScreenTitle: {
        defaultMessage: "Something went wrong",
        description: "Error screen title",
        id: "SoftwareRovoStart.Page.errorScreenTitle"
    },
    errorScreenMessageOne: {
        defaultMessage: "<a>Contact support</a> for further help or try again.",
        description: "Error screen message part one",
        id: "SoftwareRovoStart.Page.errorScreenMessageOne"
    },
    errorScreenMessageTwo: {
        defaultMessage: "To receive a quote for Rovo, <a>contact sales.</a>",
        description: "Error screen message part two",
        id: "SoftwareRovoStart.Page.errorScreenMessageTwo"
    }
});

});

parcelRegister("cxI2Y", function(module, exports) {
$parcel$export(module.exports, "ScribbleImage", function () { return $84c16d41bc354312$export$31b1a25c5f295125; });

var $7VQPk = parcelRequire("7VQPk");
const $84c16d41bc354312$var$ScribbleImageComponent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "105",
        height: "17",
        viewBox: "0 0 105 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z",
            fill: "#FCA700"
        })
    });
};
const $84c16d41bc354312$export$31b1a25c5f295125 = $84c16d41bc354312$var$ScribbleImageComponent;

});


parcelRegister("6VYIX", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $6c345910e2c56d86$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $7qFQI = parcelRequire("7qFQI");

var $8AQXb = parcelRequire("8AQXb");
const $6c345910e2c56d86$var$loadingCss = null;
const $6c345910e2c56d86$export$b08b517936747730 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "progressbar",
        "aria-label": intl.formatMessage((0, $8AQXb.messages).loading),
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tke1kxc"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "large"
        })
    });
};

});



parcelRegister("gsqLc", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", function () { return $88cb943b67e1fe7e$export$42f84e610f279c31; });
/* error-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $dTJrO = parcelRequire("dTJrO");

var $5yMx4 = parcelRequire("5yMx4");

var $7OBrw = parcelRequire("7OBrw");
var $9HSUa = parcelRequire("9HSUa");
var $4HBPY = parcelRequire("4HBPY");

var $k18Zl = parcelRequire("k18Zl");

var $iSeHD = parcelRequire("iSeHD");

var $jQ0cd = parcelRequire("jQ0cd");

var $8AQXb = parcelRequire("8AQXb");

var $fJCnK = parcelRequire("fJCnK");
const $88cb943b67e1fe7e$var$elevatedContainerInnerStyles = (0, $4HBPY.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.400",
    alignSelf: "stretch",
    paddingBlockStart: "space.150"
});
const $88cb943b67e1fe7e$var$contentStyles = (0, $4HBPY.xcss)({
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.200"
});
const $88cb943b67e1fe7e$var$bodyStyles = (0, $4HBPY.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignSelf: "stretch",
    fontSize: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "400"
});
const $88cb943b67e1fe7e$var$linkStyles = null;
const $88cb943b67e1fe7e$export$42f84e610f279c31 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const localizedContactHref = (0, $jQ0cd.useLocalizedHref)("/enterprise/contact");
    (0, $1oC0p.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPageErrorScreen",
            source: "softwareRovoStartPage"
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const fireButtonAnalytics = (0, $1oC0p.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "errorScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const contactSupportLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics("contactSupportLink"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $1oC0p.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k18Zl.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5yMx4.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9HSUa.default), {
            xcss: $88cb943b67e1fe7e$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJCnK.ErrorIconImage), {}),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9HSUa.default), {
                    xcss: $88cb943b67e1fe7e$var$contentStyles,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dTJrO.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $8AQXb.messages).errorScreenTitle))
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9HSUa.default), {
                            xcss: $88cb943b67e1fe7e$var$bodyStyles,
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7OBrw.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $8AQXb.messages).errorScreenMessageOne), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                    href: "https://support.atlassian.com/contact/",
                                                    onClick: contactSupportLinkHandler,
                                                    "aria-label": "Contact Atlassian Support Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7OBrw.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $8AQXb.messages).errorScreenMessageTwo), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                                    href: localizedContactHref,
                                                    onClick: contactSalesLinkHandler,
                                                    "aria-label": "Contact Atlassian Sales Page",
                                                    className: (0, $2jatx.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("fJCnK", function(module, exports) {
$parcel$export(module.exports, "ErrorIconImage", function () { return $ef9db3692a497100$export$a1922be2c234f039; });

var $7VQPk = parcelRequire("7VQPk");
const $ef9db3692a497100$var$ErrorIconComponent = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "105",
        height: "97",
        viewBox: "0 0 105 97",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                clipPath: "url(#clip0_2901_19175)",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M0.629883 96.2192L0.687156 96.3338H104.306L104.37 96.2192L52.4999 0.357422L0.629883 96.2192Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M52.6782 34.6891V69.6954",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M55.1283 80.6028C55.1601 80.4373 55.1728 80.2591 55.1728 80.0746C55.1728 79.8901 55.1601 79.7055 55.1283 79.5401C54.9501 78.541 54.2564 77.9301 53.2828 77.771C53.1174 77.7455 52.9455 77.7328 52.761 77.7328C52.5764 77.7328 52.3919 77.7455 52.2201 77.7773C51.2464 77.9364 50.5592 78.5537 50.3746 79.5464C50.3428 79.7119 50.3301 79.8901 50.3301 80.081C50.3301 80.2719 50.3428 80.4437 50.3746 80.6092C50.5528 81.6019 51.2464 82.2128 52.2201 82.3782C52.3919 82.4101 52.5764 82.4228 52.761 82.4228C52.9455 82.4228 53.1174 82.4101 53.2828 82.3846C54.2564 82.2255 54.9501 81.6082 55.1283 80.6155V80.6028Z",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                    id: "clip0_2901_19175",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                        width: "105",
                        height: "97",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $ef9db3692a497100$export$a1922be2c234f039 = $ef9db3692a497100$var$ErrorIconComponent;

});



parcelRegister("7Lagj", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPage", function () { return $00749ab74f7d8f60$export$536ddfd40654e3e4; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("hQ2DL");
var $hkAZ4 = parcelRequire("hkAZ4");
const $00749ab74f7d8f60$export$536ddfd40654e3e4 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProviderRelay), {
        productId: "nonprofit",
        pricingContent: pricingContent,
        queryRef: queryRef,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "non-profit-pricing",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hkAZ4.NonProfitPricingPageTemplate), {
                pricing: pricing,
                countryCode: countryCode
            })
        })
    });
};

});
parcelRegister("hQ2DL", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplate", function () { return (parcelRequire("hkAZ4")).NonProfitPricingPageTemplate; });
parcelRequire("hkAZ4");

});
parcelRegister("hkAZ4", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplate", function () { return $3183adb2da196ae8$export$55cf024acc460d8c; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $bE8d4 = parcelRequire("bE8d4");
parcelRequire("1YZW1");
var $grcEk = parcelRequire("grcEk");

var $9Url8 = parcelRequire("9Url8");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $9RHgs = parcelRequire("9RHgs");

var $kvg9i = parcelRequire("kvg9i");

var $gaPqz = parcelRequire("gaPqz");

var $btggB = parcelRequire("btggB");

var $vCUGX = parcelRequire("vCUGX");

var $g7wmQ = parcelRequire("g7wmQ");

var $fZJZd = parcelRequire("fZJZd");

var $4bEWc = parcelRequire("4bEWc");

var $71t0B = parcelRequire("71t0B");

var $gtK7Z = parcelRequire("gtK7Z");

var $k53CY = parcelRequire("k53CY");

var $lSpoK = parcelRequire("lSpoK");

var $hJy82 = parcelRequire("hJy82");

var $3icmm = parcelRequire("3icmm");

var $in9in = parcelRequire("in9in");
const $3183adb2da196ae8$export$55cf024acc460d8c = ({ pricing: pricing, countryCode: countryCode })=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const isGwp10027NonprofitPricingPage = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    if (isGwp10027NonprofitPricingPage) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $vCUGX.NonProfitPricingPageTemplateWithTwc), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "nonprofit-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSpoK.NonprofitNav), {}),
                    banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7wmQ.Banner), {}),
                    hero: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gtK7Z.Hero), {}),
                    hasGlobalFooter: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: "#F8F8F8",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fZJZd.EligibleSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k53CY.NonprofitCalculatorHeading), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9RHgs.PricingTabs), {
                                jiraCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gaPqz.JiraPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                confluenceCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kvg9i.ConfluencePriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                trelloCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in9in.TrelloPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true
                                }),
                                loomCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Url8.LoomPriceFinder), {
                                    pricing: pricing,
                                    countryCode: countryCode,
                                    shouldAddDiscount: true,
                                    ctaUrlSource: "productPlans"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bEWc.EnterpriseSection), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: "#E9F2FE",
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJy82.OfficialSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3icmm.ResourcesSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle,
                                planDetails: content === null || content === void 0 ? void 0 : content.additionalDetails
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $71t0B.Fineprint), {})
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("kvg9i", function(module, exports) {
$parcel$export(module.exports, "ConfluencePriceFinder", function () { return $82aa4d75759518c1$export$a33aedde1d62b896; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $koOAf = parcelRequire("koOAf");

var $fFFp6 = parcelRequire("fFFp6");

var $cLbmg = parcelRequire("cLbmg");

var $cOu5a = parcelRequire("cOu5a");

var $fesdZ = parcelRequire("fesdZ");

var $nFBGc = parcelRequire("nFBGc");

var $cgKz4 = parcelRequire("cgKz4");

var $eQdGa = parcelRequire("eQdGa");

var $hUuit = parcelRequire("hUuit");

var $hRBYs = parcelRequire("hRBYs");

var $6EgwO = parcelRequire("6EgwO");

var $gAdOA = parcelRequire("gAdOA");

var $ies49 = parcelRequire("ies49");

var $g1Nmd = parcelRequire("g1Nmd");

var $5CFs0 = parcelRequire("5CFs0");

var $2yu3p = parcelRequire("2yu3p");

var $9Voys = parcelRequire("9Voys");
const $82aa4d75759518c1$export$a33aedde1d62b896 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const intl = (0, $8e22h.default)();
    const newTagText = intl.formatMessage({
        id: "ConfluencePricingPage.priceFinder.newTagText",
        defaultMessage: "New"
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedPages.title",
                    defaultMessage: "Unlimited pages"
                }),
                content: (0, $5CFs0.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedSpaces.title",
                    defaultMessage: "Unlimited spaces"
                }),
                content: (0, $2yu3p.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.databases.title",
                    defaultMessage: "Organize and connect work with databases"
                }),
                content: (0, $nFBGc.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.templates.title",
                    defaultMessage: "Templates for Marketing, Product, Program Management and more"
                }),
                content: (0, $g1Nmd.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.activeWhiteboards.title",
                    defaultMessage: "Up to 3 active whiteboards per user "
                }),
                content: (0, $koOAf.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.title",
                    defaultMessage: "10 automation rule runs per month "
                }),
                content: (0, $fesdZ.FreeAutomationRuleRuns)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.supportAppsAndIntegrations",
                    defaultMessage: "Support for apps and integrations"
                }),
                content: (0, $gAdOA.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.supportFromAtlassianCommunity",
                    defaultMessage: "Support from Atlassian Community"
                }),
                content: (0, $ies49.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.freeFileStorage",
                defaultMessage: "Up to 2 GB file storage"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.title",
                    defaultMessage: "External collaboration"
                }),
                content: (0, $eQdGa.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.pagePermissions.title",
                    defaultMessage: "Page permissions"
                }),
                content: (0, $hUuit.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.title",
                    defaultMessage: "100 automation rule runs per month"
                }),
                content: (0, $fesdZ.StandardAutomationRuleRuns)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.standardStorage.title",
                defaultMessage: "250 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.regionalSupport.title",
                    defaultMessage: "9/5 regional support"
                }),
                content: (0, $6EgwO.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.standard150000singlesSite.title",
                defaultMessage: "Up to 150,000 users on a single site"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.aiPowered.title",
                    defaultMessage: "AI-powered creation and collaboration"
                }),
                content: (0, $cLbmg.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.dynamicIntranet.title",
                    defaultMessage: "Dynamic intranet"
                }),
                content: (0, $cgKz4.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.perUserAutomation.title",
                    defaultMessage: "Per user automation limits (1000 per month)"
                }),
                content: (0, $cOu5a.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.unlimitedWhiteboards.title",
                    defaultMessage: "Unlimited whiteboards"
                }),
                content: (0, $9Voys.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.adminControlsInsights.title",
                    defaultMessage: "Admin controls and insights"
                }),
                content: (0, $fFFp6.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "ConfluencePricingPageTeam24.features.premiumSupport.title",
                    defaultMessage: "24/7 support for critical issues"
                }),
                content: (0, $hRBYs.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.features.premiumSla.title",
                defaultMessage: "99.9% uptime SLA"
            })
        }
    ];
    const confluenceProductPlans = [
        {
            planName: "Free",
            offeringSku: "confluence-free",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=free&signupSource=pricing",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "confluence-standard",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "confluence-premium",
            description: intl.formatMessage({
                id: "ConfluencePricingPageTeam24.priceFinder.premiumDescription",
                defaultMessage: "Connect work across teams"
            }),
            recommendationLimit: 250,
            signupLimit: 150000,
            signupURLSuffix: "?bundle=confluence&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "ConfluencePricingPageTeam24.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "ConfluencePricingPageTeam24.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "confluence",
            productPlans: confluenceProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.confluence,
                countryCode: props.countryCode
            })
        })
    });
};
$82aa4d75759518c1$export$a33aedde1d62b896.displayName = "ConfluencePriceFinder";
var $82aa4d75759518c1$export$2e2bcd8739ae039 = $82aa4d75759518c1$export$a33aedde1d62b896;

});
parcelRegister("koOAf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f16e3c3feb0f7500$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $f16e3c3feb0f7500$var$ActiveWhiteboards = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/whiteboards");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.activeWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. Collaborate, brainstorm, draw and visualize ideas in a freeform way with up to 3 active whiteboards per user. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.activeWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $f16e3c3feb0f7500$export$2e2bcd8739ae039 = $f16e3c3feb0f7500$var$ActiveWhiteboards;

});

parcelRegister("fFFp6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $469172ebba1ea1c7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $469172ebba1ea1c7$var$AdminControlsInsights = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.adminControlsInsights.content.body",
                defaultMessage: "Inspect permissions to specify who can do and create what, and fix permission problems quickly with an admin key. Manage site health, get actionable alerts, and unlock site-level insights, all in one place."
            })
        })
    });
};
var $469172ebba1ea1c7$export$2e2bcd8739ae039 = $469172ebba1ea1c7$var$AdminControlsInsights;

});

parcelRegister("cLbmg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4433695e8f3d4b1b$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $4433695e8f3d4b1b$var$AtlassianIntelligence = ()=>{
    const localizedHref = `https://support.atlassian.com${(0, $kooLp.useLocalizedHref)("/organization-administration/docs/get-started-with-atlassian-intelligence/", {
        supportedLocales: (0, $kooLp.ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES)
    })}`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.atlassianIntelligence.content.body",
                defaultMessage: "Communicate efficiently, glean relevant insights, and work on what matters with AI capabilities. These include AI-powered editing experiences, quick summaries of long pages, and more. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.atlassianInteligence.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $4433695e8f3d4b1b$export$2e2bcd8739ae039 = $4433695e8f3d4b1b$var$AtlassianIntelligence;

});

parcelRegister("cOu5a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca383066b7aa1366$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $ca383066b7aa1366$var$PerUserAutomation = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.perUserAutomation.content.body",
                defaultMessage: "Save time by automating repetitive, manual tasks to organize and manage content at scale. Get started quickly with out-of-the box templates or build your own powerful, custom rules by using the low-code / no-code rule builder and with AI. With Premium, unlock up to 1,000 automations per user per month. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.perUserAutomation.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $ca383066b7aa1366$export$2e2bcd8739ae039 = $ca383066b7aa1366$var$PerUserAutomation;

});

parcelRegister("fesdZ", function(module, exports) {
$parcel$export(module.exports, "FreeAutomationRuleRuns", function () { return $fba808d380f6bdb1$export$cb1c6db7544762b5; });
$parcel$export(module.exports, "StandardAutomationRuleRuns", function () { return $fba808d380f6bdb1$export$6716f876ee5d7d01; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $fba808d380f6bdb1$export$cb1c6db7544762b5 = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Free, unlock 10 automation rule runs per instance per month. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.freeAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
const $fba808d380f6bdb1$export$6716f876ee5d7d01 = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/automation");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Standard, unlock 100 automation rule runs per instance per month. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.standardAutomationRuleRuns.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};

});

parcelRegister("nFBGc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $508f39883b774a30$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");

var $dtAYn = parcelRequire("dtAYn");
const $508f39883b774a30$var$Databases = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/databases");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.databases.content.body",
                defaultMessage: "Confluence databases are a central source of info that dramatically changes the way that teams can organize, reference, and display data in Confluence. <a>Learn more</a>.",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (0, $dtAYn.getMessageHyperlinkValue)({
                        localizedHref: localizedHref,
                        "data-event-container": "ConfluencePricingPage",
                        "data-label-english": "Learn more",
                        "data-track-event": "ConfluencePricingPageTeam24.databases"
                    })
                })
            })
        })
    });
};
var $508f39883b774a30$export$2e2bcd8739ae039 = $508f39883b774a30$var$Databases;

});
parcelRegister("dtAYn", function(module, exports) {
$parcel$export(module.exports, "getMessageHyperlinkValue", function () { return $fc23cd4c346f4bb0$export$c5b540569b1a51b0; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
function $fc23cd4c346f4bb0$export$c5b540569b1a51b0(params) {
    const { localizedHref: localizedHref } = params, rest = (0, $aPnCa._)(params, [
        "localizedHref"
    ]);
    return (chunks)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("a", (0, $dPABA._)((0, $6ogO3._)({
            href: params.localizedHref
        }, rest), {
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-product-key": "confluence",
            children: chunks
        }));
    };
}

});


parcelRegister("cgKz4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6464191f0fead551$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $6464191f0fead551$var$DynamicIntranet = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/use-cases/intranet-software");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.dynamicIntranet.content.body",
                defaultMessage: "Customize a dynamic info hub for your entire company with company hub, a single go-to destination for company news, announcements, and resources. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.dynamicIntranet.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $6464191f0fead551$export$2e2bcd8739ae039 = $6464191f0fead551$var$DynamicIntranet;

});

parcelRegister("eQdGa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f839d5e47581ebfa$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $f839d5e47581ebfa$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyOne",
                    defaultMessage: "Invite external partners to collaborate as guests in your Confluence site. Guests are free of charge, up to 5 guests per paid user."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "ConfluencePricingPageTeam24.features.externalCollaboration.content.bodyTwo",
                    defaultMessage: "You can also share view-only Confluence pages via public links. This can be useful for sharing information to the public, like customer FAQs and release notes."
                })
            })
        ]
    });
};
var $f839d5e47581ebfa$export$2e2bcd8739ae039 = $f839d5e47581ebfa$var$ExternalCollaboration;

});

parcelRegister("hUuit", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ef5e90854da8ecb8$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $ef5e90854da8ecb8$var$PagePermissions = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.pagePermissions.content.body",
                defaultMessage: "Control who can view, edit and comment on your pages, so important information can stay restricted until you\u2019re ready to share."
            })
        })
    });
};
var $ef5e90854da8ecb8$export$2e2bcd8739ae039 = $ef5e90854da8ecb8$var$PagePermissions;

});

parcelRegister("hRBYs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e1e0d16eb6e1cd0$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $5e1e0d16eb6e1cd0$var$PremiumSupport = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/enterprise/support-services");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "Get Premium support around the clock from a dedicated team with 1-hour response times to critical issues. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "learn more",
                            "data-track-event": "ConfluencePricingPageTeam24.premiumSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $5e1e0d16eb6e1cd0$export$2e2bcd8739ae039 = $5e1e0d16eb6e1cd0$var$PremiumSupport;

});

parcelRegister("6EgwO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a5d9a10c21c25a8$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $1a5d9a10c21c25a8$var$RegionalSupport = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/enterprise/support-services");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.regionalSupport.content.body",
                defaultMessage: "Customer support during business hours is available with Confluence Standard plan. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.regionalSupport.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $1a5d9a10c21c25a8$export$2e2bcd8739ae039 = $1a5d9a10c21c25a8$var$RegionalSupport;

});

parcelRegister("gAdOA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3f831b9287d5da4$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $f3f831b9287d5da4$var$SupportAppsIntegrations = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.supportAppsIntegrations.content.body",
                defaultMessage: "Integrate Confluence with other apps you\u2019re already using. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-label-english": "Learn More",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAppsIntegrations.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            href: "https://marketplace.atlassian.com/search?product=confluence",
                            children: chunks
                        })
                })
            })
        })
    });
};
var $f3f831b9287d5da4$export$2e2bcd8739ae039 = $f3f831b9287d5da4$var$SupportAppsIntegrations;

});

parcelRegister("ies49", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b7b841abdaecb242$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $b7b841abdaecb242$var$SupportAtlassianCommunity = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.supportAtlassianCommunity.content.body",
                defaultMessage: "Get support from the <a>Atlassian Community</a>, a public forum of community experts where you can ask questions. You can also access free Confluence guides and knowledge base articles.",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.supportAtlassianCommunity",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "Atlassian Community",
                            href: "https://community.atlassian.com/",
                            children: chunks
                        })
                })
            })
        })
    });
};
var $b7b841abdaecb242$export$2e2bcd8739ae039 = $b7b841abdaecb242$var$SupportAtlassianCommunity;

});

parcelRegister("g1Nmd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d99847d75ead21a0$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $d99847d75ead21a0$var$Templates = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/templates");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.templates.content.body",
                defaultMessage: "Get started quickly by using the <a>template library</a>. From product requirement documents to marketing plans, there\u2019s a template that\u2019s perfect fit for your project.",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.templates",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "template libary",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $d99847d75ead21a0$export$2e2bcd8739ae039 = $d99847d75ead21a0$var$Templates;

});

parcelRegister("5CFs0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b141362605c57423$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $b141362605c57423$var$UnlimitedPages = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedPages.content.body",
                defaultMessage: "Pages are used to create, share, and edit knowledge. These are living documents you can create and update for almost anything \u2013 from project plans, meeting notes, policies and more. You can create as many pages as you need."
            })
        })
    });
};
var $b141362605c57423$export$2e2bcd8739ae039 = $b141362605c57423$var$UnlimitedPages;

});

parcelRegister("2yu3p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d946899749b1f69d$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $d946899749b1f69d$var$UnlimitedSpaces = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedSpaces.content.body",
                defaultMessage: "Spaces are how you organize pages into meaningful categories, like different folders where you can store your work. You can create as many spaces as you need."
            })
        })
    });
};
var $d946899749b1f69d$export$2e2bcd8739ae039 = $d946899749b1f69d$var$UnlimitedSpaces;

});

parcelRegister("9Voys", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a0a4624eaf1e1adf$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $kooLp = parcelRequire("kooLp");
const $a0a4624eaf1e1adf$var$UnlimitedWhiteboards = ()=>{
    const localizedHref = (0, $kooLp.useLocalizedHref)("/software/confluence/whiteboards");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "ConfluencePricingPageTeam24.features.unlimitedWhiteboards.content.body",
                defaultMessage: "Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace. With Premium, unlock unlimited whiteboards and advanced Jira integrations to brainstorm, plan and action work like never before. <a>Learn more.</a>",
                values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
                    a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-product-key": "confluence",
                            "data-track-event": "ConfluencePricingPageTeam24.unlimitedWhiteboards.learnMore",
                            "data-event-container": "ConfluencePriceFinderTeam24",
                            "data-label-english": "learn more",
                            href: localizedHref,
                            children: chunks
                        })
                })
            })
        })
    });
};
var $a0a4624eaf1e1adf$export$2e2bcd8739ae039 = $a0a4624eaf1e1adf$var$UnlimitedWhiteboards;

});


parcelRegister("gaPqz", function(module, exports) {
$parcel$export(module.exports, "JiraPriceFinder", function () { return $47b0960c2ef159b2$export$1bf486cdabb14f4d; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1hGR5 = parcelRequire("1hGR5");

var $c6rNV = parcelRequire("c6rNV");

var $8kuWI = parcelRequire("8kuWI");

var $WOC4s = parcelRequire("WOC4s");

var $5Ikga = parcelRequire("5Ikga");

var $83Gke = parcelRequire("83Gke");

var $guvAv = parcelRequire("guvAv");

var $dBwTO = parcelRequire("dBwTO");

var $h2AoW = parcelRequire("h2AoW");

var $17uTl = parcelRequire("17uTl");

var $6w3tN = parcelRequire("6w3tN");

var $8wGxe = parcelRequire("8wGxe");

var $gl8tX = parcelRequire("gl8tX");
const $47b0960c2ef159b2$export$1bf486cdabb14f4d = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const intl = (0, $8e22h.default)();
    const newTagText = intl.formatMessage({
        id: "JiraSoftwarePricingPage.priceFinder.newTagText",
        defaultMessage: "New"
    });
    const freePlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.unlimitedProjectBoards.title.v2",
                    defaultMessage: "Unlimited goals, projects, tasks, and forms"
                }),
                content: (0, $8wGxe.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.backlogAndTimeline.title",
                    defaultMessage: "Backlog, list, board, timeline, calendar, and summary views"
                }),
                content: (0, $8kuWI.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.reportsAndDashboards.title",
                    defaultMessage: "Reports and dashboards"
                }),
                content: (0, $dBwTO.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.freeAutomations.title",
                    defaultMessage: "100 automation rule runs per month"
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPage.priceFinder.freePlan2GBOfStorage",
                defaultMessage: "2 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.freeCommunitySupport.title",
                    defaultMessage: "Support from Atlassian Community"
                }),
                content: (0, $h2AoW.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.upTo10Users.title",
                defaultMessage: "Up to 10 users"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.userRolesPermissions.title",
                    defaultMessage: "User roles and permissions"
                }),
                content: (0, $gl8tX.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.externalCollaboration.title",
                    defaultMessage: "External collaboration"
                }),
                content: (0, $83Gke.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.multiRegionDataResidency.title",
                    defaultMessage: "Multi-region data residency"
                }),
                content: (0, $guvAv.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.standardAutomations.title",
                    defaultMessage: "1,700 automation rule runs per month"
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.standardStorage.title",
                defaultMessage: "250 GB of storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.standardSupport.title",
                    defaultMessage: "9/5 regional support"
                }),
                content: (0, $6w3tN.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.standard5000singlesSite.title",
                defaultMessage: "Up to 100,000 users on a single site"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.aiPowered.title.v2",
                    defaultMessage: "Generate, summarize, and search content with Atlassian Intelligence (AI)"
                }),
                content: (0, $1hGR5.default)
            },
            lozengeText: newTagText
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.crossTeamPlanning.title",
                    defaultMessage: "Cross-team planning and dependency management"
                }),
                content: (0, $WOC4s.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.customizableApprovalProcesses.title",
                    defaultMessage: "Customizable approval processes"
                }),
                content: (0, $5Ikga.default)
            }
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.premiumAutomation.title",
                    defaultMessage: "Per user automation limits (1,000 rule runs per month)"
                }),
                content: (0, $c6rNV.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage"
            })
        },
        {
            featureMessage: {
                text: intl.formatMessage({
                    id: "JiraSoftwarePricingPageV2.features.premiumSupport.title",
                    defaultMessage: "24/7 support for critical issues"
                }),
                content: (0, $17uTl.default)
            }
        },
        {
            featureMessage: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.features.premiumSla.title",
                defaultMessage: "99.9% uptime SLA"
            })
        }
    ];
    const signupLimit = 100000;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: "Free",
            offeringSku: "jira-software-free",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.freeDescription",
                defaultMessage: "Free forever for 10 users"
            }),
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=free",
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "jira-software-standard",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.standardDescription",
                defaultMessage: "Everything you need to get started"
            }),
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=standard",
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "jira-software-premium",
            description: intl.formatMessage({
                id: "JiraSoftwarePricingPageV2.priceFinder.premiumDescription",
                defaultMessage: "Align multiple teams"
            }),
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: "?bundle=jira-software&edition=premium",
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "JiraSoftwarePricingPageV2.priceFinder.header",
            defaultMessage: "<blue>Simple, transparent pricing</blue> for every team."
        },
        unitCountInputText: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTextRedesign: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputDirectBuy: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy",
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "JiraSoftwarePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputTooltip: {
            id: "JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Jira Software user is any user who can log in to Jira Software, and who exists in User Management"
        },
        cardOverSignupLimit: {
            id: "JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "JiraSoftwarePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$47b0960c2ef159b2$export$1bf486cdabb14f4d.displayName = "JiraPriceFinder";

});
parcelRegister("1hGR5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $46f8509b6a94140e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $46f8509b6a94140e$var$AtlassianIntelligence = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.aiPowered.content.body.v2",
                defaultMessage: "Get more done with AI-powered summaries, generative AI editing, and natural language to build automations or search issues."
            })
        })
    });
};
var $46f8509b6a94140e$export$2e2bcd8739ae039 = $46f8509b6a94140e$var$AtlassianIntelligence;

});

parcelRegister("c6rNV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $39cb99e1093c55f5$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $39cb99e1093c55f5$var$Automations = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.automations.content.body",
                defaultMessage: "Increase efficiency by replacing manual, time-consuming work with automated processes and workflows."
            })
        })
    });
};
var $39cb99e1093c55f5$export$2e2bcd8739ae039 = $39cb99e1093c55f5$var$Automations;

});

parcelRegister("8kuWI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f8a3492cd08aa6a$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $3f8a3492cd08aa6a$var$Backlog = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.backlogAndTimeline.content.body",
                defaultMessage: "Choose from different views to support your way of working."
            })
        })
    });
};
var $3f8a3492cd08aa6a$export$2e2bcd8739ae039 = $3f8a3492cd08aa6a$var$Backlog;

});

parcelRegister("WOC4s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87bc63ad3e80b17b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $87bc63ad3e80b17b$var$CrossTeamPlanning = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.crossTeamPlanning.content.body",
                defaultMessage: "Plan and track goals, projects, and dependencies in one place."
            })
        })
    });
};
var $87bc63ad3e80b17b$export$2e2bcd8739ae039 = $87bc63ad3e80b17b$var$CrossTeamPlanning;

});

parcelRegister("5Ikga", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20b6930dc723bc10$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $20b6930dc723bc10$var$CustomizableApprovalProcesses = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.customizableApprovalProcesses.content.body",
                defaultMessage: "Add approval steps to your workflows to get required signoffs."
            })
        })
    });
};
var $20b6930dc723bc10$export$2e2bcd8739ae039 = $20b6930dc723bc10$var$CustomizableApprovalProcesses;

});

parcelRegister("83Gke", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90529a5f0f2d90d2$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $90529a5f0f2d90d2$var$ExternalCollaboration = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.externalCollaboration.content.body",
                defaultMessage: "Give people outside your org anonymous access to Jira projects."
            })
        })
    });
};
var $90529a5f0f2d90d2$export$2e2bcd8739ae039 = $90529a5f0f2d90d2$var$ExternalCollaboration;

});

parcelRegister("guvAv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b27ff3bd95e80201$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $b27ff3bd95e80201$var$MultiRegionDataResidency = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.multiRegionDataResidency.content.body",
                defaultMessage: "Specify where your content and data are hosted."
            })
        })
    });
};
var $b27ff3bd95e80201$export$2e2bcd8739ae039 = $b27ff3bd95e80201$var$MultiRegionDataResidency;

});

parcelRegister("dBwTO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e502c2ad812b693$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $5e502c2ad812b693$var$ReportsAndDashboards = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.reportsAndDashboards.content.body",
                defaultMessage: "Get insights on teamwork tracked in any Jira product or project."
            })
        })
    });
};
var $5e502c2ad812b693$export$2e2bcd8739ae039 = $5e502c2ad812b693$var$ReportsAndDashboards;

});

parcelRegister("h2AoW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $305cb22209277d1b$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $305cb22209277d1b$var$CommunitySupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.freeCommunitySupport.content.body",
                defaultMessage: "Find answers and support from other Atlassian users."
            })
        })
    });
};
var $305cb22209277d1b$export$2e2bcd8739ae039 = $305cb22209277d1b$var$CommunitySupport;

});

parcelRegister("17uTl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b772800e5f3090e$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $5b772800e5f3090e$var$PremiumSupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.premiumSupport.content.body",
                defaultMessage: "1-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $5b772800e5f3090e$export$2e2bcd8739ae039 = $5b772800e5f3090e$var$PremiumSupport;

});

parcelRegister("6w3tN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f3c08a3cece63621$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $f3c08a3cece63621$var$StandardSupport = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.standardSupport.content.body",
                defaultMessage: "2-hr response time for critical issues from Cloud support team."
            })
        })
    });
};
var $f3c08a3cece63621$export$2e2bcd8739ae039 = $f3c08a3cece63621$var$StandardSupport;

});

parcelRegister("8wGxe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1cd49baf85eeb35$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $d1cd49baf85eeb35$var$UnlimitedProjects = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.unlimitedProjectBoards.content.body.v2",
                defaultMessage: "Align projects and tasks to goals. Collect data with forms."
            })
        })
    });
};
var $d1cd49baf85eeb35$export$2e2bcd8739ae039 = $d1cd49baf85eeb35$var$UnlimitedProjects;

});

parcelRegister("gl8tX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3027e47bf2c5ff81$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
const $3027e47bf2c5ff81$var$UserRolesPermissions = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "JiraSoftwarePricingPageTeam24.features.userRolesPermissions.content.body",
                defaultMessage: "Control what users can create, view, and comment on in Jira."
            })
        })
    });
};
var $3027e47bf2c5ff81$export$2e2bcd8739ae039 = $3027e47bf2c5ff81$var$UserRolesPermissions;

});


parcelRegister("btggB", function(module, exports) {
$parcel$export(module.exports, "getIsGwp10027NonprofitPricingPage", function () { return $6f8d41d4f75a0ee9$export$5669cf21cf977647; });

var $32ng3 = parcelRequire("32ng3");
function $6f8d41d4f75a0ee9$export$5669cf21cf977647() {
    return (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp10027NonprofitPricingPage);
}

});

parcelRegister("vCUGX", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingPageTemplateWithTwc", function () { return $e7c6a76c0fc10e33$export$1e29151fb1d7b783; });

var $7VQPk = parcelRequire("7VQPk");

var $dl2JF = parcelRequire("dl2JF");
parcelRequire("bCS4H");
var $bE8d4 = parcelRequire("bE8d4");
parcelRequire("1YZW1");
var $grcEk = parcelRequire("grcEk");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("j6FQw");
var $5S2vX = parcelRequire("5S2vX");

var $iTSLe = parcelRequire("iTSLe");

var $g7wmQ = parcelRequire("g7wmQ");

var $fZJZd = parcelRequire("fZJZd");

var $4bEWc = parcelRequire("4bEWc");

var $71t0B = parcelRequire("71t0B");

var $gtK7Z = parcelRequire("gtK7Z");

var $k53CY = parcelRequire("k53CY");

var $lSpoK = parcelRequire("lSpoK");

var $hJy82 = parcelRequire("hJy82");

var $3icmm = parcelRequire("3icmm");
const $e7c6a76c0fc10e33$export$1e29151fb1d7b783 = ()=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            pageId: "nonprofit-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lSpoK.NonprofitNav), {}),
                    banner: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7wmQ.Banner), {}),
                    hero: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gtK7Z.Hero), {}),
                    hasGlobalFooter: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: (0, $kbpa7.wacToken)("color.neutral.light100"),
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fZJZd.EligibleSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k53CY.NonprofitCalculatorHeading), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iTSLe.NonProfitPricingCalculator), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4bEWc.EnterpriseSection), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    bgColor: (0, $kbpa7.wacToken)("color.extended.blue100"),
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJy82.OfficialSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: false,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3icmm.ResourcesSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
                    hasGlobalFooter: true,
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                                header: content === null || content === void 0 ? void 0 : content.getMoreDetailsTitle,
                                planDetails: content === null || content === void 0 ? void 0 : content.additionalDetails
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $71t0B.Fineprint), {})
                        ]
                    })
                })
            ]
        })
    });
};

});
parcelRegister("iTSLe", function(module, exports) {
$parcel$export(module.exports, "NonProfitPricingCalculator", function () { return $21cae14a7b90ea83$export$5866e8a6e62a7e05; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");
parcelRequire("g1ccm");
var $9RHgs = parcelRequire("9RHgs");
parcelRequire("gC9ew");
var $aT8t4 = parcelRequire("aT8t4");

var $42V1t = parcelRequire("42V1t");
parcelRequire("hEIeM");
var $5TIjy = parcelRequire("5TIjy");

var $fNAVV = parcelRequire("fNAVV");

var $437NE = parcelRequire("437NE");
const $21cae14a7b90ea83$var$DEFAULT_UNIT_COUNT = 25;
const $21cae14a7b90ea83$var$DEFAULT_BILLING_CYCLE = "ANNUAL";
const $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS = 25;
const $21cae14a7b90ea83$export$5866e8a6e62a7e05 = ()=>{
    const { plansDataByProduct: plansDataByProduct, error: error } = (0, $437NE.useNonProfitPricingCalculatorData)();
    const [inputs, setInputs] = (0, $1oC0p.useState)({
        unitCount: $21cae14a7b90ea83$var$DEFAULT_UNIT_COUNT,
        billingCycle: $21cae14a7b90ea83$var$DEFAULT_BILLING_CYCLE
    });
    const getDiscountedPrice = (0, $1oC0p.useCallback)((args)=>{
        const { price: price, inputs: inputs } = args;
        if (inputs.billingCycle === "ANNUAL" && inputs.unitCount <= $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS) return 0;
        return price * 0.25;
    }, []);
    const intl = (0, $8e22h.default)();
    if (error) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $42V1t.ErrorMessage), {});
    if (!plansDataByProduct) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TIjy.LoadingSpinner), {});
    const fullDiscountBanner = intl.formatMessage({
        id: "nonprofit.fullDiscountBanner",
        defaultMessage: "Showing 100% off"
    });
    const partialDiscountBanner = intl.formatMessage({
        id: "nonprofit.partialDiscountBanner",
        defaultMessage: "Showing 75% off"
    });
    const partialDiscountWithPromptBanner = intl.formatMessage({
        id: "nonprofit.partialDiscountWithPromptBanner",
        defaultMessage: "Showing 75% off - choose Annual billing for 100% off"
    });
    let banner = partialDiscountBanner;
    if (inputs.billingCycle === "ANNUAL" && inputs.unitCount <= $21cae14a7b90ea83$var$FULL_DISCOUNT_MAX_UNITS) banner = fullDiscountBanner;
    if (inputs.billingCycle === "MONTHLY") banner = partialDiscountWithPromptBanner;
    var _plansDataByProduct_pricingTitleInternal_JIRA, _plansDataByProduct_pricingTitleInternal_CONFLUENCE, _plansDataByProduct_pricingTitleInternal_TWC, _plansDataByProduct_pricingTitleInternal_LOOM;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9RHgs.PricingTabs), {
        banner: banner,
        jiraCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: (_plansDataByProduct_pricingTitleInternal_JIRA = plansDataByProduct[(0, $fNAVV.pricingTitleInternal).JIRA]) !== null && _plansDataByProduct_pricingTitleInternal_JIRA !== void 0 ? _plansDataByProduct_pricingTitleInternal_JIRA : [],
            urlSlug: "jira",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        }),
        confluenceCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: (_plansDataByProduct_pricingTitleInternal_CONFLUENCE = plansDataByProduct[(0, $fNAVV.pricingTitleInternal).CONFLUENCE]) !== null && _plansDataByProduct_pricingTitleInternal_CONFLUENCE !== void 0 ? _plansDataByProduct_pricingTitleInternal_CONFLUENCE : [],
            urlSlug: "confluence",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        }),
        teamworkCollectionComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: (_plansDataByProduct_pricingTitleInternal_TWC = plansDataByProduct[(0, $fNAVV.pricingTitleInternal).TWC]) !== null && _plansDataByProduct_pricingTitleInternal_TWC !== void 0 ? _plansDataByProduct_pricingTitleInternal_TWC : [],
            urlSlug: "teamwork",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        }),
        loomCalculatorComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aT8t4.default), {
            comparePlansData: (_plansDataByProduct_pricingTitleInternal_LOOM = plansDataByProduct[(0, $fNAVV.pricingTitleInternal).LOOM]) !== null && _plansDataByProduct_pricingTitleInternal_LOOM !== void 0 ? _plansDataByProduct_pricingTitleInternal_LOOM : [],
            urlSlug: "loom",
            inputs: inputs,
            onChangeInputs: setInputs,
            getDiscountedPrice: getDiscountedPrice
        })
    });
};

});
parcelRegister("gC9ew", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("aT8t4")).default; });

var $aT8t4 = parcelRequire("aT8t4");

});
parcelRegister("aT8t4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $779847b443bf05b9$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $4G0xh = parcelRequire("4G0xh");

var $kbpa7 = parcelRequire("kbpa7");

var $8bW04 = parcelRequire("8bW04");

var $gJe05 = parcelRequire("gJe05");
parcelRequire("hEIeM");
var $44bDI = parcelRequire("44bDI");
var $5TIjy = parcelRequire("5TIjy");
parcelRequire("hEIeM");
var $MgH7i = parcelRequire("MgH7i");
parcelRequire("b9I0b");
var $fEBe5 = parcelRequire("fEBe5");

var $aLva8 = parcelRequire("aLva8");

var $fhn1A = parcelRequire("fhn1A");

var $9evy5 = parcelRequire("9evy5");

var $juRep = parcelRequire("juRep");
const $779847b443bf05b9$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $1oC0p.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $779847b443bf05b9$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $8e22h.default)();
    const handleRecommendedChange = (0, $1oC0p.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $779847b443bf05b9$var$useUnitsLabel(comparePlansData);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MgH7i.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($9evy5.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $4G0xh.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8bW04.PricingCards), {
                // must set the number of sections here if removing the bottom section
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $juRep.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $779847b443bf05b9$var$disclaimerContainerCss = null;
const $779847b443bf05b9$var$disclaimerCss = null;
const $779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX = 2;
const $779847b443bf05b9$var$UniformPricingCalculator = (props)=>{
    var _comparePlansData__fields, _comparePlansData_;
    const { comparePlansData: comparePlansData, urlSlug: urlSlug, disclaimer: disclaimer, inputs: inputs, onChangeInputs: onChangeInputs, getDiscountedPrice: getDiscountedPrice } = props;
    const [selectedCardIndex, setSelectedCardIndex] = (0, $1oC0p.useState)($779847b443bf05b9$var$DEFAULT_SELECTED_CARD_INDEX);
    const providerResult = (0, $fhn1A.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug,
        inputValues: inputs
    });
    if (providerResult.status === "pending") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TIjy.LoadingSpinner), {});
    if (providerResult.status === "error") return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== "ready") return null; // this should never happen due to checks above, but fixes type error
    const { config: config, inputValues: inputValues } = providerResult.props;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aLva8.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        onChangeInputs: onChangeInputs,
        getDiscountedPrice: getDiscountedPrice,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($779847b443bf05b9$var$PricingCalculatorContent, {
            comparePlansData: comparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: (0, $44bDI.getFeaturesList)(comparePlansData === null || comparePlansData === void 0 ? void 0 : (_comparePlansData_ = comparePlansData[0]) === null || _comparePlansData_ === void 0 ? void 0 : (_comparePlansData__fields = _comparePlansData_.fields) === null || _comparePlansData__fields === void 0 ? void 0 : _comparePlansData__fields.highlightedFeaturesContainer) === undefined ? 1 : 2,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $779847b443bf05b9$export$2e2bcd8739ae039 = $779847b443bf05b9$var$UniformPricingCalculator;
function $779847b443bf05b9$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $8e22h.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $fEBe5.serviceCollectionOfferingSkus).free,
            (0, $fEBe5.serviceCollectionOfferingSkus).standard,
            (0, $fEBe5.serviceCollectionOfferingSkus).premium,
            (0, $fEBe5.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($9evy5.units.agentsUnitsLabel);
    return intl.formatMessage($9evy5.units.usersUnitsLabel);
}

});
parcelRegister("4G0xh", function(module, exports) {
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ceccdba2041bfa64$export$9c59efe722f16a54; });
const $ceccdba2041bfa64$export$e36fc9e5c75fc113 = "jiraSoftware";
const $ceccdba2041bfa64$export$b65b36d21c9a62a9 = "confluence";
const $ceccdba2041bfa64$export$b24966420407028a = "strategyCollection";
const $ceccdba2041bfa64$export$46061d552ba374f4 = "teamworkCollection";
const $ceccdba2041bfa64$export$e7e2043098922532 = "compass";
const $ceccdba2041bfa64$export$6648fdba742bde2c = "serviceCollection";
const $ceccdba2041bfa64$export$b3fce742f95b2633 = "atlassianGuard";
const $ceccdba2041bfa64$export$9c59efe722f16a54 = {
    jira: $ceccdba2041bfa64$export$e36fc9e5c75fc113,
    confluence: $ceccdba2041bfa64$export$b65b36d21c9a62a9,
    strategy: $ceccdba2041bfa64$export$b24966420407028a,
    teamwork: $ceccdba2041bfa64$export$46061d552ba374f4,
    compass: $ceccdba2041bfa64$export$e7e2043098922532,
    service: $ceccdba2041bfa64$export$6648fdba742bde2c,
    guard: $ceccdba2041bfa64$export$b3fce742f95b2633
};

});

parcelRegister("8bW04", function(module, exports) {
$parcel$export(module.exports, "PricingCards", function () { return $6b8bae1d092d0de9$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $6b8bae1d092d0de9$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $1oC0p.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? "0" : undefined,
                borderEndEndRadius: isFirstChild ? "0px" : undefined,
                borderStartStartRadius: isLastChild ? "0" : undefined,
                borderEndStartRadius: isLastChild ? "0px" : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $kbpa7.wacToken)("color.primary.black")}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: "10px",
                borderTopRightRadius: numSections === 1 && isLastChild ? "20px" : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? "0px" : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? "0px" : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8yzqy _37tx5os2 _11nh5os2 _157nyzqy _1r9zyzqy _qrtggktf _bzkjkpzv _bi30wrl1 _x330kpzv _1q1tyzqy _14bpgktf _uedh18ji _sqhgyzqy _1bs9gktf _1o36gktf _r0rayzqy _23ugyzqy _4ezvyzqy",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lyzqy _9rrkyzqy _18xwyzqy",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370yzqy _1635yzqy"
        ]),
        style: {
            "--_wcq253": (0, $6ZVlx.default)(numSections),
            "--_1j6te2o": (0, $6ZVlx.default)(numberOfChildren),
            "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
            "--_vgqxqn": (0, $6ZVlx.default)(numSections === 1 ? `1px solid ${(0, $kbpa7.wacToken)("color.neutral.light400")}` : undefined),
            "--_3ro2cj": (0, $6ZVlx.default)(numSections === 1 ? "0px" : "20px"),
            "--_14z1886": (0, $6ZVlx.default)(numSections === 1 ? "0px" : undefined),
            "--_1ecp6y0": (0, $6ZVlx.default)(numSections === 1 ? "20px" : undefined)
        },
        children: (0, $1oC0p.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, (0, $6ogO3._)({
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot
            }, index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)));
        })
    });
};

});

parcelRegister("gJe05", function(module, exports) {
$parcel$export(module.exports, "useCalculationState", function () { return $ffe53822942d34d9$export$5ac48a71a65a15bc; });

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
function $ffe53822942d34d9$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $1CtPM.useSelector)($3V3tC.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitCount(ctx)),
        unitTierLowerBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $1CtPM.useSelector)((ctx)=>$3V3tC.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $1CtPM.useSelector)($3V3tC.getNumberFormatLocale)
    };
}

});
parcelRegister("1CtPM", function(module, exports) {
$parcel$export(module.exports, "useUnitCount", function () { return $f242ee1b597a5061$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $f242ee1b597a5061$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $f242ee1b597a5061$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $f242ee1b597a5061$export$97374d6e908d2c; });

var $1oC0p = parcelRequire("1oC0p");

var $dkcYJ = parcelRequire("dkcYJ");

var $aLva8 = parcelRequire("aLva8");
function $f242ee1b597a5061$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $f242ee1b597a5061$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $aLva8.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $f242ee1b597a5061$export$f3fe2cc7a9497569() {
    return (0, $aLva8.usePricingCalculatorContext)().calculationResult;
}
const $f242ee1b597a5061$export$2105062e25df4afe = (selector)=>{
    const context = (0, $aLva8.usePricingCalculatorContext)();
    return selector(context);
};
const $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $f242ee1b597a5061$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $dkcYJ.useCCPPriceFinderData)(offeringSkus, $f242ee1b597a5061$var$PRODUCT_CATALOG_DELIVERY_KEY, $f242ee1b597a5061$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $1oC0p.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $f242ee1b597a5061$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData !== null && ssrData !== void 0 ? ssrData : clientSideData,
        status: status
    };
};
function $f242ee1b597a5061$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === "complete") return "ready";
    if (fetchStatus === "idle" || fetchStatus === "fetching") return "pending";
    return "error";
}

});
parcelRegister("aLva8", function(module, exports) {
$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $368a3b873d7337e6$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $368a3b873d7337e6$export$5a79cf764fd87278; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("7HfJk");
var $5CQu1 = parcelRequire("5CQu1");
var $8cfMz = parcelRequire("8cfMz");
const $368a3b873d7337e6$var$PricingCalculatorContext = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
const $368a3b873d7337e6$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $1oC0p.useContext)($368a3b873d7337e6$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error("usePricingCalculatorContext must be used within a PricingCalculatorProvider");
    return pricingCalculatorContext;
};
const $368a3b873d7337e6$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $1oC0p.useState)(props.inputValues);
    const calculate = (0, $1oC0p.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $8cfMz.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $5CQu1.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $1oC0p.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $1oC0p.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        var _props_onChangeInputs;
        const nextValues = (0, $6ogO3._)({}, inputValues, changes);
        setInputValues(nextValues);
        (_props_onChangeInputs = props.onChangeInputs) === null || _props_onChangeInputs === void 0 ? void 0 : _props_onChangeInputs.call(props, nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)($368a3b873d7337e6$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config,
            getDiscountedPrice: props.getDiscountedPrice
        },
        children: props.children
    });
};

});
parcelRegister("7HfJk", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return (parcelRequire("5CQu1")).calculateProductPricing; });
$parcel$export(module.exports, "getProductCalculationInputs", function () { return (parcelRequire("8cfMz")).getProductCalculationInputs; });
parcelRequire("5CQu1");
parcelRequire("8cfMz");

});
parcelRegister("5CQu1", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return $a686a54aa7deba91$export$6c0aa9d51dade71d; });

var $6ogO3 = parcelRequire("6ogO3");

var $1mbEv = parcelRequire("1mbEv");
const $a686a54aa7deba91$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $1mbEv.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push((0, $6ogO3._)({
            // @ts-ignore
            offeringSku: ccpOfferingSKU
        }, planPricing));
    }
    return productPricing;
};

});
parcelRegister("1mbEv", function(module, exports) {
$parcel$export(module.exports, "calculatePlanPricing", function () { return $0f584d23bad95648$export$f9574505c9651410; });

var $6ogO3 = parcelRequire("6ogO3");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");

var $1RK9J = parcelRequire("1RK9J");

var $aTHox = parcelRequire("aTHox");
parcelRequire("b9I0b");
var $9Nmuw = parcelRequire("9Nmuw");
const $0f584d23bad95648$var$hamsPricingDataStub = {};
const $0f584d23bad95648$var$hamsProductKeyStub = "";
function $0f584d23bad95648$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return (0, $6ogO3._)({
        offeringSku: ccpOfferingSKU
    }, (0, $1RK9J.getFreePriceCalc)(currencyISOCode));
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $9Nmuw.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === "user");
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, $0f584d23bad95648$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $0f584d23bad95648$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return (0, $6ogO3._)({
                offeringSku: ccpOfferingSKU
            }, (0, $1RK9J.getFreePriceCalc)(currencyISOCode));
        } else return (0, $6ogO3._)({
            offeringSku: ccpOfferingSKU
        }, (0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
}

});
parcelRegister("aTHox", function(module, exports) {
$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $4c3894076c255a40$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $4c3894076c255a40$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $4c3894076c255a40$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $4c3894076c255a40$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $4c3894076c255a40$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $4c3894076c255a40$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $4c3894076c255a40$export$f9cab01559b23739; });
const $4c3894076c255a40$export$6e78cb64dcbedbb9 = "MONTHLY";
const $4c3894076c255a40$export$36a5806a0e4fc360 = 5;
const $4c3894076c255a40$export$2b15976b7672c2da = 201;
const $4c3894076c255a40$export$eeb88db779daf862 = {
    free: "bitbucket-test-free",
    standard: "bitbucket-std",
    premium: "bitbucket-premium"
};
const $4c3894076c255a40$export$4d264dc26702f23b = 35000;
const $4c3894076c255a40$export$9a2735659d85fd7c = Object.values($4c3894076c255a40$export$eeb88db779daf862);
const $4c3894076c255a40$export$66d05a9262b43b7f = [
    {
        planName: "Free",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: "Standard",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: "Premium",
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    }
];
const $4c3894076c255a40$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("b9I0b", function(module, exports) {
$parcel$export(module.exports, "jiraOfferingSkus", function () { return (parcelRequire("j1ORI")).jiraOfferingSkus; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return (parcelRequire("29JVp")).confluenceOfferingSkus; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return (parcelRequire("hGYMM")).strategyCollectionOfferingSkus; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return (parcelRequire("YmHME")).teamworkCollectionOfferingSkus; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return (parcelRequire("4utnL")).loomOfferingSkus; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return (parcelRequire("lc7EO")).jpdOfferingSkus; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return (parcelRequire("7dhmX")).compassOfferingSkus; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return (parcelRequire("44C4o")).guardOfferingSkus; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return (parcelRequire("fEBe5")).serviceCollectionOfferingSkus; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return (parcelRequire("9Nmuw")).rovoDevOfferingSkus; });
parcelRequire("j1ORI");
parcelRequire("29JVp");
parcelRequire("hGYMM");
parcelRequire("YmHME");
parcelRequire("4utnL");
parcelRequire("gcAZd");
parcelRequire("lc7EO");
parcelRequire("7dhmX");
parcelRequire("44C4o");
parcelRequire("fEBe5");
parcelRequire("9Nmuw");

});
parcelRegister("j1ORI", function(module, exports) {
$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $2a2b2c5bc611aa86$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $2a2b2c5bc611aa86$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $2a2b2c5bc611aa86$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $2a2b2c5bc611aa86$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $2a2b2c5bc611aa86$export$3070b86c7bc28aea; });
const $2a2b2c5bc611aa86$export$c34e5566df36b6ba = "MONTHLY";
const $2a2b2c5bc611aa86$export$6521a918e64524fb = 300;
const $2a2b2c5bc611aa86$export$9aef50cd5f48bb38 = 801;
const $2a2b2c5bc611aa86$export$7529f2cfeec98447 = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
};
const $2a2b2c5bc611aa86$export$b2b09200ca76754f = Object.values($2a2b2c5bc611aa86$export$7529f2cfeec98447);
const $2a2b2c5bc611aa86$export$3070b86c7bc28aea = [
    {
        planName: "Free",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Standard",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $2a2b2c5bc611aa86$export$9aef50cd5f48bb38
    }
];
const $2a2b2c5bc611aa86$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("29JVp", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $1e226e69d394223a$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $1e226e69d394223a$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $1e226e69d394223a$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $1e226e69d394223a$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $1e226e69d394223a$export$53fbba6eb29a73ad; });
const $1e226e69d394223a$export$d60dc2d142b5e9dd = "MONTHLY";
const $1e226e69d394223a$export$ab3750ec8101ffcc = 300;
const $1e226e69d394223a$export$f76a76b996ace375 = 801;
const $1e226e69d394223a$export$ffe6d3f38b5f7c3a = {
    free: "confluence-free",
    standard: "confluence-standard",
    premium: "confluence-premium",
    enterprise: "confluence-enterprise-sku"
};
const $1e226e69d394223a$export$39e8fbae2abd0443 = Object.values($1e226e69d394223a$export$ffe6d3f38b5f7c3a);
const $1e226e69d394223a$export$53fbba6eb29a73ad = [
    {
        planName: "Free",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 150000
    },
    {
        planName: "Standard",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 150000
    },
    {
        planName: "Premium",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 150000
    },
    {
        planName: "Enterprise",
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 150000,
        minUnitCount: $1e226e69d394223a$export$f76a76b996ace375
    }
];
const $1e226e69d394223a$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("hGYMM", function(module, exports) {
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $45ceb3dd2bb22ad6$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $45ceb3dd2bb22ad6$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $45ceb3dd2bb22ad6$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $45ceb3dd2bb22ad6$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $45ceb3dd2bb22ad6$export$2225b2a65811f064; });
const $45ceb3dd2bb22ad6$export$c00ddd271304729a = "ANNUAL";
const $45ceb3dd2bb22ad6$export$27579c7f06007c25 = 50;
const $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a = 50;
const $45ceb3dd2bb22ad6$export$8427e2db10f569be = {
    enterprise: "strategy-collection-enterprise-sku"
};
const $45ceb3dd2bb22ad6$export$3b4c7d53b38ef615 = Object.values($45ceb3dd2bb22ad6$export$8427e2db10f569be);
const $45ceb3dd2bb22ad6$export$bc4927fbd68771ac = [
    {
        planName: "Enterprise",
        offeringSku: $45ceb3dd2bb22ad6$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $45ceb3dd2bb22ad6$export$a99f1f06dfc3702a
    }
];
const $45ceb3dd2bb22ad6$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("YmHME", function(module, exports) {
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $bf49a3d87bcf04a1$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $bf49a3d87bcf04a1$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $bf49a3d87bcf04a1$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $bf49a3d87bcf04a1$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $bf49a3d87bcf04a1$export$5861c5ce06e1556; });
const $bf49a3d87bcf04a1$export$5784a04bb778d3c1 = "MONTHLY";
const $bf49a3d87bcf04a1$export$482604a575f7b4a5 = 300;
const $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2 = 801;
const $bf49a3d87bcf04a1$export$2e2107bfa20be1d8 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};
const $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4 = Object.values($bf49a3d87bcf04a1$export$2e2107bfa20be1d8);
const $bf49a3d87bcf04a1$export$88bcddbae46dd5f1 = [
    {
        planName: "Free",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: "Standard",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2
    }
];
const $bf49a3d87bcf04a1$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("4utnL", function(module, exports) {
$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $567bad4c99b6ec03$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $567bad4c99b6ec03$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $567bad4c99b6ec03$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $567bad4c99b6ec03$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $567bad4c99b6ec03$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $567bad4c99b6ec03$export$d2bfeac6f7899675; });
const $567bad4c99b6ec03$export$501dc9dfd5b2bde4 = "MONTHLY";
const $567bad4c99b6ec03$export$2aa1a93e0ac00fc = 100;
const $567bad4c99b6ec03$export$2a2f7d7a7ae18850 = Infinity;
const $567bad4c99b6ec03$export$a64578a63428ae96 = {
    free: "loom-free-sku",
    business: "loom-business-sku",
    businessPlusAi: "loom-business-ai-sku",
    enterprise: "loom-enterprise-sku"
};
const $567bad4c99b6ec03$export$9f95f1c871571078 = Object.values($567bad4c99b6ec03$export$a64578a63428ae96);
const $567bad4c99b6ec03$export$ed1379ed8713d252 = [
    {
        planName: "Free",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business + AI",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Enterprise",
        offeringSku: $567bad4c99b6ec03$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $567bad4c99b6ec03$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("gcAZd", function(module, exports) {
const $ff47f9ee8d194adc$export$be354061b07829a8 = "MONTHLY";
const $ff47f9ee8d194adc$export$2295858875312a6f = 75;
const $ff47f9ee8d194adc$export$66d53803b4a2565a = 201;
const $ff47f9ee8d194adc$export$38631f866342776a = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
};
const $ff47f9ee8d194adc$export$efd16829e921ffb8 = Object.values($ff47f9ee8d194adc$export$38631f866342776a);
const $ff47f9ee8d194adc$export$9e62e4d7dc794618 = [
    {
        planName: "Free",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $ff47f9ee8d194adc$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $ff47f9ee8d194adc$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("lc7EO", function(module, exports) {
$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $a2567840a72a8d9f$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $a2567840a72a8d9f$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $a2567840a72a8d9f$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $a2567840a72a8d9f$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $a2567840a72a8d9f$export$370b1f24abd91670; });
const $a2567840a72a8d9f$export$513f99bdcd3bd2 = "MONTHLY";
const $a2567840a72a8d9f$export$503245d941330408 = 10;
const $a2567840a72a8d9f$export$4ebabaf17c585254 = 201;
const $a2567840a72a8d9f$export$400db592c8d58797 = {
    free: "jira-servicedesk-free",
    // jpd-free shares the same sku as jsm-free
    standard: "jira-product-discovery-standard",
    premium: "jira-product-discovery-premium-sku"
};
const $a2567840a72a8d9f$export$cf1798af40f51188 = Object.values($a2567840a72a8d9f$export$400db592c8d58797);
const $a2567840a72a8d9f$export$886e6b42d7675517 = [
    {
        planName: "Free",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    }
];
const $a2567840a72a8d9f$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};

});

parcelRegister("7dhmX", function(module, exports) {
$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $50757f59ceb0cbe4$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $50757f59ceb0cbe4$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $50757f59ceb0cbe4$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $50757f59ceb0cbe4$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $50757f59ceb0cbe4$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $50757f59ceb0cbe4$export$e0b3f0eba764d747; });
const $50757f59ceb0cbe4$export$2c789441f8bab310 = "MONTHLY";
const $50757f59ceb0cbe4$export$887bc0e84eafd3c = 300;
const $50757f59ceb0cbe4$export$862352663e0ac9d7 = Infinity;
const $50757f59ceb0cbe4$export$f93fb5caff8c778a = {
    free: "compass-free",
    standard: "compass-standard",
    premium: "compass-premium-sku"
};
const $50757f59ceb0cbe4$export$74a0fd94f40ef5c5 = Object.values($50757f59ceb0cbe4$export$f93fb5caff8c778a);
const $50757f59ceb0cbe4$export$4df3b64d28e0d138 = [
    {
        planName: "Free",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: "Standard",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: "Premium",
        offeringSku: $50757f59ceb0cbe4$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $50757f59ceb0cbe4$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("44C4o", function(module, exports) {
$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $757a4e832c1a582d$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $757a4e832c1a582d$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $757a4e832c1a582d$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $757a4e832c1a582d$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $757a4e832c1a582d$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $757a4e832c1a582d$export$129a445945b6d9b3; });
const $757a4e832c1a582d$export$9be98af08cc25cad = "MONTHLY";
const $757a4e832c1a582d$export$d28097ea69640bd5 = 100;
const $757a4e832c1a582d$export$13b500e201e8b319 = Infinity;
const $757a4e832c1a582d$export$91a420e9c7eb7c83 = {
    standard: "atlassian-access-standard-sku",
    premium: "atlassian-guard-premium-addon-sku"
};
const $757a4e832c1a582d$export$159558c2b3d66b11 = Object.values($757a4e832c1a582d$export$91a420e9c7eb7c83);
const $757a4e832c1a582d$export$a2329ae21ff2ff84 = [
    {
        planName: "Standard",
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Premium",
        offeringSku: $757a4e832c1a582d$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $757a4e832c1a582d$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fEBe5", function(module, exports) {
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $6246fc483000f258$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $6246fc483000f258$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $6246fc483000f258$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $6246fc483000f258$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $6246fc483000f258$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $6246fc483000f258$export$7c96cfb0c18bfb05; });
const $6246fc483000f258$export$9423de11a8a6dfa7 = "MONTHLY";
const $6246fc483000f258$export$515fa2affea780b3 = 75;
const $6246fc483000f258$export$3df704b75c4818f2 = 201;
const $6246fc483000f258$export$84b191ede7d628ea = {
    free: "service-collection-free",
    standard: "service-collection-standard",
    premium: "service-collection-premium",
    enterprise: "service-collection-enterprise"
};
const $6246fc483000f258$export$953539e2774d6323 = Object.values($6246fc483000f258$export$84b191ede7d628ea);
const $6246fc483000f258$export$29e5f53cb4f38894 = [
    {
        planName: "Free",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000,
        minUnitCount: $6246fc483000f258$export$3df704b75c4818f2
    }
];
const $6246fc483000f258$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("9Nmuw", function(module, exports) {
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $5113a0e17f25a106$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $5113a0e17f25a106$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $5113a0e17f25a106$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $5113a0e17f25a106$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $5113a0e17f25a106$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $5113a0e17f25a106$export$120b0272a23f9b21; });
const $5113a0e17f25a106$export$f7b45b42f23a06a6 = "MONTHLY";
const $5113a0e17f25a106$export$c80f45e98f559c29 = 10;
const $5113a0e17f25a106$export$5cdb7bb84622bb8e = Infinity;
const $5113a0e17f25a106$export$6a8477cfea6a8fb8 = {
    standard: "rovodev-standard"
};
const $5113a0e17f25a106$export$69f1beff4f684452 = Object.values($5113a0e17f25a106$export$6a8477cfea6a8fb8);
const $5113a0e17f25a106$export$93aaa2531823d54e = [
    {
        planName: "Standard",
        offeringSku: $5113a0e17f25a106$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $5113a0e17f25a106$export$5cdb7bb84622bb8e
    }
];
const $5113a0e17f25a106$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});




parcelRegister("8cfMz", function(module, exports) {
$parcel$export(module.exports, "getProductCalculationInputs", function () { return $2c139569c5386442$export$915d8a609f55f86e; });

var $hrGO1 = parcelRequire("hrGO1");
const $2c139569c5386442$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});




parcelRegister("3V3tC", function(module, exports) {
$parcel$export(module.exports, "getUnitCount", function () { return $964f907284a6b353$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $964f907284a6b353$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $964f907284a6b353$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $964f907284a6b353$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $964f907284a6b353$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $964f907284a6b353$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $964f907284a6b353$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $964f907284a6b353$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $964f907284a6b353$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $964f907284a6b353$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $964f907284a6b353$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $964f907284a6b353$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $964f907284a6b353$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $964f907284a6b353$export$8808c13548cf959c; });
const $964f907284a6b353$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $964f907284a6b353$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $964f907284a6b353$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $964f907284a6b353$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $964f907284a6b353$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $964f907284a6b353$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $964f907284a6b353$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount !== null && minUnitCount !== void 0 ? minUnitCount : 0;
};
const $964f907284a6b353$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $964f907284a6b353$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $964f907284a6b353$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $964f907284a6b353$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $964f907284a6b353$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error("unexpected empty value");
    return planLimitConfig;
};
const $964f907284a6b353$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error("unexpected empty value");
    return planPriceResult;
};
const $964f907284a6b353$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    let { totalPrice: totalPrice } = price;
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) totalPrice = getDiscountedPrice({
        price: totalPrice,
        inputs: ctx.inputValues
    });
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, totalPrice);
};
const $964f907284a6b353$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const { avgPerUnitPrice: avgPerUnitPrice } = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    const { getDiscountedPrice: getDiscountedPrice } = ctx;
    if (getDiscountedPrice) return getDiscountedPrice({
        inputs: ctx.inputValues,
        price: avgPerUnitPrice
    });
    return avgPerUnitPrice;
};
const $964f907284a6b353$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $964f907284a6b353$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $964f907284a6b353$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === "JPY";
    return isJPY ? "ja-JP" : "en-US";
};
const $964f907284a6b353$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $964f907284a6b353$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    var _options_minimumFractionDigits, _options_minimumFractionDigits1;
    return new Intl.NumberFormat(numberFormatLocale, {
        style: "currency",
        currency: currencyISOCode,
        minimumFractionDigits: (_options_minimumFractionDigits = options.minimumFractionDigits) !== null && _options_minimumFractionDigits !== void 0 ? _options_minimumFractionDigits : 0,
        maximumFractionDigits: (_options_minimumFractionDigits1 = options.minimumFractionDigits) !== null && _options_minimumFractionDigits1 !== void 0 ? _options_minimumFractionDigits1 : 0
    }).format(price);
};
const $964f907284a6b353$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $964f907284a6b353$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $964f907284a6b353$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $964f907284a6b353$var$getRecommendedOfferingSku = (ctx)=>{
    var _planLimitConfigs_recommendedPlanIdx;
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $964f907284a6b353$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return (_planLimitConfigs_recommendedPlanIdx = planLimitConfigs[recommendedPlanIdx]) === null || _planLimitConfigs_recommendedPlanIdx === void 0 ? void 0 : _planLimitConfigs_recommendedPlanIdx.offeringSku;
};
const $964f907284a6b353$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $964f907284a6b353$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitLower;
};
const $964f907284a6b353$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitUpper;
};
const $964f907284a6b353$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $964f907284a6b353$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $964f907284a6b353$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound !== null && unitTierUpperBound !== void 0 ? unitTierUpperBound : 0) - unitCount;
};
/**
 * @deprecated
 */ const $964f907284a6b353$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $964f907284a6b353$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $964f907284a6b353$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitLower;
};
const $964f907284a6b353$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $964f907284a6b353$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitUpper;
};
const $964f907284a6b353$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $964f907284a6b353$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === "ANNUAL") return $964f907284a6b353$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $964f907284a6b353$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === "JPY") {
        price = $964f907284a6b353$export$2dd65b072d3a3106(price);
        return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $964f907284a6b353$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $964f907284a6b353$export$235d4fbb478dfba0 = (ctx, args)=>{
    var _offering_defaultPricingPlans;
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $964f907284a6b353$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $964f907284a6b353$export$36cee2c7009ae4b(ctx);
    const defaultPricingPlan = offering === null || offering === void 0 ? void 0 : (_offering_defaultPricingPlans = offering.defaultPricingPlans) === null || _offering_defaultPricingPlans === void 0 ? void 0 : _offering_defaultPricingPlans.filter((item)=>item.currency.toLowerCase() == currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() == edition.toLowerCase() && item.primaryCycle_name.toLowerCase() == billingCycle.toLowerCase() && item.status.toLowerCase() == "active");
    const lastPricingPlan = defaultPricingPlan === null || defaultPricingPlan === void 0 ? void 0 : defaultPricingPlan[defaultPricingPlan.length - 1];
    return (lastPricingPlan === null || lastPricingPlan === void 0 ? void 0 : lastPricingPlan.id) || "";
};

});


parcelRegister("hEIeM", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return (parcelRequire("MgH7i")).PricingCalculatorInputs; });
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return (parcelRequire("kBDDI")).RovoDevStandardPriceCard; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionEnterprisePriceCard; });
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionFreePriceCard; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionPremiumPriceCard; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return (parcelRequire("9hJtd")).ServiceCollectionStandardPriceCard; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return (parcelRequire("v7O5E")).LoomBusinessPlusAiPriceCard; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return (parcelRequire("v7O5E")).LoomBusinessPriceCard; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return (parcelRequire("v7O5E")).LoomEnterprisePriceCard; });
$parcel$export(module.exports, "LoomFreePriceCard", function () { return (parcelRequire("v7O5E")).LoomFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryPremiumPriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return (parcelRequire("1NsjC")).JiraProductDiscoveryStandardPriceCard; });
$parcel$export(module.exports, "LoadingSpinner", function () { return (parcelRequire("5TIjy")).LoadingSpinner; });
$parcel$export(module.exports, "PriceAltContainer", function () { return (parcelRequire("iXfHC")).PriceAltContainer; });
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return (parcelRequire("9Osbp")).MonthlyEnterpriseMessage; });
$parcel$export(module.exports, "getFeaturesList", function () { return (parcelRequire("44bDI")).getFeaturesList; });
$parcel$export(module.exports, "UserTier", function () { return (parcelRequire("lbUj4")).UserTier; });
$parcel$export(module.exports, "UserTierExpanded", function () { return (parcelRequire("lbUj4")).UserTierExpanded; });
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return (parcelRequire("7khdS")).useLocalizedCtaUrl; });
parcelRequire("MgH7i");

var $5TIjy = parcelRequire("5TIjy");

var $iXfHC = parcelRequire("iXfHC");

var $9Osbp = parcelRequire("9Osbp");

var $44bDI = parcelRequire("44bDI");

var $lbUj4 = parcelRequire("lbUj4");

var $7khdS = parcelRequire("7khdS");
parcelRequire("kBDDI");
parcelRequire("9hJtd");
parcelRequire("v7O5E");
parcelRequire("1NsjC");

});
parcelRegister("MgH7i", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $884c8db4d1ecaa10$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $eY3N6 = parcelRequire("eY3N6");

var $hrGO1 = parcelRequire("hrGO1");

var $4pGAV = parcelRequire("4pGAV");

var $kbpa7 = parcelRequire("kbpa7");

var $1CtPM = parcelRequire("1CtPM");

var $3V3tC = parcelRequire("3V3tC");
const $884c8db4d1ecaa10$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $1CtPM.useUnitCount)();
    const hasMonthlyBilling = (0, $1CtPM.useSelector)($3V3tC.hasMonthlyBilling);
    const hasAnnualBilling = (0, $1CtPM.useSelector)($3V3tC.hasAnnualBilling);
    const [visualUnitCount, setVisualUnitCount] = (0, $1oC0p.useState)(// @ts-ignore
    unitCount);
    (0, $1oC0p.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount("");
        // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $hrGO1.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $2jatx.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $2jatx.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4pGAV.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $7VQPk.jsx)("legend", {
                                className: (0, $2jatx.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: "MONTHLY",
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: "ANNUAL",
                                    label: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: "blue",
                                        text: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $884c8db4d1ecaa10$var$labelStyles = null;
const $884c8db4d1ecaa10$var$legendStyles = null;
const $884c8db4d1ecaa10$var$inputTermStyle = null;
const $884c8db4d1ecaa10$var$inputCss = null;

});

parcelRegister("5TIjy", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", function () { return $5e560a7364105b43$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $7qFQI = parcelRequire("7qFQI");
const $5e560a7364105b43$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {})
        })
    });

});

parcelRegister("iXfHC", function(module, exports) {
$parcel$export(module.exports, "PriceAltContainer", function () { return $886eaf760740e014$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
const $886eaf760740e014$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    }));
};
const $886eaf760740e014$var$priceAltTextCss = null;

});

parcelRegister("9Osbp", function(module, exports) {
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $2abbf2119b6f777e$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");
const $2abbf2119b6f777e$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iXfHC.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                type: "button",
                onClick: switchToAnnual,
                tabIndex: 0,
                "data-event-component": "linkButton",
                "data-event": "clicked",
                className: (0, $2jatx.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz17la _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: intl.formatMessage($9evy5.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($9evy5.switchToAnnualToViewEnterprise)
        ]
    });
};
const $2abbf2119b6f777e$var$buttonCss = null;

});
parcelRegister("9evy5", function(module, exports) {
$parcel$export(module.exports, "recommended", function () { return $b8ce4f4c86785928$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b8ce4f4c86785928$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b8ce4f4c86785928$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b8ce4f4c86785928$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b8ce4f4c86785928$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b8ce4f4c86785928$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b8ce4f4c86785928$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b8ce4f4c86785928$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b8ce4f4c86785928$export$68a1387c7d0a683f; });

var $fnHPc = parcelRequire("fnHPc");
const $b8ce4f4c86785928$export$bc5b8d0824876806 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.recommended",
    defaultMessage: "Recommended"
});
const $b8ce4f4c86785928$export$fe0319385f0cf5a7 = (0, $fnHPc.defineMessages)({
    teamSizePrompt: {
        id: "priceFinder.teamSizePrompt",
        defaultMessage: "Team Size:"
    },
    usersUnitsLabel: {
        id: "priceFinder.usersUnitsLabel",
        defaultMessage: "users"
    },
    agentsUnitsLabel: {
        id: "priceFinder.agentsUnitsLabel",
        defaultMessage: "agents"
    }
});
const $b8ce4f4c86785928$export$d8b49137e99effc2 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.perUnitPerMonth",
    defaultMessage: "per user / month"
});
const $b8ce4f4c86785928$export$5eae4ab34e5b16ae = (0, $fnHPc.defineMessage)({
    id: "priceFinder.perYear",
    defaultMessage: "per year"
});
const $b8ce4f4c86785928$export$bf2ba8467ff15aa5 = (0, $fnHPc.defineMessages)({
    default: {
        id: "priceFinder.aboveUserMaxThreshold.default",
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: "priceFinder.aboveUserMaxThreshold.cloudEnterprise",
        defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
    },
    agents: {
        id: "priceFinder.aboveUserMaxThreshold.agents",
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: "priceFinder.aboveUserMaxThreshold.specificCount",
        defaultMessage: "For teams of more than {lowerLimit}, contact our sales team."
    },
    creators: {
        id: "priceFinder.aboveUserMaxThreshold.creators",
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b8ce4f4c86785928$export$2e64ce41e89d1e18 = (0, $fnHPc.defineMessages)({
    cloudEnterprise: {
        id: "priceFinder.belowUnitMinThreshold.cloudEnterprise",
        defaultMessage: "Enterprise plan pricing is available when you enter {minUnitCount} or more users above"
    }
});
const $b8ce4f4c86785928$export$9e1a6bb525180618 = (0, $fnHPc.defineMessage)({
    id: "priceFinder.billedAnnually",
    defaultMessage: "Billed annually."
});
const $b8ce4f4c86785928$export$3277af2b318f7bfa = (0, $fnHPc.defineMessage)({
    id: "priceFinder.switchToAnnualToViewEnterprise",
    defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
});
const $b8ce4f4c86785928$export$68a1387c7d0a683f = (0, $fnHPc.defineMessage)({
    id: "priceFinder.enterpriseJpyMessage",
    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
});

});


parcelRegister("44bDI", function(module, exports) {
$parcel$export(module.exports, "getFeaturesList", function () { return $b83af44fbf5738a9$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cXZQx = parcelRequire("cXZQx");

var $gVC4y = parcelRequire("gVC4y");
const $b83af44fbf5738a9$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    return highlightedFeaturesContainer === null || highlightedFeaturesContainer === void 0 ? void 0 : highlightedFeaturesContainer.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cXZQx.RichTextComponent), {
                    text: (0, $gVC4y.richTextToHTML)(// @ts-ignore
                    feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $b83af44fbf5738a9$var$featureDetailsCss = null;

});

parcelRegister("lbUj4", function(module, exports) {
$parcel$export(module.exports, "UserTier", function () { return $b9de452da2cf6ac9$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $b9de452da2cf6ac9$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");
const $b9de452da2cf6ac9$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = "en-US", unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === "agent") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: (0, $dPABA._)((0, $6ogO3._)({}, (0, $kooLp.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
};
const $b9de452da2cf6ac9$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = "en-US" } = props;
    const intl = (0, $8e22h.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.tier),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                children: [
                    intl.formatMessage($b9de452da2cf6ac9$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $b9de452da2cf6ac9$var$messages = (0, $fnHPc.defineMessages)({
    tier: {
        id: "PriceFinder.userTier.tier",
        defaultMessage: "Tier:"
    },
    filledSeats: {
        id: "PriceFinder.userTier.filledSeats",
        defaultMessage: "Filled seats:"
    },
    availableSeats: {
        id: "PriceFinder.userTier.availableSeats",
        defaultMessage: "Available seats:"
    }
});

});

parcelRegister("7khdS", function(module, exports) {
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33; });

var $kooLp = parcelRequire("kooLp");
function $85c9ce8b07ea27f8$export$b5e9728b9b8ebe33(ctaFields) {
    var _ctaFields_ctaUrl;
    return (0, $kooLp.useLocalizedHref)((_ctaFields_ctaUrl = ctaFields === null || ctaFields === void 0 ? void 0 : ctaFields.ctaUrl) !== null && _ctaFields_ctaUrl !== void 0 ? _ctaFields_ctaUrl : "");
}

});

parcelRegister("kBDDI", function(module, exports) {
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $429cde05ec573ae0$export$f0e8bcb2fb60056a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $429cde05ec573ae0$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: "RovoDevStandardPriceCard.monthlyPerUserLabel",
            defaultMessage: "per developer / month"
        })
    }));
};

});
parcelRegister("2Wido", function(module, exports) {
$parcel$export(module.exports, "FreePriceCard", function () { return $fd07704e9f8e1231$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $fd07704e9f8e1231$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $fd07704e9f8e1231$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $fd07704e9f8e1231$export$ba2214b2dcd26743; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $BSG7c = parcelRequire("BSG7c");

var $2wDsW = parcelRequire("2wDsW");

var $lOlsU = parcelRequire("lOlsU");

var $8HBY7 = parcelRequire("8HBY7");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $gJe05 = parcelRequire("gJe05");
parcelRequire("hEIeM");
var $44bDI = parcelRequire("44bDI");
var $9Osbp = parcelRequire("9Osbp");
var $iXfHC = parcelRequire("iXfHC");
var $7khdS = parcelRequire("7khdS");
var $lbUj4 = parcelRequire("lbUj4");

var $1CtPM = parcelRequire("1CtPM");

var $9evy5 = parcelRequire("9evy5");

var $3V3tC = parcelRequire("3V3tC");
function $fd07704e9f8e1231$var$usePriceCardEvents(props) {
    const { productKey: productKey, edition: edition } = props;
    const tryIntent = (0, $2wDsW.useTryIntent)({
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER),
        intentType: "button",
        productKey: productKey,
        edition: edition
    });
    const handleClickCta = (0, $lOlsU.useFirePricingPlanCtaEvent)({
        edition: edition,
        productKey: productKey,
        containerId: (0, $BSG7c.PRICE_FINDER_CONTAINER)
    });
    return {
        onClick: ()=>{
            tryIntent.onClick();
            handleClickCta();
        },
        onKeyDown: tryIntent.onKeyDown
    };
}
const $fd07704e9f8e1231$var$FREE_EDITION = "free";
const $fd07704e9f8e1231$export$75a717cafbbb6b29 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: $fd07704e9f8e1231$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$fd07704e9f8e1231$var$FREE_EDITION}-get-it-now`;
    let buttonHref = ctaUrl;
    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage)) {
        const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
        urlWithSignupSource.searchParams.set("signupSource", "pricing");
        buttonHref = urlWithSignupSource.toString();
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === "ANNUAL",
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonVariant: state.recommended ? "primary" : "secondary",
        buttonHref: buttonHref,
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$var$STANDARD_EDITION = "standard";
const $fd07704e9f8e1231$var$PREMIUM_EDITION = "premium";
const $fd07704e9f8e1231$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        edition: $fd07704e9f8e1231$var$STANDARD_EDITION
    }));
const $fd07704e9f8e1231$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($fd07704e9f8e1231$var$CommonPriceCard, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        edition: $fd07704e9f8e1231$var$PREMIUM_EDITION
    }));
// eslint-disable-next-line complexity
const $fd07704e9f8e1231$var$CommonPriceCard = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    let buttonHref = ctaUrl;
    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).addSignupSourceToUrlsOnPricingPage)) {
        const urlWithSignupSource = new URL(ctaUrl, window.location.origin);
        urlWithSignupSource.searchParams.set("signupSource", "pricing");
        buttonHref = urlWithSignupSource.toString();
    }
    var _props_monthlyPerUserLabel;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === "MONTHLY" ? (_props_monthlyPerUserLabel = props.monthlyPerUserLabel) !== null && _props_monthlyPerUserLabel !== void 0 ? _props_monthlyPerUserLabel : intl.formatMessage($9evy5.perUserPerMonth) : intl.formatMessage($9evy5.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === "ANNUAL" && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: buttonHref,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $fd07704e9f8e1231$export$ba2214b2dcd26743 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gJe05.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $8e22h.default)();
    const currencyIsoCode = (0, $1CtPM.useSelector)((0, $3V3tC.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $1CtPM.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === "JPY" && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.enterpriseJpyMessage)
        });
        if (state.billingCycle === "MONTHLY") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "24px"
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Osbp.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle("ANNUAL")
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($9evy5.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lbUj4.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $7khdS.useLocalizedCtaUrl)(cta);
    const edition = "enterprise";
    const eventHandlers = $fd07704e9f8e1231$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8HBY7.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : showBannerText && state.recommended && intl.formatMessage($9evy5.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($9evy5.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === "JPY",
        tooltipContent: tooltipContent,
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $BSG7c.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $44bDI.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("BSG7c", function(module, exports) {
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $d0bc5feae5415d38$export$c5526af38120e3f; });
const $d0bc5feae5415d38$export$c5526af38120e3f = "priceBlock";

});



parcelRegister("9hJtd", function(module, exports) {
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $e9537e62b8dac42c$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $e9537e62b8dac42c$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $e9537e62b8dac42c$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $e9537e62b8dac42c$export$c277b80f2da61f89; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $2Wido = parcelRequire("2Wido");
const $e9537e62b8dac42c$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$84affe19123eb209 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $e9537e62b8dac42c$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};

});

parcelRegister("v7O5E", function(module, exports) {
$parcel$export(module.exports, "LoomFreePriceCard", function () { return $c7b8be01488760da$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $c7b8be01488760da$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $c7b8be01488760da$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $c7b8be01488760da$export$d88b84b01ca5e441; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $1CtPM = parcelRequire("1CtPM");

var $2Wido = parcelRequire("2Wido");
const $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $c7b8be01488760da$export$947796c8957ff6ff = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    }));
};
const $c7b8be01488760da$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange
    }));
};
const $c7b8be01488760da$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    const intl = (0, $8e22h.default)();
    const customBannerText = intl.formatMessage({
        id: "LoomBusinessPlusAiPriceCard.mostPopular",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        customBannerText: customBannerText
    }));
};
const $c7b8be01488760da$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $c7b8be01488760da$var$useOmitRange();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
    }));
};
const $c7b8be01488760da$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $1CtPM.useBillingCycle)();
    const [unitCount] = (0, $1CtPM.useUnitCount)();
    return billingCycle === "ANNUAL" && unitCount < $c7b8be01488760da$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("1NsjC", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $bb1064deffe4f718$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $bb1064deffe4f718$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $bb1064deffe4f718$export$1fb355a43910f211; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $bb1064deffe4f718$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $6ogO3._)({}, props));
};
const $bb1064deffe4f718$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    }));
};
const $bb1064deffe4f718$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.creators)
        })
    }));
};

});


parcelRegister("fhn1A", function(module, exports) {
$parcel$export(module.exports, "useProviderProps", function () { return $00fd412ee2189aba$export$521c373ccc32c300; });
// @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1XfW0 = parcelRequire("1XfW0");

var $hu3Tl = parcelRequire("hu3Tl");

var $aTHox = parcelRequire("aTHox");

var $7dhmX = parcelRequire("7dhmX");

var $29JVp = parcelRequire("29JVp");

var $44C4o = parcelRequire("44C4o");

var $j1ORI = parcelRequire("j1ORI");

var $lc7EO = parcelRequire("lc7EO");

var $4utnL = parcelRequire("4utnL");

var $9Nmuw = parcelRequire("9Nmuw");

var $fEBe5 = parcelRequire("fEBe5");

var $hGYMM = parcelRequire("hGYMM");

var $YmHME = parcelRequire("YmHME");

var $1CtPM = parcelRequire("1CtPM");
function $00fd412ee2189aba$export$521c373ccc32c300(props) {
    const { plans: plans, product: product, inputValues: inputValues } = props;
    const billingCycle = inputValues === null || inputValues === void 0 ? void 0 : inputValues.billingCycle;
    const unitCount = inputValues === null || inputValues === void 0 ? void 0 : inputValues.unitCount;
    const locale = (0, $1XfW0.useLocale)();
    const currencyISOCode = (0, $hu3Tl.getCurrencyFromUserLocale)(locale);
    const ssrData = plans.reduce((acc, plan)=>{
        return (0, $dPABA._)((0, $6ogO3._)({}, acc), {
            [plan.fields.sku]: plan.pricingPlan
        });
    }, {});
    const { data: ccpPricingData, status: status } = (0, $1CtPM.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === "error") return {
        status: "error"
    };
    if (status === "pending") return {
        status: "pending"
    };
    if (product === "jira") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $j1ORI.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $j1ORI.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $j1ORI.jiraPlanLimitConfigs,
                unitMinEnterprise: $j1ORI.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "confluence") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $29JVp.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $29JVp.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $29JVp.confluencePlanLimitConfigs,
                unitMinEnterprise: $29JVp.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "teamwork") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $YmHME.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $YmHME.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $YmHME.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $YmHME.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $YmHME.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === "guard") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $44C4o.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $44C4o.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $44C4o.guardPlanLimitConfigs,
                unitMinEnterprise: $44C4o.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $44C4o.guardBillingCycleConfig
            }
        }
    };
    if (product === "bitbucket") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $aTHox.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $aTHox.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $aTHox.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $aTHox.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: "USD",
                localeISOCode: locale,
                billingCycleConfig: $aTHox.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === "strategy") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $hGYMM.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $hGYMM.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $hGYMM.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $hGYMM.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $hGYMM.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === "compass") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $7dhmX.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $7dhmX.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $7dhmX.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $7dhmX.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $7dhmX.compassBillingCycleConfig
            }
        }
    };
    if (product === "service") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $fEBe5.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $fEBe5.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fEBe5.serviceCollectionPlanLimitConfigs,
                unitMinEnterprise: $fEBe5.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fEBe5.serviceCollectionBillingCycleConfig
            }
        }
    };
    if (product === "rovo-dev") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $9Nmuw.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $9Nmuw.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $9Nmuw.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $9Nmuw.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $9Nmuw.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === "loom") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $4utnL.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $4utnL.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $4utnL.loomPlanLimitConfigs,
                unitMinEnterprise: $4utnL.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $4utnL.loomBillingCycleConfig
            }
        }
    };
    if (product === "product-discovery") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: billingCycle !== null && billingCycle !== void 0 ? billingCycle : $lc7EO.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: unitCount !== null && unitCount !== void 0 ? unitCount : $lc7EO.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $lc7EO.jpdPlanLimitConfigs,
                unitMinEnterprise: $lc7EO.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $lc7EO.jpdBillingCycleConfig
            }
        }
    };
    throw new Error("unknown product");
}

});
parcelRegister("1XfW0", function(module, exports) {
"use strict";
var $16c7a96eeffbdd9b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $16c7a96eeffbdd9b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $16c7a96eeffbdd9b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$16c7a96eeffbdd9b$var$__exportStar((parcelRequire("dbu8X")), module.exports);

});
parcelRegister("dbu8X", function(module, exports) {
"use strict";
var $9993af4ecc11ada2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9993af4ecc11ada2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9993af4ecc11ada2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9993af4ecc11ada2$var$__exportStar((parcelRequire("d7zsU")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("c09cG")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("9sIvp")), module.exports);

$9993af4ecc11ada2$var$__exportStar((parcelRequire("4Hi5f")), module.exports);

});
parcelRegister("d7zsU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCALES = module.exports.LOCALE_REGISTRY = module.exports.DEFAULT_LOCALE = void 0;
module.exports.DEFAULT_LOCALE = "en";
module.exports.LOCALE_REGISTRY = Object.freeze({
    [module.exports.DEFAULT_LOCALE]: {
        label: "English"
    },
    de: {
        label: "Deutsch"
    },
    es: {
        label: "Espa\xf1ol"
    },
    fr: {
        label: "Fran\xe7ais"
    },
    it: {
        label: "Italiano"
    },
    ko: {
        label: "\uD55C\uAD6D\uC5B4"
    },
    nl: {
        label: "Nederlands"
    },
    ja: {
        label: "\u65E5\u672C\u8A9E"
    },
    pl: {
        label: "Polski"
    },
    br: {
        label: "Portugu\xeas"
    },
    ru: {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    zh: {
        label: "\u4E2D\u6587"
    }
});
module.exports.LOCALES = Object.keys(module.exports.LOCALE_REGISTRY);

});

parcelRegister("c09cG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocale = $8bcc9fc4fdd32787$var$useLocale;

var $8e22h = parcelRequire("8e22h");
function $8bcc9fc4fdd32787$var$useLocale() {
    const intl = (0, $8e22h.default)();
    return intl.locale;
}

});

parcelRegister("9sIvp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocalizedHref = $6e394074629606a1$var$useLocalizedHref;

var $d7zsU = parcelRequire("d7zsU");

var $c09cG = parcelRequire("c09cG");
function $6e394074629606a1$var$useLocalizedHref(href) {
    const locale = (0, $c09cG.useLocale)();
    if (locale === $d7zsU.DEFAULT_LOCALE) return href;
    else return `/${locale}${href}`;
}

});

parcelRegister("4Hi5f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VALUES = void 0;

var $7VQPk = parcelRequire("7VQPk");
module.exports.DEFAULT_VALUES = Object.freeze({
    br: (0, $7VQPk.jsx)("br", {}),
    p: (chunks)=>(0, $7VQPk.jsx)("p", {
            children: chunks
        }),
    strong: (chunks)=>(0, $7VQPk.jsx)("strong", {
            children: chunks
        }),
    span: (chunks)=>(0, $7VQPk.jsx)("span", {
            children: chunks
        })
});

});




parcelRegister("juRep", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorCard", function () { return $1b9806dc7038eb23$export$14072311c149f96f; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $4G0xh = parcelRequire("4G0xh");
parcelRequire("hEIeM");
var $1NsjC = parcelRequire("1NsjC");
var $v7O5E = parcelRequire("v7O5E");
var $kBDDI = parcelRequire("kBDDI");
var $9hJtd = parcelRequire("9hJtd");

var $eCYOL = parcelRequire("eCYOL");

var $2Wido = parcelRequire("2Wido");

var $aTHox = parcelRequire("aTHox");
parcelRequire("b9I0b");
var $7dhmX = parcelRequire("7dhmX");
var $29JVp = parcelRequire("29JVp");
var $44C4o = parcelRequire("44C4o");
var $j1ORI = parcelRequire("j1ORI");
var $lc7EO = parcelRequire("lc7EO");
var $4utnL = parcelRequire("4utnL");
var $9Nmuw = parcelRequire("9Nmuw");
var $fEBe5 = parcelRequire("fEBe5");
var $hGYMM = parcelRequire("hGYMM");
var $YmHME = parcelRequire("YmHME");
const $1b9806dc7038eb23$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $4G0xh.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $j1ORI.jiraOfferingSkus).free:
        case (0, $29JVp.confluenceOfferingSkus).free:
        case (0, $YmHME.teamworkCollectionOfferingSkus).free:
        case (0, $7dhmX.compassOfferingSkus).free:
        case (0, $aTHox.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.FreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Standard
        case (0, $j1ORI.jiraOfferingSkus).standard:
        case (0, $29JVp.confluenceOfferingSkus).standard:
        case (0, $YmHME.teamworkCollectionOfferingSkus).standard:
        case (0, $44C4o.guardOfferingSkus).standard:
        case (0, $7dhmX.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $aTHox.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Premium
        case (0, $j1ORI.jiraOfferingSkus).premium:
        case (0, $29JVp.confluenceOfferingSkus).premium:
        case (0, $YmHME.teamworkCollectionOfferingSkus).premium:
        case (0, $44C4o.guardOfferingSkus).premium:
        case (0, $7dhmX.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $aTHox.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eCYOL.BitbucketPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Enterprise
        case (0, $j1ORI.jiraOfferingSkus).enterprise:
        case (0, $29JVp.confluenceOfferingSkus).enterprise:
        case (0, $YmHME.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $6ogO3._)({}, props));
        case (0, $hGYMM.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.EnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                isJpyPriceEnabled: true
            }));
        // Custom, for any tier
        case (0, $9Nmuw.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kBDDI.RovoDevStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $fEBe5.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9hJtd.ServiceCollectionEnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomBusinessPlusAiPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $4utnL.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $v7O5E.LoomEnterprisePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryFreePriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryStandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $lc7EO.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1NsjC.JiraProductDiscoveryPremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("eCYOL", function(module, exports) {
$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $cb5a2cb54b1cfed2$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $cb5a2cb54b1cfed2$export$3845e26e0454185b; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $aTHox = parcelRequire("aTHox");

var $9evy5 = parcelRequire("9evy5");

var $iXfHC = parcelRequire("iXfHC");

var $2Wido = parcelRequire("2Wido");
const $cb5a2cb54b1cfed2$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.StandardPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};
const $cb5a2cb54b1cfed2$export$3845e26e0454185b = (props)=>{
    const intl = (0, $8e22h.default)();
    const formattedLimit = intl.formatNumber((0, $aTHox.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Wido.PremiumPriceCard), (0, $dPABA._)((0, $6ogO3._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iXfHC.PriceAltContainer), {
            children: intl.formatMessage($9evy5.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};

});




parcelRegister("42V1t", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", function () { return $92139e655263218b$export$915e9e7bd4f0f96d; });
/* error-message.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $92139e655263218b$export$915e9e7bd4f0f96d = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "global-nav-user-profile-container-spinner",
            children: "ERROR"
        })
    });

});

parcelRegister("fNAVV", function(module, exports) {
$parcel$export(module.exports, "pricingTitleInternal", function () { return $7e2f802cabb58fc1$export$e1fb2a6f4d847984; });
$parcel$export(module.exports, "getNonprofitPricingCalculatorData", function () { return $7e2f802cabb58fc1$export$3d0bcdd9a87aae52; });

var $g0Z8A = parcelRequire("g0Z8A");

var $29JVp = parcelRequire("29JVp");

var $j1ORI = parcelRequire("j1ORI");

var $4utnL = parcelRequire("4utnL");

var $YmHME = parcelRequire("YmHME");
const $7e2f802cabb58fc1$export$e1fb2a6f4d847984 = {
    JIRA: "Jira Pricing Page",
    CONFLUENCE: "Confluence Pricing Page",
    TWC: "Teamwork Collection Pricing Page",
    LOOM: "Loom Pricing Page"
};
const $7e2f802cabb58fc1$export$3d0bcdd9a87aae52 = async ()=>{
    const result = await (0, $g0Z8A.getPricingCalculatorData)([
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC,
        $7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM
    ]);
    return $7e2f802cabb58fc1$var$omitEnterprisePlans(result);
};
const $7e2f802cabb58fc1$var$omitEnterprisePlans = (plansDataByProduct)=>{
    var _plansDataByProduct_pricingTitleInternal_JIRA, _plansDataByProduct_pricingTitleInternal_CONFLUENCE, _plansDataByProduct_pricingTitleInternal_TWC, _plansDataByProduct_pricingTitleInternal_LOOM;
    var _plansDataByProduct_pricingTitleInternal_JIRA_filter;
    const jiraPlans = (_plansDataByProduct_pricingTitleInternal_JIRA_filter = (_plansDataByProduct_pricingTitleInternal_JIRA = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA]) === null || _plansDataByProduct_pricingTitleInternal_JIRA === void 0 ? void 0 : _plansDataByProduct_pricingTitleInternal_JIRA.filter((plan)=>{
        var _plan_pricingPlan;
        const sku = (_plan_pricingPlan = plan.pricingPlan) === null || _plan_pricingPlan === void 0 ? void 0 : _plan_pricingPlan.sku;
        return sku !== (0, $j1ORI.jiraOfferingSkus).enterprise;
    })) !== null && _plansDataByProduct_pricingTitleInternal_JIRA_filter !== void 0 ? _plansDataByProduct_pricingTitleInternal_JIRA_filter : [];
    var _plansDataByProduct_pricingTitleInternal_CONFLUENCE_filter;
    const confluencePlans = (_plansDataByProduct_pricingTitleInternal_CONFLUENCE_filter = (_plansDataByProduct_pricingTitleInternal_CONFLUENCE = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE]) === null || _plansDataByProduct_pricingTitleInternal_CONFLUENCE === void 0 ? void 0 : _plansDataByProduct_pricingTitleInternal_CONFLUENCE.filter((plan)=>{
        var _plan_pricingPlan;
        const sku = (_plan_pricingPlan = plan.pricingPlan) === null || _plan_pricingPlan === void 0 ? void 0 : _plan_pricingPlan.sku;
        return sku !== (0, $29JVp.confluenceOfferingSkus).enterprise;
    })) !== null && _plansDataByProduct_pricingTitleInternal_CONFLUENCE_filter !== void 0 ? _plansDataByProduct_pricingTitleInternal_CONFLUENCE_filter : [];
    var _plansDataByProduct_pricingTitleInternal_TWC_filter;
    const teamworkCollectionPlans = (_plansDataByProduct_pricingTitleInternal_TWC_filter = (_plansDataByProduct_pricingTitleInternal_TWC = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC]) === null || _plansDataByProduct_pricingTitleInternal_TWC === void 0 ? void 0 : _plansDataByProduct_pricingTitleInternal_TWC.filter((plan)=>{
        var _plan_pricingPlan;
        const sku = (_plan_pricingPlan = plan.pricingPlan) === null || _plan_pricingPlan === void 0 ? void 0 : _plan_pricingPlan.sku;
        return sku !== (0, $YmHME.teamworkCollectionOfferingSkus).enterprise;
    })) !== null && _plansDataByProduct_pricingTitleInternal_TWC_filter !== void 0 ? _plansDataByProduct_pricingTitleInternal_TWC_filter : [];
    var _plansDataByProduct_pricingTitleInternal_LOOM_filter;
    const loomPlans = (_plansDataByProduct_pricingTitleInternal_LOOM_filter = (_plansDataByProduct_pricingTitleInternal_LOOM = plansDataByProduct[$7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM]) === null || _plansDataByProduct_pricingTitleInternal_LOOM === void 0 ? void 0 : _plansDataByProduct_pricingTitleInternal_LOOM.filter((plan)=>{
        var _plan_pricingPlan;
        const sku = (_plan_pricingPlan = plan.pricingPlan) === null || _plan_pricingPlan === void 0 ? void 0 : _plan_pricingPlan.sku;
        return sku !== (0, $4utnL.loomOfferingSkus).enterprise;
    })) !== null && _plansDataByProduct_pricingTitleInternal_LOOM_filter !== void 0 ? _plansDataByProduct_pricingTitleInternal_LOOM_filter : [];
    return {
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.JIRA]: jiraPlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.CONFLUENCE]: confluencePlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.TWC]: teamworkCollectionPlans,
        [$7e2f802cabb58fc1$export$e1fb2a6f4d847984.LOOM]: loomPlans
    };
};

});
parcelRegister("g0Z8A", function(module, exports) {
$parcel$export(module.exports, "getPricingCalculatorData", function () { return $bfe47c5595fb2c89$export$ec56dd3792d0c55e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $61WdP = parcelRequire("61WdP");
async function $bfe47c5595fb2c89$export$ec56dd3792d0c55e(pricingTitleInternals) {
    const contentClient = await (0, $61WdP.getContentfulContentClient)();
    const contentResult = await contentClient.getEntries({
        "content_type": "pricing",
        "fields.pricingTitleInternal[in]": pricingTitleInternals,
        "select": [
            "sys",
            "fields.comparePlans",
            "fields.pricingTitleInternal",
            "fields.compareFeaturesTitle"
        ],
        "include": 10
    });
    const productCatalogClient = (0, $61WdP.getContentfulProductCatalogClient)();
    const productCatalogResults = await Promise.all(contentResult.items.map((item)=>{
        const skus = item.fields.comparePlans.map((plan)=>plan.fields.sku);
        return productCatalogClient.getCCPPricingData(skus);
    }));
    const ccpPricingData = productCatalogResults.reduce((acc, result)=>{
        return (0, $6ogO3._)({}, acc, result);
    }, {});
    return pricingTitleInternals.reduce((acc, pricingTitleInternal)=>{
        const product = contentResult.items.find((product)=>product.fields.pricingTitleInternal === pricingTitleInternal);
        const comparePlans = product === null || product === void 0 ? void 0 : product.fields.comparePlans;
        if (!comparePlans) return acc;
        var _comparePlans_map;
        acc[pricingTitleInternal] = (_comparePlans_map = comparePlans.map((plan)=>(0, $dPABA._)((0, $6ogO3._)({}, plan), {
                pricingPlan: ccpPricingData[plan.fields.sku]
            }))) !== null && _comparePlans_map !== void 0 ? _comparePlans_map : [];
        return acc;
    }, {});
}

});
parcelRegister("61WdP", function(module, exports) {
$parcel$export(module.exports, "getContentfulContentClient", function () { return $c51fe70e32d8081e$export$5aaa8f1b0d95285f; });
$parcel$export(module.exports, "getContentfulProductCatalogClient", function () { return $c51fe70e32d8081e$export$c784e669eb2d0fdf; });

var $dkcYJ = parcelRequire("dkcYJ");

var $32ng3 = parcelRequire("32ng3");

var $eRzlV = parcelRequire("eRzlV");
const $c51fe70e32d8081e$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $c51fe70e32d8081e$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $c51fe70e32d8081e$var$PRODUCT_TEMPLATES_ENVIRONMENT = "master";
const $c51fe70e32d8081e$var$PRODUCT_TEMPLATES_DELIVERY_KEY = "fTu2YoVb3vqTOyvfOZveEriN4V4vgNk9aVYcJuLRfc8";

const $c51fe70e32d8081e$export$5aaa8f1b0d95285f = async ()=>{
    const { createClient: createClient } = await (parcelRequire("heQDP"));
    return createClient({
        space: "xjcz23wx147q",
        environment: $c51fe70e32d8081e$var$PRODUCT_TEMPLATES_ENVIRONMENT,
        accessToken: String($c51fe70e32d8081e$var$PRODUCT_TEMPLATES_DELIVERY_KEY)
    });
};
const $c51fe70e32d8081e$export$c784e669eb2d0fdf = ()=>{
    const productCatalogEnvironment = $c51fe70e32d8081e$var$getContentfulProductCatalogEnvironment();
    return new (0, $dkcYJ.ProductCatalogClient)(String($c51fe70e32d8081e$var$PRODUCT_CATALOG_DELIVERY_KEY), String($c51fe70e32d8081e$var$PRODUCT_CATALOG_SPACE), productCatalogEnvironment);
};
const $c51fe70e32d8081e$var$getContentfulProductCatalogEnvironment = ()=>{
    if ((0, $eRzlV.isProduction)()) return "master";
    const isCcpStaging = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9034WacPricingCcpStaging);
    return isCcpStaging ? "ccp_staging" : "master";
};

});
parcelRegister("heQDP", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("fGv84")).then(()=>parcelRequire('9pugI'));

});




parcelRegister("437NE", function(module, exports) {
$parcel$export(module.exports, "useNonProfitPricingCalculatorData", function () { return $79b000344fbd80a7$export$5805edf503905c58; });

var $1oC0p = parcelRequire("1oC0p");

var $fNAVV = parcelRequire("fNAVV");
const $79b000344fbd80a7$export$5805edf503905c58 = ()=>{
    const [plansDataByProduct, setPlansDataByProduct] = (0, $1oC0p.useState)();
    const [error, setError] = (0, $1oC0p.useState)();
    const loadPricingCalculatorData = (0, $1oC0p.useCallback)(async ()=>{
        try {
            const result = await (0, $fNAVV.getNonprofitPricingCalculatorData)();
            setPlansDataByProduct(result);
        } catch (err) {
            setError(err);
        }
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        loadPricingCalculatorData();
    }, [
        loadPricingCalculatorData
    ]);
    return {
        plansDataByProduct: plansDataByProduct,
        error: error
    };
};

});


parcelRegister("g7wmQ", function(module, exports) {
$parcel$export(module.exports, "Banner", function () { return $fb264eb8fd8740ec$export$3b4e64e77073e307; });
/* banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $kbpa7 = parcelRequire("kbpa7");

var $btggB = parcelRequire("btggB");
const $fb264eb8fd8740ec$var$bannerContainerCss = null;
const $fb264eb8fd8740ec$var$bodyCss = null;
const $fb264eb8fd8740ec$export$3b4e64e77073e307 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bfhk17la _1e0c1txw _1bah1h6o _y3gn1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _uj6k1h6o"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazu67f _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3 _1bsb1osq _1kny1nu9 _13pm1r31 _1dzg8stv _t1u2nqa1"
            ]),
            children: [
                isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.banner.body.isGwp10027",
                    defaultMessage: "Small social impact teams can now access Teamwork Collection apps at 100% off."
                }),
                !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.banner.body.gwp7869",
                    defaultMessage: "Social Enterprises are now eligible for Atlassian\u2019s discounted apps and support programs!"
                })
            ]
        })
    });
};

});

parcelRegister("fZJZd", function(module, exports) {
$parcel$export(module.exports, "EligibleSection", function () { return $12df217695235bc1$export$1830bba02ce6e4ac; });
/* eligible-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $btggB = parcelRequire("btggB");

var $61SXF = parcelRequire("61SXF");
const $12df217695235bc1$var$eligibleContainerCss = null;
const $12df217695235bc1$var$headerCss = null;
const $12df217695235bc1$var$subtitleCss = null;
const $12df217695235bc1$var$ctaBlockCss = null;
const $12df217695235bc1$var$ctaBlockContentCss = null;
const $12df217695235bc1$var$ctaBlockTitleCss = null;
const $12df217695235bc1$var$ctaBlockDetailCss = null;
const $12df217695235bc1$var$imageCss = null;
const $12df217695235bc1$export$1830bba02ce6e4ac = ()=>{
    const intl = (0, $8e22h.default)();
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const learnMore = intl.formatMessage({
        id: "NonprofitPage.eligible.cta.content.link",
        defaultMessage: "Learn more"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _17gqckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.header",
                    defaultMessage: "Who\u2019s eligible"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _1s18gktf _17gq1f4h _b8yqbxu3 _15flidpf _1d2w1wug _1svygktf _seov1wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: isGwp10027 ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.subtitle.gwp10027",
                    defaultMessage: "50% - 100% off discounts are available for nonprofits and social enterprises that are:"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.eligible.subtitle.gwp7869",
                    defaultMessage: "Discounts on Atlassian Cloud apps are available to nonprofits and social enterprises that are:"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $61SXF.EligibilityListGwp7869), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _1bsb1osq _19pk12am _2hwxidpf _otyridpf _18u0idpf _1lrw1sh2 _12veeva1 _ca0q4bvh _u5f37vkz _n3td4bvh _19bv7vkz _kqswh2mm _1itk1sc7 _13hp18tu _b2g019fs _i6jx16xz _1lh77vkz _z3nc16xz _wpai7vkz _1vkhvle5 _7uci11oj _2cw21ssb _1l142xu9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o _1ako7vkz _c7s77vkz _4puvzwfg _1r3v7vkz"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_1wyb1tcg _vwz41ul9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "NonprofitPage.eligible.cta.title",
                                defaultMessage: "Need more info?"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_1wyb7vkz _vwz41tcg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "NonprofitPage.eligible.cta.content",
                                defaultMessage: "Get the answers for your most frequently asked eligibility questions."
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                            text: learnMore,
                            "aria-label": learnMore,
                            href: "#faq",
                            type: "primary",
                            dataEventProps: {
                                "data-event-component": "linkButton",
                                // @ts-ignore
                                "data-event-container": "Eligibility section",
                                "data-event": "clicked",
                                "data-product-key": "nonProfitCalculator"
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_p12f1obz _c71l7iqz _kqswstnw _rjxp1wqo _u7co15qf _mezj12it _bna712it _p5ceka7h _enhl9by0 _j0lc1osq _1jtm1osq _1t06x19p _wtm5ka7h"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8fhb444317uecxj0n4dy144u8atr503c.webp",
                                    alt: ""
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$12df217695235bc1$export$1830bba02ce6e4ac.displayName = "EligibleSection";

});
parcelRegister("61SXF", function(module, exports) {
$parcel$export(module.exports, "EligibilityListGwp7869", function () { return $2ffcccaddfe16e55$export$c64766b093b22842; });
/* eligibility-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");
const $2ffcccaddfe16e55$export$5a8c33720cbdacee = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                            alt: ""
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.title2",
                            defaultMessage: "Non-commercial"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.content2",
                            defaultMessage: "operating on a not-for-profit basis and for the public benefit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$Nonprofit, {})
        ]
    });
};
const $2ffcccaddfe16e55$export$c64766b093b22842 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonGovernmental, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$NonPolitical, {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2ffcccaddfe16e55$var$Nonprofit, {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                            alt: ""
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                        className: (0, $2jatx.default)([
                            "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.socialMissionTitle",
                            defaultMessage: "For-profit with a social mission"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.socialMissionContent",
                            defaultMessage: "<a>as defined by Atlassian</a> and verified by Goodstack",
                            values: {
                                a: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                        href: "#faq",
                                        className: (0, $2jatx.default)([
                                            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1"
                                        ]),
                                        style: {
                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                        },
                                        children: chunks
                                    })
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$NonGovernmental = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4vunf5vd4cboe8glor3vep3mam3a3d0o.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title1",
                    defaultMessage: "Non-governmental"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.content1",
                    defaultMessage: "independent from government control"
                })
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$NonPolitical = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k1y270i4t5e33yp8hw62tn3l37850050.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title3",
                    defaultMessage: "Non-political"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.content3",
                    defaultMessage: "or against any political party, candidate, or campaign"
                })
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$Nonprofit = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8q882ia8oh77fl481x8f01up4y2a2q18.svg",
                    alt: ""
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                className: (0, $2jatx.default)([
                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf _1s181tcg _17gq1ul9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.card.title4",
                    defaultMessage: "Recognized as a nonprofit"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fpcwi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.card.content4",
                        defaultMessage: "in the country in which you are registered, in accordance with the "
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                        target: "_blank",
                        href: "https://goodstack.org/nonprofit-definitions",
                        rel: "noreferrer",
                        className: (0, $2jatx.default)([
                            "_syaz17la _4bfu1r31 _1hms8stv _ajmmnqa1"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "NonprofitPage.card.content4.link",
                            defaultMessage: "eligibility criteria for that country"
                        })
                    })
                ]
            })
        ]
    });
};
const $2ffcccaddfe16e55$var$rowWrapperCss = null;
const $2ffcccaddfe16e55$var$cardTitleCss = null;
const $2ffcccaddfe16e55$var$cardContentCss = null;
const $2ffcccaddfe16e55$var$cardContentLinkCss = null;

});


parcelRegister("4bEWc", function(module, exports) {
$parcel$export(module.exports, "EnterpriseSection", function () { return $2c55cd82052437a3$export$f366cf0ae8139431; });
/* enterprise-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");
const $2c55cd82052437a3$export$f366cf0ae8139431 = ()=>{
    const localizedCTAHRef = (0, $kooLp.useLocalizedHref)("/software/views/community-license-request#/");
    const containerStyles = null;
    const pictureStyles = null;
    const contentBlockStyles = null;
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _p12f5o3v _zulpoahv _yv0ewxkt _4cvr1h6o _y3gn1e5h _1ph4hkll _gu181h6o _1qgn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/scjwn81w6s2ardgn7641002jp2ye5252.svg",
                            alt: ""
                        },
                        className: (0, $2jatx.default)([
                            "_6rthpxbi"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerType: "h3",
                        headerText: intl.formatMessage({
                            id: "NonprofitPage.enterprise-section.heading.gwp7869",
                            defaultMessage: "Enterprise plans are 50% off for eligible nonprofits and social enterprises."
                        }),
                        ctaProps: {
                            buttonProps: {
                                text: intl.formatMessage({
                                    id: "NonprofitPage.enterprise-section.cta",
                                    defaultMessage: "Apply now"
                                }),
                                url: localizedCTAHRef
                            }
                        },
                        className: (0, $2jatx.default)([
                            "_1axibfyo _r8ntni7l _ggmhxy5q _qliy1hlo"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1rg21ssb _1h6o1ssb _rtys1osq _15pj1osq _bna71wug _1r2v1wug _1cr61wug _dusl1wug _1hlx1wug _atom1wug _18741wug _2t2f1wug _10ew1wug _1iya1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/334g168on374sch67v7r1lrv174i8psc.webp",
                        alt: ""
                    }
                })
            })
        ]
    });
};
$2c55cd82052437a3$export$f366cf0ae8139431.displayName = "EnterpriseSection";

});

parcelRegister("71t0B", function(module, exports) {
$parcel$export(module.exports, "Fineprint", function () { return $a19187bc89cb8b37$export$3fb2e06c2eeca703; });
/* fineprint.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $btggB = parcelRequire("btggB");
const $a19187bc89cb8b37$var$fineprintContainerCss = null;
const $a19187bc89cb8b37$var$headerCss = null;
const $a19187bc89cb8b37$var$bodyCss = null;
const $a19187bc89cb8b37$export$3fb2e06c2eeca703 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.fineprint.header",
                    defaultMessage: "The fine print"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.gwp10027",
                        defaultMessage: "Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian\u2019s Social Impact License eligibility criteria."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body",
                        defaultMessage: "Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian\u2019s Community License eligibility criteria."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fbxu3"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.additional",
                        defaultMessage: "Atlassian verifies Social Impact License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization\u2019s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Social Impact License eligibility guidelines at any time."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.fineprint.body.additional",
                        defaultMessage: "Atlassian verifies Community License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization\u2019s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Community License eligibility guidelines at any time."
                    })
                ]
            })
        ]
    });
};
$a19187bc89cb8b37$export$3fb2e06c2eeca703.displayName = "FineprintSection";

});

parcelRegister("gtK7Z", function(module, exports) {
$parcel$export(module.exports, "Hero", function () { return $1f97debb6b62cf0e$export$887967f05dc521ae; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $btggB = parcelRequire("btggB");
const $1f97debb6b62cf0e$var$heroContainerCss = null;
const $1f97debb6b62cf0e$var$contentBoxCss = null;
const $1f97debb6b62cf0e$var$preheaderCss = null;
const $1f97debb6b62cf0e$var$titleCss = null;
const $1f97debb6b62cf0e$var$subtitleCss = null;
const $1f97debb6b62cf0e$var$mobileImageCss = null;
const $1f97debb6b62cf0e$export$887967f05dc521ae = ()=>{
    const ctaButtonUrl = "/software/views/community-license-request#/";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1reo15vq _18m915vq _1bsb1osq _1gnk1029 _p17a18tu _1u5reva1 _rb2g8y3i _ij141rp3 _1odr1on4 _18xueva1 _1o60asht"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syaz1hlo _y3gn1h6o _kqswh2mm _1q51zwfg _p12f1fra _1waf16xz _44j9idpf _1tz91y44 _1enu1f4h"
            ]),
            style: {
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h5", {
                    className: (0, $2jatx.default)([
                        "_1wybf6fq _vwz41ou6 _1pfhidpf _6rth1skh _k48p1fw0 _1s18gktf _17gq1f4h _1ob91tcg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.preheader",
                        defaultMessage: "ATLASSIAN FOR NONPROFITS"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_1wyb1wqb _vwz4ymf6 _k48p1nn1 _1pfhidpf _6rthf6fq _1s18ymf6 _17gqys9h _b8yq1ogm _jhy41nn1"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.title",
                        defaultMessage: "Pricing that fits your nonprofit\u2019s budget"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                    className: (0, $2jatx.default)([
                        "_1wybgktf _vwz41f4h _p12f1178 _k48powjs _19pkidpf _2hwx1wug _otyr1skh _18u01wug _1s181f4h _17gq1ylp _b8yq1kdj _15flidpf _1d2w1wug _1svyo7ao _seov1wug"
                    ]),
                    children: (0, $btggB.getIsGwp10027NonprofitPricingPage)() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.subtitle.gwp10027",
                        defaultMessage: "Get free and discounted Atlassian apps for nonprofit and social enterprise teams"
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.subtitle.gwp7869",
                        defaultMessage: "Get discounted Atlassian apps for nonprofit and social enterprise teams"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                    variant: "primary",
                    size: "small",
                    color: "blue",
                    href: (0, $kooLp.useLocalizedHref)(ctaButtonUrl),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.hero.button",
                        defaultMessage: "Apply now"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1bsbixjv _4t3iva7c _1sjrglyw _mezj1osq _bna71osq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8p5v165n7f507j620h6738eoudo17oae.svg",
                            alt: ""
                        }
                    })
                })
            ]
        })
    });
};

});

parcelRegister("k53CY", function(module, exports) {
$parcel$export(module.exports, "NonprofitCalculatorHeading", function () { return $5c9f5bc678cf4f45$export$ea62e9564a56df6c; });
/* nonprofit-calculator-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");
const $5c9f5bc678cf4f45$export$ea62e9564a56df6c = ()=>{
    const headingStyles = null;
    const subtitleStyles = null;
    const imgStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpftgi _p12fbxu3 _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_k48p9y44 _1wyb1ylp _vwz48vuz _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12fz8o0 _1s18ckbl _b8yqstmo _syaz1hlo"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.calculator.heading",
                    defaultMessage: "Choose the tools and pricing that fit your team"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_p12fkbql _y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.calculator.subheading.gwp7869",
                    defaultMessage: "Use our pricing calculator to get a <bold>discounted pricing estimate</bold> available to nonprofits and social enterprises.",
                    values: {
                        // eslint-disable-next-line react/no-unstable-nested-components
                        bold: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_k48p8n31"
                                ]),
                                children: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/27360l8wso6a72x4e44yyg66uak8r51f.svg",
                    alt: ""
                },
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kqswstnw _4t3ivrzy _1bsb1dqv _mmgk1wqo _kzvi1ule _11901pbv _dm251ule"
                ])
            })
        ]
    });
};
$5c9f5bc678cf4f45$export$ea62e9564a56df6c.displayName = "TabbedCalculatorHeadingSection";

});

parcelRegister("lSpoK", function(module, exports) {
$parcel$export(module.exports, "NonprofitNav", function () { return $6309917ad16a803d$export$4dfedf5c077d010b; });
/* nonprofit-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $l2QYX = parcelRequire("l2QYX");
const $6309917ad16a803d$var$NonprofitLogo = ()=>{
    const logoCss = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_1e0c1mog _1wyb1k92 _ca0q1ou6 _u5f3idpf _n3tdgktf _19bvidpf _k48pni7l"
        ]),
        children: "Nonprofits"
    });
};
const $6309917ad16a803d$export$4dfedf5c077d010b = ()=>{
    const intl = (0, $8e22h.default)();
    const eligibilityHref = (0, $kooLp.useLocalizedHref)("/teams/nonprofits/discount-pricing");
    const supportPrograms = (0, $kooLp.useLocalizedHref)("/teams/nonprofits/support-programs");
    const resource = (0, $kooLp.useLocalizedHref)("/teams/nonprofits/resources");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "nonprofit-nav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            isShowTryNowLink: false,
            productLogoUrl: "/teams/nonprofits",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($6309917ad16a803d$var$NonprofitLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "NonprofitPageTemplate.navbar.nonprofit-logo",
                defaultMessage: "Nonprofit logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($6309917ad16a803d$var$NonprofitLogo, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.pricing",
                        defaultMessage: "Eligibility and pricing"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: eligibilityHref
                },
                {
                    globalLinksKey: "support",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.support",
                        defaultMessage: "Support programs"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: supportPrograms
                },
                {
                    globalLinksKey: "resources",
                    linkText: intl.formatMessage({
                        id: "NonprofitPageTemplate.navbar.resources",
                        defaultMessage: "Resources"
                    }),
                    hasSubnav: false,
                    productKey: "nonprofit",
                    href: resource
                }
            ],
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-nonprofit",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.pricing",
                                defaultMessage: "Eligibility and pricing"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: eligibilityHref
                        },
                        {
                            globalLinksKey: "support",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.support",
                                defaultMessage: "Support programs"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: supportPrograms
                        },
                        {
                            globalLinksKey: "resources",
                            linkText: intl.formatMessage({
                                id: "NonprofitPageTemplate.navbar.resources",
                                defaultMessage: "Resources"
                            }),
                            hasSubnav: false,
                            productKey: "nonprofit",
                            href: resource
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("hJy82", function(module, exports) {
$parcel$export(module.exports, "OfficialSection", function () { return $a3701dad3ae12d03$export$dba159851b545af3; });
/* official-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $kooLp = parcelRequire("kooLp");

var $btggB = parcelRequire("btggB");
const $a3701dad3ae12d03$var$buttonStyle = null;
const $a3701dad3ae12d03$var$officialContainerCss = null;
const $a3701dad3ae12d03$var$headerCss = null;
const $a3701dad3ae12d03$var$subtitleCss = null;
const $a3701dad3ae12d03$var$rowWrapperCss = null;
const $a3701dad3ae12d03$var$cardTitleCss = null;
const $a3701dad3ae12d03$var$imageCss = null;
const $a3701dad3ae12d03$export$dba159851b545af3 = ()=>{
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const ctaButtonUrl = "/software/views/community-license-request#/";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwx1wug _otyrdlk8 _18u01wug _p12f1y37 _1s18ckbl _17gqckbl _b8yqbxu3 _15flidpf _1d2w1wug _1svy7vkz _seov1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.official.header",
                    defaultMessage: "Let\u2019s make it official"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48p1nn1 _19pkidpf _2hwx1wug _otyr19bv _18u01wug _p12f1y37 _1lzogktf _119z1f4h _lg5ridpf _d97m1wug _1b7egktf _12521wug _3p1c1f4h _py5o1ylp _10jxbxu3 _dbjgidpf _1hvk1wug _isu4gktf _15qm1wug"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.official.subtitle.gwp10027",
                        defaultMessage: "Apply for your Social Impact License. Here\u2019s how it\u2019ll work."
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.official.subtitle",
                        defaultMessage: "Apply to verify your eligibility and receive your discounted Community License. Here\u2019s how it\u2019ll work."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "blue",
                href: (0, $kooLp.useLocalizedHref)(ctaButtonUrl),
                className: (0, $2jatx.default)([
                    "_2rko1y44 _19pkidpf _2hwx1wug _otyr1tcg _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.hero.button",
                    defaultMessage: "Apply now"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1n261g80 _1bah1yb4 _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqi1ssb _498vusvi _1gee7vkz _18ts7vkz _75fp7vkz _r0eh7vkz _1yp81x1l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1665m6o0xxrphegnh7lnwf17585pj211.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title1.gwp10027",
                                        defaultMessage: "1. Choose your apps and get started with a free trial"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title1.v2",
                                        defaultMessage: "1. Choose your apps, calculate pricing, and sign up for a free plan or trial"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ok813kjv073y16g445ogp8yerkv6qvc2.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title2.gwp10027",
                                        defaultMessage: "2. Apply for a Social Impact License"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title2",
                                        defaultMessage: "2. Apply for your discounted license"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h1503x520p8bg7w744h810188q4bypf3.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "NonprofitPage.official.card.title3",
                                    defaultMessage: "3. In 2-3 days, verification approved and received!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe077p727atw2c04p00h3ecl1on0p841.svg",
                                    alt: ""
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("h4", {
                                className: (0, $2jatx.default)([
                                    "_1wybgktf _vwz41f4h _19pkidpf _2hwxidpf _otyr1crf _18u0idpf"
                                ]),
                                children: [
                                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title4.gwp10027",
                                        defaultMessage: "4. 50-100% discount automatically applied to your subscription"
                                    }),
                                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "NonprofitPage.official.card.title4",
                                        defaultMessage: "4. Discount automatically applied to your subscription and any future upgrades"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_p12f1k4y _c71l4bvh _kqswstnw _rjxp4l2f _u7co1a11 _j6qu146b _1pn4ucft _p5ce16gx _enhl1vuk _j0lc12it _1jtm12it _10jxmgvx _1jc2mhvn _1t0616gx _wtm512it _18oi1osq _1ky91osq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g626i0m4331tsgn2313fln510p5578n1.svg",
                        alt: ""
                    }
                })
            })
        ]
    });
};
$a3701dad3ae12d03$export$dba159851b545af3.displayName = "OfficialSection";

});

parcelRegister("3icmm", function(module, exports) {
$parcel$export(module.exports, "ResourcesSection", function () { return $e3ba3f7a269b5999$export$3f0336208d56829f; });
/* resources-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $NtjLk = parcelRequire("NtjLk");

var $btggB = parcelRequire("btggB");
const $e3ba3f7a269b5999$var$resourcesContainerCss = null;
const $e3ba3f7a269b5999$var$headerCss = null;
const $e3ba3f7a269b5999$var$subtitleCss = null;
const $e3ba3f7a269b5999$var$cardBlockCss = null;
const $e3ba3f7a269b5999$export$3f0336208d56829f = ()=>{
    const intl = (0, $8e22h.default)();
    const teamCardProps = {
        title: intl.formatMessage({
            id: "NonprofitPage.resources.team.title",
            defaultMessage: "Team up with us"
        }),
        titleAs: "h3",
        body: intl.formatMessage({
            id: "NonprofitPage.resources.team.body",
            defaultMessage: "Get free, customized app and teamwork coaching sessions with Atlassian experts. No question is too big or too small."
        }),
        image: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7g2k6ru6bw83f33121usy12j03td6p88.webp",
                alt: "Partners for Nonprofits"
            }
        },
        callToAction: {
            href: (0, $kooLp.useLocalizedHref)("/teams/nonprofits/support-programs"),
            text: intl.formatMessage({
                id: "NonprofitPage.resources.team.link",
                defaultMessage: "Learn more"
            })
        }
    };
    const isGwp10027 = (0, $btggB.getIsGwp10027NonprofitPricingPage)();
    const successCardProps = {
        title: intl.formatMessage({
            id: "NonprofitPage.resources.success.title.gwp7869",
            defaultMessage: "Social impact team success stories"
        }),
        titleAs: "h3",
        body: intl.formatMessage({
            id: "NonprofitPage.resources.success.body",
            defaultMessage: "Get inspired by teams like yours driving impact with Atlassian apps."
        }),
        image: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kp84so85h055h6o517q02jx1qp42p78.webp",
                alt: "Partners for Nonprofits"
            }
        },
        callToAction: {
            href: (0, $kooLp.useLocalizedHref)("/teams/nonprofits/resources"),
            text: intl.formatMessage({
                id: "NonprofitPage.resources.success.link",
                defaultMessage: "See all use cases"
            })
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1wybzwfg _vwz410mc _k48p9y44 _19pkidpf _2hwxidpf _otyrdlk8 _18u0idpf _y3gn1h6o _1s18ckbl _17gq8vuz _15flidpf _1d2widpf _1svy7vkz _seovidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "NonprofitPage.resources.header.v1",
                    defaultMessage: "Explore resources"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb7vkz _vwz41tcg _k48powjs _19pkidpf _2hwx1wug _otyrgktf _18u01wug _y3gn1h6o _1lzogktf _119z1f4h _j6qubxu3 _lg5ridpf _d97m1wug _1b7eldb6 _12521wug _3p1c1f4h _py5o1ylp _10jx1osq"
                ]),
                children: [
                    isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.resources.subtitle.gwp10027",
                        defaultMessage: "While you wait for your Social Impact License to be approved\u2026"
                    }),
                    !isGwp10027 && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "NonprofitPage.resources.subtitle",
                        defaultMessage: "While you wait for your Community License to be approved\u2026"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "6-6",
                    className: (0, $2jatx.default)([
                        "_3intidpf _4fugidpf _1ynqidpf _1j3nidpf _quu71osq _18zx1h90"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), (0, $6ogO3._)({}, teamCardProps)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), (0, $6ogO3._)({}, successCardProps))
                    ]
                })
            })
        ]
    });
};
$e3ba3f7a269b5999$export$3f0336208d56829f.displayName = "ResourcesSection";

});


parcelRegister("in9in", function(module, exports) {
$parcel$export(module.exports, "TrelloPriceFinder", function () { return $0e2ca0aa8f567d21$export$954e0f4d6ca6524; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");
const $0e2ca0aa8f567d21$export$954e0f4d6ca6524 = (props)=>{
    var _props_pricing_ccpPricingData, _props_pricing;
    const intl = (0, $8e22h.default)();
    const freePlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedCards.title",
                defaultMessage: "Unlimited cards"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.upTo10BoardsPerWorkspace.title",
                defaultMessage: "Up to 10 boards per Workspace"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedPowerUpsPerBoard.title",
                defaultMessage: "Unlimited Power-Ups per board"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedStorage.title.free",
                defaultMessage: "Unlimited storage (10MB/file)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceCommandRuns.title",
                defaultMessage: "250 Workspace command runs per month"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.customBackgroundsAndStickers.title",
                defaultMessage: "Custom backgrounds & stickers"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedActivityLog.title",
                defaultMessage: "Unlimited activity log"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.assigneeAndDueDates.title",
                defaultMessage: "Assignee and due dates"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.mobileApps.title",
                defaultMessage: "iOS and Android mobile apps"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.twoFactorAuthentication.title",
                defaultMessage: "2-factor authentication"
            })
        }
    ];
    const standardPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedBoards.title",
                defaultMessage: "Unlimited boards"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.advancedChecklists.title",
                defaultMessage: "Advanced checklists"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.customFields.title",
                defaultMessage: "Custom Fields"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedStorage.title",
                defaultMessage: "Unlimited storage (250MB/file)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceCommandRuns.title",
                defaultMessage: "1,000 Workspace command runs per month"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.singleBoardGuests.title",
                defaultMessage: "Single board guests"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.savedSearches.title",
                defaultMessage: "Saved searches"
            })
        }
    ];
    const premiumPlanFeatureMessages = [
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.views.title",
                defaultMessage: "Views: Calendar, Timeline, Table, Dashboard, and Map"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceViews.title",
                defaultMessage: "Workspace views: Table and Calendar"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.unlimitedWorkspaceCommandRuns.title",
                defaultMessage: "Unlimited Workspace command runs"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.atlassianIntelligence.title",
                defaultMessage: "Atlassian Intelligence (AI)"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.adminAndSecurityFeatures.title",
                defaultMessage: "Admin and security features"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.workspaceLevelTemplates.title",
                defaultMessage: "Workspace-level templates"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.collections.title",
                defaultMessage: "Collections"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.observers.title",
                defaultMessage: "Observers"
            })
        },
        {
            featureMessage: intl.formatMessage({
                id: "TrelloPricingPage.features.simpleDataExport.title",
                defaultMessage: "Simple data export"
            })
        }
    ];
    const trelloProductPlans = [
        {
            planName: "Free",
            offeringSku: "jira-servicedesk-free",
            recommendationLimit: 0,
            signupLimit: 150000,
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: "Standard",
            offeringSku: "trello-standard-non-profit",
            recommendationLimit: 10,
            signupLimit: 150000,
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: "Premium",
            offeringSku: "trello-premium-non-profit",
            recommendationLimit: 250,
            signupLimit: 150000,
            planFeatureMessages: premiumPlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: "TrelloPricingPage.priceFinder.headerText",
            defaultMessage: "Build Your <blue>Source of Truth</blue>"
        },
        unitCountInputTextRedesign: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTextRedesign",
            defaultMessage: "Team size:"
        },
        unitCountInputTerm: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTerm",
            defaultMessage: "users"
        },
        billingCycleText: {
            id: "ConfluencePricingPage.priceFinder.billingCycleText",
            defaultMessage: "Billing cycle:"
        },
        unitCountInputText: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputText",
            defaultMessage: "How many users are on your team?"
        },
        unitCountInputTooltip: {
            id: "ConfluencePricingPage.priceFinder.unitCountInputTooltip",
            defaultMessage: "A Confluence user is any user who can log in to Confluence, and who exists in User Management"
        },
        monthlyExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.monthlyExampleHelpText",
            defaultMessage: "Monthly plans give you flexibility as your number of active users changes, so pay for seats as you use them. Remember that the number of seats may change the total price."
        },
        annualExampleHelpText: {
            id: "ConfluencePricingPage.priceFinder.annualExampleHelpText",
            defaultMessage: "Annual plans give you flexibility and help you prepare for growth. Buy a group of seats at a flat rate now, then fill your empty seats through the year at no extra cost."
        },
        exampleStandardPlan: {
            id: "ConfluencePricingPage.priceFinder.exampleStandardPlan",
            defaultMessage: "Pricing for {unitCount} users on Standard plan",
            description: "Standard is a plan name and should not be translated"
        },
        cardOverSignupLimit: {
            id: "ConfluencePricingPage.priceFinder.cardOverSignupLimit",
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: "ConfluencePricingPage.priceFinder.cardEnterpriseMinimumCount",
            defaultMessage: "Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above",
            description: "Enterprise is a plan name and should not be translated"
        },
        cardUnitCountTierRange: {
            id: "ConfluencePricingPage.priceFinder.cardUnitCountTierRange",
            defaultMessage: "User tier: {lowerLimit} - {upperLimit}"
        },
        cardMonthlyPerUnitCount: {
            id: "TrelloPricingPage.priceFinder.cardMonthlyPerUnitCount",
            defaultMessage: "per user / month"
        },
        cardFreeDescription: {
            id: "ConfluencePricingPage.priceFinder.cardFreeDescription",
            defaultMessage: "Always free for 10 users"
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            dataProductKey: "trello",
            productPlans: trelloProductPlans,
            defaultUnitCount: 150,
            shouldAddDiscount: props.shouldAddDiscount,
            ctaUrlSource: "productPlans",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: (_props_pricing = props.pricing) === null || _props_pricing === void 0 ? void 0 : (_props_pricing_ccpPricingData = _props_pricing.ccpPricingData) === null || _props_pricing_ccpPricingData === void 0 ? void 0 : _props_pricing_ccpPricingData.trello,
                countryCode: props.countryCode
            })
        })
    });
};
$0e2ca0aa8f567d21$export$954e0f4d6ca6524.displayName = "TrelloPriceFinder";

});




parcelRegister("lfqXN", function(module, exports) {
$parcel$export(module.exports, "TryPage", function () { return $75831ec207552eea$export$609689a2a01efdbc; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("axzLb");
var $blNyO = parcelRequire("blNyO");
const $75831ec207552eea$export$609689a2a01efdbc = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $blNyO.TryPageTemplate), {});

});
parcelRegister("axzLb", function(module, exports) {
$parcel$export(module.exports, "TryPageTemplate", function () { return (parcelRequire("blNyO")).TryPageTemplate; });

var $blNyO = parcelRequire("blNyO");

});
parcelRegister("blNyO", function(module, exports) {
$parcel$export(module.exports, "TryPageTemplate", function () { return $6b6ef2c343dd8dd5$export$86c5cc40b74df40f; });

var $7VQPk = parcelRequire("7VQPk");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $axrSA = parcelRequire("axrSA");

var $km4VI = parcelRequire("km4VI");

var $fPSzg = parcelRequire("fPSzg");

var $gTqUW = parcelRequire("gTqUW");

var $aUlfh = parcelRequire("aUlfh");

var $eLUM2 = parcelRequire("eLUM2");

var $liucL = parcelRequire("liucL");

var $cBRR6 = parcelRequire("cBRR6");
const $6b6ef2c343dd8dd5$export$86c5cc40b74df40f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                    isShowTryNowLink: false,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "try"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aUlfh.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $liucL.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cBRR6.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $km4VI.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $axrSA.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eLUM2.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gTqUW.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fPSzg.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("axrSA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9dc8f62f5e147b0$export$2e2bcd8739ae039; });
/* code-build-ship-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $e9dc8f62f5e147b0$var$sectionCss = null;
const $e9dc8f62f5e147b0$var$CodeBuildShipSection = ()=>{
    const intl = (0, $8e22h.default)();
    const codeBuildShipHeaderText = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.headerText",
        defaultMessage: "Code, Build, & Ship"
    });
    const bitbucketBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.bitbucket.bodyText",
        defaultMessage: "Collaborate on code with inline comments and pull requests. Manage and share your Git repositories to build and ship software, as a team."
    });
    const sourcetreeBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.sourcetree.bodyText",
        defaultMessage: "Harness the full power of Git and Mercurial in a beautifully simple application. Get the free desktop client for Mac and Windows."
    });
    const compassBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.compass.bodyText",
        defaultMessage: "Bring your distributed software architecture and the teams that collaborate on it together in a single, unified place."
    });
    const rovoDevBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.rovoDev.bodyText",
        defaultMessage: "Stay in the flow longer with AI-enabled productivity and quality for the full software delivery lifecycle."
    });
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const downloadNow = intl.formatMessage((0, $8p9Sp.messages).downloadNow);
    const bitbucketLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    });
    const rovoLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "rovodev",
        type: "logo",
        appearance: "brand"
    });
    const sourcetreeLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "sourcetree",
        type: "logo",
        appearance: "brand"
    });
    const compassLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "code-build-ship",
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                    dividerColor: "#ff8b00",
                    headerText: codeBuildShipHeaderText
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: bitbucketLogo,
                        link: (0, $kooLp.useLocalizedHref)("/software/bitbucket/bundle"),
                        bodyText: bitbucketBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: rovoLogo,
                        link: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=devai"),
                        bodyText: rovoDevBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: sourcetreeLogo,
                        link: "https://www.sourcetreeapp.com/",
                        bodyText: sourcetreeBody,
                        ctaText: downloadNow
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: compassLogo,
                        link: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=compass"),
                        bodyText: compassBody,
                        ctaText: tryCloud
                    })
                ]
            })
        ]
    });
};
var $e9dc8f62f5e147b0$export$2e2bcd8739ae039 = $e9dc8f62f5e147b0$var$CodeBuildShipSection;

});
parcelRegister("k8C2X", function(module, exports) {
$parcel$export(module.exports, "TryPageCard", function () { return (parcelRequire("lVutU")).TryPageCard; });
$parcel$export(module.exports, "TryPageHeader", function () { return (parcelRequire("5Dppx")).TryPageHeader; });

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

});
parcelRegister("lVutU", function(module, exports) {
$parcel$export(module.exports, "TryPageCard", function () { return $94c5ed983b086607$export$78a2651bc04a8175; });
/* try-page-card.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fJP6M = parcelRequire("fJP6M");
const $94c5ed983b086607$var$pStyle = null;
const $94c5ed983b086607$var$tryPageCardStyles = null;
const $94c5ed983b086607$var$logoBlockStyles = null;
const $94c5ed983b086607$var$StyledLogo = (logo)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1752zwfg _w8l51wug _4x201osq"
        ]),
        children: logo
    });
};
const $94c5ed983b086607$export$78a2651bc04a8175 = (props)=>{
    const { title: title, logo: logo, link: link, bodyText: bodyText, ctaText: ctaText, buttonColor: buttonColor, buttonType: buttonType } = props;
    const styledLogo = logo && $94c5ed983b086607$var$StyledLogo(logo);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                children: title
            }),
            styledLogo && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: link,
                children: styledLogo
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb1j6v _1pfhgrf3 _6rth1tcg",
                    "tryCardText"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                className: "ctaButton",
                text: ctaText,
                type: buttonType !== null && buttonType !== void 0 ? buttonType : "secondary",
                url: link,
                size: "small",
                color: buttonColor !== null && buttonColor !== void 0 ? buttonColor : "darkblue",
                dataEventProps: {
                    "data-product-key": "try",
                    "data-event-component": "linkButton",
                    "data-event-container": "cardSection",
                    "data-event": "clicked",
                    "data-label": ctaText
                }
            })
        ]
    });
};

});

parcelRegister("5Dppx", function(module, exports) {
$parcel$export(module.exports, "TryPageHeader", function () { return $1e078ab4da7fc99d$export$d30aca31b48239d; });
/* try-page-header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");
const $1e078ab4da7fc99d$export$d30aca31b48239d = (props)=>{
    const { dividerColor: dividerColor, headerText: headerText } = props;
    const headerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4f1d1bqd _z5uk7vkz _1boa7vkz _16itidpf _ad5cidpf _4rmj11ph _16niidpf _1132idpf _19abftgi _edooidpf _rzyb1k8s _1apkdlk8 _1x4qahaf _hkvxdlk8 _sizi1tcg _11o6bmm0 _u25g1y44 _19ed7vkz _pgbz11ux _2z90idpf _1mvaidpf"
        ]),
        style: {
            "--_ei0dq9": (0, $6ZVlx.default)(dividerColor)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
            headerText: headerText,
            headerType: "h2",
            horizontalRule: true
        })
    });
};

});


parcelRegister("8p9Sp", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $2356406d4679fc86$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $2356406d4679fc86$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    tryCloud: {
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    },
    downloadNow: {
        id: "TryPageTemplate.downloadNow",
        defaultMessage: "Download now"
    }
});

});


parcelRegister("km4VI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $820dda0b0a60c7c4$export$2e2bcd8739ae039; });
/* collaborate-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $820dda0b0a60c7c4$var$sectionCss = null;
const $820dda0b0a60c7c4$var$CollaborateSection = ()=>{
    const intl = (0, $8e22h.default)();
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const collaborateTitle = intl.formatMessage({
        id: "TryPageTemplate.collaborate.title",
        defaultMessage: "Collaborate"
    });
    const confluenceBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.confluenceBody",
        defaultMessage: "Get things done instead of hunting things down. Organize your work, create documents, and discuss everything in one place."
    });
    const trelloBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.trelloBody",
        defaultMessage: "Collaborate and get more done. Trello boards enable your team to organize projects in a fun, flexible, and visual way."
    });
    const loomBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.loomBody",
        defaultMessage: "Record your screen, camera, and voice with Loom. Send async video messages on an AI-powered platform."
    });
    const confluenceLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "confluence",
        type: "logo",
        appearance: "brand"
    });
    const trelloLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "trello",
        type: "logo",
        appearance: "brand"
    });
    const loomLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "loom",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "collaborateCards",
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                    headerText: collaborateTitle,
                    dividerColor: (0, $kbpa7.wacToken)("color.primary.blue")
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: confluenceLogo,
                        link: (0, $kooLp.useLocalizedHref)("/software/confluence/free"),
                        bodyText: confluenceBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: trelloLogo,
                        link: "https://www.trello.com/signup",
                        bodyText: trelloBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: loomLogo,
                        link: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium"),
                        bodyText: loomBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
                ]
            })
        ]
    });
};
var $820dda0b0a60c7c4$export$2e2bcd8739ae039 = $820dda0b0a60c7c4$var$CollaborateSection;

});

parcelRegister("fPSzg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da7b5b800f10f760$export$2e2bcd8739ae039; });
/* enterprise-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
const $da7b5b800f10f760$var$sectionCss = null;
const $da7b5b800f10f760$var$headerStyle = null;
const $da7b5b800f10f760$var$lowerCss = null;
const $da7b5b800f10f760$var$imageCss = null;
const $da7b5b800f10f760$var$EnterpriseSection = ()=>{
    const intl = (0, $8e22h.default)();
    const goBigHeader = intl.formatMessage({
        id: "try.enterprise.goBig",
        defaultMessage: "Go big with Atlassian Enterprise"
    });
    const goBigBody = intl.formatMessage({
        id: "try.enterprise.goBigBody",
        defaultMessage: "Connect, accelerate, and scale your entire enterprise with Atlassian enterprise solutions."
    });
    const learnMore = intl.formatMessage({
        id: "try.enterprise.learnMore",
        defaultMessage: "Learn more"
    });
    const cloud = intl.formatMessage({
        id: "try.enterprise.cloud",
        defaultMessage: "Cloud"
    });
    const cloudBody = intl.formatMessage({
        id: "try.enterprise.cloudBody",
        defaultMessage: "Atlassian cloud solutions are equipped with everything large and growing teams need to scale collaboration and workflows seamlessly."
    });
    const dataCenter = intl.formatMessage({
        id: "try.enterprise.dataCenter",
        defaultMessage: "Data Center"
    });
    const dataCenterBody = intl.formatMessage({
        id: "try.enterprise.dataCenterBody",
        defaultMessage: "Host our applications with IaaS vendors like AWS or Azure. Data Center is our self-managed solution for advanced administration at scale."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_syazcd5j _bfhk1ep1 _ca0q12bs _u5f3idpf _n3td12bs _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_l5k1bfng _11ebahaf _2fhk4jg8 _bpspbfng _1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: goBigHeader,
                        headerType: "h2",
                        isCentered: true,
                        bodyText: goBigBody,
                        ctaProps: {
                            buttonProps: {
                                className: "ctaButton",
                                text: learnMore,
                                url: "https://www.atlassian.com/enterprise",
                                type: "primary",
                                color: "lightblue",
                                size: "small"
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0 _x3mzbfng _k48p4jg8 _1o6v1j6v _ggmh1k8s _r8nt4jg8 _1adi12sy _19tboxwj _43ds1ep1 _bna711ux"
                ]),
                style: {
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                            title: cloud,
                            link: (0, $kooLp.useLocalizedHref)("/enterprise/cloud"),
                            bodyText: cloudBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                            title: dataCenter,
                            link: (0, $kooLp.useLocalizedHref)("/enterprise/data-center"),
                            bodyText: dataCenterBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1e0c1txw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp",
                                    alt: intl.formatMessage({
                                        id: "try.enterprise.databaseServer",
                                        defaultMessage: "Data center + server"
                                    })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $da7b5b800f10f760$export$2e2bcd8739ae039 = $da7b5b800f10f760$var$EnterpriseSection;

});

parcelRegister("gTqUW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6eb266b4632978e1$export$2e2bcd8739ae039; });
/* get-the-most-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $NtjLk = parcelRequire("NtjLk");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $6eb266b4632978e1$var$pageSection = null;
const $6eb266b4632978e1$var$sectionCss = null;
const $6eb266b4632978e1$var$headerStyle = null;
const $6eb266b4632978e1$var$cardContainer = null;
const $6eb266b4632978e1$var$GetTheMostSection = ()=>{
    const intl = (0, $8e22h.default)();
    const cardData = [
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceHeaderText",
                defaultMessage: "Tailor to your team\u2019s needs"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceBodyText",
                defaultMessage: "Extend your Atlassian products with thousands of apps from Marketplace."
            }),
            callToAction: {
                href: "https://marketplace.atlassian.com/",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.marketplacePrimaryLink",
                    defaultMessage: "Go to Marketplace"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:76e94ebd-d71e-4991-9008-7b2e838090c8/illustrations-spot-Integrations.svg?cdnVersion=2999"
        },
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityHeaderText",
                defaultMessage: "Train with Atlassian University"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityBodyText",
                defaultMessage: "Develop new skills, improve your team\u2019s work, and advance your professional career."
            }),
            callToAction: {
                href: "https://www.atlassian.com/university",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.universityPrimaryLink",
                    defaultMessage: "Go to Atlassian University"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:a88ae3d8-e6fd-4428-8a14-c9ce6b460b0e/illustrations-spot-Atlassian%20Book_1.svg?cdnVersion=2999"
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1q51xy5q _85i5xncg _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_12l21wug _ahbq1wug _1ul91osq _11rm1hrf _bfhkcd5j _kqswh2mm"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _cg411tj6 _l5k1bfng _1pxq7vkz _ygm1idpf _u6q57vkz _sydsidpf _17z411ph _xztqidpf _ubikidpf _j8iydlk8 _h9g4idpf _1kll1ejb _1g9widpf _1kovidpf _bsriidpf _1qsfidpf _1x1pahaf _12adidpf _1xe1idpf _hcanidpf _nji3idpf _j269ahaf"
                        ]),
                        style: {
                            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "TryPageTemplate.getTheMost.header",
                                defaultMessage: "Get the most out of your products"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "6-6",
                    children: cardData.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1ui68ved"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), (0, $6ogO3._)({}, card))
                        }, index))
                })
            ]
        })
    });
};
var $6eb266b4632978e1$export$2e2bcd8739ae039 = $6eb266b4632978e1$var$GetTheMostSection;

});

parcelRegister("aUlfh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca30ac8f347471af$export$2e2bcd8739ae039; });
/* hero-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("kyJ5Y");
var $3DHNM = parcelRequire("3DHNM");
const $ca30ac8f347471af$var$HeroTryGraphCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.bodyText",
        defaultMessage: "Collaborate seamlessly across cross-functional teams, at scale"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:6f126124-1d52-4017-9078-40df4c78897e/illustrations-spot-Connections.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.imgAltText",
        defaultMessage: "Connections illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$HeroTryLockCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.bodyText",
        defaultMessage: "Built with industry-leading privacy, security, and data control"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:c0c94526-036b-44df-9f0d-cd1e9455d1e2/illustrations-spot-Trust%20and%20Security.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.imgAltText",
        defaultMessage: "Trust and security illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$HeroTryPuzzleCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.bodyText",
        defaultMessage: "Customize your products with 1,000+ apps and integrations"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:3dfc6901-1535-48aa-a25a-870ee1d5ff8e/illustrations-spot-Integration%20Puzzle.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.imgAltText",
        defaultMessage: "Integration puzzle illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$sectionCssOverride = null;
const $ca30ac8f347471af$var$outerContainerCssOverride = null;
const $ca30ac8f347471af$var$HeroSection = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.header",
        defaultMessage: "Try Atlassian apps for free"
    });
    const bodyText = intl.formatMessage({
        id: "TryPageTemplate.hero.bodyText",
        defaultMessage: "Our cloud products empower teams of all types, from startup to enterprise."
    });
    const backgroundProps = {
        bgColor: (0, $kbpa7.wacToken)("color.neutral.light100")
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_cg411tj6 _18oz1wto _1ap71k7u _u8fj1tcg _163midpf _yzu7idpf _1kll14b4 _1qdgidpf _7toc10nf _cjxodlk8 _a5ip1n2x _1f35m24h _ps1ee8xo _z0gn1h6o _p1061k92 _zqtwnl7k _130319ii _10vfidpf _1of01yg0 _1xw61h67 _sz6216xe _3int1gpt _dmb7grf3"
        ]),
        style: {
            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900")),
            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_16qs1cd0 _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3DHNM.ContentBlocksInline), {
                headerText: headerText,
                bodyText: bodyText,
                backgroundProperties: backgroundProps,
                inlineContentBlocks: [
                    $ca30ac8f347471af$var$HeroTryGraphCard(),
                    $ca30ac8f347471af$var$HeroTryLockCard(),
                    $ca30ac8f347471af$var$HeroTryPuzzleCard()
                ]
            })
        })
    });
};
var $ca30ac8f347471af$export$2e2bcd8739ae039 = $ca30ac8f347471af$var$HeroSection;

});
parcelRegister("kyJ5Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3DHNM")).ContentBlocksInline; });

var $3DHNM = parcelRequire("3DHNM");

});
parcelRegister("3DHNM", function(module, exports) {
$parcel$export(module.exports, "ContentBlocksInline", function () { return $4d30ed72f33d6229$export$4fd59a663df2d810; });
/* content-blocks-inline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
const $4d30ed72f33d6229$var$getCardAspectRatio = (length)=>{
    switch(length){
        case 4:
            return "4/3";
        case 3:
            return "4/3";
        case 2:
            return "2/1";
        default:
            return "1/1";
    }
};
const $4d30ed72f33d6229$var$ctaStyle = null;
const $4d30ed72f33d6229$export$4fd59a663df2d810 = ({ headerText: headerText, bodyText: bodyText, backgroundProperties: backgroundProperties, className: className, eyebrowText: eyebrowText, iconName: iconName, linkPosition: linkPosition = "bottom", ctaProps: ctaProps, inlineContentBlocks: inlineContentBlocks })=>{
    if (inlineContentBlocks.length < 2 || inlineContentBlocks.length > 4) throw new Error("Pattern is meant to display between 2 and 4 cards");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.StyledBackground), (0, $dPABA._)((0, $6ogO3._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        iconName: iconName,
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: inlineContentBlocks.map((block, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), (0, $6ogO3._)({
                            aspectRatio: $4d30ed72f33d6229$var$getCardAspectRatio(inlineContentBlocks.length)
                        }, block), index))
                }),
                linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $6ogO3._)({}, ctaProps.primaryLinkProps))
                    })
                }) : null
            ]
        })
    }));
};

});



parcelRegister("eLUM2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eaa008ad72030cec$export$2e2bcd8739ae039; });
/* identity-and-security-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $5Dppx = parcelRequire("5Dppx");

var $lVutU = parcelRequire("lVutU");

var $8p9Sp = parcelRequire("8p9Sp");
const $eaa008ad72030cec$var$sectionStyles = null;
const $eaa008ad72030cec$var$IdentityAndSecuritySection = ()=>{
    const intl = (0, $8e22h.default)();
    const atlassianAccessHeaderText = intl.formatMessage({
        id: "TryPageTemplate.IdentityAndSecurity.title",
        defaultMessage: "Identity & Security"
    });
    const headerProps = {
        headerText: atlassianAccessHeaderText,
        dividerColor: (0, $kbpa7.wacToken)("color.primary.blue")
    };
    const atlassianAccessLink = "https://admin.atlassian.com/";
    const atlassianAccessBodyText = intl.formatMessage({
        id: "TryPageTemplate.identityAndSecurity.atlassianAccessBody",
        defaultMessage: "Gain company-wide visibility, security policies, and control across your Atlassian cloud infrastructure."
    });
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const guardLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    });
    const cardProps = {
        logo: guardLogo,
        link: atlassianAccessLink,
        bodyText: atlassianAccessBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
            name: "identityAndSecurity",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), (0, $6ogO3._)({}, headerProps))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), (0, $6ogO3._)({}, cardProps)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
                    ]
                })
            ]
        })
    });
};
var $eaa008ad72030cec$export$2e2bcd8739ae039 = $eaa008ad72030cec$var$IdentityAndSecuritySection;

});

parcelRegister("liucL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $79af9bea120adf60$export$2e2bcd8739ae039; });
/* plan-and-track.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $79af9bea120adf60$var$sectionStyles = null;
const $79af9bea120adf60$var$PlanAndTrackSection = ()=>{
    const intl = (0, $8e22h.default)();
    const jiraSofttwareHeaderText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.title",
        defaultMessage: "Plan & Track"
    });
    const headerProps = {
        headerText: jiraSofttwareHeaderText,
        dividerColor: (0, $kbpa7.wacToken)("color.primary.blue")
    };
    const jiraSofttwareBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jiraBody",
        defaultMessage: "Friendly and intuitive collaboration for business teams and their projects, built for cross-team coordination and breaking down silos."
    });
    const jiraSofttwareLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const jirProductDiscoveryBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jirProductDiscoveryBody",
        defaultMessage: "Organize and prioritize ideas, share product roadmaps, and connect business and tech teams, all in Jira."
    });
    const jirProductDiscoveryLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const jiraLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
    const jpdLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
    const jiracardProps = {
        logo: jiraLogo,
        link: jiraSofttwareLink,
        bodyText: jiraSofttwareBodyText,
        ctaText: tryCloud
    };
    const jpdcardProps = {
        logo: jpdLogo,
        link: jirProductDiscoveryLink,
        bodyText: jirProductDiscoveryBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qvbgk _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), (0, $6ogO3._)({}, headerProps))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), (0, $6ogO3._)({}, jiracardProps)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), (0, $6ogO3._)({}, jpdcardProps))
                ]
            })
        ]
    });
};
var $79af9bea120adf60$export$2e2bcd8739ae039 = $79af9bea120adf60$var$PlanAndTrackSection;

});

parcelRegister("cBRR6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d8fc6b8f8fde7c6$export$2e2bcd8739ae039; });
/* support-and-fix-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
/* Cards */ const $8d8fc6b8f8fde7c6$var$JsmCard = ()=>{
    const intl = (0, $8e22h.default)();
    const localizedLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-service-management");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.jsmCard.bodyText",
        defaultMessage: "Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast."
    });
    const localizedCtaText = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const jsmLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
        logo: jsmLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $8d8fc6b8f8fde7c6$var$StatusCard = ()=>{
    const intl = (0, $8e22h.default)();
    const localizedLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=statuspage");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.statusCard.bodyText",
        defaultMessage: "Incidents happen. Keep your users informed with fewer support emails during downtime."
    });
    const localizedCtaText = intl.formatMessage({
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    });
    const statusPageLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "statuspage",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
        logo: statusPageLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $8d8fc6b8f8fde7c6$var$sectionStyles = null;
const $8d8fc6b8f8fde7c6$var$SupportAndFixSection = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.headerText",
        defaultMessage: "Support & fix"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "support-and-fix",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                        dividerColor: "#ff8b00",
                        headerText: headerText
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($8d8fc6b8f8fde7c6$var$JsmCard, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($8d8fc6b8f8fde7c6$var$StatusCard, {})
                    ]
                })
            ]
        })
    });
};
var $8d8fc6b8f8fde7c6$export$2e2bcd8739ae039 = $8d8fc6b8f8fde7c6$var$SupportAndFixSection;

});




parcelRegister("czsFN", function(module, exports) {
$parcel$export(module.exports, "UniformConfluencePricingEntryPage", function () { return $2b8dedcd909fa0cd$export$46490ce46aa9f785; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $ea4mV = parcelRequire("ea4mV");

var $67UrT = parcelRequire("67UrT");
const $2b8dedcd909fa0cd$export$46490ce46aa9f785 = (props)=>{
    const [hasFired, fireExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).confluencePricingPageWaeMigration);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), (0, $6ogO3._)({}, props));
};

});

parcelRegister("iWEGU", function(module, exports) {
$parcel$export(module.exports, "UniformJiraPricingEntryPage", function () { return $f9cdabca1169389b$export$bf65523dba15d046; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $ea4mV = parcelRequire("ea4mV");

var $67UrT = parcelRequire("67UrT");
const $f9cdabca1169389b$export$bf65523dba15d046 = (props)=>{
    const [hasFired, fireExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).jiraPricingWaeMigrationExperimentRerunExp);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $67UrT.UniformEntryPage), (0, $6ogO3._)({}, props));
};

});

parcelRegister("2aZDx", function(module, exports) {
$parcel$export(module.exports, "UniformPreviewPage", function () { return $81d123cf08d1936b$export$485017e8654f464d; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("6tMFe");
var $1kAyD = parcelRequire("1kAyD");
const $81d123cf08d1936b$export$485017e8654f464d = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1kAyD.UniformPreviewPageTemplate), {
        composition: composition,
        isUniformPlayground: isUniformPlayground,
        isAllowPostMessage: isAllowPostMessage
    });

});
parcelRegister("6tMFe", function(module, exports) {
$parcel$export(module.exports, "UniformPreviewPageTemplate", function () { return (parcelRequire("1kAyD")).UniformPreviewPageTemplate; });

var $1kAyD = parcelRequire("1kAyD");

});
parcelRegister("1kAyD", function(module, exports) {
$parcel$export(module.exports, "UniformPreviewPageTemplate", function () { return $82214492219a5f40$export$4236df4850175643; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $82214492219a5f40$export$4236df4850175643 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});



parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-24552bb14a";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $be9c067c7be4fda0$var$BASE_URL = "https://www.atlassian.com";
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const page = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "canonical",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${$be9c067c7be4fda0$var$BASE_URL}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                            rel: "alternate",
                            href: `${$be9c067c7be4fda0$var$BASE_URL}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment !== null && $36b5b9e576032b2f$var$clientSideRelayEnvironment !== void 0 ? $36b5b9e576032b2f$var$clientSideRelayEnvironment : $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-24552bb14a";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$BASE_URL = "https://www.atlassian.com";
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${$b6785f1d81c92020$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("b3BH6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80cd36d40705ea74$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1u4In = parcelRequire("1u4In");

var $1oC0p = parcelRequire("1oC0p");

var $fweqv = parcelRequire("fweqv");
var $jn1J7 = parcelRequire("jn1J7");

var $h6fC1 = parcelRequire("h6fC1");

var $7uNuF = parcelRequire("7uNuF");

var $2EpPx = parcelRequire("2EpPx");

function $80cd36d40705ea74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80cd36d40705ea74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80cd36d40705ea74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1u4In.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80cd36d40705ea74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $80cd36d40705ea74$var$packageName = "@atlaskit/blanket";
var $80cd36d40705ea74$var$packageVersion = "15.0.0";
var $80cd36d40705ea74$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $80cd36d40705ea74$var$packageName,
    packageVersion: $80cd36d40705ea74$var$packageVersion
};
var $80cd36d40705ea74$var$baseStyles = null;
var $80cd36d40705ea74$var$shouldAllowClickThroughStyles = null;
var $80cd36d40705ea74$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $80cd36d40705ea74$var$Blanket = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $7uNuF.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $1oC0p.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $h6fC1.usePlatformLeafEventHandler)($80cd36d40705ea74$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $80cd36d40705ea74$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $1oC0p.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $1oC0p.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $1oC0p.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $fweqv.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $jn1J7.default)("var(--ds-blanket, ".concat((0, $2EpPx.N100A), ")"))
        }
    }, children);
}));
$80cd36d40705ea74$var$Blanket.displayName = 'Blanket';
var $80cd36d40705ea74$export$2e2bcd8739ae039 = $80cd36d40705ea74$var$Blanket;

});
parcelRegister("1u4In", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $114c400e295f59b7$export$2e2bcd8739ae039; });

var $7aYGr = parcelRequire("7aYGr");
function $114c400e295f59b7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7aYGr.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("7aYGr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $53988a0f08a8d70f$export$2e2bcd8739ae039; });

var $8UdpZ = parcelRequire("8UdpZ");

var $ikDLj = parcelRequire("ikDLj");
function $53988a0f08a8d70f$export$2e2bcd8739ae039(t) {
    var i = (0, $ikDLj.default)(t, "string");
    return "symbol" == (0, $8UdpZ.default)(i) ? i : i + "";
}

});
parcelRegister("8UdpZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67bdf6479608196d$export$2e2bcd8739ae039; });
function $67bdf6479608196d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $67bdf6479608196d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $67bdf6479608196d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("ikDLj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d588f02eb949127e$export$2e2bcd8739ae039; });

var $8UdpZ = parcelRequire("8UdpZ");
function $d588f02eb949127e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8UdpZ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8UdpZ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("fweqv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b4c508fd21b98f78$export$2e2bcd8739ae039; });
const $b4c508fd21b98f78$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b4c508fd21b98f78$var$ATOMIC_GROUP_LENGTH = 5;
function $b4c508fd21b98f78$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $b4c508fd21b98f78$var$UNDERSCORE_UNICODE ? $b4c508fd21b98f78$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("jn1J7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1a18130895f531e$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e1a18130895f531e$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("h6fC1", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $c72f1b7e8146d730$export$a4687b0234b40e28; });

var $1u4In = parcelRequire("1u4In");

var $1oC0p = parcelRequire("1oC0p");

var $lgfxE = parcelRequire("lgfxE");

var $7X3P7 = parcelRequire("7X3P7");
function $c72f1b7e8146d730$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c72f1b7e8146d730$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c72f1b7e8146d730$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1u4In.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c72f1b7e8146d730$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c72f1b7e8146d730$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $lgfxE.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $7X3P7.useTrackedRef)(analyticsData);
    var fnRef = (0, $7X3P7.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c72f1b7e8146d730$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("lgfxE", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $f7a725d76e55863f$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $acSNb = parcelRequire("acSNb");

var $99avv = parcelRequire("99avv");
function $f7a725d76e55863f$export$5bf35293e545f20c() {
    var analyticsContext = (0, $99avv.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $acSNb.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("acSNb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76e586fe135a990c$export$2e2bcd8739ae039; });

var $dzwPK = parcelRequire("dzwPK");

var $9TeBu = parcelRequire("9TeBu");

var $7uPLP = parcelRequire("7uPLP");

var $1cfV8 = parcelRequire("1cfV8");

var $hNYFu = parcelRequire("hNYFu");

var $ISq0T = parcelRequire("ISq0T");

var $5Wa46 = parcelRequire("5Wa46");

var $1u4In = parcelRequire("1u4In");

var $cEU2a = parcelRequire("cEU2a");
function $76e586fe135a990c$var$_callSuper(t, o, e) {
    return o = (0, $hNYFu.default)(o), (0, $1cfV8.default)(t, $76e586fe135a990c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hNYFu.default)(t).constructor) : o.apply(t, e));
}
function $76e586fe135a990c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($76e586fe135a990c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $76e586fe135a990c$var$_superPropGet(t, o, e, r) {
    var p = (0, $ISq0T.default)((0, $hNYFu.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $76e586fe135a990c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $76e586fe135a990c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $76e586fe135a990c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $9TeBu.default)(this, UIAnalyticsEvent);
        _this = $76e586fe135a990c$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $1u4In.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $1u4In.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $dzwPK.default)(_this.context);
            var handlers = (0, $dzwPK.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $1u4In.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $5Wa46.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $7uPLP.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $76e586fe135a990c$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $cEU2a.default));

});
parcelRegister("dzwPK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9e18034fd9a89193$export$2e2bcd8739ae039; });

var $lbDTd = parcelRequire("lbDTd");

var $gE8Se = parcelRequire("gE8Se");

var $2edQt = parcelRequire("2edQt");

var $fxZzo = parcelRequire("fxZzo");
function $9e18034fd9a89193$export$2e2bcd8739ae039(r) {
    return (0, $lbDTd.default)(r) || (0, $gE8Se.default)(r) || (0, $2edQt.default)(r) || (0, $fxZzo.default)();
}

});
parcelRegister("lbDTd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6c991497046bf37$export$2e2bcd8739ae039; });

var $9Mcx3 = parcelRequire("9Mcx3");
function $f6c991497046bf37$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9Mcx3.default)(r);
}

});
parcelRegister("9Mcx3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $71e2515e2d3b0c89$export$2e2bcd8739ae039; });
function $71e2515e2d3b0c89$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gE8Se", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c1e743ecd1c38c91$export$2e2bcd8739ae039; });
function $c1e743ecd1c38c91$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("2edQt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $19f7a0f3d2ceceb7$export$2e2bcd8739ae039; });

var $9Mcx3 = parcelRequire("9Mcx3");
function $19f7a0f3d2ceceb7$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9Mcx3.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9Mcx3.default)(r, a) : void 0;
    }
}

});

parcelRegister("fxZzo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b519b2905f764272$export$2e2bcd8739ae039; });
function $b519b2905f764272$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9TeBu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7334941e27c6b703$export$2e2bcd8739ae039; });
function $7334941e27c6b703$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7uPLP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $57537e49523bb09b$export$2e2bcd8739ae039; });

var $7aYGr = parcelRequire("7aYGr");
function $57537e49523bb09b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $7aYGr.default)(o.key), o);
    }
}
function $57537e49523bb09b$export$2e2bcd8739ae039(e, r, t) {
    return r && $57537e49523bb09b$var$_defineProperties(e.prototype, r), t && $57537e49523bb09b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("1cfV8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0df342ea878d5ef4$export$2e2bcd8739ae039; });

var $8UdpZ = parcelRequire("8UdpZ");

var $feu3R = parcelRequire("feu3R");
function $0df342ea878d5ef4$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $8UdpZ.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $feu3R.default)(t);
}

});
parcelRegister("feu3R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b16f7b62de24916b$export$2e2bcd8739ae039; });
function $b16f7b62de24916b$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hNYFu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf6612bbd84dbe2a$export$2e2bcd8739ae039; });
function $cf6612bbd84dbe2a$export$2e2bcd8739ae039(t) {
    return $cf6612bbd84dbe2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cf6612bbd84dbe2a$export$2e2bcd8739ae039(t);
}

});

parcelRegister("ISq0T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $086e52920b3b7165$export$2e2bcd8739ae039; });

var $e8yPc = parcelRequire("e8yPc");
function $086e52920b3b7165$export$2e2bcd8739ae039() {
    return $086e52920b3b7165$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $e8yPc.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $086e52920b3b7165$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("e8yPc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4acd381294e2c2e$export$2e2bcd8739ae039; });

var $hNYFu = parcelRequire("hNYFu");
function $a4acd381294e2c2e$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $hNYFu.default)(t)););
    return t;
}

});


parcelRegister("5Wa46", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $452a2d44802a63c7$export$2e2bcd8739ae039; });

var $61u1K = parcelRequire("61u1K");
function $452a2d44802a63c7$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $61u1K.default)(t, e);
}

});
parcelRegister("61u1K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $462a20de3dea5f4b$export$2e2bcd8739ae039; });
function $462a20de3dea5f4b$export$2e2bcd8739ae039(t, e) {
    return $462a20de3dea5f4b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $462a20de3dea5f4b$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("cEU2a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9374af9df9b7fe4f$export$2e2bcd8739ae039; });

var $8UdpZ = parcelRequire("8UdpZ");

var $9TeBu = parcelRequire("9TeBu");

var $7uPLP = parcelRequire("7uPLP");

var $1u4In = parcelRequire("1u4In");
function $9374af9df9b7fe4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9374af9df9b7fe4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9374af9df9b7fe4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1u4In.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9374af9df9b7fe4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9374af9df9b7fe4f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9374af9df9b7fe4f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $9374af9df9b7fe4f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $9TeBu.default)(this, AnalyticsEvent);
        (0, $1u4In.default)(this, "_isAnalyticsEvent", true);
        (0, $1u4In.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9374af9df9b7fe4f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $7uPLP.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $8UdpZ.default)(updater) === 'object') this.payload = $9374af9df9b7fe4f$var$_objectSpread($9374af9df9b7fe4f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("99avv", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $6a8d1ad839b65654$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $6a8d1ad839b65654$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("7X3P7", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $5ca1025a2c9557d8$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $5ca1025a2c9557d8$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("2EpPx", function(module, exports) {
$parcel$export(module.exports, "N100A", function () { return $1ee35a8d7554d885$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1ee35a8d7554d885$export$4b84fd0e2c617bd = '#FFEBE6';
var $1ee35a8d7554d885$export$b34b069eff244586 = '#FFBDAD';
var $1ee35a8d7554d885$export$be802dd0d8b57f35 = '#FF8F73';
var $1ee35a8d7554d885$export$60847d42f9da92a6 = '#FF7452';
var $1ee35a8d7554d885$export$4a7404f376229999 = '#FF5630';
var $1ee35a8d7554d885$export$2010d0fb4295b346 = '#DE350B';
var $1ee35a8d7554d885$export$2837b5a1a71d5c02 = '#BF2600';
var $1ee35a8d7554d885$export$8d9596b529bbb9cf = '#FFFAE6';
var $1ee35a8d7554d885$export$41060a744ab0b7ae = '#FFF0B3';
var $1ee35a8d7554d885$export$1cc05bbbf340e559 = '#FFE380';
var $1ee35a8d7554d885$export$5aae31392d72caaa = '#FFC400';
var $1ee35a8d7554d885$export$c6930421db9fa514 = '#FFAB00';
var $1ee35a8d7554d885$export$59619663aa6500fb = '#FF991F';
var $1ee35a8d7554d885$export$874739ea9e379ab6 = '#FF8B00';
var $1ee35a8d7554d885$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1ee35a8d7554d885$export$69a3bf21b9686c2b = '#ABF5D1';
var $1ee35a8d7554d885$export$afbce1382ec95f73 = '#79F2C0';
var $1ee35a8d7554d885$export$747d86715d4175de = '#57D9A3';
var $1ee35a8d7554d885$export$940e1f69e873f202 = '#36B37E';
var $1ee35a8d7554d885$export$a49394138f7b8e85 = '#00875A';
var $1ee35a8d7554d885$export$6fa04827ac68a4fb = '#006644';
var $1ee35a8d7554d885$export$226de0355ed012f8 = '#DEEBFF';
var $1ee35a8d7554d885$export$8c13c2ee36917869 = '#B3D4FF';
var $1ee35a8d7554d885$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1ee35a8d7554d885$export$215b7063051591f1 = '#2684FF';
var $1ee35a8d7554d885$export$e62e8919cca44969 = '#0065FF';
var $1ee35a8d7554d885$export$b3de0ae08da2ce64 = '#0052CC';
var $1ee35a8d7554d885$export$a6ee3d71bc067634 = '#0747A6';
var $1ee35a8d7554d885$export$67f15409e87642a1 = '#669DF1';
var $1ee35a8d7554d885$export$f0539dbc42dbb067 = '#8FB8F6';
var $1ee35a8d7554d885$export$363e4475840015bb = '#EAE6FF';
var $1ee35a8d7554d885$export$4b0a4417ed59760f = '#C0B6F2';
var $1ee35a8d7554d885$export$6011520a64d9a187 = '#998DD9';
var $1ee35a8d7554d885$export$a7175d4e9206bc80 = '#8777D9';
var $1ee35a8d7554d885$export$b48405b95304b5a1 = '#6554C0';
var $1ee35a8d7554d885$export$c71e4279dd54a18d = '#5243AA';
var $1ee35a8d7554d885$export$147899de772240ec = '#403294';
var $1ee35a8d7554d885$export$2cf711fe14c66f06 = '#E6FCFF';
var $1ee35a8d7554d885$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1ee35a8d7554d885$export$776c9c497ef08533 = '#79E2F2';
var $1ee35a8d7554d885$export$69cb3ca10c1e330e = '#00C7E6';
var $1ee35a8d7554d885$export$9dc1ef0f3f48059b = '#00B8D9';
var $1ee35a8d7554d885$export$7c835c78b6fcdef8 = '#00A3BF';
var $1ee35a8d7554d885$export$6036577f95c3877e = '#008DA6';
var $1ee35a8d7554d885$export$29a4f05edc054374 = '#FFFFFF';
var $1ee35a8d7554d885$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1ee35a8d7554d885$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1ee35a8d7554d885$export$3e51e8f1440314ba = '#EBECF0';
var $1ee35a8d7554d885$export$1ce2d1575d444ceb = '#DFE1E6';
var $1ee35a8d7554d885$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1ee35a8d7554d885$export$c2e91cbeada39b8b = '#B3BAC5';
var $1ee35a8d7554d885$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1ee35a8d7554d885$export$eaa8c8a70ac22806 = '#97A0AF';
var $1ee35a8d7554d885$export$7c87d337fb91a97d = '#8993A4';
var $1ee35a8d7554d885$export$d6447c357493214f = '#7A869A';
var $1ee35a8d7554d885$export$f563ee71e9ee74cd = '#6B778C';
var $1ee35a8d7554d885$export$e2ef2124cf4024b1 = '#5E6C84';
var $1ee35a8d7554d885$export$eece5f492e429f08 = '#505F79';
var $1ee35a8d7554d885$export$c39c0fe0f26207ae = '#42526E';
var $1ee35a8d7554d885$export$7090862dc3038a9f = '#344563';
var $1ee35a8d7554d885$export$ad0bacf983b7ddaa = '#253858';
var $1ee35a8d7554d885$export$7d61b15e0da132af = '#172B4D';
var $1ee35a8d7554d885$export$fbda843f0a27fe96 = '#091E42';
var $1ee35a8d7554d885$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1ee35a8d7554d885$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1ee35a8d7554d885$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1ee35a8d7554d885$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1ee35a8d7554d885$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1ee35a8d7554d885$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1ee35a8d7554d885$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1ee35a8d7554d885$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1ee35a8d7554d885$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1ee35a8d7554d885$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1ee35a8d7554d885$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1ee35a8d7554d885$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1ee35a8d7554d885$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1ee35a8d7554d885$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1ee35a8d7554d885$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1ee35a8d7554d885$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1ee35a8d7554d885$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1ee35a8d7554d885$export$2f6319cf7d736c2a = '#E6EDFA';
var $1ee35a8d7554d885$export$95126bc8884d6634 = '#DCE5F5';
var $1ee35a8d7554d885$export$8338d8c35d44ff1 = '#CED9EB';
var $1ee35a8d7554d885$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1ee35a8d7554d885$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1ee35a8d7554d885$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1ee35a8d7554d885$export$97e81faa16a182c7 = '#8C9CB8';
var $1ee35a8d7554d885$export$bfe21c59123ecf33 = '#7988A3';
var $1ee35a8d7554d885$export$ee82aa2ea6a1558 = '#67758F';
var $1ee35a8d7554d885$export$682927c6ed76be02 = '#56637A';
var $1ee35a8d7554d885$export$91fd9994c5be9757 = '#455166';
var $1ee35a8d7554d885$export$d281fbfe3cff2df6 = '#3B475C';
var $1ee35a8d7554d885$export$3902c91d8b98a753 = '#313D52';
var $1ee35a8d7554d885$export$8e8133c1ba5845b5 = '#283447';
var $1ee35a8d7554d885$export$33ff357f6620b39 = '#202B3D';
var $1ee35a8d7554d885$export$633847cf062b69e0 = '#1B2638';
var $1ee35a8d7554d885$export$9776a6e503bdbf76 = '#121A29';
var $1ee35a8d7554d885$export$6c813d5160dff5db = '#0E1624';
var $1ee35a8d7554d885$export$3d4f271a500072a = '#0D1424';
var $1ee35a8d7554d885$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1ee35a8d7554d885$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1ee35a8d7554d885$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1ee35a8d7554d885$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1ee35a8d7554d885$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1ee35a8d7554d885$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1ee35a8d7554d885$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1ee35a8d7554d885$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1ee35a8d7554d885$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1ee35a8d7554d885$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1ee35a8d7554d885$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1ee35a8d7554d885$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1ee35a8d7554d885$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1ee35a8d7554d885$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1ee35a8d7554d885$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1ee35a8d7554d885$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1ee35a8d7554d885$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1ee35a8d7554d885$export$d2adc5dedf09fced = '#292A2E';
var $1ee35a8d7554d885$export$f51762073d2bb381 = '#94C748';
var $1ee35a8d7554d885$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("beJjp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82e4268c2676c74f$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $h1JRM = parcelRequire("h1JRM");

var $10uW5 = parcelRequire("10uW5");
function $82e4268c2676c74f$export$2e2bcd8739ae039() {
    var intl = $1oC0p.useContext((0, $h1JRM.Context));
    (0, $10uW5.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("h1JRM", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return $c6561bcaf5521620$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $c6561bcaf5521620$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $c6561bcaf5521620$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $6PuZm = parcelRequire("6PuZm");

var $10uW5 = parcelRequire("10uW5");
function $c6561bcaf5521620$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var $c6561bcaf5521620$var$IntlContext = $1oC0p.createContext(null);
var $c6561bcaf5521620$var$IntlConsumer = $c6561bcaf5521620$var$IntlContext.Consumer, $c6561bcaf5521620$var$IntlProvider = $c6561bcaf5521620$var$IntlContext.Provider;
var $c6561bcaf5521620$export$2881499e37b75b9a = $c6561bcaf5521620$var$IntlProvider;
var $c6561bcaf5521620$export$841858b892ce1f4c = $c6561bcaf5521620$var$IntlContext;
function $c6561bcaf5521620$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $1oC0p.createElement($c6561bcaf5521620$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $10uW5.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $1oC0p.createElement(WrappedComponent, (0, $d3IQL.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($c6561bcaf5521620$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))($1oC0p.forwardRef(function(props, ref) {
        return $1oC0p.createElement(WithIntl, (0, $d3IQL.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(WithIntl, WrappedComponent);
}

});
parcelRegister("10uW5", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", function () { return $0bbdc9c184ffc2f9$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $0bbdc9c184ffc2f9$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $0bbdc9c184ffc2f9$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $0bbdc9c184ffc2f9$export$d36bdfa510afb180; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $jcL53 = parcelRequire("jcL53");

var $bceAk = parcelRequire("bceAk");
function $0bbdc9c184ffc2f9$export$45c4bbf6e55bba1f(intl) {
    (0, $jcL53.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $0bbdc9c184ffc2f9$export$b52f8d6fc0d47415 = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $bceAk.DEFAULT_INTL_CONFIG)), {
    textComponent: $1oC0p.Fragment
});
function $0bbdc9c184ffc2f9$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($1oC0p.Children.toArray(parts));
    };
}
function $0bbdc9c184ffc2f9$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("jcL53", function(module, exports) {
$parcel$export(module.exports, "invariant", function () { return $dfb3a87f180174ae$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $dfb3a87f180174ae$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $dfb3a87f180174ae$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $dfb3a87f180174ae$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $dfb3a87f180174ae$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $dfb3a87f180174ae$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $dfb3a87f180174ae$export$3fae2929ed23c202(map, pl, field) {
    return $dfb3a87f180174ae$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $dfb3a87f180174ae$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $dfb3a87f180174ae$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $dfb3a87f180174ae$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $dfb3a87f180174ae$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $dfb3a87f180174ae$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("bceAk", function(module, exports) {
$parcel$export(module.exports, "filterProps", function () { return $826c20f29749be7d$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $826c20f29749be7d$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $826c20f29749be7d$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $826c20f29749be7d$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $826c20f29749be7d$export$4ee1db8ce44a209b; });

var $d3IQL = parcelRequire("d3IQL");

var $gZV6A = parcelRequire("gZV6A");

var $izmPF = parcelRequire("izmPF");

var $iOyCd = parcelRequire("iOyCd");
function $826c20f29749be7d$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $826c20f29749be7d$var$defaultErrorHandler = function(error) {};
var $826c20f29749be7d$var$defaultWarnHandler = function(warning) {};
var $826c20f29749be7d$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $826c20f29749be7d$var$defaultErrorHandler,
    onWarn: $826c20f29749be7d$var$defaultWarnHandler
};
function $826c20f29749be7d$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $826c20f29749be7d$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $826c20f29749be7d$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $826c20f29749be7d$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $izmPF.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $izmPF.strategies).variadic
    });
    var getNumberFormat = (0, $izmPF.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.number),
        strategy: (0, $izmPF.strategies).variadic
    });
    var getPluralRules = (0, $izmPF.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d3IQL.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $izmPF.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $izmPF.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $gZV6A.IntlMessageFormat)(message, locales, overrideFormats, (0, $d3IQL.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.message),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $izmPF.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $izmPF.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.list),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getDisplayNames: (0, $izmPF.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $826c20f29749be7d$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $izmPF.strategies).variadic
        })
    };
}
function $826c20f29749be7d$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $iOyCd.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("gZV6A", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", function () { return $c5fea3c6d4ecc4c4$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $d3IQL = parcelRequire("d3IQL");

var $b87z9 = parcelRequire("b87z9");

var $izmPF = parcelRequire("izmPF");

var $eESD8 = parcelRequire("eESD8");
// -- MessageFormat --------------------------------------------------------
function $c5fea3c6d4ecc4c4$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $c5fea3c6d4ecc4c4$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $c5fea3c6d4ecc4c4$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $d3IQL.__assign)({}, defaultConfig));
}
function $c5fea3c6d4ecc4c4$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $c5fea3c6d4ecc4c4$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $izmPF.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $c5fea3c6d4ecc4c4$var$createFastMemoizeCache(cache.number),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getDateTimeFormat: (0, $izmPF.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $c5fea3c6d4ecc4c4$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $izmPF.strategies).variadic
        }),
        getPluralRules: (0, $izmPF.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d3IQL.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $c5fea3c6d4ecc4c4$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $izmPF.strategies).variadic
        })
    };
}
var $c5fea3c6d4ecc4c4$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $eESD8.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $eESD8.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $c5fea3c6d4ecc4c4$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $c5fea3c6d4ecc4c4$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $b87z9.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("b87z9", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("5oOXy")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("5oOXy")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("5oOXy")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("5oOXy")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("5oOXy")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("5oOXy")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("5oOXy")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("5oOXy")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("5oOXy")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("5oOXy")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("5oOXy")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("5oOXy")).TYPE; });
$parcel$export(module.exports, "parse", function () { return $81a64f7d0df62fc4$export$98e6a39c04603d36; });

var $d3IQL = parcelRequire("d3IQL");

var $esbOz = parcelRequire("esbOz");

var $iMWYU = parcelRequire("iMWYU");

var $5oOXy = parcelRequire("5oOXy");
function $81a64f7d0df62fc4$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $5oOXy.isSelectElement)(el) || (0, $5oOXy.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $81a64f7d0df62fc4$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $5oOXy.isNumberElement)(el) && (0, $5oOXy.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $5oOXy.isDateElement)(el) || (0, $5oOXy.isTimeElement)(el)) && (0, $5oOXy.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $5oOXy.isTagElement)(el)) $81a64f7d0df62fc4$var$pruneLocation(el.children);
    });
}
function $81a64f7d0df62fc4$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $d3IQL.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $iMWYU.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $esbOz.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $81a64f7d0df62fc4$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("esbOz", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", function () { return $a85cd85ea4dbf342$export$896afd8541959ee5; });
var $a85cd85ea4dbf342$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($a85cd85ea4dbf342$export$896afd8541959ee5 || ($a85cd85ea4dbf342$export$896afd8541959ee5 = {}));

});

parcelRegister("iMWYU", function(module, exports) {
$parcel$export(module.exports, "Parser", function () { return $dada76255f2d5a3e$export$7acfa6ed01010e37; });

var $d3IQL = parcelRequire("d3IQL");

var $esbOz = parcelRequire("esbOz");

var $5oOXy = parcelRequire("5oOXy");

var $9h5g7 = parcelRequire("9h5g7");
parcelRequire("2u22g");
var $5SUwH = parcelRequire("5SUwH");
var $hAvEH = parcelRequire("hAvEH");

var $ftRfC = parcelRequire("ftRfC");
var $dada76255f2d5a3e$var$_a;
var $dada76255f2d5a3e$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $9h5g7.SPACE_SEPARATOR_REGEX).source, "*"));
var $dada76255f2d5a3e$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $9h5g7.SPACE_SEPARATOR_REGEX).source, "*$"));
function $dada76255f2d5a3e$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $dada76255f2d5a3e$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $dada76255f2d5a3e$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $dada76255f2d5a3e$var$hasNativeFromEntries = !!Object.fromEntries;
var $dada76255f2d5a3e$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $dada76255f2d5a3e$var$hasTrimStart = !!String.prototype.trimStart;
var $dada76255f2d5a3e$var$hasTrimEnd = !!String.prototype.trimEnd;
var $dada76255f2d5a3e$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $dada76255f2d5a3e$var$isSafeInteger = $dada76255f2d5a3e$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $dada76255f2d5a3e$var$re = $dada76255f2d5a3e$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y = (($dada76255f2d5a3e$var$_a = $dada76255f2d5a3e$var$re.exec('a')) === null || $dada76255f2d5a3e$var$_a === void 0 ? void 0 : $dada76255f2d5a3e$var$_a[0]) === 'a';
} catch (_) {
    $dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $dada76255f2d5a3e$var$startsWith = $dada76255f2d5a3e$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $dada76255f2d5a3e$var$fromCodePoint = $dada76255f2d5a3e$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $dada76255f2d5a3e$var$fromEntries = // native
$dada76255f2d5a3e$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $dada76255f2d5a3e$var$codePointAt = $dada76255f2d5a3e$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $dada76255f2d5a3e$var$trimStart = $dada76255f2d5a3e$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($dada76255f2d5a3e$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $dada76255f2d5a3e$var$trimEnd = $dada76255f2d5a3e$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($dada76255f2d5a3e$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $dada76255f2d5a3e$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $dada76255f2d5a3e$var$matchIdentifierAtIndex;
if ($dada76255f2d5a3e$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $dada76255f2d5a3e$var$IDENTIFIER_PREFIX_RE_1 = $dada76255f2d5a3e$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $dada76255f2d5a3e$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $dada76255f2d5a3e$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $dada76255f2d5a3e$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$dada76255f2d5a3e$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $dada76255f2d5a3e$var$codePointAt(s, index);
        if (c === undefined || $dada76255f2d5a3e$var$_isWhiteSpace(c) || $dada76255f2d5a3e$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $dada76255f2d5a3e$var$fromCodePoint.apply(void 0, match);
};
var $dada76255f2d5a3e$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $5oOXy.TYPE).pound,
                    location: $dada76255f2d5a3e$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $esbOz.ErrorKind).UNMATCHED_CLOSING_TAG, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $dada76255f2d5a3e$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $5oOXy.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$dada76255f2d5a3e$var$_isAlpha(this.char())) return this.error((0, $esbOz.ErrorKind).INVALID_TAG, $dada76255f2d5a3e$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $esbOz.ErrorKind).UNMATCHED_CLOSING_TAG, $dada76255f2d5a3e$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $esbOz.ErrorKind).INVALID_TAG, $dada76255f2d5a3e$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $5oOXy.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $esbOz.ErrorKind).UNCLOSED_TAG, $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $esbOz.ErrorKind).INVALID_TAG, $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $dada76255f2d5a3e$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $dada76255f2d5a3e$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $5oOXy.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$dada76255f2d5a3e$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $dada76255f2d5a3e$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $dada76255f2d5a3e$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $esbOz.ErrorKind).EMPTY_ARGUMENT, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $esbOz.ErrorKind).MALFORMED_ARGUMENT, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $5oOXy.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $esbOz.ErrorKind).MALFORMED_ARGUMENT, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $dada76255f2d5a3e$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $dada76255f2d5a3e$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_TYPE, $dada76255f2d5a3e$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $dada76255f2d5a3e$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_STYLE, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $dada76255f2d5a3e$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $dada76255f2d5a3e$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $dada76255f2d5a3e$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $5oOXy.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $esbOz.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $ftRfC.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $5oOXy.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $5SUwH.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $5oOXy.TYPE).date : (0, $5oOXy.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $5oOXy.TYPE).number : argType === 'date' ? (0, $5oOXy.TYPE).date : (0, $5oOXy.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $esbOz.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $dada76255f2d5a3e$var$createLocation(typeEndPosition_1, (0, $d3IQL.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $esbOz.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $5oOXy.TYPE).select,
                        value: value,
                        options: $dada76255f2d5a3e$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $5oOXy.TYPE).plural,
                        value: value,
                        options: $dada76255f2d5a3e$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $esbOz.ErrorKind).INVALID_ARGUMENT_TYPE, $dada76255f2d5a3e$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $esbOz.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $esbOz.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $dada76255f2d5a3e$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $hAvEH.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $esbOz.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $5oOXy.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $hAvEH.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $esbOz.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $dada76255f2d5a3e$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $esbOz.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $esbOz.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $esbOz.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $dada76255f2d5a3e$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $esbOz.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $esbOz.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $esbOz.ErrorKind).MISSING_OTHER_CLAUSE, $dada76255f2d5a3e$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $dada76255f2d5a3e$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$dada76255f2d5a3e$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $dada76255f2d5a3e$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($dada76255f2d5a3e$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $dada76255f2d5a3e$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $dada76255f2d5a3e$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $dada76255f2d5a3e$var$_isAlphaOrSlash(codepoint) {
    return $dada76255f2d5a3e$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $dada76255f2d5a3e$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $dada76255f2d5a3e$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $dada76255f2d5a3e$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("5oOXy", function(module, exports) {
$parcel$export(module.exports, "TYPE", function () { return $3ee6b927904aff4a$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $3ee6b927904aff4a$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $3ee6b927904aff4a$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $3ee6b927904aff4a$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $3ee6b927904aff4a$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $3ee6b927904aff4a$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $3ee6b927904aff4a$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $3ee6b927904aff4a$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $3ee6b927904aff4a$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $3ee6b927904aff4a$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $3ee6b927904aff4a$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $3ee6b927904aff4a$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $3ee6b927904aff4a$export$7680c41f1a55f4cf; });
var $3ee6b927904aff4a$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($3ee6b927904aff4a$export$b87f371cbc396fcf || ($3ee6b927904aff4a$export$b87f371cbc396fcf = {}));
var $3ee6b927904aff4a$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($3ee6b927904aff4a$export$906452485466fa53 || ($3ee6b927904aff4a$export$906452485466fa53 = {}));
function $3ee6b927904aff4a$export$cfa10c5697238752(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.literal;
}
function $3ee6b927904aff4a$export$4f55724281bdfaf9(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.argument;
}
function $3ee6b927904aff4a$export$e11187b219e191e1(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.number;
}
function $3ee6b927904aff4a$export$32d811605da75f40(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.date;
}
function $3ee6b927904aff4a$export$34ec46f596b1702f(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.time;
}
function $3ee6b927904aff4a$export$dcfe1c11d168b5a1(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.select;
}
function $3ee6b927904aff4a$export$6c796d116f0a4fbc(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.plural;
}
function $3ee6b927904aff4a$export$c0ece297bdd0c082(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.pound;
}
function $3ee6b927904aff4a$export$5c83de34745812b(el) {
    return el.type === $3ee6b927904aff4a$export$b87f371cbc396fcf.tag;
}
function $3ee6b927904aff4a$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $3ee6b927904aff4a$export$906452485466fa53.number);
}
function $3ee6b927904aff4a$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $3ee6b927904aff4a$export$906452485466fa53.dateTime);
}
function $3ee6b927904aff4a$export$f0ac572c1121c662(value) {
    return {
        type: $3ee6b927904aff4a$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $3ee6b927904aff4a$export$425e864b0ba114f1(value, style) {
    return {
        type: $3ee6b927904aff4a$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("9h5g7", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $6c09c7ee5265f9bc$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $6c09c7ee5265f9bc$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $6c09c7ee5265f9bc$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("2u22g", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("5SUwH")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("hAvEH")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("hAvEH")).parseNumberSkeletonFromString; });
parcelRequire("5SUwH");
parcelRequire("hAvEH");

});
parcelRegister("5SUwH", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $448dd7dd3835406f$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $448dd7dd3835406f$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $448dd7dd3835406f$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($448dd7dd3835406f$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("hAvEH", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $ccde5a8ea86912ea$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $ccde5a8ea86912ea$export$47c6f8480bda3e11; });

var $d3IQL = parcelRequire("d3IQL");

var $8rStY = parcelRequire("8rStY");
function $ccde5a8ea86912ea$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8rStY.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $ccde5a8ea86912ea$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $ccde5a8ea86912ea$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $ccde5a8ea86912ea$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $ccde5a8ea86912ea$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $ccde5a8ea86912ea$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $ccde5a8ea86912ea$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($ccde5a8ea86912ea$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $ccde5a8ea86912ea$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $ccde5a8ea86912ea$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$ccde5a8ea86912ea$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $ccde5a8ea86912ea$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $ccde5a8ea86912ea$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $ccde5a8ea86912ea$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $ccde5a8ea86912ea$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, all), $ccde5a8ea86912ea$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, all), $ccde5a8ea86912ea$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($ccde5a8ea86912ea$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($ccde5a8ea86912ea$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($ccde5a8ea86912ea$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($ccde5a8ea86912ea$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), $ccde5a8ea86912ea$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($ccde5a8ea86912ea$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), $ccde5a8ea86912ea$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $ccde5a8ea86912ea$var$parseSign(token.stem);
        if (signOpts) result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $ccde5a8ea86912ea$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("8rStY", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $626b1b6915e59eec$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $626b1b6915e59eec$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("ftRfC", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", function () { return $02e88ffbc49e0d02$export$29c5368be8904d27; });

var $2tWoJ = parcelRequire("2tWoJ");
function $02e88ffbc49e0d02$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $02e88ffbc49e0d02$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $02e88ffbc49e0d02$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $2tWoJ.timeData)[regionTag || ''] || (0, $2tWoJ.timeData)[languageTag || ''] || (0, $2tWoJ.timeData)["".concat(languageTag, "-001")] || (0, $2tWoJ.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("2tWoJ", function(module, exports) {
$parcel$export(module.exports, "timeData", function () { return $1ceb96d4d79f4984$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $1ceb96d4d79f4984$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("izmPF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d84d34ee5b73486e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "strategies", function () { return $d84d34ee5b73486e$export$c5491a8691a23b9e; });
//
// Main
//
function $d84d34ee5b73486e$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $d84d34ee5b73486e$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $d84d34ee5b73486e$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $d84d34ee5b73486e$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $d84d34ee5b73486e$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $d84d34ee5b73486e$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $d84d34ee5b73486e$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d84d34ee5b73486e$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $d84d34ee5b73486e$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $d84d34ee5b73486e$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $d84d34ee5b73486e$var$monadic : $d84d34ee5b73486e$var$variadic;
    return $d84d34ee5b73486e$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $d84d34ee5b73486e$var$strategyVariadic(fn, options) {
    return $d84d34ee5b73486e$var$assemble(fn, this, $d84d34ee5b73486e$var$variadic, options.cache.create(), options.serializer);
}
function $d84d34ee5b73486e$var$strategyMonadic(fn, options) {
    return $d84d34ee5b73486e$var$assemble(fn, this, $d84d34ee5b73486e$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $d84d34ee5b73486e$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $d84d34ee5b73486e$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$d84d34ee5b73486e$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$d84d34ee5b73486e$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $d84d34ee5b73486e$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $d84d34ee5b73486e$var$ObjectWithoutPrototypeCache();
    }
};
var $d84d34ee5b73486e$export$c5491a8691a23b9e = {
    variadic: $d84d34ee5b73486e$var$strategyVariadic,
    monadic: $d84d34ee5b73486e$var$strategyMonadic
};

});

parcelRegister("eESD8", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", function () { return $aabf2d8b7dcd11ca$export$49694c2877b44c57; });
$parcel$export(module.exports, "formatToParts", function () { return $aabf2d8b7dcd11ca$export$275d4a3bb5f66fda; });
parcelRequire("b87z9");
var $5oOXy = parcelRequire("5oOXy");

var $2uKq5 = parcelRequire("2uKq5");
var $aabf2d8b7dcd11ca$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($aabf2d8b7dcd11ca$export$49694c2877b44c57 || ($aabf2d8b7dcd11ca$export$49694c2877b44c57 = {}));
function $aabf2d8b7dcd11ca$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal || part.type !== $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $aabf2d8b7dcd11ca$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $aabf2d8b7dcd11ca$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $5oOXy.isLiteralElement)(els[0])) return [
        {
            type: $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $5oOXy.isLiteralElement)(el)) {
            result.push({
                type: $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $5oOXy.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $2uKq5.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $5oOXy.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal : $aabf2d8b7dcd11ca$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $5oOXy.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $5oOXy.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $5oOXy.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $5oOXy.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$aabf2d8b7dcd11ca$export$df0c12a2d414a163(formatFn)) throw new (0, $2uKq5.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $aabf2d8b7dcd11ca$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $aabf2d8b7dcd11ca$export$49694c2877b44c57.literal : $aabf2d8b7dcd11ca$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $5oOXy.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $2uKq5.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $aabf2d8b7dcd11ca$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $5oOXy.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $2uKq5.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $2uKq5.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $2uKq5.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $aabf2d8b7dcd11ca$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $aabf2d8b7dcd11ca$var$mergeLiteral(result);
}

});
parcelRegister("2uKq5", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", function () { return $1d126419b27d1898$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $1d126419b27d1898$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $1d126419b27d1898$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $1d126419b27d1898$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $1d126419b27d1898$export$8bfc137e4d23fdf0; });

var $d3IQL = parcelRequire("d3IQL");
var $1d126419b27d1898$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($1d126419b27d1898$export$d4e71bc0b80dc0fb || ($1d126419b27d1898$export$d4e71bc0b80dc0fb = {}));
var $1d126419b27d1898$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $1d126419b27d1898$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $1d126419b27d1898$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($1d126419b27d1898$export$7369836851cc1329);
var $1d126419b27d1898$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $1d126419b27d1898$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($1d126419b27d1898$export$7369836851cc1329);
var $1d126419b27d1898$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $1d126419b27d1898$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($1d126419b27d1898$export$7369836851cc1329);

});



parcelRegister("iOyCd", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", function () { return $db27bf64c8264fbb$export$557d6acb76e8a244; });
$parcel$export(module.exports, "IntlError", function () { return $db27bf64c8264fbb$export$c016d36112f6ddf8; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $db27bf64c8264fbb$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $db27bf64c8264fbb$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $db27bf64c8264fbb$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $db27bf64c8264fbb$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $db27bf64c8264fbb$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $db27bf64c8264fbb$export$2ddcb436d0aa3688; });

var $d3IQL = parcelRequire("d3IQL");
var $db27bf64c8264fbb$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($db27bf64c8264fbb$export$557d6acb76e8a244 || ($db27bf64c8264fbb$export$557d6acb76e8a244 = {}));
var $db27bf64c8264fbb$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $db27bf64c8264fbb$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);
var $db27bf64c8264fbb$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($db27bf64c8264fbb$export$e3b7eee1dbc44895);
var $db27bf64c8264fbb$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $db27bf64c8264fbb$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($db27bf64c8264fbb$export$c016d36112f6ddf8);

});





parcelRegister("k0oFl", function(module, exports) {
$parcel$export(module.exports, "defineMessages", function () { return $e906f0e087fc2d17$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $e906f0e087fc2d17$export$747d244ee58120dd; });
$parcel$export(module.exports, "FormattedDate", function () { return $e906f0e087fc2d17$export$40ae3194919d16b; });
$parcel$export(module.exports, "FormattedTime", function () { return $e906f0e087fc2d17$export$5b390a54f8a846f7; });
$parcel$export(module.exports, "FormattedNumber", function () { return $e906f0e087fc2d17$export$db80edc1e6b2f63d; });
$parcel$export(module.exports, "FormattedList", function () { return $e906f0e087fc2d17$export$f52b44e459e6e71d; });
$parcel$export(module.exports, "FormattedDisplayName", function () { return $e906f0e087fc2d17$export$c2336ea5aaab92fa; });
$parcel$export(module.exports, "FormattedDateParts", function () { return $e906f0e087fc2d17$export$7fdc7d2c91ce149b; });
$parcel$export(module.exports, "FormattedTimeParts", function () { return $e906f0e087fc2d17$export$ec35873761676c2a; });
$parcel$export(module.exports, "FormattedDateTimeRange", function () { return (parcelRequire("7Wtkv")).default; });
$parcel$export(module.exports, "FormattedMessage", function () { return (parcelRequire("fzVi0")).default; });
$parcel$export(module.exports, "FormattedPlural", function () { return (parcelRequire("gjSoO")).default; });
$parcel$export(module.exports, "FormattedRelativeTime", function () { return (parcelRequire("KIxfk")).default; });
$parcel$export(module.exports, "IntlContext", function () { return (parcelRequire("h1JRM")).Context; });
$parcel$export(module.exports, "IntlProvider", function () { return (parcelRequire("12z4Z")).default; });
$parcel$export(module.exports, "RawIntlProvider", function () { return (parcelRequire("h1JRM")).Provider; });
$parcel$export(module.exports, "createIntl", function () { return (parcelRequire("12z4Z")).createIntl; });
$parcel$export(module.exports, "injectIntl", function () { return (parcelRequire("h1JRM")).default; });
$parcel$export(module.exports, "useIntl", function () { return (parcelRequire("beJjp")).default; });
$parcel$export(module.exports, "createIntlCache", function () { return (parcelRequire("bceAk")).createIntlCache; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("iOyCd")).UnsupportedFormatterError; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("iOyCd")).InvalidConfigError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("iOyCd")).MissingDataError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("iOyCd")).MessageFormatError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("iOyCd")).MissingTranslationError; });
$parcel$export(module.exports, "ReactIntlErrorCode", function () { return (parcelRequire("iOyCd")).IntlErrorCode; });
$parcel$export(module.exports, "ReactIntlError", function () { return (parcelRequire("iOyCd")).IntlError; });
$parcel$export(module.exports, "FormattedNumberParts", function () { return (parcelRequire("7AgIc")).FormattedNumberParts; });
$parcel$export(module.exports, "FormattedListParts", function () { return (parcelRequire("7AgIc")).FormattedListParts; });

var $7AgIc = parcelRequire("7AgIc");

var $h1JRM = parcelRequire("h1JRM");

var $beJjp = parcelRequire("beJjp");

var $12z4Z = parcelRequire("12z4Z");

var $KIxfk = parcelRequire("KIxfk");

var $gjSoO = parcelRequire("gjSoO");

var $fzVi0 = parcelRequire("fzVi0");

var $7Wtkv = parcelRequire("7Wtkv");

var $bceAk = parcelRequire("bceAk");
var $iOyCd = parcelRequire("iOyCd");
function $e906f0e087fc2d17$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $e906f0e087fc2d17$export$747d244ee58120dd(msg) {
    return msg;
}
var $e906f0e087fc2d17$export$40ae3194919d16b = (0, $7AgIc.createFormattedComponent)('formatDate');
var $e906f0e087fc2d17$export$5b390a54f8a846f7 = (0, $7AgIc.createFormattedComponent)('formatTime');
var $e906f0e087fc2d17$export$db80edc1e6b2f63d = (0, $7AgIc.createFormattedComponent)('formatNumber');
var $e906f0e087fc2d17$export$f52b44e459e6e71d = (0, $7AgIc.createFormattedComponent)('formatList');
var $e906f0e087fc2d17$export$c2336ea5aaab92fa = (0, $7AgIc.createFormattedComponent)('formatDisplayName');
var $e906f0e087fc2d17$export$7fdc7d2c91ce149b = (0, $7AgIc.createFormattedDateTimePartsComponent)('formatDate');
var $e906f0e087fc2d17$export$ec35873761676c2a = (0, $7AgIc.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("7AgIc", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", function () { return $5858dbd7db7f5104$export$54d4989ed3eea1ea; });
$parcel$export(module.exports, "FormattedListParts", function () { return $5858dbd7db7f5104$export$5ac259c7da6d2188; });
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $5858dbd7db7f5104$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $5858dbd7db7f5104$export$b37e14176d001dec; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");
var $5858dbd7db7f5104$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($5858dbd7db7f5104$var$DisplayName || ($5858dbd7db7f5104$var$DisplayName = {}));
var $5858dbd7db7f5104$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($5858dbd7db7f5104$var$DisplayNameParts || ($5858dbd7db7f5104$var$DisplayNameParts = {}));
var $5858dbd7db7f5104$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $beJjp.default)();
    var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$5858dbd7db7f5104$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $5858dbd7db7f5104$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $beJjp.default)();
    var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$5858dbd7db7f5104$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $5858dbd7db7f5104$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $beJjp.default)();
        var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $5858dbd7db7f5104$var$DisplayNameParts[name];
    return ComponentParts;
}
function $5858dbd7db7f5104$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $beJjp.default)();
        var value = props.value, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $1oC0p.Fragment;
        return $1oC0p.createElement(Text, null, formattedValue);
    };
    Component.displayName = $5858dbd7db7f5104$var$DisplayName[name];
    return Component;
}

});

parcelRegister("12z4Z", function(module, exports) {
$parcel$export(module.exports, "createIntl", function () { return $0c2130649a45a50f$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $0c2130649a45a50f$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $h1JRM = parcelRequire("h1JRM");

var $10uW5 = parcelRequire("10uW5");

var $ejHIf = parcelRequire("ejHIf");
var $bceAk = parcelRequire("bceAk");
var $8xwAh = parcelRequire("8xwAh");

var $iGW1r = parcelRequire("iGW1r");
function $0c2130649a45a50f$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $0c2130649a45a50f$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $iGW1r.isFormatXMLElementFn)(v) ? (0, $10uW5.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $0c2130649a45a50f$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $0c2130649a45a50f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $8xwAh.formatMessage).apply(void 0, (0, $d3IQL.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $1oC0p.Children.toArray(chunks);
    return chunks;
};
var $0c2130649a45a50f$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $d3IQL.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $0c2130649a45a50f$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $ejHIf.createIntl)((0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $10uW5.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, coreIntl), {
        formatMessage: $0c2130649a45a50f$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $0c2130649a45a50f$var$IntlProvider = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $bceAk.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $0c2130649a45a50f$export$7e4cbedfdd7b4c0d($0c2130649a45a50f$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $0c2130649a45a50f$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $0c2130649a45a50f$var$processIntlConfig(props);
        if (!(0, $10uW5.shallowEqual)(prevConfig, config)) return {
            intl: $0c2130649a45a50f$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $10uW5.invariantIntlContext)(this.state.intl);
        return $1oC0p.createElement((0, $h1JRM.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $10uW5.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($1oC0p.PureComponent);
var $0c2130649a45a50f$export$2e2bcd8739ae039 = $0c2130649a45a50f$var$IntlProvider;

});
parcelRegister("ejHIf", function(module, exports) {
$parcel$export(module.exports, "createIntl", function () { return $a6c4bf779f33db77$export$7e4cbedfdd7b4c0d; });

var $d3IQL = parcelRequire("d3IQL");

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");

var $1hBA4 = parcelRequire("1hBA4");

var $9UY0v = parcelRequire("9UY0v");

var $bqzDh = parcelRequire("bqzDh");

var $4jINt = parcelRequire("4jINt");

var $8xwAh = parcelRequire("8xwAh");

var $byRFS = parcelRequire("byRFS");

var $lFUbz = parcelRequire("lFUbz");
function $a6c4bf779f33db77$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $a6c4bf779f33db77$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $a6c4bf779f33db77$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $a6c4bf779f33db77$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $bceAk.createFormatters)(cache);
    var resolvedConfig = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, (0, $bceAk.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $iOyCd.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iOyCd.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iOyCd.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $a6c4bf779f33db77$var$verifyConfigMessages(resolvedConfig);
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $1hBA4.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $1hBA4.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $9UY0v.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $bqzDh.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $bqzDh.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $bqzDh.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $bqzDh.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $bqzDh.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $4jINt.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $8xwAh.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $8xwAh.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $byRFS.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $byRFS.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $lFUbz.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("1hBA4", function(module, exports) {
$parcel$export(module.exports, "formatNumber", function () { return $0ef487b7adb3469a$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $0ef487b7adb3469a$export$6871080848f10b2f; });

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");
var $0ef487b7adb3469a$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $0ef487b7adb3469a$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $bceAk.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $bceAk.filterProps)(options, $0ef487b7adb3469a$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $0ef487b7adb3469a$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $0ef487b7adb3469a$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $0ef487b7adb3469a$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $0ef487b7adb3469a$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

});

parcelRegister("9UY0v", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", function () { return $7387e42b3d207a7d$export$b4ea3b48dcf921f6; });

var $bceAk = parcelRequire("bceAk");

var $2uKq5 = parcelRequire("2uKq5");

var $iOyCd = parcelRequire("iOyCd");
var $7387e42b3d207a7d$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $7387e42b3d207a7d$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $bceAk.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $bceAk.filterProps)(options, $7387e42b3d207a7d$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $7387e42b3d207a7d$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $2uKq5.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $2uKq5.ErrorCode).MISSING_INTL_API));
    try {
        return $7387e42b3d207a7d$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("bqzDh", function(module, exports) {
$parcel$export(module.exports, "formatDate", function () { return $0225a42e9031fb7c$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $0225a42e9031fb7c$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $0225a42e9031fb7c$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $0225a42e9031fb7c$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $0225a42e9031fb7c$export$af6e5d7a5c73edeb; });

var $d3IQL = parcelRequire("d3IQL");

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");
var $0225a42e9031fb7c$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $0225a42e9031fb7c$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $bceAk.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $bceAk.filterProps)(options, $0225a42e9031fb7c$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $0225a42e9031fb7c$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $0225a42e9031fb7c$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $0225a42e9031fb7c$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $bceAk.filterProps)(options, $0225a42e9031fb7c$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $0225a42e9031fb7c$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $0225a42e9031fb7c$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $0225a42e9031fb7c$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

});

parcelRegister("4jINt", function(module, exports) {
$parcel$export(module.exports, "formatPlural", function () { return $324baf7f24daad9e$export$bbbd05c900f3568d; });

var $bceAk = parcelRequire("bceAk");

var $iOyCd = parcelRequire("iOyCd");

var $2uKq5 = parcelRequire("2uKq5");
var $324baf7f24daad9e$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $324baf7f24daad9e$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $2uKq5.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $2uKq5.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bceAk.filterProps)(options, $324baf7f24daad9e$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $iOyCd.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("8xwAh", function(module, exports) {
$parcel$export(module.exports, "formatMessage", function () { return $637aae58a9d9b0c5$export$25868d1e8e76735f; });

var $d3IQL = parcelRequire("d3IQL");

var $jcL53 = parcelRequire("jcL53");

var $gZV6A = parcelRequire("gZV6A");

var $iOyCd = parcelRequire("iOyCd");
parcelRequire("b87z9");
var $5oOXy = parcelRequire("5oOXy");
function $637aae58a9d9b0c5$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $d3IQL.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $637aae58a9d9b0c5$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $637aae58a9d9b0c5$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $gZV6A.IntlMessageFormat).formats;
    return (0, $d3IQL.__assign)((0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, mfFormats), f1), {
        date: $637aae58a9d9b0c5$var$deepMergeOptions($637aae58a9d9b0c5$var$setTimeZoneInOptions(mfFormats.date, timeZone), $637aae58a9d9b0c5$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $637aae58a9d9b0c5$var$deepMergeOptions($637aae58a9d9b0c5$var$setTimeZoneInOptions(mfFormats.time, timeZone), $637aae58a9d9b0c5$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $637aae58a9d9b0c5$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $jcL53.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $5oOXy.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, defaultRichTextElements), values || {});
    formats = $637aae58a9d9b0c5$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $637aae58a9d9b0c5$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $iOyCd.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $iOyCd.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $d3IQL.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iOyCd.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iOyCd.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}

});

parcelRegister("byRFS", function(module, exports) {
$parcel$export(module.exports, "formatList", function () { return $86ac814d64764510$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $86ac814d64764510$export$6f284aad1934db69; });

var $d3IQL = parcelRequire("d3IQL");

var $bceAk = parcelRequire("bceAk");

var $2uKq5 = parcelRequire("2uKq5");

var $iOyCd = parcelRequire("iOyCd");
var $86ac814d64764510$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $86ac814d64764510$var$now = Date.now();
function $86ac814d64764510$var$generateToken(i) {
    return "".concat($86ac814d64764510$var$now, "_").concat(i, "_").concat($86ac814d64764510$var$now);
}
function $86ac814d64764510$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $86ac814d64764510$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $86ac814d64764510$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $2uKq5.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $2uKq5.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bceAk.filterProps)(options, $86ac814d64764510$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $86ac814d64764510$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $d3IQL.__assign)((0, $d3IQL.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("lFUbz", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", function () { return $fc7902a0b5e79427$export$62fe1a4d9e891fa2; });

var $bceAk = parcelRequire("bceAk");

var $2uKq5 = parcelRequire("2uKq5");

var $iOyCd = parcelRequire("iOyCd");
var $fc7902a0b5e79427$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $fc7902a0b5e79427$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $2uKq5.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $2uKq5.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bceAk.filterProps)(options, $fc7902a0b5e79427$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $iOyCd.IntlError)((0, $iOyCd.IntlErrorCode).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

});


parcelRegister("iGW1r", function(module, exports) {
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $d9b9283dc19a27d2$export$df0c12a2d414a163; });
parcelRequire("b87z9");
var $5oOXy = parcelRequire("5oOXy");

var $8k7qN = parcelRequire("8k7qN");
var $d9b9283dc19a27d2$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($d9b9283dc19a27d2$export$49694c2877b44c57 || ($d9b9283dc19a27d2$export$49694c2877b44c57 = {}));
function $d9b9283dc19a27d2$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $d9b9283dc19a27d2$export$49694c2877b44c57.literal || part.type !== $d9b9283dc19a27d2$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $d9b9283dc19a27d2$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $d9b9283dc19a27d2$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $5oOXy.isLiteralElement)(els[0])) return [
        {
            type: $d9b9283dc19a27d2$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $5oOXy.isLiteralElement)(el)) {
            result.push({
                type: $d9b9283dc19a27d2$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $5oOXy.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $d9b9283dc19a27d2$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $8k7qN.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $5oOXy.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $d9b9283dc19a27d2$export$49694c2877b44c57.literal : $d9b9283dc19a27d2$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $5oOXy.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $5oOXy.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $d9b9283dc19a27d2$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $5oOXy.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $d9b9283dc19a27d2$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $5oOXy.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $d9b9283dc19a27d2$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $5oOXy.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$d9b9283dc19a27d2$export$df0c12a2d414a163(formatFn)) throw new (0, $8k7qN.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $d9b9283dc19a27d2$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $d9b9283dc19a27d2$export$49694c2877b44c57.literal : $d9b9283dc19a27d2$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $5oOXy.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $8k7qN.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d9b9283dc19a27d2$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $5oOXy.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $8k7qN.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $8k7qN.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $8k7qN.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d9b9283dc19a27d2$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $d9b9283dc19a27d2$var$mergeLiteral(result);
}

});
parcelRegister("8k7qN", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", function () { return $01905aa800c8a152$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $01905aa800c8a152$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $01905aa800c8a152$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $01905aa800c8a152$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $01905aa800c8a152$export$8bfc137e4d23fdf0; });

var $d3IQL = parcelRequire("d3IQL");
var $01905aa800c8a152$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($01905aa800c8a152$export$d4e71bc0b80dc0fb || ($01905aa800c8a152$export$d4e71bc0b80dc0fb = {}));
var $01905aa800c8a152$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $01905aa800c8a152$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $01905aa800c8a152$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($01905aa800c8a152$export$7369836851cc1329);
var $01905aa800c8a152$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $01905aa800c8a152$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($01905aa800c8a152$export$7369836851cc1329);
var $01905aa800c8a152$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $d3IQL.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $01905aa800c8a152$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($01905aa800c8a152$export$7369836851cc1329);

});



parcelRegister("KIxfk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $08c6d7c2ef6b7128$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $jcL53 = parcelRequire("jcL53");

var $beJjp = parcelRequire("beJjp");
var $08c6d7c2ef6b7128$var$MINUTE = 60;
var $08c6d7c2ef6b7128$var$HOUR = 3600;
var $08c6d7c2ef6b7128$var$DAY = 86400;
function $08c6d7c2ef6b7128$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $08c6d7c2ef6b7128$var$MINUTE) return 'second';
    if (absValue < $08c6d7c2ef6b7128$var$HOUR) return 'minute';
    if (absValue < $08c6d7c2ef6b7128$var$DAY) return 'hour';
    return 'day';
}
function $08c6d7c2ef6b7128$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $08c6d7c2ef6b7128$var$MINUTE;
        case 'hour':
            return $08c6d7c2ef6b7128$var$HOUR;
        default:
            return $08c6d7c2ef6b7128$var$DAY;
    }
}
function $08c6d7c2ef6b7128$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $08c6d7c2ef6b7128$var$MINUTE;
        default:
            return value * $08c6d7c2ef6b7128$var$HOUR;
    }
}
var $08c6d7c2ef6b7128$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $08c6d7c2ef6b7128$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $08c6d7c2ef6b7128$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $08c6d7c2ef6b7128$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $beJjp.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $d3IQL.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $1oC0p.createElement(Text, null, formattedRelativeTime);
    return $1oC0p.createElement($1oC0p.Fragment, null, formattedRelativeTime);
};
var $08c6d7c2ef6b7128$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $d3IQL.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $jcL53.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $08c6d7c2ef6b7128$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _b = $1oC0p.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $1oC0p.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $1oC0p.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($08c6d7c2ef6b7128$var$canIncrement(unit) ? $08c6d7c2ef6b7128$var$valueToSeconds(value, unit) : 0);
    }
    $1oC0p.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$08c6d7c2ef6b7128$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $08c6d7c2ef6b7128$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $08c6d7c2ef6b7128$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($08c6d7c2ef6b7128$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $08c6d7c2ef6b7128$var$selectUnit(currentValueInSeconds);
        var unitDuration = $08c6d7c2ef6b7128$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $1oC0p.createElement($08c6d7c2ef6b7128$var$SimpleFormattedRelativeTime, (0, $d3IQL.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$08c6d7c2ef6b7128$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
$08c6d7c2ef6b7128$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: 'second'
};
var $08c6d7c2ef6b7128$export$2e2bcd8739ae039 = $08c6d7c2ef6b7128$var$FormattedRelativeTime;

});

parcelRegister("gjSoO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be189e42a8b00fba$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");
var $be189e42a8b00fba$var$FormattedPlural = function(props) {
    var _a = (0, $beJjp.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $1oC0p.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$be189e42a8b00fba$var$FormattedPlural.defaultProps = {
    type: 'cardinal'
};
$be189e42a8b00fba$var$FormattedPlural.displayName = 'FormattedPlural';
var $be189e42a8b00fba$export$2e2bcd8739ae039 = $be189e42a8b00fba$var$FormattedPlural;

});

parcelRegister("fzVi0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b576905bdf724f70$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");

var $10uW5 = parcelRequire("10uW5");
function $b576905bdf724f70$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $d3IQL.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $d3IQL.__rest)(nextProps, [
        "values"
    ]);
    return (0, $10uW5.shallowEqual)(nextValues, values) && (0, $10uW5.shallowEqual)(otherProps, nextOtherProps);
}
function $b576905bdf724f70$var$FormattedMessage(props) {
    var intl = (0, $beJjp.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $1oC0p.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $1oC0p.createElement(Component, null, $1oC0p.Children.toArray(nodes));
    return $1oC0p.createElement($1oC0p.Fragment, null, nodes);
}
$b576905bdf724f70$var$FormattedMessage.displayName = 'FormattedMessage';
var $b576905bdf724f70$var$MemoizedFormattedMessage = $1oC0p.memo($b576905bdf724f70$var$FormattedMessage, $b576905bdf724f70$var$areEqual);
$b576905bdf724f70$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $b576905bdf724f70$export$2e2bcd8739ae039 = $b576905bdf724f70$var$MemoizedFormattedMessage;

});

parcelRegister("7Wtkv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c84b37497f6eba3$export$2e2bcd8739ae039; });

var $d3IQL = parcelRequire("d3IQL");

var $1oC0p = parcelRequire("1oC0p");

var $beJjp = parcelRequire("beJjp");
var $5c84b37497f6eba3$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $beJjp.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $d3IQL.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $1oC0p.Fragment;
    return $1oC0p.createElement(Text, null, formattedValue);
};
$5c84b37497f6eba3$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $5c84b37497f6eba3$export$2e2bcd8739ae039 = $5c84b37497f6eba3$var$FormattedDateTimeRange;

});


parcelRegister("j9BEl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df1c100df26f3bb5$export$2e2bcd8739ae039; });

var $kFuqb = parcelRequire("kFuqb");

var $3oV3g = parcelRequire("3oV3g");

var $7t0tI = parcelRequire("7t0tI");
var $df1c100df26f3bb5$var$_process$env;
var $df1c100df26f3bb5$var$ExportedAnalyticsContext;
if (typeof $7t0tI !== 'undefined' && $7t0tI !== null && ($df1c100df26f3bb5$var$_process$env = {}, true) && $df1c100df26f3bb5$var$_process$env !== void 0 && $df1c100df26f3bb5$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']) $df1c100df26f3bb5$var$ExportedAnalyticsContext = (0, $3oV3g.default);
else $df1c100df26f3bb5$var$ExportedAnalyticsContext = (0, $kFuqb.default);
var $df1c100df26f3bb5$export$2e2bcd8739ae039 = $df1c100df26f3bb5$var$ExportedAnalyticsContext;

});
parcelRegister("kFuqb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0bf3c0a01f39e80$export$2e2bcd8739ae039; });

var $9GFoj = parcelRequire("9GFoj");

var $1itsa = parcelRequire("1itsa");

var $4A0Tr = parcelRequire("4A0Tr");

var $i1kpm = parcelRequire("i1kpm");

var $jfDAi = parcelRequire("jfDAi");

var $djanu = parcelRequire("djanu");

var $gc1Dl = parcelRequire("gc1Dl");

var $9c1Qf = parcelRequire("9c1Qf");

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $bEiDG = parcelRequire("bEiDG");
function $f0bf3c0a01f39e80$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f0bf3c0a01f39e80$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $gc1Dl.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gc1Dl.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $djanu.default)(this, result);
    };
}
function $f0bf3c0a01f39e80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f0bf3c0a01f39e80$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func
};
var $f0bf3c0a01f39e80$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f0bf3c0a01f39e80$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, $jfDAi.default)(AnalyticsContext, _Component);
    var _super = $f0bf3c0a01f39e80$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, $1itsa.default)(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla;
            return [].concat((0, $9GFoj.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $9c1Qf.default)((0, $i1kpm.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $4A0Tr.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $1oC0p.Component));
(0, $9c1Qf.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "contextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
(0, $9c1Qf.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "childContextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
var $f0bf3c0a01f39e80$export$2e2bcd8739ae039 = $f0bf3c0a01f39e80$var$AnalyticsContext;

});

parcelRegister("3oV3g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $279fde3eadf46ed4$export$2e2bcd8739ae039; });

var $9GFoj = parcelRequire("9GFoj");

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");

var $e1T86 = parcelRequire("e1T86");

var $j10Ql = parcelRequire("j10Ql");
var $279fde3eadf46ed4$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $j10Ql.useTrackedRef)(data);
    var analyticsContext = (0, $e1T86.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $1oC0p.useCallback)(function() {
        return [].concat((0, $9GFoj.default)(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
        value: value
    }, children);
};
var $279fde3eadf46ed4$export$2e2bcd8739ae039 = $279fde3eadf46ed4$var$AnalyticsContext;

});


parcelRegister("dmRJm", function(module, exports) {

var $kIM6T = parcelRequire("kIM6T");

var $l80hK = parcelRequire("l80hK");
/** Used to compose bitmasks for value comparisons. */ var $9bb70234e0ba2b91$var$COMPARE_PARTIAL_FLAG = 1, $9bb70234e0ba2b91$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $9bb70234e0ba2b91$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $kIM6T;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $l80hK(srcValue, objValue, $9bb70234e0ba2b91$var$COMPARE_PARTIAL_FLAG | $9bb70234e0ba2b91$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $9bb70234e0ba2b91$var$baseIsMatch;

});
parcelRegister("kIM6T", function(module, exports) {

var $eDehO = parcelRequire("eDehO");

var $3zPSM = parcelRequire("3zPSM");

var $lUcgp = parcelRequire("lUcgp");

var $kguP2 = parcelRequire("kguP2");

var $fy2QK = parcelRequire("fy2QK");

var $all0A = parcelRequire("all0A");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f15d3c6271cf3ba4$var$Stack(entries) {
    var data = this.__data__ = new $eDehO(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$f15d3c6271cf3ba4$var$Stack.prototype.clear = $3zPSM;
$f15d3c6271cf3ba4$var$Stack.prototype['delete'] = $lUcgp;
$f15d3c6271cf3ba4$var$Stack.prototype.get = $kguP2;
$f15d3c6271cf3ba4$var$Stack.prototype.has = $fy2QK;
$f15d3c6271cf3ba4$var$Stack.prototype.set = $all0A;
module.exports = $f15d3c6271cf3ba4$var$Stack;

});
parcelRegister("3zPSM", function(module, exports) {

var $eDehO = parcelRequire("eDehO");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $29ace2c6d3207ea0$var$stackClear() {
    this.__data__ = new $eDehO;
    this.size = 0;
}
module.exports = $29ace2c6d3207ea0$var$stackClear;

});

parcelRegister("lUcgp", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff28573e0b4321e0$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $ff28573e0b4321e0$var$stackDelete;

});

parcelRegister("kguP2", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ec0d35f1384f2d1d$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $ec0d35f1384f2d1d$var$stackGet;

});

parcelRegister("fy2QK", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b51c3de59d2ccb15$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $b51c3de59d2ccb15$var$stackHas;

});

parcelRegister("all0A", function(module, exports) {

var $eDehO = parcelRequire("eDehO");

var $8IbLS = parcelRequire("8IbLS");

var $jCpAW = parcelRequire("jCpAW");
/** Used as the size to enable large array optimizations. */ var $787c2968852d0c5a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $787c2968852d0c5a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $eDehO) {
        var pairs = data.__data__;
        if (!$8IbLS || pairs.length < $787c2968852d0c5a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $jCpAW(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $787c2968852d0c5a$var$stackSet;

});


parcelRegister("l80hK", function(module, exports) {

var $7hoil = parcelRequire("7hoil");

var $lhaWD = parcelRequire("lhaWD");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f61a90f977b56423$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$lhaWD(value) && !$lhaWD(other)) return value !== value && other !== other;
    return $7hoil(value, other, bitmask, customizer, $f61a90f977b56423$var$baseIsEqual, stack);
}
module.exports = $f61a90f977b56423$var$baseIsEqual;

});
parcelRegister("7hoil", function(module, exports) {

var $kIM6T = parcelRequire("kIM6T");

var $3KkwK = parcelRequire("3KkwK");

var $cPBh3 = parcelRequire("cPBh3");

var $l3vrq = parcelRequire("l3vrq");

var $fMIy0 = parcelRequire("fMIy0");

var $lPKNl = parcelRequire("lPKNl");

var $jGQxx = parcelRequire("jGQxx");

var $zh0e0 = parcelRequire("zh0e0");
/** Used to compose bitmasks for value comparisons. */ var $54ccf76346e2988e$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $54ccf76346e2988e$var$argsTag = '[object Arguments]', $54ccf76346e2988e$var$arrayTag = '[object Array]', $54ccf76346e2988e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $54ccf76346e2988e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $54ccf76346e2988e$var$hasOwnProperty = $54ccf76346e2988e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $54ccf76346e2988e$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $lPKNl(object), othIsArr = $lPKNl(other), objTag = objIsArr ? $54ccf76346e2988e$var$arrayTag : $fMIy0(object), othTag = othIsArr ? $54ccf76346e2988e$var$arrayTag : $fMIy0(other);
    objTag = objTag == $54ccf76346e2988e$var$argsTag ? $54ccf76346e2988e$var$objectTag : objTag;
    othTag = othTag == $54ccf76346e2988e$var$argsTag ? $54ccf76346e2988e$var$objectTag : othTag;
    var objIsObj = objTag == $54ccf76346e2988e$var$objectTag, othIsObj = othTag == $54ccf76346e2988e$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $jGQxx(object)) {
        if (!$jGQxx(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $kIM6T);
        return objIsArr || $zh0e0(object) ? $3KkwK(object, other, bitmask, customizer, equalFunc, stack) : $cPBh3(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $54ccf76346e2988e$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $54ccf76346e2988e$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $54ccf76346e2988e$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $kIM6T);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $kIM6T);
    return $l3vrq(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $54ccf76346e2988e$var$baseIsEqualDeep;

});
parcelRegister("3KkwK", function(module, exports) {

var $fTwME = parcelRequire("fTwME");

var $4PN4h = parcelRequire("4PN4h");

var $ivYUA = parcelRequire("ivYUA");
/** Used to compose bitmasks for value comparisons. */ var $2ba597420d1278c2$var$COMPARE_PARTIAL_FLAG = 1, $2ba597420d1278c2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $2ba597420d1278c2$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2ba597420d1278c2$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $2ba597420d1278c2$var$COMPARE_UNORDERED_FLAG ? new $fTwME : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$4PN4h(other, function(othValue, othIndex) {
                if (!$ivYUA(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $2ba597420d1278c2$var$equalArrays;

});
parcelRegister("fTwME", function(module, exports) {

var $jCpAW = parcelRequire("jCpAW");

var $2oKKn = parcelRequire("2oKKn");

var $5Mfmc = parcelRequire("5Mfmc");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $b9256c387fc9b567$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $jCpAW;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$b9256c387fc9b567$var$SetCache.prototype.add = $b9256c387fc9b567$var$SetCache.prototype.push = $2oKKn;
$b9256c387fc9b567$var$SetCache.prototype.has = $5Mfmc;
module.exports = $b9256c387fc9b567$var$SetCache;

});
parcelRegister("2oKKn", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $1bf215ab674fc9e3$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $1bf215ab674fc9e3$var$setCacheAdd(value) {
    this.__data__.set(value, $1bf215ab674fc9e3$var$HASH_UNDEFINED);
    return this;
}
module.exports = $1bf215ab674fc9e3$var$setCacheAdd;

});

parcelRegister("5Mfmc", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $434d5905c0e2d285$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $434d5905c0e2d285$var$setCacheHas;

});


parcelRegister("4PN4h", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $3851fcc04e846b4d$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $3851fcc04e846b4d$var$arraySome;

});

parcelRegister("ivYUA", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d7aa5f0be688545e$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $d7aa5f0be688545e$var$cacheHas;

});


parcelRegister("cPBh3", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $gEINE = parcelRequire("gEINE");

var $8tfJP = parcelRequire("8tfJP");

var $3KkwK = parcelRequire("3KkwK");

var $jFnRj = parcelRequire("jFnRj");

var $6ANrX = parcelRequire("6ANrX");
/** Used to compose bitmasks for value comparisons. */ var $957729547d2447c0$var$COMPARE_PARTIAL_FLAG = 1, $957729547d2447c0$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $957729547d2447c0$var$boolTag = '[object Boolean]', $957729547d2447c0$var$dateTag = '[object Date]', $957729547d2447c0$var$errorTag = '[object Error]', $957729547d2447c0$var$mapTag = '[object Map]', $957729547d2447c0$var$numberTag = '[object Number]', $957729547d2447c0$var$regexpTag = '[object RegExp]', $957729547d2447c0$var$setTag = '[object Set]', $957729547d2447c0$var$stringTag = '[object String]', $957729547d2447c0$var$symbolTag = '[object Symbol]';
var $957729547d2447c0$var$arrayBufferTag = '[object ArrayBuffer]', $957729547d2447c0$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $957729547d2447c0$var$symbolProto = $3MHuE ? $3MHuE.prototype : undefined, $957729547d2447c0$var$symbolValueOf = $957729547d2447c0$var$symbolProto ? $957729547d2447c0$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $957729547d2447c0$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $957729547d2447c0$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $957729547d2447c0$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $gEINE(object), new $gEINE(other))) return false;
            return true;
        case $957729547d2447c0$var$boolTag:
        case $957729547d2447c0$var$dateTag:
        case $957729547d2447c0$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $8tfJP(+object, +other);
        case $957729547d2447c0$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $957729547d2447c0$var$regexpTag:
        case $957729547d2447c0$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $957729547d2447c0$var$mapTag:
            var convert = $jFnRj;
        case $957729547d2447c0$var$setTag:
            var isPartial = bitmask & $957729547d2447c0$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $6ANrX);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $957729547d2447c0$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $3KkwK(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $957729547d2447c0$var$symbolTag:
            if ($957729547d2447c0$var$symbolValueOf) return $957729547d2447c0$var$symbolValueOf.call(object) == $957729547d2447c0$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $957729547d2447c0$var$equalByTag;

});
parcelRegister("gEINE", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Built-in value references. */ var $c203221415f41931$var$Uint8Array = $bBiRC.Uint8Array;
module.exports = $c203221415f41931$var$Uint8Array;

});

parcelRegister("jFnRj", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $e5145a8e0f796a13$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $e5145a8e0f796a13$var$mapToArray;

});

parcelRegister("6ANrX", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $4ccc7696483f6c7a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $4ccc7696483f6c7a$var$setToArray;

});


parcelRegister("l3vrq", function(module, exports) {

var $lk7RV = parcelRequire("lk7RV");
/** Used to compose bitmasks for value comparisons. */ var $f5424466c6ee4aa5$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f5424466c6ee4aa5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f5424466c6ee4aa5$var$hasOwnProperty = $f5424466c6ee4aa5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f5424466c6ee4aa5$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f5424466c6ee4aa5$var$COMPARE_PARTIAL_FLAG, objProps = $lk7RV(object), objLength = objProps.length, othProps = $lk7RV(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f5424466c6ee4aa5$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $f5424466c6ee4aa5$var$equalObjects;

});
parcelRegister("lk7RV", function(module, exports) {

var $3eEUA = parcelRequire("3eEUA");

var $dgk1F = parcelRequire("dgk1F");

var $lrU6c = parcelRequire("lrU6c");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f86191c8c7318196$var$getAllKeys(object) {
    return $3eEUA(object, $lrU6c, $dgk1F);
}
module.exports = $f86191c8c7318196$var$getAllKeys;

});
parcelRegister("3eEUA", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $lPKNl = parcelRequire("lPKNl");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $25b26a18cffa7dd2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $lPKNl(object) ? result : $4jLK2(result, symbolsFunc(object));
}
module.exports = $25b26a18cffa7dd2$var$baseGetAllKeys;

});
parcelRegister("4jLK2", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $324df84505b66cc8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $324df84505b66cc8$var$arrayPush;

});


parcelRegister("dgk1F", function(module, exports) {

var $eRDHU = parcelRequire("eRDHU");

var $hJ191 = parcelRequire("hJ191");
/** Used for built-in method references. */ var $9a7c4daf90bb6692$var$objectProto = Object.prototype;
/** Built-in value references. */ var $9a7c4daf90bb6692$var$propertyIsEnumerable = $9a7c4daf90bb6692$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9a7c4daf90bb6692$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $9a7c4daf90bb6692$var$getSymbols = !$9a7c4daf90bb6692$var$nativeGetSymbols ? $hJ191 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $eRDHU($9a7c4daf90bb6692$var$nativeGetSymbols(object), function(symbol) {
        return $9a7c4daf90bb6692$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $9a7c4daf90bb6692$var$getSymbols;

});
parcelRegister("eRDHU", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ad24d0fa01a20a72$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $ad24d0fa01a20a72$var$arrayFilter;

});

parcelRegister("hJ191", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $ce7786e945828a84$var$stubArray() {
    return [];
}
module.exports = $ce7786e945828a84$var$stubArray;

});




parcelRegister("fMIy0", function(module, exports) {

var $4w1PP = parcelRequire("4w1PP");

var $8IbLS = parcelRequire("8IbLS");

var $9R3rT = parcelRequire("9R3rT");

var $2a3F6 = parcelRequire("2a3F6");

var $614Hw = parcelRequire("614Hw");

var $2EKmr = parcelRequire("2EKmr");

var $j0oFE = parcelRequire("j0oFE");
/** `Object#toString` result references. */ var $b7dde4eb65678917$var$mapTag = '[object Map]', $b7dde4eb65678917$var$objectTag = '[object Object]', $b7dde4eb65678917$var$promiseTag = '[object Promise]', $b7dde4eb65678917$var$setTag = '[object Set]', $b7dde4eb65678917$var$weakMapTag = '[object WeakMap]';
var $b7dde4eb65678917$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $b7dde4eb65678917$var$dataViewCtorString = $j0oFE($4w1PP), $b7dde4eb65678917$var$mapCtorString = $j0oFE($8IbLS), $b7dde4eb65678917$var$promiseCtorString = $j0oFE($9R3rT), $b7dde4eb65678917$var$setCtorString = $j0oFE($2a3F6), $b7dde4eb65678917$var$weakMapCtorString = $j0oFE($614Hw);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b7dde4eb65678917$var$getTag = $2EKmr;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($4w1PP && $b7dde4eb65678917$var$getTag(new $4w1PP(new ArrayBuffer(1))) != $b7dde4eb65678917$var$dataViewTag || $8IbLS && $b7dde4eb65678917$var$getTag(new $8IbLS) != $b7dde4eb65678917$var$mapTag || $9R3rT && $b7dde4eb65678917$var$getTag($9R3rT.resolve()) != $b7dde4eb65678917$var$promiseTag || $2a3F6 && $b7dde4eb65678917$var$getTag(new $2a3F6) != $b7dde4eb65678917$var$setTag || $614Hw && $b7dde4eb65678917$var$getTag(new $614Hw) != $b7dde4eb65678917$var$weakMapTag) $b7dde4eb65678917$var$getTag = function(value) {
    var result = $2EKmr(value), Ctor = result == $b7dde4eb65678917$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $j0oFE(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $b7dde4eb65678917$var$dataViewCtorString:
            return $b7dde4eb65678917$var$dataViewTag;
        case $b7dde4eb65678917$var$mapCtorString:
            return $b7dde4eb65678917$var$mapTag;
        case $b7dde4eb65678917$var$promiseCtorString:
            return $b7dde4eb65678917$var$promiseTag;
        case $b7dde4eb65678917$var$setCtorString:
            return $b7dde4eb65678917$var$setTag;
        case $b7dde4eb65678917$var$weakMapCtorString:
            return $b7dde4eb65678917$var$weakMapTag;
    }
    return result;
};
module.exports = $b7dde4eb65678917$var$getTag;

});
parcelRegister("4w1PP", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $349b92f9a7fb06f9$var$DataView = $4jmfA($bBiRC, 'DataView');
module.exports = $349b92f9a7fb06f9$var$DataView;

});

parcelRegister("9R3rT", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $72cbbd2d95e590d9$var$Promise = $4jmfA($bBiRC, 'Promise');
module.exports = $72cbbd2d95e590d9$var$Promise;

});

parcelRegister("2a3F6", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $192f5b1ee45264ad$var$Set = $4jmfA($bBiRC, 'Set');
module.exports = $192f5b1ee45264ad$var$Set;

});

parcelRegister("614Hw", function(module, exports) {

var $4jmfA = parcelRequire("4jmfA");

var $bBiRC = parcelRequire("bBiRC");
/* Built-in method references that are verified to be native. */ var $46167b9446278235$var$WeakMap = $4jmfA($bBiRC, 'WeakMap');
module.exports = $46167b9446278235$var$WeakMap;

});





parcelRegister("8flHN", function(module, exports) {

var $3rDfs = parcelRequire("3rDfs");

var $lrU6c = parcelRequire("lrU6c");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $018ca77a74e285a1$var$getMatchData(object) {
    var result = $lrU6c(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $3rDfs(value)
        ];
    }
    return result;
}
module.exports = $018ca77a74e285a1$var$getMatchData;

});
parcelRegister("3rDfs", function(module, exports) {

var $ih96c = parcelRequire("ih96c");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $282256a21dad6a21$var$isStrictComparable(value) {
    return value === value && !$ih96c(value);
}
module.exports = $282256a21dad6a21$var$isStrictComparable;

});


parcelRegister("hQkBB", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $cfd746d1bf871dc9$export$64d6499adf9b2e51; });

var $lRA4b = parcelRequire("lRA4b");
function $cfd746d1bf871dc9$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $lRA4b.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("lRA4b", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $feaa86424f980873$export$ce553301d55c2fd8; });
$parcel$export(module.exports, "COMMERCIAL", function () { return $feaa86424f980873$export$f005e2e9f707cb5f; });
$parcel$export(module.exports, "FEDRAMP_FEDEX", function () { return $feaa86424f980873$export$bd6b5a7802d76127; });
$parcel$export(module.exports, "STAGING", function () { return $feaa86424f980873$export$a739cd5aac835909; });
$parcel$export(module.exports, "PRODUCTION", function () { return $feaa86424f980873$export$42dd0cdd351a4a9; });
$parcel$export(module.exports, "DEV", function () { return $feaa86424f980873$export$404582bc18fe4d9e; });
var $feaa86424f980873$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $feaa86424f980873$export$f005e2e9f707cb5f = 'commercial';
var $feaa86424f980873$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $feaa86424f980873$export$a739cd5aac835909 = 'stg';
var $feaa86424f980873$export$42dd0cdd351a4a9 = 'prod';
var $feaa86424f980873$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("1wCKu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $11c6d65546a19ba3$export$2e2bcd8739ae039; });

var $6XQNN = parcelRequire("6XQNN");
function $11c6d65546a19ba3$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $11c6d65546a19ba3$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $11c6d65546a19ba3$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($11c6d65546a19ba3$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $11c6d65546a19ba3$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($11c6d65546a19ba3$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $6XQNN.default)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $11c6d65546a19ba3$var$getOptions(options);
    return $11c6d65546a19ba3$var$defaultBehavior((0, $6XQNN.default)(target, computeOptions), computeOptions.behavior);
}
var $11c6d65546a19ba3$export$2e2bcd8739ae039 = $11c6d65546a19ba3$var$scrollIntoView;

});
parcelRegister("6XQNN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5121362796a3b437$export$2e2bcd8739ae039; });
function $5121362796a3b437$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $5121362796a3b437$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $5121362796a3b437$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $5121362796a3b437$var$e(r.overflowY, n) || $5121362796a3b437$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $5121362796a3b437$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $5121362796a3b437$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$5121362796a3b437$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $5121362796a3b437$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $5121362796a3b437$var$n(m) && !$5121362796a3b437$var$n(document.documentElement) || null != m && $5121362796a3b437$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $5121362796a3b437$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $5121362796a3b437$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $5121362796a3b437$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $5121362796a3b437$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};

});


parcelRegister("8Buwy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6LNID = parcelRequire("6LNID");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $643974dad75ce7e5$var$_interopRequireDefault($6LNID).default;
    }
});
function $643974dad75ce7e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("6LNID", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4eddb301d974f51f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1gsc7 = parcelRequire("1gsc7");

var $gUjjH = parcelRequire("gUjjH");
function $4eddb301d974f51f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4eddb301d974f51f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4eddb301d974f51f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $4eddb301d974f51f$var$NodeResolver = function(_Component) {
    $4eddb301d974f51f$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $4eddb301d974f51f$var$_classCallCheck(this, NodeResolver);
        return $4eddb301d974f51f$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $4eddb301d974f51f$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $gUjjH.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($1gsc7.Component);
module.exports.default = $4eddb301d974f51f$var$NodeResolver;

});
parcelRegister("1gsc7", function(module, exports) {
'use strict';

module.exports = (parcelRequire("89Qvd"));

});
parcelRegister("89Qvd", function(module, exports) {
$parcel$export(module.exports, "Children", function () { return $5f07e3e6ae9098b0$export$dca3b0875bd9a954; }, function (v) { return $5f07e3e6ae9098b0$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5f07e3e6ae9098b0$export$16fa2f45be04daa8; }, function (v) { return $5f07e3e6ae9098b0$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5f07e3e6ae9098b0$export$ffb0004e005737fa; }, function (v) { return $5f07e3e6ae9098b0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $5f07e3e6ae9098b0$export$e2c29f18771995cb; }, function (v) { return $5f07e3e6ae9098b0$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5f07e3e6ae9098b0$export$221d75b3f55bb0bd; }, function (v) { return $5f07e3e6ae9098b0$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5f07e3e6ae9098b0$export$5f8d39834fd61797; }, function (v) { return $5f07e3e6ae9098b0$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5f07e3e6ae9098b0$export$74bf444e3cd11ea5; }, function (v) { return $5f07e3e6ae9098b0$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5f07e3e6ae9098b0$export$ae55be85d98224ed; }, function (v) { return $5f07e3e6ae9098b0$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5f07e3e6ae9098b0$export$e530037191fcd5d7; }, function (v) { return $5f07e3e6ae9098b0$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5f07e3e6ae9098b0$export$fd42f52fd3ae1109; }, function (v) { return $5f07e3e6ae9098b0$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5f07e3e6ae9098b0$export$c8a8987d4410bf2d; }, function (v) { return $5f07e3e6ae9098b0$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $5f07e3e6ae9098b0$export$d38cd72104c1f0e9; }, function (v) { return $5f07e3e6ae9098b0$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $5f07e3e6ae9098b0$export$7d1e3a5e95ceca43; }, function (v) { return $5f07e3e6ae9098b0$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5f07e3e6ae9098b0$export$257a8862b851cb5b; }, function (v) { return $5f07e3e6ae9098b0$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5f07e3e6ae9098b0$export$a8257692ac88316c; }, function (v) { return $5f07e3e6ae9098b0$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5f07e3e6ae9098b0$export$488013bae63b21da; }, function (v) { return $5f07e3e6ae9098b0$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5f07e3e6ae9098b0$export$7c73462e0d25e514; }, function (v) { return $5f07e3e6ae9098b0$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $5f07e3e6ae9098b0$export$7568632d0d33d16d; }, function (v) { return $5f07e3e6ae9098b0$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $5f07e3e6ae9098b0$export$88948ce120ea2619; }, function (v) { return $5f07e3e6ae9098b0$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5f07e3e6ae9098b0$export$35808ee640e87ca7; }, function (v) { return $5f07e3e6ae9098b0$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5f07e3e6ae9098b0$export$fae74005e78b1a27; }, function (v) { return $5f07e3e6ae9098b0$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5f07e3e6ae9098b0$export$dc8fbce3eb94dc1e; }, function (v) { return $5f07e3e6ae9098b0$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $5f07e3e6ae9098b0$export$6a7bc4e911dc01cf; }, function (v) { return $5f07e3e6ae9098b0$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $5f07e3e6ae9098b0$export$6d9c69b0de29b591; }, function (v) { return $5f07e3e6ae9098b0$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $5f07e3e6ae9098b0$export$f680877a34711e37; }, function (v) { return $5f07e3e6ae9098b0$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5f07e3e6ae9098b0$export$d5a552a76deda3c2; }, function (v) { return $5f07e3e6ae9098b0$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $5f07e3e6ae9098b0$export$aaabe4eda9ed9969; }, function (v) { return $5f07e3e6ae9098b0$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5f07e3e6ae9098b0$export$e5c5a5f917a5871c; }, function (v) { return $5f07e3e6ae9098b0$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5f07e3e6ae9098b0$export$1538c33de8887b59; }, function (v) { return $5f07e3e6ae9098b0$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $5f07e3e6ae9098b0$export$13e3392192263954; }, function (v) { return $5f07e3e6ae9098b0$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5f07e3e6ae9098b0$export$b8f5890fc79d6aca; }, function (v) { return $5f07e3e6ae9098b0$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5f07e3e6ae9098b0$export$60241385465d0a34; }, function (v) { return $5f07e3e6ae9098b0$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $5f07e3e6ae9098b0$export$306c0aa65ff9ec16; }, function (v) { return $5f07e3e6ae9098b0$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $5f07e3e6ae9098b0$export$7b286972b8d8ccbf; }, function (v) { return $5f07e3e6ae9098b0$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $5f07e3e6ae9098b0$export$83d89fbfd8236492; }, function (v) { return $5f07e3e6ae9098b0$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5f07e3e6ae9098b0$export$dca3b0875bd9a954;
var $5f07e3e6ae9098b0$export$16fa2f45be04daa8;
var $5f07e3e6ae9098b0$export$ffb0004e005737fa;
var $5f07e3e6ae9098b0$export$e2c29f18771995cb;
var $5f07e3e6ae9098b0$export$221d75b3f55bb0bd;
var $5f07e3e6ae9098b0$export$5f8d39834fd61797;
var $5f07e3e6ae9098b0$export$74bf444e3cd11ea5;
var $5f07e3e6ae9098b0$export$ae55be85d98224ed;
var $5f07e3e6ae9098b0$export$e530037191fcd5d7;
var $5f07e3e6ae9098b0$export$fd42f52fd3ae1109;
var $5f07e3e6ae9098b0$export$c8a8987d4410bf2d;
var $5f07e3e6ae9098b0$export$d38cd72104c1f0e9;
var $5f07e3e6ae9098b0$export$7d1e3a5e95ceca43;
var $5f07e3e6ae9098b0$export$257a8862b851cb5b;
var $5f07e3e6ae9098b0$export$a8257692ac88316c;
var $5f07e3e6ae9098b0$export$488013bae63b21da;
var $5f07e3e6ae9098b0$export$7c73462e0d25e514;
var $5f07e3e6ae9098b0$export$7568632d0d33d16d;
var $5f07e3e6ae9098b0$export$88948ce120ea2619;
var $5f07e3e6ae9098b0$export$35808ee640e87ca7;
var $5f07e3e6ae9098b0$export$fae74005e78b1a27;
var $5f07e3e6ae9098b0$export$dc8fbce3eb94dc1e;
var $5f07e3e6ae9098b0$export$6a7bc4e911dc01cf;
var $5f07e3e6ae9098b0$export$6d9c69b0de29b591;
var $5f07e3e6ae9098b0$export$f680877a34711e37;
var $5f07e3e6ae9098b0$export$d5a552a76deda3c2;
var $5f07e3e6ae9098b0$export$aaabe4eda9ed9969;
var $5f07e3e6ae9098b0$export$e5c5a5f917a5871c;
var $5f07e3e6ae9098b0$export$1538c33de8887b59;
var $5f07e3e6ae9098b0$export$13e3392192263954;
var $5f07e3e6ae9098b0$export$b8f5890fc79d6aca;
var $5f07e3e6ae9098b0$export$60241385465d0a34;
var $5f07e3e6ae9098b0$export$306c0aa65ff9ec16;
var $5f07e3e6ae9098b0$export$7b286972b8d8ccbf;
var $5f07e3e6ae9098b0$export$83d89fbfd8236492;
'use strict';
var $5f07e3e6ae9098b0$var$l = Symbol.for("react.element"), $5f07e3e6ae9098b0$var$n = Symbol.for("react.portal"), $5f07e3e6ae9098b0$var$p = Symbol.for("react.fragment"), $5f07e3e6ae9098b0$var$q = Symbol.for("react.strict_mode"), $5f07e3e6ae9098b0$var$r = Symbol.for("react.profiler"), $5f07e3e6ae9098b0$var$t = Symbol.for("react.provider"), $5f07e3e6ae9098b0$var$u = Symbol.for("react.context"), $5f07e3e6ae9098b0$var$v = Symbol.for("react.forward_ref"), $5f07e3e6ae9098b0$var$w = Symbol.for("react.suspense"), $5f07e3e6ae9098b0$var$x = Symbol.for("react.memo"), $5f07e3e6ae9098b0$var$y = Symbol.for("react.lazy"), $5f07e3e6ae9098b0$var$z = Symbol.iterator;
function $5f07e3e6ae9098b0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5f07e3e6ae9098b0$var$z && a[$5f07e3e6ae9098b0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5f07e3e6ae9098b0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5f07e3e6ae9098b0$var$C = Object.assign, $5f07e3e6ae9098b0$var$D = {};
function $5f07e3e6ae9098b0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5f07e3e6ae9098b0$var$D;
    this.updater = e || $5f07e3e6ae9098b0$var$B;
}
$5f07e3e6ae9098b0$var$E.prototype.isReactComponent = {};
$5f07e3e6ae9098b0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5f07e3e6ae9098b0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5f07e3e6ae9098b0$var$F() {}
$5f07e3e6ae9098b0$var$F.prototype = $5f07e3e6ae9098b0$var$E.prototype;
function $5f07e3e6ae9098b0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5f07e3e6ae9098b0$var$D;
    this.updater = e || $5f07e3e6ae9098b0$var$B;
}
var $5f07e3e6ae9098b0$var$H = $5f07e3e6ae9098b0$var$G.prototype = new $5f07e3e6ae9098b0$var$F;
$5f07e3e6ae9098b0$var$H.constructor = $5f07e3e6ae9098b0$var$G;
$5f07e3e6ae9098b0$var$C($5f07e3e6ae9098b0$var$H, $5f07e3e6ae9098b0$var$E.prototype);
$5f07e3e6ae9098b0$var$H.isPureReactComponent = !0;
var $5f07e3e6ae9098b0$var$I = Array.isArray, $5f07e3e6ae9098b0$var$J = Object.prototype.hasOwnProperty, $5f07e3e6ae9098b0$var$K = {
    current: null
}, $5f07e3e6ae9098b0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5f07e3e6ae9098b0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5f07e3e6ae9098b0$var$J.call(b, d) && !$5f07e3e6ae9098b0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $5f07e3e6ae9098b0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $5f07e3e6ae9098b0$var$K.current
    };
}
function $5f07e3e6ae9098b0$var$N(a, b) {
    return {
        $$typeof: $5f07e3e6ae9098b0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5f07e3e6ae9098b0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5f07e3e6ae9098b0$var$l;
}
function $5f07e3e6ae9098b0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5f07e3e6ae9098b0$var$P = /\/+/g;
function $5f07e3e6ae9098b0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5f07e3e6ae9098b0$var$escape("" + a.key) : b.toString(36);
}
function $5f07e3e6ae9098b0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5f07e3e6ae9098b0$var$l:
                case $5f07e3e6ae9098b0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $5f07e3e6ae9098b0$var$Q(h, 0) : d, $5f07e3e6ae9098b0$var$I(c) ? (e = "", null != a && (e = a.replace($5f07e3e6ae9098b0$var$P, "$&/") + "/"), $5f07e3e6ae9098b0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($5f07e3e6ae9098b0$var$O(c) && (c = $5f07e3e6ae9098b0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($5f07e3e6ae9098b0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($5f07e3e6ae9098b0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $5f07e3e6ae9098b0$var$Q(k, g);
        h += $5f07e3e6ae9098b0$var$R(k, b, e, f, c);
    }
    else if (f = $5f07e3e6ae9098b0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $5f07e3e6ae9098b0$var$Q(k, g++), h += $5f07e3e6ae9098b0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $5f07e3e6ae9098b0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $5f07e3e6ae9098b0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $5f07e3e6ae9098b0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $5f07e3e6ae9098b0$var$U = {
    current: null
}, $5f07e3e6ae9098b0$var$V = {
    transition: null
}, $5f07e3e6ae9098b0$var$W = {
    ReactCurrentDispatcher: $5f07e3e6ae9098b0$var$U,
    ReactCurrentBatchConfig: $5f07e3e6ae9098b0$var$V,
    ReactCurrentOwner: $5f07e3e6ae9098b0$var$K
};
$5f07e3e6ae9098b0$export$dca3b0875bd9a954 = {
    map: $5f07e3e6ae9098b0$var$S,
    forEach: function(a, b, e) {
        $5f07e3e6ae9098b0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $5f07e3e6ae9098b0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5f07e3e6ae9098b0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5f07e3e6ae9098b0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$5f07e3e6ae9098b0$export$16fa2f45be04daa8 = $5f07e3e6ae9098b0$var$E;
$5f07e3e6ae9098b0$export$ffb0004e005737fa = $5f07e3e6ae9098b0$var$p;
$5f07e3e6ae9098b0$export$e2c29f18771995cb = $5f07e3e6ae9098b0$var$r;
$5f07e3e6ae9098b0$export$221d75b3f55bb0bd = $5f07e3e6ae9098b0$var$G;
$5f07e3e6ae9098b0$export$5f8d39834fd61797 = $5f07e3e6ae9098b0$var$q;
$5f07e3e6ae9098b0$export$74bf444e3cd11ea5 = $5f07e3e6ae9098b0$var$w;
$5f07e3e6ae9098b0$export$ae55be85d98224ed = $5f07e3e6ae9098b0$var$W;
$5f07e3e6ae9098b0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $5f07e3e6ae9098b0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5f07e3e6ae9098b0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5f07e3e6ae9098b0$var$J.call(b, f) && !$5f07e3e6ae9098b0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $5f07e3e6ae9098b0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$5f07e3e6ae9098b0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $5f07e3e6ae9098b0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $5f07e3e6ae9098b0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$5f07e3e6ae9098b0$export$c8a8987d4410bf2d = $5f07e3e6ae9098b0$var$M;
$5f07e3e6ae9098b0$export$d38cd72104c1f0e9 = function(a) {
    var b = $5f07e3e6ae9098b0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$5f07e3e6ae9098b0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5f07e3e6ae9098b0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5f07e3e6ae9098b0$var$v,
        render: a
    };
};
$5f07e3e6ae9098b0$export$a8257692ac88316c = $5f07e3e6ae9098b0$var$O;
$5f07e3e6ae9098b0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5f07e3e6ae9098b0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5f07e3e6ae9098b0$var$T
    };
};
$5f07e3e6ae9098b0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5f07e3e6ae9098b0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5f07e3e6ae9098b0$export$7568632d0d33d16d = function(a) {
    var b = $5f07e3e6ae9098b0$var$V.transition;
    $5f07e3e6ae9098b0$var$V.transition = {};
    try {
        a();
    } finally{
        $5f07e3e6ae9098b0$var$V.transition = b;
    }
};
$5f07e3e6ae9098b0$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$5f07e3e6ae9098b0$export$35808ee640e87ca7 = function(a, b) {
    return $5f07e3e6ae9098b0$var$U.current.useCallback(a, b);
};
$5f07e3e6ae9098b0$export$fae74005e78b1a27 = function(a) {
    return $5f07e3e6ae9098b0$var$U.current.useContext(a);
};
$5f07e3e6ae9098b0$export$dc8fbce3eb94dc1e = function() {};
$5f07e3e6ae9098b0$export$6a7bc4e911dc01cf = function(a) {
    return $5f07e3e6ae9098b0$var$U.current.useDeferredValue(a);
};
$5f07e3e6ae9098b0$export$6d9c69b0de29b591 = function(a, b) {
    return $5f07e3e6ae9098b0$var$U.current.useEffect(a, b);
};
$5f07e3e6ae9098b0$export$f680877a34711e37 = function() {
    return $5f07e3e6ae9098b0$var$U.current.useId();
};
$5f07e3e6ae9098b0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $5f07e3e6ae9098b0$var$U.current.useImperativeHandle(a, b, e);
};
$5f07e3e6ae9098b0$export$aaabe4eda9ed9969 = function(a, b) {
    return $5f07e3e6ae9098b0$var$U.current.useInsertionEffect(a, b);
};
$5f07e3e6ae9098b0$export$e5c5a5f917a5871c = function(a, b) {
    return $5f07e3e6ae9098b0$var$U.current.useLayoutEffect(a, b);
};
$5f07e3e6ae9098b0$export$1538c33de8887b59 = function(a, b) {
    return $5f07e3e6ae9098b0$var$U.current.useMemo(a, b);
};
$5f07e3e6ae9098b0$export$13e3392192263954 = function(a, b, e) {
    return $5f07e3e6ae9098b0$var$U.current.useReducer(a, b, e);
};
$5f07e3e6ae9098b0$export$b8f5890fc79d6aca = function(a) {
    return $5f07e3e6ae9098b0$var$U.current.useRef(a);
};
$5f07e3e6ae9098b0$export$60241385465d0a34 = function(a) {
    return $5f07e3e6ae9098b0$var$U.current.useState(a);
};
$5f07e3e6ae9098b0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $5f07e3e6ae9098b0$var$U.current.useSyncExternalStore(a, b, e);
};
$5f07e3e6ae9098b0$export$7b286972b8d8ccbf = function() {
    return $5f07e3e6ae9098b0$var$U.current.useTransition();
};
$5f07e3e6ae9098b0$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("37Osf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $246929c39dc571fb$export$2e2bcd8739ae039; });

var $l885a = parcelRequire("l885a");

var $737SZ = parcelRequire("737SZ");

var $aZlFU = parcelRequire("aZlFU");

var $4NAcO = parcelRequire("4NAcO");

var $7EJP8 = parcelRequire("7EJP8");

var $h3tyo = parcelRequire("h3tyo");

var $iclgX = parcelRequire("iclgX");
function $246929c39dc571fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $246929c39dc571fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $246929c39dc571fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $l885a.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $246929c39dc571fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $246929c39dc571fb$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $246929c39dc571fb$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $246929c39dc571fb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $737SZ.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $4NAcO.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $7EJP8.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$246929c39dc571fb$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = (0, $iclgX.flightDeckClientExperience)();
        experience.start();
        try {
            const artifactWithKey = $246929c39dc571fb$var$_objectSpread($246929c39dc571fb$var$_objectSpread({}, artifact), {}, {
                key: (0, $h3tyo.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $iclgX.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $l885a.default)(this, "fallbackArtifactMap", new Map());
        (0, $l885a.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $aZlFU.default)($246929c39dc571fb$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $h3tyo.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
}

});
parcelRegister("l885a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6209d5301efe3b1$export$2e2bcd8739ae039; });

var $97bZy = parcelRequire("97bZy");
function $f6209d5301efe3b1$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $97bZy.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("97bZy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6a2e11cfed4762ea$export$2e2bcd8739ae039; });

var $58wvV = parcelRequire("58wvV");

var $cegge = parcelRequire("cegge");
function $6a2e11cfed4762ea$export$2e2bcd8739ae039(t) {
    var i = (0, $cegge.default)(t, "string");
    return "symbol" == (0, $58wvV.default)(i) ? i : i + "";
}

});
parcelRegister("58wvV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3bd6ebb6ef46d4d9$export$2e2bcd8739ae039; });
function $3bd6ebb6ef46d4d9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3bd6ebb6ef46d4d9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3bd6ebb6ef46d4d9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cegge", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8e7367ebadfca483$export$2e2bcd8739ae039; });

var $58wvV = parcelRequire("58wvV");
function $8e7367ebadfca483$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $58wvV.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $58wvV.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("737SZ", function(module, exports) {
$parcel$export(module.exports, "retryOnException", function () { return $521eee301a453b24$export$1d94629c94e7a17f; });

var $7qEFI = parcelRequire("7qEFI");

var $8uF5R = parcelRequire("8uF5R");

var $i77oH = parcelRequire("i77oH");

var $coDBZ = parcelRequire("coDBZ");

var $bWqzq = parcelRequire("bWqzq");

var $5MrcS = parcelRequire("5MrcS");
var $521eee301a453b24$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $521eee301a453b24$var$NO_CALLS_ERROR = 'No calls made';
var $521eee301a453b24$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
        return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $bWqzq.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $5MrcS.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, $7qEFI.default)(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($521eee301a453b24$var$NO_CALLS_ERROR);
                case 4:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 5;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 9;
                    return $521eee301a453b24$export$5c069c93d2b7493f(nextMSInterval);
                case 9:
                    if (onRetry && error.message !== $521eee301a453b24$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 12;
                    return invokeOperation();
                case 12:
                    return _context.abrupt("return", _context.sent);
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](5);
                    error = (0, $coDBZ.default)(_context.t0);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                case 20:
                    _context.next = 4;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                15
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("7qEFI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $568a82aa17fb85fb$export$2e2bcd8739ae039; });

var $5q75f = parcelRequire("5q75f");

var $admSn = parcelRequire("admSn");

var $dwqJh = parcelRequire("dwqJh");

var $aUwzX = parcelRequire("aUwzX");
function $568a82aa17fb85fb$export$2e2bcd8739ae039(r) {
    return (0, $5q75f.default)(r) || (0, $admSn.default)(r) || (0, $dwqJh.default)(r) || (0, $aUwzX.default)();
}

});
parcelRegister("5q75f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f24e01c14a5c512$export$2e2bcd8739ae039; });

var $kQGgh = parcelRequire("kQGgh");
function $3f24e01c14a5c512$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $kQGgh.default)(r);
}

});
parcelRegister("kQGgh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2d97239844d8c1f$export$2e2bcd8739ae039; });
function $f2d97239844d8c1f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("admSn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76fcdcff07aa6729$export$2e2bcd8739ae039; });
function $76fcdcff07aa6729$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("dwqJh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9d82ff664aace5cd$export$2e2bcd8739ae039; });

var $kQGgh = parcelRequire("kQGgh");
function $9d82ff664aace5cd$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kQGgh.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kQGgh.default)(r, a) : void 0;
    }
}

});

parcelRegister("aUwzX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7f1867ddddd88516$export$2e2bcd8739ae039; });
function $7f1867ddddd88516$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8uF5R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $62f100658f2ef156$export$2e2bcd8739ae039; });
function $62f100658f2ef156$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $62f100658f2ef156$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $62f100658f2ef156$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $62f100658f2ef156$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("i77oH", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $d2fe9e6bb472dc97$var$runtime = (parcelRequire("gEeHy"))();
module.exports = $d2fe9e6bb472dc97$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $d2fe9e6bb472dc97$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $d2fe9e6bb472dc97$var$runtime;
    else Function("r", "regeneratorRuntime = r")($d2fe9e6bb472dc97$var$runtime);
}

});
parcelRegister("gEeHy", function(module, exports) {

var $f071I = parcelRequire("f071I");

var $5w2nT = parcelRequire("5w2nT");

var $4WRHp = parcelRequire("4WRHp");

var $e66u2 = parcelRequire("e66u2");

var $kTgGv = parcelRequire("kTgGv");

var $hLiKH = parcelRequire("hLiKH");

var $gJsUE = parcelRequire("gJsUE");
function $c1ebc9302b084f7d$var$_regeneratorRuntime() {
    "use strict";
    var r = $5w2nT(), e = r.m($c1ebc9302b084f7d$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $gJsUE(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $c1ebc9302b084f7d$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $f071I(r, e);
            },
            AsyncIterator: $kTgGv,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $e66u2 : $4WRHp)(a(r), e, t, o, u);
            },
            keys: $hLiKH,
            values: $gJsUE
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $c1ebc9302b084f7d$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f071I", function(module, exports) {
function $aebc4e76a2311576$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $aebc4e76a2311576$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5w2nT", function(module, exports) {

var $iOGTh = parcelRequire("iOGTh");
function $4041ca66ef9ad414$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $iOGTh(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($iOGTh(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $iOGTh(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $iOGTh(u, "constructor", GeneratorFunctionPrototype), $iOGTh(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $iOGTh(GeneratorFunctionPrototype, o, "GeneratorFunction"), $iOGTh(u), $iOGTh(u, o, "Generator"), $iOGTh(u, n, function() {
        return this;
    }), $iOGTh(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $4041ca66ef9ad414$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $4041ca66ef9ad414$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iOGTh", function(module, exports) {
function $db2e2aac84ebdc42$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $db2e2aac84ebdc42$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $db2e2aac84ebdc42$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $db2e2aac84ebdc42$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $db2e2aac84ebdc42$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4WRHp", function(module, exports) {

var $e66u2 = parcelRequire("e66u2");
function $39a63bb68c397fe0$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $e66u2(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $39a63bb68c397fe0$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e66u2", function(module, exports) {

var $5w2nT = parcelRequire("5w2nT");

var $kTgGv = parcelRequire("kTgGv");
function $a436a7b1a433d7e6$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $kTgGv($5w2nT().w(r, e, t, o), n || Promise);
}
module.exports = $a436a7b1a433d7e6$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kTgGv", function(module, exports) {

var $f071I = parcelRequire("f071I");

var $iOGTh = parcelRequire("iOGTh");
function $f355e2eac7e869ab$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $f071I ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($iOGTh($f355e2eac7e869ab$var$AsyncIterator.prototype), $iOGTh($f355e2eac7e869ab$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $iOGTh(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $f355e2eac7e869ab$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hLiKH", function(module, exports) {
function $cee55f3ae1284e1a$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $cee55f3ae1284e1a$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gJsUE", function(module, exports) {

var $5bDkW = parcelRequire("5bDkW");
var $0324c334cb9e599e$var$_typeof = $5bDkW.default;
function $0324c334cb9e599e$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($0324c334cb9e599e$var$_typeof(e) + " is not iterable");
}
module.exports = $0324c334cb9e599e$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5bDkW", function(module, exports) {
function $3c6c7e4cfadfb8ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3c6c7e4cfadfb8ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3c6c7e4cfadfb8ec$var$_typeof(o);
}
module.exports = $3c6c7e4cfadfb8ec$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("coDBZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $906673f9fdb738cb$export$2e2bcd8739ae039; });

var $58wvV = parcelRequire("58wvV");
var $906673f9fdb738cb$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if ((0, $58wvV.default)(e) === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $906673f9fdb738cb$export$2e2bcd8739ae039 = $906673f9fdb738cb$var$convertToError;

});

parcelRegister("bWqzq", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", function () { return $8b19b8ccb3a031dc$export$a0a1c8f90becc136; });
var $8b19b8ccb3a031dc$export$a0a1c8f90becc136 = [];
var $8b19b8ccb3a031dc$export$972171517b12aa4 = [
    0,
    0
];
var $8b19b8ccb3a031dc$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $8b19b8ccb3a031dc$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("5MrcS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43568a20975868f4$export$2e2bcd8739ae039; });

var $3QE0F = parcelRequire("3QE0F");

var $kSmn1 = parcelRequire("kSmn1");

var $lzlKn = parcelRequire("lzlKn");

var $1NDyh = parcelRequire("1NDyh");

var $lWnz4 = parcelRequire("lWnz4");

var $4jjWt = parcelRequire("4jjWt");
function $43568a20975868f4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $43568a20975868f4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lWnz4.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lWnz4.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $1NDyh.default)(this, result);
    };
}
function $43568a20975868f4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $43568a20975868f4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    (0, $lzlKn.default)(FailedFetchError, _Error);
    var _super = $43568a20975868f4$var$_createSuper(FailedFetchError);
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, $kSmn1.default)(this, FailedFetchError);
        _this = _super.call(this);
        _this.name = 'FailedFetchError';
        _this.message = error.message || 'Unknown fetch error';
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split('?')[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        return _this;
    }
    return (0, $3QE0F.default)(FailedFetchError);
}(/*#__PURE__*/ (0, $4jjWt.default)(Error));

});
parcelRegister("3QE0F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2cd543881762ac2b$export$2e2bcd8739ae039; });

var $97bZy = parcelRequire("97bZy");
function $2cd543881762ac2b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $97bZy.default)(o.key), o);
    }
}
function $2cd543881762ac2b$export$2e2bcd8739ae039(e, r, t) {
    return r && $2cd543881762ac2b$var$_defineProperties(e.prototype, r), t && $2cd543881762ac2b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("kSmn1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f32a34116eda3d50$export$2e2bcd8739ae039; });
function $f32a34116eda3d50$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lzlKn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fb3dbc5ca753afa1$export$2e2bcd8739ae039; });

var $67Zcx = parcelRequire("67Zcx");
function $fb3dbc5ca753afa1$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $67Zcx.default)(t, e);
}

});
parcelRegister("67Zcx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4762ded2f5ba5fb9$export$2e2bcd8739ae039; });
function $4762ded2f5ba5fb9$export$2e2bcd8739ae039(t, e) {
    return $4762ded2f5ba5fb9$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4762ded2f5ba5fb9$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1NDyh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14f90c36060c10e1$export$2e2bcd8739ae039; });

var $58wvV = parcelRequire("58wvV");

var $34tDW = parcelRequire("34tDW");
function $14f90c36060c10e1$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $58wvV.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $34tDW.default)(t);
}

});
parcelRegister("34tDW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23c8bd5285c1add1$export$2e2bcd8739ae039; });
function $23c8bd5285c1add1$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("lWnz4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff914b325941efba$export$2e2bcd8739ae039; });
function $ff914b325941efba$export$2e2bcd8739ae039(t) {
    return $ff914b325941efba$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ff914b325941efba$export$2e2bcd8739ae039(t);
}

});

parcelRegister("4jjWt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $323867d78220f500$export$2e2bcd8739ae039; });

var $lWnz4 = parcelRequire("lWnz4");

var $67Zcx = parcelRequire("67Zcx");

var $fxaZJ = parcelRequire("fxaZJ");

var $iU2Ar = parcelRequire("iU2Ar");
function $323867d78220f500$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $323867d78220f500$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $fxaZJ.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $iU2Ar.default)(t, arguments, (0, $lWnz4.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $67Zcx.default)(Wrapper, t);
    }, $323867d78220f500$export$2e2bcd8739ae039(t);
}

});
parcelRegister("fxaZJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b4f2776965e9738f$export$2e2bcd8739ae039; });
function $b4f2776965e9738f$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("iU2Ar", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dc2f76a168a3fe9c$export$2e2bcd8739ae039; });

var $2CVs3 = parcelRequire("2CVs3");

var $67Zcx = parcelRequire("67Zcx");
function $dc2f76a168a3fe9c$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $2CVs3.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $67Zcx.default)(p, r.prototype), p;
}

});
parcelRegister("2CVs3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1e9bb20b88a515e6$export$2e2bcd8739ae039; });
function $1e9bb20b88a515e6$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1e9bb20b88a515e6$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("aZlFU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $80006a14e7fe218c$export$2e2bcd8739ae039; });

var $kSmn1 = parcelRequire("kSmn1");

var $3QE0F = parcelRequire("3QE0F");

var $l885a = parcelRequire("l885a");

var $g7DPP = parcelRequire("g7DPP");
var $80006a14e7fe218c$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
var $80006a14e7fe218c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function StorageClient(clientKey, options) {
        var _this = this;
        (0, $kSmn1.default)(this, StorageClient);
        (0, $l885a.default)(this, "getItem", function(key) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                useExpiredItem: false
            }, useExpiredItem = _ref.useExpiredItem;
            var item = _this.client.getItem(_this.itemKey(key));
            if (item) try {
                var parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
             * Commented out removing this item, as it is a slightly different state
             * to the item not existing that we may want to preserve.
             *  this.client.removeItem(this.itemKey(key));
             */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                _this.captureException(e);
            }
            return undefined;
        });
        (0, $l885a.default)(this, "removeItem", function(key) {
            try {
                _this.client.removeItem(_this.itemKey(key));
            } catch (e) {
                _this.captureException(e);
            }
        });
        (0, $l885a.default)(this, "setItemWithExpiry", function(key, value, expireInMS) {
            var itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                _this.client.setItem(_this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                _this.captureException(e);
            }
        });
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        var storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $80006a14e7fe218c$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $g7DPP.mockWindowStorage)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    (0, $3QE0F.default)(StorageClient, [
        {
            key: "captureException",
            value: function captureException(e, tags) {
                var _this$handlers;
                if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) {
                    var _this$handlers2;
                    (_this$handlers2 = this.handlers) === null || _this$handlers2 === void 0 || _this$handlers2.captureException(e, tags);
                }
            }
        },
        {
            key: "itemKey",
            value: function itemKey(key) {
                return "".concat(this.clientKey, "_").concat(key);
            }
        }
    ]);
    return StorageClient;
}();

});
parcelRegister("g7DPP", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", function () { return $bbcc332eee3093b5$export$efebfe7859cae3c7; });

var $l885a = parcelRequire("l885a");
function $bbcc332eee3093b5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbcc332eee3093b5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbcc332eee3093b5$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $l885a.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbcc332eee3093b5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbcc332eee3093b5$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $bbcc332eee3093b5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bbcc332eee3093b5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bbcc332eee3093b5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bbcc332eee3093b5$var$_arrayLikeToArray(o, minLen);
}
function $bbcc332eee3093b5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $bbcc332eee3093b5$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function setItem(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function getItem(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function removeItem(id) {
        return delete this._data[id];
    },
    clear: function clear() {
        return this._data = {};
    },
    key: function key(index) {
        return Object.keys(this._data)[index];
    }
};
var $bbcc332eee3093b5$export$efebfe7859cae3c7 = function mockWindowStorage() {
    var storageToMock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
        'localStorage',
        'sessionStorage'
    ];
    var _iterator = $bbcc332eee3093b5$var$_createForOfIteratorHelper(storageToMock), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var storageToMockElement = _step.value;
            Object.defineProperty(window, storageToMockElement, {
                value: $bbcc332eee3093b5$var$_objectSpread({}, $bbcc332eee3093b5$export$c65e688d8b365035),
                configurable: true
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
};

});


parcelRegister("4NAcO", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", function () { return $37e7d2b813017b8f$export$6026918e023c9101; });

var $2hVi7 = parcelRequire("2hVi7");

var $9zB5r = parcelRequire("9zB5r");

var $ia7Qf = parcelRequire("ia7Qf");

var $hgXMP = parcelRequire("hgXMP");

var $1MOuf = parcelRequire("1MOuf");

var $eRMh2 = parcelRequire("eRMh2");

var $f40Bu = parcelRequire("f40Bu");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $37e7d2b813017b8f$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $37e7d2b813017b8f$var$defaultPerimeter = "commercial";
async function $37e7d2b813017b8f$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $37e7d2b813017b8f$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $37e7d2b813017b8f$var$defaultPerimeter;
    const environment = $37e7d2b813017b8f$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $2hVi7.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        environment: environment,
        locale: locale
    };
    const client = await $37e7d2b813017b8f$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $37e7d2b813017b8f$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $37e7d2b813017b8f$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $37e7d2b813017b8f$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $37e7d2b813017b8f$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $37e7d2b813017b8f$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $eRMh2.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $eRMh2.getVersionMetadataFetchExperience)();
    return new (0, $1MOuf.ConfigClient)(new (0, $ia7Qf.BifrostDataSource)(new (0, $hgXMP.BifrostHttpClientImpl)(env, perimeter), (0, $9zB5r.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $37e7d2b813017b8f$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("2hVi7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1aa99c250c6901b2$export$2e2bcd8739ae039; });
/**
 * This function is being used to address locale discrepancies in Atlassian products;
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ var $1aa99c250c6901b2$export$852ff24d0930c62f = function mapLocaleToPrsLocale(locale) {
    var standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-US':
        case 'en-GB':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $1aa99c250c6901b2$export$2e2bcd8739ae039 = $1aa99c250c6901b2$export$852ff24d0930c62f;

});

parcelRegister("9zB5r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $5NcNp = parcelRequire("5NcNp");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $5NcNp.Either;
    }
});

var $gubMS = parcelRequire("gubMS");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $gubMS.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $gubMS.tryGetArtifactData;
    }
});

var $4TYFU = parcelRequire("4TYFU");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $4TYFU.parseArtifactManifest;
    }
});

var $40yiy = parcelRequire("40yiy");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $40yiy.parseVersionMetadata;
    }
});

var $8PjUn = parcelRequire("8PjUn");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $8PjUn.checkManifest;
    }
});

var $6lwzY = parcelRequire("6lwzY");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $6lwzY.ConfigRegistryDataSource;
    }
});

var $3L3ce = parcelRequire("3L3ce");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $3L3ce.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $3L3ce.Versions;
    }
});

});
parcelRegister("5NcNp", function(module, exports) {
"use strict";
var $437b745a00a9d3f9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $437b745a00a9d3f9$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $437b745a00a9d3f9$var$Right(value);
    };
    Either.left = function(error) {
        return new $437b745a00a9d3f9$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $437b745a00a9d3f9$var$Either;
var $437b745a00a9d3f9$var$Right = /** @class */ function(_super) {
    $437b745a00a9d3f9$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $437b745a00a9d3f9$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $437b745a00a9d3f9$var$Either.right(this.right);
    };
    return Right;
}($437b745a00a9d3f9$var$Either);
var $437b745a00a9d3f9$var$Left = /** @class */ function(_super) {
    $437b745a00a9d3f9$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $437b745a00a9d3f9$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $437b745a00a9d3f9$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $437b745a00a9d3f9$var$Either.left(f(this.left));
    };
    return Left;
}($437b745a00a9d3f9$var$Either);

});

parcelRegister("gubMS", function(module, exports) {
"use strict";
var $c0089769980bdb91$var$__assign = module.exports && module.exports.__assign || function() {
    $c0089769980bdb91$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0089769980bdb91$var$__assign.apply(this, arguments);
};
var $c0089769980bdb91$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c0089769980bdb91$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $c0089769980bdb91$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $c0089769980bdb91$var$tryGetArtifactData;

var $hbtOD = parcelRequire("hbtOD");

var $9zB5r = parcelRequire("9zB5r");

var $304Us = parcelRequire("304Us");

var $btDQD = parcelRequire("btDQD");

var $2FfAj = parcelRequire("2FfAj");
function $c0089769980bdb91$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $c0089769980bdb91$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $c0089769980bdb91$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $c0089769980bdb91$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $c0089769980bdb91$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $9zB5r.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $304Us.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $c0089769980bdb91$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $btDQD.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $c0089769980bdb91$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $c0089769980bdb91$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $c0089769980bdb91$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $hbtOD.interpolateTagScheme)(manifest.tagScheme, $c0089769980bdb91$var$__assign($c0089769980bdb91$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $c0089769980bdb91$var$__awaiter(_this, void 0, void 0, function() {
                                return $c0089769980bdb91$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $c0089769980bdb91$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $2FfAj.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $2FfAj.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $btDQD.assertUnreachable)(artifact);
    }
}

});
parcelRegister("hbtOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $c82a9786233d5a82$var$interpolateTagScheme;
module.exports.generateTagScheme = $c82a9786233d5a82$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $c82a9786233d5a82$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $c82a9786233d5a82$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $c82a9786233d5a82$var$getVersionMetadataTag;
const $c82a9786233d5a82$var$TAG_SCHEME_VERSION = 2;
function $c82a9786233d5a82$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($c82a9786233d5a82$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $c82a9786233d5a82$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $c82a9786233d5a82$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $c82a9786233d5a82$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $c82a9786233d5a82$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $c82a9786233d5a82$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $c82a9786233d5a82$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $c82a9786233d5a82$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("304Us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $22f52e25a403a4d1$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $22f52e25a403a4d1$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("btDQD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $85b1501b423ea552$var$assertUnreachable;
function $85b1501b423ea552$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("2FfAj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $1f0b7fe01c629eb8$var$toJson;
module.exports.toPrettyJson = $1f0b7fe01c629eb8$var$toPrettyJson;
function $1f0b7fe01c629eb8$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $1f0b7fe01c629eb8$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("4TYFU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $391b5d45c7d5c1c2$var$parseArtifactManifest;

var $4e7Ar = parcelRequire("4e7Ar");
function $391b5d45c7d5c1c2$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $4e7Ar.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $4e7Ar.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $391b5d45c7d5c1c2$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $4e7Ar.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $391b5d45c7d5c1c2$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $391b5d45c7d5c1c2$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $4e7Ar.parseUnknownObject)(dimensions);
    var supported = (0, $4e7Ar.parseArray)(unparsedDimensions.supported).map($4e7Ar.parseString);
    var fallback = (0, $4e7Ar.parseUndefinedOr)($4e7Ar.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $391b5d45c7d5c1c2$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $4e7Ar.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $391b5d45c7d5c1c2$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $391b5d45c7d5c1c2$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $4e7Ar.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $4e7Ar.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $4e7Ar.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $4e7Ar.parseUndefinedOr)($4e7Ar.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $391b5d45c7d5c1c2$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $391b5d45c7d5c1c2$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("4e7Ar", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $313e5acf31b69ea6$var$parseString;
module.exports.parseArray = $313e5acf31b69ea6$var$parseArray;
module.exports.parseBoolean = $313e5acf31b69ea6$var$parseBoolean;
module.exports.parseUnknownObject = $313e5acf31b69ea6$var$parseUnknownObject;
module.exports.parseUndefinedOr = $313e5acf31b69ea6$var$parseUndefinedOr;
function $313e5acf31b69ea6$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $313e5acf31b69ea6$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $313e5acf31b69ea6$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $313e5acf31b69ea6$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $313e5acf31b69ea6$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("40yiy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $2eb1c469e5a32cf2$var$parseVersionMetadata;

var $4e7Ar = parcelRequire("4e7Ar");
function $2eb1c469e5a32cf2$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $4e7Ar.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $4e7Ar.parseString)(unknownObject.version);
    var publishTime = new Date((0, $4e7Ar.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $4e7Ar.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("8PjUn", function(module, exports) {
"use strict";
var $66d2878a3a9bd1fb$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $66d2878a3a9bd1fb$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $66d2878a3a9bd1fb$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $66d2878a3a9bd1fb$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("6lwzY", function(module, exports) {
"use strict";
var $49edf9ca1d9517f7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $49edf9ca1d9517f7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $hbtOD = parcelRequire("hbtOD");

var $5NcNp = parcelRequire("5NcNp");

var $4TYFU = parcelRequire("4TYFU");

var $40yiy = parcelRequire("40yiy");
var $49edf9ca1d9517f7$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $49edf9ca1d9517f7$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $49edf9ca1d9517f7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $hbtOD.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($4TYFU.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $5NcNp.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $49edf9ca1d9517f7$var$__awaiter(this, void 0, void 0, function() {
            return $49edf9ca1d9517f7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $49edf9ca1d9517f7$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $49edf9ca1d9517f7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $hbtOD.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $40yiy.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $49edf9ca1d9517f7$var$ConfigRegistryDataSource;

});

parcelRegister("3L3ce", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $2bc83d9fdb657ba9$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $2bc83d9fdb657ba9$var$BaseUrls;
var $2bc83d9fdb657ba9$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $2bc83d9fdb657ba9$var$Versions;

});


parcelRegister("ia7Qf", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", function () { return $d38f3e57bde984ec$export$2cb8d79200775058; });

var $9zB5r = parcelRequire("9zB5r");

var $hbtOD = parcelRequire("hbtOD");
class $d38f3e57bde984ec$export$2cb8d79200775058 {
    async getLatestVersionMetadata() {
        const tag = (0, $hbtOD.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $9zB5r.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $9zB5r.parseVersionMetadata)(response);
                return (0, $9zB5r.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $9zB5r.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $hbtOD.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $9zB5r.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $9zB5r.parseArtifactManifest)(response);
                return (0, $9zB5r.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $9zB5r.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
}

});

parcelRegister("hgXMP", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", function () { return $c9324ea40e9aaf6a$export$45c6d12ca9c14f83; });

var $9zB5r = parcelRequire("9zB5r");
function $c9324ea40e9aaf6a$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $c9324ea40e9aaf6a$export$45c6d12ca9c14f83 {
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $9zB5r.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $9zB5r.Either).right(json)));
            }).catch((error)=>resolve((0, $9zB5r.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
    constructor(env, perimeter){
        this.baseUrl = $c9324ea40e9aaf6a$export$f654b28f82155665(env, perimeter);
    }
}

});

parcelRegister("1MOuf", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", function () { return $14d16fcbc5539836$export$8489e2f039bfcc4c; });

var $l885a = parcelRequire("l885a");

var $9zB5r = parcelRequire("9zB5r");

var $4Uq7P = parcelRequire("4Uq7P");
function $14d16fcbc5539836$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14d16fcbc5539836$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14d16fcbc5539836$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $l885a.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14d16fcbc5539836$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $14d16fcbc5539836$export$8489e2f039bfcc4c {
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $14d16fcbc5539836$var$_objectSpread($14d16fcbc5539836$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $9zB5r.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $9zB5r.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $4Uq7P.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
}

});
parcelRegister("4Uq7P", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", function () { return $3930a850de1f3604$export$1cc944571619e6e8; });
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $3930a850de1f3604$export$1cc944571619e6e8 {
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
}

});


parcelRegister("eRMh2", function(module, exports) {
$parcel$export(module.exports, "getFlightDeckFetchExperience", function () { return $ad2b76163ebd593f$export$a3006f8f221c0a3b; });
$parcel$export(module.exports, "getVersionMetadataFetchExperience", function () { return $ad2b76163ebd593f$export$c3ac7702bfd47c1b; });
const $ad2b76163ebd593f$var$SAMPLING_RATE = 10;
class $ad2b76163ebd593f$var$UFOExperienceWrapper {
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
    constructor(experience){
        this.experience = experience;
    }
}
class $ad2b76163ebd593f$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $ad2b76163ebd593f$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $ad2b76163ebd593f$var$SAMPLING_RATE) return new $ad2b76163ebd593f$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("3ZcHi"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $ad2b76163ebd593f$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $ad2b76163ebd593f$export$5e7536cf7bc56fee();
    }
}
const $ad2b76163ebd593f$export$a3006f8f221c0a3b = ()=>$ad2b76163ebd593f$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $ad2b76163ebd593f$export$c3ac7702bfd47c1b = ()=>$ad2b76163ebd593f$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("3ZcHi", function(module, exports) {


module.exports = (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("aju28")).then(()=>parcelRequire('eYtTg'));

});


parcelRegister("f40Bu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $i2FWz = parcelRequire("i2FWz");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $i2FWz.parseConfigWithTargeting;
    }
});

var $2X6Au = parcelRequire("2X6Au");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $2X6Au.TargetedConfig;
    }
});

});
parcelRegister("i2FWz", function(module, exports) {
"use strict";
var $d228f306dc77eddd$var$__assign = module.exports && module.exports.__assign || function() {
    $d228f306dc77eddd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d228f306dc77eddd$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $d228f306dc77eddd$var$parseConfigWithTargeting;

var $2X6Au = parcelRequire("2X6Au");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $d228f306dc77eddd$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $d228f306dc77eddd$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $2X6Au.TargetedConfig({
                defaultConfig: $d228f306dc77eddd$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $d228f306dc77eddd$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $2X6Au.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $d228f306dc77eddd$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $d228f306dc77eddd$var$__assign($d228f306dc77eddd$var$__assign({}, accObject), (_a = {}, _a[key] = $d228f306dc77eddd$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $d228f306dc77eddd$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $d228f306dc77eddd$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $d228f306dc77eddd$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $d228f306dc77eddd$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $d228f306dc77eddd$var$parseIdentifierList(target.orgIds),
            siteIds: $d228f306dc77eddd$var$parseIdentifierList(target.siteIds),
            userIds: $d228f306dc77eddd$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $d228f306dc77eddd$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("2X6Au", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $2266339d0bbba62b$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $2266339d0bbba62b$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $2266339d0bbba62b$var$TargetedConfig;
function $2266339d0bbba62b$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("7EJP8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $592fd07c55ce8430$export$2e2bcd8739ae039; });
class $592fd07c55ce8430$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
    }
}
const $592fd07c55ce8430$export$1d76d155060824c9 = (e)=>e instanceof $592fd07c55ce8430$export$2e2bcd8739ae039;

});

parcelRegister("h3tyo", function(module, exports) {
$parcel$export(module.exports, "artifactKey", function () { return $c6a9a43cbf9d3417$export$e3553dc63541d477; });
const $c6a9a43cbf9d3417$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("iclgX", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", function () { return $d3f9d947d341ee1e$export$1e3a41a51f6457c5; });
$parcel$export(module.exports, "exceptionToMetadata", function () { return $d3f9d947d341ee1e$export$f33622abb5224195; });

var $l885a = parcelRequire("l885a");

var $7QZnA = parcelRequire("7QZnA");
var $vYGsY = parcelRequire("vYGsY");
function $d3f9d947d341ee1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3f9d947d341ee1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3f9d947d341ee1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $l885a.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3f9d947d341ee1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d3f9d947d341ee1e$export$6061a1a9a61f2e21 = ()=>new (0, $vYGsY.UFOExperience)("fetch", {
        type: (0, $7QZnA.ExperienceTypes).Operation,
        performanceType: (0, $7QZnA.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $d3f9d947d341ee1e$export$1e3a41a51f6457c5 = ()=>new (0, $vYGsY.UFOExperience)("retrieve-artifact", {
        type: (0, $7QZnA.ExperienceTypes).Operation,
        performanceType: (0, $7QZnA.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $d3f9d947d341ee1e$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $d3f9d947d341ee1e$var$_objectSpread($d3f9d947d341ee1e$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});
parcelRegister("7QZnA", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", function () { return $5b7d006f119b3bea$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $5b7d006f119b3bea$export$cc26007c03242fff; });
var $5b7d006f119b3bea$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($5b7d006f119b3bea$export$994164cf3ae1cc9a || ($5b7d006f119b3bea$export$994164cf3ae1cc9a = {}));
var $5b7d006f119b3bea$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($5b7d006f119b3bea$export$cc26007c03242fff || ($5b7d006f119b3bea$export$cc26007c03242fff = {}));

});

parcelRegister("vYGsY", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", function () { return $0601f7ee719391cf$export$c00d22927c60484a; });

var $3QE0F = parcelRequire("3QE0F");

var $kSmn1 = parcelRequire("kSmn1");

var $lzlKn = parcelRequire("lzlKn");

var $1NDyh = parcelRequire("1NDyh");

var $lWnz4 = parcelRequire("lWnz4");

var $c8NwH = parcelRequire("c8NwH");
function $0601f7ee719391cf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0601f7ee719391cf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $lWnz4.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $lWnz4.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $1NDyh.default)(this, result);
    };
}
function $0601f7ee719391cf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0601f7ee719391cf$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, $lzlKn.default)(UFOExperience, _UFOAbstractExperienc);
    var _super = $0601f7ee719391cf$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, $kSmn1.default)(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, $3QE0F.default)(UFOExperience);
}((0, $c8NwH.UFOAbstractExperience));

});
parcelRegister("c8NwH", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", function () { return $8d6ca6521b52e16d$export$d31c89db257648c; });

var $7qEFI = parcelRequire("7qEFI");

var $8uF5R = parcelRequire("8uF5R");

var $kSmn1 = parcelRequire("kSmn1");

var $3QE0F = parcelRequire("3QE0F");

var $l885a = parcelRequire("l885a");

var $i77oH = parcelRequire("i77oH");

var $10s8f = parcelRequire("10s8f");

var $4wI0P = parcelRequire("4wI0P");

var $94rfp = parcelRequire("94rfp");

var $j6425 = parcelRequire("j6425");

var $5Zgra = parcelRequire("5Zgra");

var $dszxe = parcelRequire("dszxe");

var $fXc0M = parcelRequire("fXc0M");

var $2WZKA = parcelRequire("2WZKA");

var $3ZHVV = parcelRequire("3ZHVV");

var $2Uy7K = parcelRequire("2Uy7K");

var $7QZnA = parcelRequire("7QZnA");
function $8d6ca6521b52e16d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8d6ca6521b52e16d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8d6ca6521b52e16d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $l885a.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8d6ca6521b52e16d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8d6ca6521b52e16d$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $94rfp.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $fXc0M.PageVisibleState).VISIBLE : (0, $fXc0M.PageVisibleState).HIDDEN;
};
var $8d6ca6521b52e16d$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2WZKA.roundPerfNow)();
};
var $8d6ca6521b52e16d$export$d31c89db257648c = /*#__PURE__*/ function() {
    // for concurrent
    // @todo move to page load experience when proper classes/inheritance prepared
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $kSmn1.default)(this, UFOAbstractExperience);
        (0, $l885a.default)(this, "state", (0, $3ZHVV.UFOExperienceState).NOT_STARTED);
        (0, $l885a.default)(this, "instanceId", null);
        (0, $l885a.default)(this, "parent", null);
        (0, $l885a.default)(this, "category", null);
        (0, $l885a.default)(this, "metadata", {});
        (0, $l885a.default)(this, "onDoneCallbacks", []);
        (0, $l885a.default)(this, "childExperiences", []);
        (0, $l885a.default)(this, "explicitTimings", {});
        (0, $l885a.default)(this, "isSSROutputAsFMP", false);
        (0, $l885a.default)(this, "uuid", null);
        (0, $l885a.default)(this, "_until", null);
        (0, $l885a.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $l885a.default)(this, "performanceConfig", {});
        (0, $l885a.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $fXc0M.PageVisibleState).MIXED;
            (0, $dszxe.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $8d6ca6521b52e16d$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7QZnA.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7QZnA.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, $3QE0F.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $5Zgra.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $2Uy7K.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $5Zgra.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $3ZHVV.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $8d6ca6521b52e16d$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $10s8f.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $8d6ca6521b52e16d$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $j6425.getGlobalEventStream)().push((0, $j6425.unsubscribeEvent)((0, $fXc0M.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $5Zgra.ufolog)('this.parent', this.parent);
                                (0, $j6425.getGlobalEventStream)().push((0, $j6425.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $5Zgra.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $5Zgra.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $3ZHVV.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $8d6ca6521b52e16d$var$getPageVisibleState();
                                    (0, $dszxe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $5Zgra.ufolog)('subscribed', this.id);
                                        (0, $j6425.getGlobalEventStream)().push((0, $j6425.subscribeEvent)((0, $fXc0M.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $fXc0M.FMP_MARK) && name !== (0, $fXc0M.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $5Zgra.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $8d6ca6521b52e16d$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $3ZHVV.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $fXc0M.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $fXc0M.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $5Zgra.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $dszxe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $3ZHVV.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $3ZHVV.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $3ZHVV.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $5Zgra.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $8uF5R.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($i77oH))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $4wI0P.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $8d6ca6521b52e16d$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $8d6ca6521b52e16d$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $7qEFI.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("10s8f", function(module, exports) {

var $fMbjf = parcelRequire("fMbjf");

var $4SzGT = parcelRequire("4SzGT");
var $0bbb9cf4b3b3750b$var$uuid = $4SzGT;
$0bbb9cf4b3b3750b$var$uuid.v1 = $fMbjf;
$0bbb9cf4b3b3750b$var$uuid.v4 = $4SzGT;
module.exports = $0bbb9cf4b3b3750b$var$uuid;

});
parcelRegister("fMbjf", function(module, exports) {

var $lfmFS = parcelRequire("lfmFS");

var $5Fsgk = parcelRequire("5Fsgk");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b7c41c86ac93428b$var$_nodeId;
var $b7c41c86ac93428b$var$_clockseq;
// Previous uuid creation time
var $b7c41c86ac93428b$var$_lastMSecs = 0;
var $b7c41c86ac93428b$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b7c41c86ac93428b$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b7c41c86ac93428b$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b7c41c86ac93428b$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $lfmFS();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b7c41c86ac93428b$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b7c41c86ac93428b$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b7c41c86ac93428b$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b7c41c86ac93428b$var$_lastMSecs + (nsecs - $b7c41c86ac93428b$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b7c41c86ac93428b$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $b7c41c86ac93428b$var$_lastMSecs = msecs;
    $b7c41c86ac93428b$var$_lastNSecs = nsecs;
    $b7c41c86ac93428b$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $5Fsgk(b);
}
module.exports = $b7c41c86ac93428b$var$v1;

});
parcelRegister("lfmFS", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $f77c965593c42b16$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($f77c965593c42b16$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $f77c965593c42b16$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $f77c965593c42b16$var$getRandomValues($f77c965593c42b16$var$rnds8);
        return $f77c965593c42b16$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $f77c965593c42b16$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $f77c965593c42b16$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $f77c965593c42b16$var$rnds;
    };
}

});

parcelRegister("5Fsgk", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $4206b467799d164d$var$byteToHex = [];
for(var $4206b467799d164d$var$i = 0; $4206b467799d164d$var$i < 256; ++$4206b467799d164d$var$i)$4206b467799d164d$var$byteToHex[$4206b467799d164d$var$i] = ($4206b467799d164d$var$i + 0x100).toString(16).substr(1);
function $4206b467799d164d$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $4206b467799d164d$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $4206b467799d164d$var$bytesToUuid;

});


parcelRegister("4SzGT", function(module, exports) {

var $lfmFS = parcelRequire("lfmFS");

var $5Fsgk = parcelRequire("5Fsgk");
function $38d7e4042b2549fb$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $lfmFS)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5Fsgk(rnds);
}
module.exports = $38d7e4042b2549fb$var$v4;

});


parcelRegister("4wI0P", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $34bc4a84d91b2ee6$export$2295b861f318254a; });
// temp solution until we can get it automated
var $34bc4a84d91b2ee6$export$2295b861f318254a = '0.1.5';

});

parcelRegister("94rfp", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $69a99f9848c16385$export$15e172712955e18f; });
var $69a99f9848c16385$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});

parcelRegister("j6425", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", function () { return $de71b4a88fd636bc$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $de71b4a88fd636bc$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $de71b4a88fd636bc$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $de71b4a88fd636bc$export$7c957416596ca127; });

var $5Zgra = parcelRequire("5Zgra");

var $fXc0M = parcelRequire("fXc0M");
var $de71b4a88fd636bc$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $de71b4a88fd636bc$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $de71b4a88fd636bc$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $de71b4a88fd636bc$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $5Zgra.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $de71b4a88fd636bc$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $fXc0M.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $de71b4a88fd636bc$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $fXc0M.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $de71b4a88fd636bc$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $fXc0M.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5Zgra", function(module, exports) {
$parcel$export(module.exports, "ufolog", function () { return $45bf6657173d0367$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $45bf6657173d0367$export$d53d07b6034c4560; });

var $kSmn1 = parcelRequire("kSmn1");

var $3QE0F = parcelRequire("3QE0F");

var $l885a = parcelRequire("l885a");
var $45bf6657173d0367$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $kSmn1.default)(this, UFOLogger);
        (0, $l885a.default)(this, "enabled", false);
    }
    (0, $3QE0F.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, $l885a.default)($45bf6657173d0367$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $45bf6657173d0367$export$4ab84f6f04f6566d = new $45bf6657173d0367$var$UFOLogger();
var $45bf6657173d0367$export$b4958caff08a0960 = function ufolog() {
    $45bf6657173d0367$export$4ab84f6f04f6566d.log.apply($45bf6657173d0367$export$4ab84f6f04f6566d, arguments);
};
var $45bf6657173d0367$export$d53d07b6034c4560 = function ufowarn() {
    $45bf6657173d0367$export$4ab84f6f04f6566d.warn.apply($45bf6657173d0367$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("fXc0M", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $b9d5aef0b4c8094e$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $b9d5aef0b4c8094e$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $b9d5aef0b4c8094e$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $b9d5aef0b4c8094e$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $b9d5aef0b4c8094e$export$837e0f79a8056912; });

var $b9d5aef0b4c8094e$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($b9d5aef0b4c8094e$export$96253c35c37cf96b || ($b9d5aef0b4c8094e$export$96253c35c37cf96b = {}));
var $b9d5aef0b4c8094e$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($b9d5aef0b4c8094e$export$a12c67b37a306b13 || ($b9d5aef0b4c8094e$export$a12c67b37a306b13 = {}));
var $b9d5aef0b4c8094e$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($b9d5aef0b4c8094e$export$66b33c055cbb625e || ($b9d5aef0b4c8094e$export$66b33c055cbb625e = {}));
var $b9d5aef0b4c8094e$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($b9d5aef0b4c8094e$export$3ce489cbe02dc21b || ($b9d5aef0b4c8094e$export$3ce489cbe02dc21b = {}));
var $b9d5aef0b4c8094e$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($b9d5aef0b4c8094e$export$341b330828bd3906 || ($b9d5aef0b4c8094e$export$341b330828bd3906 = {}));
var $b9d5aef0b4c8094e$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($b9d5aef0b4c8094e$export$b9b20160f581e4f8 || ($b9d5aef0b4c8094e$export$b9b20160f581e4f8 = {}));
var $b9d5aef0b4c8094e$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $b9d5aef0b4c8094e$export$9f2bf58999404c75 = 'fmp';
var $b9d5aef0b4c8094e$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("dszxe", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", function () { return $9cc97463492fc80a$export$13e680397ec8f3eb; });

var $kSmn1 = parcelRequire("kSmn1");

var $3QE0F = parcelRequire("3QE0F");

var $l885a = parcelRequire("l885a");

var $94rfp = parcelRequire("94rfp");
var $9cc97463492fc80a$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $kSmn1.default)(this, VisibilityChangeObserver);
        (0, $l885a.default)(this, "started", false);
        (0, $l885a.default)(this, "observers", []);
        (0, $l885a.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, $3QE0F.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $94rfp.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $9cc97463492fc80a$export$13e680397ec8f3eb = new $9cc97463492fc80a$var$VisibilityChangeObserver();

});

parcelRegister("2WZKA", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", function () { return $2260e5ea1458e9eb$export$5f490af6b2b115cf; });
var $2260e5ea1458e9eb$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("3ZHVV", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", function () { return $2e8925d4a6ba1dbb$export$81b70111112841a0; });
var $2e8925d4a6ba1dbb$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("2Uy7K", function(module, exports) {
$parcel$export(module.exports, "canTransition", function () { return $21eb480796cfeeeb$export$178881f329fdb81f; });

var $l885a = parcelRequire("l885a");

var $3ZHVV = parcelRequire("3ZHVV");
var $21eb480796cfeeeb$var$_UFOStateAvailableTra;
var $21eb480796cfeeeb$var$UFOStateAvailableTransitions = ($21eb480796cfeeeb$var$_UFOStateAvailableTra = {}, (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).NOT_STARTED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).STARTED.id, [
    (0, $3ZHVV.UFOExperienceState).IN_PROGRESS.id,
    (0, $3ZHVV.UFOExperienceState).BLOCKED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).IN_PROGRESS.id, [
    (0, $3ZHVV.UFOExperienceState).BLOCKED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).BLOCKED.id, [
    (0, $3ZHVV.UFOExperienceState).RECOVERED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).RECOVERED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $3ZHVV.UFOExperienceState).SUCCEEDED.id,
    (0, $3ZHVV.UFOExperienceState).FAILED.id,
    (0, $3ZHVV.UFOExperienceState).ABORTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).FAILED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), (0, $l885a.default)($21eb480796cfeeeb$var$_UFOStateAvailableTra, (0, $3ZHVV.UFOExperienceState).ABORTED.id, [
    (0, $3ZHVV.UFOExperienceState).STARTED.id
]), $21eb480796cfeeeb$var$_UFOStateAvailableTra);
var $21eb480796cfeeeb$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $21eb480796cfeeeb$var$UFOStateAvailableTransitions[state1.id] && $21eb480796cfeeeb$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});





parcelRegister("eR566", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareIcon", function () { return $ad09f82b55244efa$export$c3835feba2a66e67; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $ad09f82b55244efa$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 32 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"108.695%\" x2=\"12.439%\" y1=\"-14.936%\" y2=\"45.215%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"0%\" x2=\"91.029%\" y1=\"118.55%\" y2=\"63.971%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z\" />\n      <path fill=\"url(#").concat(id, "-1\" d=\"M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z\" />\n      <path fill=\"url(#").concat(id, "-2\" d=\"M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z\" />\n    </g>\n  </svg>");
};
var $ad09f82b55244efa$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $ad09f82b55244efa$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("kKPLy", function(module, exports) {
$parcel$export(module.exports, "useId", function () { return $f1c0423122792582$export$f680877a34711e37; });

var $2SXKI = parcelRequire("2SXKI");

var $1oC0p = parcelRequire("1oC0p");

var $6JmtO = parcelRequire("6JmtO");

var $glNDr = parcelRequire("glNDr");
var $f1c0423122792582$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $f1c0423122792582$var$react18UseId = ($f1c0423122792582$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useId) !== null && $f1c0423122792582$var$_React$useId !== void 0 ? $f1c0423122792582$var$_React$useId : undefined;
function $f1c0423122792582$export$f680877a34711e37() {
    if ($f1c0423122792582$var$react18UseId && (0, $glNDr.fg)('platform.design-system-team.react-18-use-id_mn8q4')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $f1c0423122792582$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $6JmtO.useUID)());
}
var $f1c0423122792582$export$6be90bcb437e928f = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($f1c0423122792582$export$f680877a34711e37()).concat(postfix);
    (0, $1oC0p.useEffect)(function() {
        if (!ref) return;
        switch((0, $2SXKI.default)(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, $2SXKI.default)(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $f1c0423122792582$export$6ee17796e3d70de2() {
    if ($f1c0423122792582$var$react18UseId && (0, $glNDr.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $f1c0423122792582$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6JmtO.useUIDSeed)();
}

});


parcelRegister("chlLd", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementIcon", function () { return $8f07f3c3869018f7$export$7330b9fc5718fd30; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $kKPLy = parcelRequire("kKPLy");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $8f07f3c3869018f7$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $eggzj.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n    <svg\n      fill=\"none\"\n      height=\"32\"\n      viewBox=\"0 0 32 32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <linearGradient\n        id=\"".concat(id, "\"\n        gradientUnits=\"userSpaceOnUse\"\n        x1=\"13.9485\"\n        x2=\"20.7792\"\n        y1=\"20.2388\"\n        y2=\"11.8277\"\n      >\n        <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " />\n        <stop offset=\"100%\" stop-color=\"").concat(colors.iconGradientStop, "\" />\n      </linearGradient>\n      <path\n        d=\"m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z\"\n        fill=\"url(#").concat(id, ")\"\n      />\n      <path\n      fill=\"").concat(colors.iconColor, "\"\n      d=\"m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z\"\n      />\n    </svg>");
};
var $8f07f3c3869018f7$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Work Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $kKPLy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $8f07f3c3869018f7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4ZpaI", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $3a20628da031bb87$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("1oC0p");


var $adHov = parcelRequire("adHov");
var $3a20628da031bb87$var$strictApi = (0, $adHov.createStrictAPI)();
var $3a20628da031bb87$export$dbf350e5966cf602 = $3a20628da031bb87$var$strictApi.css;
var $3a20628da031bb87$export$eb1ecd84a24ee424 = $3a20628da031bb87$var$strictApi.cssMap;
$3a20628da031bb87$var$strictApi.cssMap;
var $3a20628da031bb87$export$a274e22fb40f762e = $3a20628da031bb87$var$strictApi.cx;
var $3a20628da031bb87$var$XCSSProp = $3a20628da031bb87$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("adHov", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", function () { return $770cc77e9a9570a2$export$39716b4af53f4ad; });

var $jfTaL = parcelRequire("jfTaL");

var $3sHnI = parcelRequire("3sHnI");
function $770cc77e9a9570a2$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $jfTaL.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $jfTaL.createStrictSetupError)();
        },
        cx: $3sHnI.cx,
        XCSSProp () {
            throw (0, $jfTaL.createStrictSetupError)();
        }
    };
}

});
parcelRegister("jfTaL", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", function () { return $e04a372ede62fd0e$export$c4df1cb0c2b4d77c; });
const $e04a372ede62fd0e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $e04a372ede62fd0e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("3sHnI", function(module, exports) {
$parcel$export(module.exports, "cx", function () { return $2855a34b1870f1b9$export$a274e22fb40f762e; });

var $2jatx = parcelRequire("2jatx");
const $2855a34b1870f1b9$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $2jatx.default)(actualStyles);
};

});



parcelRegister("Il3dn", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("leqii", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f74f4d43cffd7f04$var$_react = $f74f4d43cffd7f04$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f74f4d43cffd7f04$var$_baseNew = $f74f4d43cffd7f04$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f74f4d43cffd7f04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f74f4d43cffd7f04$var$EpicIcon = (props)=>/*#__PURE__*/ $f74f4d43cffd7f04$var$_react.default.createElement($f74f4d43cffd7f04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$f74f4d43cffd7f04$var$EpicIcon.displayName = 'EpicIcon';
var $f74f4d43cffd7f04$var$_default = module.exports.default = $f74f4d43cffd7f04$var$EpicIcon;

});

parcelRegister("dJqoM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ff3f48be8ac951c$var$_react = $9ff3f48be8ac951c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9ff3f48be8ac951c$var$_baseNew = $9ff3f48be8ac951c$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $9ff3f48be8ac951c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ff3f48be8ac951c$var$TaskIcon = (props)=>/*#__PURE__*/ $9ff3f48be8ac951c$var$_react.default.createElement($9ff3f48be8ac951c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$9ff3f48be8ac951c$var$TaskIcon.displayName = 'TaskIcon';
var $9ff3f48be8ac951c$var$_default = module.exports.default = $9ff3f48be8ac951c$var$TaskIcon;

});

parcelRegister("2u2Jd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hxJDR = parcelRequire("hxJDR");
var $1cf07fdf0b6a767a$var$_extends3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($hxJDR);

var $assfS = parcelRequire("assfS");
var $1cf07fdf0b6a767a$var$_getPrototypeOf2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($assfS);

var $6hpgc = parcelRequire("6hpgc");
var $1cf07fdf0b6a767a$var$_classCallCheck3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($6hpgc);

var $eoU9h = parcelRequire("eoU9h");
var $1cf07fdf0b6a767a$var$_createClass3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($eoU9h);

var $arjX2 = parcelRequire("arjX2");
var $1cf07fdf0b6a767a$var$_possibleConstructorReturn3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($arjX2);

var $fpmbk = parcelRequire("fpmbk");
var $1cf07fdf0b6a767a$var$_inherits3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($fpmbk);

var $1oC0p = parcelRequire("1oC0p");
var $1cf07fdf0b6a767a$var$_react2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($1oC0p);

var $4OgEb = parcelRequire("4OgEb");
var $1cf07fdf0b6a767a$var$_propTypes2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($4OgEb);

var $lDo4H = parcelRequire("lDo4H");
var $1cf07fdf0b6a767a$var$_lottieWeb2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($lDo4H);
function $1cf07fdf0b6a767a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1cf07fdf0b6a767a$var$Lottie = function(_React$Component) {
    (0, $1cf07fdf0b6a767a$var$_inherits3.default)(Lottie, _React$Component);
    function Lottie() {
        var _ref;
        var _temp, _this, _ret;
        (0, $1cf07fdf0b6a767a$var$_classCallCheck3.default)(this, Lottie);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $1cf07fdf0b6a767a$var$_possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, $1cf07fdf0b6a767a$var$_getPrototypeOf2.default)(Lottie)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleClickToPause = function() {
            // The pause() method is for handling pausing by passing a prop isPaused
            // This method is for handling the ability to pause by clicking on the animation
            if (_this.anim.isPaused) _this.anim.play();
            else _this.anim.pause();
        }, _temp), (0, $1cf07fdf0b6a767a$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $1cf07fdf0b6a767a$var$_createClass3.default)(Lottie, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, options = _props.options, eventListeners = _props.eventListeners;
                var loop = options.loop, autoplay = options.autoplay, animationData = options.animationData, rendererSettings = options.rendererSettings, segments = options.segments;
                this.options = {
                    container: this.el,
                    renderer: 'svg',
                    loop: loop !== false,
                    autoplay: autoplay !== false,
                    segments: segments !== false,
                    animationData: animationData,
                    rendererSettings: rendererSettings
                };
                this.options = (0, $1cf07fdf0b6a767a$var$_extends3.default)({}, this.options, options);
                this.anim = $1cf07fdf0b6a767a$var$_lottieWeb2.default.loadAnimation(this.options);
                this.registerEvents(eventListeners);
            }
        },
        {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps /* , nextState */ ) {
                /* Recreate the animation handle if the data is changed */ if (this.options.animationData !== nextProps.options.animationData) {
                    this.deRegisterEvents(this.props.eventListeners);
                    this.destroy();
                    this.options = (0, $1cf07fdf0b6a767a$var$_extends3.default)({}, this.options, nextProps.options);
                    this.anim = $1cf07fdf0b6a767a$var$_lottieWeb2.default.loadAnimation(this.options);
                    this.registerEvents(nextProps.eventListeners);
                }
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.props.isStopped) this.stop();
                else if (this.props.segments) this.playSegments();
                else this.play();
                this.pause();
                this.setSpeed();
                this.setDirection();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.deRegisterEvents(this.props.eventListeners);
                this.destroy();
                this.options.animationData = null;
                this.anim = null;
            }
        },
        {
            key: 'setSpeed',
            value: function setSpeed() {
                this.anim.setSpeed(this.props.speed);
            }
        },
        {
            key: 'setDirection',
            value: function setDirection() {
                this.anim.setDirection(this.props.direction);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.anim.play();
            }
        },
        {
            key: 'playSegments',
            value: function playSegments() {
                this.anim.playSegments(this.props.segments);
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.anim.stop();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                if (this.props.isPaused && !this.anim.isPaused) this.anim.pause();
                else if (!this.props.isPaused && this.anim.isPaused) this.anim.pause();
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.anim.destroy();
            }
        },
        {
            key: 'registerEvents',
            value: function registerEvents(eventListeners) {
                var _this2 = this;
                eventListeners.forEach(function(eventListener) {
                    _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'deRegisterEvents',
            value: function deRegisterEvents(eventListeners) {
                var _this3 = this;
                eventListeners.forEach(function(eventListener) {
                    _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, width = _props2.width, height = _props2.height, ariaRole = _props2.ariaRole, ariaLabel = _props2.ariaLabel, isClickToPauseDisabled = _props2.isClickToPauseDisabled, title = _props2.title;
                var getSize = function getSize(initial) {
                    var size = void 0;
                    if (typeof initial === 'number') size = initial + 'px';
                    else size = initial || '100%';
                    return size;
                };
                var lottieStyles = (0, $1cf07fdf0b6a767a$var$_extends3.default)({
                    width: getSize(width),
                    height: getSize(height),
                    overflow: 'hidden',
                    margin: '0 auto',
                    outline: 'none'
                }, this.props.style);
                var onClickHandler = isClickToPauseDisabled ? function() {
                    return null;
                } : this.handleClickToPause;
                return(// Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                $1cf07fdf0b6a767a$var$_react2.default.createElement('div', {
                    ref: function ref(c) {
                        _this4.el = c;
                    },
                    style: lottieStyles,
                    onClick: onClickHandler,
                    title: title,
                    role: ariaRole,
                    'aria-label': ariaLabel,
                    tabIndex: '0'
                }));
            }
        }
    ]);
    return Lottie;
}($1cf07fdf0b6a767a$var$_react2.default.Component);
module.exports.default = $1cf07fdf0b6a767a$var$Lottie;
$1cf07fdf0b6a767a$var$Lottie.propTypes = {
    eventListeners: $1cf07fdf0b6a767a$var$_propTypes2.default.arrayOf($1cf07fdf0b6a767a$var$_propTypes2.default.object),
    options: $1cf07fdf0b6a767a$var$_propTypes2.default.object.isRequired,
    height: $1cf07fdf0b6a767a$var$_propTypes2.default.oneOfType([
        $1cf07fdf0b6a767a$var$_propTypes2.default.string,
        $1cf07fdf0b6a767a$var$_propTypes2.default.number
    ]),
    width: $1cf07fdf0b6a767a$var$_propTypes2.default.oneOfType([
        $1cf07fdf0b6a767a$var$_propTypes2.default.string,
        $1cf07fdf0b6a767a$var$_propTypes2.default.number
    ]),
    isStopped: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    isPaused: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    speed: $1cf07fdf0b6a767a$var$_propTypes2.default.number,
    segments: $1cf07fdf0b6a767a$var$_propTypes2.default.arrayOf($1cf07fdf0b6a767a$var$_propTypes2.default.number),
    direction: $1cf07fdf0b6a767a$var$_propTypes2.default.number,
    ariaRole: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    ariaLabel: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    isClickToPauseDisabled: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    title: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    style: $1cf07fdf0b6a767a$var$_propTypes2.default.string
};
$1cf07fdf0b6a767a$var$Lottie.defaultProps = {
    eventListeners: [],
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: 'button',
    ariaLabel: 'animation',
    isClickToPauseDisabled: false,
    title: ''
};

});
parcelRegister("hxJDR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $cc58ec3eb70ca8a9$export$1e511d4a378977f5; }, function (v) { return $cc58ec3eb70ca8a9$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $cc58ec3eb70ca8a9$export$2e2bcd8739ae039; }, function (v) { return $cc58ec3eb70ca8a9$export$2e2bcd8739ae039 = v; });
var $cc58ec3eb70ca8a9$export$1e511d4a378977f5;
var $cc58ec3eb70ca8a9$export$2e2bcd8739ae039;
"use strict";
$cc58ec3eb70ca8a9$export$1e511d4a378977f5 = true;

var $5Ibi5 = parcelRequire("5Ibi5");
var $cc58ec3eb70ca8a9$var$_assign2 = $cc58ec3eb70ca8a9$var$_interopRequireDefault($5Ibi5);
function $cc58ec3eb70ca8a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$cc58ec3eb70ca8a9$export$2e2bcd8739ae039 = $cc58ec3eb70ca8a9$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("5Ibi5", function(module, exports) {

module.exports = {
    "default": (parcelRequire("3aJcb")),
    __esModule: true
};

});
parcelRegister("3aJcb", function(module, exports) {
parcelRequire("fsMh2");

module.exports = (parcelRequire("23f7N")).Object.assign;

});
parcelRegister("fsMh2", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $6TZmN = parcelRequire("6TZmN");

$6TZmN($6TZmN.S + $6TZmN.F, 'Object', {
    assign: (parcelRequire("cNTzW"))
});

});
parcelRegister("6TZmN", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");

var $23f7N = parcelRequire("23f7N");

var $04VsN = parcelRequire("04VsN");

var $1XBAS = parcelRequire("1XBAS");

var $763mL = parcelRequire("763mL");
var $50677b4cdf98284c$var$PROTOTYPE = 'prototype';
var $50677b4cdf98284c$var$$export = function(type, name, source) {
    var IS_FORCED = type & $50677b4cdf98284c$var$$export.F;
    var IS_GLOBAL = type & $50677b4cdf98284c$var$$export.G;
    var IS_STATIC = type & $50677b4cdf98284c$var$$export.S;
    var IS_PROTO = type & $50677b4cdf98284c$var$$export.P;
    var IS_BIND = type & $50677b4cdf98284c$var$$export.B;
    var IS_WRAP = type & $50677b4cdf98284c$var$$export.W;
    var exports = IS_GLOBAL ? $23f7N : $23f7N[name] || ($23f7N[name] = {});
    var expProto = exports[$50677b4cdf98284c$var$PROTOTYPE];
    var target = IS_GLOBAL ? $4FFa4 : IS_STATIC ? $4FFa4[name] : ($4FFa4[name] || {})[$50677b4cdf98284c$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $763mL(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $04VsN(out, $4FFa4) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$50677b4cdf98284c$var$PROTOTYPE] = C[$50677b4cdf98284c$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $04VsN(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $50677b4cdf98284c$var$$export.R && expProto && !expProto[key]) $1XBAS(expProto, key, out);
        }
    }
};
// type bitmap
$50677b4cdf98284c$var$$export.F = 1; // forced
$50677b4cdf98284c$var$$export.G = 2; // global
$50677b4cdf98284c$var$$export.S = 4; // static
$50677b4cdf98284c$var$$export.P = 8; // proto
$50677b4cdf98284c$var$$export.B = 16; // bind
$50677b4cdf98284c$var$$export.W = 32; // wrap
$50677b4cdf98284c$var$$export.U = 64; // safe
$50677b4cdf98284c$var$$export.R = 128; // real proto method for `library`
module.exports = $50677b4cdf98284c$var$$export;

});
parcelRegister("4FFa4", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $366aeb9262291f44$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $366aeb9262291f44$var$global; // eslint-disable-line no-undef

});

parcelRegister("23f7N", function(module, exports) {
var $17e7980f5bcf229c$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $17e7980f5bcf229c$var$core; // eslint-disable-line no-undef

});

parcelRegister("04VsN", function(module, exports) {
// optional / simple context binding

var $2045g = parcelRequire("2045g");
module.exports = function(fn, that, length) {
    $2045g(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("2045g", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("1XBAS", function(module, exports) {

var $19vSD = parcelRequire("19vSD");

var $kKJnZ = parcelRequire("kKJnZ");

module.exports = (parcelRequire("2PPTD")) ? function(object, key, value) {
    return $19vSD.f(object, key, $kKJnZ(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("19vSD", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $0d6f5c78ac7c57a6$export$2d1720544b23b823; }, function (v) { return $0d6f5c78ac7c57a6$export$2d1720544b23b823 = v; });
var $0d6f5c78ac7c57a6$export$2d1720544b23b823;

var $5asEa = parcelRequire("5asEa");

var $1Vpr5 = parcelRequire("1Vpr5");

var $bIV2P = parcelRequire("bIV2P");
var $0d6f5c78ac7c57a6$var$dP = Object.defineProperty;

$0d6f5c78ac7c57a6$export$2d1720544b23b823 = (parcelRequire("2PPTD")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $5asEa(O);
    P = $bIV2P(P, true);
    $5asEa(Attributes);
    if ($1Vpr5) try {
        return $0d6f5c78ac7c57a6$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("5asEa", function(module, exports) {

var $7QZ8S = parcelRequire("7QZ8S");
module.exports = function(it) {
    if (!$7QZ8S(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("7QZ8S", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("1Vpr5", function(module, exports) {



module.exports = !(parcelRequire("2PPTD")) && !(parcelRequire("hs8hK"))(function() {
    return Object.defineProperty((parcelRequire("kjubI"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2PPTD", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("hs8hK"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("hs8hK", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("kjubI", function(module, exports) {

var $7QZ8S = parcelRequire("7QZ8S");

var $4FFa4 = parcelRequire("4FFa4");
var $ec9cffabb69d468c$require$document = $4FFa4.document;
// typeof document.createElement is 'object' in old IE
var $ec9cffabb69d468c$var$is = $7QZ8S($ec9cffabb69d468c$require$document) && $7QZ8S($ec9cffabb69d468c$require$document.createElement);
module.exports = function(it) {
    return $ec9cffabb69d468c$var$is ? $ec9cffabb69d468c$require$document.createElement(it) : {};
};

});


parcelRegister("bIV2P", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $7QZ8S = parcelRequire("7QZ8S");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$7QZ8S(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("kKJnZ", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("763mL", function(module, exports) {
var $52abb468452e06ed$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $52abb468452e06ed$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("cNTzW", function(module, exports) {
'use strict';

var $2PPTD = parcelRequire("2PPTD");

var $E0yCE = parcelRequire("E0yCE");

var $jBejz = parcelRequire("jBejz");

var $gGh3r = parcelRequire("gGh3r");

var $7tWaA = parcelRequire("7tWaA");

var $kMWzF = parcelRequire("kMWzF");
var $95252c6fd67bc852$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$95252c6fd67bc852$var$$assign || (parcelRequire("hs8hK"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $95252c6fd67bc852$var$$assign({}, A)[S] != 7 || Object.keys($95252c6fd67bc852$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $7tWaA(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $jBejz.f;
    var isEnum = $gGh3r.f;
    while(aLen > index){
        var S = $kMWzF(arguments[index++]);
        var keys = getSymbols ? $E0yCE(S).concat(getSymbols(S)) : $E0yCE(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2PPTD || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $95252c6fd67bc852$var$$assign;

});
parcelRegister("E0yCE", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $64rCp = parcelRequire("64rCp");

var $f5whe = parcelRequire("f5whe");
module.exports = Object.keys || function keys(O) {
    return $64rCp(O, $f5whe);
};

});
parcelRegister("64rCp", function(module, exports) {

var $763mL = parcelRequire("763mL");

var $2hx6g = parcelRequire("2hx6g");

var $46b88a3ecfad9eac$var$arrayIndexOf = (parcelRequire("5sIDY"))(false);

var $46b88a3ecfad9eac$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $2hx6g(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $46b88a3ecfad9eac$var$IE_PROTO) $763mL(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($763mL(O, key = names[i++])) ~$46b88a3ecfad9eac$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("2hx6g", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $kMWzF = parcelRequire("kMWzF");

var $bwTK5 = parcelRequire("bwTK5");
module.exports = function(it) {
    return $kMWzF($bwTK5(it));
};

});
parcelRegister("kMWzF", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $gNg6c = parcelRequire("gNg6c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $gNg6c(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("gNg6c", function(module, exports) {
var $c39db5dd98abd16e$var$toString = {}.toString;
module.exports = function(it) {
    return $c39db5dd98abd16e$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("bwTK5", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("5sIDY", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $2hx6g = parcelRequire("2hx6g");

var $f0lw7 = parcelRequire("f0lw7");

var $6AE42 = parcelRequire("6AE42");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $2hx6g($this);
        var length = $f0lw7(O.length);
        var index = $6AE42(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("f0lw7", function(module, exports) {
// 7.1.15 ToLength

var $3ylxK = parcelRequire("3ylxK");
var $aec78bf4e7ec90d9$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $aec78bf4e7ec90d9$var$min($3ylxK(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("3ylxK", function(module, exports) {
// 7.1.4 ToInteger
var $2965421f6a410d04$var$ceil = Math.ceil;
var $2965421f6a410d04$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $2965421f6a410d04$var$floor : $2965421f6a410d04$var$ceil)(it);
};

});


parcelRegister("6AE42", function(module, exports) {

var $3ylxK = parcelRequire("3ylxK");
var $4cc52ebfd89326d3$var$max = Math.max;
var $4cc52ebfd89326d3$var$min = Math.min;
module.exports = function(index, length) {
    index = $3ylxK(index);
    return index < 0 ? $4cc52ebfd89326d3$var$max(index + length, 0) : $4cc52ebfd89326d3$var$min(index, length);
};

});


parcelRegister("9gke3", function(module, exports) {

var $6be54c1617561861$var$shared = (parcelRequire("izZ3Q"))('keys');

var $hoAgo = parcelRequire("hoAgo");
module.exports = function(key) {
    return $6be54c1617561861$var$shared[key] || ($6be54c1617561861$var$shared[key] = $hoAgo(key));
};

});
parcelRegister("izZ3Q", function(module, exports) {

var $23f7N = parcelRequire("23f7N");

var $4FFa4 = parcelRequire("4FFa4");
var $d86adc506cb5ba45$var$SHARED = '__core-js_shared__';
var $d86adc506cb5ba45$var$store = $4FFa4[$d86adc506cb5ba45$var$SHARED] || ($4FFa4[$d86adc506cb5ba45$var$SHARED] = {});

(module.exports = function(key, value) {
    return $d86adc506cb5ba45$var$store[key] || ($d86adc506cb5ba45$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $23f7N.version,
    mode: (parcelRequire("jHsIx")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("jHsIx", function(module, exports) {
module.exports = true;

});


parcelRegister("hoAgo", function(module, exports) {
var $caa0ceb2324f08b0$var$id = 0;
var $caa0ceb2324f08b0$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$caa0ceb2324f08b0$var$id + $caa0ceb2324f08b0$var$px).toString(36));
};

});



parcelRegister("f5whe", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("jBejz", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $e44c939e5b5d76a8$export$2d1720544b23b823; }, function (v) { return $e44c939e5b5d76a8$export$2d1720544b23b823 = v; });
var $e44c939e5b5d76a8$export$2d1720544b23b823;
$e44c939e5b5d76a8$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("gGh3r", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $c24dcc42a8b9bb86$export$2d1720544b23b823; }, function (v) { return $c24dcc42a8b9bb86$export$2d1720544b23b823 = v; });
var $c24dcc42a8b9bb86$export$2d1720544b23b823;
$c24dcc42a8b9bb86$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("7tWaA", function(module, exports) {
// 7.1.13 ToObject(argument)

var $bwTK5 = parcelRequire("bwTK5");
module.exports = function(it) {
    return Object($bwTK5(it));
};

});






parcelRegister("assfS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5rUW5")),
    __esModule: true
};

});
parcelRegister("5rUW5", function(module, exports) {
parcelRequire("iULCI");

module.exports = (parcelRequire("23f7N")).Object.getPrototypeOf;

});
parcelRegister("iULCI", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $7tWaA = parcelRequire("7tWaA");

var $kxvda = parcelRequire("kxvda");

(parcelRequire("bcSMG"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $kxvda($7tWaA(it));
    };
});

});
parcelRegister("kxvda", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $763mL = parcelRequire("763mL");

var $7tWaA = parcelRequire("7tWaA");

var $ef3f19ab31140719$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
var $ef3f19ab31140719$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $7tWaA(O);
    if ($763mL(O, $ef3f19ab31140719$var$IE_PROTO)) return O[$ef3f19ab31140719$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $ef3f19ab31140719$var$ObjectProto : null;
};

});

parcelRegister("bcSMG", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $6TZmN = parcelRequire("6TZmN");

var $23f7N = parcelRequire("23f7N");

var $hs8hK = parcelRequire("hs8hK");
module.exports = function(KEY, exec) {
    var fn = ($23f7N.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $6TZmN($6TZmN.S + $6TZmN.F * $hs8hK(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("6hpgc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $4927ecc8d63b2fec$export$1e511d4a378977f5; }, function (v) { return $4927ecc8d63b2fec$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $4927ecc8d63b2fec$export$2e2bcd8739ae039; }, function (v) { return $4927ecc8d63b2fec$export$2e2bcd8739ae039 = v; });
var $4927ecc8d63b2fec$export$1e511d4a378977f5;
var $4927ecc8d63b2fec$export$2e2bcd8739ae039;
"use strict";
$4927ecc8d63b2fec$export$1e511d4a378977f5 = true;
$4927ecc8d63b2fec$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("eoU9h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $a7bedc85ff7818cc$export$1e511d4a378977f5; }, function (v) { return $a7bedc85ff7818cc$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $a7bedc85ff7818cc$export$2e2bcd8739ae039; }, function (v) { return $a7bedc85ff7818cc$export$2e2bcd8739ae039 = v; });
var $a7bedc85ff7818cc$export$1e511d4a378977f5;
var $a7bedc85ff7818cc$export$2e2bcd8739ae039;
"use strict";
$a7bedc85ff7818cc$export$1e511d4a378977f5 = true;

var $eYaOS = parcelRequire("eYaOS");
var $a7bedc85ff7818cc$var$_defineProperty2 = $a7bedc85ff7818cc$var$_interopRequireDefault($eYaOS);
function $a7bedc85ff7818cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a7bedc85ff7818cc$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $a7bedc85ff7818cc$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("eYaOS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kxJeH")),
    __esModule: true
};

});
parcelRegister("kxJeH", function(module, exports) {
parcelRequire("hlCNl");

var $23f7N = parcelRequire("23f7N");
var $ef49faa80d2c2f9b$require$$Object = $23f7N.Object;
module.exports = function defineProperty(it, key, desc) {
    return $ef49faa80d2c2f9b$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("hlCNl", function(module, exports) {

var $6TZmN = parcelRequire("6TZmN");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$6TZmN($6TZmN.S + $6TZmN.F * !(parcelRequire("2PPTD")), 'Object', {
    defineProperty: (parcelRequire("19vSD")).f
});

});




parcelRegister("arjX2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $799be6e526c9d7f5$export$1e511d4a378977f5; }, function (v) { return $799be6e526c9d7f5$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $799be6e526c9d7f5$export$2e2bcd8739ae039; }, function (v) { return $799be6e526c9d7f5$export$2e2bcd8739ae039 = v; });
var $799be6e526c9d7f5$export$1e511d4a378977f5;
var $799be6e526c9d7f5$export$2e2bcd8739ae039;
"use strict";
$799be6e526c9d7f5$export$1e511d4a378977f5 = true;

var $frdl0 = parcelRequire("frdl0");
var $799be6e526c9d7f5$var$_typeof3 = $799be6e526c9d7f5$var$_interopRequireDefault($frdl0);
function $799be6e526c9d7f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$799be6e526c9d7f5$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $799be6e526c9d7f5$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("frdl0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $b3d3b93c2659cce8$export$1e511d4a378977f5; }, function (v) { return $b3d3b93c2659cce8$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $b3d3b93c2659cce8$export$2e2bcd8739ae039; }, function (v) { return $b3d3b93c2659cce8$export$2e2bcd8739ae039 = v; });
var $b3d3b93c2659cce8$export$1e511d4a378977f5;
var $b3d3b93c2659cce8$export$2e2bcd8739ae039;
"use strict";
$b3d3b93c2659cce8$export$1e511d4a378977f5 = true;

var $73CEX = parcelRequire("73CEX");
var $b3d3b93c2659cce8$var$_iterator2 = $b3d3b93c2659cce8$var$_interopRequireDefault($73CEX);

var $7xVAR = parcelRequire("7xVAR");
var $b3d3b93c2659cce8$var$_symbol2 = $b3d3b93c2659cce8$var$_interopRequireDefault($7xVAR);
var $b3d3b93c2659cce8$var$_typeof = typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && typeof $b3d3b93c2659cce8$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && obj.constructor === $b3d3b93c2659cce8$var$_symbol2.default && obj !== $b3d3b93c2659cce8$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $b3d3b93c2659cce8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b3d3b93c2659cce8$export$2e2bcd8739ae039 = typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && $b3d3b93c2659cce8$var$_typeof($b3d3b93c2659cce8$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $b3d3b93c2659cce8$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && obj.constructor === $b3d3b93c2659cce8$var$_symbol2.default && obj !== $b3d3b93c2659cce8$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $b3d3b93c2659cce8$var$_typeof(obj);
};

});
parcelRegister("73CEX", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kX62j")),
    __esModule: true
};

});
parcelRegister("kX62j", function(module, exports) {
parcelRequire("kvp0v");
parcelRequire("a6Pd3");

module.exports = (parcelRequire("iY0Fa")).f('iterator');

});
parcelRegister("kvp0v", function(module, exports) {
'use strict';

var $eeda19c7512e8b4e$var$$at = (parcelRequire("evNBk"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("1MYRJ"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $eeda19c7512e8b4e$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("evNBk", function(module, exports) {

var $3ylxK = parcelRequire("3ylxK");

var $bwTK5 = parcelRequire("bwTK5");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($bwTK5(that));
        var i = $3ylxK(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("1MYRJ", function(module, exports) {
'use strict';

var $jHsIx = parcelRequire("jHsIx");

var $6TZmN = parcelRequire("6TZmN");

var $aDsEo = parcelRequire("aDsEo");

var $1XBAS = parcelRequire("1XBAS");

var $aODcA = parcelRequire("aODcA");

var $gRPe6 = parcelRequire("gRPe6");

var $jr22O = parcelRequire("jr22O");

var $kxvda = parcelRequire("kxvda");

var $14d97ccfd41e5645$var$ITERATOR = (parcelRequire("9xDAg"))('iterator');
var $14d97ccfd41e5645$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $14d97ccfd41e5645$var$FF_ITERATOR = '@@iterator';
var $14d97ccfd41e5645$var$KEYS = 'keys';
var $14d97ccfd41e5645$var$VALUES = 'values';
var $14d97ccfd41e5645$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $gRPe6(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$14d97ccfd41e5645$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $14d97ccfd41e5645$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $14d97ccfd41e5645$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $14d97ccfd41e5645$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$14d97ccfd41e5645$var$ITERATOR] || proto[$14d97ccfd41e5645$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $kxvda($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $jr22O(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$jHsIx && typeof IteratorPrototype[$14d97ccfd41e5645$var$ITERATOR] != 'function') $1XBAS(IteratorPrototype, $14d97ccfd41e5645$var$ITERATOR, $14d97ccfd41e5645$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $14d97ccfd41e5645$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$jHsIx || FORCED) && ($14d97ccfd41e5645$var$BUGGY || VALUES_BUG || !proto[$14d97ccfd41e5645$var$ITERATOR])) $1XBAS(proto, $14d97ccfd41e5645$var$ITERATOR, $default);
    // Plug for library
    $aODcA[NAME] = $default;
    $aODcA[TAG] = $14d97ccfd41e5645$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($14d97ccfd41e5645$var$VALUES),
            keys: IS_SET ? $default : getMethod($14d97ccfd41e5645$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $aDsEo(proto, key, methods[key]);
        } else $6TZmN($6TZmN.P + $6TZmN.F * ($14d97ccfd41e5645$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("aDsEo", function(module, exports) {

module.exports = (parcelRequire("1XBAS"));

});

parcelRegister("aODcA", function(module, exports) {
module.exports = {};

});

parcelRegister("gRPe6", function(module, exports) {
'use strict';

var $lmUsf = parcelRequire("lmUsf");

var $kKJnZ = parcelRequire("kKJnZ");

var $jr22O = parcelRequire("jr22O");
var $c4795519cce9da72$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("1XBAS"))($c4795519cce9da72$var$IteratorPrototype, (parcelRequire("9xDAg"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $lmUsf($c4795519cce9da72$var$IteratorPrototype, {
        next: $kKJnZ(1, next)
    });
    $jr22O(Constructor, NAME + ' Iterator');
};

});
parcelRegister("lmUsf", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $5asEa = parcelRequire("5asEa");

var $6Gg6R = parcelRequire("6Gg6R");

var $f5whe = parcelRequire("f5whe");

var $f8e771c717e03d19$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
var $f8e771c717e03d19$var$Empty = function() {};
var $f8e771c717e03d19$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f8e771c717e03d19$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("kjubI"))('iframe');
    var i = $f5whe.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("h3ZDN")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $f8e771c717e03d19$var$createDict = iframeDocument.F;
    while(i--)delete $f8e771c717e03d19$var$createDict[$f8e771c717e03d19$var$PROTOTYPE][$f5whe[i]];
    return $f8e771c717e03d19$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f8e771c717e03d19$var$Empty[$f8e771c717e03d19$var$PROTOTYPE] = $5asEa(O);
        result = new $f8e771c717e03d19$var$Empty();
        $f8e771c717e03d19$var$Empty[$f8e771c717e03d19$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f8e771c717e03d19$var$IE_PROTO] = O;
    } else result = $f8e771c717e03d19$var$createDict();
    return Properties === undefined ? result : $6Gg6R(result, Properties);
};

});
parcelRegister("6Gg6R", function(module, exports) {

var $19vSD = parcelRequire("19vSD");

var $5asEa = parcelRequire("5asEa");

var $E0yCE = parcelRequire("E0yCE");

module.exports = (parcelRequire("2PPTD")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $5asEa(O);
    var keys = $E0yCE(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$19vSD.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("h3ZDN", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");
var $c6c2880f85f59af4$require$document = $4FFa4.document;
module.exports = $c6c2880f85f59af4$require$document && $c6c2880f85f59af4$require$document.documentElement;

});


parcelRegister("jr22O", function(module, exports) {

var $19vSD = parcelRequire("19vSD");
var $e2621feb5510ea07$require$def = $19vSD.f;

var $763mL = parcelRequire("763mL");

var $e2621feb5510ea07$var$TAG = (parcelRequire("9xDAg"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$763mL(it = stat ? it : it.prototype, $e2621feb5510ea07$var$TAG)) $e2621feb5510ea07$require$def(it, $e2621feb5510ea07$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("9xDAg", function(module, exports) {

var $6f25e6afc0784b1a$var$store = (parcelRequire("izZ3Q"))('wks');

var $hoAgo = parcelRequire("hoAgo");

var $4FFa4 = parcelRequire("4FFa4");
var $6f25e6afc0784b1a$require$Symbol = $4FFa4.Symbol;
var $6f25e6afc0784b1a$var$USE_SYMBOL = typeof $6f25e6afc0784b1a$require$Symbol == 'function';
var $6f25e6afc0784b1a$var$$exports = module.exports = function(name) {
    return $6f25e6afc0784b1a$var$store[name] || ($6f25e6afc0784b1a$var$store[name] = $6f25e6afc0784b1a$var$USE_SYMBOL && $6f25e6afc0784b1a$require$Symbol[name] || ($6f25e6afc0784b1a$var$USE_SYMBOL ? $6f25e6afc0784b1a$require$Symbol : $hoAgo)('Symbol.' + name));
};
$6f25e6afc0784b1a$var$$exports.store = $6f25e6afc0784b1a$var$store;

});





parcelRegister("a6Pd3", function(module, exports) {
parcelRequire("lP6GC");

var $4FFa4 = parcelRequire("4FFa4");

var $1XBAS = parcelRequire("1XBAS");

var $aODcA = parcelRequire("aODcA");

var $75c23011e1e94f01$var$TO_STRING_TAG = (parcelRequire("9xDAg"))('toStringTag');
var $75c23011e1e94f01$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $75c23011e1e94f01$var$i = 0; $75c23011e1e94f01$var$i < $75c23011e1e94f01$var$DOMIterables.length; $75c23011e1e94f01$var$i++){
    var $75c23011e1e94f01$var$NAME = $75c23011e1e94f01$var$DOMIterables[$75c23011e1e94f01$var$i];
    var $75c23011e1e94f01$var$Collection = $4FFa4[$75c23011e1e94f01$var$NAME];
    var $75c23011e1e94f01$var$proto = $75c23011e1e94f01$var$Collection && $75c23011e1e94f01$var$Collection.prototype;
    if ($75c23011e1e94f01$var$proto && !$75c23011e1e94f01$var$proto[$75c23011e1e94f01$var$TO_STRING_TAG]) $1XBAS($75c23011e1e94f01$var$proto, $75c23011e1e94f01$var$TO_STRING_TAG, $75c23011e1e94f01$var$NAME);
    $aODcA[$75c23011e1e94f01$var$NAME] = $aODcA.Array;
}

});
parcelRegister("lP6GC", function(module, exports) {
'use strict';

var $aWD6E = parcelRequire("aWD6E");

var $1Kz5Q = parcelRequire("1Kz5Q");

var $aODcA = parcelRequire("aODcA");

var $2hx6g = parcelRequire("2hx6g");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("1MYRJ"))(Array, 'Array', function(iterated, kind) {
    this._t = $2hx6g(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $1Kz5Q(1);
    }
    if (kind == 'keys') return $1Kz5Q(0, index);
    if (kind == 'values') return $1Kz5Q(0, O[index]);
    return $1Kz5Q(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$aODcA.Arguments = $aODcA.Array;
$aWD6E('keys');
$aWD6E('values');
$aWD6E('entries');

});
parcelRegister("aWD6E", function(module, exports) {
module.exports = function() {};

});

parcelRegister("1Kz5Q", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("iY0Fa", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $dcee583f97a923c0$export$2d1720544b23b823; }, function (v) { return $dcee583f97a923c0$export$2d1720544b23b823 = v; });
var $dcee583f97a923c0$export$2d1720544b23b823;

$dcee583f97a923c0$export$2d1720544b23b823 = (parcelRequire("9xDAg"));

});



parcelRegister("7xVAR", function(module, exports) {

module.exports = {
    "default": (parcelRequire("iI7gd")),
    __esModule: true
};

});
parcelRegister("iI7gd", function(module, exports) {
parcelRequire("99gPT");
parcelRequire("cPEqH");
parcelRequire("9qJRy");
parcelRequire("lm1z6");

module.exports = (parcelRequire("23f7N")).Symbol;

});
parcelRegister("99gPT", function(module, exports) {
'use strict';

var $4FFa4 = parcelRequire("4FFa4");

var $763mL = parcelRequire("763mL");

var $2PPTD = parcelRequire("2PPTD");

var $6TZmN = parcelRequire("6TZmN");

var $aDsEo = parcelRequire("aDsEo");

var $cj3Wz = parcelRequire("cj3Wz");
var $6a920393d90de711$require$META = $cj3Wz.KEY;

var $hs8hK = parcelRequire("hs8hK");

var $izZ3Q = parcelRequire("izZ3Q");

var $jr22O = parcelRequire("jr22O");

var $hoAgo = parcelRequire("hoAgo");

var $9xDAg = parcelRequire("9xDAg");

var $iY0Fa = parcelRequire("iY0Fa");

var $9PxVb = parcelRequire("9PxVb");

var $8x7zY = parcelRequire("8x7zY");

var $lap9z = parcelRequire("lap9z");

var $5asEa = parcelRequire("5asEa");

var $7QZ8S = parcelRequire("7QZ8S");

var $7tWaA = parcelRequire("7tWaA");

var $2hx6g = parcelRequire("2hx6g");

var $bIV2P = parcelRequire("bIV2P");

var $kKJnZ = parcelRequire("kKJnZ");

var $lmUsf = parcelRequire("lmUsf");

var $76OH6 = parcelRequire("76OH6");

var $k9HHU = parcelRequire("k9HHU");

var $jBejz = parcelRequire("jBejz");

var $19vSD = parcelRequire("19vSD");

var $E0yCE = parcelRequire("E0yCE");
var $6a920393d90de711$var$gOPD = $k9HHU.f;
var $6a920393d90de711$var$dP = $19vSD.f;
var $6a920393d90de711$var$gOPN = $76OH6.f;
var $6a920393d90de711$var$$Symbol = $4FFa4.Symbol;
var $6a920393d90de711$var$$JSON = $4FFa4.JSON;
var $6a920393d90de711$var$_stringify = $6a920393d90de711$var$$JSON && $6a920393d90de711$var$$JSON.stringify;
var $6a920393d90de711$var$PROTOTYPE = 'prototype';
var $6a920393d90de711$var$HIDDEN = $9xDAg('_hidden');
var $6a920393d90de711$var$TO_PRIMITIVE = $9xDAg('toPrimitive');
var $6a920393d90de711$var$isEnum = {}.propertyIsEnumerable;
var $6a920393d90de711$var$SymbolRegistry = $izZ3Q('symbol-registry');
var $6a920393d90de711$var$AllSymbols = $izZ3Q('symbols');
var $6a920393d90de711$var$OPSymbols = $izZ3Q('op-symbols');
var $6a920393d90de711$var$ObjectProto = Object[$6a920393d90de711$var$PROTOTYPE];
var $6a920393d90de711$var$USE_NATIVE = typeof $6a920393d90de711$var$$Symbol == 'function' && !!$jBejz.f;
var $6a920393d90de711$var$QObject = $4FFa4.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $6a920393d90de711$var$setter = !$6a920393d90de711$var$QObject || !$6a920393d90de711$var$QObject[$6a920393d90de711$var$PROTOTYPE] || !$6a920393d90de711$var$QObject[$6a920393d90de711$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $6a920393d90de711$var$setSymbolDesc = $2PPTD && $hs8hK(function() {
    return $lmUsf($6a920393d90de711$var$dP({}, 'a', {
        get: function() {
            return $6a920393d90de711$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $6a920393d90de711$var$gOPD($6a920393d90de711$var$ObjectProto, key);
    if (protoDesc) delete $6a920393d90de711$var$ObjectProto[key];
    $6a920393d90de711$var$dP(it, key, D);
    if (protoDesc && it !== $6a920393d90de711$var$ObjectProto) $6a920393d90de711$var$dP($6a920393d90de711$var$ObjectProto, key, protoDesc);
} : $6a920393d90de711$var$dP;
var $6a920393d90de711$var$wrap = function(tag) {
    var sym = $6a920393d90de711$var$AllSymbols[tag] = $lmUsf($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $6a920393d90de711$var$isSymbol = $6a920393d90de711$var$USE_NATIVE && typeof $6a920393d90de711$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $6a920393d90de711$var$$Symbol;
};
var $6a920393d90de711$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $6a920393d90de711$var$ObjectProto) $6a920393d90de711$var$$defineProperty($6a920393d90de711$var$OPSymbols, key, D);
    $5asEa(it);
    key = $bIV2P(key, true);
    $5asEa(D);
    if ($763mL($6a920393d90de711$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$763mL(it, $6a920393d90de711$var$HIDDEN)) $6a920393d90de711$var$dP(it, $6a920393d90de711$var$HIDDEN, $kKJnZ(1, {}));
            it[$6a920393d90de711$var$HIDDEN][key] = true;
        } else {
            if ($763mL(it, $6a920393d90de711$var$HIDDEN) && it[$6a920393d90de711$var$HIDDEN][key]) it[$6a920393d90de711$var$HIDDEN][key] = false;
            D = $lmUsf(D, {
                enumerable: $kKJnZ(0, false)
            });
        }
        return $6a920393d90de711$var$setSymbolDesc(it, key, D);
    }
    return $6a920393d90de711$var$dP(it, key, D);
};
var $6a920393d90de711$var$$defineProperties = function defineProperties(it, P) {
    $5asEa(it);
    var keys = $8x7zY(P = $2hx6g(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$6a920393d90de711$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $6a920393d90de711$var$$create = function create(it, P) {
    return P === undefined ? $lmUsf(it) : $6a920393d90de711$var$$defineProperties($lmUsf(it), P);
};
var $6a920393d90de711$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $6a920393d90de711$var$isEnum.call(this, key = $bIV2P(key, true));
    if (this === $6a920393d90de711$var$ObjectProto && $763mL($6a920393d90de711$var$AllSymbols, key) && !$763mL($6a920393d90de711$var$OPSymbols, key)) return false;
    return E || !$763mL(this, key) || !$763mL($6a920393d90de711$var$AllSymbols, key) || $763mL(this, $6a920393d90de711$var$HIDDEN) && this[$6a920393d90de711$var$HIDDEN][key] ? E : true;
};
var $6a920393d90de711$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $2hx6g(it);
    key = $bIV2P(key, true);
    if (it === $6a920393d90de711$var$ObjectProto && $763mL($6a920393d90de711$var$AllSymbols, key) && !$763mL($6a920393d90de711$var$OPSymbols, key)) return;
    var D = $6a920393d90de711$var$gOPD(it, key);
    if (D && $763mL($6a920393d90de711$var$AllSymbols, key) && !($763mL(it, $6a920393d90de711$var$HIDDEN) && it[$6a920393d90de711$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $6a920393d90de711$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $6a920393d90de711$var$gOPN($2hx6g(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$763mL($6a920393d90de711$var$AllSymbols, key = names[i++]) && key != $6a920393d90de711$var$HIDDEN && key != $6a920393d90de711$require$META) result.push(key);
    return result;
};
var $6a920393d90de711$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $6a920393d90de711$var$ObjectProto;
    var names = $6a920393d90de711$var$gOPN(IS_OP ? $6a920393d90de711$var$OPSymbols : $2hx6g(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($763mL($6a920393d90de711$var$AllSymbols, key = names[i++]) && (IS_OP ? $763mL($6a920393d90de711$var$ObjectProto, key) : true)) result.push($6a920393d90de711$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$6a920393d90de711$var$USE_NATIVE) {
    $6a920393d90de711$var$$Symbol = function Symbol() {
        if (this instanceof $6a920393d90de711$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $hoAgo(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $6a920393d90de711$var$ObjectProto) $set.call($6a920393d90de711$var$OPSymbols, value);
            if ($763mL(this, $6a920393d90de711$var$HIDDEN) && $763mL(this[$6a920393d90de711$var$HIDDEN], tag)) this[$6a920393d90de711$var$HIDDEN][tag] = false;
            $6a920393d90de711$var$setSymbolDesc(this, tag, $kKJnZ(1, value));
        };
        if ($2PPTD && $6a920393d90de711$var$setter) $6a920393d90de711$var$setSymbolDesc($6a920393d90de711$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $6a920393d90de711$var$wrap(tag);
    };
    $aDsEo($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $k9HHU.f = $6a920393d90de711$var$$getOwnPropertyDescriptor;
    $19vSD.f = $6a920393d90de711$var$$defineProperty;
    (parcelRequire("bZLYs")).f = $76OH6.f = $6a920393d90de711$var$$getOwnPropertyNames;
    (parcelRequire("gGh3r")).f = $6a920393d90de711$var$$propertyIsEnumerable;
    $jBejz.f = $6a920393d90de711$var$$getOwnPropertySymbols;
    if ($2PPTD && !(parcelRequire("jHsIx"))) $aDsEo($6a920393d90de711$var$ObjectProto, 'propertyIsEnumerable', $6a920393d90de711$var$$propertyIsEnumerable, true);
    $iY0Fa.f = function(name) {
        return $6a920393d90de711$var$wrap($9xDAg(name));
    };
}
$6TZmN($6TZmN.G + $6TZmN.W + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, {
    Symbol: $6a920393d90de711$var$$Symbol
});
for(var $6a920393d90de711$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $6a920393d90de711$var$j = 0; $6a920393d90de711$var$es6Symbols.length > $6a920393d90de711$var$j;)$9xDAg($6a920393d90de711$var$es6Symbols[$6a920393d90de711$var$j++]);
for(var $6a920393d90de711$var$wellKnownSymbols = $E0yCE($9xDAg.store), $6a920393d90de711$var$k = 0; $6a920393d90de711$var$wellKnownSymbols.length > $6a920393d90de711$var$k;)$9PxVb($6a920393d90de711$var$wellKnownSymbols[$6a920393d90de711$var$k++]);
$6TZmN($6TZmN.S + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $763mL($6a920393d90de711$var$SymbolRegistry, key += '') ? $6a920393d90de711$var$SymbolRegistry[key] : $6a920393d90de711$var$SymbolRegistry[key] = $6a920393d90de711$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$6a920393d90de711$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $6a920393d90de711$var$SymbolRegistry)if ($6a920393d90de711$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $6a920393d90de711$var$setter = true;
    },
    useSimple: function() {
        $6a920393d90de711$var$setter = false;
    }
});
$6TZmN($6TZmN.S + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $6a920393d90de711$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $6a920393d90de711$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $6a920393d90de711$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $6a920393d90de711$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $6a920393d90de711$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $6a920393d90de711$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $6a920393d90de711$var$FAILS_ON_PRIMITIVES = $hs8hK(function() {
    $jBejz.f(1);
});
$6TZmN($6TZmN.S + $6TZmN.F * $6a920393d90de711$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $jBejz.f($7tWaA(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$6a920393d90de711$var$$JSON && $6TZmN($6TZmN.S + $6TZmN.F * (!$6a920393d90de711$var$USE_NATIVE || $hs8hK(function() {
    var S = $6a920393d90de711$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $6a920393d90de711$var$_stringify([
        S
    ]) != '[null]' || $6a920393d90de711$var$_stringify({
        a: S
    }) != '{}' || $6a920393d90de711$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$7QZ8S(replacer) && it === undefined || $6a920393d90de711$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$lap9z(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$6a920393d90de711$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $6a920393d90de711$var$_stringify.apply($6a920393d90de711$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE][$6a920393d90de711$var$TO_PRIMITIVE] || (parcelRequire("1XBAS"))($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE], $6a920393d90de711$var$TO_PRIMITIVE, $6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$jr22O($6a920393d90de711$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$jr22O(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$jr22O($4FFa4.JSON, 'JSON', true);

});
parcelRegister("cj3Wz", function(module, exports) {

var $8f5a5183b2bf41cd$var$META = (parcelRequire("hoAgo"))('meta');

var $7QZ8S = parcelRequire("7QZ8S");

var $763mL = parcelRequire("763mL");

var $19vSD = parcelRequire("19vSD");
var $8f5a5183b2bf41cd$require$setDesc = $19vSD.f;
var $8f5a5183b2bf41cd$var$id = 0;
var $8f5a5183b2bf41cd$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $8f5a5183b2bf41cd$var$FREEZE = !(parcelRequire("hs8hK"))(function() {
    return $8f5a5183b2bf41cd$var$isExtensible(Object.preventExtensions({}));
});
var $8f5a5183b2bf41cd$var$setMeta = function(it) {
    $8f5a5183b2bf41cd$require$setDesc(it, $8f5a5183b2bf41cd$var$META, {
        value: {
            i: 'O' + ++$8f5a5183b2bf41cd$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $8f5a5183b2bf41cd$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$7QZ8S(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$763mL(it, $8f5a5183b2bf41cd$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8f5a5183b2bf41cd$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $8f5a5183b2bf41cd$var$setMeta(it);
    // return object ID
    }
    return it[$8f5a5183b2bf41cd$var$META].i;
};
var $8f5a5183b2bf41cd$var$getWeak = function(it, create) {
    if (!$763mL(it, $8f5a5183b2bf41cd$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8f5a5183b2bf41cd$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $8f5a5183b2bf41cd$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$8f5a5183b2bf41cd$var$META].w;
};
// add metadata on freeze-family methods calling
var $8f5a5183b2bf41cd$var$onFreeze = function(it) {
    if ($8f5a5183b2bf41cd$var$FREEZE && $8f5a5183b2bf41cd$var$meta.NEED && $8f5a5183b2bf41cd$var$isExtensible(it) && !$763mL(it, $8f5a5183b2bf41cd$var$META)) $8f5a5183b2bf41cd$var$setMeta(it);
    return it;
};
var $8f5a5183b2bf41cd$var$meta = module.exports = {
    KEY: $8f5a5183b2bf41cd$var$META,
    NEED: false,
    fastKey: $8f5a5183b2bf41cd$var$fastKey,
    getWeak: $8f5a5183b2bf41cd$var$getWeak,
    onFreeze: $8f5a5183b2bf41cd$var$onFreeze
};

});

parcelRegister("9PxVb", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");

var $23f7N = parcelRequire("23f7N");

var $jHsIx = parcelRequire("jHsIx");

var $iY0Fa = parcelRequire("iY0Fa");

var $19vSD = parcelRequire("19vSD");
var $72833089d3e03b7a$require$defineProperty = $19vSD.f;
module.exports = function(name) {
    var $Symbol = $23f7N.Symbol || ($23f7N.Symbol = $jHsIx ? {} : $4FFa4.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $72833089d3e03b7a$require$defineProperty($Symbol, name, {
        value: $iY0Fa.f(name)
    });
};

});

parcelRegister("8x7zY", function(module, exports) {
// all enumerable object keys, includes symbols

var $E0yCE = parcelRequire("E0yCE");

var $jBejz = parcelRequire("jBejz");

var $gGh3r = parcelRequire("gGh3r");
module.exports = function(it) {
    var result = $E0yCE(it);
    var getSymbols = $jBejz.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $gGh3r.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("lap9z", function(module, exports) {
// 7.2.2 IsArray(argument)

var $gNg6c = parcelRequire("gNg6c");
module.exports = Array.isArray || function isArray(arg) {
    return $gNg6c(arg) == 'Array';
};

});

parcelRegister("76OH6", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $52d06ac0be21d279$export$2d1720544b23b823; }, function (v) { return $52d06ac0be21d279$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $52d06ac0be21d279$export$2d1720544b23b823;

var $2hx6g = parcelRequire("2hx6g");

var $bZLYs = parcelRequire("bZLYs");
var $52d06ac0be21d279$require$gOPN = $bZLYs.f;
var $52d06ac0be21d279$var$toString = {}.toString;
var $52d06ac0be21d279$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $52d06ac0be21d279$var$getWindowNames = function(it) {
    try {
        return $52d06ac0be21d279$require$gOPN(it);
    } catch (e) {
        return $52d06ac0be21d279$var$windowNames.slice();
    }
};
$52d06ac0be21d279$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $52d06ac0be21d279$var$windowNames && $52d06ac0be21d279$var$toString.call(it) == '[object Window]' ? $52d06ac0be21d279$var$getWindowNames(it) : $52d06ac0be21d279$require$gOPN($2hx6g(it));
};

});
parcelRegister("bZLYs", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $8bba9ae47cc7daf1$export$2d1720544b23b823; }, function (v) { return $8bba9ae47cc7daf1$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $8bba9ae47cc7daf1$export$2d1720544b23b823;

var $64rCp = parcelRequire("64rCp");

var $8bba9ae47cc7daf1$var$hiddenKeys = (parcelRequire("f5whe")).concat('length', 'prototype');
$8bba9ae47cc7daf1$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $64rCp(O, $8bba9ae47cc7daf1$var$hiddenKeys);
};

});


parcelRegister("k9HHU", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $eac68d442f70e4ee$export$2d1720544b23b823; }, function (v) { return $eac68d442f70e4ee$export$2d1720544b23b823 = v; });
var $eac68d442f70e4ee$export$2d1720544b23b823;

var $gGh3r = parcelRequire("gGh3r");

var $kKJnZ = parcelRequire("kKJnZ");

var $2hx6g = parcelRequire("2hx6g");

var $bIV2P = parcelRequire("bIV2P");

var $763mL = parcelRequire("763mL");

var $1Vpr5 = parcelRequire("1Vpr5");
var $eac68d442f70e4ee$var$gOPD = Object.getOwnPropertyDescriptor;

$eac68d442f70e4ee$export$2d1720544b23b823 = (parcelRequire("2PPTD")) ? $eac68d442f70e4ee$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $2hx6g(O);
    P = $bIV2P(P, true);
    if ($1Vpr5) try {
        return $eac68d442f70e4ee$var$gOPD(O, P);
    } catch (e) {}
    if ($763mL(O, P)) return $kKJnZ(!$gGh3r.f.call(O, P), O[P]);
};

});


parcelRegister("cPEqH", function(module, exports) {

});

parcelRegister("9qJRy", function(module, exports) {

(parcelRequire("9PxVb"))('asyncIterator');

});

parcelRegister("lm1z6", function(module, exports) {

(parcelRequire("9PxVb"))('observable');

});





parcelRegister("fpmbk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $b37a659efa5f0475$export$1e511d4a378977f5; }, function (v) { return $b37a659efa5f0475$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $b37a659efa5f0475$export$2e2bcd8739ae039; }, function (v) { return $b37a659efa5f0475$export$2e2bcd8739ae039 = v; });
var $b37a659efa5f0475$export$1e511d4a378977f5;
var $b37a659efa5f0475$export$2e2bcd8739ae039;
"use strict";
$b37a659efa5f0475$export$1e511d4a378977f5 = true;

var $iwWa6 = parcelRequire("iwWa6");
var $b37a659efa5f0475$var$_setPrototypeOf2 = $b37a659efa5f0475$var$_interopRequireDefault($iwWa6);

var $eTqtS = parcelRequire("eTqtS");
var $b37a659efa5f0475$var$_create2 = $b37a659efa5f0475$var$_interopRequireDefault($eTqtS);

var $frdl0 = parcelRequire("frdl0");
var $b37a659efa5f0475$var$_typeof3 = $b37a659efa5f0475$var$_interopRequireDefault($frdl0);
function $b37a659efa5f0475$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b37a659efa5f0475$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $b37a659efa5f0475$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $b37a659efa5f0475$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b37a659efa5f0475$var$_setPrototypeOf2.default ? (0, $b37a659efa5f0475$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("iwWa6", function(module, exports) {

module.exports = {
    "default": (parcelRequire("13ZIY")),
    __esModule: true
};

});
parcelRegister("13ZIY", function(module, exports) {
parcelRequire("asvPg");

module.exports = (parcelRequire("23f7N")).Object.setPrototypeOf;

});
parcelRegister("asvPg", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $6TZmN = parcelRequire("6TZmN");

$6TZmN($6TZmN.S, 'Object', {
    setPrototypeOf: (parcelRequire("5BFbR")).set
});

});
parcelRegister("5BFbR", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $7QZ8S = parcelRequire("7QZ8S");

var $5asEa = parcelRequire("5asEa");
var $41505bfbff01f966$var$check = function(O, proto) {
    $5asEa(O);
    if (!$7QZ8S(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("04VsN"))(Function.call, (parcelRequire("k9HHU")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $41505bfbff01f966$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $41505bfbff01f966$var$check
};

});




parcelRegister("eTqtS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("cFZmJ")),
    __esModule: true
};

});
parcelRegister("cFZmJ", function(module, exports) {
parcelRequire("fj7wp");

var $23f7N = parcelRequire("23f7N");
var $93a8ea4cff4cea96$require$$Object = $23f7N.Object;
module.exports = function create(P, D) {
    return $93a8ea4cff4cea96$require$$Object.create(P, D);
};

});
parcelRegister("fj7wp", function(module, exports) {

var $6TZmN = parcelRequire("6TZmN");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$6TZmN($6TZmN.S, 'Object', {
    create: (parcelRequire("lmUsf"))
});

});





parcelRegister("lWOKW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ffa662df7c16fff2$export$2e2bcd8739ae039; });

var $8hsZ5 = parcelRequire("8hsZ5");

var $eqx5z = parcelRequire("eqx5z");

var $288na = parcelRequire("288na");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $lPa8d = parcelRequire("lPa8d");

var $mWKBO = parcelRequire("mWKBO");

var $hIewe = parcelRequire("hIewe");
var $h4AmC = parcelRequire("h4AmC");
var $1sBRT = parcelRequire("1sBRT");
var $jessv = parcelRequire("jessv");
var $ffa662df7c16fff2$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "size",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId"
];
/* eslint-disable @atlaskit/design-system/no-nested-styles */ var $ffa662df7c16fff2$var$checkboxStyles = (0, $3dJ4i.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-width, 1px)" : 2,
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    '&&:focus + svg, &&:checked:focus + svg': {
        '--checkbox-border-color': 'var(--local-border-focus)'
    },
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $ffa662df7c16fff2$var$Checkbox = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function Checkbox(props, ref) {
    var isCheckedProp = props.isChecked, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$isIndeterminat = props.isIndeterminate, isIndeterminate = _props$isIndeterminat === void 0 ? false : _props$isIndeterminat, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, onChangeProps = props.onChange, analyticsContext = props.analyticsContext, label = props.label, name = props.name, value = props.value, isRequired = props.isRequired, testId = props.testId, rest = (0, $288na.default)(props, $ffa662df7c16fff2$var$_excluded);
    var _useState = (0, $1oC0p.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, $eqx5z.default)(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $gJJny.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "12.6.11"
    });
    var internalRef = (0, $1oC0p.useRef)(null);
    var mergedRefs = (0, $lPa8d.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return (0, $3dJ4i.jsx)((0, $h4AmC.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label")
    }, (0, $3dJ4i.jsx)("input", (0, $8hsZ5.default)({}, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $ffa662df7c16fff2$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), (0, $3dJ4i.jsx)((0, $hIewe.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && (0, $3dJ4i.jsx)((0, $1sBRT.default), null, label, isRequired && (0, $3dJ4i.jsx)((0, $jessv.default), null)));
}));
$ffa662df7c16fff2$var$Checkbox.displayName = 'Checkbox';
var $ffa662df7c16fff2$export$2e2bcd8739ae039 = $ffa662df7c16fff2$var$Checkbox;

});
parcelRegister("8hsZ5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $607664f25d90898f$export$2e2bcd8739ae039; });
function $607664f25d90898f$export$2e2bcd8739ae039() {
    return $607664f25d90898f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $607664f25d90898f$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("eqx5z", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a80d29213b4e80b3$export$2e2bcd8739ae039; });

var $2X8Fp = parcelRequire("2X8Fp");

var $hBdHg = parcelRequire("hBdHg");

var $3lwfc = parcelRequire("3lwfc");

var $hPShP = parcelRequire("hPShP");
function $a80d29213b4e80b3$export$2e2bcd8739ae039(r, e) {
    return (0, $2X8Fp.default)(r) || (0, $hBdHg.default)(r, e) || (0, $3lwfc.default)(r, e) || (0, $hPShP.default)();
}

});
parcelRegister("2X8Fp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2267d087b74c1f0f$export$2e2bcd8739ae039; });
function $2267d087b74c1f0f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("hBdHg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd0084406844a3c1$export$2e2bcd8739ae039; });
function $cd0084406844a3c1$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3lwfc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26fc584674574666$export$2e2bcd8739ae039; });

var $fXaLm = parcelRequire("fXaLm");
function $26fc584674574666$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fXaLm.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fXaLm.default)(r, a) : void 0;
    }
}

});
parcelRegister("fXaLm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b9d4b6fc2a4427b7$export$2e2bcd8739ae039; });
function $b9d4b6fc2a4427b7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("hPShP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cfc14f46f41370bd$export$2e2bcd8739ae039; });
function $cfc14f46f41370bd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("288na", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18d2d2beab7b4831$export$2e2bcd8739ae039; });

var $3p5A9 = parcelRequire("3p5A9");
function $18d2d2beab7b4831$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3p5A9.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("3p5A9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27a8095f51b15f62$export$2e2bcd8739ae039; });
function $27a8095f51b15f62$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lPa8d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe363853292213b8$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $fe363853292213b8$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("mWKBO", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $044fa0dd75e56d89$export$470e5c2be1411c89; });

var $eM5qO = parcelRequire("eM5qO");
function $044fa0dd75e56d89$export$ba05d765b8392e5e(flagResolver) {
    (0, $eM5qO.setBooleanResolver)(flagResolver);
}
function $044fa0dd75e56d89$export$470e5c2be1411c89(name) {
    return (0, $eM5qO.resolveBooleanFlag)(name);
}

});
parcelRegister("eM5qO", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $ac19c2f114c4a454$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $ac19c2f114c4a454$export$6333b6aff9fc6275; });

var $1xWAc = parcelRequire("1xWAc");

var $7t0tI = parcelRequire("7t0tI");
var $ac19c2f114c4a454$var$pkgName = '@atlaskit/platform-feature-flags';
var $ac19c2f114c4a454$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $ac19c2f114c4a454$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $ac19c2f114c4a454$var$ENV_ENABLE_PLATFORM_FF = $ac19c2f114c4a454$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ac19c2f114c4a454$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ac19c2f114c4a454$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ac19c2f114c4a454$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ac19c2f114c4a454$var$ENV_ENABLE_PLATFORM_FF || $ac19c2f114c4a454$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ac19c2f114c4a454$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $ac19c2f114c4a454$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98] = $ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98] || $ac19c2f114c4a454$var$DEFAULT_PFF_GLOBAL;
function $ac19c2f114c4a454$export$f2b591175b3e424c(resolver) {
    $ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $ac19c2f114c4a454$export$6333b6aff9fc6275(flagKey) {
    if ($ac19c2f114c4a454$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1xWAc.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ac19c2f114c4a454$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $ac19c2f114c4a454$var$globalVar[$ac19c2f114c4a454$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("1xWAc", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $120650dbfc20a854$export$1c9f709888824e05; });
var $120650dbfc20a854$var$_ref, $120650dbfc20a854$var$_globalThis$process, $120650dbfc20a854$var$_globalThis$process$e, $120650dbfc20a854$var$_globalThis$process2, $120650dbfc20a854$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $120650dbfc20a854$var$TESTS_MODE = ($120650dbfc20a854$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process = globalThis.process) === null || $120650dbfc20a854$var$_globalThis$process === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process$e = $120650dbfc20a854$var$_globalThis$process.env) === null || $120650dbfc20a854$var$_globalThis$process$e === void 0 ? void 0 : $120650dbfc20a854$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $120650dbfc20a854$var$_ref !== void 0) ? $120650dbfc20a854$var$_ref : false;
var $120650dbfc20a854$var$DEBUG_MODE = !$120650dbfc20a854$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process2 = globalThis.process) === null || $120650dbfc20a854$var$_globalThis$process2 === void 0 ? void 0 : ($120650dbfc20a854$var$_globalThis$process2$ = $120650dbfc20a854$var$_globalThis$process2.env) === null || $120650dbfc20a854$var$_globalThis$process2$ === void 0 ? void 0 : $120650dbfc20a854$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $120650dbfc20a854$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$120650dbfc20a854$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("hIewe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce51ced9a5cc497a$export$2e2bcd8739ae039; });
/**  @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $e2V0T = parcelRequire("e2V0T");
function $ce51ced9a5cc497a$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return (0, $3dJ4i.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return (0, $3dJ4i.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $ce51ced9a5cc497a$var$CheckboxIcon = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var size = _ref.size, isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $1oC0p.useMemo)(function() {
        return $ce51ced9a5cc497a$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return (0, $3dJ4i.jsx)((0, $e2V0T.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, (0, $3dJ4i.jsx)("g", {
        fillRule: "evenodd"
    }, (0, $3dJ4i.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $ce51ced9a5cc497a$export$2e2bcd8739ae039 = $ce51ced9a5cc497a$var$CheckboxIcon;

});
parcelRegister("e2V0T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a39d7a46070a4568$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $dlnJq = parcelRequire("dlnJq");

var $2qiIe = parcelRequire("2qiIe");

var $7m1q2 = parcelRequire("7m1q2");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $a39d7a46070a4568$var$svgStyles = (0, $3dJ4i.css)((0, $7m1q2.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $a39d7a46070a4568$var$SVG = /*#__PURE__*/ (0, $1oC0p.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    var _useGlobalTheme = (0, $dlnJq.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor || (0, $2qiIe.getBackground)(mode)
        },
        css: [
            $a39d7a46070a4568$var$svgStyles,
            (0, $7m1q2.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $a39d7a46070a4568$export$2e2bcd8739ae039 = $a39d7a46070a4568$var$SVG;

});
parcelRegister("dlnJq", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $9b6fa52042443d0e$export$7692396083754928; });

var $fZr91 = parcelRequire("fZr91");
// Create default global light theme
var $9b6fa52042443d0e$var$_createTheme = (0, $fZr91.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $9b6fa52042443d0e$var$Provider = $9b6fa52042443d0e$var$_createTheme.Provider, $9b6fa52042443d0e$var$Consumer = $9b6fa52042443d0e$var$_createTheme.Consumer, $9b6fa52042443d0e$export$7692396083754928 = $9b6fa52042443d0e$var$_createTheme.useTheme;
var $9b6fa52042443d0e$export$2e2bcd8739ae039 = {
    Provider: $9b6fa52042443d0e$var$Provider,
    Consumer: $9b6fa52042443d0e$var$Consumer
};

});
parcelRegister("fZr91", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $ba419bd530b5f287$export$25d302a5b900a763; });

var $288na = parcelRequire("288na");

var $1oC0p = parcelRequire("1oC0p");
var $ba419bd530b5f287$var$_excluded = [
    "children"
];
function $ba419bd530b5f287$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $288na.default)(props, $ba419bd530b5f287$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("2qiIe", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $1c3c86630911910b$export$18cb9425622d4e06; });
var $1c3c86630911910b$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $1c3c86630911910b$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
    return $1c3c86630911910b$var$themedBackground[mode];
};

});

parcelRegister("7m1q2", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $0161bca626919ed6$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $0161bca626919ed6$export$ef0ad74202575b64; });

var $7NHwz = parcelRequire("7NHwz");

var $3dJ4i = parcelRequire("3dJ4i");
var $0161bca626919ed6$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $0161bca626919ed6$var$smallStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).small);
var $0161bca626919ed6$var$mediumStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).medium);
var $0161bca626919ed6$var$largeStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).large);
var $0161bca626919ed6$var$xlargeStyles = (0, $3dJ4i.css)((0, $7NHwz.dimensions).xlarge);
var $0161bca626919ed6$export$ef0ad74202575b64 = {
    small: $0161bca626919ed6$var$smallStyles,
    medium: $0161bca626919ed6$var$mediumStyles,
    large: $0161bca626919ed6$var$largeStyles,
    xlarge: $0161bca626919ed6$var$xlargeStyles
};
var $0161bca626919ed6$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $7NHwz.dimensions)[size];
    return undefined;
};

});
parcelRegister("7NHwz", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $5adedf072958a79e$export$62ad7b0c781000e9; });
var $5adedf072958a79e$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $5adedf072958a79e$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $5adedf072958a79e$export$62ad7b0c781000e9 = {
    small: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.small,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.medium,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.large,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $5adedf072958a79e$export$c647cb0ee6e282fe.xlarge,
        height: $5adedf072958a79e$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("h4AmC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c6df047995b8adca$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $drn1i = parcelRequire("drn1i");

var $dlnJq = parcelRequire("dlnJq");

var $4Trtv = parcelRequire("4Trtv");

var $finpS = parcelRequire("finpS");
var $c6df047995b8adca$var$labelStyles = (0, $3dJ4i.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: "var(--ds-text, ".concat((0, $drn1i.N900), ")"),
    cursor: 'default',
    fontFamily: "var(--ds-font-family-sans, ".concat((0, $4Trtv.fontFamily), ")")
});
var $c6df047995b8adca$var$textLabelLayoutStyles = (0, $3dJ4i.css)({
    gap: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
    gridTemplateColumns: 'min-content auto'
});
var $c6df047995b8adca$var$disabledStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-disabled, ".concat((0, $drn1i.N80), ")"),
    cursor: 'not-allowed'
});
var $c6df047995b8adca$var$themeStyles = {
    light: (0, $3dJ4i.css)({
        /**
     * Background
     */ '--local-background': (0, $finpS.default).light.boxColor.rest,
        '--local-background-active': (0, $finpS.default).light.boxColor.active,
        '--local-background-checked': (0, $finpS.default).light.boxColor.checked,
        '--local-background-checked-hover': (0, $finpS.default).light.boxColor.hoveredAndChecked,
        '--local-background-disabled': (0, $finpS.default).light.boxColor.disabled,
        '--local-background-hover': (0, $finpS.default).light.boxColor.hovered,
        /**
     * Border
     */ '--local-border': (0, $finpS.default).light.borderColor.rest,
        '--local-border-active': (0, $finpS.default).light.borderColor.active,
        '--local-border-checked': (0, $finpS.default).light.borderColor.checked,
        '--local-border-checked-hover': (0, $finpS.default).light.borderColor.hoveredAndChecked,
        '--local-border-checked-invalid': (0, $finpS.default).light.borderColor.invalidAndChecked,
        '--local-border-disabled': (0, $finpS.default).light.borderColor.disabled,
        '--local-border-focus': (0, $finpS.default).light.borderColor.focused,
        '--local-border-hover': (0, $finpS.default).light.borderColor.hovered,
        '--local-border-invalid': (0, $finpS.default).light.borderColor.invalid,
        /**
     * Tick
     */ '--local-tick-active': (0, $finpS.default).light.tickColor.activeAndChecked,
        '--local-tick-checked': (0, $finpS.default).light.tickColor.checked,
        '--local-tick-disabled': (0, $finpS.default).light.tickColor.disabledAndChecked,
        '--local-tick-rest': 'transparent'
    }),
    dark: (0, $3dJ4i.css)({
        /**
     * Background
     */ '--local-background': (0, $finpS.default).dark.boxColor.rest,
        '--local-background-active': (0, $finpS.default).dark.boxColor.active,
        '--local-background-checked': (0, $finpS.default).dark.boxColor.checked,
        '--local-background-checked-hover': (0, $finpS.default).dark.boxColor.hoveredAndChecked,
        '--local-background-disabled': (0, $finpS.default).dark.boxColor.disabled,
        '--local-background-hover': (0, $finpS.default).dark.boxColor.hovered,
        /**
     * Border
     */ '--local-border': (0, $finpS.default).dark.borderColor.rest,
        '--local-border-active': (0, $finpS.default).dark.borderColor.active,
        '--local-border-checked': (0, $finpS.default).dark.borderColor.checked,
        '--local-border-checked-hover': (0, $finpS.default).dark.borderColor.hoveredAndChecked,
        '--local-border-checked-invalid': (0, $finpS.default).dark.borderColor.invalidAndChecked,
        '--local-border-disabled': (0, $finpS.default).dark.borderColor.disabled,
        '--local-border-focus': (0, $finpS.default).dark.borderColor.focused,
        '--local-border-hover': (0, $finpS.default).dark.borderColor.hovered,
        '--local-border-invalid': (0, $finpS.default).dark.borderColor.invalid,
        /**
     * Tick
     */ '--local-tick-active': (0, $finpS.default).dark.tickColor.activeAndChecked,
        '--local-tick-checked': (0, $finpS.default).dark.tickColor.checked,
        '--local-tick-disabled': (0, $finpS.default).dark.tickColor.disabledAndChecked,
        '--local-tick-rest': 'transparent'
    })
};
function $c6df047995b8adca$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id;
    var _useGlobalTheme = (0, $dlnJq.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("label", {
        css: [
            $c6df047995b8adca$var$labelStyles,
            label && $c6df047995b8adca$var$textLabelLayoutStyles,
            isDisabled && $c6df047995b8adca$var$disabledStyles,
            mode === 'light' && $c6df047995b8adca$var$themeStyles.light,
            mode === 'dark' && $c6df047995b8adca$var$themeStyles.dark
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});
parcelRegister("drn1i", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $9c8fa7405310b87c$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $9c8fa7405310b87c$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "B50", function () { return $9c8fa7405310b87c$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $9c8fa7405310b87c$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B200", function () { return $9c8fa7405310b87c$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $9c8fa7405310b87c$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $9c8fa7405310b87c$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $9c8fa7405310b87c$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $9c8fa7405310b87c$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $9c8fa7405310b87c$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $9c8fa7405310b87c$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $9c8fa7405310b87c$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $9c8fa7405310b87c$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $9c8fa7405310b87c$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $9c8fa7405310b87c$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $9c8fa7405310b87c$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN200", function () { return $9c8fa7405310b87c$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN90", function () { return $9c8fa7405310b87c$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $9c8fa7405310b87c$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN30", function () { return $9c8fa7405310b87c$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN10", function () { return $9c8fa7405310b87c$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $9c8fa7405310b87c$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $lTHzN = parcelRequire("lTHzN");
var $9c8fa7405310b87c$export$4b84fd0e2c617bd = '#FFEBE6';
var $9c8fa7405310b87c$export$b34b069eff244586 = '#FFBDAD';
var $9c8fa7405310b87c$export$be802dd0d8b57f35 = '#FF8F73';
var $9c8fa7405310b87c$export$60847d42f9da92a6 = '#FF7452';
var $9c8fa7405310b87c$export$4a7404f376229999 = '#FF5630';
var $9c8fa7405310b87c$export$2010d0fb4295b346 = '#DE350B';
var $9c8fa7405310b87c$export$2837b5a1a71d5c02 = '#BF2600';
var $9c8fa7405310b87c$export$8d9596b529bbb9cf = '#FFFAE6';
var $9c8fa7405310b87c$export$41060a744ab0b7ae = '#FFF0B3';
var $9c8fa7405310b87c$export$1cc05bbbf340e559 = '#FFE380';
var $9c8fa7405310b87c$export$5aae31392d72caaa = '#FFC400';
var $9c8fa7405310b87c$export$c6930421db9fa514 = '#FFAB00';
var $9c8fa7405310b87c$export$59619663aa6500fb = '#FF991F';
var $9c8fa7405310b87c$export$874739ea9e379ab6 = '#FF8B00';
var $9c8fa7405310b87c$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $9c8fa7405310b87c$export$69a3bf21b9686c2b = '#ABF5D1';
var $9c8fa7405310b87c$export$afbce1382ec95f73 = '#79F2C0';
var $9c8fa7405310b87c$export$747d86715d4175de = '#57D9A3';
var $9c8fa7405310b87c$export$940e1f69e873f202 = '#36B37E';
var $9c8fa7405310b87c$export$a49394138f7b8e85 = '#00875A';
var $9c8fa7405310b87c$export$6fa04827ac68a4fb = '#006644';
var $9c8fa7405310b87c$export$226de0355ed012f8 = '#DEEBFF';
var $9c8fa7405310b87c$export$8c13c2ee36917869 = '#B3D4FF';
var $9c8fa7405310b87c$export$ecfc1dff386a3e7a = '#4C9AFF';
var $9c8fa7405310b87c$export$215b7063051591f1 = '#2684FF';
var $9c8fa7405310b87c$export$e62e8919cca44969 = '#0065FF';
var $9c8fa7405310b87c$export$b3de0ae08da2ce64 = '#0052CC';
var $9c8fa7405310b87c$export$a6ee3d71bc067634 = '#0747A6';
var $9c8fa7405310b87c$export$363e4475840015bb = '#EAE6FF';
var $9c8fa7405310b87c$export$4b0a4417ed59760f = '#C0B6F2';
var $9c8fa7405310b87c$export$6011520a64d9a187 = '#998DD9';
var $9c8fa7405310b87c$export$a7175d4e9206bc80 = '#8777D9';
var $9c8fa7405310b87c$export$b48405b95304b5a1 = '#6554C0';
var $9c8fa7405310b87c$export$c71e4279dd54a18d = '#5243AA';
var $9c8fa7405310b87c$export$147899de772240ec = '#403294';
var $9c8fa7405310b87c$export$2cf711fe14c66f06 = '#E6FCFF';
var $9c8fa7405310b87c$export$7a8f4d33f6f9772c = '#B3F5FF';
var $9c8fa7405310b87c$export$776c9c497ef08533 = '#79E2F2';
var $9c8fa7405310b87c$export$69cb3ca10c1e330e = '#00C7E6';
var $9c8fa7405310b87c$export$9dc1ef0f3f48059b = '#00B8D9';
var $9c8fa7405310b87c$export$7c835c78b6fcdef8 = '#00A3BF';
var $9c8fa7405310b87c$export$6036577f95c3877e = '#008DA6';
var $9c8fa7405310b87c$export$29a4f05edc054374 = '#FFFFFF';
var $9c8fa7405310b87c$export$e655ef011c4aa1a2 = '#FAFBFC';
var $9c8fa7405310b87c$export$9fdfb749e33cdf97 = '#F4F5F7';
var $9c8fa7405310b87c$export$3e51e8f1440314ba = '#EBECF0';
var $9c8fa7405310b87c$export$1ce2d1575d444ceb = '#DFE1E6';
var $9c8fa7405310b87c$export$8754fc7e6d8b3000 = '#C1C7D0';
var $9c8fa7405310b87c$export$c2e91cbeada39b8b = '#B3BAC5';
var $9c8fa7405310b87c$export$5f71e19f3a7ad9de = '#A5ADBA';
var $9c8fa7405310b87c$export$eaa8c8a70ac22806 = '#97A0AF';
var $9c8fa7405310b87c$export$7c87d337fb91a97d = '#8993A4';
var $9c8fa7405310b87c$export$d6447c357493214f = '#7A869A';
var $9c8fa7405310b87c$export$f563ee71e9ee74cd = '#6B778C';
var $9c8fa7405310b87c$export$e2ef2124cf4024b1 = '#5E6C84';
var $9c8fa7405310b87c$export$eece5f492e429f08 = '#505F79';
var $9c8fa7405310b87c$export$c39c0fe0f26207ae = '#42526E';
var $9c8fa7405310b87c$export$7090862dc3038a9f = '#344563';
var $9c8fa7405310b87c$export$ad0bacf983b7ddaa = '#253858';
var $9c8fa7405310b87c$export$7d61b15e0da132af = '#172B4D';
var $9c8fa7405310b87c$export$fbda843f0a27fe96 = '#091E42';
var $9c8fa7405310b87c$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $9c8fa7405310b87c$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $9c8fa7405310b87c$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $9c8fa7405310b87c$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $9c8fa7405310b87c$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $9c8fa7405310b87c$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $9c8fa7405310b87c$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $9c8fa7405310b87c$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $9c8fa7405310b87c$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $9c8fa7405310b87c$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $9c8fa7405310b87c$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $9c8fa7405310b87c$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $9c8fa7405310b87c$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $9c8fa7405310b87c$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $9c8fa7405310b87c$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $9c8fa7405310b87c$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $9c8fa7405310b87c$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $9c8fa7405310b87c$export$2f6319cf7d736c2a = '#E6EDFA';
var $9c8fa7405310b87c$export$95126bc8884d6634 = '#DCE5F5';
var $9c8fa7405310b87c$export$8338d8c35d44ff1 = '#CED9EB';
var $9c8fa7405310b87c$export$5368d76ae4fbbda7 = '#B8C7E0';
var $9c8fa7405310b87c$export$9f0a771d16ec8d36 = '#ABBBD6';
var $9c8fa7405310b87c$export$abcf8c38338b4aa5 = '#9FB0CC';
var $9c8fa7405310b87c$export$97e81faa16a182c7 = '#8C9CB8';
var $9c8fa7405310b87c$export$bfe21c59123ecf33 = '#7988A3';
var $9c8fa7405310b87c$export$ee82aa2ea6a1558 = '#67758F';
var $9c8fa7405310b87c$export$682927c6ed76be02 = '#56637A';
var $9c8fa7405310b87c$export$91fd9994c5be9757 = '#455166';
var $9c8fa7405310b87c$export$d281fbfe3cff2df6 = '#3B475C';
var $9c8fa7405310b87c$export$3902c91d8b98a753 = '#313D52';
var $9c8fa7405310b87c$export$8e8133c1ba5845b5 = '#283447';
var $9c8fa7405310b87c$export$33ff357f6620b39 = '#202B3D';
var $9c8fa7405310b87c$export$633847cf062b69e0 = '#1B2638';
var $9c8fa7405310b87c$export$9776a6e503bdbf76 = '#121A29';
var $9c8fa7405310b87c$export$6c813d5160dff5db = '#0E1624';
var $9c8fa7405310b87c$export$3d4f271a500072a = '#0D1424';
var $9c8fa7405310b87c$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $9c8fa7405310b87c$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $9c8fa7405310b87c$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $9c8fa7405310b87c$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $9c8fa7405310b87c$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $9c8fa7405310b87c$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $9c8fa7405310b87c$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $9c8fa7405310b87c$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $9c8fa7405310b87c$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $9c8fa7405310b87c$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $9c8fa7405310b87c$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $9c8fa7405310b87c$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $9c8fa7405310b87c$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $9c8fa7405310b87c$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $9c8fa7405310b87c$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $9c8fa7405310b87c$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $9c8fa7405310b87c$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $9c8fa7405310b87c$export$8ce1fd94bee2f412 = (0, $lTHzN.default)({
    light: "var(--ds-surface, ".concat($9c8fa7405310b87c$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($9c8fa7405310b87c$export$633847cf062b69e0, ")")
});
var $9c8fa7405310b87c$export$b861914ea877b580 = (0, $lTHzN.default)({
    light: "var(--ds-background-selected, ".concat($9c8fa7405310b87c$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($9c8fa7405310b87c$export$8c13c2ee36917869, ")")
});
var $9c8fa7405310b87c$export$3f1b020df94387af = (0, $lTHzN.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($9c8fa7405310b87c$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($9c8fa7405310b87c$export$d281fbfe3cff2df6, ")")
});
var $9c8fa7405310b87c$export$c0183dbab98ca63e = (0, $lTHzN.default)({
    light: "var(--ds-surface-overlay, ".concat($9c8fa7405310b87c$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($9c8fa7405310b87c$export$8e8133c1ba5845b5, ")")
});
var $9c8fa7405310b87c$export$6f093cfa640b7166 = (0, $lTHzN.default)({
    light: "var(--ds-text, ".concat($9c8fa7405310b87c$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($9c8fa7405310b87c$export$5368d76ae4fbbda7, ")")
});
var $9c8fa7405310b87c$export$42f8e9c698766e7a = (0, $lTHzN.default)({
    light: "var(--ds-text, ".concat($9c8fa7405310b87c$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9c8fa7405310b87c$export$5368d76ae4fbbda7, ")")
});
var $9c8fa7405310b87c$export$c2d157ca1c34b6e3 = (0, $lTHzN.default)({
    light: "var(--ds-text-selected, ".concat($9c8fa7405310b87c$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($9c8fa7405310b87c$export$b3de0ae08da2ce64, ")")
});
var $9c8fa7405310b87c$export$1905ba28d7cf066f = (0, $lTHzN.default)({
    light: "var(--ds-text-subtlest, ".concat($9c8fa7405310b87c$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9c8fa7405310b87c$export$97e81faa16a182c7, ")")
});
var $9c8fa7405310b87c$export$bd9002130d306d39 = (0, $lTHzN.default)({
    light: "var(--ds-text-subtlest, ".concat($9c8fa7405310b87c$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9c8fa7405310b87c$export$bfe21c59123ecf33, ")")
});
var $9c8fa7405310b87c$export$46e4a324ac90507f = (0, $lTHzN.default)({
    light: "var(--ds-text, ".concat($9c8fa7405310b87c$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9c8fa7405310b87c$export$5368d76ae4fbbda7, ")")
});
var $9c8fa7405310b87c$export$79f3f2b82beb0d36 = (0, $lTHzN.default)({
    light: "var(--ds-text-subtlest, ".concat($9c8fa7405310b87c$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9c8fa7405310b87c$export$97e81faa16a182c7, ")")
});
var $9c8fa7405310b87c$export$7bb0d5c671655cc4 = (0, $lTHzN.default)({
    light: $9c8fa7405310b87c$export$9fdfb749e33cdf97,
    dark: $9c8fa7405310b87c$export$8e8133c1ba5845b5
});
var $9c8fa7405310b87c$export$9c30223ca0a664fb = (0, $lTHzN.default)({
    light: "var(--ds-link, ".concat($9c8fa7405310b87c$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($9c8fa7405310b87c$export$ecfc1dff386a3e7a, ")")
});
var $9c8fa7405310b87c$export$7ed258b0728b004b = (0, $lTHzN.default)({
    light: "var(--ds-link-pressed, ".concat($9c8fa7405310b87c$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($9c8fa7405310b87c$export$215b7063051591f1, ")")
});
var $9c8fa7405310b87c$export$dfa920d8decc8a59 = (0, $lTHzN.default)({
    light: "var(--ds-link-pressed, ".concat($9c8fa7405310b87c$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($9c8fa7405310b87c$export$ecfc1dff386a3e7a, ")")
});
var $9c8fa7405310b87c$export$6069e6ad5c78f632 = (0, $lTHzN.default)({
    light: "var(--ds-border-focused, ".concat($9c8fa7405310b87c$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($9c8fa7405310b87c$export$215b7063051591f1, ")")
});
var $9c8fa7405310b87c$export$9ad721cf3b3debe0 = (0, $lTHzN.default)({
    light: "var(--ds-background-brand-bold, ".concat($9c8fa7405310b87c$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($9c8fa7405310b87c$export$ecfc1dff386a3e7a, ")")
});
var $9c8fa7405310b87c$export$2aa0182783e7e9de = (0, $lTHzN.default)({
    light: $9c8fa7405310b87c$export$b3de0ae08da2ce64,
    dark: $9c8fa7405310b87c$export$ecfc1dff386a3e7a
});
var $9c8fa7405310b87c$export$8bf7dff220b82b4a = (0, $lTHzN.default)({
    light: $9c8fa7405310b87c$export$9dc1ef0f3f48059b,
    dark: $9c8fa7405310b87c$export$69cb3ca10c1e330e
});
var $9c8fa7405310b87c$export$e13cce2a2d16a9d4 = (0, $lTHzN.default)({
    light: $9c8fa7405310b87c$export$b48405b95304b5a1,
    dark: $9c8fa7405310b87c$export$6011520a64d9a187
});
var $9c8fa7405310b87c$export$a90204d1394caf30 = (0, $lTHzN.default)({
    light: $9c8fa7405310b87c$export$4a7404f376229999,
    dark: $9c8fa7405310b87c$export$4a7404f376229999
});
var $9c8fa7405310b87c$export$594c5a8758200c32 = (0, $lTHzN.default)({
    light: $9c8fa7405310b87c$export$c6930421db9fa514,
    dark: $9c8fa7405310b87c$export$c6930421db9fa514
});
var $9c8fa7405310b87c$export$955a2ebd2fb142ae = (0, $lTHzN.default)({
    light: $9c8fa7405310b87c$export$940e1f69e873f202,
    dark: $9c8fa7405310b87c$export$940e1f69e873f202
});
var $9c8fa7405310b87c$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($9c8fa7405310b87c$export$8d43898f60b96a82, ")");
};

});
parcelRegister("lTHzN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff1089605d04487c$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $5cG0G = parcelRequire("5cG0G");
// Unpack custom variants, and get correct value for the current theme
function $ff1089605d04487c$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $5cG0G.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $ff1089605d04487c$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $ff1089605d04487c$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $5cG0G.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("5cG0G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c9ea90f73f7abd4$export$2e2bcd8739ae039; });

var $cQ8gP = parcelRequire("cQ8gP");
function $3c9ea90f73f7abd4$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $cQ8gP.CHANNEL) in props.theme) return props.theme[0, $cQ8gP.CHANNEL];
        else if ('mode' in props.theme && (0, $cQ8gP.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $cQ8gP.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("cQ8gP", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $9590c1ad497406ea$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $9590c1ad497406ea$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $9590c1ad497406ea$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "fontFamily", function () { return $9590c1ad497406ea$export$a5975749f0374264; });

var $3SEsK = parcelRequire("3SEsK");

var $drn1i = parcelRequire("drn1i");
var $9590c1ad497406ea$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $9590c1ad497406ea$export$c93026a968943f95 = 'light';
var $9590c1ad497406ea$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $9590c1ad497406ea$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $9590c1ad497406ea$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $9590c1ad497406ea$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $9590c1ad497406ea$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $9590c1ad497406ea$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $9590c1ad497406ea$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $9590c1ad497406ea$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $drn1i.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9590c1ad497406ea$export$6d8204c2cb2e06b8() / 4;
    (0, $3SEsK.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $9590c1ad497406ea$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $9590c1ad497406ea$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $9590c1ad497406ea$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $3SEsK.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $9590c1ad497406ea$export$ba1d834b86d72a09 = $9590c1ad497406ea$export$a1b3edb637fb4f35;
var $9590c1ad497406ea$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $drn1i.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $drn1i.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $drn1i.N30A), ")")
            }
        }
    };
};

});
parcelRegister("3SEsK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2d35cd451d4a3864$export$2e2bcd8739ae039; });

var $9g5kK = parcelRequire("9g5kK");

var $7t0tI = parcelRequire("7t0tI");
function $2d35cd451d4a3864$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $9g5kK.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $2d35cd451d4a3864$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("9g5kK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6bd9bed3d5c681ad$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $6bd9bed3d5c681ad$var$printed = {};
function $6bd9bed3d5c681ad$export$2e2bcd8739ae039(message) {
    if ($6bd9bed3d5c681ad$var$printed[message]) return;
    $6bd9bed3d5c681ad$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("4Trtv", function(module, exports) {
$parcel$export(module.exports, "fontFamily", function () { return $39019c6be36422e1$export$a5975749f0374264; });

var $cQ8gP = parcelRequire("cQ8gP");
var $39019c6be36422e1$export$a5975749f0374264 = (0, $cQ8gP.fontFamily)();

});

parcelRegister("finpS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b22ab37906e5b0ff$export$2e2bcd8739ae039; });

var $mWKBO = parcelRequire("mWKBO");

var $drn1i = parcelRequire("drn1i");
var $b22ab37906e5b0ff$var$theme = {
    light: {
        borderColor: {
            rest: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $drn1i.N100), ")") : "var(--ds-border-input, ".concat((0, $drn1i.N40), ")"),
            hovered: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $drn1i.N100), ")") : "var(--ds-border-input, ".concat((0, $drn1i.N40), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $drn1i.N20), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $drn1i.B400), ")"),
            active: "var(--ds-border, ".concat((0, $drn1i.B50), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $drn1i.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $drn1i.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $drn1i.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $drn1i.B300), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $drn1i.N10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $drn1i.N30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $drn1i.N20), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $drn1i.B50), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $drn1i.B300), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $drn1i.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $drn1i.N70), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $drn1i.B400), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $drn1i.N10), ")")
        }
    },
    dark: {
        borderColor: {
            rest: (0, $mWKBO.getBooleanFF)('platform.design-system-team.update-border-radio-checkbox_7askv') ? "var(--ds-border-bold, ".concat((0, $drn1i.DN200), ")") : "var(--ds-border-input, ".concat((0, $drn1i.DN80), ")"),
            hovered: "var(--ds-border-input, ".concat((0, $drn1i.DN200), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $drn1i.DN10), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $drn1i.B400), ")"),
            active: "var(--ds-border, ".concat((0, $drn1i.B200), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $drn1i.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $drn1i.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $drn1i.B75), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $drn1i.B75), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $drn1i.DN10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $drn1i.DN30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $drn1i.DN10), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $drn1i.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $drn1i.B75), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $drn1i.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $drn1i.DN90), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $drn1i.DN10), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $drn1i.DN10), ")")
        }
    }
};
var $b22ab37906e5b0ff$export$2e2bcd8739ae039 = $b22ab37906e5b0ff$var$theme;

});


parcelRegister("1sBRT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1105c7d30b6a22e8$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");
var $1105c7d30b6a22e8$var$labelTextStyles = (0, $3dJ4i.css)({
    alignSelf: 'center',
    gridArea: '1 / 2 / 2 / 3'
});
function $1105c7d30b6a22e8$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $1105c7d30b6a22e8$var$labelTextStyles
    }, children);
}

});

parcelRegister("jessv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e005666ec4f6e1dd$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $drn1i = parcelRequire("drn1i");
var $e005666ec4f6e1dd$var$requiredIndicatorStyles = (0, $3dJ4i.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: "var(--ds-text-danger, ".concat((0, $drn1i.R500), ")")
});
function $e005666ec4f6e1dd$export$2e2bcd8739ae039() {
    return (0, $3dJ4i.jsx)("span", {
        css: $e005666ec4f6e1dd$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("7aZKn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $53995d408ff78c17$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $bEO5x = parcelRequire("bEO5x");

var $4HBPY = parcelRequire("4HBPY");
var $53995d408ff78c17$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $53995d408ff78c17$var$justifyItemsMap = {
    start: (0, $3dJ4i.css)({
        justifyItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyItems: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyItems: 'stretch'
    })
};
var $53995d408ff78c17$var$alignContentMap = {
    start: (0, $3dJ4i.css)({
        alignContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        alignContent: 'stretch'
    })
};
var $53995d408ff78c17$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    })
};
var $53995d408ff78c17$var$baseStyles = (0, $3dJ4i.css)({
    display: 'grid',
    boxSizing: 'border-box'
});
var $53995d408ff78c17$var$gridAutoFlowMap = {
    row: (0, $3dJ4i.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $3dJ4i.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $3dJ4i.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $3dJ4i.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $53995d408ff78c17$var$Grid = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || 'div';
    var xcssClassName = xcss && (0, $4HBPY.parseXcss)(xcss);
    var style = gridTemplateAreas || gridTemplateColumns || gridTemplateRows ? Object.assign({}, {
        gridTemplateAreas: gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return "\"".concat(str, "\"");
        }).join('\n') : undefined,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows
    }) : undefined;
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        css: [
            $53995d408ff78c17$var$baseStyles,
            gap && (0, $bEO5x.spaceStylesMap).gap[gap],
            columnGap && (0, $bEO5x.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $bEO5x.spaceStylesMap).rowGap[rowGap],
            alignItems && $53995d408ff78c17$var$alignItemsMap[alignItems],
            alignContent && $53995d408ff78c17$var$alignContentMap[alignContent],
            justifyContent && $53995d408ff78c17$var$justifyContentMap[justifyContent],
            autoFlow && $53995d408ff78c17$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$53995d408ff78c17$var$Grid.displayName = 'Grid';
var $53995d408ff78c17$export$2e2bcd8739ae039 = $53995d408ff78c17$var$Grid;

});

parcelRegister("kR3EL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2eb97fa9922fb9c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $jo4dM = parcelRequire("jo4dM");

var $cWoYJ = parcelRequire("cWoYJ");
var $f2eb97fa9922fb9c$var$formSectionDescriptionStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-100, 8px)"
});
var $f2eb97fa9922fb9c$var$formSectionTitleStyles = (0, $3dJ4i.css)({
    marginTop: 0,
    marginRight: "var(--ds-space-400, 32px)",
    lineHeight: "var(--ds-space-400, 32px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $f2eb97fa9922fb9c$var$formSectionWrapperStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $f2eb97fa9922fb9c$var$lightH600Styles = (0, $3dJ4i.css)((0, $cWoYJ.h600)({
    theme: {
        mode: 'light'
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $f2eb97fa9922fb9c$var$darkH600Styles = (0, $3dJ4i.css)((0, $cWoYJ.h600)({
    theme: {
        mode: 'dark'
    }
}));
var $f2eb97fa9922fb9c$var$FormSectionWrapper = function FormSectionWrapper(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $f2eb97fa9922fb9c$var$formSectionWrapperStyles
    }, children);
};
var $f2eb97fa9922fb9c$var$FormSectionTitle = function FormSectionTitle(_ref2) {
    var children = _ref2.children;
    var _useGlobalTheme = (0, $jo4dM.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("h3", {
        css: [
            $f2eb97fa9922fb9c$var$formSectionTitleStyles,
            mode === 'light' ? $f2eb97fa9922fb9c$var$lightH600Styles : $f2eb97fa9922fb9c$var$darkH600Styles
        ]
    }, children);
};
var $f2eb97fa9922fb9c$var$FormSectionDescription = function FormSectionDescription(_ref3) {
    var children = _ref3.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $f2eb97fa9922fb9c$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */ var $f2eb97fa9922fb9c$var$FormSection = function FormSection(_ref4) {
    var children = _ref4.children, description = _ref4.description, title = _ref4.title;
    return (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionWrapper, null, title && (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionTitle, null, title), description && (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionDescription, null, description), children);
};
var $f2eb97fa9922fb9c$export$2e2bcd8739ae039 = $f2eb97fa9922fb9c$var$FormSection;

});

parcelRegister("pmFxV", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccess", function () { return $04c3eb868b06356f$export$4962f3898bd5c829; });

var $1oC0p = parcelRequire("1oC0p");
var $04c3eb868b06356f$export$4962f3898bd5c829 = function ExperienceSuccess(_ref) {
    var experience = _ref.experience;
    (0, $1oC0p.useLayoutEffect)(function() {
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("7NyFd", function(module, exports) {
$parcel$export(module.exports, "useUFOComponentExperience", function () { return $5ad7ff80959957cb$export$30ab340faaed55d4; });

var $1oC0p = parcelRequire("1oC0p");
var $5ad7ff80959957cb$var$useConstructor = function useConstructor(callback) {
    var hasBeenFired = (0, $1oC0p.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
var $5ad7ff80959957cb$export$30ab340faaed55d4 = function useUFOComponentExperience(experience) {
    (0, $1oC0p.useEffect)(function() {
        return function() {
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $5ad7ff80959957cb$var$useConstructor(function() {
        return experience.start();
    });
    return null;
};

});

parcelRegister("auF8s", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $e06LX = parcelRequire("e06LX");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a3c9d6218c43abc$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e06LX);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a3c9d6218c43abc$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $4jLK2(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a3c9d6218c43abc$var$baseFlatten;

});
parcelRegister("e06LX", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");
/** Built-in value references. */ var $a31651a1aa52b9f5$var$spreadableSymbol = $3MHuE ? $3MHuE.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $a31651a1aa52b9f5$var$isFlattenable(value) {
    return $lPKNl(value) || $8E4Q5(value) || !!($a31651a1aa52b9f5$var$spreadableSymbol && value && value[$a31651a1aa52b9f5$var$spreadableSymbol]);
}
module.exports = $a31651a1aa52b9f5$var$isFlattenable;

});


parcelRegister("5oMeU", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $3ee49cf968a053d8$var$baseGet(object, path) {
    path = $hLLeA(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$119FI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $3ee49cf968a053d8$var$baseGet;

});

parcelRegister("3KbVH", function(module, exports) {

var $dilJK = parcelRequire("dilJK");

var $jeI8Y = parcelRequire("jeI8Y");

var $1f5iV = parcelRequire("1f5iV");

var $lPKNl = parcelRequire("lPKNl");

var $4etkd = parcelRequire("4etkd");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $2b9eebf5a55b4b79$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $1f5iV;
    if (typeof value == 'object') return $lPKNl(value) ? $jeI8Y(value[0], value[1]) : $dilJK(value);
    return $4etkd(value);
}
module.exports = $2b9eebf5a55b4b79$var$baseIteratee;

});
parcelRegister("dilJK", function(module, exports) {

var $dmRJm = parcelRequire("dmRJm");

var $8flHN = parcelRequire("8flHN");

var $hJEpp = parcelRequire("hJEpp");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $9addd149db741bb3$var$baseMatches(source) {
    var matchData = $8flHN(source);
    if (matchData.length == 1 && matchData[0][2]) return $hJEpp(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $dmRJm(object, source, matchData);
    };
}
module.exports = $9addd149db741bb3$var$baseMatches;

});
parcelRegister("hJEpp", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ce95fbfe7bad507a$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $ce95fbfe7bad507a$var$matchesStrictComparable;

});


parcelRegister("jeI8Y", function(module, exports) {

var $l80hK = parcelRequire("l80hK");

var $4EAwS = parcelRequire("4EAwS");

var $8avIg = parcelRequire("8avIg");

var $lIDFS = parcelRequire("lIDFS");

var $3rDfs = parcelRequire("3rDfs");

var $hJEpp = parcelRequire("hJEpp");

var $119FI = parcelRequire("119FI");
/** Used to compose bitmasks for value comparisons. */ var $e0119120d5390bec$var$COMPARE_PARTIAL_FLAG = 1, $e0119120d5390bec$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $e0119120d5390bec$var$baseMatchesProperty(path, srcValue) {
    if ($lIDFS(path) && $3rDfs(srcValue)) return $hJEpp($119FI(path), srcValue);
    return function(object) {
        var objValue = $4EAwS(object, path);
        return objValue === undefined && objValue === srcValue ? $8avIg(object, path) : $l80hK(srcValue, objValue, $e0119120d5390bec$var$COMPARE_PARTIAL_FLAG | $e0119120d5390bec$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $e0119120d5390bec$var$baseMatchesProperty;

});
parcelRegister("4EAwS", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36373bd43f9f4b21$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5oMeU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $36373bd43f9f4b21$var$get;

});

parcelRegister("8avIg", function(module, exports) {

var $90xK9 = parcelRequire("90xK9");

var $eW6W4 = parcelRequire("eW6W4");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5f27db6f2fb2ce7d$var$hasIn(object, path) {
    return object != null && $eW6W4(object, path, $90xK9);
}
module.exports = $5f27db6f2fb2ce7d$var$hasIn;

});
parcelRegister("90xK9", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $68ee49e62966a7ed$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $68ee49e62966a7ed$var$baseHasIn;

});

parcelRegister("eW6W4", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");

var $f6osf = parcelRequire("f6osf");

var $cTpmH = parcelRequire("cTpmH");

var $119FI = parcelRequire("119FI");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $adfbdcbd1c5e47b6$var$hasPath(object, path, hasFunc) {
    path = $hLLeA(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $119FI(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cTpmH(length) && $f6osf(key, length) && ($lPKNl(object) || $8E4Q5(object));
}
module.exports = $adfbdcbd1c5e47b6$var$hasPath;

});



parcelRegister("1f5iV", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0e7b4e76421e80bb$var$identity(value) {
    return value;
}
module.exports = $0e7b4e76421e80bb$var$identity;

});

parcelRegister("4etkd", function(module, exports) {

var $9Qn7O = parcelRequire("9Qn7O");

var $b8vlH = parcelRequire("b8vlH");

var $lIDFS = parcelRequire("lIDFS");

var $119FI = parcelRequire("119FI");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $314f3793de1805c8$var$property(path) {
    return $lIDFS(path) ? $9Qn7O($119FI(path)) : $b8vlH(path);
}
module.exports = $314f3793de1805c8$var$property;

});
parcelRegister("9Qn7O", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $72aae887a83b3cce$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $72aae887a83b3cce$var$baseProperty;

});

parcelRegister("b8vlH", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $81b8c253b34c5572$var$basePropertyDeep(path) {
    return function(object) {
        return $5oMeU(object, path);
    };
}
module.exports = $81b8c253b34c5572$var$basePropertyDeep;

});



parcelRegister("kY6PH", function(module, exports) {

var $aGDk7 = parcelRequire("aGDk7");

var $aoZtB = parcelRequire("aoZtB");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $f43eb61b79c72930$var$baseEach = $aoZtB($aGDk7);
module.exports = $f43eb61b79c72930$var$baseEach;

});
parcelRegister("aGDk7", function(module, exports) {

var $hInl6 = parcelRequire("hInl6");

var $lrU6c = parcelRequire("lrU6c");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7c7c547755c2d334$var$baseForOwn(object, iteratee) {
    return object && $hInl6(object, iteratee, $lrU6c);
}
module.exports = $7c7c547755c2d334$var$baseForOwn;

});
parcelRegister("hInl6", function(module, exports) {

var $5jobf = parcelRequire("5jobf");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ce58a670f068373a$var$baseFor = $5jobf();
module.exports = $ce58a670f068373a$var$baseFor;

});
parcelRegister("5jobf", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3de17bd8d8789b42$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $3de17bd8d8789b42$var$createBaseFor;

});



parcelRegister("aoZtB", function(module, exports) {

var $6PGLN = parcelRequire("6PGLN");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $792bd5382a824cff$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$6PGLN(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $792bd5382a824cff$var$createBaseEach;

});


parcelRegister("bqMAt", function(module, exports) {

var $1f5iV = parcelRequire("1f5iV");

var $axmYb = parcelRequire("axmYb");

var $jj29P = parcelRequire("jj29P");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $8527cfd5a337ca91$var$baseRest(func, start) {
    return $jj29P($axmYb(func, start, $1f5iV), func + '');
}
module.exports = $8527cfd5a337ca91$var$baseRest;

});
parcelRegister("axmYb", function(module, exports) {

var $3ls0q = parcelRequire("3ls0q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7abecdc323c478eb$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $7abecdc323c478eb$var$overRest(func, start, transform) {
    start = $7abecdc323c478eb$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $7abecdc323c478eb$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $3ls0q(func, this, otherArgs);
    };
}
module.exports = $7abecdc323c478eb$var$overRest;

});
parcelRegister("3ls0q", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $26f90e9ed1e087a4$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $26f90e9ed1e087a4$var$apply;

});


parcelRegister("jj29P", function(module, exports) {

var $j199U = parcelRequire("j199U");

var $i9M4A = parcelRequire("i9M4A");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e0e17718533c241f$var$setToString = $i9M4A($j199U);
module.exports = $e0e17718533c241f$var$setToString;

});
parcelRegister("j199U", function(module, exports) {

var $3Kt5H = parcelRequire("3Kt5H");

var $cmtMX = parcelRequire("cmtMX");

var $1f5iV = parcelRequire("1f5iV");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $dd85370c1f08aaa6$var$baseSetToString = !$cmtMX ? $1f5iV : function(func, string) {
    return $cmtMX(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $3Kt5H(string),
        'writable': true
    });
};
module.exports = $dd85370c1f08aaa6$var$baseSetToString;

});
parcelRegister("3Kt5H", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2bac3bd7f8fc3bd7$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $2bac3bd7f8fc3bd7$var$constant;

});


parcelRegister("i9M4A", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d37e5b869faf8491$var$HOT_COUNT = 800, $d37e5b869faf8491$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d37e5b869faf8491$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d37e5b869faf8491$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d37e5b869faf8491$var$nativeNow(), remaining = $d37e5b869faf8491$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d37e5b869faf8491$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $d37e5b869faf8491$var$shortOut;

});



parcelRegister("cHt3R", function(module, exports) {

var $8tfJP = parcelRequire("8tfJP");

var $6PGLN = parcelRequire("6PGLN");

var $f6osf = parcelRequire("f6osf");

var $ih96c = parcelRequire("ih96c");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $93f00b2a7ebaaf8b$var$isIterateeCall(value, index, object) {
    if (!$ih96c(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $6PGLN(object) && $f6osf(index, object.length) : type == 'string' && index in object) return $8tfJP(object[index], value);
    return false;
}
module.exports = $93f00b2a7ebaaf8b$var$isIterateeCall;

});

parcelRegister("2OL6m", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return (parcelRequire("jrlIh")).combine; });

var $jrlIh = parcelRequire("jrlIh");

});
parcelRegister("jrlIh", function(module, exports) {
$parcel$export(module.exports, "combine", function () { return $e27161b4180d34ed$export$1be1fc439b849fdf; });
/** Create a new combined function that will call all the provided functions */ function $e27161b4180d34ed$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("kzuyT", function(module, exports) {
$parcel$export(module.exports, "draggable", function () { return (parcelRequire("fxPVd")).draggable; });
$parcel$export(module.exports, "dropTargetForElements", function () { return (parcelRequire("fxPVd")).dropTargetForElements; });
$parcel$export(module.exports, "monitorForElements", function () { return (parcelRequire("fxPVd")).monitorForElements; });

var $fxPVd = parcelRequire("fxPVd");
 // Payload for the draggable being dragged

});
parcelRegister("fxPVd", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", function () { return $b51236a7af728235$export$e7140b68045b5036; });
$parcel$export(module.exports, "monitorForElements", function () { return $b51236a7af728235$export$59a074bac4c54f54; });
$parcel$export(module.exports, "draggable", function () { return $b51236a7af728235$export$c746a5152d4ba26c; });

var $6eqPh = parcelRequire("6eqPh");

var $dH1HR = parcelRequire("dH1HR");

var $kwSyV = parcelRequire("kwSyV");

var $hDj86 = parcelRequire("hDj86");

var $9LOtS = parcelRequire("9LOtS");

var $jrlIh = parcelRequire("jrlIh");

var $LSEQ4 = parcelRequire("LSEQ4");

var $jNxxH = parcelRequire("jNxxH");

var $lJqmY = parcelRequire("lJqmY");

var $gUlOk = parcelRequire("gUlOk");

var $32gfR = parcelRequire("32gfR");

var $6bk4h = parcelRequire("6bk4h");

var $Kswn1 = parcelRequire("Kswn1");
var $b51236a7af728235$var$draggableRegistry = new WeakMap();
function $b51236a7af728235$var$addToRegistry(args) {
    $b51236a7af728235$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $b51236a7af728235$var$draggableRegistry.delete(args.element);
    };
}
var $b51236a7af728235$var$honeyPotFix = (0, $hDj86.makeHoneyPotFix)();
var $b51236a7af728235$var$adapter = (0, $9LOtS.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $jrlIh.combine)($b51236a7af728235$var$honeyPotFix.bindEvents(), (0, $dH1HR.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $b51236a7af728235$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $gUlOk.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $kwSyV.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, $6eqPh.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $lJqmY.isAndroid)() && !event.dataTransfer.types.includes((0, $32gfR.textMediaType)) && !event.dataTransfer.types.includes((0, $6bk4h.URLMediaType))) event.dataTransfer.setData((0, $32gfR.textMediaType), (0, $lJqmY.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $Kswn1.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $b51236a7af728235$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $b51236a7af728235$var$honeyPotFix.getOnPostDispatch()
});
var $b51236a7af728235$export$e7140b68045b5036 = $b51236a7af728235$var$adapter.dropTarget;
var $b51236a7af728235$export$59a074bac4c54f54 = $b51236a7af728235$var$adapter.monitor;
function $b51236a7af728235$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $jrlIh.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $b51236a7af728235$var$adapter.registerUsage(), $b51236a7af728235$var$addToRegistry(args), (0, $jNxxH.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $LSEQ4.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("6eqPh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4898dbfc2a9ce226$export$2e2bcd8739ae039; });

var $gWYtT = parcelRequire("gWYtT");

var $4fTsQ = parcelRequire("4fTsQ");

var $d1AIc = parcelRequire("d1AIc");

var $8H664 = parcelRequire("8H664");
function $4898dbfc2a9ce226$export$2e2bcd8739ae039(r, e) {
    return (0, $gWYtT.default)(r) || (0, $4fTsQ.default)(r, e) || (0, $d1AIc.default)(r, e) || (0, $8H664.default)();
}

});
parcelRegister("gWYtT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c570fa6602175f5b$export$2e2bcd8739ae039; });
function $c570fa6602175f5b$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("4fTsQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3193962a3070387b$export$2e2bcd8739ae039; });
function $3193962a3070387b$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("d1AIc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $97b7d88e371e64a5$export$2e2bcd8739ae039; });

var $7KjRX = parcelRequire("7KjRX");
function $97b7d88e371e64a5$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7KjRX.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7KjRX.default)(r, a) : void 0;
    }
}

});
parcelRegister("7KjRX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5a3c3de4169ec202$export$2e2bcd8739ae039; });
function $5a3c3de4169ec202$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("8H664", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6547119538ea256a$export$2e2bcd8739ae039; });
function $6547119538ea256a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kwSyV", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", function () { return $ef211ec2baf817be$export$81d0353f25f5dd; });

var $6eqPh = parcelRequire("6eqPh");

var $g3bBV = parcelRequire("g3bBV");
function $ef211ec2baf817be$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, $6eqPh.default)(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $g3bBV.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("g3bBV", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", function () { return $baf5eed03cf5a0ad$export$821bdcd739a2706b; });

var $2mVQF = parcelRequire("2mVQF");
function $baf5eed03cf5a0ad$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $2mVQF.honeyPotDataAttribute));
}

});
parcelRegister("2mVQF", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", function () { return $1b9a8258b1e41ecb$export$6eafea55f7947469; });
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $1b9a8258b1e41ecb$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("hDj86", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", function () { return $cd64eaee9cf1bbf2$export$8ecad27c959e89e0; });

var $5nJAu = parcelRequire("5nJAu");

var $dH1HR = parcelRequire("dH1HR");

var $XNt2f = parcelRequire("XNt2f");

var $2mVQF = parcelRequire("2mVQF");
function $cd64eaee9cf1bbf2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd64eaee9cf1bbf2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd64eaee9cf1bbf2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5nJAu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd64eaee9cf1bbf2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cd64eaee9cf1bbf2$var$honeyPotSize = 2;
var $cd64eaee9cf1bbf2$var$halfHoneyPotSize = $cd64eaee9cf1bbf2$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $cd64eaee9cf1bbf2$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $cd64eaee9cf1bbf2$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $cd64eaee9cf1bbf2$var$halfHoneyPotSize,
        y: point.y - $cd64eaee9cf1bbf2$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $cd64eaee9cf1bbf2$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $cd64eaee9cf1bbf2$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $cd64eaee9cf1bbf2$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $cd64eaee9cf1bbf2$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $cd64eaee9cf1bbf2$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $cd64eaee9cf1bbf2$var$preventGoingForwardsOffScreen($cd64eaee9cf1bbf2$var$preventGoingBackwardsOffScreen($cd64eaee9cf1bbf2$var$pullBackByHalfHoneyPotSize($cd64eaee9cf1bbf2$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $cd64eaee9cf1bbf2$var$honeyPotSize,
        height: $cd64eaee9cf1bbf2$var$honeyPotSize
    });
}
function $cd64eaee9cf1bbf2$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $cd64eaee9cf1bbf2$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $cd64eaee9cf1bbf2$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $2mVQF.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $cd64eaee9cf1bbf2$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $cd64eaee9cf1bbf2$var$_objectSpread($cd64eaee9cf1bbf2$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $cd64eaee9cf1bbf2$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $XNt2f.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $dH1HR.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $cd64eaee9cf1bbf2$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $cd64eaee9cf1bbf2$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($cd64eaee9cf1bbf2$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $dH1HR.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $cd64eaee9cf1bbf2$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $dH1HR.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $cd64eaee9cf1bbf2$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("5nJAu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3eb2767e2546f26f$export$2e2bcd8739ae039; });

var $kbiNV = parcelRequire("kbiNV");
function $3eb2767e2546f26f$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kbiNV.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("kbiNV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb136bdd3c421b9f$export$2e2bcd8739ae039; });

var $b8d6k = parcelRequire("b8d6k");

var $aLJ6e = parcelRequire("aLJ6e");
function $eb136bdd3c421b9f$export$2e2bcd8739ae039(t) {
    var i = (0, $aLJ6e.default)(t, "string");
    return "symbol" == (0, $b8d6k.default)(i) ? i : i + "";
}

});
parcelRegister("b8d6k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $81aa9aa8a1272936$export$2e2bcd8739ae039; });
function $81aa9aa8a1272936$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $81aa9aa8a1272936$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $81aa9aa8a1272936$export$2e2bcd8739ae039(o);
}

});

parcelRegister("aLJ6e", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7d7147032f5fb385$export$2e2bcd8739ae039; });

var $b8d6k = parcelRequire("b8d6k");
function $7d7147032f5fb385$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8d6k.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8d6k.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("XNt2f", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", function () { return $0b3be1faf74e0525$export$7d0a15ee70427305; });
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $0b3be1faf74e0525$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("9LOtS", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", function () { return $71cfa94ff585bac1$export$2aa3a33160990d96; });

var $4BNx6 = parcelRequire("4BNx6");

var $bHtty = parcelRequire("bHtty");

var $fvY3W = parcelRequire("fvY3W");

var $2DD9Q = parcelRequire("2DD9Q");
function $71cfa94ff585bac1$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $2DD9Q.makeMonitor)();
    var dropTargetAPI = (0, $fvY3W.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $4BNx6.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $4BNx6.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $bHtty.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("4BNx6", function(module, exports) {
$parcel$export(module.exports, "lifecycle", function () { return $35b10a550411be33$export$3efdceeb8ca25c51; });

var $hs2By = parcelRequire("hs2By");

var $dH1HR = parcelRequire("dH1HR");

var $kwSyV = parcelRequire("kwSyV");

var $g3bBV = parcelRequire("g3bBV");

var $lmWo8 = parcelRequire("lmWo8");

var $hl86x = parcelRequire("hl86x");

var $gUlOk = parcelRequire("gUlOk");

var $hETpl = parcelRequire("hETpl");
var $35b10a550411be33$var$globalState = {
    isActive: false
};
function $35b10a550411be33$var$canStart() {
    return !$35b10a550411be33$var$globalState.isActive;
}
function $35b10a550411be33$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $35b10a550411be33$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $35b10a550411be33$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$35b10a550411be33$var$canStart()) return;
    var initial = $35b10a550411be33$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $35b10a550411be33$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $35b10a550411be33$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $hETpl.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $35b10a550411be33$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $gUlOk.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $g3bBV.isHoneyPotElement)(event.target) ? (0, $kwSyV.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $35b10a550411be33$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $35b10a550411be33$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $dH1HR.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $lmWo8.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $gUlOk.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $35b10a550411be33$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $gUlOk.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, $hs2By.default)((0, $hl86x.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $35b10a550411be33$var$getNativeSetDragImage(event)
    });
}
function $35b10a550411be33$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $35b10a550411be33$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $gUlOk.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $35b10a550411be33$export$3efdceeb8ca25c51 = {
    canStart: $35b10a550411be33$var$canStart,
    start: $35b10a550411be33$var$start
};

});
parcelRegister("hs2By", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cb471271087fb58b$export$2e2bcd8739ae039; });

var $10j7M = parcelRequire("10j7M");

var $OQkYA = parcelRequire("OQkYA");

var $d1AIc = parcelRequire("d1AIc");

var $68iaM = parcelRequire("68iaM");
function $cb471271087fb58b$export$2e2bcd8739ae039(r) {
    return (0, $10j7M.default)(r) || (0, $OQkYA.default)(r) || (0, $d1AIc.default)(r) || (0, $68iaM.default)();
}

});
parcelRegister("10j7M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0bb4a044db8f8d4c$export$2e2bcd8739ae039; });

var $7KjRX = parcelRequire("7KjRX");
function $0bb4a044db8f8d4c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7KjRX.default)(r);
}

});

parcelRegister("OQkYA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $098d44bab634cc5b$export$2e2bcd8739ae039; });
function $098d44bab634cc5b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("68iaM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $47719634b4e3841c$export$2e2bcd8739ae039; });
function $47719634b4e3841c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lmWo8", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", function () { return $f8e8f1c08f8e8d3d$export$57d220c74e84a273; });

var $gjrVx = parcelRequire("gjrVx");

var $6EVQu = parcelRequire("6EVQu");

var $jFod5 = parcelRequire("jFod5");

var $3RPG8 = parcelRequire("3RPG8");
function $f8e8f1c08f8e8d3d$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $6EVQu.isSafari)()) return (0, $jFod5.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $gjrVx.isFirefox)()) return (0, $3RPG8.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("gjrVx", function(module, exports) {
$parcel$export(module.exports, "isFirefox", function () { return $be041565cdba7374$export$b7d78993b74f766d; });

var $LSEQ4 = parcelRequire("LSEQ4");
var $be041565cdba7374$export$b7d78993b74f766d = (0, $LSEQ4.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("LSEQ4", function(module, exports) {
$parcel$export(module.exports, "once", function () { return $08fec9c7b3ed8a7f$export$d2de3aaeafa91619; });
/** Provide a function that you only ever want to be called a single time */ function $08fec9c7b3ed8a7f$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("6EVQu", function(module, exports) {
$parcel$export(module.exports, "isSafari", function () { return $4d93597535f1d36d$export$95df08bae54cb4df; });

var $LSEQ4 = parcelRequire("LSEQ4");
var $4d93597535f1d36d$export$95df08bae54cb4df = (0, $LSEQ4.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("jFod5", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", function () { return $e514a04b6e3bb510$export$de68634bd94ed596; });
$parcel$export(module.exports, "isLeavingWindowInSafari", function () { return $e514a04b6e3bb510$export$f21837c338005454; });

var $dH1HR = parcelRequire("dH1HR");

var $6EVQu = parcelRequire("6EVQu");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $e514a04b6e3bb510$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $e514a04b6e3bb510$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $6EVQu.isSafari)()) return false;
    return dragEnter.hasOwnProperty($e514a04b6e3bb510$var$symbols.isEnteringWindow);
}
function $e514a04b6e3bb510$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $6EVQu.isSafari)()) return false;
    return dragLeave.hasOwnProperty($e514a04b6e3bb510$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $6EVQu.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $dH1HR.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$e514a04b6e3bb510$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$e514a04b6e3bb510$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("3RPG8", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", function () { return $2d0e68a1726d26be$export$e46810fef53b5b0e; });
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $2d0e68a1726d26be$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $2d0e68a1726d26be$export$e46810fef53b5b0e(eventTarget) {
    return $2d0e68a1726d26be$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("hl86x", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", function () { return $c9faaf2f097e7b0c$export$ac5e5b0daf997b2; });
function $c9faaf2f097e7b0c$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("gUlOk", function(module, exports) {
$parcel$export(module.exports, "getInput", function () { return $c4f2cb7929aef229$export$7c112ceec8941e67; });
function $c4f2cb7929aef229$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("hETpl", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", function () { return $cdb126ee2a5c3c22$export$9f13ecc44e83d682; });

var $FcGYz = parcelRequire("FcGYz");
var $cdb126ee2a5c3c22$var$scheduleOnDrag = (0, $FcGYz.default)(function(fn) {
    return fn();
});
var $cdb126ee2a5c3c22$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $cdb126ee2a5c3c22$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $cdb126ee2a5c3c22$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $cdb126ee2a5c3c22$var$dragStart.flush();
            $cdb126ee2a5c3c22$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $cdb126ee2a5c3c22$var$scheduleOnDrag(function() {
                $cdb126ee2a5c3c22$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $cdb126ee2a5c3c22$var$dragStart.flush();
            $cdb126ee2a5c3c22$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("bHtty", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $884a93185dad55c1$export$6503ec6e8aabbaf; });
// Extending `Map` to allow us to link Key and Values together
var $884a93185dad55c1$var$ledger = new Map();
function $884a93185dad55c1$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $884a93185dad55c1$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $884a93185dad55c1$var$ledger.set(typeKey, initial);
    return initial;
}
function $884a93185dad55c1$export$6503ec6e8aabbaf(args) {
    var entry = $884a93185dad55c1$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $884a93185dad55c1$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("fvY3W", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", function () { return $b4b85775c702178f$export$47d10e7bd9c81890; });

var $5nJAu = parcelRequire("5nJAu");

var $hs2By = parcelRequire("hs2By");

var $jrlIh = parcelRequire("jrlIh");

var $LSEQ4 = parcelRequire("LSEQ4");

var $jNxxH = parcelRequire("jNxxH");
function $b4b85775c702178f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4b85775c702178f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4b85775c702178f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5nJAu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4b85775c702178f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4b85775c702178f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b4b85775c702178f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b4b85775c702178f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b4b85775c702178f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b4b85775c702178f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b4b85775c702178f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b4b85775c702178f$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $b4b85775c702178f$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $jrlIh.combine)((0, $jNxxH.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $LSEQ4.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, $hs2By.default)(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $b4b85775c702178f$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $b4b85775c702178f$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $b4b85775c702178f$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $b4b85775c702178f$var$copyReverse(current);
        var actualCaptureOrdered = $b4b85775c702178f$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($b4b85775c702178f$var$_objectSpread($b4b85775c702178f$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $b4b85775c702178f$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("jNxxH", function(module, exports) {
$parcel$export(module.exports, "addAttribute", function () { return $e69c9cc9a78ce998$export$5dcb5c23b6ba980a; });
function $e69c9cc9a78ce998$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("2DD9Q", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", function () { return $1ebd9937af4d03e5$export$5dd4ed888d5b12ca; });

var $5nJAu = parcelRequire("5nJAu");

var $LSEQ4 = parcelRequire("LSEQ4");
function $1ebd9937af4d03e5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1ebd9937af4d03e5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1ebd9937af4d03e5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1ebd9937af4d03e5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1ebd9937af4d03e5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1ebd9937af4d03e5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1ebd9937af4d03e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ebd9937af4d03e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ebd9937af4d03e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5nJAu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ebd9937af4d03e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1ebd9937af4d03e5$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $1ebd9937af4d03e5$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $LSEQ4.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $1ebd9937af4d03e5$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("lJqmY", function(module, exports) {
$parcel$export(module.exports, "isAndroid", function () { return $fd224162c5813617$export$a11b0059900ceec8; });
$parcel$export(module.exports, "androidFallbackText", function () { return $fd224162c5813617$export$aceb3ed8b7f7bd2c; });

var $LSEQ4 = parcelRequire("LSEQ4");
var $fd224162c5813617$export$a11b0059900ceec8 = (0, $LSEQ4.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $fd224162c5813617$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("32gfR", function(module, exports) {
$parcel$export(module.exports, "textMediaType", function () { return $235e2adb5c73372c$export$fd3d00026297c0ad; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $235e2adb5c73372c$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("6bk4h", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", function () { return $4803563e49ee8c25$export$4c44a460f123106; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $4803563e49ee8c25$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("Kswn1", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", function () { return $08ba6bb0561a593b$export$c9c4cc54e73b125d; });
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $08ba6bb0561a593b$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("eDaGe", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", function () { return (parcelRequire("kB894")).monitorForExternal; });

var $kB894 = parcelRequire("kB894");
 // The data that is being dragged

});
parcelRegister("kB894", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", function () { return $efed94d33bb2fc91$export$bb1740f3194979c1; });

var $hs2By = parcelRequire("hs2By");

var $dH1HR = parcelRequire("dH1HR");

var $9LOtS = parcelRequire("9LOtS");

var $lJqmY = parcelRequire("lJqmY");

var $2WVea = parcelRequire("2WVea");

var $hl86x = parcelRequire("hl86x");

var $32gfR = parcelRequire("32gfR");

var $Kswn1 = parcelRequire("Kswn1");
function $efed94d33bb2fc91$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $Kswn1.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $32gfR.textMediaType) && value === (0, $lJqmY.androidFallbackText)) return false;
    return true;
}
function $efed94d33bb2fc91$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $efed94d33bb2fc91$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $efed94d33bb2fc91$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $efed94d33bb2fc91$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $efed94d33bb2fc91$var$didDragStartLocally = false;
var $efed94d33bb2fc91$var$adapter = (0, $9LOtS.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $dH1HR.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($efed94d33bb2fc91$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $2WVea.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $efed94d33bb2fc91$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $efed94d33bb2fc91$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$efed94d33bb2fc91$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $efed94d33bb2fc91$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $efed94d33bb2fc91$var$adapter.dropTarget(args);
}
function $efed94d33bb2fc91$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $efed94d33bb2fc91$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $efed94d33bb2fc91$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $efed94d33bb2fc91$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $dH1HR.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, $hs2By.default)((0, $hl86x.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $dH1HR.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $efed94d33bb2fc91$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("2WVea", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", function () { return $225d63bde78125d5$export$d1c6f249e893cdf4; });

var $gjrVx = parcelRequire("gjrVx");

var $6EVQu = parcelRequire("6EVQu");

var $jFod5 = parcelRequire("jFod5");

var $3RPG8 = parcelRequire("3RPG8");
function $225d63bde78125d5$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $6EVQu.isSafari)()) return (0, $jFod5.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $gjrVx.isFirefox)()) return (0, $3RPG8.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("d58at", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", function () { return (parcelRequire("fJq9X")).monitorForTextSelection; });

var $fJq9X = parcelRequire("fJq9X");
 // Payload for the text selection being dragged

});
parcelRegister("fJq9X", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", function () { return $b73f59c29195457a$export$2e178e3647f5e6e9; });

var $dH1HR = parcelRequire("dH1HR");

var $hDj86 = parcelRequire("hDj86");

var $9LOtS = parcelRequire("9LOtS");

var $jrlIh = parcelRequire("jrlIh");

var $6EVQu = parcelRequire("6EVQu");

var $ihvnn = parcelRequire("ihvnn");

var $32gfR = parcelRequire("32gfR");

var $Kswn1 = parcelRequire("Kswn1");
function $b73f59c29195457a$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $6EVQu.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $32gfR.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $b73f59c29195457a$var$honeyPotFix = (0, $hDj86.makeHoneyPotFix)();
var $b73f59c29195457a$var$adapter = (0, $9LOtS.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $jrlIh.combine)($b73f59c29195457a$var$honeyPotFix.bindEvents(), (0, $dH1HR.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $Kswn1.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $32gfR.textMediaType))) return;
                var target = $b73f59c29195457a$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $32gfR.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $ihvnn.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $b73f59c29195457a$var$honeyPotFix.getOnPostDispatch()
});
function $b73f59c29195457a$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $b73f59c29195457a$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $b73f59c29195457a$var$adapter.registerUsage();
})();
function $b73f59c29195457a$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $b73f59c29195457a$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("ihvnn", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", function () { return $d4f227288019bb04$export$338a9f6c7a1f02b0; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $d4f227288019bb04$export$338a9f6c7a1f02b0 = 'text/html';

});



parcelRegister("juHRB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e312d80949a3af53$export$2e2bcd8739ae039; });
function $e312d80949a3af53$export$2e2bcd8739ae039() {
    return $e312d80949a3af53$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e312d80949a3af53$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("lh6gB", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $f7d00bf16dc866e5$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $f7d00bf16dc866e5$export$2e2bcd8739ae039; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $juHRB = parcelRequire("juHRB");

var $3eKHz = parcelRequire("3eKHz");

var $1oC0p = parcelRequire("1oC0p");

var $liJ1d = parcelRequire("liJ1d");
function $f7d00bf16dc866e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7d00bf16dc866e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7d00bf16dc866e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3eKHz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7d00bf16dc866e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $f7d00bf16dc866e5$var$iconStyles = null;
var $f7d00bf16dc866e5$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $f7d00bf16dc866e5$var$baseHcmStyles = null;
var $f7d00bf16dc866e5$var$primaryEqualsSecondaryHcmStyles = null;
var $f7d00bf16dc866e5$var$secondaryTransparentHcmStyles = null;
var $f7d00bf16dc866e5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $1oC0p.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $juHRB.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $f7d00bf16dc866e5$var$_objectSpread($f7d00bf16dc866e5$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $liJ1d.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $f7d00bf16dc866e5$var$sizeStyles[size]
        ])
    }));
});
var $f7d00bf16dc866e5$export$2e2bcd8739ae039 = $f7d00bf16dc866e5$export$f04a61298a47a40f;

});
parcelRegister("3eKHz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $25b6e7eb66633d06$export$2e2bcd8739ae039; });

var $21EcX = parcelRequire("21EcX");
function $25b6e7eb66633d06$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $21EcX.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("21EcX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $179add3b036ad843$export$2e2bcd8739ae039; });

var $f3yGC = parcelRequire("f3yGC");

var $9w56w = parcelRequire("9w56w");
function $179add3b036ad843$export$2e2bcd8739ae039(t) {
    var i = (0, $9w56w.default)(t, "string");
    return "symbol" == (0, $f3yGC.default)(i) ? i : i + "";
}

});
parcelRegister("f3yGC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af620ad841c62d38$export$2e2bcd8739ae039; });
function $af620ad841c62d38$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $af620ad841c62d38$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $af620ad841c62d38$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9w56w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6edb0fce587f87fd$export$2e2bcd8739ae039; });

var $f3yGC = parcelRequire("f3yGC");
function $6edb0fce587f87fd$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $f3yGC.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $f3yGC.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("5OpwE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43b56c1c35984d2f$var$_react = $43b56c1c35984d2f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $43b56c1c35984d2f$var$_baseNew = $43b56c1c35984d2f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $43b56c1c35984d2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43b56c1c35984d2f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $43b56c1c35984d2f$var$_react.default.createElement($43b56c1c35984d2f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$43b56c1c35984d2f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $43b56c1c35984d2f$var$_default = module.exports.default = $43b56c1c35984d2f$var$CrossCircleIcon;

});

parcelRegister("5P1ZO", function(module, exports) {
$parcel$export(module.exports, "auth", function () { return $43d34383b0503a4c$export$73693bad9f5880b0; });
$parcel$export(module.exports, "AuthError", function () { return (parcelRequire("89ncj")).AuthError; });

var $ienDc = parcelRequire("ienDc");

var $89ncj = parcelRequire("89ncj");

var $D3o0i = parcelRequire("D3o0i");
function $43d34383b0503a4c$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise(function(resolve, reject) {
        var authWindow = null;
        var authWindowInterval;
        var handleAuthWindowMessage = function handleAuthWindowMessage(event) {
            if (event.source !== authWindow) return;
            var data = event.data;
            if ((0, $ienDc.default)(data) !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    var errorType = data.errorType.toLowerCase();
                    if ((0, $D3o0i.isOfTypeAuthError)(errorType)) reject(new (0, $89ncj.AuthError)(data.message, errorType));
                    else reject(new (0, $89ncj.AuthError)(data.message));
                    break;
            }
        };
        var handleAuthWindowInterval = function handleAuthWindowInterval() {
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $89ncj.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        var start = function start() {
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        var finish = function finish() {
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("ienDc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d45bdd75e69db9cb$export$2e2bcd8739ae039; });
function $d45bdd75e69db9cb$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d45bdd75e69db9cb$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d45bdd75e69db9cb$export$2e2bcd8739ae039(o);
}

});

parcelRegister("89ncj", function(module, exports) {
$parcel$export(module.exports, "AuthError", function () { return $5ef12891a1a44a4c$export$145273558d58e0ac; });

var $1r8Mv = parcelRequire("1r8Mv");

var $kui8G = parcelRequire("kui8G");

var $X4Dxy = parcelRequire("X4Dxy");

var $z99Nn = parcelRequire("z99Nn");

var $eMPeG = parcelRequire("eMPeG");

var $7cbed = parcelRequire("7cbed");
function $5ef12891a1a44a4c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5ef12891a1a44a4c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $eMPeG.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eMPeG.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $z99Nn.default)(this, result);
    };
}
function $5ef12891a1a44a4c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5ef12891a1a44a4c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5ef12891a1a44a4c$export$145273558d58e0ac = /*#__PURE__*/ function(_Error) {
    (0, $X4Dxy.default)(AuthError, _Error);
    var _super = $5ef12891a1a44a4c$var$_createSuper(AuthError);
    function AuthError(message, type) {
        var _this;
        (0, $kui8G.default)(this, AuthError);
        _this = _super.call(this, message);
        _this.message = message;
        _this.type = type;
        _this.name = 'AuthError';
        _this.type = type;
        _this.message = message;
        return _this;
    }
    return (0, $1r8Mv.default)(AuthError);
}(/*#__PURE__*/ (0, $7cbed.default)(Error));

});
parcelRegister("1r8Mv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $10bf1fdbfbe062df$export$2e2bcd8739ae039; });

var $lTjtg = parcelRequire("lTjtg");
function $10bf1fdbfbe062df$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $lTjtg.default)(o.key), o);
    }
}
function $10bf1fdbfbe062df$export$2e2bcd8739ae039(e, r, t) {
    return r && $10bf1fdbfbe062df$var$_defineProperties(e.prototype, r), t && $10bf1fdbfbe062df$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("lTjtg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fefdd68f7f2c503f$export$2e2bcd8739ae039; });

var $ienDc = parcelRequire("ienDc");

var $3zjyS = parcelRequire("3zjyS");
function $fefdd68f7f2c503f$export$2e2bcd8739ae039(t) {
    var i = (0, $3zjyS.default)(t, "string");
    return "symbol" == (0, $ienDc.default)(i) ? i : i + "";
}

});
parcelRegister("3zjyS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2993d079300a16cf$export$2e2bcd8739ae039; });

var $ienDc = parcelRequire("ienDc");
function $2993d079300a16cf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ienDc.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ienDc.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("kui8G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eea4ae0b84a1b5e4$export$2e2bcd8739ae039; });
function $eea4ae0b84a1b5e4$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("X4Dxy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0b191b905a1c1062$export$2e2bcd8739ae039; });

var $c0kbE = parcelRequire("c0kbE");
function $0b191b905a1c1062$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c0kbE.default)(t, e);
}

});
parcelRegister("c0kbE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8bd524d085f7c8a7$export$2e2bcd8739ae039; });
function $8bd524d085f7c8a7$export$2e2bcd8739ae039(t, e) {
    return $8bd524d085f7c8a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8bd524d085f7c8a7$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("z99Nn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $069a5f62e6d51648$export$2e2bcd8739ae039; });

var $ienDc = parcelRequire("ienDc");

var $hyFDq = parcelRequire("hyFDq");
function $069a5f62e6d51648$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $ienDc.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hyFDq.default)(t);
}

});
parcelRegister("hyFDq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc85e87de3053c18$export$2e2bcd8739ae039; });
function $cc85e87de3053c18$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("eMPeG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ac3d4ac4d15a47fa$export$2e2bcd8739ae039; });
function $ac3d4ac4d15a47fa$export$2e2bcd8739ae039(t) {
    return $ac3d4ac4d15a47fa$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ac3d4ac4d15a47fa$export$2e2bcd8739ae039(t);
}

});

parcelRegister("7cbed", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $53d25d16106b9f0f$export$2e2bcd8739ae039; });

var $eMPeG = parcelRequire("eMPeG");

var $c0kbE = parcelRequire("c0kbE");

var $iJA9n = parcelRequire("iJA9n");

var $3tsBw = parcelRequire("3tsBw");
function $53d25d16106b9f0f$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $53d25d16106b9f0f$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $iJA9n.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $3tsBw.default)(t, arguments, (0, $eMPeG.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $c0kbE.default)(Wrapper, t);
    }, $53d25d16106b9f0f$export$2e2bcd8739ae039(t);
}

});
parcelRegister("iJA9n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da3878a73103852b$export$2e2bcd8739ae039; });
function $da3878a73103852b$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("3tsBw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $287a44baa858995e$export$2e2bcd8739ae039; });

var $lO0fn = parcelRequire("lO0fn");

var $c0kbE = parcelRequire("c0kbE");
function $287a44baa858995e$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $lO0fn.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $c0kbE.default)(p, r.prototype), p;
}

});
parcelRegister("lO0fn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fdfe75859f668eb8$export$2e2bcd8739ae039; });
function $fdfe75859f668eb8$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fdfe75859f668eb8$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});




parcelRegister("D3o0i", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", function () { return $0756450db8909afa$export$400e64c8451aa84f; });
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
var $0756450db8909afa$export$400e64c8451aa84f = function isOfTypeAuthError(inputString) {
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("9tc44", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e502e4b67b18fd0$var$_react = $6e502e4b67b18fd0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6e502e4b67b18fd0$var$_baseNew = $6e502e4b67b18fd0$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6e502e4b67b18fd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e502e4b67b18fd0$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $6e502e4b67b18fd0$var$_react.default.createElement($6e502e4b67b18fd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$6e502e4b67b18fd0$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $6e502e4b67b18fd0$var$_default = module.exports.default = $6e502e4b67b18fd0$var$CheckboxCheckedIcon;

});

parcelRegister("ldYqt", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", function () { return $f739af3b6cae21c8$export$81b70111112841a0; });
var $f739af3b6cae21c8$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("fxaW1", function(module, exports) {
$parcel$export(module.exports, "shallowEqualObjects", function () { return $b4f26b8985dec6dd$export$3e67810a3f0e9f1c; });
function $b4f26b8985dec6dd$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $b4f26b8985dec6dd$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $b4f26b8985dec6dd$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $b4f26b8985dec6dd$export$967a6b9924a689f7(a, b);
    return $b4f26b8985dec6dd$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("h8nQ0", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", function () { return $c795acb9486f97f6$export$ac1cddfee07ba6ac; });

var $bj7O4 = parcelRequire("bj7O4");

var $hlTGc = parcelRequire("hlTGc");

var $7VYEH = parcelRequire("7VYEH");

var $jggcA = parcelRequire("jggcA");

var $ek6PN = parcelRequire("ek6PN");
var $c795acb9486f97f6$export$ac1cddfee07ba6ac = /*#__PURE__*/ function() {
    function ConcurrentExperience(experienceId, config) {
        (0, $bj7O4.default)(this, ConcurrentExperience);
        (0, $7VYEH.default)(this, "instances", {});
        this.experienceId = experienceId;
        this.config = config;
    }
    return (0, $hlTGc.default)(ConcurrentExperience, [
        {
            key: "getInstance",
            value: function getInstance(instanceId) {
                if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $ek6PN.UFOExperience)(this.experienceId, this.config, instanceId);
                return this.instances[instanceId];
            }
        },
        {
            key: "release",
            value: function release(instanceId) {
                (0, $jggcA.ufolog)('instanceId', instanceId);
                if (this.instances[instanceId]) this.instances[instanceId].abort();
                delete this.instances[instanceId];
            }
        }
    ]);
}();

});
parcelRegister("bj7O4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $83b7864e7b6a1a38$export$2e2bcd8739ae039; });
function $83b7864e7b6a1a38$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hlTGc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca1f96a96ebdb80d$export$2e2bcd8739ae039; });

var $i6dBz = parcelRequire("i6dBz");
function $ca1f96a96ebdb80d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $i6dBz.default)(o.key), o);
    }
}
function $ca1f96a96ebdb80d$export$2e2bcd8739ae039(e, r, t) {
    return r && $ca1f96a96ebdb80d$var$_defineProperties(e.prototype, r), t && $ca1f96a96ebdb80d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("i6dBz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d2d3572de3bea27e$export$2e2bcd8739ae039; });

var $fGKCr = parcelRequire("fGKCr");

var $es9ah = parcelRequire("es9ah");
function $d2d3572de3bea27e$export$2e2bcd8739ae039(t) {
    var i = (0, $es9ah.default)(t, "string");
    return "symbol" == (0, $fGKCr.default)(i) ? i : i + "";
}

});
parcelRegister("fGKCr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b6bef0cf6ac3860d$export$2e2bcd8739ae039; });
function $b6bef0cf6ac3860d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b6bef0cf6ac3860d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b6bef0cf6ac3860d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("es9ah", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a85aca2de407c4da$export$2e2bcd8739ae039; });

var $fGKCr = parcelRequire("fGKCr");
function $a85aca2de407c4da$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fGKCr.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fGKCr.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7VYEH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c6ce82cab3da670$export$2e2bcd8739ae039; });

var $i6dBz = parcelRequire("i6dBz");
function $5c6ce82cab3da670$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $i6dBz.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("jggcA", function(module, exports) {
$parcel$export(module.exports, "ufolog", function () { return $e05c14597ab17ea4$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $e05c14597ab17ea4$export$d53d07b6034c4560; });

var $bj7O4 = parcelRequire("bj7O4");

var $hlTGc = parcelRequire("hlTGc");

var $7VYEH = parcelRequire("7VYEH");
var $e05c14597ab17ea4$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $bj7O4.default)(this, UFOLogger);
        (0, $7VYEH.default)(this, "enabled", false);
    }
    return (0, $hlTGc.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
}();
(0, $7VYEH.default)($e05c14597ab17ea4$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $e05c14597ab17ea4$export$4ab84f6f04f6566d = new $e05c14597ab17ea4$var$UFOLogger();
var $e05c14597ab17ea4$export$b4958caff08a0960 = function ufolog() {
    $e05c14597ab17ea4$export$4ab84f6f04f6566d.log.apply($e05c14597ab17ea4$export$4ab84f6f04f6566d, arguments);
};
var $e05c14597ab17ea4$export$d53d07b6034c4560 = function ufowarn() {
    $e05c14597ab17ea4$export$4ab84f6f04f6566d.warn.apply($e05c14597ab17ea4$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("ek6PN", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", function () { return $a6d83c1c9803e538$export$c00d22927c60484a; });

var $hlTGc = parcelRequire("hlTGc");

var $bj7O4 = parcelRequire("bj7O4");

var $kCuoL = parcelRequire("kCuoL");

var $ku8YH = parcelRequire("ku8YH");

var $18fYE = parcelRequire("18fYE");

var $8EmPZ = parcelRequire("8EmPZ");
function $a6d83c1c9803e538$var$_callSuper(t, o, e) {
    return o = (0, $ku8YH.default)(o), (0, $kCuoL.default)(t, $a6d83c1c9803e538$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $ku8YH.default)(t).constructor) : o.apply(t, e));
}
function $a6d83c1c9803e538$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a6d83c1c9803e538$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a6d83c1c9803e538$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    function UFOExperience() {
        (0, $bj7O4.default)(this, UFOExperience);
        return $a6d83c1c9803e538$var$_callSuper(this, UFOExperience, arguments);
    }
    (0, $18fYE.default)(UFOExperience, _UFOAbstractExperienc);
    return (0, $hlTGc.default)(UFOExperience);
}((0, $8EmPZ.UFOAbstractExperience));

});
parcelRegister("kCuoL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f02eefc5ddfceade$export$2e2bcd8739ae039; });

var $fGKCr = parcelRequire("fGKCr");

var $10Flm = parcelRequire("10Flm");
function $f02eefc5ddfceade$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $fGKCr.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $10Flm.default)(t);
}

});
parcelRegister("10Flm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0bc5dc832e325cc5$export$2e2bcd8739ae039; });
function $0bc5dc832e325cc5$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("ku8YH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ee9d92d47dabfe78$export$2e2bcd8739ae039; });
function $ee9d92d47dabfe78$export$2e2bcd8739ae039(t) {
    return $ee9d92d47dabfe78$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ee9d92d47dabfe78$export$2e2bcd8739ae039(t);
}

});

parcelRegister("18fYE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0d32ee870483e5e7$export$2e2bcd8739ae039; });

var $8R1ad = parcelRequire("8R1ad");
function $0d32ee870483e5e7$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $8R1ad.default)(t, e);
}

});
parcelRegister("8R1ad", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $67242d0f11264f28$export$2e2bcd8739ae039; });
function $67242d0f11264f28$export$2e2bcd8739ae039(t, e) {
    return $67242d0f11264f28$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $67242d0f11264f28$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("8EmPZ", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", function () { return $64c3c63d1bb981f6$export$d31c89db257648c; });

var $hQrK6 = parcelRequire("hQrK6");

var $kpMp0 = parcelRequire("kpMp0");

var $bj7O4 = parcelRequire("bj7O4");

var $hlTGc = parcelRequire("hlTGc");

var $7VYEH = parcelRequire("7VYEH");

var $eaPRg = parcelRequire("eaPRg");

var $5df37 = parcelRequire("5df37");

var $iEVkD = parcelRequire("iEVkD");

var $6BOUe = parcelRequire("6BOUe");

var $jggcA = parcelRequire("jggcA");

var $gr8DY = parcelRequire("gr8DY");

var $inUWW = parcelRequire("inUWW");

var $l7rXA = parcelRequire("l7rXA");

var $4kW0y = parcelRequire("4kW0y");

var $ldYqt = parcelRequire("ldYqt");

var $eOBv1 = parcelRequire("eOBv1");

var $bPjpC = parcelRequire("bPjpC");
function $64c3c63d1bb981f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64c3c63d1bb981f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64c3c63d1bb981f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $7VYEH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64c3c63d1bb981f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $64c3c63d1bb981f6$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $4kW0y.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $inUWW.PageVisibleState).VISIBLE : (0, $inUWW.PageVisibleState).HIDDEN;
};
var $64c3c63d1bb981f6$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $l7rXA.roundPerfNow)();
};
var $64c3c63d1bb981f6$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $bj7O4.default)(this, UFOAbstractExperience);
        (0, $7VYEH.default)(this, "state", (0, $ldYqt.UFOExperienceState).NOT_STARTED);
        (0, $7VYEH.default)(this, "instanceId", null);
        // for concurrent
        (0, $7VYEH.default)(this, "parent", null);
        (0, $7VYEH.default)(this, "category", null);
        (0, $7VYEH.default)(this, "metadata", {});
        (0, $7VYEH.default)(this, "onDoneCallbacks", []);
        (0, $7VYEH.default)(this, "childExperiences", []);
        (0, $7VYEH.default)(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, $7VYEH.default)(this, "isSSROutputAsFMP", false);
        (0, $7VYEH.default)(this, "uuid", null);
        (0, $7VYEH.default)(this, "_until", null);
        (0, $7VYEH.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $7VYEH.default)(this, "performanceConfig", {});
        (0, $7VYEH.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $inUWW.PageVisibleState).MIXED;
            (0, $gr8DY.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $64c3c63d1bb981f6$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $bPjpC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $bPjpC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    return (0, $hlTGc.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $kpMp0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $jggcA.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $eOBv1.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $jggcA.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $ldYqt.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $64c3c63d1bb981f6$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $5df37.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $64c3c63d1bb981f6$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $6BOUe.getGlobalEventStream)().push((0, $6BOUe.unsubscribeEvent)((0, $inUWW.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $jggcA.ufolog)('this.parent', this.parent);
                                (0, $6BOUe.getGlobalEventStream)().push((0, $6BOUe.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $jggcA.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $jggcA.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $kpMp0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $ldYqt.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $64c3c63d1bb981f6$var$getPageVisibleState();
                                    (0, $gr8DY.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $jggcA.ufolog)('subscribed', this.id);
                                        (0, $6BOUe.getGlobalEventStream)().push((0, $6BOUe.subscribeEvent)((0, $inUWW.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $inUWW.FMP_MARK) && name !== (0, $inUWW.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $jggcA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $64c3c63d1bb981f6$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $ldYqt.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $inUWW.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $inUWW.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $jggcA.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $gr8DY.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $kpMp0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $ldYqt.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $kpMp0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $ldYqt.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $kpMp0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $ldYqt.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $jggcA.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $kpMp0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $kpMp0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eaPRg))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $iEVkD.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $64c3c63d1bb981f6$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $64c3c63d1bb981f6$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $hQrK6.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
}();

});
parcelRegister("hQrK6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cfdcd0149ff551fb$export$2e2bcd8739ae039; });

var $7VOrb = parcelRequire("7VOrb");

var $1gjqm = parcelRequire("1gjqm");

var $xyVks = parcelRequire("xyVks");

var $8QghY = parcelRequire("8QghY");
function $cfdcd0149ff551fb$export$2e2bcd8739ae039(r) {
    return (0, $7VOrb.default)(r) || (0, $1gjqm.default)(r) || (0, $xyVks.default)(r) || (0, $8QghY.default)();
}

});
parcelRegister("7VOrb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c64fb1b7165d20c$export$2e2bcd8739ae039; });

var $7trxc = parcelRequire("7trxc");
function $5c64fb1b7165d20c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7trxc.default)(r);
}

});
parcelRegister("7trxc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5710999f2ad59081$export$2e2bcd8739ae039; });
function $5710999f2ad59081$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1gjqm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0eb65a510a0f098a$export$2e2bcd8739ae039; });
function $0eb65a510a0f098a$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("xyVks", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $064e2c4b19b30a90$export$2e2bcd8739ae039; });

var $7trxc = parcelRequire("7trxc");
function $064e2c4b19b30a90$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7trxc.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7trxc.default)(r, a) : void 0;
    }
}

});

parcelRegister("8QghY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66ffd0b1be14169d$export$2e2bcd8739ae039; });
function $66ffd0b1be14169d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kpMp0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edcbb02021ba1a09$export$2e2bcd8739ae039; });
function $edcbb02021ba1a09$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $edcbb02021ba1a09$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $edcbb02021ba1a09$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $edcbb02021ba1a09$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("eaPRg", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $a51a39ceccded4a8$var$runtime = (parcelRequire("fp3oU"))();
module.exports = $a51a39ceccded4a8$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a51a39ceccded4a8$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a51a39ceccded4a8$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a51a39ceccded4a8$var$runtime);
}

});
parcelRegister("fp3oU", function(module, exports) {

var $fzS7W = parcelRequire("fzS7W");

var $k9GFR = parcelRequire("k9GFR");

var $fW4FU = parcelRequire("fW4FU");

var $cKK8i = parcelRequire("cKK8i");

var $feLeE = parcelRequire("feLeE");

var $8bOdj = parcelRequire("8bOdj");

var $h3SCN = parcelRequire("h3SCN");
function $b36bd41fa92d55fb$var$_regeneratorRuntime() {
    "use strict";
    var r = $k9GFR(), e = r.m($b36bd41fa92d55fb$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $h3SCN(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $b36bd41fa92d55fb$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $fzS7W(r, e);
            },
            AsyncIterator: $feLeE,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $cKK8i : $fW4FU)(a(r), e, t, o, u);
            },
            keys: $8bOdj,
            values: $h3SCN
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $b36bd41fa92d55fb$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fzS7W", function(module, exports) {
function $b5741c6dedaea51b$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $b5741c6dedaea51b$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k9GFR", function(module, exports) {

var $dOmim = parcelRequire("dOmim");
function $eac5c01ad2c3be21$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $dOmim(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($dOmim(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $dOmim(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $dOmim(u, "constructor", GeneratorFunctionPrototype), $dOmim(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $dOmim(GeneratorFunctionPrototype, o, "GeneratorFunction"), $dOmim(u), $dOmim(u, o, "Generator"), $dOmim(u, n, function() {
        return this;
    }), $dOmim(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $eac5c01ad2c3be21$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $eac5c01ad2c3be21$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dOmim", function(module, exports) {
function $a0e13d3d4928ac0a$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $a0e13d3d4928ac0a$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $a0e13d3d4928ac0a$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a0e13d3d4928ac0a$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $a0e13d3d4928ac0a$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fW4FU", function(module, exports) {

var $cKK8i = parcelRequire("cKK8i");
function $b99fe622b5b82bbb$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $cKK8i(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $b99fe622b5b82bbb$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cKK8i", function(module, exports) {

var $k9GFR = parcelRequire("k9GFR");

var $feLeE = parcelRequire("feLeE");
function $948d90ed82f911e8$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $feLeE($k9GFR().w(r, e, t, o), n || Promise);
}
module.exports = $948d90ed82f911e8$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("feLeE", function(module, exports) {

var $fzS7W = parcelRequire("fzS7W");

var $dOmim = parcelRequire("dOmim");
function $b17ccdc922689fb9$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $fzS7W ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($dOmim($b17ccdc922689fb9$var$AsyncIterator.prototype), $dOmim($b17ccdc922689fb9$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $dOmim(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $b17ccdc922689fb9$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8bOdj", function(module, exports) {
function $5f664d39927c7818$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $5f664d39927c7818$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("h3SCN", function(module, exports) {

var $2ZhwD = parcelRequire("2ZhwD");
var $c6bd16d3aca44479$var$_typeof = $2ZhwD.default;
function $c6bd16d3aca44479$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($c6bd16d3aca44479$var$_typeof(e) + " is not iterable");
}
module.exports = $c6bd16d3aca44479$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2ZhwD", function(module, exports) {
function $22cedf768b250c33$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $22cedf768b250c33$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $22cedf768b250c33$var$_typeof(o);
}
module.exports = $22cedf768b250c33$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("5df37", function(module, exports) {

var $fl0qq = parcelRequire("fl0qq");

var $5TdI6 = parcelRequire("5TdI6");
var $3cb9d723354318c5$var$uuid = $5TdI6;
$3cb9d723354318c5$var$uuid.v1 = $fl0qq;
$3cb9d723354318c5$var$uuid.v4 = $5TdI6;
module.exports = $3cb9d723354318c5$var$uuid;

});
parcelRegister("fl0qq", function(module, exports) {

var $1iFDD = parcelRequire("1iFDD");

var $hUX6u = parcelRequire("hUX6u");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b2a925a4a14fdead$var$_nodeId;
var $b2a925a4a14fdead$var$_clockseq;
// Previous uuid creation time
var $b2a925a4a14fdead$var$_lastMSecs = 0;
var $b2a925a4a14fdead$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b2a925a4a14fdead$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b2a925a4a14fdead$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b2a925a4a14fdead$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $1iFDD();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b2a925a4a14fdead$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b2a925a4a14fdead$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b2a925a4a14fdead$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b2a925a4a14fdead$var$_lastMSecs + (nsecs - $b2a925a4a14fdead$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b2a925a4a14fdead$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $b2a925a4a14fdead$var$_lastMSecs = msecs;
    $b2a925a4a14fdead$var$_lastNSecs = nsecs;
    $b2a925a4a14fdead$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $hUX6u(b);
}
module.exports = $b2a925a4a14fdead$var$v1;

});
parcelRegister("1iFDD", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $0f27c5622fc8e20b$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($0f27c5622fc8e20b$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $0f27c5622fc8e20b$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $0f27c5622fc8e20b$var$getRandomValues($0f27c5622fc8e20b$var$rnds8);
        return $0f27c5622fc8e20b$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $0f27c5622fc8e20b$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $0f27c5622fc8e20b$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $0f27c5622fc8e20b$var$rnds;
    };
}

});

parcelRegister("hUX6u", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $d0b58365f3fc0a25$var$byteToHex = [];
for(var $d0b58365f3fc0a25$var$i = 0; $d0b58365f3fc0a25$var$i < 256; ++$d0b58365f3fc0a25$var$i)$d0b58365f3fc0a25$var$byteToHex[$d0b58365f3fc0a25$var$i] = ($d0b58365f3fc0a25$var$i + 0x100).toString(16).substr(1);
function $d0b58365f3fc0a25$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $d0b58365f3fc0a25$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $d0b58365f3fc0a25$var$bytesToUuid;

});


parcelRegister("5TdI6", function(module, exports) {

var $1iFDD = parcelRequire("1iFDD");

var $hUX6u = parcelRequire("hUX6u");
function $449cb9673c4c8bbb$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $1iFDD)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $hUX6u(rnds);
}
module.exports = $449cb9673c4c8bbb$var$v4;

});


parcelRegister("iEVkD", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $d9586f57762d7b94$export$2295b861f318254a; });
// temp solution until we can get it automated
var $d9586f57762d7b94$export$2295b861f318254a = '0.1.5';

});

parcelRegister("6BOUe", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", function () { return $4cfdafa11067bef8$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $4cfdafa11067bef8$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $4cfdafa11067bef8$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $4cfdafa11067bef8$export$7c957416596ca127; });

var $jggcA = parcelRequire("jggcA");

var $inUWW = parcelRequire("inUWW");
var $4cfdafa11067bef8$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $4cfdafa11067bef8$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $4cfdafa11067bef8$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $4cfdafa11067bef8$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $jggcA.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $4cfdafa11067bef8$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $inUWW.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $4cfdafa11067bef8$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $inUWW.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $4cfdafa11067bef8$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $inUWW.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("inUWW", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $d6268cfd730b888d$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $d6268cfd730b888d$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $d6268cfd730b888d$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $d6268cfd730b888d$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $d6268cfd730b888d$export$837e0f79a8056912; });
var $d6268cfd730b888d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $d6268cfd730b888d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $d6268cfd730b888d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $d6268cfd730b888d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $d6268cfd730b888d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $d6268cfd730b888d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $d6268cfd730b888d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $d6268cfd730b888d$export$9f2bf58999404c75 = 'fmp';
var $d6268cfd730b888d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("gr8DY", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", function () { return $bf75df6b54fa30f6$export$13e680397ec8f3eb; });

var $bj7O4 = parcelRequire("bj7O4");

var $hlTGc = parcelRequire("hlTGc");

var $7VYEH = parcelRequire("7VYEH");

var $4kW0y = parcelRequire("4kW0y");
var $bf75df6b54fa30f6$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $bj7O4.default)(this, VisibilityChangeObserver);
        (0, $7VYEH.default)(this, "started", false);
        (0, $7VYEH.default)(this, "observers", []);
        (0, $7VYEH.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, $hlTGc.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $4kW0y.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $bf75df6b54fa30f6$export$13e680397ec8f3eb = new $bf75df6b54fa30f6$var$VisibilityChangeObserver();

});
parcelRegister("4kW0y", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $328606e00ae501f0$export$15e172712955e18f; });
var $328606e00ae501f0$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});


parcelRegister("l7rXA", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", function () { return $f5fff0b37cd90aa9$export$5f490af6b2b115cf; });
var $f5fff0b37cd90aa9$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("eOBv1", function(module, exports) {
$parcel$export(module.exports, "canTransition", function () { return $ac92d2cb8014fbef$export$178881f329fdb81f; });

var $7VYEH = parcelRequire("7VYEH");

var $ldYqt = parcelRequire("ldYqt");
var $ac92d2cb8014fbef$var$UFOStateAvailableTransitions = (0, $7VYEH.default)((0, $7VYEH.default)((0, $7VYEH.default)((0, $7VYEH.default)((0, $7VYEH.default)((0, $7VYEH.default)((0, $7VYEH.default)((0, $7VYEH.default)((0, $7VYEH.default)({}, (0, $ldYqt.UFOExperienceState).NOT_STARTED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]), (0, $ldYqt.UFOExperienceState).STARTED.id, [
    (0, $ldYqt.UFOExperienceState).IN_PROGRESS.id,
    (0, $ldYqt.UFOExperienceState).BLOCKED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).IN_PROGRESS.id, [
    (0, $ldYqt.UFOExperienceState).BLOCKED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).BLOCKED.id, [
    (0, $ldYqt.UFOExperienceState).RECOVERED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).RECOVERED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).SUCCEEDED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]), (0, $ldYqt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $ldYqt.UFOExperienceState).SUCCEEDED.id,
    (0, $ldYqt.UFOExperienceState).FAILED.id,
    (0, $ldYqt.UFOExperienceState).ABORTED.id
]), (0, $ldYqt.UFOExperienceState).FAILED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]), (0, $ldYqt.UFOExperienceState).ABORTED.id, [
    (0, $ldYqt.UFOExperienceState).STARTED.id
]);
var $ac92d2cb8014fbef$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $ac92d2cb8014fbef$var$UFOStateAvailableTransitions[state1.id] && $ac92d2cb8014fbef$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("bPjpC", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", function () { return $89c383feb39d12a0$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $89c383feb39d12a0$export$cc26007c03242fff; });
var $89c383feb39d12a0$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $89c383feb39d12a0$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});




parcelRegister("8J7fH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65a826d15e242ce0$var$_react = $65a826d15e242ce0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $65a826d15e242ce0$var$_baseNew = $65a826d15e242ce0$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $65a826d15e242ce0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65a826d15e242ce0$var$EmailIcon = (props)=>/*#__PURE__*/ $65a826d15e242ce0$var$_react.default.createElement($65a826d15e242ce0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$65a826d15e242ce0$var$EmailIcon.displayName = 'EmailIcon';
var $65a826d15e242ce0$var$_default = module.exports.default = $65a826d15e242ce0$var$EmailIcon;

});

parcelRegister("7surG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56e2c3c1a9226f96$var$_react = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56e2c3c1a9226f96$var$_baseNew = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56e2c3c1a9226f96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56e2c3c1a9226f96$var$PersonIcon = (props)=>/*#__PURE__*/ $56e2c3c1a9226f96$var$_react.default.createElement($56e2c3c1a9226f96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$56e2c3c1a9226f96$var$PersonIcon.displayName = 'PersonIcon';
var $56e2c3c1a9226f96$var$_default = module.exports.default = $56e2c3c1a9226f96$var$PersonIcon;

});

parcelRegister("gvZeq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c05f09ee49282e55$var$_react = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c05f09ee49282e55$var$_baseNew = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c05f09ee49282e55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c05f09ee49282e55$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c05f09ee49282e55$var$_react.default.createElement($c05f09ee49282e55$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$c05f09ee49282e55$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c05f09ee49282e55$var$_default = module.exports.default = $c05f09ee49282e55$var$PeopleGroupIcon;

});

parcelRegister("b7lH6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81812d2b521be69e$var$_react = $81812d2b521be69e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $81812d2b521be69e$var$_baseNew = $81812d2b521be69e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $81812d2b521be69e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81812d2b521be69e$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $81812d2b521be69e$var$_react.default.createElement($81812d2b521be69e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$81812d2b521be69e$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $81812d2b521be69e$var$_default = module.exports.default = $81812d2b521be69e$var$LinkBrokenIcon;

});

parcelRegister("3NjNJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c354eccac1ea1fe$var$_react = $2c354eccac1ea1fe$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2c354eccac1ea1fe$var$_baseNew = $2c354eccac1ea1fe$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2c354eccac1ea1fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c354eccac1ea1fe$var$SettingsIcon = (props)=>/*#__PURE__*/ $2c354eccac1ea1fe$var$_react.default.createElement($2c354eccac1ea1fe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$2c354eccac1ea1fe$var$SettingsIcon.displayName = 'SettingsIcon';
var $2c354eccac1ea1fe$var$_default = module.exports.default = $2c354eccac1ea1fe$var$SettingsIcon;

});

parcelRegister("deg4B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a190cfac3d772e7$var$_react = $9a190cfac3d772e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9a190cfac3d772e7$var$_baseNew = $9a190cfac3d772e7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $9a190cfac3d772e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a190cfac3d772e7$var$LinkIcon = (props)=>/*#__PURE__*/ $9a190cfac3d772e7$var$_react.default.createElement($9a190cfac3d772e7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$9a190cfac3d772e7$var$LinkIcon.displayName = 'LinkIcon';
var $9a190cfac3d772e7$var$_default = module.exports.default = $9a190cfac3d772e7$var$LinkIcon;

});

parcelRegister("LlYs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08e56f7bc5f7a423$var$_react = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $08e56f7bc5f7a423$var$_baseNew = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $08e56f7bc5f7a423$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08e56f7bc5f7a423$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $08e56f7bc5f7a423$var$_react.default.createElement($08e56f7bc5f7a423$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$08e56f7bc5f7a423$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $08e56f7bc5f7a423$var$_default = module.exports.default = $08e56f7bc5f7a423$var$InformationCircleIcon;

});

parcelRegister("1iwGZ", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", function () { return $0f20d4e60ee3bbef$export$ea56ca58f08ffa52; });

var $3ptYX = parcelRequire("3ptYX");

var $buEUY = parcelRequire("buEUY");

var $fyh48 = parcelRequire("fyh48");

var $jdISP = parcelRequire("jdISP");
var $0f20d4e60ee3bbef$export$ea56ca58f08ffa52 = function createLocalizationProvider(locale, formatterOptions) {
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    var normalizedLocale = (0, $buEUY.normalizeLocale)(locale);
    var formatDate = function formatDate(date) {
        return Intl.DateTimeFormat(normalizedLocale).format(date);
    };
    var formatTime = function formatTime(date) {
        return Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    };
    var getDays = function getDays() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var length = arguments.length > 1 ? arguments[1] : undefined;
        var dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        var weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        var rotatedWeekdays = weekStartDay > 0 ? [].concat((0, $3ptYX.default)(weekdays.slice(weekStartDay)), (0, $3ptYX.default)(weekdays.slice(0, weekStartDay))) : weekdays;
        return rotatedWeekdays.map(function(day) {
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            var result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    var getDaysShort = function getDaysShort() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return getDays(weekStartDay, 'short');
    };
    var getDaysLong = function getDaysLong() {
        var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return getDays(weekStartDay, 'long');
    };
    var getMonthsLong = function getMonthsLong() {
        var monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(function(month) {
            return(// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
        });
    };
    var parseDate = function parseDate(date) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return (0, $fyh48.createDateParser)(normalizedLocale)(date, options);
    };
    var formatToParts = function formatToParts() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ var fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        var fixedParts = (0, $jdISP.toFormattedParts)(formatter.formatToParts(fixedDate));
        var originalParts = (0, $jdISP.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("3ptYX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $27baf6bbf1c0f0b1$export$2e2bcd8739ae039; });

var $5drhr = parcelRequire("5drhr");

var $akaBi = parcelRequire("akaBi");

var $4fev3 = parcelRequire("4fev3");

var $3jJhk = parcelRequire("3jJhk");
function $27baf6bbf1c0f0b1$export$2e2bcd8739ae039(r) {
    return (0, $5drhr.default)(r) || (0, $akaBi.default)(r) || (0, $4fev3.default)(r) || (0, $3jJhk.default)();
}

});
parcelRegister("5drhr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3cc353eee0735241$export$2e2bcd8739ae039; });

var $6nXSp = parcelRequire("6nXSp");
function $3cc353eee0735241$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $6nXSp.default)(r);
}

});
parcelRegister("6nXSp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4a6356470732c54f$export$2e2bcd8739ae039; });
function $4a6356470732c54f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("akaBi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7843feafeca48bd5$export$2e2bcd8739ae039; });
function $7843feafeca48bd5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("4fev3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3173cf8165941852$export$2e2bcd8739ae039; });

var $6nXSp = parcelRequire("6nXSp");
function $3173cf8165941852$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $6nXSp.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $6nXSp.default)(r, a) : void 0;
    }
}

});

parcelRegister("3jJhk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26a644cf6f918fd3$export$2e2bcd8739ae039; });
function $26a644cf6f918fd3$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("buEUY", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", function () { return $85e23c7e44c9c8ec$export$dca0327c9b9c6498; });
var $85e23c7e44c9c8ec$export$dca0327c9b9c6498 = function normalizeLocale(locale) {
    return locale.replace(/_/g, '-');
};

});

parcelRegister("fyh48", function(module, exports) {
$parcel$export(module.exports, "createDateParser", function () { return $b52744e6b99782bf$export$cfa2ef2687faeda2; });

var $buEUY = parcelRequire("buEUY");

var $8syug = parcelRequire("8syug");
var $b52744e6b99782bf$var$INVALID_DATE = new Date(NaN);
var $b52744e6b99782bf$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
var $b52744e6b99782bf$var$INVARIANT_DATE = (0, $8syug.toDate)($b52744e6b99782bf$var$INVARIANT);
var $b52744e6b99782bf$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
var $b52744e6b99782bf$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
var $b52744e6b99782bf$var$stripExtras = function stripExtras(str) {
    return str.replace(/\u200E/g, '');
};
var $b52744e6b99782bf$var$extractDateParts = function extractDateParts(matchResult) {
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map(function(datePart) {
        return parseInt(datePart, 10);
    });
};
var $b52744e6b99782bf$export$cfa2ef2687faeda2 = function createDateParser(locale) {
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    var normalizedLocale = (0, $buEUY.normalizeLocale)(locale);
    var dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    var rawDateString = dateFormatter.format($b52744e6b99782bf$var$INVARIANT_DATE);
    var shortDate = $b52744e6b99782bf$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    var formatMatch = shortDate.match($b52744e6b99782bf$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    var formatParts = $b52744e6b99782bf$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    var yearPosition = formatParts.indexOf($b52744e6b99782bf$var$INVARIANT.year);
    var monthPosition = formatParts.indexOf($b52744e6b99782bf$var$INVARIANT.month);
    var dayPosition = formatParts.indexOf($b52744e6b99782bf$var$INVARIANT.day);
    return function(date) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var dateMatch = $b52744e6b99782bf$var$stripExtras(date).match($b52744e6b99782bf$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $b52744e6b99782bf$var$INVALID_DATE;
        var dateParts = $b52744e6b99782bf$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        var extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        var normalizedDate = (0, $8syug.normalizeDate)(extractedDate, options === null || options === void 0 ? void 0 : options.defaultFirstDay);
        if (!(0, $8syug.isValid)(normalizedDate)) return $b52744e6b99782bf$var$INVALID_DATE;
        return (0, $8syug.toDate)(normalizedDate);
    };
};

});
parcelRegister("8syug", function(module, exports) {
$parcel$export(module.exports, "toDate", function () { return $628bb0aa1e0f97f7$export$e67a095c620b86fe; });
$parcel$export(module.exports, "isValid", function () { return $628bb0aa1e0f97f7$export$1ea939691cdc45b8; });
$parcel$export(module.exports, "normalizeDate", function () { return $628bb0aa1e0f97f7$export$fcc71269590ba0a8; });
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ var $628bb0aa1e0f97f7$export$abe96da78d4f59dd = function toDateObj(date) {
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    };
};
var $628bb0aa1e0f97f7$export$e67a095c620b86fe = function toDate(date) {
    return(// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day));
};
var $628bb0aa1e0f97f7$export$553d7fa8e3805fc0 = function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
var $628bb0aa1e0f97f7$export$f645ddd439eb259d = function getDaysInMonth(year, month) {
    // February depends on leap year
    if (month === 2 && $628bb0aa1e0f97f7$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
var $628bb0aa1e0f97f7$export$1ea939691cdc45b8 = function isValid(date) {
    var year = date.year, month = date.month, day = date.day;
    var daysInMonth = $628bb0aa1e0f97f7$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
var $628bb0aa1e0f97f7$export$fcc71269590ba0a8 = function normalizeDate(date) {
    var defaultFirstDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var now = $628bb0aa1e0f97f7$export$abe96da78d4f59dd(new Date());
    var year = date.year, month = date.month, day = date.day;
    // 19 should evaluate to 2019
    var fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    var normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    var normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    var normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jdISP", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", function () { return $dfe20c1d9e806559$export$9b7ca29af37c192; });

var $6X52n = parcelRequire("6X52n");
function $dfe20c1d9e806559$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dfe20c1d9e806559$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dfe20c1d9e806559$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6X52n.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dfe20c1d9e806559$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dfe20c1d9e806559$export$9b7ca29af37c192 = function toFormattedParts(rawParts) {
    return rawParts.reduce(function(result, datePart) {
        return $dfe20c1d9e806559$var$_objectSpread($dfe20c1d9e806559$var$_objectSpread({}, result), {}, (0, $6X52n.default)({}, datePart.type, datePart.value));
    }, {});
};

});
parcelRegister("6X52n", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50fc29152baa25dd$export$2e2bcd8739ae039; });

var $kSvNS = parcelRequire("kSvNS");
function $50fc29152baa25dd$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kSvNS.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("kSvNS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f33185506af14073$export$2e2bcd8739ae039; });

var $2SAQS = parcelRequire("2SAQS");

var $lU676 = parcelRequire("lU676");
function $f33185506af14073$export$2e2bcd8739ae039(t) {
    var i = (0, $lU676.default)(t, "string");
    return "symbol" == (0, $2SAQS.default)(i) ? i : i + "";
}

});
parcelRegister("2SAQS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $218d35e9623091fa$export$2e2bcd8739ae039; });
function $218d35e9623091fa$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $218d35e9623091fa$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $218d35e9623091fa$export$2e2bcd8739ae039(o);
}

});

parcelRegister("lU676", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff2391f82c9ce3b6$export$2e2bcd8739ae039; });

var $2SAQS = parcelRequire("2SAQS");
function $ff2391f82c9ce3b6$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2SAQS.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2SAQS.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("4szpS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33f53fe53f7c5942$var$_react = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33f53fe53f7c5942$var$_baseNew = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $33f53fe53f7c5942$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33f53fe53f7c5942$var$BacklogIcon = (props)=>/*#__PURE__*/ $33f53fe53f7c5942$var$_react.default.createElement($33f53fe53f7c5942$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$33f53fe53f7c5942$var$BacklogIcon.displayName = 'BacklogIcon';
var $33f53fe53f7c5942$var$_default = module.exports.default = $33f53fe53f7c5942$var$BacklogIcon;

});

parcelRegister("26k9M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $187bc709663ecc73$var$_react = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $187bc709663ecc73$var$_baseNew = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $187bc709663ecc73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $187bc709663ecc73$var$BoardIcon = (props)=>/*#__PURE__*/ $187bc709663ecc73$var$_react.default.createElement($187bc709663ecc73$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$187bc709663ecc73$var$BoardIcon.displayName = 'BoardIcon';
var $187bc709663ecc73$var$_default = module.exports.default = $187bc709663ecc73$var$BoardIcon;

});

parcelRegister("lfTOg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7964a51710834b2$var$_react = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f7964a51710834b2$var$_baseNew = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f7964a51710834b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7964a51710834b2$var$CalendarIcon = (props)=>/*#__PURE__*/ $f7964a51710834b2$var$_react.default.createElement($f7964a51710834b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$f7964a51710834b2$var$CalendarIcon.displayName = 'CalendarIcon';
var $f7964a51710834b2$var$_default = module.exports.default = $f7964a51710834b2$var$CalendarIcon;

});

parcelRegister("3GRvb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2afecbb2c786369d$var$_react = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2afecbb2c786369d$var$_baseNew = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2afecbb2c786369d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2afecbb2c786369d$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $2afecbb2c786369d$var$_react.default.createElement($2afecbb2c786369d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$2afecbb2c786369d$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $2afecbb2c786369d$var$_default = module.exports.default = $2afecbb2c786369d$var$ListChecklistIcon;

});

parcelRegister("PQhz5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09bd51b6223980e7$var$_react = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $09bd51b6223980e7$var$_baseNew = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $09bd51b6223980e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09bd51b6223980e7$var$PageIcon = (props)=>/*#__PURE__*/ $09bd51b6223980e7$var$_react.default.createElement($09bd51b6223980e7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$09bd51b6223980e7$var$PageIcon.displayName = 'PageIcon';
var $09bd51b6223980e7$var$_default = module.exports.default = $09bd51b6223980e7$var$PageIcon;

});

parcelRegister("fLF1J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7ab11e61c51605b$var$_react = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b7ab11e61c51605b$var$_baseNew = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $b7ab11e61c51605b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7ab11e61c51605b$var$TimelineIcon = (props)=>/*#__PURE__*/ $b7ab11e61c51605b$var$_react.default.createElement($b7ab11e61c51605b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$b7ab11e61c51605b$var$TimelineIcon.displayName = 'TimelineIcon';
var $b7ab11e61c51605b$var$_default = module.exports.default = $b7ab11e61c51605b$var$TimelineIcon;

});

parcelRegister("cBRzT", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $92e2802c3f3faa2d$export$f04a61298a47a40f; });

var $j5iXZ = parcelRequire("j5iXZ");

var $f4dRo = parcelRequire("f4dRo");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $7bjkc = parcelRequire("7bjkc");

var $ePzZI = parcelRequire("ePzZI");

var $2T05n = parcelRequire("2T05n");
function $92e2802c3f3faa2d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $92e2802c3f3faa2d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $92e2802c3f3faa2d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f4dRo.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $92e2802c3f3faa2d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $92e2802c3f3faa2d$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $92e2802c3f3faa2d$var$_objectSpread($92e2802c3f3faa2d$var$_objectSpread({}, (0, $2T05n.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $92e2802c3f3faa2d$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $92e2802c3f3faa2d$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $92e2802c3f3faa2d$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $92e2802c3f3faa2d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $2T05n.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $7bjkc.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("span", (0, $j5iXZ.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $ePzZI.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $92e2802c3f3faa2d$var$iconStyles,
            $92e2802c3f3faa2d$var$baseHcmStyles,
            primaryColor === secondaryColor && $92e2802c3f3faa2d$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $92e2802c3f3faa2d$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $3dJ4i.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $92e2802c3f3faa2d$export$2e2bcd8739ae039 = $92e2802c3f3faa2d$export$f04a61298a47a40f;

});
parcelRegister("j5iXZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de4d32501cbaa890$export$2e2bcd8739ae039; });
function $de4d32501cbaa890$export$2e2bcd8739ae039() {
    return $de4d32501cbaa890$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $de4d32501cbaa890$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("f4dRo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af81fb11f20b4dbf$export$2e2bcd8739ae039; });

var $gPZ2W = parcelRequire("gPZ2W");
function $af81fb11f20b4dbf$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gPZ2W.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("gPZ2W", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c420c34ad2881120$export$2e2bcd8739ae039; });

var $9ZcxL = parcelRequire("9ZcxL");

var $a0eM0 = parcelRequire("a0eM0");
function $c420c34ad2881120$export$2e2bcd8739ae039(t) {
    var i = (0, $a0eM0.default)(t, "string");
    return "symbol" == (0, $9ZcxL.default)(i) ? i : i + "";
}

});
parcelRegister("9ZcxL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74538a79640a74ac$export$2e2bcd8739ae039; });
function $74538a79640a74ac$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $74538a79640a74ac$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $74538a79640a74ac$export$2e2bcd8739ae039(o);
}

});

parcelRegister("a0eM0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74855d28c2077da5$export$2e2bcd8739ae039; });

var $9ZcxL = parcelRequire("9ZcxL");
function $74855d28c2077da5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $9ZcxL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $9ZcxL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7bjkc", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $53a88cfe98fdf71d$export$7692396083754928; });

var $cxQhM = parcelRequire("cxQhM");
// Create default global light theme
var $53a88cfe98fdf71d$var$_createTheme = (0, $cxQhM.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $53a88cfe98fdf71d$var$Provider = $53a88cfe98fdf71d$var$_createTheme.Provider, $53a88cfe98fdf71d$var$Consumer = $53a88cfe98fdf71d$var$_createTheme.Consumer, $53a88cfe98fdf71d$export$7692396083754928 = $53a88cfe98fdf71d$var$_createTheme.useTheme;
var $53a88cfe98fdf71d$export$2e2bcd8739ae039 = {
    Provider: $53a88cfe98fdf71d$var$Provider,
    Consumer: $53a88cfe98fdf71d$var$Consumer
};

});
parcelRegister("cxQhM", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $92211ff8e272fcf3$export$25d302a5b900a763; });

var $hbMSe = parcelRequire("hbMSe");

var $1oC0p = parcelRequire("1oC0p");
var $92211ff8e272fcf3$var$_excluded = [
    "children"
];
function $92211ff8e272fcf3$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $hbMSe.default)(props, $92211ff8e272fcf3$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("hbMSe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c83960118bdb5237$export$2e2bcd8739ae039; });

var $kNa4S = parcelRequire("kNa4S");
function $c83960118bdb5237$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $kNa4S.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("kNa4S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2303371223ab2e5$export$2e2bcd8739ae039; });
function $f2303371223ab2e5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("ePzZI", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $acc1bfd6f6771c37$export$18cb9425622d4e06; });
var $acc1bfd6f6771c37$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $acc1bfd6f6771c37$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
    return $acc1bfd6f6771c37$var$themedBackground[mode];
};

});

parcelRegister("2T05n", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $21a0c8d570a57771$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $21a0c8d570a57771$export$3eb7d6130acfda37; });

var $kyKK7 = parcelRequire("kyKK7");

var $3dJ4i = parcelRequire("3dJ4i");
var $21a0c8d570a57771$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $21a0c8d570a57771$var$smallStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).small);
var $21a0c8d570a57771$var$mediumStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).medium);
var $21a0c8d570a57771$var$largeStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).large);
var $21a0c8d570a57771$var$xlargeStyles = (0, $3dJ4i.css)((0, $kyKK7.dimensions).xlarge);
var $21a0c8d570a57771$export$ef0ad74202575b64 = {
    small: $21a0c8d570a57771$var$smallStyles,
    medium: $21a0c8d570a57771$var$mediumStyles,
    large: $21a0c8d570a57771$var$largeStyles,
    xlarge: $21a0c8d570a57771$var$xlargeStyles
};
var $21a0c8d570a57771$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $kyKK7.dimensions)[size];
    return undefined;
};

});
parcelRegister("kyKK7", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $ef7b3dca63f74e4a$export$62ad7b0c781000e9; });
var $ef7b3dca63f74e4a$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $ef7b3dca63f74e4a$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $ef7b3dca63f74e4a$export$62ad7b0c781000e9 = {
    small: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.small,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.medium,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.large,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.xlarge,
        height: $ef7b3dca63f74e4a$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("7eewv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54351b3d8fb90994$var$_react = $54351b3d8fb90994$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cBRzT = parcelRequire("cBRzT");
function $54351b3d8fb90994$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $54351b3d8fb90994$var$Story16Icon = (props)=>/*#__PURE__*/ $54351b3d8fb90994$var$_react.default.createElement($cBRzT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$54351b3d8fb90994$var$Story16Icon.displayName = 'Story16Icon';
var $54351b3d8fb90994$var$_default = $54351b3d8fb90994$var$Story16Icon;
module.exports.default = $54351b3d8fb90994$var$_default;

});

parcelRegister("iyuye", function(module, exports) {

var $erWD3 = parcelRequire("erWD3");

var $ih96c = parcelRequire("ih96c");
/** Error message constants. */ var $d82319cd6e5631ad$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $d82319cd6e5631ad$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($d82319cd6e5631ad$var$FUNC_ERROR_TEXT);
    if ($ih96c(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $erWD3(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $d82319cd6e5631ad$var$throttle;

});

parcelRegister("6N4Iz", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", function () { return $4f1afa8b11407978$export$c4b5b1f965d8b3eb; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $4f1afa8b11407978$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $4f1afa8b11407978$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        svg: $4f1afa8b11407978$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7VkQP", function(module, exports) {
$parcel$export(module.exports, "tabbedHeroSectionPagesMessages", function () { return $5ec21e3943929bcb$export$4256e39427240bad; });
$parcel$export(module.exports, "tabbedHeroSectionWhiteboardsMessages", function () { return $5ec21e3943929bcb$export$86b5cdc1c559b81d; });
$parcel$export(module.exports, "tabbedHeroSectionDatabasesMessages", function () { return $5ec21e3943929bcb$export$505de7052a30846e; });
$parcel$export(module.exports, "tabbedHeroSectionSpacesMessages", function () { return $5ec21e3943929bcb$export$954db68b244e5987; });

var $fnHPc = parcelRequire("fnHPc");
const $5ec21e3943929bcb$export$4256e39427240bad = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.tabName",
        defaultMessage: "Pages"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.title.v2",
        defaultMessage: "Get everyone on the same page"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.description.v2",
        defaultMessage: "Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.iconsHeader",
        defaultMessage: "Create content with ease:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon1",
        defaultMessage: "Countless templates to get started fast"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon2",
        defaultMessage: "Realtime collaboration with live docs, or draft and publish with pages"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon3",
        defaultMessage: "AI editor to fill in the blanks"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.cta",
        defaultMessage: "Try it out"
    }
});
const $5ec21e3943929bcb$export$86b5cdc1c559b81d = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.tabName",
        defaultMessage: "Whiteboards"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.title",
        defaultMessage: "Next-gen brainstorming"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.description",
        defaultMessage: "Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.iconsHeader",
        defaultMessage: "Ideate on an infinite canvas with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon1",
        defaultMessage: "Brainstorming templates"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon2",
        defaultMessage: "Diagrams and flow charts"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon3",
        defaultMessage: "Team retrospectives"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.cta",
        defaultMessage: "Explore Whiteboards"
    }
});
const $5ec21e3943929bcb$export$505de7052a30846e = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabName",
        defaultMessage: "Databases"
    },
    tabLozenge: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabLozenge",
        defaultMessage: "beta"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.title",
        defaultMessage: "A new way to stay in sync"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.description",
        defaultMessage: "Add structure, sync in real-time, and visualize your team\u2019s work with Confluence Databases."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.iconsHeader",
        defaultMessage: "Connect and relate information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon1",
        defaultMessage: "Dynamic fields"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon2",
        defaultMessage: "Configurable views"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon3",
        defaultMessage: "Aggregated data sources"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.cta",
        defaultMessage: "Explore Databases"
    }
});
const $5ec21e3943929bcb$export$954db68b244e5987 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.tabName",
        defaultMessage: "Spaces"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.title",
        defaultMessage: "Find what you need"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.description",
        defaultMessage: "Organize knowledge across teams, projects, and goals with Spaces in Confluence."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.iconsHeader",
        defaultMessage: "Discover relevant information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon1",
        defaultMessage: "Structured page tree"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon2",
        defaultMessage: "Centralized access to knowledge"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon3",
        defaultMessage: "Customizable permissions"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.cta",
        defaultMessage: "Explore knowledge sharing"
    }
});

});

parcelRegister("kz1DD", function(module, exports) {
$parcel$export(module.exports, "TransformWrapper", function () { return $ef8858de857ee727$export$51cb649375dcd655; });
$parcel$export(module.exports, "TransformComponent", function () { return $ef8858de857ee727$export$1def2aa75b7c7fe0; });

var $1oC0p = parcelRequire("1oC0p");
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $ef8858de857ee727$var$roundNumber = function(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $ef8858de857ee727$var$checkIsNumber = function(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $ef8858de857ee727$var$handleCallback = function(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $ef8858de857ee727$var$easeOut = function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $ef8858de857ee727$var$linear = function(t) {
    return t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuad = function(t) {
    return t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuad = function(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInCubic = function(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutCubic = function(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuart = function(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuart = function(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuart = function(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $ef8858de857ee727$var$easeInQuint = function(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $ef8858de857ee727$var$easeOutQuint = function(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $ef8858de857ee727$var$easeInOutQuint = function(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $ef8858de857ee727$var$animations = {
    easeOut: $ef8858de857ee727$var$easeOut,
    linear: $ef8858de857ee727$var$linear,
    easeInQuad: $ef8858de857ee727$var$easeInQuad,
    easeOutQuad: $ef8858de857ee727$var$easeOutQuad,
    easeInOutQuad: $ef8858de857ee727$var$easeInOutQuad,
    easeInCubic: $ef8858de857ee727$var$easeInCubic,
    easeOutCubic: $ef8858de857ee727$var$easeOutCubic,
    easeInOutCubic: $ef8858de857ee727$var$easeInOutCubic,
    easeInQuart: $ef8858de857ee727$var$easeInQuart,
    easeOutQuart: $ef8858de857ee727$var$easeOutQuart,
    easeInOutQuart: $ef8858de857ee727$var$easeInOutQuart,
    easeInQuint: $ef8858de857ee727$var$easeInQuint,
    easeOutQuint: $ef8858de857ee727$var$easeOutQuint,
    easeInOutQuint: $ef8858de857ee727$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $ef8858de857ee727$var$handleCancelAnimationFrame = function(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $ef8858de857ee727$var$handleCancelAnimation = function(contextInstance) {
    if (!contextInstance.mounted) return;
    $ef8858de857ee727$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $ef8858de857ee727$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $ef8858de857ee727$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $ef8858de857ee727$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $ef8858de857ee727$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setTransformState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $ef8858de857ee727$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $ef8858de857ee727$var$getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY
    };
};
var $ef8858de857ee727$var$calculateBounds = function(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _a = $ef8858de857ee727$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = $ef8858de857ee727$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $ef8858de857ee727$var$boundLimiter = function(value, minBound, maxBound, isActive) {
    if (!isActive) return $ef8858de857ee727$var$roundNumber(value, 2);
    if (value < minBound) return $ef8858de857ee727$var$roundNumber(minBound, 2);
    if (value > maxBound) return $ef8858de857ee727$var$roundNumber(maxBound, 2);
    return $ef8858de857ee727$var$roundNumber(value, 2);
};
var $ef8858de857ee727$var$handleCalculateBounds = function(contextInstance, newScale) {
    var bounds = $ef8858de857ee727$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $ef8858de857ee727$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $ef8858de857ee727$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $ef8858de857ee727$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $ef8858de857ee727$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function $ef8858de857ee727$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale) return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return zoom;
}
var $ef8858de857ee727$var$isPanningStartAllowed = function(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
        if (!(el instanceof Element)) return false;
        return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
    }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$isPanningAllowed = function(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$handlePanningSetup = function(contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $ef8858de857ee727$var$handleTouchPanningSetup = function(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $ef8858de857ee727$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $ef8858de857ee727$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var $ef8858de857ee727$var$getPanningClientPosition = function(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $ef8858de857ee727$var$getPaddingValue = function(contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) return size;
    return 0;
};
var $ef8858de857ee727$var$isVelocityCalculationAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$isVelocityAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $ef8858de857ee727$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) return animationTime * velocity * sensitivity;
    return animationTime;
}
function $ef8858de857ee727$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $ef8858de857ee727$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function $ef8858de857ee727$var$getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    return defaultMultiplier;
}
function $ef8858de857ee727$var$handleCalculateVelocity(contextInstance, position) {
    var isAllowed = $ef8858de857ee727$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $ef8858de857ee727$var$getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $ef8858de857ee727$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $ef8858de857ee727$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $ef8858de857ee727$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    $ef8858de857ee727$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $ef8858de857ee727$var$animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $ef8858de857ee727$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $ef8858de857ee727$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    });
}
function $ef8858de857ee727$var$handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
    $ef8858de857ee727$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $ef8858de857ee727$var$handleTouchPanningSetup(contextInstance, event);
    else $ef8858de857ee727$var$handlePanningSetup(contextInstance, event);
}
function $ef8858de857ee727$var$handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $ef8858de857ee727$var$handlePanToBounds(contextInstance);
    if (targetState) $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $ef8858de857ee727$var$handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $ef8858de857ee727$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    $ef8858de857ee727$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    });
    $ef8858de857ee727$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $ef8858de857ee727$var$handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) $ef8858de857ee727$var$handleVelocityPanning(contextInstance);
        else $ef8858de857ee727$var$handleAlignToBounds(contextInstance);
    }
}
function $ef8858de857ee727$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) // fire fit to bounds animation
    $ef8858de857ee727$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $ef8858de857ee727$var$__assign = function() {
    $ef8858de857ee727$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef8858de857ee727$var$__assign.apply(this, arguments);
};
function $ef8858de857ee727$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ef8858de857ee727$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $ef8858de857ee727$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $ef8858de857ee727$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true
    }
};
var $ef8858de857ee727$var$baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component"
};
var $ef8858de857ee727$var$createState = function(props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : $ef8858de857ee727$var$initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : $ef8858de857ee727$var$initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : $ef8858de857ee727$var$initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : $ef8858de857ee727$var$initialState.positionY
    };
};
var $ef8858de857ee727$var$createSetup = function(props) {
    var newSetup = $ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof $ef8858de857ee727$var$initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($ef8858de857ee727$var$initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[key] = $ef8858de857ee727$var$__assign($ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$initialSetup[key]), props[key]);
            else if (isArray) newSetup[key] = $ef8858de857ee727$var$__spreadArray($ef8858de857ee727$var$__spreadArray([], $ef8858de857ee727$var$initialSetup[key], true), props[key], true);
            else newSetup[key] = props[key];
        }
    });
    return newSetup;
};
var $ef8858de857ee727$var$handleCalculateButtonZoom = function(contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $ef8858de857ee727$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = $ef8858de857ee727$var$createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return;
    var newBounds = $ef8858de857ee727$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $ef8858de857ee727$var$getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    $ef8858de857ee727$var$animate(contextInstance, newState, animationTime, animationType);
}
function $ef8858de857ee727$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $ef8858de857ee727$var$calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $ef8858de857ee727$var$getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $ef8858de857ee727$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = $ef8858de857ee727$var$calculateBounds(contextInstance, newScale);
    var _b = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $ef8858de857ee727$var$zoomIn = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$zoomOut = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$setTransform = function(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$resetTransform = function(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $ef8858de857ee727$var$centerView = function(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $ef8858de857ee727$export$a51b33620579dad4(scale || transformState.scale, wrapperComponent, contentComponent);
            $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $ef8858de857ee727$var$zoomToElement = function(contextInstance) {
    return function(node, scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $ef8858de857ee727$var$calculateZoomToNode(contextInstance, target, scale);
            $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $ef8858de857ee727$var$getControls = function(contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: $ef8858de857ee727$var$zoomIn(contextInstance),
        zoomOut: $ef8858de857ee727$var$zoomOut(contextInstance),
        setTransform: $ef8858de857ee727$var$setTransform(contextInstance),
        resetTransform: $ef8858de857ee727$var$resetTransform(contextInstance),
        centerView: $ef8858de857ee727$var$centerView(contextInstance),
        zoomToElement: $ef8858de857ee727$var$zoomToElement(contextInstance)
    };
};
var $ef8858de857ee727$var$getState = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState
    };
};
var $ef8858de857ee727$var$getContext = function(contextInstance) {
    var ref = {};
    Object.assign(ref, $ef8858de857ee727$var$getState(contextInstance));
    Object.assign(ref, $ef8858de857ee727$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $ef8858de857ee727$var$passiveSupported = false;
function $ef8858de857ee727$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $ef8858de857ee727$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $ef8858de857ee727$var$passiveSupported = false;
        return $ef8858de857ee727$var$passiveSupported;
    }
}
var $ef8858de857ee727$var$matchPrefix = ".".concat($ef8858de857ee727$var$baseClasses.wrapperClass);
var $ef8858de857ee727$var$isExcludedNode = function(node, excluded) {
    return excluded.some(function(exclude) {
        return node.matches("".concat($ef8858de857ee727$var$matchPrefix, " ").concat(exclude, ", ").concat($ef8858de857ee727$var$matchPrefix, " .").concat(exclude, ", ").concat($ef8858de857ee727$var$matchPrefix, " ").concat(exclude, " *, ").concat($ef8858de857ee727$var$matchPrefix, " .").concat(exclude, " *"));
    });
};
var $ef8858de857ee727$var$cancelTimeout = function(timeout) {
    if (timeout) clearTimeout(timeout);
};
var $ef8858de857ee727$export$c15ec262effbd456 = function(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var $ef8858de857ee727$export$3b94f66093db6f05 = function(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $ef8858de857ee727$export$a51b33620579dad4 = function(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $ef8858de857ee727$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $ef8858de857ee727$var$isWheelAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$getDeltaY = function(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $ef8858de857ee727$var$getDelta(event, customDelta) {
    var deltaY = $ef8858de857ee727$var$getDeltaY(event);
    var delta = $ef8858de857ee727$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY
    };
}
var $ef8858de857ee727$var$handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $ef8858de857ee727$var$handleWheelZoomStop = function(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $ef8858de857ee727$var$isPinchStartAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$isPinchAllowed = function(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed) return false;
    return true;
};
var $ef8858de857ee727$var$calculateTouchMidPoint = function(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = $ef8858de857ee727$var$roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = $ef8858de857ee727$var$roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = $ef8858de857ee727$var$roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = $ef8858de857ee727$var$roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $ef8858de857ee727$var$getTouchDistance = function(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $ef8858de857ee727$var$calculatePinchZoom = function(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.transformState.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return $ef8858de857ee727$var$checkZoomBounds($ef8858de857ee727$var$roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var $ef8858de857ee727$var$wheelStopEventTime = 160;
var $ef8858de857ee727$var$wheelAnimationTime = 100;
var $ef8858de857ee727$var$handleWheelStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheelStart);
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $ef8858de857ee727$var$handleWheelZoom = function(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) throw new Error("Component not mounted");
    event.preventDefault();
    event.stopPropagation();
    var delta = $ef8858de857ee727$var$getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = $ef8858de857ee727$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheel);
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
};
var $ef8858de857ee727$var$handleWheelStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $ef8858de857ee727$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $ef8858de857ee727$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $ef8858de857ee727$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $ef8858de857ee727$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onWheelStop);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStop);
        }, $ef8858de857ee727$var$wheelStopEventTime);
    }
};
var $ef8858de857ee727$var$getTouchCenter = function(event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for(var i = 0; i < 2; i += 1){
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return {
        x: x,
        y: y
    };
};
var $ef8858de857ee727$var$handlePinchStart = function(contextInstance, event) {
    var distance = $ef8858de857ee727$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = $ef8858de857ee727$var$getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    $ef8858de857ee727$var$handleCancelAnimation(contextInstance);
};
var $ef8858de857ee727$var$handlePinchZoom = function(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $ef8858de857ee727$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $ef8858de857ee727$var$getTouchDistance(event);
    var newScale = $ef8858de857ee727$var$calculatePinchZoom(contextInstance, currentDistance);
    var center = $ef8858de857ee727$var$getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0) return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = $ef8858de857ee727$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $ef8858de857ee727$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $ef8858de857ee727$var$getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = $ef8858de857ee727$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var $ef8858de857ee727$var$handlePinchStop = function(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    $ef8858de857ee727$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $ef8858de857ee727$var$handleDoubleClickStop = function(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $ef8858de857ee727$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $ef8858de857ee727$var$handleDoubleClickResetMode = function(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    $ef8858de857ee727$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
    });
    $ef8858de857ee727$var$handleDoubleClickStop(contextInstance, event);
};
function $ef8858de857ee727$var$getDoubleClickScale(mode, scale) {
    if (mode === "toggle") return scale === 1 ? 1 : -1;
    return mode === "zoomOut" ? -1 : 1;
}
function $ef8858de857ee727$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $ef8858de857ee727$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = $ef8858de857ee727$var$getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = $ef8858de857ee727$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $ef8858de857ee727$var$getMousePosition(event, contentComponent, scale);
    var targetState = $ef8858de857ee727$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(contextInstance), event, onZoom);
    $ef8858de857ee727$var$animate(contextInstance, targetState, animationTime, animationType);
    $ef8858de857ee727$var$handleDoubleClickStop(contextInstance, event);
}
var $ef8858de857ee727$var$isDoubleClickAllowed = function(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $ef8858de857ee727$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $ef8858de857ee727$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            _this.props = newProps;
            $ef8858de857ee727$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = $ef8858de857ee727$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a, _b;
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b;
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 || _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $ef8858de857ee727$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($ef8858de857ee727$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function(callback) {
                            return callback($ef8858de857ee727$var$getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function() {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed) return;
            $ef8858de857ee727$var$handleWheelStart(_this, event);
            $ef8858de857ee727$var$handleWheelZoom(_this, event);
            $ef8858de857ee727$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function(event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent || !_this.contentComponent || disabled || !wheel.wheelDisabled || panning.disabled || !panning.wheelPanning || event.ctrlKey) return;
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = $ef8858de857ee727$var$getPaddingValue(_this, sizeX);
            var paddingValueY = $ef8858de857ee727$var$getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY) return;
            $ef8858de857ee727$var$handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            $ef8858de857ee727$var$handlePanningStart(_this, event);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handlePanning(_this, event.clientX, event.clientY);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $ef8858de857ee727$var$handlePanningEnd(_this);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $ef8858de857ee727$var$handlePinchStart(_this, event);
            $ef8858de857ee727$var$handleCancelAnimation(_this);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinchingStart);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoomStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            event.preventDefault();
            event.stopPropagation();
            $ef8858de857ee727$var$handlePinchZoom(_this, event);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinching);
            $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoom);
        };
        this.onPinchStop = function(event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                $ef8858de857ee727$var$handlePinchStop(_this);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPinchingStop);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (!isDoubleTap) {
                _this.lastTouch = +new Date();
                $ef8858de857ee727$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    $ef8858de857ee727$var$handleCancelAnimation(_this);
                    $ef8858de857ee727$var$handlePanningStart(_this, event);
                    $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $ef8858de857ee727$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $ef8858de857ee727$var$handlePanning(_this, touch.clientX, touch.clientY);
                $ef8858de857ee727$var$handleCallback($ef8858de857ee727$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $ef8858de857ee727$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $ef8858de857ee727$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (!keys.length) return true;
            return Boolean(keys.find(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setTransformState = function(scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $ef8858de857ee727$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $ef8858de857ee727$var$handleCallback(ctx_1, {
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransformed);
            } else console.error("Detected NaN set state values");
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $ef8858de857ee727$export$a51b33620579dad4(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $ef8858de857ee727$export$c15ec262effbd456(x, y, scale);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function() {
            return $ef8858de857ee727$var$getContext(_this);
        };
        /**
         * Hooks
         */ this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $ef8858de857ee727$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $ef8858de857ee727$var$getContext(_this);
            $ef8858de857ee727$var$handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = $ef8858de857ee727$var$createSetup(this.props);
        this.transformState = $ef8858de857ee727$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $ef8858de857ee727$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext(null);
var $ef8858de857ee727$var$getContent = function(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $ef8858de857ee727$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(props, ref) {
    var instance = (0, $1oC0p.useRef)(new $ef8858de857ee727$var$ZoomPanPinch(props)).current;
    var content = $ef8858de857ee727$var$getContent(props.children, $ef8858de857ee727$var$getControls(instance));
    (0, $1oC0p.useImperativeHandle)(ref, function() {
        return $ef8858de857ee727$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $1oC0p.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($ef8858de857ee727$export$841858b892ce1f4c.Provider, {
        value: instance
    }, content);
});
var $ef8858de857ee727$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function(props, ref) {
    var localRef = (0, $1oC0p.useRef)(null);
    var instance = (0, $1oC0p.useContext)($ef8858de857ee727$export$841858b892ce1f4c);
    (0, $1oC0p.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, props, {
        ref: $ef8858de857ee727$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $ef8858de857ee727$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $ef8858de857ee727$var$useResize = function(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $1oC0p.useRef)();
    var rectRef = (0, $1oC0p.useRef)($ef8858de857ee727$var$initialElementRect);
    var didUnmount = (0, $1oC0p.useRef)(false);
    (0, $1oC0p.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) return;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ef8858de857ee727$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $ef8858de857ee727$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px"
};
var $ef8858de857ee727$export$a97dd8f3835953ef = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = $ef8858de857ee727$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "children"
    ]);
    var _e = (0, $1oC0p.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var instance = $ef8858de857ee727$export$1708b11af87412f8();
    var miniMapInstance = (0, $1oC0p.useRef)(null);
    var mainRef = (0, $1oC0p.useRef)(null);
    var wrapperRef = (0, $1oC0p.useRef)(null);
    var previewRef = (0, $1oC0p.useRef)(null);
    var getViewportSize = (0, $1oC0p.useCallback)(function() {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.wrapperComponent
    ]);
    var getContentSize = (0, $1oC0p.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.transformState.scale
    ]);
    var computeMiniMapScale = (0, $1oC0p.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden"
        };
        Object.keys(style).forEach(function(key) {
            if (wrapperRef.current) wrapperRef.current.style[key] = style[key];
        });
    };
    var transformMiniMap = function() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function() {
        transformMiniMap();
    };
    $ef8858de857ee727$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $ef8858de857ee727$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $ef8858de857ee727$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $1oC0p.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale = zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX = zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY = zpp.instance.transformState.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    var wrapperStyle = (0, $1oC0p.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden"
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, rest, {
        ref: wrapperRef,
        className: "rzpp-wrapper"
    }), children), (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        className: "rzpp-preview",
        ref: previewRef,
        style: $ef8858de857ee727$var$__assign($ef8858de857ee727$var$__assign({}, $ef8858de857ee727$var$previewStyles), {
            borderColor: borderColor
        })
    }));
};
function $ef8858de857ee727$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $ef8858de857ee727$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var $ef8858de857ee727$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo"
};
$ef8858de857ee727$var$styleInject($ef8858de857ee727$var$css_248z);
var $ef8858de857ee727$export$1def2aa75b7c7fe0 = function(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0, $1oC0p.useContext)($ef8858de857ee727$export$841858b892ce1f4c), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0, $1oC0p.useRef)(null);
    var contentRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "".concat($ef8858de857ee727$var$baseClasses.wrapperClass, " ").concat($ef8858de857ee727$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", $ef8858de857ee727$var$__assign({}, contentProps, {
        ref: contentRef,
        className: "".concat($ef8858de857ee727$var$baseClasses.contentClass, " ").concat($ef8858de857ee727$var$styles.content, " ").concat(contentClass),
        style: contentStyle
    }), children));
};
var $ef8858de857ee727$export$1708b11af87412f8 = function() {
    var libraryContext = (0, $1oC0p.useContext)($ef8858de857ee727$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $ef8858de857ee727$export$8a75c83865bcf9dd = function() {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    return $ef8858de857ee727$var$getControls(libraryContext);
};
var $ef8858de857ee727$export$e14839139473133b = function(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    (0, $1oC0p.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($ef8858de857ee727$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($ef8858de857ee727$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, []);
};
var $ef8858de857ee727$export$769cca75086a299c = function(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    (0, $1oC0p.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($ef8858de857ee727$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};
function $ef8858de857ee727$export$4915c4f91c47b682(callback) {
    var libraryContext = $ef8858de857ee727$export$1708b11af87412f8();
    var _a = (0, $1oC0p.useState)(callback($ef8858de857ee727$var$getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    (0, $1oC0p.useEffect)(function() {
        var mounted = true;
        var unmount = libraryContext.onChange(function(ref) {
            if (mounted) setTransformRender(callback($ef8858de857ee727$var$getState(ref.instance)));
        });
        return function() {
            unmount();
            mounted = false;
        };
    }, [
        callback,
        libraryContext
    ]);
    return transformRender;
}

});

parcelRegister("gRDcE", function(module, exports) {
$parcel$export(module.exports, "ZoomIn", function () { return $e28c461dfd89186d$export$d13069184bfa0730; });

var $7VQPk = parcelRequire("7VQPk");
const $e28c461dfd89186d$export$d13069184bfa0730 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-zoom in",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.65,45.65 L44.6,38.7 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M26.23,0.18 C40.72,0.18 52.46,11.93 52.46,26.42 C52.46,40.9 40.72,52.65 26.23,52.65 C11.74,52.65 0,40.9 0,26.42 C0,11.93 11.74,0.18 26.23,0.18 Z M46.97,26.42 C46.97,37.87 37.69,47.16 26.23,47.16 C14.78,47.16 5.49,37.87 5.49,26.42 C5.49,14.96 14.78,5.67 26.23,5.67 C37.69,5.67 46.97,14.96 46.97,26.42 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M26.54,14.52 C28.05,14.52 29.28,15.75 29.28,17.26 L29.28,23.97 L35.99,23.97 C37.51,23.97 38.74,25.2 38.74,26.72 C38.74,28.24 37.51,29.46 35.99,29.46 L29.28,29.46 L29.28,36.18 C29.28,37.69 28.05,38.92 26.54,38.92 C25.02,38.92 23.79,37.69 23.79,36.18 L23.79,29.46 L17.08,29.46 C15.56,29.46 14.34,28.24 14.34,26.72 C14.34,25.2 15.56,23.97 17.08,23.97 L23.79,23.97 L23.79,17.26 C23.79,15.75 25.02,14.52 26.54,14.52 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("yKFYG", function(module, exports) {
$parcel$export(module.exports, "ZoomOut", function () { return $0b44293d87c575f9$export$adc4acb67269225; });

var $7VQPk = parcelRequire("7VQPk");
const $0b44293d87c575f9$export$adc4acb67269225 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        id: "icon-content-zoom out",
        width: size,
        height: size,
        viewBox: "0 0 62 63",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M59.66,53.76 C61.58,55.68 61.58,58.79 59.66,60.71 C57.74,62.63 54.63,62.63 52.71,60.71 L37.33,45.33 L44.28,38.38 L59.66,53.76 Z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M52.46,26.42 C52.46,11.93 40.72,0.18 26.23,0.18 C11.74,0.18 0,11.93 0,26.42 C0,40.9 11.74,52.65 26.23,52.65 C40.72,52.65 52.46,40.9 52.46,26.42 Z M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                        d: "M26.23,47.16 C37.69,47.16 46.97,37.87 46.97,26.42 C46.97,14.96 37.69,5.67 26.23,5.67 C14.78,5.67 5.49,14.96 5.49,26.42 C5.49,37.87 14.78,47.16 26.23,47.16 Z M38.74,26.72 C38.74,25.2 37.51,23.97 35.99,23.97 L17.08,23.97 L16.95,23.98 C15.5,24.05 14.34,25.25 14.34,26.72 C14.34,28.24 15.56,29.47 17.08,29.47 L35.99,29.47 L36.12,29.46 C37.58,29.39 38.74,28.19 38.74,26.72 Z",
                        opacity: "0.5"
                    })
                ]
            })
        })
    });

});

parcelRegister("9lp51", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cd98791958e6401$var$_react = $6cd98791958e6401$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6cd98791958e6401$var$_baseNew = $6cd98791958e6401$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6cd98791958e6401$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cd98791958e6401$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $6cd98791958e6401$var$_react.default.createElement($6cd98791958e6401$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$6cd98791958e6401$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $6cd98791958e6401$var$_default = module.exports.default = $6cd98791958e6401$var$BookWithBookmarkIcon;

});

parcelRegister("7H8sx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35a8ca9f503841cffe12f1ff6d6bb3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59a31c6591dcb8cb$var$_react = $59a31c6591dcb8cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $59a31c6591dcb8cb$var$_baseNew = $59a31c6591dcb8cb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $59a31c6591dcb8cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59a31c6591dcb8cb$var$CameraIcon = (props)=>/*#__PURE__*/ $59a31c6591dcb8cb$var$_react.default.createElement($59a31c6591dcb8cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.4.8A.75.75 0 0 1 6 .5h4a.75.75 0 0 1 .6.3l1.275 1.7h1.375A2.75 2.75 0 0 1 16 5.25V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.25A2.75 2.75 0 0 1 2.75 2.5h1.375zM6.375 2 5.1 3.7a.75.75 0 0 1-.6.3H2.75c-.69 0-1.25.56-1.25 1.25V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.25c0-.69-.56-1.25-1.25-1.25H11.5a.75.75 0 0 1-.6-.3L9.625 2zM8 6.5A1.75 1.75 0 1 0 8 10a1.75 1.75 0 0 0 0-3.5M4.75 8.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/>`
    }, props));
$59a31c6591dcb8cb$var$CameraIcon.displayName = 'CameraIcon';
var $59a31c6591dcb8cb$var$_default = module.exports.default = $59a31c6591dcb8cb$var$CameraIcon;

});

parcelRegister("dmI5f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9baf86847fb0b0d5$var$_react = $9baf86847fb0b0d5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9baf86847fb0b0d5$var$_baseNew = $9baf86847fb0b0d5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $9baf86847fb0b0d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9baf86847fb0b0d5$var$DecisionIcon = (props)=>/*#__PURE__*/ $9baf86847fb0b0d5$var$_react.default.createElement($9baf86847fb0b0d5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$9baf86847fb0b0d5$var$DecisionIcon.displayName = 'DecisionIcon';
var $9baf86847fb0b0d5$var$_default = module.exports.default = $9baf86847fb0b0d5$var$DecisionIcon;

});

parcelRegister("ppCkT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04c634faffce0aa7$var$_react = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $04c634faffce0aa7$var$_baseNew = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $04c634faffce0aa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04c634faffce0aa7$var$DepartmentIcon = (props)=>/*#__PURE__*/ $04c634faffce0aa7$var$_react.default.createElement($04c634faffce0aa7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$04c634faffce0aa7$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $04c634faffce0aa7$var$_default = module.exports.default = $04c634faffce0aa7$var$DepartmentIcon;

});

parcelRegister("b2tob", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8096adab141a7275$var$_react = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8096adab141a7275$var$_baseNew = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8096adab141a7275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8096adab141a7275$var$EditIcon = (props)=>/*#__PURE__*/ $8096adab141a7275$var$_react.default.createElement($8096adab141a7275$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$8096adab141a7275$var$EditIcon.displayName = 'EditIcon';
var $8096adab141a7275$var$_default = module.exports.default = $8096adab141a7275$var$EditIcon;

});

parcelRegister("2lAyB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b59e66893d4c7d3$var$_react = $1b59e66893d4c7d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1b59e66893d4c7d3$var$_baseNew = $1b59e66893d4c7d3$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $1b59e66893d4c7d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b59e66893d4c7d3$var$EmojiIcon = (props)=>/*#__PURE__*/ $1b59e66893d4c7d3$var$_react.default.createElement($1b59e66893d4c7d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$1b59e66893d4c7d3$var$EmojiIcon.displayName = 'EmojiIcon';
var $1b59e66893d4c7d3$var$_default = module.exports.default = $1b59e66893d4c7d3$var$EmojiIcon;

});

parcelRegister("5alrx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c2e8512528ccc45$var$_react = $3c2e8512528ccc45$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3c2e8512528ccc45$var$_baseNew = $3c2e8512528ccc45$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $3c2e8512528ccc45$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c2e8512528ccc45$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $3c2e8512528ccc45$var$_react.default.createElement($3c2e8512528ccc45$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$3c2e8512528ccc45$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $3c2e8512528ccc45$var$_default = module.exports.default = $3c2e8512528ccc45$var$EyeOpenIcon;

});

parcelRegister("eMDDH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac344be6bebfa432$var$_react = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ac344be6bebfa432$var$_baseNew = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ac344be6bebfa432$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac344be6bebfa432$var$FeedbackIcon = (props)=>/*#__PURE__*/ $ac344be6bebfa432$var$_react.default.createElement($ac344be6bebfa432$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ac344be6bebfa432$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $ac344be6bebfa432$var$_default = module.exports.default = $ac344be6bebfa432$var$FeedbackIcon;

});

parcelRegister("cB1fn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92b9e8622fafa0ab$var$_react = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $92b9e8622fafa0ab$var$_baseNew = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $92b9e8622fafa0ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92b9e8622fafa0ab$var$FileIcon = (props)=>/*#__PURE__*/ $92b9e8622fafa0ab$var$_react.default.createElement($92b9e8622fafa0ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$92b9e8622fafa0ab$var$FileIcon.displayName = 'FileIcon';
var $92b9e8622fafa0ab$var$_default = module.exports.default = $92b9e8622fafa0ab$var$FileIcon;

});

parcelRegister("b0jeq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b192fbc7db5453924997563ea93d01df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $802e9ccbe48cbd7f$var$_react = $802e9ccbe48cbd7f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $802e9ccbe48cbd7f$var$_baseNew = $802e9ccbe48cbd7f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $802e9ccbe48cbd7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $802e9ccbe48cbd7f$var$FilesIcon = (props)=>/*#__PURE__*/ $802e9ccbe48cbd7f$var$_react.default.createElement($802e9ccbe48cbd7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$802e9ccbe48cbd7f$var$FilesIcon.displayName = 'FilesIcon';
var $802e9ccbe48cbd7f$var$_default = module.exports.default = $802e9ccbe48cbd7f$var$FilesIcon;

});

parcelRegister("6zF1U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c95d69c59142f9b$var$_react = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c95d69c59142f9b$var$_baseNew = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4c95d69c59142f9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c95d69c59142f9b$var$LightbulbIcon = (props)=>/*#__PURE__*/ $4c95d69c59142f9b$var$_react.default.createElement($4c95d69c59142f9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$4c95d69c59142f9b$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $4c95d69c59142f9b$var$_default = module.exports.default = $4c95d69c59142f9b$var$LightbulbIcon;

});

parcelRegister("6ED9p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0140140442510c7f$var$_react = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0140140442510c7f$var$_baseNew = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0140140442510c7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0140140442510c7f$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $0140140442510c7f$var$_react.default.createElement($0140140442510c7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$0140140442510c7f$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $0140140442510c7f$var$_default = module.exports.default = $0140140442510c7f$var$ListBulletedIcon;

});

parcelRegister("5WMok", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4547e807fcbff5a7$var$_react = $4547e807fcbff5a7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4547e807fcbff5a7$var$_baseNew = $4547e807fcbff5a7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4547e807fcbff5a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4547e807fcbff5a7$var$RefreshIcon = (props)=>/*#__PURE__*/ $4547e807fcbff5a7$var$_react.default.createElement($4547e807fcbff5a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$4547e807fcbff5a7$var$RefreshIcon.displayName = 'RefreshIcon';
var $4547e807fcbff5a7$var$_default = module.exports.default = $4547e807fcbff5a7$var$RefreshIcon;

});

parcelRegister("dTWad", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ed8782c3681aeb$var$_react = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1ed8782c3681aeb$var$_baseNew = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a1ed8782c3681aeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1ed8782c3681aeb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $a1ed8782c3681aeb$var$_react.default.createElement($a1ed8782c3681aeb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$a1ed8782c3681aeb$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $a1ed8782c3681aeb$var$_default = module.exports.default = $a1ed8782c3681aeb$var$RoadmapIcon;

});

parcelRegister("gjva1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be06978ded12aba7$var$_react = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $be06978ded12aba7$var$_baseNew = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $be06978ded12aba7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be06978ded12aba7$var$TeamsIcon = (props)=>/*#__PURE__*/ $be06978ded12aba7$var$_react.default.createElement($be06978ded12aba7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$be06978ded12aba7$var$TeamsIcon.displayName = 'TeamsIcon';
var $be06978ded12aba7$var$_default = module.exports.default = $be06978ded12aba7$var$TeamsIcon;

});

parcelRegister("HMZ3r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ftgEA")).ContentPlatformImage; });

var $ftgEA = parcelRequire("ftgEA");

});
parcelRegister("ftgEA", function(module, exports) {
$parcel$export(module.exports, "ContentPlatformImage", function () { return $93bafa18ccb06246$export$f8e4eb6f7b9af79c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $imIsw = parcelRequire("imIsw");
const $93bafa18ccb06246$export$f8e4eb6f7b9af79c = (_param)=>{
    var { contentType: contentType, src: src, alt: alt, baseWidth: baseWidth } = _param, rest = (0, $aPnCa._)(_param, [
        "contentType",
        "src",
        "alt",
        "baseWidth"
    ]);
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $imIsw.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", (0, $dPABA._)((0, $6ogO3._)({
        loading: "lazy"
    }, rest), {
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    })));
};

});


parcelRegister("hhv63", function(module, exports) {
$parcel$export(module.exports, "ConsentHubClientConfigProvider", function () { return $a62f11770126afae$export$4f1d572ab3f4c2e6; });
$parcel$export(module.exports, "useConsentHubClientConfig", function () { return $a62f11770126afae$export$ef2475d0eafefa1b; });
//@ts-nocheck

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $PE2DD = parcelRequire("PE2DD");
const $a62f11770126afae$var$requiredProps = [
    "email",
    "site",
    "locale",
    "formUrl"
];
const $a62f11770126afae$var$defaultLocaleConfig = {
    locale: "UNKNOWN",
    localeRequiresMarketingCommunicationOptIn: true
};
const $a62f11770126afae$export$ff156a5e09be2a6a = async (stargateClient)=>{
    return await stargateClient.getConsentConfig().then((response)=>response, (err)=>{
        return $a62f11770126afae$var$defaultLocaleConfig;
    });
};
const $a62f11770126afae$export$7bb3e177c1a1e841 = async (stargateClient, params, localeConfig)=>{
    const paramsLocale = params.paramsLocale ? params.paramsLocale : "UNKNOWN";
    const postData = (0, $6ogO3._)({
        locale: localeConfig.locale || paramsLocale
    }, params);
    if (!$a62f11770126afae$var$requiredProps.every((prop)=>postData.hasOwnProperty(prop))) throw `Invalid parameters. Required: {${$a62f11770126afae$var$requiredProps.toString()}}`;
    const updateConsentPreferencesResponseStatus = await stargateClient.updateConsentPreferences(postData);
    return updateConsentPreferencesResponseStatus;
};
const $a62f11770126afae$var$useGetConsentConfig = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const [localeConfig, setLocaleConfig] = (0, $1oC0p.useState)($a62f11770126afae$var$defaultLocaleConfig);
    (0, $1oC0p.useEffect)(()=>{
        const fetchConfigData = async ()=>{
            const consentHubConfig = await $a62f11770126afae$export$ff156a5e09be2a6a(stargateClient);
            if (consentHubConfig) setLocaleConfig(consentHubConfig);
        };
        fetchConfigData().catch((err)=>console.log(err));
    }, [
        stargateClient
    ]);
    return [
        localeConfig
    ];
};
const $a62f11770126afae$export$6ccd5662e539f2b6 = /*#__PURE__*/ (0, $1oC0p.createContext)($a62f11770126afae$var$defaultLocaleConfig);
const $a62f11770126afae$export$4f1d572ab3f4c2e6 = ({ children: children })=>{
    const [localeConfig] = $a62f11770126afae$var$useGetConsentConfig();
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a62f11770126afae$export$6ccd5662e539f2b6.Provider, {
        value: localeConfig,
        children: children
    });
};
const $a62f11770126afae$export$ef2475d0eafefa1b = ()=>{
    const context = (0, $1oC0p.useContext)($a62f11770126afae$export$6ccd5662e539f2b6);
    if (!context) throw new Error("useConsentHubClientConfig must be used within a ConsentHubClientConfigProvider");
    return context;
};

});

parcelRegister("l1i8p", function(module, exports) {
$parcel$export(module.exports, "CallToAction", function () { return (parcelRequire("5JoNJ")).CallToAction; });
$parcel$export(module.exports, "CustomerTestimonials", function () { return (parcelRequire("i1SI4")).CustomerTestimonials; });
$parcel$export(module.exports, "HeroCarousel", function () { return (parcelRequire("us1N6")).HeroCarousel; });
$parcel$export(module.exports, "Logos", function () { return (parcelRequire("behZZ")).Logos; });
$parcel$export(module.exports, "FeaturesHighlight", function () { return (parcelRequire("anFhN")).FeaturesHighlight; });
$parcel$export(module.exports, "Integration", function () { return (parcelRequire("ifNiy")).Integration; });
$parcel$export(module.exports, "MobileApp", function () { return (parcelRequire("euqle")).MobileApp; });
$parcel$export(module.exports, "SideNav", function () { return (parcelRequire("5f18E")).SideNav; });

var $5JoNJ = parcelRequire("5JoNJ");

var $i1SI4 = parcelRequire("i1SI4");

var $anFhN = parcelRequire("anFhN");

var $8J2ZV = parcelRequire("8J2ZV");

var $us1N6 = parcelRequire("us1N6");

var $ifNiy = parcelRequire("ifNiy");

var $behZZ = parcelRequire("behZZ");

var $euqle = parcelRequire("euqle");

var $5f18E = parcelRequire("5f18E");

var $4Fnxt = parcelRequire("4Fnxt");
parcelRequire("5uGt2");
var $7kpd6 = parcelRequire("7kpd6");

});
parcelRegister("5JoNJ", function(module, exports) {
$parcel$export(module.exports, "CallToAction", function () { return $fb865668dbde9df8$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $fb865668dbde9df8$var$callToActionStyles = null;
const $fb865668dbde9df8$var$typographyOverrides = null;
const $fb865668dbde9df8$var$polygonStyles = null;
const $fb865668dbde9df8$var$contentStyles = null;
const $fb865668dbde9df8$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = "black" })=>{
    const buttonProps = backgroundColor === "blue" ? {
        variant: "primary_alt",
        colorAgainst: "other"
    } : {
        variant: "primary",
        colorAgainst: "black"
    };
    const transformedButton = /*#__PURE__*/ (0, $1oC0p.cloneElement)(button, buttonProps);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            style: {
                "--background-color": (0, $kbpa7.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $2jatx.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton
            ]
        })
    });
};

});

parcelRegister("i1SI4", function(module, exports) {
$parcel$export(module.exports, "CustomerTestimonials", function () { return $82b7f8eaea519598$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a9lfn = parcelRequire("a9lfn");

var $ftgEA = parcelRequire("ftgEA");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
// Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $82b7f8eaea519598$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $82b7f8eaea519598$var$backgroundShape = null;
const $82b7f8eaea519598$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $82b7f8eaea519598$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $82b7f8eaea519598$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f _1uiy1wzc",
    "white-bg": "_d4ksr3uz _i862r3uz"
};
const $82b7f8eaea519598$var$justifyContentStyleMap = {
    "dark-bg": "_1bahh9n0",
    "white-bg": "_1bah1h6o"
};
const $82b7f8eaea519598$export$ff99f9acc73d9931 = ({ bgColor: bgColor = "black", testimonials: testimonials, productKey: productKey })=>{
    const bgTheme = bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbykb7n _6rth1jfw",
                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme]
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                    $82b7f8eaea519598$var$backgroundColorStyleMap[bgColor],
                                    bgColor === "black" && "_mkrzq8qa _kxoh75ra"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                ]),
                                children: testimonials.map((testimonial, index)=>{
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                                        id: `${index}`,
                                        panelIndex: index,
                                        forceRender: true,
                                        hideTabPanelRole: true,
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$TopRowContent, {
                                            testimonial: testimonial,
                                            index: index,
                                            bgTheme: bgTheme,
                                            bgColor: bgColor,
                                            productKey: productKey
                                        })
                                    }, index);
                                })
                            }),
                            testimonials.length > 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4DraggableTabList), {
                                        rowGap: "32px",
                                        className: (0, $2jatx.default)([
                                            "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                    $82b7f8eaea519598$var$topLineStyleMap[bgColor]
                                                ])
                                            }),
                                            testimonials.map((testimonial, index)=>{
                                                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                                    as: "li",
                                                    tabIndex: index,
                                                    dataEventProps: {
                                                        "data-product-key": productKey,
                                                        "data-event-component": "tab",
                                                        "data-event-container": "testimonialsSection",
                                                        "data-event": "clicked",
                                                        "data-label-english": testimonial.label
                                                    },
                                                    label: testimonial.label,
                                                    className: (0, $2jatx.default)([
                                                        $82b7f8eaea519598$var$logoOptionStyleMap[bgTheme],
                                                        "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$LogoTabContent, {
                                                        testimonialLogo: testimonial.logo
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $82b7f8eaea519598$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive, productKey: productKey })=>{
    var _testimonial_link_type, _testimonial_link_dataEventProps;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== "string" && "contentType" in testimonial.image ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), (0, $6ogO3._)({}, testimonial.image)) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: ""
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _bozg1b66 _85i51b66 _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $82b7f8eaea519598$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: (_testimonial_link_type = testimonial.link.type) !== null && _testimonial_link_type !== void 0 ? _testimonial_link_type : "primary",
                                bgColor: bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                "aria-label": testimonial.link.text,
                                dataEventProps: (_testimonial_link_dataEventProps = testimonial.link.dataEventProps) !== null && _testimonial_link_dataEventProps !== void 0 ? _testimonial_link_dataEventProps : {
                                    "data-product-key": productKey,
                                    "data-event-component": "linkButton",
                                    "data-event-container": "testimonialsSection",
                                    "data-event": "clicked"
                                }
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $82b7f8eaea519598$var$topRowActiveStyle = null;
const $82b7f8eaea519598$var$customerImagesImgActiveStyle = null;
const $82b7f8eaea519598$var$quoteContainerActiveStyle = null;
const $82b7f8eaea519598$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = "contentType" in testimonialLogo;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), (0, $dPABA._)((0, $6ogO3._)({}, testimonialLogo), {
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: "contain",
                            objectPosition: "center center"
                        },
                        className: "tab-logo"
                    })) : testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $82b7f8eaea519598$var$logoImgStyle = null;
const $82b7f8eaea519598$var$logoImgSelectedStyle = null;
const $82b7f8eaea519598$var$logoButtonStyle = null;
const $82b7f8eaea519598$var$topMarkerStyle = null;
const $82b7f8eaea519598$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $82b7f8eaea519598$var$topLineStyles = null;
const $82b7f8eaea519598$var$testimonialKeyframeStyles = null;
const $82b7f8eaea519598$var$rowWidthStyle = null;
const $82b7f8eaea519598$var$topRowStyle = null;
const $82b7f8eaea519598$var$bgShapeStyle = null;
const $82b7f8eaea519598$var$customerImagesSectionStyles = null;
const $82b7f8eaea519598$var$customerImagesSectionImageStyles = null;
const $82b7f8eaea519598$var$customerQuotesSectionStyle = null;
const $82b7f8eaea519598$var$testimonialQuotesSectionStyle = null;
const $82b7f8eaea519598$var$quoteContainerStyle = null;
const $82b7f8eaea519598$var$quoteContainerPStyle = null;
const $82b7f8eaea519598$var$logosContainerBaseStyle = null;
const $82b7f8eaea519598$var$logosStyle = null;
const $82b7f8eaea519598$var$logoOptionStyle = null;
const $82b7f8eaea519598$var$testimonialStyles = null;
const $82b7f8eaea519598$var$tabPanelWrapperStyles = null;

});

parcelRegister("anFhN", function(module, exports) {
$parcel$export(module.exports, "FeaturesHighlight", function () { return $00c15acb18b151d4$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $ggSCt = parcelRequire("ggSCt");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $lE15B = parcelRequire("lE15B");

var $kbpa7 = parcelRequire("kbpa7");
const $00c15acb18b151d4$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(0);
    const onFeatureSelect = (featureKey)=>{
        setActiveFeature(featureKey);
    };
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $2jatx.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx17la _uoz5x71z _suga1ule _1ah31y44",
                `feature ${activeFeature === featureKey ? "selected" : ""}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1pbykb7n _bfhk17la _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    var _props_feature1ImageAltText;
    const feature1Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: (_props_feature1ImageAltText = props.feature1ImageAltText) !== null && _props_feature1ImageAltText !== void 0 ? _props_feature1ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    var _props_feature1VideoAltText;
    const feature1Video = props.feature1VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature1VideoSrc,
        poster: props.feature1VideoPoster,
        alt: (_props_feature1VideoAltText = props.feature1VideoAltText) !== null && _props_feature1VideoAltText !== void 0 ? _props_feature1VideoAltText : ""
    }, "feature1-video") : null;
    var _props_feature2VideoAltText;
    const feature2Video = props.feature2VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature2VideoSrc,
        poster: props.feature2VideoPoster,
        alt: (_props_feature2VideoAltText = props.feature2VideoAltText) !== null && _props_feature2VideoAltText !== void 0 ? _props_feature2VideoAltText : ""
    }, "feature2-video") : null;
    var _props_feature3VideoAltText;
    const feature3Video = props.feature3VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature3VideoSrc,
        poster: props.feature3VideoPoster,
        alt: (_props_feature3VideoAltText = props.feature3VideoAltText) !== null && _props_feature3VideoAltText !== void 0 ? _props_feature3VideoAltText : ""
    }, "feature3-video") : null;
    const feature2Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    var _props_feature2ImageAltText;
    const feature2Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: (_props_feature2ImageAltText = props.feature2ImageAltText) !== null && _props_feature2ImageAltText !== void 0 ? _props_feature2ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    var _props_feature3ImageAltText;
    const feature3Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: (_props_feature3ImageAltText = props.feature3ImageAltText) !== null && _props_feature3ImageAltText !== void 0 ? _props_feature3ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const content = [
        props.feature1ImageSrc ? feature1Image : feature1Video,
        props.feature2ImageSrc ? feature2Image : feature2Video,
        props.feature3Title && props.feature3ImageSrc ? feature3Image : feature3Video
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1cls"
            ]),
            style: {
                "--_1lhuu6n": (0, $6ZVlx.default)(featureNum === activeFeature ? (0, $kbpa7.wacToken)("color.primary.black") : (0, $kbpa7.wacToken)("color.neutral.light500"))
            }
        });
    };
    // @ts-ignore
    const navDotsContainer = (_)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: props.linkText,
                        href: props.linkHref,
                        "aria-label": props.linkText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tabpanel",
                className: (0, $2jatx.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: content[activeFeature]
                }, activeFeature)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), (0, $dPABA._)((0, $6ogO3._)({}, sliderSettings), {
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                content[index]
                            ]
                        }, index))
                }))
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $00c15acb18b151d4$var$slickStyle = null;

});

parcelRegister("8J2ZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3798516d873ca4cc$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $3798516d873ca4cc$export$887967f05dc521ae = (_param)=>{
    var { layout: layout = "image-right" } = _param, props = (0, $aPnCa._)(_param, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $kbpa7.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $2jatx.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroBothImages, (0, $6ogO3._)({
            layout: layout
        }, props)) : /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroOneImage, (0, $6ogO3._)({
            layout: layout
        }, props))
    });
};
var $3798516d873ca4cc$export$2e2bcd8739ae039 = $3798516d873ca4cc$export$887967f05dc521ae;
const $3798516d873ca4cc$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $3798516d873ca4cc$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const _ref = callToActionProps !== null && callToActionProps !== void 0 ? callToActionProps : {}, { text: buttonText } = _ref, buttonProps = (0, $aPnCa._)(_ref, [
        "text"
    ]);
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $3798516d873ca4cc$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $2jatx.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, buttonProps), {
                size: "large",
                className: (0, $2jatx.default)([
                    "_1pfhxy5q"
                ]),
                children: buttonText
            }))
        ]
    });
};
const $3798516d873ca4cc$var$HeroOneImage = (_param)=>{
    var { layout: layout = "image-right", imageProps: imageProps } = _param, props = (0, $aPnCa._)(_param, [
        "layout",
        "imageProps"
    ]);
    var _imageProps_alt;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, (0, $6ogO3._)({}, props))
                }),
                imageProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: (_imageProps_alt = imageProps.alt) !== null && _imageProps_alt !== void 0 ? _imageProps_alt : "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$gridStyle = null;
const $3798516d873ca4cc$var$headingStyle = null;
const $3798516d873ca4cc$var$imageStartStyle = null;
const $3798516d873ca4cc$var$bodyStyle = null;
const $3798516d873ca4cc$var$buttonStyle = null;
/*
This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
Initial support is seens on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine

TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
  Currently it is very tailored to the aforementioned enterprise experience
*/ const $3798516d873ca4cc$var$HeroBothImages = (_param)=>{
    var { imageProps: imageProps, secondaryImageProps: secondaryImageProps } = _param, props = (0, $aPnCa._)(_param, [
        "imageProps",
        "secondaryImageProps"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $6ZVlx.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $6ZVlx.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, (0, $dPABA._)((0, $6ogO3._)({}, props), {
                    size: "regular"
                }))
            })
        })
    });
};
const $3798516d873ca4cc$var$gridTwoImagesStyle = null;

});

parcelRegister("us1N6", function(module, exports) {
$parcel$export(module.exports, "HeroCarousel", function () { return $13e2b0d7d2657b7f$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");
parcelRequire("8EEDU");
var $hBYvx = parcelRequire("hBYvx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
const $13e2b0d7d2657b7f$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $1oC0p.useState)(0);
    const listRef = (0, $1oC0p.useRef)(null);
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $jKShK.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $jKShK.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    (0, $1oC0p.useEffect)(()=>{
        const listElement = listRef === null || listRef === void 0 ? void 0 : listRef.current;
        if (listElement) {
            var _listElement_children;
            const tabElement = (_listElement_children = listElement.children) === null || _listElement_children === void 0 ? void 0 : _listElement_children[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === "function") {
                tabElement.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "end"
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            let newFocusIndex = 0;
            if (e.key === "ArrowRight") {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === "ArrowLeft") {
                newFocusIndex = selectedTab - 1;
                // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_syazcd5j _1wyb1j6v _k48pni7l _vwz410nf"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? "h1" : "h2"
                        }, tab.id))
                })
            ]
        })
    });
};
var $13e2b0d7d2657b7f$export$2e2bcd8739ae039 = $13e2b0d7d2657b7f$export$b92905002f03c113;
const $13e2b0d7d2657b7f$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71hlo _1bsb1osq _syazcd5j _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-ignore
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $2jatx.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $13e2b0d7d2657b7f$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? "true" : "false",
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _oxutkb7n _svxhkb7n",
            isSelected && "_mqm21hn9 _1wk5kb7n"
        ]),
        style: {
            "--_1vwzriw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.yellow"))
        },
        children: children
    });
};
const $13e2b0d7d2657b7f$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $13e2b0d7d2657b7f$var$Panel = (_param)=>{
    var { isSelected: isSelected, id: id, panel: panel } = _param, props = (0, $aPnCa._)(_param, [
        "isSelected",
        "id",
        "panel"
    ]);
    var _panel_secondaryCallToAction, _panel_bgImage, _panel_secondaryCallToAction1;
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const baseStyle = null;
    const isVideoLink = ((_panel_secondaryCallToAction = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction === void 0 ? void 0 : _panel_secondaryCallToAction.type) === "video";
    const isForegroundLight = [
        "blue",
        "black"
    ].includes(panel.bgColor);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc12wd"
        ]),
        style: {
            "--bg-color": panel.bgColor === "neutral" ? (0, $kbpa7.wacToken)(`color.neutral.light200`) : (0, $kbpa7.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $6ZVlx.default)(((_panel_bgImage = panel.bgImage) === null || _panel_bgImage === void 0 ? void 0 : _panel_bgImage.lg) ? `url(${panel.bgImage.lg})` : undefined),
            "--_xe4ghn": (0, $6ZVlx.default)(panel.layout === "end" ? "0% 50%" : "center center")
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: "Close video",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hBYvx.Video), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: (_panel_secondaryCallToAction1 = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction1 === void 0 ? void 0 : _panel_secondaryCallToAction1.href
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    isForegroundLight && "_cg41121t _125x121t",
                    panel.layout === "end" ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === "start" ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelActions, (0, $dPABA._)((0, $6ogO3._)({}, panel), {
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    }))
                ]
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelContent = (_param)=>{
    var { panel: panel } = _param, props = (0, $aPnCa._)(_param, [
        "panel"
    ]);
    const { titleAs: Title = "h2" } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)(Title, {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "h1"
                ]),
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "body-lg"
                ]),
                children: panel.body
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === "start" || panel.layout === "end") && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PrimaryCallToAction, (0, $6ogO3._)({
                bgColor: panel.bgColor
            }, panel.primaryCallToAction)),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$SecondaryCallToAction, (0, $6ogO3._)({}, panel))
        ]
    });
};
const $13e2b0d7d2657b7f$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor } = props, rest = (0, $aPnCa._)(props, [
        "bgColor"
    ]);
    let variant = "primary";
    if (bgColor === "blue") variant = "primary_alt";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, rest), {
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    }));
};
const $13e2b0d7d2657b7f$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        "blue",
        "black"
    ].includes(panel.bgColor) ? "bgBlackBlue" : "bgWhite";
    return(// @ts-ignore
    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), (0, $dPABA._)((0, $6ogO3._)({}, secondaryCallToAction), {
        bgColor: bgColor,
        anchorProps: {
            "data-testid": "secondary-cta"
        },
        onClick: panel.onVideoClick,
        onKeyDown: panel.onVideoClick,
        role: "button",
        tabIndex: 0,
        children: secondaryCallToAction === null || secondaryCallToAction === void 0 ? void 0 : secondaryCallToAction.text
    })));
};
const $13e2b0d7d2657b7f$var$sectionStyles = null;
const $13e2b0d7d2657b7f$var$tabListStyle = null;
const $13e2b0d7d2657b7f$var$scrollableStyle = null;
const $13e2b0d7d2657b7f$var$fittableStyle = null;
const $13e2b0d7d2657b7f$var$tabStyle = null;
const $13e2b0d7d2657b7f$var$tabTextStyle = null;
const $13e2b0d7d2657b7f$var$tabTitleStyle = null;
const $13e2b0d7d2657b7f$var$tabSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelContainerStyle = null;
const $13e2b0d7d2657b7f$var$panelStyle = null;
const $13e2b0d7d2657b7f$var$panelSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelDetailsStyle = null;
const $13e2b0d7d2657b7f$var$panelEndStyle = null;
const $13e2b0d7d2657b7f$var$panelStartStyle = null;
const $13e2b0d7d2657b7f$var$panelCenteredStyle = null;
const $13e2b0d7d2657b7f$var$detailsTextStyle = null;
const $13e2b0d7d2657b7f$var$panelColorStyle = null;
const $13e2b0d7d2657b7f$var$actionContainerStyle = null;
const $13e2b0d7d2657b7f$var$actionStartStyle = null;

});

parcelRegister("ifNiy", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $945afc5e0498e2e0$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $945afc5e0498e2e0$var$logoSizes = {
    regular: {
        size: "78px",
        cornerRadius: "18.7px"
    },
    large: {
        size: "100px",
        cornerRadius: "24px"
    }
};
const $945afc5e0498e2e0$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    var _props_dataEventProps;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhkcd5j _19it1k0a _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz1cd0"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_1jpuyj7": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", (0, $dPABA._)((0, $6ogO3._)({
            href: props.href
        }, (_props_dataEventProps = props.dataEventProps) !== null && _props_dataEventProps !== void 0 ? _props_dataEventProps : {}), {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbsq37 _4t3isbdl"
                ]),
                style: {
                    "--_1hn5070": (0, $6ZVlx.default)(props.width ? `${props.width}px` : "100%"),
                    "--_1jk4xy3": (0, $6ZVlx.default)(props.width ? "auto" : "100%")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        }))
    });
};
const $945afc5e0498e2e0$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = "h3", body: body, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, logoLinkDataEventProps: logoLinkDataEventProps, logos: logos, background: background = "polygon", backgroundColor: backgroundColor = "neutral.light100", flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>{
        var _logo_href;
        return (_logo_href = logo.href) !== null && _logo_href !== void 0 ? _logo_href : false;
    }).length;
    const logoSize = numLogos <= 6 ? "large" : "regular";
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _kqswh2mm _1moul8wr _11q7fulm _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_pxzrua": (0, $6ZVlx.default)(background === "full" ? 0 : "var(--ds-space-800, 64px)"),
            "--_1sgx88i": (0, $6ZVlx.default)(background === "full" ? (0, $kbpa7.wacToken)(`color.${backgroundColor}`) : "transparent")
        },
        children: [
            background === "polygon" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $6ZVlx.default)((0, $kbpa7.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>{
                            var _logo_dataEventProps;
                            return /*#__PURE__*/ (0, $7VQPk.jsx)($945afc5e0498e2e0$var$IntegrationLogo, (0, $dPABA._)((0, $6ogO3._)({}, logo), {
                                logoSize: logoSize,
                                dataEventProps: (_logo_dataEventProps = logo.dataEventProps) !== null && _logo_dataEventProps !== void 0 ? _logo_dataEventProps : logoLinkDataEventProps
                            }), index);
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: (0, $6ogO3._)({
                                text: linkLabel,
                                href: linkHref
                            }, linkDataEventProps && {
                                dataEventProps: linkDataEventProps
                            })
                        } : undefined,
                        alignment: {
                            mobile: "center",
                            tablet: "start",
                            desktop: "start"
                        }
                    })
                ]
            })
        ]
    });
};
const $945afc5e0498e2e0$var$contentContainerStyles = null;
const $945afc5e0498e2e0$var$logosContainerStyles = null;
const $945afc5e0498e2e0$var$sevenLogosGridStyles = null;

});

parcelRegister("behZZ", function(module, exports) {
$parcel$export(module.exports, "Logos", function () { return $511c14fce74817fd$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
const $511c14fce74817fd$export$c847549a613b9060 = ({ logos: logos })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o"
        ]),
        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                    src: logo.src,
                    alt: logo.alt,
                    style: (0, $6ogO3._)({}, $511c14fce74817fd$var$logoStyles, logo.width ? {
                        width: `${logo.width}px`,
                        height: "auto"
                    } : {})
                })
            }, index))
    });
};
const $511c14fce74817fd$var$logosContainerStyle = null;
const $511c14fce74817fd$var$logoStyles = {
    height: "32px",
    width: "auto",
    maxWidth: "auto",
    filter: "grayscale(100%) brightness(66%)",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)"
};

});

parcelRegister("euqle", function(module, exports) {
$parcel$export(module.exports, "MobileApp", function () { return $dec4263d3b3e8269$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
const $dec4263d3b3e8269$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, imageSrc: imageSrc, imageAlt: imageAlt = "", appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: (0, $6ogO3._)({
                                text: linkLabel,
                                href: linkHref
                            }, linkDataEventProps && {
                                dataEventProps: linkDataEventProps
                            })
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: appleAppStoreUrl,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: "Download on the Apple App Store"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: googlePlayStoreUrl,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: "Get it on the Google Play Store"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $2jatx.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $dec4263d3b3e8269$var$sectionStyles = null;
const $dec4263d3b3e8269$var$leftSideContentStyles = null;
const $dec4263d3b3e8269$var$appStoreLinksContainerStyles = null;
const $dec4263d3b3e8269$var$imageContainerStyles = null;
const $dec4263d3b3e8269$var$imageStyles = null;

});

parcelRegister("5f18E", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $0ecd955324bfea13$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $46Ma8 = parcelRequire("46Ma8");

var $bxChG = parcelRequire("bxChG");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $0ecd955324bfea13$var$MobileExpandableNav = ({ title: title, children: children })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $1oC0p.useState)(0);
    const navRef = (0, $1oC0p.useRef)(null);
    const buttonRef = (0, $1oC0p.useRef)(null);
    const contentRef = (0, $1oC0p.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Calculate button position for nav positioning
    (0, $1oC0p.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $1oC0p.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $1oC0p.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: navRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1wqb _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _kqswh2mm _1pbyibnn _irr3u4vp _s51sxy5q"
                ]),
                style: {
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxChG))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ma8))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "eyebrow-md",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentRef,
                id: "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_bfhkcd5j _1bsb1osq _18zr1wqb _v564vpel _1reo1wug _18m91wug _s51sxy5q",
                    isExpanded ? "_kqsw1n9t _152t1um1 _dk5didpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51wqb _18zr1wqb _s51sxy5q" : "_kqsw1n9t _c71lidpf _tzy4idpf _lcxvglyw _152tidpf _dk5didpf _1bsbauwl"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $6ZVlx.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1reo1wug _18m91wug"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $0ecd955324bfea13$export$6b43f262d1299a2e = ({ sideNavItems: sideNavItems })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t _1reo1wug _18m91wug _1jc21nkh _1xey1k0a",
            "sidenav-menu"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: sideNavItems.map((sideNavItem)=>{
            if (sideNavItem.type === "collection") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.SideNavCollection), {
                type: "collection",
                collectionName: sideNavItem.collectionName,
                sideNavItems: sideNavItem.sideNavItems,
                depth: 0
            }, sideNavItem.collectionName);
            if (sideNavItem.type === "link") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.SideNavLink), {
                dataEventProps: sideNavItem.dataEventProps,
                type: "link",
                text: sideNavItem.text,
                href: sideNavItem.href,
                anchors: sideNavItem.anchors,
                depth: 0
            }, sideNavItem.text);
            return null;
        })
    });
};
const $0ecd955324bfea13$export$1a35787d6353cf6a = ({ title: title, sideNavItems: sideNavItems })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
                id: "side-nav-desktop",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.desktop.label",
                    defaultMessage: `{hub_topics} desktop navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_kqsw1if8 _152t1dln",
                    "_19ityzqy _2rkovwyg _1yt4v47k _85i51wqb _4t3i1ns9"
                ]),
                style: {
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1tke1wqb _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
                id: "side-nav-tablet-mobile",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.mobile.label",
                    defaultMessage: `{hub_topics} mobile navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_dm25glyw",
                    "_kqsw1n9t _1e02idpf _1pbyegat _1bsbauwl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$var$MobileExpandableNav, {
                    title: title,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw",
                    "_4t3i1wqb"
                ])
            })
        ]
    });
};
const $0ecd955324bfea13$var$desktopCss = null;
const $0ecd955324bfea13$var$tabletMobileCss = null;
const $0ecd955324bfea13$var$stickyCss = null;
const $0ecd955324bfea13$var$fixedCss = null;
const $0ecd955324bfea13$var$listCss = null;
const $0ecd955324bfea13$var$containerCss = null;
const $0ecd955324bfea13$var$desktopTitleCss = null;
const $0ecd955324bfea13$var$mobileIconCss = null;
const $0ecd955324bfea13$var$mobileExpandableButtonCss = null;
const $0ecd955324bfea13$var$mobileNavContentCss = null;
const $0ecd955324bfea13$var$mobileNavContentCollapsedCss = null;
const $0ecd955324bfea13$var$mobileInnerContentCss = null;

});
parcelRegister("bxChG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8670793cd6a627cd$var$_react = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8670793cd6a627cd$var$_baseNew = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8670793cd6a627cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8670793cd6a627cd$var$MinusIcon = (props)=>/*#__PURE__*/ $8670793cd6a627cd$var$_react.default.createElement($8670793cd6a627cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$8670793cd6a627cd$var$MinusIcon.displayName = 'MinusIcon';
var $8670793cd6a627cd$var$_default = module.exports.default = $8670793cd6a627cd$var$MinusIcon;

});


parcelRegister("5uGt2", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return (parcelRequire("aeZV4")).useTabsContext; });
$parcel$export(module.exports, "Tabs", function () { return (parcelRequire("aeZV4")).Tabs; });
$parcel$export(module.exports, "DraggableTabList", function () { return (parcelRequire("6Iidb")).DraggableTabList; });
$parcel$export(module.exports, "DraggableTab", function () { return (parcelRequire("4q5Ua")).DraggableTab; });
$parcel$export(module.exports, "TabPanel", function () { return (parcelRequire("kFhJA")).TabPanel; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("7kpd6")).TabsSection; });
$parcel$export(module.exports, "mapChild", function () { return (parcelRequire("jgQie")).mapChild; });

var $aeZV4 = parcelRequire("aeZV4");

var $6Iidb = parcelRequire("6Iidb");

var $4q5Ua = parcelRequire("4q5Ua");

var $kFhJA = parcelRequire("kFhJA");

var $7kpd6 = parcelRequire("7kpd6");

var $jgQie = parcelRequire("jgQie");

});
parcelRegister("aeZV4", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return $0f3c3abb0b914582$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $0f3c3abb0b914582$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $aHkxS = parcelRequire("aHkxS");

var $jgQie = parcelRequire("jgQie");
const $0f3c3abb0b914582$var$TabsContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $0f3c3abb0b914582$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $1oC0p.useContext)($0f3c3abb0b914582$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $0f3c3abb0b914582$var$nextId = 0;
const $0f3c3abb0b914582$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(initialTab !== null && initialTab !== void 0 ? initialTab : 0);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    const [focus, setFocus] = (0, $1oC0p.useState)(false);
    const tabIds = (0, $1oC0p.useRef)([]);
    const contextId = (0, $1oC0p.useRef)(`:tabs:${id ? id : $0f3c3abb0b914582$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $jKShK.useInView)((0, $6ogO3._)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    }, useInViewOptionsContainer));
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $jgQie.deepForEach)(children, (child)=>{
            if ((0, $jgQie.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        const tabsCount = getTabsCount();
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - tabsCount;
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $jgQie.deepMap)(children, (child)=>{
            var _window_document_activeElement;
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? (_window_document_activeElement = window.document.activeElement) === null || _window_document_activeElement === void 0 ? void 0 : _window_document_activeElement.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $jgQie.isTabList)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $1oC0p.Children).toArray(child.props.children).filter((0, $jgQie.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                    children: (0, $jgQie.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $1oC0p.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $jgQie.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = (0, $dPABA._)((0, $6ogO3._)({}, existingProps), {
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                });
                panelIndex++;
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, props);
            }
            return result;
        });
    }
    const unsetUserSelected = ()=>{
        setUserSelected(false);
    };
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
        setUserSelected(true);
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $1oC0p.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0f3c3abb0b914582$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            unsetUserSelected: unsetUserSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("jgQie", function(module, exports) {
$parcel$export(module.exports, "isTab", function () { return $5fe887815c1bacdb$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $5fe887815c1bacdb$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $5fe887815c1bacdb$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $5fe887815c1bacdb$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $5fe887815c1bacdb$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $5fe887815c1bacdb$export$519ada94592b97fc; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1oC0p = parcelRequire("1oC0p");
function $5fe887815c1bacdb$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $5fe887815c1bacdb$export$bdc9792d96913679 = $5fe887815c1bacdb$var$makeTypeChecker("Tab");
const $5fe887815c1bacdb$export$9c326233b9ae5588 = $5fe887815c1bacdb$var$makeTypeChecker("TabList");
const $5fe887815c1bacdb$export$9e12445c79db89b = $5fe887815c1bacdb$var$makeTypeChecker("TabPanel");
const $5fe887815c1bacdb$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $5fe887815c1bacdb$var$isTabChild(child) {
    return $5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9c326233b9ae5588(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child);
}
function $5fe887815c1bacdb$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($5fe887815c1bacdb$export$dbaa4172856e20ab(child)) return (0, $1oC0p.cloneElement)(child, (0, $6ogO3._)({}, child.props, additionalProps));
    return child;
}
function $5fe887815c1bacdb$export$ce7eaaed37329a1b(children, callback) {
    return (0, $1oC0p.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($5fe887815c1bacdb$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $1oC0p.cloneElement)(child, (0, $dPABA._)((0, $6ogO3._)({}, child.props), {
            children: $5fe887815c1bacdb$export$ce7eaaed37329a1b(child.props.children, callback)
        }));
        return child;
    });
}
function $5fe887815c1bacdb$export$519ada94592b97fc(children, callback) {
    return (0, $1oC0p.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($5fe887815c1bacdb$export$9c326233b9ae5588(child)) callback(child, index);
            $5fe887815c1bacdb$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("6Iidb", function(module, exports) {
$parcel$export(module.exports, "DraggableTabList", function () { return $5334c6b54e489af6$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
const $5334c6b54e489af6$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-ignore
tabSize = "large", children: children })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const mouseDown = (0, $1oC0p.useRef)(false);
    const startX = (0, $1oC0p.useRef)(0);
    const scrollLeft = (0, $1oC0p.useRef)(0);
    const canDrag = (0, $1oC0p.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $aeZV4.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        var _containerRef_current;
        if (!canDrag.current) return;
        // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        var _ref;
        startX.current = (_ref = touch && touch.touches[0] ? touch.touches[0].clientX : mouse === null || mouse === void 0 ? void 0 : mouse.clientX) !== null && _ref !== void 0 ? _ref : 0;
        var _containerRef_current_scrollLeft;
        scrollLeft.current = (_containerRef_current_scrollLeft = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollLeft) !== null && _containerRef_current_scrollLeft !== void 0 ? _containerRef_current_scrollLeft : 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
        // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $1oC0p.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.marginLeft} + ${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.paddingLeft});`);
                } else if (alignment === "start") containerRef.current.setAttribute("style", "margin-inline: 0px; padding-inline: 0px;");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-ignore
            onTouchStart: (e)=>startDragging(undefined, e),
            // @ts-ignore
            onMouseDown: (e)=>startDragging(e),
            // @ts-ignore
            onTouchEnd: (e)=>{
                // @ts-ignore
                move(undefined, e);
                stopDragging();
            },
            // @ts-ignore
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $5334c6b54e489af6$var$tabsContainerStyles = null;
$5334c6b54e489af6$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("4q5Ua", function(module, exports) {
$parcel$export(module.exports, "DraggableTab", function () { return $2726a747230786c6$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
const $2726a747230786c6$export$3a29ca89d63c5c20 = (_param)=>{
    var { id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false, children: children } = _param, props = (0, $aPnCa._)(_param, [
        "id",
        "focus",
        "tabIndex",
        "title",
        "iconUrl",
        "tabSize",
        "bgColor",
        "label",
        "dataEventProps",
        "className",
        "enableRovoBorder",
        "enableResponsiveTabSize",
        "children"
    ]);
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $aeZV4.useTabsContext)();
    const startX = (0, $1oC0p.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $1oC0p.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
        // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            var _tabRef_current_parentElement;
            if ((_tabRef_current_parentElement = tabRef.current.parentElement) === null || _tabRef_current_parentElement === void 0 ? void 0 : _tabRef_current_parentElement.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        var _props_onMouseDown;
        var _e_clientX;
        startX.current = (_e_clientX = e.clientX) !== null && _e_clientX !== void 0 ? _e_clientX : 0;
        (_props_onMouseDown = props.onMouseDown) === null || _props_onMouseDown === void 0 ? void 0 : _props_onMouseDown.call(props, e);
    };
    const onClick = (0, $1oC0p.useCallback)((e)=>{
        var _props_onClick;
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $kbpa7.wacToken)("color.neutral.light200") : (0, $kbpa7.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, props), {
        // @ts-ignore
        ref: tabRef,
        // @ts-ignore
        className: className,
        children: !!children ? /*#__PURE__*/ (0, $1oC0p.cloneElement)(children, (0, $6ogO3._)({
            onMouseDown: // @ts-ignore
            onMouseDown,
            onClick: // @ts-ignore
            onClick,
            onKeyDown: // @ts-ignore
            onKeyDown
        }, dataEventProps)) : /*#__PURE__*/ (0, $7VQPk.jsxs)("button", (0, $dPABA._)((0, $6ogO3._)({
            id: `tab${id}`,
            role: "tab",
            "aria-selected": isTabSelected,
            "aria-controls": `panel${id}`,
            "aria-label": label,
            title: label,
            className: (0, $2jatx.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            // how to adjust for different page? or just remove?
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            // @ts-ignore
            onMouseDown: onMouseDown,
            // @ts-ignore
            onClick: onClick,
            // @ts-ignore
            onKeyDown: onKeyDown
        }, dataEventProps), {
            style: {
                "--_7aj7gm": (0, $6ZVlx.default)(tabColor),
                "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        }))
    }));
};
$2726a747230786c6$export$3a29ca89d63c5c20.tabsRole = "Tab";

});

parcelRegister("kFhJA", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $73f95d72bd57759d$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");
parcelRequire("5uGt2");
var $jgQie = parcelRequire("jgQie");
var $aeZV4 = parcelRequire("aeZV4");
const $73f95d72bd57759d$var$hidePanelStyle = null;
const $73f95d72bd57759d$export$3d96ec278d3efce4 = (_param)=>{
    var { forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole } = _param, props = (0, $aPnCa._)(_param, [
        "forceRender",
        "children",
        "panelIndex",
        "id",
        "hideTabPanelRole"
    ]);
    const { isCurrentTab: isCurrentTab } = (0, $aeZV4.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    const { css: existingCss } = props, propsWithoutCss = (0, $aPnCa._)(props, [
        "css"
    ]);
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    const inlineHideStyle = !isTabSelected && !forceRender ? {
        display: "none"
    } : undefined;
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $dPABA._)((0, $6ogO3._)({}, filteredProps), {
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    }));
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$73f95d72bd57759d$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});

parcelRegister("7kpd6", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $55e394e1b826b27b$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
parcelRequire("5uGt2");
var $4q5Ua = parcelRequire("4q5Ua");
var $6Iidb = parcelRequire("6Iidb");
var $kFhJA = parcelRequire("kFhJA");
var $aeZV4 = parcelRequire("aeZV4");
const $55e394e1b826b27b$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $aeZV4.Tabs), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Iidb.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $4q5Ua.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kFhJA.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});



parcelRegister("hXSMk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d14270378c3131a7$var$_react = $d14270378c3131a7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d14270378c3131a7$var$_baseNew = $d14270378c3131a7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $d14270378c3131a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d14270378c3131a7$var$AlertIcon = (props)=>/*#__PURE__*/ $d14270378c3131a7$var$_react.default.createElement($d14270378c3131a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$d14270378c3131a7$var$AlertIcon.displayName = 'AlertIcon';
var $d14270378c3131a7$var$_default = module.exports.default = $d14270378c3131a7$var$AlertIcon;

});

parcelRegister("eOOWL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac9d412ae10a01ab$var$_react = $ac9d412ae10a01ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ac9d412ae10a01ab$var$_baseNew = $ac9d412ae10a01ab$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ac9d412ae10a01ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac9d412ae10a01ab$var$ChartBarIcon = (props)=>/*#__PURE__*/ $ac9d412ae10a01ab$var$_react.default.createElement($ac9d412ae10a01ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$ac9d412ae10a01ab$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $ac9d412ae10a01ab$var$_default = module.exports.default = $ac9d412ae10a01ab$var$ChartBarIcon;

});

parcelRegister("kAq28", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efcb5d22d8bd146c$var$_react = $efcb5d22d8bd146c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $efcb5d22d8bd146c$var$_baseNew = $efcb5d22d8bd146c$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $efcb5d22d8bd146c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efcb5d22d8bd146c$var$IncidentIcon = (props)=>/*#__PURE__*/ $efcb5d22d8bd146c$var$_react.default.createElement($efcb5d22d8bd146c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$efcb5d22d8bd146c$var$IncidentIcon.displayName = 'IncidentIcon';
var $efcb5d22d8bd146c$var$_default = module.exports.default = $efcb5d22d8bd146c$var$IncidentIcon;

});

parcelRegister("kzcfD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef90945cc818a91e$var$_react = $ef90945cc818a91e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ef90945cc818a91e$var$_baseNew = $ef90945cc818a91e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ef90945cc818a91e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef90945cc818a91e$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $ef90945cc818a91e$var$_react.default.createElement($ef90945cc818a91e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$ef90945cc818a91e$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $ef90945cc818a91e$var$_default = module.exports.default = $ef90945cc818a91e$var$LobbyBellIcon;

});

parcelRegister("efg6m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5eef4da1ee45f40$var$_react = $a5eef4da1ee45f40$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a5eef4da1ee45f40$var$_baseNew = $a5eef4da1ee45f40$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a5eef4da1ee45f40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5eef4da1ee45f40$var$ChangesIcon = (props)=>/*#__PURE__*/ $a5eef4da1ee45f40$var$_react.default.createElement($a5eef4da1ee45f40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a5eef4da1ee45f40$var$ChangesIcon.displayName = 'ChangesIcon';
var $a5eef4da1ee45f40$var$_default = module.exports.default = $a5eef4da1ee45f40$var$ChangesIcon;

});

parcelRegister("FI4AH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fb18bc89cea9c558386c877fcbee03e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07d604706fb56cdd$var$_react = $07d604706fb56cdd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $07d604706fb56cdd$var$_baseNew = $07d604706fb56cdd$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $07d604706fb56cdd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07d604706fb56cdd$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $07d604706fb56cdd$var$_react.default.createElement($07d604706fb56cdd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$07d604706fb56cdd$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $07d604706fb56cdd$var$_default = module.exports.default = $07d604706fb56cdd$var$ChartTrendUpIcon;

});

parcelRegister("bf5rK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82f551fa44ba4d63$var$_react = $82f551fa44ba4d63$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $82f551fa44ba4d63$var$_baseNew = $82f551fa44ba4d63$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $82f551fa44ba4d63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82f551fa44ba4d63$var$PagesIcon = (props)=>/*#__PURE__*/ $82f551fa44ba4d63$var$_react.default.createElement($82f551fa44ba4d63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$82f551fa44ba4d63$var$PagesIcon.displayName = 'PagesIcon';
var $82f551fa44ba4d63$var$_default = module.exports.default = $82f551fa44ba4d63$var$PagesIcon;

});

parcelRegister("ggVkr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd8a9c39c889598d$var$_react = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bd8a9c39c889598d$var$_baseNew = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bd8a9c39c889598d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd8a9c39c889598d$var$PersonAddIcon = (props)=>/*#__PURE__*/ $bd8a9c39c889598d$var$_react.default.createElement($bd8a9c39c889598d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$bd8a9c39c889598d$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $bd8a9c39c889598d$var$_default = module.exports.default = $bd8a9c39c889598d$var$PersonAddIcon;

});

parcelRegister("35vmV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3a8c88470e968ec08c5aa075e8f42b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23fa2be7417a36cb$var$_react = $23fa2be7417a36cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $23fa2be7417a36cb$var$_baseNew = $23fa2be7417a36cb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $23fa2be7417a36cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23fa2be7417a36cb$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $23fa2be7417a36cb$var$_react.default.createElement($23fa2be7417a36cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$23fa2be7417a36cb$var$ChartBubbleIcon.displayName = 'ChartBubbleIcon';
var $23fa2be7417a36cb$var$_default = module.exports.default = $23fa2be7417a36cb$var$ChartBubbleIcon;

});

parcelRegister("k2zyM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e96f93ff829ead8b$var$_react = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e96f93ff829ead8b$var$_baseNew = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("jcI35")));
function $e96f93ff829ead8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e96f93ff829ead8b$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $e96f93ff829ead8b$var$_react.default.createElement($e96f93ff829ead8b$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$e96f93ff829ead8b$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $e96f93ff829ead8b$var$_default = module.exports.default = $e96f93ff829ead8b$var$BrowserExtensionIcon;

});

parcelRegister("7JEHy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a1c4ed3f3b8d061$var$_react = $5a1c4ed3f3b8d061$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5a1c4ed3f3b8d061$var$_baseNew = $5a1c4ed3f3b8d061$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5a1c4ed3f3b8d061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a1c4ed3f3b8d061$var$GoalIcon = (props)=>/*#__PURE__*/ $5a1c4ed3f3b8d061$var$_react.default.createElement($5a1c4ed3f3b8d061$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$5a1c4ed3f3b8d061$var$GoalIcon.displayName = 'GoalIcon';
var $5a1c4ed3f3b8d061$var$_default = module.exports.default = $5a1c4ed3f3b8d061$var$GoalIcon;

});

parcelRegister("8BlKa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6432a540254daa54$var$_react = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6432a540254daa54$var$_baseNew = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6432a540254daa54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6432a540254daa54$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $6432a540254daa54$var$_react.default.createElement($6432a540254daa54$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$6432a540254daa54$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $6432a540254daa54$var$_default = module.exports.default = $6432a540254daa54$var$RoadmapsPlanIcon;

});

parcelRegister("bOuCy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $899c1ddf7bade55b$var$_react = $899c1ddf7bade55b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $899c1ddf7bade55b$var$_baseNew = $899c1ddf7bade55b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $899c1ddf7bade55b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $899c1ddf7bade55b$var$BugIcon = (props)=>/*#__PURE__*/ $899c1ddf7bade55b$var$_react.default.createElement($899c1ddf7bade55b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$899c1ddf7bade55b$var$BugIcon.displayName = 'BugIcon';
var $899c1ddf7bade55b$var$_default = module.exports.default = $899c1ddf7bade55b$var$BugIcon;

});

parcelRegister("2GO8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f5663fd08175dde$var$_react = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1f5663fd08175dde$var$_baseNew = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("jcI35")));
function $1f5663fd08175dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f5663fd08175dde$var$NotepadIcon = (props)=>/*#__PURE__*/ $1f5663fd08175dde$var$_react.default.createElement($1f5663fd08175dde$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$1f5663fd08175dde$var$NotepadIcon.displayName = 'NotepadIcon';
var $1f5663fd08175dde$var$_default = module.exports.default = $1f5663fd08175dde$var$NotepadIcon;

});

parcelRegister("6xXDI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c441650e47ff0d3$var$_react = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c441650e47ff0d3$var$_baseNew = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("jcI35")));
function $4c441650e47ff0d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c441650e47ff0d3$var$SyncIcon = (props)=>/*#__PURE__*/ $4c441650e47ff0d3$var$_react.default.createElement($4c441650e47ff0d3$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$4c441650e47ff0d3$var$SyncIcon.displayName = 'SyncIcon';
var $4c441650e47ff0d3$var$_default = module.exports.default = $4c441650e47ff0d3$var$SyncIcon;

});

parcelRegister("8cFW9", function(module, exports) {

var $bBiRC = parcelRequire("bBiRC");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bBiRC.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("044AT", function(module, exports) {

var $jM7lD = parcelRequire("jM7lD");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $00c3f019a8ea1fc2$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jM7lD(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $00c3f019a8ea1fc2$var$cloneTypedArray;

});
parcelRegister("jM7lD", function(module, exports) {

var $gEINE = parcelRequire("gEINE");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e658332d980af196$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $gEINE(result).set(new $gEINE(arrayBuffer));
    return result;
}
module.exports = $e658332d980af196$var$cloneArrayBuffer;

});


parcelRegister("64IpJ", function(module, exports) {

var $6DkQS = parcelRequire("6DkQS");

var $iiMec = parcelRequire("iiMec");

var $1b6pL = parcelRequire("1b6pL");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $46c5917dd804d4c7$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$1b6pL(object) ? $6DkQS($iiMec(object)) : {};
}
module.exports = $46c5917dd804d4c7$var$initCloneObject;

});
parcelRegister("6DkQS", function(module, exports) {

var $ih96c = parcelRequire("ih96c");
/** Built-in value references. */ var $4d468f5c997304ff$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $4d468f5c997304ff$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$ih96c(proto)) return {};
        if ($4d468f5c997304ff$var$objectCreate) return $4d468f5c997304ff$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $4d468f5c997304ff$var$baseCreate;

});

parcelRegister("iiMec", function(module, exports) {

var $a8tXu = parcelRequire("a8tXu");
/** Built-in value references. */ var $d52f5187398d5cf2$var$getPrototype = $a8tXu(Object.getPrototypeOf, Object);
module.exports = $d52f5187398d5cf2$var$getPrototype;

});


parcelRegister("6mx2n", function(module, exports) {

var $c5uls = parcelRequire("c5uls");

var $h6ZSp = parcelRequire("h6ZSp");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $4a1e6cacd7634ff8$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $h6ZSp(object, key, newValue);
        else $c5uls(object, key, newValue);
    }
    return object;
}
module.exports = $4a1e6cacd7634ff8$var$copyObject;

});

parcelRegister("58mMQ", function(module, exports) {

var $94SbA = parcelRequire("94SbA");

var $gRjiS = parcelRequire("gRjiS");

var $6PGLN = parcelRequire("6PGLN");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $3bcf6012be1fceb8$var$keysIn(object) {
    return $6PGLN(object) ? $94SbA(object, true) : $gRjiS(object);
}
module.exports = $3bcf6012be1fceb8$var$keysIn;

});
parcelRegister("gRjiS", function(module, exports) {

var $ih96c = parcelRequire("ih96c");

var $1b6pL = parcelRequire("1b6pL");

var $d8aqD = parcelRequire("d8aqD");
/** Used for built-in method references. */ var $c46091dcf5529043$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c46091dcf5529043$var$hasOwnProperty = $c46091dcf5529043$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c46091dcf5529043$var$baseKeysIn(object) {
    if (!$ih96c(object)) return $d8aqD(object);
    var isProto = $1b6pL(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$c46091dcf5529043$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $c46091dcf5529043$var$baseKeysIn;

});
parcelRegister("d8aqD", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $98f41c9e4a4b76be$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $98f41c9e4a4b76be$var$nativeKeysIn;

});



parcelRegister("hGxEi", function(module, exports) {

var $iCQu6 = parcelRequire("iCQu6");

var $24uwp = parcelRequire("24uwp");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ce0075e69d454d18$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ce0075e69d454d18$var$rsComboMarksRange = '\\u0300-\\u036f', $ce0075e69d454d18$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ce0075e69d454d18$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ce0075e69d454d18$var$rsComboRange = $ce0075e69d454d18$var$rsComboMarksRange + $ce0075e69d454d18$var$reComboHalfMarksRange + $ce0075e69d454d18$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ce0075e69d454d18$var$rsCombo = '[' + $ce0075e69d454d18$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ce0075e69d454d18$var$reComboMark = RegExp($ce0075e69d454d18$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ce0075e69d454d18$var$deburr(string) {
    string = $24uwp(string);
    return string && string.replace($ce0075e69d454d18$var$reLatin, $iCQu6).replace($ce0075e69d454d18$var$reComboMark, '');
}
module.exports = $ce0075e69d454d18$var$deburr;

});
parcelRegister("iCQu6", function(module, exports) {

var $6V9cT = parcelRequire("6V9cT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $037fd0776303ae37$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $037fd0776303ae37$var$deburrLetter = $6V9cT($037fd0776303ae37$var$deburredLetters);
module.exports = $037fd0776303ae37$var$deburrLetter;

});
parcelRegister("6V9cT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $509f35426b22b824$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $509f35426b22b824$var$basePropertyOf;

});



parcelRegister("KrnvM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7Y7ZZ"));

});
parcelRegister("7Y7ZZ", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $5cd4576c4e69a9a0$export$bf730a2d8bf68b42; }, function (v) { return $5cd4576c4e69a9a0$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5cd4576c4e69a9a0$export$bf730a2d8bf68b42;
'use strict';

var $1oC0p = parcelRequire("1oC0p");

var $ixLXc = parcelRequire("ixLXc");
function $5cd4576c4e69a9a0$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5cd4576c4e69a9a0$var$q = "function" === typeof Object.is ? Object.is : $5cd4576c4e69a9a0$var$p, $5cd4576c4e69a9a0$var$r = $ixLXc.useSyncExternalStore, $5cd4576c4e69a9a0$var$t = $1oC0p.useRef, $5cd4576c4e69a9a0$var$u = $1oC0p.useEffect, $5cd4576c4e69a9a0$var$v = $1oC0p.useMemo, $5cd4576c4e69a9a0$var$w = $1oC0p.useDebugValue;
$5cd4576c4e69a9a0$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $5cd4576c4e69a9a0$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $5cd4576c4e69a9a0$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($5cd4576c4e69a9a0$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $5cd4576c4e69a9a0$var$r(a, c[0], c[1]);
    $5cd4576c4e69a9a0$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $5cd4576c4e69a9a0$var$w(d);
    return d;
};

});


parcelRegister("lXgpb", function(module, exports) {

var $gHIMV = parcelRequire("gHIMV");

var $dNNx2 = parcelRequire("dNNx2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ffbbd5682208087f$var$camelCase = $dNNx2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $gHIMV(word) : word);
});
module.exports = $ffbbd5682208087f$var$camelCase;

});
parcelRegister("dNNx2", function(module, exports) {

var $5r99q = parcelRequire("5r99q");

var $hGxEi = parcelRequire("hGxEi");

var $cGaAm = parcelRequire("cGaAm");
/** Used to compose unicode capture groups. */ var $a0c645f3644bc61c$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $a0c645f3644bc61c$var$reApos = RegExp($a0c645f3644bc61c$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $a0c645f3644bc61c$var$createCompounder(callback) {
    return function(string) {
        return $5r99q($cGaAm($hGxEi(string).replace($a0c645f3644bc61c$var$reApos, '')), callback, '');
    };
}
module.exports = $a0c645f3644bc61c$var$createCompounder;

});
parcelRegister("5r99q", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3f56928ff1fa1456$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3f56928ff1fa1456$var$arrayReduce;

});

parcelRegister("cGaAm", function(module, exports) {

var $agIzJ = parcelRequire("agIzJ");

var $2fyoH = parcelRequire("2fyoH");

var $24uwp = parcelRequire("24uwp");

var $51QbK = parcelRequire("51QbK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $93b19e4fcd969484$var$words(string, pattern, guard) {
    string = $24uwp(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2fyoH(string) ? $51QbK(string) : $agIzJ(string);
    return string.match(pattern) || [];
}
module.exports = $93b19e4fcd969484$var$words;

});
parcelRegister("agIzJ", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $779df9bff564b02d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $779df9bff564b02d$var$asciiWords(string) {
    return string.match($779df9bff564b02d$var$reAsciiWord) || [];
}
module.exports = $779df9bff564b02d$var$asciiWords;

});

parcelRegister("2fyoH", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1a37aa184b5f841b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1a37aa184b5f841b$var$hasUnicodeWord(string) {
    return $1a37aa184b5f841b$var$reHasUnicodeWord.test(string);
}
module.exports = $1a37aa184b5f841b$var$hasUnicodeWord;

});

parcelRegister("51QbK", function(module, exports) {
/** Used to compose unicode character classes. */ var $3a9587500dbb7d28$var$rsAstralRange = '\\ud800-\\udfff', $3a9587500dbb7d28$var$rsComboMarksRange = '\\u0300-\\u036f', $3a9587500dbb7d28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3a9587500dbb7d28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3a9587500dbb7d28$var$rsComboRange = $3a9587500dbb7d28$var$rsComboMarksRange + $3a9587500dbb7d28$var$reComboHalfMarksRange + $3a9587500dbb7d28$var$rsComboSymbolsRange, $3a9587500dbb7d28$var$rsDingbatRange = '\\u2700-\\u27bf', $3a9587500dbb7d28$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3a9587500dbb7d28$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3a9587500dbb7d28$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3a9587500dbb7d28$var$rsPunctuationRange = '\\u2000-\\u206f', $3a9587500dbb7d28$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3a9587500dbb7d28$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3a9587500dbb7d28$var$rsVarRange = '\\ufe0e\\ufe0f', $3a9587500dbb7d28$var$rsBreakRange = $3a9587500dbb7d28$var$rsMathOpRange + $3a9587500dbb7d28$var$rsNonCharRange + $3a9587500dbb7d28$var$rsPunctuationRange + $3a9587500dbb7d28$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3a9587500dbb7d28$var$rsApos = "['\u2019]", $3a9587500dbb7d28$var$rsBreak = '[' + $3a9587500dbb7d28$var$rsBreakRange + ']', $3a9587500dbb7d28$var$rsCombo = '[' + $3a9587500dbb7d28$var$rsComboRange + ']', $3a9587500dbb7d28$var$rsDigits = '\\d+', $3a9587500dbb7d28$var$rsDingbat = '[' + $3a9587500dbb7d28$var$rsDingbatRange + ']', $3a9587500dbb7d28$var$rsLower = '[' + $3a9587500dbb7d28$var$rsLowerRange + ']', $3a9587500dbb7d28$var$rsMisc = '[^' + $3a9587500dbb7d28$var$rsAstralRange + $3a9587500dbb7d28$var$rsBreakRange + $3a9587500dbb7d28$var$rsDigits + $3a9587500dbb7d28$var$rsDingbatRange + $3a9587500dbb7d28$var$rsLowerRange + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3a9587500dbb7d28$var$rsModifier = '(?:' + $3a9587500dbb7d28$var$rsCombo + '|' + $3a9587500dbb7d28$var$rsFitz + ')', $3a9587500dbb7d28$var$rsNonAstral = '[^' + $3a9587500dbb7d28$var$rsAstralRange + ']', $3a9587500dbb7d28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3a9587500dbb7d28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3a9587500dbb7d28$var$rsUpper = '[' + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3a9587500dbb7d28$var$rsMiscLower = '(?:' + $3a9587500dbb7d28$var$rsLower + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsMiscUpper = '(?:' + $3a9587500dbb7d28$var$rsUpper + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsOptContrLower = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3a9587500dbb7d28$var$rsOptContrUpper = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3a9587500dbb7d28$var$reOptMod = $3a9587500dbb7d28$var$rsModifier + '?', $3a9587500dbb7d28$var$rsOptVar = '[' + $3a9587500dbb7d28$var$rsVarRange + ']?', $3a9587500dbb7d28$var$rsOptJoin = '(?:' + $3a9587500dbb7d28$var$rsZWJ + '(?:' + [
    $3a9587500dbb7d28$var$rsNonAstral,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + ')*', $3a9587500dbb7d28$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3a9587500dbb7d28$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3a9587500dbb7d28$var$rsSeq = $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + $3a9587500dbb7d28$var$rsOptJoin, $3a9587500dbb7d28$var$rsEmoji = '(?:' + [
    $3a9587500dbb7d28$var$rsDingbat,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsSeq;
/** Used to match complex or compound words. */ var $3a9587500dbb7d28$var$reUnicodeWord = RegExp([
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsMiscUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper + $3a9587500dbb7d28$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsMiscLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower,
    $3a9587500dbb7d28$var$rsUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper,
    $3a9587500dbb7d28$var$rsOrdUpper,
    $3a9587500dbb7d28$var$rsOrdLower,
    $3a9587500dbb7d28$var$rsDigits,
    $3a9587500dbb7d28$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3a9587500dbb7d28$var$unicodeWords(string) {
    return string.match($3a9587500dbb7d28$var$reUnicodeWord) || [];
}
module.exports = $3a9587500dbb7d28$var$unicodeWords;

});




parcelRegister("9qukn", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return (parcelRequire("grkXZ")).DropdownSelector; });

var $grkXZ = parcelRequire("grkXZ");

});
parcelRegister("grkXZ", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return $7df351058cf48215$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kKAAc = parcelRequire("kKAAc");
const $7df351058cf48215$var$dropdownSelectorContainerStyle = null;
const $7df351058cf48215$var$labelStyle = null;
const $7df351058cf48215$var$labelStyleSignup = null;
const $7df351058cf48215$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $1oC0p.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            (cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) === "signup" && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !(cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                    defaultValue: defaultValue || {
                        label: "Select...",
                        value: ""
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "");
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                appearance: "none",
                                flexDirection: "row",
                                fontSize: "1rem",
                                lineHeight: "1.2",
                                textAlign: "left"
                            }), (cssOverrides || {}).container),
                        // @ts-ignore
                        singleValue: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).singleValue),
                        // @ts-ignore
                        placeholder: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).placeholder),
                        // @ts-ignore
                        valueContainer: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).valueContainer),
                        // @ts-ignore
                        menu: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: "0px 3px 5px 0px #091E4233",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: "#ffffff",
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)"
                            }), (cssOverrides || {}).menu),
                        // @ts-ignore
                        control: (provided, state)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                "cursor": "pointer",
                                "backgroundColor": isMenuOpen ? "#253858" : "#FAFBFC",
                                "color": isMenuOpen ? "#ffffff" : "#172B4D",
                                "height": "2.65rem",
                                "border": state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                "borderRadius": "var(--ds-space-050, 4px)",
                                "&:hover": {
                                    background: isMenuOpen ? undefined : "#F4F5F7"
                                }
                            }), (cssOverrides || {}).control),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                transition: "all .2s ease",
                                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined
                            }), (cssOverrides || {}).dropdownIndicator),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).indicatorsContainer),
                        // @ts-ignore
                        option: (provided, state)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                "cursor": "pointer",
                                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                "whiteSpace": "pre-wrap",
                                "overflowWrap": "break-word",
                                "backgroundColor": state.isSelected ? "#B2D4FF" : state.isFocused ? "#EBECF0" : "#FAFBFC",
                                "color": state.isSelected ? "#0065FF" : "#172B4D",
                                "&:hover": {
                                    background: state.isSelected ? "#B2D4FF" : "#EBECF0"
                                },
                                "&:active": {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: "#DFE1E5"
                                }
                            }), (cssOverrides || {}).option),
                        // @ts-ignore
                        input: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                color: "transparent"
                            }), (cssOverrides || {}).input)
                    }
                })
            })
        ]
    });
};

});


parcelRegister("gNuc8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3a8a4fb00075491$var$_react = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c3a8a4fb00075491$var$_baseNew = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c3a8a4fb00075491$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3a8a4fb00075491$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $c3a8a4fb00075491$var$_react.default.createElement($c3a8a4fb00075491$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$c3a8a4fb00075491$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $c3a8a4fb00075491$var$_default = module.exports.default = $c3a8a4fb00075491$var$ChartTrendIcon;

});

parcelRegister("7Xpzl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb1e08dc9ec04f5$var$_react = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5cb1e08dc9ec04f5$var$_baseNew = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5cb1e08dc9ec04f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb1e08dc9ec04f5$var$InformationIcon = (props)=>/*#__PURE__*/ $5cb1e08dc9ec04f5$var$_react.default.createElement($5cb1e08dc9ec04f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5cb1e08dc9ec04f5$var$InformationIcon.displayName = 'InformationIcon';
var $5cb1e08dc9ec04f5$var$_default = module.exports.default = $5cb1e08dc9ec04f5$var$InformationIcon;

});

parcelRegister("iMdbU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dab6f123f69f6bcc$var$_react = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dab6f123f69f6bcc$var$_baseNew = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $dab6f123f69f6bcc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dab6f123f69f6bcc$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $dab6f123f69f6bcc$var$_react.default.createElement($dab6f123f69f6bcc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$dab6f123f69f6bcc$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $dab6f123f69f6bcc$var$_default = module.exports.default = $dab6f123f69f6bcc$var$PersonAddedIcon;

});

parcelRegister("7pQ29", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56633b0430bc4d64$var$_react = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56633b0430bc4d64$var$_baseNew = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56633b0430bc4d64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56633b0430bc4d64$var$PhoneIcon = (props)=>/*#__PURE__*/ $56633b0430bc4d64$var$_react.default.createElement($56633b0430bc4d64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$56633b0430bc4d64$var$PhoneIcon.displayName = 'PhoneIcon';
var $56633b0430bc4d64$var$_default = module.exports.default = $56633b0430bc4d64$var$PhoneIcon;

});

parcelRegister("l6HGO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5dc0c5d851b1603$var$_react = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5dc0c5d851b1603$var$_baseNew = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f5dc0c5d851b1603$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5dc0c5d851b1603$var$StarStarredIcon = (props)=>/*#__PURE__*/ $f5dc0c5d851b1603$var$_react.default.createElement($f5dc0c5d851b1603$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$f5dc0c5d851b1603$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $f5dc0c5d851b1603$var$_default = module.exports.default = $f5dc0c5d851b1603$var$StarStarredIcon;

});

parcelRegister("kHMU7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12dc2233694369e$var$_react = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f12dc2233694369e$var$_baseNew = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f12dc2233694369e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12dc2233694369e$var$WarningIcon = (props)=>/*#__PURE__*/ $f12dc2233694369e$var$_react.default.createElement($f12dc2233694369e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$f12dc2233694369e$var$WarningIcon.displayName = 'WarningIcon';
var $f12dc2233694369e$var$_default = module.exports.default = $f12dc2233694369e$var$WarningIcon;

});

parcelRegister("f11bi", function(module, exports) {
$parcel$export(module.exports, "FeaturedInfoCard", function () { return $868863b8ca40ac22$export$d26c611c5262ca6a; });
/* featured-info-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $imIsw = parcelRequire("imIsw");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");
const $868863b8ca40ac22$var$containerStyles = null;
const $868863b8ca40ac22$var$cardStyles = null;
const $868863b8ca40ac22$var$cardBodyStyles = null;
const $868863b8ca40ac22$var$ctaStyles = null;
const $868863b8ca40ac22$var$renderCta = ({ ctaProps: ctaProps })=>{
    if ("button" in ctaProps && ctaProps.button !== undefined) // Button + optional Link case
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bah1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), (0, $dPABA._)((0, $6ogO3._)({}, ctaProps.button), {
                children: ctaProps.buttonText
            })),
            "link" in ctaProps && ctaProps.link && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), (0, $6ogO3._)({}, ctaProps.link))
        ]
    });
    // Link only case
    if ("link" in ctaProps && ctaProps.link !== undefined) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bah1y6m"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), (0, $6ogO3._)({}, ctaProps.link))
    });
    return null;
};
const $868863b8ca40ac22$export$d26c611c5262ca6a = ({ Icon: Icon, title: title, body: body, iconSize: iconSize = "24", image: image, video: video, ctaProps: ctaProps })=>{
    var _video_captions, _video_captions1, _video_captions2;
    var _video_controls, _video_preload;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_7cca15wb _1bsb1osq _4t3i1osq _gm59vrvc _o4yy1fhb _1bjp1ohn _5olw1ohn _13ndkb7n _5gu2kb7n _1g3pf1ug _7u5mf1ug _q8sr1wug _kw8y1wug _1cb1qfx8 _1ndykb7n _1ofjf1ug _sv321h6o",
            "featured-info-card"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1y6m _1o9zidpf _2rkou2gc _1bsb1osq _4t3i1osq _1reozryt _18m9zryt _11q7cd5j _1i4oidpf _eytuidpf _1q3x1osq _1fj51wug _ufqd1ule _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf _1axi10nf _zcqx10nf"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                video ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "video",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                        src: video.src,
                        poster: video.poster,
                        autoPlay: video.autoplay,
                        muted: video.muted,
                        loop: video.loop,
                        controls: (_video_controls = video.controls) !== null && _video_controls !== void 0 ? _video_controls : true,
                        width: video.width,
                        height: video.height,
                        preload: (_video_preload = video.preload) !== null && _video_preload !== void 0 ? _video_preload : "metadata",
                        "aria-label": video.alt || title,
                        style: video.width && video.height ? {
                            aspectRatio: `${video.width}/${video.height}`
                        } : undefined,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                            kind: "captions",
                            src: ((_video_captions = video.captions) === null || _video_captions === void 0 ? void 0 : _video_captions.src) || "",
                            srcLang: ((_video_captions1 = video.captions) === null || _video_captions1 === void 0 ? void 0 : _video_captions1.srclang) || "en",
                            label: ((_video_captions2 = video.captions) === null || _video_captions2 === void 0 ? void 0 : _video_captions2.label) || "Captions",
                            default: true
                        })
                    })
                }) : image ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "image",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), (0, $6ogO3._)({}, image))
                }) : null,
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1yt4xy5q _4cvr1y6m _zulp19bv _1o9zidpf _2rkou2gc _11q7cd5j _1x1tidpf _clfdidpf _s9kqidpf _11pqidpf _4wztidpf _q0a5idpf _98csidpf _c3k8idpf _1axi10nf _zcqx10nf _zcqx1k8s",
                        "body"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: [
                        Icon && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)(Icon, {
                                size: iconSize
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: "h4",
                            children: title
                        }),
                        body && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: body
                        }),
                        ctaProps && $868863b8ca40ac22$var$renderCta({
                            ctaProps: ctaProps
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("ahPqL", function(module, exports) {
$parcel$export(module.exports, "AirCanadaLogo", function () { return (parcelRequire("76f4d")).AirCanadaLogo; });
$parcel$export(module.exports, "CanvaLogo", function () { return (parcelRequire("1yAvB")).CanvaLogo; });
$parcel$export(module.exports, "DominosLogo", function () { return (parcelRequire("abXwn")).DominosLogo; });
$parcel$export(module.exports, "FordLogo", function () { return (parcelRequire("hI0HU")).FordLogo; });
$parcel$export(module.exports, "NasaLogo", function () { return (parcelRequire("bynL4")).NasaLogo; });
$parcel$export(module.exports, "VisaLogo", function () { return (parcelRequire("38U9C")).VisaLogo; });
$parcel$export(module.exports, "ArrowRight", function () { return (parcelRequire("9MZ6h")).ArrowRight; });
$parcel$export(module.exports, "getAiImage", function () { return (parcelRequire("iNnWi")).getAiImage; });
$parcel$export(module.exports, "getAiImageJSM", function () { return (parcelRequire("iNnWi")).getAiImageJSM; });
$parcel$export(module.exports, "getAiVideo", function () { return (parcelRequire("iNnWi")).getAiVideo; });
$parcel$export(module.exports, "getAiVideoJSM", function () { return (parcelRequire("iNnWi")).getAiVideoJSM; });
$parcel$export(module.exports, "getCollaborateFirstImage", function () { return (parcelRequire("iNnWi")).getCollaborateFirstImage; });
$parcel$export(module.exports, "getCollaborateFourthImage", function () { return (parcelRequire("iNnWi")).getCollaborateFourthImage; });
$parcel$export(module.exports, "getCollaborateSecondImage", function () { return (parcelRequire("iNnWi")).getCollaborateSecondImage; });
$parcel$export(module.exports, "getCollaborateThirdImage", function () { return (parcelRequire("iNnWi")).getCollaborateThirdImage; });
$parcel$export(module.exports, "getDoubleFeatureFirstImage", function () { return (parcelRequire("iNnWi")).getDoubleFeatureFirstImage; });
$parcel$export(module.exports, "getDoubleFeatureSecondImage", function () { return (parcelRequire("iNnWi")).getDoubleFeatureSecondImage; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureFirstImage", function () { return (parcelRequire("iNnWi")).getStaggeredDoubleFeautureFirstImage; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureSecondImage", function () { return (parcelRequire("iNnWi")).getStaggeredDoubleFeautureSecondImage; });
parcelRequire("76f4d");
parcelRequire("1yAvB");
parcelRequire("abXwn");
parcelRequire("hI0HU");
parcelRequire("bynL4");
parcelRequire("38U9C");
parcelRequire("9MZ6h");
parcelRequire("iNnWi");

});
parcelRegister("76f4d", function(module, exports) {
$parcel$export(module.exports, "AirCanadaLogo", function () { return $c116e0278aa92ff1$export$ea8385ffd753ff4e; });

var $7VQPk = parcelRequire("7VQPk");
const $c116e0278aa92ff1$export$ea8385ffd753ff4e = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "185",
        height: "24",
        viewBox: "0 0 185 24",
        fill: "currentColor",
        role: "img",
        "aria-label": "Air Canada",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.8603 17.077C12.8603 16.2693 13.2065 16.1539 14.0142 16.6154C15.3988 17.4231 16.7834 18.1154 16.7834 18.1154C16.7834 17.6539 17.2449 17.3077 18.0526 17.5385C18.8603 17.7693 19.668 17.8847 19.668 17.8847C19.668 17.8847 19.2065 16.8462 18.9757 16.3847C18.6295 15.577 18.9757 15.1154 19.3218 15C19.3218 15 18.8603 14.6539 18.5141 14.4231C17.8218 13.9616 17.9372 13.3847 18.6295 13.1539C19.5526 12.6924 20.8218 12.2308 20.8218 12.2308C20.4757 12.0001 20.0142 11.4231 20.4757 10.6154C20.9372 9.92312 21.7449 8.88466 21.7449 8.88466H19.5526C18.7449 8.88466 18.5141 8.19234 18.5141 7.73081C18.5141 7.73081 17.2449 8.6539 16.3218 9.23083C15.5142 9.80775 14.8218 9.23083 14.9372 8.30774C15.168 6.92313 15.2834 5.30775 15.2834 5.30775C14.8219 5.76928 14.0141 5.65391 13.5526 4.96159C12.9757 3.80774 12.3988 2.42312 12.3988 2.42312C12.3988 2.42312 11.8218 3.80774 11.2449 4.96159C10.8987 5.65391 10.0911 5.76928 9.62953 5.42312C9.62953 5.42312 9.74493 7.03849 9.97569 8.42311C10.0911 9.2308 9.39877 9.80772 8.59108 9.2308C7.66799 8.65387 6.28338 7.73079 6.28338 7.73079C6.28338 8.19232 6.05261 8.76924 5.24492 8.88464H3.05262C3.05262 8.88464 3.86031 9.92309 4.32184 10.6154C4.78337 11.3077 4.32184 12 3.97568 12.2308C3.97568 12.2308 5.12953 12.8077 6.16798 13.1539C6.8603 13.5 7.09107 13.9616 6.28338 14.4231C6.05261 14.6539 5.47569 15 5.47569 15C5.93722 15.1154 6.28338 15.5769 5.93722 16.3846C5.70645 16.8462 5.2449 17.8846 5.2449 17.8846C5.2449 17.8846 6.05259 17.6539 6.86028 17.5385C7.66797 17.3077 8.01413 17.7692 8.1295 18.1154C8.1295 18.1154 9.51411 17.3077 10.8987 16.6154C11.591 16.1539 12.0526 16.3846 12.0526 17.0769V19.0385C12.0526 20.1923 11.8218 21.3462 11.4756 22.0385C6.28335 21.4615 1.89872 17.3077 1.89872 11.7692C1.89872 6.11538 6.62948 1.50001 12.5141 1.50001C18.3987 1.50001 23.1295 6.11541 23.1295 11.7692C23.1295 17.0769 18.9756 21.4615 13.668 22.0385V23.4231C19.8987 22.8461 24.7449 17.8846 24.7449 11.7692C24.7449 5.1923 19.2064 0 12.3987 0C5.70643 0 0.167969 5.1923 0.167969 11.6538C0.167969 17.3077 4.43721 22.0385 10.0911 23.0769C11.0141 23.3077 11.5911 23.4231 12.168 24C12.7449 22.8461 12.8603 20.5384 12.8603 19.2692V17.077Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M62.3613 17.8843V5.42273H68.4767C71.7075 5.42273 73.2075 6.80734 73.3229 8.53812C73.3229 9.34581 73.2075 10.1535 72.6306 10.7304C72.0537 11.3073 71.8229 11.5381 70.7844 12.115L75.3998 17.9997H72.0537L67.8998 12.692H65.1306V17.8843L62.3613 17.8843ZM65.1306 11.0766H66.3998C69.7459 11.0766 70.4383 10.4997 70.4383 8.88428C70.4383 7.2689 68.9382 7.03814 66.7459 7.03814H65.1306V11.0766Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M35.0156 17.8843L40.4387 5.42273H43.7849L49.208 17.8843H45.8618L44.3618 14.5381H38.5926L37.0926 17.8843H35.0156ZM39.2849 12.9228H43.5541L41.3618 7.96122L39.2849 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M55.9002 5.42273H53.0156V17.8843H55.9002V5.42273Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M96.1674 17.4227C94.7827 17.9997 93.052 18.2304 90.9751 18.2304C88.552 18.2304 86.5904 17.6535 85.2058 16.4996C83.8213 15.3458 83.1289 13.7304 83.1289 11.6535C83.1289 9.57654 83.8212 7.84579 85.2058 6.80731C86.5905 5.65346 88.552 5.07654 91.2058 5.07654C92.8212 5.07654 94.4366 5.19193 96.1674 5.53807V7.615C94.3212 7.03808 92.5904 6.80731 91.3212 6.80731C89.7058 6.80731 88.552 7.26884 87.6289 8.07653C86.8212 8.88422 86.3597 10.1535 86.3597 11.6535C86.3597 13.1534 86.8212 14.3073 87.7443 15.2304C88.6674 16.0381 89.9366 16.4996 91.552 16.4996C93.052 16.4996 94.6674 16.1534 96.1674 15.5765L96.1674 17.4227Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M99.7461 17.8843L105.169 5.42273H108.515L113.938 17.8843H110.592L109.092 14.5381H103.323L101.823 17.8843H99.7461ZM104.131 12.9228H108.4L106.323 7.96122L104.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M135.861 17.8843L141.284 5.42273H144.631L150.054 17.8843H146.708L145.207 14.5381H139.438L137.938 17.8843H135.861ZM140.131 12.9228H144.4L142.207 7.96122L140.131 12.9228Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M176.477 7.96119L178.669 12.9227H174.4L176.477 7.96119ZM175.554 5.42273L170.131 17.8843H172.208L173.708 14.5381H179.477L180.977 17.8843H184.323L178.9 5.42273H175.554Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M118.092 17.8843V5.42273H121.438L129.284 14.3074V5.42273H131.707V17.8843H128.592L120.515 8.53812V17.8843H118.092Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M154.092 17.8843V5.42273H160.092C162.284 5.42273 163.9 5.99965 165.053 6.92274C166.207 7.96119 166.784 9.46121 166.784 11.3074C166.784 13.3843 166.207 14.9997 164.938 16.0381C163.669 17.192 162.053 17.7689 159.861 17.7689H154.092L154.092 17.8843ZM156.976 16.1535H159.169C160.669 16.1535 161.823 15.8074 162.63 14.9997C163.438 14.192 163.784 13.1535 163.784 11.5381C163.784 10.3843 163.438 9.34581 162.861 8.53812C162.4 7.96119 161.938 7.61503 161.361 7.38427C160.784 7.1535 159.976 7.03811 158.823 7.03811H157.092V16.1535H156.976Z"
            })
        ]
    });

});

parcelRegister("1yAvB", function(module, exports) {
$parcel$export(module.exports, "CanvaLogo", function () { return $627549377313d3c5$export$41d9e6d43cf45e91; });

var $7VQPk = parcelRequire("7VQPk");
const $627549377313d3c5$export$41d9e6d43cf45e91 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "73",
        height: "73",
        viewBox: "0 0 73 73",
        fill: "currentColor",
        role: "img",
        "aria-label": "Canva",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M51.3643 35.0746C50.9233 35.0746 50.7793 35.6686 50.7793 36.1096C50.8126 36.9942 51.1568 37.8387 51.7513 38.4946C51.9811 37.9215 52.106 37.3118 52.1203 36.6946C52.1023 35.5966 51.6613 35.0746 51.3643 35.0746Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M36.4512 0.69458C29.3311 0.69458 22.3708 2.80594 16.4507 6.76167C10.5305 10.7174 5.91628 16.3398 3.19152 22.918C0.46677 29.4961 -0.24615 36.7345 1.14292 43.7178C2.53199 50.7011 5.96065 57.1157 10.9953 62.1504C16.03 67.1851 22.4446 70.6138 29.4279 72.0029C36.4113 73.3919 43.6497 72.679 50.2278 69.9542C56.8059 67.2295 62.4284 62.6153 66.3841 56.6951C70.3398 50.7749 72.4512 43.8147 72.4512 36.6946C72.4512 27.1468 68.6583 17.99 61.907 11.2387C55.1557 4.48743 45.999 0.69458 36.4512 0.69458ZM62.3892 46.4686C62.2848 46.4807 62.1794 46.4552 62.0922 46.3966C61.4858 46.201 60.9422 45.848 60.5169 45.3737C60.0915 44.8993 59.7997 44.3206 59.6712 43.6966C59.4147 44.0614 59.0735 44.3584 58.6769 44.5622C58.2803 44.766 57.8401 44.8705 57.3942 44.8666C56.6375 44.8137 55.9229 44.4992 55.3728 43.977C54.8226 43.4548 54.4714 42.7575 54.3792 42.0046C54.3079 41.31 54.3815 40.6083 54.5952 39.9436C54.0646 40.309 53.4392 40.5123 52.7952 40.5286H52.2822C51.2379 42.1236 49.8891 43.4968 48.3132 44.5696C47.9532 44.7729 47.5547 44.8986 47.1432 44.9386C47.0175 44.945 46.8921 44.9223 46.7766 44.8724C46.6611 44.8224 46.5586 44.7465 46.4772 44.6506C46.2312 44.3978 46.0396 44.0972 45.9143 43.7675C45.7889 43.4378 45.7324 43.086 45.7482 42.7336C44.5868 44.0553 42.9904 44.9174 41.2482 45.1636C41.0186 45.172 40.7896 45.1348 40.5745 45.054C40.3593 44.9733 40.1624 44.8507 39.9949 44.6934C39.8275 44.536 39.693 44.347 39.5992 44.1373C39.5053 43.9275 39.454 43.7013 39.4482 43.4716C39.4004 43.0775 39.4248 42.6779 39.5202 42.2926C39.8189 40.8972 40.2098 39.5232 40.6902 38.1796C40.6902 38.0356 40.6182 37.9636 40.5462 37.9636C39.8172 37.9636 37.3152 40.5286 36.9462 42.2206L36.6492 43.6156C36.5554 44.0328 36.3297 44.4087 36.0055 44.6876C35.6812 44.9664 35.2758 45.1333 34.8492 45.1636C34.7031 45.1712 34.5598 45.1221 34.4491 45.0265C34.3384 44.9309 34.2689 44.7962 34.2552 44.6506V44.2096L34.4082 43.4716C33.4455 44.2995 32.2918 44.8748 31.0512 45.1456C30.6669 45.1923 30.2794 45.0879 29.9705 44.8546C29.6616 44.6212 29.4553 44.277 29.3952 43.8946C29.145 44.2716 28.8072 44.5824 28.4106 44.8003C28.0141 45.0181 27.5706 45.1366 27.1182 45.1456C26.5535 45.121 26.0067 44.9396 25.5394 44.6216C25.072 44.3037 24.7024 43.8618 24.4722 43.3456C23.6937 44.2137 22.8075 44.9789 21.8352 45.6226C20.3011 46.7055 18.4907 47.3298 16.6152 47.4226C15.018 47.3779 13.4957 46.7355 12.3492 45.6226C11.105 44.3767 10.3293 42.7394 10.1532 40.9876C9.45119 35.7946 12.6462 28.9816 17.5512 26.0386C18.6183 25.3792 19.843 25.0187 21.0972 24.9946C22.1451 24.9667 23.1666 25.3257 23.9667 26.003C24.7669 26.6803 25.2896 27.6284 25.4352 28.6666C25.5805 29.5671 25.4134 30.4903 24.9615 31.2827C24.5096 32.0751 23.8002 32.6891 22.9512 33.0226C21.9252 33.5356 21.4122 33.5356 21.2592 33.2386C21.2132 33.1384 21.2033 33.0254 21.2311 32.9187C21.259 32.8121 21.323 32.7184 21.4122 32.6536C23.3202 31.1146 23.3202 29.7916 23.0952 27.9556C23.094 27.4674 22.9074 26.998 22.5733 26.6421C22.2391 26.2862 21.7823 26.0705 21.2952 26.0386C17.4792 26.0386 12.1872 34.3456 12.9252 40.3666C13.2132 42.7156 14.7252 45.4336 17.6232 45.4336C18.6458 45.4096 19.6506 45.1607 20.5662 44.7046C21.9121 44.1221 23.0998 43.2274 24.0312 42.0946C23.8152 39.3046 26.2362 35.7946 29.7642 35.7946C31.3122 35.7946 32.5542 36.3796 32.7072 37.5946C32.7491 37.8246 32.7377 38.0613 32.674 38.2862C32.6102 38.5112 32.4957 38.7186 32.3392 38.8924C32.1828 39.0662 31.9886 39.2019 31.7715 39.2889C31.5545 39.376 31.3204 39.4121 31.0872 39.3946C30.6462 39.3946 29.9892 39.2506 29.9082 38.8816C29.8272 38.5126 30.8712 38.6656 30.7182 37.7026C30.6462 37.1176 29.9892 36.9016 29.3952 36.9016C27.1902 36.9016 25.9482 39.9886 26.1642 41.8966C26.2362 42.7966 26.7492 43.6966 27.4872 43.6966C28.2252 43.6966 29.1072 42.7426 29.3952 41.4196C29.4903 41.003 29.7164 40.6279 30.0403 40.3492C30.3643 40.0706 30.7691 39.9032 31.1952 39.8716C31.5642 39.8716 31.7892 40.0246 31.7892 40.3846V40.8256C31.7082 41.1946 31.4202 42.6256 31.4202 42.8146C31.4177 42.8921 31.4311 42.9693 31.4596 43.0414C31.4881 43.1135 31.5311 43.179 31.586 43.2338C31.6408 43.2886 31.7063 43.3316 31.7784 43.3601C31.8505 43.3887 31.9277 43.4021 32.0052 43.3996C33.0226 43.0491 33.9462 42.4703 34.7052 41.7076C35.0742 39.9076 35.5152 37.5946 35.5152 37.4506C35.5289 37.2199 35.5905 36.9945 35.696 36.7889C35.8016 36.5833 35.9488 36.402 36.1282 36.2563C36.3077 36.1107 36.5155 36.0041 36.7385 35.9432C36.9614 35.8823 37.1946 35.8684 37.4232 35.9026C37.5698 35.8952 37.7133 35.9458 37.8228 36.0435C37.9323 36.1412 37.9989 36.2781 38.0082 36.4246V36.8566L37.6482 38.8456C38.9712 37.0456 41.0232 35.7586 42.2742 35.7586C42.5153 35.7419 42.754 35.8156 42.9437 35.9654C43.1334 36.1151 43.2605 36.3302 43.3002 36.5686C43.3143 37.0429 43.2411 37.5158 43.0842 37.9636C42.5581 39.4664 42.1459 41.0068 41.8512 42.5716C41.819 42.6702 41.8121 42.7752 41.831 42.8772C41.8498 42.9792 41.894 43.0748 41.9593 43.1554C42.0246 43.2359 42.1091 43.2988 42.205 43.3383C42.3008 43.3778 42.4051 43.3927 42.5082 43.3816C43.183 43.2388 43.8229 42.9641 44.3913 42.5734C44.9596 42.1826 45.4452 41.6835 45.8202 41.1046V40.3666C45.764 39.3003 45.8888 38.2322 46.1892 37.2076C46.3356 36.8008 46.591 36.4421 46.9275 36.1707C47.264 35.8992 47.6686 35.7255 48.0972 35.6686C48.1761 35.66 48.2559 35.6693 48.3308 35.6957C48.4056 35.7221 48.4736 35.7649 48.5297 35.821C48.5859 35.8772 48.6287 35.9451 48.6551 36.02C48.6815 36.0949 48.6907 36.1747 48.6822 36.2536C48.6934 36.4042 48.6688 36.5554 48.6102 36.6946C48.1656 37.948 47.9166 39.2624 47.8722 40.5916C47.8865 41.3998 47.9799 42.2046 48.1512 42.9946C48.1469 43.0243 48.1495 43.0547 48.1587 43.0833C48.1679 43.1119 48.1835 43.138 48.2044 43.1597C48.2252 43.1814 48.2507 43.1981 48.2789 43.2084C48.3071 43.2188 48.3373 43.2226 48.3672 43.2196C49.4848 42.374 50.4059 41.2962 51.0672 40.0606C50.5825 39.7281 50.1924 39.2755 49.9352 38.747C49.6781 38.2184 49.5626 37.6322 49.6002 37.0456C49.6002 34.8406 50.9232 33.6616 52.2462 33.6616C52.522 33.6642 52.794 33.7254 53.0443 33.8413C53.2946 33.9571 53.5174 34.1249 53.6979 34.3335C53.8783 34.542 54.0123 34.7866 54.091 35.0509C54.1697 35.3152 54.1912 35.5933 54.1542 35.8666C54.09 36.9274 53.782 37.9591 53.2542 38.8816H53.5512C53.8931 38.8929 54.2332 38.8258 54.5452 38.6854C54.8572 38.545 55.1329 38.335 55.3512 38.0716C55.4796 37.928 55.6282 37.8037 55.7922 37.7026C56.3143 37.051 56.9738 36.5227 57.7237 36.1556C58.4736 35.7884 59.2953 35.5914 60.1302 35.5786C61.6692 35.5786 62.9202 36.1636 63.0642 37.3786C63.105 37.6131 63.0938 37.8537 63.0316 38.0835C62.9693 38.3133 62.8575 38.5266 62.7039 38.7085C62.5504 38.8904 62.3588 39.0364 62.1427 39.1363C61.9266 39.2362 61.6912 39.2875 61.4532 39.2866C61.0122 39.2866 60.2742 39.1426 60.2742 38.7736C60.2742 38.4046 61.2282 38.5486 61.1742 37.5946C61.1022 37.0096 60.4362 36.6946 59.8512 36.6946C57.7902 36.6946 56.3952 39.3946 56.6202 41.6896C56.6922 42.5896 57.1332 43.4896 57.9432 43.4896C58.6002 43.4896 59.5542 42.5356 59.9232 41.2126C60.0332 40.8046 60.2639 40.4393 60.5851 40.1647C60.9063 39.89 61.303 39.7189 61.7232 39.6736C61.7963 39.6632 61.8709 39.6688 61.9417 39.6899C62.0125 39.7109 62.0779 39.7471 62.1334 39.7958C62.189 39.8445 62.2334 39.9046 62.2635 39.9721C62.2937 40.0395 62.3089 40.1127 62.3082 40.1866C62.2297 40.8778 62.1064 41.5633 61.9392 42.2386C61.8296 42.747 61.7812 43.2667 61.7952 43.7866C61.8989 44.4661 62.2138 45.0959 62.6952 45.5866C62.8071 45.6829 62.8859 45.812 62.9202 45.9556C62.9365 46.0279 62.934 46.1033 62.9127 46.1744C62.8915 46.2455 62.8523 46.3099 62.799 46.3614C62.7456 46.413 62.6799 46.4499 62.6081 46.4687C62.5363 46.4874 62.4609 46.4874 62.3892 46.4686Z"
            })
        ]
    });

});

parcelRegister("abXwn", function(module, exports) {
$parcel$export(module.exports, "DominosLogo", function () { return $3dcbc0b04b75e475$export$3a87515d6bae358a; });

var $7VQPk = parcelRequire("7VQPk");
const $3dcbc0b04b75e475$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "149",
        height: "33",
        viewBox: "0 0 149 33",
        fill: "currentColor",
        role: "img",
        "aria-label": "Domino\u2019s",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M85.1443 21.4717C83.5509 17.7341 78.0566 18.8925 76.5524 21.2925V19.4237H71.7656V32.6781H76.7245V26.0093C76.7245 23.5197 77.2535 23.3405 78.5856 23.2509C79.9114 23.1613 80.4468 23.3405 80.4468 26.0093L80.536 32.6781H85.3228V25.8301C85.3228 24.5821 85.5905 23.4301 86.9162 23.4301C88.5097 23.3405 88.8666 23.5197 88.8666 25.4781V32.7741H93.9147V22.8925C94.004 18.1821 87.3624 18.0925 85.1443 21.4717Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M63.1736 18.4457C59.2729 18.4457 56.0859 21.6457 56.0859 25.5625C56.0859 29.4793 59.2729 32.6793 63.1736 32.6793C67.0744 32.6793 70.2614 29.4793 70.2614 25.5625C70.2614 21.6457 67.0744 18.4457 63.1736 18.4457ZM63.1736 28.0521C61.7587 28.0521 60.6942 26.8937 60.6942 25.5625C60.6942 24.1417 61.8479 23.0729 63.1736 23.0729C64.4994 23.0729 65.6531 24.2313 65.6531 25.5625C65.6594 26.9001 64.5058 28.0521 63.1736 28.0521Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M49.7117 15.1528C48.7365 14.7112 47.7613 14.3528 46.6969 14.2632C45.1927 14.084 43.6821 13.9944 42.1778 13.9944H36.6836V32.676H41.7317C43.4144 32.676 45.0971 32.5864 46.6905 32.4072C47.755 32.228 48.8194 31.9656 49.7882 31.5176C51.2924 30.7176 52.6246 29.5592 53.5998 28.1384C55.3717 25.2008 55.3717 21.4696 53.5998 18.532C52.6373 17.1112 51.3052 15.9528 49.7117 15.1528ZM49.0935 25.5592C48.7365 26.18 48.2075 26.8072 47.5 27.1592C47.1431 27.3384 46.7033 27.5176 46.2571 27.6008C45.5496 27.6904 44.9313 27.78 44.2175 27.6904H42.1778V18.8904H44.4788C45.0971 18.8904 45.7217 18.8904 46.34 18.98C46.7798 19.0696 47.2259 19.1592 47.5829 19.4216C48.2011 19.78 48.7365 20.3112 49.1763 21.0216C49.5333 21.732 49.7053 22.532 49.7053 23.2424C49.6225 24.0488 49.444 24.8488 49.0935 25.5592Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M101.002 19.1608H96.043V32.5944H101.002V19.1608Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M136.701 16.4923C136.88 15.6923 136.88 14.8027 136.523 14.0923C136.083 13.1131 135.108 12.4923 134.044 12.4923C132.801 12.4027 131.653 13.2923 131.386 14.4507C131.029 15.8715 131.825 17.2987 133.247 17.7403C133.604 17.8299 133.954 17.7403 133.687 18.1819C133.419 18.5403 133.068 18.8923 132.711 19.1611L133.24 19.9611C135.376 18.8027 136.44 17.6443 136.701 16.4923Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M125.541 18.4457C121.64 18.4457 118.453 21.6457 118.453 25.5625C118.453 29.4793 121.64 32.6793 125.541 32.6793C129.442 32.6793 132.629 29.4793 132.629 25.5625C132.629 21.6457 129.442 18.4457 125.541 18.4457ZM125.541 28.0521C124.126 28.0521 123.061 26.8937 123.061 25.5625C123.061 24.2313 124.215 23.0729 125.541 23.0729C126.867 23.0729 128.02 24.2313 128.02 25.5625C128.02 26.9001 126.956 28.0521 125.541 28.0521Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M142.286 23.6923C139.807 23.6923 139.985 22.0027 141.49 21.9131C143.083 21.8235 144.677 22.2715 145.919 23.2443L147.513 20.1339C143.172 17.5547 135.817 17.9131 135.645 22.6235C135.556 25.2923 137.595 26.6235 141.757 27.0715C144.772 27.4299 143.886 28.7611 142.197 28.9403C140.514 29.1195 138.921 28.3195 137.238 27.3403L135.109 30.5403C140.954 34.2779 147.774 32.5883 148.042 28.2299C148.31 25.6507 146.27 23.6027 142.286 23.6923Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M108.089 21.2934V19.4246H103.303V32.679H108.089V26.0102C108.089 23.7894 109.065 23.3414 110.129 23.2518C111.455 23.0726 112.43 23.3414 112.43 26.0102L112.519 32.679H117.306V22.983C117.217 18.183 109.951 18.183 108.089 21.2934Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M98.5225 12.4861C97.0183 12.4861 95.7754 13.7341 95.7754 15.2445C95.7754 16.7549 97.0183 18.0029 98.5225 18.0029C100.027 18.0029 101.27 16.7549 101.27 15.2445C101.27 13.7341 100.027 12.4861 98.5225 12.4861Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.8143 10.4361L22.5148 1.09853C22.075 0.656934 21.4504 0.656934 21.0106 1.09853L11.1758 10.8841L21.9858 21.7385L31.8206 11.9529C32.2604 11.5049 32.2604 10.8841 31.8143 10.4361ZM23.7577 12.9321C22.6933 14.0009 21.0106 14.0009 20.0354 12.9321C18.971 11.8633 18.971 10.1737 20.0354 9.19453C21.0998 8.12573 22.7825 8.12573 23.7577 9.19453C24.7329 10.1737 24.7329 11.8633 23.7577 12.9321Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.5567 11.5936L0.632581 21.4688C0.192786 21.9104 0.192786 22.5376 0.632581 22.9792L9.93202 32.3168C10.3718 32.7584 10.9964 32.7584 11.4362 32.3168L21.2711 22.5376L10.5567 11.5936ZM8.60626 24.2272C7.54183 25.2064 5.85913 25.2064 4.88393 24.2272C3.8195 23.1584 3.8195 21.4688 4.88393 20.4896C5.94836 19.5104 7.63106 19.5104 8.60626 20.4896C9.58145 21.4688 9.58145 23.1584 8.60626 24.2272ZM12.5899 24.2272C11.5255 23.248 11.5255 21.4688 12.5899 20.4896C13.6543 19.4208 15.337 19.4208 16.3122 20.4896C17.3767 21.5584 17.3767 23.248 16.3122 24.2272C15.2478 25.296 13.6543 25.296 12.5899 24.2272Z"
            })
        ]
    });

});

parcelRegister("hI0HU", function(module, exports) {
$parcel$export(module.exports, "FordLogo", function () { return $2ec6afa33ab5e2c3$export$22ac95c9dec2accf; });

var $7VQPk = parcelRequire("7VQPk");
const $2ec6afa33ab5e2c3$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "115",
        height: "41",
        viewBox: "0 0 115 41",
        fill: "currentColor",
        role: "img",
        "aria-label": "Ford",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.3414 0.674927C25.954 0.674927 0.511719 9.52522 0.511719 20.4487C0.511719 31.3721 25.954 40.2178 57.3414 40.2178C88.7289 40.2178 114.171 31.3721 114.171 20.4487C114.171 9.52522 88.7266 0.674927 57.3414 0.674927ZM57.3414 38.5218C27.058 38.5218 2.50943 30.4349 2.50943 20.4647C2.50943 10.4944 27.058 2.38007 57.3414 2.38007C87.6249 2.38007 112.171 10.4692 112.171 20.4487C112.171 30.4281 87.6249 38.5149 57.3414 38.5149V38.5218Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.9218 17.9264C46.4007 17.739 48.5789 17.531 49.9869 17.451C50.2978 17.4327 50.3618 17.4373 50.4875 17.5904C50.8651 18.0357 51.3234 18.4057 51.8384 18.6807C51.9825 18.7797 52.1491 18.841 52.3229 18.859C52.4138 18.8581 52.5033 18.8371 52.5851 18.7976C52.6668 18.7581 52.7389 18.701 52.7961 18.6304C52.8642 18.5664 52.9111 18.4829 52.9303 18.3913C52.9495 18.2998 52.9401 18.2045 52.9035 18.1184C52.8189 17.9722 51.8452 17.4327 51.8132 17.2156C51.7927 17.0762 51.9458 17.0464 51.9458 17.0464C52.3523 16.9276 52.731 16.7287 53.0596 16.4614C53.3881 16.1941 53.6599 15.8638 53.8589 15.4899C54.3047 14.635 54.3778 13.4967 53.5641 12.8659C52.8487 12.3059 51.7698 12.3973 50.9104 13.1676C50.5297 13.5183 50.2394 13.9559 50.0643 14.4431C49.8892 14.9302 49.8344 15.4524 49.9047 15.9653C49.9252 16.1299 49.9047 16.1939 49.6898 16.1939C48.3961 16.2967 47.1481 16.3333 45.7629 16.4064C45.6692 16.4064 45.6395 16.3516 45.6944 16.2853C47.2944 13.515 49.6738 11.5402 52.3229 9.59273C52.4967 9.46244 52.4418 9.21101 52.4349 9.00301C57.1984 10.0362 61.8064 11.963 66.7389 11.9242C68.7824 11.9059 70.7367 11.595 72.6064 10.5687C74.2498 9.67502 74.9172 8.84301 74.9675 7.98359C75.0064 7.38473 74.5927 7.00987 74.0029 7.13787C69.0087 8.28073 64.2498 8.28073 59.2829 7.67044C53.6464 6.98473 48.2384 5.5813 42.6315 5.5813C41.7881 5.5813 40.9424 5.6133 40.0875 5.68416C34.6681 6.1413 29.5115 9.19273 29.5001 13.8259C29.5001 16.1733 31.1641 18.0796 33.7538 17.995C36.7915 17.8899 39.2898 15.4556 40.5995 12.3859C41.0955 11.2179 40.1767 10.7356 39.7378 11.4053C38.9816 12.5797 37.9217 13.5275 36.6704 14.1482C35.2372 14.8476 33.7104 14.6579 33.2418 13.4967C32.5904 11.8556 33.9458 9.4053 37.0384 8.23959C41.5069 6.58473 46.1812 7.67959 50.6772 8.5253C50.7389 8.5253 50.9789 8.65787 50.7687 8.7653C49.7477 9.25956 48.7956 9.88504 47.9367 10.6259C46.8736 11.497 45.8899 12.4608 44.9972 13.5059C44.1058 14.5893 43.4727 15.563 42.6384 16.6304C42.6102 16.6728 42.5727 16.708 42.5287 16.7334C42.4847 16.7587 42.4354 16.7736 42.3847 16.7767C40.3367 17.131 38.3458 17.3596 36.5218 18.619C36.1469 18.8796 35.9847 19.339 36.2109 19.6956C36.2693 19.7689 36.3417 19.8298 36.4239 19.8748C36.506 19.9198 36.5963 19.948 36.6895 19.9578C36.7827 19.9676 36.8769 19.9587 36.9666 19.9318C37.0563 19.9048 37.1397 19.8603 37.2121 19.8007C38.2556 18.9932 39.5317 18.5436 40.8509 18.5184C40.9081 18.5184 40.9355 18.5344 40.9538 18.5687C40.9577 18.5849 40.9579 18.6017 40.9543 18.618C40.9507 18.6342 40.9435 18.6494 40.9332 18.6624C38.9287 21.4442 38.4189 22.0727 36.9195 23.7962C36.1743 24.6452 35.3806 25.4503 34.5424 26.2076C31.1138 29.387 27.4384 29.3322 26.1149 27.3505C25.7719 26.8382 25.5751 26.242 25.5457 25.6262C25.5163 25.0104 25.6554 24.3982 25.9481 23.8556C26.5858 22.5779 27.8704 21.6453 28.9424 21.099C29.3401 20.8956 29.4544 20.3859 29.0567 19.9219C28.8052 19.6224 28.1904 19.5676 27.7332 19.6522C26.3321 19.9104 24.6727 20.971 23.6966 22.2464C22.56 23.6964 22.0329 25.5321 22.2269 27.3642C22.5606 30.8865 25.4544 32.9162 28.7435 32.891C31.3629 32.8705 33.8269 32.0796 36.7938 29.067C39.5572 26.2579 42.0784 22.0659 44.4395 18.1733C44.5127 18.0453 44.5675 17.9699 44.9218 17.9264ZM51.8909 13.8602C52.0025 13.736 52.1556 13.6569 52.3214 13.6375C52.4872 13.6181 52.6543 13.6599 52.7915 13.755C53.0544 13.9836 52.9309 14.539 52.6635 14.9299C52.3735 15.3647 51.9359 15.6797 51.4315 15.8167H51.3972C51.3218 15.8167 51.2601 15.7642 51.2258 15.5882C51.1896 15.2679 51.2311 14.9436 51.3469 14.6428C51.4627 14.3419 51.6493 14.0735 51.8909 13.8602Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M92.5408 13.7385H89.5031C89.2745 13.7385 89.1625 13.7682 89.0574 13.9671C88.7054 14.6368 84.4516 21.0117 83.6608 22.2482C83.5305 22.4357 83.3659 22.4082 83.3454 22.1957C83.2676 21.4597 82.6322 20.6162 81.6311 20.2117C80.9069 19.9192 80.117 19.8283 79.3454 19.9488C77.9465 20.1362 76.7008 20.8631 75.6036 21.7065C73.9556 22.9637 72.5294 24.5911 70.6916 25.7934C69.6836 26.4585 68.3122 27.0254 67.3979 26.1751C66.5659 25.4025 66.6596 23.6882 67.9305 22.3602C68.0676 22.2231 68.2276 22.3397 68.2025 22.4631C68.1338 22.7513 68.1425 23.0525 68.2276 23.3362C68.3127 23.62 68.4712 23.8763 68.6871 24.0791C68.9628 24.3176 69.3042 24.4672 69.6665 24.508C70.0288 24.5488 70.3949 24.4789 70.7168 24.3077C71.1004 24.1091 71.4297 23.8197 71.6759 23.4648C71.9221 23.1098 72.0778 22.7 72.1294 22.2711C72.1744 21.9558 72.1541 21.6346 72.0697 21.3275C71.9854 21.0204 71.8387 20.7339 71.6389 20.4859C71.4391 20.2378 71.1904 20.0336 70.9083 19.8857C70.6262 19.7379 70.3167 19.6497 69.9991 19.6265C68.9385 19.5534 67.9237 19.9214 66.9362 20.7397C66.468 21.1167 66.0609 21.5639 65.7294 22.0654C65.6219 22.214 65.4619 22.23 65.4688 22.006C65.5168 20.2757 64.7991 19.2997 63.3682 19.2631C62.2551 19.238 61.0688 19.8391 60.1408 20.5797C59.1282 21.3934 58.2391 22.4722 57.2882 23.4894C57.1694 23.6151 57.0596 23.6082 57.0345 23.366C57.0048 22.2231 56.7145 21.1054 56.1842 20.3168C56.087 20.1724 55.9398 20.0692 55.771 20.027C55.6021 19.9848 55.4236 20.0066 55.2699 20.0882C54.891 20.269 54.5298 20.4848 54.1911 20.7328C54.0929 20.8138 54.0225 20.9234 53.9897 21.0464C53.9569 21.1693 53.9634 21.2994 54.0082 21.4185C54.5153 23.1725 54.4097 25.0469 53.7088 26.7328C53.0711 28.2437 51.8276 29.6014 50.3694 30.0654C49.4094 30.3671 48.4082 30.2185 47.7888 29.366C46.9408 28.1911 47.2836 26.1431 48.5476 24.4471C49.6676 22.95 51.2905 22.0014 52.8905 21.3865C52.9278 21.3788 52.9629 21.3627 52.9931 21.3394C53.0232 21.3161 53.0477 21.2863 53.0647 21.2522C53.0816 21.2181 53.0906 21.1805 53.0909 21.1424C53.0912 21.1043 53.0829 21.0666 53.0665 21.0322C52.9774 20.7648 52.8379 20.406 52.7831 20.2414C52.6322 19.8482 52.2208 19.7842 51.7134 19.8391C50.5628 19.9917 49.4524 20.3642 48.4425 20.9362C45.6996 22.3991 44.3282 25.2311 43.7385 26.7488C43.5351 27.3179 43.2453 27.8521 42.8791 28.3328C42.4494 28.8723 41.9076 29.366 40.9179 30.2345C40.8649 30.2853 40.8289 30.3512 40.815 30.4233C40.8011 30.4954 40.8099 30.57 40.8402 30.6368C40.9408 30.8425 41.4574 31.5694 41.5991 31.638C41.6734 31.6578 41.7516 31.6586 41.8263 31.6402C41.901 31.6218 41.9699 31.5849 42.0265 31.5328C42.7381 31.0436 43.3848 30.466 43.9511 29.814C44.0951 29.6448 44.2391 29.718 44.3145 29.9785C44.4953 30.6541 44.84 31.2745 45.3181 31.7849C45.7961 32.2953 46.3928 32.6798 47.0551 32.9043C49.5694 33.7523 52.1591 32.5294 54.1225 30.39C55.3682 29.0368 55.8208 28.166 56.2985 27.574C57.1122 26.5705 58.7122 24.326 60.6094 22.886C61.3065 22.3511 62.1339 21.9442 62.5476 22.214C62.8814 22.4425 62.9888 22.934 62.4539 23.9054C60.5134 27.4482 57.6539 31.6128 57.1351 32.6208C57.0368 32.7991 57.1351 32.934 57.3065 32.934C58.3236 32.934 59.3294 32.934 60.2505 32.934C60.312 32.9324 60.372 32.9144 60.4243 32.8819C60.4765 32.8493 60.5191 32.8034 60.5476 32.7488C62.0379 30.4174 63.4391 28.2002 64.9408 25.9054C65.0254 25.7705 65.1031 25.8757 65.1054 25.9351C65.1396 26.4654 65.2676 27.1945 65.5854 27.6722C65.8183 28.0636 66.1499 28.387 66.547 28.6101C66.9441 28.8331 67.3928 28.9479 67.8482 28.9431C68.5591 28.9431 68.9202 28.8425 69.6768 28.5545C70.2133 28.3555 70.7201 28.084 71.1831 27.7477C71.4116 27.59 71.4482 27.8528 71.4414 27.894C71.0962 29.7431 71.5236 31.9351 73.3637 32.8448C75.5625 33.9283 77.9808 32.406 79.3751 31.0277C79.5076 30.8951 79.6539 30.9088 79.6699 31.1945C79.7065 31.7943 79.9552 32.3614 80.3717 32.7945C81.5374 33.9625 83.8894 33.4985 86.2505 31.67C87.7659 30.502 89.3545 28.8471 90.7854 27.0985C90.8043 27.0796 90.8193 27.0572 90.8296 27.0325C90.8398 27.0078 90.8451 26.9813 90.8451 26.9545C90.8451 26.9278 90.8398 26.9013 90.8296 26.8766C90.8193 26.8519 90.8043 26.8294 90.7854 26.8105C90.5568 26.582 90.2528 26.3237 90.0357 26.1248C89.9887 26.089 89.9313 26.0697 89.8722 26.0697C89.8132 26.0697 89.7558 26.089 89.7088 26.1248C88.2414 27.5237 86.9179 29.1168 85.0094 30.4334C84.3625 30.8905 83.3362 31.2494 82.8745 30.6231C82.6939 30.3808 82.7145 30.0448 82.8928 29.606C83.4482 28.2162 92.2642 14.79 92.7214 13.9945C92.8036 13.8391 92.7214 13.7385 92.5408 13.7385ZM81.0665 25.238C81.0848 25.3431 81.2174 25.4414 81.3476 25.4871C81.3956 25.5031 81.4208 25.5397 81.3705 25.6448C81.031 26.3334 80.6333 26.9918 80.1819 27.6128C79.7627 28.23 79.2525 28.7802 78.6688 29.2448C77.9831 29.8117 77.0917 30.4174 76.2505 30.4174C75.9983 30.4206 75.7493 30.3609 75.5259 30.2437C75.0688 30.0151 74.8745 29.3728 74.8814 28.8585C74.9065 27.414 75.5488 25.9305 76.7351 24.4722C78.1819 22.6894 79.7819 21.766 80.8311 22.2711C81.9191 22.79 81.5739 24.0448 81.0871 25.0345C81.0538 25.097 81.0464 25.1701 81.0665 25.238Z"
            })
        ]
    });

});

parcelRegister("bynL4", function(module, exports) {
$parcel$export(module.exports, "NasaLogo", function () { return $b07d7862f0c2a57d$export$e44efe2f415651b3; });

var $7VQPk = parcelRequire("7VQPk");
const $b07d7862f0c2a57d$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "88",
        height: "72",
        viewBox: "0 0 88 72",
        fill: "currentColor",
        role: "img",
        "aria-label": "NASA",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.4359 36C76.4359 55.7457 60.1693 71.9967 40.4025 71.9967C20.6364 71.9967 4.36914 55.7447 4.36914 36C4.36914 16.2532 20.256 0.0032959 40.4025 0.0032959C59.787 0.0032959 76.4359 16.2541 76.4359 36Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5289 54.9456C63.9235 61.2787 61.2524 45.2754 53.0462 33.0216C48.3951 26.0795 42.3294 20.2956 38.5036 17.5045C25.8183 8.24615 17.9873 13.8614 26.9449 32.1201C29.8412 38.0235 33.5609 42.0079 36.4663 45.7634C38.6851 48.6306 43.0069 50.0662 41.4845 51.426C39.7687 52.9603 35.6147 46.1937 35.6147 46.1937C32.5467 42.4938 29.6224 38.5457 26.6085 33.1273C19.723 20.7524 20.7158 8.12178 33.1799 13.6237C43.7574 18.2953 53.8606 31.3977 57.9232 40.7025C59.7991 44.9995 64.9144 61.9986 48.6221 55.1256",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.658203 46.6707C7.43066 42.1604 13.8517 39.2483 24.7788 35.6388C40.1336 30.5663 51.6898 27.1567 65.87 20.0294C72.2171 16.8399 83.23 9.68665 87.168 3.46851C85.9891 5.87521 82.3362 10.5597 80.6837 12.6312C61.4447 36.7206 20.464 35.3546 0.928637 46.9194"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M10.4824 29.0644C16.6807 29.113 16.0726 29.0519 16.145 29.1246C16.2532 29.1246 21.0941 37.461 21.0941 37.5334C21.0941 37.5686 21.0581 34.5706 21.0581 30.8208C21.0581 30.3878 19.8666 29.1249 19.9021 29.1249C21.6714 29.1249 23.9836 29.161 23.9836 29.161C23.1173 30.1715 22.9441 30.0881 22.9367 30.713C22.9123 32.7206 22.8897 36.4321 22.9367 40.6002C22.9435 41.2251 23.4064 41.4665 24.1652 42.5491H18.4931C16.6508 39.4818 13.2748 33.7275 13.2916 33.7443C13.3176 33.7706 13.2189 37.3537 13.327 40.2399C13.3634 41.1936 13.797 41.5028 14.5921 42.3694C14.5921 42.3694 15.5067 42.345 10.1484 42.4052C11.7741 41.5389 11.5581 40.4565 11.5574 40.4205C11.4991 36.4321 11.5452 33.0222 11.5452 30.8208C11.5452 30.46 11.5208 30.4957 10.4015 29.1246M29.8626 35.2239C30.383 33.417 30.8276 31.8024 31.0388 30.749C31.0745 30.5684 30.6415 29.9191 29.9552 29.2694L29.9066 29.1686C33.2163 29.1793 36.6739 29.1979 36.6739 29.1979C37.5771 31.3987 39.6358 37.5695 41.1893 41.3592C41.6 42.36 42.3093 42.5497 42.3093 42.5497C39.4916 42.514 34.2626 42.5384 34.2904 42.514C35.6988 41.2501 35.5182 41.2501 34.904 39.4112H30.4973C29.594 41.5037 30.7787 42.4859 30.9303 42.4782C29.9274 42.5302 26.5236 42.4782 26.5236 42.4782C28.3659 41.1783 28.2571 40.7817 28.2571 40.7817C28.7631 38.9812 29.3495 37.0087 29.8629 35.2236L31.671 35.2239L30.8942 37.7137H34.3992L32.4481 32.7334L31.6713 35.2233L29.8632 35.223M60.1359 35.4042C60.6554 33.5979 61.1003 31.9826 61.3115 30.9293C61.3469 30.749 60.9133 30.0997 60.2273 29.4494L60.1787 29.3492C63.4893 29.3599 66.9475 29.3782 66.9475 29.3782C67.8492 31.5796 69.9085 37.7498 71.4614 41.5395C71.8718 42.5415 72.5804 42.73 72.5804 42.73C69.7646 42.6943 64.5353 42.7187 64.5625 42.6943C65.9712 41.4313 65.7912 41.4313 65.177 39.5915H60.7694C59.8661 41.6843 61.0502 42.6662 61.2017 42.6591C60.1998 42.7105 56.7951 42.6591 56.7951 42.6591C58.6374 41.3598 58.5295 40.9626 58.5295 40.9626C59.0355 39.1615 59.6216 37.1899 60.1359 35.4042H61.9437C61.5544 36.65 61.1675 37.8949 61.1675 37.8949H64.6706L62.7195 32.914C62.7195 32.914 62.3324 34.1586 61.9437 35.4035L60.1359 35.4042ZM54.4372 32.4462C54.3654 29.8824 54.4372 29.0531 54.4372 29.0531C53.317 29.9558 53.8826 29.8406 51.0784 29.3779C42.9977 28.0447 42.382 35.5884 46.7795 37.2804C50.4709 38.7013 51.7784 38.98 51.2223 40.3114C51.0417 40.7459 47.6825 42.3331 44.2148 39.1209L44.2854 43.596C44.7193 43.1496 45.912 42.3331 45.912 42.3331C45.9471 42.3331 49.6706 43.9731 53.0276 42.261C58.194 39.6272 55.6155 35.3635 50.102 33.6725C45.5138 32.265 49.849 28.9807 54.4 32.4816M40.9091 3.27236C40.9089 3.35014 40.8779 3.42468 40.823 3.47974C40.768 3.5348 40.6936 3.56592 40.6158 3.56632C40.538 3.56584 40.4636 3.53469 40.4087 3.47965C40.3537 3.42461 40.3227 3.35011 40.3224 3.27236C40.3224 3.11284 40.4554 2.97961 40.6158 2.97961C40.6934 2.97986 40.7678 3.01076 40.8227 3.06559C40.8777 3.12042 40.9087 3.19473 40.9091 3.27236ZM42.9443 7.71602C42.9443 7.91404 42.7799 8.07752 42.5831 8.07752C42.4873 8.07712 42.3955 8.03891 42.3278 7.97122C42.26 7.90352 42.2218 7.8118 42.2213 7.71602C42.2213 7.51862 42.3844 7.35575 42.5831 7.35575C42.7802 7.35575 42.9443 7.51832 42.9443 7.71602ZM48.224 14.9783C48.224 15.1757 48.062 15.3392 47.8625 15.3392C47.7669 15.3386 47.6755 15.3003 47.6079 15.2328C47.5403 15.1653 47.502 15.0739 47.5013 14.9783C47.5013 14.7803 47.6526 14.6165 47.8515 14.6165C48.0507 14.6171 48.224 14.7803 48.224 14.9783ZM39.7357 10.2196C39.7354 10.2973 39.7044 10.3717 39.6494 10.4266C39.5945 10.4815 39.52 10.5124 39.4424 10.5126C39.3646 10.5124 39.2901 10.4815 39.2351 10.4266C39.18 10.3717 39.1489 10.2973 39.1484 10.2196C39.1484 10.0592 39.2813 9.92625 39.4424 9.92625C39.5201 9.92649 39.5946 9.95747 39.6495 10.0124C39.7045 10.0674 39.7355 10.1419 39.7357 10.2196ZM42.8984 11.889C42.8979 11.9665 42.8668 12.0407 42.812 12.0954C42.7571 12.1502 42.6829 12.1812 42.6054 12.1817C42.5278 12.1813 42.4535 12.1504 42.3985 12.0956C42.3435 12.0408 42.3124 11.9666 42.3117 11.889C42.3117 11.7285 42.4446 11.5959 42.6054 11.5959C42.7658 11.5959 42.8984 11.7285 42.8984 11.889ZM38.7884 7.21947C38.7884 7.41748 38.6253 7.58096 38.4273 7.58096C38.2292 7.58096 38.0661 7.4184 38.0661 7.21947C38.0661 7.02206 38.2292 6.85828 38.4273 6.85828C38.6253 6.85828 38.7884 7.02145 38.7884 7.21947ZM34.0031 10.1295C34.0031 10.2905 33.8708 10.4228 33.7095 10.4228C33.6318 10.4224 33.5574 10.3914 33.5025 10.3364C33.4476 10.2815 33.4165 10.2071 33.4161 10.1295C33.4161 9.96903 33.5487 9.8361 33.7095 9.8361C33.7872 9.83634 33.8617 9.86732 33.9168 9.92227C33.9718 9.97723 34.0028 10.0517 34.0031 10.1295ZM34.8587 10.7152C34.8584 10.7931 34.8274 10.8677 34.7723 10.9228C34.7172 10.9778 34.6427 11.0089 34.5648 11.0092C34.4869 11.0088 34.4124 10.9777 34.3574 10.9227C34.3023 10.8676 34.2712 10.7931 34.2708 10.7152C34.2743 10.6396 34.3068 10.5682 34.3615 10.5159C34.4163 10.4636 34.4891 10.4344 34.5648 10.4344C34.6405 10.4344 34.7133 10.4636 34.7681 10.5159C34.8228 10.5682 34.8553 10.6396 34.8587 10.7152ZM35.7174 11.3019C35.7172 11.3797 35.6862 11.4543 35.6313 11.5093C35.5763 11.5644 35.5018 11.5955 35.4241 11.5959C35.3463 11.5955 35.2717 11.5644 35.2168 11.5093C35.1618 11.4543 35.1307 11.3798 35.1304 11.3019C35.1304 11.1421 35.2633 11.0095 35.4241 11.0095C35.5851 11.0095 35.7174 11.1418 35.7174 11.3019ZM34.4096 12.4301C34.4088 12.5078 34.3775 12.582 34.3225 12.6369C34.2676 12.6918 34.1933 12.7228 34.1156 12.7235C34.0379 12.7231 33.9634 12.6921 33.9084 12.6372C33.8534 12.5822 33.8222 12.5079 33.8216 12.4301C33.8216 12.2697 33.9542 12.1371 34.1156 12.1371C34.276 12.1371 34.4096 12.2697 34.4096 12.4301ZM27.5903 17.2115C27.5899 17.2892 27.5587 17.3635 27.5036 17.4184C27.4486 17.4732 27.3741 17.504 27.2964 17.5042C27.1353 17.5042 27.0027 17.3722 27.0027 17.2115C27.0027 17.0507 27.1357 16.9178 27.2964 16.9178C27.4571 16.9178 27.5903 17.0504 27.5903 17.2115ZM28.8542 18.7457C28.8536 18.8234 28.8224 18.8976 28.7674 18.9525C28.7125 19.0073 28.6382 19.0383 28.5605 19.0388C28.4829 19.0383 28.4085 19.0073 28.3535 18.9525C28.2985 18.8977 28.2673 18.8234 28.2666 18.7457C28.2666 18.5844 28.3995 18.4524 28.5605 18.4524C28.7216 18.4524 28.8542 18.5844 28.8542 18.7457ZM27.8495 43.5111C27.849 43.5887 27.8179 43.6631 27.7629 43.718C27.7079 43.7728 27.6335 43.8038 27.5558 43.8041C27.3948 43.8041 27.2625 43.6715 27.2625 43.5111C27.2625 43.3506 27.3948 43.2174 27.5558 43.2174C27.7172 43.2174 27.8495 43.3506 27.8495 43.5111ZM28.0301 50.3434C28.0301 50.5414 27.8669 50.7046 27.6689 50.7046C27.4709 50.7046 27.3077 50.5423 27.3077 50.3434C27.3077 50.146 27.4709 49.9828 27.6689 49.9828C27.7644 49.9833 27.8559 50.0214 27.9235 50.0889C27.9911 50.1564 28.0294 50.2479 28.0301 50.3434ZM24.1459 53.8429C24.1453 53.9204 24.1143 53.9946 24.0594 54.0493C24.0046 54.1041 23.9304 54.1351 23.8529 54.1356C23.7753 54.1352 23.7009 54.1043 23.646 54.0495C23.591 53.9947 23.5598 53.9205 23.5592 53.8429C23.5592 53.6812 23.6921 53.5492 23.8529 53.5492C24.0133 53.5492 24.1459 53.6809 24.1459 53.8429ZM19.4957 55.2601C19.495 55.3558 19.4567 55.4474 19.389 55.515C19.3212 55.5826 19.2296 55.6208 19.1339 55.6213C19.0382 55.621 18.9465 55.5828 18.8788 55.5152C18.8112 55.4475 18.773 55.3558 18.7727 55.2601C18.7727 55.0624 18.9359 54.8989 19.1339 54.8989C19.2295 54.8995 19.3212 54.9377 19.3889 55.0053C19.4566 55.0729 19.4949 55.1644 19.4957 55.2601ZM18.5472 52.1038C18.5472 52.3009 18.384 52.4641 18.1866 52.4641C18.0911 52.4636 17.9996 52.4255 17.932 52.3581C17.8644 52.2907 17.8261 52.1993 17.8254 52.1038C17.8258 52.0081 17.8639 51.9163 17.9316 51.8485C17.9992 51.7808 18.0908 51.7424 18.1866 51.7417C18.384 51.7426 18.5472 51.9055 18.5472 52.1038ZM18.006 54.1115C18.006 54.2725 17.8731 54.4045 17.7123 54.4045C17.5516 54.4045 17.4184 54.2725 17.4184 54.1115C17.4184 53.9516 17.5516 53.8181 17.7123 53.8181C17.8731 53.8181 18.006 53.9507 18.006 54.1115ZM14.5282 52.4433C14.5278 52.5208 14.4968 52.5951 14.442 52.6499C14.3872 52.7047 14.313 52.7358 14.2355 52.7364C14.1578 52.736 14.0833 52.7051 14.0283 52.6502C13.9733 52.5954 13.9421 52.521 13.9415 52.4433C13.9415 52.2835 14.0742 52.1503 14.2355 52.1503C14.3956 52.1503 14.5282 52.2826 14.5282 52.4433ZM26.6748 58.0809C26.6748 58.2419 26.5535 58.3745 26.3931 58.3745C26.2321 58.3745 26.0878 58.2419 26.0878 58.0809C26.0878 57.9204 26.2208 57.7875 26.3812 57.7875C26.5428 57.7875 26.6748 57.9201 26.6748 58.0809ZM30.3332 55.3979C30.3332 55.5959 30.1816 55.7597 29.983 55.7597C29.785 55.7597 29.6108 55.5969 29.6108 55.3979C29.6108 55.2005 29.774 55.0373 29.972 55.0373C30.0675 55.0378 30.159 55.076 30.2267 55.1435C30.2943 55.211 30.3325 55.3024 30.3332 55.3979ZM30.7518 58.8479C30.7518 59.0089 30.6073 59.1421 30.4472 59.1421C30.3693 59.1417 30.2948 59.1105 30.2397 59.0554C30.1847 59.0003 30.1536 58.9257 30.1532 58.8479C30.1532 58.6881 30.2858 58.5554 30.4472 58.5554C30.6073 58.5551 30.7518 58.6871 30.7518 58.8479ZM45.7861 55.5538C45.7856 55.6313 45.7546 55.7056 45.6998 55.7605C45.6451 55.8154 45.5709 55.8466 45.4934 55.8474C45.4155 55.847 45.341 55.8159 45.2859 55.7609C45.2308 55.706 45.1995 55.6316 45.1988 55.5538C45.1988 55.3927 45.3314 55.2607 45.4934 55.2607C45.6535 55.2607 45.7861 55.3927 45.7861 55.5538ZM38.7884 58.0347C38.7881 58.1124 38.7571 58.1868 38.7021 58.2417C38.6472 58.2966 38.5728 58.3275 38.4951 58.3278C38.4175 58.3274 38.3431 58.2964 38.2882 58.2415C38.2333 58.1867 38.2022 58.1124 38.2017 58.0347C38.2017 57.8749 38.3347 57.7417 38.4951 57.7417C38.6564 57.7417 38.7884 57.8743 38.7884 58.0347ZM57.6183 61.6008C57.6176 61.6784 57.5865 61.7527 57.5315 61.8075C57.4766 61.8624 57.4022 61.8934 57.3246 61.8938C57.2469 61.8935 57.1724 61.8626 57.1173 61.8077C57.0622 61.7529 57.031 61.6785 57.0303 61.6008C57.0303 61.4407 57.1636 61.3077 57.3246 61.3077C57.485 61.3077 57.6183 61.4401 57.6183 61.6008ZM59.1519 47.728C59.1514 47.8238 59.1131 47.9154 59.0453 47.9831C58.9776 48.0508 58.8859 48.089 58.7901 48.0895C58.6945 48.0889 58.6028 48.0507 58.5352 47.983C58.4675 47.9153 58.4292 47.8237 58.4286 47.728C58.4286 47.53 58.5915 47.3665 58.7901 47.3665C58.8859 47.3669 58.9777 47.4051 59.0454 47.4728C59.1132 47.5405 59.1515 47.6322 59.1519 47.728ZM56.2643 49.6898C56.2637 49.7676 56.2325 49.8421 56.1774 49.897C56.1223 49.952 56.0478 49.983 55.97 49.9834C55.8099 49.9834 55.677 49.8505 55.677 49.6898C55.677 49.5291 55.8099 49.397 55.97 49.397C56.1313 49.397 56.2643 49.5288 56.2643 49.6898ZM59.1098 50.2551C59.1098 50.4528 58.9469 50.6169 58.748 50.6169C58.549 50.6169 58.3862 50.4537 58.3862 50.2551C58.3862 50.0577 58.549 49.8939 58.748 49.8939C58.9469 49.8939 59.1098 50.0577 59.1098 50.2551ZM56.2643 53.7509C56.2637 53.8286 56.2325 53.903 56.1774 53.9579C56.1223 54.0128 56.0478 54.0437 55.97 54.0439C55.8925 54.0434 55.8182 54.0123 55.7634 53.9575C55.7086 53.9026 55.6775 53.8284 55.677 53.7509C55.677 53.5898 55.8099 53.4572 55.97 53.4572C56.1313 53.4572 56.2643 53.5895 56.2643 53.7509ZM63.6225 45.7662C63.6225 45.9263 63.489 46.0596 63.3289 46.0596C63.2513 46.0589 63.1771 46.0278 63.1222 45.9729C63.0674 45.918 63.0364 45.8438 63.0358 45.7662C63.0358 45.6055 63.1684 45.4735 63.3289 45.4735C63.4893 45.4735 63.6225 45.6055 63.6225 45.7662ZM64.3345 47.5477C64.3345 47.7454 64.1839 47.9092 63.9849 47.9092C63.7866 47.9092 63.6121 47.7463 63.6121 47.5477C63.6121 47.3497 63.775 47.1868 63.973 47.1868C64.1716 47.1874 64.3345 47.3497 64.3345 47.5477ZM69.404 49.6684C69.404 49.8661 69.2426 50.0296 69.0425 50.0296C68.9467 50.0293 68.855 49.9911 68.7872 49.9235C68.7195 49.8558 68.6812 49.7641 68.6807 49.6684C68.6813 49.5726 68.7196 49.481 68.7873 49.4133C68.855 49.3456 68.9467 49.3074 69.0425 49.3069C69.1383 49.3072 69.23 49.3454 69.2978 49.4131C69.3655 49.4809 69.4037 49.5726 69.404 49.6684ZM64.2547 53.4364C64.254 53.5142 64.2227 53.5885 64.1677 53.6433C64.1126 53.6981 64.0382 53.7291 63.9605 53.7295C63.8828 53.7291 63.8085 53.6981 63.7535 53.6433C63.6985 53.5884 63.6674 53.5141 63.6668 53.4364C63.6668 53.2754 63.8001 53.1428 63.9605 53.1428C64.1209 53.1428 64.2547 53.2745 64.2547 53.4364ZM67.5064 50.3682C67.506 50.4458 67.475 50.5201 67.4201 50.5749C67.3652 50.6298 67.2909 50.6608 67.2133 50.6612C67.1357 50.6607 67.0614 50.6297 67.0065 50.5749C66.9516 50.52 66.9205 50.4458 66.92 50.3682C66.92 50.208 67.0535 50.0748 67.2133 50.0748C67.3737 50.0748 67.5064 50.2071 67.5064 50.3682ZM66.9074 55.1046C66.907 55.1822 66.876 55.2565 66.8212 55.3113C66.7663 55.3662 66.692 55.3972 66.6144 55.3976C66.5366 55.3975 66.462 55.3666 66.4069 55.3117C66.3518 55.2568 66.3206 55.1824 66.3201 55.1046C66.3201 54.9448 66.4527 54.8112 66.6144 54.8112C66.7748 54.8112 66.9074 54.9438 66.9074 55.1046ZM68.2856 47.233C68.2856 47.4808 68.0815 47.684 67.8336 47.684C67.5861 47.684 67.3823 47.4808 67.3823 47.233C67.3823 46.9854 67.5861 46.7822 67.8336 46.7822C68.0815 46.7822 68.2856 46.9854 68.2856 47.233Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M67.8322 45.8578L67.698 47.0981L66.4675 47.2338L67.7087 47.3682L67.8444 48.6544L67.9801 47.3682L69.1987 47.21L67.9691 47.0972L67.8322 45.8578ZM65.1223 55.0797C65.1223 55.3279 64.9185 55.5317 64.6707 55.5317C64.551 55.5312 64.4363 55.4834 64.3517 55.3988C64.267 55.3141 64.2192 55.1994 64.2188 55.0797C64.2188 54.8322 64.4229 54.629 64.6707 54.629C64.7902 54.6295 64.9046 54.6771 64.9892 54.7615C65.0738 54.8459 65.1216 54.9603 65.1223 55.0797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.6731 53.7047L64.5374 54.9457L63.3074 55.0804L64.5487 55.2161L64.6847 56.5011L64.8204 55.2161L66.0384 55.0578L64.8078 54.9448L64.6731 53.7047ZM31.4384 17.8199C31.4384 18.0674 31.2346 18.2709 30.9871 18.2709C30.8675 18.2706 30.7529 18.223 30.6682 18.1385C30.5835 18.054 30.5357 17.9395 30.5352 17.8199C30.5352 17.5717 30.7387 17.3685 30.9871 17.3685C31.2346 17.3691 31.4384 17.5723 31.4384 17.8199Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.9876 16.4441L30.8519 17.6845L29.6211 17.8201L30.863 17.9543L30.9986 19.2411L31.1337 17.9543L32.3529 17.7972L31.1221 17.6839L30.9876 16.4441ZM48.237 6.90409C48.237 7.15161 48.0329 7.35543 47.7851 7.35543C47.5373 7.35543 47.334 7.15161 47.334 6.90409C47.334 6.65597 47.5369 6.45215 47.7851 6.45215C48.0332 6.45215 48.237 6.65658 48.237 6.90409Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M47.7847 5.5271L47.6503 6.76834L46.42 6.90402L47.6616 7.03878L47.796 8.32464L47.9317 7.03878L49.1503 6.88049L47.9198 6.76773L47.7847 5.5271ZM27.8154 62.3008C27.8154 62.5489 27.6116 62.7521 27.3641 62.7521C27.2444 62.7517 27.1298 62.704 27.0451 62.6195C26.9605 62.535 26.9127 62.4204 26.9121 62.3008C26.9121 62.0536 27.1159 61.8491 27.3641 61.8491C27.6116 61.8494 27.8154 62.0539 27.8154 62.3008Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.3734 60.923L27.2384 62.1642L26.0078 62.2993L27.2494 62.434L27.3847 63.7199L27.5198 62.434L28.739 62.2764L27.5088 62.1633L27.3734 60.923Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M87.1638 3.46875C81.6723 19.7596 59.6743 32.3392 41.1564 44.3476C29.9849 51.595 18.8935 59.9362 11.2578 67.0335C9.24526 68.9052 11.6679 66.3335 10.8966 67.124C21.5526 54.8548 33.8104 47.5467 40.5841 42.9463C52.0398 35.1636 58.5556 33.2021 78.3195 14.9975"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M5.23755 43.8289C3.26537 44.7929 1.49884 45.746 0 46.6765L0.911835 47.0084C2.22275 46.2013 3.79646 45.3595 5.45421 44.6179M15.6491 62.0592C13.7728 63.6953 11.9275 65.3667 10.1142 67.0724L10.0317 68.3164C11.7429 66.5529 13.845 64.6501 16.2709 62.6303"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M48.5295 54.9457C63.9241 61.2787 61.253 45.2755 53.0468 33.0216C48.3954 26.0796 42.6597 20.5725 38.5039 17.5045C33.6514 13.9217 33.1777 13.6246 33.1777 13.6246C44.014 18.7678 53.8584 31.3984 57.9204 40.7038C59.797 45.0005 64.912 61.9996 48.6193 55.1266",
                fill: "white"
            })
        ]
    });

});

parcelRegister("38U9C", function(module, exports) {
$parcel$export(module.exports, "VisaLogo", function () { return $864117658491d5fa$export$c17820a482ea0e7b; });

var $7VQPk = parcelRequire("7VQPk");
const $864117658491d5fa$export$c17820a482ea0e7b = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "61",
        height: "19",
        viewBox: "0 0 61 19",
        fill: "currentColor",
        role: "img",
        "aria-label": "Visa",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M44.4329 0.753178C43.0385 0.245085 41.5646 -0.00987869 40.0805 0.000292741C35.2812 0.000292741 31.8917 2.41793 31.8677 5.88841C31.8378 8.43803 34.2764 9.87481 36.1211 10.7267C38.0138 11.6026 38.6467 12.1545 38.6407 12.9374C38.6287 14.1282 37.129 14.6681 35.7342 14.6681C33.8175 14.6681 32.7706 14.4011 31.1599 13.7322L30.5629 13.4533L29.882 17.4487C31.0489 17.9346 33.1516 18.3515 35.3232 18.3875C40.4255 18.3875 43.761 15.9849 43.8 12.2924C43.8419 10.2558 42.5221 8.71698 39.7446 7.44517C38.0558 6.6203 37.009 6.06838 37.009 5.23151C37.009 4.49062 37.9058 3.69874 39.7806 3.69874C41.0282 3.66855 42.2682 3.90264 43.419 4.38563L43.8689 4.5866L44.5498 0.726183L44.4329 0.753178ZM56.887 0.324244H53.1376C51.9707 0.324244 51.0919 0.645195 50.5819 1.80302L43.371 18.1386H48.4733L49.4931 15.46L55.7202 15.466C55.8672 16.0929 56.3171 18.1386 56.3171 18.1386H60.8164L56.887 0.324244ZM24.9658 0.174265H29.8281L26.7865 17.9976H21.9302L24.9658 0.168267V0.174265ZM12.6226 9.99779L13.1266 12.4724L17.8778 0.324244H23.0281L15.3762 18.1146H10.238L6.03862 3.05083C5.97061 2.80245 5.81088 2.58912 5.59169 2.45392C4.07812 1.67205 2.47439 1.07871 0.816406 0.687187L0.882396 0.312243H8.70822C9.77006 0.354237 10.6249 0.687188 10.9099 1.82102L12.6196 10.0068L12.6226 9.99779ZM50.8879 11.8155L52.8256 6.83027C52.8016 6.88426 53.2245 5.80142 53.4705 5.13252L53.8035 6.67129L54.9283 11.8125H50.8849L50.8879 11.8155Z"
        })
    });

});

parcelRegister("9MZ6h", function(module, exports) {
$parcel$export(module.exports, "ArrowRight", function () { return $3c710196451a00e5$export$acad20503ad73ac1; });

var $7VQPk = parcelRequire("7VQPk");
const $3c710196451a00e5$export$acad20503ad73ac1 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        width: "11",
        height: "8",
        viewBox: "0 0 11 8",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
        })
    });

});

parcelRegister("iNnWi", function(module, exports) {
$parcel$export(module.exports, "getProductSoftwareDevelopmentModalImage", function () { return $3283639d1ff6b124$export$6954fe49bbdabc54; });
$parcel$export(module.exports, "getProductMarketingModalImage", function () { return $3283639d1ff6b124$export$cc19a82b226e3f08; });
$parcel$export(module.exports, "getProductItModalImage", function () { return $3283639d1ff6b124$export$fa7e84d2d2c567a7; });
$parcel$export(module.exports, "getUpdatedProductItModalImage", function () { return $3283639d1ff6b124$export$f31d1f714b55f0fb; });
$parcel$export(module.exports, "getProductDesignModalImage", function () { return $3283639d1ff6b124$export$e0ab49165f0180f7; });
$parcel$export(module.exports, "getProductOperationsModalImage", function () { return $3283639d1ff6b124$export$51a8246da0eeafec; });
$parcel$export(module.exports, "getDoubleFeatureFirstImage", function () { return $3283639d1ff6b124$export$af7f348492750745; });
$parcel$export(module.exports, "getDoubleFeatureSecondImage", function () { return $3283639d1ff6b124$export$51c1e8c9994962ad; });
$parcel$export(module.exports, "getCollaborateFirstImage", function () { return $3283639d1ff6b124$export$7a98b35c48983fe6; });
$parcel$export(module.exports, "getCollaborateSecondImage", function () { return $3283639d1ff6b124$export$3ff8286854e1bb40; });
$parcel$export(module.exports, "getCollaborateThirdImage", function () { return $3283639d1ff6b124$export$54ce02c1025509fa; });
$parcel$export(module.exports, "getCollaborateFourthImage", function () { return $3283639d1ff6b124$export$ea3cb1bf26550cc6; });
$parcel$export(module.exports, "getHeroCardOperationsImage", function () { return $3283639d1ff6b124$export$a27f10b8f2dbe6ec; });
$parcel$export(module.exports, "getHeroCardDesignImage", function () { return $3283639d1ff6b124$export$d2a58a00fc2c43; });
$parcel$export(module.exports, "getHeroCardItImage", function () { return $3283639d1ff6b124$export$e7e5a083e5974d8d; });
$parcel$export(module.exports, "getHeroCardMarketingImage", function () { return $3283639d1ff6b124$export$bf236abab7f9a91d; });
$parcel$export(module.exports, "getHeroCardSoftwareDevelopmentImage", function () { return $3283639d1ff6b124$export$44d7a932d2767a7a; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureSecondImage", function () { return $3283639d1ff6b124$export$2d0f6370ca103766; });
$parcel$export(module.exports, "getStaggeredDoubleFeautureFirstImage", function () { return $3283639d1ff6b124$export$78335ebe3bbd9065; });
$parcel$export(module.exports, "getAiVideo", function () { return $3283639d1ff6b124$export$944f00714b8c3d98; });
$parcel$export(module.exports, "getAiImage", function () { return $3283639d1ff6b124$export$2e497ec5a3f0e9f7; });
$parcel$export(module.exports, "getAiVideoJSM", function () { return $3283639d1ff6b124$export$e88a1961b910936; });
$parcel$export(module.exports, "getAiImageJSM", function () { return $3283639d1ff6b124$export$be405a6adaf81ee7; });
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $3283639d1ff6b124$var$aiVideoJSMProductTourMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/ov2b53oh3ly6rgucw1do7w4xoni4d6qh.mp4"
};
const $3283639d1ff6b124$var$aiImageJSMProductTourMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/3cd8m6q81i47wxm8nt733jv5h885h064.webp"
};
const $3283639d1ff6b124$var$aiVideoMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/c57sisavif7febh3gsegy4vp55lm66v1.mp4"
};
const $3283639d1ff6b124$var$aiImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/3mo3s2f6q0xfbg75wj1fqyjayo6ta246.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/l3mu66v75b212vhbp3v18217neb26r30.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/25qwhvk4ue212kn22s30d38la4p58d81.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/4hhj8m4kmqh5es882153t0um1s327867.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/d5t1854qx65olc52p81k78p5336547sl.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/8mj2v25vh521026wl1f7wv3a7ts63cb0.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/avkee2xvjgp258dmf71tt5u060cr0bj4.webp"
};
const $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/ex8536t33720160jkps31diiavoq7wa6.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/t67x4j1qeis0c6330we56e5op7j58040.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/4863jx76lcis60cobj438qq2f76r6110.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/q5q45b8nf7dwl071122e311n0x2c8i6o.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/qd37iok4pb43q380hyxv8ran8iegwopd.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/8c4y5koi0roj2a5gl14ya60101g867dp.webp"
};
const $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/ye325r1c82vwe80p17v707876sor0v57.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/kc48608o743ijn83hfsc7248o0855n33.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/r0138653i47tn4bd3ms25o67277wb4en.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/25a73j3b325y5433sgkc4056k8u2bgs2.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/qyc8q4674b85g13bsliagfc2sv2nt1l7.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/rulhdo87w10h368w5k071a7544kfdi34.webp"
};
const $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/ue25kj6kn4wq0wn1qg02q56fyop66rj8.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/t1p200v6f4ug14ngayoyim42cy1618bc.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/684fjfuywyexc1a23u572wcj05fi84y0.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/m51m5bb51aj4548p81jssu7w660ro0f8.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/l01f0tas2w10qap5g6u81tcq516vg37x.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/smh5n4ctme1r523d1g3uf7lm60130o04.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/0j22k38v760owv56755oje0p37yeo711.webp"
};
const $3283639d1ff6b124$var$heroCardMarketingImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/m5hssc3g11uo84qx614br11443b744l3.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/63wxf44y8ut01ncxb0vo3g1762p76oe7.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/5u4x162411psnh2s22l4le4184aj4al3.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/30rrl683rurgws20103f520tec8a0b4r.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/q5gymh0604qp2b2vy2fiwymo6bcj5x47.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/6hq32u063ywsjill83o7v2a283g6jtq3.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/p3hnqjlr54wg1w56adkc254mb756ye22.webp"
};
const $3283639d1ff6b124$var$heroCardItImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/b00tc08w5880bt2xx078p24e142u0561.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/01oj3p2mmd1srk878al477q26840m1yv.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/fj108jc842621v46n6djd408300vcfod.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/vvuv40v0ibe0c2jh7xqdy3le0ev673np.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/tg55er46478ged8wg75q0muh70l03xp4.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/w2vr012658o07r84oikfd3vmw1728e31.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/sqst050suh056l837i652ato1382b4p0.webp"
};
const $3283639d1ff6b124$var$heroCardDesignImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/n831bpy2hv077jl7q3uvymb57bx0js6d.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/t7m1271fl2r40704e4u5i1r07b28bv3a.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/3v68u503i5xkawuuf45g6uq85syu7h05.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/686564sowva47fegxg4y73oi8o6d77s6.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/rvj516a70mqo3hu0lgv2si7h0w08015i.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/l0u14221yq50dk1khv04lunbo6k271fd.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/66sjkv3q65r33272rgr0y35m72726ekc.webp"
};
const $3283639d1ff6b124$var$heroCardOperationsImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/6w08m6f83182557c4n2gdqd5lc8bxgux.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/7t8ueumf388d67yap32075jv4n0w83lq.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/360yo8kpm3rl16l3d714vx8puhjs3a8x.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/p6ioacvwp466w8lh28582w86io78kv75.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/2hx5h0y3380nx822w58k37ou7lt382a0.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/b75eb832avo555l01i0tf77yfr23ai80.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/2y560886wr2048l0r4hxs6w5ym64doj7.webp"
};
const $3283639d1ff6b124$var$collaborateFirstImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/1u8phig8g50c70bnq25c6x5htq6b253w.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/25udrh4pt816l1xn2s76v5fbk866h103.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/71x7642o01xexq1j3j36318p8hp3l4a7.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/6g6278kp6hdn68of821401s82qbd3dc8.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/df3a577s74j71s4q86w3fw2xh7r0kpxv.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/khf18qf74wmj0l07o8wh834t2h473ofn.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/26i42bqsjw1p6528lnf58602d7sjyksj.webp"
};
const $3283639d1ff6b124$var$collaborateSecondImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/30ref08c2xjhdi3bypsd4l534o6343k6.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/u53361562rpcil174kh548pmj47wk23r.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/3it6mj67uqnn1kqqec0fili26xy1ad5a.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/h78h53re850ksk5b2u6mi3840u213jr7.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/cuikrei76g1lf48du36620j33lfkbaav.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/orake1uc43tel34v10d2lgp47pnkv65h.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/yykayg74usu65600v256n3sqnv6x6yov.webp"
};
const $3283639d1ff6b124$var$collaborateThirdImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/2tqg4ls4336u276d4f6y7rennjd1t742.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/866dvbo07ft271755xa204dm1p4ej1sa.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/vai65atabw3lwv7w0abi8w748gf3725m.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/c3b3d36p064m286t2w140a75imlk0b76.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/s8038n5n37vkf1w3c75iy7y1o7871a43.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/hi58ex76esr013c8kr8xys2p036873w2.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/5r0r46q12refy5k44k760k6g3tyiy7l0.webp"
};
const $3283639d1ff6b124$var$collaborateFourthImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/j7ib7le01l6x411v5h42l87m64l0f611.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/m88b68g3r0vsqpmoe60kf2sps5717w22.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/6wox43k7ynt50p8w10bx6yj464ohbi68.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/01076d8sr5n4102kr7mgk302120o1421.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/pxrvm8q420v080r6nk43l87l6j1jr5j7.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/34301480xcnvb0qv17v074o405q67r30.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/o80f05nbv41b7i2ug006675p00r6027r.webp"
};
const $3283639d1ff6b124$var$doubleFeatureFirstImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/754lk6c6s3xkb50hyimkf4aujig8h7e8.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/85025n6sg53gb1o54gw52sa0a8l5252y.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/kp1g7ob05s14rv38xrl478bak8j1enwc.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/6c3xt34m70oh8712kl7p3225la77fb25.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/e717x180w2841fge4313e207b27f0jlp.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/52w7e23sbeuy32p6y3n06w7e2082yhxu.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/v74q0j753uk82d464054gqr5u568dw5w.webp"
};
const $3283639d1ff6b124$var$doubleFeatureSecondImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/m8lju6a7edoja1ey3g865yj77rgt2n6j.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/iddw2873d71vdyu0wrmasn218jn87a7f.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/3e6ib72c51x05342cv48k07a0wo1jx7v.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/x64it50wnwrpqm50wye4140q63lm47y7.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/63apc7jibfy0ms6ntjv1486rcen53oc4.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/3761m3b1ktjte0puv5f23r67n0be6rg5.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/837mvx5jali362e7a7504m853u81l73w.webp"
};
const $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/41y0vfa38q60m5384dg7sa765mf4ro28.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/pr2e520p47gw100v5eep6831u755nm23.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/m5070g810735714b11i5081065621m4s.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/46du0bd600v7yneguim2p18s2bmx38vt.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/365d4k835x4xj45a5wf6r7u3i865283g.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/6smuygao6ka5l72ud1e80j6cw33a5107.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/0k440p3esv0l6u5c6dvgv2660166u7m4.webp"
};
const $3283639d1ff6b124$var$productMarketingModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/i58e36nty6p6km3a64v20ow565ecq126.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/hxx6isxs3m277360y8iub0e65pn6so78.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/j21lvt288m01q3m7g6f0l3d1bhjmdb24.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/7u5oc32sv0yh6q1vdh2u60jnq8dwy2vk.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/61nt5bt5l4sebtma1l3a7e6w400dae0g.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/ibp320cjl61b0rd8873ra2o332j266j4.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/wkx7n8q12fn88166l3y207e5f53xd646.webp"
};
const $3283639d1ff6b124$var$productItModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/75ous6w840rg1doie0203543yt22qnpa.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/r52381x63k34ljy2v248746pixvx76e5.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/d7q26epsti24r540gfcd4c5c1173cmc8.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/330645peuxhlid3577lr71073dm5ieyl.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/xpyktqf5jil6xah1xd7u54g8f08vi74j.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/7a7kgk12347go142kr1euulv6058uak6.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/p70x4xyevviso1is348gj5yuci5735pk.webp"
};
const $3283639d1ff6b124$var$updatedProductItModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/whjwswo26s750yn06387a0s80ehy3e52.webp"
};
const $3283639d1ff6b124$var$productDesignModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/b2x4amce3w8mn2b213mtx3r31n44403q.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/44u783fxt66o02mxf5lr7kbw1xty380i.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/08smrtsr040biq47toh66t6us66q1o00.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/7y78rlqj681mf1jlh7o65l525s6m7eya.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/1a3lwr5vav0fd2a3yp4ouw244u1d1u36.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/57dmhof07485d05q2cdubfx65vxs85ah.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/u11mi1pyr7ncq1ur1b2x20y0774185ru.webp"
};
const $3283639d1ff6b124$var$productOperationsModalImageMap = {
    en: "https://dam-cdn.atl.orangelogic.com/AssetLink/rf4b8d0jn3u85g7rn8uf8481a1n1t8l5.webp",
    fr: "https://dam-cdn.atl.orangelogic.com/AssetLink/q4hr0hm0ooqt42r0156010yevq5v3646.webp",
    es: "https://dam-cdn.atl.orangelogic.com/AssetLink/m5p21md0n60ec14qju78yfq7517sase0.webp",
    ja: "https://dam-cdn.atl.orangelogic.com/AssetLink/n1w6347fgj1icy62w6gmak63ty1i66rq.webp",
    ru: "https://dam-cdn.atl.orangelogic.com/AssetLink/7v5df3xyd24e02x68l71pi0vrpsi1h86.webp",
    br: "https://dam-cdn.atl.orangelogic.com/AssetLink/v1e777xn7wd21g22ytpg5t44d055li82.webp",
    de: "https://dam-cdn.atl.orangelogic.com/AssetLink/0eo1cu114id26b7ed48g46igo4j11pma.webp"
};
const $3283639d1ff6b124$export$6954fe49bbdabc54 = (locale)=>{
    return $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap[locale] || $3283639d1ff6b124$var$productSoftwareDevelopmentModalImageMap["en"];
};
const $3283639d1ff6b124$export$cc19a82b226e3f08 = (locale)=>{
    return $3283639d1ff6b124$var$productMarketingModalImageMap[locale] || $3283639d1ff6b124$var$productMarketingModalImageMap["en"];
};
const $3283639d1ff6b124$export$fa7e84d2d2c567a7 = (locale)=>{
    return $3283639d1ff6b124$var$productItModalImageMap[locale] || $3283639d1ff6b124$var$productItModalImageMap["en"];
};
const $3283639d1ff6b124$export$f31d1f714b55f0fb = (locale)=>{
    return $3283639d1ff6b124$var$updatedProductItModalImageMap[locale] || $3283639d1ff6b124$var$updatedProductItModalImageMap["en"];
};
const $3283639d1ff6b124$export$e0ab49165f0180f7 = (locale)=>{
    return $3283639d1ff6b124$var$productDesignModalImageMap[locale] || $3283639d1ff6b124$var$productDesignModalImageMap["en"];
};
const $3283639d1ff6b124$export$51a8246da0eeafec = (locale)=>{
    return $3283639d1ff6b124$var$productOperationsModalImageMap[locale] || $3283639d1ff6b124$var$productOperationsModalImageMap["en"];
};
const $3283639d1ff6b124$export$af7f348492750745 = (locale)=>{
    return $3283639d1ff6b124$var$doubleFeatureFirstImageMap[locale] || $3283639d1ff6b124$var$doubleFeatureFirstImageMap["en"];
};
const $3283639d1ff6b124$export$51c1e8c9994962ad = (locale)=>{
    return $3283639d1ff6b124$var$doubleFeatureSecondImageMap[locale] || $3283639d1ff6b124$var$doubleFeatureSecondImageMap["en"];
};
const $3283639d1ff6b124$export$7a98b35c48983fe6 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateFirstImageMap[locale] || $3283639d1ff6b124$var$collaborateFirstImageMap["en"];
};
const $3283639d1ff6b124$export$3ff8286854e1bb40 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateSecondImageMap[locale] || $3283639d1ff6b124$var$collaborateSecondImageMap["en"];
};
const $3283639d1ff6b124$export$54ce02c1025509fa = (locale)=>{
    return $3283639d1ff6b124$var$collaborateThirdImageMap[locale] || $3283639d1ff6b124$var$collaborateThirdImageMap["en"];
};
const $3283639d1ff6b124$export$ea3cb1bf26550cc6 = (locale)=>{
    return $3283639d1ff6b124$var$collaborateFourthImageMap[locale] || $3283639d1ff6b124$var$collaborateFourthImageMap["en"];
};
const $3283639d1ff6b124$export$a27f10b8f2dbe6ec = (locale)=>{
    return $3283639d1ff6b124$var$heroCardOperationsImageMap[locale] || $3283639d1ff6b124$var$heroCardOperationsImageMap["en"];
};
const $3283639d1ff6b124$export$d2a58a00fc2c43 = (locale)=>{
    return $3283639d1ff6b124$var$heroCardDesignImageMap[locale] || $3283639d1ff6b124$var$heroCardDesignImageMap["en"];
};
const $3283639d1ff6b124$export$e7e5a083e5974d8d = (locale)=>{
    return $3283639d1ff6b124$var$heroCardItImageMap[locale] || $3283639d1ff6b124$var$heroCardItImageMap["en"];
};
const $3283639d1ff6b124$export$bf236abab7f9a91d = (locale)=>{
    return $3283639d1ff6b124$var$heroCardMarketingImageMap[locale] || $3283639d1ff6b124$var$heroCardMarketingImageMap["en"];
};
const $3283639d1ff6b124$export$44d7a932d2767a7a = (locale)=>{
    return $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap[locale] || $3283639d1ff6b124$var$heroCardSoftwareDevelopmentImageMap["en"];
};
const $3283639d1ff6b124$export$2d0f6370ca103766 = (locale)=>{
    return $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap[locale] || $3283639d1ff6b124$var$staggaredDoubleFeautureSecondImageMap["en"];
};
const $3283639d1ff6b124$export$78335ebe3bbd9065 = (locale)=>{
    return $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap[locale] || $3283639d1ff6b124$var$staggaredDoubleFeautureFirstImageMap["en"];
};
const $3283639d1ff6b124$export$944f00714b8c3d98 = (locale)=>{
    return $3283639d1ff6b124$var$aiVideoMap[locale] || $3283639d1ff6b124$var$aiVideoMap["en"];
};
const $3283639d1ff6b124$export$2e497ec5a3f0e9f7 = (locale)=>{
    return $3283639d1ff6b124$var$aiImageMap[locale] || $3283639d1ff6b124$var$aiImageMap["en"];
};
const $3283639d1ff6b124$export$e88a1961b910936 = (locale)=>{
    return $3283639d1ff6b124$var$aiVideoJSMProductTourMap[locale] || $3283639d1ff6b124$var$aiVideoJSMProductTourMap["en"];
};
const $3283639d1ff6b124$export$be405a6adaf81ee7 = (locale)=>{
    return $3283639d1ff6b124$var$aiImageJSMProductTourMap[locale] || $3283639d1ff6b124$var$aiImageJSMProductTourMap["en"];
};

});


parcelRegister("1pbCD", function(module, exports) {
$parcel$export(module.exports, "Intelligence", function () { return $7ed9ae281286c3c7$export$f080dd2dfaa7a195; });

var $7VQPk = parcelRequire("7VQPk");
const $7ed9ae281286c3c7$export$f080dd2dfaa7a195 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    id: "Group 626186",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z",
                            fill: "url(#paint0_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z",
                            fill: "url(#paint1_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z",
                            fill: "url(#paint2_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_4",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z",
                            fill: "url(#paint3_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_5",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_6",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_7",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            id: "Vector (Stroke)_8",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint0_linear_2487_5195",
                            x1: "47.1571",
                            y1: "23.8756",
                            x2: "38.1517",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.270833",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint1_linear_2487_5195",
                            x1: "25.2872",
                            y1: "0.718933",
                            x2: "25.2872",
                            y2: "9.72432",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.1875",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint2_linear_2487_5195",
                            x1: "10.6981",
                            y1: "23.8756",
                            x2: "1.69272",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.791667",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                            id: "paint3_linear_2487_5195",
                            x1: "25.2872",
                            y1: "36.7404",
                            x2: "25.2872",
                            y2: "47.0323",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                    offset: "0.802083",
                                    stopColor: "#A6CCFE"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("b3ukl", function(module, exports) {
$parcel$export(module.exports, "FeaturedImages", function () { return $2ecc3b22ab257db2$export$946cd9d3a173e972; });
$parcel$export(module.exports, "FeaturedInfoSection", function () { return $2ecc3b22ab257db2$export$2e0f2d2dcf045a0b; });
$parcel$export(module.exports, "PLAN", function () { return (parcelRequire("kHvUj")).PLAN; });
$parcel$export(module.exports, "TRACK", function () { return (parcelRequire("kHvUj")).TRACK; });
$parcel$export(module.exports, "LAUNCH", function () { return (parcelRequire("kHvUj")).LAUNCH; });
$parcel$export(module.exports, "REPORT", function () { return (parcelRequire("kHvUj")).REPORT; });
/* featured-info.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable no-non-orangelogic-images-eslint

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kHvUj = parcelRequire("kHvUj");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $2ecc3b22ab257db2$var$featuresSectionStyles = null;
const $2ecc3b22ab257db2$var$featuresGridStyles = null;
const $2ecc3b22ab257db2$export$946cd9d3a173e972 = {
    collaborateAutomateWorkflows: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/collaborate-automate-workflows.webp",
    collaborateShareKeyResources: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/collaborate-share-key-resources.webp",
    collaborateStreamlineRequests: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/jswf-collaborate-streamline-requests-2.webp",
    planAlignWorkToGoals: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-align-work-to-goals.webp",
    planGetTheBigPicture: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-get-the-big-picture.webp",
    planJumpstartWithExpertTemplates: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-jumpstart-with-expert-templates.webp",
    planPlanAndAssignWork: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/plan-plan-and-assign-work.webp",
    reportLearnAsYouDeliver: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-learn-as-you-deliver-2.webp",
    reportShareRealTimeUpdates: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-share-real-time-updates.webp",
    reportTrackYourProgressToGoals: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-track-your-progress-to-goals-2.webp",
    reportUnderstandTeamPerformance: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/report-understand-team-performance-2.webp",
    trackManageDependencies: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-manage-dependencies.webp",
    trackMonitorProgress: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-monitor-progress.webp",
    trackRemoveManualWork: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-remove-manual-work.webp",
    trackTrackWorkWhereYouWork: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/track-track-work-where-you-work.webp",
    streamlineRequests: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/streamline-requests.webp",
    shareKeyResources: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jswf/share-key-resources.webp"
};
const $2ecc3b22ab257db2$export$2e0f2d2dcf045a0b = ({ variant: variant, eyebrow: eyebrow, header: header, description: description, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_11q71rga _ca0qckbl _u5f3idpf _n3tdckbl _19bvidpf"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kHvUj.FeaturedInfoHeader), {
                    variant: variant,
                    eyebrow: eyebrow,
                    header: header,
                    description: description
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _kqswh2mm _yv0ehkll _zulpzwfg _19pkidpf _2hwxzwfg _otyridpf _18u0zwfg _b8yq1nx3 _15flidpf _1d2w1wug _1svyidpf _seov1wug _1j8bfsjm _f2s5g31l"
                    ]),
                    children: children
                })
            ]
        })
    });
};

});
parcelRegister("kHvUj", function(module, exports) {
$parcel$export(module.exports, "PLAN", function () { return $8866872d119dba20$export$c303e491e026ebc6; });
$parcel$export(module.exports, "TRACK", function () { return $8866872d119dba20$export$23a21f8efe49e17f; });
$parcel$export(module.exports, "LAUNCH", function () { return $8866872d119dba20$export$609f530f49033bf7; });
$parcel$export(module.exports, "REPORT", function () { return $8866872d119dba20$export$e3d31417f21c1ce7; });
$parcel$export(module.exports, "FeaturedInfoHeader", function () { return $8866872d119dba20$export$4bbaf432f1794430; });
/* featured-info-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $8866872d119dba20$export$c303e491e026ebc6 = "plan";
const $8866872d119dba20$export$23a21f8efe49e17f = "track";
const $8866872d119dba20$export$609f530f49033bf7 = "launch";
const $8866872d119dba20$export$e3d31417f21c1ce7 = "report";
const $8866872d119dba20$var$containerStyles = null;
const $8866872d119dba20$var$planVariantStyles = null;
const $8866872d119dba20$var$trackVariantStyles = null;
const $8866872d119dba20$var$launchVariantStyles = null;
const $8866872d119dba20$var$reportVariantStyles = null;
const $8866872d119dba20$var$headerStyles = null;
const $8866872d119dba20$var$eyebrowStyles = null;
const $8866872d119dba20$var$PlanEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "46",
        height: "26",
        viewBox: "0 0 46 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M27.8179 8.5621L28.9492 7.54226C28.9492 7.54226 29.1999 6.94045 28.9993 6.53364C28.8767 6.28288 28.6873 6.03769 28.4811 5.84822C28.0631 5.46928 27.5672 5.34664 27.3498 5.94291C27.322 5.92619 27.2774 5.92622 27.2384 5.89835C27.1604 6.65623 26.2241 6.69528 25.8842 7.25812C26.018 7.35285 25.8731 7.28036 25.8731 7.28036C25.9232 7.87663 25.3548 8.2166 25.3548 8.22217C24.6137 9.36457 23.2539 10.6407 22.5908 11.9949L22.6186 12.006L22.641 12.0283C22.8862 12.0506 22.5295 12.3849 22.4905 12.2512C21.7047 12.658 20.646 13.8896 20.4899 14.7589C20.6571 14.8703 20.5679 15.0208 20.5233 14.9539C19.9605 14.9149 15.4912 19.7742 17.8819 19.6739L18.0268 19.8411C18.3556 19.5848 20.6292 17.6177 20.6459 17.64C21.1029 17.8796 21.0193 15.7174 21.493 16.6982C23.9951 16.2301 27.0991 10.5125 27.0991 10.5125L27.1715 9.83268C27.1715 9.83268 28.0742 9.27539 27.8123 8.55652L27.8179 8.5621Z",
                fill: (0, $kbpa7.wacToken)("color.neutral.light0")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.85401 4.95098L8.60878 4.31569C8.60878 4.31569 9.15488 3.40732 8.59204 2.88906L9.12706 1.4625C9.12706 1.4625 9.07134 0.810485 8.70912 0.542998C8.48064 0.375818 8.202 0.242056 7.93451 0.175184C7.39396 0.0302949 6.89243 0.14737 6.97045 0.782652C6.93701 0.782652 6.89795 0.799313 6.8478 0.79374C7.12643 1.50147 6.31288 1.96401 6.27387 2.62159C6.43548 2.64388 6.55806 2.69403 6.4689 2.69403L6.26829 2.64948C6.58593 3.15659 5.88373 3.29032 6.49672 3.81972L6.2404 3.71938C6.10666 5.07911 5.4825 6.82894 5.52151 8.33913H5.55498C5.55498 8.33913 5.64414 8.71807 5.55498 8.61776C5.04229 9.34221 4.67449 10.9193 4.92526 11.7607C5.12588 11.783 2.79095 18.5148 4.86397 17.3278L5.07016 17.4114C5.24291 17.0325 5.3822 16.7149 5.87816 16.3861C5.85587 16.3192 5.90047 16.3247 5.68314 16.2802C5.65527 16.2579 5.594 16.2189 5.50484 16.2077C4.98101 16.1074 6.70848 13.0257 6.70848 13.0257C8.71464 11.4598 8.84843 4.95656 8.84843 4.95656L8.85401 4.95098Z",
                fill: (0, $kbpa7.wacToken)("color.neutral.light0")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44.1735 17.8016C43.984 17.2722 43.6106 16.9267 43.1314 17.3503C43.1147 17.3224 43.0756 17.3001 43.0534 17.2555C42.6243 17.8852 41.7828 17.4728 41.2199 17.8128C41.2924 17.9577 41.1976 17.8295 41.1976 17.8295C40.958 18.3756 40.3004 18.409 40.3004 18.4146C39.1023 19.0722 37.3024 19.5459 36.082 20.4264L36.0987 20.4486L36.1098 20.4765C36.316 20.6103 35.8423 20.7384 35.8702 20.5991C34.9841 20.5824 33.4684 21.1675 32.9222 21.8529C33.017 22.0313 33.0672 21.5297 33.3792 22.1037C33.2009 22.1873 33.056 22.3545 32.8777 22.4214C32.7105 22.0313 32.8665 22.1204 32.8554 22.0424C32.3761 21.7415 26.1404 23.9037 28.2914 24.9458L28.3415 25.1631C28.7539 25.0907 29.6232 24.9235 29.5842 24.8399C29.3725 24.3551 31.6907 24.4331 31.6963 24.4665L32.8888 24.0374C35.3129 24.8065 40.7574 21.2511 40.7574 21.2511L41.1475 20.6883C41.1475 20.6883 42.2063 20.627 42.3177 19.8691L43.7945 19.5069C43.7945 19.5069 44.3016 19.0945 44.3128 18.6431C44.3239 18.3645 44.2737 18.0579 44.1846 17.796L44.1735 17.8016Z",
                fill: (0, $kbpa7.wacToken)("color.neutral.light0")
            })
        ]
    });
const $8866872d119dba20$var$TrackEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "43",
        height: "20",
        viewBox: "0 0 43 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.1672 6.20799C29.1522 -1.68807 19.1878 -0.0992864 12.5988 1.16576C9.10339 0.0506007 -6.62876 8.95992 3.16787 6.59171C7.3767 3.10833 21.6519 1.39363 29.518 4.72712C31.8203 2.91049 46.5871 12.3833 41.1612 6.20799H41.1672Z",
                fill: (0, $kbpa7.wacToken)("color.primary.black")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M34.6504 11.8079C29.9799 7.55705 23.1151 8.00677 20.2852 8.34252C22.5635 6.96356 16.5019 7.59904 15.5187 8.30051C16.478 8.24055 15.9745 8.85811 15.1771 8.92406C14.9252 7.26931 4.39719 11.1483 7.26304 13.1508C8.54008 12.4853 9.17553 13.0789 9.28944 11.7599C9.93096 13.3247 11.244 11.0884 11.6816 10.9145C12.6169 11.2203 12.593 11.598 13.8101 10.6927C15.4408 10.6927 17.773 11.1424 20.513 10.6328C24.3321 10.5069 26.4066 11.688 29.5662 11.9937C30.8972 12.4854 37.5462 15.627 34.6624 11.8199L34.6504 11.8079Z",
                fill: (0, $kbpa7.wacToken)("color.primary.black")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M28.9065 17.8751C27.0359 16.2983 24.6736 15.369 21.3641 15.5788C22.7551 16.736 21.4541 16.706 20.5668 16.1484C22.3295 14.8773 16.7837 15.1892 18.2106 16.2803C17.8389 16.5441 17.4252 16.3822 17.707 16.0824C15.6385 15.1412 9.31332 19.7457 14.4574 18.7505C14.2176 17.9351 15.1289 19.9256 15.8064 17.977C16.5978 18.5166 16.3459 18.8104 17.0414 18.061C17.7728 18.109 19.2118 19.0083 20.6807 18.4327C22.7731 17.9411 23.5346 19.7757 25.1054 18.7025C26.0407 19.5059 30.5013 20.3512 28.8945 17.8691L28.9065 17.8751Z",
                fill: (0, $kbpa7.wacToken)("color.primary.black")
            })
        ]
    });
const $8866872d119dba20$var$LaunchEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "58",
        height: "20",
        viewBox: "0 0 58 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M50.3635 18.9904C50.6395 18.4167 52.3934 17.7903 52.2324 17.1698C52.4164 17.2517 53.1467 16.561 53.0374 15.9171C55.1363 14.4477 58 10.0161 58 10.0161C58 10.0161 56.3036 6.15833 54.13 5.07533C54.0725 5.15729 48.1151 -1.82082 47.7068 1.34037C48.2186 1.5277 48.3221 3.24884 48.8742 2.55806C49.2939 1.75606 50.2887 3.78741 50.6568 3.86937C50.3865 4.7182 51.2548 5.73687 51.8758 5.83053C52.7844 7.10671 54.13 8.3418 54.13 8.3418C54.13 8.3418 47.3963 7.55744 45.1594 8.86289C44.1933 8.29505 25.6081 7.85015 32.6236 9.02096C31.1572 9.98688 25.2516 8.65797 29.1676 8.4004C18.5984 8.14282 13.0263 7.32917 0.979278 10.8123C-2.42494 12.3402 4.08448 12.1236 4.77452 11.5967C4.87803 11.1342 4.90103 10.8474 5.37257 10.9177C5.52208 12.6446 9.75435 10.2855 10.2604 10.3674C17.0631 11.4797 31.4678 10.461 40.2601 11.9128C42.3532 11.7957 51.0305 10.9411 52.5141 10.9411C53.9977 10.9411 53.0202 11.6084 52.0139 12.3695C51.9794 12.3695 51.9736 12.4456 51.8758 12.3812C51.7723 14.3189 50.444 15.8408 48.9087 17.1287C48.0806 17.7844 49.2537 20.694 50.3635 18.9904Z",
            fill: (0, $kbpa7.wacToken)("color.primary.black")
        })
    });
const $8866872d119dba20$var$ReportEyelash = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "51",
        height: "50",
        viewBox: "0 0 51 50",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M30.3513 23.6639C31.5684 22.8331 35.6575 18.0452 31.7445 19.1689C30.6929 20.0051 25.8724 26.4493 23.2247 29.7726C22.6428 28.4092 20.9719 26.9179 19.7495 26.1617C19.0074 25.4747 18.7085 26.6091 18.7085 26.6091C18.9167 26.9127 19.1356 27.392 19.6427 27.7754C20.2085 28.2015 20.2833 29.0855 21.2121 29.7619C24.4792 32.1319 23.0058 35.6202 26.1661 29.5754C27.2551 26.9232 29.9882 26.0605 30.3459 23.6639H30.3513Z",
                fill: (0, $kbpa7.wacToken)("color.primary.black")
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.9995 23.467C51.0262 16.5808 49.8999 5.78014 42.3943 3.2291C47.5991 10.1845 50.754 21.3899 47.8553 30.0123C45.1702 43.6729 24.4417 51.3366 11.9501 43.4225C13.2313 44.6368 16.162 46.0163 17.961 46.5488C13.1886 47.582 2.45871 35.5564 10.0551 42.1018C-11.5009 14.6262 22.6267 -11.651 42.2715 12.0806C36.6983 1.31722 22.2263 -2.3629 13.3114 2.87232C-29.6403 36.808 44.5296 76.9961 50.9942 23.467H50.9995Z",
                fill: (0, $kbpa7.wacToken)("color.primary.black")
            })
        ]
    });
const $8866872d119dba20$export$4bbaf432f1794430 = ({ variant: variant, eyebrow: eyebrow, header: header, description: description })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _p12f17kt _19pkidpf _2hwx1wug _otyridpf _18u01wug _1reozryt _1b3husvi _1pbyidpf _1kt9b3bt _1cs8stnw _dsq4glyw _1mp417kt _kfgtocp2 _1g0v1mrw _1tes1qqs _7dwzzr6s",
            variant === $8866872d119dba20$export$c303e491e026ebc6 && "_1ikbcd5j _1loecd5j _iwqycd5j _1rus17la _tgsmh130 _13zg1gqn _1tynglyw _1w7r13g9 _1m1v1827",
            variant === $8866872d119dba20$export$23a21f8efe49e17f && "_1rusmd2z _1mp41gvu _tgsm1iq9 _1ksz1b5c",
            variant === $8866872d119dba20$export$609f530f49033bf7 && "_1rusyamf _kfgt8re4 _tgsm14z4 _13zg1gqn _1tynglyw _6my9ocp2 _1cnl1uo2 _1w7r1827",
            variant === $8866872d119dba20$export$e3d31417f21c1ce7 && "_1rus9f4l _kfgtlwrb _tgsm19fw _13zg1gqn _1tynglyw _1cnl1hc7 _1w7r1uo2 _1m1v13g9"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_p19pmn": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime400")),
            "--_l6d3j7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.yellow200")),
            "--_k62i9u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple400"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc _19pkidpf _2hwx1wug _otyrzwfg _18u01wug _p12f1nx3 _ca0q4bvh _u5f3idpf _n3tdidpf _19bvidpf _1c58idpf _1fexidpf _1mh0idpf _av1ridpf _c5hwbxu3 _w7wbidpf _1iipidpf _6bnpidpf _cxn3idpf _dn1fbxu3 _178vidpf _obsiidpf _1qcbidpf _fzpmidpf _1rkbkd3c _1kmx4bvh _1ggmidpf _1ykzidpf _1maeidpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                    className: "h2",
                    children: header
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1f491mrw _1e0c1txw _2lx21bp4 _zulpdlk8"
                    ]),
                    children: [
                        variant === $8866872d119dba20$export$c303e491e026ebc6 && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$PlanEyelash, {}),
                        variant === $8866872d119dba20$export$23a21f8efe49e17f && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$TrackEyelash, {}),
                        variant === $8866872d119dba20$export$609f530f49033bf7 && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$LaunchEyelash, {}),
                        variant === $8866872d119dba20$export$e3d31417f21c1ce7 && /*#__PURE__*/ (0, $7VQPk.jsx)($8866872d119dba20$var$ReportEyelash, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: "eyebrow-md",
                            children: eyebrow
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "body-md",
                    children: description
                })
            ]
        })
    });
};

});


parcelRegister("hLTRc", function(module, exports) {
$parcel$export(module.exports, "TimelineIcon", function () { return $696d79ea84e61612$export$e5aa73ddcf9d62e8; });
$parcel$export(module.exports, "RedoIcon", function () { return $696d79ea84e61612$export$d275b7689549104e; });
$parcel$export(module.exports, "FastIcon", function () { return $696d79ea84e61612$export$74dd0403ff5f7484; });
$parcel$export(module.exports, "LaunchSection", function () { return $696d79ea84e61612$export$a181f92ca97e792; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $f11bi = parcelRequire("f11bi");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $82jSm = parcelRequire("82jSm");

var $b3ukl = parcelRequire("b3ukl");
var $kHvUj = parcelRequire("kHvUj");
const $696d79ea84e61612$export$e5aa73ddcf9d62e8 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0 5.26807L16.5 5.26807V1.51807L0 1.51807V5.26807Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1.5 17.2681L18 17.2681V13.5181L1.5 13.5181L1.5 17.2681Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M24 23.2681L7.5 23.2681V19.5181L24 19.5181V23.2681Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M6 11.2681L22.5 11.2681V7.51806L6 7.51807V11.2681Z",
                fill: "#1868DB"
            })
        ]
    });
const $696d79ea84e61612$export$d275b7689549104e = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M2.87302 12.5736C2.87302 8.60683 6.08876 5.39109 10.0556 5.39109C14.0224 5.39109 17.2381 8.60683 17.2381 12.5736V13.415L15.3809 11.5578L13.3494 13.5893L18.6747 18.9146L24 13.5893L21.9685 11.5578L20.1111 13.4151V12.5736C20.1111 7.0201 15.6091 2.51807 10.0556 2.51807C4.50203 2.51807 0 7.0201 0 12.5736C0 18.1272 4.50203 22.6292 10.0556 22.6292V19.7562C6.08876 19.7562 2.87302 16.5405 2.87302 12.5736Z",
            fill: "#1868DB"
        })
    });
const $696d79ea84e61612$export$74dd0403ff5f7484 = ({ size: size })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M0 15.1847L10.6667 0.518066V9.8514H17.3333L6.66667 24.5181V15.1847H0Z",
            fill: "#1868DB"
        })
    });
const $696d79ea84e61612$export$a181f92ca97e792 = ()=>{
    const intl = (0, $8e22h.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7999JiraFeatures);
    const launchSharedReleaseDatesImage = (0, $82jSm.useLocalizedImage)("launchSharedReleaseDatesImage");
    const launchYourFavoriteAppImage = (0, $82jSm.useLocalizedImage)("launchYourFavoriteAppImage");
    const launchWorkflowsAutomationImage = (0, $82jSm.useLocalizedImage)("launchWorkflowsAutomationImage");
    if (showGwp7999JiraFeaturesUpdates) return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $b3ukl.FeaturedInfoSection), {
        variant: (0, $kHvUj.LAUNCH),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Eyebrow",
            defaultMessage: "Collaborate"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Header",
            defaultMessage: "Get every team on the same page"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Description",
            defaultMessage: "Jira brings teams, tools, and AI together to keep the entire org in sync and deliver impact faster."
        }),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $b3ukl.FeaturedImages).collaborateStreamlineRequests,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Alt",
                            defaultMessage: "Forms in Jira"
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$e5aa73ddcf9d62e8,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Header",
                    defaultMessage: "Streamline Requests"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.StreamlineRequests.Description",
                    defaultMessage: "Make it easy for partner teams to submit requests and track progress with forms."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $b3ukl.FeaturedImages).collaborateShareKeyResources,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Alt",
                            defaultMessage: "Release management in Jira"
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$d275b7689549104e,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Header",
                    defaultMessage: "Share key resources"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.ShareResources.Description",
                    defaultMessage: "Keep everyone aligned by sharing key resources like content calendars or release announcements."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $b3ukl.FeaturedImages).collaborateAutomateWorkflows,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Alt",
                            defaultMessage: "Manage workflows in Jira"
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$74dd0403ff5f7484,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Header",
                    defaultMessage: "Automate workflows"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999LaunchSection.Card.AutomateWorkflows.Description",
                    defaultMessage: "Scale processes and save time with customizable workflows that integrate with your tech stack."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $b3ukl.FeaturedInfoSection), {
        variant: (0, $kHvUj.LAUNCH),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Eyebrow",
            defaultMessage: "Collaborate and launch"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Header",
            defaultMessage: "Connect, collaborate, celebrate"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Description",
            defaultMessage: "Jira better connects teams and work for more seamless collaboration and faster alignment."
        }),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchSharedReleaseDatesImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.ImageAlt",
                            defaultMessage: "Shared release date module in Jira"
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$e5aa73ddcf9d62e8,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.Header",
                    defaultMessage: "Shared release dates"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.ReleaseDates.Description",
                    defaultMessage: "The only place where teams who make your product are connected to teams who launch it. When dates change, every team is in the know."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchYourFavoriteAppImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.ImageAlt",
                            defaultMessage: "Slack and Jira integration"
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$d275b7689549104e,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.Header",
                    defaultMessage: "Slack, Figma, {openBracket}your favorite app{closeBracket} "
                }, {
                    openBracket: "<",
                    closeBracket: ">"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.SlackFigma.Description",
                    defaultMessage: "Bring in real-time data and information from popular 3rd party apps like Slack, Figma, and GitHub, so Jira becomes your team\u2019s trusted source for information."
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $f11bi.FeaturedInfoCard), {
                image: {
                    image: {
                        src: launchWorkflowsAutomationImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowAutomation.ImageAlt",
                            defaultMessage: "Workflow trigger setup screen in Jira"
                        })
                    }
                },
                Icon: $696d79ea84e61612$export$74dd0403ff5f7484,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowsAutomation.Header",
                    defaultMessage: "Workflows and automation"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightLaunchSection.Card.WorkflowAutomation.Description",
                    defaultMessage: "Save time and scale your work confidently with no-code automation and workflows, like approvals, that keeps work moving forward when no one is watching."
                })
            })
        ]
    });
};

});
parcelRegister("82jSm", function(module, exports) {
$parcel$export(module.exports, "useLocalizedImage", function () { return $6c5cccb5cc778b4c$export$351d137f57ab4fe2; });

var $8e22h = parcelRequire("8e22h");
/**
 * Enforces that values in `imageMaps` satisfy the type `ImageMap`
 * while still allowing for the keys in `imageMaps`
 * to be extracted and used as a union type.
 */ const $6c5cccb5cc778b4c$var$createImageMaps = (imageMaps)=>imageMaps;
/**
 * A map of image ids to their localized URLs.
 *
 * The keys in the map are the ids that should be passed to `useLocalizedImage`.
 * The values are objects thap map locales to URLs for localized images.
 * Note that the `en` is required!
 */ const $6c5cccb5cc778b4c$var$imageMaps = $6c5cccb5cc778b4c$var$createImageMaps({
    // Add image ids and their localized URLs here
    heroImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/image-368080789.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_es-ES-280262892.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_hu-HU-1564215628.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_ko-KR-2299841745.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-nl-NL-29055006.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_ru-RU-3031695244.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Herofr-FR-34984137.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Heroit-IT-215402249.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Heroptbr-PTBR-2288648393.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero_de-DE-3182006582.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-1517722948.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-1037378293.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Hero-2582835035.webp"
    },
    planLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-1878220112.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_es-ES-2320946370.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_hu-HU-219670370.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_ko-KR-830423807.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_nl-NL-2786930498.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_ru-RU-3701573538.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planfr-FR-3457271915.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planit-IT-3195604523.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Planptbr-PTBR-3247145579.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_de-DE-2971266205.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-1551581806.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan-2929654303.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001%20Plan_zh-CN-681007050.webp"
    },
    trackLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-61709455.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_es-ES-3383229661.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_hu-HU-28375869.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_ko-KR-1956228992.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_nl-NL-1580836701.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_ru-RU-1652057597.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackfr-FR-545895028.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackit-IT-3805011636.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Trackptbr-PTBR-1151313332.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_de-DE-1856152322.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-1287427121.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track-2267954944.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002%20Track_zh-CN-2298675573.webp"
    },
    collaborateLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-1370881390.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_es-ES-3256840060.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_hu-HU-2907439260.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_ko-KR-1915737025.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_nl-NL-3907414524.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_ru-RU-1681301724.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabfr-FR-306933269.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabit-IT-2959014357.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collabptbr-PTBR-1526398485.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_de-DE-3903230755.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-559675728.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab-2507891681.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003%20Collab_zh-CN-3730365236.webp"
    },
    launchLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-3779179643.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_es-ES-1284707561.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_hu-HU-4125799561.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_ko-KR-804198996.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_nl-NL-1935282025.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_ru-RU-3225671625.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchfr-FR-492072672.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchit-IT-2893616864.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launchptbr-PTBR-177406496.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_de-DE-3859546614.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-236640965.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch-724975156.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004%20Launch_zh-CN-3721511201.webp"
    },
    reportLabelImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-161454665.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_es-ES-585529307.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_hu-HU-388065915.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_ko-KR-403646438.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_nl-NL-1236103771.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_ru-RU-3382627771.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportfr-FR-426962258.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportit-IT-2146252498.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Reportptbr-PTBR-1506788626.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_de-DE-1473304260.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-1135116023.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report-3347665734.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/005%20Report_zh-CN-2860637139.webp"
    },
    planListViewImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-list-view-194474286.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2187812077.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-529772653.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-912241933.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3071040621.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-1543276909.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-4036874011.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-1435305947.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1646874907.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-3074059530.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-948026910.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-4156364335.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-248550045.webp"
    },
    planCalendarImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-calendar-view-3686747294.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-4180018574.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-2766112334.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3040982382.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-751132046.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-3037425358.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-264278680.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-774319384.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-2340951128.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-852905257.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-528338429.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1352144332.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-92973118.webp"
    },
    planSprintsBacklogImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-sprints-backlog-3533034495.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-111313327.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2885932719.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-2978588495.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-3774460207.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-4230471727.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-726055961.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-2656446425.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-891882521.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3628604488.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-3756990428.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-846581101.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-1061927263.webp"
    },
    planTimelineImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/plan-timeline-4119095287.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-1062283080.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-3613163400.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-3905143976.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-629198920.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-631159688.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-1420566174.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-3283003422.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-3398383966.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-3798227823.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-2344293819.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-65640202.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-43781880.webp"
    },
    trackProjectBoardsImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-project-boards-1345608737.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2893710705.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-1128889137.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1991995121.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3117326833.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-2679980209.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-775791207.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-3559459943.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1057291367.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-2702397782.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-2821188546.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-3940287731.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-2162175841.webp"
    },
    trackTaskManagementImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-task-management-158514083.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-1304081970.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-3046449970.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-4045234866.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-1847663410.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-143791666.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-3937704452.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-2056260804.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-1262140356.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-2273949461.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1980867905.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-3060959664.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-1124331746.webp"
    },
    trackDependencyManagementImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-dependency-management-3383416513.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-519446131.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2597762739.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-2710641267.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-948636659.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-805907123.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-3862859045.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-899278885.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-561550885.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3571317332.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-681376448.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-792789361.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-3400868451.webp"
    },
    trackGoalTrackingImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/track-goal-tracking-2550106487.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-3670223412.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-3589060020.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-1965549108.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-1673756468.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-2335341108.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-34424514.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-3310367362.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-2386394754.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-2554936851.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-3474928967.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-2541054262.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-2539167460.webp"
    },
    launchSharedReleaseDatesImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-shared-release-dates-1278148773.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-2825366097.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-17543633.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1641702961.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-3905234641.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-1474490321.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-1231209191.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-2864685991.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-1060273383.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-336816374.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-3868783586.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-1515546771.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-1419555617.webp"
    },
    launchYourFavoriteAppImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-your-favorite-app-2394898694.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-3521797326.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-436086830.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3646187539.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-2753210190.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-772035182.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-2890898724.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-659776164.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-1851042404.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-1088218453.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-3724103425.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-22237808.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-1063538050.webp"
    },
    launchWorkflowsAutomationImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-workflows-automation-2356540848.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-1136820627.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-1318620819.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-4096002803.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-701640211.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-1260566547.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-742697573.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-555982117.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-3107713637.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-816862644.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-671006752.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-3547956049.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-2248394595.webp"
    },
    reportPlanYourWorkImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-plan-your-work-3125149458.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_es-ES-632410416.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-3065455472.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KR-1532904656.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-1310062384.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ru-RU-2476318832.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-3982217318.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001it-IT-2788550118.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-2400170662.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-1437448791.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-428996611.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-573869554.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_zh-CN-2842346112.webp"
    },
    reportDuringYourProjectImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-during-your-project-3187559990.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_es-ES-2948979027.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_hu-HU-3833184595.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ko-KR-3046902707.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_nl-NL-373810899.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_ru-RU-937298899.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002fr-FR-2722552485.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002it-IT-1760744037.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002ptbr-PTBR-2857878437.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_de-DE-384230900.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-1804751584.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002-873723665.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/002_zh-CN-2609941795.webp"
    },
    reportWhenYouLaunchImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-when-you-launch-1999669051.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_es-ES-184654834.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_hu-HU-2168975026.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ko-KR-933027090.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_nl-NL-3642225138.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_ru-RU-116775218.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003fr-FR-1939314020.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003it-IT-1748958436.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003ptbr-PTBR-4034521252.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_de-DE-3037516437.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-4127636161.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003-912760624.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/003_zh-CN-1622278210.webp"
    },
    reportBringItAllTogetherImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/report-bring-it-all-together-2435824002.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_es-ES-35668245.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_hu-HU-1879148693.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ko-KR-681638133.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_nl-NL-1789762965.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_ru-RU-2525782933.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004fr-FR-904249251.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004it-IT-1751247971.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004ptbr-PTBR-966252707.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_de-DE-1966850610.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-92672934.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004-1929635927.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/004_zh-CN-4274294245.webp"
    },
    artificialIntelligenceImage: {
        en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/artificial-intelligence-2046937004.webp",
        es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Image%20AI001_es-ES%201_es-ES-989623482.webp",
        hu: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_hu-HU-3851804662.webp",
        ko: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_ko-KO-813949256.webp",
        nl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_nl-NL-1612463222.webp",
        ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/AI_Smart%20summary_JSW%201_ru-RU-2161971397.webp",
        fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001fr-FR-1823876768.webp",
        it: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_it-IT-2008232250.webp",
        br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001ptbr-PTBR-3467326432.webp",
        de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001_de-DE-1473393171.webp",
        jp: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-440488517.webp",
        pl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-928822708.webp",
        zh: "https://wac-cdn.atlassian.com/misc-assets/webp-images/001-2477633690.webp"
    }
});
function $6c5cccb5cc778b4c$export$351d137f57ab4fe2(id) {
    const intl = (0, $8e22h.default)();
    const imageMap = $6c5cccb5cc778b4c$var$imageMaps[id];
    var _imageMap_intl_locale;
    return (_imageMap_intl_locale = imageMap[intl.locale]) !== null && _imageMap_intl_locale !== void 0 ? _imageMap_intl_locale : imageMap.en;
}

});


parcelRegister("evmye", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("5huaA")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("ljd5i")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("jjx9d")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $ixLXc = parcelRequire("ixLXc");

var $KrnvM = parcelRequire("KrnvM");
parcelRequire("dfFgi");
var $gUjjH = parcelRequire("gUjjH");

var $3YZxS = parcelRequire("3YZxS");

var $jjx9d = parcelRequire("jjx9d");

var $k4dLS = parcelRequire("k4dLS");
parcelRequire("aZyKU");
(0, $jjx9d.initializeUseSelector)((0, $KrnvM.useSyncExternalStoreWithSelector));
(0, $k4dLS.initializeConnect)((0, $ixLXc.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $3YZxS.setBatch)((0, $gUjjH.unstable_batchedUpdates));

});
parcelRegister("dfFgi", function(module, exports) {
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("gUjjH")).unstable_batchedUpdates; });

var $gUjjH = parcelRequire("gUjjH");

});

parcelRegister("3YZxS", function(module, exports) {
$parcel$export(module.exports, "setBatch", function () { return $2e66b756d4258c8a$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $2e66b756d4258c8a$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $2e66b756d4258c8a$var$defaultNoopBatch(callback) {
    callback();
}
let $2e66b756d4258c8a$var$batch = $2e66b756d4258c8a$var$defaultNoopBatch; // Allow injecting another batching function later
const $2e66b756d4258c8a$export$4b9874722d0da7bc = (newBatch)=>$2e66b756d4258c8a$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $2e66b756d4258c8a$export$fc47d4c0ba3bd2c6 = ()=>$2e66b756d4258c8a$var$batch;

});

parcelRegister("jjx9d", function(module, exports) {
$parcel$export(module.exports, "initializeUseSelector", function () { return $e0f981148329114b$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $e0f981148329114b$export$2105062e25df4afe; });

var $1oC0p = parcelRequire("1oC0p");

var $dqXUQ = parcelRequire("dqXUQ");

var $6llk2 = parcelRequire("6llk2");

var $hJtym = parcelRequire("hJtym");
let $e0f981148329114b$var$useSyncExternalStoreWithSelector = (0, $hJtym.notInitialized);
const $e0f981148329114b$export$e2e6e3f3f3b782e3 = (fn)=>{
    $e0f981148329114b$var$useSyncExternalStoreWithSelector = fn;
};
const $e0f981148329114b$var$refEquality = (a, b)=>a === b;
function $e0f981148329114b$export$2b53f90d2bd1cbfb(context = (0, $6llk2.ReactReduxContext)) {
    const useReduxContext = context === (0, $6llk2.ReactReduxContext) ? (0, $dqXUQ.useReduxContext) : (0, $dqXUQ.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $e0f981148329114b$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $1oC0p.useRef)(true);
        const wrappedSelector = (0, $1oC0p.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $e0f981148329114b$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $1oC0p.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $e0f981148329114b$export$2105062e25df4afe = /*#__PURE__*/ $e0f981148329114b$export$2b53f90d2bd1cbfb();

});
parcelRegister("dqXUQ", function(module, exports) {
$parcel$export(module.exports, "createReduxContextHook", function () { return $9c7c2e159092eda4$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $9c7c2e159092eda4$export$c1275ca9a6fd3ec5; });

var $1oC0p = parcelRequire("1oC0p");

var $6llk2 = parcelRequire("6llk2");
function $9c7c2e159092eda4$export$d4d6226d5fc61558(context = (0, $6llk2.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $1oC0p.useContext)(context);
        return contextValue;
    };
}
const $9c7c2e159092eda4$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $9c7c2e159092eda4$export$d4d6226d5fc61558();

});
parcelRegister("6llk2", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", function () { return $49e53e5d370fc464$export$cc80c08dc91f1c00; });

var $1oC0p = parcelRequire("1oC0p");
const $49e53e5d370fc464$var$ContextKey = Symbol.for(`react-redux-context`);
const $49e53e5d370fc464$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $49e53e5d370fc464$var$getContext() {
    var _gT$ContextKey;
    if (!$1oC0p.createContext) return {};
    const contextMap = (_gT$ContextKey = $49e53e5d370fc464$var$gT[$49e53e5d370fc464$var$ContextKey]) != null ? _gT$ContextKey : $49e53e5d370fc464$var$gT[$49e53e5d370fc464$var$ContextKey] = new Map();
    let realContext = contextMap.get($1oC0p.createContext);
    if (!realContext) {
        realContext = $1oC0p.createContext(null);
        contextMap.set($1oC0p.createContext, realContext);
    }
    return realContext;
}
const $49e53e5d370fc464$export$cc80c08dc91f1c00 = /*#__PURE__*/ $49e53e5d370fc464$var$getContext();
var $49e53e5d370fc464$export$2e2bcd8739ae039 = $49e53e5d370fc464$export$cc80c08dc91f1c00;

});


parcelRegister("hJtym", function(module, exports) {
$parcel$export(module.exports, "notInitialized", function () { return $ce8d904e7b5f1467$export$20656a4825650bd0; });
const $ce8d904e7b5f1467$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("k4dLS", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", function () { return $e9bedd0684062466$export$36d45daa6a4925b8; });

var $h5n66 = parcelRequire("h5n66");

var $fJo36 = parcelRequire("fJo36");

var $6PuZm = parcelRequire("6PuZm");

var $1oC0p = parcelRequire("1oC0p");

var $i98sK = parcelRequire("i98sK");

var $jUj8J = parcelRequire("jUj8J");

var $2SNac = parcelRequire("2SNac");

var $9Vog3 = parcelRequire("9Vog3");

var $asxdX = parcelRequire("asxdX");

var $1iuz7 = parcelRequire("1iuz7");

var $iQ6YZ = parcelRequire("iQ6YZ");

var $7yj9S = parcelRequire("7yj9S");
parcelRequire("7PpWx");

var $6llk2 = parcelRequire("6llk2");

var $hJtym = parcelRequire("hJtym");
const $e9bedd0684062466$var$_excluded = [
    "reactReduxForwardedRef"
];
let $e9bedd0684062466$var$useSyncExternalStore = (0, $hJtym.notInitialized);
const $e9bedd0684062466$export$36d45daa6a4925b8 = (fn)=>{
    $e9bedd0684062466$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $e9bedd0684062466$var$EMPTY_ARRAY = [
    null,
    0
];
const $e9bedd0684062466$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $e9bedd0684062466$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $e9bedd0684062466$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $e9bedd0684062466$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $e9bedd0684062466$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $e9bedd0684062466$var$initStateUpdates = ()=>$e9bedd0684062466$var$EMPTY_ARRAY;
function $e9bedd0684062466$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $e9bedd0684062466$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $e9bedd0684062466$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $e9bedd0684062466$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $7yj9S.default), areStatePropsEqual: areStatePropsEqual = (0, $7yj9S.default), areMergedPropsEqual: areMergedPropsEqual = (0, $7yj9S.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $6llk2.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $9Vog3.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $2SNac.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $asxdX.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $1oC0p.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $fJo36.default)(props, $e9bedd0684062466$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $1oC0p.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $i98sK.isContextConsumer)(/*#__PURE__*/ $1oC0p.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $1oC0p.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $1oC0p.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $jUj8J.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $1oC0p.useMemo(()=>{
                if (!shouldHandleStateChanges) return $e9bedd0684062466$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $1iuz7.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $1oC0p.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $h5n66.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $1oC0p.useRef();
            const lastWrapperProps = $1oC0p.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $1oC0p.useRef();
            const renderIsScheduled = $1oC0p.useRef(false);
            const isProcessingDispatch = $1oC0p.useRef(false);
            const isMounted = $1oC0p.useRef(false);
            const latestSubscriptionCallbackError = $1oC0p.useRef();
            (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $1oC0p.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $1oC0p.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $e9bedd0684062466$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $e9bedd0684062466$var$useIsomorphicLayoutEffectWithArgs($e9bedd0684062466$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $e9bedd0684062466$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $1oC0p.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $1oC0p.createElement(WrappedComponent, (0, $h5n66.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $1oC0p.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $1oC0p.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $1oC0p.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $1oC0p.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $1oC0p.createElement(Connect, (0, $h5n66.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($6PuZm)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $e9bedd0684062466$export$2e2bcd8739ae039 = $e9bedd0684062466$var$connect;

});
parcelRegister("h5n66", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c704d1fda4c81db7$export$2e2bcd8739ae039; });
function $c704d1fda4c81db7$export$2e2bcd8739ae039() {
    return $c704d1fda4c81db7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c704d1fda4c81db7$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fJo36", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b73db6a01b7d7910$export$2e2bcd8739ae039; });
function $b73db6a01b7d7910$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("i98sK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jT1Rh"));

});
parcelRegister("jT1Rh", function(module, exports) {
$parcel$export(module.exports, "ContextConsumer", function () { return $e7a49864e45a9be5$export$a7c73072b1a182ae; }, function (v) { return $e7a49864e45a9be5$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e7a49864e45a9be5$export$9f27bc3417b4524d; }, function (v) { return $e7a49864e45a9be5$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e7a49864e45a9be5$export$db77ccec0bb4ccac; }, function (v) { return $e7a49864e45a9be5$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e7a49864e45a9be5$export$8392c0c9d3dcbd35; }, function (v) { return $e7a49864e45a9be5$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e7a49864e45a9be5$export$ffb0004e005737fa; }, function (v) { return $e7a49864e45a9be5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e7a49864e45a9be5$export$b624eff549462981; }, function (v) { return $e7a49864e45a9be5$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e7a49864e45a9be5$export$7897aa7841a5380c; }, function (v) { return $e7a49864e45a9be5$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e7a49864e45a9be5$export$602eac185826482c; }, function (v) { return $e7a49864e45a9be5$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e7a49864e45a9be5$export$e2c29f18771995cb; }, function (v) { return $e7a49864e45a9be5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e7a49864e45a9be5$export$5f8d39834fd61797; }, function (v) { return $e7a49864e45a9be5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e7a49864e45a9be5$export$74bf444e3cd11ea5; }, function (v) { return $e7a49864e45a9be5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $e7a49864e45a9be5$export$998bcd577473dd93; }, function (v) { return $e7a49864e45a9be5$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e7a49864e45a9be5$export$92387174baf9b227; }, function (v) { return $e7a49864e45a9be5$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e7a49864e45a9be5$export$ec112efeb987d9c6; }, function (v) { return $e7a49864e45a9be5$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e7a49864e45a9be5$export$b706b080d889d2c9; }, function (v) { return $e7a49864e45a9be5$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e7a49864e45a9be5$export$5be5a87408f70ddc; }, function (v) { return $e7a49864e45a9be5$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e7a49864e45a9be5$export$45a5e7f76e0caa8d; }, function (v) { return $e7a49864e45a9be5$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e7a49864e45a9be5$export$455c2e768291efa6; }, function (v) { return $e7a49864e45a9be5$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e7a49864e45a9be5$export$9522e17588c12572; }, function (v) { return $e7a49864e45a9be5$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e7a49864e45a9be5$export$2110ac352bb060b9; }, function (v) { return $e7a49864e45a9be5$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e7a49864e45a9be5$export$56885ab8b9c456ab; }, function (v) { return $e7a49864e45a9be5$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e7a49864e45a9be5$export$d927fcb6adf8f9de; }, function (v) { return $e7a49864e45a9be5$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e7a49864e45a9be5$export$b82d16f27459e05a; }, function (v) { return $e7a49864e45a9be5$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e7a49864e45a9be5$export$522c17b4f5e123e8; }, function (v) { return $e7a49864e45a9be5$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e7a49864e45a9be5$export$1aabd8a0274ecfd6; }, function (v) { return $e7a49864e45a9be5$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $e7a49864e45a9be5$export$3d6c20d97e46b957; }, function (v) { return $e7a49864e45a9be5$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e7a49864e45a9be5$export$9b621391a187a31a; }, function (v) { return $e7a49864e45a9be5$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e7a49864e45a9be5$export$f5bbd400c2f4426f; }, function (v) { return $e7a49864e45a9be5$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e7a49864e45a9be5$export$a7c73072b1a182ae;
var $e7a49864e45a9be5$export$9f27bc3417b4524d;
var $e7a49864e45a9be5$export$db77ccec0bb4ccac;
var $e7a49864e45a9be5$export$8392c0c9d3dcbd35;
var $e7a49864e45a9be5$export$ffb0004e005737fa;
var $e7a49864e45a9be5$export$b624eff549462981;
var $e7a49864e45a9be5$export$7897aa7841a5380c;
var $e7a49864e45a9be5$export$602eac185826482c;
var $e7a49864e45a9be5$export$e2c29f18771995cb;
var $e7a49864e45a9be5$export$5f8d39834fd61797;
var $e7a49864e45a9be5$export$74bf444e3cd11ea5;
var $e7a49864e45a9be5$export$998bcd577473dd93;
var $e7a49864e45a9be5$export$92387174baf9b227;
var $e7a49864e45a9be5$export$ec112efeb987d9c6;
var $e7a49864e45a9be5$export$b706b080d889d2c9;
var $e7a49864e45a9be5$export$5be5a87408f70ddc;
var $e7a49864e45a9be5$export$45a5e7f76e0caa8d;
var $e7a49864e45a9be5$export$455c2e768291efa6;
var $e7a49864e45a9be5$export$9522e17588c12572;
var $e7a49864e45a9be5$export$2110ac352bb060b9;
var $e7a49864e45a9be5$export$56885ab8b9c456ab;
var $e7a49864e45a9be5$export$d927fcb6adf8f9de;
var $e7a49864e45a9be5$export$b82d16f27459e05a;
var $e7a49864e45a9be5$export$522c17b4f5e123e8;
var $e7a49864e45a9be5$export$1aabd8a0274ecfd6;
var $e7a49864e45a9be5$export$3d6c20d97e46b957;
var $e7a49864e45a9be5$export$9b621391a187a31a;
var $e7a49864e45a9be5$export$f5bbd400c2f4426f;
'use strict';
var $e7a49864e45a9be5$var$b = Symbol.for("react.element"), $e7a49864e45a9be5$var$c = Symbol.for("react.portal"), $e7a49864e45a9be5$var$d = Symbol.for("react.fragment"), $e7a49864e45a9be5$var$e = Symbol.for("react.strict_mode"), $e7a49864e45a9be5$var$f = Symbol.for("react.profiler"), $e7a49864e45a9be5$var$g = Symbol.for("react.provider"), $e7a49864e45a9be5$var$h = Symbol.for("react.context"), $e7a49864e45a9be5$var$k = Symbol.for("react.server_context"), $e7a49864e45a9be5$var$l = Symbol.for("react.forward_ref"), $e7a49864e45a9be5$var$m = Symbol.for("react.suspense"), $e7a49864e45a9be5$var$n = Symbol.for("react.suspense_list"), $e7a49864e45a9be5$var$p = Symbol.for("react.memo"), $e7a49864e45a9be5$var$q = Symbol.for("react.lazy"), $e7a49864e45a9be5$var$t = Symbol.for("react.offscreen"), $e7a49864e45a9be5$var$u;
$e7a49864e45a9be5$var$u = Symbol.for("react.module.reference");
function $e7a49864e45a9be5$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $e7a49864e45a9be5$var$b:
                switch(a = a.type, a){
                    case $e7a49864e45a9be5$var$d:
                    case $e7a49864e45a9be5$var$f:
                    case $e7a49864e45a9be5$var$e:
                    case $e7a49864e45a9be5$var$m:
                    case $e7a49864e45a9be5$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e7a49864e45a9be5$var$k:
                            case $e7a49864e45a9be5$var$h:
                            case $e7a49864e45a9be5$var$l:
                            case $e7a49864e45a9be5$var$q:
                            case $e7a49864e45a9be5$var$p:
                            case $e7a49864e45a9be5$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $e7a49864e45a9be5$var$c:
                return r;
        }
    }
}
$e7a49864e45a9be5$export$a7c73072b1a182ae = $e7a49864e45a9be5$var$h;
$e7a49864e45a9be5$export$9f27bc3417b4524d = $e7a49864e45a9be5$var$g;
$e7a49864e45a9be5$export$db77ccec0bb4ccac = $e7a49864e45a9be5$var$b;
$e7a49864e45a9be5$export$8392c0c9d3dcbd35 = $e7a49864e45a9be5$var$l;
$e7a49864e45a9be5$export$ffb0004e005737fa = $e7a49864e45a9be5$var$d;
$e7a49864e45a9be5$export$b624eff549462981 = $e7a49864e45a9be5$var$q;
$e7a49864e45a9be5$export$7897aa7841a5380c = $e7a49864e45a9be5$var$p;
$e7a49864e45a9be5$export$602eac185826482c = $e7a49864e45a9be5$var$c;
$e7a49864e45a9be5$export$e2c29f18771995cb = $e7a49864e45a9be5$var$f;
$e7a49864e45a9be5$export$5f8d39834fd61797 = $e7a49864e45a9be5$var$e;
$e7a49864e45a9be5$export$74bf444e3cd11ea5 = $e7a49864e45a9be5$var$m;
$e7a49864e45a9be5$export$998bcd577473dd93 = $e7a49864e45a9be5$var$n;
$e7a49864e45a9be5$export$92387174baf9b227 = function() {
    return !1;
};
$e7a49864e45a9be5$export$ec112efeb987d9c6 = function() {
    return !1;
};
$e7a49864e45a9be5$export$b706b080d889d2c9 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$h;
};
$e7a49864e45a9be5$export$5be5a87408f70ddc = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$g;
};
$e7a49864e45a9be5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e7a49864e45a9be5$var$b;
};
$e7a49864e45a9be5$export$455c2e768291efa6 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$l;
};
$e7a49864e45a9be5$export$9522e17588c12572 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$d;
};
$e7a49864e45a9be5$export$2110ac352bb060b9 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$q;
};
$e7a49864e45a9be5$export$56885ab8b9c456ab = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$p;
};
$e7a49864e45a9be5$export$d927fcb6adf8f9de = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$c;
};
$e7a49864e45a9be5$export$b82d16f27459e05a = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$f;
};
$e7a49864e45a9be5$export$522c17b4f5e123e8 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$e;
};
$e7a49864e45a9be5$export$1aabd8a0274ecfd6 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$m;
};
$e7a49864e45a9be5$export$3d6c20d97e46b957 = function(a) {
    return $e7a49864e45a9be5$var$v(a) === $e7a49864e45a9be5$var$n;
};
$e7a49864e45a9be5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e7a49864e45a9be5$var$d || a === $e7a49864e45a9be5$var$f || a === $e7a49864e45a9be5$var$e || a === $e7a49864e45a9be5$var$m || a === $e7a49864e45a9be5$var$n || a === $e7a49864e45a9be5$var$t || "object" === typeof a && null !== a && (a.$$typeof === $e7a49864e45a9be5$var$q || a.$$typeof === $e7a49864e45a9be5$var$p || a.$$typeof === $e7a49864e45a9be5$var$g || a.$$typeof === $e7a49864e45a9be5$var$h || a.$$typeof === $e7a49864e45a9be5$var$l || a.$$typeof === $e7a49864e45a9be5$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$e7a49864e45a9be5$export$f5bbd400c2f4426f = $e7a49864e45a9be5$var$v;

});


parcelRegister("jUj8J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e7e2181096bfccff$export$2e2bcd8739ae039; });

var $fJo36 = parcelRequire("fJo36");
parcelRequire("1jZg7");
const $e7e2181096bfccff$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e7e2181096bfccff$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $e7e2181096bfccff$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $fJo36.default)(_ref, $e7e2181096bfccff$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $e7e2181096bfccff$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("1jZg7", function(module, exports) {

var $7PpWx = parcelRequire("7PpWx");
function $0f671588e05a2c63$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $7PpWx.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $0f671588e05a2c63$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $0f671588e05a2c63$var$verify(mapStateToProps, 'mapStateToProps');
    $0f671588e05a2c63$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $0f671588e05a2c63$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("7PpWx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5b316b95b6b4d68b$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5b316b95b6b4d68b$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("2SNac", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $2196c2c090c8a7f7$export$b69a785ceac019a6; });

var $3fgLb = parcelRequire("3fgLb");

var $aHbfu = parcelRequire("aHbfu");

var $bj3j6 = parcelRequire("bj3j6");
function $2196c2c090c8a7f7$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $aHbfu.wrapMapToPropsConstant)((dispatch)=>(0, $3fgLb.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $aHbfu.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $aHbfu.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $bj3j6.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("3fgLb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $25cfc60251c47938$export$2e2bcd8739ae039; });
function $25cfc60251c47938$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("aHbfu", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $7c96a552cd77e605$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $7c96a552cd77e605$export$8d46c7f53c8c602f; });
parcelRequire("gtkVO");
function $7c96a552cd77e605$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $7c96a552cd77e605$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $7c96a552cd77e605$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $7c96a552cd77e605$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $7c96a552cd77e605$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("gtkVO", function(module, exports) {

var $kNp48 = parcelRequire("kNp48");

var $7PpWx = parcelRequire("7PpWx");
function $bfdf975662db4485$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $kNp48.default)(value)) (0, $7PpWx.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("kNp48", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f23bd3cbbe953a09$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f23bd3cbbe953a09$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("bj3j6", function(module, exports) {
$parcel$export(module.exports, "createInvalidArgFactory", function () { return $83b408c9c6f51c21$export$19ef7b929f7e2559; });
function $83b408c9c6f51c21$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("9Vog3", function(module, exports) {
$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $739c411240e02ce1$export$e00e93951827eda7; });

var $aHbfu = parcelRequire("aHbfu");

var $bj3j6 = parcelRequire("bj3j6");
function $739c411240e02ce1$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $aHbfu.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $aHbfu.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $bj3j6.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("asxdX", function(module, exports) {
$parcel$export(module.exports, "mergePropsFactory", function () { return $79d64a86c26bad0b$export$17457cf6fa742f84; });

var $h5n66 = parcelRequire("h5n66");
parcelRequire("gtkVO");

var $bj3j6 = parcelRequire("bj3j6");
function $79d64a86c26bad0b$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $h5n66.default)({}, ownProps, stateProps, dispatchProps);
}
function $79d64a86c26bad0b$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $79d64a86c26bad0b$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$79d64a86c26bad0b$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $79d64a86c26bad0b$export$5b105939c84b5234(mergeProps) : (0, $bj3j6.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("1iuz7", function(module, exports) {
$parcel$export(module.exports, "createSubscription", function () { return $0f1f2e8c857f8c1d$export$d567d2b9af322f8f; });

var $3YZxS = parcelRequire("3YZxS");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $0f1f2e8c857f8c1d$var$createListenerCollection() {
    const batch = (0, $3YZxS.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $0f1f2e8c857f8c1d$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $0f1f2e8c857f8c1d$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $0f1f2e8c857f8c1d$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0f1f2e8c857f8c1d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $0f1f2e8c857f8c1d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("iQ6YZ", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $db727feb5f78601c$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
const $db727feb5f78601c$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $db727feb5f78601c$export$700979bc83e7db82 = $db727feb5f78601c$export$71594e8a50f746f4 ? $1oC0p.useLayoutEffect : $1oC0p.useEffect;

});

parcelRegister("7yj9S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $57fa91cbde18c714$export$2e2bcd8739ae039; });
function $57fa91cbde18c714$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $57fa91cbde18c714$export$2e2bcd8739ae039(objA, objB) {
    if ($57fa91cbde18c714$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$57fa91cbde18c714$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("aZyKU", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("5huaA")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("ljd5i")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("jjx9d")).useSelector; });

var $5huaA = parcelRequire("5huaA");

var $k4dLS = parcelRequire("k4dLS");

var $6llk2 = parcelRequire("6llk2");

var $ljd5i = parcelRequire("ljd5i");

var $jjx9d = parcelRequire("jjx9d");

var $cbn1I = parcelRequire("cbn1I");

var $7yj9S = parcelRequire("7yj9S");
parcelRequire("b1saB");

});
parcelRegister("5huaA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d85f160b0ec9c95$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $6llk2 = parcelRequire("6llk2");

var $1iuz7 = parcelRequire("1iuz7");

var $iQ6YZ = parcelRequire("iQ6YZ");
function $3d85f160b0ec9c95$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $1oC0p.useMemo(()=>{
        const subscription = (0, $1iuz7.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $1oC0p.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $iQ6YZ.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $6llk2.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $1oC0p.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $3d85f160b0ec9c95$export$2e2bcd8739ae039 = $3d85f160b0ec9c95$var$Provider;

});

parcelRegister("ljd5i", function(module, exports) {
$parcel$export(module.exports, "useDispatch", function () { return $f83585a36441adc0$export$8ad76b76a4c905f8; });

var $6llk2 = parcelRequire("6llk2");

var $cbn1I = parcelRequire("cbn1I");
function $f83585a36441adc0$export$bc9b55530897c558(context = (0, $6llk2.ReactReduxContext)) {
    const useStore = context === (0, $6llk2.ReactReduxContext) ? (0, $cbn1I.useStore) : (0, $cbn1I.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $f83585a36441adc0$export$8ad76b76a4c905f8 = /*#__PURE__*/ $f83585a36441adc0$export$bc9b55530897c558();

});
parcelRegister("cbn1I", function(module, exports) {
$parcel$export(module.exports, "createStoreHook", function () { return $8de85fb95013398c$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $8de85fb95013398c$export$6ccbb43953eebf8; });

var $6llk2 = parcelRequire("6llk2");

var $dqXUQ = parcelRequire("dqXUQ");
function $8de85fb95013398c$export$671dba69185d0304(context = (0, $6llk2.ReactReduxContext)) {
    const useReduxContext = context === (0, $6llk2.ReactReduxContext) ? (0, $dqXUQ.useReduxContext) : (0, $dqXUQ.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $8de85fb95013398c$export$6ccbb43953eebf8 = /*#__PURE__*/ $8de85fb95013398c$export$671dba69185d0304();

});


parcelRegister("b1saB", function(module, exports) {

});



parcelRegister("3GhuR", function(module, exports) {
$parcel$export(module.exports, "createAction", function () { return $2ae2ddd62f1f182e$export$309c7a02b0b0bc62; });
$parcel$export(module.exports, "configureStore", function () { return $2ae2ddd62f1f182e$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createReducer", function () { return $2ae2ddd62f1f182e$export$473eb76d322d0290; });
$parcel$export(module.exports, "createSlice", function () { return $2ae2ddd62f1f182e$export$4d8d9bd83c24ae8b; });

var $eSosQ = parcelRequire("eSosQ");

var $bcxFK = parcelRequire("bcxFK");

var $gYrFl = parcelRequire("gYrFl");

var $8aRHJ = parcelRequire("8aRHJ");

var $7t0tI = parcelRequire("7t0tI");
var $2ae2ddd62f1f182e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2ae2ddd62f1f182e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2ae2ddd62f1f182e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $2ae2ddd62f1f182e$var$__defProp = Object.defineProperty;
var $2ae2ddd62f1f182e$var$__defProps = Object.defineProperties;
var $2ae2ddd62f1f182e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2ae2ddd62f1f182e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2ae2ddd62f1f182e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2ae2ddd62f1f182e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2ae2ddd62f1f182e$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $2ae2ddd62f1f182e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $2ae2ddd62f1f182e$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($2ae2ddd62f1f182e$var$__hasOwnProp.call(b, prop)) $2ae2ddd62f1f182e$var$__defNormalProp(a, prop, b[prop]);
    if ($2ae2ddd62f1f182e$var$__getOwnPropSymbols) for(var _i = 0, _c = $2ae2ddd62f1f182e$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($2ae2ddd62f1f182e$var$__propIsEnum.call(b, prop)) $2ae2ddd62f1f182e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2ae2ddd62f1f182e$var$__spreadProps = function(a, b) {
    return $2ae2ddd62f1f182e$var$__defProps(a, $2ae2ddd62f1f182e$var$__getOwnPropDescs(b));
};
var $2ae2ddd62f1f182e$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $2ae2ddd62f1f182e$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $gYrFl.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $2ae2ddd62f1f182e$var$__spreadArray([
            (0, $eSosQ.isDraft)(value) ? (0, $eSosQ.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $2ae2ddd62f1f182e$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $bcxFK.compose;
    return (0, $bcxFK.compose).apply(null, arguments);
};
var $2ae2ddd62f1f182e$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $2ae2ddd62f1f182e$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $2ae2ddd62f1f182e$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $2ae2ddd62f1f182e$export$b956e38827fca970(action) {
    return $2ae2ddd62f1f182e$export$53b83ca8eaab0383(action) && "type" in action;
}
function $2ae2ddd62f1f182e$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $2ae2ddd62f1f182e$var$hasMatchFunction(action);
}
function $2ae2ddd62f1f182e$export$ebd532f9034651f3(action) {
    return $2ae2ddd62f1f182e$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($2ae2ddd62f1f182e$var$isValidKey);
}
function $2ae2ddd62f1f182e$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $2ae2ddd62f1f182e$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $2ae2ddd62f1f182e$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $2ae2ddd62f1f182e$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $2ae2ddd62f1f182e$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $2ae2ddd62f1f182e$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $2ae2ddd62f1f182e$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $2ae2ddd62f1f182e$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $2ae2ddd62f1f182e$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $2ae2ddd62f1f182e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $2ae2ddd62f1f182e$var$freezeDraftable(val) {
    return (0, $eSosQ.isDraftable)(val) ? (0, $eSosQ.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $2ae2ddd62f1f182e$var$isProduction = true;
var $2ae2ddd62f1f182e$var$prefix = "Invariant failed";
function $2ae2ddd62f1f182e$var$invariant(condition, message) {
    if (condition) return;
    if ($2ae2ddd62f1f182e$var$isProduction) throw new Error($2ae2ddd62f1f182e$var$prefix);
    throw new Error($2ae2ddd62f1f182e$var$prefix + ": " + (message || ""));
}
function $2ae2ddd62f1f182e$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $2ae2ddd62f1f182e$var$getSerialize(serializer, decycler), indent);
}
function $2ae2ddd62f1f182e$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $2ae2ddd62f1f182e$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $2ae2ddd62f1f182e$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $2ae2ddd62f1f182e$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $2ae2ddd62f1f182e$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $2ae2ddd62f1f182e$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $2ae2ddd62f1f182e$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $2ae2ddd62f1f182e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $2ae2ddd62f1f182e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $2ae2ddd62f1f182e$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $2ae2ddd62f1f182e$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $2ae2ddd62f1f182e$export$53b83ca8eaab0383(val);
}
function $2ae2ddd62f1f182e$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $2ae2ddd62f1f182e$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $2ae2ddd62f1f182e$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $2ae2ddd62f1f182e$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $2ae2ddd62f1f182e$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$2ae2ddd62f1f182e$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $2ae2ddd62f1f182e$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $2ae2ddd62f1f182e$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $2ae2ddd62f1f182e$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $2ae2ddd62f1f182e$export$36c1185aeee5b0a6(options);
    };
}
function $2ae2ddd62f1f182e$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $2ae2ddd62f1f182e$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($2ae2ddd62f1f182e$var$isBoolean(thunk)) middlewareArray.push((0, $8aRHJ.default));
        else middlewareArray.push((0, $8aRHJ.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $2ae2ddd62f1f182e$var$IS_PRODUCTION = true;
function $2ae2ddd62f1f182e$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $2ae2ddd62f1f182e$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($2ae2ddd62f1f182e$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $bcxFK.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$2ae2ddd62f1f182e$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$2ae2ddd62f1f182e$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $bcxFK.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $bcxFK.compose);
    if (devTools) finalCompose = $2ae2ddd62f1f182e$var$composeWithDevTools($2ae2ddd62f1f182e$var$__spreadValues({
        trace: !$2ae2ddd62f1f182e$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $2ae2ddd62f1f182e$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $2ae2ddd62f1f182e$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $bcxFK.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $2ae2ddd62f1f182e$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $2ae2ddd62f1f182e$var$isStateFunction(x) {
    return typeof x === "function";
}
var $2ae2ddd62f1f182e$var$hasWarnedAboutObjectNotation = false;
function $2ae2ddd62f1f182e$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $2ae2ddd62f1f182e$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($2ae2ddd62f1f182e$var$isStateFunction(initialState)) getInitialState = function() {
        return $2ae2ddd62f1f182e$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $2ae2ddd62f1f182e$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $2ae2ddd62f1f182e$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $eSosQ.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $eSosQ.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $eSosQ.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $2ae2ddd62f1f182e$var$hasWarnedAboutObjectNotation2 = false;
function $2ae2ddd62f1f182e$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $2ae2ddd62f1f182e$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $7t0tI;
    var initialState = typeof options.initialState == "function" ? options.initialState : $2ae2ddd62f1f182e$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $2ae2ddd62f1f182e$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type, prepareCallback) : $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $2ae2ddd62f1f182e$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $2ae2ddd62f1f182e$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $2ae2ddd62f1f182e$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $2ae2ddd62f1f182e$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($2ae2ddd62f1f182e$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $2ae2ddd62f1f182e$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $2ae2ddd62f1f182e$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $2ae2ddd62f1f182e$var$createSingleArgumentStateOperator(mutator) {
    var operator = $2ae2ddd62f1f182e$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $2ae2ddd62f1f182e$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $2ae2ddd62f1f182e$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $eSosQ.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $eSosQ.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $2ae2ddd62f1f182e$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $2ae2ddd62f1f182e$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $2ae2ddd62f1f182e$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $2ae2ddd62f1f182e$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $2ae2ddd62f1f182e$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $2ae2ddd62f1f182e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $2ae2ddd62f1f182e$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $2ae2ddd62f1f182e$var$createStateOperator(addOneMutably),
        addMany: $2ae2ddd62f1f182e$var$createStateOperator(addManyMutably),
        setOne: $2ae2ddd62f1f182e$var$createStateOperator(setOneMutably),
        setMany: $2ae2ddd62f1f182e$var$createStateOperator(setManyMutably),
        setAll: $2ae2ddd62f1f182e$var$createStateOperator(setAllMutably),
        updateOne: $2ae2ddd62f1f182e$var$createStateOperator(updateOneMutably),
        updateMany: $2ae2ddd62f1f182e$var$createStateOperator(updateManyMutably),
        upsertOne: $2ae2ddd62f1f182e$var$createStateOperator(upsertOneMutably),
        upsertMany: $2ae2ddd62f1f182e$var$createStateOperator(upsertManyMutably),
        removeOne: $2ae2ddd62f1f182e$var$createStateOperator(removeOneMutably),
        removeMany: $2ae2ddd62f1f182e$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $2ae2ddd62f1f182e$var$createSortedStateAdapter(selectId, sort) {
    var _c = $2ae2ddd62f1f182e$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($2ae2ddd62f1f182e$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $2ae2ddd62f1f182e$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $2ae2ddd62f1f182e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $2ae2ddd62f1f182e$var$createStateOperator(addOneMutably),
        updateOne: $2ae2ddd62f1f182e$var$createStateOperator(updateOneMutably),
        upsertOne: $2ae2ddd62f1f182e$var$createStateOperator(upsertOneMutably),
        setOne: $2ae2ddd62f1f182e$var$createStateOperator(setOneMutably),
        setMany: $2ae2ddd62f1f182e$var$createStateOperator(setManyMutably),
        setAll: $2ae2ddd62f1f182e$var$createStateOperator(setAllMutably),
        addMany: $2ae2ddd62f1f182e$var$createStateOperator(addManyMutably),
        updateMany: $2ae2ddd62f1f182e$var$createStateOperator(updateManyMutably),
        upsertMany: $2ae2ddd62f1f182e$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $2ae2ddd62f1f182e$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $2ae2ddd62f1f182e$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $2ae2ddd62f1f182e$var$createInitialStateFactory();
    var selectorsFactory = $2ae2ddd62f1f182e$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $2ae2ddd62f1f182e$var$createSortedStateAdapter(selectId, sortComparer) : $2ae2ddd62f1f182e$var$createUnsortedStateAdapter(selectId);
    return $2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues($2ae2ddd62f1f182e$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $2ae2ddd62f1f182e$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $2ae2ddd62f1f182e$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $2ae2ddd62f1f182e$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $2ae2ddd62f1f182e$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $2ae2ddd62f1f182e$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $2ae2ddd62f1f182e$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $2ae2ddd62f1f182e$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $2ae2ddd62f1f182e$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $2ae2ddd62f1f182e$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $2ae2ddd62f1f182e$var$__spreadProps($2ae2ddd62f1f182e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $2ae2ddd62f1f182e$var$__spreadProps($2ae2ddd62f1f182e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $2ae2ddd62f1f182e$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $2ae2ddd62f1f182e$var$__spreadProps($2ae2ddd62f1f182e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $2ae2ddd62f1f182e$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $2ae2ddd62f1f182e$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$2ae2ddd62f1f182e$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $2ae2ddd62f1f182e$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $2ae2ddd62f1f182e$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $2ae2ddd62f1f182e$var$RejectWithValue) throw result;
                                                if (result instanceof $2ae2ddd62f1f182e$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $2ae2ddd62f1f182e$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($2ae2ddd62f1f182e$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $2ae2ddd62f1f182e$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $2ae2ddd62f1f182e$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $2ae2ddd62f1f182e$var$matches = function(matcher, action) {
    if ($2ae2ddd62f1f182e$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $2ae2ddd62f1f182e$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $2ae2ddd62f1f182e$var$matches(matcher, action);
        });
    };
}
function $2ae2ddd62f1f182e$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $2ae2ddd62f1f182e$var$matches(matcher, action);
        });
    };
}
function $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $2ae2ddd62f1f182e$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $2ae2ddd62f1f182e$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $2ae2ddd62f1f182e$export$9dd1fb32974da385($2ae2ddd62f1f182e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $2ae2ddd62f1f182e$export$9dd1fb32974da385($2ae2ddd62f1f182e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $2ae2ddd62f1f182e$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $2ae2ddd62f1f182e$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$2ae2ddd62f1f182e$var$isAsyncThunkArray(asyncThunks)) return $2ae2ddd62f1f182e$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $2ae2ddd62f1f182e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $2ae2ddd62f1f182e$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $2ae2ddd62f1f182e$var$noop = function() {};
var $2ae2ddd62f1f182e$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $2ae2ddd62f1f182e$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $2ae2ddd62f1f182e$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $2ae2ddd62f1f182e$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $2ae2ddd62f1f182e$var$task = "task";
var $2ae2ddd62f1f182e$var$listener = "listener";
var $2ae2ddd62f1f182e$var$completed = "completed";
var $2ae2ddd62f1f182e$var$cancelled = "cancelled";
var $2ae2ddd62f1f182e$var$taskCancelled = "task-" + $2ae2ddd62f1f182e$var$cancelled;
var $2ae2ddd62f1f182e$var$taskCompleted = "task-" + $2ae2ddd62f1f182e$var$completed;
var $2ae2ddd62f1f182e$var$listenerCancelled = $2ae2ddd62f1f182e$var$listener + "-" + $2ae2ddd62f1f182e$var$cancelled;
var $2ae2ddd62f1f182e$var$listenerCompleted = $2ae2ddd62f1f182e$var$listener + "-" + $2ae2ddd62f1f182e$var$completed;
var $2ae2ddd62f1f182e$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $2ae2ddd62f1f182e$var$task + " " + $2ae2ddd62f1f182e$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $2ae2ddd62f1f182e$var$validateActive = function(signal) {
    if (signal.aborted) throw new $2ae2ddd62f1f182e$export$cb1bdac908fed7f(signal.reason);
};
function $2ae2ddd62f1f182e$var$raceWithSignal(signal, promise2) {
    var cleanup = $2ae2ddd62f1f182e$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $2ae2ddd62f1f182e$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $2ae2ddd62f1f182e$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $2ae2ddd62f1f182e$var$noop;
    });
}
var $2ae2ddd62f1f182e$var$runTask = function(task2, cleanUp) {
    return $2ae2ddd62f1f182e$var$__async(void 0, null, function() {
        var value, error_1;
        return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $2ae2ddd62f1f182e$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $2ae2ddd62f1f182e$var$createPause = function(signal) {
    return function(promise2) {
        return $2ae2ddd62f1f182e$var$catchRejection($2ae2ddd62f1f182e$var$raceWithSignal(signal, promise2).then(function(output) {
            $2ae2ddd62f1f182e$var$validateActive(signal);
            return output;
        }));
    };
};
var $2ae2ddd62f1f182e$var$createDelay = function(signal) {
    var pause = $2ae2ddd62f1f182e$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $2ae2ddd62f1f182e$var$assign = Object.assign;
var $2ae2ddd62f1f182e$var$INTERNAL_NIL_TOKEN = {};
var $2ae2ddd62f1f182e$var$alm = "listenerMiddleware";
var $2ae2ddd62f1f182e$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $2ae2ddd62f1f182e$var$addAbortSignalListener(parentAbortSignal, function() {
            return $2ae2ddd62f1f182e$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $2ae2ddd62f1f182e$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $2ae2ddd62f1f182e$var$runTask(function() {
            return $2ae2ddd62f1f182e$var$__async(void 0, null, function() {
                var result2;
                return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $2ae2ddd62f1f182e$var$validateActive(parentAbortSignal);
                            $2ae2ddd62f1f182e$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $2ae2ddd62f1f182e$var$createPause(childAbortController.signal),
                                    delay: $2ae2ddd62f1f182e$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $2ae2ddd62f1f182e$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $2ae2ddd62f1f182e$var$abortControllerWithReason(childAbortController, $2ae2ddd62f1f182e$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $2ae2ddd62f1f182e$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $2ae2ddd62f1f182e$var$abortControllerWithReason(childAbortController, $2ae2ddd62f1f182e$var$taskCancelled);
            }
        };
    };
};
var $2ae2ddd62f1f182e$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $2ae2ddd62f1f182e$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $2ae2ddd62f1f182e$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $2ae2ddd62f1f182e$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $2ae2ddd62f1f182e$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $2ae2ddd62f1f182e$var$catchRejection(take(predicate, timeout));
    };
};
var $2ae2ddd62f1f182e$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $2ae2ddd62f1f182e$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $2ae2ddd62f1f182e$var$createListenerEntry = function(options) {
    var _c = $2ae2ddd62f1f182e$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $2ae2ddd62f1f182e$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $2ae2ddd62f1f182e$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $2ae2ddd62f1f182e$var$abortControllerWithReason(controller, $2ae2ddd62f1f182e$var$listenerCancelled);
    });
};
var $2ae2ddd62f1f182e$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($2ae2ddd62f1f182e$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $2ae2ddd62f1f182e$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $2ae2ddd62f1f182e$export$f03a6b845d3fb58b = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62($2ae2ddd62f1f182e$var$alm + "/add");
var $2ae2ddd62f1f182e$export$b1b8022855fb2b71 = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62($2ae2ddd62f1f182e$var$alm + "/removeAll");
var $2ae2ddd62f1f182e$export$b03e9483f936dccb = $2ae2ddd62f1f182e$export$309c7a02b0b0bc62($2ae2ddd62f1f182e$var$alm + "/remove");
var $2ae2ddd62f1f182e$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $2ae2ddd62f1f182e$var$__spreadArray([
        $2ae2ddd62f1f182e$var$alm + "/error"
    ], args));
};
function $2ae2ddd62f1f182e$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $2ae2ddd62f1f182e$var$defaultErrorHandler : _c;
    $2ae2ddd62f1f182e$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $2ae2ddd62f1f182e$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $2ae2ddd62f1f182e$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $2ae2ddd62f1f182e$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $2ae2ddd62f1f182e$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $2ae2ddd62f1f182e$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $2ae2ddd62f1f182e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $2ae2ddd62f1f182e$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $2ae2ddd62f1f182e$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $2ae2ddd62f1f182e$var$createDelay(internalTaskController.signal),
                                pause: $2ae2ddd62f1f182e$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $2ae2ddd62f1f182e$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $2ae2ddd62f1f182e$var$abortControllerWithReason(controller, $2ae2ddd62f1f182e$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $2ae2ddd62f1f182e$export$cb1bdac908fed7f)) $2ae2ddd62f1f182e$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $2ae2ddd62f1f182e$var$abortControllerWithReason(internalTaskController, $2ae2ddd62f1f182e$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $2ae2ddd62f1f182e$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$2ae2ddd62f1f182e$export$b956e38827fca970(action)) return next(action);
                if ($2ae2ddd62f1f182e$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($2ae2ddd62f1f182e$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($2ae2ddd62f1f182e$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $2ae2ddd62f1f182e$var$INTERNAL_NIL_TOKEN) throw new Error($2ae2ddd62f1f182e$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $2ae2ddd62f1f182e$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $2ae2ddd62f1f182e$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $2ae2ddd62f1f182e$export$8fb31c0f05df007b = "RTK_autoBatch";
var $2ae2ddd62f1f182e$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$2ae2ddd62f1f182e$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $2ae2ddd62f1f182e$var$promise;
var $2ae2ddd62f1f182e$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($2ae2ddd62f1f182e$var$promise || ($2ae2ddd62f1f182e$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $2ae2ddd62f1f182e$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $2ae2ddd62f1f182e$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $2ae2ddd62f1f182e$var$createQueueWithTimer(10);
var $2ae2ddd62f1f182e$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $2ae2ddd62f1f182e$var$queueMicrotaskShim : options.type === "raf" ? $2ae2ddd62f1f182e$var$rAF : options.type === "callback" ? options.queueNotification : $2ae2ddd62f1f182e$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$2ae2ddd62f1f182e$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $eSosQ.enableES5)();

});
parcelRegister("bcxFK", function(module, exports) {
$parcel$export(module.exports, "createStore", function () { return $827aef558ac6896f$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $827aef558ac6896f$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $827aef558ac6896f$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $827aef558ac6896f$export$9ff26e0402cc7b7; });

var $4ZNNf = parcelRequire("4ZNNf");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $827aef558ac6896f$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $827aef558ac6896f$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $827aef558ac6896f$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $827aef558ac6896f$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $827aef558ac6896f$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $827aef558ac6896f$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $827aef558ac6896f$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $827aef558ac6896f$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $827aef558ac6896f$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($827aef558ac6896f$var$isDate(val)) return 'date';
    if ($827aef558ac6896f$var$isError(val)) return 'error';
    var constructorName = $827aef558ac6896f$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $827aef558ac6896f$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $827aef558ac6896f$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $827aef558ac6896f$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $827aef558ac6896f$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $827aef558ac6896f$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(1));
        return enhancer($827aef558ac6896f$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$827aef558ac6896f$var$isPlainObject(action)) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $827aef558ac6896f$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$827aef558ac6896f$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $827aef558ac6896f$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$827aef558ac6896f$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $827aef558ac6896f$export$8928921ea2d3b126 = $827aef558ac6896f$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $827aef558ac6896f$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $827aef558ac6896f$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $827aef558ac6896f$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$827aef558ac6896f$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $827aef558ac6896f$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $827aef558ac6896f$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $827aef558ac6896f$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $827aef558ac6896f$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $827aef558ac6896f$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($827aef558ac6896f$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $827aef558ac6896f$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $827aef558ac6896f$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($827aef558ac6896f$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $827aef558ac6896f$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $827aef558ac6896f$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $827aef558ac6896f$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($827aef558ac6896f$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $827aef558ac6896f$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $827aef558ac6896f$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $827aef558ac6896f$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($827aef558ac6896f$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $827aef558ac6896f$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $4ZNNf.default)((0, $4ZNNf.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("4ZNNf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3a337bd60e2443a5$export$2e2bcd8739ae039; });

var $gGM8m = parcelRequire("gGM8m");
function $3a337bd60e2443a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a337bd60e2443a5$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a337bd60e2443a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gGM8m.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a337bd60e2443a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("gGM8m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c265e7f2ea979058$export$2e2bcd8739ae039; });

var $iXAre = parcelRequire("iXAre");
function $c265e7f2ea979058$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $iXAre.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("iXAre", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dcda008a96ad599a$export$2e2bcd8739ae039; });

var $gd8Nu = parcelRequire("gd8Nu");

var $djfmw = parcelRequire("djfmw");
function $dcda008a96ad599a$export$2e2bcd8739ae039(t) {
    var i = (0, $djfmw.default)(t, "string");
    return "symbol" == (0, $gd8Nu.default)(i) ? i : i + "";
}

});
parcelRegister("gd8Nu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcd4af328ac3f73b$export$2e2bcd8739ae039; });
function $bcd4af328ac3f73b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $bcd4af328ac3f73b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bcd4af328ac3f73b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("djfmw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b08f751cbb1face$export$2e2bcd8739ae039; });

var $gd8Nu = parcelRequire("gd8Nu");
function $9b08f751cbb1face$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $gd8Nu.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $gd8Nu.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("gYrFl", function(module, exports) {
$parcel$export(module.exports, "createSelector", function () { return $c5b7b5cfcb030a5f$export$595d22ed68ca2841; });

var $7EqCI = parcelRequire("7EqCI");
function $c5b7b5cfcb030a5f$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $c5b7b5cfcb030a5f$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $c5b7b5cfcb030a5f$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $c5b7b5cfcb030a5f$export$595d22ed68ca2841 = /* #__PURE__ */ $c5b7b5cfcb030a5f$export$5943f4447f6ef248((0, $7EqCI.defaultMemoize));
var $c5b7b5cfcb030a5f$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $c5b7b5cfcb030a5f$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("7EqCI", function(module, exports) {
$parcel$export(module.exports, "defaultMemoize", function () { return $5920ebb5cf61fafa$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $5920ebb5cf61fafa$var$NOT_FOUND = 'NOT_FOUND';
function $5920ebb5cf61fafa$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $5920ebb5cf61fafa$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $5920ebb5cf61fafa$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $5920ebb5cf61fafa$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $5920ebb5cf61fafa$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $5920ebb5cf61fafa$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $5920ebb5cf61fafa$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $5920ebb5cf61fafa$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $5920ebb5cf61fafa$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $5920ebb5cf61fafa$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $5920ebb5cf61fafa$var$createSingletonCache(comparator) : $5920ebb5cf61fafa$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $5920ebb5cf61fafa$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("8aRHJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f38ea78e345cae2$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $5f38ea78e345cae2$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $5f38ea78e345cae2$var$thunk = $5f38ea78e345cae2$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$5f38ea78e345cae2$var$thunk.withExtraArgument = $5f38ea78e345cae2$var$createThunkMiddleware;
var $5f38ea78e345cae2$export$2e2bcd8739ae039 = $5f38ea78e345cae2$var$thunk;

});


parcelRegister("6UAxX", function(module, exports) {
$parcel$export(module.exports, "PatternLogos", function () { return (parcelRequire("9uL34")).PatternLogos; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("9uL34")).PatternLogos; });

var $9uL34 = parcelRequire("9uL34");

});
parcelRegister("9uL34", function(module, exports) {
$parcel$export(module.exports, "PatternLogos", function () { return $9ce6b13b299d308e$export$355432025e812df1; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
parcelRequire("2tb46");
var $2ivuE = parcelRequire("2ivuE");

var $jMhSx = parcelRequire("jMhSx");
const $9ce6b13b299d308e$var$ConditionalLogo = (props)=>{
    if (props.link) return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: props.link,
        className: "logoblock logo-linked",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
            src: props.src,
            alt: props.alt,
            width: props.width,
            loading: "lazy"
        })
    });
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        className: "logoblock logo-plain",
        src: props.src,
        alt: props.alt,
        width: props.width,
        loading: "lazy"
    }));
};
const $9ce6b13b299d308e$export$355432025e812df1 = ({ inlineLogos: inlineLogos, headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, linkPosition: linkPosition = "top" })=>{
    if (inlineLogos.length < 4 || inlineLogos.length > 12) throw new Error("Minimum 4 logos required, maximum 12");
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916ud5o _1nk71e5h _jti51ul9 _xjyridpf _2thuidpf _hbr3idpf",
            className
        ]),
        children: [
            headerText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                    isCentered: true,
                    headerText: headerText,
                    headerType: "h2",
                    eyebrowText: eyebrowText,
                    bodyText: bodyText,
                    ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : undefined
                })
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: `logos-content lgth length-${inlineLogos.length}`,
                    children: inlineLogos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($9ce6b13b299d308e$var$ConditionalLogo, {
                            alt: inlineLogo.alt,
                            src: inlineLogo.src,
                            link: inlineLogo.link,
                            width: inlineLogo.width
                        }, index))
                })
            }),
            footNoteText ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: "footnote-text",
                    children: footNoteText
                })
            }) : null,
            linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $6ogO3._)({}, ctaProps.primaryLinkProps))
                })
            }) : null
        ]
    });
};

});


//@ts-nocheck
// This file is the entry for Webpack and Parcel fallback.

var $yhhhl = parcelRequire("yhhhl");

var $fuLgT = parcelRequire("fuLgT");

var $hgaI1 = parcelRequire("hgaI1");
// This file includes the mapping between the route and the component that should be rendered for that route.
// You are not meant to import this file on client-side code, as it will make the bundle size bigger.

var $4ccia = parcelRequire("4ccia");

var $6mvtm = parcelRequire("6mvtm");

var $ea4mV = parcelRequire("ea4mV");
parcelRequire("b7P4C");
var $k6PTJ = parcelRequire("k6PTJ");
var $5UKqd = parcelRequire("5UKqd");

var $iwpqF = parcelRequire("iwpqF");

var $lsYgE = parcelRequire("lsYgE");

var $2ABij = parcelRequire("2ABij");

var $2kCSN = parcelRequire("2kCSN");

var $83Z9w = parcelRequire("83Z9w");

var $4DBV5 = parcelRequire("4DBV5");

var $8bbjU = parcelRequire("8bbjU");

var $1mtK6 = parcelRequire("1mtK6");

var $5zs0K = parcelRequire("5zs0K");

var $806Eh = parcelRequire("806Eh");

var $cv1g1 = parcelRequire("cv1g1");

var $jNwD4 = parcelRequire("jNwD4");

var $bWWTF = parcelRequire("bWWTF");

var $fxtKw = parcelRequire("fxtKw");

var $dG76n = parcelRequire("dG76n");

var $2fKIG = parcelRequire("2fKIG");

var $boM8U = parcelRequire("boM8U");

var $8IsVQ = parcelRequire("8IsVQ");

var $9Ws6n = parcelRequire("9Ws6n");

var $kufmD = parcelRequire("kufmD");

var $gKC0O = parcelRequire("gKC0O");

var $fTqPM = parcelRequire("fTqPM");

var $e18uw = parcelRequire("e18uw");

var $ccCRD = parcelRequire("ccCRD");

var $kqZTJ = parcelRequire("kqZTJ");

var $kShM7 = parcelRequire("kShM7");

var $4f5AO = parcelRequire("4f5AO");

var $SJn7F = parcelRequire("SJn7F");

var $8vTdi = parcelRequire("8vTdi");

var $drgFv = parcelRequire("drgFv");

var $2veNk = parcelRequire("2veNk");

var $cqCPq = parcelRequire("cqCPq");

var $WuRB2 = parcelRequire("WuRB2");

var $8KaV5 = parcelRequire("8KaV5");

var $jToCF = parcelRequire("jToCF");

var $4FLZc = parcelRequire("4FLZc");

var $45Tk8 = parcelRequire("45Tk8");

var $imhoT = parcelRequire("imhoT");

var $ik40B = parcelRequire("ik40B");

var $jYywI = parcelRequire("jYywI");

var $30s1N = parcelRequire("30s1N");

var $fenhY = parcelRequire("fenhY");

var $kPZ6t = parcelRequire("kPZ6t");

var $c33x4 = parcelRequire("c33x4");

var $8ItDm = parcelRequire("8ItDm");

var $6mr2B = parcelRequire("6mr2B");

var $kUDf6 = parcelRequire("kUDf6");

var $5v5zT = parcelRequire("5v5zT");

var $9h3ui = parcelRequire("9h3ui");

var $8v2ki = parcelRequire("8v2ki");

var $2LTjU = parcelRequire("2LTjU");

var $idul7 = parcelRequire("idul7");

var $iEYMn = parcelRequire("iEYMn");

var $1MAo5 = parcelRequire("1MAo5");

var $dQR2M = parcelRequire("dQR2M");

var $dXL3R = parcelRequire("dXL3R");

var $3jSW5 = parcelRequire("3jSW5");

var $2LlD0 = parcelRequire("2LlD0");

var $faUzl = parcelRequire("faUzl");

var $7btsq = parcelRequire("7btsq");

var $eNeuM = parcelRequire("eNeuM");

var $lTIGz = parcelRequire("lTIGz");

var $eIZwM = parcelRequire("eIZwM");

var $bcBwv = parcelRequire("bcBwv");

var $gfnSo = parcelRequire("gfnSo");

var $lFb3d = parcelRequire("lFb3d");

var $g4d4R = parcelRequire("g4d4R");

var $02cSL = parcelRequire("02cSL");

var $koI83 = parcelRequire("koI83");

var $Q2S5p = parcelRequire("Q2S5p");

var $2S6eY = parcelRequire("2S6eY");

var $6PSGm = parcelRequire("6PSGm");

var $04Umd = parcelRequire("04Umd");

var $fTJHm = parcelRequire("fTJHm");

var $hgMlo = parcelRequire("hgMlo");

var $dbZp9 = parcelRequire("dbZp9");

var $7xaX2 = parcelRequire("7xaX2");

var $kuBeN = parcelRequire("kuBeN");

var $gsiI9 = parcelRequire("gsiI9");

var $5NnUP = parcelRequire("5NnUP");

var $k1ORe = parcelRequire("k1ORe");

var $8xrM0 = parcelRequire("8xrM0");

var $l8sJe = parcelRequire("l8sJe");

var $dsoMC = parcelRequire("dsoMC");

var $23HrX = parcelRequire("23HrX");

var $gy1vX = parcelRequire("gy1vX");

var $9u36t = parcelRequire("9u36t");

var $lhmFt = parcelRequire("lhmFt");

var $e7uW8 = parcelRequire("e7uW8");

var $1H2ve = parcelRequire("1H2ve");

var $aZQ1N = parcelRequire("aZQ1N");

var $aWYhK = parcelRequire("aWYhK");

var $iDsYU = parcelRequire("iDsYU");

var $31J3d = parcelRequire("31J3d");

var $6QgX2 = parcelRequire("6QgX2");

var $keOu4 = parcelRequire("keOu4");

var $cbLEA = parcelRequire("cbLEA");

var $ioPgw = parcelRequire("ioPgw");

var $hI6CC = parcelRequire("hI6CC");

var $7Lagj = parcelRequire("7Lagj");

var $7R96I = parcelRequire("7R96I");

var $lfqXN = parcelRequire("lfqXN");

var $czsFN = parcelRequire("czsFN");

var $67UrT = parcelRequire("67UrT");

var $iWEGU = parcelRequire("iWEGU");
parcelRequire("2aZDx");

var $gbUpX = parcelRequire("gbUpX");

var $1YXN8 = parcelRequire("1YXN8");
const $8d8fc7d3d32dbcb4$export$9dab8dd71c3a980f = async ()=>{
    try {
        let routingTableUrl = "https://wac-routing-table--routing-table.us-east-1.prod.public.atl-paas.net/routing-table.json";
        window.location.search.includes("wacae-preview=true");
        const response = await fetch(routingTableUrl);
        if (!response.ok) throw new Error(`Failed to fetch Routing Table from CloudFront: ${response.status} ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error("Error fetching Routing Table", error);
    }
};
const $8d8fc7d3d32dbcb4$export$443f269ba643b5d6 = (segments, index, segLength, routeObject)=>{
    const currSeg = String(segments[index]);
    const hasSeg = routeObject[currSeg];
    const hasWildcard = routeObject["*"];
    const lastSeg = index == segLength;
    let hasSegResult = false;
    let hasWildcardResult = false;
    if (hasSeg) {
        if (lastSeg) hasSegResult = !Boolean(hasSeg["p"]);
        else hasSegResult = $8d8fc7d3d32dbcb4$export$443f269ba643b5d6(segments, index + 1, segLength, hasSeg);
    }
    if (hasWildcard) {
        if (lastSeg) hasWildcardResult = !Boolean(hasWildcard["p"]);
        else hasWildcardResult = $8d8fc7d3d32dbcb4$export$443f269ba643b5d6(segments, index + 1, segLength, hasWildcard);
    }
    return hasSegResult || hasWildcardResult;
};



var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $hu7gH = parcelRequire("hu7gH");
const $fc114bc7d66a4f84$export$da6d2f7032b7150b = (location, userLocale, userLoggedIn, subAnchor, routingTable)=>{
    const route = (0, $hu7gH.parseRoute)(location);
    // Check if page is a Uniform-supported route
    const checkRoutingTable = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).routingTable);
    if (checkRoutingTable && routingTable) {
        const segments = route.path.split("/");
        const segLength = segments.length;
        if (routingTable && route.path !== "" && (0, $8d8fc7d3d32dbcb4$export$443f269ba643b5d6)(segments, 0, segLength - 1, routingTable["wac"])) {
            console.log(route.path, "is Uniform route served by Routing Table");
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        } else console.log(route.path, "is NOT Uniform route");
    }
    switch(route.path){
        case "uniform-preview":
            return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: "404"
            };
        case "software/rovo/pricing":
            route.variant;
            return {
                Component: (0, $ioPgw.SoftwareRovoPricingPage),
                entryName: "software-rovo-pricing-page",
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("rovo", location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case "software/rovo-dev/pricing":
            const isRovoDevPricingEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8036RovoDevPricingPage);
            if (isRovoDevPricingEnabled) return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: "404"
            };
        case "software/rovo":
            switch(route.variant){
                default:
                    const isRovoProductTourEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8011RovoProductTour);
                    if (isRovoProductTourEnabled) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $iwpqF.FourOhFourPage),
                        entryName: "404"
                    };
            }
        case "software/jira/product-discovery/pricing":
            switch(route.variant){
                default:
                    const isWae = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    const jiraProductDiscoveryPricingTitle = (0, $6PSGm.getPricingTitleInternal)();
                    return {
                        Component: (0, $04Umd.JiraProductDiscoveryPricingPage),
                        entryName: "jira-product-discovery-pricing-page",
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("jira-product-discovery", location, jiraProductDiscoveryPricingTitle),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case "software/guard/pricing":
            switch(route.variant){
                default:
                    const isWae1 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae1) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $kUDf6.SoftwareGuardPricingPage),
                        entryName: "software-guard-pricing-page",
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("atlassian-access", location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case "software/compass/pricing":
            switch(route.variant){
                default:
                    const isWae2 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae2) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $boM8U.SoftwareCompassPricingPage),
                        entryName: "software-compass-pricing-page",
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("compass", location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case "software/loom/pricing":
            switch(route.variant){
                default:
                    const isWae3 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae3) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $cbLEA.LoomPricingPage),
                        entryName: "loom-pricing-page",
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("loom", location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case `software/loom${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "software/loom")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "collections/service/pricing":
            switch(route.variant){
                default:
                    const isServiceCollectionPricingEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8037ServiceCollectionPricingPage);
                    if (isServiceCollectionPricingEnabled) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $iwpqF.FourOhFourPage),
                        entryName: "404"
                    };
            }
        case "collections/teamwork/pricing":
            switch(route.variant){
                default:
                    const isWae4 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae4) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $8bbjU.TeamworkCollectionPricingPage),
                        entryName: "teamwork-collection-pricing-page",
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("teamwork", location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case "collections/strategy/pricing":
            switch(route.variant){
                default:
                    const isWae5 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae5) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $4DBV5.StrategyCollectionPricingPage),
                        entryName: "strategy-collection-pricing-page",
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("strategy", location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case "buy/cloud/org-setup":
            route.variant;
            return {
                Component: (0, $lsYgE.BuyCloudOrgSetupPage),
                entryName: "buy-cloud-org-setup-page"
            };
        case "buy/cloud/site-setup":
            route.variant;
            return {
                Component: (0, $2kCSN.BuyCloudSiteSetupPage),
                entryName: "buy-cloud-site-setup-page"
            };
        case "software/bitbucket/pricing":
            switch(route.variant){
                default:
                    const isWae6 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7856PricingPagesWaeMigrationM3);
                    if (isWae6) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $2fKIG.SoftwareBitbucketPricingPage),
                        entryName: "software-bitbucket-pricing-page",
                        query: (0, $5UKqd.PricingPageRelayQuery),
                        queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("bitbucket", location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
            }
        case "buy/cloud/post-order-provisioning":
            route.variant;
            return {
                Component: (0, $2ABij.BuyCloudPostOrderProvisioningPage),
                entryName: "buy-cloud-post-order-provisioning-page"
            };
        case "software/rovo/start":
            route.variant;
            return {
                Component: (0, $hI6CC.SoftwareRovoStartPage),
                entryName: "software-rovo-start-page"
            };
        case "customers":
            return {
                Component: (0, $1mtK6.CustomersLandingPage),
                entryName: "customers-landing-page",
                query: (0, $4ccia.CustomerLandingPageRelayQuery),
                queryVars: (0, $4ccia.getCustomerLandingPageRelayQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `customers${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "customers")}`:
            if (// these should only be of the form `customers/<slug>`.
            // There should never be more than 2 parts
            $fc114bc7d66a4f84$var$getRouteExtension(route.path, "customers").split("/").length > 2) return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: "404"
            };
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "software/jira":
            switch(route.variant){
                case "paid-lp-jsw-features":
                    return {
                        Component: (0, $7btsq.JiraSoftwarePagePaidLpJswFeatures),
                        entryName: "jira-software-page-paid-lp-jsw-features"
                    };
                case "paid-lp-jsw-roadmaps":
                    return {
                        Component: (0, $eIZwM.JiraSoftwarePagePaidLpJswRoadmaps),
                        entryName: "jira-software-page-paid-lp-jsw-roadmaps",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-template":
                    return {
                        Component: (0, $gfnSo.JiraSoftwarePagePaidLpJswTemplate),
                        entryName: "jira-software-page-paid-lp-jsw-template",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-tracker":
                    return {
                        Component: (0, $lFb3d.JiraSoftwarePagePaidLpJswTracker),
                        entryName: "jira-software-page-paid-lp-jsw-tracker",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-pm":
                    return {
                        Component: (0, $eNeuM.JiraSoftwarePagePaidLpJswPm),
                        entryName: "jira-software-page-paid-lp-jsw-pm",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-project_collaboration":
                    return {
                        Component: (0, $lTIGz.JiraSoftwarePagePaidLpJswProjCollab),
                        entryName: "jira-software-page-paid-lp-jsw-project_collaboration",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-automation":
                    return {
                        Component: (0, $2LlD0.JiraSoftwarePagePaidLpJswAutomation),
                        entryName: "jira-software-page-paid-lp-jsw-automation",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-teamwork":
                    return {
                        Component: (0, $bcBwv.JiraSoftwarePagePaidLpJswTeamwork),
                        entryName: "jira-software-page-paid-lp-jsw-teamwork",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-agile":
                    return {
                        Component: (0, $3jSW5.JiraSoftwarePagePaidLpJswAgile),
                        entryName: "jira-software-page-paid-lp-jsw-agile",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsw-competitors":
                    return {
                        Component: (0, $faUzl.JiraSoftwarePagePaidLpJswCompetitors),
                        entryName: "jira-software-page-paid-lp-jsw-competitors",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-engineering":
                    return {
                        Component: (0, $9h3ui.JiraSoftwarePageAnchorLpJswEngineering),
                        entryName: "jira-software-page-anchor-lp-jsw-team-engineering",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-marketing":
                    return {
                        Component: (0, $idul7.JiraSoftwarePageAnchorLpJswMarketing),
                        entryName: "jira-software-page-anchor-lp-jsw-team-marketing",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-hr":
                    return {
                        Component: (0, $8v2ki.JiraSoftwarePageAnchorLpJswHr),
                        entryName: "jira-software-page-anchor-lp-jsw-team-hr",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-legal":
                    return {
                        Component: (0, $2LTjU.JiraSoftwarePageAnchorLpJswLegal),
                        entryName: "jira-software-page-anchor-lp-jsw-team-legal",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-operations":
                    return {
                        Component: (0, $iEYMn.JiraSoftwarePageAnchorLpJswOperations),
                        entryName: "jira-software-page-anchor-lp-jsw-team-operations",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-design":
                    return {
                        Component: (0, $5v5zT.JiraSoftwarePageAnchorLpJswDesign),
                        entryName: "jira-software-page-anchor-lp-jsw-team-design",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-programmgmt":
                    return {
                        Component: (0, $1MAo5.JiraSoftwarePageAnchorLpJswProgramMgmt),
                        entryName: "jira-software-page-anchor-lp-jsw-team-programmgmt",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsw-team-sales":
                    return {
                        Component: (0, $dQR2M.JiraSoftwarePageAnchorLpJswSales),
                        entryName: "jira-software-page-anchor-lp-jsw-team-sales",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                default:
                    //For logged in, we will either show a "Has Jira" experience, otherwise the Uniform "logged out" page
                    return {
                        Component: (0, $dXL3R.JiraSoftwarePage),
                        entryName: "jira-software-page",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
            }
        case "software/jira/product-discovery":
            return {
                Component: (0, $2S6eY.JiraProductDiscoveryPage),
                entryName: "jira-product-discovery-page"
            };
        case "software/jira/features":
            return {
                Component: (0, $g4d4R.JiraSoftwareFeaturesPage),
                entryName: "jira-software-features-page"
            };
        case "software/jira/free":
            return {
                Component: (0, $02cSL.JiraSoftwareFreePage),
                entryName: "jira-software-free-page"
            };
        case "software/jira/pricing":
            const isWae7 = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).jiraPricingWaeMigrationExperimentRerunGate);
            const isJiraPricingExperiment = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).jiraPricingWaeMigrationExperimentRerunExp);
            if (isWae7 && isJiraPricingExperiment.type === "enrolled" && isJiraPricingExperiment.value === true) return {
                Component: (0, $iWEGU.UniformJiraPricingEntryPage),
                entryName: "uniform-jira-pricing-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            const jiraPricingTitleInternal = (0, $koI83.getPricingTitleInternal)();
            return {
                Component: (0, $Q2S5p.JiraSoftwarePricingPage),
                entryName: "jira-software-pricing-page",
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("jira-software", location, jiraPricingTitleInternal),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case "software/jira/service-management":
            switch(route.variant){
                case "anchor-lp-jsm-automation":
                    return {
                        Component: (0, $hgMlo.JiraServiceManagementSoftwarePageAnchorAutomation),
                        entryName: "jira-service-management-anchor-lp-jsm-automation",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-competitors":
                    return {
                        Component: (0, $dbZp9.JiraServiceManagementSoftwarePageAnchorCompetitors),
                        entryName: "jira-service-management-anchor-lp-jsm-competitors",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-esm":
                    return {
                        Component: (0, $gsiI9.JiraServiceManagementSoftwarePageAnchorEsm),
                        entryName: "jira-service-management-anchor-lp-jsm-esm",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-csm":
                    return {
                        Component: (0, $7xaX2.JiraServiceManagementSoftwarePageAnchorCsm),
                        entryName: "jira-service-management-anchor-lp-jsm-csm",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-marketing":
                    return {
                        Component: (0, $23HrX.JiraServiceManagementSoftwarePageAnchorMarketing),
                        entryName: "jira-service-management-anchor-lp-jsm-team-marketing",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-engineering":
                    return {
                        Component: (0, $8xrM0.JiraServiceManagementSoftwarePageAnchorEngineering),
                        entryName: "jira-service-management-anchor-lp-jsm-team-engineering",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-hr":
                    return {
                        Component: (0, $l8sJe.JiraServiceManagementSoftwarePageAnchorHr),
                        entryName: "jira-service-management-anchor-lp-jsm-team-hr",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-legal":
                    return {
                        Component: (0, $dsoMC.JiraServiceManagementSoftwarePageAnchorLegal),
                        entryName: "jira-service-management-anchor-lp-jsm-team-legal",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-operations":
                    return {
                        Component: (0, $gy1vX.JiraServiceManagementSoftwarePageAnchorOperations),
                        entryName: "jira-service-management-anchor-lp-jsm-team-operations",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-features":
                    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
                    if (isDxpMigrationJsmAnchorJourney.type === "enrolled" && isDxpMigrationJsmAnchorJourney.value === true) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $lhmFt.JiraServiceManagementSoftwarePagePaidLpJsmFeatures),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-features",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-features-cerebro":
                    return {
                        Component: (0, $e7uW8.JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebro),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-features-cerebro",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-incidentchangemgmt":
                    return {
                        Component: (0, $1H2ve.JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmt),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-incidentchangemgmt",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-ticketing":
                    const isDxpMigrationJsmAnchorJourneyTicketing = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
                    if (isDxpMigrationJsmAnchorJourneyTicketing.type === "enrolled" && isDxpMigrationJsmAnchorJourneyTicketing.value === true) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $iDsYU.JiraServiceManagementSoftwarePagePaidLpJsmTicketing),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-ticketing",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-service-desk":
                    const isDxpMigrationJsmAnchorJourneyServiceDesk = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
                    if (isDxpMigrationJsmAnchorJourneyServiceDesk.type === "enrolled" && isDxpMigrationJsmAnchorJourneyServiceDesk.value === true) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $aWYhK.JiraServiceManagementSoftwarePagePaidLpJsmServiceDesk),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-service-desk",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-jsm-itsm":
                    const isDxpMigrationJsmAnchorJourneyItsm = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
                    if (isDxpMigrationJsmAnchorJourneyItsm.type === "enrolled" && isDxpMigrationJsmAnchorJourneyItsm.value === true) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    return {
                        Component: (0, $aZQ1N.JiraServiceManagementSoftwarePagePaidLpJsmItsm),
                        entryName: "jira-service-management-software-page-paid-lp-jsm-itsm",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-asset":
                    return {
                        Component: (0, $fTJHm.JiraServiceManagementSoftwarePageAnchorLpJsmAsset),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-asset",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-devops":
                    return {
                        Component: (0, $kuBeN.JiraServiceManagementSoftwarePageAnchorLpJsmDevops),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-devops",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-customerservice":
                    return {
                        Component: (0, $5NnUP.JiraServiceManagementSoftwarePageAnchorCustomerService),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-team-customerservice",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-jsm-team-design":
                    return {
                        Component: (0, $k1ORe.JiraServiceManagementSoftwarePageAnchorDesign),
                        entryName: "jira-service-management-software-page-anchor-lp-jsm-team-design",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                default:
                    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).dxpMigrationJsmProductTourGate)) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    else return {
                        Component: (0, $9u36t.JiraServiceManagementSoftwarePage),
                        entryName: "jira-service-management-software-page"
                    };
            }
        case "software/confluence":
            const excludedCountyCodesFromExperiment = [
                "IN",
                "ID",
                "GB"
            ];
            const excludedCountry = userLocale != null && excludedCountyCodesFromExperiment.includes(userLocale);
            if (route.variant && (0, $ik40B.isTargetedSubAnchor)(subAnchor) && !excludedCountry) {
                const subAnchorExperiment = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).cfind4782LandingPageSubAnchorV3);
                // if treatment return the sub anchor experiment, else control gets whatever normal route behavior is
                if (subAnchorExperiment.type == "enrolled" && subAnchorExperiment.value) return {
                    Component: (0, $jToCF.ConfluenceSoftwarePageVariantPaidLpConfSubAnchors),
                    entryName: "confluence-software-page-variant-paid-lp-conf-subAnchors",
                    query: (0, $k6PTJ.AnchorPageRelayQuery),
                    queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)((0, $ik40B.getPageId)(subAnchor), location),
                    isRelayEnabled: true,
                    relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                };
            }
            const isCBSubAnchorPriority = (0, $ik40B.isInContextualBanditsSubAnchor)(subAnchor) && route.locale === "en";
            if (!userLoggedIn && route.variant && (0, $cqCPq.isTargetedKeyword)(route.keyword) && !isCBSubAnchorPriority) return {
                Component: (0, $8KaV5.ConfluenceSoftwarePageVariantPaidLpConfKeywords),
                entryName: "confluence-software-page-variant-paid-lp-conf-keywords",
                query: (0, $k6PTJ.AnchorPageRelayQuery),
                queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)((0, $cqCPq.getPageId)(route.keyword), location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
            switch(route.variant){
                case "paid-lp-conf-features":
                    return {
                        Component: (0, $WuRB2.ConfluenceSoftwarePageVariantPaidLpConfFeatures),
                        entryName: "confluence-software-page-variant-paid-lp-conf-features"
                    };
                case "paid-lp-confl-template":
                    return {
                        Component: (0, $imhoT.ConfluenceSoftwarePageVariantPaidLpConflTemplate),
                        entryName: "confluence-software-page-variant-paid-lp-confl-template",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-confl-documentation":
                    return {
                        Component: (0, $4FLZc.ConfluenceSoftwarePageVariantPaidLpConflDocumentation),
                        entryName: "confluence-software-page-variant-paid-lp-confl-documentation",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "paid-lp-confl-projectmgmt":
                    return {
                        Component: (0, $45Tk8.ConfluenceSoftwarePageVariantPaidLpConflProjectMgmt),
                        entryName: "confluence-software-page-variant-paid-lp-confl-projectmgmt",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-collaboration":
                    return {
                        Component: (0, $9Ws6n.ConfluenceSoftwarePageVariantAnchorLpConfCollaboration),
                        entryName: "confluence-software-page-variant-anchor-lp-conf-collaboration",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-automation":
                    return {
                        Component: (0, $8IsVQ.ConfluenceSoftwarePageAnchorAutomation),
                        entryName: "confluence-software-anchor-lp-automation",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-teamwork":
                    return {
                        Component: (0, $8vTdi.ConfluenceSoftwarePageAnchorTeamwork),
                        entryName: "confluence-software-anchor-lp-teamwork",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-competitors":
                    return {
                        Component: (0, $kufmD.ConfluenceSoftwarePageAnchorCompetitors),
                        entryName: "confluence-software-anchor-lp-competitors",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-work-management":
                    return {
                        Component: (0, $drgFv.ConfluenceSoftwarePageAnchorWorkManagement),
                        entryName: "confluence-software-anchor-lp-work-management",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-engineering":
                    return {
                        Component: (0, $e18uw.ConfluenceSoftwarePageAnchorEngineering),
                        entryName: "confluence-software-anchor-lp-team-engineering",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-marketing":
                    return {
                        Component: (0, $kShM7.ConfluenceSoftwarePageAnchorMarketing),
                        entryName: "confluence-software-anchor-lp-team-marketing",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-legal":
                    return {
                        Component: (0, $kqZTJ.ConfluenceSoftwarePageAnchorLegal),
                        entryName: "confluence-software-anchor-lp-team-legal",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-hr":
                    return {
                        Component: (0, $ccCRD.ConfluenceSoftwarePageAnchorHr),
                        entryName: "confluence-software-anchor-lp-team-hr",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-operations":
                    return {
                        Component: (0, $4f5AO.ConfluenceSoftwarePageAnchorOperations),
                        entryName: "confluence-software-anchor-lp-team-operations",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-design":
                    return {
                        Component: (0, $fTqPM.ConfluenceSoftwarePageAnchorDesign),
                        entryName: "confluence-software-anchor-lp-team-design",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-programmgmt":
                    return {
                        Component: (0, $SJn7F.ConfluenceSoftwarePageAnchorProgramMgmt),
                        entryName: "confluence-software-anchor-lp-team-programmgmt",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                case "anchor-lp-conf-team-customerservice":
                    return {
                        Component: (0, $gKC0O.ConfluenceSoftwarePageAnchorCustomerService),
                        entryName: "confluence-software-anchor-lp-team-customerservice",
                        query: (0, $k6PTJ.AnchorPageRelayQuery),
                        queryVars: (0, $k6PTJ.getAnchorPageRelayQueryVars)(route.variant, location),
                        isRelayEnabled: true,
                        relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
                    };
                default:
                    if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).dxpMigrationConfluenceProductTourGate)) return {
                        Component: (0, $67UrT.UniformEntryPage),
                        entryName: "uniform-entry-page",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        isUniformCanary: route.isUniformCanary,
                        isS3UniformRoute: true
                    };
                    else return {
                        Component: (0, $2veNk.ConfluenceSoftwarePage),
                        entryName: "confluence-software-page"
                    };
            }
        case "software/jira/service-management/product-pricing":
            if (!(0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp7923NewJsmRouteDeIndex)) return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: "404"
            };
            const jiraServiceManagementProductPricingTitle = (0, $31J3d.getPricingTitleInternal)();
            return {
                Component: (0, $6QgX2.JiraServiceManagementPricingPage),
                entryName: "jira-service-management-pricing-page",
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("jira-service-management", location, jiraServiceManagementProductPricingTitle),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case "software/jira/service-management/pricing":
            const jiraServiceManagementPricingTitle = (0, $31J3d.getPricingTitleInternal)();
            return {
                Component: (0, $6QgX2.JiraServiceManagementPricingPage),
                entryName: "jira-service-management-pricing-page",
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("jira-service-management", location, jiraServiceManagementPricingTitle),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case "software/confluence/pricing":
            const isWaeMigration = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).confluencePricingPageWaeMigration);
            const isConfluenceExperiment = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).confluencePricingPageWaeMigration);
            if (isWaeMigration && isConfluenceExperiment.type === "enrolled" && isConfluenceExperiment.value === true) return {
                Component: (0, $czsFN.UniformConfluencePricingEntryPage),
                entryName: "uniform-confluence-pricing-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            const confluencePricingTitleInternal = (0, $fenhY.getPricingTitleInternal)();
            return {
                Component: (0, $30s1N.ConfluencePricingPage),
                entryName: "confluence-pricing-page",
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("confluence", location, confluencePricingTitleInternal),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case "software/confluence/free":
            return {
                Component: (0, $jYywI.ConfluenceFreePage),
                entryName: "confluence-free-page"
            };
        case "software/confluence/templates":
            return {
                Component: (0, $8ItDm.ConfluenceTemplatesRelayPage),
                entryName: "confluence-templates-contentful-relay-page",
                query: (0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $1YXN8.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case "software":
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "try":
            return {
                Component: (0, $lfqXN.TryPage),
                entryName: "try-page"
            };
        case "try/cloud/signup":
            return {
                Component: (0, $7R96I.SignupPage),
                entryName: "signup-page"
            };
        case "ondemand/signup/checkemail":
            return {
                Component: (0, $bWWTF.CheckemailPage),
                entryName: "checkemail-page"
            };
        case "ondemand/signup/confirmation":
        case "buy/cloud/confirmation":
            return {
                Component: (0, $fxtKw.ConfirmationPage),
                entryName: "confirmation-page",
                featureFlags: route.featureFlags
            };
        case "software/confluence/templates/search":
            return {
                Component: (0, $6mr2B.ConfluenceTemplateSearchRelayPage),
                entryName: "confluence-template-search-contentful-relay-page",
                query: (0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $1YXN8.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates/categories${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "software/confluence/templates/categories")}`:
            return {
                Component: (0, $kPZ6t.ConfluenceTemplateCategoryRelayPage),
                entryName: "confluence-template-category-contentful-relay-page",
                query: (0, $1YXN8.ConfluenceTemplatesUnifiedRelayPageQuery),
                queryVars: (0, $1YXN8.getConfluenceTemplatesUnifiedRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates/collections${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "software/confluence/templates/collections")}`:
            return {
                Component: (0, $c33x4.ConfluenceTemplateCollectionDetailsRelayPage),
                entryName: "confluence-template-collection-details-contentful-relay-page",
                query: (0, $gbUpX.ConfluenceTemplateCollectionDetailsRelayPageQuery),
                queryVars: (0, $gbUpX.getConfluenceTemplateCollectionDetailsRelayPageQueryVars)(location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/jira/templates/service-management`:
            return {
                Component: (0, $keOu4.JiraTemplateCategoryPage),
                entryName: "jira-template-category-page"
            };
        case "enterprise/contact":
            return {
                Component: (0, $5zs0K.EnterpriseContactSalesPage),
                entryName: "enterprise-contact-sales-page"
            };
        case "enterprise/contact-thanks":
            switch(route.variant){
                case "product-features":
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "pricing-quotes":
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "migration-options":
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "billing-licensing":
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "technical-support":
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
                default:
                    return {
                        Component: (0, $806Eh.EnterpriseContactThanksPage),
                        entryName: "enterprise-contact-thanks-page"
                    };
            }
        case "enterprise/success":
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "software/confluence/enterprise":
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "software/jira/enterprise":
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "software/jira/service-management/enterprise":
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "enterprise":
            if ((0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).enterprisePageDXPMigration)) return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
            return {
                Component: (0, $cv1g1.EnterpriseLandingPage),
                entryName: "enterprise-landing-page"
            };
        case "teams/nonprofits/discount-pricing":
            return {
                Component: (0, $7Lagj.NonProfitPricingPage),
                entryName: "non-profit-pricing-page",
                query: (0, $5UKqd.PricingPageRelayQuery),
                queryVars: (0, $5UKqd.getPricingPageRelayQueryVars)("nonprofit", location),
                isRelayEnabled: true,
                relayApi: (0, $6mvtm.RELAY_API_CONTENTFUL)
            };
        case `software/confluence/templates${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "software/confluence/templates")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case `itsm${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "itsm")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case `incident-management${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "incident-management")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case `devops${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "devops")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case `continuous-delivery${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "continuous-delivery")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case `microservices${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "microservices")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case `data${$fc114bc7d66a4f84$var$getRouteExtension(route.path, "data")}`:
            return {
                Component: (0, $67UrT.UniformEntryPage),
                entryName: "uniform-entry-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "cdn-library":
            return {
                Component: (0, $83Z9w.default),
                entryName: "cdn-library"
            };
        case "search":
            return {
                Component: (0, $dG76n.SearchResultsPage),
                entryName: "search"
            };
        case "":
            return {
                Component: (0, $jNwD4.HomePage),
                entryName: "home"
            };
        default:
            return {
                Component: (0, $iwpqF.FourOhFourPage),
                entryName: "404"
            };
    }
};
const $fc114bc7d66a4f84$var$getRouteExtension = (path, baseTemplate)=>{
    const pathExtn = path.split(baseTemplate).splice(1).join(baseTemplate);
    return pathExtn ? pathExtn : "";
};



var $3t7DW = parcelRequire("3t7DW");

var $3NQOU = parcelRequire("3NQOU");


var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $idVA4 = parcelRequire("idVA4");
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $8fffc1c97a6ec5cd$var$parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
const $8fffc1c97a6ec5cd$var$userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
const $8fffc1c97a6ec5cd$var$locationData = {
    countryIsoCode: window.countryCode || "",
    regionIsoCode: window.regionIsoCode || ""
};
const $8fffc1c97a6ec5cd$var$isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), $8fffc1c97a6ec5cd$var$locationData);
const { finalExperimentOverrides: $8fffc1c97a6ec5cd$var$finalExperimentOverrides, finalFeatureGateOverrides: $8fffc1c97a6ec5cd$var$finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)($8fffc1c97a6ec5cd$var$parsedClientCookies, $8fffc1c97a6ec5cd$var$userAgent, $8fffc1c97a6ec5cd$var$isPerfOnetrustEnabled);
if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
    (0, $hp3ar.overrideAjsAnonIdFromCookie)();
    (0, $hp3ar.overrideCustomAttributes)();
}
(0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
    overrideValues: {
        experimentOverrides: $8fffc1c97a6ec5cd$var$finalExperimentOverrides,
        featureGateOverrides: $8fffc1c97a6ec5cd$var$finalFeatureGateOverrides
    },
    localMode: !$8fffc1c97a6ec5cd$var$isPerfOnetrustEnabled
}).then(async ()=>{
    const routingTable = await (0, $8d8fc7d3d32dbcb4$export$9dab8dd71c3a980f)();
    const { Component: Component, isRelayEnabled: isRelayEnabled, query: query, queryVars: queryVars, relayApi: relayApi } = (0, $fc114bc7d66a4f84$export$da6d2f7032b7150b)(window.location, undefined, undefined, undefined, routingTable);
    if (!isRelayEnabled) (0, $3NQOU.init)(Component);
    else (0, $3t7DW.init)(Component, query, queryVars, relayApi);
});




//# sourceMappingURL=index.27bd8f2e.js.map
